import { observable, toJS, runInAction, reaction, action, configure } from 'mobx';
import '@ungap/global-this';
import { observer, useLocalObservable, Observer } from 'mobx-react-lite';
export { Observer, observer } from 'mobx-react-lite';
import React__default, { useEffect, useState, createElement, useCallback, useMemo, useRef, Fragment as Fragment$1, Component, useLayoutEffect, createContext, useContext } from 'react';
import uuid from '@lukeed/uuid';
import { types as types$1, getSnapshot, getParent, destroy, applySnapshot, onAction, isAlive, isRoot, onSnapshot, addMiddleware, resolvePath, getRoot, detach, getType, hasParent } from 'mobx-state-tree';
import produce$1, { produce } from 'immer';
import cn from '@aqrojo/class-names/src';
import cn$1 from '@aqrojo/class-names';
import { compile, evaluate, equal, parse, simplify } from 'mathjs';
import { createPortal, render } from 'react-dom';
import { usePopper } from 'react-popper';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/js/languages/es.js';
import 'froala-editor/js/languages/pt_br.js';
import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/plugins/char_counter.min.js';
import 'froala-editor/js/plugins/code_beautifier.min.js';
import 'froala-editor/js/plugins/code_view.min.js';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/draggable.min.js';
import 'froala-editor/js/plugins/edit_in_popup.min.js';
import 'froala-editor/js/plugins/font_family.min.js';
import 'froala-editor/js/plugins/font_size.min.js';
import 'froala-editor/js/plugins/image.min.js';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';
import 'froala-editor/js/plugins/paragraph_style.min.js';
import 'froala-editor/js/plugins/quote.min.js';
import 'froala-editor/js/plugins/table.min.js';
import 'froala-editor/js/plugins/word_paste.min.js';
import 'froala-editor/js/plugins/video.min.js';
import FroalaEditor from 'froala-editor';
import FroalaEditorComponent from 'react-froala-wysiwyg';
import domToImage from 'dom-to-image';
import amplitude from 'amplitude-js';
import { useDropzone } from 'react-dropzone';
import useDrivePicker from 'react-google-drive-picker';
import { Tooltip as Tooltip$1 } from 'react-tooltip/dist/react-tooltip.umd.js';
import Slider$2, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { SketchPicker } from 'react-color';
import { Editor as Editor$1, Transforms, createEditor, Text } from 'slate';
import { useSlate, withReact, Slate, Editable } from 'slate-react';
import 'froala-editor/js/froala_editor.pkgd.min.js';
import 'froala-editor/js/plugins.pkgd.min.js';
import { jsx } from 'slate-hyperscript';
import escapeHtml from 'escape-html';
import Draggable$1 from 'react-draggable';
import useResizeObserver from '@react-hook/resize-observer';
import useForceUpdate from 'use-force-update';
import { isEqual } from 'underscore';

var currentVersion = '3.38.10';
if (window !== undefined) window.lemonadeVersion = currentVersion ;

function printLemonadeVersion() {
  var message = "LEMONADE " + currentVersion + "       ~ OneClick.es";
  console.log(message);
}

var _multiplicationSymbol;
var CROSS_SYMBOL = 'CROSS_SYMBOL';
var DOT_SYMBOL = 'DOT_SYMBOL';
var multiplicationSymbol = (_multiplicationSymbol = {}, _multiplicationSymbol[CROSS_SYMBOL] = '\\times', _multiplicationSymbol[DOT_SYMBOL] = '\\cdot', _multiplicationSymbol);

function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : String(i);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function defaultValue(lens, root, def) {
  var children = lens.split('.');
  if (!root) return def;
  var getValue = function getValue(obj, idx) {
    if (idx === void 0) {
      idx = 0;
    }
    return idx === children.length ? obj : obj[children[idx]] ? getValue(obj[children[idx]], idx + 1) : false;
  };
  var fullPath = getValue(root);
  return root && fullPath ? fullPath : def;
}
function anyOrDefault(prop, root, pattern, def) {
  return root[prop] ? function (result) {
    return result ? result[0] : '';
  }(root[prop].match(pattern)) : def;
}

function createLinkTags(_ref) {
  var src = _ref.src;
  return new Promise(function (resolve, reject) {
    var lnk = document.createElement('link');
    lnk.href = src;
    lnk.rel = 'stylesheet';
    lnk.type = 'text/css';
    (document.head || document.documentElement).appendChild(lnk);
    var r = false;
    lnk.onerror = function (err) {
      reject(err, lnk);
    };
    lnk.onload = lnk.onreadystatechange = function () {
      if (!r && (!this.readyState || this.readyState === 'complete')) {
        r = true;
        resolve();
      }
    };
    var t = document.getElementsByTagName('link')[0];
    t.parentElement.insertBefore(lnk, t);
  });
}

function createScriptTags(_ref) {
  var id = _ref.id,
    src = _ref.src;
  return new Promise(function (resolve, reject) {
    var s = document.createElement('script');
    var r = false;
    s.type = 'text/javascript';
    s.id = id;
    s.src = src;
    s.onerror = function (err) {
      reject(err, s);
    };
    s.onload = s.onreadystatechange = function () {
      if (!r && (!this.readyState || this.readyState === 'complete')) {
        r = true;
        resolve();
      }
    };
    var t = document.getElementsByTagName('script')[0];
    t.parentElement.insertBefore(s, t);
  });
}
function createInlineScript(_ref2) {
  var id = _ref2.id,
    content = _ref2.content,
    _ref2$attrs = _ref2.attrs,
    attrs = _ref2$attrs === void 0 ? {} : _ref2$attrs;
  if (document.getElementById(id)) return Promise.resolve();
  return new Promise(function (resolve) {
    var tag = document.createElement('script');
    tag.id = id;
    tag.innerHTML = content;
    Object.entries(attrs).forEach(function (entry) {
      return tag[entry[0]] = entry[1];
    });
    document.head.append(tag);
    resolve();
  });
}

function renderKatex(element, callBack) {
  if (callBack === void 0) {
    callBack = function callBack() {
      console.log('renderKatex:: callback not defined');
    };
  }
  var processMath = function processMath() {
    try {
      window.renderMathInElement(element, {
        throwOnError: false,
        delimiters: delimitersKatex
      });
      callBack(element);
    } catch (e) {
      console.log(e);
    }
  };
  if (window && window.renderMathInElement) {
    processMath();
  }
}
var delimitersKatex = [{
  left: '$$',
  right: '$$',
  display: true
}, {
  left: '\\(',
  right: '\\)',
  display: false
}, {
  left: '\\begin{equation}',
  right: '\\end{equation}',
  display: true
}, {
  left: '\\begin{align}',
  right: '\\end{align}',
  display: true
}, {
  left: '\\begin{alignat}',
  right: '\\end{alignat}',
  display: true
}, {
  left: '\\begin{gather}',
  right: '\\end{gather}',
  display: true
}, {
  left: '\\begin{CD}',
  right: '\\end{CD}',
  display: true
}, {
  left: '\\[',
  right: '\\]',
  display: true
}, {
  left: '`',
  right: '`',
  display: false
}];

var MATHJAX_ENGINE = 'mathjax';
var KATEX_ENGINE = 'katex';
function addMathJax(mode) {
  if (mode === void 0) {
    mode = 'TeX-MML-AM_SVG';
  }
  var mathJaxConfig = "\n    function configMathJax () {\n      try{\n        MathJax.Hub.Config({\"fast-preview\": {disabled: true},asciimath2jax: { processClass: \"fr-math\", ignoreClass: \"no-mathjax|editor-page\"},\"TeX\": { extensions: [\"color.js\",\"cancel.js\"] }, \"HTML-CSS\": { scale: 100, linebreaks: { automatic: true }, availableFonts : [\"TeX\"], preferredFont : \"TeX\", webFont : \"STIX-Web\"},SVG: { scale: 100, linebreaks: { automatic:false }, font: \"STIX-Web\"}, displayAlign: \"left\",showMathMenu: false,showMathMenuMSIE: false,showProcessingMessages: false, messageStyle: \"none\"});\n       }catch(e){ /* setTimeout (configMathJax, 300) */}\n    }\n    configMathJax();";
  var cdnPath = "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.7/MathJax.js?config=" + mode;
  if (window && !window.MathJax && !window.loadingMathLib) {
    window.loadingMathLib = true;
    return createScriptTags({
      id: 'MathJax-script',
      src: cdnPath
    }).then(function () {
      return createInlineScript({
        id: 'MathJax-config',
        content: mathJaxConfig,
        attrs: {
          type: 'text/x-mathjax-config'
        }
      });
    })["catch"](function (e) {
      return console.log('error cargando Mathjax', e);
    });
  } else {
    return Promise.resolve();
  }
}
function addAutoRenderKatex() {
  var autoRendercdnPath = 'https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/contrib/auto-render.min.js';
  if (window && !window.renderMathInElement) {
    return createScriptTags({
      id: 'Katex-auto-render',
      src: autoRendercdnPath
    });
  } else {
    return Promise.resolve();
  }
}
function addKatex() {
  var cdnPath = 'https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/katex.min.js';
  var katexScript = document.getElementById('Katex-script');
  if (window && !window.katex && !katexScript) {
    return createScriptTags({
      id: 'Katex-script',
      src: cdnPath
    });
  } else {
    return Promise.resolve();
  }
}
function addKatexCss() {
  var cdnStylePath = 'https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/katex.min.css';
  createLinkTags({
    id: 'Katex-style',
    src: cdnStylePath
  });
}
function firstRender(mathEngine) {
  var lemonadeContainer = document.getElementsByClassName(LEMONADE_WRAPPER_CLASS);
  if (lemonadeContainer.length > 0) {
    for (var index = 0; index < lemonadeContainer.length; index++) {
      var lemonadeContainerElement = lemonadeContainer[index];
      if (window.renderMathInElement && mathEngine === KATEX_ENGINE) {
        window.renderMathInElement(lemonadeContainerElement, {
          delimiters: delimitersKatex
        });
      } else if (window.MathJax) {
        window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub, lemonadeContainerElement]);
      }
    }
  }
}
function addLatex(mathEngine, mode) {
  if (mathEngine === void 0) {
    mathEngine = MATHJAX_ENGINE;
  }
  if (mode === void 0) {
    mode = 'TeX-MML-AM_SVG';
  }
  if (mathEngine === KATEX_ENGINE) {
    addKatex().then(function () {
      addKatexCss();
      addAutoRenderKatex().then(function () {
        return firstRender(mathEngine);
      });
    });
  } else {
    addMathJax(mode).then(function () {
      return firstRender(mathEngine);
    });
  }
}

var editorComponents = {
  title: 'title',
  hints: 'hints',
  answerOptions: 'answerOptions',
  questions: 'questions',
  clearAll: 'clearAll'
};

var translations = {
	validate: "التحقق من صحة الحل",
	restart: "إعادة تشغيل",
	showSolution: "إظهار الحلّ",
	hideSolution: "إخفاء الحلّ",
	send: "أرسل ",
	points: "نقاط",
	title: "Title",
	enunciated: "Enunciated",
	stimulus: "Question development",
	enunciated_placeholder: "Write a description",
	multiple_choice_activity: "Multiple Choice",
	answer_options: "Answer options",
	add_new_response: "Add new response",
	add_new_question: "Add new question",
	new_question_stem: "New Question",
	validation: "Score",
	option: "Option",
	type_of_validation: "Choose the validation type:",
	exactMatch: "Exacto: Con todo correcto obtienes la puntuación.",
	partialMatch: "Parcial: Cada respuesta correcta otorga la puntuación.",
	partialMatchV2: "Parcial por respuesta: Se divide la puntuación entre el número de respuestas.",
	score: "Score",
	high_score: "Max points",
	enter_a_score: "Enter a score",
	minimum_score: "Minimum score per try",
	cancel: "Cancel",
	save: "Save",
	shuffle_options: "Shuffle answers",
	multiple_responses: "Multiple responses",
	"Word limit": "Word limit",
	essay_placeholder: "Write your answer",
	right_answer: "Right answer",
	write_right_answer: "Write the right answer",
	copy: "Copy",
	cut: "Cut",
	paste: "Paste",
	cloze_text: "Cloze text",
	activity_data_wrong: "The data has wrong format",
	this_is_the_stem: "This is the stem",
	"true": "True",
	"false": "False",
	column: "Column",
	columns: "Columns",
	row: "Row",
	world_map: "World map",
	Greenland: "Greenland",
	Russia: "Russia",
	United_States: "United States",
	table_editor: "Table editor",
	drags: "Drags",
	add_new_column: "Add new column",
	add_new_row: "Add new row",
	duplicate_responses: "Duplicate responses",
	solutions: "Solutions",
	column_count: "Column count",
	row_count: "Row count",
	cloze_template: "Risus {{response}}, et tincidunt turpis facilisis. Curabitur eu nulla justo. Curabitur vulputate ut nisl et bibendum. Nunc diam enim, porta sed eros vitae. {{response}} dignissim, et tincidunt turpis facilisis. Curabitur eu nulla justo. Curabitur vulputate ut nisl et bibendum.",
	response: "Response",
	response_containers: "Response containers",
	global_size: "Global size",
	width: "Width",
	height: "Height",
	upload_file: "Upload file",
	choose_file: "Choose file",
	change_file: "Change file",
	load_image_error_message: "An error occurred while trying to upload the image",
	sending_file: "Uploading file",
	select_an_item: "Select an item",
	pointer: "Pointer",
	none: "None",
	left: "Left",
	right: "Right",
	top: "Top",
	bottom: "Bottom",
	show_check_icon: "Show check icon",
	Transcription: "الترجمة",
	other_rating_stimulus_default: "حان الوقت لتقييم المحتوى!",
	other_rating_tooltip_1_star: "1 نجمة",
	other_rating_tooltip_multiple_stars: "{{count}} نجوم",
	other_rating_description_1_star: "لم يعجبني. أثار حيرتي ومللني.",
	other_rating_description_2_stars: "أعجبني أكثر أو أقل... فهمت بعض الأشياء أفضل من غيرها.",
	other_rating_description_3_stars: "أعجبني كثيراً. فهمته وأثار اهتمامي :)",
	other_rating_description_4_stars: "أحببته! وجدته مثيراً للاهتمام وممتعاً. أريد المزيد!",
	adaptative_choice_levels_config: "تكوين المستويات",
	adaptative_choice_levels_config_help: "قم بتكوين عناوين كل مستوى من النشاط التكيفي",
	adaptative_choice_level_title: "المستوى {{level_number}}",
	adaptative_choice_level_title_label: "عنوان المستوى:",
	adaptative_choice_level_title_placeholder: "اكتب عنوان هذا المستوى...",
	other_adaptative_choice_back: "رجوع",
	other_adaptative_choice_next: "التالي"
};
var ar = {
	translations: translations
};

var translations$1 = {
	title: "Títol",
	enunciated: "Enunciat",
	stimulus: "Enunciat de l’activitat",
	enunciated_placeholder: "Escriu una descripció",
	multiple_choice_activity: "Selecció múltiple",
	answer_options: "Opcions de resposta",
	add_new_response: "Afegir",
	add_new_question: "Afegir",
	new_question_stem: "Pregunta nova",
	validation: "Puntuació",
	option: "Opció",
	type_of_validation: "Introdueix el tipus de validació:",
	exactMatch: "Exacta: és necessari contestar totes les opcions correctament.",
	partialMatch: "Parcial: cada resposta correcta atorga la puntuació.",
	partialMatchV2: "Parcial per resposta: es divideix la puntuació entre el nombre de respostes.",
	score: "Puntuació",
	high_score: "Puntuació màxima",
	enter_a_score: "Introdueix una puntuació.",
	minimum_score: "Puntuació mínima per intentar-ho",
	cancel: "Cancel·lar",
	save: "Desar",
	send: "Envia",
	reset: "Restaurar",
	shuffle_options: "Barrejar respostes",
	multiple_responses: "Resposta múltiple",
	words_limit: "Límit de paraules",
	letters_limit: "Límit de lletres",
	essay_placeholder: "Escriu la teva resposta.",
	right_answer: "Resposta correcta",
	write_right_answer: "Escriu la resposta correcta.",
	copy: "Copiar",
	cut: "Tallar",
	paste: "Enganxar",
	cloze_text: "Prova de compleció",
	activity_data_wrong: "Les dades estan mal formades.",
	this_is_the_stem: "Desenvolupa la pregunta aquí.",
	"true": "Veritable",
	"false": "Fals",
	column: "Columna",
	columns: "Columnes",
	row: "Fila",
	world_map: "Mapa mundial",
	Greenland: "Groenlàndia",
	Russia: "Rússia",
	United_States: "Estats Units",
	table_editor: "Editor de taula",
	drags: "Arrossegables",
	add_new_column: "Afegir un títol a la columna",
	add_new_row: "Afegir un títol a la fila",
	duplicate_responses: "Respostes publicades",
	solutions: "Solucions",
	Solution: "Solució",
	column_count: "Nombre de columnes",
	row_count: "Nombre de files",
	cloze_template: "En un lugar de la Mancha, de cuyo nombre no quiero acordarme, no ha mucho tiempo que vivía un {{response}} de los de lanza en astillero, adarga antigua, rocín flaco y {{response}} corredor.",
	response: "Resposta",
	response_containers: "Contenidors de respostes",
	global_size: "Escala global",
	width: "Ample",
	height: "Alt",
	upload_file: "Pujar fitxer",
	completed: "Completat",
	choose_file: "Elegir fitxer",
	change_file: "Canviar fitxer",
	load_image_error_message: "Hi ha hagut un error en intentar pujar la imatge.",
	sending_file: "Pujant el fitxer",
	select_an_item: "Selecciona un element",
	pointer: "Punter",
	none: "Cap",
	left: "Esquerra",
	right: "Dreta",
	top: "Amunt",
	bottom: "Avall",
	show_check_icon: "Mostrar icona",
	alternative_text: "Text alternatiu",
	isEvaluable: "Forma d’avaluació",
	autosize_response: "Longitud automàtica",
	text_normalization: "Normalització de textos",
	load_image: "Pujar imatge",
	image_size: "Mida de la imatge",
	text_sample: "Text d’exemple",
	size: "Mida",
	accent_sensitive: "Sensible a accents",
	case_sensitive: "Sensible a majúscules",
	spaces_sensitive: "Correcció d’espais",
	orientation: "Orientació",
	"delete": "Esborrar",
	stack: "Amuntegat",
	box: "Caixa",
	Feedback: "Feedback",
	"Remove Feedback": "Treure feedback",
	Visibility: "Visibilitat",
	"Success Message": "Missatge d’èxit",
	"Error Messages": "Missatges d’error",
	Sequence: "Seqüència",
	cyclic: "Cíclic",
	random: "Aleatori",
	"Add new error": "Afegir un error nou",
	"Error message": "Missatge d’error",
	Configuration: "Configuració",
	"Shuffle Answers": "Ordre aleatori",
	"When turned on the questions will be sorted in differ order each time they are presented": "Les opcions sortiran de forma aleatòria en cada alumne.",
	"Show check icon": "Mostrar icona de verificació",
	"When turned on the answers will have a radio button next to them": "Activa’l per mostrar una caixa de selecció al costat de les opcions.",
	Columns: "Columnes",
	"Choose how many columns you want the answers to be displayed into": "Elegeix en quantes columnes vols mostrar les respostes.",
	style_block_none: "Cap",
	style_block_BLOCK: "Bloc",
	style_block_NUMERICAL: "Numèric",
	style_block_LOWER_ALPHA: "Alfabet en minúscules",
	style_block_UPPER_ALPHA: "Alfabet en majúscules",
	"1 columns": "1 columna",
	"2 columns": "2 columnes",
	"3 columns": "3 columnes",
	"4 columns": "4 columnes",
	"5 columns": "5 columnes",
	"6 columns": "6 columnes",
	SERVER_ERROR: "S’ha produït un error en pujar el fitxer. Torna-ho a intentar.",
	MAX_FILES_REACHED: "Has arribat al límit de fitxers permesos.",
	INVALID_TYPE: "Tipus de fitxer no vàlid",
	MAX_SIZE_EXCEEDED: "El fitxer que vols pujar supera la mida màxima permesa. Si us plau, redueix-ne la mida i torna-ho a intentar. ",
	UNKNOWN_ERROR: "Hi ha hagut un problema en pujar el fitxer. Si us plau, torna-ho a intentar.",
	"You can set up the settings of each type of question here": "Pots configurar els paràmetres de cada tipus de pregunta aquí.",
	"Different max / min file upload": "Pujada de fitxer amb un màxim/mínim diferent.",
	"Turn on if you want to allow uploading a range of files to the exercise": "Permet pujar diversos fitxers en aquesta activitat.",
	"File size limit": "Límit de mida del fitxer",
	"Max size each file can reach. This is a default value and cannot be editted": "Mida màxima a què pot arribar cada fitxer. És un valor per defecte i no es pot editar.",
	"Types of files allowed as attachments": "Tipus de fitxers permesos com a adjunts",
	"MS Word, Excel, Power Point, jpg, png, pdf, Open Office, txt, video and audio": "Word, Excel, Power Point, jpg, png, pdf, Open Office, txt, vídeo i àudio",
	"default": "Per defecte",
	"Files limit": "Límit de fitxers",
	"Min/Max number of files the student is allowed to upload": "Nombre mínim/màxim de fitxers que l'alumne pot pujar.",
	"Size thumb": "Mida de la miniatura",
	"Image size": "Mida de la imatge",
	"Background image": "Imatge de fons",
	"Canvas Background Image": "Imatge de fons del llenç",
	"Allowed files: images (jpg, png, gif), audio (mp3, ogg), video (mp4, ogg, webm, mkv), documents (word, excel, power point, pdf, open office, txt)": "Fitxers permesos: imatges (jpg, png, gif), àudio (mp3, ogg), vídeo (mp4, ogg, webm, mkv), documents (word, excel, power point, pdf, open office, txt)",
	"Allowed files: images (jpg, png, gif)": "Formats permesos: imatges (jpg, png, gif)",
	Exercise: "Activitat",
	background_image_alt: "Text alternatiu",
	response_exact_or_equivalent_title: "El resultat és exacte o equivalent",
	response_exact_or_equivalent_subtitle: "Elegeix ‘exacte’ si vols avaluar com a correctes només les respostes exactes. Elegeix ‘equivalent’ si vols donar com a correcta qualsevol expressió equivalent.",
	response_exact_or_equivalent_subtitle_option_equivliteral: "Exacte",
	response_exact_or_equivalent_subtitle_option_equivsymbolic: "Equivalent",
	response_decimals_title: "Decimals",
	response_decimals_subtitle: "Selecciona el nombre mínim de decimals.",
	response_response_value: "Valor de la resposta",
	response_title: "Resposta",
	response_decimal_option_0: "Sense decimals",
	response_decimal_option_1: "1 decimal",
	response_decimal_option_2: "2 decimals",
	response_decimal_option_3: "3 decimals",
	response_decimal_option_4: "4 decimals",
	response_decimal_option_5: "5 decimals",
	response_decimal_option_6: "6 decimals",
	stimulus_help: "Escriu l'enunciat de l'exercici aquí. Hi pots afegir text, equacions, taules i qualsevol material editable.",
	config_help: "Pots configurar els paràmetres de cada tipus de pregunta aquí.",
	answer_options_help: "Escriu les diferents opcions que vulguis mostrar a l'estudiant com a possibles respostes i tria’n l’ordre. Pots afegir més respostes fent clic al botó ‘Afegir’.",
	editor_response_title_accordion: "Resposta",
	config_canvas_height_title: "Altura per defecte",
	config_canvas_height_subtitle: "Altura predeterminada de l’espai de fons",
	background_image_title: "Imatge de fons",
	background_image_subtitle: "Estableix una imatge de fons",
	response_result_button_delete: "Eliminar resposta",
	config_variant_style_title: "Variant de l’autor",
	config_variant_style_subtitle: "Selecciona la variant desitjada",
	config_variant_style_input_placeholder: "Afegeix el nom de la classe",
	style_variant_default: "Per defecte",
	style_variant_custom: "Personalitzada",
	config_multiple_responses_title: "Resposta múltiple",
	config_multiple_responses_subtitle: "Activa’l si hi ha més d’una resposta vàlida.",
	button_validation_title_box: "Botó",
	button_validation_title: "Afegir el botó de validació",
	button_validation_subtitle: "Activa’l per afegir un botó de confirmació a l’alumne.",
	button_validation_alt: "Afegeix el teu text aquí.",
	button_validation_help: "Utilitza aquesta opció si vols que els alumnes marquin aquesta activitat com a completa després de finalitzar-la.",
	button_validation_default: "Fet",
	button_edit: "Editar",
	button_cancel: "Cancel·lar",
	button_confirm: "Confirmar",
	button_try_again: "** Intentar otra vez",
	button_cant_speak_now: "** No puedo hablar ahora",
	config_background_title: "Afegeix una imatge de fons",
	config_background_subtitle: "Activa’l per pujar una imatge per al fons.",
	config_background_help: "Pots pujar una imatge de fons.",
	exercise_example_text_title: "Escriu aquí el text de la pregunta.",
	exercise_example_text_subtitle: "Text abans d’emplenar una etiqueta",
	exercise_label_font_size_title: "Mida de la font",
	exercise_label_font_size_subtitle: "Determina la mida de la font a la caixa",
	config_duplicate_responses_title: "Duplicar respostes",
	config_duplicate_responses_subtitle: "Activa’l per duplicar les respostes.",
	feedback_exercise_title: "Tractament de l’error",
	feedback_exercise_placeholder: "Afegeix aquí el feedback general.",
	feedback_exercise_help: "Recorda que això ofereix a l’alumnat un tractament de l’error general de tota l’activitat. Pots fer-lo servir per fer alguna indicació o recordatori.",
	feedback_exercise_help_with_individual: "Pots ajudar l’alumnat oferint un tractament de l’error general de l’activitat. També pots introduir comentaris individuals a cada resposta, que li apareixeran si s’equivoca.",
	config_is_math_title: "És matemàtiques",
	config_is_math_subtitle: "Indica si és matemàtiques.",
	config_accent_sensitive_title: "Sensible als accents",
	config_accent_sensitive_subtitle: "Activa’l si vols tenir en compte els accents a les correccions.",
	config_case_sensitive_title: "Sensible a les majúscules",
	config_case_sensitive_subtitle: "Activa’l si vols que la resposta distingeixi entre majúscules i minúscules en corregir.",
	config_fix_spaces_title: "Arregla els espais.",
	config_fix_spaces_subtitle: "Desactiva’l si vols que l’ús incorrecte d’espais no penalitzi, independentment del lloc a la paraula.",
	config_max_character_title: "Restricció de caràcters",
	config_max_character_subtitle: "Introdueix el nombre màxim de caràcters per restringir l’extensió de la resposta.",
	config_max_character_input_title: "Estableix el límit de caràcters.",
	config_max_character_input_subtitle: "Especifica el nombre màxim de caràcters que l’alumne pot escriure.",
	config_max_character_input_placeholder: "Nombre màxim de caràcters",
	config_words_limit_title: "Comptador de paraules",
	config_words_limit_subtitle: "Introdueix un nombre màxim de paraules.",
	config_words_limit_input_title: "Estableix el límit de paraules.",
	config_words_limit_input_subtitle: "Especifica el nombre màxim de paraules que un estudiant pot escriure.",
	config_words_limit_input_placeholder: "Introduir el nombre màxim de paraules",
	config_autosize_response_title: "Resposta amb mida automàtica",
	config_autosize_response_subtitle: "Activa’l si vols que la longitud màxima del quadre de resposta sigui la mateixa que la de la solució.",
	"Drop your files here or": "Busca o arrossega aquí els teus fitxers.",
	browse: " ",
	"Max file size": "Mida màxima del fitxer",
	"MB · At least": "MB · mínim",
	"file required": "fitxer requerit",
	richText_placeholder: "Escriu aquí la teva resposta.",
	"Questions options": "Opcions de pregunta",
	"Answer options": "Opcions de resposta",
	Answer: "Resposta",
	config_stack_title: "Amuntegar",
	config_stack_subtitle: "Els arrossegables s’aniran amuntegant dins de les àrees quan la mida de la pantalla ho permeti.",
	config_with_box_title: "Opcions d'emmarcar en caixes",
	config_with_box_subtitle: "Els arrossegables es marcaran amb una línia en seleccionar-los.",
	config_lines_color_title: "Color de les línies",
	config_lines_color_subtitle: "Elegeix un color de línia",
	line_thinckness_fine: "Fi",
	line_thinckness_medium: "Mitjà",
	line_thinckness_coarse: "Gruixut",
	config_line_thickness_title: "Gruix de les línies",
	config_line_thickness_subtitle: "Elegeix una mida de línia.",
	config_feedback_mode_click_to_find_title: "Mode de feedback",
	config_feedback_mode_click_to_find_subtitle: "Cap, amb vora o marca",
	feedback_mode_none: "Cap",
	"feedback_mode_feedback-with-border": "Amb vora",
	"feedback_mode_feedback-with-tick": "Amb marca",
	click_to_find_size_background_title: "Mida de la imatge de fons",
	click_to_find_size_background_subtitle: "Mida de la imatge",
	click_to_find_solutions_tooltip_correct: "Marcar com a correcte",
	click_to_find_solutions_tooltip_incorrect: "Marcar com a incorrecte",
	config_column_direction_title: "Direcció de la columna",
	config_column_direction_subtitle: "Vertical o horitzontal",
	column_direction_horizontal: "Horitzontal",
	column_direction_vertical: "Vertical",
	linking_lines_limit_options_help: "Per a una visualització correcta, el nombre d’opcions està limitat a 6.",
	evaluation_mode_tooltip: "Desactiva’l si vols corregir manualment o recollir informació que no compti per a la nota.",
	individual_feedback_exercise_placeholder: "Escriu el feedback en aquesta resposta.",
	label_drop_item: "Resposta",
	individual_feedback_exercise_tooltip: "Afegeix el feedback per a aquesta resposta.",
	change_image: "Canviar la imatge",
	answer_options_help_multiple_choice: "Escriu les diferents opcions que vulguis mostrar a l'estudiant com a possibles respostes i elegeix-ne l’ordre.",
	add_alternative: "Alternativa",
	solutions_instructions: "Defineix la resposta correcta a l’exercici i la puntuació. Assigna el 100 % si la resposta és correcta. També pots proporcionar una resposta alternativa i assignar el % del total de punts que mereix.",
	image: "Imatge",
	add_an_image_to_exercise: "Afegeix una imatge a l’activitat",
	button_show_hints: "Pista",
	button_validate: "Comprova",
	button_restart: "Refés",
	button_repeat: "Repetir",
	button_show_solution: "Mostra la solució",
	button_hide_solution: "Mostra la meva resposta",
	button_restart_scaffold: "Reiniciar scaffolding",
	points: "Punts",
	button_next_question: "Següent",
	button_i_dont_know: "No ho sé",
	title_help: "Aquest camp no serà visible per a l’alumnat. Servirà per facilitar a l’editor la cerca d’exercicis.",
	title_placeholder: "Escriu aquí el text",
	hints_title_box: "Pista",
	hints_help: "Les pistes són petits missatges que l’alumnat pot demanar quan necessiti ajuda. Pots afegir suggeriments a aquesta activitat aquí.",
	hints_title: "Afegeix la pista",
	hints_subtitle: "Activa’l per donar a l’alumnat una petita informació o consell.",
	hint_placeholder: "Àrea amb text de pista",
	automatic_evaluation: "Avaluació automàtica",
	automatic_evaluation_description: "Desactiva’l per avaluar manualment i permetre respostes obertes.",
	title_title_box: "Nom intern",
	feedback_exercise_toogle_title: "Afegeix el feedback",
	feedback_exercise_toogle_subtitle: "Activa’l per orientar l’alumnat quan comet un error.",
	multiple_choice_multiple_stimulus_default: "Selecciona almenys una (o més) de les opcions següents:",
	multiple_choice_single_stimulus_default: "Selecciona una de les opcions següents:",
	multiple_choice_truefalse_stimulus_default: "Llegeix i contesta 'Veritable' o 'Fals':",
	multiple_choice_blockletter_stimulus_default: "Elegeix una de les opcions següents:",
	choice_matrix_inline_stimulus_default: "Decideix si les opcions següents són veritables o falses:",
	choice_matrix_standard_stimulus_default: "Decideix si les opcions següents són veritables o falses:",
	classify_classification_stimulus_default: "Arrossega i deixa anar cada resposta al seu lloc:",
	classify_matchlist_stimulus_default: "Emparella cada resposta amb el seu concepte:",
	classify_orderlist_stimulus_default: "Arrossega i deixa anar per ordenar les respostes:",
	classify_linkinglines_stimulus_default: "Uneix cada paraula amb el seu significat:",
	cloze_text_stimulus_default: "Escriu la paraula que falta a les caixes que es mostren a continuació:",
	cloze_dropdown_stimulus_default: "Selecciona l’opció correcta de cada desplegable:",
	cloze_drag_drop_stimulus_default: "Arrossega i deixa anar les respostes dins dels buits.",
	essay_plaintext_stimulus_default: "Escriu una redacció de 200 paraules sobre el teu lloc preferit.",
	essay_sorttext_stimulus_default: "Quin és el riu més llarg d’Amèrica del Sud?",
	essay_sorttext_solution1_default: "El riu Amazones.",
	essay_richtext_stimulus_default: "Escriu una redacció de 200 paraules sobre el teu lloc preferit.",
	labelimage_dragdrop_stimulus_default: "Arrossega i deixa anar cada país al seu lloc:",
	labelimage_dropdown_stimulus_default: "Selecciona l’opció correcta de cada desplegable:",
	labelimage_imagewithtext_stimulus_default: "Escriu el nom de cada país:",
	math_clozemath_stimulus_default: "Calcula les operacions següents:",
	other_uploadfile_stimulus_default: "Fes una foto als teus deures i puja-la aquí:",
	other_pencil_stimulus_default: "Dibuixa la teva mascota o animal preferit i on viu:",
	other_statement_stimulus_default: "Elegeix un company o companya i comenta per què tenir un estil de vida saludable és important.",
	other_clicktofind_stimulus_default: "Fes clic a totes les llimones:",
	choice_matrix_questions_help: "Introdueix els enunciats de les preguntes a les caixes. Pots afegir més preguntes fent clic al botó ‘Afegir’.",
	match_list_questions_help: "Introdueix els enunciats de les preguntes a les caixes. Pots afegir més preguntes fent clic al botó ‘Afegir’.",
	linking_lines_questions_help: "Introdueix els enunciats de les preguntes a les caixes. Pots afegir més preguntes fent clic al botó ‘Afegir’.",
	scaffold_separator_step: "Pas",
	scaffold_separator_of: "de",
	title_check_icon_single_choice: "Botó d’opció",
	subtitle_check_icon_single_choice: "Desactiva’l per amagar el botó i utilitzar el mode bloc en lloc seu. ",
	title_check_icon_multiple_choice: "Casella d’opció",
	subtitle_check_icon_multiple_choice: "Desactiva’l per amagar la casella i utilitzar el mode bloc en lloc seu.",
	title_block_style: "Estil de la llista",
	subtitle_block_style: "Cap, numèrica o alfabètica",
	Spain: "Espanya",
	template_exercise_markup_add_blank: "Afegeix un buit",
	template_markup_add_blank: "Afegeix un buit",
	sending_button: "Enviant...",
	table_editor_help: "Utilitza l’editor de taula per configurar el nombre de columnes i files de la taula. Hi pot haver, com a mínim, una columna i, com a  màxim, cinc.",
	cloze_exercise_help: "Escriu una oració i utilitza les caixes en blanc perquè l’alumnat identifiqui quines són les paraules clau que falten al text.",
	cloze_math_exercise_help: "Escriu l’enunciat i utilitza les caixes en blanc perquè l'alumne identifiqui quins són els números o fórmules clau que hi falten.",
	label_exercise_help: "Afegeix tantes caixes en blanc com necessitis i col·loca-les a la imatge. Pots canviar la imatge de fons, redimensionar les caixes i la mida de la font.",
	cloze_dropdown_exercise_help: "Escriu una oració i utilitza les caixes en blanc per afegir-hi opcions. L’alumne haurà de seleccionar l’opció correcta a cada buit que trobi al text.",
	click_to_find_exercise_help: "Reemplaça la imatge de fons, afegeix imatges noves i col·loca-les al llenç. Podràs definir quina és correcta o incorrecta a la secció ‘Solució’.",
	linking_lines_question_option: "Opció de pregunta",
	title_evaluation_type: "Tipus d’avaluació",
	subtitle_evaluation_type_exact_match: "L’alumne haurà de contestar correctament per rebre la puntuació.",
	subtitle_evaluation_type_partial_match: "La puntuació general de l’exercici es dividirà entre les respostes, i cadascuna es puntuarà individualment.",
	subtitle_evaluation_type_manual: "L’activitat no s’avalua.",
	subtitle_evaluation_type_match_response: "La puntuació general de l’exercici es dividirà entre els elements d’arrossegament, i cadascun es puntuarà individualment.",
	subtitle_evaluation_type_match_group: "La puntuació general de l’exercici es dividirà entre els grups, i cadascun es puntuarà individualment.",
	evaluation_type_exact_match: "Correcció exacta",
	evaluation_type_partial_match: "Correcció parcial",
	evaluation_type_manual: "Correcció manual",
	evaluation_type_match_response: "Parcial per resposta",
	evaluation_type_match_group: "Parcial per grup",
	manual_or_alternative_solutions_help: "Defineix la resposta correcta a l’exercici que tindrà assignat el 100 %. També pots crear solucions alternatives i assignar el % que mereixin. En cas que vulguis que l’exercici no sigui autoavaluatiu, selecciona la correcció manual.",
	exact_math_or_partial_match_or_manual_solutions_help: "Amb la correcció exacta, l’alumnat haurà de resoldre l’exercici correctament per rebre la puntuació. També pots crear solucions alternatives i assignar el % que mereixi. Amb la correcció parcial, el total de punts es dividirà entre cada resposta, i cadascuna s’avaluarà individualment. Si vols que l’exercici no sigui autoavaluatiu, selecciona la correcció manual.",
	exact_math_or_match_response_or_match_group_or_manual_solutions_help: "Amb la correcció exacta, l’alumnat haurà de resoldre l’exercici correctament per rebre la puntuació. També pots crear solucions alternatives i assignar el % que mereixin. Amb la correcció parcial per resposta, el total de punts es dividirà entre cada resposta, i cadascuna s’avaluarà individualment. Amb la correcció parcial per grup, els punts es dividiran entre els elements o cel·les. Si vols que l’exercici no s'avaluï, selecciona la correcció manual.",
	solutions_penalty_title: "Personalitzat",
	solutions_penalty_subtitle: "Selecciona manualment un % de penalització per resposta",
	feedback_exercise_toogle_individual_feedback_title: "Afegeix el tractament de l’error a cada resposta.",
	feedback_exercise_toogle_individual_feedback_subtitle: "El missatge li apareixerà a l’alumnat quan respongui incorrectament.",
	"Answer Option": "Opció de resposta",
	"Text Prompt": "Pregunta",
	config_fixed_keyboard_title: "Teclat flotant",
	config_fixed_keyboard_subtitle: "Activa’l per mostrar a l’alumne un teclat flotant quan selecciona una casella.",
	config_number_keyboards_title: "Teclat numèric",
	config_number_keyboards_subtitle: "Selecciona el tipus de teclat que apareixerà a l’alumne.",
	keyboard_type_NONE: "Cap",
	keyboard_type_NUMERICAL: "Numèric",
	keyboard_type_BASIC: "Bàsic",
	keyboard_type_INTERMEDIATE: "Intermedi",
	keyboard_type_COMPLEX: "Avançat",
	keyboard_type_SCIENTIFIC: "Científic",
	solutions_new_alternative_text: "Nova",
	no_microphone: "No tinc micròfon.",
	confirm_replace_audio_message: "Ja existeix un àudio gravat. Fes clic a 'Confirmar' si vols reemplaçar-lo per un de nou.",
	config_audio_duration_limit_title: "Límit de temps",
	config_audio_duration_limit_subtitle: "Selecciona els segons que l’alumne tindrà per enregistrar-se.",
	other_audio_recorder_stimulus_default: "Enregistra’t explicant el procés de la fotosíntesi.",
	no_mic_available: "No s'ha trobat el micròfon al dispositiu.",
	no_mic_permission: "Micròfon bloquejat. Assegura't que l'accés està permès.",
	confirm_switching_keyboards_title: "Atenció",
	confirm_switching_keyboards_message: "Les solucions editades s'esborraran en canviar de teclat.",
	math_counting_stimulus_default: "Quantes pomes i llimones necessito per tenir sis peces de fruita?",
	other_clock_stimulus_default: "Són les 15:30",
	sample_answer_title_box: "Resposta model",
	sample_answer_help: "Pots crear una resposta model que t'ajudi a corregir les activitats no autoavaluatives. Aquesta secció només serà visible per al professorat.",
	sample_answer_title: "Afegeix resposta model",
	sample_answer_subtitle: "Exemple d'una solució model per al professorat.",
	sample_answer_placeholder: "Escriu aquí el text",
	other_word_search_stimulus_default: "Troba les paraules següents:",
	word_search_grid_s: "S (6x6)",
	word_search_grid_m: "M (10x10)",
	word_search_grid_l: "L (15x15)",
	word_search_title_box: "Sopa de lletres",
	word_search_help: "Selecciona la mida de la quadrícula",
	word_search_title: "Quadrícula",
	word_search_subtitle: "Selecciona el nombre de files/columnes",
	config_word_search_random_title: "Posició aleatòria de les paraules",
	config_word_search_random_subtitle: "Les paraules es mostraran en una posició diferent cada vegada que s'hi accedeixi.",
	config_word_search_backward_title: "Paraules invertides",
	config_word_search_backward_subtitle: "Hi pot haver paraules escrites de dreta a esquerra",
	config_word_search_diagonal_title: "Paraules en diagonal",
	config_word_search_diagonal_subtitle: "Hi pot haver paraules escrites en diagonal",
	word_search_counter_letter: "Límit de lletres",
	config_word_search_allowed_letters_title: "Lletres permeses",
	config_word_search_allowed_letters_subtitle: "Activa per indicar les lletres permeses",
	confirm_switching_columns_rows_title: "Atenció!",
	confirm_switching_columns_rows_message: "Les paraules següents s'eliminaran:",
	confirm_edit_allowed_letter_title: "Atenció!",
	confirm_edit_allowed_letter_message: "Les paraules que continguin caràcters diferents dels indicats s'eliminaran.",
	word_search_preview_title_box: "Previsualització de la sopa de lletres",
	word_search_preview_help: "Així es veuran les solucions a la sopa de lletres",
	word_search_button_generate: "Genera nova",
	word_search_solutions_help: "Indica paraules amb 2 lletres com a mínim. No es poden utilitzar nombres, espais o caràcters especials.",
	other_crossword_stimulus_default: "Mots encreuats",
	crossword_solutions_help: "Indica paraules amb almenys dues lletres. No es poden fer servir nombres, espais o caràcters especials.",
	crossword_counter_letter: "Límit de lletres",
	crossword_word_out: "No existeix cap coincidència entre paraules. Intenta-ho afegint més paraules.",
	config_uppercase_lowercase_title: "Selecciona majúscules/minúscules",
	config_uppercase_lowercase_subtitle: "Les paraules es mostraran en majúscules o en minúscules.",
	config_uppercase: "Majúscules",
	config_lowercase: "Minúscules",
	crossword_message_min_words: "Necessita un mínim de {{num_words}} paraules.",
	crossword_solutions_text_not_valid: "Paraula no vàlida. Mínim 2 lletres.",
	crossword_preview_title_box: "Previsualització dels mots encreuats",
	crossword_preview_help: "Així es veuran les solucions dels mots encreuats.",
	crossword_button_generate: "Genera’n de nous",
	generation_error: "No s’han pogut generar els mots encreuats.",
	upload_file_button_drive: "Puja amb Google Drive",
	file_uploader_drive: "Via Google Drive",
	file_uploaded_successfully: "Fitxer enviat correctament",
	files_uploaded_successfully: "Fitxers enviats correctament",
	title_penalty_modes: "Punts de penalització",
	subtitle_penalty_mode_none: "Penalitza les respostes fallides pel mateix valor de les respostes encertades. També pots crear la penalització a mida",
	subtitle_penalty_mode_per_response: "Penalitza les respostes fallides pel mateix valor de les respostes encertades. També pots crear la penalització a mida",
	subtitle_penalty_mode_custom: "Penalitza les respostes fallides pel mateix valor de les respostes encertades. També pots crear la penalització a mida",
	penalty_mode_none: "Cap",
	penalty_mode_per_response: "Puntuació de resposta encertada",
	penalty_mode_custom: "Personalitzat",
	config_show_selection_title: "Mostra selecció",
	config_show_selection_subtitle: "L'estudiant veurà senyalat l'objecte seleccionat",
	alternative_response: "Resposte alternative",
	alternative_responses: "Respostes alternatives",
	config_autosize_box_title: "Capsa amb mida de resposta",
	config_autosize_box_subtitle: "Activa-ho si vols que la mida de la capsa s’adapti a la mida de la resposta",
	Transcription: "Transcripció",
	other_rating_stimulus_default: "És hora de valorar el contingut!",
	other_rating_tooltip_1_star: "1 estrella",
	other_rating_tooltip_multiple_stars: "{{count}} estrelles",
	other_rating_description_1_star: "No m'ha agradat. M'ha confós i m'ha avorrit.",
	other_rating_description_2_stars: "M'ha agradat més o menys... Algunes coses les he entès millor que d'altres.",
	other_rating_description_3_stars: "M'ha agradat força. L'he entès i m'ha interessat :)",
	other_rating_description_4_stars: "M'ha encantat! L'he trobat interessant i divertit. Vull més!",
	adaptative_choice_levels_config: "Configuració de Nivells",
	adaptative_choice_levels_config_help: "Configura els títols de cada nivell de l'activitat adaptativa",
	adaptative_choice_level_title: "Nivell {{level_number}}",
	adaptative_choice_level_title_label: "Títol del nivell:",
	adaptative_choice_level_title_placeholder: "Escriu el títol d'aquest nivell...",
	other_adaptative_choice_back: "Enrere",
	other_adaptative_choice_next: "Següent"
};
var ca = {
	translations: translations$1
};

var translations$2 = {
	title: "Title",
	enunciated: "Text prompt",
	stimulus: "Add Exercise Elements",
	enunciated_placeholder: "Write a description",
	multiple_choice_activity: "Multiple Choice",
	answer_options: "Answer Options",
	add_new_response: "Add",
	add_new_question: "Add",
	new_question_stem: "New question",
	validation: "Score",
	option: "Option",
	type_of_validation: "Choose the validation type:",
	exactMatch: "Exact: All parts of the question must be answered correctly to receive a mark.",
	partialMatch: "Partial: Each correct response element will be scored individually, and the overall question score will be divided between responses.",
	partialMatchV2: "Partial per response: Each correct response element will be awarded an individual score.",
	score: "Score",
	high_score: "Max points",
	enter_a_score: "Enter a score",
	minimum_score: "Minimum score per try",
	cancel: "Cancel",
	save: "Save",
	send: "Send",
	reset: "Reset",
	undo: "Undo",
	redo: "Redo",
	shuffle_options: "Shuffle Answers",
	multiple_responses: "Multiple Responses",
	words_limit: "Word Limit",
	letters_limit: "Character Limit",
	essay_placeholder: "Write your answer",
	right_answer: "Right answer",
	write_right_answer: "Write the right answer",
	copy: "Copy",
	cut: "Cut",
	paste: "Paste",
	cloze_text: "Cloze Text",
	activity_data_wrong: "The data has wrong format",
	this_is_the_stem: "Write the question statement here",
	"true": "True",
	"false": "False",
	column: "Column",
	columns: "Columns",
	row: "Row",
	world_map: "World map",
	Greenland: "Greenland",
	Russia: "Russia",
	United_States: "United States",
	table_editor: "Table Editor",
	drags: "Drags",
	add_new_column: "Add column title",
	add_new_row: "Add row title",
	duplicate_responses: "Duplicate Responses",
	solutions: "Solutions",
	Solution: "Solution",
	column_count: "Column Count",
	row_count: "Row Count",
	cloze_template: "Risus {{response}}, et tincidunt turpis facilisis. Curabitur eu nulla justo. Curabitur vulputate ut nisl et bibendum. Nunc diam enim, porta sed eros vitae. {{response}} dignissim, et tincidunt turpis facilisis. Curabitur eu nulla justo. Curabitur vulputate ut nisl et bibendum.",
	response: "Response",
	response_containers: "Response Containers",
	global_size: "Global size",
	width: "Width",
	height: "Height",
	upload_file: "Upload File",
	completed: "Completed",
	choose_file: "Choose File",
	change_file: "Change File",
	load_image_error_message: "An error occurred while trying to upload the image.",
	sending_file: "Uploading file",
	select_an_item: "Select an item",
	pointer: "Pointer",
	none: "None",
	left: "Left",
	right: "Right",
	top: "Top",
	bottom: "Bottom",
	show_check_icon: "Show Check Icon",
	alternative_text: "Alternative text image description",
	isEvaluable: "Evaluation Mode",
	autosize_response: "Autosize Response",
	text_normalization: "Text normalization",
	load_image: "Upload Image",
	image_size: "Image Size",
	text_sample: "Text Sample",
	size: "Size",
	accent_sensitive: "Accent Sensitive",
	case_sensitive: "Case Sensitive",
	spaces_sensitive: "Consider Spaces",
	orientation: "Orientation",
	"delete": "Delete",
	stack: "Stack",
	box: "Box",
	Feedback: "Feedback",
	"Remove feedback": "Remove Feedback",
	Visibility: "Visibility",
	"Success Message": "Success message",
	"Error Messages": "Error messages",
	Sequence: "Sequence",
	cyclic: "Cyclic",
	random: "Random",
	"Add new error": "Add new error",
	"Error message": "Error message",
	Configuration: "Configuration",
	"Shuffle Answers": "Shuffle Answers",
	"When turned on the questions will be sorted in differ order each time they are presented": "When turned on, the questions will be sorted in a different order each time they are presented",
	"Show check icon": "Show Check Icon",
	"When turned on the answers will have a radio button next to them": "When turned on the answers will have a radio button next to them",
	Columns: "Columns",
	"Choose how many columns you want the answers to be displayed into": "Choose how many columns you want the answers to be displayed in",
	style_block_none: "None",
	style_block_BLOCK: "Block",
	style_block_NUMERICAL: "Numerical",
	style_block_UPPER_ALPHA: "Uppercase alphabet",
	style_block_LOWER_ALPHA: "Lowercase alphabet",
	"1 columns": "1 column",
	"2 columns": "2 columns",
	"3 columns": "3 columns",
	"4 columns": "4 columns",
	"5 columns": "5 columns",
	"6 columns": "6 columns",
	SERVER_ERROR: "Sorry, there was a problem uploading the file. Please try again.",
	MAX_FILES_REACHED: "You’ve reached the maximum number of files allowed.",
	INVALID_TYPE: "Invalid file type",
	MAX_SIZE_EXCEEDED: "The file you’re trying to upload exceeds the maximum size allowed. Please reduce the file size and try again",
	UNKNOWN_ERROR: "Sorry, there was a problem uploading the file. Please try again.",
	"You can set up the settings of each type of question here": "You can set up the settings of each type of question here",
	"Different max / min file upload": "Number of file uploads allowed",
	"Turn on if you want to allow uploading a range of files to the exercise": "Turn this on to specify the minimum and maximum number of files a student can upload to this exercise",
	"File size limit": "File size limit",
	"Max size each file can reach. This is a default value and cannot be editted": "Max size each file can reach. This is a default value and cannot be edited",
	"Types of files allowed as attachments": "Types of files allowed as attachments",
	"MS Word, Excel, Power Point, jpg, png, pdf, Open Office, txt, video and audio": "MS Word, Excel, Power Point, jpg, png, pdf, Open Office, txt, video and audio",
	"default": "default",
	"Files limit": "Files Limit",
	"Min/Max number of files the student is allowed to upload": "Min/Max number of files the student is allowed to upload",
	"Size thumb": "Size thumb",
	"Image size": "Image size",
	"Background image": "Background Image",
	"Canvas Background Image": "Upload a background image to the canvas",
	"Allowed files: images (jpg, png, gif), audio (mp3, ogg), video (mp4, ogg, webm, mkv), documents (word, excel, power point, pdf, open office, txt)": "Allowed files: images (jpg, png, gif), audio (mp3, ogg), video (mp4, ogg, webm, mkv), documents (word, excel, power point, pdf, open office, txt)",
	"Allowed files: images (jpg, png, gif)": "Allowed files: images (jpg, png, gif)",
	Exercise: "Exercise Text",
	background_image_alt: "Alternative text image description",
	response_exact_or_equivalent_title: "Result is exact or equivalent",
	response_exact_or_equivalent_subtitle: "Select exact if you want only the exact expression or value to be evaluated as correct. Select equivalent if any equivalent expression or value will be evaluated as correct.",
	response_exact_or_equivalent_subtitle_option_equivliteral: "Exact",
	response_exact_or_equivalent_subtitle_option_equivsymbolic: "Equivalent",
	response_decimals_title: "Decimals",
	response_decimals_subtitle: "Select minimum number of decimals",
	response_response_value: "Response value",
	response_title: "Response",
	response_decimal_option_0: "No decimals",
	response_decimal_option_1: "1 decimal",
	response_decimal_option_2: "2 decimals",
	response_decimal_option_3: "3 decimals",
	response_decimal_option_4: "4 decimals",
	response_decimal_option_5: "5 decimals",
	response_decimal_option_6: "6 decimals",
	stimulus_help: "Include all information for the exercise here. You can add text, equations, tables and any other editable material.",
	config_help: "You can configure the exercise settings here.",
	answer_options_help: "Define the different options you want the student to see as responses and in which order. You can add more answer options by clicking the Add button.",
	editor_response_title_accordion: "Response",
	config_canvas_height_title: "Height default",
	config_canvas_height_subtitle: "Default background space height",
	background_image_title: "Background Image",
	background_image_subtitle: "Set the background image",
	response_result_button_delete: "Delete response",
	config_variant_style_title: "Author's Variant",
	config_variant_style_subtitle: "Select the style variant for the exercise",
	config_variant_style_input_placeholder: "Add Classname",
	style_variant_default: "Default",
	style_variant_custom: "Custom",
	config_multiple_responses_title: "Multiple Responses",
	config_multiple_responses_subtitle: "When turned on more than one response is valid",
	button_validation_title_box: "Button",
	button_validation_title: "Add Completion Button",
	button_validation_subtitle: "Turn it on to add a completion button for the student to select, and rename it if necessary",
	button_validation_alt: "Add your text here",
	button_validation_help: "Use this button if you need the student to mark this activity as complete after they have finished it.",
	button_validation_default: "Done",
	button_edit: "Edit",
	button_cancel: "Cancel",
	button_confirm: "Confirm",
	button_try_again: "Try again",
	button_cant_speak_now: "Can't speak now",
	config_background_title: "Add background image",
	config_background_subtitle: "Turn it on to upload a background image",
	config_background_help: "You can upload a background image.",
	exercise_example_text_title: "Example Text",
	exercise_example_text_subtitle: "Sample filler text",
	exercise_label_font_size_title: "Label font size",
	exercise_label_font_size_subtitle: "Determines the font size of a label",
	config_duplicate_responses_title: "Duplicate Responses",
	config_duplicate_responses_subtitle: "When turned on more than one response is valid",
	feedback_exercise_title: "Corrective Feedback",
	feedback_exercise_placeholder: "Write general feedback",
	feedback_exercise_help: "Remember this will provide overall exercise feedback and not for each possible response. You might want to use it to give some advice or to review a topic.",
	feedback_exercise_help_with_individual: "You can add overall exercise feedback to give some advice or to review a topic. You can also provide feedback on each response to help the student when answers incorrectly.",
	config_is_math_title: "Is Math",
	config_is_math_subtitle: "Indicate if it is math",
	config_accent_sensitive_title: "Accent Sensitive",
	config_accent_sensitive_subtitle: "Turn off if you do not want accents to matter (for example, 'canción' will be the same as 'cancion')",
	config_case_sensitive_title: "Case Sensitive",
	config_case_sensitive_subtitle: "Turn off if you do not want the answer to be case sensitive",
	config_fix_spaces_title: "Consider Spaces",
	config_fix_spaces_subtitle: "Turn off if you do not want unnecessary spaces to be counted as a mistake, whether they are at the beginning, middle or end of the sentence (for example, 'the sun is a star' will be the same as '  the   sun   is  a     star   ')",
	config_max_character_title: "Max Character Restriction",
	config_max_character_subtitle: "Turn off if you do not want to restrict the length of the answer",
	config_max_character_input_title: "Select Character Limit",
	config_max_character_input_subtitle: "Specify the maximum number of characters a student can write",
	config_max_character_input_placeholder: "Max Character",
	config_words_limit_title: "Word Counter",
	config_words_limit_subtitle: "Add a maximum word limit",
	config_words_limit_input_title: "Select Word Limit",
	config_words_limit_input_subtitle: "Specify the maximum number of words a student can write",
	config_words_limit_input_placeholder: "Enter a maximum number of words",
	config_autosize_response_title: "Max answer length",
	config_autosize_response_subtitle: "Limit the maximum number of answer characters to match the longest solution",
	"Drop your files here or": "Drop your files here or",
	browse: "Browse",
	"Max file size": "Max file size",
	"MB · At least": "MB · At least",
	"file required": "file required",
	richText_placeholder: "Write your answer",
	"Questions options": "Text Prompts",
	"Answer options": "Answer Options",
	Answer: "Answer",
	config_stack_title: "Stack Options",
	config_stack_subtitle: "If turned on, the drop options will be stacked inside the drag area on smaller screens to save space",
	config_with_box_title: "Frame options in boxes",
	config_with_box_subtitle: "If turned off, the line border surrounding each answer option will disappear when dropped into the table",
	config_lines_color_title: "Connecting Lines Color",
	config_lines_color_subtitle: "Select a line color",
	line_thinckness_fine: "Fine",
	line_thinckness_medium: "Medium",
	line_thinckness_coarse: "Coarse",
	config_line_thickness_title: "Connecting Lines Thickness",
	config_line_thickness_subtitle: "Select a line size",
	config_feedback_mode_click_to_find_title: "Feedback Mode",
	config_feedback_mode_click_to_find_subtitle: "Select none, with border or with tick",
	feedback_mode_none: "None",
	"feedback_mode_feedback-with-border": "With border",
	"feedback_mode_feedback-with-tick": "With tick",
	click_to_find_size_background_title: "Size of Background",
	click_to_find_size_background_subtitle: "Use it to resize the background image",
	click_to_find_solutions_tooltip_correct: "Mark as correct",
	click_to_find_solutions_tooltip_incorrect: "Mark as wrong",
	config_column_direction_title: "Column Direction",
	config_column_direction_subtitle: "Vertical or horizontal",
	column_direction_horizontal: "Horizontal",
	column_direction_vertical: "Vertical",
	linking_lines_limit_options_help: "For it to be displayed correctly, the number of options is limited to 6.",
	evaluation_mode_tooltip: "Turn off if you want to manually assess or collect non-grading information.",
	individual_feedback_exercise_placeholder: "Write individual feedback to this answer",
	label_drop_item: "Response",
	individual_feedback_exercise_tooltip: "Write individual feedback for this answer.",
	change_image: "Change Image",
	answer_options_help_multiple_choice: "Define the different options you want the student to see as responses to the question and in which order.",
	add_alternative: "Alternative",
	solutions_instructions: "Choose the correct answer option that will be awarded 100% of the points. You can also provide an alternative answer and assign it an appropriate percentage of points.",
	image: "Image",
	add_an_image_to_exercise: "Add an image to the exercise",
	button_show_hints: "Hint",
	button_validate: "Check answer",
	button_restart: "Restart",
	button_repeat: "Repeat",
	button_show_solution: "Show solution",
	button_hide_solution: "Show my answer",
	button_restart_scaffold: "Restart scaffolding",
	points: "Points",
	button_next_question: "Next",
	button_i_dont_know: "Step by step guidance",
	title_help: "This field will not be visible to the student. It will serve to facilitate searches for exercises by an editor.",
	title_placeholder: "Add your text here",
	hints_title_box: "Hint",
	hints_help: "Hints are short messages the student can ask for if they need help. You can add hints to this exercise here.",
	hints_title: "Add Hint",
	hints_subtitle: "Turn it on to give the student some helpful information or advice",
	hint_placeholder: "Area with hint text",
	automatic_evaluation: "Automatic Evaluation",
	automatic_evaluation_description: "Turn it off to manually assess and allow open answers",
	title_title_box: "Internal Name",
	feedback_exercise_toogle_title: "Add Feedback",
	feedback_exercise_toogle_subtitle: "Turn it on to give some guidance if the student makes a mistake",
	multiple_choice_multiple_stimulus_default: "Select at least one (or more) from the following options:",
	multiple_choice_single_stimulus_default: "Choose one of the following options:",
	multiple_choice_truefalse_stimulus_default: "Read and answer True or False:",
	multiple_choice_blockletter_stimulus_default: "Choose one of the following options:",
	choice_matrix_inline_stimulus_default: "Decide if the following are True or False:",
	choice_matrix_standard_stimulus_default: "Decide if the following are True or False:",
	classify_classification_stimulus_default: "Drag and drop each answer into the category you think it belongs:",
	classify_matchlist_stimulus_default: "Match each answer with the appropriate concept:",
	classify_orderlist_stimulus_default: "Drag and drop to order the following options:",
	classify_linkinglines_stimulus_default: "Link each word with its meaning:",
	cloze_text_stimulus_default: "Type the missing word in the boxes below:",
	cloze_dropdown_stimulus_default: "Select the correct option from the dropdown list:",
	cloze_drag_drop_stimulus_default: "Drag and drop the answers into the empty boxes.",
	essay_plaintext_stimulus_default: "Write a 200 words essay about your favorite place.",
	essay_sorttext_stimulus_default: "What is the longest river in South America?",
	essay_sorttext_solution1_default: "The Amazon River",
	essay_richtext_stimulus_default: "Write a 200 words essay about your favorite place.",
	labelimage_dragdrop_stimulus_default: "Drag and drop countries to their corresponding places:",
	labelimage_dropdown_stimulus_default: "Select the correct option from the dropdown list:",
	labelimage_imagewithtext_stimulus_default: "Write the name of each country labeled below:",
	math_clozemath_stimulus_default: "Calculate the following operations:",
	other_uploadfile_stimulus_default: "Take a picture of your homework and drop it here:",
	other_pencil_stimulus_default: "Draw below your favorite animal or pet and where it lives:",
	other_statement_stimulus_default: "Choose a partner and discuss why living a healthy lifestyle is important.",
	other_clicktofind_stimulus_default: "Click on all the lemons:",
	choice_matrix_questions_help: "Enter the text prompts in the boxes below. You can add more text prompts by clicking the Add button.",
	match_list_questions_help: "Enter the text prompts in the boxes below. You can add more text prompts by clicking the Add button.",
	linking_lines_questions_help: "Enter the text prompts in the boxes below. You can add more text prompts by clicking the Add button.",
	scaffold_separator_step: "Step",
	scaffold_separator_of: "of",
	title_check_icon_single_choice: "Radio button",
	subtitle_check_icon_single_choice: "Turn it off to hide the radio button and use a block style instead",
	title_check_icon_multiple_choice: "Check box",
	subtitle_check_icon_multiple_choice: "Turn it off to hide the check box and use a block style instead",
	title_block_style: "List style",
	subtitle_block_style: "Choose from none, numbers or upper/lowercase alphabet",
	Spain: "Spain",
	template_exercise_markup_add_blank: "Add blank",
	template_markup_add_blank: "Add blank",
	sending_button: "Sending ...",
	table_editor_help: "Use the table editor settings to configure the number of rows and columns in your table. You will have at least one column and no more than five.",
	cloze_exercise_help: "Write a sentence or paragraph and use blank boxes so the student can fill in the missing keywords.",
	cloze_math_exercise_help: "Create the exercise using the blank boxes so the student can fill in the missing number or expression.",
	label_exercise_help: "Add as many blank boxes as you need and place them on the image. You can change the image background, resize the boxes and the font size of the responses.",
	cloze_dropdown_exercise_help: "Write a sentence or paragraph and use blank boxes to add different options. The student will select one option for each missing keyword.",
	click_to_find_exercise_help: "Replace the background image, use the add button to insert new images and place them wherever you need. You can define which one is correct or incorrect in Solutions below.",
	linking_lines_question_option: "Text prompt",
	title_evaluation_type: "Evaluation Type",
	subtitle_evaluation_type_exact_match: "All parts of the question must be answered correctly to receive a mark",
	subtitle_evaluation_type_partial_match: "Each correct response element will be scored individually, and the overall question score will be divided between responses",
	subtitle_evaluation_type_manual: "Removes all scoring from the question. Useful for practice questions or in case review by the teacher is needed",
	subtitle_evaluation_type_match_response: "Each correct response element will be scored individually, and the overall question score will be divided between responses",
	subtitle_evaluation_type_match_group: "The overall question score will be divided between drops, and each one will be scored individually",
	evaluation_type_exact_match: "Exact Match",
	evaluation_type_partial_match: "Partial Match",
	evaluation_type_manual: "Manual",
	evaluation_type_match_response: "Match Response",
	evaluation_type_match_group: "Match Group",
	manual_or_alternative_solutions_help: "Choose the correct Answer Option that will be awarded 100% of the points. You can also provide and alternative answer and assign it an appropriate percentage of points. In case that you want to remove all scoring from the question, select Manual evaluation.",
	exact_math_or_partial_match_or_manual_solutions_help: "Exact Match will give the correct solution 100% of the score and all parts of the question must be answered correctly to receive a mark. You can also provide and alternative answer and assign it an appropriate percentage of points. Partial Match will score each correct response element individually, and the overall question score will be divided between responses. Manual evaluation will remove all scoring from the question.",
	exact_math_or_match_response_or_match_group_or_manual_solutions_help: "Exact Match will give the correct solution 100% of the score and all parts of the question must be answered correctly to receive a mark. You can also provide and alternative answer and assign it an appropriate percentage of points. Match Response will score each response individually, and the overall question score will be divided between responses. Match Group will divide the score between drops. Manual evaluation will remove all scoring from the question.",
	solutions_penalty_title: "Custom",
	solutions_penalty_subtitle: "Select a custom % of penalization per response",
	feedback_exercise_toogle_individual_feedback_title: "Add specific feedback to each response",
	feedback_exercise_toogle_individual_feedback_subtitle: "Indications will appear to students when they answer incorrectly",
	"Answer Option": "Answer Option",
	"Text Prompt": "Text Prompt",
	config_fixed_keyboard_title: "Floating Keyboard",
	config_fixed_keyboard_subtitle: "Activate it to show the student a floating keyboard when an input box is clicked",
	config_number_keyboards_title: "Number Keyboards",
	config_number_keyboards_subtitle: "Select the style variant for the exercise",
	keyboard_type_NONE: "None",
	keyboard_type_NUMERICAL: "Numeric",
	keyboard_type_BASIC: "Basic",
	keyboard_type_INTERMEDIATE: "Intermediate",
	keyboard_type_COMPLEX: "Advanced",
	keyboard_type_SCIENTIFIC: "Scientific",
	keyboard_type_ROMAN: "Roman",
	keyboard_type_FUNCTIONS: "Functions",
	solutions_new_alternative_text: "New",
	no_microphone: "I don't have a mic",
	confirm_replace_audio_message: "<h1 class='lemo-confirm-title'>Replace audio<h1/><p class='lemo-confirm-content'>A previous audio recording exists. If you continue it will be replaced.</p>",
	config_audio_duration_limit_title: "Recording time limit",
	config_audio_duration_limit_subtitle: "Set a maximum length of seconds the student can record",
	other_audio_recorder_stimulus_default: "Record yourself explaining the process of photosynthesis.",
	no_mic_available: "We are unable to detect a microphone with your computer",
	no_mic_permission: "Microphone blocked. Make sure access is allowed",
	confirm_switching_keyboards_title: "Caution",
	confirm_switching_keyboards_message: "Edited solutions will be deleted when switching keyboards",
	math_counting_stimulus_default: "How many apples and lemons do I need to have six fruits?",
	other_clock_stimulus_default: "It's 15:30",
	sample_answer_title_box: "Reference Solution",
	sample_answer_help: "You can create a model answer to help you correct the manual correction activities. This section will only be visible to the teacher.",
	sample_answer_title: "Add Reference Solution",
	sample_answer_subtitle: "Example of a visible solution for the teacher",
	sample_answer_placeholder: "Add your text here",
	other_word_search_stimulus_default: "Find the following words:",
	word_search_grid_s: "S (6x6)",
	word_search_grid_m: "M (10x10)",
	word_search_grid_l: "L (15x15)",
	word_search_title_box: "Word Search",
	word_search_help: "Select grid size",
	word_search_title: "Grid",
	word_search_subtitle: " Select your grid size rows/columns",
	config_word_search_random_title: "Shuffle Answers",
	config_word_search_random_subtitle: "When turned on, the questions will be sorted in a different order each time they are presented",
	config_word_search_backward_title: "Inverted words",
	config_word_search_backward_subtitle: "Words appear in reverse",
	config_word_search_diagonal_title: "Diagonal words",
	config_word_search_diagonal_subtitle: "Diagonal words",
	word_search_counter_letter: "letter limit",
	config_word_search_allowed_letters_title: "Letters allowed",
	config_word_search_allowed_letters_subtitle: "Activate to edit the allowed letters",
	confirm_switching_columns_rows_title: "Attention!",
	confirm_switching_columns_rows_message: "The following words will be removed:",
	confirm_edit_allowed_letter_title: "Attention!",
	confirm_edit_allowed_letter_message: "Words containing characters other than the new string will be deleted.",
	word_search_preview_title_box: "Word Search Preview",
	word_search_preview_help: "This is how the solutions will look in the Word Search",
	word_search_button_generate: "Generate new",
	word_search_solutions_help: "Indicates words with at least 2 letters. No numbers, spaces or special characters can be entered.",
	other_crossword_stimulus_default: "Crossword",
	crossword_solutions_help: "Indicates words with at least two letters. No numbers, spaces or special characters can be used",
	crossword_counter_letter: "Letter limit",
	crossword_word_out: "No word match. Try adding more words.",
	config_uppercase_lowercase_title: "Select uppercase/ lowercase",
	config_uppercase_lowercase_subtitle: "Words will be shown in upper or lower case",
	config_uppercase: "Uppercase",
	config_lowercase: "Lowercase",
	crossword_message_min_words: "Need minimum {{num_words}} words",
	crossword_solutions_text_not_valid: "Invalid word. Minimum 2 letters",
	crossword_preview_title_box: "Crossword Preview",
	crossword_preview_help: "This is how the solutions will look in the crossword",
	crossword_button_generate: "Generate new",
	generation_error: "The crossword could not be generated",
	upload_file_button_drive: "Upload with Google Drive",
	file_uploader_drive: "Via Google Drive",
	file_uploaded_successfully: "File uploaded successfully",
	files_uploaded_successfully: "Files uploaded successfully",
	other_pathway_stimulus_default: "Follow the instructions",
	direction_LEFT: "to the left",
	direction_RIGHT: "to the right",
	direction_BOTTOM: "to the bottom",
	direction_TOP: "to the top",
	title_penalty_modes: "Penalty point",
	subtitle_penalty_mode_none: "Penalise failed answers by the same value as successful answers. You can also create a customised penalty",
	subtitle_penalty_mode_per_response: "Penalise failed answers by the same value as successful answers. You can also create a customised penalty",
	subtitle_penalty_mode_custom: "Penalise failed answers by the same value as successful answers. You can also create a customised penalty",
	penalty_mode_none: "None",
	penalty_mode_per_response: "Response score",
	penalty_mode_custom: "Custom",
	config_show_selection_title: "Show Selection",
	config_show_selection_subtitle: "** Mostrar la selección del estudiante",
	alternative_response: "Alternative response",
	alternative_responses: "Alternative responses",
	config_autosize_box_title: "Answer box size",
	config_autosize_box_subtitle: "If the answer is shorter than 6 characters, this option adapts the box size to the longest solution",
	charts_fractions_and_decimals_stimulus_default: "*** What would the figure to represent 4/6 look like?",
	charts_barchart_stimulus_default: "<p>In the shopping cart we have 5 avocados, 3 apples and 7 lemons. Select the correct quantity from the following chart.</p>",
	charts_linechart_stimulus_default: "<p>Which has been the average temperature during the year in these cities?</p>",
	charts_coordinate_axes_stimulus_default: "<p>Coordinate axes default stimulus</p>",
	"lemo-coordinate-axes-multiple-quadrant-error": "At the moment it's only possible to show a single coordinate quadrant.",
	no_audio_uploaded: "No audio uploaded",
	no_file_uploaded: "No file uploaded",
	main_response: "Main response",
	pie_chart_total_items_input: "In total there are",
	group_name: "Group Name",
	group_editor_exercise_list: "List",
	remove_grouped_question_modal_title: "Remove question",
	remove_grouped_question_modal_description: "<p>Are you sure you want to remove this question?</p><p>This action cannot be undone</p>",
	charts_pictograph_y_axis_name: "Units",
	charts_pictograph_x_axis_name: "Shopping list",
	charts_pictograph_y_axis_label: "Units",
	charts_pictograph_x_axis_label: "Shopping list",
	Avocados: "Avocados",
	Lemons: "Lemons",
	Apples: "Apples",
	Units: "Units",
	monday: "Monday",
	tuesday: "Tuesday",
	wednesday: "Wednesday",
	thursday: "Thursday",
	friday: "Friday",
	saturday: "Saturday",
	sunday: "Sunday",
	Madrid: "Madrid",
	Paris: "Paris",
	charts_line_chart_x_axis_name: "Seasons",
	charts_line_chart_y_axis_name: "Temperatures",
	question_group: "Question group",
	add_new_exercise: "Add new exercise",
	steps: "Steps",
	direction: "Direction",
	TOP: "Top",
	BOTTOM: "Bottom",
	LEFT: "Left",
	RIGHT: "Right",
	not_completed: "Not completed",
	group_name_placeholder: "Add your text here",
	group_name_help_text: "This field will not be visible to the student. It will serve to facilitate searches for exercise groups by an editor.",
	group_stimulus_box_title: "Group Stimulus",
	group_stimulus_placeholder: "Write the group question statement here",
	add_new_activity: "Add new activity",
	group_editor_exercise_list_help_text: "All exercises from this group will appear here. You can change their order of appearance.",
	question_group_default_stimulus: "Write the Group stimulus here",
	no_questions_in_group: "There's nothing here",
	pathway_steps_counter: "$numSteps steps left",
	upload_files: "Upload Files",
	get_feedback: "Get feedback",
	scaffolding_navigation_counter: "Step {index} of {total}",
	"scaffolding_navigation_toggle-show-activity": "View activity",
	"scaffolding_navigation_toggle-show-steps": "View step-by-step",
	barchart_table_editor_help: "Fill in the blanks to complete the table and the graph. Changes will be reflected in the player.",
	barchart_table_editor_add_row_tooltip: "Add rows to the table; they will also be reflected in the graph.",
	barchart_table_editor_add_series_tooltip: "Add a new series; it will be displayed in the graph as a new bar per series.",
	table_title: "Table title",
	series: "Series",
	serie_placeholder: "Serie's name",
	x_axis_title: "X axis title",
	y_axis_title: "Y axis title",
	measure: "Measure",
	measure_placeholder: "Measure unit",
	measure_description: "Choose the type of measurement unit",
	input_needs_value: "Please fill out this field",
	hide_table: "Hide Table",
	hide_table_description: "Show or hide the table next to the chart",
	chart_position: "Chart position",
	chart_position_description: "Select above, below left or right",
	table_position: "Table position",
	table_position_description: "Select above, left or right",
	max_y_value: "Maximum value Y",
	max_y_value_description: "Maximum value for the Y axis",
	linechart_max_y_value_description: "Maximum value for the Y axis (max 10, min 3)",
	min_y_value: "Minimum value Y",
	min_y_value_description: "Minimum value for the Y axis",
	multiplier: "Multiplier",
	multiplier_description: "Spacing displayed between numbers on the Y axis",
	TRIANGLE: "Triangle",
	QUAD: "Quad",
	RECTANGLE: "Rectangle",
	PENTAGON: "Pentagon",
	HEXAGON: "Hexagon",
	CIRCLE: "Circle",
	RANDOM: "Random",
	HUNDREDTHS: "Hundredths",
	TENTHS: "Tenths",
	winter: "Winter",
	spring: "Spring",
	summer: "Summer",
	fall: "Fall",
	add_row: "Add row",
	add_serie: "Add serie",
	text_turned_into_alt_text: "Text added will be turned into alt text and will not be shown.",
	modal_barchart_editor_reduce_bars_message: "The max quantity of bars to use series is 3. Clicking on confirm button, will remove the extra bars. Do you want to continue?",
	"theme-light-orange": "Light orange",
	"theme-dark-orange": "Dark orange",
	"theme-light-blue": "Light blue",
	"theme-dark-blue": "Dark blue",
	"theme-turquoise": "Turquoise",
	"theme-violet": "Violet",
	"theme-bordeaux": "Bordeaux",
	"theme-green": "Green",
	fraction_editor: "Fraction editor",
	fraction_editor_help: "Complete the sections to create the fraction to your liking.",
	fractions_shape_editor_title: "Shape",
	fractions_shape_editor_description: "Select the shape for the activity",
	fractions_divisions_editor_title: "Divisions",
	fractions_divisions_editor_description: "Choose how many divisions the figure will display",
	select_color_theme_title: "Color",
	select_color_theme_description: "Select a color",
	operations_editor_title: "Operations",
	operations_editor_help: "Complete the sections to create the operation to your liking.",
	counting_editor_operation_title: "Type of operation",
	counting_editor_operation_subtitle: "Select whether it is a sum, count or a subtraction",
	counting_editor_summand_title: "Summand",
	counting_editor_summand_subtitle: "Select a quantity",
	change_image_title: "Change image",
	change_image_subtitle: "The image can be changed but this field cannot be left empty",
	change_image_alt: "Change image",
	items_to_show_title: "Items shown",
	items_to_show_description: "Type here how many items will appear",
	minuend_title: "Minuend",
	select_a_quantity: "Select a quantity",
	add: "Counting add",
	count: "Counting count",
	subtract: "Counting subtract",
	show_result_title: "Show result",
	show_result_subtitle: "Show the result of the operation instantly.",
	math_number_line_stimulus_default: "Represent the following points on the graph",
	number_line_editor_help: "Define the different options you want the student to see as responses to the question.",
	divisions: "Divisions",
	number_line_starting_number: "Starting number",
	number_line_starting_number_description: "Where the line starts",
	number_line_finishing_number: "Finishing number",
	number_line_finishing_number_description: "Where the line ends",
	number_line_divisions_description: "Choose how many marks there are in the line",
	number_line_distance: "Distance of numbers shown",
	number_line_distance_description: "Select the interval between numbers shown",
	number_line_fractions: "Fractions",
	number_line_fractions_description: "Show fractions instead of integers",
	number_line_denominator: "Denominator",
	number_line_denominator_description: "Type a number. It will act as a denominator for the whole line",
	number_line_fractions_as_integers: "Whole fractions as units",
	number_line_fractions_as_integers_description: "If the numerator is a multiple of the denominator, the whole number is displayed",
	grid_editor: "Grid editor",
	grid_editor_description: "Grid editor description ...",
	grid_size_title: "Grid size",
	grid_size_subtitle: "Select grid size",
	charts_pictograph_stimulus_default: "Complete the shopping list.",
	pictograph_table_editor_help: "Fill in the blanks to complete the table and the graph. Changes will be reflected in the player.",
	pictograph_table_title_empty: "The table must have a title",
	Pineapples: "Pineapples",
	Strawberries: "Strawberries",
	editor_pathway_grid_title: "Grid editor",
	editor_pathway_grid_editor_help: "Complete the sections to create the pathway to your liking.",
	editor_pathway_grid_size_title: "Grid size",
	editor_pathway_grid_size_subtitle: "Select grid size",
	editor_pathway_grid_width_title: "Width",
	editor_pathway_grid_width_subtitle: "It can be different from height",
	editor_pathway_grid_height_title: "Height",
	editor_pathway_grid_height_subtitle: "It can be different from width",
	editor_pathway_change_image_title: "Change background image",
	editor_pathway_change_image_subtitle: "Turn it on to upload a different image",
	editor_pathway_change_character_title: "Change character",
	editor_pathway_change_character_subtitle: "Choose between a variety of characters",
	editor_pathway_coordinate_x_title: "Starting coordinate: X",
	editor_type_or_select_number: "Type or select a number",
	editor_pathway_coordinate_y_title: "Starting coordinate: Y",
	editor_pathway_solutions_help: "editor_pathway_solutions_help",
	sand: "Sand",
	grass: "Grass",
	stone: "Stone",
	farmer: "Farmer",
	pirate: "Pirate",
	worker: "Worker",
	editor_coordinate_axes_grid_size_title: "Grid size",
	editor_coordinate_axes_grid_size_subtitle: "Select grid size",
	editor_coordinate_axes_quadrant_title: "Quadrant",
	editor_coordinate_axes_quadrant_subtitle: "Select quadrant I, II, III, IV",
	editor_coordinate_axes_dot_color_title: "Dot color",
	editor_coordinate_axes_dot_color_subtitle: "Select a color for the dot",
	generate_new: "Generate new",
	ABOVE: "Above",
	boxplot_editor_title: "Boxplot editor",
	boxplot_editor_help: "Edit the maximum and minimum values of the line.",
	boxplot_editor_min_title: "Pot: Minimum value",
	boxplot_editor_min_description: "Choose how many divisions the figure will display",
	boxplot_editor_max_title: "Plot: Maximum value",
	boxplot_editor_max_description: "Choose how many divisions the figure will display",
	linechart_table_editor_title: "Table editor",
	linechart_table_editor_help: "Fill in the blanks to complete the table and the graph. Changes will be reflected in the player. ",
	linechart_add_row_description: "Add rows to the table; they will also be reflected in the graph.",
	linechart_add_serie_description: "Add a new series; it will be displayed in the graph as a new line.",
	modal_barchart_editor_reduce_bars_title: "There are too many bars to use the series feature",
	modal_barchart_editor_reduce_bars_title_subtitle: "The number of bars will be reduced to fit within this feature, with a maximum of three bars per series allowed.",
	other_reverse_pathway_stimulus_default: "What steps does the pirate have to take to reach the goal?",
	editor_coordinate_axes_quadrant_all: "All",
	config_clock_digital_title: "Digital clock",
	config_clock_digital_subtitle: "Switch between analog and digital clock",
	config_clock_dark_mode_title: "Dark mode",
	config_clock_dark_mode_subtitle: "Choose light or dark theme for the clock",
	config_clock_steps_title: "Steps",
	config_clock_steps_subtitle: "Select the time interval (one by one, five by five)",
	config_clock_steps_one: "One by one",
	config_clock_steps_five: "Five by five",
	config_clock_24_hour_title: "24 hour clock",
	config_clock_24_hour_subtitle: "Select between 12 hour view or 24 hour view",
	charts_pie_chart_stimulus_default: "In the shopping basket, we have 1 pear, 2 apples, and 3 pineapples.",
	piechart_table_editor_help: " Fill in the blanks to complete the table and the graph. Changes will be reflected in the player.",
	charts_pie_chart_table_title: "Table title",
	charts_pie_chart_table_title_placeholder: "Write a text for the title",
	piechart_table_title_error_empty: "The table must have a title",
	charts_pie_chart_elements: "Elements",
	charts_pie_chart_elements_placeholder: "Element's name",
	charts_pie_chart_elements_error_empty: "All elements must have a name",
	charts_pie_chart_add_element: "Add element",
	charts_pie_chart_add_element_tooltip: "Add one more element to the piechart.",
	input_tootltip_help: "Type here!",
	input_tootltip_help_touch_devices: "Tap here!",
	config_automatic_drop_title: "Autofill Responses",
	config_automatic_drop_subtitle: "When clicked, answers will be automatically inserted into the first available gap",
	input_math_floating_tootltip_help: "Click here!",
	answer_options_group_responses_toggle: "Group",
	stickers_drop_editor_title: "Drop editor",
	stickers_drop_editor_help: "Upload a background image for your exercise and create hotspots to be filled by the students",
	hotspots_painter_button_undo: "Undo",
	hotspots_painter_button_redo: "Redo",
	hotspots_painter_button_select: "Select",
	hotspots_painter_button_draw: "Draw",
	hotspots_painter_button_delete: "Delete",
	stickers_drop_editor_tab_upload_image: "1. Upload image",
	stickers_drop_editor_tab_hotspots: "2. Hotspots",
	config_show_hotspots_title: "Show hotspots",
	config_show_hotspots_subtitle: "The student will see the area in which they can drop the sticker",
	config_drop_indicator_title: "Drop indicator",
	config_drop_indicator_subtitle: "Visual help for the student",
	stickers_stimulus_default: "Place two avocados in the first basket and two lemons in the second.",
	input_floating_tootltip_help: "Click here!",
	input_floating_tootltip_help_touch_devices: "Tap here!",
	stickers_answer_options_placeholder: "Alternate text image description",
	stickers_drop_editor_image_placeholder: "Alternate text image description",
	config_vertical_orientation_title: "Vertical orientation",
	config_vertical_orientation_subtitle: "Display the hotspots in columns",
	classify_stickers_stimulus_default: "Place two avocados in the first basket and two lemons in the second.",
	classify_stickers_series_stimulus_default: "Continue the series.",
	fruit_avocados: "Avocados",
	fruit_lemons: "Lemons",
	fruit_apples: "Apples",
	fruit_pineapples: "Pineapples",
	stickers_series_exercise_help: "Add as many blank boxes as you need and place them on the image. You can change the background image and resize the boxes.",
	stickers_series_exercise_title_box: "Image editor",
	clear_all_button: "Clear all",
	clear_all_description: "Clicking on this will delete all the data on this exercise",
	clear_all_confirmation_title: "¡Atención!",
	clear_all_confirmation_description: "All elements will be deleted",
	clear_all_confirmation_cancel_button: "Cancel",
	clear_all_confirmation_confirm_button: "Confirm",
	move_bottom_handle: "Move the bottom handle",
	axis_editor_title: "Axis editor",
	axis_editor_help: "Adjust the appearance of the coordinate axis",
	math_vertical_operation_stimulus_default: "Complete the following operation",
	response_ignore_trailing_zeros_title: "Ignore trailing zeros",
	response_ignore_trailing_zeros_subtitle: "If enabled, the student's answer will be considered correct even if it has trailing decimal zeros.",
	word_search_button_generate_is_loading: "Generating...",
	transformations_in_plane_stimulus_default: "Represents the translation of this figure 5 squares to the right.",
	lineal_function_stimulus_default: "Represents graphically y = -3x + 1",
	quadratic_function_stimulus_default: "Represents graphically y = −2x² + 4x + 1",
	charts_flow_chart_stimulus_default: "Complete the following flowchart.",
	"empty-figure": "Empty figure",
	prime_number_decomposition_stimulus_default: "Decompose the number 12 into prime factors.",
	charts_histograms_stimulus_default: "Build a histogram from the following data table.",
	charts_histograms_x_axis_name: "T(ºC)",
	charts_histograms_x_axis_label: "Maximum temperature",
	charts_histograms_y_axis_name: "Absolute frequency",
	charts_histograms_y_axis_label: "Absolute frequency",
	math_find_closest_value_stimulus_default: "Indicate the result of the following number using the number line",
	"move-right": "Move right",
	"move-left": "Move left",
	"move-up": "Rotate up",
	"move-down": "Rotate down",
	rotate: "Rotate",
	"flip-horizontal": "Horizontal reflection",
	"flip-vertical": "Vertical reflection",
	grid_divisions_title: "Grid divisions",
	grid_divisions_description: "Configure the number of grid divisions",
	functions_editor: "Functions editor",
	functions_editor_help: "Use the editor settings to enter new functions and adjust their values.",
	add_function: "Add function",
	operation_editor: "Operation editor",
	operation_editor_help: "In this block, you could configure the operation values.",
	config_operation_title: "Dynamic Operations",
	config_operation_subtitle: "Generate a random or custom operation.",
	digits_per_addend_title: "Number of digits per addend",
	digits_per_addend_subtitle: "Define the number of digits in each addend.",
	addend_count_title: "Number of addends",
	addend_count_subtitle: "Define the number of addends in the operation.",
	column_help_title: "Column highlight",
	column_help_subtitle: "Visual aid that highlights the current column.",
	order_terms_title: "Term sorting",
	order_terms_subtitle: "Displays the terms of the operation from highest to lowest.",
	prime_number_generator_editor: "Dynamic values generator",
	prime_number_generator_editor_help: "Generates a random number that the student will have to decompose based on the selection you make in these options.",
	enabled_factors_title: "Prime numbers",
	enabled_factors_subtitle: "Select the possible factors of the generated number.",
	factors_length_title: "Number of factors",
	factors_length_subtitle: "Indicates the maximum number of factors that the generated number can have without counting 1.",
	Transcription: "Transcription",
	other_rating_stimulus_default: "It's time to rate the content!",
	other_rating_tooltip_1_star: "1 star",
	other_rating_tooltip_multiple_stars: "{{count}} stars",
	other_rating_description_1_star: "I didn't like it. It confused me and bored me.",
	other_rating_description_2_stars: "I liked it more or less... I understood some things better than others.",
	other_rating_description_3_stars: "I liked it quite a bit. I understood it and it interested me :)",
	other_rating_description_4_stars: "I loved it! I found it interesting and fun. I want more!",
	adaptative_choice_levels_config: "Levels Configuration",
	adaptative_choice_levels_config_help: "Configure the titles of each level of the adaptive activity",
	adaptative_choice_level_title: "Level {{level_number}}",
	adaptative_choice_level_title_label: "Level title:",
	adaptative_choice_level_title_placeholder: "Write the title of this level...",
	other_adaptative_choice_back: "Back",
	other_adaptative_choice_next: "Next"
};
var en = {
	translations: translations$2
};

var translations$3 = {
	title: "Título",
	enunciated: "Enunciado",
	stimulus: "Enunciado de la actividad",
	enunciated_placeholder: "Escribe una descripción",
	multiple_choice_activity: "Selección múltiple",
	answer_options: "Opciones de respuesta",
	add_new_response: "Añadir",
	add_new_question: "Añadir",
	new_question_stem: "Nueva pregunta",
	validation: "Puntuación",
	option: "Opción",
	type_of_validation: "Introduce el tipo de validación:",
	exactMatch: "Exacta: es necesario contestar todas las opciones correctamente.",
	partialMatch: "Parcial: cada respuesta correcta otorga la puntuación.",
	partialMatchV2: "Parcial por respuesta: se divide la puntuación entre el número de respuestas.",
	score: "Puntuación",
	high_score: "Máxima Puntuación",
	enter_a_score: "Introduce una puntuación",
	minimum_score: "Mínima puntuación por intentarlo",
	cancel: "Cancelar",
	save: "Guardar",
	send: "Enviar",
	reset: "Restaurar",
	undo: "Deshacer",
	redo: "Rehacer",
	shuffle_options: "Mezclar respuestas",
	multiple_responses: "Respuesta múltiple",
	words_limit: "Límite de palabras",
	letters_limit: "Límite de letras",
	essay_placeholder: "Escribe tu respuesta.",
	right_answer: "Respuesta correcta",
	write_right_answer: "Escribe la respuesta correcta",
	copy: "Copiar",
	cut: "Cortar",
	paste: "Pegar",
	cloze_text: "Cloze text",
	activity_data_wrong: "Los datos están mal formados",
	this_is_the_stem: "Desarrolla la pregunta aquí",
	"true": "Verdadero",
	"false": "Falso",
	column: "Columna",
	columns: "Columnas",
	row: "Fila",
	world_map: "Mapa mundial",
	Greenland: "Groenlandia",
	Russia: "Rusia",
	United_States: "Estados Unidos",
	table_editor: "Editor de tabla",
	drags: "Arrastrables",
	add_new_column: "Añadir título columna",
	add_new_row: "Añadir título fila",
	duplicate_responses: "Duplicar respuestas",
	solutions: "Soluciones",
	Solution: "Solución",
	column_count: "Número de columnas",
	row_count: "Número de filas",
	cloze_template: "En un lugar de la Mancha, de cuyo nombre no quiero acordarme, no ha mucho tiempo que vivía un {{response}} de los de lanza en astillero, adarga antigua, rocín flaco y {{response}} corredor.",
	response: "Respuesta",
	response_containers: "Contenedores de respuestas",
	global_size: "Escala global",
	width: "Ancho",
	height: "Alto",
	upload_file: "Subir archivo",
	completed: "Completado",
	choose_file: "Elegir archivo",
	change_file: "Cambiar archivo",
	load_image_error_message: "Ha ocurrido un error al intentar subir la imagen",
	sending_file: "Subiendo archivo",
	select_an_item: "Selecciona un elemento",
	pointer: "Puntero",
	none: "Ninguno",
	left: "Izquierda",
	right: "Derecha",
	top: "Arriba",
	bottom: "Abajo",
	show_check_icon: "Mostrar icono",
	alternative_text: "Texto alternativo",
	isEvaluable: "Modo evaluación",
	autosize_response: "Longitud automática",
	text_normalization: "Normalización de textos",
	load_image: "Subir imagen",
	image_size: "Tamaño de imagen",
	text_sample: "Texto de ejemplo",
	size: "Tamaño",
	accent_sensitive: "Sensible a acentos",
	case_sensitive: "Sensible a mayúsculas",
	spaces_sensitive: "Corrección de espacios",
	orientation: "Orientación",
	"delete": "Borrar",
	stack: "Apilado",
	box: "Caja",
	Feedback: "Feedback",
	"Remove feedback": "Borrar feedback",
	Visibility: "Visibilidad",
	"Success Message": "Mensaje de éxito",
	"Error Messages": "Mensajes de error",
	Sequence: "Secuencia",
	cyclic: "Cíclico",
	random: "Aleatorio",
	"Add new error": "Añadir nuevo error",
	"Error message": "Mensaje de error",
	Configuration: "Ajustes",
	"Shuffle Answers": "Orden aleatorio",
	"When turned on the questions will be sorted in differ order each time they are presented": "Las opciones saldrán de forma aleatoria en cada alumno",
	"Show check icon": "Botón de opción",
	"When turned on the answers will have a radio button next to them": "Desactívalo para esconder el botón y usar el modo bloque en su lugar",
	Columns: "Columnas",
	"Choose how many columns you want the answers to be displayed into": "Elige en cuántas columnas deseas mostrar las respuestas",
	style_block_none: "Ninguno",
	style_block_BLOCK: "Bloque",
	style_block_NUMERICAL: "Numérico",
	style_block_UPPER_ALPHA: "Alfabeto en mayúsculas",
	style_block_LOWER_ALPHA: "Alfabeto en minúsculas",
	"1 columns": "1 columna",
	"2 columns": "2 columnas",
	"3 columns": "3 columnas",
	"4 columns": "4 columnas",
	"5 columns": "5 columnas",
	"6 columns": "6 columnas",
	SERVER_ERROR: "Se ha producido un error al subir el archivo. Inténtalo de nuevo.",
	MAX_FILES_REACHED: "Has alcanzado el límite de archivos permitidos.",
	INVALID_TYPE: "Tipo de archivo no válido",
	MAX_SIZE_EXCEEDED: "El archivo que deseas subir sobrepasa el tamaño máximo permitido. Por favor, reduce el tamaño y vuelve a intentarlo.",
	UNKNOWN_ERROR: "Ha ocurrido un problema al subir el archivo. Por favor, inténtalo de nuevo.",
	"You can set up the settings of each type of question here": "Puede configurar los ajustes de cada tipo de pregunta aquí.",
	"Different max / min file upload": "Subida de archivo con diferente máximo / mínimo",
	"Turn on if you want to allow uploading a range of files to the exercise": "Permite la subida de varios archivos en esta actividad",
	"File size limit": "Límite de tamaño de archivo",
	"Max size each file can reach. This is a default value and cannot be editted": "Tamaño máximo que puede alcanzar cada archivo. Este es un valor predeterminado y no se puede editar",
	"Types of files allowed as attachments": "Tipo de archivos permitidos como adjuntos",
	"MS Word, Excel, Power Point, jpg, png, pdf, Open Office, txt, video and audio": "Word, Excel, Power Point, jpg, png, pdf, Open Office, txt, vídeo y audio",
	"default": "Por defecto",
	"Files limit": "Límite de archivos",
	"Min/Max number of files the student is allowed to upload": "Mínimo/máximo número de archivos que el alumno puede subir",
	"Size thumb": "Tamaño de la miniatura",
	"Image size": "Tamaño de imagen",
	"Background image": "Imagen de fondo",
	"Canvas Background Image": "Imagen de fondo del lienzo",
	"Allowed files: images (jpg, png, gif), audio (mp3, ogg), video (mp4, ogg, webm, mkv), documents (word, excel, power point, pdf, open office, txt)": "Archivos permitidos: imágenes (jpg, png, gif), audio (mp3, ogg), vídeo (mp4, ogg, webm, mkv), documentos (word, excel, power point, pdf, open office, txt)",
	"Allowed files: images (jpg, png, gif)": "Formatos permitidos: imágenes (jpg, png, gif)",
	Exercise: "Actividad",
	background_image_alt: "Texto alternativo",
	response_exact_or_equivalent_title: "El resultado es exacto o equivalente",
	response_exact_or_equivalent_subtitle: "Elige exacto si quieres evaluar como correctas solamente las respuestas exactas. Elige equivalente si quieres dar como correcta cualquier expresión equivalente",
	response_exact_or_equivalent_subtitle_option_equivliteral: "Exacto",
	response_exact_or_equivalent_subtitle_option_equivsymbolic: "Equivalente",
	response_decimals_title: "Decimales",
	response_decimals_subtitle: "Selecciona el número mínimo de decimales",
	response_response_value: "Valor de la respuesta",
	response_title: "Respuesta",
	response_decimal_option_0: "Sin decimales",
	response_decimal_option_1: "1 decimal",
	response_decimal_option_2: "2 decimales",
	response_decimal_option_3: "3 decimales",
	response_decimal_option_4: "4 decimales",
	response_decimal_option_5: "5 decimales",
	response_decimal_option_6: "6 decimales",
	stimulus_help: "Escribe el enunciado de la actividad aquí. Puedes añadir texto, ecuaciones, tablas y cualquier material editable.",
	config_help: "Puedes configurar los ajustes de cada tipo de pregunta aquí.",
	answer_options_help: "Escribe las diferentes opciones que quieras mostrar al alumnado como posibles respuestas y elige su orden. Puedes añadir más respuestas haciendo click en el botón de Añadir.",
	editor_response_title_accordion: "Respuesta",
	config_canvas_height_title: "Altura por defecto",
	config_canvas_height_subtitle: "Altura predeterminada del espacio de fondo",
	background_image_title: "Imagen de fondo",
	background_image_subtitle: "Establece una imagen de fondo",
	response_result_button_delete: "Eliminar respuesta",
	config_variant_style_title: "Variante de autor",
	config_variant_style_subtitle: "Selecciona la variante deseada",
	config_variant_style_input_placeholder: "Añadir nombre de clase",
	style_variant_default: "Por defecto",
	style_variant_custom: "Personalizada",
	config_multiple_responses_title: "Respuesta múltiple",
	config_multiple_responses_subtitle: "Actívalo si hay más de una respuesta válida",
	button_validation_title_box: "Botón",
	button_validation_title: "Añadir botón de validación",
	button_validation_subtitle: "Actívalo para añadir un botón de confirmación al alumno",
	button_validation_alt: "Añade tu texto aquí",
	button_validation_help: "Usa esta opción si necesitas que los alumnos marquen esta actividad como completada tras finalizarla",
	button_validation_default: "Hecho",
	button_edit: "Editar",
	button_cancel: "Cancelar",
	button_confirm: "Confirmar",
	button_try_again: "Intentar otra vez",
	button_cant_speak_now: "No puedo hablar ahora",
	config_background_title: "Añadir imagen de fondo",
	config_background_subtitle: "Actívalo para subir una imagen para el fondo",
	config_background_help: "Puedes subir una imagen de fondo.",
	exercise_example_text_title: "Escribe aquí el texto de la pregunta",
	exercise_example_text_subtitle: "Texto antes de rellenar una etiqueta",
	exercise_label_font_size_title: "Tamaño de fuente",
	exercise_label_font_size_subtitle: "Determina el tamaño de fuente en la caja",
	config_duplicate_responses_title: "Duplicar respuestas",
	config_duplicate_responses_subtitle: "Actívalo para duplicar las respuestas",
	feedback_exercise_title: "Tratamiento del error",
	feedback_exercise_placeholder: "Añade aquí feedback general",
	feedback_exercise_help: "Recuerda que esto ofrece al alumnado un tratamiento del error general de toda la actividad. Puedes usarlo para hacer alguna indicación o recordatorio.",
	feedback_exercise_help_with_individual: "Puedes ayudar al alumnado ofreciendo un tratamiento del error general de la actividad. También puedes introducir comentarios individuales en cada respuesta que le aparecerán al alumno si se equivoca.",
	config_is_math_title: "Es matemáticas",
	config_is_math_subtitle: "Indica si es matemáticas",
	config_accent_sensitive_title: "Sensible a las tildes",
	config_accent_sensitive_subtitle: "Actívalo si quieres tener en cuenta las tildes en las correcciones",
	config_case_sensitive_title: "Sensible a las mayúsculas",
	config_case_sensitive_subtitle: "Activar si deseas que la respuesta distinga entre mayúsculas y minúsculas al corregir",
	config_fix_spaces_title: "Arregla los espacios",
	config_fix_spaces_subtitle: "Desactívalo si quieres que el uso incorrecto de espacios no penalice, independientemente del lugar en la palabra",
	config_max_character_title: "Restricción de caracteres",
	config_max_character_subtitle: "Introduce el máximo de caracteres para restringir la extensión de la respuesta",
	config_max_character_input_title: "Establece el límite de caracteres",
	config_max_character_input_subtitle: "Especifica el número máximo de caracteres que el alumno puede escribir",
	config_max_character_input_placeholder: "Máximo de caractéres",
	config_words_limit_title: "Contador de palabras",
	config_words_limit_subtitle: "Introduce un máximo de palabras",
	config_words_limit_input_title: "Establece el límite de palabras",
	config_words_limit_input_subtitle: "Especifica el máximo número de palabras que un alumno puede escribir",
	config_words_limit_input_placeholder: "Introducir número máximo de palabras",
	config_autosize_response_title: "Longitud máxima de respuesta",
	config_autosize_response_subtitle: "Limita el número máximo de caracteres de respuesta al de la solución más larga",
	"Drop your files here or": "Arrastra aquí tus archivos o",
	browse: "selecciona un archivo",
	"Max file size": "Tamaño máximo de archivo",
	"MB · At least": "MB ·",
	"file required": "archivo requerido",
	richText_placeholder: "Escribe tu respuesta aquí",
	"Questions options": "Opciones de pregunta",
	"Answer options": "Opciones de respuesta",
	Answer: "Respuesta",
	config_stack_title: "Apilar",
	config_stack_subtitle: "Los arrastrables se irán apilando dentro de las áreas cuando el tamaño de la pantalla lo permita",
	config_with_box_title: "Opciones de enmarcar en cajas",
	config_with_box_subtitle: "Los arrastables se marcarán con una línea al seleccinarlos",
	config_lines_color_title: "Color de las líneas",
	config_lines_color_subtitle: "Elige un color de línea",
	line_thinckness_fine: "Fino",
	line_thinckness_medium: "Medio",
	line_thinckness_coarse: "Grueso",
	config_line_thickness_title: "Grosor de las líneas",
	config_line_thickness_subtitle: "Elige un tamaño de línea",
	config_feedback_mode_click_to_find_title: "Modo de feedback",
	config_feedback_mode_click_to_find_subtitle: "Ninguno, con borde o marca",
	feedback_mode_none: "Ninguno",
	"feedback_mode_feedback-with-border": "Con borde",
	"feedback_mode_feedback-with-tick": "Con marca",
	click_to_find_size_background_title: "Tamaño de imagen de fondo",
	click_to_find_size_background_subtitle: "Tamaño de imagen",
	click_to_find_solutions_tooltip_correct: "Marcar como correcto",
	click_to_find_solutions_tooltip_incorrect: "Marcar como incorrecto",
	config_column_direction_title: "Dirección de la columna",
	config_column_direction_subtitle: "Vertical u horizontal",
	column_direction_horizontal: "Horizontal",
	column_direction_vertical: "Vertical",
	linking_lines_limit_options_help: "Para una correcta visualización, el número de opciones está limitado a 6",
	evaluation_mode_tooltip: "Desactívalo si quieres corregir manualmente o recoger información que no cuente para nota.",
	individual_feedback_exercise_placeholder: "Escribe feedback individual en esta respuesta",
	label_drop_item: "Respuesta",
	individual_feedback_exercise_tooltip: "Añade feedback para esta respuesta",
	change_image: "Cambiar imagen",
	answer_options_help_multiple_choice: "Escribe las diferentes opciones que quieras mostrar al alumnado como posibles respuestas y elige su orden.",
	add_alternative: "Alternativa",
	solutions_instructions: "Define la respuesta correcta a la actividad y su puntuación. Asigna el 100% si la respuesta es correcta. También puedes proporcionar una respuesta alternativa y asignar el % del total de puntos que merece.",
	image: "Imagen",
	add_an_image_to_exercise: "Añade una imagen a la actividad",
	button_show_hints: "Pista",
	button_validate: "Comprobar",
	button_restart: "Rehacer",
	button_repeat: "Repetir",
	button_show_solution: "Ver solución",
	button_hide_solution: "Ver mi respuesta",
	button_restart_scaffold: "Reiniciar scaffolding",
	points: "Puntos",
	button_next_question: "Siguiente",
	button_i_dont_know: "Ayuda paso a paso",
	title_help: "Este campo no va a ser visible para el alumno. Servirá para facilitar busquedas de actividades por parte de un editor.",
	title_placeholder: "Escribe aquí el texto",
	hints_title_box: "Pista",
	hints_help: "Las pistas son pequeños mensajes que el alumnado puede pedir cuando necesite ayuda. Puedes añadir sugerencias a esta actividad aquí.",
	hints_title: "Añadir pista",
	hints_subtitle: "Actívalo para darle al alumnado una pequeña información o consejo",
	hint_placeholder: "Área con texto de pista",
	automatic_evaluation: "Evaluación automática",
	automatic_evaluation_description: "Desactívalo para evaluar manualmente y permitir respuestas abiertas",
	title_title_box: "Nombre interno",
	feedback_exercise_toogle_title: "Añadir feedback",
	feedback_exercise_toogle_subtitle: "Actívalo para orientar cuando el alumno comete un error",
	multiple_choice_multiple_stimulus_default: "Selecciona al menos una (o más) de las siguientes opciones:",
	multiple_choice_single_stimulus_default: "Selecciona una de las siguientes opciones:",
	multiple_choice_truefalse_stimulus_default: "Lee y contesta 'Verdadero' o 'Falso':",
	multiple_choice_blockletter_stimulus_default: "Elige una de las siguientes opciones:",
	choice_matrix_inline_stimulus_default: "Decide si las siguientes opciones son verdaderas o falsas:",
	choice_matrix_standard_stimulus_default: "Decide si las siguientes opciones son verdaderas o falsas:",
	classify_classification_stimulus_default: "Arrastra y suelta cada respuesta en su lugar:",
	classify_matchlist_stimulus_default: "Empareja cada respuesta con su concepto:",
	classify_orderlist_stimulus_default: "Arrastra y suelta para ordenar las respuestas:",
	classify_linkinglines_stimulus_default: "Une cada palabra con su significado:",
	cloze_text_stimulus_default: "Escribe la palabra que falta en las cajas que se muestran a continuación:",
	cloze_dropdown_stimulus_default: "Selecciona la opción correcta de cada desplegable:",
	cloze_drag_drop_stimulus_default: "Arrastra y suelta las respuestas dentro de los huecos.",
	essay_plaintext_stimulus_default: "Escribe una redacción de 200 palabras sobre tu lugar favorito.",
	essay_sorttext_stimulus_default: "¿Cuál es el río más largo de América del Sur?",
	essay_sorttext_solution1_default: "El río Amazonas",
	essay_richtext_stimulus_default: "Escribe una redacción de 200 palabras sobre tu lugar favorito.",
	labelimage_dragdrop_stimulus_default: "Arrastra y suelta cada país en su lugar:",
	labelimage_dropdown_stimulus_default: "Selecciona la opción correcta de cada desplegable:",
	labelimage_imagewithtext_stimulus_default: "Escribe el nombre de cada país:",
	math_clozemath_stimulus_default: "Calcula las siguientes operaciones:",
	other_uploadfile_stimulus_default: "Haz una foto a tus deberes y suéltala aquí:",
	other_pencil_stimulus_default: "Dibuja a tu mascota o animal favorito y dónde vive:",
	other_statement_stimulus_default: "Elige un compañero o compañera y comenta por qué tener un estilo de vida saludable es importante.",
	other_clicktofind_stimulus_default: "Haz click en todos los limones:",
	choice_matrix_questions_help: "Introduce los enunciados de las preguntas en las cajas. Puedes añadir más preguntas haciendo clic en el botón añadir.",
	match_list_questions_help: "Introduce los enunciados de las preguntas en las cajas. Puedes añadir más preguntas haciendo clic en el botón añadir.",
	linking_lines_questions_help: "Introduce los enunciados de las preguntas en las cajas. Puedes añadir más preguntas haciendo clic en el botón añadir.",
	scaffold_separator_step: "Paso",
	scaffold_separator_of: "de",
	title_check_icon_single_choice: "Botón de opción",
	subtitle_check_icon_single_choice: "Desactívalo para esconder el botón y usar el modo bloque en su lugar",
	title_check_icon_multiple_choice: "Casilla de opción",
	subtitle_check_icon_multiple_choice: "Desactívalo para esconder la casilla y usar el modo bloque en su lugar",
	title_block_style: "Estilo de lista",
	subtitle_block_style: "Ninguna, numérica o alfabética",
	Spain: "España",
	template_exercise_markup_add_blank: "Añadir hueco",
	template_markup_add_blank: "Añadir hueco",
	sending_button: "Enviando ...",
	table_editor_help: "Usa el editor de tabla para configurar el número de columnas y filas de la tabla. Las columnas podrán ser como mínimo una y como máximo cinco.",
	cloze_exercise_help: "Escribe una oración y utiliza las cajas en blanco para que el alumno identifique cuáles son las palabras clave que faltan en el texto.",
	cloze_math_exercise_help: "Escribe el enunciado y utiliza las cajas en blanco para que el alumno identifique cuáles son los números o fórmulas clave que faltan.",
	label_exercise_help: "Añade tantas cajas en blanco como necesites y colócalas por la imagen. Puedes cambiar la imagen de fondo, redimensionar las cajas y el tamaño de la fuente.",
	cloze_dropdown_exercise_help: "Escribe una oración y utiliza las cajas blancas para añadir opciones. El alumno tendrá que seleccionar la opción correcta en cada hueco que encuentre en el texto.",
	click_to_find_exercise_help: "Reemplaza la imagen de fondo, añade nuevas imágenes y colócalas por el lienzo. Podrás definir cuál es correcta o incorrecta en la sección de Solución.",
	linking_lines_question_option: "Opción de pregunta",
	title_evaluation_type: "Tipo de evaluación",
	subtitle_evaluation_type_exact_match: "El alumno deberá contestar la actividad correctamente para recibir la puntuación",
	subtitle_evaluation_type_partial_match: "La puntuación general de la actividad se dividirá entre las respuestas, y cada una de ellas se puntuará individualmente",
	subtitle_evaluation_type_manual: "La actividad no se evalúa. Útil para practicar o si es necesario revisión por parte del profesor",
	subtitle_evaluation_type_match_response: "La puntuación general de la actividad se dividirá entre los elementos de arrastre, y cada una de ellos se puntuará individualmente",
	subtitle_evaluation_type_match_group: "La puntuación general de la actividad se dividirá entre los grupos, y cada una de ellos se puntuará individualmente",
	evaluation_type_exact_match: "Corrección exacta",
	evaluation_type_partial_match: "Corrección parcial",
	evaluation_type_manual: "Corrección manual",
	evaluation_type_match_response: "Parcial por respuesta",
	evaluation_type_match_group: "Parcial por grupo",
	manual_or_alternative_solutions_help: "Define la respuesta correcta a la actividad que tendrá asignado el 100%. También puedes crear soluciones alternativas y asignar el % que merezcan. En caso de que quieras que la actividad no sea autoevaluativa, selecciona corrección manual.",
	exact_math_or_partial_match_or_manual_solutions_help: "Con corrección exacta el alumno deberá contestar la actividad correctamente para recibir la puntuación. También puedes crear soluciones alternativas y asignar el % que merezcan. Con la corrección parcial, el total de puntos se dividirá entre cada respuesta, y cada una de ellas se evaluará individualmente. Si quieres que la actividad no sea autoevaluativa, selecciona corrección manual.",
	exact_math_or_match_response_or_match_group_or_manual_solutions_help: "Con corrección exacta el alumno deberá contestar la actividad correctamente para recibir la puntuación. También puedes crear soluciones alternativas y asignar el % que merezcan. Con la corrección parcial por respuesta, el total de puntos se dividirá entre cada respuesta, y cada una de ellas se evaluará individualmente. Con la corrección parcial por grupo, los puntos se dividirán entre los elementos o celdas. Si quieres que la actividad no se evalúe, selecciona corrección manual.",
	solutions_penalty_title: "Personalizado",
	solutions_penalty_subtitle: "Selecciona manualmente un % de penalización por respuesta",
	feedback_exercise_toogle_individual_feedback_title: "Añade tratamiento de error a cada respuesta",
	feedback_exercise_toogle_individual_feedback_subtitle: "El mensaje le aparecerá al alumno cuando responda incorrectamente",
	"Answer Option": "Opción de respuesta",
	"Text Prompt": "Enunciado",
	config_fixed_keyboard_title: "Teclado flotante",
	config_fixed_keyboard_subtitle: "Actívalo para mostrar al alumno un teclado flotante cuando selecciona una casilla",
	config_number_keyboards_title: "Teclado numérico",
	config_number_keyboards_subtitle: "Selecciona el tipo de teclado que le aparecerá al alumno",
	keyboard_type_NONE: "Ninguno",
	keyboard_type_NUMERICAL: "Numérico",
	keyboard_type_BASIC: "Básico",
	keyboard_type_INTERMEDIATE: "Intermedio",
	keyboard_type_COMPLEX: "Avanzado",
	keyboard_type_SCIENTIFIC: "Científico",
	keyboard_type_ROMAN: "Romano",
	keyboard_type_FUNCTIONS: "Funciones",
	solutions_new_alternative_text: "Nueva",
	no_microphone: "No tengo micrófono",
	confirm_replace_audio_message: "Ya existe un audio grabado. Pulsa en confirmar si quieres reemplazarlo por uno nuevo.",
	config_audio_duration_limit_title: "Límite de tiempo",
	config_audio_duration_limit_subtitle: "Selecciona los segundos que el estudiante tendrá para grabarse",
	other_audio_recorder_stimulus_default: "Grábate explicando el proceso de la fotosíntesis.",
	no_mic_available: "No se ha encontrado el micrófono en el dispositivo.",
	no_mic_permission: "Micrófono bloqueado. Asegúrate que el acceso está permitido.",
	confirm_switching_keyboards_title: "Atención",
	confirm_switching_keyboards_message: "Las soluciones editadas se borrarán al cambiar de teclado.",
	math_counting_stimulus_default: "¿Cuántas manzanas y limones necesito para tener seis frutas?",
	other_clock_stimulus_default: "Son las 15:30",
	sample_answer_title_box: "Respuesta modelo",
	sample_answer_help: "Puedes crear una respuesta modelo que te ayude a corregir las actividades no autoevaluativas. Esta sección sólo será visible para el profesorado.",
	sample_answer_title: "Añadir respuesta modelo",
	sample_answer_subtitle: "Ejemplo de una solución modelo para el profesorado.",
	sample_answer_placeholder: "Escribe aquí el texto",
	other_word_search_stimulus_default: "Encuentra las siguientes palabras:",
	word_search_grid_s: "S (6x6)",
	word_search_grid_m: "M (10x10)",
	word_search_grid_l: "L (15x15)",
	word_search_title_box: "Sopa de letras",
	word_search_help: "Selecciona el tamaño de la cuadrícula",
	word_search_title: "Cuadrícula",
	word_search_subtitle: "Selecciona el número de filas/columnas",
	config_word_search_random_title: "Posición aleatoria de las palabras",
	config_word_search_random_subtitle: "Las palabras se mostrarán en una posición distinta cada vez que se acceda.",
	config_word_search_backward_title: "Palabras invertidas",
	config_word_search_backward_subtitle: "Puede haber palabras escritas de derecha a izquierda",
	config_word_search_diagonal_title: "Palabras en diagonal",
	config_word_search_diagonal_subtitle: "Puede haber palabras escritas en diagonal",
	word_search_counter_letter: "Límite de letras",
	config_word_search_allowed_letters_title: "Letras permitidas",
	config_word_search_allowed_letters_subtitle: "Activa para indicar las letras permitidas",
	confirm_switching_columns_rows_title: "¡Atención!",
	confirm_switching_columns_rows_message: "Las siguientes palabras se eliminaran:",
	confirm_edit_allowed_letter_title: "¡Atención!",
	confirm_edit_allowed_letter_message: "Las palabras que contengan caracteres distintos a los indicados se eliminarán.",
	word_search_preview_title_box: "Previsualización de la sopa de letras",
	word_search_preview_help: "Así se verán las soluciones en la sopa de letras",
	word_search_button_generate: "Generar nueva",
	word_search_solutions_help: "Indica palabras con al menos 2 letras. No se pueden utilizar números, espacios o caracteres especiales.",
	other_crossword_stimulus_default: "Crucigrama",
	crossword_solutions_help: "Indica palabras con al menos dos letras. No se puede utilizar números, espacios o caracteres especiales",
	crossword_counter_letter: "Límite de letras",
	crossword_word_out: "No existe coincidencia entre palabras. Intenta añadiendo más palabras",
	config_uppercase_lowercase_title: "Selecciona mayúsculas / minúsculas",
	config_uppercase_lowercase_subtitle: "Las palabras se mostrarán en mayúsculas o en minúsculas",
	config_uppercase: "Mayúsculas",
	config_lowercase: "Minúsculas",
	crossword_message_min_words: "Necesita mínimo {{num_words}} palabras",
	crossword_solutions_text_not_valid: "Palabra no válida. Mínimo dos letras",
	crossword_preview_title_box: "Previsualización del crucigrama",
	crossword_preview_help: "Así se verán las soluciones del crucigrama",
	crossword_button_generate: "Generar nuevo",
	generation_error: "No se ha podido generar el crucigrama",
	upload_file_button_drive: "Subir con Google Drive",
	file_uploader_drive: "Vía Google Drive",
	file_uploaded_successfully: "Archivo enviado correctamente",
	files_uploaded_successfully: "Archivos enviados correctamente",
	other_pathway_stimulus_default: "Sigue las instrucciones",
	direction_LEFT: "a la izquierda",
	direction_RIGHT: "a la derecha",
	direction_BOTTOM: "hacia abajo",
	direction_TOP: "hacia arriba",
	title_penalty_modes: "Puntos de penalización",
	subtitle_penalty_mode_none: "Penaliza las respuestas fallidas por el mismo valor de las respuestas acertadas. También puedes crear la penalización a medida",
	subtitle_penalty_mode_per_response: "Penaliza las respuestas fallidas por el mismo valor de las respuestas acertadas. También puedes crear la penalización a medida",
	subtitle_penalty_mode_custom: "Penaliza las respuestas fallidas por el mismo valor de las respuestas acertadas. También puedes crear la penalización a medida",
	penalty_mode_none: "Ninguno",
	penalty_mode_per_response: "Puntuación de respuesta acertada",
	penalty_mode_custom: "Personalizado",
	config_show_selection_title: "Mostrar selección",
	config_show_selection_subtitle: "El estudiante verá señalado el objeto seleccionado",
	alternative_response: "Respuesta alternativa",
	alternative_responses: "Respuestas alternativas",
	config_autosize_box_title: "Tamaño de la caja de respuesta",
	config_autosize_box_subtitle: "Si es de menos de 6 caracteres, adapta el tamaño de la caja al de la solución más larga",
	charts_fractions_and_decimals_stimulus_default: "¿Cómo sería la figura para representar 4/6?",
	charts_barchart_stimulus_default: "<p>En la cesta de la compra tenemos 5 aguacates, 3 manzanas y 7 limones. Selecciona la cantidad correcta en el siguiente gráfico</p>",
	charts_linechart_stimulus_default: "<p>¿Cuál ha sido la temperatura media durante el año en estas ciudades?</p>",
	charts_coordinate_axes_stimulus_default: "<p>Título por defecto para el template de eje de coordenadas</p>",
	"lemo-coordinate-axes-multiple-quadrant-error": "Por el momento solo es posible mostrar un cuadrante de coordenadas",
	no_audio_uploaded: "No se ha subido un audio",
	no_file_uploaded: "No se han subido archivos",
	main_response: "Respuesta principal",
	pie_chart_total_items_input: "En total hay",
	group_name: "Nombre del grupo",
	group_editor_exercise_list: "Lista",
	remove_grouped_question_modal_title: "Borrar actividad",
	remove_grouped_question_modal_description: "<p>¿Estás seguro de que quieres borrar esta actividad?</p><p>Esta acción no se puede deshacer</p>",
	charts_pictograph_y_axis_name: "Unidades",
	charts_pictograph_x_axis_name: "Lista de la compra",
	charts_pictograph_y_axis_label: "Unidades",
	charts_pictograph_x_axis_label: "Lista de la compra",
	Avocados: "Aguacates",
	Lemons: "Limones",
	Apples: "Manzanas",
	Units: "Unidades",
	monday: "Lunes",
	tuesday: "Martes",
	wednesday: "Miércoles",
	thursday: "Jueves",
	friday: "Viernes",
	saturday: "Sábado",
	sunday: "Domingo",
	Madrid: "Madrid",
	Paris: "París",
	charts_line_chart_x_axis_name: "Estaciones",
	charts_line_chart_y_axis_name: "Temperaturas",
	question_group: "Actividades agrupadas",
	add_new_exercise: "Añadir nuevo ejercicio",
	steps: "Pasos",
	direction: "Dirección",
	TOP: "Arriba",
	BOTTOM: "Abajo",
	LEFT: "Izquierda",
	RIGHT: "Derecha",
	not_completed: "No completado",
	group_name_placeholder: "Escriba aquí su texto",
	group_name_help_text: "Este campo no será visible para el estudiante. Servirá para facilitar las búsquedas de grupos de actividades para un editor.",
	group_stimulus_box_title: "Enunciado del grupo",
	group_stimulus_placeholder: "Escriba aquí el enunciado de la pregunta del grupo",
	add_new_activity: "Añadir nueva actividad",
	group_editor_exercise_list_help_text: "Todos los ejercicios de este grupo aparecerán aquí. Usted puede cambiar el orden de apariencia.",
	question_group_default_stimulus: "Escriba el enunciado del grupo aquí",
	no_questions_in_group: "No hay nada aquí",
	pathway_steps_counter: "Faltan $numSteps pasos",
	upload_files: "Subir archivos",
	get_feedback: "Obtener feedback",
	scaffolding_navigation_counter: "Paso {index} de {total}",
	"scaffolding_navigation_toggle-show-activity": "Ver actividad",
	"scaffolding_navigation_toggle-show-steps": "Ver paso a paso",
	barchart_table_editor_help: "Rellena los espacios para completar la tabla y la gráfica. Los cambios se verán reflejados en el player.",
	barchart_table_editor_add_row_tooltip: "Añade filas a la tabla; también se verán reflejadas en la gráfica.",
	barchart_table_editor_add_series_tooltip: "Agrega una nueva serie; se mostrará en el gráfico como una nueva barra por serie.",
	table_title: "Título de tabla",
	series: "Series",
	serie_placeholder: "Nombre de serie",
	x_axis_title: "Título eje x",
	y_axis_title: "Título eje y",
	measure: "Medida",
	measure_placeholder: "Unidad de medida",
	measure_description: "Elige un tipo de unidad de medida",
	input_needs_value: "Por favor, complete este campo",
	hide_table: "Ocultar tabla",
	hide_table_description: "Mostrar u ocultar la tabla",
	chart_position: "Posición del gráfico",
	chart_position_description: "Selecciona arriba, abajo, izquierda o derecha",
	table_position: "Posición de la tabla",
	table_position_description: "Selecciona arriba, abajo, izquierda o derecha",
	max_y_value: "Maximum value Y",
	max_y_value_description: "Maximum value for the Y axis",
	linechart_max_y_value_description: "Modificar logitud para el eje Y (máximo 10, mínimo 3)",
	min_y_value: "Minimum value Y",
	min_y_value_description: "Modificar valor mínimo para el eje Y",
	multiplier: "Multiplicador",
	multiplier_description: "Distancia entre valores dentro del eje Y",
	TRIANGLE: "Triángulo",
	QUAD: "Cuadrado",
	RECTANGLE: "Rectángulo",
	PENTAGON: "Pentágono",
	HEXAGON: "Hexágono",
	CIRCLE: "Círculo",
	RANDOM: "Aleatorio",
	HUNDREDTHS: "Centésimas",
	TENTHS: "Décimas",
	winter: "Invierno",
	spring: "Primavera",
	summer: "Verano",
	fall: "Otoño",
	add_row: "Añadir fila",
	add_serie: "Añadir serie",
	text_turned_into_alt_text: "Cuando hay una imágen cargada, el texto el texto funciona como texto alternativo.",
	modal_barchart_editor_reduce_bars_message: "La cantidad máxima de barras para usar series es de 3. Si haces click en el botón confirmar, el excedente de barras será borrado ¿Estás seguro de querer continuar?",
	"theme-light-orange": "Naranja claro",
	"theme-dark-orange": "Naranja oscuro",
	"theme-light-blue": "Azul claro",
	"theme-dark-blue": "Azul oscuro",
	"theme-turquoise": "Turquesa",
	"theme-violet": "Violeta",
	"theme-bordeaux": "Burdeos",
	"theme-green": "Verde",
	fraction_editor: "Editor de fracciones",
	fraction_editor_help: "Completa las secciones para crear la fracción a tu gusto.",
	fractions_shape_editor_title: "Forma",
	fractions_shape_editor_description: "Selecciona la forma para la actividad",
	fractions_divisions_editor_title: "Divisiones",
	fractions_divisions_editor_description: "Elige cuántas divisiones tendrá la figura",
	select_color_theme_title: "Color",
	select_color_theme_description: "Selecciona un color",
	operations_editor_title: "Operaciones",
	operations_editor_help: "Completa las secciones para crear la operación a tu gusto.",
	counting_editor_operation_title: "Tipo de operación",
	counting_editor_operation_subtitle: "Selecciona si es una suma o una resta",
	counting_editor_summand_title: "Sumando",
	counting_editor_summand_subtitle: "Selecciona una cantidad",
	change_image_title: "Cambiar imagen",
	change_image_subtitle: "Puedes cambiar imagen pero no puede quedar vacía",
	change_image_alt: "Cambiar imagen",
	items_to_show_title: "Elementos mostrados",
	items_to_show_description: "Escribe aquí cuántos elementos aparecerán",
	minuend_title: "Sustraendo",
	select_a_quantity: "Selecciona una cantidad",
	add: "Conteo Sumar",
	count: "Conteo Simple",
	subtract: "Conteo Restar",
	show_result_title: "Mostrar resultado",
	show_result_subtitle: "Muestra el resultado de la operación de inmediato",
	math_number_line_stimulus_default: "Representa en la gráfica los siguientes puntos",
	number_line_editor_help: "Escribe las diferentes opciones que quieras mostrar al alumnado como respuestas.",
	divisions: "Divisiones",
	number_line_starting_number: "Número inicial",
	number_line_starting_number_description: "Donde empieza la recta",
	number_line_finishing_number: "Número final",
	number_line_finishing_number_description: "Donde termina la recta",
	number_line_divisions_description: "Elige cuántas marcas hay en la línea",
	number_line_distance: "Distancia de los números mostrados",
	number_line_distance_description: "Selecciona el intervalo entre los números mostrados",
	number_line_fractions: "Fracciones",
	number_line_fractions_description: "Mostrar fracciones en lugar de números enteros",
	number_line_denominator: "Denominador",
	number_line_denominator_description: "Escribe un número. Actuará como denominador para toda la línea",
	number_line_fractions_as_integers: "Fracciones enteras como unidades",
	number_line_fractions_as_integers_description: "Si el numerador es un múltiplo del denominador, se muestra el número entero",
	grid_editor: "Editor de tabla",
	grid_editor_description: "**empty**",
	grid_size_title: "Tamaño de la tabla",
	grid_size_subtitle: "**empty**",
	charts_pictograph_stimulus_default: "Completa la lista de la compra.",
	pictograph_table_editor_help: "Rellena los espacios para completar la tabla y la gráfica. Los cambios se verán reflejados en el player.",
	pictograph_table_title_empty: "La tabla debe tener un título",
	Pineapples: "Piñas",
	Strawberries: "Fresas",
	editor_pathway_grid_title: "Editor de cuadrícula",
	editor_pathway_grid_editor_help: "Completa las secciones para crear el laberinto a tu gusto.",
	editor_pathway_grid_size_title: "Tamaño cuadrícula",
	editor_pathway_grid_size_subtitle: "Selecciona un tamaño de cuadrícula",
	editor_pathway_grid_width_title: "Ancho",
	editor_pathway_grid_width_subtitle: "Puede ser diferente al alto",
	editor_pathway_grid_height_title: "Alto",
	editor_pathway_grid_height_subtitle: "Puede ser diferente al ancho",
	editor_pathway_change_image_title: "Cambiar imagen de fondo",
	editor_pathway_change_image_subtitle: "Actívalo para subir tu propia imagen",
	editor_pathway_change_character_title: "Cambiar personaje",
	editor_pathway_change_character_subtitle: "Elige entre los diferentes personajes",
	editor_pathway_coordinate_x_title: "Coordenada de inicio: X",
	editor_type_or_select_number: "Escribe o selecciona un número",
	editor_pathway_coordinate_y_title: "Coordenada de inicio: Y",
	editor_pathway_solutions_help: "editor_pathway_solutions_help",
	sand: "Arena",
	grass: "Hierba",
	stone: "Piedra",
	farmer: "Granjero",
	pirate: "Pirata",
	worker: "Trabajador",
	editor_coordinate_axes_grid_size_title: "Tamaño de cuadrícula",
	editor_coordinate_axes_grid_size_subtitle: "Selecciona el tamaño de la cuadrícula",
	editor_coordinate_axes_quadrant_title: "Cuadrante",
	editor_coordinate_axes_quadrant_subtitle: "Selecciona tipo de cuadrante I, II, III, IV, Todos",
	editor_coordinate_axes_dot_color_title: "Color del punto",
	editor_coordinate_axes_dot_color_subtitle: "Selecciona un color para el punto",
	generate_new: "Generar nuevo",
	ABOVE: "Encima",
	boxplot_editor_title: "Editor de diagrama de caja y bigotes",
	boxplot_editor_help: "Edita los valores máximo y mínimo de la recta.",
	boxplot_editor_min_title: "Caja: Valor mínimo",
	boxplot_editor_min_description: "Elige cuántas divisiones mostrará la figura",
	boxplot_editor_max_title: "Caja: Valor máximo",
	boxplot_editor_max_description: "Elige cuántas divisiones mostrará la figura",
	linechart_table_editor_title: "Editor de tabla",
	linechart_table_editor_help: "Rellena los espacios para completar la tabla y la gráfica. Los cambios se verán reflejados en el player ",
	linechart_add_row_description: "Añade filas a la tabla; también se verán reflejadas en la gráfica.",
	linechart_add_serie_description: "Añade una serie nueva; en la gráfica se verá reflejada como una línea nueva.",
	modal_barchart_editor_reduce_bars_title: "Hay demasiadas barras para usar la función de series",
	modal_barchart_editor_reduce_bars_title_subtitle: "El número de barras se reducirá hasta encajar con esta función, siendo el máximo permitido tres barras por serie",
	other_reverse_pathway_stimulus_default: "¿Qué pasos tiene que dar el pirata para llegar a la meta?",
	editor_coordinate_axes_quadrant_all: "Todos",
	config_clock_digital_title: "Reloj digital",
	config_clock_digital_subtitle: "Cambia entre reloj analógico y digital",
	config_clock_dark_mode_title: "Modo oscuro",
	config_clock_dark_mode_subtitle: "Elige entre el tema claro u oscuro para el reloj",
	config_clock_steps_title: "Pasos",
	config_clock_steps_subtitle: "Selecciona el intervalo de tiempo (uno a uno, de cinco en cinco)",
	config_clock_steps_one: "Uno a uno",
	config_clock_steps_five: "De cinco en cinco",
	config_clock_24_hour_title: "Reloj de 24 horas",
	config_clock_24_hour_subtitle: "Selecciona entre la vista de 12 horas o la vista de 24 horas",
	charts_pie_chart_stimulus_default: "En la cesta de la compra tenemos 1 pera, 2 manzanas y 3 piñas.",
	piechart_table_editor_help: " Rellena los espacios para completar la tabla y la gráfica. Los cambios se verán reflejados en el player.",
	charts_pie_chart_table_title: "Título de la tabla",
	charts_pie_chart_table_title_placeholder: "Escribe un texto para el título",
	piechart_table_title_error_empty: "La tabla debe tener un título",
	charts_pie_chart_elements: "Elementos",
	charts_pie_chart_elements_placeholder: "Nombre del elemento",
	charts_pie_chart_elements_error_empty: "Todos los elementos deben tener un nombre",
	charts_pie_chart_add_element: "Agregar elemento",
	charts_pie_chart_add_element_tooltip: "Añade un elemento más al gráfico de sectores.",
	input_tootltip_help: "¡Escribe aquí!",
	input_tootltip_help_touch_devices: "¡Pulsa aquí!",
	config_automatic_drop_title: "Autocompletar respuestas",
	config_automatic_drop_subtitle: "Al hacer clic, las respuestas se insertarán automáticamente en el primer espacio disponible",
	input_math_floating_tootltip_help: "¡Haz clic aquí!",
	answer_options_group_responses_toggle: "Agrupar",
	stickers_drop_editor_title: "Editor de drops",
	stickers_drop_editor_help: "Sube una imagen de fondo para tu ejercicio y crea hotspots que los estudiantes deben rellenar",
	hotspots_painter_button_undo: "Deshacer",
	hotspots_painter_button_redo: "Rehacer",
	hotspots_painter_button_select: "Seleccionar",
	hotspots_painter_button_draw: "Dibujar",
	hotspots_painter_button_delete: "Eliminar",
	stickers_drop_editor_tab_upload_image: "1. Subir imagen",
	stickers_drop_editor_tab_hotspots: "2. Hotspots",
	config_show_hotspots_title: "Mostrar hotspots",
	config_show_hotspots_subtitle: "El estudiante verá el área donde puede colocar la pegatina",
	config_drop_indicator_title: "Indicador de drop",
	config_drop_indicator_subtitle: "Ayuda visual para el estudiante",
	stickers_stimulus_default: "Coloca dos aguacates en la primera cesta y dos limones en la segunda.",
	input_floating_tootltip_help: "¡Haz clic aquí!",
	input_floating_tootltip_help_touch_devices: "¡Toca aquí!",
	stickers_answer_options_placeholder: "Descripción alternativa de la imagen",
	stickers_drop_editor_image_placeholder: "Descripción alternativa de la imagen",
	config_vertical_orientation_title: "Orientación vertical",
	config_vertical_orientation_subtitle: "Mostrar los hotspots en columnas",
	classify_stickers_stimulus_default: "Coloca dos aguacates en la primera cesta y dos limones en la segunda.",
	classify_stickers_series_stimulus_default: "Continúa las series.",
	fruit_avocados: "Aguacates",
	fruit_lemons: "Limones",
	fruit_apples: "Manzanas",
	fruit_pineapples: "Piñas",
	stickers_series_exercise_help: "Añade tantas cajas en blanco como necesites y colócalas por la imagen. Puedes cambiar la imagen de fondo y redimensionar las cajas.",
	stickers_series_exercise_title_box: "Editor de imágenes",
	clear_all_button: "Borrar todo",
	clear_all_description: "Al hacer clic en esto se eliminarán todos los datos de este ejercicio",
	clear_all_confirmation_title: "Atención",
	clear_all_confirmation_description: "Todos los elementos serán eliminados",
	clear_all_confirmation_cancel_button: "Cancelar",
	clear_all_confirmation_confirm_button: "Confirmar",
	move_bottom_handle: "Mueve el tirador de abajo",
	axis_editor_title: "Editor de ejes",
	axis_editor_help: "Configura el aspecto del eje de coordenadas",
	math_vertical_operation_stimulus_default: "Completa la siguiente operación",
	response_ignore_trailing_zeros_title: "Ignorar ceros a la derecha",
	response_ignore_trailing_zeros_subtitle: "Si está activado, la respuesta del alumno se considerará correcta incluso si tiene ceros decimales a la derecha.",
	word_search_button_generate_is_loading: "Generando...",
	transformations_in_plane_stimulus_default: "Representa la traslación de esta figura 5 cuadrados a la derecha",
	lineal_function_stimulus_default: "Representa gráficamente y = -3x + 1",
	quadratic_function_stimulus_default: "Representa gráficamente y = −2x² + 4x + 1",
	charts_flow_chart_stimulus_default: "Completa el siguiente diagrama de flujo.",
	"empty-figure": "Vaciar figura",
	prime_number_decomposition_stimulus_default: "Descompón en factores primos el número 12.",
	charts_histograms_stimulus_default: "Construye un histograma a partir de la siguiente tabla de datos.",
	charts_histograms_x_axis_name: "T(ºC)",
	charts_histograms_x_axis_label: "Temperatura máxima",
	charts_histograms_y_axis_name: "Frecuencia absoluta",
	charts_histograms_y_axis_label: "Frecuencia absoluta",
	math_find_closest_value_stimulus_default: "Indica el resultado del número usando la recta númerica",
	"move-right": "Trasladar derecha",
	"move-left": "Trasladar izquierda",
	"move-up": "Rotar arriba",
	"move-down": "Rotar abajo",
	rotate: "Rotar",
	"flip-horizontal": "Reflexión horizontal",
	"flip-vertical": "Reflexión vertical",
	functions_editor: "Editor de funciones",
	functions_editor_help: "Usa el editor de funciones para introducir nuevas funciones y ajustar sus valores.",
	add_function: "Añadir función",
	operation_editor: "Editor de opearaciones",
	operation_editor_help: "En este bloque, puedes configurar los valores de la operación.",
	config_operation_title: "Operaciones dinámicas",
	config_operation_subtitle: "Genera una operación aleatoria o a medida.",
	digits_per_addend_title: "Número de dígitos por sumando",
	digits_per_addend_subtitle: "Define la cantidad de dígitos en cada sumando.",
	addend_count_title: "Cantidad de sumandos",
	addend_count_subtitle: "Define la cantidad de sumandos que tendrá la operación.",
	column_help_title: "Resalte de columnas",
	column_help_subtitle: "Ayuda visual que resalta la columna actual.",
	order_terms_title: "Ordenación de términos",
	order_terms_subtitle: "Muestra los términos de la operación de mayor a menor.",
	prime_number_generator_editor: "Generador de valores dinámicos",
	prime_number_generator_editor_help: "Genera un número aleatorio que el alumno tendrá que descomponer en base a la selección que hagas en estas opciones.",
	enabled_factors_title: "Números primos",
	enabled_factors_subtitle: "Selecciona los posibles factores del número generado.",
	factors_length_title: "Número de factores",
	factors_length_subtitle: "Indica la cantidad máxima de factores que puede tener el número generado sin contar con el 1.",
	Transcription: "Transcripción",
	other_rating_stimulus_default: "¡Es momento de valorar el contenido!",
	other_rating_tooltip_1_star: "1 estrella",
	other_rating_tooltip_multiple_stars: "{{count}} estrellas",
	other_rating_description_1_star: "No me ha gustado. Me ha confundido y me ha aburrido.",
	other_rating_description_2_stars: "Me ha gustado más o menos... Algunas cosas las he entendido que otras.",
	other_rating_description_3_stars: "Me ha gustado bastante. Lo he entendido y me ha interesado :)",
	other_rating_description_4_stars: "¡Me encantó! Lo encontré interesante y divertido. ¡Quiero más!",
	adaptative_choice_levels_config: "Configuración de Niveles",
	adaptative_choice_levels_config_help: "Configura los títulos de cada nivel de la actividad adaptativa",
	adaptative_choice_level_title: "Nivel {{level_number}}",
	adaptative_choice_level_title_label: "Título del nivel:",
	adaptative_choice_level_title_placeholder: "Escribe el título de este nivel...",
	other_adaptative_choice_back: "Atrás",
	other_adaptative_choice_next: "Siguiente"
};
var es = {
	translations: translations$3
};

var translations$4 = {
	title: "Titulua",
	enunciated: "Enuntziatua",
	stimulus: "Jardueraren enuntziatua",
	enunciated_placeholder: "Idatzi deskribapen bat",
	multiple_choice_activity: "Aukera anitzekoa",
	answer_options: "Erantzun aukerak",
	add_new_response: "Gehitu",
	add_new_question: "Gehitu",
	new_question_stem: "Galdera berria",
	validation: "Puntuazioa",
	option: "Aukera",
	type_of_validation: "Sartu baliozkotze mota:",
	exactMatch: "Zehatza: aukera guztiak zuzen erantzun behar dira.",
	partialMatch: "Partziala: erantzun zuzen bakoitzak emango du puntuazioa.",
	partialMatchV2: "Partziala erantzun bakoitzeko: puntuazioa erantzun kopuruaz zatituko da.",
	score: "Puntuazioa",
	high_score: "Puntuazio maximoa",
	enter_a_score: "Sartu puntuazioa",
	minimum_score: "Gutxieneko puntuazioa saiatzeagatik",
	cancel: "Ezeztatu",
	save: "Gorde",
	send: "Bidali",
	reset: "Berrezarri",
	shuffle_options: "Nahastu erantzunak",
	multiple_responses: "Erantzun anizkoitza",
	words_limit: "Hitz muga",
	letters_limit: "Letra muga",
	essay_placeholder: "Idatzi zure erantzuna.",
	right_answer: "Erantzun zuzena",
	write_right_answer: "Idatzi erantzun zuzena",
	copy: "Kopiatu",
	cut: "Ebaki",
	paste: "Itsatsi",
	cloze_text: "Cloze testua",
	activity_data_wrong: "Datuak gaizki eratuta daude",
	this_is_the_stem: "Garatu galdera hemen",
	"true": "Zuzena",
	"false": "Okerra",
	column: "Zutabea",
	columns: "Zutabeak",
	row: "Errenkada",
	world_map: "Munduko mapa",
	Greenland: "Groenlandia",
	Russia: "Errusia",
	United_States: "Estatu Batuak",
	table_editor: "Taula editorea",
	drags: "Arrastatzekoa",
	add_new_column: "Gehitu izenburua zutabeari",
	add_new_row: "Gehitu izenburua errenkadari",
	duplicate_responses: "Bikoiztutako erantzunak",
	solutions: "Ebazpenak",
	Solution: "Ebazpena",
	column_count: "Zutabe kopurua",
	row_count: "Errenkada kopurua",
	cloze_template: "Mantxa aldeko herri koxkor batean, izenik gogoratu nahi ez dudana, aspaldi ez dela {{response}} bat bizi zen, lantza altxatokian, adarga zahar, zaldi zingil eta {{response}} lasterkari daduzkaten horietarikoa.",
	response: "Erantzuna",
	response_containers: "Erantzun edukiontziak",
	global_size: "Eskala orokorra",
	width: "Zabalera",
	height: "Altuera",
	upload_file: "Igo fitxategia",
	completed: "Osatuta",
	choose_file: "Aukeratu fitxategia",
	change_file: "Aldatu fitxategia",
	load_image_error_message: "Errorea gertatu da irudia igotzen saiatzean",
	sending_file: "Fitxategia igotzen",
	select_an_item: "Aukeratu elementu bat",
	pointer: "Erakuslea",
	none: "Batere ez",
	left: "Ezkerra",
	right: "Eskuina",
	top: "Goia",
	bottom: "Behea",
	show_check_icon: "Erakutsi ikonoa",
	alternative_text: "Testu alternatiboa",
	isEvaluable: "Ebaluazio modua",
	autosize_response: "Luzera automatikoa",
	text_normalization: "Testuen normalizazioa",
	load_image: "Igo irudia",
	image_size: "Irudiaren tamaina",
	text_sample: "Ereduzko testua",
	size: "Tamaina",
	accent_sensitive: "Azentu markak bereizten ditu",
	case_sensitive: "Letra larriak bereizten ditu",
	spaces_sensitive: "Zuriuneak bereizten ditu",
	orientation: "Orientazioa",
	"delete": "Ezabatu",
	stack: "Pilatu",
	box: "Kaxa",
	Feedback: "Feedbacka",
	"Remove Feedback": "Kendu feedbacka",
	Visibility: "Ikusgarritasuna",
	"Success Message": "Arrakasta mezua",
	"Error Messages": "Akats mezuak",
	Sequence: "Sekuentzia",
	cyclic: "Ziklikoa",
	random: "Ausazkoa",
	"Add new error": "Gehitu akatsa",
	"Error message": "Akats mezua",
	Configuration: "Ezarpenak",
	"Shuffle Answers": "Ausazko ordena",
	"When turned on the questions will be sorted in differ order each time they are presented": "Aukerak ausaz aterako dira ikasle bakoitzarentzat.",
	"Show check icon": "Erakutsi egiaztapeneko ikonoa",
	"When turned on the answers will have a radio button next to them": "Aktibatu, aukeren alboan aukeraketa kaxa erakusteko.",
	Columns: "Zutabeak",
	"Choose how many columns you want the answers to be displayed into": "Aukeratu erantzunak zenbat zutabetan erakutsi nahi dituzun",
	style_block_none: "Batere ez",
	style_block_BLOCK: "Blokea",
	style_block_NUMERICAL: "Zenbakizkoa",
	style_block_LOWER_ALPHA: "Alfabetoa letra xehez",
	style_block_UPPER_ALPHA: "Alfabetoa letra larriz",
	"1 columns": "1 zutabe",
	"2 columns": "2 zutabe",
	"3 columns": "3 zutabe",
	"4 columns": "4 zutabe",
	"5 columns": "5 zutabe",
	"6 columns": "6 zutabe",
	SERVER_ERROR: "Errorea gertatu da fitxategia igotzean. Saiatu berriz.",
	MAX_FILES_REACHED: "Baimendutako fitxategi kopurua gainditu duzu.",
	INVALID_TYPE: "Fitxategi mota hori ez da baliozkoa",
	MAX_SIZE_EXCEEDED: "Igo nahi duzun fitxategiak baimendutako gehieneko tamaina gainditzen du. Mesedez, murriztu tamaina, eta saiatu berriz.",
	UNKNOWN_ERROR: "Arazoa izan da fitxategia igotzean. Saiatu berriz, mesedez.",
	"You can set up the settings of each type of question here": "Hemen konfigura ditzakezu galdera mota bakoitzaren ezarpenak.",
	"Different max / min file upload": "Gehieneko/gutxieneko desberdineko fitxategia igotzea",
	"Turn on if you want to allow uploading a range of files to the exercise": "Zenbait fitxategi igo daitezke jarduera honetan.",
	"File size limit": "Fitxategiaren gehieneko tamaina",
	"Max size each file can reach. This is a default value and cannot be editted": "Fitxategi bakoitzak izan dezakeen gehieneko tamaina. Aurrez zehaztutako balioa da hau, eta ezin da aldatu",
	"Types of files allowed as attachments": "Eranskin gisa onartutako fitxategi mota",
	"MS Word, Excel, Power Point, jpg, png, pdf, Open Office, txt, video and audio": "Word, Excel, Power Point, jpg, png, pdf, Open Office, txt, bideoa eta audioa",
	"default": "Lehenetsita",
	"Files limit": "Fitxategien muga",
	"Min/Max number of files the student is allowed to upload": "Ikasleak igo dezakeen gehieneko/gutxieneko fitxategi kopurua",
	"Size thumb": "Miniaturaren tamaina",
	"Image size": "Irudiaren tamaina",
	"Background image": "Atzealdeko irudia",
	"Canvas Background Image": "Mihisearen atzealdeko irudia",
	"Allowed files: images (jpg, png, gif), audio (mp3, ogg), video (mp4, ogg, webm, mkv), documents (word, excel, power point, pdf, open office, txt)": "Onartutako formatuak: irudiak (jpg, png, gif) audioa (mp3, ogg), bideoa (mp4, ogg, webm, mkv), dokumentuak (word, excel, power point, pdf, open office, txt)",
	"Allowed files: images (jpg, png, gif)": "Onartutako formatuak: irudiak (jpg, png, gif)",
	Exercise: "Jarduera",
	background_image_alt: "Testu alternatiboa",
	response_exact_or_equivalent_title: "Emaitza zehatza edo baliokidea da",
	response_exact_or_equivalent_subtitle: "Aukeratu zehatza, erantzun zehatzak soilik nahi badituzu zuzentzat ebaluatu. Aukeratu baliokidea edozein adierazpen baliokide zuzentzat hartu nahi baduzu",
	response_exact_or_equivalent_subtitle_option_equivliteral: "Zehatza",
	response_exact_or_equivalent_subtitle_option_equivsymbolic: "Baliokidea",
	response_decimals_title: "Dezimalak",
	response_decimals_subtitle: "Aukeratu gutxieneko dezimal kopurua",
	response_response_value: "Erantzunaren balioa",
	response_title: "Erantzuna",
	response_decimal_option_0: "Dezimalik gabe",
	response_decimal_option_1: "1 dezimal",
	response_decimal_option_2: "2 dezimal",
	response_decimal_option_3: "3 dezimal",
	response_decimal_option_4: "4 dezimal",
	response_decimal_option_5: "5 dezimal",
	response_decimal_option_6: "6 dezimal",
	stimulus_help: "Idatzi hemen jardueraren enuntziatua. Testua, ekuazioak, taulak eta edozein material editagarri gehitu dezakezu.",
	config_help: "Hemen konfigura ditzakezu galdera mota bakoitzaren ezarpenak.",
	answer_options_help: "Idatzi ikasleari erantzun posible gisa erakutsi nahi dizkiozun aukerak, eta aukeratu haien ordena. Erantzun gehiago gehitu ditzakezu Gehitu botoiari klik eginda.",
	editor_response_title_accordion: "Erantzuna",
	config_canvas_height_title: "Altuera lehenetsia",
	config_canvas_height_subtitle: "Atzealdeko espazioaren altuera lehenetsia",
	background_image_title: "Atzealdeko irudia",
	background_image_subtitle: "Ezarri atzealdeko irudi bat",
	response_result_button_delete: "Ezabatu erantzuna",
	config_variant_style_title: "Egilearen aldagaia",
	config_variant_style_subtitle: "Aukeratu nahi den aldagaia",
	config_variant_style_input_placeholder: "Gehitu ikastaldearen izena",
	style_variant_default: "Lehenetsita",
	style_variant_custom: "Pertsonalizatua",
	config_multiple_responses_title: "Erantzun anizkoitza",
	config_multiple_responses_subtitle: "Aktibatu, baliozko erantzun bat baino gehiago badago",
	button_validation_title_box: "Botoia",
	button_validation_title: "Gehitu balidatzeko botoia",
	button_validation_subtitle: "Aktibatu, ikasleari berrespeneko botoia gehitzeko",
	button_validation_alt: "Gehitu zure testua hemen",
	button_validation_help: "Erabili aukera hau, ikasleek jarduera amaitutakoan amaitutakotzat markatzea nahi baduzu",
	button_validation_default: "Eginda",
	button_edit: "Editatu",
	button_cancel: "Ezeztatu",
	button_confirm: "Berretsi",
	button_try_again: "** Intentar otra vez",
	button_cant_speak_now: "** No puedo hablar ahora",
	config_background_title: "Gehitu atzealdeko irudia",
	config_background_subtitle: "Aktibatu, atzealderako irudi bat igo nahi baduzu",
	config_background_help: "Atzealdeko irudi bat igo dezakezu.",
	exercise_example_text_title: "Idatzi hemen galderaren testua",
	exercise_example_text_subtitle: "Etiketa bat bete aurreko testua",
	exercise_label_font_size_title: "Letra tamaina",
	exercise_label_font_size_subtitle: "Kaxako letraren tamaina zehazten du",
	config_duplicate_responses_title: "Bikoiztu erantzunak",
	config_duplicate_responses_subtitle: "Aktibatu, erantzunak bikoizteko",
	feedback_exercise_title: "Akatsen trataera",
	feedback_exercise_placeholder: "Gehitu hemen feedback orokorra",
	feedback_exercise_help: "Gogoan izan horrek ikasleei jarduera osoaren akats orokorraren trataera eskaintzen diela. Oharren bat egiteko erabil dezakezu.",
	feedback_exercise_help_with_individual: "Ikasleei lagundu diezaiekezue jardueraren akats orokorraren trataera eskainita. Halaber, erantzun bakoitzean banakako iruzkinak sar ditzakezu, eta ikasleari agertuko zaizkio, huts egiten badu.",
	config_is_math_title: "Matematika da",
	config_is_math_subtitle: "Adierazi matematika den",
	config_accent_sensitive_title: "Azentu markak bereizten ditu",
	config_accent_sensitive_subtitle: "Aktibatu, zuzenketetan azentu markak kontuan hartu nahi badituzu",
	config_case_sensitive_title: "Letra larriak bereizten ditu",
	config_case_sensitive_subtitle: "Aktibatu, zuzenketetan letra larriak eta letra xeheak bereiztea nahi baduzu",
	config_fix_spaces_title: "Zuzendu zuriuneak",
	config_fix_spaces_subtitle: "Desaktibatu, zuriuneen erabilera okerra kontuan hartu nahi ez baduzu, hitzeko edozein lekutan izanik ere.",
	config_max_character_title: "Karaktere murrizketa",
	config_max_character_subtitle: "Sartu gehieneko karaktere kopurua, erantzunaren luzera murrizteko",
	config_max_character_input_title: "Ezarri karaktere muga",
	config_max_character_input_subtitle: "Zehaztu ikasleak idatzi dezakeen gehieneko karaktere kopurua",
	config_max_character_input_placeholder: "Gehieneko karaktere kopurua",
	config_words_limit_title: "Hitz kontagailua",
	config_words_limit_subtitle: "Sartu gehieneko hitz kopurua",
	config_words_limit_input_title: "Ezarri hitz muga",
	config_words_limit_input_subtitle: "Zehaztu ikasleak idatz dezakeen gehieneko hitz kopurua",
	config_words_limit_input_placeholder: "Sartu gehieneko hitz kopurua",
	config_autosize_response_title: "Neurri automatikoko erantzuna",
	config_autosize_response_subtitle: "Aktibatu, erantzun koadroaren gehieneko luzerak erantzunaren luzera bera izan dezan nahi baduzu",
	"Drop your files here or": "Arrastatu hona zure artxiboak edo aukeratu artxibo bat",
	browse: " ",
	"Max file size": "Fitxategiaren gehieneko neurria",
	"MB · At least": "MB ·",
	"file required": "fitxategia nahitaezkoa da",
	richText_placeholder: "Idatzi hemen zure erantzuna",
	"Questions options": "Galdera aukerak",
	"Answer options": "Erantzun aukerak",
	Answer: "Erantzuna",
	config_stack_title: "Pilatu",
	config_stack_subtitle: "Arrastatzekoak eremuen gainean pilatuko dira, pantailaren tamainak hala ahalbidetzen duenean",
	config_with_box_title: "Kaxetan sartzeko aukerak",
	config_with_box_subtitle: "Arrastatzekoak lerro batekin markatuko dira aukeratzean",
	config_lines_color_title: "Lerroen kolorea",
	config_lines_color_subtitle: "Aukeratu lerroaren kolorea",
	line_thinckness_fine: "Fina",
	line_thinckness_medium: "Ertaina",
	line_thinckness_coarse: "Lodia",
	config_line_thickness_title: "Lerroen lodiera",
	config_line_thickness_subtitle: "Aukeratu lerroaren tamaina",
	config_feedback_mode_click_to_find_title: "Feedback modua",
	config_feedback_mode_click_to_find_subtitle: "Batere ez, ertzarekin edo markarekin",
	feedback_mode_none: "Batere ez",
	"feedback_mode_feedback-with-border": "Ertzarekin",
	"feedback_mode_feedback-with-tick": "Markarekin",
	click_to_find_size_background_title: "Atzealdeko irudiaren tamaina",
	click_to_find_size_background_subtitle: "Irudiaren tamaina",
	click_to_find_solutions_tooltip_correct: "Markatu zuzen gisa",
	click_to_find_solutions_tooltip_incorrect: "Markatu oker gisa",
	config_column_direction_title: "Zutabearen norabidea",
	config_column_direction_subtitle: "Bertikala edo horizontala",
	column_direction_horizontal: "Horizontala",
	column_direction_vertical: "Bertikala",
	linking_lines_limit_options_help: "Behar bezala bistaratzeko, aukera kopurua 6ra mugatuta dago",
	evaluation_mode_tooltip: "Desaktibatu, eskuz zuzendu nahi baduzu, edo notarako kontuan hartuko ez den informazioa jaso nahi baduzu.",
	individual_feedback_exercise_placeholder: "Idatzi banakako feedbacka erantzun honetan",
	label_drop_item: "Erantzuna",
	individual_feedback_exercise_tooltip: "Gehitu feedbacka erantzun honetarako",
	change_image: "Aldatu irudia",
	answer_options_help_multiple_choice: "Idatzi ikasleari erantzun posible gisa erakutsi nahi dizkiozun aukerak, eta aukeratu haien ordena.",
	add_alternative: "Alternatiba",
	solutions_instructions: "Definitu jardueraren erantzun zuzena eta haren puntuazioa. Esleitu % 100 erantzuna zuzena bada. Erantzun alternatiboa ere eman dezakezu, eta merezi duen puntu kopuru osoaren % esleitu.",
	image: "Irudia",
	add_an_image_to_exercise: "Gehitu jardueraren irudi bat",
	button_show_hints: "Lagungarria",
	button_validate: "Egiaztatu",
	button_restart: "Berregin",
	button_repeat: "Errepikatu",
	button_show_solution: "Ikusi erantzuna",
	button_hide_solution: "Ikusi nire erantzuna",
	button_restart_scaffold: "Berrabiarazi scaffoldinga",
	points: "Puntuak",
	button_next_question: "Hurrengoa",
	button_i_dont_know: "Ez dakit",
	title_help: "Eremu hau ez da ikusgai egongo ikaslearentzat. Editoreak jarduerak errazago bilatzeko balioko du.",
	title_placeholder: "Idatzi hemen testua",
	hints_title_box: "Lagungarria",
	hints_help: "Ikasleak laguntza behar duenean eska ditzakeen mezu laburrak dira lagungarriak. Jarduera honetarako iradokizunak gehitu ditzakezu hemen.",
	hints_title: "Gehitu lagungarria",
	hints_subtitle: "Aktibatu, ikasleari informazioa edo aholku txiki bat emateko",
	hint_placeholder: "Lagungarriaren testua duen eremua",
	automatic_evaluation: "Ebaluazio automatikoa",
	automatic_evaluation_description: "Desaktibatu, eskuz ebaluatzeko eta erantzun irekiak baimentzeko",
	title_title_box: "Barneko izena",
	feedback_exercise_toogle_title: "Gehitu feedbacka",
	feedback_exercise_toogle_subtitle: "Aktibatu, ikasle batek akatsa egiten duenean orientatzeko",
	multiple_choice_multiple_stimulus_default: "Hautatu aukera hauetako gutxienez bat (edo gehiago):",
	multiple_choice_single_stimulus_default: "Hautatu aukera hauetako bat:",
	multiple_choice_truefalse_stimulus_default: "Irakurri, eta erantzun ‘Zuzena’ edo ‘Okerra':",
	multiple_choice_blockletter_stimulus_default: "Hautatu aukera hauetako bat:",
	choice_matrix_inline_stimulus_default: "Erabaki aukera hauek zuzenak ala okerrak diren:",
	choice_matrix_standard_stimulus_default: "Erabaki aukera hauek zuzenak ala okerrak diren:",
	classify_classification_stimulus_default: "Arrastatu eta askatu erantzun bakoitza dagokion tokian:",
	classify_matchlist_stimulus_default: "Elkartu erantzun bakoitza dagokion kontzeptuarekin:",
	classify_orderlist_stimulus_default: "Arrastatu eta askatu, erantzunak ordenatzeko:",
	classify_linkinglines_stimulus_default: "Lotu hitz bakoitza dagokion esanahiarekin:",
	cloze_text_stimulus_default: "Idatzi jarraian ageri diren kaxetan falta den hitza:",
	cloze_dropdown_stimulus_default: "Aukeratu goitibeherako menu bakoitzeko aukera zuzena:",
	cloze_drag_drop_stimulus_default: "Arrastatu eta askatu erantzunak hutsuneetan.",
	essay_plaintext_stimulus_default: "Sortu zure leku gogokoenari buruzko 200 hitzeko idazlan bat.",
	essay_sorttext_stimulus_default: "Zein da Hego Amerikako ibairik luzeena?",
	essay_sorttext_solution1_default: "Amazonas ibaia",
	essay_richtext_stimulus_default: "Sortu zure leku gogokoenari buruzko 200 hitzeko idazlan bat.",
	labelimage_dragdrop_stimulus_default: "Arrastatu eta askatu herrialde bakoitza dagokion tokian:",
	labelimage_dropdown_stimulus_default: "Aukeratu goitibeherako menu bakoitzeko aukera zuzena:",
	labelimage_imagewithtext_stimulus_default: "Idatzi herrialde bakoitzaren izena:",
	math_clozemath_stimulus_default: "Kalkulatu eragiketa hauek:",
	other_uploadfile_stimulus_default: "Egin zure etxeko lanen argazki bat, eta askatu hemen:",
	other_pencil_stimulus_default: "Marraztu zure maskota edo animalia gogokoena eta non bizi den:",
	other_statement_stimulus_default: "Aukeratu ikaskide bat, eta aipatu zergatik den garrantzitsua bizimodu osasungarria izatea.",
	other_clicktofind_stimulus_default: "Egin klik limoi guztietan:",
	choice_matrix_questions_help: "Sartu galderen enuntziatuak kaxetan. Galdera gehiago gehitu ditzakezu gehitu botoiari klik eginda.",
	match_list_questions_help: "Sartu galderen enuntziatuak kaxetan. Galdera gehiago gehitu ditzakezu gehitu botoiari klik eginda.",
	linking_lines_questions_help: "Sartu galderen enuntziatuak kaxetan. Galdera gehiago gehitu ditzakezu gehitu botoiari klik eginda.",
	scaffold_separator_step: "Pausoa",
	scaffold_separator_of: "/",
	title_check_icon_single_choice: "Aukera botoia",
	subtitle_check_icon_single_choice: "Desaktibatu, botoia ezkutatzeko eta haren ordez bloke modua erabiltzeko",
	title_check_icon_multiple_choice: "Aukera laukitxoa",
	subtitle_check_icon_multiple_choice: "Desaktibatu, laukitxoa ezkutatzeko eta haren ordez bloke modua erabiltzeko",
	title_block_style: "Zerrenda estiloa",
	subtitle_block_style: "Batere ez, zenbakizkoa edo alfabetikoa",
	Spain: "Espainia",
	template_exercise_markup_add_blank: "Gehitu hutsunea",
	template_markup_add_blank: "Gehitu hutsunea",
	sending_button: "Bidaltzen...",
	table_editor_help: "Erabili taula editorea taulako zutabe eta zerrenda kopurua konfiguratzeko. Zutabeetan gutxienez bat eta gehienez bost jarri ahal izango dira.",
	cloze_exercise_help: "Idatzi esaldi bat, eta erabili zuriunea duten kaxak, ikasleak testuan falta diren gako hitzak zein diren identifika ditzan.",
	cloze_math_exercise_help: "Idatzi enuntziatua, eta erabili zuriunea duten kaxak, ikasleak falta diren zenbakiak edo formulak zein diren identifika ditzan.",
	label_exercise_help: "Gehitu behar dituzun bezainbeste kaxa, eta jarri irudian. Atzealdeko irudia alda dezakezu, kaxei neurria eta letraren tamaina ere alda dezakezu.",
	cloze_dropdown_exercise_help: "Idatzi esaldi bat, eta erabili kaxa zuriak, aukerak gehitzeko. Ikasleak aukera zuzena hautatu beharko du testuan topatuko duen hutsune bakoitzean.",
	click_to_find_exercise_help: "Ordezkatu atzealdeko irudia, gehitu irudi berriak, eta jarri mihisean. Erantzunaren atalean zuzena edo okerra zein den definitu ahal izango duzu.",
	linking_lines_question_option: "Galdera aukera",
	title_evaluation_type: "Ebaluazio mota",
	subtitle_evaluation_type_exact_match: "Ikasleak ariketa zuzen egin beharko du puntuazioa jasotzeko",
	subtitle_evaluation_type_partial_match: "Ariketaren puntuazio orokorra erantzunen artean banatuko da, eta haietako bakoitzak bere puntuazioa jasoko du",
	subtitle_evaluation_type_manual: "Jarduera ez da ebaluatuko.",
	subtitle_evaluation_type_match_response: "Ariketaren puntuazio orokorra arrastatzeko elementuen artean banatuko da, eta haietako bakoitzak bere puntuazioa jasoko du",
	subtitle_evaluation_type_match_group: "Ariketaren puntuazio orokorra taldeen artean banatuko da, eta haietako bakoitzak bere puntuazioa jasoko du",
	evaluation_type_exact_match: "Zuzenketa zehatza",
	evaluation_type_partial_match: "Zuzenketa partziala",
	evaluation_type_manual: "Eskuzko zuzenketa",
	evaluation_type_match_response: "Partziala erantzun bakoitzeko",
	evaluation_type_match_group: "Partziala talde bakoitzeko",
	manual_or_alternative_solutions_help: "Definitu % 100 esleituta izango duen ariketaren erantzun zuzena. Beste erantzun alternatibo batzuk ere sortu ditzakezu, eta merezi duten % esleitu. Ariketa autoebaluaziokoa izatea nahi ez baduzu, aukeratu eskuzko zuzenketa.",
	exact_math_or_partial_match_or_manual_solutions_help: "Zuzenketa zehatzarekin, ikasleak ariketa zuzen egin beharko du puntuazioa jasotzeko. Beste erantzun alternatibo batzuk ere sortu ditzakezu, eta merezi duten % esleitu. Zuzenketa partzialarekin, puntuazio osoa erantzun guztien artean banatuko da, eta haietako bakoitzak bere puntuazioa jasoko du. Ariketa autoebaluaziokoa izatea nahi ez baduzu, aukeratu eskuzko zuzenketa.",
	exact_math_or_match_response_or_match_group_or_manual_solutions_help: "Zuzenketa zehatzarekin, ikasleak ariketa zuzen egin beharko du puntuazioa jasotzeko. Beste erantzun alternatibo batzuk ere sortu ditzakezu, eta merezi duten % esleitu. Erantzun bakoitzeko zuzenketa partzialarekin, puntuazio osoa erantzun guztien artean banatuko da, eta haietako bakoitzak bere puntuazioa jasoko du. Talde bakoitzeko zuzenketa partzialarekin, puntuak elementu edo gelaxken artean banatuko dira. Ariketa ebaluatzerik nahi ez baduzu, aukeratu eskuzko zuzenketa.",
	solutions_penalty_title: "Pertsonalizatua",
	solutions_penalty_subtitle: "Aukeratu eskuz erantzun bakoitzeko penalizazioaren % ",
	feedback_exercise_toogle_individual_feedback_title: "Gehitu akatsen trataera erantzun bakoitzari",
	feedback_exercise_toogle_individual_feedback_subtitle: "Ikasleak oker erantzuten duenean agertuko zaio mezua",
	"Answer Option": "Erantzun aukera",
	"Text Prompt": "Galdera",
	config_fixed_keyboard_title: "Teklatu higikorra",
	config_fixed_keyboard_subtitle: "Aktibatu, laukitxo bat aukeratzen dutenean ikasleei teklatu higikorra ager dakien",
	config_number_keyboards_title: "Zenbakizko teklatua",
	config_number_keyboards_subtitle: "Aukeratu ikasleari agertuko zaion teklatu mota",
	keyboard_type_NONE: "Batere ez",
	keyboard_type_NUMERICAL: "Zenbakizkoa",
	keyboard_type_BASIC: "Oinarrizkoa",
	keyboard_type_INTERMEDIATE: "Tartekoa",
	keyboard_type_COMPLEX: "Aurreratua",
	keyboard_type_SCIENTIFIC: "Zientifikoa",
	solutions_new_alternative_text: "Berria",
	no_microphone: "Ez dut mikrofonorik",
	confirm_replace_audio_message: "Badago audioa grabatuta. Sakatu ‘Berretsi’ beste batekin ordezkatu nahi baduzu.",
	config_audio_duration_limit_title: "Denbora muga",
	config_audio_duration_limit_subtitle: "Aukeratu ikasleak bere burua grabatu beharko duen segundo kopurua",
	other_audio_recorder_stimulus_default: "Grabatu zeure burua fotosintesiaren prozesua azaltzen.",
	no_mic_available: "Gailuan ez da mikrofonorik topatu.",
	no_mic_permission: "Mikrofonoa blokeatuta. Ziurtatu sarbidea baimenduta dagoela.",
	confirm_switching_keyboards_title: "Adi!",
	confirm_switching_keyboards_message: "Editatutako erantzunak ezabatu egingo dira teklatua aldatzean.",
	math_counting_stimulus_default: "Zenbat sagar eta limoi behar ditut sei fruta ale izateko?",
	other_clock_stimulus_default: "15:30 dira",
	sample_answer_title_box: "Ereduzko erantzuna",
	sample_answer_help: "Autoebaluatzekoak ez diren jarduerak zuzentzen laguntzeko, ereduzko erantzuna sortu dezakezu. Atal hori irakasleek soilik ikusi ahal izango dute.",
	sample_answer_title: "Gehitu ereduzko erantzuna.",
	sample_answer_subtitle: "Irakasleentzako ereduzko erantzun baten adibidea.",
	sample_answer_placeholder: "Idatzi hemen testua",
	other_word_search_stimulus_default: "Aurkitu hitz hauek:",
	word_search_grid_s: "S (6x6)",
	word_search_grid_m: "M (10x10)",
	word_search_grid_l: "L (15x15)",
	word_search_title_box: "Letra zopa",
	word_search_help: "Aukeratu lauki sarearen neurria",
	word_search_title: "Lauki sarea",
	word_search_subtitle: "Aukeratu zutabe/errenkada kopurua",
	config_word_search_random_title: "Hitzen ausazko kokapena",
	config_word_search_random_subtitle: "Hitzak beti kokapen desberdinean agertuko dira sartutako bakoitzean.",
	config_word_search_backward_title: "Alderantzizkatutako hitzak",
	config_word_search_backward_subtitle: "Hitzak eskuinetik ezkerrera idatzita egon daitezke.",
	config_word_search_diagonal_title: "Hitzak diagonalean",
	config_word_search_diagonal_subtitle: "Hitzak diagonalean idatzita egon daitezke.",
	word_search_counter_letter: "Letra muga",
	config_word_search_allowed_letters_title: "Baimendutako letras",
	config_word_search_allowed_letters_subtitle: "Aktibatu baimendutako letrak adierazteko",
	confirm_switching_columns_rows_title: "Adi!",
	confirm_switching_columns_rows_message: "Hitz hauek kenduko dira:",
	confirm_edit_allowed_letter_title: "Adi!",
	confirm_edit_allowed_letter_message: "Adierazitakoez bestelako karaktereak dituzten hitzak ezabatu egingo dira.",
	word_search_preview_title_box: "Letra zoparen aurrebista",
	word_search_preview_help: "Horrela ikusiko dira ebazpenak letra zopan",
	word_search_button_generate: "Sortu berria",
	word_search_solutions_help: "Adierazi gutxienez 2 letra dituzten hitzak. Ezin dira zenbakiak, zuriuneak edo karaktere bereziak erabili.",
	other_crossword_stimulus_default: "Gurutzegrama",
	crossword_solutions_help: "Adierazi gutxienez bi letra dituzten hitzak. Ezin dira zenbakiak, zuriuneak edo karaktere bereziak erabili",
	crossword_counter_letter: "Letra muga",
	crossword_word_out: "Ez dago hitzen arteko bat etortzerik. Saiatu hitz gehiago gehituta",
	config_uppercase_lowercase_title: "Aukeratu letra larriak / letra xeheak",
	config_uppercase_lowercase_subtitle: "Hitza letra larriz edo letra xehez agertuko dira",
	config_uppercase: "Letra larriak",
	config_lowercase: "Letra xeheak",
	crossword_message_min_words: "Gutxienez {{num_words}} hitz behar dira.",
	crossword_solutions_text_not_valid: "Hitza ez da baliozkoa. Gutxienez 2 letra.",
	crossword_preview_title_box: "Gurutzegramaren aurrebista",
	crossword_preview_help: "Honela agertuko dira gurutzegramaren ebazpenak",
	crossword_button_generate: "Sortu berria",
	generation_error: "Ezin izan da gurutzegrama sortu.",
	upload_file_button_drive: "Igo Google Drivekin",
	file_uploader_drive: "Google Drive bidez",
	file_uploaded_successfully: "Fitxategia ongi bidali da",
	files_uploaded_successfully: "Fitxategiak ongi bidali dira",
	title_penalty_modes: "Penalizazio puntuak ",
	subtitle_penalty_mode_none: "Penalizatu erantzun okerrak erantzun zuzenen balio berarekin. Neurrirako penalizazioa ere sortu dezakezu",
	subtitle_penalty_mode_per_response: "Penalizatu erantzun okerrak erantzun zuzenen balio berarekin. Neurrirako penalizazioa ere sortu dezakezu",
	subtitle_penalty_mode_custom: "Penalizatu erantzun okerrak erantzun zuzenen balio berarekin. Neurrirako penalizazioa ere sortu dezakezu",
	penalty_mode_none: "Batere ez",
	penalty_mode_per_response: "Erantzun zuzen bakoitzeko puntuazioa ",
	penalty_mode_custom: "Pertsonalizatua",
	config_show_selection_title: "Erakutsi hautapena",
	config_show_selection_subtitle: "Ikasleak aukeratutako objektua ikusiko du ",
	alternative_response: "Beste erantzun batzuk",
	alternative_responses: "Beste erantzun batzuk",
	config_autosize_box_title: "Erantzunaren neurriko kaxa",
	config_autosize_box_subtitle: "Aktiba ezazu kaxaren neurria erantzunaren neurrira egokitzea nahi baduzu.",
	Transcription: "Transkripzioa",
	other_rating_stimulus_default: "Edukia baloratzeko ordua da!",
	other_rating_tooltip_1_star: "1 estrella",
	other_rating_tooltip_multiple_stars: "{{count}} estrellas",
	other_rating_description_1_star: "Ez zait gustatu. Nahastu eta aspergarri egin nau.",
	other_rating_description_2_stars: "Gustatu zait gehienbat... Gauza batzuk besteak baino hobeto ulertu ditut.",
	other_rating_description_3_stars: "Nahiko gustatu zait. Ulertu dut eta interesgarria izan da :)",
	other_rating_description_4_stars: "Gustatu zait! Interesgarria eta dibertigarria iruditu zait. Gehiago nahi dut!",
	adaptative_choice_levels_config: "Mailen Konfigurazioa",
	adaptative_choice_levels_config_help: "Konfiguratu jarduera egokitzaileraren maila bakoitzaren izenburuak",
	adaptative_choice_level_title: "Maila {{level_number}}",
	adaptative_choice_level_title_label: "Mailaren izenburua:",
	adaptative_choice_level_title_placeholder: "Idatzi maila honen izenburua...",
	other_adaptative_choice_back: "Atzera",
	other_adaptative_choice_next: "Hurrengoa"
};
var eu = {
	translations: translations$4
};

var translations$5 = {
	title: "Título",
	enunciated: "Enunciado",
	stimulus: "Enunciado da actividade",
	enunciated_placeholder: "Escribe unha descrición",
	multiple_choice_activity: "Selección múltiple",
	answer_options: "Opcións de resposta",
	add_new_response: "Engadir",
	add_new_question: "Engadir",
	new_question_stem: "Nova pregunta",
	validation: "Puntuación",
	option: "Opción",
	type_of_validation: "Introduce o tipo de validación:",
	exactMatch: "Exacta: é necesario contestar todas as opcións correctamente.",
	partialMatch: "Parcial: cada resposta correcta outorga a puntuación.",
	partialMatchV2: "Parcial por resposta: divídese a puntuación entre o número de respostas.",
	score: "Puntuación",
	high_score: "Máxima puntuación",
	enter_a_score: "Introduce unha puntuación",
	minimum_score: "Mínima puntuación por intentalo",
	cancel: "Cancelar",
	save: "Gardar",
	send: "Enviar",
	reset: "Restaurar",
	shuffle_options: "Mesturar respostas",
	multiple_responses: "Resposta múltiple",
	words_limit: "Límite de palabras",
	letters_limit: "Límite de letras",
	essay_placeholder: "Escribe a túa resposta.",
	right_answer: "Resposta correcta",
	write_right_answer: "Escribe a resposta correcta",
	copy: "Copiar",
	cut: "Cortar",
	paste: "Pegar",
	cloze_text: "Cloze text",
	activity_data_wrong: "Os datos están mal formados",
	this_is_the_stem: "Desenvolve a pregunta aquí",
	"true": "Verdadeiro",
	"false": "Falso",
	column: "Columna",
	columns: "Columnas",
	row: "Fila",
	world_map: "Mapa mundial",
	Greenland: "Grenlandia",
	Russia: "Rusia",
	United_States: "Estados Unidos",
	table_editor: "Editor de táboa",
	drags: "Arrastrables",
	add_new_column: "Engadir título columna",
	add_new_row: "Engadir título fila",
	duplicate_responses: "Respostas duplicadas",
	solutions: "Solucións",
	Solution: "Solución",
	column_count: "Número de columnas",
	row_count: "Número de filas",
	cloze_template: "Nun lugar da Mancha, de cuxo nome non me quero lembrar, no hai moito tempo vivía un {{response}} dos de lanza en estaleiro, adarga antiga, cabalo fraco e {{response}} corredor.",
	response: "Resposta",
	response_containers: "Contedores de respostas",
	global_size: "Escala global",
	width: "Ancho",
	height: "Alto",
	upload_file: "Subir arquivo",
	completed: "Completado",
	choose_file: "Elixir arquivo",
	change_file: "Cambiar arquivo",
	load_image_error_message: "Ocorreu un erro ao intentar subir a imaxe",
	sending_file: "Subindo arquivo",
	select_an_item: "Selecciona un elemento",
	pointer: "Punteiro",
	none: "Ningún",
	left: "Esquerda",
	right: "Dereita",
	top: "Arriba",
	bottom: "Abaixo",
	show_check_icon: "Mostrar icona",
	alternative_text: "Texto alternativo",
	isEvaluable: "Modo avaliación",
	autosize_response: "Lonxitude automática",
	text_normalization: "Normalización de textos",
	load_image: "Subir imaxe",
	image_size: "Tamaño de imaxe",
	text_sample: "Texto de exemplo",
	size: "Tamaño",
	accent_sensitive: "Sensible a acentos",
	case_sensitive: "Sensible a maiúsculas",
	spaces_sensitive: "Corrección de espazos",
	orientation: "Orientación",
	"delete": "Borrar",
	stack: "Amoreado",
	box: "Caixa",
	Feedback: "Feedback",
	"Remove Feedback": "Quitar feedback",
	Visibility: "Visibilidade",
	"Success Message": "Mensaxe de éxito",
	"Error Messages": "Mensaxes de erro",
	Sequence: "Secuencia",
	cyclic: "Cíclico",
	random: "Aleatorio",
	"Add new error": "Engadir novo erro",
	"Error message": "Mensaxe de erro",
	Configuration: "Axustes",
	"Shuffle Answers": "Orde aleatoria",
	"When turned on the questions will be sorted in differ order each time they are presented": "As opcións sairán de forma aleatoria en cada alumno ou alumna.",
	"Show check icon": "Mostrar icona de verificación",
	"When turned on the answers will have a radio button next to them": "Actívao para mostrar unha caixa de selección xunto ás opcións.",
	Columns: "Columnas",
	"Choose how many columns you want the answers to be displayed into": "Elixe en cantas columnas desexas mostrar as respostas",
	style_block_none: "Ningunha",
	style_block_BLOCK: "Bloque",
	style_block_NUMERICAL: "Numérico",
	style_block_LOWER_ALPHA: "Alfabeto en minúsculas",
	style_block_UPPER_ALPHA: "Alfabeto en mayúsculas",
	"1 columns": "1 columna",
	"2 columns": "2 columnas",
	"3 columns": "3 columnas",
	"4 columns": "4 columnas",
	"5 columns": "5 columnas",
	"6 columns": "6 columnas",
	SERVER_ERROR: "Se ha producido un error al subir el archivo. Inténtalo de nuevo.",
	MAX_FILES_REACHED: "Has alcanzado el límite de archivos permitidos.",
	INVALID_TYPE: "Tipo de archivo no válido",
	MAX_SIZE_EXCEEDED: "El archivo que deseas subir sobrepasa el tamaño máximo permitido. Por favor, reduce el tamaño y vuelve a intentarlo.",
	UNKNOWN_ERROR: "Ha ocurrido un problema al subir el archivo. Por favor, inténtalo de nuevo.",
	"You can set up the settings of each type of question here": "Puede configurar los ajustes de cada tipo de pregunta aquí.",
	"Different max / min file upload": "Subida de archivo con diferente máximo / mínimo",
	"Turn on if you want to allow uploading a range of files to the exercise": "Permite la subida de varios archivos en esta actividad.",
	"File size limit": "Límite de tamaño de archivo",
	"Max size each file can reach. This is a default value and cannot be editted": "Tamaño máximo que puede alcanzar cada archivo. Este es un valor predeterminado y no se puede editar",
	"Types of files allowed as attachments": "Tipo de archivos permitidos como adjuntos",
	"MS Word, Excel, Power Point, jpg, png, pdf, Open Office, txt, video and audio": "Word, Excel, Power Point, jpg, png, pdf, Open Office, txt, vídeo y audio",
	"default": "Por defecto",
	"Files limit": "Límite de archivos",
	"Min/Max number of files the student is allowed to upload": "Mínimo/máximo número de archivos que el alumno puede subir",
	"Size thumb": "Tamaño da miniatura",
	"Image size": "Tamaño de imaxe",
	"Background image": "Imaxe de fondo",
	"Canvas Background Image": "Imaxe de fondo do lenzo",
	"Allowed files: images (jpg, png, gif), audio (mp3, ogg), video (mp4, ogg, webm, mkv), documents (word, excel, power point, pdf, open office, txt)": " ",
	"Allowed files: images (jpg, png, gif)": "Formatos permitidos imaxes (jpg, png, gif)",
	Exercise: "Actividade",
	background_image_alt: "Texto alternativo",
	response_exact_or_equivalent_title: "El resultado es exacto o equivalente",
	response_exact_or_equivalent_subtitle: "Elige exacto si quieres evaluar como correctas solamente las respuestas exactas. Elige equivalente si quieres dar como correcta cualquier expresión equivalente",
	response_exact_or_equivalent_subtitle_option_equivliteral: "Exacto",
	response_exact_or_equivalent_subtitle_option_equivsymbolic: "Equivalente",
	response_decimals_title: "Decimais",
	response_decimals_subtitle: "Selecciona o número mínimo de decimais",
	response_response_value: "Valor da resposta",
	response_title: "Respuesta",
	response_decimal_option_0: "Sen decimais",
	response_decimal_option_1: "1 decimal",
	response_decimal_option_2: "2 decimais",
	response_decimal_option_3: "3 decimais",
	response_decimal_option_4: "4 decimais",
	response_decimal_option_5: "5 decimais",
	response_decimal_option_6: "6 decimais",
	stimulus_help: "Escribe o enunciado do exercicio aquí. Podes engadir texto, ecuacións, táboas e calquera material editable.",
	config_help: "Podes configurar os axustes de cada tipo de pregunta aquí.",
	answer_options_help: "Escribe as diferentes opcións que queiras mostrar ao estudante como posibles respostas e elixe a súa orde. Podes engadir máis respostas facendo clic no botón de Engadir.",
	editor_response_title_accordion: "Resposta",
	config_canvas_height_title: "Altura por defecto",
	config_canvas_height_subtitle: "Altura predeterminada do espazo de fondo",
	background_image_title: "Imaxe de fondo",
	background_image_subtitle: "Establece unha imaxe de fondo",
	response_result_button_delete: "Eliminar resposta",
	config_variant_style_title: "Variante de autor",
	config_variant_style_subtitle: "Selecciona a variante desexada",
	config_variant_style_input_placeholder: "Engadir nome de clase",
	style_variant_default: "Por defecto",
	style_variant_custom: "Personalizada",
	config_multiple_responses_title: "Resposta múltiple",
	config_multiple_responses_subtitle: "Actívao se hai máis dunha resposta válida",
	button_validation_title_box: "Botón",
	button_validation_title: "Engadir botón de validación",
	button_validation_subtitle: "Actívao para engadir un botón de confirmación ao alumnado",
	button_validation_alt: "Engade o teu texto aquí",
	button_validation_help: "Usa esta opción se necesitas que o alumnado marque esta actividade como completada tras finalizala",
	button_validation_default: "Feito",
	button_edit: "Editar",
	button_cancel: "Cancelar",
	button_confirm: "Confirmar",
	button_try_again: "** Intentar otra vez",
	button_cant_speak_now: "** No puedo hablar ahora",
	config_background_title: "Engadir imaxe de fondo",
	config_background_subtitle: "Actívao para subir unha imaxe para o fondo",
	config_background_help: "Podes subir unha imaxe de fondo.",
	exercise_example_text_title: "Escribe aquí o texto da pregunta",
	exercise_example_text_subtitle: "Texto antes de encher unha etiqueta",
	exercise_label_font_size_title: "Tamaño de fonte",
	exercise_label_font_size_subtitle: "Determina o tamaño de fonte na caixa",
	config_duplicate_responses_title: "Duplicar respostas",
	config_duplicate_responses_subtitle: "Actívao para duplicar as respostas",
	feedback_exercise_title: "Tratamento do erro",
	feedback_exercise_placeholder: "Engade aquí feedback xeral",
	feedback_exercise_help: "Lembra que isto ofrece ao alumnado un tratamento do erro xeral de toda a actividade. Podes usalo para facer algunha indicación ou recordatorio.",
	feedback_exercise_help_with_individual: "Podes axudar o alumnado ofrecendo un tratamento do erro xeral da actividade. Tamén podes introducir comentarios individuais en cada resposta que lle aparecerán ao alumnado se se equivoca.",
	config_is_math_title: "É matemáticas",
	config_is_math_subtitle: "Indica se é matemáticas",
	config_accent_sensitive_title: "Sensible aos acentos gráficos",
	config_accent_sensitive_subtitle: "Actívao se queres ter en conta os acentos gráficos nas correccións",
	config_case_sensitive_title: "Sensible ás maiúsculas",
	config_case_sensitive_subtitle: "Activar se desexas que a resposta distinga entre maiúsculas e minúsculas ao corrixir",
	config_fix_spaces_title: "Arranxa os espazos",
	config_fix_spaces_subtitle: "Desactívao se queres que o uso incorrecto de espazos non penalice, independentemente do lugar na palabra.",
	config_max_character_title: "Restrición de caracteres",
	config_max_character_subtitle: "Introduce o máximo de caracteres para restrinxir a extensión da resposta",
	config_max_character_input_title: "Establece o límite de caracteres",
	config_max_character_input_subtitle: "Especifica o número máximo de caracteres que o alumnado pode escribir",
	config_max_character_input_placeholder: "Máximo de caracteres",
	config_words_limit_title: "Contador de palabras",
	config_words_limit_subtitle: "Introduce un máximo de palabras",
	config_words_limit_input_title: "Establece o límite de palabras",
	config_words_limit_input_subtitle: "Especifica o máximo número de palabras que un estudante pode escribir",
	config_words_limit_input_placeholder: "Introducir número máximo de palabras",
	config_autosize_response_title: "Resposta con tamaño automático",
	config_autosize_response_subtitle: "Actívao se desexas que a lonxitude máxima do cadro de resposta teña a mesma lonxitude que a solución",
	"Drop your files here or": "Busca ou arrastra aquí os teus arquivos",
	browse: " ",
	"Max file size": "Tamaño máximo de arquivo",
	"MB · At least": "MB ·",
	"file required": "arquivo requirido",
	richText_placeholder: "Escribe a túa resposta aquí",
	"Questions options": "Opcións de pregunta",
	"Answer options": "Opcións de resposta",
	Answer: "Resposta",
	config_stack_title: "Amorear",
	config_stack_subtitle: "Os arrastrables iranse amoreando dentro das áreas cando o tamaño da pantalla o permita",
	config_with_box_title: "Opcións de enmarcar en caixas",
	config_with_box_subtitle: "Os arrastables marcaranse cunha liña ao seleccionalos",
	config_lines_color_title: "Cor das liñas",
	config_lines_color_subtitle: "Elixe unha cor de liña",
	line_thinckness_fine: "Fino",
	line_thinckness_medium: "Medio",
	line_thinckness_coarse: "Groso",
	config_line_thickness_title: "Grosor das liñas",
	config_line_thickness_subtitle: "Elixe un tamaño de liña",
	config_feedback_mode_click_to_find_title: "Modo de feedback",
	config_feedback_mode_click_to_find_subtitle: "Ningún, con bordo ou marca",
	feedback_mode_none: "Ningún",
	"feedback_mode_feedback-with-border": "Con bordo",
	"feedback_mode_feedback-with-tick": "Con marca",
	click_to_find_size_background_title: "Tamaño de imaxe de fondo",
	click_to_find_size_background_subtitle: "Tamaño de imaxe",
	click_to_find_solutions_tooltip_correct: "Marcar como correcto",
	click_to_find_solutions_tooltip_incorrect: "Marcar como incorrecto",
	config_column_direction_title: "Dirección da columna",
	config_column_direction_subtitle: "Vertical ou horizontal",
	column_direction_horizontal: "Horizontal",
	column_direction_vertical: "Vertical",
	linking_lines_limit_options_help: "Para unha correcta visualización, o número de opcións está limitado a 6",
	evaluation_mode_tooltip: "Desactívao se queres corrixir manualmente ou recoller información que non conte para nota.",
	individual_feedback_exercise_placeholder: "Escribe feedback individual nesta resposta",
	label_drop_item: "Resposta",
	individual_feedback_exercise_tooltip: "Engade feedback para esta resposta",
	change_image: "Cambiar imaxe",
	answer_options_help_multiple_choice: "Escribe as diferentes opcións que queiras mostrar ao estudante como posibles respostas e elixe a súa orde.",
	add_alternative: "Alternativa",
	solutions_instructions: "Define a resposta correcta ao exercicio e a súa puntuación. Asigna o 100% se a resposta é correcta. Tamén podes proporcionar unha resposta alternativa e asignar o % do total de puntos que merece.",
	image: "Imaxe",
	add_an_image_to_exercise: "Engade unha imaxe á actividade",
	button_show_hints: "Pista",
	button_validate: "Comprobar",
	button_restart: "Refacer",
	button_repeat: "Repetir",
	button_show_solution: "Ver solución",
	button_hide_solution: "Ver a miña resposta",
	button_restart_scaffold: "Reiniciar scaffolding",
	points: "Puntos",
	button_next_question: "Seguinte",
	button_i_dont_know: "Non o sei",
	title_help: "Este campo non vai ser visible para o alumnado. Servirá para facilitar buscas de exercicios por parte dun editor.",
	title_placeholder: "Escribe aquí o texto",
	hints_title_box: "Pista",
	hints_help: "As pistas son pequenas mensaxes que o alumnado pode pedir cando necesite axuda. Podes engadir  suxestións a esta actividade aquí.",
	hints_title: "Engadir pista",
	hints_subtitle: "Actívao para darlle ao alumnado unha pequena información ou consello",
	hint_placeholder: "Área con texto de pista",
	automatic_evaluation: "Avaliación automática",
	automatic_evaluation_description: "Desactívao para avaliar manualmente e permitir respostas abertas",
	title_title_box: "Nome interno",
	feedback_exercise_toogle_title: "Engadir feedback",
	feedback_exercise_toogle_subtitle: "Actívao para orientar cando o alumnado comete un erro",
	multiple_choice_multiple_stimulus_default: "Selecciona polo menos unha (ou máis) das seguintes opcións:",
	multiple_choice_single_stimulus_default: "Selecciona unha das seguintes opcións:",
	multiple_choice_truefalse_stimulus_default: "Le e contesta 'Verdadeiro' ou 'Falso':",
	multiple_choice_blockletter_stimulus_default: "Elixe unha das seguintes opcións:",
	choice_matrix_inline_stimulus_default: "Decide se as seguintes opcións son verdadeiras o falsas:",
	choice_matrix_standard_stimulus_default: "Decide se as seguintes opcións son verdadeiras ou falsas:",
	classify_classification_stimulus_default: "Arrastra e solta cada resposta no seu lugar:",
	classify_matchlist_stimulus_default: "Emparella cada resposta co seu concepto:",
	classify_orderlist_stimulus_default: "Arrastra e solta para ordenar as respostas:",
	classify_linkinglines_stimulus_default: "Une cada palabra co seu significado:",
	cloze_text_stimulus_default: "Escribe a palabra que falta nas caixas que se mostran a continuación:",
	cloze_dropdown_stimulus_default: "Selecciona a opción correcta de cada despregable:",
	cloze_drag_drop_stimulus_default: "Arrastra e solta as respostas dentro dos ocos.",
	essay_plaintext_stimulus_default: "Escribe unha redacción de 200 palabras sobre o teu lugar favorito.",
	essay_sorttext_stimulus_default: "Cal é o río máis longo de América do Sur?",
	essay_sorttext_solution1_default: "O río Amazonas",
	essay_richtext_stimulus_default: "Escribe unha redacción de 200 palabras sobre o teu lugar favorito.",
	labelimage_dragdrop_stimulus_default: "Arrastra e solta cada país no seu lugar:",
	labelimage_dropdown_stimulus_default: "Selecciona a opción correcta de cada despregable:",
	labelimage_imagewithtext_stimulus_default: "Escribe o nome de cada país:",
	math_clozemath_stimulus_default: "Calcula as seguintes operacións:",
	other_uploadfile_stimulus_default: "Fai unha foto aos teus deberes e sóltaa aquí:",
	other_pencil_stimulus_default: "Debuxa a túa mascota ou animal favorito e onde vive:",
	other_statement_stimulus_default: "Elixe un compañeiro ou compañeira e comenta por que ter un estilo de vida saudable é importante.",
	other_clicktofind_stimulus_default: "Fai clic en todos os limóns:",
	choice_matrix_questions_help: "Introduce os enunciados das preguntas nas caixas. Podes engadir máis preguntas facendo clic no botón engadir.",
	match_list_questions_help: "Introduce os enunciados das preguntas nas caixas. Podes engadir máis preguntas facendo clic no botón engadir.",
	linking_lines_questions_help: "Introduce os enunciados das preguntas nas caixas. Podes engadir máis preguntas facendo clic no botón engadir.",
	scaffold_separator_step: "Paso",
	scaffold_separator_of: "de",
	title_check_icon_single_choice: "Botón de opción",
	subtitle_check_icon_single_choice: "Desactívao para agochar o botón e usar o modo bloque no seu lugar",
	title_check_icon_multiple_choice: "Cela de opción",
	subtitle_check_icon_multiple_choice: "Desactívao para agochar a cela e usar o modo bloque no seu lugar",
	title_block_style: "Estilo de lista",
	subtitle_block_style: "Ningunha, numérica ou alfabética",
	Spain: "España",
	template_exercise_markup_add_blank: "Engadir oco",
	template_markup_add_blank: "Engadir oco",
	sending_button: "Enviando ...",
	table_editor_help: "Usa o editor de táboa para configurar o número de columnas e filas da táboa. As columnas poderán ser como mínimo unha e como máximo cinco.",
	cloze_exercise_help: "Escribe unha oración e utiliza as caixas en branco para que o alumnado identifique cales son as palabras clave que faltan no texto.",
	cloze_math_exercise_help: "Escribe o enunciado e utiliza as caixas en branco para que o alumnado identifique cales son os números ou fórmulas clave que faltan.",
	label_exercise_help: "Engade tantas caixas en branco como necesites e colócaas pola imaxe. Podes cambiar a imaxe de fondo, redimensionar as caixas e o tamaño da fonte.",
	cloze_dropdown_exercise_help: "Escribe unha oración e utiliza as caixas brancas para engadir opcións. O alumnado terá que seleccionar a opción correcta en cada oco que encontre no texto.",
	click_to_find_exercise_help: "Reempraza a imaxe de fondo, engade novas imaxes e colócaas polo lenzo. Poderás definir cal é correcta ou incorrecta na sección de Solución.",
	linking_lines_question_option: "Opción de pregunta",
	title_evaluation_type: "Tipo de avaliación",
	subtitle_evaluation_type_exact_match: "O alumnado deberá contestar o exercicio correctamente para recibir a puntuación",
	subtitle_evaluation_type_partial_match: "A puntuación xeral do exercicio dividirase entre as respostas, e cada unha delas puntuarase individualmente",
	subtitle_evaluation_type_manual: "A actividade non se avalía.",
	subtitle_evaluation_type_match_response: "A puntuación xeral do exercicio dividirase entre os elementos de arrastre, e cada unha deles puntuarase individualmente",
	subtitle_evaluation_type_match_group: "A puntuación xeral do exercicio dividirase entre os grupos, e cada unha deles se puntuará individualmente",
	evaluation_type_exact_match: "Corrección exacta",
	evaluation_type_partial_match: "Corrección parcial",
	evaluation_type_manual: "Corrección manual",
	evaluation_type_match_response: "Parcial por resposta",
	evaluation_type_match_group: "Parcial por grupo",
	manual_or_alternative_solutions_help: "Define a resposta correcta ao exercicio que terá asignado o 100%. Tamén podes crear solucións alternativas e asignar o % que merezan. En caso de que queiras que o exercicio non sexa autoavaliativo, selecciona corrección manual.",
	exact_math_or_partial_match_or_manual_solutions_help: "Con corrección exacta o alumnado deberá contestar o exercicio correctamente para recibir a puntuación. Tamén podes crear solucións alternativas e asignar o % que merezan. Coa corrección parcial, o total de puntos dividirase entre cada resposta, e cada unha delas avaliarase individualmente. Se queres que o exercicio non sexa autoavaliativo, selecciona corrección manual.",
	exact_math_or_match_response_or_match_group_or_manual_solutions_help: "Con corrección exacta o alumnado deberá contestar o exercicio correctamente para recibir a puntuación. Tamén podes crear solucións alternativas e asignar o % que merezan. Coa corrección parcial, o total de puntos dividirase entre cada resposta, e cada unha delas avaliarase individualmente. Se queres que o exercicio non sexa autoavaliativo, selecciona corrección manual.",
	solutions_penalty_title: "Personalizado",
	solutions_penalty_subtitle: "Selecciona manualmente un % de penalización por resposta",
	feedback_exercise_toogle_individual_feedback_title: "Engade tratamento de erro a cada resposta",
	feedback_exercise_toogle_individual_feedback_subtitle: "A mensaxe apareceralle ao alumno cando responda incorrectamente",
	"Answer Option": "Opción de resposta",
	"Text Prompt": "Pregunta",
	config_fixed_keyboard_title: "Teclado flotante",
	config_fixed_keyboard_subtitle: "Actívao para mostrar ao alumnado un teclado flotante cando selecciona unha cela",
	config_number_keyboards_title: "Teclado numérico",
	config_number_keyboards_subtitle: "Selecciona o tipo de teclado que lle aparecerá ao alumnado",
	keyboard_type_NONE: "Ningún",
	keyboard_type_NUMERICAL: "Numérico",
	keyboard_type_BASIC: "Básico",
	keyboard_type_INTERMEDIATE: "Intermedio",
	keyboard_type_COMPLEX: "Avanzado",
	keyboard_type_SCIENTIFIC: "Científico",
	solutions_new_alternative_text: "Nova",
	no_microphone: "Non teño micrófono",
	confirm_replace_audio_message: "Xa existe un audio gravado. Preme en 'Confirmar' se queres reemprazalo por un novo.",
	config_audio_duration_limit_title: "Límite de tempo",
	config_audio_duration_limit_subtitle: "Selecciona os segundos que o alumnado terá para gravarse",
	other_audio_recorder_stimulus_default: "Grávate explicando o proceso da fotosíntese.",
	no_mic_available: "Non se atopou o micrófono no dispositivo.",
	no_mic_permission: "Micrófono bloqueado. Asegúrate que o acceso está permitido.",
	confirm_switching_keyboards_title: "Atención",
	confirm_switching_keyboards_message: "As solucións editadas borraranse ao cambiar de teclado.",
	math_counting_stimulus_default: "Cantas manzás e limóns necesito para ter seis froitas?",
	other_clock_stimulus_default: "Son as 15:30",
	sample_answer_title_box: "Resposta modelo",
	sample_answer_help: "Podes crear unha resposta modelo que che axude a corrixir as actividades non autoavaliativas. Esta sección só será visible para o profesorado.",
	sample_answer_title: "Engadir resposta modelo",
	sample_answer_subtitle: "Exemplo dunha solución modelo para o profesorado.",
	sample_answer_placeholder: "Escribe aquí o texto",
	other_word_search_stimulus_default: "Atopa as seguintes palabras:",
	word_search_grid_s: "S (6x6)",
	word_search_grid_m: "M (10x10)",
	word_search_grid_l: "L (15x15)",
	word_search_title_box: "Barullo de letras",
	word_search_help: "Selecciona o tamaño da cuadrícula",
	word_search_title: "Cuadrícula",
	word_search_subtitle: "Selecciona o número de filas/columnas",
	config_word_search_random_title: "Posición aleatoria das palabras",
	config_word_search_random_subtitle: "As palabras mostraranse nunha posición distinta cada vez que se acceda.",
	config_word_search_backward_title: "Palabras invertidas",
	config_word_search_backward_subtitle: "Pode haber palabras escritas de dereita a esquerda",
	config_word_search_diagonal_title: "Palabras en diagonal",
	config_word_search_diagonal_subtitle: "Pode haber palabras escritas en diagonal",
	word_search_counter_letter: "Límite de letras",
	config_word_search_allowed_letters_title: "Letras permitidas",
	config_word_search_allowed_letters_subtitle: "Activa para indicar as letras permitidas",
	confirm_switching_columns_rows_title: "Atención!",
	confirm_switching_columns_rows_message: "Eliminaranse as seguintes palabras:",
	confirm_edit_allowed_letter_title: "Atención!",
	confirm_edit_allowed_letter_message: "As palabras que conteñan caracteres distintos aos indicados eliminaranse.",
	word_search_preview_title_box: "Previsualización do barullo de letras",
	word_search_preview_help: "Así se verán as solucións no barullo de letras",
	word_search_button_generate: "Xerar nova",
	word_search_solutions_help: "Indica palabras con polo menos 2 letras. Non se poden utilizar números, espazos ou caracteres especiais.",
	other_crossword_stimulus_default: "Encrucillado",
	crossword_solutions_help: "Indica palabras con polo menos dúas letras. Non se pode utilizar números, espazos ou caracteres especiais",
	crossword_counter_letter: "Límite de letras",
	crossword_word_out: "Non existe coincidencia entre palabras. Intenta engadindo máis palabras",
	config_uppercase_lowercase_title: "Selecciona maiúsculas / minúsculas",
	config_uppercase_lowercase_subtitle: "As palabras mostraranse en maiúsculas ou en minúsculas",
	config_uppercase: "Maiúsculas",
	config_lowercase: "Minúsculas",
	crossword_message_min_words: "Necesita mínimo {{num_words}} palabras",
	crossword_solutions_text_not_valid: "Palabra non válida. Mínimo 2 letras",
	crossword_preview_title_box: "Previsualización do encrucillado",
	crossword_preview_help: "Así se verán as solucións do encrucillado",
	crossword_button_generate: "Xerar novo",
	generation_error: "Non se puido xerar o encrucillado",
	upload_file_button_drive: "Subir con Google Drive",
	file_uploader_drive: "Vía Google Drive",
	file_uploaded_successfully: "Arquivo enviado correctamente",
	files_uploaded_successfully: "Arquivos enviados correctamente",
	title_penalty_modes: "Puntos de penalización",
	subtitle_penalty_mode_none: "Penaliza as respostas erradas polo mesmo valor das respostas acertadas. Tamén podes crear a penalización a medida",
	subtitle_penalty_mode_per_response: "Penaliza as respostas erradas polo mesmo valor das respostas acertadas. Tamén podes crear a penalización a medida",
	subtitle_penalty_mode_custom: "Penaliza as respostas erradas polo mesmo valor das respostas acertadas. Tamén podes crear a penalización a medida",
	penalty_mode_none: "Ningún",
	penalty_mode_per_response: "Puntuación de resposta acertada",
	penalty_mode_custom: "Personalizado",
	config_show_selection_title: "Mostrar selección",
	config_show_selection_subtitle: "O estudante verá sinalado o obxecto seleccionado",
	alternative_response: "Resposta alternativa",
	alternative_responses: "Respostas alternativas",
	config_autosize_box_title: "Caixa con tamaño de resposta",
	config_autosize_box_subtitle: "Actívao se desexas que o tamaño da caixa se adapte ao tamaño da resposta",
	Transcription: "Transcripción",
	other_rating_stimulus_default: "É hora de valorar o contido!",
	other_rating_tooltip_1_star: "1 estrela",
	other_rating_tooltip_multiple_stars: "{{count}} estrelas",
	other_rating_description_1_star: "Non me gustou. Confundiuse e aburriume.",
	other_rating_description_2_stars: "Gustoume máis ou menos... Algunhas cousas entendinas mellor que outras.",
	other_rating_description_3_stars: "Gustoume bastante. Entendino e interesoume :)",
	other_rating_description_4_stars: "Encantoume! Pareceume interesante e divertido. Quero máis!",
	adaptative_choice_levels_config: "Configuración de Niveis",
	adaptative_choice_levels_config_help: "Configura os títulos de cada nivel da actividade adaptativa",
	adaptative_choice_level_title: "Nivel {{level_number}}",
	adaptative_choice_level_title_label: "Título do nivel:",
	adaptative_choice_level_title_placeholder: "Escribe o título deste nivel...",
	other_adaptative_choice_back: "Atrás",
	other_adaptative_choice_next: "Seguinte"
};
var gl = {
	translations: translations$5
};

var translations$6 = {
	title: "Título",
	enunciated: "Título",
	stimulus: "Desenvolvimento",
	enunciated_placeholder: "Escreva uma descrição",
	multiple_choice_activity: "Múltipla escolha",
	answer_options: "Opções de resposta",
	add_new_response: "Adicionar",
	add_new_question: "Adicione outra pergunta",
	new_question_stem: "Nova pergunta",
	validation: "Pontuação",
	option: "Opção",
	type_of_validation: "Digite o tipo de validação:",
	exactMatch: "Exato: com tudo correto, você obtém a pontuação.",
	partialMatch: "Parcial: cada resposta correta fornece a pontuação.",
	partialMatchV2: "Parcial por resposta: a pontuação é dividida pelo número de respostas.",
	score: "Pontuação",
	high_score: "Pontuação máxima",
	enter_a_score: "Insira uma pontuação.",
	minimum_score: "Pontuação mínima para tentar",
	cancel: "Cancelar",
	save: "Salvar",
	send: "Enviar",
	reset: "Restaurar",
	undo: "Desfazer",
	redo: "Refazer",
	shuffle_options: "Misture as respostas",
	multiple_responses: "Resposta múltipla",
	words_limit: "Limite de palavras",
	letters_limit: "Limite de letras",
	essay_placeholder: "Escreva sua resposta.",
	right_answer: "Resposta correta",
	write_right_answer: "Escreva a resposta correta.",
	copy: "Copiar",
	cut: "Cortar",
	paste: "Colar",
	cloze_text: "Cloze text",
	activity_data_wrong: "Os dados estão mal formados.",
	this_is_the_stem: "Desenvolva a pergunta.",
	"true": "Verdadeiro",
	"false": "Falso",
	column: "Coluna",
	columns: "Colunas",
	row: "Linha",
	world_map: "Mapa do mundo",
	Greenland: "Gronelândia",
	Russia: "Rússia",
	United_States: "Estados Unidos",
	table_editor: "Editor de tabelas",
	drags: "Item arrastável",
	add_new_column: "Adicionar o título da coluna",
	add_new_row: "Adicionar o título da linha",
	duplicate_responses: "Duplicar respostas",
	solutions: "Soluções",
	Solution: "Solução",
	column_count: "Número de colunas",
	row_count: "Número de linhas",
	cloze_template: "A respiração aeróbica pode ser dividida em três fases, denominadas {{response}}, ciclo de Krebs e cadeia respiratória. Quanto aos locais da célula onde esas fases ocorrem, pode-se afirmar que {{response}}.",
	response: "Resposta",
	response_containers: "Contêineres de resposta",
	global_size: "Tamanho global",
	width: "Largura",
	height: "Altura",
	upload_file: "Fazer upload de arquivo",
	upload_files: "Enviar arquivos",
	completed: "Completado",
	choose_file: "Escolha o arquivo.",
	change_file: "Mudar arquivo",
	load_image_error_message: "Ocorreu um erro ao tentar fazer upload da imagem.",
	sending_file: "Fazendo upload do arquivo.",
	select_an_item: "Selecione um item.",
	pointer: "Ponteiro",
	none: "Nenhum",
	left: "Esquerda",
	right: "Direita",
	top: "Topo",
	bottom: "Fundo",
	show_check_icon: "Mostrar ícone",
	alternative_text: "Texto alternativo",
	isEvaluable: "Modo de avaliação",
	autosize_response: "Comprimento automático",
	text_normalization: "Normalização de texto",
	load_image: "Enviar imagem",
	image_size: "Tamanho da imagem",
	text_sample: "Amostra de texto",
	size: "Tamanho",
	accent_sensitive: "Sensível à acentuação",
	case_sensitive: "Maiúsculas e minúsculas",
	spaces_sensitive: "Consertar espaços",
	orientation: "Orientação",
	"delete": "Excluir",
	stack: "Pilha",
	box: "Caixa",
	Feedback: "Tratamento de erro",
	"Remove feedback": "Remover Feedback",
	Visibility: "Visibilidade",
	"Success Message": "Mensagem de sucesso",
	"Error Messages": "Mensagem de erro",
	Sequence: "Sequência",
	cyclic: "Cíclico",
	random: "Aleatório",
	"Add new error": "Adicionar novo erro",
	"Error message": "Mensagem de erro",
	Configuration: "Configuração",
	"Shuffle Answers": "Ordem aleatória",
	"When turned on the questions will be sorted in differ order each time they are presented": "Ative-o para que as opções sejam desordenadas para cada aluno.",
	"Show check icon": "Mostrar ícone de verificação",
	"When turned on the answers will have a radio button next to them": "Ative-o para mostrar um botão de opção ao lado das respostas.",
	Columns: "Colunas",
	"Choose how many columns you want the answers to be displayed into": "Escolha o número de colunas em que você deseja exibir as respostas.",
	style_block_none: "Nenhum",
	style_block_BLOCK: "Bloco",
	style_block_NUMERICAL: "Numérico",
	style_block_UPPER_ALPHA: "Alfabeto em maiúsculas",
	style_block_LOWER_ALPHA: "Alfabeto em minúsculas",
	"1 columns": "1 coluna",
	"2 columns": "2 colunas",
	"3 columns": "3 colunas",
	"4 columns": "4 colunas",
	"5 columns": "5 colunas",
	"6 columns": "6 colunas",
	SERVER_ERROR: "Desculpe, houve um problema ao fazer o upload do arquivo. Por favor, tente de novo.",
	MAX_FILES_REACHED: "Alcançou o número máximo de arquivos permitido.",
	INVALID_TYPE: "Tipo de arquivo inválido",
	MAX_SIZE_EXCEEDED: "O arquivo que está tentando fazer upload excede o tamanho máximo permitido. Por favor, reduza o tamanho do arquivo e tente de novo.",
	UNKNOWN_ERROR: "Desculpe, houve um problema ao fazer o upload do arquivo. Por favor, tente de novo.",
	"You can set up the settings of each type of question here": "Pode definir aqui as configurações para cada tipo de pergunta.",
	"Different max / min file upload": "Upload de arquivos com diferentes máximos e mínimos.",
	"Turn on if you want to allow uploading a range of files to the exercise": "Ativar se quiser permitir múltiplos uploads de arquivos para esta atividade.",
	"File size limit": "Limite de tamanho do arquivo",
	"Max size each file can reach. This is a default value and cannot be editted": "Tamanho máximo que cada arquivo pode alcançar. Este é um valor padrão e não pode ser editado.",
	"Types of files allowed as attachments": "Tipo de arquivos permitidos como anexos",
	"MS Word, Excel, Power Point, jpg, png, pdf, Open Office, txt, video and audio": "MS Word, Excel, Power Point, jpg, png, pdf, Open Office, txt, vídeo e áudio",
	"default": "Padrão",
	"Files limit": "Limite de arquivos",
	"Min/Max number of files the student is allowed to upload": "Número mínimo e máximo de arquivos que o aluno pode fazer upload.",
	"Size thumb": "Tamanho da miniatura",
	"Image size": "Tamanho da imagem",
	"Background image": "Imagem de fundo",
	"Canvas Background Image": "Imagem de fundo da tela",
	"Allowed files: images (jpg, png, gif), audio (mp3, ogg), video (mp4, ogg, webm, mkv), documents (word, excel, power point, pdf, open office, txt)": "Arquivos permitidos: imagens (jpg, png, gif), áudio (mp3, ogg), vídeo (mp4, ogg, webm, mkv), documentos (word, excel, power point, pdf, open office, txt)",
	"Allowed files: images (jpg, png, gif)": "Formatos permitidos: imagens (jpg, png, gif).",
	Exercise: "Atividade",
	background_image_alt: "Texto alternativo",
	response_exact_or_equivalent_title: "O resultado é exato ou equivalente",
	response_exact_or_equivalent_subtitle: "Escolha exato se você quiser avaliar apenas as respostas exatas como corretas. Escolha equivalente se você quiser dar qualquer expressão equivalente como correta.",
	response_exact_or_equivalent_subtitle_option_equivliteral: "Exato",
	response_exact_or_equivalent_subtitle_option_equivsymbolic: "Equivalente",
	response_decimals_title: "Decimais",
	response_decimals_subtitle: "Selecione o número de decimais.",
	response_response_value: "Valor da resposta",
	response_title: "Resposta",
	response_decimal_option_0: "Sem decimais",
	response_decimal_option_1: "1 decimal",
	response_decimal_option_2: "2 decimais",
	response_decimal_option_3: "3 decimais",
	response_decimal_option_4: "4 decimais",
	response_decimal_option_5: "5 decimais",
	response_decimal_option_6: "6 decimais",
	stimulus_help: "Escreva aqui o enunciado da atividade. Pode adicionar texto, equações, tabelas e qualquer material editável.",
	config_help: "Pode definir aqui as configurações para cada tipo de pergunta.",
	answer_options_help: "Escreva as diferentes opções que deseja mostrar aos alunos como possíveis respostas e escolha sua ordem. Você pode adicionar mais respostas clicando no botão Adicionar.",
	editor_response_title_accordion: "Resposta",
	config_canvas_height_title: "Altura padrão",
	config_canvas_height_subtitle: "Altura padrão do espaço de fundo.",
	background_image_title: "Imagem de fundo",
	background_image_subtitle: "Estabelece uma imagem de fundo.",
	response_result_button_delete: "Remover resposta",
	config_variant_style_title: "Variante do autor",
	config_variant_style_subtitle: "Selecione a variante desejada.",
	config_variant_style_input_placeholder: "Adicionar nome da turma",
	style_variant_default: "Padrão",
	style_variant_custom: "Customizada",
	config_multiple_responses_title: "Resposta múltipla",
	config_multiple_responses_subtitle: "Ative-o se houver mais de uma resposta correta.",
	button_validation_title_box: "Botão",
	button_validation_title: "Adicionar botão de validação",
	button_validation_subtitle: "Ative-o para adicionar um botão de confirmação ao aluno e mude o nome, se necessário.",
	button_validation_alt: "Adicione seu texto aqui.",
	button_validation_help: "Use este botão se precisar que os alunos marquem esta atividade como concluída após terminá-la.",
	button_validation_default: "Completada",
	button_edit: "Editar",
	button_cancel: "Cancelar",
	button_confirm: "Confirmar",
	button_try_again: "** Tente novamente",
	button_cant_speak_now: "** Não posso falar agora",
	config_background_title: "Adicionar imagem de fundo",
	config_background_subtitle: "Ative-o para fazer o upload de uma imagem para o fundo.",
	config_background_help: "Adicione uma imagem de fundo à atividade aqui.",
	exercise_example_text_title: "Escreva aqui o texto da pergunta.",
	exercise_example_text_subtitle: "Texto antes de preencher uma etiqueta.",
	exercise_label_font_size_title: "Tamanho de fonte",
	exercise_label_font_size_subtitle: "Determina o tamanho de fonte na caixa.",
	config_duplicate_responses_title: "Duplicar respostas",
	config_duplicate_responses_subtitle: "Ative-o para duplicar as respostas.",
	feedback_exercise_title: "Tratamento de erros",
	feedback_exercise_placeholder: "Adicione aqui o tratamento de erro geral.",
	feedback_exercise_help: "Lembre-se que isto dá ao aluno um tratamento de erro geral de toda a atividade. Pode usá-lo para dar-lhes alguns conselhos ou lembrá-los da lição.",
	feedback_exercise_help_with_individual: "Pode ajudar os alunos fornecendo um tratamento do erro geral na atividade. Também pode introduzir comentários individuais sobre cada resposta que aparecerão para o aluno se ele cometer um erro.",
	config_is_math_title: "É matemática",
	config_is_math_subtitle: "Indique se é matemática.",
	config_accent_sensitive_title: "Sensível à acentuação",
	config_accent_sensitive_subtitle: "Ative-o se quiser levar em conta os acentos (por exemplo, 'maçã' não significa o mesmo que 'maça').",
	config_case_sensitive_title: "Sensível a letras maiúsculas",
	config_case_sensitive_subtitle: "Ativar se quiser que a resposta seja sensível a maiúsculas e minúsculas ao fazer a revisão.",
	config_fix_spaces_title: "Arrumar os espaços",
	config_fix_spaces_subtitle: "Desative-o se quiser que o uso incorreto dos espaços não seja penalizado, independentemente do lugar na palavra (por exemplo, 'senão' ou 'se não').",
	config_max_character_title: "Restrição de caracteres",
	config_max_character_subtitle: "Digite o número máximo de caracteres para restringir o comprimento da resposta.",
	config_max_character_input_title: "Estabelece o limite de caracteres",
	config_max_character_input_subtitle: "Especifique o número máximo de caracteres que o aluno pode digitar.",
	config_max_character_input_placeholder: "Número máximo de caracteres",
	config_words_limit_title: "Contador de palavras",
	config_words_limit_subtitle: "Digite um número máximo de palavras.",
	config_words_limit_input_title: "Estabelece o limite da palavras",
	config_words_limit_input_subtitle: "Especifique o número máximo de palavras que o aluno pode digitar.",
	config_words_limit_input_placeholder: "Digitar um número máximo de palavras",
	config_autosize_response_title: "Resposta com tamanho automático",
	config_autosize_response_subtitle: "Ative-o se quiser que o comprimento máximo da caixa de resposta tenha o mesmo comprimento que a solução.",
	"Drop your files here or": "Procure ou arraste seus arquivos aqui.",
	browse: "Inspecionar",
	"Max file size": "Tamanho máximo de arquivo",
	"MB · At least": "MB · Pelo menos",
	"file required": "arquivo necessário",
	richText_placeholder: "Escreva aqui sua resposta.",
	"Questions options": "Opções de pergunta",
	"Answer options": "Opções de resposta",
	Answer: "Resposta",
	config_stack_title: "Empilhar",
	config_stack_subtitle: "Os itens arrastáveis serão empilhados dentro das áreas conforme o tamanho da tela permitir.",
	config_with_box_title: "Opções de enquadramento de caixas",
	config_with_box_subtitle: "Os itens arrastáveis serão marcados com uma linha quando selecionados.",
	config_lines_color_title: "Cor das linhas",
	config_lines_color_subtitle: "Escolha uma cor de linha.",
	line_thinckness_fine: "Fina",
	line_thinckness_medium: "Média",
	line_thinckness_coarse: "Grossa",
	config_line_thickness_title: "Espessura de linhas",
	config_line_thickness_subtitle: "Escolha um tamanho de linha.",
	config_feedback_mode_click_to_find_title: "Modo de tratamento de erro",
	config_feedback_mode_click_to_find_subtitle: "Nenhum, com borda ou marca",
	feedback_mode_none: "Nenhum",
	"feedback_mode_feedback-with-border": "Com borda",
	"feedback_mode_feedback-with-tick": "Com marca",
	click_to_find_size_background_title: "Tamanho da imagem de fundo",
	click_to_find_size_background_subtitle: "Tamanho da imagem",
	click_to_find_solutions_tooltip_correct: "Marcar como correto",
	click_to_find_solutions_tooltip_incorrect: "Marcar como incorreto",
	config_column_direction_title: "Sentido da coluna",
	config_column_direction_subtitle: "Vertical ou horizontal",
	column_direction_horizontal: "Horizontal",
	column_direction_vertical: "Vertical",
	linking_lines_limit_options_help: "Para uma visualização correta, o número de opções é limitado a 6.",
	evaluation_mode_tooltip: "Desative-o se quiser revisar manualmente ou coletar informação que não conte para a nota.",
	individual_feedback_exercise_placeholder: "Escreva um tratamento de erro individual nesta resposta.",
	label_drop_item: "Resposta",
	individual_feedback_exercise_tooltip: "Adicione tratamento de erro para esta resposta.",
	change_image: "Alterar imagem",
	answer_options_help_multiple_choice: "Escreva as diferentes opções que deseja mostrar ao aluno como respostas possíveis e escolha sua ordem. Também pode fornecer tratamento de erro individual sobre cada resposta para ajudar o aluno quando errar.",
	add_alternative: "Alternativa",
	solutions_instructions: "Defina a solução para essa atividade que contará para 100% dos pontos. Além disso, pode criar soluções alternativas e atribuir a % correspondente.",
	image: "Imagem",
	add_an_image_to_exercise: "Adicione uma imagem à atividade",
	button_show_hints: "Dica",
	button_validate: "Verificar",
	button_restart: "Refazer",
	button_repeat: "Repetir",
	button_show_solution: "Ver solução",
	button_hide_solution: "Ver minha resposta",
	button_restart_scaffold: "Reiniciar scaffolding",
	points: "Pontos",
	button_next_question: "Seguinte",
	button_i_dont_know: "Ajuda passo a passo",
	title_help: "Este campo não será visível para o aluno. Será usado para facilitar a busca de atividades por parte de um editor.",
	title_placeholder: "Escreva o texto aqui.",
	hints_title_box: "Dica",
	hints_help: "As dicas são mensagens curtas que o aluno pode pedir quando precisa de ajuda. Você pode adicionar dicas a este exercício aqui.",
	hints_title: "Adicionar dica",
	hints_subtitle: "Ative-o para dar ao aluno informação ou conselho.",
	hint_placeholder: "Área com texto de dica",
	automatic_evaluation: "Avaliação automática",
	automatic_evaluation_description: "Desative-o para avaliar manualmente e permitir respostas abertas.",
	title_title_box: "Nome interno",
	feedback_exercise_toogle_title: "Adicionar tratamento de erro",
	feedback_exercise_toogle_subtitle: "Ative-o para aconselhar quando o aluno comete um erro.",
	multiple_choice_multiple_stimulus_default: "Selecione pelo menos uma (ou mais) das seguintes opções:",
	multiple_choice_single_stimulus_default: "Selecione uma das seguintes opções:",
	multiple_choice_truefalse_stimulus_default: "Leia e responda verdadeiro ou falso:",
	multiple_choice_blockletter_stimulus_default: "Selecione uma das seguintes opções:",
	choice_matrix_inline_stimulus_default: "Decida se as seguintes opções são verdadeiras ou falsas:",
	choice_matrix_standard_stimulus_default: "Decida se as seguintes opções são verdadeiras ou falsas:",
	classify_classification_stimulus_default: "Arraste e solte cada resposta no lugar:",
	classify_matchlist_stimulus_default: "Ligue cada resposta com seu conceito:",
	classify_orderlist_stimulus_default: "Arraste e solte para ordenar as respostas:",
	classify_linkinglines_stimulus_default: "Ligue cada palavra com seu significado:",
	cloze_text_stimulus_default: "Escreva a palavra que falta nas caixas a seguir:",
	cloze_dropdown_stimulus_default: "Selecione a opção correta de cada menu suspenso:",
	cloze_drag_drop_stimulus_default: "Arraste e solte as respostas nos espaços.",
	essay_plaintext_stimulus_default: "Escreva um ensaio de 200 palavras sobre seu lugar preferido.",
	essay_sorttext_stimulus_default: "Qual é o rio mais longo da América do Sul?",
	essay_sorttext_solution1_default: "O rio Amazonas.",
	essay_richtext_stimulus_default: "Escreva um ensaio de 200 palavras sobre seu lugar preferido.",
	labelimage_dragdrop_stimulus_default: "Arraste e solte cada país no lugar correto:",
	labelimage_dropdown_stimulus_default: "Selecione a opção correta de cada menu suspenso:",
	labelimage_imagewithtext_stimulus_default: "Escreva o nome de cada país:",
	math_clozemath_stimulus_default: "Calcule as seguintes operações:",
	other_uploadfile_stimulus_default: "Tire uma foto de sua lição de casa e coloque-a aqui:",
	other_pencil_stimulus_default: "Desenhe seu animal de estimação ou animal preferido e onde vive:",
	other_statement_stimulus_default: "Escolha um companheiro e discuta por que ter um estilo de vida saudável é importante.",
	other_clicktofind_stimulus_default: "Clique em todos os limões:",
	choice_matrix_questions_help: "Digite os enunciados de perguntas nas caixas. Pode adicionar mais perguntas clicando no botão Adicionar.",
	match_list_questions_help: "Digite os enunciados de perguntas nas caixas. Pode adicionar mais perguntas clicando no botão Adicionar.",
	linking_lines_questions_help: "Digite os enunciados de perguntas nas caixas. Pode adicionar mais perguntas clicando no botão Adicionar.",
	scaffold_separator_step: "Passo",
	scaffold_separator_of: "de",
	title_check_icon_single_choice: "Botão de opção",
	subtitle_check_icon_single_choice: "Desative-o para ocultar o botão e usar o modo bloco.",
	title_check_icon_multiple_choice: "Caixa de opção",
	subtitle_check_icon_multiple_choice: "Desative-o para ocultar a caixa e usar o modo bloco.",
	title_block_style: "Estilo de lista",
	subtitle_block_style: "Nenhuma, numérica ou alfabética",
	Spain: "Espanha",
	template_exercise_markup_add_blank: "Adicionar espaço",
	template_markup_add_blank: "Adicionar espaço",
	sending_button: "Enviando...",
	table_editor_help: "Use o editor de tabela para definir o número de colunas e linhas na tabela. As colunas podem ter um mínimo de uma e um máximo de cinco.",
	cloze_exercise_help: "Escreva uma oração e use as caixas em branco para ajudar o aluno a identificar quais palavras-chave estão faltando no texto.",
	cloze_math_exercise_help: "Escreva o enunciado e use as caixas em branco para ajudar o aluno a identificar quais números ou fórmulas-chave estão faltando.",
	label_exercise_help: "Adicione tantas caixas em branco quantas forem necessárias e coloque-as em torno da imagem. Pode mudar a imagem de fundo, redimensionar as caixas e o tamanho da fonte.",
	cloze_dropdown_exercise_help: "Escreva uma oração e use as caixas brancas para adicionar opções. O aluno tem que selecionar a opção correta em cada espaço no texto.",
	click_to_find_exercise_help: "Substitua a imagem de fundo, adicione novas imagens e coloque-as em toda a tela. Pode definir qual é correta ou incorreta na seção Solução.",
	linking_lines_question_option: "Opção de pergunta",
	title_evaluation_type: "Tipo de avaliação",
	subtitle_evaluation_type_exact_match: "O aluno deve responder corretamente à atividade para receber a pontuação",
	subtitle_evaluation_type_partial_match: "A pontuação geral da atividade será dividida entre as respostas, e cada uma será pontuada individualmente",
	subtitle_evaluation_type_manual: "A atividade não é avaliada. Útil para a prática ou se for necessária a revisão do professor",
	subtitle_evaluation_type_match_response: "A pontuação geral da atividade será dividida entre os itens arrastáveis, e cada um será pontuado individualmente",
	subtitle_evaluation_type_match_group: "A pontuação geral da atividade será dividida entre os grupos, e cada um será pontuado individualmente",
	evaluation_type_exact_match: " Correção exata",
	evaluation_type_partial_match: "Correção parcial",
	evaluation_type_manual: "Correção manual",
	evaluation_type_match_response: "Parcial por resposta",
	evaluation_type_match_group: "Parcial por grupo",
	manual_or_alternative_solutions_help: "Define a resposta correta para a atividade que será atribuída 100% da pontuação. Também pode fornecer soluções alternativas e atribuir-lhes uma porcentagem apropriada. Caso não deseje uma atividade de autoavaliação, selecione a correção manual.",
	exact_math_or_partial_match_or_manual_solutions_help: "A correção exata implica que o aluno deve responder corretamente à atividade para receber uma pontuação. Você pode fornecer soluções alternativas e atribuir-lhes uma porcentagem apropriada. Enquanto que com a correção parcial os pontos totais serão divididos entre cada resposta, e cada resposta será avaliada individualmente. Caso não deseje uma atividade de autoavaliação, selecione a correção manual.",
	exact_math_or_match_response_or_match_group_or_manual_solutions_help: " A correção exata implica que o aluno deve responder corretamente à atividade para receber uma pontuação. Você pode fornecer soluções alternativas e atribuir-lhes uma porcentagem apropriada. Com a correção parcial por resposta os pontos totais serão divididos entre cada resposta, e cada uma delas será avaliada individualmente. Enquanto que com a correção parcial por grupo os pontos totais serão divididos entre cada item ou célula. Caso não deseje uma atividade de autoavaliação, selecione a correção manual.",
	solutions_penalty_title: "Penalização para respostas erradas",
	solutions_penalty_subtitle: "Selecione um valor para penalizar respostas incorretas e assim dissuadir tentativas aleatórias.",
	feedback_exercise_toogle_individual_feedback_title: "Adicione a cada resposta um tratamento de erro",
	feedback_exercise_toogle_individual_feedback_subtitle: "A mensagem aparecerá ao aluno quando ele responder de forma errada.",
	"Answer Option": "Opção de resposta",
	"Text Prompt": "Enunciado",
	config_fixed_keyboard_title: "Teclado flutuante",
	config_fixed_keyboard_subtitle: "Ative-o para mostrar ao aluno um teclado flutuante quando ele clicar em uma caixa",
	config_number_keyboards_title: "Teclados numéricos",
	config_number_keyboards_subtitle: "Selecione o estilo da atividade",
	keyboard_type_NONE: "Nenhum",
	keyboard_type_NUMERICAL: "Números",
	keyboard_type_BASIC: "Básico",
	keyboard_type_INTERMEDIATE: "Intermediário",
	keyboard_type_COMPLEX: "Avançado",
	keyboard_type_SCIENTIFIC: "Científico",
	keyboard_type_ROMAN: "Romano",
	keyboard_type_FUNCTIONS: "Funções",
	solutions_new_alternative_text: "Nova",
	no_microphone: "Não há microfone",
	confirm_replace_audio_message: "Já existe um áudio gravado. Clique em confirmar se você deseja substituí-lo por um novo.",
	config_audio_duration_limit_title: "Limite de tempo para a gravação",
	config_audio_duration_limit_subtitle: "Defina uma duração máxima de tempo que o aluno pode gravar",
	other_audio_recorder_stimulus_default: "Faça uma gravação sobre o processo de fotossíntese.",
	no_mic_available: "Não foi possível encontrar um microfone em seu computador",
	no_mic_permission: "Microfone bloqueado. Verifique se o acesso é permitido",
	confirm_switching_keyboards_title: "Atenção",
	confirm_switching_keyboards_message: "As soluções editadas serão apagadas ao trocar de teclado",
	math_counting_stimulus_default: "Quantas maçãs e limões eu preciso para ter seis frutas?",
	other_clock_stimulus_default: "São 15:30",
	sample_answer_title_box: "Solução de referência",
	sample_answer_help: "Você pode criar uma resposta modelo para facilitar a correção das atividades de correção manual. Esta seção só será visível para o professor.",
	sample_answer_title: "Adicionar solução de referência",
	sample_answer_subtitle: "Exemplo de uma solução visível para o professor.",
	sample_answer_placeholder: "Escreva o texto aqui",
	other_word_search_stimulus_default: "Encontre as seguintes palavras:",
	word_search_grid_s: "S (6x6)",
	word_search_grid_m: "M (10x10)",
	word_search_grid_l: "L (15x15)",
	word_search_title_box: "Caça-palavras",
	word_search_help: "Selecione o tamanho da malha",
	word_search_title: "Malha",
	word_search_subtitle: "Selecione o número de linhas/colunas",
	config_word_search_random_title: "Ordem aleatória",
	config_word_search_random_subtitle: "Quando ativado, as palavras serão ordenadas em uma ordem diferente cada vez que forem apresentadas",
	config_word_search_backward_title: "Palavras invertidas",
	config_word_search_backward_subtitle: "As palavras aparecem invertidas",
	config_word_search_diagonal_title: "Palavras em diagonal",
	config_word_search_diagonal_subtitle: "Direção das palavras em diagonal",
	word_search_counter_letter: "Limite de letras",
	config_word_search_allowed_letters_title: "Cadeias de letras permitidas",
	config_word_search_allowed_letters_subtitle: "Ativar para editar as letras permitidas",
	confirm_switching_columns_rows_title: "Atenção!",
	confirm_switching_columns_rows_message: "As seguintes palavras serão removidas:",
	confirm_edit_allowed_letter_title: "Atenção!",
	confirm_edit_allowed_letter_message: "As palavras que contenham outros caracteres além da nova cadeia serão deletadas.",
	word_search_preview_title_box: "Pré-visualização do caça-palavras",
	word_search_preview_help: "Assim ficarão as soluções no caça-palavras",
	word_search_button_generate: "Criar nova",
	word_search_solutions_help: "Digite palavras com pelo menos 2 letras. Não podem ser inseridos números, espaços ou caracteres especiais",
	other_crossword_stimulus_default: "Palavras cruzadas",
	crossword_solutions_help: "Digite palavras com pelo menos 2 letras. Não podem ser inseridos números, espaços ou caracteres especiais",
	crossword_counter_letter: "Limite de letras",
	crossword_word_out: "Não há letras coincidentes entre as palavras. Tente acrescentar mais palavras",
	config_uppercase_lowercase_title: "Selecione Maiúsculas/Minúsculas",
	config_uppercase_lowercase_subtitle: "As palavras serão apresentadas em maiúsculas ou minúsculas",
	config_uppercase: "Maiúsculas",
	config_lowercase: "Minúsculas",
	crossword_message_min_words: "Precisa pelo menos {{num_words}} palavras",
	crossword_solutions_text_not_valid: "Palavra não válida. Mínimo de 2 letras",
	crossword_preview_title_box: "Pré-visualização das palavras cruzadas",
	crossword_preview_help: "Assim ficarão as soluções nas palavras cruzadas",
	crossword_button_generate: "Criar novas",
	generation_error: "Não foi possível gerar as palavras cruzadas",
	upload_file_button_drive: "Upload com Google Drive",
	file_uploader_drive: "Via Google Drive",
	file_uploaded_successfully: "Arquivo enviado com sucesso",
	files_uploaded_successfully: "Arquivos enviados com sucesso",
	other_pathway_stimulus_default: "Segue as indicações.",
	direction_LEFT: "à esquerda",
	direction_RIGHT: "à direita",
	direction_BOTTOM: "para baixo",
	direction_TOP: "para cima",
	title_penalty_modes: "Pontos de penalização",
	subtitle_penalty_mode_none: "Penalize as respostas erradas pelo mesmo valor que as respostas certas. Você também pode criar uma penalização personalizada",
	subtitle_penalty_mode_per_response: "Penalize as respostas erradas pelo mesmo valor que as respostas certas. Você também pode criar uma penalização personalizada",
	subtitle_penalty_mode_custom: "Penalize as respostas erradas pelo mesmo valor que as respostas certas. Você também pode criar uma penalização personalizada",
	penalty_mode_none: "Nenhum",
	penalty_mode_per_response: "Pontuação da resposta certa",
	penalty_mode_custom: "Personalizado",
	config_show_selection_title: "Mostrar a seleção",
	config_show_selection_subtitle: "O aluno verá o objeto selecionado em destaque",
	alternative_response: "Resposta alternativa",
	alternative_responses: "Respostas alternativas",
	config_autosize_box_title: "Caixa com tamanho de resposta",
	config_autosize_box_subtitle: "Habilite isto se você quiser que o tamanho da caixa se adapte ao tamanho da resposta",
	charts_fractions_and_decimals_stimulus_default: "Como a figura representaria 4/6?",
	charts_barchart_stimulus_default: "<p>No carrinho de compras, temos 5 abacates, 3 maçãs e 7 limões. Selecione a quantidade correta no gráfico a seguir.</p>",
	charts_linechart_stimulus_default: "<p>Qual foi a temperatura média durante o ano nessas cidades?</p>",
	charts_coordinate_axes_stimulus_default: "<p>Estímulo padrão dos eixos de coordenadas</p>",
	"lemo-coordinate-axes-multiple-quadrant-error": "Atualmente, só é possível mostrar um único quadrante de coordenadas.",
	no_audio_uploaded: "Nenhum áudio enviado",
	no_file_uploaded: "Nenhum arquivo enviado",
	main_response: "Resposta principal",
	pie_chart_total_items_input: "No total, existem",
	group_name: "Nome do Grupo",
	group_editor_exercise_list: "Lista",
	remove_grouped_question_modal_title: "Remover pergunta",
	remove_grouped_question_modal_description: "<p>Tem certeza de que deseja remover esta pergunta?</p><p>Esta ação não pode ser desfeita.</p>",
	charts_pictograph_y_axis_name: "Unidades",
	charts_pictograph_x_axis_name: "Lista de compras",
	charts_pictograph_y_axis_label: "Unidades",
	charts_pictograph_x_axis_label: "Lista de compras",
	Avocados: "Abacates",
	Lemons: "Limões",
	Apples: "Maçãs",
	Units: "Unidades",
	monday: "Segunda-feira",
	tuesday: "Terça-feira",
	wednesday: "Quarta-feira",
	thursday: "Quinta-feira",
	friday: "Sexta-feira",
	saturday: "Sábado",
	sunday: "Domingo",
	Madrid: "Madri",
	Paris: "Paris",
	charts_line_chart_x_axis_name: "Estações",
	charts_line_chart_y_axis_name: "Temperaturas",
	question_group: "Grupo de perguntas",
	add_new_exercise: "Adicionar novo exercício",
	steps: "Passos",
	direction: "Direção",
	TOP: "Topo",
	BOTTOM: "Fundo",
	LEFT: "Esquerda",
	RIGHT: "Direita",
	not_completed: "Não concluído",
	group_name_placeholder: "Adicione seu texto aqui",
	group_name_help_text: "Este campo não será visível para o aluno. Servirá para facilitar buscas por grupos de exercícios por parte do editor.",
	group_stimulus_box_title: "Estímulo do Grupo",
	group_stimulus_placeholder: "Escreva a declaração da pergunta do grupo aqui",
	add_new_activity: "Adicionar nova atividade",
	group_editor_exercise_list_help_text: "Todos os exercícios deste grupo aparecerão aqui. Você pode alterar a ordem de exibição deles.",
	question_group_default_stimulus: "Escreva o estímulo do grupo aqui",
	no_questions_in_group: "Não há nada aqui",
	pathway_steps_counter: "$numSteps passos restantes",
	get_feedback: "Obter feedback",
	scaffolding_navigation_counter: "Passo {index} de {total}",
	"scaffolding_navigation_toggle-show-activity": "Ver atividade",
	"scaffolding_navigation_toggle-show-steps": "Ver passo a passo",
	barchart_table_editor_help: "Preencha os espaços em branco para completar a tabela e o gráfico. As alterações serão refletidas no jogador.",
	barchart_table_editor_add_row_tooltip: "Adicione linhas à tabela; elas também serão refletidas no gráfico.",
	barchart_table_editor_add_series_tooltip: "Adicione uma nova série; ela será exibida no gráfico como uma nova barra por série.",
	table_title: "Título da tabela",
	series: "Séries",
	serie_placeholder: "Nome da Série",
	x_axis_title: "Título do Eixo X",
	y_axis_title: "Título do Eixo Y",
	measure: "Medida",
	measure_placeholder: "Unidade de medida",
	measure_description: "Escolha o tipo de unidade de medida",
	input_needs_value: "Por favor, preencha este campo",
	hide_table: "Ocultar tabela",
	hide_table_description: "Mostrar ou ocultar a tabela",
	chart_position: "Posição do gráfico",
	chart_position_description: "Selecione acima, abaixo, à esquerda ou à direita",
	table_position: "Posição da tabela",
	table_position_description: "Selecione acima, abaixo, à esquerda ou à direita",
	max_y_value: "Valor máximo de Y",
	max_y_value_description: "Valor máximo para o eixo Y",
	linechart_max_y_value_description: "Valor máximo para o eixo Y (máx 10, mín 3)",
	min_y_value: "Valor mínimo de Y",
	min_y_value_description: "Valor mínimo para o eixo Y",
	multiplier: "Multiplicador",
	multiplier_description: "Distancia entre valores dentro do eixo Y",
	TRIANGLE: "Triângulo",
	QUAD: "Quadrado",
	RECTANGLE: "Retângulo",
	PENTAGON: "Pentágono",
	HEXAGON: "Hexágono",
	CIRCLE: "Círculo",
	RANDOM: "Aleatorio",
	HUNDREDTHS: "Centésimas",
	TENTHS: "Décimas",
	winter: "Inverno",
	spring: "Primavera",
	summer: "Verão",
	fall: "Outono",
	add_row: "Adicionar linha",
	add_serie: "Adicionar série",
	text_turned_into_alt_text: "Quando há uma imagem carregada, o texto serve como texto alternativo.",
	modal_barchart_editor_reduce_bars_message: "A quantidade máxima de barras para usar a função de série é de 3. Se clicar no botão confirmar, as barras excedentes serão apagadas. Deseja continuar?",
	"theme-light-orange": "Laranja claro",
	"theme-dark-orange": "Laranja escuro",
	"theme-light-blue": "Azul claro",
	"theme-dark-blue": "Azul escuro",
	"theme-turquoise": "Turquesa",
	"theme-violet": "Violeta",
	"theme-bordeaux": "Bordeaux",
	"theme-green": "Verde",
	fraction_editor: "Editor de frações",
	fraction_editor_help: "Complete as seções para criar a fração de acordo com a sua preferência.",
	fractions_shape_editor_title: "Forma",
	fractions_shape_editor_description: "Selecione a forma para a atividade",
	fractions_divisions_editor_title: "Divisões",
	fractions_divisions_editor_description: "Escolha quantas divisões a figura mostrará",
	select_color_theme_title: "Cor",
	select_color_theme_description: "Selecione uma cor",
	operations_editor_title: "Operação",
	operations_editor_help: "Complete as seções para criar a operação de acordo com sua preferência.",
	counting_editor_operation_title: "Tipo de operação",
	counting_editor_operation_subtitle: "Selecione se é uma soma ou uma subtração",
	counting_editor_summand_title: "Adicionado",
	counting_editor_summand_subtitle: "Selecione uma quantidade",
	change_image_title: "Mudar imagem",
	change_image_subtitle: "Você pode mudar a imagem mas não pode ficar vazia",
	change_image_alt: "Mudar imagem",
	items_to_show_title: "Elementos mostrados",
	items_to_show_description: "Digite aqui quantos elementos aparecerão",
	minuend_title: "Subtraendo",
	select_a_quantity: "Selecione uma quantidade",
	add: "Contar a adição",
	count: "Contagem simples",
	subtract: "Contar a subtração",
	show_result_title: "Mostrar resultado",
	show_result_subtitle: "Mostre o resultado da operação imediatamente",
	math_number_line_stimulus_default: "Represente os seguintes pontos no gráfico",
	number_line_editor_help: "Defina as diferentes opções que você quer que o aluno veja como respostas para a pergunta.",
	divisions: "Divisiones",
	number_line_starting_number: "Número inicial",
	number_line_starting_number_description: "Onde a reta começa",
	number_line_finishing_number: "Número final",
	number_line_finishing_number_description: "Onde a reta termina",
	number_line_divisions_description: "Escolha quantas marcas há na linha",
	number_line_distance: "Distância dos números mostrados",
	number_line_distance_description: "Selecione o intervalo entre os números mostrados",
	number_line_fractions: "Fracciones",
	number_line_fractions_description: "Mostrar frações em vez de números inteiros",
	number_line_denominator: "Denominador",
	number_line_denominator_description: "Digite um número. Ele atuará como denominador para toda a linha",
	number_line_fractions_as_integers: "Frações inteiras como unidades",
	number_line_fractions_as_integers_description: "Se o numerador for um múltiplo do denominador, o número inteiro é exibido",
	grid_editor: "Editor de grade",
	grid_editor_description: "Descrição do editor de grade...",
	grid_size_title: "Tamanho da grade",
	grid_size_subtitle: "Selecione o tamanho da grade",
	charts_pictograph_stimulus_default: "Complete a lista de compras",
	pictograph_table_editor_help: "Preencha os espaços em branco para completar a tabela e o gráfico. As alterações serão refletidas no jogador.",
	pictograph_table_title_empty: "A tabela deve ter um título",
	Pineapples: "Abacaxis",
	Strawberries: "Morangos",
	editor_pathway_grid_title: "Editor de grade",
	editor_pathway_grid_editor_help: "Complete as seções para criar o caminho de acordo com sua preferência.",
	editor_pathway_grid_size_title: "Tamanho da grade",
	editor_pathway_grid_size_subtitle: "Selecione um tamanho de grade",
	editor_pathway_grid_width_title: "Largura",
	editor_pathway_grid_width_subtitle: "Pode ser diferente da altura",
	editor_pathway_grid_height_title: "Altura",
	editor_pathway_grid_height_subtitle: "Pode ser diferente da largura",
	editor_pathway_change_image_title: "Mudar imagem de fundo",
	editor_pathway_change_image_subtitle: "Ative para enviar sua própria imagem",
	editor_pathway_change_character_title: "Mudar personagem",
	editor_pathway_change_character_subtitle: "Escolha entre os diferentes personagens",
	editor_pathway_coordinate_x_title: "Coordenada inicial: X",
	editor_type_or_select_number: "Digite ou selecione um número",
	editor_pathway_coordinate_y_title: "Coordenada inicial: Y",
	editor_pathway_solutions_help: "editor_pathway_solutions_help",
	sand: "Arena",
	grass: "Grama",
	stone: "Pedra",
	farmer: "Fazendeiro",
	pirate: "Pirata",
	worker: "Obrero",
	editor_coordinate_axes_grid_size_title: "Tamanho da grade",
	editor_coordinate_axes_grid_size_subtitle: "Selecione o tamanho da grade",
	editor_coordinate_axes_quadrant_title: "Quadrante",
	editor_coordinate_axes_quadrant_subtitle: "Selecione o tipo de quadrante I, II, III, IV",
	editor_coordinate_axes_dot_color_title: "Cor do ponto",
	editor_coordinate_axes_dot_color_subtitle: "Selecione uma cor para o ponto",
	generate_new: "Gerar novo",
	ABOVE: "Acima",
	boxplot_editor_title: "Editor de diagrama",
	boxplot_editor_help: "Edite os valores máximos e mínimos da linha.",
	boxplot_editor_min_title: "Caixa: Valor mínimo",
	boxplot_editor_min_description: "Escolha quantas divisões a figura irá mostrar",
	boxplot_editor_max_title: "Caixa: Valor máximo",
	boxplot_editor_max_description: "Escolha quantas divisões a figura irá mostrar",
	linechart_table_editor_title: "Editor de tabelas",
	linechart_table_editor_help: "Preencha os espaços em branco para completar a tabela e o gráfico. As alterações serão refletidas no jogador.",
	linechart_add_row_description: "Adicione linhas à tabela; elas também serão refletidas no gráfico.",
	linechart_add_serie_description: "Adicione uma nova série; ela será exibida no gráfico como uma nova linha.",
	modal_barchart_editor_reduce_bars_title: "Há barras demais para usar a função de séries",
	modal_barchart_editor_reduce_bars_title_subtitle: "O número de barras será reduzido para se adequar a esta função, sendo permitido um máximo de três barras por série",
	other_reverse_pathway_stimulus_default: "Que passos o pirata precisa dar para alcançar o objetivo?",
	editor_coordinate_axes_quadrant_all: "Todos",
	config_clock_digital_title: "Relógio digital",
	config_clock_digital_subtitle: "Alterne entre relógio analógico e digital",
	config_clock_dark_mode_title: "Modo escuro",
	config_clock_dark_mode_subtitle: "Escolha entre o tema claro ou escuro para o relógio",
	config_clock_steps_title: "Passos",
	config_clock_steps_subtitle: "Selecione o intervalo de tempo (um a um, de cinco em cinco)",
	config_clock_steps_one: "Um a um",
	config_clock_steps_five: "De cinco em cinco",
	config_clock_24_hour_title: "Relógio de 24 horas",
	config_clock_24_hour_subtitle: "Selecione entre a vista de 12 horas ou a vista de 24 horas",
	charts_pie_chart_stimulus_default: "No cesto de compras, temos 1 pêra, 2 maçãs e 3 abacaxis.",
	piechart_table_editor_help: "Preencha os espaços em branco para completar a tabela e o gráfico. As alterações serão refletidas no reprodutor.",
	charts_pie_chart_table_title: "Título da tabela",
	charts_pie_chart_table_title_placeholder: "Escreva um texto para o título",
	piechart_table_title_error_empty: "A tabela deve ter um título",
	charts_pie_chart_elements: "Elementos",
	charts_pie_chart_elements_placeholder: "Nome do elemento",
	charts_pie_chart_elements_error_empty: "Todos os elementos devem ter um nome",
	charts_pie_chart_add_element: "Adicionar elemento",
	charts_pie_chart_add_element_tooltip: "Adicione mais um elemento ao gráfico de pizza.",
	input_tootltip_help: "Escreva aqui!",
	input_tootltip_help_touch_devices: "Toque aqui!",
	config_automatic_drop_title: "Preencher automaticamente as Respostas",
	config_automatic_drop_subtitle: "Quando clicado, as respostas serão inseridas automaticamente na primeira lacuna dispon",
	input_math_floating_tootltip_help: "Clique aqui!",
	answer_options_group_responses_toggle: "Agrupar",
	stickers_drop_editor_title: "Editor de drops",
	stickers_drop_editor_help: "Carregue uma imagem de fundo para o seu exercício e crie hotspots a serem preenchidas pelos alunos",
	hotspots_painter_button_undo: "Desfazer",
	hotspots_painter_button_redo: "Refazer",
	hotspots_painter_button_select: "Selecionar",
	hotspots_painter_button_draw: "Desenhar",
	hotspots_painter_button_delete: "Excluir",
	stickers_drop_editor_tab_upload_image: "1. Carregar imagem",
	stickers_drop_editor_tab_hotspots: "2. Hotspots",
	config_show_hotspots_title: "Mostrar hotspots",
	config_show_hotspots_subtitle: "O aluno verá a área onde pode colocar o adesivo",
	config_drop_indicator_title: "Indicador de área de destino",
	config_drop_indicator_subtitle: "Ajuda visual para o aluno",
	stickers_stimulus_default: "Coloque dois abacates na primeira cesta e dois limões na segunda.",
	input_floating_tootltip_help: "Clique aqui!",
	input_floating_tootltip_help_touch_devices: "Toque aqui!",
	stickers_answer_options_placeholder: "Descrição alternativa da imagem",
	stickers_drop_editor_image_placeholder: "Descrição alternativa da imagem",
	config_vertical_orientation_title: "Orientação vertical",
	config_vertical_orientation_subtitle: "Mostrar os hotspots em colunas",
	classify_stickers_stimulus_default: "Coloque dois abacates na primeira cesta e dois limões na segunda.",
	classify_stickers_series_stimulus_default: "Continue as sequências.",
	fruit_avocados: "Abacates",
	fruit_lemons: "Limões",
	fruit_apples: "Maçãs",
	fruit_pineapples: "Abacaxis",
	stickers_series_exercise_help: "Adicione quantas caixas em branco precisar e posicione-as sobre a imagem. Você pode alterar a imagem de fundo e redimensionar as caixas. ",
	stickers_series_exercise_title_box: "Editor de imagens",
	clear_all_button: "Limpar tudo",
	clear_all_description: "Ao clicar neste botão, todos os dados deste exercício serão apagados",
	clear_all_confirmation_title: "Atenção!",
	clear_all_confirmation_description: "Todos os elementos serão apagados",
	clear_all_confirmation_cancel_button: "Cancelar",
	clear_all_confirmation_confirm_button: "Confirmar",
	move_bottom_handle: "Move a alça de baixo",
	axis_editor_title: "Editor de eixo",
	axis_editor_help: "Configure a aparência do eixo de coordenadas",
	math_sum_stimulus_default: "Complete a seguinte operação",
	response_ignore_trailing_zeros_title: "Ignorar zeros à direita",
	response_ignore_trailing_zeros_subtitle: "Se ativado, a resposta do aluno será considerada correta mesmo que tenha zeros decimais à direita.",
	word_search_button_generate_is_loading: "Gerando...",
	transformations_in_plane_stimulus_default: "Representa a translação desta figura 5 quadrados para a direita.",
	lineal_function_stimulus_default: "Representa graficamente y = -3x + 1",
	quadratic_function_stimulus_default: "Representa graficamente y = −2x² + 4x + 1",
	charts_flow_chart_stimulus_default: "Complete o seguinte diagrama de fluxo.",
	"empty-figure": "Esvaziar figura",
	prime_number_decomposition_stimulus_default: "Decomponha o número 12 em fatores primos.",
	charts_histograms_stimulus_default: "Construa um histograma a partir da seguinte tabela de dados.",
	charts_histograms_x_axis_name: "T(ºC)",
	charts_histograms_x_axis_label: "Temperatura máxima",
	charts_histograms_y_axis_name: "Frequência absoluta",
	charts_histograms_y_axis_label: "Frequência absoluta",
	math_find_closest_value_stimulus_default: "Indique o resultado do número usando a reta numérica",
	"move-right": "Mover para direita",
	"move-left": "Mover para esquerda",
	"move-up": "Girar para cima",
	"move-down": "Girar para baixo",
	rotate: "Girar",
	"flip-horizontal": "Reflexão horizontal",
	"flip-vertical": "Reflexão vertical",
	functions_editor: "Editor de funções",
	functions_editor_help: "Use o editor de funções para inserir novas funções e ajustar seus valores.",
	add_function: "Adicionar função",
	operation_editor: "Editor de operações",
	operation_editor_help: "Neste bloco, você pode configurar os valores da operação.",
	config_operation_title: "Operações dinâmicas",
	config_operation_subtitle: "Gere uma operação aleatória ou personalizada.",
	digits_per_addend_title: "Número de dígitos por parcela",
	digits_per_addend_subtitle: "Defina a quantidade de dígitos em cada parcela.",
	addend_count_title: "Quantidade de parcelas",
	addend_count_subtitle: "Defina a quantidade de parcelas que a operação terá.",
	column_help_title: "Realce de colunas",
	column_help_subtitle: "Ajuda visual que destaca a coluna atual.",
	order_terms_title: "Ordenação de termos",
	order_terms_subtitle: "Mostra os termos da operação do maior para o menor.",
	prime_number_generator_editor: "Gerador de valores dinâmicos",
	prime_number_generator_editor_help: "Gera um número aleatório que o aluno terá que decompor com base na seleção que você fizer nestas opções.",
	enabled_factors_title: "Números primos",
	enabled_factors_subtitle: "Selecione os possíveis fatores do número gerado.",
	factors_length_title: "Número de fatores",
	factors_length_subtitle: "Indica a quantidade máxima de fatores que o número gerado pode ter sem contar com o 1.",
	Transcription: "Transcrição",
	other_rating_stimulus_default: "É hora de avaliar o conteúdo!",
	other_rating_tooltip_1_star: "1 estrela",
	other_rating_tooltip_multiple_stars: "{{count}} estrelas",
	other_rating_description_1_star: "Não gostei. Confundiu-me e aborreceu-me.",
	other_rating_description_2_stars: "Gostei mais ou menos... Algumas coisas entendi melhor que outras.",
	other_rating_description_3_stars: "Gostei bastante. Entendi e interessou-me :)",
	other_rating_description_4_stars: "Adorei! Pareceu-me interessante e divertido. Quero mais!",
	adaptative_choice_levels_config: "Configuração de Níveis",
	adaptative_choice_levels_config_help: "Configure os títulos de cada nível da atividade adaptativa",
	adaptative_choice_level_title: "Nível {{level_number}}",
	adaptative_choice_level_title_label: "Título do nível:",
	adaptative_choice_level_title_placeholder: "Escreva o título deste nível...",
	other_adaptative_choice_back: "Voltar",
	other_adaptative_choice_next: "Próximo"
};
var pt = {
	translations: translations$6
};

var translations$7 = {
	title: "Títol",
	enunciated: "Enunciat",
	stimulus: "Enunciat de l’activitat",
	enunciated_placeholder: "Escriu una descripció",
	multiple_choice_activity: "Selecció múltiple",
	answer_options: "Opcions de resposta",
	add_new_response: "Afig",
	add_new_question: "Afig",
	new_question_stem: "Nova pregunta",
	validation: "Puntuació",
	option: "Opció",
	type_of_validation: "Introdueix el tipus de validació:",
	exactMatch: "Exacta: és necessari contestar totes les opcions correctament.",
	partialMatch: "Parcial: cada resposta correcta atorga la puntuació.",
	partialMatchV2: "Parcial per resposta: es divideix la puntuació entre el nombre de respostes.",
	score: "Puntuació",
	high_score: "Màxima puntuació",
	enter_a_score: "Introdueix una puntuació",
	minimum_score: "Mínima puntuació per intentar-ho",
	cancel: "Cancel·la",
	save: "Guarda",
	send: "Envia",
	reset: "Restaura",
	shuffle_options: "Mescla respostes",
	multiple_responses: "Resposta múltiple",
	words_limit: "Límit de paraules",
	letters_limit: "Límit de lletres",
	essay_placeholder: "Escriu la teua resposta.",
	right_answer: "Resposta correcta",
	write_right_answer: "Escriu la resposta correcta",
	copy: "Copia",
	cut: "Talla",
	paste: "Apega",
	cloze_text: "Tanca el text",
	activity_data_wrong: "Les dades estan mal formades",
	this_is_the_stem: "Desenvolupa la pregunta ací",
	"true": "Vertader",
	"false": "Fals",
	column: "Columna",
	columns: "Columnes",
	row: "Fila",
	world_map: "Mapa mundial",
	Greenland: "Grenlàndia",
	Russia: "Rússia",
	United_States: "Estats Units",
	table_editor: "Editor de taula",
	drags: "Arrossega",
	add_new_column: "Afig títol columna",
	add_new_row: "Afig títol fila",
	duplicate_responses: "Respostes duplicades",
	solutions: "Solucions",
	Solution: "Solució",
	column_count: "Nombre de columnes",
	row_count: "Nombre de files",
	cloze_template: "Això va anar i era un cas que va passar en la vila de {{response}}. Un cas gros i {{response}}, per cert.",
	response: "Resposta",
	response_containers: "Contenidors de respostes",
	global_size: "Escala global",
	width: "Ample",
	height: "Alt",
	upload_file: "Puja arxiu",
	completed: "Completat",
	choose_file: "Tria arxiu",
	change_file: "Canvia arxiu",
	load_image_error_message: "S’ha produït un error en intentar pujar la imatge",
	sending_file: "Pujant arxiu",
	select_an_item: "Selecciona un element",
	pointer: "Punter",
	none: "Cap",
	left: "Esquerra",
	right: "Dreta",
	top: "Amunt",
	bottom: "Avall",
	show_check_icon: "Mostra icona",
	alternative_text: "Text alternatiu",
	isEvaluable: "Mode avaluació",
	autosize_response: "Longitud automàtica",
	text_normalization: "Normalització de textos",
	load_image: "Puja imatge",
	image_size: "Grandària d’imatge",
	text_sample: "Text d’exemple",
	size: "Grandària",
	accent_sensitive: "Sensible a accents",
	case_sensitive: "Sensible a majúscules",
	spaces_sensitive: "Correcció d’espais",
	orientation: "Orientació",
	"delete": "Esborra",
	stack: "Apilat",
	box: "Caixa",
	Feedback: "Feedback",
	"Remove Feedback": "Elimina feedback",
	Visibility: "Visibilitat",
	"Success Message": "Missatge d’èxit",
	"Error Messages": "Missatges d’error",
	Sequence: "Seqüència",
	cyclic: "Cíclic",
	random: "Aleatori",
	"Add new error": "Afig nou error",
	"Error message": "Missatge d’error",
	Configuration: "Ajustatge",
	"Shuffle Answers": "Ordre aleatori",
	"When turned on the questions will be sorted in differ order each time they are presented": "Les opcions eixiran de forma aleatori en cada alumne.",
	"Show check icon": "Mostra icona de verificació",
	"When turned on the answers will have a radio button next to them": "Activa’l per a mostrar una caixa de selecció junt amb les opcions.",
	Columns: "Columnes",
	"Choose how many columns you want the answers to be displayed into": "Tria en quantes columnes vols mostrar les respostes",
	style_block_none: "Cap",
	style_block_BLOCK: "Bloc",
	style_block_NUMERICAL: "Numèric",
	style_block_LOWER_ALPHA: "Alfabet en minúscules",
	style_block_UPPER_ALPHA: "Alfabet en majúscules",
	"1 columns": "1 columna",
	"2 columns": "2 columnes",
	"3 columns": "3 columnes",
	"4 columns": "4 columnes",
	"5 columns": "5 columnes",
	"6 columns": "6 columnes",
	SERVER_ERROR: "S’ha produït un error en pujar l’arxiu. Intenta-ho de nou.",
	MAX_FILES_REACHED: "Has arribat al límit d’arxius permesos.",
	INVALID_TYPE: "Tipus d’arxiu no vàlid",
	MAX_SIZE_EXCEEDED: "L’arxiu que vols pujar sobrepassa la grandària màxima permesa. Per favor, redueix-ne la grandària i torna-ho a intentar.",
	UNKNOWN_ERROR: "S’ha produït un problema en pujar l’arxiu. Per favor, intenta-ho de nou.",
	"You can set up the settings of each type of question here": "Pots configurar els ajustatges de cada tipus de pregunta ací.",
	"Different max / min file upload": "Pujada d’arxiu amb diferent màxim / mínim",
	"Turn on if you want to allow uploading a range of files to the exercise": "Permet la pujada de diversos arxius en aquesta activitat.",
	"File size limit": "Límit de grandària d’arxiu",
	"Max size each file can reach. This is a default value and cannot be editted": "Grandària màxima a la qual pot arribar cada arxiu. Aquest és un valor predeterminat i no es pot editar",
	"Types of files allowed as attachments": "Tipus d’arxius permesos com a adjunts",
	"MS Word, Excel, Power Point, jpg, png, pdf, Open Office, txt, video and audio": "Word, Excel, Power Point, jpg, png, pdf, Open Office, txt, vídeo i àudio",
	"default": "Per defecte",
	"Files limit": "Límit d’arxius",
	"Min/Max number of files the student is allowed to upload": "Mínim/màxim nombre d’arxius que l’alumne pot pujar",
	"Size thumb": "Grandària de la miniatura",
	"Image size": "Grandària d’imatge",
	"Background image": "Imatge de fons",
	"Canvas Background Image": "Imatge de fons del llenç",
	"Allowed files: images (jpg, png, gif), audio (mp3, ogg), video (mp4, ogg, webm, mkv), documents (word, excel, power point, pdf, open office, txt)": " ",
	"Allowed files: images (jpg, png, gif)": "Formats permesos: imatges (jpg, png, gif)",
	Exercise: "Activitat",
	background_image_alt: "Text alternatiu",
	response_exact_or_equivalent_title: "El resultat és exacte o equivalent",
	response_exact_or_equivalent_subtitle: "Tria exacte si vols avaluar com a correctes només les respostes exactes. Tria equivalent si vols donar com a correcta qualsevol expressió equivalent",
	response_exact_or_equivalent_subtitle_option_equivliteral: "Exacte",
	response_exact_or_equivalent_subtitle_option_equivsymbolic: "Equivalent",
	response_decimals_title: "Decimals",
	response_decimals_subtitle: "Selecciona el nombre mínim de decimals",
	response_response_value: "Valor de la resposta",
	response_title: "Resposta",
	response_decimal_option_0: "Sense decimals",
	response_decimal_option_1: "1 decimal",
	response_decimal_option_2: "2 decimals",
	response_decimal_option_3: "3 decimals",
	response_decimal_option_4: "4 decimals",
	response_decimal_option_5: "5 decimals",
	response_decimal_option_6: "6 decimals",
	stimulus_help: "Escriu l’enunciat de l’exercici ací. Pots afegir-hi text, equacions, taules i qualsevol material editable.",
	config_help: "Pots configurar els ajustatges de cada tipus de pregunta ací.",
	answer_options_help: "Escriu les diferents opcions que vulgues mostrar a l’estudiant com a possibles respostes i tria’n l’ordre. Pots afegir-hi més respostes fent clic en el botó d’Afig.",
	editor_response_title_accordion: "Resposta",
	config_canvas_height_title: "Altura per defecte",
	config_canvas_height_subtitle: "Altura predeterminada de l’espai de fons",
	background_image_title: "Imatge de fons",
	background_image_subtitle: "Estableix una imatge de fons",
	response_result_button_delete: "Elimina resposta",
	config_variant_style_title: "Variant d’autor",
	config_variant_style_subtitle: "Selecciona la variant desitjada",
	config_variant_style_input_placeholder: "Afig nom de classe",
	style_variant_default: "Per defecte",
	style_variant_custom: "Personalitzada",
	config_multiple_responses_title: "Resposta múltiple",
	config_multiple_responses_subtitle: "Activa’l si hi ha més d’una resposta vàlida",
	button_validation_title_box: "Botó",
	button_validation_title: "Afig botó de validació",
	button_validation_subtitle: "Activa’l per a afegir un botó de confirmació a l’alumnat",
	button_validation_alt: "Afig el teu text ací",
	button_validation_help: "Utilitza aquesta opció si necessites que l’alumnat marque aquesta activitat com a completada quan l’acaben",
	button_validation_default: "Fet",
	button_edit: "Edita",
	button_cancel: "Cancel·la",
	button_confirm: "Confirma",
	button_try_again: "** Intentar otra vez",
	button_cant_speak_now: "** No puedo hablar ahora",
	config_background_title: "Afig imatge de fons",
	config_background_subtitle: "Activa’l per a pujar una imatge per al fons",
	config_background_help: "Pots pujar una imatge de fons.",
	exercise_example_text_title: "Escriu ací el text de la pregunta",
	exercise_example_text_subtitle: "Text abans d’emplenar una etiqueta",
	exercise_label_font_size_title: "Grandària de font",
	exercise_label_font_size_subtitle: "Determina la grandària de font en la caixa",
	config_duplicate_responses_title: "Duplica respostes",
	config_duplicate_responses_subtitle: "Activa’l per a duplicar les respostes",
	feedback_exercise_title: "Tractament de l’error",
	feedback_exercise_placeholder: "Afig ací feedback general",
	feedback_exercise_help: "Recorda que això ofereix a l’alumnat un tractament de l’error general de tota l’activitat. Pots usar-lo per a fer alguna indicació o recordatori.",
	feedback_exercise_help_with_individual: "Pots ajudar l’alumnat oferint un tractament de l’error general de l’activitat. També pots introduir comentaris individuals en cada resposta que apareixeran a l’alumnat si s’equivoca.",
	config_is_math_title: "És matemàtiques",
	config_is_math_subtitle: "Indica si és matemàtiques",
	config_accent_sensitive_title: "Sensible als accents",
	config_accent_sensitive_subtitle: "Activa’l si vols tenir en compte els accents en les correccions",
	config_case_sensitive_title: "Sensible a les majúscules",
	config_case_sensitive_subtitle: "Activa’l si vols que la resposta distingisca entre majúscules i minúscules en corregir",
	config_fix_spaces_title: "Arregla els espais",
	config_fix_spaces_subtitle: "Desactiva’l si vols que l’ús incorrecte d’espais no penalitze, independentment del lloc en la paraula.",
	config_max_character_title: "Restricció de caràcters",
	config_max_character_subtitle: "Introdueix el màxim de caràcters per a restringir l’extensió de la resposta",
	config_max_character_input_title: "Estableix el límit de caràcters",
	config_max_character_input_subtitle: "Especifica el nombre màxim de caràcters que l’alumnat pot escriure",
	config_max_character_input_placeholder: "Màxim de caràcters",
	config_words_limit_title: "Comptador de paraules",
	config_words_limit_subtitle: "Introdueix un màxim de paraules",
	config_words_limit_input_title: "Estableix el límit de paraules",
	config_words_limit_input_subtitle: "Especifica el màxim nombre de paraules que un estudiant pot escriure",
	config_words_limit_input_placeholder: "Introdueix nombre màxim de paraules",
	config_autosize_response_title: "Resposta amb grandària automàtica",
	config_autosize_response_subtitle: "Activa’l si vols que la longitud màxima del quadre de resposta tinga la mateixa longitud que la solució",
	"Drop your files here or": "Busca o arrossega ací els teus arxius",
	browse: " ",
	"Max file size": "Grandària màxima d’arxiu",
	"MB · At least": "MB ·",
	"file required": "arxiu requerit",
	richText_placeholder: "Escriu la teua resposta ací",
	"Questions options": "Opcions de pregunta",
	"Answer options": "Opcions de resposta",
	Answer: "Resposta",
	config_stack_title: "Apila",
	config_stack_subtitle: "Els arrossegables s’aniran apilant dins de les àrees quan la grandària de la pantalla ho permeta",
	config_with_box_title: "Opcions d’emmarcar en caixes",
	config_with_box_subtitle: "Els arrossegables es marcaran con una línia en seleccionar-los",
	config_lines_color_title: "Color de les línies",
	config_lines_color_subtitle: "Tria un color de línia",
	line_thinckness_fine: "Fi",
	line_thinckness_medium: "Mitjà",
	line_thinckness_coarse: "Gros",
	config_line_thickness_title: "Grossària de les línies",
	config_line_thickness_subtitle: "Tria una grandària de línia",
	config_feedback_mode_click_to_find_title: "Mode de feedback",
	config_feedback_mode_click_to_find_subtitle: "Cap, amb vora o marca",
	feedback_mode_none: "Cap",
	"feedback_mode_feedback-with-border": "Amb vora",
	"feedback_mode_feedback-with-tick": "Amb marca",
	click_to_find_size_background_title: "Grandària d’imatge de fons",
	click_to_find_size_background_subtitle: "Grandària d’imatge",
	click_to_find_solutions_tooltip_correct: "Marca com a correcte",
	click_to_find_solutions_tooltip_incorrect: "Marca com a incorrecte",
	config_column_direction_title: "Direcció de la columna",
	config_column_direction_subtitle: "Vertical o horitzontal",
	column_direction_horizontal: "Horitzontal",
	column_direction_vertical: "Vertical",
	linking_lines_limit_options_help: "Per a una visualització correcta, el nombre d’opcions està limitat a 6",
	evaluation_mode_tooltip: "Desactiva’l si vols corregir manualment o recollir informació que no compte per a nota.",
	individual_feedback_exercise_placeholder: "Escriu feedback individual en aquesta resposta",
	label_drop_item: "Resposta",
	individual_feedback_exercise_tooltip: "Afig feedback per a aquesta resposta",
	change_image: "Canvia imatge",
	answer_options_help_multiple_choice: "Escriu les diferents opcions que vulgues mostrar a l’alumnat com a possibles respostes i tria’n l’ordre.",
	add_alternative: "Alternativa",
	solutions_instructions: "Defineix la resposta correcta a l’exercici i la puntuació corresponent. Assigna el 100% si la resposta és correcta. També pots proporcionar una resposta alternativa i assignar el % del total de punts que es mereix.",
	image: "Imatge",
	add_an_image_to_exercise: "Afig una imatge a l’activitat",
	button_show_hints: "Pista",
	button_validate: "Comprova",
	button_restart: "Refés",
	button_repeat: "Repeteix",
	button_show_solution: "Mostra solució",
	button_hide_solution: "Mostra la meua resposta",
	button_restart_scaffold: "Reinicia scaffolding",
	points: "Punts",
	button_next_question: "Següent",
	button_i_dont_know: "No ho sé",
	title_help: "Aquest camp no serà visible per a l’alumnat. Servirà per a facilitar recerques d’exercicis per part d’un editor o editora.",
	title_placeholder: "Escriu ací el text",
	hints_title_box: "Pista",
	hints_help: "Les pistes són missatges breus que l’alumnat pot demanar quan necessite ajuda. Pots afegir suggeriments a aquesta activitat ací.",
	hints_title: "Afig pista",
	hints_subtitle: "Activa’l per a donar a l’alumnat una informació o un consell",
	hint_placeholder: "Àrea amb text de pista",
	automatic_evaluation: "Avaluació automàtica",
	automatic_evaluation_description: "Desactiva’l per a avaluar manualment i permet respostes obertes",
	title_title_box: "Nom intern",
	feedback_exercise_toogle_title: "Afig feedback",
	feedback_exercise_toogle_subtitle: "Activa’l per a orientar quan l’alumnat cometa un error",
	multiple_choice_multiple_stimulus_default: "Selecciona com a mínim una (o més) de les opcions següents:",
	multiple_choice_single_stimulus_default: "Selecciona una de les opcions següents:",
	multiple_choice_truefalse_stimulus_default: "Llig i contesta 'Vertader' o 'Fals':",
	multiple_choice_blockletter_stimulus_default: "Tria una de les opcions següents:",
	choice_matrix_inline_stimulus_default: "Decideix si les opcions següents són vertaderes o falses:",
	choice_matrix_standard_stimulus_default: "Decideix si les opcions següents són vertaderes o falses:",
	classify_classification_stimulus_default: "Arrossega i solta cada resposta al lloc corresponent:",
	classify_matchlist_stimulus_default: "Emparella cada resposta amb el concepte corresponent:",
	classify_orderlist_stimulus_default: "Arrossega i solta per a ordenar les respostes:",
	classify_linkinglines_stimulus_default: "Uneix cada paraula amb el significat corresponent:",
	cloze_text_stimulus_default: "Escriu la paraula que falta en les caixes que es mostren a continuació:",
	cloze_dropdown_stimulus_default: "Selecciona l’opció correcta de cada desplegable:",
	cloze_drag_drop_stimulus_default: "Arrossega i solta les respostes dins dels buits.",
	essay_plaintext_stimulus_default: "Escriu una redacció de 200 paraules sobre el teu lloc favorit.",
	essay_sorttext_stimulus_default: "Quin és el riu més llarg de l’Amèrica del Sud?",
	essay_sorttext_solution1_default: "El riu Amazones",
	essay_richtext_stimulus_default: "Escriu una redacció de 200 paraules sobre el teu lloc favorit.",
	labelimage_dragdrop_stimulus_default: "Arrossega i solta cada país al lloc corresponent:",
	labelimage_dropdown_stimulus_default: "Selecciona l’opció correcta de cada desplegable:",
	labelimage_imagewithtext_stimulus_default: "Escriu el nom de cada país:",
	math_clozemath_stimulus_default: "Calcula les operacions següents:",
	other_uploadfile_stimulus_default: "Fes una foto dels teus deures i solta-la ací:",
	other_pencil_stimulus_default: "Dibuix la teua mascota o animal favorit i on viu:",
	other_statement_stimulus_default: "Tria un company o companya i comenta per què portar un estil de vida saludable és important.",
	other_clicktofind_stimulus_default: "Fes clic en totes les llimes:",
	choice_matrix_questions_help: "Introdueix els enunciats de les preguntes en les caixes. Pots afegir més preguntes fent clic en el botó Afig.",
	match_list_questions_help: "Introdueix els enunciats de les preguntes en les caixes. Pots afegir més preguntes fent clic en el botó Afig.",
	linking_lines_questions_help: "Introdueix els enunciats de les preguntes en les caixes. Pots afegir més preguntes fent clic en el botó Afig.",
	scaffold_separator_step: "Pas",
	scaffold_separator_of: "de",
	title_check_icon_single_choice: "Botó d’opció",
	subtitle_check_icon_single_choice: "Desactiva’l per a amagar el botó i utilitzar el mode bloc en el seu lloc",
	title_check_icon_multiple_choice: "Casella d’opció",
	subtitle_check_icon_multiple_choice: "Desactiva’l per a amagar la casella i utilitzar el mode bloc en el seu lloc",
	title_block_style: "Estil de llista",
	subtitle_block_style: "Cap, numèrica o alfabètica",
	Spain: "Espanya",
	template_exercise_markup_add_blank: "Afig buit",
	template_markup_add_blank: "Afig buit",
	sending_button: "Enviant...",
	table_editor_help: "Usa l’editor de taula per a configurar el nombre de columnes i files de la taula. Les columnes podran ser com a mínim una i com a màxim, cinc.",
	cloze_exercise_help: "Escriu una oració i utilitza les caixes en blanc perquè l’alumnat identifique quines són les paraules clau que falten en el text.",
	cloze_math_exercise_help: "Escriu l’enunciat i utilitza les caixes en blanc perquè l’alumnat identifique quins són els nombres o les fórmules clau que falten.",
	label_exercise_help: "Afig tantes caixes en blanc com necessites i col·loca-les per la imatge. Pots canviar la imatge de fons, redimensionar les caixes i la grandària de la font.",
	cloze_dropdown_exercise_help: "Escriu una oració i utilitza les caixes blanques per a afegir opcions. L’alumnat haurà de seleccionar l’opció correcta en cada buit que trobe en el text.",
	click_to_find_exercise_help: "Reemplaça la imatge de fons, afig noves imatges i col·loca-les pel llenç. Podràs definir quina és correcta o incorrecta en la secció de Solució.",
	linking_lines_question_option: "Opció de pregunta",
	title_evaluation_type: "Tipus d’avaluació",
	subtitle_evaluation_type_exact_match: "L’alumnat haurà de contestar l’exercici correctament per a rebre la puntuació",
	subtitle_evaluation_type_partial_match: "La puntuació general de l’exercici es dividirà entre les respostes, i cadascuna es puntuarà individualment",
	subtitle_evaluation_type_manual: "L’activitat no s’avalua.",
	subtitle_evaluation_type_match_response: "La puntuació general de l’exercici es dividirà entre els elements d’arrossegament, i cadascun es puntuarà individualment",
	subtitle_evaluation_type_match_group: "La puntuació general de l’exercici es dividirà entre els grups, i cadascun es puntuarà individualment",
	evaluation_type_exact_match: "Correcció exacta",
	evaluation_type_partial_match: "Correcció parcial",
	evaluation_type_manual: "Correcció manual",
	evaluation_type_match_response: "Parcial per resposta",
	evaluation_type_match_group: "Parcial per grup",
	manual_or_alternative_solutions_help: "Defineix la resposta correcta a l’exercici que tindrà assignat el 100%. També pots crear solucions alternatives i assignar el % que es meresquen. En cas que vulgues que l’exercici no siga autoavaluador, selecciona correcció manual.",
	exact_math_or_partial_match_or_manual_solutions_help: "Amb correcció exacta l’alumnat haurà de contestar l’exercici correctament per a rebre la puntuació. També pots crear solucions alternatives i assignar el % que es meresquen. Amb la correcció parcial, el total de punts es dividirà entre cada resposta, i cadascuna s’avaluarà individualment. Si vols que l’exercici no siga autoavaluador, selecciona correcció manual.",
	exact_math_or_match_response_or_match_group_or_manual_solutions_help: "Amb correcció exacta l’alumnat haurà de contestar l’exercici correctament per a rebre la puntuació. També pots crear solucions alternatives i assignar el % que es meresquen. Amb la correcció parcial per resposta, el total de punts es dividirà entre cada resposta, i cadascuna s’avaluarà individualment. Amb la correcció parcial per grup, els punts es dividiran entre els elements o cel·les. Si vols que l’exercici no s’avalue, selecciona correcció manual.",
	solutions_penalty_title: "Personalitzat",
	solutions_penalty_subtitle: "Selecciona manualment un % de penalització per resposta",
	feedback_exercise_toogle_individual_feedback_title: "Afig tractament d’error a cada resposta",
	feedback_exercise_toogle_individual_feedback_subtitle: "El missatge apareixerà a l’alumnat quan responga incorrectament",
	"Answer Option": "Opció de resposta",
	"Text Prompt": "Pregunta",
	config_fixed_keyboard_title: "Teclat flotant",
	config_fixed_keyboard_subtitle: "Activa’l per a mostrar l’alumnat un teclat flotant quan selecciona una casella",
	config_number_keyboards_title: "Teclat numèric",
	config_number_keyboards_subtitle: "Selecciona el tipus de teclat que apareixerà a l’alumnat",
	keyboard_type_NONE: "Cap",
	keyboard_type_NUMERICAL: "Numèric",
	keyboard_type_BASIC: "Bàsic",
	keyboard_type_INTERMEDIATE: "Intermedi",
	keyboard_type_COMPLEX: "Avançat",
	keyboard_type_SCIENTIFIC: "Científic",
	solutions_new_alternative_text: "Nova",
	no_microphone: "No tinc micròfon",
	confirm_replace_audio_message: "Ja hi ha un àudio gravat. Polsa 'Confirma' si vols reemplaçar-lo per un de nou.",
	config_audio_duration_limit_title: "Límit de temps",
	config_audio_duration_limit_subtitle: "Selecciona els segons que l’alumnat tindrà per a gravar-se",
	other_audio_recorder_stimulus_default: "Grava’t explicant el procés de la fotosíntesi.",
	no_mic_available: "No s'ha trobat el micròfon en el dispositiu.",
	no_mic_permission: "Micròfon bloquejat. Asegura't que l'accés està permés.",
	confirm_switching_keyboards_title: "Atenció",
	confirm_switching_keyboards_message: "Les solucions editades s'esborraran en canviar de teclat.",
	math_counting_stimulus_default: "Quantes pomes i llimes necessite per a tenir sis fruites?",
	other_clock_stimulus_default: "Són les 15:30",
	sample_answer_title_box: "Resposta model",
	sample_answer_help: "Pots crear una resposta model que t'ajude a corregir les activitats no autoavaluatives. Aquesta secció només serà visible per al professorat.",
	sample_answer_title: "Afig resposta model",
	sample_answer_subtitle: "Exemple d'una solució model per al professorat.",
	sample_answer_placeholder: "Escriu ací el text",
	other_word_search_stimulus_default: "Troba les paraules següents:",
	word_search_grid_s: "S (6x6)",
	word_search_grid_m: "M (10x10)",
	word_search_grid_l: "L (15x15)",
	word_search_title_box: "Sopa de lletres",
	word_search_help: "Selecciona la grandària de la quadrícula",
	word_search_title: "Quadrícula",
	word_search_subtitle: "Selecciona el nombre de files/columnes",
	config_word_search_random_title: "Posició aleatòria de les paraules",
	config_word_search_random_subtitle: "Les paraules es mostraran en una posició diferent cada vegada que s'hi accedisca.",
	config_word_search_backward_title: "Paraules invertides",
	config_word_search_backward_subtitle: "Pot haver-hi paraules escrites de dreta a esquerra",
	config_word_search_diagonal_title: "Paraules en diagonal",
	config_word_search_diagonal_subtitle: "Pot haver-hi paraules escrites en diagonal",
	word_search_counter_letter: "Límit de lletres",
	config_word_search_allowed_letters_title: "Lletres permeses",
	config_word_search_allowed_letters_subtitle: "Activa per a indicar les lletres permeses",
	confirm_switching_columns_rows_title: "Atenció!",
	confirm_switching_columns_rows_message: "Les següents paraules s'eliminaren:",
	confirm_edit_allowed_letter_title: "Atenció!",
	confirm_edit_allowed_letter_message: "Les paraules que continguen caràcters diferents als indicats s'eliminaran.",
	word_search_preview_title_box: "Previsualització de la sopa de lletres",
	word_search_preview_help: "Així es veuran les solucions en la sopa de lletres",
	word_search_button_generate: "Genera nova",
	word_search_solutions_help: "Indica paraules amb almenys 2 lletres. No es poden utilitzar nombres, espais o caràcters especials.",
	other_crossword_stimulus_default: "Mots encreuats",
	crossword_solutions_help: "Indica paraules amb almenys dues lletres. No es pot utilitzar nombres, espais o caràcters especials",
	crossword_counter_letter: "Límit de lletres",
	crossword_word_out: "No hi ha coincidència entre paraules. Intenta-ho afegint més paraules",
	config_uppercase_lowercase_title: "Selecciona majúscules / minúscules",
	config_uppercase_lowercase_subtitle: "Les paraules es mostraran en majúscules o en minúscules",
	config_uppercase: "Majúscules",
	config_lowercase: "Minúscules",
	crossword_message_min_words: "Necessita mínim {{num_words}} paraules",
	crossword_solutions_text_not_valid: "Paraula no vàlida. Mínim 2 lletres",
	crossword_preview_title_box: "Previsualització dels mots encreuats",
	crossword_preview_help: "Així es veuran les solucions dels mots encreuats",
	crossword_button_generate: "Genera de nou",
	generation_error: "No s'han pogut generar els mots encreuats",
	upload_file_button_drive: "Puja amb Google Drive",
	file_uploader_drive: "Via Google Drive",
	file_uploaded_successfully: "Arxiu enviat correctament",
	files_uploaded_successfully: "Arxius enviats correctament",
	title_penalty_modes: "Punts de penalització",
	subtitle_penalty_mode_none: "Penalitza les respostes fallides pel mateix valor de les respostes encertades. També pots crear la penalització a mida",
	subtitle_penalty_mode_per_response: "Penalitza les respostes fallides pel mateix valor de les respostes encertades. També pots crear la penalització a mida",
	subtitle_penalty_mode_custom: "Penalitza les respostes fallides pel mateix valor de les respostes encertades. També pots crear la penalització a mida",
	penalty_mode_none: "Cap",
	penalty_mode_per_response: "Puntuació de resposta encertada",
	penalty_mode_custom: "Personalitzat",
	config_show_selection_title: "Mostra selecció",
	config_show_selection_subtitle: "L'estudiant veurà assenyalat l'objecte seleccionat",
	alternative_response: "Resposte alternative",
	alternative_responses: "Respostes alternatives",
	config_autosize_box_title: "Caixa amb grandària de resposta",
	config_autosize_box_subtitle: "Activa-ho si desitges que la grandària de la caixa s'adapte a la grandària de la resposta",
	Transcription: "Transcripció",
	other_rating_stimulus_default: "És hora de valorar el contingut!",
	other_rating_tooltip_1_star: "1 estrella",
	other_rating_tooltip_multiple_stars: "{{count}} estrellas",
	other_rating_description_1_star: "No m'ha agradat. M'ha confós i m'ha avorrit.",
	other_rating_description_2_stars: "M'ha agradat més o menys... Algunes coses les he entès millor que d'altres.",
	other_rating_description_3_stars: "M'ha agradat força. L'he entès i m'ha interessat :)",
	other_rating_description_4_stars: "M'ha encantat! L'he trobat interessant i divertit. Vull més!",
	adaptative_choice_levels_config: "Configuració de Nivells",
	adaptative_choice_levels_config_help: "Configura els títols de cada nivell de l'activitat adaptativa",
	adaptative_choice_level_title: "Nivell {{level_number}}",
	adaptative_choice_level_title_label: "Títol del nivell:",
	adaptative_choice_level_title_placeholder: "Escriu el títol d'aquest nivell...",
	other_adaptative_choice_back: "Enrere",
	other_adaptative_choice_next: "Següent"
};
var vl = {
	translations: translations$7
};

var types = {
  multipleChoice: {
    Single: 'Multiple choice – standard',
    Multiple: 'Multiple choice – multiple response',
    TrueFalse: 'True or false',
    BlockLetter: 'Multiple choice – block layout',
    EmotionsSingle: 'Emotions choise - standard'
  },
  choiceMatrix: {
    Table: 'Choice matrix – standard',
    Inline: 'Choice matrix – inline',
    Labels: 'Choice matrix – labels'
  },
  essay: {
    PlainText: 'Essay with plain text',
    ShortText: 'Short text',
    RichText: 'Essay with rich text'
  },
  cloze: {
    Text: 'Cloze with text',
    DropDown: 'Cloze with drop down',
    Association: 'Cloze with drag & drop'
  },
  classify: {
    Classification: 'Classification',
    MatchList: 'Match list',
    OrderList: 'Order list',
    LinkingLines: 'Linking lines',
    OrderListMobile: 'Order list mobile',
    MatchListMobile: 'Match list mobile',
    StickersSeries: 'Stickers series',
    Stickers: 'Stickers'
  },
  labelImage: {
    DragDrop: 'Label image with drag & drop',
    DropDown: 'Label image with drop-down',
    Text: 'Label image with text',
    TextV2: 'LabelImageTextV2',
    DropDownV2: 'LabelImageDropDownV2',
    DragDropV2: 'LabelImageDragDropV2'
  },
  math: {
    ClozeMath: 'Cloze math',
    Counting: 'Counting',
    NumberLine: 'Number line',
    Fraction: 'Fraction',
    CoordinateAxes: 'Coordinate axes',
    Boxplot: 'Boxplot',
    Sum: 'Addition',
    Subtraction: 'Subtraction',
    TransformationsInPlane: 'Transformations in plane',
    LinealFunction: 'Linear function',
    QuadraticFunction: 'Quadratic function',
    PrimeNumberDecomposition: 'Prime number decomposition',
    FindClosestValue: 'Find closest value'
  },
  other: {
    UploadFile: 'Upload file',
    Pencil: 'Pencil',
    ClickToFind: 'Click to find',
    Statement: 'Statement',
    AudioRecorder: 'Audio recorder',
    Clock: 'Clock',
    WordSearch: 'Word search',
    Crossword: 'Crossword',
    PathWay: 'Pathway',
    ReversePathWay: 'Reverse pathway',
    Rating: 'Rating',
    AdaptativeChoice: 'Adaptative choice'
  },
  charts: {
    Pictograph: 'Pictograph',
    Barchart: 'Bar chart',
    LineChart: 'Line chart',
    PieChart: 'Pie chart',
    Flowchart: 'Flowchart',
    Histograms: 'Histograms'
  }
};

var when = function () {
  var fn = function fn(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
      _ref$debug = _ref.debug,
      debug = _ref$debug === void 0 ? false : _ref$debug;
    this.result = false;
    this.caseCounter = 0;
    this.matchedCase = null;
    this.debug = debug;
  };
  fn.prototype.reset = function () {
    this.result = false;
    this.caseCounter = 0;
    this.matchedCase = null;
  };
  fn.prototype["case"] = function (x, value) {
    this.caseCounter += 1;
    if (this.result) return this;
    if (x) {
      this.result = value;
      this.matchedCase = this.caseCounter;
    }
    return this;
  };
  fn.prototype.trace = function () {
    var r = typeof this.result === 'function' ? this.result() : this.result;
    console.log('result ::: ', r);
    console.log('matched case ::: ', this.matchedCase);
    return this;
  };
  fn.prototype.resolve = function () {
    var value = arguments.length > 0 ? arguments[0] : false;
    var returned = this.result !== false ? this.result : value;
    if (this.debug) this.trace();
    this.reset();
    return typeof returned === 'function' ? returned() : returned;
  };
  return function (props) {
    return new fn(props);
  };
}();

var amplitudeEnvironments = {
  NONE: 'none',
  PRODUCTION: 'production',
  DEVELOPMENT: 'development',
  QA: 'qa'
};
function checkAmplitudeEnvironment(env) {
  var available = Object.values(amplitudeEnvironments).find(function (x) {
    return x === env;
  });
  if (available) return true;
  throw new Error("\n  The environment definded for amplitud is not available,\n  Please, use one of the following list:\n    - development\n    - qa\n    - production\n  ");
}
var isEnvironmentInitialized = function isEnvironmentInitialized() {
  return config.amplitudeEnvironment !== amplitudeEnvironments.NONE;
};

var defaultVariants = {};

function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item);
}
function objectDeepMerge(target, source) {
  var output = Object.assign({}, target);
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(function (key) {
      if (isObject(source[key])) {
        var _Object$assign;
        if (!(key in target)) Object.assign(output, (_Object$assign = {}, _Object$assign[key] = source[key], _Object$assign));else output[key] = objectDeepMerge(target[key], source[key]);
      } else {
        var _Object$assign2;
        Object.assign(output, (_Object$assign2 = {}, _Object$assign2[key] = source[key], _Object$assign2));
      }
    });
  }
  return output;
}

var categories = [
	{
		name: "Choice",
		questions: [
			{
				id: "Multiple choice – standard",
				name: "Single choice"
			},
			{
				id: "Multiple choice – multiple response",
				name: "Multiple choice"
			},
			{
				id: "True or false",
				name: "True / False"
			},
			{
				id: "Multiple choice – block layout",
				name: "Multiple choice block"
			},
			{
				id: "Choice matrix – standard",
				name: "Choice matrix table"
			},
			{
				id: "Choice matrix – inline",
				name: "Choice matrix inline,"
			}
		]
	},
	{
		name: "Text input",
		questions: [
			{
				id: "Short text",
				name: "Short text field"
			},
			{
				id: "Cloze with text",
				name: "Fill the blanks with text"
			},
			{
				id: "LabelImageTextV2",
				name: "Label image text"
			}
		]
	},
	{
		name: "Dropdown and drag & drop",
		questions: [
			{
				id: "Cloze with drop down",
				name: "Fill the blanks with dropdown"
			},
			{
				id: "Cloze with drag & drop",
				name: "Fill the blanks with drag & drop"
			},
			{
				id: "LabelImageDropDownV2",
				name: "Label image dropdown"
			},
			{
				id: "LabelImageDragDropV2",
				name: "Label image drag & drop"
			}
		]
	},
	{
		name: "Identify, order and match",
		questions: [
			{
				id: "Click to find",
				name: "Click to find"
			},
			{
				id: "Order list",
				name: "Order list"
			},
			{
				id: "Match list",
				name: "Match list"
			},
			{
				id: "Linking lines",
				name: "Linking lines"
			},
			{
				id: "Classification",
				name: "Classification"
			},
			{
				id: "Word search",
				name: "Word search"
			},
			{
				id: "Crossword",
				name: "Crossword"
			}
		]
	},
	{
		name: "Math",
		questions: [
			{
				id: "Cloze math",
				name: "Cloze math"
			}
		]
	}
];
var addQuestionModalConfig = {
	categories: categories
};

var NONE = '';

var _configEditor, _configExercise;
var LEMONADE_WRAPPER_CLASS = 'lemonade-exercises';
var thousandsSeparatorTypes = {
  NONE: '',
  COMMA: ',',
  POINT: '.',
  SPACE: ' '
};
var decimalSeparatorTypes = {
  COMMA: ',',
  POINT: '.'
};
var autoFocusTypes = {
  NONE: '',
  ENABLED: 'enabled',
  DISABLED: 'disabled'
};
var config = observable({
  lang: 'en',
  langList: {
    ar: ar,
    en: en,
    es: es,
    pt: pt,
    ca: ca,
    gl: gl,
    eu: eu,
    vl: vl
  },
  debounceTime: 500,
  rtl: false,
  assetsQuestionApi: '',
  assetsEditorApi: '',
  assetsQuestionApiDrive: '',
  desmosApiKey: '',
  maxUploadFileSize: 10,
  withFroalaCss: true,
  showFeedback: true,
  showSampleAnswer: false,
  individualFeedbackTooltip: true,
  negativeScore: false,
  mathRenderEngine: '',
  chartsEnable: false,
  mathFieldIcon: true,
  hostName: document ? document.location.host : 'application-host-name',
  amplitudeEnvironment: (amplitudeEnvironments === null || amplitudeEnvironments === void 0 ? void 0 : amplitudeEnvironments.NONE) || 'none',
  googlePicker: {
    clientId: null,
    developerKey: null
  },
  pencilColorList: ['#000', '#828282', '#EB5757', '#F2C94C', '#219653', '#56CCF2', '#BB6BD9'],
  variants: defaultVariants,
  thousandsSeparator: thousandsSeparatorTypes.NONE,
  decimalSeparator: decimalSeparatorTypes.POINT,
  labelImageFontSizeMultiplier: 10,
  graphsHelpMarks: true,
  useMatchListInMobileMode: false,
  useAutoDrop: false,
  useOrderListInMobileMode: NONE,
  inputMathFloating: true,
  attachmentsEnable: false,
  showAIFeedbackGenerator: false,
  showAutoFeedback: false,
  customTranslationsByLang: {},
  audioRecorderDurationLimit: 120,
  showAuthorVariantsEditor: false,
  configEditor: (_configEditor = {}, _configEditor[editorComponents.title] = {
    isVisible: true
  }, _configEditor[editorComponents.hints] = {
    isVisible: true
  }, _configEditor[editorComponents.answerOptions] = {
    imageDefaultSize: {
      height: '124px',
      width: null
    }
  }, _configEditor[editorComponents.questions] = {
    imageDefaultSize: {
      height: '124px',
      width: null
    }
  }, _configEditor),
  keyboards: {
    functions: {
      multiplicationSymbol: DOT_SYMBOL
    }
  },
  configExercise: (_configExercise = {}, _configExercise[types.classify.Classification] = {
    columnCountMax: 5
  }, _configExercise[types.cloze.Text] = {
    isElementFeedbackOnlyNotEmptyValue: true
  }, _configExercise[types.cloze.DropDown] = {
    isElementFeedbackOnlyNotEmptyValue: true
  }, _configExercise[types.cloze.Association] = {
    isElementFeedbackOnlyNotEmptyValue: true
  }, _configExercise[types.choiceMatrix.Table] = {
    isElementFeedbackOnlyNotEmptyValue: true
  }, _configExercise[types.choiceMatrix.Inline] = {
    isElementFeedbackOnlyNotEmptyValue: true
  }, _configExercise[types.labelImage.TextV2] = {
    isElementFeedbackOnlyNotEmptyValue: true
  }, _configExercise[types.labelImage.DragDropV2] = {
    isElementFeedbackOnlyNotEmptyValue: true
  }, _configExercise[types.labelImage.DropDownV2] = {
    isElementFeedbackOnlyNotEmptyValue: true
  }, _configExercise[types.classify.MatchList] = {
    isElementFeedbackOnlyNotEmptyValue: true
  }, _configExercise[types.classify.LinkingLines] = {
    isElementFeedbackOnlyNotEmptyValue: true
  }, _configExercise[types.classify.MatchListMobile] = {
    isElementFeedbackOnlyNotEmptyValue: true
  }, _configExercise[types.classify.OrderList] = {
    isElementFeedbackOnlyNotEmptyValue: true
  }, _configExercise[types.classify.OrderListMobile] = {
    isElementFeedbackOnlyNotEmptyValue: true
  }, _configExercise[types.math.ClozeMath] = {
    isElementFeedbackOnlyNotEmptyValue: true
  }, _configExercise[types.other.WordSearch] = {
    allowedLetters: null
  }, _configExercise[types.other.PathWay] = {
    instructions_position: 'TOP'
  }, _configExercise[types.math.Sum] = {
    showColumnHelp: false
  }, _configExercise[types.math.Subtraction] = {
    showColumnHelp: false
  }, _configExercise),
  groupedQuestionModal: addQuestionModalConfig,
  autoFocus: autoFocusTypes.NONE,
  overwriteTranslations: function overwriteTranslations(langKeys) {
    config.langList[config.lang].translations = _extends({}, config.langList[config.lang].translations, langKeys);
  },
  overwriteTranslationsByLang: function overwriteTranslationsByLang(lang, langKeys) {
    var _config$customTransla;
    var currentValues = ((_config$customTransla = config.customTranslationsByLang) === null || _config$customTransla === void 0 ? void 0 : _config$customTransla[lang]) || {};
    config.customTranslationsByLang[lang] = _extends({}, currentValues, langKeys);
  },
  setLabelImageFontSizeMultiplier: function setLabelImageFontSizeMultiplier(val) {
    this.labelImageFontSizeMultiplier = val;
  },
  setVariants: function setVariants(variants) {
    this.variants = objectDeepMerge(toJS(this.variants), variants);
  },
  setIndividualFeedbackTooltip: function setIndividualFeedbackTooltip(individualFeedbackTooltip) {
    this.individualFeedbackTooltip = individualFeedbackTooltip;
  },
  setShowFeedback: function setShowFeedback(bool) {
    this.showFeedback = bool;
  },
  setShowSampleAnswer: function setShowSampleAnswer(bool) {
    this.showSampleAnswer = bool;
  },
  setDebounceTime: function setDebounceTime(debounceTime) {
    config.debounceTime = debounceTime;
  },
  setLang: function setLang(lang) {
    var _this = this;
    if (lang && this.langList[lang]) {
      runInAction(function () {
        return _this.lang = lang;
      });
    }
  },
  setRTL: function setRTL(rtl) {
    config.rtl = rtl;
  },
  setAssetsQuestionApi: function setAssetsQuestionApi(assetsQuestionApi) {
    config.assetsQuestionApi = assetsQuestionApi;
  },
  setAssetsEditorApi: function setAssetsEditorApi(assetsEditorApi) {
    config.assetsEditorApi = assetsEditorApi;
  },
  setAssetsQuestionApiDrive: function setAssetsQuestionApiDrive(assetsQuestionApiDrive) {
    config.assetsQuestionApiDrive = assetsQuestionApiDrive;
  },
  switchFroalaCss: function switchFroalaCss(withFroalaCss) {
    config.withFroalaCss = withFroalaCss;
  },
  setConfig: function setConfig(conf) {
    Object.assign(this, objectDeepMerge(this, conf));
  },
  setNegativeScore: function setNegativeScore(negativeScore) {
    config.negativeScore = negativeScore;
  },
  setMathRenderEngine: function setMathRenderEngine(engine) {
    config.mathRenderEngine = engine;
    window.mathRenderEngine = engine;
  },
  setChartsEnable: function setChartsEnable(enable) {
    config.chartsEnable = enable;
  },
  setMathFieldIcon: function setMathFieldIcon(bool) {
    config.mathFieldIcon = bool;
  },
  setHostName: function setHostName(str) {
    config.hostName = str;
  },
  setGooglePicker: function setGooglePicker(googlePicker) {
    config.googlePicker = googlePicker;
  },
  setPencilColorList: function setPencilColorList(list) {
    config.pencilColorList = list;
  },
  addToPencilColorList: function addToPencilColorList(list) {
    config.pencilColorList = [].concat(config.pencilColorList, list);
  },
  setInputMathFloating: function setInputMathFloating(value) {
    config.inputMathFloating = value;
  },
  setThousandsSeparator: function setThousandsSeparator(thousandsSeparator) {
    var selectedSeparator = thousandsSeparatorTypes[thousandsSeparator];
    if (selectedSeparator === undefined) {
      console.warn("The selected thousand separator value: " + thousandsSeparator + " is not valid, please select one of the following list:");
      console.table(thousandsSeparatorTypes);
      return false;
    }
    this.thousandsSeparator = selectedSeparator;
  },
  setDecimalSeparator: function setDecimalSeparator(_decimalSeparator) {
    var selectedSeparator = decimalSeparatorTypes[_decimalSeparator];
    if (selectedSeparator === undefined) {
      console.warn("The selected decimal separator value: " + _decimalSeparator + " is not valid, please select one of the following list:");
      console.table(decimalSeparatorTypes);
      return false;
    }
    this.decimalSeparator = selectedSeparator;
  },
  initLemoAmplitude: function initLemoAmplitude(hostName, environment) {
    this.hostName = hostName;
    if (checkAmplitudeEnvironment(environment)) {
      this.amplitudeEnvironment = environment;
    }
  },
  setGraphsHelpMarks: function setGraphsHelpMarks(bool) {
    this.graphsHelpMarks = bool;
  },
  setGroupedQuestionModal: function setGroupedQuestionModal(config) {
    this.groupedQuestionModal = config;
  },
  get onUpdate() {
    return this.lang + this.assetsEditorApi + this.assetsQuestionApi + this.debounceTime.toString() + this.rtl.toString();
  },
  get froalaLang() {
    return this.lang === 'pt' ? 'pt_br' : this.lang;
  },
  get translations() {
    var extraValuesByLang = config.customTranslationsByLang[this.lang] || {};
    var langKeys = defaultValue(this.lang + ".translations", this.langList, '');
    return _extends({}, langKeys, extraValuesByLang);
  },
  get thousandsSeparatorRegx() {
    return when()["case"](this.thousandsSeparator === '.', /\./g)["case"](this.thousandsSeparator === ' ', /\s/g)["case"](this.thousandsSeparator === ',', /,/g).resolve('');
  },
  get isGooglePickerEnabled() {
    return config.googlePicker.clientId && config.googlePicker.developerKey;
  }
});
reaction(function () {
  return config.mathRenderEngine;
}, function (value) {
  window.mathRenderEngine = value;
  console.log('ADD MATH ENGINE ', value);
  addLatex(value);
});

function translate(key) {
  return config.translations[key] || key;
}

function roundToTwo(num) {
  return +(Math.round(num + 'e+2') + 'e-2');
}
function inRange(min, max, num) {
  return num >= min && num <= max;
}
function minMax(min, max, num) {
  return Math.min(Math.max(num, min), max);
}
function secureRandomInt(min, max) {
  var byteArray = new Uint8Array(4);
  var range = max - min + 1;
  var _crypto = window.crypto || window.msCrypto;
  if (_crypto) {
    _crypto.getRandomValues(byteArray);
  } else {
    return 0;
  }
  var maxRange = Math.pow(2, 8 * byteArray.byteLength);
  var random = new DataView(byteArray.buffer).getUint32(0, true) / maxRange;
  return Math.floor(random * range) + min;
}
function mathRandom() {
  var max = 1;
  var min = 0;
  var range = max - min + 1;
  return secureRandomInt(min, max) / range;
}
function generateRandomNumberWithDigits(digits) {
  if (digits <= 0) return 0;
  var min = Math.pow(10, digits - 1);
  var max = Math.pow(10, digits) - 1;
  return secureRandomInt(min, max);
}

var penaltyModes = {
  NONE: 'NONE',
  PER_RESPONSE: 'PER_RESPONSE',
  CUSTOM: 'CUSTOM'
};

var withPenalty = types$1.model({
  penalty: types$1.optional(types$1.number, 0),
  penalty_mode: types$1.optional(types$1.enumeration('penaltyMode', Object.keys(penaltyModes)), penaltyModes.NONE)
}).actions(function (state) {
  return {
    setPenalty: function setPenalty(penalty) {
      state.penalty = penalty;
    },
    setPenaltyMode: function setPenaltyMode(penaltyMode) {
      state.penalty_mode = penaltyMode;
      if (penaltyMode !== penaltyModes.CUSTOM) state.setPenalty(0);
    }
  };
});

function safeSnapshot(val) {
  if (!val) return val;
  try {
    return getSnapshot(val);
  } catch (e) {
    return val;
  }
}

var validationModes = {
  EXACT_MATCH: 'exactMatch',
  PARTIAL_MATCH: 'partialMatch',
  PARTIAL_MATCH_V2: 'partialMatchV2',
  PARTIAL_MATCH_ELEMENT_V2: 'partialMatchElementV2',
  MANUAL: 'manual'
};
function isEvaluationPartial(evaluationtype) {
  return evaluationtype === validationModes.PARTIAL_MATCH || evaluationtype === validationModes.PARTIAL_MATCH_V2 || evaluationtype === validationModes.PARTIAL_MATCH_ELEMENT_V2;
}
var AltResponse = types$1.model({
  value: types$1.frozen(),
  score: types$1.optional(types$1.number, 1)
}).actions(function (state) {
  return {
    setValue: function setValue(value) {
      state.value = value;
    },
    addEmptyValue: function addEmptyValue(newValue) {
      state.value = [].concat(state.value, [newValue]);
    },
    addEmptyValueIndex: function addEmptyValueIndex(indexAdd, newValue) {
      state.value = [].concat(state.value.slice(0, indexAdd), [newValue], state.value.slice(indexAdd));
    },
    addNewValue: function addNewValue(val) {
      state.value = [].concat(state.value, [val]);
    },
    removeValueAt: function removeValueAt(idx) {
      state.value = state.value.filter(function (_, i) {
        return idx !== i;
      });
    },
    removeValue: function removeValue(val) {
      state.value = state.value.filter(function (item) {
        return item !== val;
      });
    }
  };
});
var ValidationBaseModel = types$1.compose(withPenalty, types$1.model({
  scoring_type: types$1.optional(types$1.enumeration(Object.values(validationModes)), 'exactMatch'),
  score: types$1.optional(types$1.number, 1),
  value: types$1.frozen(),
  alt_responses: types$1.optional(types$1.array(AltResponse), []),
  immediateFeedback: types$1.optional(types$1["boolean"], false),
  penalty: types$1.optional(types$1.number, 0),
  raw: types$1.frozen()
}).actions(function (state) {
  return {
    setScore: function setScore(val) {
      var currentVal = val || 1;
      state.score = parseInt(currentVal, 10);
    },
    setImmediateFeedback: function setImmediateFeedback(value) {
      state.immediateFeedback = value;
      if (value) state.alt_responses = [];
    },
    setScoringType: function setScoringType(val) {
      state.scoring_type = val;
      if (val === validationModes.EXACT_MATCH || val === validationModes.MANUAL) {
        state.setPenaltyMode(penaltyModes.NONE);
      }
    },
    setPenalty: function setPenalty(penalty) {
      state.penalty = penalty;
    },
    removeValue: function removeValue(val) {
      state.value = state.value.filter(function (item) {
        return item !== val;
      });
      state.alt_responses.forEach(function (res) {
        return res.removeValue(val);
      });
    },
    resetValues: function resetValues(len, empty) {
      var resetVal = new Array(len).fill(empty);
      state.value = resetVal;
      state.alt_responses.forEach(function (res) {
        res.value = resetVal;
      });
    },
    addValue: function addValue(val) {
      if (!state.hasValue(val)) state.value = [].concat(state.value, [val]);
    },
    addNewValue: function addNewValue(val) {
      state.value = [].concat(state.value, [val]);
      state.alt_responses.forEach(function (res) {
        return res.addNewValue(val);
      });
    },
    createAlternativeSolution: function createAlternativeSolution(data) {
      state.alt_responses = [].concat(state.alt_responses, [data]);
    },
    updateSolution: function updateSolution(idx, value) {
      if (idx > 0) {
        state.updateAlternative(idx, {
          score: state.alt_responses[idx - 1].score,
          value: value
        });
      } else {
        state.setValue(value);
      }
    },
    findAndUpdateValue: function findAndUpdateValue(oldValue, newValue) {
      var replaceValue = function replaceValue(valueList) {
        return valueList.map(function (val) {
          return val.toString() === oldValue.toString() ? newValue : val;
        });
      };
      state.value = replaceValue(state.value);
      state.alt_responses.forEach(function (resp) {
        resp.value = replaceValue(resp.value);
      });
    },
    updateValueIndex: function updateValueIndex(idx, newValue) {
      var replaceValue = function replaceValue(valueList) {
        return function (arr) {
          arr[idx] = newValue;
          return arr;
        }([].concat(valueList));
      };
      state.value = replaceValue(state.value);
      state.alt_responses.forEach(function (resp) {
        resp.value = replaceValue(resp.value);
      });
    },
    updateAlternative: function updateAlternative(idx, data) {
      state.alt_responses = state.alt_responses.map(function (item, i) {
        return i === idx - 1 ? data : item;
      });
    },
    changeScore: function changeScore(idx, score) {
      if (idx === 0) {
        state.score = score;
      } else {
        state.alt_responses[idx - 1].score = score;
      }
    },
    removeSolution: function removeSolution(idx) {
      if (idx > 0) state.alt_responses = state.alt_responses.filter(function (_, i) {
        return i !== idx - 1;
      });
    },
    resetSolutions: function resetSolutions() {
      state.alt_responses = [];
    },
    setValue: function setValue(val) {
      state.value = val;
    },
    removeValueAt: function removeValueAt(idx) {
      state.value = state.value.filter(function (_, i) {
        return idx !== i;
      });
      state.alt_responses.forEach(function (alt) {
        return alt.removeValueAt(idx);
      });
    },
    updateNotifier: function updateNotifier() {
      getParent(state).updateNotifier();
    },
    removeAltResponses: function removeAltResponses() {
      state.alt_responses.forEach(function (response) {
        return destroy(response);
      });
    },
    deleteValuesDuplicate: function deleteValuesDuplicate() {
      function getValueWithoutDuplicates(value) {
        var valuesUsed = [];
        return value.map(function (item) {
          return item.filter(function (val) {
            var toRet = valuesUsed.indexOf(val) < 0;
            if (valuesUsed.indexOf(val) < 0) valuesUsed.push(val);
            return toRet;
          });
        });
      }
      state.value = getValueWithoutDuplicates(state.value);
      state.alt_responses.forEach(function (res) {
        res.value = getValueWithoutDuplicates(res.value);
      });
    },
    clearAllSolutions: function clearAllSolutions() {
      state.setValue('');
      state.alt_responses.forEach(function (response) {
        return response.setValue('');
      });
    },
    setAsMainSolution: function setAsMainSolution(idx) {
      if (idx === 0) return false;
      var mainSolution = safeSnapshot(state.alt_responses[idx - 1].value);
      state.alt_responses.splice(idx - 1, 1);
      state.alt_responses.unshift({
        value: state.value,
        score: 1
      });
      state.value = mainSolution;
      return true;
    }
  };
}).views(function (state) {
  return {
    hasValue: function hasValue(val) {
      return state.value.indexOf(val) > -1;
    },
    checkValidResponse: function checkValidResponse(val) {
      return state.solutionList.reduce(function (acc, next) {
        return next.value.includes(val) || acc;
      }, false);
    },
    getSolutionPoints: function getSolutionPoints(idx) {
      return idx === 0 ? state.score : defaultValue(idx - 1 + ".score", state.alt_responses, 0);
    },
    getSolutionPointsPercent: function getSolutionPointsPercent(idx) {
      return Math.round(this.getSolutionPoints(idx) * 100);
    },
    get solutionList() {
      return [{
        value: state.value,
        score: state.score
      }].concat(state.alt_responses.map(function (alt) {
        return getSnapshot(alt);
      }));
    },
    get freshSolution() {
      return when()["case"](typeof state.value === 'string', function () {
        return '';
      })["case"](Array.isArray(state.value) && Array.isArray(state.value[0]), function () {
        return state.value.map(function () {
          return [''];
        });
      }).resolve(function () {
        return state.value.map(function () {
          return '';
        });
      });
    },
    getAltValuesFrom: function getAltValuesFrom(idx) {
      return state.alt_responses.map(function (alt) {
        return alt.value[idx];
      });
    },
    get output() {
      var isEvaluable = getParent(state).isEvaluable;
      return {
        scoring_type: isEvaluable ? validationModes.MANUAL : state.scoring_type,
        immediateFeedback: state.immediateFeedback,
        alt_responses: getSnapshot(state.alt_responses),
        valid_response: {
          score: state.score,
          value: state.value
        },
        penalty: state.penalty
      };
    }
  };
}));
function getAllScoresPre(snapshot) {
  var allScores = [];
  if (snapshot) {
    if (snapshot.valid_response && snapshot.valid_response.score !== undefined) allScores.push(snapshot.valid_response.score);
    if (!snapshot.immediateFeedback) {
      if (snapshot.alt_responses) {
        snapshot.alt_responses.forEach(function (alt_response) {
          if (alt_response && alt_response.hasOwnProperty('score') && alt_response.score !== undefined) {
            allScores.push(alt_response.score);
          }
        });
      }
    }
  }
  return allScores;
}
function getMaxScorePre(snapshot) {
  var allScrores = getAllScoresPre(snapshot);
  var max = 0;
  for (var i = 0; i <= allScrores.length; i++) {
    if (max < allScrores[i]) {
      max = allScrores[i];
    }
  }
  return max;
}
function getNewScore(score, maxScore, multiplyingFactor) {
  if (maxScore > 1) {
    return roundToTwo(score * multiplyingFactor / 100);
  } else return score;
}
var ValidationModel = types$1.snapshotProcessor(ValidationBaseModel, {
  preProcessor: function preProcessor(snapshot) {
    return _preProcessor(snapshot);
  },
  postProcessor: function postProcessor(snapshot) {
    return _postProcessor(snapshot);
  }
});
function _postProcessor(snapshot) {
  return {
    scoring_type: snapshot.scoring_type,
    immediateFeedback: snapshot.immediateFeedback,
    alt_responses: snapshot.alt_responses,
    valid_response: {
      score: snapshot.score,
      value: snapshot.value
    },
    penalty_mode: snapshot.penalty_mode,
    penalty: snapshot.penalty
  };
}
function _preProcessor(snapshot) {
  var maxScore = getMaxScorePre(snapshot);
  var multiplyingFactor = 100 / maxScore;
  var _alt_responses = [];
  var _score = 1;
  if (snapshot && snapshot.valid_response) {
    if (!snapshot.immediateFeedback) {
      if (snapshot.alt_responses) {
        _alt_responses = snapshot.alt_responses.map(function (alt_response) {
          return _extends({}, alt_response, {
            score: alt_response.score && alt_response.score > 0 ? getNewScore(alt_response.score, maxScore, multiplyingFactor) : alt_response.score
          });
        });
      } else {
        _alt_responses = snapshot.alt_responses;
      }
    }
    _score = snapshot.valid_response.score > 0 ? getNewScore(snapshot.valid_response.score, maxScore, multiplyingFactor) : snapshot.valid_response.score;
  }
  if (snapshot) {
    if (snapshot.valid_response) {
      return _extends({}, snapshot, {
        alt_responses: _alt_responses,
        score: _score,
        immediateFeedback: snapshot.immediateFeedback,
        penalty: snapshot.penalty,
        penalty_mode: snapshot.penalty_mode,
        value: snapshot.valid_response.value
      });
    } else {
      return snapshot;
    }
  } else {
    return {
      scoring_type: validationModes.MANUAL
    };
  }
}

var defaultData = function defaultData(dataId) {
  var _types$choiceMatrix$I;
  return (_types$choiceMatrix$I = {}, _types$choiceMatrix$I[types.choiceMatrix.Inline] = getTemplate({
    name: types.choiceMatrix.Inline,
    stimulus: 'choice_matrix_inline_stimulus_default',
    type: 'inline'
  }), _types$choiceMatrix$I[types.choiceMatrix.Table] = getTemplate({
    name: types.choiceMatrix.Table,
    stimulus: 'choice_matrix_inline_stimulus_default',
    type: 'table'
  }), _types$choiceMatrix$I)[dataId];
};
function getTemplate(_ref) {
  var name = _ref.name,
    stimulus = _ref.stimulus,
    type = _ref.type;
  return {
    title: '',
    type: 'choicematrix',
    metadata: {
      name: name
    },
    data: {
      options: [translate('option') + " 1", translate('option') + " 2"],
      feedback_responses: [],
      stems: [translate('enunciated') + " 1", translate('enunciated') + " 2", translate('enunciated') + " 3", translate('enunciated') + " 4"],
      stimulus: "<p>" + translate(stimulus) + "</p>",
      type: 'choicematrix',
      ui_style: {
        type: type,
        horizontal_lines: false
      },
      validation: {
        scoring_type: validationModes.PARTIAL_MATCH_V2,
        penalty: 0,
        valid_response: {
          score: 1,
          value: [[0], [0], [1], [1]]
        }
      }
    }
  };
}
function getDefaultData(dataId) {
  var reference = uuid();
  return _extends({}, defaultData(dataId), {
    reference: reference
  });
}

function commitFeedbackMessages(_ref) {
  var state = _ref.state,
    collection = _ref.collection,
    condition = _ref.condition;
  if (!state.feedback.config.visibility) return false;
  state.feedback.setResponseMessages(collection.reduce(function (acc, next, idx) {
    if (!condition(next)) return acc;
    return [].concat(acc, [{
      idx: idx,
      value: next.feedback,
      mode: next.isValid ? 'success' : 'error',
      optionIndex: next.index
    }]);
  }, []));
}

var Response = types$1.model({
  value: types$1.frozen(),
  score: types$1.optional(types$1.number, 0)
}).actions(function (state) {
  return {
    setValue: function setValue(value) {
      state.value = value;
    }
  };
});
var QuestionValidationModel = types$1.compose(Response, withPenalty, types$1.model({
  scoring_type: types$1.optional(types$1.enumeration(Object.values(validationModes)), validationModes.MANUAL),
  alt_responses: types$1.optional(types$1.array(Response), []),
  immediateFeedback: types$1.optional(types$1["boolean"], false),
  penalty: types$1.optional(types$1.number, 0)
}).actions(function (state) {
  return {
    setImmediateFeedback: function setImmediateFeedback(immediateFeedback) {
      state.immediateFeedback = immediateFeedback;
    },
    setPenalty: function setPenalty(penalty) {
      state.penalty = penalty;
    }
  };
}).views(function (state) {
  return {
    hasValue: function hasValue(val) {
      return state.value.indexOf(val) > -1;
    },
    get solutionList() {
      return [{
        value: state.value,
        score: state.score
      }].concat(state.alt_responses.map(function (alt) {
        return getSnapshot(alt);
      }));
    },
    checkValidResponse: function checkValidResponse(val) {
      return state.solutionList.reduce(function (acc, next) {
        return next.value.includes(val) || acc;
      }, false);
    }
  };
}));
var QuestionValidationModel$1 = types$1.snapshotProcessor(QuestionValidationModel, {
  preProcessor: function preProcessor(snapshot) {
    if (!snapshot) return {};
    return {
      scoring_type: snapshot.scoring_type,
      alt_responses: defaultValue('alt_responses', snapshot, []),
      score: snapshot.valid_response.score,
      value: snapshot.valid_response.value,
      immediateFeedback: snapshot.immediateFeedback,
      penalty: snapshot.penalty
    };
  },
  postProcessor: function postProcessor(snapshot) {
    return {
      scoring_type: snapshot.scoring_type,
      immediateFeedback: snapshot.immediateFeedback,
      alt_responses: snapshot.alt_responses,
      valid_response: {
        score: snapshot.score,
        value: snapshot.value
      },
      penalty: snapshot.penalty
    };
  }
});

var withHidrateQuestionPreviewQuestionBaseModel = types$1.model({}).actions(function (state) {
  return {
    hydrateQuestionPreview: function hydrateQuestionPreview(rawData) {
      return hydrateQuestionPreviewFn(state, rawData, false);
    },
    onHydrateQuestionPreview: function onHydrateQuestionPreview() {}
  };
});
function hydrateQuestionPreviewFn(state, rawData, isLemonadeBaseModel) {
  if (state.isSolutionsMode) return false;
  try {
    var _state$keyboard, _state$keyboard$updat;
    var data = state.createSnapshot(rawData);
    var prevAssetsQuestionApi = state.assetsQuestionApi;
    var prevAssetsQuestionApiDrive = state.assetsQuestionApiDrive;
    applySnapshot(state, data);
    state === null || state === void 0 ? void 0 : (_state$keyboard = state.keyboard) === null || _state$keyboard === void 0 ? void 0 : (_state$keyboard$updat = _state$keyboard.updateFromUIStyle) === null || _state$keyboard$updat === void 0 ? void 0 : _state$keyboard$updat.call(_state$keyboard, data.ui_style);
    if (isLemonadeBaseModel) {
      state.validation = _preProcessor(rawData.data.validation);
    }
    state.setIsSolutionMode(false);
    state.setAssetsQuestionApi(prevAssetsQuestionApi);
    state.setAssetsQuestionApiDrive && state.setAssetsQuestionApiDrive(prevAssetsQuestionApiDrive);
    state.onHydrateQuestionPreview();
  } catch (e) {
    console.error(e);
  }
  return new Promise(function (resolve) {
    return setTimeout(resolve, 100);
  });
}

var autoFeedbackStatus = {
  NONE: 'none',
  START: 'start',
  CANCELLED: 'cancelled'
};
var MAX_AUTO_FEEDBACK_COUNTER = 3;
var AUTO_FEEDBACK_DURATION = 2000;
var withShowSolutions = types$1.model({
  autoFeedback: types$1.optional(types$1.enumeration(Object.values(autoFeedbackStatus)), autoFeedbackStatus.NONE),
  internalAutoFeedback: types$1.optional(types$1["boolean"], false),
  showSolution: types$1.optional(types$1["boolean"], false),
  cacheResponse: types$1.optional(types$1.frozen(), []),
  cachePoints: types$1.optional(types$1.number, 0),
  interval: types$1.maybeNull(types$1.number),
  intervalCounter: types$1.optional(types$1.number, 0)
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      var eq = function eq(val) {
        return state.autoFeedback === val;
      };
      reaction(function () {
        return state.isEvaluated && eq(autoFeedbackStatus.NONE);
      }, function (bool) {
        return bool && state.initAutoFeedback();
      });
      reaction(function () {
        return !state.isEvaluated && eq(autoFeedbackStatus.START);
      }, function (bool) {
        return bool && state.resetCache();
      });
    },
    beforeDestroy: function beforeDestroy() {
      state.resetCache(state.interval);
    },
    showAutoFeedback: function showAutoFeedback(status) {
      state.autoFeedback = status;
    },
    saveCache: function saveCache() {
      var _state$getFormatedUse;
      state.cacheResponse = ((_state$getFormatedUse = state.getFormatedUserResponse) === null || _state$getFormatedUse === void 0 ? void 0 : _state$getFormatedUse.call(state)) || state.getUserResponse();
      state.cachePoints = isNaN(state.points) ? -1 : state.points;
    },
    clearFeedbackInterval: function clearFeedbackInterval() {
      clearInterval(state.interval);
      state.internalAutoFeedback = false;
      state.intervalCounter = 0;
    },
    resetCache: function resetCache() {
      state.clearFeedbackInterval();
      state.autoFeedback = autoFeedbackStatus.NONE;
      state.cacheResponse = [];
      state.cachePoints = 0;
    },
    cancelAutoFeedback: function cancelAutoFeedback() {
      state.clearFeedbackInterval();
      state.autoFeedback = autoFeedbackStatus.CANCELLED;
      state.applyShowSolutions(false);
    },
    applyShowSolutions: function applyShowSolutions(bool) {
      var _state$getValidRespon;
      var validResponses = ((_state$getValidRespon = state.getValidResponses) === null || _state$getValidRespon === void 0 ? void 0 : _state$getValidRespon.call(state)) || state.getSolutions();
      state.setResponse(bool ? validResponses : state.cacheResponse);
    },
    initAutoFeedback: function initAutoFeedback() {
      var _state$ui_style;
      state.saveCache();
      if (state.isPreviewMode) return false;
      if (state.avoidAutoFeedback) return false;
      if (!config.showAutoFeedback) return false;
      if (state !== null && state !== void 0 && (_state$ui_style = state.ui_style) !== null && _state$ui_style !== void 0 && _state$ui_style.cancel_auto_feedback) return false;
      if (state.isAutoFeedbackRunning) return false;
      if (state.points === 1) return false;
      state.showAutoFeedback(autoFeedbackStatus.START);
      clearInterval(state.interval);
      state.interval = setInterval(function () {
        !state.isEvaluated || state.intervalCounter >= MAX_AUTO_FEEDBACK_COUNTER ? state.clearFeedbackInterval() : state.runAutoFeedback();
      }, AUTO_FEEDBACK_DURATION);
    },
    runAutoFeedback: function runAutoFeedback() {
      if (!state.isAutoFeedbackRunning) {
        clearInterval(state.interval);
        return false;
      }
      var bool = !state.internalAutoFeedback;
      state.internalAutoFeedback = bool;
      state.applyShowSolutions(bool);
      state.incrementIntervalCounter();
    },
    incrementIntervalCounter: function incrementIntervalCounter() {
      if (!state.internalAutoFeedback) {
        state.intervalCounter = state.intervalCounter + 1;
      }
    },
    showSolutions: function showSolutions(bool) {
      if (bool === void 0) {
        bool = true;
      }
      state.cancelAutoFeedback();
      state.applyShowSolutions(bool);
      state.showSolution = bool;
      state.updateNotifier();
    }
  };
}).views(function (state) {
  return {
    getRealUserResponse: function getRealUserResponse(response) {
      return state.showSolution || state.internalAutoFeedback ? state.cacheResponse : response;
    },
    get isAutoFeedbackRunning() {
      return state.autoFeedback === autoFeedbackStatus.START;
    }
  };
});

var HintsModel = types$1.model({
  hintList: types$1.optional(types$1.array(types$1.string), []),
  isVisible: types$1.optional(types$1["boolean"], false),
  currentHintIndex: types$1.optional(types$1.number, 0)
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      onAction(getParent(state), function (_ref) {
        var name = _ref.name;
        if (name === 'reset') {
          state.hideHint();
        }
      });
    },
    addHint: function addHint(hint) {
      state.hintList.push(hint);
      getParent(state).updateNotifier();
    },
    resetHints: function resetHints() {
      state.hintList = [];
      getParent(state).updateNotifier();
    },
    onUpdateHint: function onUpdateHint(index, value) {
      if (index < state.hintList.length) state.hintList[index] = value;
      getParent(state).updateNotifier();
    },
    showHint: function showHint() {
      state.isVisible = true;
    },
    hideHint: function hideHint() {
      state.isVisible = false;
    }
  };
}).views(function (state) {
  return {
    get hasHints() {
      return state.hintList.toString().length > 0;
    },
    get currentHint() {
      return state.hasHints && state.isVisible ? state.hintList[state.currentHintIndex] : undefined;
    }
  };
});
var HintsModel$1 = types$1.snapshotProcessor(HintsModel, {
  preProcessor: function preProcessor(snapshot) {
    var hintList = snapshot || [];
    return {
      hintList: hintList
    };
  },
  postProcessor: function postProcessor(snapshot) {
    return snapshot.hintList;
  }
});

var AttemptsModel = types$1.model({
  attempts: types$1.optional(types$1.number, 0),
  currentAttempt: types$1.optional(types$1.number, 0)
}).actions(function (state) {
  return {
    setAttempts: function setAttempts(attempts) {
      state.attempts = attempts;
    },
    setCurrentAttempt: function setCurrentAttempt(attempt) {
      state.currentAttempt = attempt;
    },
    addAttempt: function addAttempt() {
      state.currentAttempt = Math.min(state.attempts, state.currentAttempt + 1);
    },
    reset: function reset() {
      state.currentAttempt = 0;
    }
  };
}).views(function (state) {
  return {
    get attemptAvailable() {
      return state.attempts > 0 && state.attempts > state.currentAttempt;
    }
  };
});
var initialValue = {};
var AttemptsModel$1 = types$1.snapshotProcessor(AttemptsModel, {
  postProcessor: function postProcessor(snapshot) {
    return {
      attempts: snapshot.attempts
    };
  }
});

function splitAt(list, size) {
  return list.reduce(function (acc, next, idx) {
    if (idx % size === 0) acc.push([next]);else acc[acc.length - 1].push(next);
    return acc;
  }, []);
}
function shuffle(array) {
  for (var i = array.length - 1; i > 0; i--) {
    var j = secureRandomInt(0, i);
    var temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
}
var sortArrayItem = function sortArrayItem(source, destination, arr) {
  return function (cleanArray) {
    return when()["case"](source === destination, function () {
      return arr;
    })["case"](destination >= arr.length - 1, function () {
      return [].concat(cleanArray, [arr[source]]);
    })["case"](destination === 0, function () {
      return [arr[source]].concat(cleanArray);
    }).resolve(function () {
      return cleanArray.reduce(function (acc, next, idx) {
        return idx === destination ? [].concat(acc, [arr[source], next]) : [].concat(acc, [next]);
      }, []);
    });
  }(arr.filter(function (i, idx) {
    return idx !== source;
  }));
};
var last = function last(arr) {
  return arr[arr.length - 1];
};
function compareFlatArray(array1, array2, count) {
  if (count === void 0) {
    count = 0;
  }
  if (count === array2.length) return true;
  return array1[count] === array2[count] ? compareFlatArray(array1, array2, count + 1) : false;
}
function rmItem(idx, arr) {
  return [].concat(arr.slice(0, idx), arr.slice(idx + 1, arr.length));
}
function flatten(list) {
  return [].concat.apply([], list);
}
function sortAndStringify(arr) {
  if (!arr || arr.length === 0) return '';
  return arr.slice().sort(function (a, b) {
    return a < b ? -1 : 1;
  }).toString();
}
function createRandomIndexes(arr) {
  return shuffle(arr.map(function (_, idx) {
    return idx;
  }));
}
function swapArrayElements(indexA, indexB, arr) {
  var temp = arr[indexA];
  arr[indexA] = arr[indexB];
  arr[indexB] = temp;
  return arr;
}
function reject(iteratorFunction, array) {
  return array.filter(function (item) {
    return !iteratorFunction(item);
  });
}
function removeDuplicates(arr) {
  return arr.reduce(function (acc, next) {
    return acc.includes(next) ? acc : [].concat(acc, [next]);
  }, []);
}
function compareArray(a1, a2) {
  var i = a1.length;
  if (i !== a2.length) return false;
  while (i--) {
    if (a1[i] !== a2[i]) return false;
  }
  return true;
}

var FeedbackConfigModel = types$1.model({
  visibility: types$1.optional(types$1["boolean"], true),
  hasGlobalFeedback: types$1.optional(types$1["boolean"], false),
  hasSpecificFeedback: types$1.optional(types$1["boolean"], false),
  sequence: types$1.optional(types$1.enumeration('sequence', ['stack', 'cyclic', 'random']), 'stack')
}).actions(function (state) {
  return {
    setVisibility: function setVisibility(visibility) {
      state.visibility = visibility;
    },
    setSequence: function setSequence(sequence) {
      state.sequence = sequence;
    },
    setGlobalFeedback: function setGlobalFeedback(bool) {
      state.hasGlobalFeedback = bool;
    },
    setSpecificFeedback: function setSpecificFeedback(bool) {
      state.hasSpecificFeedback = bool;
    }
  };
});

var modes = {
  success: 'success',
  error: 'error',
  none: ''
};
var FeedbackResponseModel = types$1.model({
  idx: types$1.maybe(types$1.number),
  value: types$1.string,
  mode: types$1.optional(types$1.enumeration('mode', Object.values(modes)), ''),
  optionIndex: types$1.maybe(types$1.number)
}).actions(function (state) {
  return {
    update: function update(data) {
      applySnapshot(state, _extends({}, getSnapshot(state), data));
    }
  };
}).views(function (state) {
  return {
    get localIndex() {
      var parent = getParent(state);
      return parent.findIndex(function (children) {
        return children === state;
      }) + 1;
    }
  };
});

var FeedbackModel = types$1.model({
  successMessage: types$1.optional(types$1.string, ''),
  errorMessages: types$1.optional(types$1.array(types$1.string), []),
  responseMessages: types$1.optional(types$1.array(FeedbackResponseModel), []),
  config: types$1.optional(FeedbackConfigModel, {
    visibility: config.showFeedback,
    sequence: 'stack'
  })
}).actions(function (state) {
  return {
    sendUpdate: function sendUpdate() {
      getParent(state).updateNotifier();
    },
    setSuccessMessage: function setSuccessMessage(successMessage) {
      state.successMessage = successMessage;
      state.sendUpdate();
    },
    setErrorString: function setErrorString(errorMessage) {
      errorMessage === '' ? state.errorMessages = [] : state.errorMessages[0] = errorMessage;
      state.sendUpdate();
    },
    setErrorMessages: function setErrorMessages(errorMessages) {
      errorMessages.length === 1 && errorMessages[0] === '' ? state.errorMessages = [] : state.errorMessages = errorMessages;
      state.sendUpdate();
    },
    setResponseMessages: function setResponseMessages(responseMessages) {
      state.responseMessages = responseMessages;
      state.sendUpdate();
    },
    addErrorMessages: function addErrorMessages(errorMessage) {
      state.errorMessages.push(errorMessage);
      state.sendUpdate();
    },
    removeErrorMessage: function removeErrorMessage(idx) {
      state.errorMessages = rmItem(idx, state.errorMessages);
      state.sendUpdate();
    },
    reset: function reset() {
      state.responseMessages = [];
    }
  };
}).views(function (state) {
  return {
    get withFeedbackPanel() {
      return config.showFeedback;
    },
    get currentAttempt() {
      var _getParent;
      var attempts = (_getParent = getParent(state)) === null || _getParent === void 0 ? void 0 : _getParent.attempts;
      if (!attempts) return 1;
      return attempts.attempts === 0 ? 1 : attempts.currentAttempt;
    },
    get hasErrors() {
      return when()["case"](state.errorMessages.length === 0, function () {
        return false;
      })["case"](state.errorMessages.length === 1 && state.errorMessages[0].length === 0, function () {
        return false;
      }).resolve(function () {
        return true;
      });
    },
    get errorMessage() {
      var errorsLength = state.errorMessages.length;
      return when()["case"](!state.hasErrors, function () {
        return '';
      })["case"](errorsLength >= state.currentAttempt, function () {
        return getResponse(state.errorMessages[state.currentAttempt - 1], modes.error);
      }).resolve(getResponse(last(state.errorMessages), modes.error));
    },
    get currentFeedback() {
      var parent = getParent(state);
      var showErrorMessage = parent.points <= 0 || parent.showSolution || parent.isAutoFeedbackRunning;
      var exerciseFeedback = when()["case"](!parent, function () {
        return '';
      })["case"](!parent.isEvaluable, function () {
        return '';
      })["case"](state.currentAttempt === 0, function () {
        return '';
      })["case"](showErrorMessage, function () {
        return state.errorMessage;
      })["case"](state.successMessage === '', function () {
        return '';
      }).resolve(function () {
        return getResponse(state.successMessage, modes.success);
      });
      return [].concat(exerciseFeedback !== '' ? [exerciseFeedback] : [], state.responseMessages);
    },
    get globalFeedback() {
      var result = state.currentFeedback.filter(function (_ref) {
        var optionIndex = _ref.optionIndex;
        return optionIndex === undefined;
      });
      return result.length > 0 ? result[0] : undefined;
    },
    get individualFeedback() {
      return state.currentFeedback.filter(function (_ref2) {
        var optionIndex = _ref2.optionIndex;
        return optionIndex !== undefined;
      });
    }
  };
});
function getResponse(value, mode) {
  return {
    value: value,
    mode: mode
  };
}
var initialValue$1 = {
  successMessage: '',
  errorMessages: [],
  config: {
    visibility: true,
    sequence: 'stack'
  }
};

function addLastSlash(path) {
  return path === '' ? '' : path[path.length - 1] === '/' ? path : path + '/';
}

function removeTags(str) {
  return str.replace(/(<([^>]+)>)/gi, '');
}
function findAbsolutePathSrc(str) {
  return str.match(/src=(\\)?"(f|ht)tps*:\/\//) || str.match(/src=(\\)?"\/\//);
}
function findAbsolutePath(str) {
  return str.match(/(f|ht)tps*:\/\//) || str.match(/^\/\//);
}
function appendPathSrc(path, str) {
  if (findAbsolutePathSrc(str)) return "<img " + str;
  return str.replace(/(.*)(src=\\")(.*)(\\")/, "<img $1$2" + path + "$3$4");
}
function addFullImagePaths(path, data) {
  return JSON.parse(JSON.stringify(data).split(/<img /g).reduce(function (acc, next, idx) {
    return idx === 0 ? next : acc + appendPathSrc(path, next);
  }, ''));
}
function withBasePath(basePath, data) {
  return !data || basePath.length === 0 ? data : addFullImagePaths(basePath, data);
}

var hasData = function hasData(val) {
  return val && val.toString().length > 0;
};
function extractText(strToParse, strStart, strFinish) {
  var toRet = null;
  if (strToParse && strStart && strFinish) {
    var matches = strToParse.match(strStart + '(.*?)' + strFinish);
    if (matches && matches.length > 1) {
      toRet = matches[1];
    }
  }
  return toRet;
}
function getCountWords(str) {
  if (str.trim().length === 0) {
    return 0;
  } else return str.trim().split(/\s+/).length;
}
function kebabCase(str) {
  return str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g).join('-').toLowerCase();
}
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function getSrc(src, basePath) {
  return findAbsolutePath(src) || !hasData(basePath) ? src : "" + addLastSlash(basePath) + src;
}

var withBasePathModel = types$1.model({
  basePath: types$1.optional(types$1.string, '')
}).actions(function (state) {
  return {
    setBasePath: function setBasePath(basePath) {
      state.basePath = basePath;
    }
  };
}).views(function (state) {
  return {
    withBasePath: function withBasePath(src) {
      return getSrc(src, state.basePath);
    }
  };
});

var withCommonParams = types$1.compose(withBasePathModel, types$1.model({}).actions(function (state) {
  return {
    setCommonParamsFn: function setCommonParamsFn(params) {
      var basePath = params.basePath;
      state.setBasePath(basePath);
    },
    setCommonParams: function setCommonParams(params) {
      throw new Error('Abstract method setCommonParams not implemented');
    }
  };
}).views(function (state) {
  return {};
}));
function setCommonsParamsStoreFn(store, exerciseData, props) {
  store.setCommonParams(getCommonParams(exerciseData, props));
}
function getCommonParams(exerciseData, props) {
  var basePath = props.basePath,
    assetsQuestionApi = props.assetsQuestionApi,
    assetsEditorApi = props.assetsEditorApi;
  return {
    basePath: basePath,
    assetsQuestionApi: assetsQuestionApi,
    assetsEditorApi: assetsEditorApi
  };
}

var userStatus = {
  FINISHED: 'FINISHED',
  LOCKED: 'LOCKED',
  NONE: 'NONE'
};
var ResponseFromDataModel = types$1.model({
  value: types$1.maybe(types$1.frozen()),
  status: types$1.optional(types$1.enumeration('userStatus', Object.values(userStatus)), userStatus.NONE)
}).actions(function (state) {
  var parent = getParent(state);
  return {
    init: function init() {
      if (!state.value) return false;
      if (state.isSolutionMode) return false;
      state.applyResponse();
      state.applyStatus();
    },
    applyResponse: function applyResponse() {
      if (state.value) parent.setResponse(state.value);
    },
    applyStatus: function applyStatus() {
      var eq = function eq(val) {
        return state.status === val;
      };
      if (!eq(userStatus.NONE)) getParent(state).clearFeedbackInterval();
      if (eq(userStatus.FINISHED)) parent.checkAnswers();
      if (eq(userStatus.LOCKED)) parent.setDisabled(true);
    }
  };
});

var questionContext = {
  REVISION: 'REVISION',
  NONE: 'NONE'
};
var ContextModel = types$1.model({
  status: types$1.optional(types$1.enumeration(Object.values(questionContext)), questionContext.NONE)
}).actions(function (state) {
  return {
    setStatus: function setStatus(status) {
      state.status = status;
    }
  };
});

var withSetPrintMode = types$1.model({
  isPrintMode: false
}).actions(function (state) {
  return {
    setIsPrintMode: function setIsPrintMode(bool) {
      state.isPrintMode = bool;
    }
  };
});

var fileStatuses = {
  START: 'START',
  ADDED: 'ADDED',
  UPLOADING: 'UPLOADING',
  COMPLETE: 'COMPLETE',
  ERROR: 'ERROR',
  FILE_LIMIT: 'FILE_LIMIT'
};
function isCompleted(status) {
  return status === fileStatuses.COMPLETE;
}
function isDisabled(status) {
  return status === fileStatuses.UPLOADING || isCompleted(status) || status === fileStatuses.FILE_LIMIT;
}

function isManualEvaluation(metadataName) {
  return [types.essay.PlainText, types.essay.RichText, types.other.UploadFile, types.other.Pencil, types.other.Statement, types.other.AudioRecorder].includes(metadataName);
}

var XAPIModel = types$1.model({}).views(function (state) {
  return {
    onComplete: function onComplete() {
      return 'xAPI onComplete not implemented';
    }
  };
});

var QuestionBaseModel = types$1.compose(withCommonParams, withShowSolutions, withHidrateQuestionPreviewQuestionBaseModel, withSetPrintMode, types$1.model({
  isEvaluated: types$1.optional(types$1["boolean"], false),
  showSolution: types$1.optional(types$1["boolean"], false),
  _disabled: types$1.optional(types$1["boolean"], false),
  attempts: types$1.optional(AttemptsModel$1, initialValue),
  feedback: types$1.optional(FeedbackModel, initialValue$1),
  validation: QuestionValidationModel$1,
  assetsQuestionApi: types$1.maybe(types$1.string),
  onUpdateNotifier: types$1.optional(types$1.number, function () {
    return Date.now();
  }),
  onUpdateQuestionPreview: types$1.optional(types$1.number, function () {
    return Date.now();
  }),
  hints: types$1.maybe(HintsModel$1),
  responseFromData: types$1.maybe(ResponseFromDataModel),
  questionContext: types$1.optional(ContextModel, {}),
  raw: types$1.frozen(),
  isSolutionMode: false,
  isPreviewMode: false,
  resetNotifier: types$1.optional(types$1.maybeNull(types$1.number), null),
  xAPI: types$1.optional(XAPIModel, {})
}).actions(function (state) {
  return {
    setDisabled: function setDisabled(bool) {
      state._disabled = bool;
    },
    checkAnswers: function checkAnswers() {
      var _state$updateFirstInt;
      state.isEvaluated = true;
      state.attempts.addAttempt();
      state === null || state === void 0 ? void 0 : (_state$updateFirstInt = state.updateFirstInteraction) === null || _state$updateFirstInt === void 0 ? void 0 : _state$updateFirstInt.call(state);
      state.commitResponseFeedback && state.commitResponseFeedback();
      state.afterCheckAnswers();
    },
    afterCheckAnswers: function afterCheckAnswers() {},
    baseReset: function baseReset() {
      state.isEvaluated = false;
      state.showSolution = false;
      state.tempResponse = [];
      state.resetCache();
      state.updateResetNotifier();
    },
    setEvaluated: function setEvaluated(bool) {
      state.isEvaluated = bool;
    },
    setAssetsQuestionApi: function setAssetsQuestionApi(assetsQuestionApi) {
      state.assetsQuestionApi = assetsQuestionApi;
    },
    setContext: function setContext(context) {
      state.questionContext.setStatus(context);
    },
    reset: function reset() {
      state.setEvaluated(false);
    },
    setFeedback: function setFeedback(feedback) {
      state.feedback = feedback;
    },
    setIsSolutionMode: function setIsSolutionMode(isSolutionMode) {
      state.isSolutionMode = isSolutionMode;
    },
    setIsPreviewMode: function setIsPreviewMode(isSolutionMode) {
      state.isPreviewMode = isSolutionMode;
    },
    updateNotifier: function updateNotifier() {
      state.onUpdateNotifier = Date.now();
    },
    updateQuestionPreview: function updateQuestionPreview() {
      state.onUpdateQuestionPreview = Date.now();
    },
    updateEditorStore: function updateEditorStore(actionName, args) {},
    updateValidation: function updateValidation(validation) {
      state.setResponse(validation.valid_response.value);
      state.validation.alt_responses.forEach(function (alt, idx) {
        alt.setValue(state.responses.map(function (r) {
          return r.validAlternatives.responses[idx];
        }));
      });
      state.updateNotifier();
    },
    setCommonParams: function setCommonParams(params) {
      var assetsQuestionApi = params.assetsQuestionApi;
      state.setCommonParamsFn(params);
      state.setAssetsQuestionApi(assetsQuestionApi);
    },
    updateResetNotifier: function updateResetNotifier() {
      state.resetNotifier = Date.now();
    }
  };
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      throw new Error('Abstract method createSnapshot not implemented');
    },
    get reference() {
      var _state$raw;
      return (state === null || state === void 0 ? void 0 : (_state$raw = state.raw) === null || _state$raw === void 0 ? void 0 : _state$raw.reference) || uuid();
    },
    get disabled() {
      return state._disabled || state.isEvaluated;
    },
    get name() {
      return state.raw.metadata.name;
    },
    get isEvaluable() {
      var _state$validation, _state$raw$data;
      var scoringType = state === null || state === void 0 ? void 0 : (_state$validation = state.validation) === null || _state$validation === void 0 ? void 0 : _state$validation.scoring_type;
      if (scoringType === validationModes.MANUAL) return false;
      return ((_state$raw$data = state.raw.data) === null || _state$raw$data === void 0 ? void 0 : _state$raw$data.isEvaluable) !== false;
    },
    get points() {
      return when()["case"](!state.isEvaluable, function () {
        return -1;
      })["case"](!state.validation, function () {
        return 1;
      })["case"](state.showSolution, function () {
        return state.cachePoints;
      }).resolve(function () {
        return state.getResults();
      });
    },
    getSolutions: function getSolutions() {
      var _state$validation2;
      return (state === null || state === void 0 ? void 0 : (_state$validation2 = state.validation) === null || _state$validation2 === void 0 ? void 0 : _state$validation2.value) || '';
    },
    getScore: function getScore() {
      return when()["case"](!state.isEvaluable, function () {
        return {
          score: 0,
          max_score: 0
        };
      })["case"](!state.validation, function () {
        return {
          score: 1,
          max_score: 1
        };
      }).resolve(function () {
        return {
          score: state.points,
          max_score: state.validation.score
        };
      });
    },
    getResponse: function getResponse() {
      return _extends({
        reference: state.raw.reference,
        type: state.raw.metadata.name,
        apiVersion: currentVersion,
        revision: 1,
        value: state.getUserResponse(),
        scoring_type: getScoringType(state.raw)
      }, state.getScore());
    },
    getResponseWithKey: function getResponseWithKey() {
      var _ref;
      return _ref = {}, _ref[state.raw.reference] = state.getResponse(), _ref;
    },
    get withMath() {
      return defaultValue('raw.normalization.isMath', state, false);
    },
    get title() {
      return state.raw.title;
    },
    get stimulus() {
      return state.raw.data.stimulus;
    },
    get context() {
      return state.questionContext.status;
    },
    get ui_style() {
      return state.raw.data.ui_style;
    },
    get duplicate_responses() {
      var _state$raw$data2;
      return ((_state$raw$data2 = state.raw.data) === null || _state$raw$data2 === void 0 ? void 0 : _state$raw$data2.duplicate_responses) || false;
    },
    get shuffle_options() {
      var _state$raw$data3;
      return ((_state$raw$data3 = state.raw.data) === null || _state$raw$data3 === void 0 ? void 0 : _state$raw$data3.shuffle_options) || false;
    },
    get extraValues() {
      var _state$raw2, _state$raw2$extraValu;
      return (_state$raw2 = state.raw) === null || _state$raw2 === void 0 ? void 0 : (_state$raw2$extraValu = _state$raw2.extraValues) === null || _state$raw2$extraValu === void 0 ? void 0 : _state$raw2$extraValu.extraValues;
    },
    get successResult() {
      return state.isEvaluated && state.points > 0;
    },
    get errorResult() {
      return state.isEvaluated && state.points === 0;
    },
    get variants() {
      var typology = state.raw.metadata.name;
      return Object.entries(defaultValue("variants." + typology, config, [])).map(function (_ref2) {
        var key = _ref2[0],
          value = _ref2[1];
        return {
          name: key,
          value: value
        };
      });
    },
    get attachments() {
      var _state$raw$data4;
      var files = ((_state$raw$data4 = state.raw.data) === null || _state$raw$data4 === void 0 ? void 0 : _state$raw$data4.attachments) || [];
      return files.map(function (file) {
        return _extends({}, file, {
          status: fileStatuses.COMPLETE,
          ext: file.name.toLowerCase().substring(file.name.lastIndexOf('.') + 1)
        });
      });
    },
    get output() {
      return exportCommonValuesFromRaw(state.raw, state);
    }
  };
}));
function importCommonValues(data) {
  var response = data.response,
    context = data.context,
    _data$data = data.data,
    attempts = _data$data.attempts,
    scormData = _data$data.scormData,
    feedback = _data$data.feedback,
    _data$data$attachment = _data$data.attachments,
    attachments = _data$data$attachment === void 0 ? [] : _data$data$attachment;
  return {
    attempts: attempts,
    scormData: scormData,
    responseFromData: response,
    questionContext: context && {
      status: context
    },
    feedback: feedback,
    attachments: attachments,
    raw: _extends({}, data, {
      reference: (data === null || data === void 0 ? void 0 : data.reference) || uuid()
    })
  };
}
function getNotEvaluableValidation() {
  return {
    scoring_type: 'manual',
    immediateFeedback: false,
    alt_responses: [],
    valid_response: {
      score: 0
    },
    penalty_mode: 'NONE',
    penalty: 0
  };
}
function exportCommonValuesFromRaw(raw, state) {
  var _window;
  return _extends({}, raw, {
    lemonadeVersion: (_window = window) === null || _window === void 0 ? void 0 : _window.lemonadeVersion,
    data: _extends({}, raw.data, {
      validation: raw.data.validation || getNotEvaluableValidation(),
      isEvaluable: state.isEvaluable,
      ui_style: state.ui_style || {}
    })
  });
}
function getScoringType(data) {
  var _data$data2;
  var MANUAL = validationModes.MANUAL;
  var validation = data === null || data === void 0 ? void 0 : (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.validation;
  if (!validation) return MANUAL;
  if (!validation.scoring_type) return MANUAL;
  if (isManualEvaluation(data.metadata.name)) return MANUAL;
  return validation.scoring_type;
}

function typeChecker(model, value) {
  try {
    model.create(value);
    return true;
  } catch (err) {
    return false;
  }
}

function getClosestSolutionModel(checkFunction) {
  return types$1.model({}).views(function (state) {
    return {
      getCurrentSolution: function getCurrentSolution(idx) {
        return state.validation.solutionList[state.closestSolution].value[idx];
      },
      checkSolution: function checkSolution(solution) {
        return state.getUserResponse().reduce(function (acc, next, idx) {
          var result = checkFunction(solution[idx], next, state, idx);
          return when()["case"](result, function () {
            return _extends({}, acc, {
              hits: acc.hits + 1
            });
          })["case"](result === false, function () {
            return _extends({}, acc, {
              failures: acc.failures + 1
            });
          }).resolve(function () {
            return _extends({}, acc, {
              notAnswered: acc.notAnswered + 1
            });
          });
        }, {
          hits: 0,
          failures: 0,
          notAnswered: 0
        });
      },
      get closestSolutionIndex() {
        return state.validation.solutionList.map(function (_ref) {
          var value = _ref.value;
          return state.checkSolution(value);
        }).reduce(function (acc, next, idx) {
          return next.hits > acc.hits ? _extends({}, next, {
            solutionIndex: idx
          }) : acc;
        }, {
          hits: 0,
          failures: 0,
          solutionIndex: 0
        }).solutionIndex;
      },
      get closestSolutionStats() {
        return state.checkSolution(state.solution.value);
      },
      get responseLength() {
        var _state$closestSolutio = state.closestSolutionStats,
          hits = _state$closestSolutio.hits,
          failures = _state$closestSolutio.failures;
        return state.closestSolutionStats ? hits + failures : 0;
      },
      get closestSolution() {
        return when()["case"](state.validation.alt_responses.length === 0, function () {
          return 0;
        }).resolve(state.closestSolutionIndex);
      },
      get solution() {
        return state.validation.solutionList[state.closestSolution];
      }
    };
  });
}

var feedback = {
  NOT_EVALUATED: 'NOT_EVALUATED',
  RIGHT: 'RIGHT',
  WRONG: 'WRONG'
};

function getWithFeedbackResult(normalize) {
  return types$1.model({
    resultCache: types$1.maybe(types$1["boolean"])
  }).actions(function (state) {
    return {
      afterCreate: function afterCreate() {
        var parent = getParent(state, 2);
        reaction(function () {
          return parent.isEvaluated;
        }, function (value) {
          isAlive(state) && state.setResultCache(value ? state.isSuccess : undefined);
        });
      },
      setResultCache: function setResultCache(resultCache) {
        state.resultCache = resultCache;
      }
    };
  }).views(function (state) {
    return {
      get validate() {
        var solution = getParent(state, 2).validation.value[state.index];
        return normalize(solution, state) === normalize(state.value, state);
      },
      get isValid() {
        var parent = getParent(state, 2);
        var currentSolution = parent === null || parent === void 0 ? void 0 : parent.getCurrentSolution(state.index);
        var currentResponse = currentSolution !== undefined ? currentSolution : parent.validation.value[state.index];
        return normalize(currentResponse, state) === normalize(state.value, state);
      },
      get feedbackResult() {
        try {
          var parent = getParent(state, 2);
          var evaluationReady = parent.isEvaluated || parent.validation.immediateFeedback;
          return when()["case"](!evaluationReady, function () {
            return feedback.NOT_EVALUATED;
          })["case"](!parent.isEvaluable, function () {
            return feedback.NOT_EVALUATED;
          })["case"](parent.showSolution, function () {
            return feedback.RIGHT;
          })["case"](state.isValid, function () {
            return feedback.RIGHT;
          })["case"](!state.isValid, function () {
            return feedback.WRONG;
          }).resolve();
        } catch (e) {
          return feedback.NOT_EVALUATED;
        }
      },
      get isWrong() {
        return state.feedbackResult === feedback.WRONG;
      },
      get isWrongCache() {
        return state.resultCache === undefined ? state.isWrong : state.resultCache === false;
      },
      get isSuccess() {
        return state.feedbackResult === feedback.RIGHT;
      },
      get isError() {
        return state.isWrong;
      },
      get isLock() {
        try {
          return getParent(state, 2).disabled;
        } catch (e) {
          return false;
        }
      },
      get isCanShowElementFeedback() {
        return true;
      }
    };
  });
}
function isCanShowElementFeedbackParam(typeExercise, isEmptyValue, defaultValueConfigExercise) {
  var isElementFeedbackOnlyNotEmptyValue = config.configExercise[typeExercise] && config.configExercise[typeExercise].isElementFeedbackOnlyNotEmptyValue || defaultValueConfigExercise;
  return isElementFeedbackOnlyNotEmptyValue ? !isEmptyValue : true;
}
function getConditionCommitFeedbackMessages(item) {
  if (!item) return false;
  return item.isWrong && item.feedback && item.isCanShowElementFeedback;
}

var ResponseItem = types$1.model({
  itemRef: types$1.string,
  value: types$1["boolean"],
  propagate: types$1.optional(types$1["boolean"], true)
});
function createResponseItem(collectionName) {
  return ResponseItem.actions(function (state) {
    return {
      reset: function reset() {
        var item = getParent(state, 2)[collectionName].find(function (response) {
          return response.id === state.itemRef;
        });
        !!item && item.reset();
      }
    };
  }).views(function (state) {
    return {
      get item() {
        return getParent(state, 2)[collectionName].find(function (response) {
          return response.id === state.itemRef;
        });
      }
    };
  });
}

function withImmediateHandlers(itemList) {
  var ResponseItem = createResponseItem(itemList);
  return types$1.model({
    responseList: types$1.optional(types$1.array(ResponseItem), [])
  }).actions(function (state) {
    return {
      setImmediateResponse: function setImmediateResponse(response) {
        state.isEvaluable && state.responseList.push(response);
      }
    };
  }).views(function (state) {
    return {
      get questionCompleted() {
        var _state$validation = state.validation,
          immediateFeedback = _state$validation.immediateFeedback,
          value = _state$validation.value;
        return immediateFeedback && value.toString() === state.getUserResponse().toString();
      }
    };
  });
}

var RIGHT = feedback.RIGHT,
  WRONG = feedback.WRONG;
function validateList(response, solution, result, idx) {
  if (response === void 0) {
    response = [];
  }
  if (solution === void 0) {
    solution = [];
  }
  if (result === void 0) {
    result = [];
  }
  if (idx === void 0) {
    idx = 0;
  }
  if (idx === response.length) return result;else if (solution.length === 0) {
    return validateList(response, solution, [].concat(result, [WRONG]), idx + 1);
  } else {
    var value = solution.findIndex(function (i) {
      return i === response[idx];
    });
    var currentSolution = value > -1 ? rmItem(value, solution) : solution;
    return validateList(response, currentSolution, [].concat(result, [value > -1 ? RIGHT : WRONG]), idx + 1);
  }
}

var RIGHT$1 = feedback.RIGHT;
var withValidationModes = types$1.model().views(function (state) {
  return {
    getExactMatch: function getExactMatch() {
      return state.isSolvedCorrectly ? state.solution.score : 0;
    },
    getPartialMatch: function getPartialMatch() {
      var _state$validation;
      var _state$solution = state.solution,
        score = _state$solution.score,
        value = _state$solution.value;
      var _state$closestSolutio = state.closestSolutionStats,
        hits = _state$closestSolutio.hits,
        failures = _state$closestSolutio.failures;
      var penalty = ((_state$validation = state.validation) === null || _state$validation === void 0 ? void 0 : _state$validation.penalty) || 0;
      var partialPointsPerHits = score / value.length * hits;
      var penalizationPoints = score * penalty * failures;
      var partialResult = partialPointsPerHits - penalizationPoints;
      var resultOutput = config.negativeScore ? partialResult : Math.max(partialResult, 0);
      return state.isSolvedCorrectly ? score : resultOutput;
    },
    getPartialMatchElement: function getPartialMatchElement() {
      var _state$raw$data$valid;
      var _state$solution2 = state.solution,
        score = _state$solution2.score,
        value = _state$solution2.value;
      var _getPartialMatchEleme = getPartialMatchElementStats(state.getUserResponse(), value),
        hits = _getPartialMatchEleme.hits,
        failures = _getPartialMatchEleme.failures;
      var responsesLength = flatten(value).length;
      var isSolvedCorrectly = failures === 0 && responsesLength === hits;
      var penalty = ((_state$raw$data$valid = state.raw.data.validation) === null || _state$raw$data$valid === void 0 ? void 0 : _state$raw$data$valid.penalty) || 0;
      var partialPointsPerHits = score / responsesLength * hits;
      var penalizationPoints = score * penalty * failures;
      var partialResult = partialPointsPerHits - penalizationPoints;
      var resultOutput = config.negativeScore ? partialResult : Math.max(partialResult, 0);
      return isSolvedCorrectly ? score : resultOutput;
    },
    getResults: function getResults() {
      var EXACT_MATCH = validationModes.EXACT_MATCH,
        PARTIAL_MATCH_V2 = validationModes.PARTIAL_MATCH_V2,
        PARTIAL_MATCH_ELEMENT_V2 = validationModes.PARTIAL_MATCH_ELEMENT_V2;
      var eq = function eq(type) {
        return type === state.validation.scoring_type;
      };
      try {
        return when()["case"](eq(EXACT_MATCH), state.getExactMatch)["case"](eq(PARTIAL_MATCH_V2), state.getPartialMatch)["case"](eq(PARTIAL_MATCH_ELEMENT_V2), state.getPartialMatchElement).resolve(function () {
          return 0;
        });
      } catch (e) {
        return 0;
      }
    },
    get isSolvedCorrectly() {
      var _state$closestSolutio2 = state.closestSolutionStats,
        failures = _state$closestSolutio2.failures,
        hits = _state$closestSolutio2.hits;
      var solutionLength = state.solution.value.length;
      return solutionLength === hits && failures === 0;
    }
  };
});
function getPartialMatchElementStats(response, solution) {
  var result = response.map(function (responseItem, idx) {
    var solutionItem = (solution === null || solution === void 0 ? void 0 : solution[idx]) || [];
    return validateList(responseItem, solutionItem);
  });
  return flatten(result).reduce(function (acc, next) {
    return next === RIGHT$1 ? _extends({}, acc, {
      hits: acc.hits + 1
    }) : _extends({}, acc, {
      failures: acc.failures + 1
    });
  }, {
    hits: 0,
    failures: 0
  });
}

var OptionModel = types$1.model({
  id: types$1.optional(types$1.string, function () {
    return uuid();
  }),
  label: types$1.string
}).views(function (state) {
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    }
  };
});

var AnswerOptionModel = OptionModel.actions(function (state) {
  return {
    reset: function reset() {
      var _state$input;
      (_state$input = state.input) === null || _state$input === void 0 ? void 0 : _state$input.removeLink(state.index);
    }
  };
}).views(function (state) {
  var parent = getParent(state, 2);
  return {
    get input() {
      var questionOptions = parent.questionOptions;
      return questionOptions.find(function (question) {
        return question.value.includes(state.index);
      });
    },
    get isWaitingForMatch() {
      var _parent$selection = parent.selection,
        input = _parent$selection.input,
        output = _parent$selection.output;
      var notDragging = !parent.isDragging;
      return notDragging && input > -1 && output === -1;
    },
    get isSelected() {
      return parent.selection.output === state.index;
    },
    get isMatched() {
      return state.input;
    },
    get isValid() {
      if (!state.isMatched) return 0;
      var checkAnswerIsValid = parent.checkAnswerIsValid;
      return checkAnswerIsValid({
        question: state.input,
        answer: state
      }) ? 1 : 2;
    },
    get feedbackResult() {
      try {
        var evaluationReady = parent.isEvaluated || parent.validation.immediateFeedback;
        return when()["case"](!evaluationReady, function () {
          return feedback.NOT_EVALUATED;
        })["case"](!parent.isEvaluable, function () {
          return feedback.NOT_EVALUATED;
        })["case"](parent.showSolution, function () {
          return feedback.RIGHT;
        })["case"](state.isValid === 0, function () {
          return feedback.NOT_EVALUATED;
        })["case"](state.isValid === 1, function () {
          return feedback.RIGHT;
        })["case"](state.isValid === 2, function () {
          return feedback.WRONG;
        }).resolve();
      } catch (e) {
        return feedback.NOT_EVALUATED;
      }
    },
    get value() {
      return state.input ? state.input.value : [];
    }
  };
});

var withElementFeedback = types$1.model({
  feedback: types$1.optional(types$1.string, '')
}).actions(function (state) {
  return {
    setFeedback: function setFeedback(val) {
      state.feedback = val;
    }
  };
}).views(function (state) {
  return {
    get hasFeedback() {
      return state.feedback.length > 0;
    },
    get parent() {
      return !isRoot(state) ? getParent(state, 2) : null;
    },
    get feedbackData() {
      var parent = getParent(state, 2);
      if (!state.withPin) return false;
      return parent === null || parent === void 0 ? void 0 : parent.feedback.responseMessages.find(function (item) {
        return item.optionIndex === state.index;
      });
    },
    get feedbackIndex() {
      var _state$feedbackData;
      return state === null || state === void 0 ? void 0 : (_state$feedbackData = state.feedbackData) === null || _state$feedbackData === void 0 ? void 0 : _state$feedbackData.localIndex;
    },
    get withPin() {
      var parent = state.parent;
      var canShowFeedback = state.canShowElementFeedback || state.isCanShowElementFeedback;
      return parent && parent.isEvaluable && parent.isEvaluated && parent.feedback.withFeedbackPanel && parent.feedback.config.visibility && canShowFeedback && state.feedback.length > 0;
    }
  };
});

var withShowSolutionsParent = types$1.model({}).actions(function (state) {
  return {};
}).views(function (state) {
  return {
    get index() {
      throw new Error('Abstract method index not implemented');
    },
    get parent() {
      return getParent(state, 2);
    },
    get cacheResponse() {
      var parent = state.parent;
      if (parent && parent.cacheResponse && parent.cacheResponse.length > state.index) {
        return parent.cacheResponse[state.index];
      } else return null;
    },
    isEmptyResponse: function isEmptyResponse(response) {
      var _state$parent = state.parent,
        _state$parent$showSol = _state$parent.showSolution,
        showSolution = _state$parent$showSol === void 0 ? false : _state$parent$showSol,
        _state$parent$interna = _state$parent.internalAutoFeedback,
        internalAutoFeedback = _state$parent$interna === void 0 ? false : _state$parent$interna;
      return !showSolution && !internalAutoFeedback ? !hasData(response) : !hasData(state.cacheResponse);
    }
  };
});

var QuestionOptionModel = types$1.compose(withShowSolutionsParent, OptionModel, withElementFeedback, getWithFeedbackResult(sortAndStringify), types$1.model({
  value: types$1.optional(types$1.array(types$1.number), [])
}).actions(function (state) {
  return {
    setValue: function setValue(value) {
      state.value = applyNewValue(state.value, value);
      state.triggerImmediateResponse();
    },
    reset: function reset() {
      state.value = [];
    },
    removeLink: function removeLink(idx) {
      state.value.remove(idx);
    },
    triggerImmediateResponse: function triggerImmediateResponse() {
      getParent(state, 2).setImmediateResponse({
        itemRef: state.id,
        value: state.isValid
      });
    }
  };
}).views(function (state) {
  var parent = getParent(state, 2);
  return {
    get isWaitingForMatch() {
      var _parent$selection = parent.selection,
        input = _parent$selection.input,
        output = _parent$selection.output;
      var notDragging = !parent.isDragging;
      return notDragging && output > -1 && input === -1;
    },
    get answer() {
      return state.value.length > 0 && getParent(state, 2).answerOptions[state.value[0]];
    },
    get answerList() {
      return state.value.length > 0 ? state.value.map(function (val) {
        return parent.answerOptions[val];
      }) : [];
    },
    get isMatched() {
      return state.value.length > 0;
    },
    get answerCache() {
      return state.cacheResponse && state.cacheResponse.length > 0 && parent.answerOptions[state.cacheResponse[0]];
    },
    get isEmptyResponse() {
      var _getParent = getParent(state, 2),
        _getParent$showSoluti = _getParent.showSolution,
        showSolution = _getParent$showSoluti === void 0 ? false : _getParent$showSoluti,
        _getParent$internalAu = _getParent.internalAutoFeedback,
        internalAutoFeedback = _getParent$internalAu === void 0 ? false : _getParent$internalAu;
      if (!showSolution && !internalAutoFeedback) {
        return !state.answer;
      } else {
        return !state.answerCache;
      }
    },
    get isSelected() {
      return parent.selection.input === state.index;
    },
    get isCanShowElementFeedback() {
      return isCanShowElementFeedbackParam(types.classify.LinkingLines, state.isEmptyResponse, false);
    }
  };
}));
function applyNewValue(value, _newValue) {
  var newValue = !Array.isArray(_newValue) ? [_newValue] : _newValue;
  return removeDuplicates([].concat(value, newValue).sort());
}

var SelectionModel = types$1.model({
  input: types$1.optional(types$1.number, -1),
  output: types$1.optional(types$1.number, -1)
}).actions(function (state) {
  return {
    setInput: function setInput(idx) {
      if (state.input === idx) return state.clearInput();
      if (state.output > -1) return state.linkFromInput(idx);
      state.input = idx;
    },
    clearInput: function clearInput() {
      state.input = -1;
    },
    setOutput: function setOutput(idx) {
      if (state.output === idx) return state.clearOutput();
      if (state.input > -1) return state.linkFromOutput(idx);
      state.output = idx;
    },
    clearOutput: function clearOutput() {
      state.output = -1;
    },
    linkItems: function linkItems() {
      state.inputInstance.setValue(state.output);
      state.reset();
    },
    linkFromInput: function linkFromInput(idx) {
      var outputInstance = getInstance(state.output, getParent(state).answerOptions);
      outputInstance.reset();
      state.input = idx;
      state.linkItems();
    },
    linkFromOutput: function linkFromOutput(idx) {
      state.resetCurrentLink(getInstance(idx, getParent(state).answerOptions));
      state.output = idx;
      state.linkItems();
    },
    reset: function reset() {
      state.clearInput();
      state.clearOutput();
    },
    resetCurrentLink: function resetCurrentLink(currentInstance) {
      currentInstance && currentInstance.value.length > 0 && currentInstance.reset();
    },
    clearLine: function clearLine() {
      state.isDrawing && state.reset();
    }
  };
}).views(function (state) {
  return {
    get inputInstance() {
      return getInstance(state.input, getParent(state).questionOptions);
    },
    get outputInstance() {
      return getInstance(state.output, getParent(state).answerOptions);
    },
    get originInstance() {
      return when()["case"](!state.isDrawing, function () {
        return false;
      })["case"](state.input > -1, function () {
        return state.inputInstance;
      })["case"](state.output > -1, function () {
        return state.outputInstance;
      }).resolve(false);
    },
    get isDrawing() {
      return state.input !== state.output;
    }
  };
});
function getInstance(idx, list) {
  return idx === -1 ? undefined : list[idx];
}

function withPenaltyPoints(responseLength, validation) {
  var _validation$penalty = validation.penalty,
    penalty = _validation$penalty === void 0 ? 0 : _validation$penalty,
    penalty_mode = validation.penalty_mode;
  var isPenaltyPerResponse = penalty_mode === penaltyModes.PER_RESPONSE;
  var penaltyValue = isPenaltyPerResponse ? 1 / responseLength : penalty;
  return _extends({}, validation, {
    penalty: penaltyValue
  });
}

var COLUMNS_DIRECTIONS_TYPES = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
};
var withColumnDirection = types$1.model({
  column_direction: types$1.optional(types$1.enumeration('columnDirection', Object.values(COLUMNS_DIRECTIONS_TYPES)), COLUMNS_DIRECTIONS_TYPES.VERTICAL)
}).actions(function (state) {
  return {
    setColumnDirection: function setColumnDirection(columnDirection) {
      state.column_direction = columnDirection;
      getParent(state).updateNotifier();
    }
  };
});

var InteractiveModel = types$1.model({
  id: types$1.identifier,
  type: types$1.optional(types$1.string, ''),
  latency: types$1.optional(types$1.Date, function () {
    return new Date();
  }),
  pattern: types$1.array(types$1.frozen()),
  learner_response: types$1.frozen(),
  response: types$1.frozen(),
  description: types$1.string,
  result: 'incorrect'
}).actions(function (state) {
  return {
    update: function update(_ref) {
      var userResponse = _ref.userResponse,
        result = _ref.result;
      state.latency = new Date();
      state.learner_response = userResponse;
      state.response = userResponse;
      state.result = result ? 'correct' : 'incorrect';
    },
    setResult: function setResult(bool) {
      state.result = bool ? 'correct' : 'incorrect';
    }
  };
}).views(function (state) {
  return {
    get output() {
      return _extends({}, getSnapshot(state), {
        latency: new Date(state.latency)
      });
    }
  };
});

var scormTypes = {
  FILL_IN: 'fill-in',
  TRUE_FALSE: 'true-false',
  CHOICE: 'choice',
  LONG_FILL_IN: 'long-fill-in',
  MATCHING: 'matching',
  PERFORMANCE: 'performance',
  SEQUENCING: 'sequencing',
  LIKERT: 'likert',
  NUMERIC: 'numeric',
  OTHER: 'other'
};
var ScormModel = types$1.model({
  identifier: types$1.optional(types$1.string, ''),
  minScore: 0,
  maxScore: types$1.optional(types$1.number, 1),
  initTime: types$1.maybe(types$1.Date),
  scormVersion: '1.2',
  tries: types$1.optional(types$1.number, 0),
  interactiveList: types$1.optional(types$1.map(InteractiveModel), {})
}).actions(function (state) {
  return {
    setScormVersion: function setScormVersion(scormVersion) {
      state.scormVersion = scormVersion;
    },
    setInteractiveList: function setInteractiveList(list, exerciseType, patternHeaders) {
      state.interactiveList.clear();
      list.forEach(function (item) {
        var itemId = safeSnapshot(item).id;
        return state.interactiveList.set(itemId, {
          id: itemId,
          type: exerciseType,
          pattern: [patternHeaders + JSON.stringify(item.rightAnswer)],
          learner_response: item.userResponse,
          response: item.userResponse,
          description: 'interactive_' + item.id,
          result: item.result ? 'correct' : 'incorrect'
        });
      });
    },
    init: function init(activity, interactiveList) {
      var getFillInHeaders = activity.exerciseType === scormTypes.FILL_IN ? "{case_matters=true}{lang=" + config.lang + "}" : '';
      state.identifier = activity.raw.reference;
      state.maxScore = defaultValue('validation.score', activity, 1);
      state.initTime = new Date();
      state.setInteractiveList(interactiveList, activity.exerciseType, getFillInHeaders);
    },
    updateInteractiveList: function updateInteractiveList(activity, interactiveList) {
      !!interactiveList && getIdsToString(interactiveList) !== getIdsToString(state.interactiveList) && state.init(activity, interactiveList);
    },
    updateInteractive: function updateInteractive(item) {
      try {
        state.interactiveList.get(item.id).update(item);
      } catch (e) {}
    },
    addTries: function addTries() {
      state.tries = state.tries + 1;
    }
  };
}).views(function (state) {
  return {
    get result() {
      var result = [];
      state.interactiveList.forEach(function (interactive) {
        result.push(interactive.result === 'correct');
      });
      return result;
    },
    get output() {
      return _extends({}, getSnapshot(state), {
        initTime: new Date(state.initTime)
      });
    }
  };
});
function getIdsToString(list) {
  return list.map(function (item) {
    return item.id;
  }).toString();
}

function getAlternativeSolutions(idx, state) {
  return state.validation.solutionList.reduce(function (acc, next) {
    var _next$value;
    var response = (_next$value = next.value) === null || _next$value === void 0 ? void 0 : _next$value[idx];
    var itemResponse = response !== undefined ? response : '';
    if (acc.length === 0) return [itemResponse];
    var solutionIsUnique = checkUnique(itemResponse, acc);
    return solutionIsUnique ? [].concat(acc, [itemResponse]) : acc;
  }, []);
}
function checkUnique(currentValue, accumulator) {
  var itemFound = accumulator.find(function (response) {
    if (!response) return '';
    return response.toString() === currentValue.toString();
  });
  return !itemFound;
}
function getAlternativeTextSolutions(idx, state) {
  return state.validation.solutionList.map(function (solution) {
    return solution.values[idx];
  }).flat();
}

var withConfigureScorm = types$1.model({
  scormData: types$1.optional(ScormModel, {})
}).actions(function (state) {
  var getItemData = function getItemData(item, idx) {
    return {
      id: item.id,
      userResponse: getSnapshot(item.value),
      rightAnswer: getAlternativeSolutions(idx, state),
      result: item.isValid
    };
  };
  return {
    afterCreate: function afterCreate() {
      state.exerciseType = scormTypes.MATCHING;
      state.initScorm();
      onAction(state, function (_ref) {
        var name = _ref.name,
          path = _ref.path;
        if (name === 'reset' && path === '') state.initScorm();
      }, true);
      onSnapshot(state.questionOptions, function () {
        state.questionOptions.forEach(function (item, idx) {
          state.scormData.updateInteractive(getItemData(item, idx));
        });
      });
    },
    initScorm: function initScorm() {
      state.scormData.init(state, state.questionOptions.map(function (item, idx) {
        return getItemData(item, idx);
      }));
    }
  };
});

var HORIZONTAL = COLUMNS_DIRECTIONS_TYPES.HORIZONTAL;
var LINES_THICKNESS_TYPES = {
  FINE: 0,
  MEDIUM: 1,
  COARSE: 2
};
var LinkingLinesQuestionStore = types$1.compose(getClosestSolutionModel(checkResponse), withImmediateHandlers('questionOptions'), QuestionBaseModel, withValidationModes, withConfigureScorm, types$1.model({
  questionOptions: types$1.array(QuestionOptionModel),
  answerOptions: types$1.array(AnswerOptionModel),
  selection: types$1.optional(SelectionModel, {}),
  optionsOrder: types$1.frozen(types$1.array(types$1.number)),
  isDragging: types$1.optional(types$1["boolean"], false),
  redraw: 0
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      onAction(state, function (_ref) {
        var name = _ref.name;
        if (name === 'reset') {
          state.onRedraw();
        }
      });
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.array(types$1.number)), response)) {
        return false;
      }
      state.questionOptions.forEach(function (option, idx) {
        option.reset();
        response.length > idx && option.setValue(response[idx]);
      });
    },
    reset: function reset() {
      state.baseReset();
      state.setEvaluated(false);
      state.selection.reset();
      state.questionOptions.forEach(function (option) {
        option.reset();
      });
    },
    updateOptionsOrder: function updateOptionsOrder() {
      state.optionsOrder = function (idxArr) {
        return state.shuffle_options ? shuffle(idxArr) : idxArr;
      }(state.options.map(function (o, idx) {
        return idx;
      }));
    },
    clearLine: function clearLine() {
      state.selection.clearLine();
    },
    onRedraw: function onRedraw() {
      state.redraw = Date.now();
    },
    setIsDragging: function setIsDragging(bool) {
      state.isDragging = bool;
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot(rawData);
      applySnapshot(state, data);
      return new Promise(function (resolve) {
        return setTimeout(function () {
          resolve();
          state.onRedraw();
        }, 100);
      });
    },
    hydrateQuestionPreview: function hydrateQuestionPreview(rawData) {
      var data = _createSnapshot(rawData);
      var prevAssetsQuestionApi = state.assetsQuestionApi;
      applySnapshot(state, data);
      state.setIsSolutionMode(false);
      state.setAssetsQuestionApi(prevAssetsQuestionApi);
      return new Promise(function (resolve) {
        return setTimeout(function () {
          resolve();
          state.onRedraw();
        }, 100);
      });
    },
    updateNotifier: function updateNotifier() {
      state.onRedraw();
    },
    commitResponseFeedback: function commitResponseFeedback() {
      commitFeedbackMessages({
        state: state,
        collection: state.questionOptions,
        condition: getConditionCommitFeedbackMessages
      });
    }
  };
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot(rawData);
    },
    get answerList() {
      return state.optionsOrder.map(function (order) {
        return state.answerOptions[order];
      });
    },
    getUserResponse: function getUserResponse() {
      var userResponse = state.questionOptions.map(function (question) {
        return getSnapshot(question.value);
      });
      return state.getRealUserResponse(userResponse);
    },
    checkAnswerIsValid: function checkAnswerIsValid(_ref2) {
      var question = _ref2.question,
        answer = _ref2.answer;
      return state.solution.value[question.index].includes(answer.index);
    },
    getSolutions: function getSolutions() {
      return state.validation.value;
    },
    get isHorizontal() {
      return state.ui_style.column_direction === HORIZONTAL;
    },
    get relationList() {
      return state.questionOptions.reduce(function (acc, next) {
        return acc.concat(next.answerList);
      }, []);
    }
  };
}));
function _createSnapshot(data) {
  var _data$data = data.data,
    stimulus_list = _data$data.stimulus_list,
    possible_responses = _data$data.possible_responses,
    feedback_responses = _data$data.feedback_responses,
    shuffle_options = _data$data.shuffle_options,
    validation = _data$data.validation;
  var responsesLength = validation.valid_response.value.length;
  return _extends({}, data.data, importCommonValues(data), {
    validation: withPenaltyPoints(responsesLength, validation),
    optionsOrder: shuffle_options ? createRandomIndexes(possible_responses) : possible_responses.map(function (_, idx) {
      return idx;
    }),
    questionOptions: stimulus_list.map(function (label, idx) {
      var _feedback_responses$i;
      return {
        label: label,
        feedback: (feedback_responses === null || feedback_responses === void 0 ? void 0 : (_feedback_responses$i = feedback_responses[idx]) === null || _feedback_responses$i === void 0 ? void 0 : _feedback_responses$i.feedback) || ''
      };
    }),
    answerOptions: possible_responses.map(function (label) {
      return {
        label: label
      };
    })
  });
}
function checkResponse(solution, userResponse) {
  if (solution === void 0) {
    solution = [];
  }
  if (userResponse === void 0) {
    userResponse = [];
  }
  if (userResponse.length === 0 && solution.length === 0) return true;
  return userResponse.length > 0 ? solution.toString() === userResponse.toString() : null;
}
function createStore(data) {
  return LinkingLinesQuestionStore.create(_createSnapshot(data));
}

var defaultData$1 = function defaultData(dataId) {
  var _types$classify$Class;
  return (_types$classify$Class = {}, _types$classify$Class[types.classify.Classification] = {
    title: '',
    type: 'classification',
    metadata: {
      name: 'Classification'
    },
    data: {
      possible_responses: ["<p>" + translate('option') + " 1</p>", "<p>" + translate('option') + " 2</p>", "<p>" + translate('option') + " 3</p>", "<p>" + translate('option') + " 4</p>"],
      possible_responses_config: [{
        number_duplicates: 5
      }, {
        number_duplicates: 5
      }, {
        number_duplicates: 5
      }, {
        number_duplicates: 5
      }],
      stimulus: "<p>" + translate('classify_classification_stimulus_default') + "</p>",
      type: 'classification',
      ui_style: {
        column_count: 2,
        column_titles: [translate('column') + " 1", translate('column') + " 2"],
        row_count: 2,
        row_titles: [translate('row') + " 1"],
        withBox: true
      },
      validation: {
        scoring_type: validationModes.PARTIAL_MATCH_V2,
        valid_response: {
          score: 1,
          value: [[0, 1], [], [], []]
        }
      },
      shuffle_options: false,
      duplicate_responses: true
    }
  }, _types$classify$Class[types.classify.MatchList] = getMatchListData(), _types$classify$Class[types.classify.MatchListMobile] = getMatchListData(types.classify.MatchListMobile), _types$classify$Class[types.classify.OrderList] = getOrderListData(), _types$classify$Class[types.classify.OrderListMobile] = getOrderListData(types.classify.OrderListMobile), _types$classify$Class[types.classify.LinkingLines] = {
    title: '',
    widget_type: 'response',
    metadata: {
      name: types.classify.LinkingLines
    },
    type: 'linkinglines',
    data: {
      stimulus: "<p>" + translate('classify_linkinglines_stimulus_default') + "</p>",
      feedback_responses: [],
      stimulus_list: [translate('linking_lines_question_option') + " 1", translate('linking_lines_question_option') + " 2", translate('linking_lines_question_option') + " 3"],
      possible_responses: [translate('Answer') + " 1", translate('Answer') + " 2", translate('Answer') + " 3"],
      type: 'linkinglines',
      validation: {
        scoring_type: validationModes.PARTIAL_MATCH_V2,
        penalty_mode: penaltyModes.NONE,
        penalty: 0,
        valid_response: {
          score: 1,
          value: [[0], [1], [2]]
        }
      },
      ui_style: {
        line_thickness: LINES_THICKNESS_TYPES.FINE,
        line_color: '#828282',
        column_direction: COLUMNS_DIRECTIONS_TYPES.VERTICAL
      },
      shuffle_options: false,
      duplicate_responses: false
    }
  }, _types$classify$Class[types.classify.Stickers] = {
    title: '',
    type: 'stickers',
    metadata: {
      name: 'Stickers'
    },
    data: {
      type: 'stickers',
      stimulus: "<p>" + translate('classify_stickers_stimulus_default') + "</p>",
      image: {
        src: 'https://lemonade-assets-prod-content.s3.eu-central-1.amazonaws.com/stickers.png',
        width: 613,
        height: 220,
        alt: '',
        title: '',
        percent: 1
      },
      possible_responses: [{
        id: 'DRAG_1',
        label: "" + translate('fruit_avocados'),
        feedback: '',
        image: {
          src: 'https://lemonade-assets-prod-content.s3.eu-central-1.amazonaws.com/aguacate-small.png'
        },
        number_duplicates: 4
      }, {
        id: 'DRAG_2',
        label: "" + translate('fruit_lemons'),
        feedback: '',
        image: {
          src: 'https://lemonade-assets-prod-content.s3.eu-central-1.amazonaws.com/limon-small.png'
        },
        number_duplicates: 4
      }],
      duplicate_responses: true,
      group_responses: false,
      hotspots: [{
        id: 'DROP_1',
        label: '',
        area: [{
          x: 36,
          y: 145.4176330566406
        }, {
          x: 68,
          y: 63.417633056640625
        }, {
          x: 66,
          y: 21.417633056640625
        }, {
          x: 235,
          y: 19.417633056640625
        }, {
          x: 234,
          y: 62.417633056640625
        }, {
          x: 265,
          y: 146.4176330566406
        }]
      }, {
        id: 'DROP_2',
        label: '',
        area: [{
          x: 348,
          y: 143.4176330566406
        }, {
          x: 377,
          y: 63.417633056640625
        }, {
          x: 376,
          y: 23.417633056640625
        }, {
          x: 550,
          y: 19.417633056640625
        }, {
          x: 550,
          y: 62.417633056640625
        }, {
          x: 580,
          y: 145.4176330566406
        }]
      }],
      validation: {
        scoring_type: 'exactMatch',
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: [{
            x: 58.68494271685762,
            y: 43.795096139861016,
            dropId: 'DROP_1',
            dragId: 'DRAG_1'
          }, {
            x: 150.9959083469722,
            y: 44.798369462283276,
            dropId: 'DROP_1',
            dragId: 'DRAG_1'
          }, {
            x: 376.7454991816694,
            y: 56.80491610712778,
            dropId: 'DROP_2',
            dragId: 'DRAG_2'
          }, {
            x: 470.1252045826514,
            y: 57.808189429550055,
            dropId: 'DROP_2',
            dragId: 'DRAG_2'
          }]
        },
        penalty: 0
      },
      shuffle_options: false,
      ui_style: {
        customClass: '',
        show_hotspots: true,
        show_drag_over: false
      }
    },
    extraValues: {}
  }, _types$classify$Class[types.classify.StickersSeries] = {
    title: '',
    type: 'stickers_series',
    metadata: {
      name: 'Stickers series'
    },
    data: {
      type: 'stickers_series',
      stimulus: "<p>" + translate('classify_stickers_series_stimulus_default') + "</p>",
      image: {
        src: 'https://lemonade-assets-prod-content.s3.eu-central-1.amazonaws.com/sticker-series.png',
        width: 604,
        height: 252,
        alt: '',
        title: '',
        percent: 1
      },
      possible_responses: [{
        id: 'DRAG_1',
        label: "" + translate('fruit_avocados'),
        feedback: '',
        image: {
          src: 'https://lemonade-assets-prod-content.s3.eu-central-1.amazonaws.com/aguacate-small.png'
        },
        number_duplicates: 4
      }, {
        id: 'DRAG_2',
        label: "" + translate('fruit_lemons'),
        feedback: '',
        image: {
          src: 'https://lemonade-assets-prod-content.s3.eu-central-1.amazonaws.com/limon-small.png'
        },
        number_duplicates: 4
      }, {
        id: 'DRAG_3',
        label: "" + translate('fruit_apples'),
        feedback: '',
        image: {
          src: 'https://lemonade-assets-prod-content.s3.eu-central-1.amazonaws.com/manzana-small.png'
        },
        number_duplicates: 4
      }, {
        id: 'DRAG_4',
        label: "" + translate('fruit_pineapples'),
        feedback: '',
        image: {
          src: 'https://lemonade-assets-prod-content.s3.eu-central-1.amazonaws.com/pinia-small.png'
        },
        number_duplicates: 4
      }],
      duplicate_responses: true,
      group_responses: true,
      containers: [{
        id: 'DROP_1',
        x: 203,
        y: 0,
        z: 2,
        orientation: 'horizontal',
        width: 400,
        height: 114,
        fixed_elements: 0
      }, {
        id: 'DROP_2',
        x: 203,
        y: 136,
        z: 3,
        orientation: 'horizontal',
        width: 400,
        height: 114,
        fixed_elements: 0
      }],
      show_drag_over: false,
      validation: {
        scoring_type: 'exactMatch',
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: {
            DROP_1: {
              responses: ['DRAG_1', 'DRAG_2', 'DRAG_1', 'DRAG_2']
            },
            DROP_2: {
              responses: ['DRAG_3', 'DRAG_4', 'DRAG_3', 'DRAG_4']
            }
          }
        },
        penalty: 0
      },
      shuffle_options: false,
      ui_style: {
        customClass: ''
      }
    },
    extraValues: {}
  }, _types$classify$Class)[dataId];
};
function getMatchListData(name) {
  if (name === void 0) {
    name = types.classify.MatchList;
  }
  return {
    title: '',
    widget_type: 'response',
    metadata: {
      name: name
    },
    type: 'association',
    data: {
      possible_responses: ["<p>" + translate('option') + " 1</p>", "<p>" + translate('option') + " 2</p>", "<p>" + translate('option') + " 3</p>"],
      stimulus: "<p>" + translate('classify_matchlist_stimulus_default') + "</p>",
      stimulus_list: [translate('enunciated') + " 1", translate('enunciated') + " 2", translate('enunciated') + " 3"],
      type: 'association',
      validation: {
        scoring_type: validationModes.PARTIAL_MATCH_V2,
        penalty: 0,
        valid_response: {
          score: 1,
          value: ["<p>" + translate('option') + " 1</p>", "<p>" + translate('option') + " 2</p>", "<p>" + translate('option') + " 3</p>"]
        }
      },
      shuffle_options: false,
      duplicate_responses: false
    }
  };
}
function getOrderListData(name) {
  if (name === void 0) {
    name = types.classify.OrderList;
  }
  return {
    title: '',
    widget_type: 'response',
    metadata: {
      name: name
    },
    type: 'orderlist',
    data: {
      feedback_responses: [],
      list: [translate('option') + " 1", translate('option') + " 2", translate('option') + " 3", translate('option') + " 4"],
      stimulus: "<p>" + translate('classify_orderlist_stimulus_default') + "</p>",
      type: 'orderlist',
      shuffle_options: false,
      validation: {
        scoring_type: validationModes.PARTIAL_MATCH_V2,
        penalty: 0,
        valid_response: {
          score: 1,
          value: [0, 1, 2, 3]
        }
      },
      ui_style: {
        column_direction: COLUMNS_DIRECTIONS_TYPES.VERTICAL
      }
    }
  };
}
function getDefaultData$1(dataId) {
  var reference = uuid();
  return _extends({}, defaultData$1(dataId), {
    reference: reference
  });
}

var keyboards = {
  none: '',
  numerical: 'NUMERICAL',
  basic: 'BASIC',
  intermediate: 'INTERMEDIATE',
  complex: 'COMPLEX',
  scientific: 'SCIENTIFIC',
  roman: 'ROMAN',
  functions: 'FUNCTIONS',
  primeNumbers: 'PRIME_NUMBERS'
};
function getKeyboardTranslate(keyboardKey) {
  var KEY_BEGIN = 'keyboard_type_';
  if (keyboardKey === keyboards.none) {
    return KEY_BEGIN + 'NONE';
  } else {
    return KEY_BEGIN + keyboardKey;
  }
}
var KeyboardModel = types$1.model({
  type: types$1.optional(types$1.enumeration('type', Object.values(keyboards)), keyboards.none),
  isFloating: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    setType: function setType(type) {
      state.type = type;
    },
    setIsFloating: function setIsFloating(isFloating) {
      state.isFloating = isFloating;
    }
  };
});

var defaultData$2 = function defaultData(dataId) {
  var _types$cloze$Text$typ;
  return (_types$cloze$Text$typ = {}, _types$cloze$Text$typ[types.cloze.Text] = {
    title: '',
    type: 'clozetext',
    metadata: {
      name: 'Cloze with text'
    },
    data: {
      feedback_responses: [],
      stimulus: "<p>" + translate('cloze_text_stimulus_default') + "</p>",
      template: translate('cloze_template'),
      autosizeResponse: false,
      autosizeBox: false,
      type: 'clozetext',
      validation: {
        scoring_type: validationModes.PARTIAL_MATCH_V2,
        penalty: 0,
        grouped_responses: [],
        valid_response: {
          score: 1,
          value: [translate('option') + " 1", translate('option') + " 2"]
        }
      },
      ui_style: {
        keyboard: {
          type: keyboards.none,
          isFixed: true
        }
      }
    }
  }, _types$cloze$Text$typ[types.cloze.DropDown] = {
    title: '',
    type: 'clozedropdown',
    metadata: {
      name: 'Cloze with drop down'
    },
    data: {
      feedback_responses: [],
      possible_responses: [[translate('option') + " 1", translate('option') + " 2", translate('option') + " 3", translate('option') + " 4", translate('option') + " 5"], [translate('option') + " 1", translate('option') + " 2", translate('option') + " 3"], [translate('option') + " 1", translate('option') + " 2", translate('option') + " 3"]],
      response_container: {
        pointer: 'left'
      },
      stimulus: "<p>" + translate('cloze_dropdown_stimulus_default') + "</p>",
      template: translate('cloze_template'),
      type: 'clozedropdown',
      case_sensitive: true,
      validation: {
        scoring_type: validationModes.PARTIAL_MATCH_V2,
        penalty: 0,
        valid_response: {
          score: 1,
          value: [translate('option') + " 1", translate('option') + " 2"]
        }
      }
    }
  }, _types$cloze$Text$typ[types.cloze.Association] = {
    title: '',
    type: 'clozeassociation',
    metadata: {
      name: 'Cloze with drag & drop'
    },
    data: {
      possible_responses: ["<p>" + translate('option') + " 1</p>", "<p>" + translate('option') + " 2</p>", "<p>" + translate('option') + " 3</p>"],
      feedback_responses: [],
      response_container: {
        pointer: 'left'
      },
      stimulus: "<p>" + translate('cloze_drag_drop_stimulus_default') + "</p>",
      template: translate('cloze_template'),
      type: 'clozeassociation',
      case_sensitive: true,
      validation: {
        scoring_type: validationModes.PARTIAL_MATCH_V2,
        penalty: 0,
        valid_response: {
          score: 1,
          value: ["<p>" + translate('option') + " 1</p>", "<p>" + translate('option') + " 2</p>"]
        }
      },
      duplicate_responses: false,
      shuffle_options: true
    }
  }, _types$cloze$Text$typ)[dataId];
};
function getDefaultData$2(dataId) {
  var reference = uuid();
  return _extends({}, defaultData$2(dataId), {
    reference: reference
  });
}

var defaultData$3 = function defaultData(dataId) {
  var _types$essay$PlainTex;
  return (_types$essay$PlainTex = {}, _types$essay$PlainTex[types.essay.PlainText] = {
    title: '',
    type: 'plaintext',
    metadata: {
      name: 'Essay with plain text'
    },
    data: {
      show_copy: true,
      show_cut: true,
      show_paste: true,
      stimulus: "<p>" + translate('essay_plaintext_stimulus_default') + "</p>",
      type: 'plaintext'
    }
  }, _types$essay$PlainTex[types.essay.ShortText] = {
    title: '',
    type: 'shorttext',
    metadata: {
      name: 'Short text'
    },
    data: {
      stimulus: "<p>" + translate('essay_sorttext_stimulus_default') + "</p>",
      type: 'shorttext',
      max_length: 20,
      validation: {
        scoring_type: 'exactMatch',
        valid_response: {
          score: 1,
          value: "" + translate('essay_sorttext_solution1_default')
        }
      }
    }
  }, _types$essay$PlainTex[types.essay.RichText] = {
    data: {
      stimulus: "<p>" + translate('essay_richtext_stimulus_default') + "</p>",
      type: 'longtextV2',
      max_length: 1000,
      wordsLimit: 200
    },
    metadata: {
      name: 'Essay with rich text'
    },
    type: 'longtextV2'
  }, _types$essay$PlainTex)[dataId];
};
function getDefaultData$3(dataId) {
  var reference = uuid();
  return _extends({}, defaultData$3(dataId), {
    reference: reference
  });
}

var validationModes$1 = {
  EXACT_MATCH: 'exactMatch',
  PARTIAL_MATCH: 'partialMatch',
  PARTIAL_MATCH_V2: 'partialMatchV2',
  PARTIAL_MATCH_ELEMENT_V2: 'partialMatchElementV2',
  MANUAL: 'manual'
};

var defaultData$4 = function defaultData(dataId) {
  var _types$labelImage$Dra;
  return (_types$labelImage$Dra = {}, _types$labelImage$Dra[types.labelImage.DragDrop] = {
    title: '',
    type: 'imageclozeassociationV2',
    metadata: {
      name: 'Label image with drag & drop'
    },
    data: {
      image: {
        src: 'https://lemonade-assets.oneclick.es/world-map-800x510.png',
        width: 800,
        height: 400,
        alt: '',
        title: translate('world_map')
      },
      possible_responses: ["<p>" + translate('Greenland'), "<p>" + translate('United_States'), "<p>" + translate('Russia')],
      response_containers: [{
        x: 23,
        y: 30,
        width: '27%',
        height: '13%',
        aria_label: '',
        pointer: 'left'
      }, {
        x: 40,
        y: 8,
        width: '27%',
        height: '13%',
        aria_label: '',
        pointer: 'left'
      }, {
        x: 64,
        y: 24,
        aria_label: '',
        width: '22%',
        height: '11%',
        pointer: 'top'
      }],
      stimulus: "<p>" + translate('labelimage_dragdrop_stimulus_default') + "</p>",
      type: 'imageclozeassociationV2',
      case_sensitive: true,
      sampleText: "" + translate('response'),
      validation: {
        scoring_type: 'exactMatch',
        valid_response: {
          score: 1,
          value: [["<p>" + translate('United_States')], ["<p>" + translate('Greenland')], ["<p>" + translate('Russia')]]
        }
      },
      duplicate_responses: false,
      shuffle_options: false,
      response_container: {
        background_color: 'rgba(255, 255, 255, 0.8)'
      }
    }
  }, _types$labelImage$Dra[types.labelImage.DropDown] = {
    title: '',
    type: 'imageclozedropdown',
    metadata: {
      name: 'Label image with drop-down'
    },
    data: {
      image: {
        src: 'https://lemonade-assets.oneclick.es/world-map-800x510.png',
        alt: '',
        title: translate('world_map')
      },
      possible_responses: [[translate('Greenland'), translate('United_States'), translate('Russia')], [translate('Greenland'), translate('United_States'), translate('Russia')], [translate('Greenland'), translate('United_States'), translate('Russia')]],
      response_container: {
        pointer: 'left',
        vertical_top: true
      },
      response_positions: [{
        x: 22,
        y: 32
      }, {
        x: 40,
        y: 7.5
      }, {
        x: 67,
        y: 18
      }],
      stimulus: "<p>" + translate('labelimage_dropdown_stimulus_default') + "</p>",
      type: 'imageclozedropdown',
      case_sensitive: true,
      validation: {
        scoring_type: 'exactMatch',
        valid_response: {
          score: 1,
          value: [translate('United_States'), translate('Greenland'), translate('Russia')]
        },
        match_all_possible_responses: true
      },
      aria_labels: ['', '', ''],
      shuffle_options: true
    }
  }, _types$labelImage$Dra[types.labelImage.Text] = {
    widget_type: 'response',
    metadata: {
      name: 'Label image with text'
    },
    data: {
      image: {
        src: 'https://lemonade-assets.oneclick.es/world-map-800x510.png',
        alt: '',
        width: 1200,
        height: 765,
        title: translate('world_map')
      },
      response_container: {
        width: '147.9px',
        height: '27.75px',
        x: '59.037214885954384px',
        y: '24.81544256120528px',
        aria_label: '',
        pointer: 'bottom',
        placeholder: '',
        value: '',
        validResponse: translate('Russia')
      },
      response_positions: [{
        x: 19.95198079231693,
        y: 36.31261770244821
      }, {
        x: 47.19207683073229,
        y: 35.29190207156309
      }, {
        x: 59.037214885954384,
        y: 24.81544256120528
      }],
      stimulus: "<p>" + translate('labelimage_imagewithtext_stimulus_default') + "</p>",
      type: 'imageclozetext',
      sampleText: "" + translate('response'),
      validation: {
        scoring_type: 'exactMatch',
        valid_response: {
          score: 1,
          value: [translate('United_States'), translate('Spain'), translate('Russia')]
        },
        penalty: 0,
        min_score_if_attempted: 0,
        automarkable: true,
        alt_responses: []
      },
      ui_style: {
        keyboard: {
          type: keyboards.none,
          isFixed: true
        }
      },
      aria_labels: ['', '', ''],
      isEvaluated: false,
      showSolution: false,
      disabled: false,
      basePath: '',
      max_length: 1000,
      response_containers: [{
        width: '147.9px',
        height: '27.75px',
        x: '19.95198079231693px',
        y: '36.31261770244821px',
        aria_label: '',
        pointer: 'left',
        placeholder: '',
        value: '',
        validResponse: translate('United_States')
      }, {
        width: '147.9px',
        height: '27.75px',
        x: '47.19207683073229px',
        y: '35.29190207156309px',
        aria_label: '',
        pointer: 'top',
        placeholder: '',
        value: '',
        validResponse: translate('Spain')
      }, {
        width: '147.9px',
        height: '27.75px',
        x: '59.037214885954384px',
        y: '24.81544256120528px',
        aria_label: '',
        pointer: 'bottom',
        placeholder: '',
        value: '',
        validResponse: translate('Russia')
      }]
    },
    type: 'imageclozetext',
    title: ''
  }, _types$labelImage$Dra.LabelImageTextV2 = {
    title: '',
    type: 'LabelImageTextV2',
    metadata: {
      name: 'LabelImageTextV2'
    },
    data: {
      image: {
        src: 'https://lemonade-assets.oneclick.es/world-map-800x510.png',
        width: 800,
        height: 510,
        title: translate('world_map')
      },
      fontSize: 10,
      responses: [{
        x: 160,
        y: 241,
        z: 25,
        width: 160,
        height: 55,
        pointer: 'bottom'
      }, {
        x: 291,
        y: 112,
        z: 24,
        width: 160,
        height: 55,
        pointer: 'left'
      }, {
        x: 508,
        y: 209,
        z: 26,
        width: 160,
        height: 55,
        pointer: 'top'
      }],
      feedback_responses: [],
      stimulus: "<p>" + translate('labelimage_imagewithtext_stimulus_default') + "</p>",
      autosizeResponse: false,
      type: 'LabelImageTextV2',
      sampleText: "" + translate('response'),
      validation: {
        scoring_type: validationModes$1.PARTIAL_MATCH_V2,
        penalty: 0,
        valid_response: {
          score: 1,
          value: [translate('United_States'), translate('Greenland'), translate('Russia')]
        }
      },
      ui_style: {
        keyboard: {
          type: keyboards.none,
          isFixed: true
        }
      }
    }
  }, _types$labelImage$Dra.LabelImageDropDownV2 = {
    title: '',
    type: 'LabelImageDropDownV2',
    metadata: {
      name: 'LabelImageDropDownV2'
    },
    data: {
      image: {
        src: 'https://lemonade-assets.oneclick.es/world-map-800x510.png',
        width: 800,
        height: 510,
        title: translate('world_map')
      },
      fontSize: 10,
      responseAutoSize: true,
      responses: [{
        x: 163,
        y: 251,
        z: 16,
        width: 140,
        height: 50,
        pointer: 'bottom',
        valueList: [translate('option') + " 1", translate('option') + " 2", translate('option') + " 3"]
      }, {
        x: 291,
        y: 111,
        z: 17,
        width: 140,
        height: 50,
        pointer: 'left',
        valueList: [translate('option') + " 1", translate('option') + " 2", translate('option') + " 3"]
      }, {
        x: 495,
        y: 214,
        z: 18,
        width: 140,
        height: 50,
        pointer: 'top',
        valueList: [translate('option') + " 1", translate('option') + " 2", translate('option') + " 3"]
      }],
      stimulus: "<p>" + translate('labelimage_dropdown_stimulus_default') + "</p>",
      type: 'LabelImageDropDownV2',
      validation: {
        scoring_type: validationModes$1.PARTIAL_MATCH_V2,
        penalty: 0,
        valid_response: {
          score: 1,
          value: [translate('option') + " 1", translate('option') + " 2", translate('option') + " 3"]
        }
      }
    }
  }, _types$labelImage$Dra.LabelImageDragDropV2 = {
    title: '',
    type: 'LabelImageDragDropV2',
    metadata: {
      name: 'LabelImageDragDropV2'
    },
    data: {
      image: {
        src: 'https://lemonade-assets.oneclick.es/world-map-800x510.png',
        width: 800,
        height: 510,
        title: translate('world_map')
      },
      fontSize: 10,
      responses: [{
        x: 160,
        y: 241,
        z: 25,
        width: 160,
        height: 55,
        pointer: 'bottom'
      }, {
        x: 291,
        y: 112,
        z: 24,
        width: 160,
        height: 55,
        pointer: 'left'
      }, {
        x: 508,
        y: 209,
        z: 26,
        width: 160,
        height: 55,
        pointer: 'top'
      }],
      possible_responses: ["<p>" + translate('Greenland') + "</p>", "<p>" + translate('United_States') + "</p>", "<p>" + translate('Russia') + "</p>"],
      stimulus: "<p>" + translate('labelimage_dragdrop_stimulus_default') + "</p>",
      type: 'LabelImageDragDropV2',
      sampleText: "" + translate('response'),
      validation: {
        scoring_type: validationModes$1.PARTIAL_MATCH_V2,
        penalty: 0,
        valid_response: {
          score: 1,
          value: ["<p>" + translate('United_States') + "</p>", "<p>" + translate('Greenland') + "</p>", "<p>" + translate('Russia') + "</p>"]
        }
      }
    }
  }, _types$labelImage$Dra)[dataId];
};
function getDefaultData$4(dataId) {
  var reference = uuid();
  return _extends({}, defaultData$4(dataId), {
    reference: reference
  });
}

var SVGNS = 'http://www.w3.org/2000/svg';
var CIRCLE = 'CIRCLE';
var RECTANGLE = 'RECTANGLE';
var QUAD = 'QUAD';
var TENTHS = 'TENTHS';
var HUNDREDTHS = 'HUNDREDTHS';
var TRIANGLE = 'TRIANGLE';
var PENTAGON = 'PENTAGON';
var HEXAGON = 'HEXAGON';
var RANDOM = 'RANDOM';
var SLICE_CLASS = 'fractional-shape-slice';
var BACKGROUND_CLASS = 'fractional-shape-background';
var FIX_BORDERS_CLASS = 'fractional-shape-fix-borders';
var FEEDBACK_BORDER_CLASS = 'fractional-shape-feedback-class';
var LINE_CLASS = 'fractional-shape-line';

var NUMBER = 'NUMBER';
var FRACTION = 'FRACTION';

var quadrantList = {
  I: 'I',
  II: 'II',
  III: 'III',
  IV: 'IV'
};

var TOP = 'TOP';
var BOTTOM = 'BOTTOM';
var LEFT = 'LEFT';
var RIGHT$2 = 'RIGHT';

var defaultData$5 = function defaultData(dataId) {
  var _types$math$ClozeMath;
  return (_types$math$ClozeMath = {}, _types$math$ClozeMath[types.math.ClozeMath] = {
    title: '',
    type: 'clozeformula',
    metadata: {
      name: types.math.ClozeMath
    },
    data: {
      type: 'clozeformula',
      stimulus: "<p>" + translate('math_clozemath_stimulus_default') + "</p>",
      template: '<p>34,52 ÷ 10 = &nbsp;{{response}}&nbsp;</p><p>34,52 ÷ 100 =&nbsp;{{response}}&nbsp;</p><p>34,52 ÷ 1000 = &nbsp;&nbsp;&nbsp;{{response}}&nbsp;</p>',
      validation: {
        scoring_type: validationModes.PARTIAL_MATCH_V2,
        penalty: 0,
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: [{
            value: '3.452',
            method: 'equivLiteral',
            options: {
              decimalPlaces: 0
            },
            feedback: ''
          }, {
            value: '0.3452',
            method: 'equivLiteral',
            options: {
              decimalPlaces: 0
            },
            feedback: ''
          }, {
            value: '0.03452',
            method: 'equivLiteral',
            options: {
              decimalPlaces: 0
            },
            feedback: ''
          }]
        }
      },
      feedback: {
        config: {
          visibility: true,
          sequence: 'stack'
        },
        errorMessages: [],
        responseMessages: [],
        successMessage: ''
      },
      isEvaluable: true,
      ui_style: {
        keyboard: {
          type: keyboards.scientific,
          isFixed: true
        }
      }
    }
  }, _types$math$ClozeMath[types.math.Counting] = {
    title: '',
    type: 'counting',
    metadata: {
      name: 'Counting'
    },
    data: {
      options: [{
        value: 6,
        src: 'https://lemonade-assets.oneclick.es/fruits/manzana-1.png'
      }, {
        value: 6,
        src: 'https://lemonade-assets.oneclick.es/fruits/limon-1.png'
      }],
      showResult: true,
      operation: 'add',
      feedback_responses: [{
        feedback: ''
      }, {
        feedback: ''
      }],
      stimulus: "<p>" + translate('math_counting_stimulus_default') + "</p>",
      type: 'counting',
      validation: {
        scoring_type: 'exactMatch',
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: 6
        },
        penalty: 0
      },
      ui_style: {
        type: '',
        customClass: ''
      },
      isEvaluable: true,
      attempts: {
        attempts: 0
      },
      hints: [],
      feedback: {
        successMessage: '',
        errorMessages: [],
        responseMessages: [],
        config: {
          visibility: true,
          sequence: 'stack'
        }
      }
    },
    extraValues: {}
  }, _types$math$ClozeMath[types.math.NumberLine] = {
    title: '',
    type: types.math.NumberLine,
    metadata: {
      name: types.math.NumberLine
    },
    data: {
      line: {
        max: 20,
        min: -10,
        divisions: 16,
        denominator: undefined
      },
      labels: {
        frequency: 1,
        show_max: true,
        show_min: true
      },
      ticks: {
        distance: 1,
        show: true
      },
      points: ['3+1', '10'],
      mode: NUMBER,
      feedback_responses: [{
        feedback: ''
      }, {
        feedback: ''
      }],
      stimulus: "<p>" + translate('math_number_line_stimulus_default') + "</p>",
      type: types.math.NumberLine,
      validation: {
        scoring_type: 'exactMatch',
        penalty: 0,
        penalty_mode: penaltyModes.NONE,
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: [{
            position: 4
          }, {
            position: 10
          }]
        }
      },
      ui_style: {
        type: '',
        customClass: ''
      },
      isEvaluable: true,
      attempts: {
        attempts: 0
      },
      hints: [],
      feedback: {
        successMessage: '',
        errorMessages: [],
        responseMessages: [],
        config: {
          visibility: true,
          sequence: 'stack'
        }
      }
    },
    extraValues: {}
  }, _types$math$ClozeMath[normalizedTypes.math_fraction.value] = {
    title: '',
    type: normalizedTypes.math_fraction.value.toLowerCase(),
    metadata: {
      name: normalizedTypes.math_fraction.value
    },
    data: {
      type: normalizedTypes.math_fraction.value.toLowerCase(),
      stimulus: "<p>" + translate('charts_fractions_and_decimals_stimulus_default') + "</p>",
      shape: {
        type: CIRCLE,
        divisions: 6
      },
      validation: {
        scoring_type: 'exactMatch',
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: 4
        },
        penalty: 0
      },
      shuffle_options: false,
      ui_style: {
        theme: ''
      }
    }
  }, _types$math$ClozeMath[normalizedTypes.math_coordinate_axes.value] = {
    title: '',
    type: 'coordinateaxes',
    metadata: {
      name: normalizedTypes.math_coordinate_axes.value
    },
    data: {
      type: 'coordinateaxes',
      stimulus: "<p>" + translate('charts_coordinate_axes_stimulus_default') + "</p>",
      grid_size: 10,
      grid_full: false,
      grid_quadrant: quadrantList.I,
      validation: {
        scoring_type: 'exactMatch',
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: coordinateAxesSolutions.topRight
        },
        penalty: 0
      },
      ui_style: {
        customClass: '',
        theme: 'theme-bordeaux'
      }
    },
    extraValues: {}
  }, _types$math$ClozeMath[normalizedTypes.math_boxplot.value] = {
    title: '',
    type: 'boxplot',
    metadata: {
      name: normalizedTypes.math_boxplot.value
    },
    data: {
      type: 'boxplot',
      stimulus: '<p>Forma el diagrama de caja y bigotes dado este conjunto de números</p>',
      plot: {
        min: 0,
        max: 17,
        data: [2, 5, 7, 8, 8, 9, 11]
      },
      validation: {
        scoring_type: 'exactMatch',
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: [2, 5, 8, 9, 11]
        },
        penalty: 0
      },
      shuffle_options: false,
      ui_style: {
        customClass: ''
      }
    },
    extraValues: {}
  }, _types$math$ClozeMath[normalizedTypes.math_transformations_in_plane.value] = {
    title: '',
    type: normalizedTypes.math_transformations_in_plane.value,
    metadata: {
      name: normalizedTypes.math_transformations_in_plane.value
    },
    data: {
      type: normalizedTypes.math_transformations_in_plane.value,
      stimulus: "<p>" + translate('transformations_in_plane_stimulus_default') + "</p>",
      figure: {
        preset: 1,
        theme: '',
        x: 3,
        y: 2,
        isFlipped: false,
        rotation: 0,
        pivot: {
          position: 0,
          label: 'C'
        }
      },
      grid: {
        width: 20,
        height: 10
      },
      validation: {
        scoring_type: 'exactMatch',
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: [{
            type: 'TRANSLATION',
            transformations: {
              x: 5,
              y: 0
            }
          }]
        },
        penalty: 0
      },
      ui_style: {
        customClass: '',
        controls_position: BOTTOM
      }
    },
    extraValues: {}
  }, _types$math$ClozeMath[normalizedTypes.math_sum.value] = createOperation({
    type: normalizedTypes.math_sum.value,
    stimulus: 'math_vertical_operation_stimulus_default',
    operands: [2621, 6531, 8837],
    uiStyle: {
      order_terms: true,
      column_help: true
    }
  }), _types$math$ClozeMath[normalizedTypes.math_subtraction.value] = createOperation({
    type: normalizedTypes.math_subtraction.value,
    stimulus: 'math_vertical_operation_stimulus_default',
    operands: [147, 59],
    uiStyle: {
      column_help: true
    }
  }), _types$math$ClozeMath[normalizedTypes.math_lineal_function.value] = {
    title: '',
    type: 'functions',
    metadata: {
      name: normalizedTypes.math_lineal_function.value
    },
    data: {
      type: 'functions',
      stimulus: "<p>" + translate('lineal_function_stimulus_default') + "</p>",
      grid_size: 550,
      grid_divisions: 10,
      validation: {
        scoring_type: 'exactMatch',
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: [[-3, 1]]
        },
        penalty: 0
      },
      ui_style: {
        customClass: ''
      }
    },
    extraValues: {}
  }, _types$math$ClozeMath[normalizedTypes.math_quadratic_function.value] = {
    title: '',
    type: 'functions',
    metadata: {
      name: normalizedTypes.math_quadratic_function.value
    },
    data: {
      type: 'functions',
      stimulus: "<p>" + translate('quadratic_function_stimulus_default') + "</p>",
      grid_size: 550,
      grid_divisions: 10,
      validation: {
        scoring_type: 'exactMatch',
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: [[-2, 4, 1]]
        },
        penalty: 0
      },
      ui_style: {
        customClass: ''
      }
    },
    extraValues: {}
  }, _types$math$ClozeMath[normalizedTypes.math_prime_number_decomposition.value] = {
    title: '',
    type: 'primeNumberDecomposition',
    metadata: {
      name: normalizedTypes.math_prime_number_decomposition.value
    },
    data: {
      type: 'primeNumberDecomposition',
      stimulus: "<p>" + translate('prime_number_decomposition_stimulus_default') + "</p>",
      initialNumber: 12,
      dynamic_generator: {
        prime_list: [2, 3, 5, 7, 11],
        factors_length: 4
      },
      validation: {
        scoring_type: 'exactMatch',
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: ''
        },
        penalty: 0
      },
      ui_style: {
        customClass: ''
      }
    },
    extraValues: {}
  }, _types$math$ClozeMath[normalizedTypes.math_find_closest_value.value] = {
    title: '',
    type: normalizedTypes.math_find_closest_value.value,
    metadata: {
      name: normalizedTypes.math_find_closest_value.value
    },
    data: {
      stimulus: "<p>" + translate('math_find_closest_value_stimulus_default') + "</p>",
      type: normalizedTypes.math_find_closest_value.value,
      line: {
        max: 20,
        min: -10,
        divisions: 6,
        denominator: undefined,
        margin_of_error: 1
      },
      labels: {
        frequency: 1,
        show_max: true,
        show_min: true
      },
      ticks: {
        distance: 1,
        show: true
      },
      points: ['<span class="fr-math-v2" data-original-math="\\(\\sqrt6\\)">\\(\\sqrt6\\)</span>'],
      mode: NUMBER,
      feedback_responses: [{
        feedback: ''
      }, {
        feedback: ''
      }],
      validation: {
        scoring_type: 'exactMatch',
        penalty: 0,
        penalty_mode: penaltyModes.NONE,
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: [{
            position: 2.45
          }]
        }
      },
      ui_style: {
        type: '',
        customClass: ''
      },
      isEvaluable: true,
      attempts: {
        attempts: 0
      },
      hints: [],
      feedback: {
        successMessage: '',
        errorMessages: [],
        responseMessages: [],
        config: {
          visibility: true,
          sequence: 'stack'
        }
      }
    },
    extraValues: {}
  }, _types$math$ClozeMath)[dataId];
};
var coordinateAxesSolutions = {
  topLeft: [{
    x: -2,
    y: 2
  }, {
    x: -4,
    y: 4
  }, {
    x: -6,
    y: 6
  }, {
    x: -8,
    y: 8
  }],
  topRight: [{
    x: 2,
    y: 2
  }, {
    x: 4,
    y: 4
  }, {
    x: 6,
    y: 6
  }, {
    x: 8,
    y: 8
  }],
  bottomRight: [{
    x: 2,
    y: -2
  }, {
    x: 4,
    y: -4
  }, {
    x: 6,
    y: -6
  }, {
    x: 8,
    y: -8
  }],
  bottomLeft: [{
    x: -2,
    y: -2
  }, {
    x: -4,
    y: -4
  }, {
    x: -6,
    y: -6
  }, {
    x: -8,
    y: -8
  }]
};
function createOperation(_ref) {
  var operands = _ref.operands,
    type = _ref.type,
    stimulus = _ref.stimulus,
    _ref$uiStyle = _ref.uiStyle,
    uiStyle = _ref$uiStyle === void 0 ? {} : _ref$uiStyle;
  return {
    title: '',
    type: 'verticalOperation',
    metadata: {
      name: type
    },
    data: {
      type: 'verticalOperation',
      stimulus: "<p>" + translate(stimulus) + "</p>",
      operation: {
        type: type,
        operands: operands
      },
      validation: {
        scoring_type: 'exactMatch',
        valid_response: {
          score: 1,
          value: ''
        }
      },
      ui_style: _extends({
        customClass: '',
        column_help: true,
        keyboard: {
          type: keyboards.numerical,
          isFloating: false
        }
      }, uiStyle)
    }
  };
}
function getDefaultData$5(dataId) {
  var reference = uuid();
  return _extends({}, defaultData$5(dataId), {
    reference: reference
  });
}

var labelTypes = {
  NONE: '',
  NUMERICAL: 'NUMERICAL',
  UPPER_ALPHA: 'UPPER_ALPHA',
  LOWER_ALPHA: 'LOWER_ALPHA'
};
var letters = 'abcdefghijklmnopqrstuvwxyz';
var numbers = function () {
  var n = [];
  for (var i = 0; i < 50; i++) {
    n.push(i + 1);
  }
  return n;
}();
function getLabel(idx, labelType) {
  return when()["case"](labelType === labelTypes.NUMERICAL, function () {
    return numbers;
  })["case"](labelType === labelTypes.UPPER_ALPHA, function () {
    return letters.toUpperCase();
  })["case"](labelType === labelTypes.LOWER_ALPHA, function () {
    return letters;
  }).resolve(function () {
    return letters;
  })[idx];
}

var defaultData$6 = function defaultData(dataId) {
  var _types$multipleChoice;
  return (_types$multipleChoice = {}, _types$multipleChoice[types.multipleChoice.Multiple] = {
    title: '',
    type: 'mcq',
    data: {
      type: 'mcq',
      multiple_responses: true,
      options: [{
        label: translate('option') + " 1",
        value: '0'
      }, {
        label: translate('option') + " 2",
        value: '1'
      }, {
        label: translate('option') + " 3",
        value: '2'
      }, {
        label: translate('option') + " 4",
        value: '3'
      }],
      stimulus: "<p>" + translate('multiple_choice_multiple_stimulus_default') + "</p>",
      shuffle_options: false,
      validation: {
        scoring_type: validationModes$1.PARTIAL_MATCH_V2,
        penalty: 0,
        penalty_mode: penaltyModes.PER_RESPONSE,
        valid_response: {
          score: 1,
          value: ['0', '2']
        }
      },
      ui_style: {
        type: types.multipleChoice.Multiple,
        columns: 1,
        mobile_columns: 1,
        labelType: labelTypes.NONE
      }
    },
    metadata: {
      name: types.multipleChoice.Multiple
    }
  }, _types$multipleChoice[types.multipleChoice.Single] = {
    title: '',
    type: 'mcq',
    metadata: {
      name: types.multipleChoice.Single
    },
    data: {
      options: [{
        label: translate('option') + " 1",
        value: '0'
      }, {
        label: translate('option') + " 2",
        value: '1'
      }, {
        label: translate('option') + " 3",
        value: '2'
      }, {
        label: translate('option') + " 4",
        value: '3'
      }],
      stimulus: "<p>" + translate('multiple_choice_single_stimulus_default') + "</p>",
      type: 'mcq',
      validation: {
        scoring_type: 'exactMatch',
        valid_response: {
          score: 1,
          value: ['0']
        }
      },
      ui_style: {
        type: types.multipleChoice.Single,
        columns: 1,
        mobile_columns: 1,
        labelType: labelTypes.NONE
      }
    }
  }, _types$multipleChoice[types.multipleChoice.TrueFalse] = {
    title: '',
    type: 'mcq',
    metadata: {
      name: types.multipleChoice.TrueFalse
    },
    data: {
      options: [{
        label: "" + translate('true'),
        value: '0'
      }, {
        label: "" + translate('false'),
        value: '1'
      }],
      stimulus: "<p>" + translate('multiple_choice_truefalse_stimulus_default') + "</p>",
      type: 'mcq',
      validation: {
        scoring_type: 'exactMatch',
        valid_response: {
          score: 1,
          value: ['1']
        }
      },
      ui_style: {
        type: types.multipleChoice.TrueFalse,
        columns: 1,
        mobile_columns: 1,
        labelType: labelTypes.NONE
      }
    }
  }, _types$multipleChoice[types.multipleChoice.BlockLetter] = {
    title: '',
    type: 'mcq',
    metadata: {
      name: types.multipleChoice.BlockLetter
    },
    data: {
      options: [{
        label: translate('option') + " 1",
        value: '0'
      }, {
        label: translate('option') + " 2",
        value: '1'
      }, {
        label: translate('option') + " 3",
        value: '2'
      }, {
        label: translate('option') + " 4",
        value: '3'
      }],
      stimulus: "<p>" + translate('multiple_choice_blockletter_stimulus_default') + "</p>",
      type: 'mcq',
      validation: {
        scoring_type: 'exactMatch',
        valid_response: {
          score: 1,
          value: ['3']
        }
      },
      ui_style: {
        type: types.multipleChoice.BlockLetter,
        columns: 1,
        mobile_columns: 1,
        labelType: labelTypes.NUMERICAL
      }
    }
  }, _types$multipleChoice[types.multipleChoice.EmotionsSingle] = {
    title: '',
    type: 'mcq',
    metadata: {
      name: types.multipleChoice.EmotionsSingle
    },
    data: {
      options: [{
        label: 'Sorprendido',
        value: '0'
      }, {
        label: 'Preocupado',
        value: '1'
      }, {
        label: 'Enojado',
        value: '2'
      }, {
        label: 'Alegre',
        value: '3'
      }, {
        label: 'Aburrido',
        value: '4'
      }, {
        label: 'Miedoso',
        value: '5'
      }],
      stimulus: '<p>¿Con qué emoción te identificas en este momento?</p>',
      type: 'mcq',
      validation: {
        scoring_type: 'manual',
        valid_response: {
          score: 1,
          value: []
        }
      },
      ui_style: {
        type: types.multipleChoice.EmotionsSingle,
        columns: 2,
        mobile_columns: 2,
        labelType: labelTypes.NONE
      },
      showCheckIcon: false,
      isEvaluable: false
    }
  }, _types$multipleChoice)[dataId];
};
function getDefaultData$6(dataId) {
  var reference = uuid();
  return _extends({}, defaultData$6(dataId), {
    reference: reference
  });
}

function getCorrectResponsesPattern(data, parentPath, options) {
  if (parentPath === void 0) {
    parentPath = '';
  }
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    _options$isAlternativ = _options.isAlternative,
    isAlternative = _options$isAlternativ === void 0 ? false : _options$isAlternativ;
  var separator = isAlternative ? '[;]' : '[,]';
  if (typeof data !== 'object' || data === null) {
    return parentPath ? parentPath + "[.]" + data : "" + data;
  }
  if (Array.isArray(data)) {
    if (data.every(function (item) {
      return typeof item !== 'object' || item === null;
    })) {
      var joinedValues = data.join(separator);
      return parentPath ? parentPath + "[.]" + joinedValues : joinedValues;
    }
    return data.map(function (item, index) {
      var newPath = parentPath ? parentPath + "[.]" + index : "" + index;
      return getCorrectResponsesPattern(item, newPath, options);
    }).flat();
  }
  var results = [];
  for (var _i = 0, _Object$entries = Object.entries(data); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _Object$entries[_i],
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    var newPath = parentPath ? parentPath + "." + key : key;
    if (typeof value === 'object' && value !== null) {
      var nestedResults = getCorrectResponsesPattern(value, newPath, options);
      if (Array.isArray(nestedResults)) {
        results.push.apply(results, nestedResults);
      } else {
        results.push(nestedResults);
      }
    } else {
      results.push(newPath + "[.]" + value);
    }
  }
  return results;
}
function formatXAPIResponses(data, options) {
  if (options === void 0) {
    options = {};
  }
  var _options2 = options,
    _options2$isAlternati = _options2.isAlternative,
    isAlternative = _options2$isAlternati === void 0 ? false : _options2$isAlternati;
  var separator = isAlternative ? '[;]' : '[,]';
  var processed = getCorrectResponsesPattern(data, '', options);
  if (Array.isArray(processed)) {
    return [processed.join(separator)];
  }
  return [processed];
}

var xApiBaseModel = types$1.model({}).views(function (state) {
  return {
    getResult: function getResult() {
      return getXAPIResults(getParent(state));
    },
    onComplete: function onComplete() {
      return {
        objectDefinition: state.getObjectDefinition(),
        result: state.getResult()
      };
    }
  };
});

function populate(times, fn, index, value) {
  if (index === void 0) {
    index = 0;
  }
  if (value === void 0) {
    value = [];
  }
  if (index === times) return value;
  return populate(times, fn, index + 1, [].concat(value, [fn(index, value)]));
}

function findSubKey(key, collection, idx) {
  if (idx === void 0) {
    idx = 0;
  }
  var keyList = Object.keys(collection);
  if (idx === keyList.length) return null;
  return Object.keys(collection[keyList[idx]]).find(function (item) {
    return collection[keyList[idx]][item] === key;
  }) ? [keyList[idx], key] : findSubKey(key, collection, idx + 1);
}
function omit(k, obj) {
  var recursive = function recursive(keyList, _obj) {
    if (keyList.length === 0) return _obj;
    delete _obj[keyList[0]];
    return recursive(keyList.slice(1), _obj);
  };
  return recursive(k, _extends({}, obj));
}
function pick(k, obj, result) {
  var _extends2;
  if (result === void 0) {
    result = {};
  }
  if (k.length === 0) return result;
  var key = k[0];
  var r = obj[key] ? _extends({}, result, (_extends2 = {}, _extends2[key] = obj[key], _extends2)) : result;
  return pick(k.slice(1), obj, r);
}
function hasKey(key, obj) {
  return key in obj;
}
function conditionalObjectField(condition, object) {
  return condition ? object : {};
}

var xAPI_ACTIVITY_TYPE = 'Activity';
var OPTION = 'option';
var SOURCE = 'source';
var TARGET = 'target';
var EMPTY_STRING = 'empty';
function getLangString() {
  var lang = config.lang;
  return lang + "-" + lang.toUpperCase();
}
function getXAPIDescription(store) {
  var _ref;
  var langString = getLangString();
  return _ref = {}, _ref[langString] = removeTags(store.stimulus), _ref;
}
function getXAPIOptionList(options, type) {
  if (type === void 0) {
    type = OPTION;
  }
  var langString = getLangString();
  return options.map(function (option, idx) {
    var _description;
    return {
      id: type + "-" + (idx + 1),
      description: (_description = {}, _description[langString] = option, _description)
    };
  });
}
function getGenericSource(sourceLength) {
  return populate(sourceLength, function (idx) {
    return EMPTY_STRING + "-" + (idx + 1);
  });
}
function getXAPIResults(store) {
  var userResponse = store.getUserResponse();
  var points = store.points;
  var isSuccess = points > 0;
  var isEvaluable = store.isEvaluable;
  return _extends({
    response: JSON.stringify(userResponse),
    success: isEvaluable ? isSuccess : null
  }, conditionalObjectField(isEvaluable, {
    score: {
      scaled: points
    }
  }));
}
function getXAPIChoiceSolution(_ref2) {
  var state = _ref2.state,
    source = _ref2.source,
    target = _ref2.target;
  var solution = state.validation.value;
  var langString = getLangString();
  var findTarget = function findTarget(value) {
    return target.find(function (item) {
      return item.description[langString] === value;
    });
  };
  return solution.reduce(function (acc, next, idx) {
    var _findTarget;
    acc[source[idx].id] = ((_findTarget = findTarget(next)) === null || _findTarget === void 0 ? void 0 : _findTarget.id) || '_';
    return acc;
  }, {});
}
function exportXAPI(customImplementation) {
  var exported = types$1.compose(xApiBaseModel, customImplementation);
  return types$1.model({
    xAPI: types$1.optional(exported, {})
  });
}
var formatResponses = formatXAPIResponses;

var withXAPITypeOther = function withXAPITypeOther(_ref) {
  var xAPISolution = _ref.xAPISolution,
    _ref$interactionType = _ref.interactionType,
    interactionType = _ref$interactionType === void 0 ? scormTypes.OTHER : _ref$interactionType;
  return types$1.model({}).views(function (state) {
    return {
      getObjectDefinition: function getObjectDefinition() {
        var parent = getParent(state);
        var solution = (xAPISolution === null || xAPISolution === void 0 ? void 0 : xAPISolution(parent)) || parent.validation.value;
        return {
          description: getXAPIDescription(parent),
          correctResponsesPattern: [JSON.stringify(solution)],
          objectType: xAPI_ACTIVITY_TYPE,
          interactionType: interactionType
        };
      }
    };
  });
};
var withXAPITypeOther$1 = (function (_temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
    xAPISolution = _ref2.xAPISolution,
    interactionType = _ref2.interactionType;
  return exportXAPI(withXAPITypeOther({
    xAPISolution: xAPISolution,
    interactionType: interactionType
  }));
});

var DEFAULT_HOURS = 0;
var DEFAULT_MINUTES = 0;
var CLOCK_TYPES = {
  ANALOG: 'analog',
  DIGITAL: 'digital'
};
var CLOCK_TIME_SYSTEMS = {
  HOUR_24: '24H',
  HOUR_12: '12H'
};
var CLOCK_THEMES = {
  DARK: 'dark',
  LIGHT: 'light'
};
var ClockQuestionStore = types$1.compose(QuestionBaseModel, withXAPITypeOther$1(), types$1.model({
  hours: types$1.optional(types$1.number, DEFAULT_HOURS),
  minutes: types$1.optional(types$1.number, DEFAULT_MINUTES)
}).actions(function (state) {
  return {
    setTime: function setTime(time) {
      state.setHours(time.hours);
      state.setMinutes(time.minutes);
    },
    setHours: function setHours(hours) {
      state.hours = hours;
    },
    setMinutes: function setMinutes(minutes) {
      state.minutes = minutes;
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.number), response)) {
        return false;
      }
      state.setHours(getHoursFromArrayTime(response));
      state.setMinutes(getMinutesFromArrayTime(response));
    },
    reset: function reset() {
      state.baseReset();
      state.setHours(DEFAULT_HOURS);
      state.setMinutes(DEFAULT_MINUTES);
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot$1(rawData);
      applySnapshot(state, data);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  return {
    getUserResponse: function getUserResponse() {
      var userResponse = getArrayTime(state.hours, state.minutes);
      return state.getRealUserResponse(userResponse);
    },
    getResults: function getResults() {
      if (state.ui_style.type === CLOCK_TYPES.ANALOG) {
        var hoursUser12h = getHoursFormat12(state.hours);
        var hourValidation = getHoursFromArrayTime(state.validation.value);
        var minutesValidation = getMinutesFromArrayTime(state.validation.value);
        var hourValidation12h = getHoursFormat12(hourValidation);
        return JSON.stringify(getArrayTime(hoursUser12h, state.minutes)) === JSON.stringify(getArrayTime(hourValidation12h, minutesValidation)) ? 1 : 0;
      } else {
        return JSON.stringify(state.getUserResponse()) === JSON.stringify(state.validation.value) ? 1 : 0;
      }
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$1(rawData);
    },
    get isEmpty() {
      return false;
    },
    get success() {
      try {
        return !state.isSolutionMode && state.isEvaluated && state.getResults() === 1;
      } catch (e) {
        return false;
      }
    },
    get error() {
      try {
        return !state.isSolutionMode && state.isEvaluated && state.getResults() === 0;
      } catch (e) {
        return false;
      }
    },
    get feedbackStatus() {
      return when()["case"](state.success, function () {
        return 'success';
      })["case"](state.showSolution, function () {
        return 'success';
      })["case"](state.error, function () {
        return 'error';
      }).resolve('');
    }
  };
}));
function getArrayTime(hours, minutes) {
  return [hours, minutes];
}
function getHoursFormat12(hours) {
  return hours > 12 ? (hours + 11) % 12 + 1 : hours;
}
function getHoursFromArrayTime(arrayTime) {
  return arrayTime.length >= 1 ? arrayTime[0] : DEFAULT_HOURS;
}
function getMinutesFromArrayTime(arrayTime) {
  return arrayTime.length >= 1 ? arrayTime[1] : DEFAULT_MINUTES;
}
function _createSnapshot$1(data) {
  return _extends({}, data.data, importCommonValues(data), {
    raw: data
  });
}
function createStore$1(data) {
  var snapshot = _createSnapshot$1(data);
  return ClockQuestionStore.create(snapshot);
}

var TABLE_POSITION_ABOVE = 'lemo-table_position_above';
var TABLE_POSITION_BELOW = 'lemo-table_position_below';
var TABLE_POSITION_LEFT = 'lemo-table_position_left';
var TABLE_POSITION_RIGHT = 'lemo-table_position_right';
var ABOVE = 'ABOVE';
var BELOW = 'BELOW';

var wordSearchData = {
  es: {
    value: ['LIMON', 'MANZANA', 'PLATANO', 'FRESAS', 'SANDIA', 'MELOCOTON'],
    letters: [['J', 'U', 'O', 'F', 'R', 'E', 'S', 'A', 'S', 'V'], ['V', 'D', 'P', 'B', 'M', 'Z', 'O', 'L', 'P', 'I'], ['V', 'V', 'A', 'T', 'A', 'X', 'M', 'C', 'L', 'A'], ['Z', 'A', 'Y', 'H', 'N', 'J', 'L', 'E', 'A', 'N'], ['J', 'V', 'A', 'R', 'Z', 'R', 'I', 'X', 'T', 'H'], ['W', 'G', 'J', 'M', 'A', 'Y', 'M', 'B', 'A', 'G'], ['R', 'C', 'D', 'A', 'N', 'T', 'O', 'F', 'N', 'W'], ['G', 'B', 'K', 'X', 'A', 'K', 'N', 'T', 'O', 'F'], ['M', 'M', 'E', 'L', 'O', 'C', 'O', 'T', 'O', 'N'], ['S', 'A', 'N', 'D', 'I', 'A', 'N', 'G', 'D', 'T']],
    allowed_letters: ''
  },
  en: {
    value: ['LEMON', 'APPLE', 'BANANA', 'PEAR', 'WATERMELON', 'PEACH'],
    letters: [['F', 'U', 'N', 'T', 'I', 'O', 'T', 'X', 'C', 'P'], ['A', 'P', 'L', 'E', 'M', 'O', 'N', 'Z', 'H', 'R'], ['P', 'K', 'E', 'V', 'J', 'K', 'H', 'I', 'A', 'H'], ['P', 'O', 'O', 'A', 'S', 'F', 'X', 'E', 'R', 'K'], ['L', 'U', 'R', 'T', 'C', 'D', 'P', 'O', 'D', 'M'], ['E', 'N', 'D', 'I', 'J', 'H', 'O', 'A', 'I', 'O'], ['B', 'Y', 'D', 'X', 'A', 'M', 'B', 'Z', 'M', 'G'], ['W', 'A', 'T', 'E', 'R', 'M', 'E', 'L', 'O', 'N'], ['R', 'D', 'C', 'E', 'L', 'P', 'Q', 'N', 'P', 'L'], ['B', 'A', 'N', 'A', 'N', 'A', 'I', 'E', 'A', 'P']],
    allowed_letters: ''
  },
  pt: {
    value: ['LIMÃO', 'MAÇÃ', 'BANANA', 'MORANGOS', 'MELANCIA', 'PÊSSEGO'],
    letters: [['N', 'N', 'U', 'Y', 'J', 'X', 'E', 'Z', 'Ã', 'W'], ['Í', 'Q', 'Ú', 'K', 'M', 'S', 'V', 'R', 'X', 'Û'], ['A', 'M', 'E', 'L', 'A', 'N', 'C', 'I', 'A', 'Z'], ['H', 'L', 'Û', 'Y', 'Ç', 'Ê', 'Ê', 'S', 'G', 'O'], ['Ã', 'Û', 'I', 'Î', 'Ã', 'Â', 'N', 'Ó', 'B', 'X'], ['E', 'A', 'I', 'M', 'H', 'R', 'Â', 'J', 'A', 'W'], ['Ú', 'U', 'X', 'Z', 'Ã', 'Ç', 'B', 'Ç', 'N', 'I'], ['Â', 'I', 'R', 'L', 'F', 'O', 'S', 'W', 'A', 'A'], ['M', 'O', 'R', 'A', 'N', 'G', 'O', 'S', 'N', 'I'], ['L', 'P', 'Ê', 'S', 'S', 'E', 'G', 'O', 'A', 'E']],
    allowed_letters: ''
  }
};
var langDefault = 'es';
function getWordSearchLetters(lang) {
  var _wordSearchData$lang;
  return ((_wordSearchData$lang = wordSearchData[lang]) === null || _wordSearchData$lang === void 0 ? void 0 : _wordSearchData$lang.letters) || wordSearchData[langDefault].letters;
}
function getWordSearchValue(lang) {
  var _wordSearchData$lang2;
  return ((_wordSearchData$lang2 = wordSearchData[lang]) === null || _wordSearchData$lang2 === void 0 ? void 0 : _wordSearchData$lang2.value) || wordSearchData[langDefault].value;
}
function getWordSearchAllowedLetters(lang) {
  var _wordSearchData$lang3;
  return ((_wordSearchData$lang3 = wordSearchData[lang]) === null || _wordSearchData$lang3 === void 0 ? void 0 : _wordSearchData$lang3.allowed_letters) || wordSearchData[langDefault].allowed_letters;
}

var crosswordData = {
  es: {
    value: ['PLATANO', 'LIMON', 'MELOCOTON', 'FRESAS', 'MANZANA', 'SANDIA'],
    letters: [['', '', '', 'P', '', '', '', '', '', ''], ['', 'M', 'E', 'L', 'O', 'C', 'O', 'T', 'O', 'N'], ['', '', '', 'A', '', '', '', '', '', ''], ['', '', '', 'T', '', '', '', '', 'S', ''], ['', '', 'M', 'A', 'N', 'Z', 'A', 'N', 'A', ''], ['', '', '', 'N', '', '', '', '', 'N', ''], ['L', 'I', 'M', 'O', 'N', '', '', '', 'D', ''], ['', '', '', '', '', '', '', '', 'I', ''], ['', '', '', '', 'F', 'R', 'E', 'S', 'A', 'S'], ['', '', '', '', '', '', '', '', '', '']],
    words_position: [{
      word: 'PLATANO',
      startX: 3,
      startY: 0,
      visibleLetters: [],
      vertical: true
    }, {
      word: 'LIMON',
      startX: 0,
      startY: 6,
      visibleLetters: [],
      vertical: false
    }, {
      word: 'MELOCOTON',
      startX: 1,
      startY: 1,
      visibleLetters: [],
      vertical: false
    }, {
      word: 'FRESAS',
      startX: 4,
      startY: 8,
      visibleLetters: [],
      vertical: false
    }, {
      word: 'MANZANA',
      startX: 2,
      startY: 4,
      visibleLetters: [],
      vertical: false
    }, {
      word: 'SANDIA',
      startX: 8,
      startY: 3,
      visibleLetters: [],
      vertical: true
    }]
  },
  en: {
    value: ['BANANA', 'LEMON', 'PEACH', 'PINEAPPLE', 'APPLE', 'WATERMELON'],
    letters: [['A', 'P', 'P', 'L', 'E', '', '', '', '', '', ''], ['', '', 'E', '', '', '', '', '', '', '', ''], ['', 'W', 'A', 'T', 'E', 'R', 'M', 'E', 'L', 'O', 'N'], ['', '', 'C', '', '', '', '', '', 'E', '', ''], ['', '', 'H', '', '', '', 'P', '', 'M', '', ''], ['', '', '', '', '', '', 'I', '', 'O', '', ''], ['', '', '', '', 'B', 'A', 'N', 'A', 'N', 'A', ''], ['', '', '', '', '', '', 'E', '', '', '', ''], ['', '', '', '', '', '', 'A', '', '', '', ''], ['', '', '', '', '', '', 'P', '', '', '', ''], ['', '', '', '', '', '', 'P', '', '', '', ''], ['', '', '', '', '', '', 'L', '', '', '', ''], ['', '', '', '', '', '', 'E', '', '', '', '']],
    words_position: [{
      word: 'BANANA',
      startX: 4,
      startY: 6,
      visibleLetters: [],
      vertical: false
    }, {
      word: 'LEMON',
      startX: 8,
      startY: 2,
      visibleLetters: [],
      vertical: true
    }, {
      word: 'PEACH',
      startX: 2,
      startY: 0,
      visibleLetters: [],
      vertical: true
    }, {
      word: 'PINEAPPLE',
      startX: 6,
      startY: 4,
      visibleLetters: [],
      vertical: true
    }, {
      word: 'APPLE',
      startX: 0,
      startY: 0,
      visibleLetters: [],
      vertical: false
    }, {
      word: 'WATERMELON',
      startX: 1,
      startY: 2,
      visibleLetters: [],
      vertical: false
    }]
  },
  pt: {
    value: ['BANANA', 'LIMÃO', 'PÊSSEGO', 'MORANGOS', 'MAÇÃ', 'MELANCIA'],
    letters: [['', '', '', '', '', '', 'P', ''], ['', '', '', '', '', '', 'Ê', ''], ['', 'L', '', '', '', '', 'S', ''], ['', 'I', '', 'M', '', '', 'S', ''], ['', 'M', '', 'E', '', '', 'E', ''], ['', 'Ã', '', 'L', '', '', 'G', ''], ['M', 'O', 'R', 'A', 'N', 'G', 'O', 'S'], ['A', '', '', 'N', '', '', '', ''], ['Ç', '', '', 'C', '', '', '', ''], ['Ã', '', '', 'I', '', '', '', ''], ['', '', 'B', 'A', 'N', 'A', 'N', 'A']],
    words_position: [{
      word: 'BANANA',
      startX: 2,
      startY: 10,
      visibleLetters: [],
      vertical: false
    }, {
      word: 'LIMÃO',
      startX: 1,
      startY: 2,
      visibleLetters: [],
      vertical: true
    }, {
      word: 'PÊSSEGO',
      startX: 6,
      startY: 0,
      visibleLetters: [],
      vertical: true
    }, {
      word: 'MORANGOS',
      startX: 0,
      startY: 6,
      visibleLetters: [],
      vertical: false
    }, {
      word: 'MAÇÃ',
      startX: 0,
      startY: 6,
      visibleLetters: [],
      vertical: true
    }, {
      word: 'MELANCIA',
      startX: 3,
      startY: 3,
      visibleLetters: [],
      vertical: true
    }]
  }
};
var langDefault$1 = 'es';
function getCrosswordLetters(lang) {
  var _crosswordData$lang;
  return ((_crosswordData$lang = crosswordData[lang]) === null || _crosswordData$lang === void 0 ? void 0 : _crosswordData$lang.letters) || crosswordData[langDefault$1].letters;
}
function getCrosswordValue(lang) {
  var _crosswordData$lang2;
  return ((_crosswordData$lang2 = crosswordData[lang]) === null || _crosswordData$lang2 === void 0 ? void 0 : _crosswordData$lang2.value) || crosswordData[langDefault$1].value;
}
function getCrosswordWords(lang) {
  var value = getCrosswordValue(lang);
  return value.map(function (item) {
    return {
      word: item,
      description: ''
    };
  });
}
function getCrosswordWordsPosition(lang) {
  var _crosswordData$lang3;
  return ((_crosswordData$lang3 = crosswordData[lang]) === null || _crosswordData$lang3 === void 0 ? void 0 : _crosswordData$lang3.words_position) || crosswordData[langDefault$1].words_position;
}

var defaultData$7 = function defaultData(dataId) {
  var _types$other$UploadFi;
  return (_types$other$UploadFi = {}, _types$other$UploadFi[types.other.UploadFile] = {
    title: '',
    type: 'uploadfile',
    maxFiles: 10,
    minFiles: 1,
    data: {
      type: 'uploadfile',
      stimulus: "<p>" + translate('other_uploadfile_stimulus_default') + "</p>"
    },
    metadata: {
      name: types.other.UploadFile
    }
  }, _types$other$UploadFi[types.other.Pencil] = {
    title: '',
    type: 'pencil',
    data: {
      type: 'pencil',
      stimulus: "<p>" + translate('other_pencil_stimulus_default') + "</p>",
      height: 400
    },
    metadata: {
      name: types.other.Pencil
    }
  }, _types$other$UploadFi[types.other.Statement] = {
    title: '',
    type: 'statement',
    data: {
      type: 'statement',
      stimulus: "<p>" + translate('other_statement_stimulus_default') + "</p>"
    },
    metadata: {
      name: types.other.Statement
    }
  }, _types$other$UploadFi[types.other.ClickToFind] = {
    type: 'clicktofind',
    stimulus: '<p>[This is the stem.]</p>',
    metadata: {
      name: types.other.ClickToFind
    },
    data: {
      stimulus: "<p>" + translate('other_clicktofind_stimulus_default') + "</p>",
      type: 'clicktofind',
      image: {
        src: 'https://lemonade-assets.oneclick.es/fruits/background.png',
        width: 1280,
        height: 800
      },
      hotspots: [{
        src: 'https://lemonade-assets.oneclick.es/fruits/aguacate.png',
        x: 78.5,
        y: 25,
        width: 12.578125,
        height: 24.5,
        original_height_px: 196,
        original_width_px: 161,
        z: 1
      }, {
        src: 'https://lemonade-assets.oneclick.es/fruits/fresa-1.png',
        x: 59,
        y: 74.6,
        width: 11.328125,
        height: 15.875,
        original_height_px: 127,
        original_width_px: 145,
        z: 2
      }, {
        src: 'https://lemonade-assets.oneclick.es/fruits/fresa-2.png',
        x: 11.3,
        y: 68.7,
        width: 12.265625,
        height: 12.125,
        original_height_px: 97,
        original_width_px: 157,
        z: 3
      }, {
        src: 'https://lemonade-assets.oneclick.es/fruits/limon-1.png',
        x: 64.2,
        y: 13.6,
        width: 11.953125,
        height: 15.75,
        original_height_px: 126,
        original_width_px: 153,
        z: 4
      }, {
        src: 'https://lemonade-assets.oneclick.es/fruits/limon-2.png',
        x: 6,
        y: 33.9,
        width: 11.09375,
        height: 16,
        original_height_px: 128,
        original_width_px: 142,
        z: 5
      }, {
        src: 'https://lemonade-assets.oneclick.es/fruits/limon-3.png',
        x: 43.9,
        y: 58,
        width: 12.34375,
        height: 15.875,
        original_height_px: 127,
        original_width_px: 158,
        z: 6
      }, {
        src: 'https://lemonade-assets.oneclick.es/fruits/manzana-1.png',
        x: 21.7,
        y: 6.2,
        width: 11.171875,
        height: 18.875,
        original_height_px: 151,
        original_width_px: 143,
        z: 7
      }, {
        src: 'https://lemonade-assets.oneclick.es/fruits/manzana-2.png',
        x: 60.1,
        y: 42,
        width: 11.09375,
        height: 20.875,
        original_height_px: 167,
        original_width_px: 142,
        z: 8
      }, {
        src: 'https://lemonade-assets.oneclick.es/fruits/naranja.png',
        x: 32,
        y: 73.7,
        width: 10.625,
        height: 20.125,
        original_height_px: 161,
        original_width_px: 136,
        z: 9
      }, {
        src: 'https://lemonade-assets.oneclick.es/fruits/pinia-1.png',
        x: 43.3,
        y: 14,
        width: 10.78125,
        height: 28.75,
        original_height_px: 230,
        original_width_px: 138,
        z: 10
      }, {
        src: 'https://lemonade-assets.oneclick.es/fruits/pinia-2.png',
        x: 76.2,
        y: 57,
        width: 12.890625,
        height: 27.375,
        original_height_px: 219,
        original_width_px: 165,
        z: 11
      }, {
        src: 'https://lemonade-assets.oneclick.es/fruits/sandia.png',
        x: 26.5,
        y: 34.2,
        width: 11.171875,
        height: 22.625,
        original_height_px: 181,
        original_width_px: 143,
        z: 12
      }],
      validation: {
        scoring_type: validationModes.PARTIAL_MATCH_V2,
        penalty: 0,
        penalty_mode: penaltyModes.PER_RESPONSE,
        immediateFeedback: false,
        valid_response: {
          score: 1,
          value: [3, 4, 5]
        }
      },
      ui_style: {
        feedback_mode: 'feedback-with-tick',
        showSelection: true,
        no_box_padding: true
      }
    }
  }, _types$other$UploadFi[types.other.AudioRecorder] = {
    title: '',
    type: 'audiorecorder',
    data: {
      type: 'audiorecorder',
      stimulus: "<p>" + translate('other_audio_recorder_stimulus_default') + "</p>",
      maxTime: 120
    },
    metadata: {
      name: types.other.AudioRecorder
    }
  }, _types$other$UploadFi[types.other.Clock] = {
    title: '',
    type: 'clock',
    data: {
      type: 'clock',
      stimulus: "<p>" + translate('other_clock_stimulus_default') + "</p>",
      validation: {
        scoring_type: 'exactMatch',
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: [15, 30]
        },
        penalty: 0
      },
      ui_style: {
        type: CLOCK_TYPES.ANALOG,
        time_system: CLOCK_TIME_SYSTEMS.HOUR_24,
        theme: CLOCK_THEMES.DARK,
        step: 1,
        customClass: ''
      }
    },
    metadata: {
      name: types.other.Clock
    }
  }, _types$other$UploadFi[types.other.WordSearch] = {
    title: '',
    type: 'wordsearch',
    data: {
      type: 'wordsearch',
      stimulus: "<p>" + translate('other_word_search_stimulus_default') + " " + getWordSearchValue(config.lang).join(', ') + "</p>",
      validation: {
        scoring_type: validationModes.PARTIAL_MATCH_V2,
        penalty_mode: penaltyModes.NONE,
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: getWordSearchValue(config.lang)
        },
        penalty: 0
      },
      board: {
        columns: 10,
        rows: 10,
        letters: getWordSearchLetters(config.lang),
        backward: false,
        diagonal: true,
        allowed_letters: getWordSearchAllowedLetters(config.lang)
      },
      shuffle_options: false,
      ui_style: {
        customClass: ''
      }
    },
    metadata: {
      name: types.other.WordSearch
    }
  }, _types$other$UploadFi[types.other.Crossword] = {
    title: '',
    type: 'crossword',
    data: {
      type: 'crossword',
      stimulus: "<p>" + translate('other_crossword_stimulus_default') + "</p>",
      validation: {
        scoring_type: validationModes.PARTIAL_MATCH_V2,
        penalty_mode: penaltyModes.NONE,
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: getCrosswordValue(config.lang)
        },
        penalty: 0
      },
      words: getCrosswordWords(config.lang),
      board: {
        columns: 10,
        rows: 10,
        letters: getCrosswordLetters(config.lang),
        words_position: getCrosswordWordsPosition(config.lang)
      },
      shuffle_options: false,
      ui_style: {
        customClass: ''
      },
      normalization: {
        accents: false,
        spaces: false,
        lower: false,
        isMath: false
      }
    },
    metadata: {
      name: types.other.Crossword
    }
  }, _types$other$UploadFi[types.other.PathWay] = {
    title: '',
    type: 'pathway',
    extraValues: {},
    metadata: {
      name: types.other.PathWay
    },
    data: {
      type: 'pathway',
      stimulus: "<p>" + translate('other_pathway_stimulus_default') + "</p>",
      validation: {
        scoring_type: 'exactMatch',
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: [[3, 0], [2, 0], [2, 1], [2, 2], [2, 3], [3, 3]]
        },
        penalty: 0
      },
      board: {
        columns: 5,
        rows: 5,
        icon: 'https://lemonade-assets.oneclick.es/pathway/pirate.png',
        background: {
          src: 'https://lemonade-assets.oneclick.es/pathway/bck1.png',
          mode: 'repeat',
          width: 125,
          height: 125,
          alt: ''
        }
      },
      shuffle_options: false,
      ui_style: {
        customClass: ''
      }
    }
  }, _types$other$UploadFi[types.other.ReversePathWay] = {
    title: '',
    type: 'reversepathway',
    metadata: {
      name: types.other.ReversePathWay
    },
    data: {
      type: 'reversepathway',
      stimulus: "<p>" + translate('other_reverse_pathway_stimulus_default') + "</p>",
      board: {
        columns: 5,
        rows: 5,
        icon: 'https://lemonade-assets.oneclick.es/pathway/pirate.png',
        background: {
          src: 'https://lemonade-assets.oneclick.es/pathway/bck1.png',
          mode: 'repeat',
          width: undefined,
          height: undefined,
          alt: ''
        },
        pathway: [[2, 0], [2, 1], [2, 2], [3, 2], [3, 3], [4, 3]]
      },
      validation: {
        scoring_type: 'exactMatch',
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: [{
            steps: 2,
            direction: 'BOTTOM'
          }, {
            steps: 1,
            direction: 'RIGHT'
          }, {
            steps: 1,
            direction: 'BOTTOM'
          }, {
            steps: 1,
            direction: 'RIGHT'
          }]
        },
        penalty: 0
      },
      shuffle_options: false,
      ui_style: {
        customClass: ''
      }
    },
    extraValues: {}
  }, _types$other$UploadFi[types.other.Rating] = {
    title: '',
    type: 'rating',
    metadata: {
      name: types.other.Rating
    },
    data: {
      type: 'rating',
      stimulus: "<p>" + translate('other_rating_stimulus_default') + "</p>",
      cumulative_mode: true,
      options: [{
        value: '1',
        label_tooltip: translate('other_rating_tooltip_1_star'),
        label: 'icon_star',
        description: translate('other_rating_description_1_star')
      }, {
        value: '2',
        label_tooltip: translate('other_rating_tooltip_multiple_stars').replaceAll('{{count}}', 2),
        label: 'icon_star',
        description: translate('other_rating_description_2_stars')
      }, {
        value: '3',
        label_tooltip: translate('other_rating_tooltip_multiple_stars').replaceAll('{{count}}', 3),
        label: 'icon_star',
        description: translate('other_rating_description_3_stars')
      }, {
        value: '4',
        label_tooltip: translate('other_rating_tooltip_multiple_stars').replaceAll('{{count}}', 4),
        label: 'icon_star',
        description: translate('other_rating_description_4_stars')
      }],
      ui_style: {
        customClass: ''
      }
    }
  }, _types$other$UploadFi[types.other.AdaptativeChoice] = {
    title: '',
    type: 'adaptativechoice',
    metadata: {
      name: types.other.AdaptativeChoice
    },
    data: {
      type: 'adaptativechoice',
      stimulus: '',
      levels: [{
        id: 'level_1',
        title: 'Selecciona tu universo preferido:',
        options: [{
          label: 'El planeta',
          value: '1',
          src: '🌍'
        }, {
          label: 'Círculos',
          value: '2',
          src: '⭕'
        }, {
          label: 'Máquinas',
          value: '3',
          src: '⚙️'
        }, {
          label: 'Pasatiempos',
          value: '4',
          src: '🎯'
        }]
      }, {
        id: 'level_2',
        title: 'Selecciona tu mundo específico:',
        dependencies: {
          1: [{
            label: 'Lugares',
            value: '1_1',
            src: '🗺️'
          }, {
            label: 'Gente del mundo',
            value: '1_2',
            src: '👥'
          }, {
            label: 'Especies',
            value: '1_3',
            src: '🦁'
          }],
          2: [{
            label: 'Pertenencia',
            value: '2_1',
            src: '🔗'
          }, {
            label: 'Popularidad',
            value: '2_2',
            src: '⭐'
          }, {
            label: 'Huella',
            value: '2_3',
            src: '👣'
          }],
          3: [{
            label: 'Gadgets',
            value: '3_1',
            src: '📱'
          }, {
            label: 'Robótica',
            value: '3_2',
            src: '🤖'
          }, {
            label: 'Innovación',
            value: '3_3',
            src: '💡'
          }],
          4: [{
            label: 'Deportes',
            value: '4_1',
            src: '⚽'
          }, {
            label: 'Arte',
            value: '4_2',
            src: '🎨'
          }, {
            label: 'Juego',
            value: '4_3',
            src: '🎮'
          }]
        }
      }],
      validation: {
        scoring_type: 'manual',
        valid_response: {
          score: 1,
          value: ''
        }
      },
      ui_style: {
        customClass: ''
      },
      showCheckIcon: false,
      isEvaluable: false
    }
  }, _types$other$UploadFi)[dataId];
};
function getDefaultData$7(dataId) {
  var reference = uuid();
  return _extends({}, defaultData$7(dataId), {
    reference: reference
  });
}

var TABLE_POSITION_ABOVE$1 = 'lemo-table_position_above';
var TABLE_POSITION_BELOW$1 = 'lemo-table_position_below';
var TABLE_POSITION_LEFT$1 = 'lemo-table_position_left';
var TABLE_POSITION_RIGHT$1 = 'lemo-table_position_right';
var ABOVE$1 = 'ABOVE';
var BELOW$1 = 'BELOW';
var LEFT$1 = 'LEFT';
var RIGHT$3 = 'RIGHT';

var defaultData$8 = function defaultData(dataId) {
  var _normalizedTypes$char;
  return (_normalizedTypes$char = {}, _normalizedTypes$char[normalizedTypes.charts_pictograph.value] = {
    title: '',
    type: normalizedTypes.charts_pictograph.value.toLowerCase(),
    metadata: {
      name: normalizedTypes.charts_pictograph.value
    },
    data: {
      type: normalizedTypes.charts_pictograph.value.toLowerCase(),
      stimulus: "<p>" + translate('charts_pictograph_stimulus_default') + "</p>",
      chart_data: {
        data: [{
          id: '0',
          src: 'https://lemonade-assets.oneclick.es/fruits/manzana-1.png',
          x: translate('Apples'),
          y: 0
        }, {
          id: '1',
          src: 'https://lemonade-assets.oneclick.es/fruits/limon-1.png',
          x: translate('Lemons'),
          y: 0
        }, {
          id: '2',
          src: 'https://lemonade-assets.oneclick.es/fruits/pinia-1.png',
          x: translate('Pineapples'),
          y: 0
        }, {
          id: '3',
          src: 'https://lemonade-assets.oneclick.es/fruits/aguacate.png',
          x: translate('Avocados'),
          y: 0
        }, {
          id: '4',
          src: 'https://lemonade-assets.oneclick.es/fruits/fresa-1.png',
          x: translate('Strawberries'),
          y: 0
        }],
        name: '',
        y_axis_name: translate('charts_pictograph_y_axis_name'),
        x_axis_name: translate('charts_pictograph_x_axis_name'),
        y_axis_label: translate('charts_pictograph_y_axis_label'),
        x_axis_label: translate('charts_pictograph_x_axis_label'),
        max_y_value: 8,
        multiplier_y_value: 1
      },
      validation: {
        scoring_type: 'exactMatch',
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: [{
            x: translate('Apples'),
            y: 4
          }, {
            x: translate('Lemons'),
            y: 2
          }, {
            x: translate('Pineapples'),
            y: 1
          }, {
            x: translate('Avocados'),
            y: 5
          }, {
            x: translate('Strawberries'),
            y: 3
          }]
        },
        penalty: 0
      },
      ui_style: {
        legend_show: false,
        chart_data_show: true,
        chart_data_position: ABOVE$1
      }
    }
  }, _normalizedTypes$char[normalizedTypes.charts_barchart.value] = {
    title: '',
    type: 'barchart',
    metadata: {
      name: normalizedTypes.charts_barchart.value
    },
    data: {
      type: 'barchart',
      stimulus: "<p>" + translate('charts_barchart_stimulus_default') + "</p>",
      chart_data: {
        data: [{
          id: '0',
          src: 'https://lemonade-assets.oneclick.es/fruits/aguacate.png',
          x: translate('Avocados'),
          y: [0],
          theme: 'theme-light-orange'
        }, {
          id: '1',
          src: 'https://lemonade-assets.oneclick.es/fruits/limon-1.png',
          x: translate('Lemons'),
          y: [0],
          theme: 'theme-dark-orange'
        }, {
          id: '2',
          src: 'https://lemonade-assets.oneclick.es/fruits/manzana-1.png',
          x: translate('Apples'),
          y: [0],
          theme: 'theme-light-blue'
        }],
        name: '',
        y_axis_name: translate('charts_pictograph_y_axis_name'),
        x_axis_name: translate('charts_pictograph_x_axis_name'),
        x_axis_label: translate('charts_pictograph_x_axis_label'),
        y_axis_labels: [{
          label: translate('charts_pictograph_y_axis_label')
        }],
        max_y_value: 10,
        min_y_value: 0,
        multiplier_y_value: 10
      },
      validation: {
        scoring_type: 'exactMatch',
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: [{
            id: '0',
            x: translate('Avocados'),
            y: [2]
          }, {
            id: '1',
            x: translate('Lemons'),
            y: [4]
          }, {
            id: '2',
            x: translate('Apples'),
            y: [6]
          }]
        },
        penalty: 0
      },
      ui_style: {
        customClass: '',
        legend_show: false,
        chart_data_show: true,
        chart_data_position: ABOVE$1
      }
    },
    extraValues: {}
  }, _normalizedTypes$char[normalizedTypes.charts_line_chart.value] = {
    title: '',
    type: 'linechart',
    metadata: {
      name: normalizedTypes.charts_line_chart.value
    },
    data: {
      type: 'linechart',
      stimulus: "<p>" + translate('charts_linechart_stimulus_default') + "</p>",
      chart_data: {
        data: [[{
          x: translate('winter'),
          y: 0
        }, {
          x: translate('spring'),
          y: 0
        }, {
          x: translate('summer'),
          y: 0
        }, {
          x: translate('fall'),
          y: 0
        }], [{
          x: translate('winter'),
          y: 0
        }, {
          x: translate('spring'),
          y: 0
        }, {
          x: translate('summer'),
          y: 0
        }, {
          x: translate('fall'),
          y: 0
        }]],
        name: '',
        y_axis_name: translate('charts_line_chart_y_axis_name'),
        x_axis_name: translate('charts_line_chart_x_axis_name'),
        x_axis_label: translate('charts_line_chart_x_axis_name'),
        y_axis_labels: [{
          label: translate('Madrid'),
          theme: 'theme-light-blue'
        }, {
          label: translate('Paris'),
          theme: 'theme-dark-orange'
        }],
        max_y_value: 10,
        min_y_value: 2,
        multiplier_y_value: 2,
        measure: 'º C'
      },
      validation: {
        scoring_type: 'exactMatch',
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: [[{
            x: translate('winter'),
            y: 4
          }, {
            x: translate('spring'),
            y: 2
          }, {
            x: translate('summer'),
            y: 3
          }, {
            x: translate('fall'),
            y: 6
          }], [{
            x: translate('winter'),
            y: 6
          }, {
            x: translate('spring'),
            y: 5
          }, {
            x: translate('summer'),
            y: 4
          }, {
            x: translate('fall'),
            y: 0
          }]]
        },
        penalty: 0
      },
      ui_style: {
        customClass: '',
        legend_show: false,
        chart_data_show: true,
        chart_data_position: ABOVE$1
      }
    },
    extraValues: {}
  }, _normalizedTypes$char[normalizedTypes.charts_pie_chart.value] = {
    title: '',
    type: 'piechart',
    metadata: {
      name: normalizedTypes.charts_pie_chart.value
    },
    data: {
      type: 'piechart',
      stimulus: "<p>" + translate('charts_pie_chart_stimulus_default') + "</p>",
      chart_data: {
        data: [{
          label: translate('Pears'),
          theme: 'theme-turquoise'
        }, {
          label: translate('Apples'),
          theme: 'theme-dark-orange'
        }, {
          label: translate('Pineapples'),
          theme: 'theme-light-orange'
        }],
        labels: [translate('Fruits'), translate('Quantity')]
      },
      validation: {
        scoring_type: 'exactMatch',
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: [{
            label: translate('Pears'),
            value: 5
          }, {
            label: translate('Apples'),
            value: 2
          }, {
            label: translate('Pineapples'),
            value: 3
          }]
        },
        penalty: 0
      },
      ui_style: {
        customClass: '',
        chart_data_position: ABOVE$1
      }
    },
    extraValues: {}
  }, _normalizedTypes$char[normalizedTypes.charts_flowchart.value] = {
    title: '',
    type: normalizedTypes.charts_flowchart.value.toLowerCase(),
    metadata: {
      name: normalizedTypes.charts_flowchart.value
    },
    data: {
      type: normalizedTypes.charts_flowchart.value.toLowerCase(),
      stimulus: "<p>" + translate('charts_flow_chart_stimulus_default') + "</p>",
      chart: {
        config: {
          chart: 'flowchart',
          direction: 'TB'
        },
        nodes: [{
          id: 'n1',
          label: 'Inicio',
          type: 'start',
          "static": true
        }, {
          id: 'n2',
          label: '¿Los denominadores de las fracciones son iguales?',
          type: 'decision'
        }, {
          id: 'n3',
          label: 'Sí',
          type: 'process'
        }, {
          id: 'n4',
          label: 'La fracción con el numerador mayor será la mayor.',
          type: 'process'
        }, {
          id: 'n6',
          label: 'No',
          type: 'process'
        }, {
          id: 'n7',
          label: 'Calcula fracciones equivalentes con el mismo denominador y compáralas. La mayor es la que tiene mayor denominador.',
          type: 'process'
        }, {
          id: 'n8',
          label: 'Fin',
          type: 'end',
          "static": true
        }],
        edges: [{
          source: 'n1',
          target: 'n2'
        }, {
          source: 'n2',
          target: 'n3',
          label: 'Sí'
        }, {
          source: 'n2',
          target: 'n6',
          label: 'No'
        }, {
          source: 'n3',
          target: 'n4'
        }, {
          source: 'n6',
          target: 'n7'
        }, {
          source: 'n4',
          target: 'n8'
        }, {
          source: 'n7',
          target: 'n8'
        }]
      },
      validation: {
        scoring_type: 'exactMatch',
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: [1]
        },
        penalty: 0
      },
      ui_style: {
        customClass: ''
      }
    },
    extraValues: {}
  }, _normalizedTypes$char[normalizedTypes.charts_histograms.value] = {
    title: '',
    type: normalizedTypes.charts_histograms.value.toLowerCase(),
    metadata: {
      name: normalizedTypes.charts_histograms.value
    },
    data: {
      type: normalizedTypes.charts_histograms.value.toLowerCase(),
      stimulus: "<p>" + translate('charts_histograms_stimulus_default') + "</p>",
      chart_data: {
        x_values: [30, 34, 38, 42, 46],
        data: [{
          id: '0',
          x: '[30, 34)',
          y: [0]
        }, {
          id: '1',
          x: '[34, 38)',
          y: [0]
        }, {
          id: '2',
          x: '[38, 42)',
          y: [0]
        }, {
          id: '0',
          x: '[42, 46)',
          y: [0]
        }],
        x_axis_name: translate('charts_histograms_x_axis_name'),
        x_axis_label: translate('charts_histograms_x_axis_label'),
        y_axis_name: translate('charts_histograms_y_axis_name'),
        y_axis_label: translate('charts_histograms_y_axis_label'),
        max_y_value: 9,
        min_y_value: 1,
        multiplier_y_value: 1
      },
      validation: {
        scoring_type: 'exactMatch',
        immediateFeedback: false,
        alt_responses: [],
        valid_response: {
          score: 1,
          value: [{
            id: '0',
            x: '[30, 34)',
            y: [4]
          }, {
            id: '1',
            x: '[34, 38)',
            y: [8]
          }, {
            id: '2',
            x: '[38, 42)',
            y: [9]
          }, {
            id: '3',
            x: '[42, 46)',
            y: [6]
          }]
        },
        penalty: 0
      },
      ui_style: {
        customClass: '',
        legend_show: false,
        chart_data_show: true,
        chart_data_position: ABOVE$1
      }
    },
    extraValues: {}
  }, _normalizedTypes$char)[dataId];
};
function getDefaultData$8(dataId) {
  var reference = uuid();
  return _extends({}, defaultData$8(dataId), {
    reference: reference
  });
}

function getDefaultData$9(metaName) {
  var _findSubKey = findSubKey(metaName, types),
    family = _findSubKey[0];
  switch (family) {
    case 'multipleChoice':
      return exportData(getDefaultData$6(metaName));
    case 'choiceMatrix':
      return exportData(getDefaultData(metaName));
    case 'essay':
      return exportData(getDefaultData$3(metaName));
    case 'cloze':
      return exportData(getDefaultData$2(metaName));
    case 'classify':
      return exportData(getDefaultData$1(metaName));
    case 'labelImage':
      return exportData(getDefaultData$4(metaName));
    case 'math':
      return exportData(getDefaultData$5(metaName));
    case 'other':
      return exportData(getDefaultData$7(metaName));
    case 'charts':
      return exportData(getDefaultData$8(metaName));
    default:
      return null;
  }
}
function exportData(activityData) {
  var _window;
  var result = produce(activityData, function (draft) {
    if (!draft.data.validation) {
      draft.data.validation = getEmptyValidation();
    }
    if (draft.data.isEvaluable === undefined) {
      draft.data.isEvaluable = getIsEvaluable(draft);
    }
    if (!draft.data.ui_style) {
      draft.data.ui_style = {};
    }
  });
  return _extends({}, result, {
    lemonadeVersion: (_window = window) === null || _window === void 0 ? void 0 : _window.lemonadeVersion,
    reference: uuid()
  });
}
function getEmptyValidation() {
  return {
    scoring_type: 'manual',
    valid_response: {
      score: 0,
      value: ''
    }
  };
}
function getIsEvaluable(draft) {
  return draft.data.validation.scoring_type !== validationModes$1.MANUAL;
}

var normalizedTypes = {
  multiple_choice_single: {
    value: types.multipleChoice.Single,
    className: 'lemo-multiple-choice',
    subTemplateId: 'lemo-multiple-choice-single'
  },
  emotions_choice_single: {
    value: types.multipleChoice.EmotionsSingle,
    className: 'lemo-multiple-choice',
    subTemplateId: 'lemo-emotions-choice-single'
  },
  multiple_choice_multiple: {
    value: types.multipleChoice.Multiple,
    className: 'lemo-multiple-choice',
    subTemplateId: 'lemo-multiple-choice-multiple'
  },
  multiple_choice_true_false: {
    value: types.multipleChoice.TrueFalse,
    className: 'lemo-multiple-choice',
    subTemplateId: 'lemo-multiple-choice-true-false'
  },
  multiple_choice_block_letter: {
    value: types.multipleChoice.BlockLetter,
    className: 'lemo-multiple-choice',
    subTemplateId: 'lemo-multiple-choice-block'
  },
  choice_matrix_table: {
    value: types.choiceMatrix.Table,
    className: 'lemo-choice-matrix',
    subTemplateId: 'lemo-multiple-choice-table'
  },
  choice_matrix_inline: {
    value: types.choiceMatrix.Inline,
    className: 'lemo-choice-matrix',
    subTemplateId: 'lemo-choice-matrix-inline'
  },
  essay_short_text: {
    value: types.essay.ShortText,
    className: 'lemo-essay-short-text'
  },
  essay_rich_text: {
    value: types.essay.RichText,
    className: 'lemo-essay-rich-text'
  },
  essay_plain_text: {
    value: types.essay.PlainText,
    className: 'lemo-essay-rich-text'
  },
  cloze_text: {
    value: types.cloze.Text,
    className: 'lemo-cloze-text'
  },
  cloze_dropdown: {
    value: types.cloze.DropDown,
    className: 'lemo-cloze-dropdown'
  },
  cloze_drag_drop: {
    value: types.cloze.Association,
    className: 'lemo-cloze-drag'
  },
  classify_classification: {
    value: types.classify.Classification,
    className: 'lemo-classify-classification'
  },
  classify_match_list: {
    value: types.classify.MatchList,
    className: 'lemo-classify-match-list'
  },
  classify_match_list_mobile: {
    value: types.classify.MatchListMobile,
    className: 'lemo-classify-match-list'
  },
  classify_order_list: {
    value: types.classify.OrderList,
    className: 'lemo-classify-order-list'
  },
  classify_linking_lines: {
    value: types.classify.LinkingLines,
    className: 'lemo-classify-linking-lines'
  },
  classify_order_list_mobile: {
    value: types.classify.OrderListMobile,
    className: 'lemo-classify-order-list-mobile'
  },
  classify_stickers: {
    value: types.classify.Stickers,
    className: 'lemo-classify-stickers'
  },
  classify_stickers_series: {
    value: types.classify.StickersSeries,
    className: 'lemo-classify-stickers-series'
  },
  label_image_text_v2: {
    value: types.labelImage.TextV2,
    className: 'lemo-label-image-text'
  },
  label_image_dropdown_v2: {
    value: types.labelImage.DropDownV2,
    className: 'lemo-label-image-dropdown'
  },
  label_image_drag_drop_v2: {
    value: types.labelImage.DragDropV2,
    className: 'lemo-label-image-drag'
  },
  math_cloze_math: {
    value: types.math.ClozeMath,
    className: 'lemo-math-cloze-math'
  },
  math_counting: {
    value: types.math.Counting,
    className: 'lemo-math-counting'
  },
  math_number_line: {
    value: types.math.NumberLine,
    className: 'lemo-math-number-line'
  },
  math_fraction: {
    value: types.math.Fraction,
    className: 'lemo-charts-fraction'
  },
  math_coordinate_axes: {
    value: types.math.CoordinateAxes,
    className: 'lemo-math_coordinate_axes'
  },
  math_boxplot: {
    value: types.math.Boxplot,
    className: 'lemo-math-boxplot'
  },
  math_sum: {
    value: types.math.Sum,
    className: 'lemo-sum'
  },
  math_subtraction: {
    value: types.math.Subtraction,
    className: 'lemo-subtraction'
  },
  math_transformations_in_plane: {
    value: types.math.TransformationsInPlane,
    className: 'lemo-transformations-in-plane'
  },
  math_lineal_function: {
    value: types.math.LinealFunction,
    className: 'lemo-math-functions'
  },
  math_quadratic_function: {
    value: types.math.QuadraticFunction,
    className: 'lemo-math-functions'
  },
  math_prime_number_decomposition: {
    value: types.math.PrimeNumberDecomposition,
    className: 'lemo-math-prime-number-decomposition'
  },
  math_find_closest_value: {
    value: types.math.FindClosestValue,
    className: 'lemo-math-find-closest-value'
  },
  other_upload_file: {
    value: types.other.UploadFile,
    className: 'lemo-other-upload-file'
  },
  other_pencil: {
    value: types.other.Pencil,
    className: 'lemo-other-pencil'
  },
  other_click_to_find: {
    value: types.other.ClickToFind,
    className: 'lemo-other-click-to-find'
  },
  other_audio_recorder: {
    value: types.other.AudioRecorder,
    className: 'lemo-other-audio-recorder'
  },
  other_statement: {
    value: types.other.Statement,
    className: 'lemo-other-statement'
  },
  other_clock: {
    value: types.other.Clock,
    className: 'lemo-other-clock'
  },
  other_word_search: {
    value: types.other.WordSearch,
    className: 'lemo-other-word-search'
  },
  other_crossword: {
    value: types.other.Crossword,
    className: 'lemo-other-crossword'
  },
  other_pathway: {
    value: types.other.PathWay,
    className: 'lemo-other-pathway'
  },
  other_reverse_pathway: {
    value: types.other.ReversePathWay,
    className: 'lemo-other-reverse-pathway'
  },
  other_rating: {
    value: types.other.Rating,
    className: 'lemo-other-rating'
  },
  other_adaptative_choice: {
    value: types.other.AdaptativeChoice,
    className: 'lemo-adaptative-choice',
    subTemplateId: 'lemo-other-adaptative-choice'
  },
  charts_pictograph: {
    value: types.charts.Pictograph,
    className: 'lemo-charts-pictograph'
  },
  charts_barchart: {
    value: types.charts.Barchart,
    className: 'lemo-charts-barchart'
  },
  charts_line_chart: {
    value: types.charts.LineChart,
    className: 'lemo-charts-line-chart'
  },
  charts_pie_chart: {
    value: types.charts.PieChart,
    className: 'lemo-charts-pie-chart'
  },
  charts_flowchart: {
    value: types.charts.Flowchart,
    className: 'lemo-charts-flowchart'
  },
  charts_histograms: {
    value: types.charts.Histograms,
    className: 'lemo-charts-histograms'
  }
};

function queryParams(source) {
  return source.split(/[?|&]/).reduce(function (acc, next) {
    return !next ? acc : _extends({}, acc, function (val, _ref) {
      return _ref = {}, _ref[val[0]] = val[1], _ref;
    }(next.split(/=(.+)/)));
  }, {});
}

function isDeveloperMode() {
  if (window.location.host.indexOf('localhost:') === 0) return true;
  if (window.lemonadeDeveloperMode) return true;
  if (queryParams(document.location.href).dev === 1) return true;
  return false;
}

function QuestionPreview(_ref) {
  var store = _ref.store,
    changed = _ref.changed,
    scormControls = _ref.scormControls,
    immediateFeedback = _ref.immediateFeedback,
    onImmediateError = _ref.onImmediateError,
    onImmediateSuccess = _ref.onImmediateSuccess,
    onComplete = _ref.onComplete,
    onKeyboardVisible = _ref.onKeyboardVisible,
    stimulusBullet = _ref.stimulusBullet;
  var _useLemonadeQuestion = useLemonadeQuestion({
      data: store.output,
      lang: config.lang
    }),
    exercise = _useLemonadeQuestion.exercise;
  useEffect(function () {
    if (store.questionNeedUpdate && !areStoresEqual(store.output.data, exercise.questionApi.output.data)) {
      exercise.questionApi.resetCache();
      exercise.questionApi.hydrateQuestionPreview(store.output).then(function () {});
    }
  }, [store.onUpdateNotifier, store.onUpdateQuestionPreview]);
  if (isDeveloperMode()) window.previewStore = exercise.questionApi;
  return !isAlive(store) ? null : /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-preview",
    key: exercise.onUpdateNotifier
  }, /*#__PURE__*/React__default.createElement(exercise.Controls, {
    showPoints: true,
    showCheckAnswer: true,
    showReset: true,
    showSolution: true
  }, /*#__PURE__*/React__default.createElement(exercise.Question, {
    changed: changed,
    scormControls: scormControls,
    immediateFeedback: immediateFeedback,
    onImmediateError: onImmediateError,
    onImmediateSuccess: onImmediateSuccess,
    onComplete: onComplete,
    onKeyboardVisible: onKeyboardVisible,
    isPreview: true,
    stimulusBullet: stimulusBullet
  }), /*#__PURE__*/React__default.createElement(exercise.Feedback, null)), /*#__PURE__*/React__default.createElement(exercise.SampleAnswer, null));
}
function areStoresEqual(editor, solution) {
  return JSON.stringify(editor) === JSON.stringify(solution);
}
var _QuestionPreview = observer(QuestionPreview);

function AllQuestionsExercise(_ref) {
  var data = _ref.data;
  var _useLemonadeQuestion = useLemonadeQuestion({
      data: data
    }),
    exercise = _useLemonadeQuestion.exercise;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemonade-exercises"
  }, /*#__PURE__*/React__default.createElement(_QuestionPreview, {
    store: exercise.questionApi
  }));
}
var AllQuestionsExercise$1 = observer(AllQuestionsExercise);

function AllQuestions() {
  var _useState = useState([]),
    dataList = _useState[0],
    setDataList = _useState[1];
  useEffect(function () {
    var newDataList = [];
    var keys = Object.keys(normalizedTypes);
    for (var i = 0; i < keys.length; i++) {
      var normalizeType = normalizedTypes[keys[i]];
      newDataList.push(getDefaultData$9(normalizeType.value));
    }
    setDataList(newDataList);
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemonade-all-exercises"
  }, dataList.map(function (data) {
    return data ? /*#__PURE__*/React__default.createElement(AllQuestionsExercise$1, {
      key: data.reference,
      data: data
    }) : '<p>No se puede</p>';
  }));
}
AllQuestions.propTypes = {};
AllQuestions.defaultProps = {};

function EditorAndQuestion(_ref) {
  var data = _ref.data,
    _ref$showQuestion = _ref.showQuestion,
    showQuestion = _ref$showQuestion === void 0 ? true : _ref$showQuestion,
    _ref$showEditor = _ref.showEditor,
    showEditor = _ref$showEditor === void 0 ? true : _ref$showEditor;
  var _useLemonadeEditor = useLemonadeEditor({
      data: data,
      lang: config.lang
    }),
    _useLemonadeEditor$ex = _useLemonadeEditor.exercise,
    Question = _useLemonadeEditor$ex.Question,
    Editor = _useLemonadeEditor$ex.Editor,
    editorApi = _useLemonadeEditor$ex.editorApi;
  return !isAlive(editorApi) ? null : /*#__PURE__*/React__default.createElement("div", {
    className: cn('lemonade-exercises')
  }, showQuestion && showEditor ? /*#__PURE__*/React__default.createElement("div", {
    className: "editor-column-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "editor-column sticky"
  }, /*#__PURE__*/React__default.createElement(Question, null)), /*#__PURE__*/React__default.createElement("div", {
    className: "editor-column"
  }, /*#__PURE__*/React__default.createElement(Editor, null))) : showEditor ? /*#__PURE__*/React__default.createElement(Editor, null) : /*#__PURE__*/React__default.createElement(Question, null));
}
var EditorAndQuestion$1 = observer(EditorAndQuestion);

function AllEditorsExercise(_ref) {
  var data = _ref.data,
    _ref$showQuestion = _ref.showQuestion,
    showQuestion = _ref$showQuestion === void 0 ? true : _ref$showQuestion,
    _ref$showEditor = _ref.showEditor,
    showEditor = _ref$showEditor === void 0 ? true : _ref$showEditor;
  return /*#__PURE__*/React__default.createElement(Lemonade, null, /*#__PURE__*/React__default.createElement(EditorAndQuestion$1, {
    data: data,
    showQuestion: showQuestion,
    showEditor: showEditor
  }));
}
var AllEditorsExercise$1 = observer(AllEditorsExercise);

function AllEditors() {
  var _useState = useState([]),
    dataList = _useState[0],
    setDataList = _useState[1];
  useEffect(function () {
    var newDataList = [];
    var keys = Object.keys(normalizedTypes);
    for (var i = 0; i < keys.length; i++) {
      var normalizeType = normalizedTypes[keys[i]];
      newDataList.push(getDefaultData$9(normalizeType.value));
    }
    setDataList(newDataList);
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemonade-all-exercises"
  }, dataList.map(function (data) {
    return data ? /*#__PURE__*/React__default.createElement(AllEditorsExercise$1, {
      key: data.reference,
      data: data
    }) : '<p>No se puede</p>';
  }));
}
AllEditors.propTypes = {};
AllEditors.defaultProps = {};

var controlsStatus = {
  first: {
    initial: {
      id: 'firstInitial',
      visible: {
        validate: true,
        idk: true
      },
      disabled: {}
    },
    success: {
      id: 'firstSuccess',
      visible: {
        reset: true,
        idk: true
      },
      disabled: {
        idk: true
      }
    },
    error: {
      id: 'firstError',
      visible: {
        validate: true,
        idk: true
      },
      disabled: {
        validate: true,
        idk: true
      }
    }
  },
  inBetween: {
    initial: {
      id: 'inBetweenInitial',
      visible: {
        validate: true,
        hint: true
      },
      disabled: {}
    },
    success: {
      id: 'inBetweenSuccess',
      visible: {
        validate: true,
        hint: true
      },
      disabled: {
        validate: true,
        hint: true
      }
    },
    error: {
      id: 'inError',
      visible: {
        reset: true,
        hint: true,
        showSolution: true
      },
      disabled: {}
    },
    solution: {
      id: 'inBetweenSolution',
      visible: {
        hint: true,
        reset: true,
        showSolution: true
      },
      disabled: {
        reset: true
      }
    }
  },
  last: {
    initial: {
      id: 'lastInitial',
      visible: {
        validate: true,
        hint: true
      },
      disabled: {}
    },
    success: {
      id: 'lastSuccess',
      visible: {
        restartScaffold: true,
        hint: true
      },
      disabled: {
        hint: true
      }
    },
    error: {
      id: 'lastError',
      visible: {
        reset: true,
        hint: true,
        showSolution: true
      },
      disabled: {}
    },
    solution: {
      id: 'lastSolution',
      visible: {
        restartScaffold: true,
        hint: true,
        showSolution: true
      },
      disabled: {}
    }
  }
};
function useQuestionStatus(_ref) {
  var store = _ref.store,
    currentQuestion = _ref.currentQuestion;
  var isSuccess = store.isEvaluated && store.points > 0;
  var isError = store.isEvaluated && store.points === 0;
  var isFirstInitial = currentQuestion.isMain && !currentQuestion.isDisabled;
  var isFirstSuccess = currentQuestion.isMain && isSuccess;
  var isFirstError = currentQuestion.isMain && currentQuestion.isDisabled;
  var isInBetweenInitial = currentQuestion.isInBetween && !store.isEvaluated;
  var isInBetweenSuccess = currentQuestion.isInBetween && isSuccess && !currentQuestion.wasSolutionVisible;
  var isInBetweenError = currentQuestion.isInBetween && isError && !currentQuestion.wasSolutionVisible;
  var isInBetweenSolution = currentQuestion.isInBetweenSolution;
  var isLastInitial = currentQuestion.isLast && !store.isEvaluated;
  var isLastSuccess = currentQuestion.isLast && isSuccess && !currentQuestion.wasSolutionVisible;
  var isLastError = currentQuestion.isLast && isError && !currentQuestion.wasSolutionVisible;
  var isLastSolution = currentQuestion.isLast && isError && currentQuestion.wasSolutionVisible;
  return when()["case"](isFirstInitial, function () {
    return controlsStatus.first.initial;
  })["case"](isFirstSuccess, function () {
    return controlsStatus.first.success;
  })["case"](isFirstError, function () {
    return controlsStatus.first.error;
  })["case"](isInBetweenInitial, function () {
    return controlsStatus.inBetween.initial;
  })["case"](isInBetweenSuccess, function () {
    return controlsStatus.inBetween.success;
  })["case"](isInBetweenError, function () {
    return controlsStatus.inBetween.error;
  })["case"](isInBetweenSolution, function () {
    return controlsStatus.inBetween.solution;
  })["case"](isLastInitial, function () {
    return controlsStatus.last.initial;
  })["case"](isLastSuccess, function () {
    return controlsStatus.last.success;
  })["case"](isLastError, function () {
    return controlsStatus.last.error;
  })["case"](isLastSolution, function () {
    return controlsStatus.last.solution;
  }).resolve();
}

var actionList = {
  COMPLETE: 'COMPLETE',
  NEXT: 'NEXT',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
};

var SvgAdjustments = function SvgAdjustments(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M4 15a1 1 0 1 0 0 2h7.268a2 2 0 0 0 3.464 0H16a1 1 0 1 0 0-2h-1.268a2 2 0 0 0-3.464 0zM4 9a1 1 0 1 0 0 2h1.268a2 2 0 0 0 3.464 0H16a1 1 0 1 0 0-2H8.732a2 2 0 0 0-3.464 0zM3 4a1 1 0 0 1 1-1h7.268a2 2 0 0 1 3.464 0H16a1 1 0 1 1 0 2h-1.268a2 2 0 0 1-3.464 0H4a1 1 0 0 1-1-1"
  }));
};

var SvgArrowCircleLeft = function SvgArrowCircleLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m.707-10.293a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L9.414 11H13a1 1 0 1 0 0-2H9.414z",
    clipRule: "evenodd"
  }));
};

var SvgArrowSmRight = function SvgArrowSmRight(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M16.468 8.469a1.6 1.6 0 0 1 2.263 0l6.4 6.4a1.6 1.6 0 0 1 0 2.262l-6.4 6.4a1.6 1.6 0 0 1-2.263-2.262l3.67-3.669H8a1.6 1.6 0 1 1 0-3.2h12.137l-3.669-3.669a1.6 1.6 0 0 1 0-2.262",
    clipRule: "evenodd"
  }));
};

var SvgAscending = function SvgAscending(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M3 3a1 1 0 0 0 0 2h11a1 1 0 1 0 0-2zm0 4a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm10 5a1 1 0 1 0 2 0v-5.586l1.293 1.293a1 1 0 0 0 1.414-1.414l-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 1 0 1.414 1.414L13 10.414z"
  }));
};

var SvgBackspace = function SvgBackspace(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M10.731 7.806A4.8 4.8 0 0 1 14.125 6.4H24a4.8 4.8 0 0 1 4.8 4.8v9.6a4.8 4.8 0 0 1-4.8 4.8h-9.875a4.8 4.8 0 0 1-3.394-1.406L3.67 17.131a1.6 1.6 0 0 1 0-2.262zm6.4 3.863a1.6 1.6 0 1 0-2.262 2.262L16.937 16l-2.068 2.069a1.6 1.6 0 1 0 2.262 2.262l2.069-2.068 2.069 2.068a1.6 1.6 0 0 0 2.262-2.262L21.463 16l2.068-2.069a1.6 1.6 0 1 0-2.262-2.262L19.2 13.737z",
    clipRule: "evenodd"
  }));
};

var SvgBolt = function SvgBolt(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M11 21h-1l1-7H7.5c-.58 0-.57-.32-.38-.66s.05-.08.07-.12C8.48 10.94 10.42 7.54 13 3h1l-1 7h3.5c.49 0 .56.33.47.51l-.07.15C12.96 17.55 11 21 11 21"
  }));
};

var SvgCheckBold = function SvgCheckBold(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 6"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M7.733.257a.993.993 0 0 0-1.333 0L3.022 3.686 1.6 2.314a.993.993 0 0 0-1.333 0c-.356.343-.356.943 0 1.372L2.31 5.743a.993.993 0 0 0 1.333 0l4.09-4.114c.355-.343.355-.943 0-1.372"
  }));
};

var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M16 28.8c7.07 0 12.8-5.73 12.8-12.8S23.07 3.2 16 3.2 3.2 8.93 3.2 16 8.93 28.8 16 28.8m5.931-14.869a1.6 1.6 0 1 0-2.262-2.262L14.4 16.937l-2.069-2.068a1.6 1.6 0 1 0-2.262 2.262l3.2 3.2a1.6 1.6 0 0 0 2.262 0z",
    clipRule: "evenodd"
  }));
};

var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M26.731 8.469a1.6 1.6 0 0 1 0 2.262l-12.8 12.8a1.6 1.6 0 0 1-2.262 0l-6.4-6.4A1.6 1.6 0 0 1 7.53 14.87l5.269 5.268L24.469 8.47a1.6 1.6 0 0 1 2.262 0z",
    clipRule: "evenodd"
  }));
};

var SvgChevronDoubleDown = function SvgChevronDoubleDown(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M15.707 4.293a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 1.414-1.414L10 8.586l4.293-4.293a1 1 0 0 1 1.414 0m0 6a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L10 14.586l4.293-4.293a1 1 0 0 1 1.414 0",
    clipRule: "evenodd"
  }));
};

var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M8.469 11.669a1.6 1.6 0 0 1 2.262 0L16 16.937l5.269-5.268a1.6 1.6 0 1 1 2.262 2.262l-6.4 6.4a1.6 1.6 0 0 1-2.262 0l-6.4-6.4a1.6 1.6 0 0 1 0-2.262",
    clipRule: "evenodd"
  }));
};

var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M12.707 5.293a1 1 0 0 1 0 1.414L9.414 10l3.293 3.293a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0",
    clipRule: "evenodd"
  }));
};

var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M7.293 14.707a1 1 0 0 1 0-1.414L10.586 10 7.293 6.707a1 1 0 0 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0",
    clipRule: "evenodd"
  }));
};

var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M23.531 20.331a1.6 1.6 0 0 1-2.262 0L16 15.063l-5.269 5.268A1.6 1.6 0 1 1 8.47 18.07l6.4-6.4a1.6 1.6 0 0 1 2.262 0l6.4 6.4a1.6 1.6 0 0 1 0 2.262z",
    clipRule: "evenodd"
  }));
};

var ClipboardCheck = function ClipboardCheck(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/createElement("g", {
    id: "Icon/Solid/clipboard-check"
  }, /*#__PURE__*/createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/createElement("path", {
    d: "M10.8 2.40039C10.1373 2.40039 9.60005 2.93765 9.60005 3.60039C9.60005 4.26313 10.1373 4.80039 10.8 4.80039H13.2C13.8628 4.80039 14.4 4.26313 14.4 3.60039C14.4 2.93765 13.8628 2.40039 13.2 2.40039H10.8Z"
  }), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.80005 6.00039C4.80005 4.67491 5.87457 3.60039 7.20005 3.60039C7.20005 5.58862 8.81182 7.20039 10.8 7.20039H13.2C15.1883 7.20039 16.8 5.58862 16.8 3.60039C18.1255 3.60039 19.2 4.67491 19.2 6.00039V19.2004C19.2 20.5259 18.1255 21.6004 16.8 21.6004H7.20005C5.87457 21.6004 4.80005 20.5259 4.80005 19.2004V6.00039ZM16.4486 12.8489C16.9172 12.3803 16.9172 11.6205 16.4486 11.1519C15.9799 10.6832 15.2201 10.6832 14.7515 11.1519L10.8 15.1033L9.24858 13.5519C8.77995 13.0832 8.02015 13.0832 7.55152 13.5519C7.08289 14.0205 7.08289 14.7803 7.55152 15.2489L9.95152 17.6489C10.4201 18.1175 11.1799 18.1175 11.6486 17.6489L16.4486 12.8489Z"
  }))));
};

var SvgClipboardList = function SvgClipboardList(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M14.4 3.2a1.6 1.6 0 1 0 0 3.2h3.2a1.6 1.6 0 1 0 0-3.2z"
  }), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M6.4 8a3.2 3.2 0 0 1 3.2-3.2 4.8 4.8 0 0 0 4.8 4.8h3.2a4.8 4.8 0 0 0 4.8-4.8A3.2 3.2 0 0 1 25.6 8v17.6a3.2 3.2 0 0 1-3.2 3.2H9.6a3.2 3.2 0 0 1-3.2-3.2zm4.8 6.4a1.6 1.6 0 1 0 0 3.2h.016a1.6 1.6 0 0 0 0-3.2zm4.8 0a1.6 1.6 0 1 0 0 3.2h4.8a1.6 1.6 0 0 0 0-3.2zm-4.8 6.4a1.6 1.6 0 1 0 0 3.2h.016a1.6 1.6 0 1 0 0-3.2zm4.8 0a1.6 1.6 0 1 0 0 3.2h4.8a1.6 1.6 0 1 0 0-3.2z",
    clipRule: "evenodd"
  }));
};

var SvgClipboard = function SvgClipboard(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M9.6 3.598a1.2 1.2 0 0 1 1.2-1.2h2.4a1.2 1.2 0 0 1 0 2.4h-2.4a1.2 1.2 0 0 1-1.2-1.2"
  }), /*#__PURE__*/createElement("path", {
    d: "M7.2 3.598a2.4 2.4 0 0 0-2.4 2.4v13.2a2.4 2.4 0 0 0 2.4 2.4h9.6a2.4 2.4 0 0 0 2.4-2.4v-13.2a2.4 2.4 0 0 0-2.4-2.4 3.6 3.6 0 0 1-3.6 3.6h-2.4a3.6 3.6 0 0 1-3.6-3.6"
  }));
};

var SvgCloudUpload = function SvgCloudUpload(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M8.8 20.8a5.6 5.6 0 0 1-.59-11.17 6.4 6.4 0 1 1 12.406-3.164A7.2 7.2 0 1 1 21.6 20.8h-4.001v-5.736l2.069 2.068a1.6 1.6 0 1 0 2.262-2.262l-4.8-4.8a1.6 1.6 0 0 0-2.262 0l-4.8 4.8a1.6 1.6 0 1 0 2.262 2.262l2.069-2.068V20.8z"
  }), /*#__PURE__*/createElement("path", {
    d: "M14.4 20.8h3.2v8a1.6 1.6 0 0 1-3.2 0z"
  }));
};

var SvgCloud = function SvgCloud(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M8.8 25.6a5.6 5.6 0 0 1-.59-11.17 6.4 6.4 0 1 1 12.406-3.164A7.2 7.2 0 1 1 21.6 25.6H8.799z"
  }));
};

var SvgCursorClick = function SvgCursorClick(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/createElement("g", {
    id: "Icon/Solid/cursor-click"
  }, /*#__PURE__*/createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/createElement("path", {
    d: "M6.67163 1.91147C6.52869 1.37801 5.98035 1.06142 5.44688 1.20437C4.91342 1.34731 4.59684 1.89565 4.73978 2.42911L4.9986 3.39504C5.14154 3.9285 5.68988 4.24509 6.22334 4.10214C6.75681 3.9592 7.07339 3.41086 6.93045 2.8774L6.67163 1.91147Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M2.42899 4.7399C1.89552 4.59696 1.34719 4.91354 1.20424 5.44701C1.0613 5.98047 1.37788 6.52881 1.91135 6.67175L2.87728 6.93057C3.41074 7.07351 3.95908 6.75693 4.10202 6.22346C4.24496 5.69 3.92838 5.14166 3.39491 4.99872L2.42899 4.7399Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M11.2424 4.17149C11.633 3.78097 11.633 3.1478 11.2424 2.75728C10.8519 2.36676 10.2187 2.36676 9.82823 2.75728L9.12112 3.46439C8.73059 3.85491 8.7306 4.48808 9.12112 4.8786C9.51164 5.26912 10.1448 5.26912 10.5353 4.8786L11.2424 4.17149Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M4.17137 11.2426L4.87848 10.5355C5.269 10.1449 5.269 9.51177 4.87848 9.12124C4.48795 8.73072 3.85479 8.73072 3.46427 9.12124L2.75716 9.82835C2.36663 10.2189 2.36663 10.852 2.75716 11.2426C3.14768 11.6331 3.78085 11.6331 4.17137 11.2426Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M7.3713 6.07152C6.99988 5.92295 6.57566 6.01002 6.2928 6.29289C6.00994 6.57575 5.92286 6.99997 6.07143 7.37138L10.0714 17.3714C10.2177 17.737 10.5649 17.9828 10.9583 17.9991C11.3518 18.0155 11.7182 17.7994 11.8943 17.4472L13.2739 14.6882L16.2928 17.7071C16.6833 18.0976 17.3165 18.0976 17.707 17.7071C18.0975 17.3166 18.0975 16.6834 17.707 16.2929L14.6881 13.2739L17.4471 11.8944C17.7993 11.7183 18.0154 11.3519 17.999 10.9584C17.9827 10.565 17.7369 10.2178 17.3713 10.0715L7.3713 6.07152Z"
  }))));
};

var SvgDesktopComputer = function SvgDesktopComputer(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M3 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.22l.123.489.804.804A1 1 0 0 1 13 18H7a1 1 0 0 1-.707-1.707l.804-.804L7.22 15H5a2 2 0 0 1-2-2zm5.771 7H5V5h10v7H8.771",
    clipRule: "evenodd"
  }));
};

var SvgDeviceMobile = function SvgDeviceMobile(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M7 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm3 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
    clipRule: "evenodd"
  }));
};

var SvgDeviceTablet = function SvgDeviceTablet(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm4 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
    clipRule: "evenodd"
  }));
};

var SvgDobleArrowVertical = function SvgDobleArrowVertical(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 32"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M9.707 11.707a1 1 0 0 1-1.414 0L5 8.414l-3.293 3.293a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414M.377 26.15a1 1 0 0 1 1.414 0l3.293 3.293 3.293-3.293a1 1 0 0 1 1.414 1.415l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.415",
    className: "doble-arrow-vertical_svg__icon-double-arrow-vertical_path1",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    d: "M5.113 29.887v-22",
    className: "doble-arrow-vertical_svg__icon-double-arrow-vertical_path2"
  }));
};

var SvgDobleArrow = function SvgDobleArrow(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 11"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M26.15 9.707a1 1 0 0 1 0-1.414L29.443 5 26.15 1.707A1 1 0 0 1 27.565.293l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.415 0M5.707.377a1 1 0 0 1 0 1.414L2.414 5.084l3.293 3.293A1 1 0 0 1 4.293 9.79l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0z",
    className: "doble-arrow_svg__icon-double-arrow_path",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    d: "M1.857 5h28",
    className: "doble-arrow_svg__icon-double-arrow_path2"
  }));
};

var SvgDocumentDuplicate = function SvgDocumentDuplicate(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M10.8 2.4a2.4 2.4 0 0 0-2.4 2.4v9.6a2.4 2.4 0 0 0 2.4 2.4H18a2.4 2.4 0 0 0 2.4-2.4V7.697A2.4 2.4 0 0 0 19.697 6L16.8 3.103a2.4 2.4 0 0 0-1.697-.703z"
  }), /*#__PURE__*/createElement("path", {
    d: "M3.6 9.6A2.4 2.4 0 0 1 6 7.2v12h9.6a2.4 2.4 0 0 1-2.4 2.4H6a2.4 2.4 0 0 1-2.4-2.4z"
  }));
};

var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M6.4 6.4a3.2 3.2 0 0 1 3.2-3.2h7.338a3.2 3.2 0 0 1 2.262.937L24.663 9.6c.6.6.937 1.414.937 2.263V25.6a3.2 3.2 0 0 1-3.2 3.2H9.6a3.2 3.2 0 0 1-3.2-3.2z",
    clipRule: "evenodd"
  }));
};

var SvgDotsVertical = function SvgDotsVertical(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M16 9.6a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4m0 9.6a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4m0 9.6a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4"
  }));
};

var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M14.75 8.436h-1.325V4.269a.836.836 0 0 0-.833-.833H9.259a.836.836 0 0 0-.834.833v4.167H7.1c-.741 0-1.116.9-.591 1.425l3.825 3.824a.83.83 0 0 0 1.175 0l3.825-3.824c.525-.525.158-1.425-.584-1.425m-9.658 8.333c0 .458.375.833.833.833h10a.836.836 0 0 0 .834-.833.836.836 0 0 0-.834-.833h-10a.836.836 0 0 0-.833.833"
  }));
};

var SvgDrag = function SvgDrag(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/createElement("g", {
    clipPath: "url(#drag_svg__a)"
  }, /*#__PURE__*/createElement("path", {
    d: "M9.167 15c0 .917-.75 1.667-1.667 1.667S5.833 15.917 5.833 15s.75-1.667 1.667-1.667 1.667.75 1.667 1.667M7.5 8.333c-.917 0-1.667.75-1.667 1.667s.75 1.667 1.667 1.667 1.667-.75 1.667-1.667-.75-1.667-1.667-1.667m0-5c-.917 0-1.667.75-1.667 1.667s.75 1.667 1.667 1.667S9.167 5.917 9.167 5 8.417 3.333 7.5 3.333m5 3.334c.917 0 1.667-.75 1.667-1.667s-.75-1.667-1.667-1.667-1.667.75-1.667 1.667.75 1.667 1.667 1.667m0 1.666c-.917 0-1.667.75-1.667 1.667s.75 1.667 1.667 1.667 1.667-.75 1.667-1.667-.75-1.667-1.667-1.667m0 5c-.917 0-1.667.75-1.667 1.667s.75 1.667 1.667 1.667 1.667-.75 1.667-1.667-.75-1.667-1.667-1.667"
  })), /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "drag_svg__a"
  }, /*#__PURE__*/createElement("path", {
    d: "M0 0h20v20H0z"
  }))));
};

var SvgDrive = function SvgDrive(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 87.3 78"
  }, props), /*#__PURE__*/createElement("path", {
    fill: "#0066da",
    d: "m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3L27.5 53H0c0 1.55.4 3.1 1.2 4.5z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#00ac47",
    d: "M43.65 25 29.9 1.2c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44A9.06 9.06 0 0 0 0 53h27.5z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#ea4335",
    d: "M73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75L86.1 57.5c.8-1.4 1.2-2.95 1.2-4.5H59.798l5.852 11.5z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#00832d",
    d: "M43.65 25 57.4 1.2C56.05.4 54.5 0 52.9 0H34.4c-1.6 0-3.15.45-4.5 1.2z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#2684fc",
    d: "M59.8 53H27.5L13.75 76.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#ffba00",
    d: "m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3L43.65 25 59.8 53h27.45c0-1.55-.4-3.1-1.2-4.5z"
  }));
};

var SvgEraser = function SvgEraser(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M27.7 10.9 22 5.2c-1.1-1.1-3.1-1.1-4.2 0l-7.1 7.1-7.5 7.5C2 21 2 22.9 3.2 24L7 27.8c.2.2.4.3.7.3h6.6c.3 0 .5-.1.7-.3l12.7-12.7c1.2-1.1 1.2-3 0-4.2M14.19 25.815a1 1 0 0 1-.7.285H8.615a1 1 0 0 1-.707-.293L4.7 22.6c-.4-.4-.4-1 0-1.4l6.093-6.093a1 1 0 0 1 1.414 0l5.678 5.678a1 1 0 0 1-.008 1.422z"
  }));
};

var SvgExclamationCircle = function SvgExclamationCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M28.8 16c0 7.07-5.73 12.8-12.8 12.8S3.2 23.07 3.2 16 8.93 3.2 16 3.2 28.8 8.93 28.8 16m-11.2 6.4a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0M16 8a1.6 1.6 0 0 0-1.6 1.6V16a1.6 1.6 0 0 0 3.2 0V9.6A1.6 1.6 0 0 0 16 8",
    clipRule: "evenodd"
  }));
};

var SvgExclamation = function SvgExclamation(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M13.211 4.958c1.223-2.175 4.355-2.175 5.578 0l8.929 15.873c1.2 2.133-.342 4.768-2.79 4.768H7.073c-2.448 0-3.99-2.635-2.79-4.768zM17.6 20.8a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0M16 8a1.6 1.6 0 0 0-1.6 1.6v4.8a1.6 1.6 0 1 0 3.2 0V9.6A1.6 1.6 0 0 0 16 8",
    clipRule: "evenodd"
  }));
};

var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M11 3a1 1 0 1 0 0 2h2.586l-6.293 6.293a1 1 0 1 0 1.414 1.414L15 6.414V9a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1z"
  }), /*#__PURE__*/createElement("path", {
    d: "M5 5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3a1 1 0 1 0-2 0v3H5V7h3a1 1 0 0 0 0-2z"
  }));
};

var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6C3 4.34315 4.34315 3 6 3H16C16.3788 3 16.725 3.214 16.8944 3.55279C17.0638 3.89157 17.0273 4.29698 16.8 4.6L14.25 8L16.8 11.4C17.0273 11.703 17.0638 12.1084 16.8944 12.4472C16.725 12.786 16.3788 13 16 13H6C5.44772 13 5 13.4477 5 14V17C5 17.5523 4.55228 18 4 18C3.44772 18 3 17.5523 3 17V6Z"
  }));
};

var SvgFormatListBulleted = function SvgFormatListBulleted(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/createElement("path", {
    d: "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5m0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5m0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5M7 19h14v-2H7zm0-6h14v-2H7zm0-8v2h14V5z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
};

var SvgKeyboard = function SvgKeyboard(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M26.38 7.333H5.049A2.663 2.663 0 0 0 2.394 10l-.013 13.334A2.673 2.673 0 0 0 5.048 26H26.38c1.466 0 2.666-1.2 2.666-2.666V10c0-1.466-1.2-2.667-2.666-2.667m-12 5a1 1 0 0 1 1-1h.667a1 1 0 0 1 1 1V13a1 1 0 0 1-1 1h-.666a1 1 0 0 1-1-1zm0 4a1 1 0 0 1 1-1h.667a1 1 0 0 1 1 1V17a1 1 0 0 1-1 1h-.666a1 1 0 0 1-1-1v-.666zm-4-4a1 1 0 0 1 1-1h.667a1 1 0 0 1 1 1V13a1 1 0 0 1-1 1h-.666a1 1 0 0 1-1-1zm0 4a1 1 0 0 1 1-1h.667a1 1 0 0 1 1 1V17a1 1 0 0 1-1 1h-.666a1 1 0 0 1-1-1v-.666zM9.049 17a1 1 0 0 1-1 1H7.38a1 1 0 0 1-1-1v-.666a1 1 0 0 1 1-1h.667a1 1 0 0 1 1 1V17zm0-4a1 1 0 0 1-1 1H7.38a1 1 0 0 1-1-1v-.666a1 1 0 0 1 1-1h.667a1 1 0 0 1 1 1V13zm12 9.334a1 1 0 0 1-1 1H11.38a1 1 0 0 1-1-1v-.667a1 1 0 0 1 1-1h8.666a1 1 0 0 1 1 1v.666zm0-5.334a1 1 0 0 1-1 1h-.667a1 1 0 0 1-1-1v-.666a1 1 0 0 1 1-1h.666a1 1 0 0 1 1 1V17zm0-4a1 1 0 0 1-1 1h-.667a1 1 0 0 1-1-1v-.666a1 1 0 0 1 1-1h.666a1 1 0 0 1 1 1V13zm4 4a1 1 0 0 1-1 1h-.667a1 1 0 0 1-1-1v-.666a1 1 0 0 1 1-1h.666a1 1 0 0 1 1 1V17zm0-4a1 1 0 0 1-1 1h-.667a1 1 0 0 1-1-1v-.666a1 1 0 0 1 1-1h.666a1 1 0 0 1 1 1V13z"
  }));
};

var SvgLightBulb = function SvgLightBulb(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M17.6 4.8a1.6 1.6 0 0 0-3.2 0v1.6a1.6 1.6 0 1 0 3.2 0zm7.45 4.412a1.6 1.6 0 0 0-2.262-2.263L21.657 8.08a1.6 1.6 0 0 0 2.262 2.263l1.132-1.131zM28.8 16a1.6 1.6 0 0 1-1.6 1.6h-1.6a1.6 1.6 0 0 1 0-3.2h1.6a1.6 1.6 0 0 1 1.6 1.6M8.08 10.343a1.6 1.6 0 1 0 2.263-2.263L9.212 6.95a1.6 1.6 0 1 0-2.263 2.263l1.131 1.131zM8 16a1.6 1.6 0 0 1-1.6 1.6H4.8a1.6 1.6 0 0 1 0-3.2h1.6A1.6 1.6 0 0 1 8 16m4.8 9.6V24h6.4v1.6a3.2 3.2 0 1 1-6.4 0m6.401-3.2c.024-.545.331-1.034.762-1.374a6.4 6.4 0 1 0-7.926 0c.43.34.738.83.762 1.374H19.2z"
  }));
};

var SvgMenuAlt = function SvgMenuAlt(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M4.8 8a1.6 1.6 0 0 1 1.6-1.6h19.2a1.6 1.6 0 0 1 0 3.2H6.4A1.6 1.6 0 0 1 4.8 8m0 8a1.6 1.6 0 0 1 1.6-1.6h19.2a1.6 1.6 0 0 1 0 3.2H6.4A1.6 1.6 0 0 1 4.8 16m0 8a1.6 1.6 0 0 1 1.6-1.6H16a1.6 1.6 0 1 1 0 3.2H6.4A1.6 1.6 0 0 1 4.8 24",
    clipRule: "evenodd"
  }));
};

var SvgMicrophoneOff = function SvgMicrophoneOff(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M7 4a3 3 0 0 1 6 0v4a3 3 0 1 1-6 0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M11 14.93A7 7 0 0 0 17 8a1 1 0 1 0-2 0A5 5 0 0 1 5 8a1 1 0 0 0-2 0 7 7 0 0 0 6 6.93V17H6a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-3z"
  }), /*#__PURE__*/createElement("rect", {
    width: 19.625,
    height: 1.957,
    x: 3.907,
    y: 1.331,
    rx: 0.979,
    transform: "rotate(42.634 3.907 1.331)"
  }));
};

var SvgMicrophone = function SvgMicrophone(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M11.2 6.4a4.8 4.8 0 0 1 9.6 0v6.4a4.8 4.8 0 0 1-9.6 0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M17.6 23.887c5.428-.777 9.6-5.445 9.6-11.087a1.6 1.6 0 0 0-3.2 0 8 8 0 0 1-16 0 1.6 1.6 0 1 0-3.2 0c0 5.642 4.172 10.31 9.6 11.087V27.2H9.6a1.6 1.6 0 1 0 0 3.2h12.8a1.6 1.6 0 0 0 0-3.2h-4.8z"
  }));
};

var SvgMinusCircle = function SvgMinusCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16M7 9a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2z",
    clipRule: "evenodd"
  }));
};

var SvgMusicNote = function SvgMusicNote(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M28.8 4.8a1.6 1.6 0 0 0-1.914-1.569l-16 3.2A1.6 1.6 0 0 0 9.6 8v14.582A7 7 0 0 0 8 22.4c-2.651 0-4.8 1.433-4.8 3.2s2.149 3.2 4.8 3.2 4.8-1.433 4.8-3.2V12.512l12.8-2.56v9.43A7 7 0 0 0 24 19.2c-2.651 0-4.8 1.433-4.8 3.2s2.149 3.2 4.8 3.2 4.8-1.433 4.8-3.2z"
  }));
};

var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M28.8 16c0 7.07-5.73 12.8-12.8 12.8S3.2 23.07 3.2 16 8.93 3.2 16 3.2 28.8 8.93 28.8 16m-17.6-3.2a1.6 1.6 0 1 1 3.2 0v6.4a1.6 1.6 0 0 1-3.2 0zm8-1.6a1.6 1.6 0 0 0-1.6 1.6v6.4a1.6 1.6 0 0 0 3.2 0v-6.4a1.6 1.6 0 0 0-1.6-1.6",
    clipRule: "evenodd"
  }));
};

var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M21.737 5.737a3.2 3.2 0 0 1 4.526 4.526l-1.269 1.268-4.525-4.525zm-3.531 3.532L4.8 22.675V27.2h4.526L22.73 13.794z"
  }));
};

var SvgPhotograph = function SvgPhotograph(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M6.4 4.8A3.2 3.2 0 0 0 3.2 8v16a3.2 3.2 0 0 0 3.2 3.2h19.2a3.2 3.2 0 0 0 3.2-3.2V8a3.2 3.2 0 0 0-3.2-3.2zM25.6 24H6.4l6.4-12.8 4.8 9.6 3.2-6.4z",
    clipRule: "evenodd"
  }));
};

var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M16 28.8c7.07 0 12.8-5.73 12.8-12.8S23.07 3.2 16 3.2 3.2 8.93 3.2 16 8.93 28.8 16 28.8m-.713-17.331A1.6 1.6 0 0 0 12.8 12.8v6.4a1.6 1.6 0 0 0 2.487 1.331l4.8-3.2a1.6 1.6 0 0 0 0-2.662z",
    clipRule: "evenodd"
  }));
};

var SvgPlusCircle = function SvgPlusCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M16 28.8c7.07 0 12.8-5.73 12.8-12.8S23.07 3.2 16 3.2 3.2 8.93 3.2 16 8.93 28.8 16 28.8m1.6-17.6a1.6 1.6 0 1 0-3.2 0v3.2h-3.2a1.6 1.6 0 1 0 0 3.2h3.2v3.2a1.6 1.6 0 0 0 3.2 0v-3.2h3.2a1.6 1.6 0 0 0 0-3.2h-3.2z",
    clipRule: "evenodd"
  }));
};

var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M13 11h7.25v2H13v7.25h-2V13H3.75v-2H11V3.75h2z"
  }));
};

var SvgQuestionMarkCircle = function SvgQuestionMarkCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M28.8 16c0 7.07-5.73 12.8-12.8 12.8S3.2 23.07 3.2 16 8.93 3.2 16 3.2 28.8 8.93 28.8 16M16 11.2a1.6 1.6 0 0 0-1.387.801 1.6 1.6 0 1 1-2.77-1.602 4.8 4.8 0 1 1 5.757 6.928v.273a1.6 1.6 0 0 1-3.2 0V16a1.6 1.6 0 0 1 1.6-1.6 1.6 1.6 0 0 0 0-3.2M16 24a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2",
    clipRule: "evenodd"
  }));
};

var SvgRangeHandlerMobile = function SvgRangeHandlerMobile(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37 43"
  }, props, {
    "data-testid": "bullet"
  }), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M37 18.892a4 4 0 0 0-1.134-2.79L21.366 1.21a4 4 0 0 0-5.732 0L1.134 16.1A4 4 0 0 0 0 18.891v19.375a4 4 0 0 0 4 4h29a4 4 0 0 0 4-4z",
    clipRule: "evenodd"
  }));
};

var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M6.4 3.2A1.6 1.6 0 0 1 8 4.8v3.362A11.16 11.16 0 0 1 16 4.8c4.88 0 9.026 3.119 10.562 7.467a1.6 1.6 0 1 1-3.017 1.066A8.004 8.004 0 0 0 9.6 11.2h4.8a1.6 1.6 0 1 1 0 3.2h-8a1.6 1.6 0 0 1-1.6-1.6v-8a1.6 1.6 0 0 1 1.6-1.6m.013 14.491a1.6 1.6 0 0 1 2.042.976A8.004 8.004 0 0 0 22.4 20.8h-4.8a1.6 1.6 0 0 1 0-3.2h8a1.6 1.6 0 0 1 1.6 1.6v8a1.6 1.6 0 0 1-3.2 0v-3.362a11.17 11.17 0 0 1-8 3.362c-4.879 0-9.025-3.119-10.562-7.467a1.6 1.6 0 0 1 .975-2.042",
    clipRule: "evenodd"
  }));
};

var SvgReplay = function SvgReplay(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12 5V2.21c0-.45-.54-.67-.85-.35l-3.8 3.79c-.2.2-.2.51 0 .71l3.79 3.79c.32.31.86.09.86-.36V7c3.73 0 6.68 3.42 5.86 7.29-.47 2.27-2.31 4.1-4.57 4.57-3.57.75-6.75-1.7-7.23-5.01a1 1 0 0 0-.98-.85c-.6 0-1.08.53-1 1.13.62 4.39 4.8 7.64 9.53 6.72 3.12-.61 5.63-3.12 6.24-6.24C20.84 9.48 16.94 5 12 5"
  }));
};

var SvgReply = function SvgReply(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M12.331 5.269a1.6 1.6 0 0 1 0 2.262L8.663 11.2H17.6c6.185 0 11.2 5.015 11.2 11.2v3.2a1.6 1.6 0 0 1-3.2 0v-3.2a8 8 0 0 0-8-8H8.663l3.668 3.669a1.6 1.6 0 1 1-2.262 2.262l-6.4-6.4a1.6 1.6 0 0 1 0-2.262l6.4-6.4a1.6 1.6 0 0 1 2.262 0",
    clipRule: "evenodd"
  }));
};

var SvgRichtextBold = function SvgRichtextBold(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M5.5 2.75a.917.917 0 0 0-.917.917v14.666c0 .507.41.917.917.917h8.25a4.584 4.584 0 0 0 2.232-8.586l.092-.09a4.583 4.583 0 0 0-3.24-7.824zm7.333 7.333a2.75 2.75 0 1 0 0-5.5H6.417v5.5zm-6.416 1.834v5.5h7.333a2.75 2.75 0 0 0 0-5.5z",
    clipRule: "evenodd"
  }));
};

var SvgRichtextItalic = function SvgRichtextItalic(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M13.77 2.75h3.647a.917.917 0 0 1 0 1.834h-3.032L9.573 17.417h3.26a.917.917 0 0 1 0 1.833h-8.25a.917.917 0 1 1 0-1.833h3.032l4.812-12.833h-3.26a.917.917 0 0 1 0-1.834z",
    clipRule: "evenodd"
  }));
};

var SvgRichtextList = function SvgRichtextList(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M2.75 4.583a.917.917 0 1 0 0 1.833h.01a.917.917 0 1 0 0-1.833zm4.583 0a.917.917 0 1 0 0 1.833H19.25a.917.917 0 1 0 0-1.833zm0 5.5a.917.917 0 0 0 0 1.833H19.25a.917.917 0 1 0 0-1.833zM6.417 16.5c0-.507.41-.917.916-.917H19.25a.917.917 0 1 1 0 1.833H7.333a.917.917 0 0 1-.916-.916M1.833 11c0-.507.41-.917.917-.917h.01a.917.917 0 0 1 0 1.833h-.01A.917.917 0 0 1 1.833 11m.917 4.583a.917.917 0 0 0 0 1.833h.01a.917.917 0 1 0 0-1.833z",
    clipRule: "evenodd"
  }));
};

var SvgRichtextNumberedlist = function SvgRichtextNumberedlist(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M2.75 16.042v-.458H.917v-.917h2.75v3.667H.917v-.917H2.75v-.458h-.917v-.917zm0-8.708h-.917v-2.75H.917v-.917H2.75zm-.183 2.75H.917v-.917h2.75v.825l-1.65 1.925h1.65v.917H.917v-.825zm4.766-5.5a.917.917 0 1 0 0 1.833H19.25a.917.917 0 1 0 0-1.833zm0 5.5a.917.917 0 1 0 0 1.833H19.25a.917.917 0 1 0 0-1.833zM6.417 16.5c0-.506.41-.916.916-.916H19.25a.917.917 0 1 1 0 1.833H7.333a.917.917 0 0 1-.916-.917",
    clipRule: "evenodd"
  }));
};

var SvgRichtextQuote = function SvgRichtextQuote(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M5.897 4.583H7.5c1.191 0 2.16.97 2.16 2.16v5.49a5.19 5.19 0 0 1-5.183 5.183h-.864a.864.864 0 1 1 0-1.727h.864a3.46 3.46 0 0 0 3.455-3.455v-1.772q-.21.044-.432.044H5.897c-1.192 0-2.16-.97-2.16-2.16V6.744c0-1.19.968-2.16 2.16-2.16zm9.588 0h1.604c1.191 0 2.16.97 2.16 2.16v5.49a5.19 5.19 0 0 1-5.183 5.183h-.864a.864.864 0 1 1 0-1.727h.864a3.46 3.46 0 0 0 3.455-3.455v-1.772q-.21.044-.432.044h-1.604c-1.191 0-2.16-.97-2.16-2.16V6.744c0-1.19.969-2.16 2.16-2.16z",
    clipRule: "evenodd"
  }));
};

var SvgRichtextSubindex = function SvgRichtextSubindex(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M23.476 22.872h-1.601v-.009c0-.169.386-.442.696-.66.618-.435 1.385-.978 1.385-1.918v-.013c0-.857-.695-1.552-1.552-1.552l-.059.001h.003a1.444 1.444 0 0 0-1.54 1.402v.002a.578.578 0 1 0 1.149.09v-.002c0-.166.042-.353.375-.353l.032-.001c.237 0 .429.192.429.429v.014-.001c0 .353-.464.691-.912 1.014-.554.399-1.182.852-1.182 1.551v.601a.56.56 0 0 0 .56.536h2.215a.566.566 0 0 0 .002-1.128h-.002zM18.335.253a1.127 1.127 0 0 0-1.582.159l-.002.002-7.378 9.055L1.995.414a1.124 1.124 0 0 0-2.012.692c0 .279.101.534.269.73l-.001-.002 7.671 9.414-7.671 9.414a1.125 1.125 0 0 0 1.743 1.421l.001-.001 7.378-9.055 7.378 9.055a1.126 1.126 0 0 0 1.743-1.423l.002.002-7.672-9.412 7.671-9.414a1.127 1.127 0 0 0-.159-1.582l-.002-.002z"
  }));
};

var SvgRichtextSuperindex = function SvgRichtextSuperindex(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M23.477 4.149h-1.602V4.14c0-.169.386-.442.696-.66.618-.435 1.385-.978 1.385-1.918v-.014c0-.857-.695-1.552-1.552-1.552l-.059.001h.003a1.444 1.444 0 0 0-1.54 1.402v.002a.578.578 0 1 0 1.149.09v-.002c0-.166.042-.353.375-.353l.032-.001c.237 0 .429.192.429.429v.014-.001c0 .353-.464.691-.912 1.014-.554.399-1.182.852-1.182 1.551v.601a.56.56 0 0 0 .56.536h2.215a.566.566 0 0 0 .002-1.128h-.002zm-5.141-2.396a1.127 1.127 0 0 0-1.582.159l-.002.002-7.378 9.055-7.378-9.055A1.126 1.126 0 0 0 .253 3.337l-.002-.002 7.671 9.415-7.671 9.415a1.125 1.125 0 0 0 1.744 1.422l.001-.001 7.378-9.054 7.379 9.054a1.124 1.124 0 0 0 2.012-.692c0-.279-.101-.534-.269-.73l.001.002-7.672-9.414 7.671-9.415a1.127 1.127 0 0 0-.159-1.582z"
  }));
};

var SvgRichtextTitle = function SvgRichtextTitle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), /*#__PURE__*/createElement("path", {
    d: "M4.583 5.042c0 .76.615 1.375 1.375 1.375h3.667v9.625c0 .76.614 1.375 1.375 1.375.76 0 1.375-.614 1.375-1.375V6.417h3.667a1.374 1.374 0 1 0 0-2.75H5.958c-.76 0-1.375.614-1.375 1.375"
  }));
};

var SvgRichtextUnderline = function SvgRichtextUnderline(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M6.417 2.75a.917.917 0 0 0-1.834 0v6.416a6.417 6.417 0 1 0 12.834 0V2.75a.917.917 0 0 0-1.834 0v6.416a4.583 4.583 0 0 1-9.166 0zm-2.75 15.583a.917.917 0 0 0 0 1.833h14.666a.917.917 0 1 0 0-1.833z",
    clipRule: "evenodd"
  }));
};

var SvgRule = function SvgRule(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M6.572 17.61 9.4 20.436l1.885-1.885-2.826-2.828 2.826-2.828 3.772 3.77 1.886-1.885-3.77-3.772L16 8.181l2.828 2.828 1.887-1.885-2.83-2.828 3.772-3.772a1.333 1.333 0 0 1 1.886 0l6.6 6.6a1.333 1.333 0 0 1 0 1.885l-19.8 19.8a1.333 1.333 0 0 1-1.886 0l-6.6-6.6a1.334 1.334 0 0 1 0-1.885l4.715-4.715z"
  }));
};

var SvgSettingsTipography = function SvgSettingsTipography(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 31"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M13.188 20.387a.92.92 0 1 1-1.73-.626l3.598-9.755a1.539 1.539 0 0 1 2.887 0l3.6 9.755a.92.92 0 1 1-1.73.626l-3.246-9.162a.068.068 0 0 0-.128 0zm.113-3.325c0-.42.341-.761.762-.761h4.868a.762.762 0 1 1 0 1.523h-4.868a.76.76 0 0 1-.762-.762"
  }), /*#__PURE__*/createElement("path", {
    d: "M5 4h23v23H5z"
  }), /*#__PURE__*/createElement("rect", {
    width: 6,
    height: 6,
    x: 1,
    y: 1,
    rx: 1
  }), /*#__PURE__*/createElement("rect", {
    width: 6,
    height: 6,
    x: 1,
    y: 24,
    rx: 1
  }), /*#__PURE__*/createElement("rect", {
    width: 6,
    height: 6,
    x: 25,
    y: 1,
    rx: 1
  }), /*#__PURE__*/createElement("rect", {
    width: 6,
    height: 6,
    x: 25,
    y: 24,
    rx: 1
  }));
};

var SvgShieldExclamation = function SvgShieldExclamation(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.332a14.35 14.35 0 0 1-9.4 3.665 14.4 14.4 0 0 0-.2 2.402c0 6.27 4.007 11.604 9.6 13.58 5.593-1.976 9.6-7.31 9.6-13.58q-.001-1.228-.2-2.402A14.35 14.35 0 0 1 12 2.332m1.2 14.467a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0m0-8.4a1.2 1.2 0 1 0-2.4 0v3.6a1.2 1.2 0 0 0 2.4 0z",
    clipRule: "evenodd"
  }));
};

var SvgSortDescending = function SvgSortDescending(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M3 3a1 1 0 0 0 0 2h11a1 1 0 1 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm12-3a1 1 0 1 0-2 0v5.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L15 13.586z"
  }));
};

var SvgSortText = function SvgSortText(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/createElement("g", {
    id: "short_text-24px",
    clipPath: "url(#clip0_4894_4101)"
  }, /*#__PURE__*/createElement("path", {
    id: "Vector",
    d: "M5 9H19C19.55 9 20 9.45 20 10C20 10.55 19.55 11 19 11H5C4.45 11 4 10.55 4 10C4 9.45 4.45 9 5 9ZM5 13H13C13.55 13 14 13.45 14 14C14 14.55 13.55 15 13 15H5C4.45 15 4 14.55 4 14C4 13.45 4.45 13 5 13Z"
  })), /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "clip0_4894_4101"
  }, /*#__PURE__*/createElement("rect", {
    width: "24",
    height: "24"
  }))));
};

var SvgSparkles = function SvgSparkles(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M5 2a1 1 0 0 1 1 1v1h1a1 1 0 0 1 0 2H6v1a1 1 0 0 1-2 0V6H3a1 1 0 0 1 0-2h1V3a1 1 0 0 1 1-1m0 10a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2H6v1a1 1 0 1 1-2 0v-1H3a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1M12 2a1 1 0 0 1 .967.744L14.146 7.2 17.5 9.134a1 1 0 0 1 0 1.732l-3.354 1.935-1.18 4.455a1 1 0 0 1-1.933 0L9.854 12.8 6.5 10.866a1 1 0 0 1 0-1.732l3.354-1.935 1.18-4.455A1 1 0 0 1 12 2",
    clipRule: "evenodd"
  }));
};

var SvgSpeakerNotes = function SvgSpeakerNotes(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/createElement("path", {
    d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 19.58c0 .89 1.08 1.34 1.71.71L6 18h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2M7 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m7 6h-3c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1m3-3h-6c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1m0-3h-6c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1"
  }));
};

var Star = function Star(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M28.9565 12.5666C29.9144 9.61842 34.0853 9.61842 35.0432 12.5666L38.4659 23.1004C38.8943 24.4188 40.1229 25.3115 41.5092 25.3115H52.5851C55.685 25.3115 56.9739 29.2783 54.466 31.1004L45.5054 37.6106C44.3839 38.4254 43.9146 39.8698 44.343 41.1883L47.7656 51.722C48.7235 54.6702 45.3492 57.1218 42.8413 55.2997L33.8808 48.7895C32.7592 47.9747 31.2405 47.9747 30.1189 48.7895L21.1584 55.2997C18.6505 57.1218 15.2762 54.6702 16.2341 51.722L19.6567 41.1883C20.0851 39.8698 19.6158 38.4254 18.4943 37.6106L9.53372 31.1004C7.02583 29.2783 8.31472 25.3115 11.4146 25.3115H22.4905C23.8768 25.3115 25.1054 24.4188 25.5338 23.1004L28.9565 12.5666Z"
  }));
};

var SvgStop = function SvgStop(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M16 28.8c7.07 0 12.8-5.73 12.8-12.8S23.07 3.2 16 3.2 3.2 8.93 3.2 16 8.93 28.8 16 28.8",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("rect", {
    width: 10,
    height: 10,
    x: 11,
    y: 11,
    fill: "#fff",
    className: "stop_svg__icon-stop__rect",
    rx: 2
  }));
};

var SwitchHorizontal = function SwitchHorizontal(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M8 5a1 1 0 1 0 0 2h5.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3a1 1 0 1 0-1.414 1.414L13.586 5H8ZM12 15a1 1 0 1 0 0-2H6.414l1.293-1.293a1 1 0 1 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L6.414 15H12Z"
  }));
};

var SwitchHorizontal$1 = function SwitchHorizontal(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M5 12a1 1 0 1 0 2 0V6.414l1.293 1.293a1 1 0 0 0 1.414-1.414l-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414L5 6.414V12ZM15 8a1 1 0 1 0-2 0v5.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L15 13.586V8Z"
  }));
};

var SvgTable = function SvgTable(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm1 2a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2zm6 7a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1m-3 3a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2zm-4 1a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1m1-4a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2zm2 1a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1m4-4a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2zM9 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1M7 8a1 1 0 0 0 0 2h.01a1 1 0 0 0 0-2z",
    clipRule: "evenodd"
  }));
};

var SvgTrash$1 = function SvgTrash(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M9 2a1 1 0 0 0-.894.553L7.382 4H4a1 1 0 0 0 0 2v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6a1 1 0 1 0 0-2h-3.382l-.724-1.447A1 1 0 0 0 11 2zM7 8a1 1 0 0 1 2 0v6a1 1 0 1 1-2 0zm5-1a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1",
    clipRule: "evenodd"
  }));
};

var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M2.1 11.9a.7.7 0 0 1 .7-.7h8.4a.7.7 0 1 1 0 1.4H2.8a.7.7 0 0 1-.7-.7m2.305-7.205a.7.7 0 0 1 0-.99l2.1-2.1a.7.7 0 0 1 .99 0l2.1 2.1a.7.7 0 1 1-.99.99L7.7 3.79V9.1a.7.7 0 1 1-1.4 0V3.79l-.905.905a.7.7 0 0 1-.99 0",
    clipRule: "evenodd"
  }));
};

var SvgViewList = function SvgViewList(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M3 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  }));
};

var SvgXBold = function SvgXBold(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7 7"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M6.743 5.506a.874.874 0 1 1-1.237 1.238L3.5 4.737 1.494 6.744a.873.873 0 0 1-1.237 0 .874.874 0 0 1 0-1.238L2.263 3.5.257 1.494A.874.874 0 1 1 1.494.257L3.5 2.263 5.506.257a.874.874 0 1 1 1.237 1.237L4.737 3.5z"
  }));
};

var SvgXCircle = function SvgXCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M16 28.8c7.07 0 12.8-5.73 12.8-12.8S23.07 3.2 16 3.2 3.2 8.93 3.2 16 8.93 28.8 16 28.8m-2.069-17.131L16 13.737l2.069-2.068a1.6 1.6 0 1 1 2.262 2.262L18.263 16l2.068 2.069a1.6 1.6 0 1 1-2.262 2.262L16 18.263l-2.069 2.068a1.6 1.6 0 1 1-2.262-2.262L13.737 16l-2.068-2.069a1.6 1.6 0 1 1 2.262-2.262"
  }));
};

var SvgX = function SvgX(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    d: "M6.869 6.869a1.6 1.6 0 0 1 2.262 0L16 13.737l6.869-6.868A1.6 1.6 0 1 1 25.13 9.13L18.263 16l6.868 6.869a1.6 1.6 0 0 1-2.262 2.262L16 18.263 9.131 25.13a1.6 1.6 0 0 1-2.261-2.26L13.738 16 6.87 9.132a1.6 1.6 0 0 1 0-2.262z",
    clipRule: "evenodd"
  }));
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element$1=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element$1,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var has = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has;

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

var PropTypes = {
  __proto__: null,
  'default': propTypes,
  __moduleExports: propTypes
};

var variantsSimpleButton = {
  primary: 'primary',
  secondary: 'secondary'
};

function SimpleButton(props) {
  var _props$variant = props.variant,
    variant = _props$variant === void 0 ? variantsSimpleButton.secondary : _props$variant;
  var propsToButton = _extends({}, props);
  if (propsToButton.variant) delete propsToButton.variant;
  return /*#__PURE__*/React__default.createElement("button", _extends({
    type: "button"
  }, propsToButton, {
    className: cn$1('lemo-simple-button', 'lemo-base-button', 'lemo-text-body-m-bold', {
      'lemo-simple-button--primary lemo-base-button--primary': variant === variantsSimpleButton.primary,
      'lemo-simple-button--secondary lemo-base-button--secondary': variant === variantsSimpleButton.secondary
    }, props.className)
  }), props.children);
}
SimpleButton.propTypes = {
  variant: propTypes.oneOf([null, variantsSimpleButton.primary, variantsSimpleButton.secondary])
};

function ButtonHint(_ref) {
  var hints = _ref.hints,
    disabled = _ref.disabled;
  var showHint = useCallback(function () {
    hints.showHint();
  }, [hints]);
  return !(hints !== null && hints !== void 0 && hints.hasHints) ? null : /*#__PURE__*/React__default.createElement(SimpleButton, {
    className: "lemo-controls-button-show-hint",
    onClick: showHint,
    disabled: hints.isVisible || disabled,
    title: hints.buttonLabel
  }, /*#__PURE__*/React__default.createElement(SvgLightBulb, {
    className: "lemo-icon"
  }), translate('button_show_hints'));
}
var ButtonHint$1 = observer(ButtonHint);

function InlineButton(props) {
  return /*#__PURE__*/React__default.createElement("button", _extends({
    type: "button"
  }, props, {
    className: cn$1('lemo-inline-button', 'lemo-text-body-m-bold', 'lemo-base-button--text', 'lemo-text-body-m-bold', props.className)
  }), props.children);
}
InlineButton.propTypes = {};
InlineButton.defaultProps = {};

function RenderWhen(_ref) {
  var condition = _ref.condition,
    children = _ref.children;
  return !condition ? null : children;
}

function ScaffoldControls(_ref) {
  var store = _ref.store,
    currentQuestion = _ref.currentQuestion,
    _ref$renderScore = _ref.renderScore,
    renderScore = _ref$renderScore === void 0 ? null : _ref$renderScore;
  var status = useQuestionStatus({
    store: store,
    currentQuestion: currentQuestion
  });
  var _useState = useState(false),
    finished = _useState[0],
    setFinished = _useState[1];
  var showSolutionText = translate(store.showSolution ? 'button_hide_solution' : 'button_show_solution');
  var getResponseData = function getResponseData(_store) {
    return {
      output: _store.output,
      points: _store.points,
      response: _store.getResponseWithKey(),
      store: _store
    };
  };
  var isCompleted = function isCompleted() {
    return currentQuestion.isLast && currentQuestion.wasSolutionVisible;
  };
  var onComplete = useCallback(function () {
    if (finished) return false;
    currentQuestion.trackAction(actionList.COMPLETE);
    setFinished(true);
  }, [finished, setFinished, currentQuestion]);
  var onNext = useCallback(function () {
    currentQuestion.trackAction(actionList.NEXT);
  }, [currentQuestion]);
  var onSuccess = useCallback(function () {
    currentQuestion.trackAction(actionList.SUCCESS);
  }, [currentQuestion]);
  var onError = useCallback(function () {
    currentQuestion.trackAction(actionList.ERROR);
  }, [currentQuestion]);
  var tryToLaunchNext = useCallback(function () {
    if (!currentQuestion.isActive) return false;
    onNext();
    currentQuestion.next();
  }, [currentQuestion, onNext, isCompleted, onComplete]);
  var handleNext = useCallback(function () {
    var isRightResponse = store.points > 0;
    var isMain = currentQuestion.isMain,
      isInBetween = currentQuestion.isInBetween,
      setDisabled = currentQuestion.setDisabled,
      saveResponse = currentQuestion.saveResponse,
      isLast = currentQuestion.isLast,
      wasSolutionVisible = currentQuestion.wasSolutionVisible;
    setDisabled(true);
    saveResponse(store.getResponseWithKey());
    when()["case"](isMain && isRightResponse, onComplete)["case"](isLast && finished, null)["case"](isLast && isRightResponse, onComplete)["case"](isCompleted(), onComplete)["case"](isLast && !wasSolutionVisible, null)["case"](isInBetween && !isRightResponse && !wasSolutionVisible, null).resolve(tryToLaunchNext);
  }, [currentQuestion, onComplete, store, isCompleted, tryToLaunchNext]);
  var handleOnValidate = useCallback(function () {
    var isRightResponse = store.points > 0;
    store.checkAnswers();
    isRightResponse ? onSuccess(getResponseData(store)) : onError(getResponseData(store));
    handleNext();
  }, [onSuccess, onError, store, handleNext]);
  var handleOnIDK = useCallback(function () {
    store.setDisabled(true);
    currentQuestion.setDisabled();
    currentQuestion.saveResponse(store.getResponseWithKey());
    tryToLaunchNext();
  }, [currentQuestion, store, handleNext]);
  var handleShowSolutions = useCallback(function () {
    store.showSolutions(!store.showSolution);
    currentQuestion.setWasSolutionVisible();
    handleNext();
  }, [currentQuestion, handleNext]);
  var handleReset = useCallback(function () {
    store.reset();
    currentQuestion.reset();
    setFinished(false);
  }, [store]);
  var handleRestartScaffold = useCallback(function () {
    currentQuestion.restartScaffold();
  }, [currentQuestion, store]);
  useEffect(function () {
    !currentQuestion.isDisabled && currentQuestion.isMain && store.reset();
  }, [currentQuestion.isDisabled]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-controls"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-controls-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-controls-left"
  }, renderScore && /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-points"
  }, renderScore()), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: status.visible.hint
  }, /*#__PURE__*/React__default.createElement(ButtonHint$1, {
    hints: store.hints,
    disabled: status.disabled.hints
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-controls-right"
  }, /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: status.visible.idk
  }, /*#__PURE__*/React__default.createElement(InlineButton, {
    className: "lemo-controls-button-idk",
    onClick: handleOnIDK,
    disabled: status.disabled.idk,
    title: "button_i_dont_know"
  }, translate('button_i_dont_know'))), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: status.visible.validate
  }, /*#__PURE__*/React__default.createElement(SimpleButton, {
    className: "lemo-controls-button-check-answer",
    variant: variantsSimpleButton.primary,
    onClick: handleOnValidate,
    disabled: status.disabled.validate,
    title: "checkAnswer"
  }, translate('button_validate'))), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: status.visible.reset
  }, /*#__PURE__*/React__default.createElement(InlineButton, {
    className: "lemo-controls-button-reset",
    onClick: handleReset,
    disabled: status.disabled.reset,
    title: translate('button_repeat')
  }, /*#__PURE__*/React__default.createElement(SvgReplay, {
    className: "lemo-icon"
  }), " ", translate('button_repeat'))), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: status.visible.showSolution
  }, /*#__PURE__*/React__default.createElement(SimpleButton, {
    className: "lemo-controls-button-solution",
    onClick: handleShowSolutions,
    disabled: status.disabled.showSolution,
    title: "showSolution"
  }, translate(showSolutionText))), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: status.visible.restartScaffold
  }, /*#__PURE__*/React__default.createElement(SimpleButton, {
    className: "lemo-controls-button-restart-scaffold",
    onClick: handleRestartScaffold,
    disabled: status.disabled.restartScaffold,
    title: "restartScaffold"
  }, translate('button_restart_scaffold'))))));
}
var ScaffoldControls$1 = observer(ScaffoldControls);

function ScaffoldingNavigationButton(_ref) {
  var className = _ref.className,
    children = _ref.children,
    onClick = _ref.onClick,
    disabled = _ref.disabled;
  return /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-scaffolding-navigation-button " + className,
    role: "button",
    disabled: disabled,
    onClick: onClick
  }, children);
}

function ScaffoldingNavigationToggleButton(_ref) {
  var isOpen = _ref.isOpen,
    toggle = _ref.toggle,
    disabled = _ref.disabled;
  var directionClass = isOpen ? 'lemo-is-open' : '';
  return /*#__PURE__*/React__default.createElement(ScaffoldingNavigationButton, {
    className: 'lemo-scaffold-navigation-toggle-button ' + directionClass,
    onClick: toggle,
    disabled: disabled
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-scaffold-navigation-toggle-text"
  }, translate(isOpen ? 'scaffolding_navigation_toggle-show-activity' : 'scaffolding_navigation_toggle-show-steps')), /*#__PURE__*/React__default.createElement(SvgChevronDoubleDown, {
    className: "lemo-icon"
  }));
}
var ScaffoldingNavigationToggleButton$1 = observer(ScaffoldingNavigationToggleButton);

function ScaffoldingNavigationCounter(_ref) {
  var currentQuestionIndex = _ref.currentQuestionIndex,
    totalQuestions = _ref.totalQuestions;
  var text = translate('scaffolding_navigation_counter').replace('{index}', currentQuestionIndex).replace('{total}', totalQuestions);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-scaffold-navigation-counter"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-text"
  }, text));
}

function ScaffoldingNavigation(_ref) {
  var scaffoldStore = _ref.scaffoldStore;
  function handleToggle(e) {
    e.preventDefault();
    e.stopPropagation();
    scaffoldStore.isFirstTime ? scaffoldStore.close() : scaffoldStore.toggle();
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-scaffolding-mobile-navigation"
  }, /*#__PURE__*/React__default.createElement(ScaffoldingNavigationToggleButton$1, {
    toggle: handleToggle,
    isOpen: scaffoldStore.isOpen
  }), /*#__PURE__*/React__default.createElement(ScaffoldingNavigationCounter, {
    currentQuestionIndex: scaffoldStore.currentQuestionIndex,
    totalQuestions: scaffoldStore.totalQuestions
  }), /*#__PURE__*/React__default.createElement(ScaffoldingNavigationButton, {
    className: "lemo-scaffolding-navigation-prev-button",
    disabled: !scaffoldStore.prevButtonEnabled,
    onClick: scaffoldStore.prev
  }, /*#__PURE__*/React__default.createElement(SvgChevronLeft, {
    className: "lemo-icon",
    width: 24
  })), /*#__PURE__*/React__default.createElement(ScaffoldingNavigationButton, {
    className: "lemo-scaffolding-navigation-next-button",
    disabled: !scaffoldStore.nextButtonEnabled,
    onClick: scaffoldStore.next
  }, /*#__PURE__*/React__default.createElement(SvgChevronRight, {
    className: "lemo-icon",
    width: 24
  })));
}
var ScaffoldingNavigation$1 = observer(ScaffoldingNavigation);

function noop() {}

function debounce(fn, wait) {
  var timeout;
  return function () {
    var ctx = this;
    var args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      fn.apply(ctx, args);
    }, wait || 100);
  };
}

function isModeDebug() {
  return !isModeProduction();
}
function isModeProduction() {
  var _process, _process$env;
  return ((_process = process) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) === 'production';
}

var useChangedCallback = function useChangedCallback(changed, pattern, store, test, insideEditor) {
  if (test === void 0) {
    test = false;
  }
  if (insideEditor === void 0) {
    insideEditor = false;
  }
  var handleChange = useCallback(function () {
    var _store$getResponseWit;
    return !!changed && changed({
      output: store.output,
      points: store === null || store === void 0 ? void 0 : store.points,
      response: store === null || store === void 0 ? void 0 : (_store$getResponseWit = store.getResponseWithKey) === null || _store$getResponseWit === void 0 ? void 0 : _store$getResponseWit.call(store),
      store: store
    });
  }, [store, changed]);
  var debounced = useMemo(function () {
    return debounce(handleChange, config.debounceTime);
  }, [handleChange]);
  useEffect(function () {
    if (!changed) return function () {};
    var storeTracker = onAction(store, function (_ref) {
      var name = _ref.name;
      if (test) {
        console.log('-->' + name + '<--');
        console.log(pattern);
        verifyIfError(name, pattern, insideEditor);
      }
      if (name === 'lemoFastUpdate') {
        handleChange();
      } else {
        name.match(pattern) && debounced();
      }
    }, true);
    return function () {
      return storeTracker();
    };
  }, [store, debounced, pattern, changed, test]);
};
function verifyIfError(name, pattern, insideEditor) {
  if (isModeDebug() && insideEditor) {
    var listIgnore = ['setAssetsQuestionApi', 'setAssetsEditorApi', 'setAssetsQuestionApiDrive', 'checkAnswers', 'reset', 'showSolutions', 'addKey', 'setDisabled', 'setContent', 'getNextDepth', 'select', 'setSelected', 'updateDraw', 'setType', 'setImmediateFeedback', 'setResponse', 'matchResponse', 'send', 'onDrop', 'removeFile', 'setProgress', 'setError', 'setStatus', 'clearError'];
    if (hasData(name) && pattern && !listIgnore.find(function (itemList) {
      return itemList === name;
    }) && !pattern.test(name)) {
      console.error("OJO! El editor no tiene en pattern '" + name + "'");
    }
  }
}

var useDefaultProp = function useDefaultProp(_ref) {
  var setter = _ref.setter,
    value = _ref.value;
  useEffect(function () {
    if (value !== undefined && setter) setter(value);
  }, [setter, value]);
};

function useDispatchOnResize(onResize, container, debounceTime) {
  if (debounceTime === void 0) {
    debounceTime = 500;
  }
  useEffect(function () {
    var onResizeFn = function onResizeFn() {
      return onResize();
    };
    var debounced = debounce(onResizeFn, debounceTime);
    var resizeObserver = container !== null && container !== void 0 && container.current ? createResizableObserver(container, debounced) : noop;
    window.addEventListener('resize', debounced, false);
    return function () {
      onResizeFn = function onResizeFn() {
        return noop();
      };
      window.removeEventListener('resize', debounced);
      resizeObserver();
    };
  }, []);
}
function createResizableObserver(container, onResize) {
  var resizableObserver = new ResizeObserver(function (entries) {
    return onResize();
  });
  resizableObserver.observe(container.current);
  return function () {
    return resizableObserver.disconnect();
  };
}

function noFN() {}
function useImmediateFeedback(_ref) {
  var store = _ref.store,
    _ref$onImmediateSucce = _ref.onImmediateSuccess,
    onImmediateSuccess = _ref$onImmediateSucce === void 0 ? noFN : _ref$onImmediateSucce,
    _ref$onImmediateError = _ref.onImmediateError,
    onImmediateError = _ref$onImmediateError === void 0 ? noFN : _ref$onImmediateError,
    _ref$onComplete = _ref.onComplete,
    onComplete = _ref$onComplete === void 0 ? noFN : _ref$onComplete,
    _ref$solutionsMode = _ref.solutionsMode,
    solutionsMode = _ref$solutionsMode === void 0 ? false : _ref$solutionsMode;
  useEffect(function () {
    if (!store.validation.immediateFeedback || solutionsMode) return noFN;
    var tracker = reaction(function () {
      return store.responseList.length;
    }, function (value) {
      if (value > 0) {
        var response = store.responseList[value - 1];
        if (store.isEvaluated) return false;
        if (response.value && response.propagate) {
          onImmediateSuccess(response.item);
        }
        if (!response.value && response.propagate) {
          onImmediateError(response.item);
        }
        if (store.questionCompleted && !store.isSolutionMode) {
          onComplete();
          store.checkAnswers();
        }
      }
    });
    return function () {
      return tracker();
    };
  }, [store.validation.immediateFeedback]);
}

var MATHLIVE_SCRIPT_ID = 'mathliveScriptId';
var mathLiveUrl = '//unpkg.com/mathlive@0.96.2/dist/mathlive.min.js';
var useMathLive = function useMathLive() {
  var _useState = useState(false),
    mathLiveReady = _useState[0],
    setReady = _useState[1];
  var onLoadDone = useCallback(function () {
    (function retry(times) {
      !window.MathLive ? setTimeout(function () {
        return retry();
      }, 200) : setReady(true);
    })();
  }, [setReady]);
  var loadScript = useCallback(function (url, id) {
    if (isLoadedMathlive()) {
      onLoadDone();
    } else {
      if (!document.getElementById(id)) {
        var script = document.createElement('script');
        script.src = url;
        script.id = id;
        script.async = true;
        script.addEventListener('load', onLoadDone);
        document.body.appendChild(script);
      } else {
        onLoadDone();
      }
    }
  }, [onLoadDone]);
  useEffect(function () {
    loadScript(mathLiveUrl, MATHLIVE_SCRIPT_ID);
  }, []);
  function isLoadedMathlive() {
    return typeof window.MathLive !== 'undefined';
  }
  return {
    mathLiveReady: mathLiveReady
  };
};

function MathJaxQueue(element, onRenderElements, onMathJaxReady) {
  if (onRenderElements === void 0) {
    onRenderElements = function onRenderElements() {
      console.log('MathJaxQueue:: callback not defined');
    };
  }
  if (onMathJaxReady === void 0) {
    onMathJaxReady = function onMathJaxReady() {};
  }
  var processMath = function processMath(nodes) {
    try {
      window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub, nodes, function () {
        onRenderElements(nodes);
        onMathJaxReady(nodes);
      }]);
    } catch (e) {
      console.log(e);
    }
  };
  if (window.MathJax) {
    processMath(element);
  }
}

var mathClass = '.fr-math, .fr-math-v2, .fr−math−v2, [data-original-math]';
function renderMath(element, onRender) {
  if (onRender === void 0) {
    onRender = function onRender() {};
  }
  if (element) {
    if (config.mathRenderEngine === 'katex') renderKatex(element, onRender);else {
      MathJaxQueue(element, function (nodes) {
        onRender(nodes);
      }, function () {
        MathJaxQueue(document.querySelector("." + LEMONADE_WRAPPER_CLASS), function (val) {
          onRender(val);
        });
      });
    }
  }
}
function isFrameworkLoaded() {
  return window.MathJax || window.katex;
}
function useMathRender(rootElement, rules, onSuccess, init, onStartLatexRendering) {
  if (rules === void 0) {
    rules = [];
  }
  if (onSuccess === void 0) {
    onSuccess = null;
  }
  if (init === void 0) {
    init = false;
  }
  if (onStartLatexRendering === void 0) {
    onStartLatexRendering = null;
  }
  var _useState = useState(0),
    isUpdated = _useState[0],
    setUpdate = _useState[1];
  useEffect(function () {
    var _rootElement$current;
    var isMounted = true;
    var hasMath = rootElement === null || rootElement === void 0 ? void 0 : (_rootElement$current = rootElement.current) === null || _rootElement$current === void 0 ? void 0 : _rootElement$current.querySelector(mathClass);
    if (hasMath || init) {
      var _onStartLatexRenderin;
      (_onStartLatexRenderin = onStartLatexRendering) === null || _onStartLatexRenderin === void 0 ? void 0 : _onStartLatexRenderin();
      renderMath(rootElement === null || rootElement === void 0 ? void 0 : rootElement.current, function (nodes) {
        if (isMounted) {
          var _onSuccess;
          setUpdate(1);
          (_onSuccess = onSuccess) === null || _onSuccess === void 0 ? void 0 : _onSuccess();
        }
      });
      if (!isFrameworkLoaded()) {
        var timeoutId = setTimeout(function () {
          if (isMounted) {
            var _onSuccess2;
            (_onSuccess2 = onSuccess) === null || _onSuccess2 === void 0 ? void 0 : _onSuccess2();
          }
        }, 500);
        return function () {
          isMounted = false;
          clearTimeout(timeoutId);
        };
      }
    }
    return function () {
      isMounted = false;
    };
  }, rules);
  return {
    isUpdated: isUpdated
  };
}

var useScorm = function useScorm(store, scormControls, scormVersion) {
  if (scormVersion === void 0) {
    scormVersion = 1.2;
  }
  function handleComplete() {
    store.scormData.addTries();
    var interactiveList = Array.from(store.scormData.interactiveList.values());
    scormControls.onComplete(interactiveList.map(function (interactive) {
      return interactive.output;
    }), store.points, store.scormData.tries);
  }
  useEffect(function () {
    var _store$scormData, _store$scormData$setS;
    if (!scormControls) return function () {};
    if (!store.scormData) return function () {};
    if (!scormControls.onInit) throw new Error('scormControls should have an `onInit` function');
    if (!scormControls.onComplete) throw new Error('scormControls should have an `onComplete` function');
    scormControls.onInit(store.scormData.output);
    store === null || store === void 0 ? void 0 : (_store$scormData = store.scormData) === null || _store$scormData === void 0 ? void 0 : (_store$scormData$setS = _store$scormData.setScormVersion) === null || _store$scormData$setS === void 0 ? void 0 : _store$scormData$setS.call(_store$scormData, scormVersion.toString());
    var isEvaluatedTracker = reaction(function () {
      return store.isEvaluated;
    }, function (isEvaluated) {
      return isEvaluated && handleComplete();
    });
    return function () {
      return isEvaluatedTracker();
    };
  }, [store.raw.reference]);
};

function findUpClass(el, className) {
  while (el.parentNode) {
    var _el$classList;
    el = el.parentNode;
    if ((_el$classList = el.classList) !== null && _el$classList !== void 0 && _el$classList.contains(className)) return el;
  }
  return null;
}
function replaceNode(newElementStr, elementToReplace) {
  if (elementToReplace.outerHTML) {
    elementToReplace.outerHTML = newElementStr;
  } else {
    var tmpObj = document.createElement('div');
    tmpObj.innerHTML = '<!--THIS DATA SHOULD BE REPLACED-->';
    var ObjParent = elementToReplace.parentNode;
    ObjParent.replaceChild(tmpObj, elementToReplace);
    ObjParent.innerHTML = ObjParent.innerHTML.replace('<div><!--THIS DATA SHOULD BE REPLACED--></div>', newElementStr);
  }
}

var TYPES_AUDIO_PLAYER = {
  ONLY_ICON_PLAY: 'only-icon-play',
  CUSTOM_PLAYER: 'custom_player'
};
var ATRIBUTE_DATA_PLAYER = 'data-player';
function initAudios(element, isEditorFroala, labelTranscription) {
  if (element) {
    var audios = element.getElementsByTagName('AUDIO');
    if (audios && audios.length >= 1 && audios[0]) {
      for (var i = 0; i < audios.length; i++) {
        if (audios[i].parentElement && !audios[i].parentElement.classList.contains('fr-audio')) {
          var spanFrAudio = getSpanFrAudio(audios[i].outerHTML, isEditorFroala);
          audios[i].replaceWith(spanFrAudio);
        }
      }
    }
    var spanAudios = element.getElementsByClassName('fr-audio');
    for (var _i = 0; _i < spanAudios.length; _i++) {
      var spanAudio = spanAudios[_i];
      initAudio(spanAudio, isEditorFroala, labelTranscription);
    }
  }
}
function createElementFromHTML(htmlString) {
  var div = document.createElement('span');
  div.innerHTML = htmlString.trim();
  return div.firstChild;
}
function getSpanStringFrAudio(audioElementString, isLoading, canAudioMove) {
  if (isLoading === void 0) {
    isLoading = false;
  }
  if (canAudioMove === void 0) {
    canAudioMove = false;
  }
  return '<span class="fr-audio' + (isLoading ? ' fr-uploading' : '') + (canAudioMove ? ' fr-draggable' : '') + '" contenteditable="false"' + (canAudioMove ? ' draggable="true"' : '') + '>' + audioElementString + '</span>';
}
function getSpanFrAudio(audioElementString, canAudioMove) {
  var audioToRet = createElementFromHTML(getSpanStringFrAudio(audioElementString, false, canAudioMove));
  return audioToRet;
}
function getIconVolume() {
  return '<svg style="pointer-events:none;" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.50614 2.46092C7.80509 2.58475 8 2.87646 8 3.20003V12.8C8 13.1236 7.80509 13.4153 7.50614 13.5391C7.20721 13.663 6.86311 13.5945 6.63431 13.3657L3.66863 10.4H1.6C1.15818 10.4 0.799999 10.0418 0.799999 9.6V6.40003C0.799999 5.95819 1.15818 5.60003 1.6 5.60003H3.66863L6.63431 2.63434C6.86311 2.40554 7.20721 2.3371 7.50614 2.46092ZM11.7254 2.34311C12.0379 2.03069 12.5444 2.03069 12.8569 2.34311C14.3037 3.78995 15.2 5.79104 15.2 7.99996C15.2 10.2089 14.3037 12.21 12.8569 13.6568C12.5444 13.9692 12.0379 13.9692 11.7254 13.6568C11.413 13.3444 11.413 12.8378 11.7254 12.5254C12.8846 11.3664 13.6 9.76752 13.6 7.99996C13.6 6.23243 12.8846 4.63352 11.7254 3.47448C11.413 3.16206 11.413 2.65552 11.7254 2.34311ZM9.46272 4.60585C9.77512 4.29343 10.2817 4.29343 10.5941 4.60585C11.0148 5.02656 11.3581 5.5255 11.6002 6.07967C11.8576 6.66874 12 7.31878 12 7.99996C12 9.3252 11.4618 10.5263 10.5941 11.3941C10.2817 11.7065 9.77512 11.7065 9.46272 11.3941C9.15032 11.0817 9.15032 10.5751 9.46272 10.2627C10.0427 9.68272 10.4 8.88384 10.4 7.99996C10.4 7.54338 10.3049 7.11112 10.1341 6.72026C9.97304 6.35167 9.74416 6.01862 9.46272 5.73722C9.15032 5.4248 9.15032 4.91827 9.46272 4.60585Z" fill="white"/></svg>';
}
function getIconStop() {
  return '<svg style="pointer-events:none;" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 3.5H11C11.3978 3.5 11.7794 3.65804 12.0607 3.93934C12.342 4.22064 12.5 4.60218 12.5 5V11C12.5 11.3978 12.342 11.7794 12.0607 12.0607C11.7794 12.342 11.3978 12.5 11 12.5H5C4.60218 12.5 4.22064 12.342 3.93934 12.0607C3.65804 11.7794 3.5 11.3978 3.5 11V5C3.5 4.60218 3.65804 4.22064 3.93934 3.93934C4.22064 3.65804 4.60218 3.5 5 3.5Z" fill="white"/></svg>';
}
function getIconPlay() {
  return '<svg style="pointer-events:none;" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 8C11.5 7.72525 11.352 7.485 11.1313 7.35425L5.64025 4.1095C5.63825 4.10825 5.63625 4.10725 5.63425 4.106L5.6315 4.10425C5.51975 4.03825 5.38925 4 5.25 4C4.83575 4 4.5 4.33575 4.5 4.75V11.25C4.5 11.6642 4.83575 12 5.25 12C5.38925 12 5.51975 11.962 5.6315 11.8958L5.63425 11.894C5.63625 11.8925 5.63825 11.8915 5.64025 11.8905L11.1313 8.64575C11.352 8.51525 11.5 8.275 11.5 8Z" fill="white"/></svg>';
}
function getIconPause() {
  return '<svg style="pointer-events:none;" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 3.5C5.89782 3.5 6.27936 3.65804 6.56066 3.93934C6.84196 4.22064 7 4.60218 7 5V11C7 11.3978 6.84196 11.7794 6.56066 12.0607C6.27936 12.342 5.89782 12.5 5.5 12.5C5.10218 12.5 4.72064 12.342 4.43934 12.0607C4.15804 11.7794 4 11.3978 4 11V5C4 4.60218 4.15804 4.22064 4.43934 3.93934C4.72064 3.65804 5.10218 3.5 5.5 3.5ZM10.5 3.5C10.8978 3.5 11.2794 3.65804 11.5607 3.93934C11.842 4.22064 12 4.60218 12 5V11C12 11.3978 11.842 11.7794 11.5607 12.0607C11.2794 12.342 10.8978 12.5 10.5 12.5C10.1022 12.5 9.72064 12.342 9.43934 12.0607C9.15804 11.7794 9 11.3978 9 11V5C9 4.60218 9.15804 4.22064 9.43934 3.93934C9.72064 3.65804 10.1022 3.5 10.5 3.5Z" fill="white"/></svg>';
}
function getButtonPlayStopHtml(labelTranscription) {
  return '<span class="lemo-fr-button-audio__container">' + '<button type="button" class="lemo-fr-button-audio play">' + getIconVolume() + '</button>' + getTranscriptionContainer(labelTranscription) + '</span>';
}
function getTranscriptionContainer(labelTranscription) {
  return " <span class=\"lemo-fr-audio-transcription-container\">\n                  <span class=\"lemo-fr-audio-transcription-icon\">\n                    <span class=\"lemo-fr-audio-transcription-icon__icon\">\n                      <svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.80029 4.80015C4.80029 3.47466 5.87481 2.40015 7.20029 2.40015H12.7032C13.3398 2.40015 13.9502 2.653 14.4003 3.10309L18.4974 7.20015C18.9474 7.65023 19.2003 8.26068 19.2003 8.8972V19.2001C19.2003 20.5256 18.1258 21.6001 16.8003 21.6001H7.20029C5.87481 21.6001 4.80029 20.5256 4.80029 19.2001V4.80015ZM7.20029 12.0001C7.20029 11.3374 7.73755 10.8001 8.40029 10.8001H15.6003C16.263 10.8001 16.8003 11.3374 16.8003 12.0001C16.8003 12.6629 16.263 13.2001 15.6003 13.2001H8.40029C7.73755 13.2001 7.20029 12.6629 7.20029 12.0001ZM8.40029 15.6001C7.73755 15.6001 7.20029 16.1374 7.20029 16.8001C7.20029 17.4629 7.73755 18.0001 8.40029 18.0001H15.6003C16.263 18.0001 16.8003 17.4629 16.8003 16.8001C16.8003 16.1374 16.263 15.6001 15.6003 15.6001H8.40029Z\" fill=\"#8C99AD\"/>\n                      </svg>\n                    </span>\n                  </span>\n                  <span class=\"lemo-fr-audio-transcription lemo-fr-audio-transcription-hidden\">\n                      <span class=\"lemo-fr-audio-transcription-content\">\n                        <span class=\"lemo-fr-audio-transcription-content__header\">\n                          <span class=\"lemo-fr-audio-transcription-content__header-title\">" + labelTranscription + "</span>\n                          <span class=\"lemo-fr-audio-transcription-content__header-divider\"></span>\n                        </span>\n                        <span class=\"lemo-fr-audio-transcription-content__cue-container\">\n                        </span>\n                    </span>\n                  </span>\n          </span>";
}
function getCumtomPlayer(labelTranscription) {
  return "<span class=\"lemo-fr-audio-player\">\n          <span class=\"timeline-controls\">\n              <span class=\"controls\">\n                <span class=\"play-container\">\n                  <span class=\"toggle-play play\">" + getIconPlay() + ("</span>\n                </span>\n                <span class=\"timeline\">\n                  <span class=\"progress\"></span>\n                </span>\n                <span class=\"time\">\n                  <span class=\"current\">0:00</span>\n                  <span class=\"divider\">/</span>\n                  <span class=\"length\"></span>\n                </span>\n                " + getTranscriptionContainer(labelTranscription) + "\n              </span>\n          </span>\n      </span>");
}
function initAudio(spanAudio, isEditorFroala, labelTranscription) {
  if (spanAudio) {
    var audioElements = spanAudio.getElementsByTagName('audio');
    if (audioElements && audioElements.length >= 1) {
      var havePlayer = spanAudio.children.length > 1;
      var dataPlayer = audioElements[0].getAttribute(ATRIBUTE_DATA_PLAYER);
      if (hasData(dataPlayer) && dataPlayer === TYPES_AUDIO_PLAYER.ONLY_ICON_PLAY) {
        if (!havePlayer) {
          var playerNode = createElementFromHTML(getButtonPlayStopHtml(labelTranscription));
          spanAudio.appendChild(playerNode);
        }
        initOnlyPlay(spanAudio, !isEditorFroala, !isEditorFroala);
      } else {
        if (!havePlayer) {
          var _playerNode = createElementFromHTML(getCumtomPlayer(labelTranscription));
          spanAudio.appendChild(_playerNode);
        }
        initPlayerPersonal(spanAudio, !isEditorFroala, !isEditorFroala, false, false, false, false);
      }
    }
  }
}
function initOnlyPlay(spanAudio, isStopPropagationButtonClick, stopPropagationMouseDownUp) {
  if (isStopPropagationButtonClick === void 0) {
    isStopPropagationButtonClick = false;
  }
  if (stopPropagationMouseDownUp === void 0) {
    stopPropagationMouseDownUp = false;
  }
  var audioElements = spanAudio.getElementsByTagName('audio');
  var buttonElements = spanAudio.getElementsByTagName('button');
  if (audioElements && audioElements.length > 0 && buttonElements && buttonElements.length > 0) {
    var player = audioElements[0];
    if (player) {
      if (!player.onended) {
        player.onended = function () {
          if (button) {
            button.classList.remove('stop');
            button.classList.add('play');
            button.innerHTML = getIconVolume();
            updateDropHidden(player);
          }
        };
      }
      var handleOntimeupdate = function handleOntimeupdate(e) {
        updateActiveCue(spanAudio, player.currentTime);
      };
      player.addEventListener('timeupdate', handleOntimeupdate);
    }
    var button = buttonElements[0];
    if (button) {
      if (!button.onclick) {
        button.onclick = function (e) {
          if (!e) e = window.event;
          if (isStopPropagationButtonClick) {
            e.stopPropagation();
            e.preventDefault();
          }
          if (player.paused) {
            this.classList.remove('play');
            this.classList.add('stop');
            this.innerHTML = getIconStop();
            player.play();
          } else {
            this.classList.remove('stop');
            this.classList.add('play');
            this.innerHTML = getIconVolume();
            player.pause();
            player.currentTime = 0;
          }
          updateDropHidden(e.target);
        };
      }
      if (stopPropagationMouseDownUp) {
        button.addEventListener('mousedown', function (e) {
          e.stopPropagation();
          e.preventDefault();
        });
        button.addEventListener('mouseup', function (e) {
          e.stopPropagation();
          e.preventDefault();
        });
      }
    }
    setupTranscriptionContainer(spanAudio, audioElements[0]);
  }
}
function updateActiveCue(audioPlayer, currentTime) {
  var transcription = audioPlayer.querySelector('.lemo-fr-audio-transcription');
  if (!transcription) return;
  var cues = transcription.querySelectorAll('.lemo-fr-audio-transcription-content__cue');
  if (cues.length === 1 && cues[0].dataset.endTime === '-1') {
    cues[0].classList.remove('cueActive', 'cueInactive');
    return;
  }
  var activeCueFound = false;
  cues.forEach(function (cue) {
    var startTime = parseFloat(cue.dataset.startTime);
    var endTime = parseFloat(cue.dataset.endTime);
    cue.classList.remove('cueActive', 'cueInactive');
    if (currentTime >= startTime && (endTime === -1 || currentTime < endTime)) {
      cue.classList.add('cueActive');
      activeCueFound = true;
      var container = transcription.querySelector('.lemo-fr-audio-transcription-content__cue-container');
      if (container) {
        var containerHeight = container.clientHeight;
        var elementTop = cue.offsetTop;
        var elementHeight = cue.clientHeight;
        var scrollPosition = elementTop - containerHeight / 2 + elementHeight / 2;
        container.scrollTo({
          top: scrollPosition,
          behavior: 'smooth'
        });
      }
    } else {
      cue.classList.add('cueInactive');
    }
  });
  if (!activeCueFound && cues.length > 0) {
    var lastCue = cues[cues.length - 1];
    var lastCueEndTime = parseFloat(lastCue.dataset.endTime);
    if (currentTime >= lastCueEndTime) {
      lastCue.classList.remove('cueInactive');
      lastCue.classList.add('cueActive');
    }
  }
}
function initPlayerPersonal(spanAudio, isStopPropagationPlayerClick, isStopPropagationPlayerMouseDownUp, isStopPropagationPlayClick, isStopPropagationPlayMouseDownUp, isStopPropagationTimelineClick, isStopPropagationTimelineMouseDownUp) {
  if (isStopPropagationPlayerClick === void 0) {
    isStopPropagationPlayerClick = false;
  }
  if (isStopPropagationPlayerMouseDownUp === void 0) {
    isStopPropagationPlayerMouseDownUp = false;
  }
  if (isStopPropagationPlayClick === void 0) {
    isStopPropagationPlayClick = false;
  }
  if (isStopPropagationPlayMouseDownUp === void 0) {
    isStopPropagationPlayMouseDownUp = false;
  }
  if (isStopPropagationTimelineClick === void 0) {
    isStopPropagationTimelineClick = false;
  }
  if (isStopPropagationTimelineMouseDownUp === void 0) {
    isStopPropagationTimelineMouseDownUp = false;
  }
  var audioPlayer = spanAudio.querySelector('.lemo-fr-audio-player');
  if (audioPlayer) {
    if (isStopPropagationPlayerClick && !audioPlayer.onclick) {
      audioPlayer.onclick = function (e) {
        e.stopPropagation();
        e.preventDefault();
      };
    }
    if (isStopPropagationPlayerMouseDownUp) {
      audioPlayer.addEventListener('mousedown', function (e) {
        e.stopPropagation();
        e.preventDefault();
      });
      audioPlayer.addEventListener('mouseup', function (e) {
        e.stopPropagation();
        e.preventDefault();
      });
    }
  }
  var audioElements = spanAudio.getElementsByTagName('audio');
  if (audioElements && audioElements.length > 0 && audioPlayer) {
    var updateProgress = function updateProgress() {
      var progressBar = audioPlayer.querySelector('.progress');
      if (progressBar) progressBar.style.width = audio.currentTime / audio.duration * 100 + '%';
      if (audioPlayer.querySelector('.time .current')) audioPlayer.querySelector('.time .current').textContent = getTimeCodeFromNum(audio.currentTime);
    };
    var getTimeCodeFromNum = function getTimeCodeFromNum(num) {
      var seconds = parseInt(num);
      var minutes = parseInt(seconds / 60);
      seconds -= minutes * 60;
      var hours = parseInt(minutes / 60);
      minutes -= hours * 60;
      if (hours === 0) return minutes + ":" + String(seconds % 60).padStart(2, 0);
      return String(hours).padStart(2, 0) + ":" + minutes + ":" + String(seconds % 60).padStart(2, 0);
    };
    var audio = audioElements[0];
    audio.style.display = 'none';
    audio.addEventListener('loadeddata', function () {
      if (audioPlayer.querySelector('.time .length')) audioPlayer.querySelector('.time .length').textContent = getTimeCodeFromNum(audio.duration);
      audio.volume = 0.75;
    }, false);
    if (!audio.onended) {
      audio.onended = function () {
        if (playBtn) {
          playBtn.classList.remove('pause');
          playBtn.classList.add('play');
          playBtn.innerHTML = getIconPlay();
          updateDropHidden(audioPlayer);
        }
      };
    }
    var timeline = audioPlayer.querySelector('.timeline');
    if (timeline) {
      if (!timeline.onclick) {
        timeline.onclick = function (e) {
          if (isStopPropagationTimelineClick) {
            e.stopPropagation();
            e.preventDefault();
          }
          var timelineWidth = window.getComputedStyle(timeline).width;
          var timeToSeek = e.offsetX / parseInt(timelineWidth) * audio.duration;
          audio.currentTime = timeToSeek;
        };
      }
      if (isStopPropagationTimelineMouseDownUp) {
        timeline.addEventListener('mousedown', function (e) {
          e.stopPropagation();
          e.preventDefault();
        });
        timeline.addEventListener('mouseup', function (e) {
          e.stopPropagation();
          e.preventDefault();
        });
      }
    }
    var volumeSlider = audioPlayer.querySelector('.controls .volume-slider');
    if (volumeSlider) {
      if (!volumeSlider.onclick) {
        volumeSlider.onclick = function (e) {
          var sliderWidth = window.getComputedStyle(volumeSlider).width;
          var newVolume = e.offsetX / parseInt(sliderWidth);
          audio.volume = newVolume;
          audioPlayer.querySelector('.controls .volume-percentage').style.width = newVolume * 100 + '%';
        };
      }
    }
    var handleOntimeupdate = function handleOntimeupdate(e) {
      updateProgress();
      updateDropHidden(e.target);
      updateActiveCue(audioPlayer, audio.currentTime);
    };
    audio.addEventListener('timeupdate', handleOntimeupdate);
    var playBtn = audioPlayer.querySelector('.controls .toggle-play');
    if (playBtn) {
      if (!playBtn.onclick) {
        playBtn.onclick = function (e) {
          if (isStopPropagationPlayClick) {
            e.stopPropagation();
            e.preventDefault();
          }
          if (audio.paused) {
            playBtn.classList.remove('play');
            playBtn.classList.add('pause');
            playBtn.innerHTML = getIconPause();
            audio.play();
          } else {
            playBtn.classList.remove('pause');
            playBtn.classList.add('play');
            playBtn.innerHTML = getIconPlay();
            audio.pause();
          }
        };
      }
      if (isStopPropagationPlayMouseDownUp) {
        playBtn.addEventListener('mousedown', function (e) {
          e.stopPropagation();
          e.preventDefault();
        });
        playBtn.addEventListener('mouseup', function (e) {
          e.stopPropagation();
          e.preventDefault();
        });
      }
    }
    if (audioPlayer.querySelector('.volume-button')) {
      audioPlayer.querySelector('.volume-button').addEventListener('click', function () {
        var volumeEl = audioPlayer.querySelector('.volume-container .volume');
        audio.muted = !audio.muted;
        if (audio.muted) {
          volumeEl.classList.remove('icono-volumeMedium');
          volumeEl.classList.add('icono-volumeMute');
        } else {
          volumeEl.classList.add('icono-volumeMedium');
          volumeEl.classList.remove('icono-volumeMute');
        }
      });
    }
    setupTranscriptionContainer(audioPlayer, audio);
  }
}
function setupTranscriptionContainer(audioPlayer, audio) {
  var transcriptionIcon = audioPlayer.querySelector('.lemo-fr-audio-transcription-icon');
  if (transcriptionIcon) {
    var transcriptionSrc = audio.getAttribute('data-transcription');
    if (transcriptionSrc) {
      transcriptionIcon.classList.remove('lemo-fr-audio-transcription-icon--hidden');
    } else {
      transcriptionIcon.classList.add('lemo-fr-audio-transcription-icon--hidden');
    }
    transcriptionIcon.addEventListener('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      var transcriptionSrc = audio.getAttribute('data-transcription');
      if (transcriptionSrc) {
        var fileExtension = transcriptionSrc.split('?')[0].split('.').pop().toLowerCase();
        fetch(transcriptionSrc).then(function (response) {
          if (!response.ok) {
            throw new Error('No se pudo cargar la transcripción');
          }
          return response.text();
        }).then(function (text) {
          var cues = parseTranscriptionFile(text, fileExtension);
          var transcription = audioPlayer.querySelector('.lemo-fr-audio-transcription');
          if (transcription) {
            var cueContainer = transcription.querySelector('.lemo-fr-audio-transcription-content__cue-container');
            if (cueContainer) {
              cueContainer.innerHTML = '';
              cues.forEach(function (cue) {
                var cueElement = document.createElement('span');
                cueElement.className = 'lemo-fr-audio-transcription-content__cue';
                cueElement.innerHTML = cue.text;
                cueElement.style.whiteSpace = 'pre-line';
                cueElement.dataset.startTime = cue.startTime;
                cueElement.dataset.endTime = cue.endTime;
                cueElement.addEventListener('click', function (e) {
                  e.stopPropagation();
                  e.preventDefault();
                  audio.currentTime = cue.startTime;
                });
                cueContainer.appendChild(cueElement);
              });
            }
            transcription.classList.toggle('lemo-fr-audio-transcription-hidden');
            if (transcriptionIcon.classList.contains('active')) {
              transcriptionIcon.classList.remove('active');
            } else {
              transcriptionIcon.classList.add('active');
            }
          }
        })["catch"](function (error) {
          console.error('Error cargando la transcripción:', error);
        });
      }
    });
  }
}
function validateAudio(src, isValid, isInvalid, acceptedTypes) {
  var audio = document.createElement('audio');
  audio.setAttribute('src', src);
  audio.addEventListener('canplay', function () {
    var video = document.createElement('video');
    video.setAttribute('src', src);
    video.addEventListener('canplay', function () {
      if (video.videoHeight && video.videoHeight > 0) {
        isInvalid();
      } else {
        var urlExtension = getUrlExtension(src);
        if (acceptedTypes && urlExtension) {
          if (acceptedTypes.indexOf(urlExtension) >= 0) {
            isValid();
          } else {
            isInvalid();
          }
        } else {
          isValid();
        }
      }
    });
    video.addEventListener('error', function () {
      isInvalid();
    });
  });
  audio.addEventListener('error', function () {
    isInvalid();
  });
}
function getUrlExtension(url) {
  try {
    return url === null || url === void 0 ? void 0 : url.split(/[#?]/)[0].split('.').pop().trim();
  } catch (error) {
    return undefined;
  }
}
function updateDropHidden(element) {
  try {
    var lemoDragDropped = findUpClass(element, 'lemo-drag-dropped');
    if (lemoDragDropped) {
      var htmlContents = lemoDragDropped.getElementsByClassName('html-content');
      if (htmlContents && htmlContents.length >= 1) {
        var firstHtmlContent = htmlContents[0];
        if (firstHtmlContent && firstHtmlContent.firstElementChild && firstHtmlContent.firstElementChild.outerHTML && lemoDragDropped.parentElement && lemoDragDropped.parentElement.firstElementChild && lemoDragDropped.parentElement.firstElementChild.firstElementChild && lemoDragDropped.parentElement.firstElementChild.classList && lemoDragDropped.parentElement.firstElementChild.classList.contains('html-content')) {
          replaceNode(firstHtmlContent.firstElementChild.outerHTML, lemoDragDropped.parentElement.firstElementChild.firstElementChild);
        }
      }
    }
  } catch (error) {}
  try {
    var htmlContent = findUpClass(element, 'html-content');
    var _lemoDragDropped = findUpClass(element, 'lemo-drag-dropped');
    if (htmlContent && htmlContent.firstElementChild && htmlContent.firstElementChild.outerHTML && _lemoDragDropped && _lemoDragDropped.parentElement && _lemoDragDropped.parentElement.childNodes.length >= 2 && _lemoDragDropped.parentElement.children[1] && _lemoDragDropped.parentElement.children[1].classList && _lemoDragDropped.parentElement.children[1].classList.contains('lemo-drop-area') && _lemoDragDropped.parentElement.children[1].firstElementChild && _lemoDragDropped.parentElement.children[1].firstElementChild.classList && _lemoDragDropped.parentElement.children[1].firstElementChild.classList.contains('html-content') && _lemoDragDropped.parentElement.children[1].firstElementChild.firstElementChild) {
      replaceNode(htmlContent.firstElementChild.outerHTML, _lemoDragDropped.parentElement.children[1].firstElementChild.firstElementChild);
    }
  } catch (error) {}
  try {
    var _lemoDragDropped2 = findUpClass(element, 'lemo-drag-dropped');
    if (_lemoDragDropped2) {
      var _htmlContents = _lemoDragDropped2.getElementsByClassName('html-content');
      if (_htmlContents && _htmlContents.length >= 1) {
        var _firstHtmlContent = _htmlContents[0];
        if (_firstHtmlContent && _firstHtmlContent.firstElementChild && _firstHtmlContent.firstElementChild.outerHTML && _lemoDragDropped2.parentElement && _lemoDragDropped2.parentElement.firstElementChild && _lemoDragDropped2.parentElement.firstElementChild.firstElementChild && _lemoDragDropped2.parentElement.firstElementChild.firstElementChild.classList && _lemoDragDropped2.parentElement.firstElementChild.firstElementChild.classList.contains('html-content') && _lemoDragDropped2.parentElement.firstElementChild.firstElementChild.firstElementChild) {
          replaceNode(_firstHtmlContent.firstElementChild.outerHTML, _lemoDragDropped2.parentElement.firstElementChild.firstElementChild.firstElementChild);
        }
      }
    }
  } catch (error) {}
}
function parseTranscriptionFile(content, fileExtension) {
  if (fileExtension === 'txt') {
    var cleanText = content.replace(/\[Inicio del texto\]\n?/i, '').replace(/\[Fin del texto\]\n?/i, '').trim();
    return [{
      startTime: 0,
      endTime: -1,
      text: cleanText
    }];
  } else if (fileExtension === 'vtt') {
    var lines = content.split('\n');
    var cues = [];
    var currentCue = null;
    lines.forEach(function (line) {
      if (line.trim() === 'WEBVTT' || line.trim() === '') return;
      if (line.includes('-->')) {
        if (currentCue && currentCue.text.trim()) {
          cues.push(currentCue);
        }
        var _line$split$map = line.split('-->').map(function (t) {
            return t.trim();
          }),
          startStr = _line$split$map[0],
          endStr = _line$split$map[1];
        var parseTime = function parseTime(timeStr) {
          var parts = timeStr.split(':');
          var hours = 0,
            minutes = 0,
            seconds = 0,
            ms = 0;
          if (parts.length === 3) {
            hours = parts[0];
            minutes = parts[1];
            seconds = parts[2];
          } else {
            minutes = parts[0];
            seconds = parts[1];
          }
          var _seconds$split = seconds.split('.'),
            secs = _seconds$split[0],
            millis = _seconds$split[1];
          hours = parseFloat(hours || 0);
          minutes = parseFloat(minutes);
          seconds = parseFloat(secs);
          ms = parseFloat(millis || 0) / 1000;
          return hours * 3600 + minutes * 60 + seconds + ms;
        };
        var start = parseTime(startStr);
        var end = parseTime(endStr);
        currentCue = {
          startTime: start,
          endTime: end,
          text: ''
        };
      } else if (currentCue && !line.match(/^\d+$/)) {
        if (currentCue.text) {
          currentCue.text += '\n' + line.trim();
        } else {
          currentCue.text = line.trim();
        }
      }
    });
    if (currentCue && currentCue.text.trim()) {
      cues.push(currentCue);
    }
    return cues;
  }
  throw new Error('Extensión de archivo de transcripción no válida: ' + fileExtension);
}

function useAudios(rootElement, rules) {
  if (rules === void 0) {
    rules = [];
  }
  useEffect(function () {
    if (rootElement !== null && rootElement !== void 0 && rootElement.current) initAudios(rootElement === null || rootElement === void 0 ? void 0 : rootElement.current, false, translate('Transcription'));
  }, rules);
  return {};
}

var SVGNS$1 = 'http://www.w3.org/2000/svg';
var SVG = {
  LINE: 'line',
  RECT: 'rect',
  CIRCLE: 'circle',
  SVG: 'svg',
  G: 'g',
  FOREIGN_OBJECT: 'foreignObject',
  POLYLINE: 'polyline',
  PATH: 'path',
  TEXT: 'text'
};
function createSvgElement(_ref) {
  var type = _ref.type,
    props = _ref.props;
  var element = document.createElementNS(SVGNS$1, type);
  for (var prop in props) {
    prop === 'className' ? addClassList(element, props[prop]) : element.setAttributeNS(null, prop, props[prop]);
  }
  return element;
}
function addClassList(element, value) {
  var classList = !Array.isArray(value) ? [value] : value;
  classList.forEach(function (c) {
    element.classList.add(c);
  });
}

function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians)
  };
}
function describeArc(x, y, radius, startAngle, endAngle) {
  var start = polarToCartesian(x, y, radius, endAngle);
  var end = polarToCartesian(x, y, radius, startAngle);
  var largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';
  return ['M', start.x, start.y, 'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y].join(' ');
}

var SVGNS$2 = 'http://www.w3.org/2000/svg';
var CHART_WIDTH = '100%';
var CHART_HEIGHT = 320;
var CANVAS_HEIGHT = 280;
var CANVAS_WIDTH = 450;
var BAR_WIDTH = 14;
var BAR_MARGIN = 3;
var LEFT_VALUES_WIDTH = 40;
var HISTOGRAM_COLUMNS_WIDTH = 15;
var LINE_CHART = 'LINE_CHART';
var HISTOGRAMS = 'HISTOGRAMS';
var BAR_CHART_SINGLE_GROUP = 'BAR_CHART_SINGLE_GROUP';
var BAR_CHART_SINGLE_COLUMN = 'BAR_CHART_MULTIPLE_GROUP';
var BAR_CHART_MULTIPLE_COLUMNS = 'BAR_CHART_MULTIPLE_GROUP_WITH_LABELS';
var UNKNOWN_BARCHART = 'UNKNOWN_BARCHART';
var LINE_CLASS_NAME = 'lemo-input-chart-line';
var LINE_LABEL_CLASS_NAME = 'lemo-input-chart-line-label';

var WRAPPER_CLASS_NAME = 'lemo-input-chart-legend';
var LEGEND_ITEM_CLASS_NAME = 'lemo-input-chart-legend-item';
var LEGEND_ITEM_COLOR_CLASS_NAME = 'lemo-input-chart-legend-item-color';
var LEGEND_ITEM_LABEL_CLASS_NAME = 'lemo-input-chart-legend-item-label';
function createLegend(_ref) {
  var chartType = _ref.chartType,
    series = _ref.series;
  var element = document.createElement('div');
  element.className = WRAPPER_CLASS_NAME;
  if (chartType !== BAR_CHART_SINGLE_GROUP) {
    series.forEach(function (serie, idx) {
      element.append(createLegendItem({
        serie: serie,
        idx: idx
      }));
    });
  }
  return element;
}
function createLegendItem(_ref2) {
  var serie = _ref2.serie,
    idx = _ref2.idx;
  var element = document.createElement('div');
  var label = serie.name;
  var colorClassName = LEGEND_ITEM_COLOR_CLASS_NAME + "_" + idx;
  element.classList.add(LEGEND_ITEM_CLASS_NAME, colorClassName);
  if (label !== undefined) {
    element.innerHTML = "\n    <div class=\"" + LEGEND_ITEM_COLOR_CLASS_NAME + "\"></div>\n    <span class=\"" + LEGEND_ITEM_LABEL_CLASS_NAME + "\">" + serie.name + "</span>\n  ";
  }
  return element;
}

var WRAPPER_CLASS_NAME$1 = 'lemo-pie-chart';
var SECTION_CLASS_NAME = 'lemo-pie-chart-section';
var CIRCLE_SIZE = 240;
function createPieChart(_ref) {
  var series = _ref.series,
    labels = _ref.labels,
    chartView = _ref.chartView;
  var pieChart = createSvgElement({
    type: SVG.SVG,
    props: {
      className: [WRAPPER_CLASS_NAME$1],
      height: CIRCLE_SIZE.toString(),
      width: CIRCLE_SIZE.toString()
    }
  });
  var totalValue = series.reduce(function (acc, next) {
    return acc + next;
  }, 0);
  var sections = createSections(totalValue, series, labels);
  sections.forEach(function (section, idx) {
    pieChart.append(drawSection(section, idx));
  });
  chartView.append(createLegend({
    chartType: 'PIE_CHART',
    series: series.map(function (value, idx) {
      return {
        name: "" + labels[idx]
      };
    })
  }));
  chartView.append(pieChart);
}
function drawSection(section, idx) {
  var CIRCLE_CENTER = CIRCLE_SIZE / 2;
  var pathValue = describeArc(CIRCLE_CENTER, CIRCLE_CENTER, CIRCLE_CENTER - 2, section.startAngle, section.endAngle) + " L" + CIRCLE_CENTER + "," + CIRCLE_CENTER + " Z";
  return createSvgElement({
    type: SVG.PATH,
    props: {
      d: pathValue,
      className: [SECTION_CLASS_NAME, SECTION_CLASS_NAME + "_" + idx]
    }
  });
}
function createSections(totalValue, series, labels, sections) {
  if (sections === void 0) {
    sections = [];
  }
  if (series.length === sections.length) return sections;
  var idx = sections.length;
  var serie = series[idx];
  var startAngle = idx === 0 ? 0 : sections[idx - 1].endAngle;
  var endAngle = Math.min(startAngle + serie * 360 / totalValue, 360);
  var label = labels[idx];
  return createSections(totalValue, series, labels, [].concat(sections, [{
    startAngle: startAngle,
    endAngle: endAngle,
    label: label
  }]));
}

function hasImages(labels) {
  if (labels === void 0) {
    labels = [];
  }
  return labels.find(function (item) {
    return typeof item === 'string' && item.indexOf('<img ') > -1;
  });
}

var maxRange = 11;
var minRange = 5;
function getVerticalDivisions(_ref) {
  var chartType = _ref.chartType,
    series = _ref.series,
    low = _ref.low,
    onlyInteger = _ref.onlyInteger;
  var values = getValuesFromData({
    chartType: chartType,
    series: series,
    low: low
  });
  var _getLimits = getLimits({
      values: values,
      low: low
    }),
    min = _getLimits.min,
    max = _getLimits.max;
  var difference = max - min;
  return difference > minRange ? getNextHighestCommonDenominator({
    min: min,
    max: max,
    maxRange: maxRange,
    minRange: minRange
  }) : getDecimalSerie({
    min: min,
    max: max,
    onlyInteger: onlyInteger
  });
}
function getDecimalSerie(_ref2) {
  var min = _ref2.min,
    max = _ref2.max,
    onlyInteger = _ref2.onlyInteger;
  if (onlyInteger) return getRange({
    min: min,
    max: max,
    denominator: max
  });
  var multiplier = getNextIntHigherThan5(max - min);
  var initialList = getNextHighestCommonDenominator({
    min: min * multiplier,
    max: max * multiplier,
    maxRange: 7,
    minRange: 4
  });
  return initialList.map(function (value) {
    return value / multiplier;
  });
}
function getRange(_ref3) {
  var min = _ref3.min,
    max = _ref3.max,
    denominator = _ref3.denominator;
  var difference = max - min;
  var increment = difference / denominator;
  var result = [];
  for (var i = 0; i <= denominator; i++) {
    result.push(i * increment + min);
  }
  return result;
}
function getHighestCommonDenominator(_ref4) {
  var min = _ref4.min,
    max = _ref4.max,
    maxRange = _ref4.maxRange,
    minRange = _ref4.minRange;
  var difference = max - min;
  if (difference % maxRange === 0) {
    return getRange({
      min: min,
      max: max,
      denominator: maxRange
    });
  }
  if (maxRange < minRange) return null;
  return getHighestCommonDenominator({
    min: min,
    max: max,
    minRange: minRange,
    maxRange: maxRange - 1
  });
}
function getNextHighestCommonDenominator(_ref5) {
  var min = _ref5.min,
    max = _ref5.max,
    maxRange = _ref5.maxRange,
    minRange = _ref5.minRange;
  var denominator = getHighestCommonDenominator({
    min: min,
    max: max,
    maxRange: maxRange,
    minRange: minRange
  });
  if (denominator !== null) return denominator;
  return getNextHighestCommonDenominator({
    min: min,
    max: max + 1,
    maxRange: maxRange,
    minRange: minRange
  });
}
function getValuesFromData(_ref6) {
  var chartType = _ref6.chartType,
    series = _ref6.series;
  if (chartType === HISTOGRAMS || chartType === BAR_CHART_SINGLE_GROUP) {
    return series[0];
  }
  return series.reduce(function (acc, next) {
    return [].concat(acc, next.data);
  }, []);
}
function getLimits(_ref7) {
  var values = _ref7.values,
    low = _ref7.low;
  return values.reduce(function (acc, next) {
    if (acc.min === undefined && acc.max === undefined) {
      return {
        min: next,
        max: next
      };
    }
    return {
      min: Math.min(acc.min, next),
      max: Math.max(acc.max, next)
    };
  }, {
    min: low,
    max: low
  });
}
function getNextIntHigherThan5(original) {
  var higher = original;
  var multiplier = 1;
  while (higher < 5) {
    multiplier = multiplier * 10;
    higher = original * multiplier;
  }
  return multiplier;
}

function getSVG(className) {
  var element = document.createElementNS(SVGNS$2, 'svg');
  element.classList.add(className);
  element.setAttributeNS(null, 'width', CHART_WIDTH);
  element.setAttributeNS(null, 'height', CHART_HEIGHT);
  return element;
}

function getVerticalLine(xPos) {
  return createSvgElement({
    type: SVG.LINE,
    props: {
      className: LINE_CLASS_NAME,
      x1: xPos + "%",
      x2: xPos + "%",
      y1: '0',
      y2: "" + CANVAS_HEIGHT
    }
  });
}

var WRAPPER_CLASS_NAME$2 = 'lemo-vertical-lines';
function createHorizontalDivisions(_ref) {
  var labels = _ref.labels,
    chartType = _ref.chartType;
  var group = createSvgElement({
    type: SVG.SVG,
    props: {
      className: WRAPPER_CLASS_NAME$2,
      x: "" + LEFT_VALUES_WIDTH
    }
  });
  return when()["case"](chartType === HISTOGRAMS, function () {
    group.append(getVerticalLine(0));
    return group;
  })["case"](labels, function () {
    return createMultipleDivisions({
      group: group,
      labels: labels,
      chartType: chartType
    });
  }).resolve(function () {
    return createSingleDivision(group);
  });
}
function createSingleDivision(group) {
  group.append(getVerticalLine(90));
  group.append(getVerticalLine(0));
  return group;
}
function createMultipleDivisions(_ref2) {
  var group = _ref2.group,
    labels = _ref2.labels,
    chartType = _ref2.chartType;
  var columnWidth = 90 / labels.length;
  labels.forEach(function (label, idx) {
    group.append(getVerticalLine(columnWidth * idx));
    group.append(getXLabel({
      label: label,
      columnWidth: columnWidth,
      idx: idx
    }));
  });
  group.append(getVerticalLine(columnWidth * labels.length));
  if (chartType === LINE_CHART) {
    var linesSelection = group.querySelectorAll("." + LINE_CLASS_NAME);
    linesSelection.forEach(function (line, idx) {
      if (idx > 0) {
        line.style.transform = "translate(-" + columnWidth / 2 + "%)";
      }
    });
  }
  return group;
}
function getXLabel(_ref3) {
  var label = _ref3.label,
    columnWidth = _ref3.columnWidth,
    idx = _ref3.idx;
  var xPos = idx * columnWidth;
  var element = createSvgElement({
    type: SVG.FOREIGN_OBJECT,
    props: {
      width: columnWidth + "%",
      height: '20',
      x: xPos + "%",
      y: "" + (CANVAS_HEIGHT + 5)
    }
  });
  element.innerHTML = "<span class=\"lemo-input-chart-label\">" + label + "</span>";
  return element;
}

var WRAPPER_CLASS_NAME$3 = 'lemo-horizontal-lines';
function createVerticalDivisions(labels) {
  var rowHeight = CANVAS_HEIGHT / labels.length;
  var group = createSvgElement({
    type: SVG.SVG,
    props: {
      className: WRAPPER_CLASS_NAME$3,
      x: "" + LEFT_VALUES_WIDTH
    }
  });
  labels.forEach(function (label, idx) {
    group.append(getHorizontalLine({
      rowHeight: rowHeight,
      idx: idx
    }));
  });
  return group;
}
function getHorizontalLine(_ref) {
  var rowHeight = _ref.rowHeight,
    idx = _ref.idx,
    y = _ref.y;
  var yPos = y || rowHeight * (idx + 1);
  var element = createSvgElement({
    type: SVG.LINE,
    props: {
      className: LINE_CLASS_NAME,
      x1: '0',
      x2: '90%',
      y1: "" + yPos,
      y2: "" + yPos
    }
  });
  return element;
}

var WRAPPER_CLASS_NAME$4 = 'lemo-y-labels';
function createYLabels(labels) {
  var group = createSvgElement({
    type: SVG.SVG,
    props: {
      className: WRAPPER_CLASS_NAME$4
    }
  });
  var rowHeight = CANVAS_HEIGHT / labels.length;
  labels.reverse().forEach(function (label, idx) {
    group.append(getYLabel({
      label: label,
      rowHeight: rowHeight,
      idx: idx
    }));
  });
  return group;
}
function getYLabel(_ref) {
  var label = _ref.label,
    rowHeight = _ref.rowHeight,
    idx = _ref.idx;
  var yPos = idx * rowHeight + 16;
  var element = createSvgElement({
    type: 'foreignObject',
    props: {
      width: "" + (LEFT_VALUES_WIDTH - 5),
      height: "" + rowHeight,
      y: "" + yPos,
      x: '0'
    }
  });
  element.innerHTML = "<span class=\"lemo-input-chart-label lemo-vertical\">" + label + "</span>";
  return element;
}

function createChartCanvas(_ref) {
  var horizontalLabels = _ref.horizontalLabels,
    verticalLabels = _ref.verticalLabels,
    chartType = _ref.chartType;
  var element = getSVG('lemo-input-chart-canvas');
  element.append(createVerticalDivisions(verticalLabels));
  element.append(createYLabels(verticalLabels));
  element.append(createHorizontalDivisions({
    labels: horizontalLabels,
    chartType: chartType
  }));
  return element;
}

function normalizeYValue(_ref) {
  var verticalLabels = _ref.verticalLabels,
    value = _ref.value;
  var lowerValue = verticalLabels[verticalLabels.length - 1];
  var maxValue = verticalLabels[0] - lowerValue;
  var verticalDivisionHeight = 100 / verticalLabels.length;
  var canvasHeight = 100 - verticalDivisionHeight;
  return (value - lowerValue) * canvasHeight / maxValue;
}

var WRAPPER_CLASS_NAME$5 = 'lemo-line-chart';
var LINE_WRAPPER_CLASS_NAME = 'lemo-line-chart-line';
function createLineChart(_ref) {
  var series = _ref.series,
    verticalLabels = _ref.verticalLabels;
  var linesData = series.map(function (line, idx) {
    return {
      index: idx,
      value: line.data.map(function (value) {
        return normalizeYValue({
          verticalLabels: verticalLabels,
          value: value
        });
      })
    };
  });
  var columnWidth = 100 / linesData[0].value.length;
  var group = document.createElement('div');
  group.classList.add(WRAPPER_CLASS_NAME$5);
  linesData.forEach(function (lineData, idx) {
    group.append(createLineWrapper({
      lineData: lineData,
      columnWidth: columnWidth,
      idx: idx
    }));
  });
  return group;
}
function createLineWrapper(_ref2) {
  var lineData = _ref2.lineData,
    columnWidth = _ref2.columnWidth;
  var dotsLength = lineData.value.length;
  var lineWrapper = createSvgElement({
    type: SVG.SVG,
    props: {
      className: [LINE_WRAPPER_CLASS_NAME, LINE_WRAPPER_CLASS_NAME + "_" + lineData.index],
      height: "" + CANVAS_HEIGHT
    }
  });
  lineWrapper.style.left = columnWidth / 2 + "%";
  lineData.value.forEach(function (value, idx) {
    if (idx < dotsLength - 1) {
      var nextValue = lineData.value[idx + 1];
      lineWrapper.append(createSvgElement({
        type: SVG.LINE,
        props: {
          x1: columnWidth * idx + "%",
          x2: columnWidth * (idx + 1) + "%",
          y1: 100 - value + "%",
          y2: 100 - nextValue + "%"
        }
      }));
    }
    lineWrapper.append(createSvgElement({
      type: SVG.CIRCLE,
      props: {
        cx: columnWidth * idx + "%",
        cy: 100 - value + "%",
        r: '6'
      }
    }));
  });
  return lineWrapper;
}

function getNormalizedBarData(_ref) {
  var chartType = _ref.chartType,
    series = _ref.series,
    verticalLabels = _ref.verticalLabels;
  if (chartType === BAR_CHART_MULTIPLE_COLUMNS) {
    return formatMultipleColumns({
      series: series,
      verticalLabels: verticalLabels
    });
  }
  if (chartType === BAR_CHART_SINGLE_COLUMN) {
    return formatSingleColumn({
      series: series,
      verticalLabels: verticalLabels
    });
  }
  if (chartType === BAR_CHART_SINGLE_GROUP) {
    return formatSingleGroup({
      series: series,
      verticalLabels: verticalLabels
    });
  }
  if (chartType === HISTOGRAMS) {
    return formatSingleGroup({
      series: series,
      verticalLabels: verticalLabels
    });
  }
}
function formatMultipleColumns(_ref2) {
  var series = _ref2.series,
    verticalLabels = _ref2.verticalLabels;
  var data = series.map(function (_ref3) {
    var data = _ref3.data;
    return data;
  });
  var groupNames = series.map(function (_ref4) {
    var name = _ref4.name;
    return name;
  });
  return data[0].map(function (_, idx) {
    return data.map(function (group, groupIdx) {
      return {
        index: groupIdx,
        name: groupNames[groupIdx],
        value: normalizeYValue({
          verticalLabels: verticalLabels,
          value: group[idx]
        })
      };
    });
  });
}
function formatSingleColumn(_ref5) {
  var series = _ref5.series,
    verticalLabels = _ref5.verticalLabels;
  return [series.map(function (value, idx) {
    return {
      index: idx,
      name: value.name,
      value: normalizeYValue({
        verticalLabels: verticalLabels,
        value: value.data[0]
      })
    };
  })];
}
function formatSingleGroup(_ref6) {
  var series = _ref6.series,
    verticalLabels = _ref6.verticalLabels;
  return series[0].map(function (value, idx) {
    return [{
      index: idx,
      value: normalizeYValue({
        verticalLabels: verticalLabels,
        value: value
      })
    }];
  });
}

var WRAPPER_CLASS_NAME$6 = 'lemo-bar-group-list';
function createBarChart(_ref) {
  var chartType = _ref.chartType,
    series = _ref.series,
    verticalLabels = _ref.verticalLabels,
    colors = _ref.colors;
  console.log('createBarChart', {
    chartType: chartType,
    series: series,
    verticalLabels: verticalLabels,
    colors: colors
  });
  var barGroups = getNormalizedBarData({
    chartType: chartType,
    series: series,
    verticalLabels: verticalLabels
  });
  var groupsLength = barGroups.length;
  var hasColors = colors && colors.length === groupsLength;
  var columnWidth = 100 / barGroups.length;
  var group = document.createElement('div');
  group.classList.add(WRAPPER_CLASS_NAME$6, chartType.toLowerCase());
  barGroups.forEach(function (barGroup, idx) {
    group.append(renderBarGroup({
      barGroup: barGroup,
      columnWidth: columnWidth,
      colors: hasColors ? colors : null,
      groupsLength: groupsLength,
      groupIndex: idx,
      xPos: columnWidth * idx
    }));
  });
  return group;
}
function renderBarGroup(_ref2) {
  var barGroup = _ref2.barGroup,
    columnWidth = _ref2.columnWidth,
    xPos = _ref2.xPos,
    colors = _ref2.colors,
    groupIndex = _ref2.groupIndex,
    groupsLength = _ref2.groupsLength;
  var groupWidth = barGroup.length * (BAR_WIDTH + BAR_MARGIN) - BAR_MARGIN;
  var leftShift = (100 - groupWidth) / 2;
  var getBarPosition = function getBarPosition(barIdx) {
    return (BAR_WIDTH + BAR_MARGIN) * barIdx + leftShift;
  };
  var group = createSvgElement({
    type: SVG.SVG,
    props: {
      classList: ['lemo-bar-group'],
      x: xPos + leftShift + "%",
      width: columnWidth + "%",
      height: "" + CANVAS_HEIGHT
    }
  });
  var getBarColor = function getBarColor(barIdx) {
    if (!colors) return '';
    if (groupsLength > 0) return colors[groupIndex];
    if (groupsLength === 0) return colors[barIdx];
  };
  barGroup.forEach(function (bar, idx) {
    group.append(renderBar({
      bar: bar,
      xPos: getBarPosition(idx),
      currentColor: getBarColor(idx)
    }));
  });
  return group;
}
function renderBar(_ref3) {
  var bar = _ref3.bar,
    xPos = _ref3.xPos,
    currentColor = _ref3.currentColor;
  console.log('currentColor', currentColor);
  var BAR_CLASS_NAME = 'lemo-bar';
  var BAR_CLASS_COLOR_NAME = BAR_CLASS_NAME + "_" + bar.index;
  var style = currentColor ? "fill: " + currentColor + ";" : '';
  var element = createSvgElement({
    type: SVG.RECT,
    props: {
      x: xPos + "%",
      y: 100 - bar.value + "%",
      width: BAR_WIDTH + "%",
      height: bar.value + "%",
      style: style
    }
  });
  element.classList.add(BAR_CLASS_NAME, BAR_CLASS_COLOR_NAME);
  return element;
}

function getChartType(_ref) {
  var _series$, _series$$data, _series$2, _series$2$data;
  var type = _ref.type,
    series = _ref.series;
  var isBarchart = type === 'bar';
  var isSingleGroup = Array.isArray(series === null || series === void 0 ? void 0 : series[0]);
  var isSingleColumn = (series === null || series === void 0 ? void 0 : (_series$ = series[0]) === null || _series$ === void 0 ? void 0 : (_series$$data = _series$.data) === null || _series$$data === void 0 ? void 0 : _series$$data.length) === 1;
  var isMultipleColumns = (series === null || series === void 0 ? void 0 : (_series$2 = series[0]) === null || _series$2 === void 0 ? void 0 : (_series$2$data = _series$2.data) === null || _series$2$data === void 0 ? void 0 : _series$2$data.length) > 1;
  if (type === 'line') return LINE_CHART;
  if (type === 'histograms') return HISTOGRAMS;
  if (isBarchart && isSingleGroup) return BAR_CHART_SINGLE_GROUP;
  if (isBarchart && isSingleColumn) return BAR_CHART_SINGLE_COLUMN;
  if (isBarchart && isMultipleColumns) return BAR_CHART_MULTIPLE_COLUMNS;
  return UNKNOWN_BARCHART;
}

var COLOR_THEMES = ['theme-light-orange', 'theme-dark-orange', 'theme-light-blue', 'theme-dark-blue', 'theme-turquoise', 'theme-violet', 'theme-bordeaux', 'theme-green'];
var getRandomColorTheme = function getRandomColorTheme() {
  return COLOR_THEMES[Math.floor(Math.random() * COLOR_THEMES.length)];
};
var getRandomColorThemeList = function getRandomColorThemeList(numColors) {
  return pickColor(numColors, COLOR_THEMES);
};
function pickColor(numColors, colorList, result) {
  if (result === void 0) {
    result = [];
  }
  if (result.length === numColors) return result;
  var index = Math.floor(Math.random() * colorList.length);
  result.push(colorList[index]);
  return pickColor(numColors, rmItem(index, colorList), result);
}

var WRAPPER_CLASS_NAME$7 = 'lemo-histogram-bar-group-list';
function createHistogramsChart(_ref) {
  var chartType = _ref.chartType,
    series = _ref.series,
    verticalLabels = _ref.verticalLabels,
    labels = _ref.labels;
  var barGroups = getNormalizedBarData({
    chartType: chartType,
    series: series,
    verticalLabels: verticalLabels
  });
  var columnWidth = HISTOGRAM_COLUMNS_WIDTH;
  var group = createSvgElement({
    type: SVG.SVG,
    props: {
      width: '100%',
      height: CANVAS_HEIGHT
    }
  });
  group.style.maxWidth = CANVAS_WIDTH + "px";
  group.classList.add(WRAPPER_CLASS_NAME$7);
  var startX = (100 - columnWidth * barGroups.length) / 2;
  var fill = "var(--lemo-" + getRandomColorTheme() + "-out)";
  barGroups.forEach(function (items, idx) {
    group.append(renderBar$1({
      fill: fill,
      startX: startX,
      bar: items[0],
      xPos: columnWidth * idx
    }));
  });
  createHistogramsXlabels({
    group: group,
    labels: labels
  });
  return group;
}
function renderBar$1(_ref2) {
  var bar = _ref2.bar,
    xPos = _ref2.xPos,
    startX = _ref2.startX,
    fill = _ref2.fill;
  var BAR_CLASS_NAME = 'lemo-bar';
  var style = "fill: " + fill + ";";
  var element = createSvgElement({
    type: SVG.RECT,
    props: {
      x: xPos + startX + "%",
      y: 100 - bar.value - 0.2 + "%",
      width: HISTOGRAM_COLUMNS_WIDTH - 0.5 + "%",
      height: bar.value + "%",
      rx: '5',
      ry: '5',
      style: style
    }
  });
  element.classList.add(BAR_CLASS_NAME);
  return element;
}
function createHistogramsXlabels(_ref3) {
  var group = _ref3.group,
    labels = _ref3.labels;
  var labelsWidth = labels.length * HISTOGRAM_COLUMNS_WIDTH;
  var labelGroup = createSvgElement({
    type: SVG.G,
    props: {
      className: 'lemo-histogram-label-group'
    }
  });
  labelGroup.style.transform = "translateX(" + (100 - labelsWidth) / 2 + "%)";
  labels.forEach(function (label, idx) {
    var xPos = HISTOGRAM_COLUMNS_WIDTH * idx;
    var xLinePos = xPos + HISTOGRAM_COLUMNS_WIDTH / 2;
    var textElement = createSvgElement({
      type: SVG.FOREIGN_OBJECT,
      props: {
        width: HISTOGRAM_COLUMNS_WIDTH + "%",
        height: '30',
        x: xPos + "%",
        y: "" + (CANVAS_HEIGHT + 10)
      }
    });
    var line = createSvgElement({
      type: SVG.LINE,
      props: {
        className: LINE_LABEL_CLASS_NAME,
        x1: xLinePos + "%",
        x2: xLinePos + "%",
        y1: "" + (CANVAS_HEIGHT + 12),
        y2: "" + CANVAS_HEIGHT
      }
    });
    textElement.innerHTML = "<span class=\"lemo-input-chart-label\">" + label + "</span>";
    labelGroup.append(textElement);
    labelGroup.append(line);
  });
  group.append(labelGroup);
  return group;
}

var CHART_VIEW_WITH_IMAGES_CLASS_NAME = 'lemo-input-chart-view-with-images';
var CHART_WRAPPER_CLASS_NAME = 'lemo-input-chart-wrapper';
function renderCoordinateAxisChart(_ref) {
  var _options$axisY;
  var target = _ref.target,
    type = _ref.type,
    series = _ref.series,
    labels = _ref.labels,
    options = _ref.options,
    chartView = _ref.chartView,
    colors = _ref.colors;
  var low = (options === null || options === void 0 ? void 0 : options.low) || 0;
  var onlyInteger = (options === null || options === void 0 ? void 0 : (_options$axisY = options.axisY) === null || _options$axisY === void 0 ? void 0 : _options$axisY.onlyInteger) || false;
  hasImages(labels) && chartView.classList.add(CHART_VIEW_WITH_IMAGES_CLASS_NAME);
  var chartWrapper = document.createElement('div');
  var chartType = getChartType({
    type: type,
    series: series
  });
  if (chartType === UNKNOWN_BARCHART) {
    return target.innerHTML = '<p>unknow barchart data</p>';
  }
  chartWrapper.classList.add(CHART_WRAPPER_CLASS_NAME, chartType.toLowerCase());
  var verticalLabels = getVerticalDivisions({
    chartType: chartType,
    series: series,
    low: low,
    onlyInteger: onlyInteger
  });
  chartView.append(createLegend({
    chartType: chartType,
    series: series
  }));
  chartView.append(chartWrapper);
  chartWrapper.append(createChartCanvas({
    verticalLabels: verticalLabels,
    chartType: chartType,
    horizontalLabels: labels
  }));
  chartWrapper.append(when()["case"](chartType === LINE_CHART, function () {
    return createLineChart({
      series: series,
      verticalLabels: verticalLabels,
      low: low
    });
  })["case"](chartType === HISTOGRAMS, function () {
    return createHistogramsChart({
      chartType: chartType,
      series: series,
      verticalLabels: verticalLabels,
      labels: labels
    });
  }).resolve(function () {
    return createBarChart({
      chartType: chartType,
      series: series,
      verticalLabels: verticalLabels,
      colors: colors
    });
  }));
}

var CHART_VIEW_CLASS_NAME = 'lemo-input-chart-view';
function renderChart(_ref) {
  var target = _ref.target,
    type = _ref.type,
    series = _ref.series,
    labels = _ref.labels,
    options = _ref.options,
    xAxisName = _ref.xAxisName,
    yAxisName = _ref.yAxisName,
    colors = _ref.colors;
  target.innerHTML = '';
  var chartView = document.createElement('div');
  chartView.classList.add(CHART_VIEW_CLASS_NAME);
  if (type === 'pie') {
    createPieChart({
      series: series,
      labels: labels,
      chartView: chartView
    });
  } else {
    renderCoordinateAxisChart({
      target: target,
      type: type,
      series: series,
      labels: labels,
      options: options,
      chartView: chartView,
      xAxisName: xAxisName,
      yAxisName: yAxisName,
      colors: colors
    });
  }
  target.append(chartView);
}

function renderPictograph(target, chartData) {
  return target.innerHTML = "\n    <div class=\"lemo-pictograph-view\">\n        " + renderColumns(chartData) + "\n    </div>";
}
function renderColumns(_ref) {
  var series = _ref.series,
    labels = _ref.labels;
  return series.map(function (serie, idx) {
    var label = (labels === null || labels === void 0 ? void 0 : labels[idx]) || '';
    var value = serie.value,
      img = serie.img;
    return "<div class=\"lemo-pictograph__column\">\n        " + renderColumnContent({
      value: value,
      img: img,
      label: label
    }) + "\n        <span class=\"lemo-pictograph__column-label-size\">" + label + "</span>\n        <span class=\"lemo-pictograph__column-label\">" + label + "</span>\n      </div>";
  }).join('');
}
function renderColumnContent(_ref2) {
  var value = _ref2.value,
    img = _ref2.img,
    label = _ref2.label;
  function iterateContent(current, result) {
    if (result === void 0) {
      result = '';
    }
    return current === 0 ? result : iterateContent(current - 1, result += renderContent({
      img: img,
      label: label
    }));
  }
  return iterateContent(parseInt(value));
}
function renderContent(_ref3) {
  var img = _ref3.img,
    label = _ref3.label;
  return "\n    <div class=\"lemo-pictograph__content\">\n      <img src=\"" + img + "\" alt=\"" + label + "\"/>\n    </div>\n  ";
}

var CHARTS_CLASS = '.fr-chart';
function useCharts(rootElement, rules) {
  if (rules === void 0) {
    rules = [];
  }
  useEffect(function () {
    var _rootElement$current;
    if (!config.chartsEnable) return;
    var chartElements = rootElement === null || rootElement === void 0 ? void 0 : (_rootElement$current = rootElement.current) === null || _rootElement$current === void 0 ? void 0 : _rootElement$current.querySelectorAll(CHARTS_CLASS);
    if (!chartElements) return false;
    for (var _iterator = _createForOfIteratorHelperLoose(chartElements), _step; !(_step = _iterator()).done;) {
      var element = _step.value;
      var dataChart = null;
      try {
        dataChart = JSON.parse(element.dataset.chart);
      } catch (err) {
        element.innerHTML = '<span style="color: red">Invalid data chart</span>';
      }
      if (!dataChart) return false;
      if (dataChart.type === 'pictograph') {
        renderPictograph(element, dataChart);
        return;
      }
      renderChart({
        target: element,
        type: dataChart.type,
        series: dataChart.series,
        labels: dataChart.labels,
        options: dataChart.options,
        colors: dataChart.colors
      });
    }
  }, rules);
}

function getBaseHTML() {
  var element = document.createElement('div');
  element.classList.add('fractional-shape');
  return element;
}

function getSVG$1(size, className) {
  var element = document.createElementNS(SVGNS, 'svg');
  element.setAttributeNS(null, 'viewBox', "0 0 " + size + " " + size);
  className && element.classList.add(className);
  return element;
}

function repeat(times, fn) {
  var index = 0;
  while (index < times) {
    fn(index);
    index++;
  }
}

var getValue = function getValue(v) {
  return typeof v === 'string' ? v : v + "%";
};

function createLine(_ref) {
  var x1 = _ref.x1,
    x2 = _ref.x2,
    y1 = _ref.y1,
    y2 = _ref.y2;
  var element = document.createElementNS(SVGNS, 'line');
  element.setAttributeNS(null, 'x1', getValue(x1));
  element.setAttributeNS(null, 'x2', getValue(x2));
  element.setAttributeNS(null, 'y1', getValue(y1));
  element.setAttributeNS(null, 'y2', getValue(y2));
  element.classList.add(LINE_CLASS);
  return element;
}

function fillShape(_ref) {
  var fill = _ref.fill,
    svg = _ref.svg;
  var nodeList = svg.querySelectorAll('.fractional-shape-slice');
  nodeList.forEach(function (node, idx) {
    return idx < fill && node.classList.add('filled');
  });
}

function createCircle(_ref) {
  var divisions = _ref.divisions,
    fill = _ref.fill;
  var baseHTML = getBaseHTML();
  var svg = getSVG$1(300);
  baseHTML.append(svg);
  svg.append(drawCircle());
  repeat(divisions, function (idx) {
    svg.append(drawFill(idx, divisions));
  });
  if (divisions > 1) {
    repeat(divisions, function (idx) {
      var rotation = getRotation(idx, divisions);
      svg.append(drawLine(rotation));
    });
  }
  fillShape({
    fill: fill,
    svg: svg
  });
  return baseHTML;
}
function getRotation(idx, divisions) {
  return 360 / divisions * idx;
}
function drawCircle(isFeedbackBorder) {
  if (isFeedbackBorder === void 0) {
    isFeedbackBorder = false;
  }
  var className = isFeedbackBorder ? FEEDBACK_BORDER_CLASS : BACKGROUND_CLASS;
  var element = document.createElementNS(SVGNS, 'circle');
  element.setAttributeNS(null, 'r', '148px');
  element.setAttributeNS(null, 'cx', '50%');
  element.setAttributeNS(null, 'cy', '50%');
  element.classList.add(className);
  return element;
}
function drawFill(idx, divisions) {
  var arcLength = 360 / divisions;
  var endAngle = arcLength * (idx + 1);
  var startAngle = arcLength * idx;
  var pathValue = describeArc(150, 150, 148, startAngle, endAngle) + " L150,150 Z";
  var element = document.createElementNS(SVGNS, 'path');
  element.setAttributeNS(null, 'd', pathValue);
  element.classList.add('fractional-shape-slice');
  return element;
}
function drawLine(rotation) {
  var element = createLine({
    x1: 50,
    y1: '2px',
    x2: 50,
    y2: 50
  });
  element.style.transformOrigin = '150px 150px';
  element.style.transform = "rotate(" + rotation + "deg)";
  return element;
}

function createRect(_ref) {
  var width = _ref.width,
    height = _ref.height,
    x = _ref.x,
    y = _ref.y,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? SLICE_CLASS : _ref$className;
  var element = document.createElementNS(SVGNS, 'rect');
  element.setAttributeNS(null, 'width', getValue(width));
  element.setAttributeNS(null, 'height', getValue(height));
  element.setAttributeNS(null, 'x', getValue(x));
  element.setAttributeNS(null, 'y', getValue(y));
  element.classList.add(className);
  return element;
}

function createRectangle(_ref) {
  var divisions = _ref.divisions,
    fill = _ref.fill;
  var isPair = divisions % 2 === 0;
  var baseHTML = getBaseHTML();
  var svg = createSvgElement({
    type: SVG.SVG,
    props: {
      viewBox: '0 0 300 200'
    }
  });
  var getSlice = isPair ? drawPairSlice : drawOddSlice;
  var verticalLinesLength = isPair ? divisions / 2 : divisions;
  var background = createRect({
    width: 100,
    height: 90,
    x: 0,
    y: 5,
    className: BACKGROUND_CLASS
  });
  svg.appendChild(background);
  repeat(divisions, function (idx) {
    svg.appendChild(getSlice(idx, divisions));
  });
  repeat(verticalLinesLength, function (idx) {
    if (idx < verticalLinesLength - 1) svg.appendChild(getVerticalLine$1(idx, verticalLinesLength));
  });
  isPair && svg.appendChild(getHorizontalLine$1());
  fillShape({
    fill: fill,
    svg: svg
  });
  baseHTML.append(svg);
  return baseHTML;
}
function drawPairSlice(idx, divisions) {
  var itemsPerRow = divisions / 2;
  var width = 100 / itemsPerRow;
  var height = 45;
  var y = idx + 1 > itemsPerRow ? 50 : 5;
  var x = idx + 1 > itemsPerRow ? width * (idx - itemsPerRow) : width * idx;
  return createRect({
    width: width,
    height: height,
    x: x,
    y: y
  });
}
function drawOddSlice(idx, divisions) {
  var width = 100 / divisions;
  var height = 90;
  var y = 5;
  var x = width * idx;
  return createRect({
    width: width,
    height: height,
    x: x,
    y: y
  });
}
function getVerticalLine$1(idx, length) {
  var sliceWidth = 100 / length;
  var x = (idx + 1) * sliceWidth;
  return createLine({
    x1: x,
    x2: x,
    y1: 5,
    y2: 95
  });
}
function getHorizontalLine$1() {
  return createLine({
    x1: 0,
    x2: 100,
    y1: 50,
    y2: 50
  });
}

function createQuad(_ref) {
  var divisions = _ref.divisions,
    fill = _ref.fill;
  var baseHTML = getBaseHTML();
  var shape = function () {
    if (divisions < 3) return getQuadWith2Divisions();
    if (divisions < 5) return getQuadWith4Divisions();
    return getQuadWith8Divisions();
  }();
  var svg = getSVG$1(300);
  svg.innerHTML = shape;
  fillShape({
    fill: fill,
    svg: svg
  });
  baseHTML.append(svg);
  return baseHTML;
}
function getQuadWith2Divisions() {
  return "\n      <rect class=\"fractional-shape-background\" x=\"20\" y=\"20\" width=\"260\" height=\"260\"/>\n      <path class=\"fractional-shape-slice\" d=\"M280,280l0,-260l-260,0l260,260Z\"/>\n      <path class=\"fractional-shape-slice\" d=\"M20,280l-0,-260l260,260l-260,-0Z\"/>\n      <path class=\"fractional-shape-division\" d=\"M20,20l260,260\"/>\n  ";
}
function getQuadWith4Divisions() {
  return "\n      <rect class=\"fractional-shape-background\" x=\"20\" y=\"20\" width=\"260\" height=\"260\"/>\n      <path class=\"fractional-shape-slice\" d=\"M20,20l260,-0l-130,130l-130,-130Z\"/>\n      <path class=\"fractional-shape-slice\" d=\"M280,280l0,-260l-130,130l130,130Z\"/>\n      <path class=\"fractional-shape-slice\" d=\"M20,280l260,0l-130,-130l-130,130Z\"/>\n      <path class=\"fractional-shape-slice\" d=\"M20,280l-0,-260l130,130l-130,130Z\"/>\n      <path class=\"fractional-shape-division\" d=\"M20,20l260,260\"/>\n      <path class=\"fractional-shape-division\" d=\"M280,20l-260,260\"/>\n  ";
}
function getQuadWith8Divisions() {
  return "\n    <rect class=\"fractional-shape-background\" x=\"20\" y=\"20\" width=\"260\" height=\"260\"/>\n    <path class=\"fractional-shape-slice\" d=\"M150,20l130,0l-130,130l0,-130Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M280,150l0,-130l-130,130l130,0Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M280,280l0,-130l-130,0l130,130Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M150,280l130,0l-130,-130l-0,130Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M20,280l130,0l0,-130l-130,130Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M20,280l0,-130l130,0l-130,130Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M20,150l0,-130l130,130l-130,0Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M20,20l130,0l0,130l-130,-130Z\" />\n    <path class=\"fractional-shape-division\" d=\"M20,20l260,260\" />\n    <path class=\"fractional-shape-division\" d=\"M150,20l-0,260\" />\n    <path class=\"fractional-shape-division\" d=\"M280,150l-260,-0\" />\n    <path class=\"fractional-shape-division\" d=\"M280,20l-260,260\" />\n  ";
}

function createTriangle(_ref) {
  var fill = _ref.fill;
  var baseHTML = getBaseHTML();
  var svg = getSVG$1(300);
  svg.innerHTML = getTriangle();
  fillShape({
    fill: fill,
    svg: svg
  });
  baseHTML.append(svg);
  return baseHTML;
}
function getTriangle() {
  return "\n    <path class=\"fractional-shape-background\" d=\"M150,18l143.76,249l-287.52,0l143.76,-249Z\"/>\n    <path class=\"fractional-shape-slice\" d=\"M150,18l0,249l-143.76,0l143.76,-249Z\"/>\n    <path class=\"fractional-shape-slice\" d=\"M150,18l-0,249l143.76,0l-143.76,-249Z\"/>\n    <path class=\"fractional-shape-division\" d=\"M150,267l0,-249\"/>\n  ";
}

function createPentagon(_ref) {
  var divisions = _ref.divisions,
    fill = _ref.fill;
  var shape = divisions < 6 ? getPentagonWith5Divisions() : getPentagonWith10Divisions();
  var baseHTML = getBaseHTML();
  var svg = getSVG$1(300);
  svg.innerHTML = shape;
  fillShape({
    fill: fill,
    svg: svg
  });
  baseHTML.append(svg);
  return baseHTML;
}
function getPentagonWith5Divisions() {
  return "\n    <path class=\"fractional-shape-background\" d=\"M150,14l142.658,103.647l-54.49,167.706l-176.336,0l-54.49,-167.706l142.658,-103.647Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M292.658,117.647l-142.522,45.978l-0.136,-149.622l142.658,103.644Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M238.168,285.353l-88.032,-121.728l142.522,-45.978l-54.49,167.706Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M61.832,285.353l88.304,-121.728l88.032,121.728l-176.336,0Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M61.832,285.353l88.304,-121.728l-142.794,-45.978l54.49,167.706Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M7.342,117.647l142.794,45.978l-0.133,-149.625l-142.661,103.647Z\" />\n    <path class=\"fractional-shape-division\" d=\"M150,14l0,150\" />\n    <path class=\"fractional-shape-division\" d=\"M292.658,117.647l-142.658,46.353\"/>\n    <path class=\"fractional-shape-division\" d=\"M238.168,285.353l-88.168,-121.353\" />\n    <path class=\"fractional-shape-division\" d=\"M61.832,285.353l88.168,-121.353\" />\n    <path class=\"fractional-shape-division\" d=\"M7.342,117.647l142.658,46.353\" />\n  ";
}
function getPentagonWith10Divisions() {
  return "\n    <path class=\"fractional-shape-background\" d=\"M150,14l142.658,103.647l-54.49,167.706l-176.336,0l-54.49,-167.706l142.658,-103.647Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M221.329,65.966l-71.193,97.659l-0.136,-149.622l71.329,51.963Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M292.658,117.647l-142.522,45.978l71.261,-97.752l71.261,51.774Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M265.413,201.5l-115.277,-37.875l142.522,-45.978l-27.245,83.853Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M238.168,285.353l-88.032,-121.728l115.277,37.875l-27.245,83.853Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M150,285.728l0.136,-122.103l88.032,121.728l-88.168,0.375Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M61.832,285.353l88.304,-121.728l-0.136,121.728l-88.168,0Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M61.832,285.353l88.304,-121.728l-115.549,37.875l27.245,83.853Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M34.587,201.5l115.549,-37.875l-142.794,-45.978l27.245,83.853Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M7.342,117.647l142.794,45.978l-71.397,-97.752l-71.397,51.774Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M78.739,65.873l71.397,97.752l-0.133,-149.625l-71.264,51.873Z\" />\n    <path class=\"fractional-shape-division\" d=\"M150,14l0,150\" />\n    <path class=\"fractional-shape-division\" d=\"M221.329,65.966l-71.329,98.034\" />\n    <path class=\"fractional-shape-division\" d=\"M265.413,201.5l-115.413,-37.5\" />\n    <path class=\"fractional-shape-division\" d=\"M150,285.353l0,-121.353\" />\n    <path class=\"fractional-shape-division\" d=\"M34.587,201.5l115.413,-37.5\" />\n    <path class=\"fractional-shape-division\" d=\"M292.658,117.647l-142.658,46.353\" />\n    <path class=\"fractional-shape-division\" d=\"M238.168,285.353l-88.168,-121.353\" />\n    <path class=\"fractional-shape-division\" d=\"M61.832,285.353l88.168,-121.353\" />\n    <path class=\"fractional-shape-division\" d=\"M7.342,117.647l142.658,46.353\" />\n    <path class=\"fractional-shape-division\" d=\"M78.739,65.873l71.261,98.127\" />\n  ";
}

function createHexagon(_ref) {
  var divisions = _ref.divisions,
    fill = _ref.fill;
  var shape = divisions < 7 ? getHexagonWith6Divisions() : getHexagonWith12Divisions();
  var baseHTML = getBaseHTML();
  var svg = getSVG$1(300);
  svg.innerHTML = shape;
  fillShape({
    fill: fill,
    svg: svg
  });
  baseHTML.append(svg);
  return baseHTML;
}
function getHexagonWith6Divisions() {
  return "\n    <path class=\"fractional-shape-background\" d=\"M149.738,8l122.975,71l0,142l-122.975,71l-122.976,-71l0,-142l122.976,-71Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M272.713,79l-122.975,70.993l0,-141.993l122.975,71Z\"/>\n    <path class=\"fractional-shape-slice\" d=\"M272.713,220.983l-122.975,-70.99l122.975,-70.993l0,141.983Z\"/>\n    <path class=\"fractional-shape-slice\" d=\"M149.738,292l-0,-142.007l122.975,71.007l-122.975,71Z\"/>\n    <path class=\"fractional-shape-slice\" d=\"M26.762,221l122.976,-71.007l0,142.007l-122.976,-71Z\"/>\n    <path class=\"fractional-shape-slice\" d=\"M26.762,79l122.976,70.993l-122.976,71.007l0,-142Z\"/>\n    <path class=\"fractional-shape-slice\" d=\"M149.738,8l0,141.993l-122.97,-70.996l122.97,-70.997Z\" />\n    <path class=\"fractional-shape-division\" d=\"M149.738,8l-0,142\" />\n    <path class=\"fractional-shape-division\" d=\"M272.713,79l-122.975,71\" />\n    <path class=\"fractional-shape-division\" d=\"M272.683,220.983l-122.945,-70.983\" />\n    <path class=\"fractional-shape-division\" d=\"M149.738,292l-0,-142\" />\n    <path class=\"fractional-shape-division\" d=\"M26.762,221l122.976,-71\" />\n    <path class=\"fractional-shape-division\" d=\"M26.774,79l122.964,71\" />\n  ";
}
function getHexagonWith12Divisions() {
  return "\n    <path class=\"fractional-shape-background\" d=\"M149.738,8l122.975,71l0,142l-122.975,71l-122.976,-71l0,-142l122.976,-71Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M211.211,43.526l-61.473,106.467l0,-141.993l61.472,35.526Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M272.713,79l-122.975,70.993l61.488,-106.493l61.487,35.5Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M272.683,149.992l-122.945,0.001l122.975,-70.993l-0.03,70.992Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M272.713,220.983l-122.975,-70.99l122.945,0.007l0.03,70.983Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M211.211,256.509l-61.473,-106.516l122.975,71.007l-61.503,35.509Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M149.738,292l0,-142.007l61.488,106.507l-61.488,35.5Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M88.256,256.49l61.482,-106.497l0,142.007l-61.482,-35.51Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M26.762,221l122.976,-71.007l-61.488,106.507l-61.488,-35.5Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M26.774,150l122.964,-0.007l-122.976,71.007l0.012,-71Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M26.762,79l122.976,70.993l-122.964,0.007l-0.012,-71Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M88.256,43.497l61.482,106.496l-122.97,-70.996l61.488,-35.5Z\" />\n    <path class=\"fractional-shape-slice\" d=\"M149.738,8l0,141.993l-61.488,-106.493l61.488,-35.5Z\" />\n    <path class=\"fractional-shape-division\" d=\"M149.738,8l0,142\" />\n    <path class=\"fractional-shape-division\" d=\"M211.211,43.526l-61.473,106.474\" />\n    <path class=\"fractional-shape-division\" d=\"M272.683,150l-122.945,0\" />\n    <path class=\"fractional-shape-division\" d=\"M211.198,256.516l-61.46,-106.516\" />\n    <path class=\"fractional-shape-division\" d=\"M88.25,256.516l61.488,-106.516\" />\n    <path class=\"fractional-shape-division\" d=\"M26.774,150l122.964,0\" />\n    <path class=\"fractional-shape-division\" d=\"M88.205,43.526l61.533,106.474\" />\n    <path class=\"fractional-shape-division\" d=\"M272.713,79l-122.975,71\" />\n    <path class=\"fractional-shape-division\" d=\"M272.683,220.983l-122.945,-70.983\" />\n    <path class=\"fractional-shape-division\" d=\"M149.738,292l0,-142\" />\n    <path class=\"fractional-shape-division\" d=\"M26.762,221l122.976,-71\" />\n    <path class=\"fractional-shape-division\" d=\"M26.774,79l122.964,71\" />\n  ";
}

function createTenths(_ref) {
  var fill = _ref.fill;
  var divisions = 10;
  var baseHTML = getBaseHTML();
  var svg = createSvgElement({
    type: SVG.SVG,
    props: {
      className: FIX_BORDERS_CLASS,
      viewBox: '0 0 300 50'
    }
  });
  var background = createRect({
    width: 100,
    height: 60,
    x: 0,
    y: 25,
    className: BACKGROUND_CLASS
  });
  svg.appendChild(background);
  repeat(divisions, function (idx) {
    svg.appendChild(getSlice(idx, divisions));
  });
  repeat(divisions, function (idx) {
    if (idx < divisions - 1) svg.appendChild(getVerticalLine$2(idx, divisions));
  });
  fillShape({
    fill: fill,
    svg: svg
  });
  baseHTML.append(svg);
  return baseHTML;
}
function getSlice(idx, divisions) {
  var width = divisions;
  var height = 60;
  var y = 25;
  var x = width * idx;
  return createRect({
    width: width,
    height: height,
    x: x,
    y: y
  });
}
function getVerticalLine$2(idx, divisions) {
  var x = (idx + 1) * divisions;
  return createLine({
    x1: x,
    x2: x,
    y1: 25,
    y2: 86
  });
}

function createHundredths(_ref) {
  var fill = _ref.fill;
  var divisions = 100;
  var linesLength = 10;
  var sliceSize = 10;
  var baseHTML = getBaseHTML();
  var svg = getSVG$1(300, FIX_BORDERS_CLASS);
  var background = createRect({
    width: 100,
    height: 100,
    x: 0,
    y: 0,
    className: BACKGROUND_CLASS
  });
  svg.appendChild(background);
  repeat(divisions, function (idx) {
    svg.appendChild(getSlice$1(idx, sliceSize, linesLength));
  });
  repeat(linesLength, function (idx) {
    if (idx + 1 >= linesLength) return false;
    svg.appendChild(getVerticalLine$3(idx, linesLength));
    svg.appendChild(getHorizontalLine$2(idx, linesLength));
  });
  fillShape({
    fill: fill,
    svg: svg
  });
  baseHTML.append(svg);
  return baseHTML;
}
function getSlice$1(idx, sliceSize, linesLength) {
  var width = sliceSize;
  var height = sliceSize;
  var y = Math.floor(idx / 10) * linesLength;
  var x = idx % 10 * sliceSize;
  return createRect({
    width: width,
    height: height,
    x: x,
    y: y
  });
}
function getVerticalLine$3(idx, linesLength) {
  var x = (idx + 1) * linesLength;
  return createLine({
    x1: x,
    x2: x,
    y1: 0,
    y2: 100
  });
}
function getHorizontalLine$2(idx, linesLength) {
  var y = (idx + 1) * linesLength;
  return createLine({
    x1: 0,
    x2: 100,
    y1: y,
    y2: y
  });
}

function renderFractionalShape(target, shapeProps) {
  var shape = createShape(shapeProps);
  target.firstChild ? target.replaceChild(shape, target.firstChild) : target.appendChild(shape);
}
function getShape(type, divisions) {
  var shapeType = getShapeType(type.toUpperCase(), parseInt(divisions));
  if (shapeType === CIRCLE) return createCircle;
  if (shapeType === QUAD) return createQuad;
  if (shapeType === RECTANGLE) return createRectangle;
  if (shapeType === TRIANGLE) return createTriangle;
  if (shapeType === PENTAGON) return createPentagon;
  if (shapeType === HEXAGON) return createHexagon;
  if (shapeType === TENTHS) return createTenths;
  if (shapeType === HUNDREDTHS) return createHundredths;
  throw new Error("the shape doesn't exist");
}
function getRandomItem(list) {
  var len = list.length;
  return list[secureRandomInt(0, len - 1)];
}
function getShapeType(shapeType, divisions) {
  if (shapeType !== RANDOM) return shapeType;
  if (divisions === 2) return getRandomItem([CIRCLE, QUAD, TRIANGLE, RECTANGLE]);
  if (divisions === 3) return getRandomItem([CIRCLE, RECTANGLE]);
  if (divisions === 4) return getRandomItem([CIRCLE, QUAD, RECTANGLE]);
  if (divisions === 5) return getRandomItem([CIRCLE, PENTAGON, RECTANGLE]);
  if (divisions === 6) return getRandomItem([CIRCLE, HEXAGON, RECTANGLE]);
  if (divisions === 7) return getRandomItem([CIRCLE, RECTANGLE]);
  if (divisions === 8) return getRandomItem([CIRCLE, RECTANGLE, QUAD]);
  if (divisions === 9) return getRandomItem([CIRCLE, RECTANGLE]);
  if (divisions === 10) return getRandomItem([CIRCLE, RECTANGLE, PENTAGON]);
  if (divisions === 11) return getRandomItem([CIRCLE, RECTANGLE]);
  if (divisions === 12) return getRandomItem([CIRCLE, RECTANGLE, HEXAGON]);
  return CIRCLE;
}
function createShape(_ref) {
  var type = _ref.type,
    divisions = _ref.divisions,
    fill = _ref.fill;
  return getShape(type, divisions)({
    divisions: divisions,
    fill: fill
  });
}

var FRACTIONAL_SHAPES_CLASS = '.fr-fractional-shape';
function useFractionalShapes(rootElement, rules) {
  if (rules === void 0) {
    rules = [];
  }
  useEffect(function () {
    if (config.chartsEnable) {
      var _rootElement$current;
      var fractionalShapeElements = rootElement === null || rootElement === void 0 ? void 0 : (_rootElement$current = rootElement.current) === null || _rootElement$current === void 0 ? void 0 : _rootElement$current.querySelectorAll(FRACTIONAL_SHAPES_CLASS);
      if (fractionalShapeElements) {
        for (var _iterator = _createForOfIteratorHelperLoose(fractionalShapeElements), _step; !(_step = _iterator()).done;) {
          var element = _step.value;
          var data = null;
          try {
            data = JSON.parse(element.dataset.fraction);
          } catch (err) {
            element.innerHTML = '<span style="color: red">Invalid fraction data</span>';
          }
          if (data) {
            renderFractionalShape(element, data);
          }
        }
      }
    }
  }, rules);
}

var SVGNS$3 = 'http://www.w3.org/2000/svg';
var NUMBER_LINES_CLASS_NAME = 'lemo-number-line-view';
var DRAW_WIDTH = '100%';
var DRAW_HEIGHT = '60px';
var DRAW_HIGH_HEIGHT = '120px';

function getSVG$2(highCanvas) {
  if (highCanvas === void 0) {
    highCanvas = false;
  }
  var element = document.createElementNS(SVGNS$3, 'svg');
  element.classList.add(NUMBER_LINES_CLASS_NAME);
  element.setAttributeNS(null, 'width', DRAW_WIDTH);
  element.setAttributeNS(null, 'height', highCanvas ? DRAW_HIGH_HEIGHT : DRAW_HEIGHT);
  return element;
}

function drawBaseLine() {
  var element = document.createElementNS(SVGNS$3, 'line');
  element.setAttributeNS(null, 'x1', '0%');
  element.setAttributeNS(null, 'x2', '100%');
  element.setAttributeNS(null, 'y1', '15px');
  element.setAttributeNS(null, 'y2', '15px');
  return element;
}

function drawDivisions(_ref) {
  var min = _ref.min,
    divisions = _ref.divisions,
    distance = _ref.distance,
    mode = _ref.mode,
    denominator = _ref.denominator;
  var group = document.createElementNS(SVGNS$3, 'g');
  var lineWidth = 92;
  var initialPos = 4;
  repeat(divisions, function (i) {
    var xPos = i * (lineWidth / (divisions - 1)) + initialPos;
    group.appendChild(drawVerticalLine({
      xPos: xPos
    }));
    var value = min + distance * i;
    mode === 'FRACTION' ? group.appendChild(drawFraction({
      xPos: xPos,
      value: value,
      denominator: denominator
    })) : group.appendChild(drawNumber({
      xPos: xPos,
      value: value
    }));
    var divisionGroup = document.createElementNS(SVGNS$3, 'g');
    divisionGroup.classList.add('number-line-division');
    divisionGroup.appendChild(drawVerticalLine({
      xPos: xPos
    }));
    divisionGroup.appendChild(drawNumber({
      xPos: xPos,
      value: value
    }));
    group.appendChild(divisionGroup);
  });
  return group;
}
function drawVerticalLine(_ref2) {
  var xPos = _ref2.xPos;
  var element = document.createElementNS(SVGNS$3, 'line');
  element.setAttributeNS(null, 'x1', xPos + "%");
  element.setAttributeNS(null, 'x2', xPos + "%");
  element.setAttributeNS(null, 'y1', '0');
  element.setAttributeNS(null, 'y2', '30px');
  return element;
}
function createNumber(_ref3) {
  var x = _ref3.x,
    y = _ref3.y,
    value = _ref3.value;
  var element = document.createElementNS(SVGNS$3, 'text');
  element.setAttributeNS(null, 'x', x + "%");
  element.setAttributeNS(null, 'y', y + "px");
  element.textContent = value;
  return element;
}
function drawNumber(_ref4) {
  var xPos = _ref4.xPos,
    value = _ref4.value;
  return createNumber({
    x: xPos,
    y: 58,
    value: value
  });
}
function drawFractionLine(_ref5) {
  var values = _ref5.values,
    xPos = _ref5.xPos;
  var characterSize = 12;
  var yPos = 62;
  var maxLength = values.reduce(function (acc, next) {
    var len = next.toString().length;
    return Math.max(acc, len);
  }, 0);
  var lineWidth = maxLength * characterSize;
  var element = document.createElementNS(SVGNS$3, 'rect');
  element.setAttributeNS(null, 'x', xPos + "%");
  element.setAttributeNS(null, 'y', yPos + "px");
  element.setAttributeNS(null, 'width', lineWidth + "px");
  element.setAttributeNS(null, 'height', '1px');
  element.style.transform = "translateX(-" + lineWidth / 2 + "px)";
  return element;
}
function drawFraction(_ref6) {
  var xPos = _ref6.xPos,
    value = _ref6.value,
    denominator = _ref6.denominator;
  var group = document.createElementNS(SVGNS$3, 'g');
  group.appendChild(createNumber({
    x: xPos,
    y: 58,
    value: value
  }));
  group.appendChild(createNumber({
    x: xPos,
    y: 80,
    value: denominator
  }));
  group.appendChild(drawFractionLine({
    values: [value, denominator],
    xPos: xPos
  }));
  return group;
}

function renderNumberLineView(target, props) {
  var distance = props.distance,
    divisions = props.divisions,
    min = props.min,
    denominator = props.denominator,
    _props$mode = props.mode,
    mode = _props$mode === void 0 ? 'INTEGER' : _props$mode;
  var svg = getSVG$2(mode === 'FRACTION');
  svg.append(drawBaseLine());
  svg.append(drawDivisions({
    min: min,
    divisions: divisions,
    distance: distance,
    mode: mode,
    denominator: denominator
  }));
  target.firstChild ? target.replaceChild(svg, target.firstChild) : target.appendChild(svg);
  svg.querySelectorAll('text').forEach(function (text) {
    var fixedPosition = text.getBBox().width / 2;
    text.style.transform = "translateX(-" + fixedPosition + "px)";
  });
  var getSelection = function getSelection() {
    return svg.querySelectorAll('.number-line-division');
  };
  var setDivisionClass = function setDivisionClass(indexes, className) {
    var selection = getSelection();
    indexes.forEach(function (index) {
      if (!Array.isArray(index) && index >= 0) {
        selection[index].classList.add(className);
      }
    });
  };
  function select(indexes) {
    setDivisionClass(indexes, 'lemo-selected');
  }
  function fixValue(indexes, selectedPos) {
    setDivisionClass(indexes, 'lemo-active');
    if (selectedPos !== undefined) {
      select([selectedPos]);
    }
  }
  function clear() {
    getSelection().forEach(function (element) {
      element.classList.remove('lemo-selected', 'lemo-error', 'lemo-success', 'lemo-active');
    });
  }
  function showFeedback(_ref) {
    var success = _ref.success,
      error = _ref.error;
    clear();
    setDivisionClass(success, 'lemo-success');
    setDivisionClass(error, 'lemo-error');
  }
  return {
    select: select,
    fixValue: fixValue,
    clear: clear,
    showFeedback: showFeedback
  };
}

var NUMBER_LINE_SELECTOR = '.fr-number-line';
function useNumberLineView(rootElement, rules) {
  if (rules === void 0) {
    rules = [];
  }
  useEffect(function () {
    if (config.chartsEnable) {
      var _rootElement$current;
      var numberLineElements = rootElement === null || rootElement === void 0 ? void 0 : (_rootElement$current = rootElement.current) === null || _rootElement$current === void 0 ? void 0 : _rootElement$current.querySelectorAll(NUMBER_LINE_SELECTOR);
      if (numberLineElements) {
        for (var _iterator = _createForOfIteratorHelperLoose(numberLineElements), _step; !(_step = _iterator()).done;) {
          var element = _step.value;
          var data = null;
          try {
            data = JSON.parse(element.dataset.graphic);
          } catch (err) {
            element.innerHTML = '<span style="color: red">Invalid graphic data</span>';
          }
          if (data) {
            renderNumberLineView(element, data);
          }
        }
      }
    }
  }, rules);
}

var SVGNS$4 = 'http://www.w3.org/2000/svg';
var ANGLES_CLASS_NAME = 'lemo-angle-view';
var DRAW_SIZE = 300;
var VERTICAL_PADDING = 6;
var DRAW_HEIGHT$1 = DRAW_SIZE / 2 + VERTICAL_PADDING;
var ORIGIN = {
  x: DRAW_SIZE / 2,
  y: DRAW_HEIGHT$1 - 3
};

function getSVG$3() {
  var element = document.createElementNS(SVGNS$4, 'svg');
  element.classList.add(ANGLES_CLASS_NAME);
  element.setAttributeNS(null, 'width', DRAW_SIZE);
  element.setAttributeNS(null, 'height', DRAW_HEIGHT$1);
  return element;
}

function drawLine$1(rotation) {
  var element = document.createElementNS(SVGNS$4, 'line');
  element.setAttributeNS(null, 'x1', "" + ORIGIN.x);
  element.setAttributeNS(null, 'x2', "" + DRAW_SIZE);
  element.setAttributeNS(null, 'y1', "" + ORIGIN.y);
  element.setAttributeNS(null, 'y2', "" + ORIGIN.y);
  element.setAttributeNS(null, 'transform-origin', ORIGIN.x + " " + ORIGIN.y);
  element.setAttributeNS(null, 'style', "transform: rotate(-" + rotation + "deg)");
  return element;
}

function isTouchDevice() {
  return typeof window.ontouchstart !== 'undefined';
}

function dragElement(target, onStart) {
  if (onStart === void 0) {
    onStart = noop;
  }
  var isTouch = isTouchDevice();
  var eventMove = isTouch ? 'touchmove' : 'mousemove';
  var eventUp = isTouch ? 'touchend' : 'mouseup';
  var pos1 = 0;
  var pos2 = 0;
  var pos3 = 0;
  var pos4 = 0;
  isTouch ? target.addEventListener('touchstart', onStartDrag, false) : target.addEventListener('mousedown', onStartDrag, false);
  function onStartDrag(e) {
    e = e || window.event;
    e.preventDefault();
    pos3 = getEventTarget(e).clientX;
    pos4 = getEventTarget(e).clientY;
    document.addEventListener(eventUp, onEndDrag, false);
    document.addEventListener(eventMove, onDragMove, false);
    onStart();
    return false;
  }
  function onDragMove(e) {
    e = e || window.event;
    !isTouch && e.preventDefault();
    pos1 = pos3 - getEventTarget(e).clientX;
    pos2 = pos4 - getEventTarget(e).clientY;
    pos3 = getEventTarget(e).clientX;
    pos4 = getEventTarget(e).clientY;
    target.style.top = target.offsetTop - pos2 + 'px';
    target.style.left = target.offsetLeft - pos1 + 'px';
    return false;
  }
  function onEndDrag() {
    document.removeEventListener(eventUp, onEndDrag);
    document.removeEventListener(eventMove, onDragMove);
  }
  function getEventTarget(e) {
    return e.touches ? e.touches[0] : e;
  }
}

var isTouch = isTouchDevice();
var clickEvent = isTouch ? 'touchstart' : 'click';
var protractorImg = 'https://lemonade-assets.oneclick.es/protractor.png';
function createShowProtractorButton(target) {
  var template = "\n  <button class=\"lemo-protractor-show-tool-button\">\n    <span class=\"lemo-protractor-show-tool-button-text\">Usar transportador</span>\n    <svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M4.10753 11.0058L5.87503 12.7733L7.05336 11.595L5.28669 9.82749L7.05336 8.05999L9.41086 10.4167L10.5892 9.23832L8.23336 6.88082L10 5.11332L11.7675 6.88082L12.9467 5.70248L11.1784 3.93498L13.5359 1.57748C13.6921 1.42126 13.9041 1.3335 14.125 1.3335C14.346 1.3335 14.5579 1.42126 14.7142 1.57748L18.8392 5.70248C18.9954 5.85876 19.0832 6.07068 19.0832 6.29165C19.0832 6.51262 18.9954 6.72454 18.8392 6.88082L6.46419 19.2558C6.30792 19.412 6.096 19.4998 5.87503 19.4998C5.65406 19.4998 5.44213 19.412 5.28586 19.2558L1.16086 15.1308C1.00463 14.9745 0.91687 14.7626 0.91687 14.5417C0.91687 14.3207 1.00463 14.1088 1.16086 13.9525L4.10753 11.0058Z\"/>\n    </svg>\n  </button>\n  ";
  var questionNode = findQuestionNode(target);
  target.insertAdjacentHTML('beforeend', template);
  var showToolButton = target.querySelector('.lemo-protractor-show-tool-button');
  showToolButton.addEventListener(clickEvent, function () {
    return showProtractor(questionNode);
  });
}
function showProtractor(target) {
  console.log(target);
  var protractorInstance = target.querySelector('.lemo-protractor');
  var showToolButton = target.querySelector('.lemo-protractor-show-tool-button');
  if (protractorInstance) {
    removeProtractor({
      target: target,
      protractorInstance: protractorInstance,
      showToolButton: showToolButton
    });
  } else {
    createProtractor({
      target: target,
      showToolButton: showToolButton
    });
  }
}
function createProtractor(_ref) {
  var target = _ref.target,
    showToolButton = _ref.showToolButton;
  var protractorInstance = document.createElement('div');
  protractorInstance.classList.add('lemo-protractor');
  protractorInstance.style.left = target.offsetLeft + target.offsetWidth / 2 - 200 + "px";
  protractorInstance.style.top = target.offsetTop + 60 + "px";
  createProtractorCloseButton(protractorInstance, function () {
    return removeProtractor({
      target: target,
      protractorInstance: protractorInstance,
      showToolButton: showToolButton
    });
  });
  createProtractorImage(protractorInstance);
  createDragIcon(protractorInstance);
  target.append(protractorInstance);
  var removeDragAnimation = function removeDragAnimation() {
    var dragButton = protractorInstance.querySelector('.lemo-protractor-drag-icon');
    dragButton.classList.add('lemo-stop-headShake');
  };
  dragElement(protractorInstance, removeDragAnimation);
  showToolButton.classList.add('lemo-protractor-show-tool-button-active');
}
function createDragIcon(protractorInstance) {
  var template = "\n    <div class=\"lemo-protractor-drag-icon lemo-headShake\">\n      <svg viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path d=\"M9.16671 15.0002C9.16671 15.9168 8.41671 16.6668 7.50004 16.6668C6.58337 16.6668 5.83337 15.9168 5.83337 15.0002C5.83337 14.0835 6.58337 13.3335 7.50004 13.3335C8.41671 13.3335 9.16671 14.0835 9.16671 15.0002ZM7.50004 8.3335C6.58337 8.3335 5.83337 9.0835 5.83337 10.0002C5.83337 10.9168 6.58337 11.6668 7.50004 11.6668C8.41671 11.6668 9.16671 10.9168 9.16671 10.0002C9.16671 9.0835 8.41671 8.3335 7.50004 8.3335ZM7.50004 3.3335C6.58337 3.3335 5.83337 4.0835 5.83337 5.00016C5.83337 5.91683 6.58337 6.66683 7.50004 6.66683C8.41671 6.66683 9.16671 5.91683 9.16671 5.00016C9.16671 4.0835 8.41671 3.3335 7.50004 3.3335ZM12.5 6.66683C13.4167 6.66683 14.1667 5.91683 14.1667 5.00016C14.1667 4.0835 13.4167 3.3335 12.5 3.3335C11.5834 3.3335 10.8334 4.0835 10.8334 5.00016C10.8334 5.91683 11.5834 6.66683 12.5 6.66683ZM12.5 8.3335C11.5834 8.3335 10.8334 9.0835 10.8334 10.0002C10.8334 10.9168 11.5834 11.6668 12.5 11.6668C13.4167 11.6668 14.1667 10.9168 14.1667 10.0002C14.1667 9.0835 13.4167 8.3335 12.5 8.3335ZM12.5 13.3335C11.5834 13.3335 10.8334 14.0835 10.8334 15.0002C10.8334 15.9168 11.5834 16.6668 12.5 16.6668C13.4167 16.6668 14.1667 15.9168 14.1667 15.0002C14.1667 14.0835 13.4167 13.3335 12.5 13.3335Z\"/>\n      </svg>\n    </div>\n  ";
  protractorInstance.insertAdjacentHTML('beforeend', template);
}
function removeProtractor(_ref2) {
  var target = _ref2.target,
    protractorInstance = _ref2.protractorInstance,
    showToolButton = _ref2.showToolButton;
  target.removeChild(protractorInstance);
  showToolButton.classList.remove('lemo-protractor-show-tool-button-active');
}
function createProtractorImage(target) {
  var template = "\n    <img class=\"lemo-protractor-img\" src=\"" + protractorImg + "\" alt=\"\"/>\n  ";
  target.insertAdjacentHTML('beforeend', template);
}
function createProtractorCloseButton(target, closeFN) {
  var element = document.createElement('button');
  element.classList.add('lemo-protractor-close-button');
  var template = "\n    <svg viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM8.707 7.293a1 1 0 0 0-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 1 0 1.414 1.414L10 11.414l1.293 1.293a1 1 0 0 0 1.414-1.414L11.414 10l1.293-1.293a1 1 0 0 0-1.414-1.414L10 8.586 8.707 7.293z\"/>\n    </svg>\n  ";
  element.insertAdjacentHTML('beforeend', template);
  element.addEventListener(clickEvent, closeFN);
  target.append(element);
}
function findQuestionNode(target) {
  if (target.classList.contains('lemo-question')) return target;
  if (target === document.body) return target;
  return findQuestionNode(target.parentNode);
}

var POSITIVE = 'POSITIVE';
var NEGATIVE = 'NEGATIVE';
function drawGroup(_sense) {
  var sense = _sense || shuffle([POSITIVE, NEGATIVE])[0];
  var element = document.createElementNS(SVGNS$4, 'g');
  element.style.transformOrigin = 'center';
  element.style.transform = "scaleX(" + (sense === POSITIVE ? 1 : -1) + ")";
  return element;
}

function renderAngles(target, props) {
  var angle = props.angle,
    sense = props.sense,
    withProtractor = props.withProtractor;
  var svg = getSVG$3();
  var group = drawGroup(sense);
  group.append(drawArc(angle));
  group.append(drawLine$1());
  group.append(drawLine$1(angle));
  svg.append(group);
  if (withProtractor) {
    target.classList.add('lemo-with-protractor');
    createShowProtractorButton(target);
  }
  target.firstChild ? target.replaceChild(svg, target.firstChild) : target.appendChild(svg);
}
function drawArc(angle) {
  var endAngle = 0;
  var startAngle = -angle;
  var pathValue = describeArc(ORIGIN.x, ORIGIN.y, DRAW_SIZE / 4, startAngle, endAngle) + " L" + ORIGIN.x + "," + ORIGIN.y + " Z";
  var element = document.createElementNS(SVGNS$4, 'path');
  element.setAttributeNS(null, 'd', pathValue);
  element.style.transformOrigin = ORIGIN.x + "px " + ORIGIN.y + "px";
  return element;
}

var SELECTOR = '.fr-angle';
function useAngleView(rootElement, rules) {
  if (rules === void 0) {
    rules = [];
  }
  useEffect(function () {
    var _rootElement$current;
    var angleElements = rootElement === null || rootElement === void 0 ? void 0 : (_rootElement$current = rootElement.current) === null || _rootElement$current === void 0 ? void 0 : _rootElement$current.querySelectorAll(SELECTOR);
    if (angleElements) {
      for (var _iterator = _createForOfIteratorHelperLoose(angleElements), _step; !(_step = _iterator()).done;) {
        var element = _step.value;
        var data = null;
        try {
          data = JSON.parse(element.dataset.angle);
        } catch (err) {
          element.innerHTML = '<span style="color: red">Invalid graphic data</span>';
        }
        if (data) {
          renderAngles(element, data);
        }
      }
    }
  }, rules);
}

var SVGNS$5 = 'http://www.w3.org/2000/svg';
var BOXPLOT_CLASS_NAME = 'lemo-boxplot-view';
var DRAW_WIDTH$1 = '100%';
var DRAW_HEIGHT$2 = 80;
var GRAPH_WIDTH = 98;
var DOT_Y = 40;
var QUAD_Y = 10;
var QUAD_H = 60;
var DOT_RADIUS = 5;
var BOXPLOT_DOT_CLASS_NAME = 'lemo-boxplot-view-dot';
var BOXPLOT_LINE_CLASS_NAME = 'lemo-boxplot-view-line';
var BOXPLOT_QUAD_CLASS_NAME = 'lemo-boxplot-view-quad';
var MARGIN_X = 4;

function getSVG$4() {
  var element = document.createElementNS(SVGNS$5, 'svg');
  element.classList.add(BOXPLOT_CLASS_NAME);
  element.setAttributeNS(null, 'width', DRAW_WIDTH$1);
  element.setAttributeNS(null, 'height', DRAW_HEIGHT$2);
  return element;
}

function drawDots(_ref) {
  var boxplot = _ref.boxplot,
    normalizePosition = _ref.normalizePosition;
  var dotsContainer = document.createElementNS(SVGNS$5, 'g');
  boxplot.forEach(function (position) {
    dotsContainer.append(drawDot(normalizePosition(position)));
  });
  return dotsContainer;
}
function drawDot(position) {
  var box = document.createElementNS(SVGNS$5, 'svg');
  box.setAttribute('x', position + "%");
  var element = document.createElementNS(SVGNS$5, 'circle');
  element.classList.add(BOXPLOT_DOT_CLASS_NAME);
  element.setAttribute('cx', DOT_RADIUS.toString());
  element.setAttribute('cy', DOT_Y.toString());
  element.setAttribute('r', DOT_RADIUS.toString());
  element.setAttribute('r', DOT_RADIUS.toString());
  element.setAttribute('transform', "translate(-" + DOT_RADIUS + ", 0)");
  box.append(element);
  return box;
}

function drawLines(_ref) {
  var boxplot = _ref.boxplot,
    normalizePosition = _ref.normalizePosition;
  var LinesContainer = document.createElementNS(SVGNS$5, 'g');
  LinesContainer.append(drawLine$2({
    x1: normalizePosition(boxplot[1]),
    x2: normalizePosition(boxplot[0]),
    y: DOT_Y
  }));
  LinesContainer.append(drawLine$2({
    x1: normalizePosition(boxplot[3]),
    x2: normalizePosition(boxplot[4]),
    y: DOT_Y
  }));
  return LinesContainer;
}
function drawLine$2(_ref2) {
  var x1 = _ref2.x1,
    x2 = _ref2.x2,
    y = _ref2.y;
  var element = document.createElementNS(SVGNS$5, 'line');
  element.classList.add(BOXPLOT_LINE_CLASS_NAME);
  element.setAttribute('x1', x1 + "%");
  element.setAttribute('x2', x2 + "%");
  element.setAttribute('y1', y.toString());
  element.setAttribute('y2', y.toString());
  return element;
}

function drawRects(_ref) {
  var boxplot = _ref.boxplot,
    normalizePosition = _ref.normalizePosition;
  var rectContainer = document.createElementNS(SVGNS$5, 'g');
  rectContainer.append(drawRect({
    x: normalizePosition(boxplot[1]),
    y: QUAD_Y,
    w: normalizePosition(boxplot[2]) - normalizePosition(boxplot[1]),
    h: QUAD_H
  }));
  rectContainer.append(drawRect({
    x: normalizePosition(boxplot[2]),
    y: QUAD_Y,
    w: normalizePosition(boxplot[3]) - normalizePosition(boxplot[2]),
    h: QUAD_H
  }));
  return rectContainer;
}
function drawRect(_ref2) {
  var x = _ref2.x,
    y = _ref2.y,
    w = _ref2.w,
    h = _ref2.h;
  var element = document.createElementNS(SVGNS$5, 'rect');
  element.classList.add(BOXPLOT_QUAD_CLASS_NAME);
  element.setAttribute('x', x + "%");
  element.setAttribute('y', y.toString());
  element.setAttribute('width', w + "%");
  element.setAttribute('height', h.toString());
  return element;
}

function renderBoxplot(target, props) {
  var min = props.min,
    max = props.max,
    boxplot = props.boxplot;
  var divisions = max - min + 1;
  var distanceBetweenSegments = GRAPH_WIDTH / divisions;
  var normalizePosition = function normalizePosition(position) {
    return (position - min) * distanceBetweenSegments + MARGIN_X;
  };
  var svg = getSVG$4();
  svg.append(drawDots({
    boxplot: boxplot,
    normalizePosition: normalizePosition
  }));
  svg.append(drawLines({
    boxplot: boxplot,
    normalizePosition: normalizePosition
  }));
  svg.append(drawRects({
    boxplot: boxplot,
    normalizePosition: normalizePosition
  }));
  target.innerhtml = '';
  renderNumberLineView(target, {
    min: min,
    divisions: divisions,
    distance: 1,
    mode: NUMBER
  });
  target.prepend(svg);
}

var SELECTOR$1 = '.fr-boxplot';
function useBoxplotView(rootElement, rules) {
  if (rules === void 0) {
    rules = [];
  }
  useEffect(function () {
    var _rootElement$current;
    var boxplotElements = rootElement === null || rootElement === void 0 ? void 0 : (_rootElement$current = rootElement.current) === null || _rootElement$current === void 0 ? void 0 : _rootElement$current.querySelectorAll(SELECTOR$1);
    if (boxplotElements) {
      for (var _iterator = _createForOfIteratorHelperLoose(boxplotElements), _step; !(_step = _iterator()).done;) {
        var element = _step.value;
        var data = null;
        try {
          data = JSON.parse(element.dataset.boxplot);
        } catch (err) {
          element.innerHTML = '<span style="color: red">Invalid graphic data</span>';
        }
        if (data) {
          renderBoxplot(element, data);
        }
      }
    }
  }, rules);
}

var MAIN_CONTAINER_CLASSNAME = 'lemo-function-view-container';
var TEXT_CLASSNAME = 'lemo-plane-text';
var TEXT_VERTICAL_CLASSNAME = 'lemo-plane-text-vertical';
var TEXT_HORIZONTAL_CLASSNAME = 'lemo-plane-text-horizontal';
var TEXT_AXIS_CLASSNAME = 'lemo-plane-text-axis';
var FUNCTION_LINE_CONTAINER_CLASSNAME = 'lemo-function-line-container';
var FUNCTION_LINE_CLASSNAME = 'lemo-function-line';
var TEXT_SHOW_SMALL_DEVICES_CLASSNAME = 'lemo-show-small-devices';
var DIVISIONS = 20;
var COLOR_THEMES$1 = ['lemo-theme-dark-blue-over', 'lemo-theme-dark-orange-over', 'lemo-theme-violet-over', 'lemo-theme-bordeaux-over', 'lemo-theme-green-over'];

var positiveNumbers = populate(10, function (i) {
  return i + 1;
});
var negativeNumbers = positiveNumbers.map(function (i) {
  return -i;
});
var reverse = function reverse(arr) {
  return arr.slice().reverse();
};
var empty = '';
var yAxisNumbers = [].concat(reverse(positiveNumbers), [empty], negativeNumbers);
var xAxisNumbers = [].concat(reverse(negativeNumbers), [empty], positiveNumbers);
function drawPlane(_ref) {
  var size = _ref.size,
    divisions = _ref.divisions,
    cellSize = _ref.cellSize;
  var plane = createSvgElement({
    type: SVG.SVG,
    props: {
      className: ['lemo-function-view-plane'],
      width: '100%',
      height: '100%',
      viewBox: "0 0 " + size + " " + size
    }
  });
  plane.append(drawPlaneLines({
    size: size,
    cellSize: cellSize,
    divisions: divisions
  }));
  plane.append(drawPlaneNumbers({
    size: size,
    cellSize: cellSize,
    divisions: divisions
  }));
  plane.append(drawPlaneAxis({
    size: size,
    cellSize: cellSize,
    divisions: divisions
  }));
  return plane;
}
function drawPlaneLines(_ref2) {
  var size = _ref2.size,
    cellSize = _ref2.cellSize,
    divisions = _ref2.divisions;
  var container = createSvgElement({
    type: SVG.G
  });
  for (var i = 0; i < divisions + 1; i++) {
    var isMiddleLine = i === divisions / 2;
    var className = ['lemo-plane-line', isMiddleLine && 'lemo-plane-line-middle'];
    container.append(createSvgElement({
      type: SVG.LINE,
      props: {
        className: className,
        x1: 0,
        x2: size,
        y1: i * cellSize,
        y2: i * cellSize
      }
    }));
    container.append(createSvgElement({
      type: SVG.LINE,
      props: {
        className: className,
        x1: i * cellSize,
        x2: i * cellSize,
        y1: 0,
        y2: size
      }
    }));
  }
  return container;
}
function drawPlaneNumbers(_ref3) {
  var size = _ref3.size,
    cellSize = _ref3.cellSize,
    divisions = _ref3.divisions;
  var centerPosition = size / 2;
  var container = createSvgElement({
    type: SVG.G
  });
  var getClassList = function getClassList(idx) {
    return [TEXT_CLASSNAME].concat(idx % 5 === 0 ? [TEXT_SHOW_SMALL_DEVICES_CLASSNAME] : []);
  };
  for (var i = 0; i < divisions + 1; i++) {
    var verticalText = createSvgElement({
      type: SVG.TEXT,
      props: {
        className: getClassList(i).concat(TEXT_VERTICAL_CLASSNAME),
        'text-anchor': 'end',
        x: centerPosition,
        y: i * cellSize
      }
    });
    verticalText.innerHTML = yAxisNumbers[i].toString();
    container.append(verticalText);
    var horizontalText = createSvgElement({
      type: SVG.TEXT,
      props: {
        className: getClassList(i).concat(TEXT_HORIZONTAL_CLASSNAME),
        x: i * cellSize,
        y: centerPosition
      }
    });
    horizontalText.innerHTML = xAxisNumbers[i].toString();
    container.append(horizontalText);
  }
  return container;
}
function drawPlaneAxis(_ref4) {
  var size = _ref4.size;
  var centerPosition = size / 2;
  var container = createSvgElement({
    type: SVG.G
  });
  var xAxis = createSvgElement({
    type: SVG.TEXT,
    props: {
      className: [TEXT_CLASSNAME, TEXT_AXIS_CLASSNAME],
      'text-anchor': 'middle',
      x: centerPosition,
      y: -16
    }
  });
  xAxis.innerHTML = 'x';
  container.append(xAxis);
  var yAxis = createSvgElement({
    type: SVG.TEXT,
    props: {
      className: [TEXT_CLASSNAME, TEXT_AXIS_CLASSNAME],
      x: parseInt(size) + 20,
      y: centerPosition
    }
  });
  yAxis.innerHTML = 'y';
  container.append(yAxis);
  return container;
}

function renderFunctionView(element, data, size) {
  element.innerHTML = '';
  element.style.maxWidth = size + "px";
  element.style.maxHeight = size + "px";
  var container = document.createElement('div');
  container.className = MAIN_CONTAINER_CLASSNAME;
  var props = {
    cellSize: size / DIVISIONS,
    divisions: DIVISIONS,
    size: size,
    data: data
  };
  container.append(drawPlane(props));
  data.forEach(function (item, index) {
    var currentColor = COLOR_THEMES$1[index % COLOR_THEMES$1.length];
    container.append(drawFunction(_extends({}, props, {
      data: item,
      color: "var(--" + currentColor + ")"
    })));
  });
  element.append(container);
}
function drawFunction(_ref) {
  var size = _ref.size,
    cellSize = _ref.cellSize,
    divisions = _ref.divisions,
    data = _ref.data,
    color = _ref.color;
  var container = createSvgElement({
    type: SVG.SVG,
    props: {
      className: [FUNCTION_LINE_CONTAINER_CLASSNAME],
      width: '100%',
      height: '100%',
      viewBox: "0 0 " + size + " " + size
    }
  });
  if (data.length === 2) {
    drawLinearFunction(container, {
      size: size,
      cellSize: cellSize,
      divisions: divisions,
      data: data,
      color: color
    });
  } else if (data.length === 3) {
    drawQuadraticFunction(container, {
      size: size,
      cellSize: cellSize,
      divisions: divisions,
      data: data,
      color: color
    });
  } else {
    console.error('Formato de datos no válido');
  }
  return container;
}
function drawLinearFunction(container, _ref2) {
  var size = _ref2.size,
    cellSize = _ref2.cellSize,
    divisions = _ref2.divisions,
    data = _ref2.data,
    color = _ref2.color;
  var a = data[0],
    b = data[1];
  var points = [];
  var halfDivisions = divisions / 2;
  for (var i = -halfDivisions; i <= halfDivisions; i++) {
    var x = i;
    var y = a * x + b;
    points.push({
      x: x * cellSize + size / 2,
      y: size / 2 - y * cellSize
    });
  }
  var pathData = points.reduce(function (acc, point, index) {
    var command = index === 0 ? 'M' : 'L';
    return acc + " " + command + " " + point.x + " " + point.y;
  }, '');
  var path = createSvgElement({
    type: SVG.PATH,
    props: {
      className: FUNCTION_LINE_CLASSNAME,
      d: pathData,
      fill: 'none',
      style: "stroke: " + color + ";"
    }
  });
  container.append(path);
}
function drawQuadraticFunction(container, _ref3) {
  var size = _ref3.size,
    cellSize = _ref3.cellSize,
    divisions = _ref3.divisions,
    data = _ref3.data,
    color = _ref3.color;
  var a = data[0],
    b = data[1],
    c = data[2];
  var points = [];
  var halfDivisions = divisions / 2;
  var step = 0.1;
  for (var i = -halfDivisions; i <= halfDivisions; i += step) {
    var x = i;
    var y = a * x * x + b * x + c;
    points.push({
      x: x * cellSize + size / 2,
      y: size / 2 - y * cellSize
    });
  }
  var pathData = points.reduce(function (acc, point, index) {
    var command = index === 0 ? 'M' : 'L';
    return acc + " " + command + " " + point.x + " " + point.y;
  }, '');
  var path = createSvgElement({
    type: SVG.PATH,
    props: {
      className: FUNCTION_LINE_CLASSNAME,
      d: pathData,
      fill: 'none',
      style: "stroke: " + color + ";"
    }
  });
  container.append(path);
}

var FUNCTIONS_VIEW_CLASS = '.lemo-functions-view';
var DEFAULT_VIEW_SIZE = 550;
function useFunctionsView(rootElement, rules) {
  if (rules === void 0) {
    rules = [];
  }
  useEffect(function () {
    var _rootElement$current;
    var elementList = rootElement === null || rootElement === void 0 ? void 0 : (_rootElement$current = rootElement.current) === null || _rootElement$current === void 0 ? void 0 : _rootElement$current.querySelectorAll(FUNCTIONS_VIEW_CLASS);
    if (elementList) {
      for (var _iterator = _createForOfIteratorHelperLoose(elementList), _step; !(_step = _iterator()).done;) {
        var element = _step.value;
        var normalizedData = normalizeData(element.dataset["function"]);
        var data = JSON.parse(normalizedData);
        var size = element.dataset.size || DEFAULT_VIEW_SIZE;
        if (data && Array.isArray(data) && size) {
          var isBidimensional = data.every(function (item) {
            return Array.isArray(item);
          });
          var dataContent = isBidimensional ? data : [data];
          renderFunctionView(element, dataContent, size);
        }
      }
    }
  }, rules);
}
function normalizeData(data) {
  if (!data) return data;
  return data.replace(/−/g, '-');
}

function latexToMathJS(expression) {
  try {
    var normalized = expression.replace(/\\cos/g, 'cos').replace(/\\sin/g, 'sin').replace(/\\tan/g, 'tan').replace(/\\ln/g, 'log').replace(/\\sqrt\[(\d+)\]{([^{}]+)}/g, '($2)^(1/$1)').replace(/\\sqrt{([^{}]+)}/g, 'sqrt($1)').replace(/\\frac{([^{}]+)}{([^{}]+)}/g, '(($1)/($2))').replace(/\\left\(/g, '(').replace(/\\right\)/g, ')').replace(/÷/g, '/').replace(/×/g, '*').replace(/\\div/g, '/').replace(/\\times/g, '*').replace(/\\cdot/g, '*').replace(/\s/g, '');
    return normalized;
  } catch (e) {
    console.error('Error en normalizeLatexForMathJS:', e);
    return expression;
  }
}

function renderMathExpression(element, expressions, size) {
  if (size === void 0) {
    size = 600;
  }
  try {
    if (!Array.isArray(expressions)) {
      console.error('The expressions argument must be an array');
      return;
    }
    element.innerHTML = '';
    element.style.maxWidth = size + "px";
    element.style.maxHeight = size + "px";
    var container = document.createElement('div');
    container.className = MAIN_CONTAINER_CLASSNAME;
    var props = {
      cellSize: size / DIVISIONS,
      divisions: DIVISIONS,
      size: size
    };
    container.append(drawPlane(props));
    expressions.forEach(function (expression, index) {
      var currentColor = "var(--" + COLOR_THEMES$1[index % COLOR_THEMES$1.length] + ")";
      container.append(drawMathFunction({
        size: size,
        expression: expression,
        color: currentColor
      }));
    });
    element.append(container);
  } catch (error) {
    console.error('Error at renderMathExpression:', error);
  }
}
function drawMathFunction(_ref) {
  var size = _ref.size,
    expression = _ref.expression,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#ff0000' : _ref$color;
  var container = createSvgElement({
    type: SVG.SVG,
    props: {
      className: [FUNCTION_LINE_CONTAINER_CLASSNAME],
      width: '100%',
      height: '100%',
      viewBox: "0 0 " + size + " " + size,
      style: 'position: absolute; top: 0; left: 0; pointer-events: none;'
    }
  });
  try {
    var points = generatePoints(expression);
    if (points.length === 0) {
      console.warn('No points were generated for the function');
      return container;
    }
    var paths = splitPointsAtDiscontinuities(points);
    paths.forEach(function (pathPoints, index) {
      var svgPoints = pathPoints.map(function (point) {
        return toSVGCoordinates(point, size);
      });
      var pathData = svgPoints.reduce(function (acc, point, index) {
        var command = index === 0 ? 'M' : 'L';
        return acc + " " + command + " " + point.x + " " + point.y;
      }, '');
      var path = createSvgElement({
        type: SVG.PATH,
        props: {
          className: FUNCTION_LINE_CLASSNAME,
          d: pathData,
          stroke: color,
          fill: 'none',
          'stroke-width': '2',
          'vector-effect': 'non-scaling-stroke'
        }
      });
      container.append(path);
    });
  } catch (error) {
    console.error('Error drawing the function:', error);
  }
  return container;
}
function generatePoints(latexExpression) {
  try {
    var cleanExpression = latexExpression.replace(/^[a-zA-Z]\(x\)\s*=\s*/, '');
    var points = [];
    var mathExpr = latexToMathJS(cleanExpression);
    var code = compile(mathExpr);
    var range = [-10, 10];
    var step = 0.1;
    for (var x = range[0]; x <= range[1]; x += step) {
      try {
        var y = code.evaluate({
          x: x
        });
        if (isFinite(y)) {
          points.push({
            x: x,
            y: y
          });
        }
      } catch (error) {
        console.warn("Error evaluating x=" + x + ":", error);
      }
    }
    return points;
  } catch (error) {
    console.error('Error at generatePoints:', error);
    return [];
  }
}
function splitPointsAtDiscontinuities(points) {
  var paths = [];
  var currentPath = [];
  for (var i = 0; i < points.length; i++) {
    var point = points[i];
    var nextPoint = points[i + 1];
    currentPath.push(point);
    if (nextPoint) {
      var deltaY = Math.abs(nextPoint.y - point.y);
      var deltaX = Math.abs(nextPoint.x - point.x);
      if (deltaY > deltaX * 5 && deltaY > 20) {
        if (currentPath.length > 0) {
          paths.push(currentPath);
          currentPath = [];
        }
      }
    }
  }
  if (currentPath.length > 0) {
    paths.push(currentPath);
  }
  return paths;
}
function toSVGCoordinates(point, size) {
  var divisions = DIVISIONS;
  var cellSize = size / divisions;
  var centerDivision = divisions / 2;
  var gridX = centerDivision + point.x;
  var svgX = gridX * cellSize;
  var gridY = centerDivision - point.y;
  var svgY = gridY * cellSize;
  return {
    x: svgX,
    y: svgY
  };
}

var SELECTOR_CLASS = '.lemo-math-expression-view';
var DEFAULT_VIEW_SIZE$1 = 550;
function useMathExpression(rootElement, rules) {
  if (rules === void 0) {
    rules = [];
  }
  useEffect(function () {
    var _rootElement$current;
    var elementList = rootElement === null || rootElement === void 0 ? void 0 : (_rootElement$current = rootElement.current) === null || _rootElement$current === void 0 ? void 0 : _rootElement$current.querySelectorAll(SELECTOR_CLASS);
    if (elementList) {
      for (var _iterator = _createForOfIteratorHelperLoose(elementList), _step; !(_step = _iterator()).done;) {
        var element = _step.value;
        var latex = element.dataset.latex;
        if (!latex) return;
        var data = JSON.parse(latex);
        var size = element.dataset.size || DEFAULT_VIEW_SIZE$1;
        renderMathExpression(element, data, size);
      }
    }
  }, rules);
}

var _excluded = ["content", "innerRef", "className", "onSuccessRenderMathJax", "onStartLatexRendering", "withFullWidthFormula"];
function HTMLContent(_ref) {
  var content = _ref.content,
    innerRef = _ref.innerRef,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$onSuccessRenderM = _ref.onSuccessRenderMathJax,
    onSuccessRenderMathJax = _ref$onSuccessRenderM === void 0 ? null : _ref$onSuccessRenderM,
    onStartLatexRendering = _ref.onStartLatexRendering,
    withFullWidthFormula = _ref.withFullWidthFormula,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var rootNode = useRef(null);
  var _useState = useState(false),
    renderingLatex = _useState[0],
    setRenderingLatex = _useState[1];
  var isMathjax = config.mathRenderEngine === 'mathjax';
  var onLatexRendering = useCallback(function () {
    setRenderingLatex(true);
    onStartLatexRendering === null || onStartLatexRendering === void 0 ? void 0 : onStartLatexRendering();
  }, [setRenderingLatex, onStartLatexRendering]);
  var onLatexRenderComplete = useCallback(function () {
    setRenderingLatex(false);
    onSuccessRenderMathJax === null || onSuccessRenderMathJax === void 0 ? void 0 : onSuccessRenderMathJax();
  }, [setRenderingLatex, onSuccessRenderMathJax]);
  useMathRender(getRef(), [content], onLatexRenderComplete, false, onLatexRendering);
  useAudios(getRef(), [content]);
  useCharts(getRef(), [content]);
  useFractionalShapes(getRef(), [content]);
  useNumberLineView(getRef(), [content]);
  useAngleView(getRef(), [content]);
  useBoxplotView(getRef(), [content]);
  useFunctionsView(getRef(), [content]);
  useMathExpression(getRef(), [content]);
  var withFroalaCss = config.withFroalaCss ? ' fr-element fr-view' : '';
  useEffect(function () {
    var _rootNode$current;
    rootNode === null || rootNode === void 0 ? void 0 : (_rootNode$current = rootNode.current) === null || _rootNode$current === void 0 ? void 0 : _rootNode$current.querySelectorAll('[contenteditable="true"]').forEach(function (element) {
      element.removeAttribute('contenteditable');
    });
  }, [content]);
  function getRef() {
    return innerRef || rootNode;
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", _extends({}, props, {
    ref: getRef(),
    className: cn$1('html-content', className, withFroalaCss, {
      'lemo-rendering-latex': withFullWidthFormula || renderingLatex
    }),
    dangerouslySetInnerHTML: {
      __html: content
    }
  })), isMathjax && (withFullWidthFormula || renderingLatex) && /*#__PURE__*/React__default.createElement("div", _extends({}, props, {
    className: "lemo-while-latex-rendering",
    dangerouslySetInnerHTML: {
      __html: content
    }
  })));
}
var HTMLContent$1 = observer(HTMLContent);

var imageFiles = ['jpeg', 'jpg', 'png', 'gif'];
var audioFiles = ['mp3', 'ogg'];
var videoFiles = ['mp4', 'webm'];
var documentFiles = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt'];
var allowedFiles = ['image/jpeg,image/png,image/gif', 'audio/*', 'video/*', '.doc,.docx,.ppt,.pptx,.xls,.xlsx,.txt,.pdf,.ods,.odt,.odp'].join();

function getIcon(ext) {
  return when()["case"](imageFiles.includes(ext), function () {
    return /*#__PURE__*/React__default.createElement(SvgPhotograph, {
      width: 28
    });
  })["case"](audioFiles.includes(ext), function () {
    return /*#__PURE__*/React__default.createElement(SvgMusicNote, {
      width: 28
    });
  })["case"](videoFiles.includes(ext), function () {
    return /*#__PURE__*/React__default.createElement(SvgPlay, {
      width: 28
    });
  })["case"](documentFiles.includes(ext), function () {
    return /*#__PURE__*/React__default.createElement(SvgClipboardList, {
      width: 28
    });
  }).resolve(null);
}

function FileIcon(_ref) {
  var ext = _ref.ext;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-file-icon"
  }, getIcon(ext)));
}
var FileIcon$1 = observer(FileIcon);

function ShowWhen(_ref) {
  var condition = _ref.condition,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var isVisible = !condition ? {
    display: 'none'
  } : {};
  return /*#__PURE__*/React__default.createElement("div", {
    className: className,
    style: isVisible
  }, children);
}
var ShowWhen$1 = observer(ShowWhen);

function Progress(_ref) {
  var value = _ref.value;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-progress-bar"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-progress-bar-fill",
    style: {
      width: value + "%"
    }
  }));
}

function bytesToKB(bytes) {
  return bytes / 1024;
}
function mbToBytes(kb) {
  return kb * 1024 * 1024;
}
function bytesToMB(bytes) {
  return bytes / 1024 / 1024;
}

function FileInfo(_ref) {
  var file = _ref.file;
  var drive = file.drive,
    name = file.name,
    status = file.status,
    progress = file.progress,
    size = file.size;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-file-info"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-file-name-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-file-name-wrapper__name-drive"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-file-name"
  }, name), /*#__PURE__*/React__default.createElement(ShowWhen$1, {
    condition: status === fileStatuses.COMPLETE
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-file-size"
  }, size > 0 && bytesToKB(size).toFixed(1), size > 0 && ' kb ', drive ? translate('file_uploader_drive') : ''))), /*#__PURE__*/React__default.createElement(ShowWhen$1, {
    condition: status === fileStatuses.UPLOADING
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-file-upload-progress-value"
  }, progress, "%"))), /*#__PURE__*/React__default.createElement(ShowWhen$1, {
    condition: status === fileStatuses.UPLOADING
  }, /*#__PURE__*/React__default.createElement(Progress, {
    value: progress
  })));
}
var FileInfo$1 = observer(FileInfo);

function WrapButton(props) {
  var propsToButton = _extends({}, props);
  return /*#__PURE__*/React__default.createElement("button", _extends({
    type: "button"
  }, propsToButton, {
    className: cn$1('lemo-wrap-button', props.className)
  }), props.children);
}
WrapButton.propTypes = {};
WrapButton.defaultProps = {};

function CancelButton(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React__default.createElement(WrapButton, {
    className: "lemo-cancel-button",
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(SvgXCircle, {
    width: 32
  }));
}
var CancelButton$1 = observer(CancelButton);

function DownloadButton(_ref) {
  var file = _ref.file,
    _ref$isDownloadable = _ref.isDownloadable,
    isDownloadable = _ref$isDownloadable === void 0 ? false : _ref$isDownloadable,
    _ref$isActive = _ref.isActive,
    isActive = _ref$isActive === void 0 ? true : _ref$isActive;
  var downloadAttr = isDownloadable ? {
    download: file.name
  } : {};
  return /*#__PURE__*/React__default.createElement("a", _extends({
    className: "lemo-download-button",
    href: file.path,
    target: "_blank",
    rel: "noreferrer"
  }, downloadAttr, {
    onClick: function onClick(e) {
      if (!isActive) {
        e.preventDefault();
      }
    }
  }), /*#__PURE__*/React__default.createElement(SvgExternalLink, {
    width: 32
  }));
}
var DownloadButton$1 = observer(DownloadButton);

function DefaultControls(_ref) {
  var file = _ref.file,
    _ref$isActiveDownload = _ref.isActiveDownloadButton,
    isActiveDownloadButton = _ref$isActiveDownload === void 0 ? true : _ref$isActiveDownload;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ShowWhen$1, {
    condition: file.status === fileStatuses.UPLOADING
  }, /*#__PURE__*/React__default.createElement(CancelButton$1, {
    onClick: function onClick() {
      return file.abortUpload(file);
    }
  })), /*#__PURE__*/React__default.createElement(ShowWhen$1, {
    condition: file.status === fileStatuses.ADDED
  }, /*#__PURE__*/React__default.createElement(CancelButton$1, {
    onClick: file.removeFile
  })), /*#__PURE__*/React__default.createElement(ShowWhen$1, {
    condition: file.status === fileStatuses.COMPLETE
  }, /*#__PURE__*/React__default.createElement(DownloadButton$1, {
    file: file,
    isActive: isActiveDownloadButton
  })));
}
var DefaultControls$1 = observer(DefaultControls);

function FileItem(_ref) {
  var file = _ref.file,
    onClick = _ref.onClick,
    children = _ref.children,
    _ref$isActiveDownload = _ref.isActiveDownloadButton,
    isActiveDownloadButton = _ref$isActiveDownload === void 0 ? true : _ref$isActiveDownload;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-file-item', {
      'lemo-completed': file.status === file.isCompleted,
      'lemo-error': file.isError,
      'lemo-button-events': !!onClick
    }),
    onClick: onClick || null
  }, /*#__PURE__*/React__default.createElement(FileIcon$1, {
    ext: file.ext
  }), /*#__PURE__*/React__default.createElement(FileInfo$1, {
    file: file
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-file-controls"
  }, children || /*#__PURE__*/React__default.createElement(DefaultControls$1, {
    file: file,
    isActiveDownloadButton: isActiveDownloadButton
  })));
}
var FileItem$1 = observer(FileItem);

function QuestionHeader(_ref) {
  var store = _ref.store,
    stimulusBullet = _ref.stimulusBullet;
  function openFile(idx) {
    var file = store.attachments[idx];
    window.open(file.path, '_blank');
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-header"
  }, stimulusBullet && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-stimulus-bullet"
  }, stimulusBullet), store.stimulus && /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    content: store.stimulus,
    className: "lemo-stimulus lemo-text-body-l-regular lemo-color-text-01"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-file-uploader"
  }, store.attachments && store.attachments.map(function (file, idx) {
    return /*#__PURE__*/React__default.createElement(FileItem$1, {
      key: file.id,
      file: file,
      onClick: function onClick() {
        return openFile(idx);
      }
    }, /*#__PURE__*/React__default.createElement(DownloadButton$1, {
      file: file,
      isActive: false
    }));
  })));
}
var QuestionHeader$1 = observer(QuestionHeader);

function ScaffoldingCustomHeader(_ref) {
  var customHeader = _ref.customHeader,
    store = _ref.store;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question"
  }, customHeader({
    HeaderContent: function HeaderContent() {
      return /*#__PURE__*/React__default.createElement(QuestionHeader$1, {
        store: store
      });
    },
    questionData: store.raw
  }));
}
var ScaffoldingCustomHeader$1 = observer(ScaffoldingCustomHeader);

function ScaffoldingQuestion(_ref) {
  var exercise = _ref.exercise,
    handleChange = _ref.handleChange,
    customHeader = _ref.customHeader,
    _ref$onQuestionStart = _ref.onQuestionStart,
    onQuestionStart = _ref$onQuestionStart === void 0 ? noop : _ref$onQuestionStart,
    _ref$scaffoldQuestion = _ref.scaffoldQuestionSlot,
    scaffoldQuestionSlot = _ref$scaffoldQuestion === void 0 ? null : _ref$scaffoldQuestion;
  var customHeaderClass = customHeader ? 'lemo-custom-header-class' : '';
  useEffect(function () {
    onQuestionStart(exercise.questionApi);
  }, [exercise.questionApi.reference]);
  return exercise.Question && /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-scaffolding-question', customHeaderClass)
  }, customHeader && /*#__PURE__*/React__default.createElement(ScaffoldingCustomHeader$1, {
    customHeader: customHeader,
    store: exercise.questionApi
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-wrapper"
  }, /*#__PURE__*/React__default.createElement(exercise.Question, {
    changed: handleChange
  }), scaffoldQuestionSlot, /*#__PURE__*/React__default.createElement(exercise.Feedback, null), /*#__PURE__*/React__default.createElement(exercise.SampleAnswer, null)));
}
var ScaffoldingQuestion$1 = observer(ScaffoldingQuestion);

function CheckAnswerButton(_ref) {
  var onClick = _ref.onClick,
    disabled = _ref.disabled;
  return /*#__PURE__*/React__default.createElement(SimpleButton, {
    className: "lemo-controls-button-check-answer",
    variant: variantsSimpleButton.primary,
    onClick: onClick,
    disabled: disabled,
    title: "checkAnswer"
  }, translate('button_validate'));
}
var CheckAnswerButton$1 = observer(CheckAnswerButton);

var START = 'start';
var EVALUATED = 'evaluated';
var FINISHED = 'finished';
var SUCCESS = 'success';
var ERROR = 'error';

var controlsStatus$1 = {
  start: {
    id: START,
    visible: {
      checkAnswers: true
    },
    disabled: {}
  },
  evaluated: {
    id: EVALUATED,
    visible: {
      showSolutions: true,
      reset: true
    },
    disabled: {}
  },
  finished: {
    id: FINISHED,
    visible: {
      showSolutions: true
    },
    disabled: {}
  }
};
function getScaffoldControlsStatus(status) {
  return controlsStatus$1[status];
}

function ShowSolutionButton(_ref) {
  var showSolution = _ref.showSolution,
    onClick = _ref.onClick,
    reverseColors = _ref.reverseColors;
  var showSolutionText = translate(showSolution ? 'button_hide_solution' : 'button_show_solution');
  var variantValue = reverseColors ? !showSolution : showSolution;
  var variant = variantValue ? variantsSimpleButton.primary : variantsSimpleButton.secondary;
  return /*#__PURE__*/React__default.createElement(SimpleButton, {
    className: cn$1('lemo-controls-button-solution'),
    variant: variant,
    "data-test-id": "solutionBtn",
    onClick: onClick,
    title: showSolutionText
  }, translate(showSolutionText));
}
var ShowSolutionButton$1 = observer(ShowSolutionButton);

function ResetButton(_ref) {
  var handleReset = _ref.handleReset,
    disabled = _ref.disabled,
    isEvaluated = _ref.isEvaluated;
  return /*#__PURE__*/React__default.createElement(InlineButton, {
    className: "lemo-controls-button-reset",
    onClick: handleReset,
    disabled: disabled || isEvaluated === false,
    title: translate('button_restart')
  }, /*#__PURE__*/React__default.createElement(SvgReply, {
    className: "lemo-icon"
  }), " ", translate('button_restart'));
}
var ResetButton$1 = observer(ResetButton);

function NextButton(_ref) {
  var onClick = _ref.onClick,
    disabled = _ref.disabled;
  var text = translate('button_next_question');
  return /*#__PURE__*/React__default.createElement(SimpleButton, {
    className: "lemo-controls-button-next",
    variant: variantsSimpleButton.primary,
    onClick: onClick,
    disabled: disabled,
    title: text
  }, text);
}
var NextButton$1 = observer(NextButton);

function RestartScaffoldingButton(_ref) {
  var onClick = _ref.onClick,
    disabled = _ref.disabled;
  return /*#__PURE__*/React__default.createElement(SimpleButton, {
    className: "lemo-controls-button-restart-scaffolding",
    variant: variantsSimpleButton.secondary,
    onClick: onClick,
    disabled: disabled,
    title: "restart-scaffolding"
  }, translate('button_restart_scaffold'));
}
var RestartScaffoldingButton$1 = observer(RestartScaffoldingButton);

function ScaffoldingControls(_ref) {
  var _customButtons$reset, _customButtons$checkA, _customButtons$showSo, _customButtons$showSo2, _customButtons$next, _customButtons$restar, _customButtons$showSo3;
  var questionApi = _ref.questionApi,
    currentQuestion = _ref.currentQuestion,
    restart = _ref.restart,
    customButtons = _ref.customButtons;
  var _useState = useState(getScaffoldControlsStatus(currentQuestion.status)),
    status = _useState[0],
    setStatus = _useState[1];
  useEffect(function () {
    setStatus(getScaffoldControlsStatus(currentQuestion.status));
  }, [currentQuestion.status]);
  function handleValidation() {
    questionApi.checkAnswers();
    currentQuestion.setResponse(questionApi.getUserResponse());
    if (questionApi.points === 1) currentQuestion.finish();
  }
  function handleReset() {
    questionApi.reset();
    currentQuestion.reset();
  }
  function handleNext() {
    currentQuestion.next();
  }
  function handleShowSolution() {
    currentQuestion.finish();
    questionApi.showSolutions(!questionApi.showSolution);
  }
  var isFinished = status.id === 'finished';
  var showNextQuestion = isFinished && !currentQuestion.isLast;
  var showRestart = isFinished && currentQuestion.isLast;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "scaffolding-mobile-controls"
  }, /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: status.visible.reset
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-button-column-right-wrapper lemo-button-first-row"
  }, (customButtons === null || customButtons === void 0 ? void 0 : (_customButtons$reset = customButtons.reset) === null || _customButtons$reset === void 0 ? void 0 : _customButtons$reset.call(customButtons, {
    onClick: handleReset,
    isDisabled: status.disabled.reset
  })) || /*#__PURE__*/React__default.createElement(ResetButton$1, {
    handleReset: handleReset,
    disabled: status.disabled.reset
  }))), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: status.visible.checkAnswers
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-button-full-width-wrapper"
  }, (customButtons === null || customButtons === void 0 ? void 0 : (_customButtons$checkA = customButtons.checkAnswers) === null || _customButtons$checkA === void 0 ? void 0 : _customButtons$checkA.call(customButtons, {
    onClick: handleValidation,
    isDisabled: status.disabled.checkAnswers
  })) || /*#__PURE__*/React__default.createElement(CheckAnswerButton$1, {
    disabled: status.disabled.checkAnswers,
    onClick: handleValidation
  }))), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: status.id === 'evaluated'
  }, /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: status.visible.showSolutions
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-button-full-width-wrapper"
  }, (customButtons === null || customButtons === void 0 ? void 0 : (_customButtons$showSo = customButtons.showSolution) === null || _customButtons$showSo === void 0 ? void 0 : _customButtons$showSo.call(customButtons, {
    onClick: handleShowSolution,
    isShowingSolutions: questionApi.showSolution,
    isDisabled: status.disabled.showSolutions
  })) || /*#__PURE__*/React__default.createElement(ShowSolutionButton$1, {
    showSolution: questionApi.showSolution,
    reverseColors: true,
    onClick: handleShowSolution
  })))), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: showNextQuestion
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cn('lemo-button-columns-wrapper', {
      'lemo-flex-end': questionApi.points === 1
    })
  }, /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: questionApi.points < 1
  }, (customButtons === null || customButtons === void 0 ? void 0 : (_customButtons$showSo2 = customButtons.showSolution) === null || _customButtons$showSo2 === void 0 ? void 0 : _customButtons$showSo2.call(customButtons, {
    onClick: handleShowSolution,
    isShowingSolutions: questionApi.showSolution,
    isDisabled: status.disabled.showSolutions
  })) || /*#__PURE__*/React__default.createElement(ShowSolutionButton$1, {
    showSolution: questionApi.showSolution,
    reverseColors: true,
    onClick: handleShowSolution
  })), (customButtons === null || customButtons === void 0 ? void 0 : (_customButtons$next = customButtons.next) === null || _customButtons$next === void 0 ? void 0 : _customButtons$next.call(customButtons, {
    onClick: handleNext,
    isDisabled: status.disabled.next
  })) || /*#__PURE__*/React__default.createElement(NextButton$1, {
    onClick: handleNext
  }))), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: showRestart
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-finish-scaffolding"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-restart-wrapper"
  }, (customButtons === null || customButtons === void 0 ? void 0 : (_customButtons$restar = customButtons.restartScaffolding) === null || _customButtons$restar === void 0 ? void 0 : _customButtons$restar.call(customButtons, {
    onClick: restart,
    isDisabled: status.disabled.restartScaffolding
  })) || /*#__PURE__*/React__default.createElement(RestartScaffoldingButton$1, {
    disabled: false,
    onClick: restart
  })), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: questionApi.points < 1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-show-answer-wrapper"
  }, (customButtons === null || customButtons === void 0 ? void 0 : (_customButtons$showSo3 = customButtons.showSolution) === null || _customButtons$showSo3 === void 0 ? void 0 : _customButtons$showSo3.call(customButtons, {
    onClick: handleShowSolution,
    isShowingSolutions: questionApi.showSolution,
    isDisabled: status.disabled.showSolutions
  })) || /*#__PURE__*/React__default.createElement(ShowSolutionButton$1, {
    showSolution: questionApi.showSolution,
    reverseColors: true,
    onClick: handleShowSolution
  }))))));
}
var ScaffoldingControls$1 = observer(ScaffoldingControls);

function ScaffoldingLayout(_ref) {
  var scaffoldStore = _ref.scaffoldStore,
    handleChange = _ref.handleChange,
    handleComplete = _ref.handleComplete,
    basePath = _ref.basePath,
    assetsQuestionApi = _ref.assetsQuestionApi,
    assetsQuestionApiDrive = _ref.assetsQuestionApiDrive,
    onQuestionStart = _ref.onQuestionStart,
    customHeader = _ref.customHeader,
    customButtons = _ref.customButtons,
    scaffoldQuestionSlot = _ref.scaffoldQuestionSlot;
  var lemoOpened = when()["case"](scaffoldStore.isFirstTime, function () {
    return 'lemo-is-first-time';
  })["case"](scaffoldStore.isOpen, function () {
    return 'lemo-opened';
  }).resolve(function () {
    return '';
  });
  var getQuestionProps = function getQuestionProps() {
    return {
      data: scaffoldStore.currentQuestion.questionData,
      basePath: basePath,
      assetsQuestionApi: assetsQuestionApi,
      assetsQuestionApiDrive: assetsQuestionApiDrive
    };
  };
  var _useLemonadeQuestion = useLemonadeQuestion(getQuestionProps()),
    exercise = _useLemonadeQuestion.exercise,
    updateExercise = _useLemonadeQuestion.updateExercise;
  if (isDeveloperMode()) {
    window.questionApi = exercise.questionApi;
  }
  useEffect(function () {
    var _scaffoldStore$curren;
    var currentRef = (_scaffoldStore$curren = scaffoldStore.currentQuestion.data) === null || _scaffoldStore$curren === void 0 ? void 0 : _scaffoldStore$curren.reference;
    if (exercise.questionApi.reference !== currentRef) {
      updateExercise(getQuestionProps());
      setTimeout(function () {
        return exercise.questionApi.cancelAutoFeedback();
      }, 100);
    }
  }, [scaffoldStore.currentQuestionIndex]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-scaffolding-mobile-layout"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-layout-container', lemoOpened),
    onClick: scaffoldStore.isFirstTime ? scaffoldStore.open : null
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-navigation-container"
  }, /*#__PURE__*/React__default.createElement(ScaffoldingNavigation$1, {
    scaffoldStore: scaffoldStore
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-container"
  }, /*#__PURE__*/React__default.createElement(ScaffoldingQuestion$1, {
    exercise: exercise,
    response: scaffoldStore.currentQuestion.response,
    handleChange: handleChange,
    customHeader: customHeader,
    customButtons: customButtons,
    onQuestionStart: onQuestionStart,
    scaffoldQuestionSlot: scaffoldQuestionSlot
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-controls-container"
  }, /*#__PURE__*/React__default.createElement(ScaffoldingControls$1, {
    restart: scaffoldStore.restart,
    questionApi: exercise.questionApi,
    currentQuestion: scaffoldStore.currentQuestion,
    handleComplete: handleComplete,
    customButtons: customButtons
  }))));
}
var ScaffoldingLayout$1 = observer(ScaffoldingLayout);

var QuestionModel = types$1.model('scaffoldQuestionModel', {
  id: types$1.string,
  data: types$1.frozen(),
  finished: types$1.optional(types$1["boolean"], false),
  response: types$1.maybe(types$1.frozen())
}).actions(function (state) {
  return {
    saveResponse: function saveResponse(userResponse) {
      getParent(state, 2).addUserResponse(state.index, userResponse);
    },
    restartScaffold: function restartScaffold() {
      getParent(state, 2).restart();
    },
    reset: function reset() {
      state.response = undefined;
      state.finished = false;
    },
    next: function next() {
      getParent(state, 2).next();
    },
    setResponse: function setResponse(response) {
      state.response = response;
    },
    finish: function finish() {
      state.finished = true;
    }
  };
}).views(function (state) {
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get questionData() {
      if (state.finished || state.status === EVALUATED) {
        return _extends({}, state.data, {
          response: {
            status: FINISHED.toUpperCase(),
            value: state.response
          }
        });
      }
      return state.data;
    },
    get status() {
      if (state.finished) return FINISHED;
      if (state.response !== undefined) return EVALUATED;
      return START;
    },
    get isLast() {
      var totalQuestions = getParent(state).length;
      return totalQuestions - 1 === state.index;
    }
  };
});

var ScaffoldMobileStore = types$1.model('scaffoldStore', {
  questionList: types$1.optional(types$1.array(QuestionModel), []),
  isOpen: types$1.optional(types$1["boolean"], false),
  isFirstTime: false,
  currentQuestionIndex: types$1.optional(types$1.number, 0),
  userResponse: types$1.optional(types$1.frozen(), []),
  isFinished: false
}).actions(function (state) {
  return {
    finish: function finish() {
      state.isFinished = true;
    },
    restart: function restart() {
      console.log('init restart');
      state.isFinished = false;
      state.isOpen = false;
      state.isFirstTime = false;
      state.userResponse = [];
      state.currentQuestionIndex = 0;
      state.questionList.forEach(function (question) {
        return question.reset();
      });
      console.log('end restart');
    },
    addUserResponse: function addUserResponse(idx, userResponse) {
      var cloneList = [].concat(state.userResponse);
      cloneList[idx] = userResponse;
      state.userResponse = cloneList;
    },
    startScaffolding: function startScaffolding() {
      state.currentQuestion.finish();
      state.currentQuestionIndex = 1;
      setTimeout(state.setFirstTime, 100);
    },
    next: function next() {
      if (state.nextButtonEnabled) {
        state.currentQuestionIndex += 1;
      }
    },
    prev: function prev() {
      if (state.prevButtonEnabled) {
        state.currentQuestionIndex -= 1;
      }
    },
    toggle: function toggle() {
      state.isOpen = !state.isOpen;
      state.isFirstTime = false;
    },
    open: function open() {
      state.isOpen = true;
      state.isFirstTime = false;
    },
    close: function close() {
      state.isOpen = false;
      state.isFirstTime = false;
    },
    setFirstTime: function setFirstTime() {
      state.isFirstTime = true;
      state.isOpen = true;
    }
  };
}).views(function (state) {
  return {
    get currentQuestion() {
      return state.questionList[state.currentQuestionIndex];
    },
    get nextButtonEnabled() {
      var nextQuestion = state.currentQuestionIndex + 1;
      return nextQuestion <= state.totalUnlockedQuestions && state.currentQuestionIndex < state.totalQuestions;
    },
    get prevButtonEnabled() {
      return state.currentQuestionIndex - 1 > 0;
    },
    get totalQuestions() {
      return state.questionList.length - 1;
    },
    get totalUnlockedQuestions() {
      return state.questionList.reduce(function (acc, next) {
        return next.finished ? acc + 1 : acc;
      }, 0);
    },
    get mainQuestion() {
      return state.questionList[0];
    },
    get isScaffoldingVisible() {
      return state.currentQuestionIndex > 0;
    },
    getUserResponses: function getUserResponses() {
      var _state$getResponses = state.getResponses(),
        references = _state$getResponses.references,
        responses = _state$getResponses.responses;
      return references.map(function (ref) {
        return responses[ref].value;
      });
    },
    getResponses: function getResponses() {
      return {
        references: state.userResponse.map(function (response) {
          return Object.keys(response)[0];
        }),
        responses: state.userResponse.reduce(function (acc, next) {
          var _extends2;
          var _Object$entries$ = Object.entries(next)[0],
            key = _Object$entries$[0],
            val = _Object$entries$[1];
          return _extends({}, acc, (_extends2 = {}, _extends2[key] = val, _extends2));
        }, {})
      };
    }
  };
});
function createQuestions(questionList) {
  return questionList.map(function (question, idx) {
    return {
      id: question.reference,
      data: question
    };
  });
}
function createScaffoldMobile(_ref) {
  var data = _ref.data;
  return ScaffoldMobileStore.create({
    questionList: createQuestions(data.questions)
  });
}

function IDKButton(_ref) {
  var onClick = _ref.onClick,
    disabled = _ref.disabled;
  return /*#__PURE__*/React__default.createElement(InlineButton, {
    className: "lemo-controls-button-idk",
    disabled: disabled,
    onClick: onClick,
    title: translate('button_i_dont_know')
  }, /*#__PURE__*/React__default.createElement(SvgBolt, {
    className: "lemo-icon"
  }), " ", translate('button_i_dont_know'));
}
var IDKButton$1 = observer(IDKButton);

var controlsStatus$2 = {
  start: {
    id: START,
    visible: {
      checkAnswers: true,
      idk: true
    },
    disabled: {}
  },
  evaluated: {
    id: EVALUATED,
    visible: {
      checkAnswers: true,
      idk: true
    },
    disabled: {
      checkAnswers: true,
      idk: true
    }
  },
  success: {
    id: SUCCESS,
    visible: {
      restart: true,
      checkAnswers: false,
      idk: false
    },
    disabled: {}
  },
  error: {
    id: ERROR,
    visible: {
      checkAnswers: true,
      idk: true
    },
    disabled: {
      checkAnswers: true,
      idk: true
    }
  }
};
function getMainQuestionControlsStatus(status) {
  return controlsStatus$2[status];
}

function MainQuestionControls(_ref) {
  var _customButtons$IDK, _customButtons$checkA, _customButtons$restar;
  var handleCheckAnswers = _ref.handleCheckAnswers,
    handleIDK = _ref.handleIDK,
    handleReset = _ref.handleReset,
    isDisabled = _ref.isDisabled,
    customButtons = _ref.customButtons,
    isSuccess = _ref.isSuccess,
    isError = _ref.isError;
  var _useState = useState(getMainQuestionControlsStatus(START)),
    status = _useState[0],
    setStatus = _useState[1];
  useEffect(function () {
    var newStatus = when()["case"](isSuccess, function () {
      return SUCCESS;
    })["case"](isError, function () {
      return ERROR;
    }).resolve(function () {
      return START;
    });
    setStatus(getMainQuestionControlsStatus(newStatus));
  }, [isDisabled]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "main-question-controls"
  }, /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: status.visible.idk
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-button-column-right-wrapper lemo-button-first-row"
  }, (customButtons === null || customButtons === void 0 ? void 0 : (_customButtons$IDK = customButtons.IDK) === null || _customButtons$IDK === void 0 ? void 0 : _customButtons$IDK.call(customButtons, {
    onClick: handleIDK,
    isDisabled: status.disabled.idk
  })) || /*#__PURE__*/React__default.createElement(IDKButton$1, {
    onClick: handleIDK,
    disabled: status.disabled.idk
  }))), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: status.visible.checkAnswers
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-button-full-width-wrapper"
  }, (customButtons === null || customButtons === void 0 ? void 0 : (_customButtons$checkA = customButtons.checkAnswers) === null || _customButtons$checkA === void 0 ? void 0 : _customButtons$checkA.call(customButtons, {
    onClick: handleCheckAnswers,
    isDisabled: status.disabled.checkAnswers
  })) || /*#__PURE__*/React__default.createElement(CheckAnswerButton$1, {
    disabled: status.disabled.checkAnswers,
    onClick: handleCheckAnswers
  }))), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: status.visible.restart
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-button-full-width-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-restart-wrapper"
  }, (customButtons === null || customButtons === void 0 ? void 0 : (_customButtons$restar = customButtons.restartScaffolding) === null || _customButtons$restar === void 0 ? void 0 : _customButtons$restar.call(customButtons, {
    onClick: handleReset,
    isDisabled: status.disabled.restartScaffolding
  })) || /*#__PURE__*/React__default.createElement(RestartScaffoldingButton$1, {
    disabled: false,
    onClick: handleReset
  })))));
}
var MainQuestionControls$1 = observer(MainQuestionControls);

function ScaffoldingMainQuestion(_ref) {
  var startScaffolding = _ref.startScaffolding,
    scaffoldStore = _ref.scaffoldStore,
    basePath = _ref.basePath,
    assetsQuestionApi = _ref.assetsQuestionApi,
    assetsQuestionApiDrive = _ref.assetsQuestionApiDrive,
    handleChange = _ref.handleChange,
    onQuestionStart = _ref.onQuestionStart,
    customHeader = _ref.customHeader,
    customButtons = _ref.customButtons,
    onMainQuestionSuccess = _ref.onMainQuestionSuccess,
    _ref$mainQuestionSlot = _ref.mainQuestionSlot,
    mainQuestionSlot = _ref$mainQuestionSlot === void 0 ? null : _ref$mainQuestionSlot;
  var customHeaderClass = customHeader ? 'lemo-custom-header-class' : '';
  var _useLemonadeQuestion = useLemonadeQuestion({
      data: scaffoldStore.mainQuestion.data,
      basePath: basePath,
      assetsQuestionApi: assetsQuestionApi,
      assetsQuestionApiDrive: assetsQuestionApiDrive
    }),
    exercise = _useLemonadeQuestion.exercise;
  function handleCheckAnswers() {
    exercise.questionApi.checkAnswers();
    if (exercise.questionApi.points < 1) {
      scaffoldStore.mainQuestion.setResponse(exercise.questionApi.getUserResponse());
      startScaffolding();
    }
  }
  function handleIDK() {
    exercise.questionApi.setDisabled(true);
    scaffoldStore.mainQuestion.setResponse(exercise.questionApi.getUserResponse());
    startScaffolding();
  }
  function handleReset() {
    onMainQuestionSuccess();
    exercise.questionApi.reset();
  }
  useEffect(function () {
    onQuestionStart(exercise.questionApi);
    exercise.questionApi.cancelAutoFeedback();
    onAction(scaffoldStore, function (_ref2) {
      var name = _ref2.name;
      if (name === 'restart') {
        exercise.questionApi.reset();
        exercise.questionApi.setDisabled(false);
      }
    });
  }, []);
  var isEvaluated = exercise.questionApi.isEvaluated;
  var isSuccess = isEvaluated && exercise.questionApi.points === 1;
  var isError = isEvaluated && exercise.questionApi.points === 0;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-scaffolding-main-question', customHeaderClass)
  }, customHeader && /*#__PURE__*/React__default.createElement(ScaffoldingCustomHeader$1, {
    customHeader: customHeader,
    store: exercise.questionApi
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(exercise.Question, {
    changed: handleChange
  }), mainQuestionSlot), /*#__PURE__*/React__default.createElement(exercise.Feedback, null), /*#__PURE__*/React__default.createElement(exercise.SampleAnswer, null), /*#__PURE__*/React__default.createElement(MainQuestionControls$1, {
    handleIDK: handleIDK,
    handleCheckAnswers: handleCheckAnswers,
    handleReset: handleReset,
    isDisabled: exercise.questionApi.disabled,
    customButtons: customButtons,
    isSuccess: isSuccess,
    isError: isError
  })));
}
var ScaffoldingMainQuestion$1 = observer(ScaffoldingMainQuestion);

function ScaffoldingMobile(_ref) {
  var data = _ref.data,
    changed = _ref.changed,
    onComplete = _ref.onComplete,
    basePath = _ref.basePath,
    assetsQuestionApi = _ref.assetsQuestionApi,
    assetsQuestionApiDrive = _ref.assetsQuestionApiDrive,
    customHeader = _ref.customHeader,
    customButtons = _ref.customButtons,
    mainQuestionSlot = _ref.mainQuestionSlot,
    scaffoldQuestionSlot = _ref.scaffoldQuestionSlot,
    _ref$onScaffoldStart = _ref.onScaffoldStart,
    onScaffoldStart = _ref$onScaffoldStart === void 0 ? noop : _ref$onScaffoldStart,
    _ref$onQuestionStart = _ref.onQuestionStart,
    onQuestionStart = _ref$onQuestionStart === void 0 ? noop : _ref$onQuestionStart,
    _ref$onMainQuestionSu = _ref.onMainQuestionSuccess,
    onMainQuestionSuccess = _ref$onMainQuestionSu === void 0 ? noop : _ref$onMainQuestionSu;
  var _useState = useState(null),
    scaffoldStore = _useState[0],
    setScaffoldStore = _useState[1];
  function updateScaffold() {
    if (data) {
      var store = createScaffoldMobile({
        data: data
      });
      setScaffoldStore(store);
      onScaffoldStart(store);
    }
  }
  useEffect(function () {
    if (data !== null && data !== void 0 && data.id) {
      updateScaffold();
    }
  }, [data.id]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-scaffolding-mobile"
  }, /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: scaffoldStore
  }, (scaffoldStore === null || scaffoldStore === void 0 ? void 0 : scaffoldStore.isScaffoldingVisible) && /*#__PURE__*/React__default.createElement(ScaffoldingLayout$1, {
    scaffoldStore: scaffoldStore,
    basePath: basePath,
    assetsQuestionApi: assetsQuestionApi,
    assetsQuestionApiDrive: assetsQuestionApiDrive,
    handleChange: changed,
    handleComplete: onComplete,
    onQuestionStart: onQuestionStart,
    customHeader: customHeader,
    customButtons: customButtons,
    scaffoldQuestionSlot: scaffoldQuestionSlot
  }), /*#__PURE__*/React__default.createElement(ScaffoldingMainQuestion$1, {
    scaffoldStore: scaffoldStore,
    startScaffolding: scaffoldStore === null || scaffoldStore === void 0 ? void 0 : scaffoldStore.startScaffolding,
    basePath: basePath,
    assetsQuestionApi: assetsQuestionApi,
    assetsQuestionApiDrive: assetsQuestionApiDrive,
    handleChange: changed,
    onQuestionStart: onQuestionStart,
    onMainQuestionSuccess: onMainQuestionSuccess,
    customHeader: customHeader,
    customButtons: customButtons,
    mainQuestionSlot: mainQuestionSlot
  })));
}
var ScaffoldingMobile$1 = observer(ScaffoldingMobile);

function Dialog(_ref) {
  var innerRef = _ref.innerRef,
    children = _ref.children,
    handleClose = _ref.handleClose,
    className = _ref.className;
  return /*#__PURE__*/React__default.createElement("div", {
    ref: innerRef,
    className: 'lemo-dialog ' + className
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-close-button-wrapper"
  }, !!handleClose && /*#__PURE__*/React__default.createElement(WrapButton, {
    onClick: handleClose
  }, /*#__PURE__*/React__default.createElement(SvgXCircle, {
    className: "lemo-close-icon"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-dialog-content"
  }, children));
}

function FeedbackPinNumber(_ref) {
  var result = _ref.result,
    idx = _ref.idx,
    _ref$floating = _ref.floating,
    floating = _ref$floating === void 0 ? false : _ref$floating,
    _ref$visible = _ref.visible,
    visible = _ref$visible === void 0 ? false : _ref$visible,
    _ref$classAdd = _ref.classAdd,
    classAdd = _ref$classAdd === void 0 ? '' : _ref$classAdd;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-feedback-pin-number lemo-base-feedback__pin', classAdd, {
      'lemo-hidden': !visible,
      'lemo-floating': floating,
      'lemo-success': result,
      'lemo-error': !result
    })
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-text"
  }, idx));
}

var defaultThemeTokens = ['lemo-color-tokens', 'lemo-other-tokens', 'lemo-text-tokens', 'lemo-fractions-tokens', 'lemo-button-tokens', 'lemo-box-tokens', 'lemo-word-search-tokens'];

var Portal$1 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Portal, _React$Component);
  function Portal(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      isReady: false,
      portalId: null
    };
    _this.classes = ['lemonade-exercises'].concat(defaultThemeTokens).join(' ');
    return _this;
  }
  var _proto = Portal.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var p = this.props.portalid && document.getElementById(this.props.portalid);
    if (!p) {
      this.setState({
        isReady: true,
        portalId: this.props.portalid
      });
      p = document.createElement('div');
      p.id = this.props.portalid;
      p.className = this.props.className;
      document.body.appendChild(p);
    } else {
      this.setState({
        isReady: true,
        portalId: this.props.portalid
      });
    }
    this.portalElement = p;
    this.componentDidUpdate();
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    var p = this.props.portalid && document.getElementById(this.props.portalid);
    if (p && this.portalElement.parentNode === document.body) document.body.removeChild(this.portalElement);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps && prevProps.portalid !== this.props.portalid) {
      var p = this.props.portalid && document.getElementById(this.props.portalid);
      if (p) p.className = this.props.className;
      this.setState({
        isReady: true,
        portalId: this.props.portalid
      });
    }
  };
  _proto.render = function render() {
    return this.state.isReady ? createPortal( /*#__PURE__*/React__default.createElement("div", _extends({
      className: this.classes
    }, this.props), this.props.children), this.portalElement) : '';
  };
  return Portal;
}(React__default.Component);

function useOnClickOutside(ref, handler) {
  useEffect(function () {
    var current = ref.current || ref;
    var listener = function listener(event) {
      var _current$contains;
      if (!current || (_current$contains = current.contains) !== null && _current$contains !== void 0 && _current$contains.call(current, event.target)) {
        return;
      }
      handler(event);
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
}

var Tooltip = function Tooltip(_ref) {
  var targetElement = _ref.targetElement,
    onClose = _ref.onClose,
    children = _ref.children;
  var _useState = useState(null),
    popperElement = _useState[0],
    setPopperElement = _useState[1];
  var _useState2 = useState(null),
    arrowElement = _useState2[0],
    setArrowElement = _useState2[1];
  var _usePopper = usePopper(targetElement, popperElement, getPopoverConfig(arrowElement)),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes;
  var element = useRef();
  useOnClickOutside(element, onClose);
  var isPopperVisible = !targetElement && {
    display: 'none'
  };
  return /*#__PURE__*/React__default.createElement("div", {
    ref: element
  }, /*#__PURE__*/React__default.createElement("div", _extends({
    className: "lemo-tooltip",
    ref: setPopperElement,
    style: _extends({}, styles.popper, isPopperVisible)
  }, attributes.popper), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-tooltip__wrapper"
  }, children), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-tooltip__arrow",
    ref: setArrowElement,
    style: styles.arrow
  })));
};
function getPopoverConfig(arrowElement) {
  return {
    modifiers: [{
      name: 'arrow',
      options: {
        element: arrowElement
      }
    }, {
      name: 'offset',
      options: {
        offset: [0, 16]
      }
    }, {
      name: 'preventOverflow',
      options: {
        padding: {
          top: 60,
          bottom: 70,
          left: 10,
          right: 10
        }
      }
    }]
  };
}

var TooltipContent = function TooltipContent(_ref) {
  var content = _ref.content,
    onClose = _ref.onClose;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-tooltip-content"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-tooltip-content__close"
  }, /*#__PURE__*/React__default.createElement(WrapButton, {
    className: "lemo-tooltip-content__close-button",
    onClick: onClose
  }, /*#__PURE__*/React__default.createElement(SvgXCircle, {
    className: 'lemo-tooltip-content__close-icon'
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-tooltip-content__content"
  }, content));
};

var TooltipWrapper = function TooltipWrapper(_ref) {
  var componentTooltip = _ref.componentTooltip,
    openPortal = _ref.openPortal,
    children = _ref.children;
  var _useState = useState(uuid()),
    guid = _useState[0];
  var _useState2 = useState(),
    popperTarget = _useState2[0],
    setPopperTarget = _useState2[1];
  var showTooltip = useCallback(function (e) {
    var target = e.target;
    setPopperTarget(popperTarget ? undefined : target);
  }, [setPopperTarget, popperTarget]);
  function onClose() {
    setPopperTarget(undefined);
  }
  function getTooltipComponent() {
    return /*#__PURE__*/React__default.createElement(Tooltip, {
      targetElement: popperTarget,
      onClose: onClose
    }, /*#__PURE__*/React__default.createElement(TooltipContent, {
      content: componentTooltip,
      onClose: onClose
    }));
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-tooltip-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'lemo-tooltip-wrapper__icon',
    onClick: showTooltip
  }, children), popperTarget !== undefined && (openPortal ? /*#__PURE__*/React__default.createElement(Portal$1, {
    portalid: 'tooltip-wrapper__portal-' + guid
  }, getTooltipComponent()) : getTooltipComponent()));
};

function FeedbackPinTooltip(_ref) {
  var result = _ref.result,
    feedback = _ref.feedback,
    _ref$floating = _ref.floating,
    floating = _ref$floating === void 0 ? false : _ref$floating,
    _ref$visible = _ref.visible,
    visible = _ref$visible === void 0 ? false : _ref$visible,
    _ref$classAdd = _ref.classAdd,
    classAdd = _ref$classAdd === void 0 ? '' : _ref$classAdd,
    _ref$openPortal = _ref.openPortal,
    openPortal = _ref$openPortal === void 0 ? true : _ref$openPortal,
    _ref$mirrorIcon = _ref.mirrorIcon,
    mirrorIcon = _ref$mirrorIcon === void 0 ? false : _ref$mirrorIcon;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-feedback-pin-tooltip', classAdd, {
      'lemo-mirror-icon': mirrorIcon,
      'lemo-hidden': !visible,
      'lemo-floating': floating,
      'lemo-success': result,
      'lemo-error': !result
    })
  }, /*#__PURE__*/React__default.createElement(TooltipWrapper, {
    componentTooltip: /*#__PURE__*/React__default.createElement(HTMLContent$1, {
      content: feedback
    }),
    openPortal: openPortal
  }, /*#__PURE__*/React__default.createElement(SvgExclamationCircle, {
    className: "lemo-feedback-pin-tooltip__icon",
    width: 30
  })));
}

function FeedbackPin(_ref) {
  var result = _ref.result,
    idx = _ref.idx,
    feedback = _ref.feedback,
    _ref$floating = _ref.floating,
    floating = _ref$floating === void 0 ? false : _ref$floating,
    _ref$visible = _ref.visible,
    visible = _ref$visible === void 0 ? false : _ref$visible,
    _ref$classAdd = _ref.classAdd,
    classAdd = _ref$classAdd === void 0 ? '' : _ref$classAdd,
    _ref$openPortal = _ref.openPortal,
    openPortal = _ref$openPortal === void 0 ? true : _ref$openPortal,
    _ref$mirrorIcon = _ref.mirrorIcon,
    mirrorIcon = _ref$mirrorIcon === void 0 ? false : _ref$mirrorIcon;
  var commonProps = {
    result: result,
    idx: idx,
    floating: floating,
    visible: visible,
    classAdd: classAdd
  };
  return config.individualFeedbackTooltip ? /*#__PURE__*/React__default.createElement(FeedbackPinTooltip, _extends({}, commonProps, {
    feedback: feedback,
    openPortal: openPortal,
    mirrorIcon: mirrorIcon
  })) : /*#__PURE__*/React__default.createElement(FeedbackPinNumber, commonProps);
}
var FeedbackPin$1 = observer(FeedbackPin);

function FeedbackItem(_ref) {
  var feedback = _ref.feedback,
    showSolution = _ref.showSolution;
  var isIndividualFeedback = feedback.idx !== undefined;
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": isIndividualFeedback ? 'individualFeedback' : 'globalFeedback',
    className: cn$1('lemo-feedback-item', {
      'lemo-error': feedback.mode === 'error',
      'lemo-success': feedback.mode === 'success',
      'lemo-show-solution': showSolution,
      'lemo-global-feedback': !isIndividualFeedback
    })
  }, isIndividualFeedback && /*#__PURE__*/React__default.createElement(FeedbackPin$1, {
    result: feedback.mode === 'success',
    idx: feedback.localIndex,
    visible: true,
    classAdd: 'lemo-base-feedback-pin__dialog',
    feedback: feedback.value
  }), /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    className: "lemo-feedback-value lemo-text-body-m-regular lemo-color-text-01",
    content: feedback.value
  }));
}
var FeedbackItem$1 = observer(FeedbackItem);

function FeedbackManager(_ref) {
  var store = _ref.store,
    _ref$isVisible = _ref.isVisible,
    isVisible = _ref$isVisible === void 0 ? true : _ref$isVisible;
  var _useState = useState(false),
    visible = _useState[0],
    setVisible = _useState[1];
  var shouldShowFeedback = function shouldShowFeedback() {
    return store.feedback.currentFeedback.length > 0 && store.feedback.config.visibility && store.isEvaluable;
  };
  var isFeedbackAvailable = function isFeedbackAvailable() {
    return !visible || !isVisible || !store.isEvaluated;
  };
  var shouldShowItemFeedback = function shouldShowItemFeedback(feedback) {
    return !config.individualFeedbackTooltip && !store.inlineFeedback;
  };
  useEffect(function () {
    if (store.isEvaluated || store.showSolution || store.isAutoFeedbackRunning) {
      setVisible(shouldShowFeedback());
    }
  }, [store.isEvaluated]);
  return isFeedbackAvailable() ? null : /*#__PURE__*/React__default.createElement(Dialog, {
    className: "lemo-feedback-dialog"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-feedback-list"
  }, store.feedback.config.hasSpecificFeedback && store.feedback.individualFeedback.map(function (feedback, idx) {
    return shouldShowItemFeedback() && /*#__PURE__*/React__default.createElement(FeedbackItem$1, {
      key: "feedback-response-" + idx,
      showSolution: store.showSolution || store.internalAutoFeedback,
      feedback: feedback
    });
  }), store.feedback.config.hasGlobalFeedback && store.feedback.globalFeedback && store.cachePoints === 0 && /*#__PURE__*/React__default.createElement(FeedbackItem$1, {
    feedback: store.feedback.globalFeedback
  })));
}
var FeedbackManager$1 = observer(FeedbackManager);

function addCatalanLang() {
  var literals = {
    translation: {
      'Type something': 'Escriu alguna cosa',
      Bold: 'Negreta',
      Italic: 'Itàlica',
      Underline: 'Subratllat',
      Strikethrough: 'Ratllat',
      Insert: 'Afegeix',
      Delete: 'Esborra',
      Cancel: 'Cancel·la',
      OK: 'Ok',
      Back: 'Enrere',
      Remove: 'Elimina',
      More: 'Més',
      Update: 'Actualització',
      Style: 'Estil',
      'Font Family': 'Família de fonts',
      'Font Size': 'Mida de font',
      Colors: 'Colors',
      Background: 'Fons',
      Text: 'Text',
      'HEX Color': 'Color hexadecimal',
      'Paragraph Format': 'Format de paràgraf',
      Normal: 'Normal',
      Code: 'Codi',
      'Heading 1': 'Encapçalament 1',
      'Heading 2': 'Encapçalament 2',
      'Heading 3': 'Encapçalament 3',
      'Heading 4': 'Encapçalament 4',
      'Paragraph Style': 'Estil de paràgraf',
      'Inline Style': 'Estil en línia',
      Align: 'Alinea',
      'Align Left': 'Alinea a l’esquerra',
      'Align Center': 'Alinea al centre',
      'Align Right': 'Alinea a la dreta',
      'Align Justify': 'Justifica',
      None: 'Cap',
      'Ordered List': 'Llista ordenada',
      'Unordered List': 'Llista desordenada',
      'Decrease Indent': 'Redueix el sagnat',
      'Increase Indent': 'Augmenta el sagnat',
      'Insert Link': 'Afegeix enllaç',
      'Open in new tab': 'Obre en una pestanya nova',
      'Open Link': 'Obre l’enllaç',
      'Edit Link': 'Edita l’enllaç',
      Unlink: 'Elimina l’enllaç',
      'Choose Link': 'Tria l’enllaç',
      'Insert Image': 'Afegeix una imatge',
      'Upload Image': 'Carrega una imatge',
      'By URL': 'Per URL',
      Browse: 'Examina',
      'Drop image': 'Deixa anar la imatge',
      'or click': 'o fes clic a',
      'Manage Images': 'Administra imatges',
      Loading: 'S’està carregant',
      Deleting: 'S’està suprimint',
      Tags: 'Etiquetes',
      'Are you sure? Image will be deleted.': 'N’estàs segur? La imatge se suprimirà.',
      Replace: 'Canvia',
      Uploading: 'S’està pujant',
      'Loading image': 'S’està carregant la imatge',
      Display: 'Visualitza',
      Inline: 'En línia',
      'Break Text': 'Salta el text',
      'Alternative Text': 'Text alternatiu',
      'Change Size': 'Canvia la mida',
      Width: 'Amplada',
      Height: 'Alçària',
      'Something went wrong. Please try again.': 'Alguna cosa no ha anat bé. Si us plau, torna-ho a provar.',
      'Image Caption': 'Captura d’imatge',
      'Advanced Edit': 'Edició avançada',
      'Insert Video': 'Afegeix vídeo',
      'Embedded Code': 'Codi incrustat',
      'Drop video': 'Deixa anar el vídeo',
      'Your browser does not support HTML5 video.': 'El teu navegador no és compatible amb vídeo html5.',
      'Upload Video': 'Puja un vídeo',
      'Insert Table': 'Afegeix una taula',
      'Table Header': 'Capçalera de la taula',
      'Remove Table': 'Elimina la taula',
      'Table Style': 'Estil de taula',
      'Horizontal Align': 'Alineació horitzontal',
      Row: 'Fila',
      'Insert row above': 'Afegeix fila abans',
      'Insert row below': 'Afegeix fila després',
      'Delete row': 'Elimina fila',
      Column: 'Columna',
      'Insert column before': 'Afegeix columna abans',
      'Insert column after': 'Afegeix columna després',
      'Delete column': 'Elimina columna',
      Cell: 'Cel·la',
      'Merge cells': 'Combina cel·les',
      'Horizontal split': 'Divisió horitzontal',
      'Vertical split': 'Divisió vertical',
      'Cell Background': 'Fons de la cel·la',
      'Vertical Align': 'Alineació vertical',
      Top: 'Part superior',
      Middle: 'Centre',
      Bottom: 'Part inferior',
      'Align Top': 'Alineació superior',
      'Align Middle': 'Alineació central',
      'Align Bottom': 'Alineació inferior',
      'Cell Style': 'Estil de cel·la',
      'Upload File': 'Carrega un fitxer',
      'Drop file': 'Deixa anar el fitxer',
      Emoticons: 'Emoticones',
      'Grinning face': 'Cara somrient',
      'Grinning face with smiling eyes': 'Cara somrient amb ulls somrients',
      'Face with tears of joy': 'Cara amb llàgrimes d’alegria',
      'Smiling face with open mouth': 'Cara somrient amb la boca oberta',
      'Smiling face with open mouth and smiling eyes': 'Cara somrient amb la boca oberta i els ulls somrients',
      'Smiling face with open mouth and cold sweat': 'Cara somrient amb la boca oberta i suor freda',
      'Smiling face with open mouth and tightly-closed eyes': 'Cara somrient amb la boca oberta i els ulls tancats fent força',
      'Smiling face with halo': 'Cara somrient amb halo',
      'Smiling face with horns': 'Cara somrient amb banyes',
      'Winking face': 'Cara que fa l’ullet',
      'Smiling face with smiling eyes': 'Cara somrient amb ulls somrients',
      'Face savoring delicious food': 'Cara d’assaborir un menjar deliciós',
      'Relieved face': 'Cara d’alleujament',
      'Smiling face with heart-shaped eyes': 'Cara somrient amb els ulls en forma de cor',
      'Smiling face with sunglasses': 'Cara somrient amb ulleres de sol',
      'Smirking face': 'Cara amb somriure de satisfacció',
      'Neutral face': 'Cara neutra',
      'Expressionless face': 'Cara inexpressiva',
      'Unamused face': 'Cara avorrida',
      'Face with cold sweat': 'Cara amb suor freda',
      'Pensive face': 'Cara pensativa',
      'Confused face': 'Cara confusa',
      'Confounded face': 'Cara desconcertada',
      'Kissing face': 'Cara que fa un petó',
      'Face throwing a kiss': 'Cara que llança un petó',
      'Kissing face with smiling eyes': 'Cara fent un petó amb ulls somrients',
      'Kissing face with closed eyes': 'Cara fent un petó amb els ulls tancats',
      'Face with stuck out tongue': 'Cara amb la llengua fora',
      'Face with stuck out tongue and winking eye': 'Cara amb la llengua fora i fent l’ullet',
      'Face with stuck out tongue and tightly-closed eyes': 'Cara amb la llengua fora i els ulls tancats fent força',
      'Disappointed face': 'Cara de decepció',
      'Worried face': 'Cara de preocupació',
      'Angry face': 'Cara enfadada',
      'Pouting face': 'Cara que fa el petarrell',
      'Crying face': 'Cara plorant',
      'Persevering face': 'Cara de perseverança',
      'Face with look of triumph': 'Cara amb expressió de triomf',
      'Disappointed but relieved face': 'Cara decebuda, però alleujada',
      'Frowning face with open mouth': 'Cara amb la boca oberta i les celles arrufades',
      'Anguished face': 'Cara angoixada',
      'Fearful face': 'Cara esporuguida',
      'Weary face': 'Cara esgotada',
      'Sleepy face': 'Cara somnolent',
      'Tired face': 'Cara cansada',
      'Grimacing face': 'Cara fent una ganyota',
      'Loudly crying face': 'Cara plorant en veu alta',
      'Face with open mouth': 'Cara amb la boca oberta',
      'Hushed face': 'Cara callada',
      'Face with open mouth and cold sweat': 'Cara amb la boca oberta i suor freda',
      'Face screaming in fear': 'Cara cridant de por',
      'Astonished face': 'Cara de sorpresa',
      'Flushed face': 'Cara enrojolada',
      'Sleeping face': 'Cara adormida',
      'Dizzy face': 'Cara marejada',
      'Face without mouth': 'Cara sense boca',
      'Face with medical mask': 'Cara amb mascareta mèdica',
      Break: 'Salta',
      Subscript: 'Subíndex',
      Superscript: 'Superíndex',
      Fullscreen: 'Pantalla completa',
      'Insert Horizontal Line': 'Afegeix línia horitzontal',
      'Clear Formatting': 'Elimina el format',
      Undo: 'Desfés',
      Redo: 'Refés',
      'Select All': 'Selecciona-ho tot',
      'Code View': 'Vista de codi',
      Quote: 'Citació',
      Increase: 'Augmenta',
      Decrease: 'Redueix',
      'Quick Insert': 'Inserció ràpida',
      'Special Characters': 'Caràcters especials',
      Latin: 'Llatí',
      Greek: 'Grec',
      Cyrillic: 'Ciríl·lic',
      Punctuation: 'Puntuació',
      Currency: 'Moneda',
      Arrows: 'Fletxes',
      Math: 'Mates',
      Misc: 'Miscel·lània',
      Print: 'Impressió',
      'Spell Checker': 'Corrector ortogràfic',
      Help: 'Ajuda',
      Shortcuts: 'Dreceres',
      'Inline Editor': 'Editor en línia',
      'Show the editor': 'Mostra l’editor',
      'Common actions': 'Accions comunes',
      Copy: 'Copia',
      Cut: 'Retalla',
      Paste: 'Enganxa',
      'Basic Formatting': 'Format bàsic',
      'Increase quote level': 'Augmenta el nivell de citació',
      'Decrease quote level': 'Redueix el nivell de citació',
      'Image / Video': 'Imatge / vídeo',
      'Resize larger': 'Fes més gran',
      'Resize smaller': 'Fes més petit',
      Table: 'Taula',
      'Select table cell': 'Selecciona una celdla',
      'Extend selection one cell': 'Amplia la selecció una cel·la',
      'Extend selection one row': 'Amplia la selecció una fila',
      Navigation: 'Navegació',
      'Focus popup / toolbar': 'Focus emergent / barra d’eines',
      'Return focus to previous position': 'Fes tornar el focus a la posició anterior',
      'Embed URL': 'Incrusta URL',
      'Paste in a URL to embed': 'Enganxa un url per incrustar',
      'The pasted content is coming from a Microsoft Word document. Do you want to keep the format or clean it up?': 'El contingut enganxat ve d’un document de Microsoft Word. Vols mantenir-ne el format?',
      Keep: 'Desa',
      Clean: 'Suprimeix',
      'Word Paste Detected': 'Paraula detectada',
      'Dashed Borders': 'Vores discontínues',
      'Alternate Rows': 'Files alternes',
      Highlighted: 'Ressaltada',
      Thick: 'Gruixuda',
      'Paste the URL of the video you want to insert.': 'Enganxa URL del vídeo que vols afegir. Compatible: Vimeo i Youtube.',
      'Paste in a video URL': 'URL del vídeo (Vimeo o Youtube).',
      'Number Group': 'No trencar',
      'More Text': 'Més text',
      'Text Color': 'Color de text',
      'Background Color': 'Color de fons',
      'More Paragraph': 'Més paràgraf',
      'More Rich': 'Més opcions',
      'More Misc': 'Més opcions',
      'Add blank': 'Afegeix buit',
      'Insert math expresion': 'Insereix expressió matemàtica',
      'Font size': 'Grandària de text',
      Default: 'Per defecte',
      'Lower Alpha': 'Alpha en minúscula',
      'Lower Greek': 'Gregas en minúscula',
      'Lower Roman': 'Romanes en minúscula',
      'Upper Alpha': 'Alpha majúscules',
      'Upper Roman': 'Romanes majúscules',
      Circle: 'Cercle',
      Square: 'Quadrat',
      Disc: 'Disc',
      'With Borders': 'Amb vores',
      'Insert Audio': 'Inserir àudio',
      'Upload Audio': 'Subir àudio',
      'Only icon play/stop': 'Només icona reproducir/parar',
      'Drop audio': 'Soltar àudio',
      'Paste in an audio URL': "Pegar una URL d'àudio",
      'Remove transcription': 'Eliminar transcripción',
      'Transcripción eliminada': 'Transcripción eliminada',
      'Drop transcription': 'Soltar transcripción',
      Transcription: 'Transcripció'
    },
    direction: 'ltr'
  };
  FroalaEditor.LANGUAGE.ca = literals;
}

function addEuskeraLang() {
  var literals = {
    translation: {
      'Type something': 'Idatzi zerbait',
      Bold: 'Letra lodia',
      Italic: 'It\xE1lica',
      Underline: 'Azpimarratua',
      Strikethrough: 'Ezabatua',
      Insert: 'Txertatu',
      Delete: 'Ezabatu',
      Cancel: 'Utzi',
      OK: 'Ok',
      Back: 'Atzera',
      Remove: 'Kendu',
      More: 'Gehiago',
      Update: 'Eguneratu',
      Style: 'Estiloa',
      'Font Family': 'Letra familia',
      'Font Size': 'Letraren neurria',
      Colors: 'Koloreak',
      Background: 'Atzealdea',
      Text: 'Testua',
      'HEX Color': 'Kolore hamaseitarra',
      'Paragraph Format': 'Paragrafo formatua',
      Normal: 'Normala',
      Code: 'Kodea',
      'Heading 1': '1. goiburua',
      'Heading 2': '2. goiburua',
      'Heading 3': '3. goiburua',
      'Heading 4': '4. goiburua',
      'Line Height': 'Lerroartea',
      'Paragraph Style': 'Paragrafo estiloa',
      'Inline Style': 'Lerro estiloa',
      Align: 'Lerrokatu',
      'Align Left': 'Lerrokatu ezkerrean',
      'Align Center': 'Lerrokatu erdian',
      'Align Right': 'Lerrokatu eskuinean',
      'Align Justify': 'Justifikatu',
      None: 'Batere ez',
      'Ordered List': 'Zerrenda ordenatua',
      'Unordered List': 'Zerrenda desordenatua',
      'Decrease Indent': 'Txikitu koska',
      'Increase Indent': 'Handitu koska',
      'Insert Link': 'Txertatu esteka',
      'Open in new tab': 'Ireki beste erlaitz batean',
      'Open Link': 'Ireki esteka',
      'Edit Link': 'Editatu esteka',
      Unlink: 'Kendu esteka',
      'Choose Link': 'Aukeratu esteka',
      'Insert Image': 'Txertatu irudia',
      'Upload Image': 'Kargatu irudia',
      'By URL': 'URL bidez',
      Browse: 'Arakatu',
      'Drop image': 'Askatu irudia',
      'or click': 'edo egin klik hemen:',
      'Manage Images': 'Administratu irudiak',
      Loading: 'Kargatzen',
      Deleting: 'Ezabatu',
      Tags: 'Etiketak',
      'Are you sure? Image will be deleted.': 'Ziur zaude? Irudia ezabatu egingo da.',
      Replace: 'Ordeztu',
      Uploading: 'Kargatu',
      'Loading image': 'Irudia kargatzen',
      Display: 'Erakutsi',
      Inline: 'Lerroan',
      'Break Text': 'Testu jauzia',
      'Alternative Text': 'Testu alternatiboa',
      'Change Size': 'Aldatu neurria',
      Width: 'Zabalera',
      Height: 'Altuera',
      'Something went wrong. Please try again.': 'Zerbait gaizki atera da. Mesedez, saiatu berriz.',
      'Image Caption': 'Pantaila irudia',
      'Advanced Edit': 'Edizio aurreratua',
      'Insert Video': 'Txertatu bideoa',
      'Embedded Code': 'Kodea txertatuta',
      'Drop video': 'Askatu bideoa',
      'Your browser does not support HTML5 video.': 'Zure nabigatzailea ez da bateragarria html5 bideoarekin.',
      'Upload Video': 'Igo bideoa',
      'Insert Table': 'Txertatu taula',
      'Table Header': 'Taularen goiburua',
      'Remove Table': 'Kendu taula',
      'Table Style': 'Taula estiloa',
      'Horizontal Align': 'Lerrokatze horizontala',
      Row: 'Fila',
      'Insert row above': 'Txertatu errenkada aurretik',
      'Insert row below': 'Txertatu errenkada ondoren',
      'Delete row': 'Ezabatu errenkada',
      Column: 'Zutabea',
      'Insert column before': 'Txertatu zutabea aurretik',
      'Insert column after': 'Txertatu errenkada ondoren',
      'Delete column': 'Ezabatu zutabea',
      Cell: 'Gelaxka',
      'Merge cells': 'Konbinatu gelaxkak',
      'Horizontal split': 'Zatiketa horizontala',
      'Vertical split': 'Zatiketa bertikala',
      'Cell Background': 'Gelaxkaren atzealdea',
      'Vertical Align': 'Lerrokatze bertikala',
      Top: 'Goi aldea',
      Middle: 'Erdi aldea',
      Bottom: 'Behe aldea',
      'Align Top': 'Lerrokatu goiko aldean',
      'Align Middle': 'Lerrokatu erdian',
      'Align Bottom': 'Lerrokatu behean',
      'Cell Style': 'Gelaxka estiloa',
      'Upload File': 'Igo fitxategia',
      'Drop file': 'Askatu fitxategia',
      Emoticons: 'Emotikonoak',
      'Grinning face': 'Aurpegia irribarrez',
      'Grinning face with smiling eyes': 'Aurpegia irribarrez, begi irribarretsuekin',
      'Face with tears of joy': 'Aurpegia pozaren pozez malkotan',
      'Smiling face with open mouth': 'Aurpegi irribarretsua, ahoa irekita',
      'Smiling face with open mouth and smiling eyes': 'Aurpegi irribarretsua, ahoa irekita eta begi irribarretsuekin',
      'Smiling face with open mouth and cold sweat': 'Aurpegi irribarretsua, ahoa irekita eta izerdi hotzarekin',
      'Smiling face with open mouth and tightly-closed eyes': 'Aurpegi irribarretsua, ahoa irekita eta begiak indarrez itxita',
      'Smiling face with halo': 'Aurpegi irribarretsua, argi koroarekin',
      'Smiling face with horns': 'Aurpegi irribarretsua, adarrekin',
      'Winking face': 'Aurpegiko keinua',
      'Smiling face with smiling eyes': 'Aurpegi irribarretsua, begi irribarretsuekin',
      'Face savoring delicious food': 'Janari gozagarria dastatzearen aurpegia',
      'Relieved face': 'Lasaitasun aurpegia',
      'Smiling face with heart-shaped eyes': 'Aurpegi irribarretsua, bihotz formako begiekin',
      'Smiling face with sunglasses': 'Aurpegi irribarretsua, eguzkitako betaurrekoekin',
      'Smirking face': 'Irribarre maltzurreko aurpegia',
      'Neutral face': 'Aurpegi neutrala',
      'Expressionless face': 'Espresiorik gabeko aurpegia',
      'Unamused face': 'Aspertu aurpegia',
      'Face with cold sweat': 'Aurpegia, izerdi hotzarekin',
      'Pensive face': 'Aurpegi pentsakorra',
      'Confused face': 'Aurpegi zalantzatia',
      'Confounded face': 'Aurpegi nahasia',
      'Kissing face': 'Aurpegia musu ematen',
      'Face throwing a kiss': 'Aurpegia musua botatzen',
      'Kissing face with smiling eyes': 'Aurpegia musua ematen, begi irribarretsuekin',
      'Kissing face with closed eyes': 'Aurpegia musua ematen, begiak itxita',
      'Face with stuck out tongue': 'Aurpegia mihia aterata',
      'Face with stuck out tongue and winking eye': 'Aurpegia mihia aterata eta begiarekin keinu egiten',
      'Face with stuck out tongue and tightly-closed eyes': 'Aurpegi mihia aterata eta begiak indarrez itxita',
      'Disappointed face': 'Desilusio aurpegia',
      'Worried face': 'Kezka aurpegia',
      'Angry face': 'Aurpegi haserretua',
      'Pouting face': 'Aurpegi txarra jarrita',
      'Crying face': 'Aurpegia negarrez',
      'Persevering face': 'Pertseberantzia aurpegia',
      'Face with look of triumph': 'Garaipen espresioa duen aurpegia',
      'Disappointed but relieved face': 'Desilusionatuta, baina aurpegia arinduta',
      'Frowning face with open mouth': 'Aurpegia, ahoa irekita eta bekozkoarekin',
      'Anguished face': 'Aurpegi larritua',
      'Fearful face': 'Aurpegi beldurtua',
      'Weary face': 'Aurpegi nekatua',
      'Sleepy face': 'Aurpegi logaletua',
      'Tired face': 'Aurpegi nekatua',
      'Grimacing face': 'Aurpegia keinu batekin',
      'Loudly crying face': 'Aurpegia ahots ozenez negarrez',
      'Face with open mouth': 'Aurpegia ahoa irekita',
      'Hushed face': 'Aurpegi isila',
      'Face with open mouth and cold sweat': 'Aurpegia ahoa irekita eta izerdi hotzarekin',
      'Face screaming in fear': 'Aurpegia beldurrez oihuka',
      'Astonished face': 'Aurpegi txunditua',
      'Flushed face': 'Aurpegi gorritua',
      'Sleeping face': 'Aurpegi lokartua',
      'Dizzy face': 'Aurpegi zorabiatua',
      'Face without mouth': 'Ahorik gabeko aurpegia',
      'Face with medical mask': 'Musuko medikoa duen aurpegia',
      Break: 'Etena',
      Subscript: 'Azpiindizea',
      Superscript: 'Goi indizea',
      Fullscreen: 'Pantaila osoa',
      'Insert Horizontal Line': 'Txertatu lerro horizontala',
      'Clear Formatting': 'Kendu formatua',
      Undo: 'Desegin',
      Redo: 'Berregin',
      'Select All': 'Aukeratu dena',
      'Code View': 'Kode ikuspegia',
      Quote: 'Aipua',
      Increase: 'Handitu',
      Decrease: 'Murriztu',
      'Quick Insert': 'Txertaketa bizkorra',
      'Special Characters': 'Karaktere bereziak',
      Latin: 'Latina',
      Greek: 'Greziera',
      Cyrillic: 'Zirilikoa',
      Punctuation: 'Puntuazioa',
      Currency: 'Moneta',
      Arrows: 'Geziak',
      Math: 'Mate',
      Misc: 'Nahas-mahasa',
      Print: 'Inprimaketa',
      'Spell Checker': 'Zuzentzaile ortografikoa',
      Help: 'Laguntza',
      Shortcuts: 'Lasterbideak',
      'Inline Editor': 'Online editorea',
      'Show the editor': 'Erakutsi editorea',
      'Common actions': 'Ohiko ekintzak',
      Copy: 'Kopiatu',
      Cut: 'Ebaki',
      Paste: 'Itsatsi',
      'Basic Formatting': 'Oinarrizko formatua',
      'Increase quote level': 'Kotizazio maila igo',
      'Decrease quote level': 'Kotizazio maila jaitsi',
      'Image / Video': 'Irudia / bideoa',
      'Resize larger': 'Birdimentsionatu handiena',
      'Resize smaller': 'Birdimentsionatu txikiena',
      Table: 'Taula',
      'Select table cell': 'Aukeratu taulako gelaxka',
      'Extend selection one cell': 'Zabaldu gelaxka baten hautapena',
      'Extend selection one row': 'Zabaldu errenkada baten hautapena',
      Navigation: 'Nabigazioa',
      'Focus popup / toolbar': 'Focus popup / toolbar',
      'Return focus to previous position': 'Itzuli aurreko posiziora',
      'Embed URL': 'Txertatutako URLa',
      'Paste in a URL to embed': 'Itsatsi txertatu beharreko URL batean',
      'The pasted content is coming from a Microsoft Word document. Do you want to keep the format or clean it up?': 'Itsatsitako edukia Microsoft Word dokumentu batetik dator. Formatua gorde nahi duzu edo garbitu egin nahi duzu?',
      Keep: 'Gorde',
      Clean: 'Garbitu',
      'Word Paste Detected': 'Hitza detektatuta',
      'Dashed Borders': 'Ertz etenak',
      'Alternate Rows': 'Errenkada alternatiboak',
      Highlighted: 'Nabarmendua',
      Thick: 'Lodia',
      'Paste the URL of the video you want to insert.': 'Itsatsi txertatu nahi duzun bideoaren URLa. Bateragarria: Vimeo eta Youtube.',
      'Paste in a video URL': 'Bideoaren URLa (Vimeo edo Youtube).',
      'Number Group': 'Hausturarik gabe',
      'More Text': 'Testu gehiago',
      'Text Color': 'Testuaren kolorea',
      'Background Color': 'Atzealdeko kolorea',
      'More Paragraph': 'Paragrafo gehiago',
      'More Rich': 'Aukera gehiago',
      'More Misc': 'Aukera gehiago',
      'Add blank': 'Gehitu hutsunea',
      'Insert math expresion': 'Sartu adierazpen matematiko bat',
      'Font size': 'Testuaren tamaina',
      Default: 'Lehenetsia',
      'Lower Alpha': 'Alpha minuskula',
      'Lower Greek': 'Grekoa minuskula',
      'Lower Roman': 'Erromatarra minuskula ',
      'Upper Alpha': 'Alpha hizki larriak',
      'Upper Roman': 'Erromatarra hizki larriak',
      Circle: 'Zirculu',
      Square: 'Karratu',
      Disc: 'Diskoa',
      'With Borders': 'Mugak',
      'Insert Audio': 'Gehitu audioa',
      'Upload Audio': 'Erantsi audioa',
      'Only icon play/stop': 'Erreproduzitu/gelditu ikonoa soilik',
      'Drop audio': 'Erantsi audioa',
      'Paste in an audio URL': 'Itsatsi audio-url bat',
      'Drop transcription': 'Erantsi testua',
      'Remove transcription': 'Ezabatu testua',
      'Transcripción eliminada': 'Testua ezabatu da',
      Transcription: 'Transkripzioa'
    },
    direction: 'ltr'
  };
  FroalaEditor.LANGUAGE.eu = literals;
}

((function addExtraLang() {
  FroalaEditor.LANGUAGE.es.translation = _extends({}, FroalaEditor.LANGUAGE.es.translation, {
    'Type something': 'Escribe algo',
    Default: 'Por defecto',
    Circle: 'Círculo',
    Disc: 'Disco',
    OK: 'OK',
    'Something went wrong. Please try again.': 'Ha habido un problema. Por favor, vuelve a intentarlo.',
    'Insert Video': 'Insertar vídeo',
    'Drop video': 'Soltar vídeo',
    'Your browser does not support HTML5 video.': 'Su navegador no es compatible con vídeos HTML5.',
    'Upload Video': 'Subir vídeo',
    'Remove Table': 'Borra la tabla',
    'Relieved face': 'Cara aliviada',
    Math: 'Matemáticas',
    Misc: 'Miscelánea',
    'Image / Video': 'Imagen / vídeo',
    Table: 'Tabla',
    'Select table cell': 'Celda de tabla seleccionada',
    'Focus popup / toolbar': 'Foco / barra de herramientas',
    'Return focus to previous position': 'Volver el foco a la posición anterior',
    'Embed URL': 'URL insertada',
    'Paste in a URL to embed': 'Pegar una URL para insertar',
    'Dashed Borders': 'Bordes discontinuos',
    'Alternate Rows': 'Filas alternativas',
    Highlighted: 'Destacada',
    Thick: 'Gruesa',
    'Paste the URL of the video you want to insert.': 'Pegar URL del vídeo que quieres insertar. Compatible: Vimeo y Youtube.',
    'Paste in a video URL': 'URL del vídeo (Vimeo o Youtube).',
    'Number Group': 'No romper',
    'More Text': 'Más texto',
    'Text Color': 'Color texto',
    'Background Color': 'Color fondo',
    'More Paragraph': 'Más párrafo',
    'More Rich': 'Más opciones',
    'More Misc': 'Más opciones',
    'Insert math expresion': 'Insertar expresión matemática',
    'With Borders': 'Con bordes',
    'Insert Audio': 'Insertar audio',
    'Upload Audio': 'Subir audio',
    'Only icon play/stop': 'Solo icono de reproducir/parar',
    'Drop audio': 'Soltar un audio',
    'Paste in an audio URL': 'Pegar una URL de audio',
    'Drop transcription': 'Soltar transcripción',
    Transcription: 'Transcripción'
  });
})());

function addGalicianLang() {
  var literals = {
    translation: {
      'Type something': 'Escribir algo',
      'Inline Class': 'Clase en liña',
      Single: 'Solteiro',
      Double: 'Doble',
      'More Misc': 'Máis diverso',
      'Download PDF': 'Descargar PDF',
      Bold: 'Grosa',
      Italic: 'Cursiva',
      Underline: 'Subliñado',
      Strikethrough: 'Tachado',
      Insert: 'Inserir',
      Delete: 'Borrar',
      Cancel: 'Cancelar',
      OK: 'OK',
      Back: 'Detrás',
      Remove: 'Quitar',
      More: 'Máis',
      Update: 'Actualizar',
      Style: 'Estilo',
      'Font Family': 'Familia tipográfica',
      'Font Size': 'Tamaño de letra',
      Colors: 'Cores',
      Background: 'Fondo',
      Text: 'Texto',
      'HEX Color': 'Cor hexadecimal',
      'Paragraph Format': 'Formato de parágrafo',
      Normal: 'Normal',
      Code: 'C\xF3digo',
      'Heading 1': 'Encabezado 1',
      'Heading 2': 'Encabezado 2',
      'Heading 3': 'Encabezado 3',
      'Heading 4': 'Encabezado 4',
      'Line Height': 'Interlineado',
      'Paragraph Style': 'Estilo de parágrafo',
      'Inline Style': 'Estilo en liña',
      Align: 'Aliñar',
      'Align Left': 'Aliñar á esquerda',
      'Align Center': 'Aliñar ó centro',
      'Align Right': 'Aliñar á dereita',
      'Align Justify': 'Xustificar',
      None: 'Ningún',
      'Ordered List': 'Lista ordenada',
      'Unordered List': 'Lista non ordenada',
      'Decrease Indent': 'Reducir sangr\xEDa',
      'Increase Indent': 'Aumentar sangr\xEDa',
      'Insert Link': 'Inserir ligazón',
      'Open in new tab': 'Abre en nova pestana',
      'Open Link': 'Abrir ligazón',
      'Edit Link': 'Editar enlace',
      Unlink: 'Quitar ligazón',
      'Choose Link': 'Elegir ligazón',
      'Insert Image': 'Inserir imaxe',
      'Upload Image': 'Cargar imaxe',
      'By URL': 'Por URL',
      Browse: 'Examinar',
      'Drop image': 'Soltaa a imaxe',
      'or click': 'o haga clic en',
      'Manage Images': 'Xestionar imaxes',
      Loading: 'Cargando',
      Deleting: 'Borrado',
      Tags: 'Etiquetas',
      'Are you sure? Image will be deleted.': 'Estás seguro? La imaxe será eliminada.',
      Replace: 'Reemplazar',
      Uploading: 'Carga',
      'Loading image': 'Cargando imaxe',
      Display: 'Mostrar',
      Inline: 'En liña',
      'Break Text': 'Romper texto',
      'Alternative Text': 'Texto alternativo',
      'Change Size': 'Cambiar tama\xF1o',
      Width: 'Ancho',
      Height: 'Altura',
      'Something went wrong. Please try again.': 'Houbo un problema. Por favor intentao de novo.',
      'Image Caption': 'Captura de imaxe',
      'Advanced Edit': 'Edición avanzada',
      'Insert Video': 'Incorporar vídeo',
      'Embedded Code': 'C\xF3digo incrustado',
      'Paste in a video URL': 'Pegar o URL dun vídeo',
      'Drop video': 'Soltar vídeo',
      'Your browser does not support HTML5 video.': 'O teu navegador non admite vídeos HTML5.',
      'Upload Video': 'Cargar vídeo',
      'Insert Table': 'Inserir taboa',
      'Table Header': 'Cabeceira da taboa',
      'Remove Table': 'Borra la taboa',
      'Table Style': 'Estilo da taboa',
      'Horizontal Align': 'Aliñar horizontal',
      Row: 'Fila',
      'Insert row above': 'Inserir fila antes',
      'Insert row below': 'Inserir fila despois',
      'Delete row': 'Borrar fila',
      Column: 'Columna',
      'Insert column before': 'Inserir columna antes',
      'Insert column after': 'Inserir columna despois',
      'Delete column': 'Eliminar columna',
      Cell: 'Célula',
      'Merge cells': 'Combinar células',
      'Horizontal split': 'Divisi\xF3n horizontal',
      'Vertical split': 'Divisi\xF3n vertical',
      'Cell Background': 'Fondo da célula',
      'Vertical Align': 'Aliñar vertical',
      Top: 'Cima',
      Middle: 'Medio',
      Bottom: 'Del fondo',
      'Align Top': 'Aliñar parte superior',
      'Align Middle': 'Aliñar media',
      'Align Bottom': 'Aliñar abajo',
      'Cell Style': 'Estilo de celda',
      'Upload File': 'Subir ficheiro',
      'Drop file': 'Soltar ficheiro',
      Emoticons: 'Emoticonos',
      'Grinning face': 'Cara sonriendo',
      'Grinning face with smiling eyes': 'Cara sonriendo con ojos sonrientes',
      'Face with tears of joy': 'Cara con l\xE1grimas de alegr\xEDa',
      'Smiling face with open mouth': 'Cara sonriente con la boca abierta',
      'Smiling face with open mouth and smiling eyes': 'Cara sonriente con la boca abierta y los ojos sonrientes',
      'Smiling face with open mouth and cold sweat': 'Cara sonriente con la boca abierta y el sudor fr\xEDo',
      'Smiling face with open mouth and tightly-closed eyes': 'Cara sonriente con la boca abierta y los ojos fuertemente cerrados',
      'Smiling face with halo': 'Cara sonriente con halo',
      'Smiling face with horns': 'Cara sonriente con cuernos',
      'Winking face': 'Gui\xF1o de la cara',
      'Smiling face with smiling eyes': 'Cara sonriente con ojos sonrientes',
      'Face savoring delicious food': 'Cara de saborear una deliciosa comida',
      'Relieved face': 'Cara aliviada',
      'Smiling face with heart-shaped eyes': 'Cara sonriente con los ojos en forma de coraz\xF3n',
      'Smiling face with sunglasses': 'Cara sonriente con gafas de sol',
      'Smirking face': 'Sonriendo cara',
      'Neutral face': 'Cara neutral',
      'Expressionless face': 'Rostro inexpresivo',
      'Unamused face': 'Cara aburrida',
      'Face with cold sweat': 'Cara con sudor fr\xEDo',
      'Pensive face': 'Rostro pensativo',
      'Confused face': 'Cara confusa',
      'Confounded face': 'Cara aturdida',
      'Kissing face': 'Cara besando',
      'Face throwing a kiss': 'Cara lanzando un beso',
      'Kissing face with smiling eyes': 'Cara besando con ojos sonrientes',
      'Kissing face with closed eyes': 'Cara besando con los ojos cerrados',
      'Face with stuck out tongue': 'Cara con la lengua pegada',
      'Face with stuck out tongue and winking eye': 'Cara con la lengua pegada y el ojo parpadeante',
      'Face with stuck out tongue and tightly-closed eyes': 'Cara con la lengua pegada y los ojos fuertemente cerrados',
      'Disappointed face': 'Cara de decepcionado',
      'Worried face': 'Cara de preocupaci\xF3n',
      'Angry face': 'Cara enojada',
      'Pouting face': 'Que pone mala cara',
      'Crying face': 'Cara llorando',
      'Persevering face': 'Cara de perseverancia',
      'Face with look of triumph': 'Cara con expresi\xF3n de triunfo',
      'Disappointed but relieved face': 'Decepcionado pero el rostro aliviado',
      'Frowning face with open mouth': 'Cara con la boca abierta con el ce\xF1o fruncido',
      'Anguished face': 'Rostro angustiado',
      'Fearful face': 'Cara temerosa',
      'Weary face': 'Rostro cansado',
      'Sleepy face': 'Rostro somnoliento',
      'Tired face': 'Rostro cansado',
      'Grimacing face': 'Cara haciendo una mueca',
      'Loudly crying face': 'Cara llorando en voz alta',
      'Face with open mouth': 'Cara con la boca abierta',
      'Hushed face': 'Cara callada',
      'Face with open mouth and cold sweat': 'Cara con la boca abierta y el sudor frío',
      'Face screaming in fear': 'Cara gritando de miedo',
      'Astonished face': 'Cara asombrosa',
      'Flushed face': 'Cara enrojecida',
      'Sleeping face': 'Rostro dormido',
      'Dizzy face': 'Cara mareada',
      'Face without mouth': 'Cara sin boca',
      'Face with medical mask': 'Cara con la m\xE1scara m\xE9dica',
      Break: 'Romper',
      Subscript: 'Sub\xEDndice',
      Superscript: 'Super\xEDndice',
      Fullscreen: 'Pantalla completa',
      'Insert Horizontal Line': 'Inserir liña horizontal',
      'Clear Formatting': 'Quitar o formato',
      Undo: 'Deshacer',
      Redo: 'Rehacer',
      'Select All': 'Seleccionar todo',
      'Code View': 'Vista de c\xF3digo',
      Quote: 'Cita',
      Increase: 'Aumentar',
      Decrease: 'Diminuír',
      'Quick Insert': 'Inserci\xF3n r\xE1pida',
      'Special Characters': 'Caracteres especiales',
      Latin: 'Latín',
      Greek: 'Grego',
      Cyrillic: 'Cirílico',
      Punctuation: 'Puntuación',
      Currency: 'Moeda',
      Arrows: 'Frechas',
      Math: 'Matemáticas',
      Misc: 'Miscelánea',
      Print: 'Impresión',
      'Spell Checker': 'Corrector ortográfico',
      Help: 'Axuda',
      Shortcuts: 'Atallos',
      'Inline Editor': 'Editor en liña',
      'Show the editor': 'Mostrar al editor',
      'Common actions': 'Acciones comunes',
      Copy: 'Copiar',
      Cut: 'Cortar',
      Paste: 'Pegar',
      'Basic Formatting': 'Formato básico',
      'Increase quote level': 'Aumentar el nivel de cotización',
      'Decrease quote level': 'Disminuir el nivel de cotización',
      'Image / Video': 'Imaxe / vídeo',
      'Resize larger': 'Redimensionar máis grande',
      'Resize smaller': 'Redimensionar máis pequeno',
      Table: 'Táboa',
      'Select table cell': 'Celda da táboa seleccionada',
      'Extend selection one cell': 'Amplía a selección nunha cela',
      'Extend selection one row': 'Amplía a selección nunha fila',
      Navigation: 'Navegación',
      'Focus popup / toolbar': 'Foco / barra de ferramientas',
      'Return focus to previous position': 'Volver el foco a la posición anterior',
      'Embed URL': 'URL insertada',
      'Paste in a URL to embed': 'Pegar una URL para insertar',
      'The pasted content is coming from a Microsoft Word document. Do you want to keep the format or clean it up?': 'El contenido pegado viene de un documento de Microsoft Word. ¿Quieres mantener el formato o limpiarlo?',
      Keep: 'Gardar',
      Clean: 'Limpar',
      'Word Paste Detected': 'Palabra detectada',
      'More Text': 'Máis texto',
      'Add blank': 'Añadir hueco',
      'More Paragraph': 'Máis párrafo',
      'Text Color': 'Cor texto',
      'Background Color': 'Cor fondo',
      'Insert math expresion': 'Inserir expresión matemática',
      'Number Group': 'Non romper',
      'More Rich': 'Máis opcións',
      'Font size': 'Tamaño do texto',
      Default: 'Por defecto',
      'Lower Alpha': 'Alpha en minúscula',
      'Lower Greek': 'Grego en minúscula',
      'Lower Roman': 'Romano en minúscula',
      'Upper Alpha': 'Alpha mayúsculas',
      'Upper Roman': 'Romano mayúscula',
      Circle: 'Círculo',
      Square: 'Cadrado',
      Disc: 'Disco',
      'Dashed Borders': 'Bordos discontinuos',
      'Alternate Rows': 'Filas alternativas',
      Highlighted: 'Destacada',
      Thick: 'Groso',
      'With Borders': 'Con bordes',
      'Insert Audio': 'Inserir audio',
      'Upload Audio': 'Subir audio',
      'Only icon play/stop': 'Só ícono de reproducir/parar',
      'Drop audio': 'Soltar un audio',
      'Paste in an audio URL': 'Pegar un URL de audio',
      'Drop transcription': 'Soltar transcripción',
      'Remove transcription': 'Eliminar transcripción',
      'Transcripción eliminada': 'Transcripción eliminada',
      Transcription: 'Transcrición'
    },
    direction: 'ltr'
  };
  FroalaEditor.LANGUAGE.gl = literals;
}

function addPortugueseLang() {
  var literals = {
    translation: {
      'Type something': 'Digite algo',
      Bold: 'Negrito',
      Italic: 'Itálico',
      Underline: 'Sublinhar',
      Strikethrough: 'Tachado',
      Insert: 'Inserir',
      Delete: 'Apagar',
      Cancel: 'Cancelar',
      OK: 'Ok',
      Back: 'Voltar',
      Remove: 'Remover',
      More: 'Mais',
      Update: 'Atualizar',
      Style: 'Estilo',
      'Font Family': 'Fonte',
      'Font Size': 'Tamanho',
      Colors: 'Cores',
      Background: 'Fundo',
      Text: 'Texto',
      'Text Color': 'Cor do texto',
      'Background Color': 'Cor do preenchimento',
      'HEX Color': 'Cor hexadecimal',
      'Paragraph Format': 'Formatos',
      Normal: 'Normal',
      Code: 'Código',
      'Heading 1': 'Cabeçalho 1',
      'Heading 2': 'Cabeçalho 2',
      'Heading 3': 'Cabeçalho 3',
      'Heading 4': 'Cabeçalho 4',
      'Paragraph Style': 'Estilo de parágrafo',
      'Inline Style': 'Estilo embutido',
      Align: 'Alinhar',
      'Align Left': 'Alinhar à esquerda',
      'Align Center': 'Centralizar',
      'Align Right': 'Alinhar à direita',
      'Align Justify': 'Justificar',
      None: 'Nenhum',
      'Ordered List': 'Lista numérica',
      'Unordered List': 'Lista com símbolos',
      Default: 'Padrão',
      'Lower Alpha': 'Letra minúscula',
      'Lower Greek': 'Letra grega',
      'Lower Roman': 'Número romano',
      'Upper Alpha': 'Letra maiúscula',
      'Upper Roman': 'Número romano maiúsculo',
      Circle: '&#9675;',
      Disc: '&#9679;',
      Square: '&#9632;',
      'Decrease Indent': 'Diminuir recuo',
      'Increase Indent': 'Aumentar recuo',
      'Insert Link': 'Inserir link',
      'Open in new tab': 'Abrir em uma nova aba',
      'Open Link': 'Abrir link',
      'Edit Link': 'Editar link',
      Unlink: 'Remover link',
      'Choose Link': 'Escolha o link',
      'Insert Image': 'Inserir imagem',
      'Upload Image': 'Carregar imagem',
      'By URL': 'Por um endereço URL',
      Browse: 'Procurar',
      'Drop image': 'Arraste sua imagem aqui',
      'or click': 'ou clique aqui para fazer o envio',
      'Manage Images': 'Gerenciar imagens',
      Loading: 'Carregando',
      Deleting: 'Excluindo',
      Tags: 'Etiquetas',
      'Are you sure? Image will be deleted.': 'Você tem certeza? A imagem será apagada.',
      Replace: 'Substituir',
      Uploading: 'Carregando imagem',
      'Loading image': 'Carregando imagem',
      Display: 'Exibir',
      Inline: 'Em linha',
      'Break Text': 'Texto de quebra',
      'Alternate Text': 'Texto alternativo',
      'Change Size': 'Alterar tamanho',
      Width: 'Largura',
      Height: 'Altura',
      'Something went wrong. Please try again.': 'Algo deu errado. Por favor, tente novamente.',
      'Image Caption': 'Legenda da imagem',
      'Advanced Edit': 'Edição avançada',
      'Insert Video': 'Inserir vídeo',
      'Embedded Code': 'Código embutido',
      'Paste in a video URL': 'Colar um endereço de vídeo',
      'Drop video': 'Solte o vídeo',
      'Your browser does not support HTML5 vídeo.': 'Seu navegador não suporta vídeo em HTML5.',
      'Upload Video': 'Carregar vídeo',
      'Insert Table': 'Inserir tabela',
      'Table Header': 'Cabeçalho da tabela',
      'Remove Table': 'Remover tabela',
      'Table Style': 'Estilo de tabela',
      'Horizontal Align': 'Alinhamento horizontal',
      Row: 'Linha',
      'Insert row above': 'Inserir linha antes',
      'Insert row below': 'Inserir linha depois',
      'Delete row': 'Excluir linha',
      Column: 'Coluna',
      'Insert column before': 'Inserir coluna antes',
      'Insert column after': 'Inserir coluna depois',
      'Delete column': 'Excluir coluna',
      Cell: 'Célula',
      'Merge cells': 'Agrupar células',
      'Horizontal split': 'Divisão horizontal',
      'Vertical split': 'Divisão vertical',
      'Cell Background': 'Fundo da célula',
      'Vertical Align': 'Alinhamento vertical',
      Top: 'Topo',
      Middle: 'Meio',
      Bottom: 'Fundo',
      'Align Top': 'Alinhar topo',
      'Align Middle': 'Alinhar meio',
      'Align Bottom': 'Alinhar fundo',
      'Cell Style': 'Estilo de célula',
      'Upload File': 'Carregar arquivo',
      'Drop file': 'Arraste seu arquivo aqui',
      Emoticons: 'Emoticons',
      'Grinning face': 'Rosto sorrindo',
      'Grinning face with smiling eyes': 'Rosto sorrindo rosto com olhos sorridentes',
      'Face with tears of joy': 'Rosto com lágrimas de alegria',
      'Smiling face with open mouth': 'Rosto sorrindo com a boca aberta',
      'Smiling face with open mouth and smiling eyes': 'Rosto sorrindo com a boca aberta e olhos sorridentes',
      'Smiling face with open mouth and cold sweat': 'Rosto sorrindo com a boca aberta e suor frio',
      'Smiling face with open mouth and tightly-closed eyes': 'Rosto sorrindo com a boca aberta e os olhos bem fechados',
      'Smiling face with halo': 'Rosto sorrindo com aréola',
      'Smiling face with horns': 'Rosto sorrindo com chifres',
      'Winking face': 'Rosto piscando',
      'Smiling face with smiling eyes': 'Rosto sorrindo com olhos sorridentes',
      'Face savoring delicious food': 'Rosto saboreando uma deliciosa comida',
      'Relieved face': 'Rosto aliviado',
      'Smiling face with heart-shaped eyes': 'Rosto sorrindo com os olhos em forma de coração',
      'Smiling face with sunglasses': 'Rosto sorrindo com óculos de sol',
      'Smirking face': 'Rosto sorridente',
      'Neutral face': 'Rosto neutro',
      'Expressionless face': 'Rosto inexpressivo',
      'Unamused face': 'Rosto sem expressão',
      'Face with cold sweat': 'Rosto com suor frio',
      'Pensive face': 'Rosto pensativo',
      'Confused face': 'Rosto confuso',
      'Confounded face': 'Rosto atônito',
      'Kissing face': 'Rosto beijando',
      'Face throwing a kiss': 'Rosto jogando um beijo',
      'Kissing face with smiling eyes': 'Rosto beijando com olhos sorridentes',
      'Kissing face with closed eyes': 'Rosto beijando com os olhos fechados',
      'Face with stuck out tongue': 'Rosto com a língua para fora',
      'Face with stuck out tongue and winking eye': 'Rosto com a língua para fora e um olho piscando',
      'Face with stuck out tongue and tightly-closed eyes': 'Rosto com a língua para fora e os olhos bem fechados',
      'Disappointed face': 'Rosto decepcionado',
      'Worried face': 'Rosto preocupado',
      'Angry face': 'Rosto irritado',
      'Pouting face': 'Rosto com beicinho',
      'Crying face': 'Rosto chorando',
      'Persevering face': 'Rosto perseverante',
      'Face with look of triumph': 'Rosto com olhar de triunfo',
      'Disappointed but relieved face': 'Rosto decepcionado mas aliviado',
      'Frowning face with open mouth': 'Rosto franzido com a boca aberta',
      'Anguished face': 'Rosto angustiado',
      'Fearful face': 'Rosto com medo',
      'Weary face': 'Rosto cansado',
      'Sleepy face': 'Rosto com sono',
      'Tired face': 'Rosto cansado',
      'Grimacing face': 'Rosto fazendo careta',
      'Loudly crying face': 'Rosto chorando alto',
      'Face with open mouth': 'Rosto com a boca aberta',
      'Hushed face': 'Rosto silencioso',
      'Face with open mouth and cold sweat': 'Rosto com a boca aferta e suando frio',
      'Face screaming in fear': 'Rosto gritando de medo',
      'Astonished face': 'Rosto surpreso',
      'Flushed face': 'Rosto envergonhado',
      'Sleeping face': 'Rosto dormindo',
      'Dizzy face': 'Rosto tonto',
      'Face without mouth': 'Rosto sem boca',
      'Face with medical mask': 'Rosto com máscara médica',
      Break: 'Quebrar linha',
      Subscript: 'Subscrito',
      Superscript: 'Sobrescrito',
      Fullscreen: 'Tela cheia',
      'Insert Horizontal Line': 'Inserir linha horizontal',
      'Clear Formatting': 'Limpar formatação',
      Save: 'Salve',
      Undo: 'Desfazer',
      Redo: 'Refazer',
      'Select All': 'Selecionar tudo',
      'Code View': 'Exibir de código',
      Quote: 'Citação',
      Increase: 'Aumentar',
      Decrease: 'Diminuir',
      'Quick Insert': 'Inserção rápida',
      'Special Characters': 'Caracteres especiais',
      Latin: 'Latino',
      Greek: 'Grego',
      Cyrillic: 'Cirílico',
      Punctuation: 'Pontuação',
      Currency: 'Moeda',
      Arrows: 'Setas',
      Math: 'Matemática',
      Misc: 'Misc',
      Print: 'Impressão',
      'Spell Checker': 'Corretor ortográfico',
      Help: 'Ajuda',
      Shortcuts: 'Atalhos',
      'Inline Editor': 'Editor em linha',
      'Show the editor': 'Mostre o editor',
      'Common actions': 'Ações comuns',
      Copy: 'Cópia de',
      Cut: 'Cortar',
      Paste: 'Colar',
      'Basic Formatting': 'Formatação básica',
      'Increase quote level': 'Aumentar o nível de cotação',
      'Decrease quote level': 'Diminuir o nível de cotação',
      'Image / Video': 'Imagem / Vídeo',
      'Resize larger': 'Redimensionar maior',
      'Resize smaller': 'Redimensionar menor',
      Table: 'Tabela',
      'Select table cell': 'Selecione a célula da tabela',
      'Extend selection one cell': 'Ampliar a seleção de uma célula',
      'Extend selection one row': 'Ampliar a seleção de uma linha',
      Navigation: 'Navegação',
      'Focus popup / toolbar': 'Pop-up de foco / Barra de ferramentas',
      'Return focus to previous position': 'Retornar o foco para a posição anterior',
      'Embed URL': 'URL de inserção',
      'Paste in a URL to embed': 'Colar um endereço URL para incorporar',
      'The pasted content is coming from a Microsoft Word document. Do you want to keep the format or clean it up?': 'O conteúdo colado vem de um documento Microsoft Word. Você quer manter o formato ou limpá-lo?',
      Keep: 'Manter formatação',
      Clean: 'Limpar formatação',
      'Word Paste Detected': 'Texto do Word detectado',
      Characters: 'Caracteres',
      'More Text': 'Mais Texto',
      'More Paragraph': 'Parágrafo',
      'More Rich': 'Mais Rico',
      'More Misc': 'Mais',
      'Add blank': 'Adicionar lacuna',
      'Insert math expresion': 'Inserir expressão matemática',
      'Number Group': 'Não quebre',
      'Font size': 'Tamanho do texto',
      'Please use valid files: mp3 or webm.': 'Favor utilizar arquivos válidos: mp3 ou webm',
      'Insert Audio': 'Inserir áudio',
      'Alternative Text': 'Texto alternativo',
      'Only icon play/stop': 'Exibir somente ícone do áudio',
      'Drop audio': 'Arrastar e soltar',
      'Paste in an audio URL': 'Colar o link do áudio',
      'Drop transcription': 'Arrastar e soltar transcrição',
      'Remove transcription': 'Remover transcrição',
      'Transcripción eliminada': 'Transcrição eliminada',
      Transcription: 'Transcrição'
    },
    direction: 'ltr'
  };
  FroalaEditor.LANGUAGE.pt_br = literals;
  FroalaEditor.LANGUAGE.pt = literals;
}

function addValencianLang() {
  var literals = {
    translation: {
      'Type something': 'Escriu alguna cosa',
      Bold: 'Negreta',
      Italic: 'Itàlica',
      Underline: 'Subratllat',
      Strikethrough: 'Ratllat',
      Insert: 'Afegeix',
      Delete: 'Esborra',
      Cancel: 'Cancel·la',
      OK: 'Ok',
      Back: 'Enrere',
      Remove: 'Elimina',
      More: 'Més',
      Update: 'Actualització',
      Style: 'Estil',
      'Font Family': 'Família de fonts',
      'Font Size': 'Mida de font',
      Colors: 'Colors',
      Background: 'Fons',
      Text: 'Text',
      'HEX Color': 'Color hexadecimal',
      'Paragraph Format': 'Format de paràgraf',
      Normal: 'Normal',
      Code: 'Codi',
      'Heading 1': 'Encapçalament 1',
      'Heading 2': 'Encapçalament 2',
      'Heading 3': 'Encapçalament 3',
      'Heading 4': 'Encapçalament 4',
      'Paragraph Style': 'Estil de paràgraf',
      'Inline Style': 'Estil en línia',
      Align: 'Alinea',
      'Align Left': 'Alinea a l’esquerra',
      'Align Center': 'Alinea al centre',
      'Align Right': 'Alinea a la dreta',
      'Align Justify': 'Justifica',
      None: 'Cap',
      'Ordered List': 'Llista ordenada',
      'Unordered List': 'Llista desordenada',
      'Decrease Indent': 'Redueix el sagnat',
      'Increase Indent': 'Augmenta el sagnat',
      'Insert Link': 'Afegeix enllaç',
      'Open in new tab': 'Obre en una pestanya nova',
      'Open Link': 'Obre l’enllaç',
      'Edit Link': 'Edita l’enllaç',
      Unlink: 'Elimina l’enllaç',
      'Choose Link': 'Tria l’enllaç',
      'Insert Image': 'Afegeix una imatge',
      'Upload Image': 'Carrega una imatge',
      'By URL': 'Per URL',
      Browse: 'Examina',
      'Drop image': 'Deixa anar la imatge',
      'or click': 'o fes clic a',
      'Manage Images': 'Administra imatges',
      Loading: 'S’està carregant',
      Deleting: 'S’està suprimint',
      Tags: 'Etiquetes',
      'Are you sure? Image will be deleted.': 'N’estàs segur? La imatge se suprimirà.',
      Replace: 'Canvia',
      Uploading: 'S’està pujant',
      'Loading image': 'S’està carregant la imatge',
      Display: 'Visualitza',
      Inline: 'En línia',
      'Break Text': 'Salta el text',
      'Alternative Text': 'Text alternatiu',
      'Change Size': 'Canvia la mida',
      Width: 'Amplada',
      Height: 'Alçària',
      'Something went wrong. Please try again.': 'Alguna cosa no ha anat bé. Si us plau, torna-ho a provar.',
      'Image Caption': 'Captura d’imatge',
      'Advanced Edit': 'Edició avançada',
      'Insert Video': 'Afegeix vídeo',
      'Embedded Code': 'Codi incrustat',
      'Drop video': 'Deixa anar el vídeo',
      'Your browser does not support HTML5 video.': 'El teu navegador no és compatible amb vídeo html5.',
      'Upload Video': 'Puja un vídeo',
      'Insert Table': 'Afegeix una taula',
      'Table Header': 'Capçalera de la taula',
      'Remove Table': 'Elimina la taula',
      'Table Style': 'Estil de taula',
      'Horizontal Align': 'Alineació horitzontal',
      Row: 'Fila',
      'Insert row above': 'Afegeix fila abans',
      'Insert row below': 'Afegeix fila després',
      'Delete row': 'Elimina fila',
      Column: 'Columna',
      'Insert column before': 'Afegeix columna abans',
      'Insert column after': 'Afegeix columna després',
      'Delete column': 'Elimina columna',
      Cell: 'Cel·la',
      'Merge cells': 'Combina cel·les',
      'Horizontal split': 'Divisió horitzontal',
      'Vertical split': 'Divisió vertical',
      'Cell Background': 'Fons de la cel·la',
      'Vertical Align': 'Alineació vertical',
      Top: 'Part superior',
      Middle: 'Centre',
      Bottom: 'Part inferior',
      'Align Top': 'Alineació superior',
      'Align Middle': 'Alineació central',
      'Align Bottom': 'Alineació inferior',
      'Cell Style': 'Estil de cel·la',
      'Upload File': 'Carrega un fitxer',
      'Drop file': 'Deixa anar el fitxer',
      Emoticons: 'Emoticones',
      'Grinning face': 'Cara somrient',
      'Grinning face with smiling eyes': 'Cara somrient amb ulls somrients',
      'Face with tears of joy': 'Cara amb llàgrimes d’alegria',
      'Smiling face with open mouth': 'Cara somrient amb la boca oberta',
      'Smiling face with open mouth and smiling eyes': 'Cara somrient amb la boca oberta i els ulls somrients',
      'Smiling face with open mouth and cold sweat': 'Cara somrient amb la boca oberta i suor freda',
      'Smiling face with open mouth and tightly-closed eyes': 'Cara somrient amb la boca oberta i els ulls tancats fent força',
      'Smiling face with halo': 'Cara somrient amb halo',
      'Smiling face with horns': 'Cara somrient amb banyes',
      'Winking face': 'Cara que fa l’ullet',
      'Smiling face with smiling eyes': 'Cara somrient amb ulls somrients',
      'Face savoring delicious food': 'Cara d’assaborir un menjar deliciós',
      'Relieved face': 'Cara d’alleujament',
      'Smiling face with heart-shaped eyes': 'Cara somrient amb els ulls en forma de cor',
      'Smiling face with sunglasses': 'Cara somrient amb ulleres de sol',
      'Smirking face': 'Cara amb somriure de satisfacció',
      'Neutral face': 'Cara neutra',
      'Expressionless face': 'Cara inexpressiva',
      'Unamused face': 'Cara avorrida',
      'Face with cold sweat': 'Cara amb suor freda',
      'Pensive face': 'Cara pensativa',
      'Confused face': 'Cara confusa',
      'Confounded face': 'Cara desconcertada',
      'Kissing face': 'Cara que fa un petó',
      'Face throwing a kiss': 'Cara que llança un petó',
      'Kissing face with smiling eyes': 'Cara fent un petó amb ulls somrients',
      'Kissing face with closed eyes': 'Cara fent un petó amb els ulls tancats',
      'Face with stuck out tongue': 'Cara amb la llengua fora',
      'Face with stuck out tongue and winking eye': 'Cara amb la llengua fora i fent l’ullet',
      'Face with stuck out tongue and tightly-closed eyes': 'Cara amb la llengua fora i els ulls tancats fent força',
      'Disappointed face': 'Cara de decepció',
      'Worried face': 'Cara de preocupació',
      'Angry face': 'Cara enfadada',
      'Pouting face': 'Cara que fa el petarrell',
      'Crying face': 'Cara plorant',
      'Persevering face': 'Cara de perseverança',
      'Face with look of triumph': 'Cara amb expressió de triomf',
      'Disappointed but relieved face': 'Cara decebuda, però alleujada',
      'Frowning face with open mouth': 'Cara amb la boca oberta i les celles arrufades',
      'Anguished face': 'Cara angoixada',
      'Fearful face': 'Cara esporuguida',
      'Weary face': 'Cara esgotada',
      'Sleepy face': 'Cara somnolent',
      'Tired face': 'Cara cansada',
      'Grimacing face': 'Cara fent una ganyota',
      'Loudly crying face': 'Cara plorant en veu alta',
      'Face with open mouth': 'Cara amb la boca oberta',
      'Hushed face': 'Cara callada',
      'Face with open mouth and cold sweat': 'Cara amb la boca oberta i suor freda',
      'Face screaming in fear': 'Cara cridant de por',
      'Astonished face': 'Cara de sorpresa',
      'Flushed face': 'Cara enrojolada',
      'Sleeping face': 'Cara adormida',
      'Dizzy face': 'Cara marejada',
      'Face without mouth': 'Cara sense boca',
      'Face with medical mask': 'Cara amb mascareta mèdica',
      Break: 'Salta',
      Subscript: 'Subíndex',
      Superscript: 'Superíndex',
      Fullscreen: 'Pantalla completa',
      'Insert Horizontal Line': 'Afegeix línia horitzontal',
      'Clear Formatting': 'Elimina el format',
      Undo: 'Desfés',
      Redo: 'Refés',
      'Select All': 'Selecciona-ho tot',
      'Code View': 'Vista de codi',
      Quote: 'Citació',
      Increase: 'Augmenta',
      Decrease: 'Redueix',
      'Quick Insert': 'Inserció ràpida',
      'Special Characters': 'Caràcters especials',
      Latin: 'Llatí',
      Greek: 'Grec',
      Cyrillic: 'Ciríl·lic',
      Punctuation: 'Puntuació',
      Currency: 'Moneda',
      Arrows: 'Fletxes',
      Math: 'Mates',
      Misc: 'Miscel·lània',
      Print: 'Impressió',
      'Spell Checker': 'Corrector ortogràfic',
      Help: 'Ajuda',
      Shortcuts: 'Dreceres',
      'Inline Editor': 'Editor en línia',
      'Show the editor': 'Mostra l’editor',
      'Common actions': 'Accions comunes',
      Copy: 'Copia',
      Cut: 'Retalla',
      Paste: 'Enganxa',
      'Basic Formatting': 'Format bàsic',
      'Increase quote level': 'Augmenta el nivell de citació',
      'Decrease quote level': 'Redueix el nivell de citació',
      'Image / Video': 'Imatge / vídeo',
      'Resize larger': 'Fes més gran',
      'Resize smaller': 'Fes més petit',
      Table: 'Taula',
      'Select table cell': 'Selecciona una celdla',
      'Extend selection one cell': 'Amplia la selecció una cel·la',
      'Extend selection one row': 'Amplia la selecció una fila',
      Navigation: 'Navegació',
      'Focus popup / toolbar': 'Focus emergent / barra d’eines',
      'Return focus to previous position': 'Fes tornar el focus a la posició anterior',
      'Embed URL': 'Incrusta URL',
      'Paste in a URL to embed': 'Enganxa un url per incrustar',
      'The pasted content is coming from a Microsoft Word document. Do you want to keep the format or clean it up?': 'El contingut enganxat ve d’un document de Microsoft Word. Vols mantenir-ne el format?',
      Keep: 'Desa',
      Clean: 'Suprimeix',
      'Word Paste Detected': 'Paraula detectada',
      'Dashed Borders': 'Vores discontínues',
      'Alternate Rows': 'Files alternes',
      Highlighted: 'Ressaltada',
      Thick: 'Gruixuda',
      'Paste the URL of the video you want to insert.': 'Enganxa URL del vídeo que vols afegir. Compatible: Vimeo i Youtube.',
      'Paste in a video URL': 'URL del vídeo (Vimeo o Youtube).',
      'Number Group': 'No trencar',
      'More Text': 'Més text',
      'Text Color': 'Color de text',
      'Background Color': 'Color de fons',
      'More Paragraph': 'Més paràgraf',
      'More Rich': 'Més opcions',
      'More Misc': 'Més opcions',
      'Add blank': 'Afegeix buit',
      'Insert math expresion': 'Insereix expressió matemàtica',
      'Font size': 'Grandària de text',
      Default: 'Per defecte',
      'Lower Alpha': 'Alpha en minúscula',
      'Lower Greek': 'Gregas en minúscula',
      'Lower Roman': 'Romanes en minúscula',
      'Upper Alpha': 'Alpha majúscules',
      'Upper Roman': 'Romanes majúscules',
      Circle: 'Cercle',
      Square: 'Quadrat',
      Disc: 'Disc',
      'With Borders': 'Amb vores',
      'Insert Audio': 'Inserir àudio',
      'Upload Audio': 'Subir àudio',
      'Only icon play/stop': 'Només icona reproducir/parar',
      'Drop audio': 'Soltar àudio',
      'Paste in an audio URL': "Pegar una URL d'àudio",
      'Drop transcription': 'Soltar transcripció',
      'Remove transcription': 'Eliminar transcripció',
      'Transcripción eliminada': 'Transcripción eliminada',
      Transcription: 'Transcripció'
    },
    direction: 'ltr'
  };
  FroalaEditor.LANGUAGE.vl = literals;
}

(function (FE) {

  Object.assign(FE.POPUP_TEMPLATES, {
    'audio.insert': '[_BUTTONS_][_BY_URL_LAYER_][_UPLOAD_LAYER_][_UPLOAD_LAYER_TRANSCRIPTION_][_REMOVE_TRANSCRIPTION_BUTTON_][_PROGRESS_BAR_]',
    'audio.edit': '[_BUTTONS_]'
  });
  Object.assign(FE.DEFAULTS, {
    audioAllowedTypes: ['mp3', 'mpeg', 'x-m4a', 'webm'],
    transcriptionAllowedTypes: ['txt', 'vtt'],
    audioEditButtons: ['audioReplace', 'audioTranscription', 'audioRemove'],
    audioInsertButtons: ['audioBack', '|', 'audioUpload', 'audioByURL'],
    audioMove: true,
    audioSplitHTML: false,
    audioUpload: true,
    audioUploadMethod: 'POST',
    audioUploadParam: 'file',
    audioUploadParams: {},
    audioUploadURL: 'https://i.froala.com/upload'
  });
  Object.assign(FE.SVG, {
    insertAudio: 'M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z',
    transcription: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 11h10v2H7v-2zm0 4h10v2H7v-2zm0-8h10v2H7V7z'
  });
  FE.PLUGINS.audio = function (editor) {
    var _errorMessages;
    var SHOW_LOG = false;
    var $ = editor.$;
    var MISSING_LINK = 1;
    var ERROR_DURING_UPLOAD = 2;
    var BAD_RESPONSE = 4;
    var BAD_FILE_TYPE = 8;
    var errorMessages = (_errorMessages = {}, _errorMessages[MISSING_LINK] = 'No link in upload response.', _errorMessages[ERROR_DURING_UPLOAD] = 'Error during file upload.', _errorMessages[BAD_RESPONSE] = 'Parsing response failed.', _errorMessages[BAD_FILE_TYPE] = 'Please use valid files: mp3 or webm.', _errorMessages);
    var currentAudio = null;
    var stopEditing = function stopEditing(audio) {
      if (!audio) audio = editor.$el.find('.fr-audio');
      if (!audio.length) return;
      editor.toolbar.enable();
      audio.removeClass('fr-active');
      currentAudio = null;
    };
    var bindInsertEvents = function bindInsertEvents($popup) {
      editor.events.$on($popup, 'dragover dragenter', '.fr-audio-upload-layer, .fr-audio-upload-layer-transcription', function () {
        $(this).addClass('fr-drop');
        return false;
      }, true);
      editor.events.$on($popup, 'dragleave dragend', '.fr-audio-upload-layer, .fr-audio-upload-layer-transcription', function () {
        $(this).removeClass('fr-drop');
        return false;
      }, true);
      editor.events.$on($popup, 'drop', '.fr-audio-upload-layer, .fr-audio-upload-layer-transcription', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).removeClass('fr-drop');
        var dt = e.originalEvent.dataTransfer;
        if (dt && dt.files) {
          var inst = $popup.data('instance') || editor;
          inst.events.disableBlur();
          if ($(this).hasClass('fr-transcription')) {
            inst.audio.uploadTranscription(dt.files);
          } else {
            inst.audio.upload(dt.files);
          }
          inst.events.enableBlur();
        }
      }, true);
      if (editor.helpers.isIOS()) {
        editor.events.$on($popup, 'touchstart', '.fr-audio-upload-layer input[type="file"], .fr-audio-upload-layer-transcription input[type="file"]', function () {
          $(this).trigger('click');
        }, true);
      }
      editor.events.$on($popup, 'change', '.fr-audio-upload-layer input[type="file"], .fr-audio-upload-layer-transcription input[type="file"]', function () {
        if (this.files) {
          var inst = $popup.data('instance') || editor;
          inst.events.disableBlur();
          $popup.find('input:focus').blur();
          inst.events.enableBlur();
          if ($(this).closest('.fr-transcription').length) {
            inst.audio.uploadTranscription(this.files);
          } else {
            inst.audio.upload(this.files);
          }
        }
        $(this).val('');
      }, true);
    };
    var refreshInsertPopup = function refreshInsertPopup() {
      var $popup = $(editor.popups.get('audio.insert'));
      var $inputs = $popup.find('input, button');
      if ($inputs) {
        for (var i = 0; i < $inputs.length; i++) {
          var input = $inputs[i];
          input.removeAttribute('disabled');
          input.value = '';
          if ('createEvent' in document) {
            var evt = document.createEvent('HTMLEvents');
            evt.initEvent('change', false, true);
            input.dispatchEvent(evt);
          } else input.fireEvent('onchange');
        }
      }
    };
    var omitSingle = function omitSingle(key, _ref) {
      var obj = _objectWithoutPropertiesLoose(_ref, [key].map(_toPropertyKey));
      return obj;
    };
    var initInsertPopup = function initInsertPopup() {
      editor.popups.onRefresh('audio.insert', refreshInsertPopup);
      editor.popups.onHide('audio.insert', editor.audio.hideProgressBar);
      var buttonSpec = editor.opts.audioInsertButtons;
      if (!editor.opts.audioUpload) buttonSpec = omitSingle('audioUpload', buttonSpec);
      var buttons = buttonSpec.length < 2 ? '' : "<div class=\"fr-buttons\">\n                " + editor.button.buildList(buttonSpec) + "\n            </div>";
      var checkboxDiv = "\n      <div class=\"fr-audio-only-play fr-checkbox-line\">\n        <span class=\"fr-checkbox\">\n            <input id=\"fr-audio-only-play\" name=\"target\" class=\"fr-link-attr fr-not-empty\" data-checked=\"_blank\" type=\"checkbox\" id=\"fr-link-target-2\" tabindex=\"3\" dir=\"ltr\">\n            <span>\n              <svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"10\" height=\"10\" viewBox=\"0 0 32 32\">\n                <path d=\"M27 4l-15 15-7-7-5 5 12 12 20-20z\" fill=\"#FFF\"></path>\n              </svg>\n            </span>\n          </span>\n          <label>\n          " + editor.language.translate('Only icon play/stop') + "\n          </label>\n      </div>";
      var by_url_layer = checkboxDiv + "<div class=\"fr-audio-by-url-layer fr-layer\" id=\"fr-audio-by-url-layer-" + editor.id + "\">\n                <div class=\"fr-input-line\">\n                    <input id=\"fr-audio-by-url-layer-text-" + editor.id + "\" type=\"text\" placeholder=\"" + editor.language.translate('Paste in an audio URL') + "\" tabIndex=\"1\" aria-required=\"true\" />\n                </div>\n                <div class=\"fr-action-buttons\">\n                    <button type=\"button\" class=\"fr-command fr-submit\" data-cmd=\"audioInsertByURL\" tabIndex=\"2\" role=\"button\">" + editor.language.translate('Insert') + "</button>\n                </div>\n            </div>";
      var accept = editor.opts.audioAllowedTypes.map(function (t) {
        return 'audio/' + t;
      }).join(',');
      var acceptTranscription = editor.opts.transcriptionAllowedTypes.map(function (t) {
        switch (t) {
          case 'vtt':
            return '.vtt,text/vtt';
          case 'txt':
            return '.txt,text/plain';
          default:
            return '.' + t;
        }
      }).join(',');
      var upload_layer = "<div class=\"fr-audio-upload-layer fr-file-upload-layer fr-layer\" id=\"fr-audio-upload-layer-" + editor.id + "\">\n        <strong>" + editor.language.translate('Drop audio') + "</strong><br />(" + editor.language.translate('or click') + ")\n                <div class=\"fr-form\">\n                    <input type=\"file\" accept=\"" + accept + "\" tabIndex=\"-1\" aria-labelledby=\"fr-audio-upload-layer-" + editor.id + "\" role=\"button\" />\n                </div>\n            </div>";
      var upload_layer_transcription = "<div class=\"fr-audio-upload-layer-transcription fr-file-upload-layer fr-layer fr-transcription\" id=\"fr-audio-upload-layer-transcription-" + editor.id + "\">\n        <strong>" + editor.language.translate('Drop transcription') + "</strong><br />(" + editor.language.translate('or click') + ")\n                <div class=\"fr-form\">\n                    <input type=\"file\" accept=\"" + acceptTranscription + "\" tabIndex=\"-1\" aria-labelledby=\"fr-audio-upload-layer-transcription-" + editor.id + "\" role=\"button\" />\n                </div>\n            </div>";
      var remove_transcription_button = "<div class=\"fr-transcription-actions\" style=\"display: none; margin-top: 0; text-align: center; border: none !important; background: transparent !important;\">\n        <button type=\"button\" class=\"fr-command fr-remove-transcription\" data-cmd=\"removeTranscription\" tabIndex=\"2\" role=\"button\">\n          " + editor.language.translate('Remove transcription') + "\n        </button>\n        <div class=\"fr-transcription-success\">" + editor.language.translate('Transcripción eliminada') + "</div>\n      </div>";
      var progress_bar = "<div class=\"fr-audio-progress-bar-layer fr-layer\">\n                <h3 tabIndex=\"-1\" class=\"fr-message\">" + editor.language.translate('Uploading') + "</h3>\n                <div class=\"fr-loader\">\n                    <span class=\"fr-progress\"></span>\n                </div>\n                <div class=\"fr-action-buttons\">\n                    <button type=\"button\" class=\"fr-command fr-dismiss\" data-cmd=\"audioDismissError\" tabIndex=\"2\" role=\"button\">\n                        " + editor.language.translate('OK') + "\n                    </button>\n                </div>\n            </div>";
      var $popup = editor.popups.create('audio.insert', {
        buttons: buttons,
        by_url_layer: by_url_layer,
        upload_layer: upload_layer,
        upload_layer_transcription: upload_layer_transcription,
        remove_transcription_button: remove_transcription_button,
        progress_bar: progress_bar
      });
      bindInsertEvents($popup);
      return $popup;
    };
    var initEditPopup = function initEditPopup() {
      var buttonSpec = editor.opts.audioEditButtons;
      var buttons = buttonSpec.length < 1 ? '' : "<div class=\"fr-buttons\">\n                " + editor.button.buildList(buttonSpec) + "\n            </div>";
      return editor.popups.create('audio.edit', {
        buttons: buttons
      });
    };
    var showProgressBar = function showProgressBar(message) {
      var $popup = editor.popups.get('audio.insert') || initInsertPopup();
      $popup.find('.fr-layer.fr-active').removeClass('fr-active').addClass('fr-pactive');
      $popup.find('.fr-audio-progress-bar-layer').addClass('fr-active');
      $popup.find('.fr-audio-only-play').hide();
      $popup.find('.fr-buttons').hide();
      $popup.find('.fr-audio-upload-layer-transcription').hide();
      if (message) showProgressMessage(message, 0);
    };
    var showErrorMessage = function showErrorMessage(message) {
      showProgressBar();
      var $popup = editor.popups.get('audio.insert');
      var $layer = $popup.find('.fr-audio-progress-bar-layer');
      $layer.addClass('fr-error');
      var $messageHeader = $layer.find('h3');
      $messageHeader.text(editor.language.translate(message));
      editor.events.disableBlur();
      $messageHeader.focus();
    };
    var throwError = function throwError(code, response) {
      editor.edit.on();
      showErrorMessage(editor.language.translate(errorMessages[code]));
      editor.events.trigger('audio.error', [{
        code: code,
        message: errorMessages[code]
      }, response]);
    };
    var showProgressMessage = function showProgressMessage(message, progress) {
      var $popup = editor.popups.get('audio.insert');
      if (!$popup) return;
      var $layer = $popup.find('.fr-audio-progress-bar-layer');
      $layer.find('h3').text(editor.language.translate(message) + (progress ? ' ' + progress + '%' : ''));
      $layer.removeClass('fr-error');
      if (progress) {
        $layer.find('div').removeClass('fr-indeterminate');
        $layer.find('div > span').css('width', progress + '%');
      } else {
        $layer.find('div').addClass('fr-indeterminate');
      }
    };
    var parseResponse = function parseResponse(response) {
      if (editor.events.trigger('audio.uploaded', [response], true) === false) {
        editor.edit.on();
        return false;
      }
      var res = response ? JSON.parse(response) : null;
      if (res) {
        if (res.link) {
          return res;
        } else {
          throwError(MISSING_LINK, response);
        }
      } else {
        return false;
      }
    };
    function getSpanFrAudio(isOnlyIconPlay, audioDefault, isLoading) {
      var audioElement = audioDefault || '<audio></audio>';
      var $spanFrAudio = $(getSpanStringFrAudio(audioElement, isLoading, editor.opts.audioMove));
      var $audio = $spanFrAudio.find('audio');
      if ($audio) {
        var _$audio$attr;
        $audio.attr((_$audio$attr = {}, _$audio$attr[ATRIBUTE_DATA_PLAYER] = isOnlyIconPlay ? TYPES_AUDIO_PLAYER.ONLY_ICON_PLAY : TYPES_AUDIO_PLAYER.CUSTOM_PLAYER, _$audio$attr));
      }
      return $spanFrAudio;
    }
    var addNewAudio = function addNewAudio(src, response, isOnlyIconPlay) {
      var data = parseResponse(response) || {};
      var $spanFrAudio = getSpanFrAudio(isOnlyIconPlay, null, true);
      editor.events.focus(true);
      editor.selection.restore();
      editor.undo.saveStep();
      if (editor.opts.audioSplitHTML) {
        editor.markers.split();
      } else {
        editor.markers.insert();
      }
      editor.html.wrap();
      var $marker = editor.$el.find('.fr-marker');
      if (editor.node.isLastSibling($marker) && $marker.parent().hasClass('fr-deletable')) {
        $marker.insertAfter($marker.parent());
      }
      $marker.replaceWith($spanFrAudio);
      editor.selection.clear();
      var player = $spanFrAudio.find('audio');
      player.text(editor.language.translate('Your browser does not support HTML5 audio.'));
      player.on('canplaythrough loadeddata', function () {
        editor.popups.hide('audio.insert');
        $spanFrAudio.removeClass('fr-uploading');
        editor.events.trigger('audio.loaded', [$spanFrAudio]);
      });
      player.on('error', function (e) {
        editor.popups.hide('audio.insert');
        $spanFrAudio.addClass('fr-error').removeClass('fr-uploading');
        editor.events.trigger('audio.error', [$spanFrAudio, e]);
      });
      Object.entries(data).forEach(function (_ref2) {
        var key = _ref2[0],
          value = _ref2[1];
        player['data-' + kebabCase(key)] = value;
      });
      if (editor.transcription) {
        player.attr('data-transcription', editor.transcription.link);
        editor.events.trigger('transcription.associated', [$spanFrAudio, editor.transcription]);
        editor.transcription = null;
      }
      player.attr({
        src: src
      });
      $spanFrAudio[0].innerHTML = '';
      $spanFrAudio.append(player);
      if (isOnlyIconPlay) {
        $spanFrAudio.append(getButtonPlayStopHtml(editor.language.translate('Transcription')));
      } else {
        $spanFrAudio.append(getCumtomPlayer(editor.language.translate('Transcription')));
      }
      initAudio($spanFrAudio[0], true, editor.language.translate('Transcription'));
      editor.events.trigger('contentChanged');
      return $spanFrAudio;
    };
    var replaceAudio = function replaceAudio($audio, src, isOnlyIconPlay) {
      var player = $audio.find('audio');
      if (player.attr('src') === src) player.attr({
        src: ''
      });
      $audio.addClass('fr-uploading');
      player.off('canplaythrough loadeddata');
      player.off('error');
      player.on('canplaythrough loadeddata', function () {
        editor.popups.hide('audio.insert');
        $audio.removeClass('fr-uploading');
        editor.events.trigger('audio.loaded', [$audio]);
        stopEditing($audio);
      });
      player.on('error', function (e) {
        $audio.addClass('fr-error').removeClass('fr-uploading');
        editor.audio.showEditPopup($audio);
        editor.events.trigger('audio.error', [$audio, e]);
      });
      player.attr({
        src: src
      });
      var buttonPlayStop = $audio[0].querySelector('.lemo-fr-button-audio');
      var customAudioPlayer = $audio[0].querySelector('.lemo-fr-audio-player');
      if (isOnlyIconPlay) {
        var _player$attr;
        player.attr((_player$attr = {}, _player$attr[ATRIBUTE_DATA_PLAYER] = TYPES_AUDIO_PLAYER.ONLY_ICON_PLAY, _player$attr));
        if (!buttonPlayStop) {
          if (customAudioPlayer && customAudioPlayer.parentNode === $audio[0]) {
            $audio[0].removeChild(customAudioPlayer);
          }
          $audio.append(getButtonPlayStopHtml(editor.language.translate('Transcription')));
        }
      } else {
        var _player$attr2;
        player.attr((_player$attr2 = {}, _player$attr2[ATRIBUTE_DATA_PLAYER] = TYPES_AUDIO_PLAYER.CUSTOM_PLAYER, _player$attr2));
        if (buttonPlayStop) {
          if (buttonPlayStop.parentNode === $audio[0]) {
            $audio[0].removeChild(buttonPlayStop);
          }
          $audio.append(getCumtomPlayer(editor.language.translate('Transcription')));
        }
      }
      $audio[0].innerHTML = '';
      $audio.append(player);
      if (isOnlyIconPlay) {
        $audio.append(getButtonPlayStopHtml(editor.language.translate('Transcription')));
      } else {
        $audio.append(getCumtomPlayer(editor.language.translate('Transcription')));
      }
      initAudio($audio[0], true, editor.language.translate('Transcription'));
      editor.events.trigger('contentChanged');
      return $audio;
    };
    function getIsOnlyIconPlay() {
      var isOnlyIconPlay = false;
      var $popup = editor.popups.get('audio.insert');
      var checkboxs = $popup.find('.fr-audio-only-play input[type="checkbox"]');
      if (checkboxs) {
        for (var i = 0; i < checkboxs.length; i++) {
          var checkbox = checkboxs[i];
          isOnlyIconPlay = checkbox.checked;
        }
      }
      return isOnlyIconPlay;
    }
    var insertHtmlAudio = function insertHtmlAudio(link, response) {
      validateAudio(link, function () {
        var isOnlyIconPlay = getIsOnlyIconPlay();
        editor.edit.on();
        showProgressMessage('Loading audio');
        showProgressBar('Loading audio');
        var replace = !!currentAudio;
        var $audio = replace ? replaceAudio(currentAudio, link, isOnlyIconPlay) : addNewAudio(link, response, isOnlyIconPlay);
        editor.undo.saveStep();
        editor.events.trigger(replace ? 'audio.replaced' : 'audio.inserted', [$audio, response]);
      }, function () {
        throwError(BAD_FILE_TYPE);
      }, editor.opts.audioAllowedTypes);
    };
    var handleTranscriptionUpload = function handleTranscriptionUpload(response) {
      try {
        var resp = parseResponse(response);
        SHOW_LOG && console.log('handleTranscriptionUpload - Respuesta parseada:', resp);
        if (resp) {
          if (currentAudio) {
            SHOW_LOG && console.log('handleTranscriptionUpload - Audio actual encontrado:', currentAudio);
            var player = currentAudio.find('audio');
            if (player) {
              var existingTranscription = player.attr('data-transcription');
              if (existingTranscription) {
                SHOW_LOG && console.log('handleTranscriptionUpload - Reemplazando transcripción existente:', existingTranscription);
                editor.events.trigger('transcription.replaced', [currentAudio, existingTranscription, resp]);
              }
              SHOW_LOG && console.log('handleTranscriptionUpload - Añadiendo nueva transcripción:', resp.link);
              player.attr('data-transcription', resp.link);
              editor.events.trigger('transcription.associated', [currentAudio, resp]);
            } else {
              SHOW_LOG && console.log('handleTranscriptionUpload - No se encontró el player en el audio actual');
            }
          }
          editor.audio.hideProgressBar(true);
          editor.edit.on();
          editor.events.focus();
          if (currentAudio) {
            editor.events.trigger('contentChanged');
            initAudio(currentAudio[0], true, editor.language.translate('Transcription'));
          }
        }
      } catch (ex) {
        throwError(BAD_RESPONSE, response);
      }
    };
    var touchScroll = false;
    var editAudio = function editAudio(e) {
      var $audio = $(this);
      if (touchScroll && e && e.type === 'touchend') {
        return true;
      }
      if (editor.edit.isDisabled()) {
        if (e) {
          e.stopPropagation();
          e.preventDefault();
        }
        return false;
      }
      editor.toolbar.disable();
      if (editor.helpers.isMobile()) {
        editor.events.disableBlur();
        editor.$el.blur();
        editor.events.enableBlur();
      }
      if (currentAudio) currentAudio.removeClass('fr-active');
      currentAudio = $audio;
      editor.audio.currentAudio = $audio;
      $audio.addClass('fr-active');
      if (editor.opts.iframe) editor.size.syncIframe();
      editor.audio.showEditPopup($audio);
      editor.selection.clear();
      var range = editor.doc.createRange();
      range.selectNode($audio[0]);
      editor.selection.get().addRange(range);
      editor.button.bulkRefresh();
      if ($audio && $audio[0]) initAudio($audio[0], true, editor.language.translate('Transcription'));
      return true;
    };
    function templateToModel(outerHTML, innerHTML) {
      var element = createElementFromHTML(outerHTML);
      if (element && outerHTML.indexOf('fr-audio') >= 0) {
        var e = element;
        var spanAudios = e.getElementsByClassName('fr-audio');
        if (spanAudios && spanAudios.length >= 1) {
          var numberSpanAudios = spanAudios.length;
          for (var i = 0; i < numberSpanAudios; i++) {
            var audio = spanAudios[0].getElementsByTagName('AUDIO');
            if (audio && audio.length >= 1 && audio[0]) {
              spanAudios[0].replaceWith(audio[0]);
            }
          }
          return e.innerHTML;
        } else return innerHTML;
      } else return innerHTML;
    }
    function removeSpacesPlayer() {
      if (editor.$el[0]) {
        var element = editor.$el[0];
        var spanAudios = element.getElementsByClassName('fr-audio');
        for (var i = 0; i < spanAudios.length; i++) {
          var spanAudio = spanAudios[i];
          if (spanAudio.innerHTML.indexOf('&nbsp;') >= 0) {
            spanAudio.innerHTML = spanAudio.innerHTML.replaceAll(/\&nbsp;/g, '');
            initAudio(spanAudio, true, editor.language.translate('Transcription'));
          }
        }
      }
    }
    return {
      _init: function _init() {
        if (editor.helpers.isMobile()) {
          editor.events.$on(editor.$el, 'touchstart', 'span.fr-audio', function () {
            touchScroll = false;
          });
          editor.events.$on(editor.$el, 'touchmove', function () {
            touchScroll = true;
          });
        }
        editor.events.on('html.set', function (e) {
          if (editor.$el[0]) {
            initAudios(editor.$el[0], true, editor.language.translate('Transcription'));
          }
        });
        editor.events.on('html.processGet', function (e) {
          if (e.innerHTML) {
            e.innerHTML = templateToModel(e.outerHTML, e.innerHTML);
          }
        });
        editor.events.on('keyup', function (keyupEvent) {
          if (keyupEvent.which === 13 || keyupEvent.which === 8 || keyupEvent.which === 46 || keyupEvent.which === 32) {
            removeSpacesPlayer();
          }
        }, true);
        editor.events.on('initialized', function () {
          this.opts.htmlAllowedEmptyTags.push('span');
        });
        editor.events.$on(editor.$el, 'mousedown', 'span.fr-audio', function (e) {
          e.stopPropagation();
        });
        editor.events.$on(editor.$el, 'click touchend', 'span.fr-audio', editAudio);
        editor.events.on('mouseup window.mouseup', function () {
          return stopEditing();
        });
        editor.events.on('commands.mousedown', function ($btn) {
          if ($btn.parents('.fr-toolbar').length) stopEditing();
        });
      },
      showInsertPopup: function showInsertPopup(type) {
        if (!editor.popups.get('audio.insert')) initInsertPopup();
        var $popup = editor.popups.get('audio.insert');
        if (type === 'transcription') {
          $popup.find('.fr-buttons').hide();
          $popup.find('.fr-audio-only-play').hide();
          $popup.find('.fr-layer').removeClass('fr-active');
          $popup.find('.fr-audio-upload-layer-transcription').addClass('fr-active').show();
          if (currentAudio && typeof currentAudio.find === 'function') {
            var player = currentAudio.find('audio');
            var transcription = player && player.attr('data-transcription');
            if (transcription && transcription.trim() !== '') {
              $popup.find('.fr-transcription-actions').show();
            } else {
              $popup.find('.fr-transcription-actions').hide();
            }
          }
          var buttonPlayStop = currentAudio.find('.lemo-fr-button-audio');
          if (buttonPlayStop.length) {
            var buttonOffset = buttonPlayStop.offset();
            var buttonWidth = buttonPlayStop.outerWidth();
            var buttonHeight = buttonPlayStop.outerHeight();
            var popupHeight = $popup.outerHeight();
            var newLeft = buttonOffset.left + buttonWidth + 5;
            var newTop = buttonOffset.top + buttonHeight + 25;
            editor.popups.show('audio.insert', newLeft, newTop, buttonHeight);
          } else {
            var $player = this.getPlayerToShowEditPopup(currentAudio);
            var height = $player.outerHeight();
            var offset = $player.offset();
            var left = offset.left + $player.width() / 2;
            var top = offset.top + height;
            editor.popups.show('audio.insert', left, top, height);
          }
          editor.accessibility.focusPopup($popup);
          editor.popups.refresh('audio.insert');
        } else {
          $popup.find('.fr-audio-upload-layer-transcription').hide().removeClass('fr-active');
          $popup.find('.fr-transcription-actions').hide();
          editor.opts.audioInsertButtons.some(function (b) {
            if (b === 'audioByURL') {
              editor.audio.showLayer('audio-by-url');
              return true;
            }
            if (b === 'audioUpload') {
              editor.audio.showLayer('audio-upload');
              return true;
            }
            return false;
          });
        }
      },
      getPlayerToShowEditPopup: function getPlayerToShowEditPopup($audio) {
        var buttonPlayPause = null;
        var customAudioPlayer = null;
        var audio = null;
        for (var i = 0; i < $audio.children().length; i++) {
          var children = $audio.children().eq(i);
          if (children && children[0]) {
            if (children[0].classList.contains('lemo-fr-button-audio')) {
              buttonPlayPause = children;
            }
            if (children[0].classList.contains('lemo-fr-audio-player')) {
              customAudioPlayer = children;
            }
            if (children[0].tagName === 'AUDIO') {
              audio = children;
            }
          }
        }
        return buttonPlayPause || customAudioPlayer || audio;
      },
      showEditPopup: function showEditPopup($audio) {
        var $popup = 'audio.edit';
        if (!editor.popups.get($popup)) initEditPopup();
        editor.popups.setContainer($popup, editor.$sc);
        editor.popups.refresh($popup);
        var $player = this.getPlayerToShowEditPopup($audio);
        var _$player$offset = $player.offset(),
          left = _$player$offset.left,
          top = _$player$offset.top;
        var height = $player.outerHeight();
        var buttonPlayStop = $audio.find('.lemo-fr-button-audio');
        if (buttonPlayStop.length) {
          var buttonOffset = buttonPlayStop.offset();
          var buttonWidth = buttonPlayStop.outerWidth();
          var buttonHeight = buttonPlayStop.outerHeight();
          var popupHeight = editor.popups.get($popup).outerHeight();
          var newLeft = buttonOffset.left + buttonWidth + 5;
          var newTop = buttonOffset.top + buttonHeight / 2 - popupHeight / 2;
          editor.popups.show($popup, newLeft, newTop, height);
        } else {
          editor.popups.show($popup, left + $player.outerWidth() / 2, top + height, height);
        }
      },
      refreshByURLButton: function refreshByURLButton($btn) {
        var $popup = editor.popups.get('audio.insert');
        if ($popup.find('.fr-audio-by-url-layer').hasClass('fr-active')) {
          $btn.addClass('fr-active').attr('aria-pressed', true);
        }
      },
      refreshUploadButton: function refreshUploadButton($btn) {
        var $popup = editor.popups.get('audio.insert');
        if ($popup.find('.fr-audio-upload-layer').hasClass('fr-active')) {
          $btn.addClass('fr-active').attr('aria-pressed', true);
        }
      },
      autoplay: function autoplay() {
        var _currentAudio;
        if (!currentAudio) return false;
        var $player = (_currentAudio = currentAudio) === null || _currentAudio === void 0 ? void 0 : _currentAudio.find('audio');
        if ($player && $player.length > 0) {
          var isAuto = $player[0].autoplay;
          $player[0].autoplay = !isAuto;
        }
      },
      align: function align(val) {
        if (!currentAudio) return false;
        if (val === 'center') val = '';
        currentAudio.css({
          textAlign: val
        });
        editor.audio.showEditPopup(currentAudio);
      },
      refreshAutoplayButton: function refreshAutoplayButton($btn) {
        var _currentAudio2;
        if (!currentAudio) return false;
        var currentAudioFind = (_currentAudio2 = currentAudio) === null || _currentAudio2 === void 0 ? void 0 : _currentAudio2.find('audio');
        if (currentAudioFind && currentAudioFind.length > 0) {
          var isAuto = currentAudioFind[0].autoplay;
          $btn.toggleClass('fr-active', isAuto).attr('aria-pressed', isAuto);
        }
      },
      refreshAlignButton: function refreshAlignButton($btn) {
        if (!currentAudio) return false;
        var align = currentAudio.css('textAlign') || 'center';
        $btn.children().first().replaceWith(editor.icon.create('audioAlign' + capitalizeFirstLetter(align)));
      },
      refreshAlignDropdown: function refreshAlignDropdown($btn, $dropdown) {
        if (!currentAudio) return;
        var align = currentAudio.css('textAlign') || 'center';
        $dropdown.find(".fr-command[data-param1=\"" + align + "\"]").addClass('fr-active').attr('aria-selected', true);
      },
      back: function back() {
        if (currentAudio) {
          editor.audio.showEditPopup(currentAudio);
        } else {
          editor.events.disableBlur();
          editor.selection.restore();
          editor.events.enableBlur();
          editor.popups.hide('audio.insert');
          editor.toolbar.showInline();
        }
      },
      refreshBackButton: function refreshBackButton($btn) {
        var showBack = currentAudio || editor.opts.toolbarInline;
        $btn.toggleClass('fr-hidden', !showBack);
        $btn.next('.fr-separator').toggleClass('fr-hidden', !showBack);
      },
      showLayer: function showLayer(name) {
        var $popup = editor.popups.get('audio.insert');
        editor.popups.setContainer('audio.insert', currentAudio ? editor.$sc : editor.$tb);
        var left;
        var top;
        var height = 0;
        if (currentAudio) {
          var buttonPlayStop = currentAudio.find('.lemo-fr-button-audio');
          if (buttonPlayStop.length) {
            var buttonOffset = buttonPlayStop.offset();
            var buttonWidth = buttonPlayStop.outerWidth();
            var buttonHeight = buttonPlayStop.outerHeight();
            var popupHeight = $popup.outerHeight();
            left = buttonOffset.left + buttonWidth + 5;
            top = buttonOffset.top + buttonHeight / 2 - popupHeight / 2;
            height = buttonHeight;
          } else {
            var $player = this.getPlayerToShowEditPopup(currentAudio);
            height = $player.outerHeight();
            var offset = $player.offset();
            left = offset.left + $player.width() / 2;
            top = offset.top + height;
          }
        } else if (editor.opts.toolbarInline) {
          top = $popup.offset().top - editor.helpers.getPX($popup.css('margin-top'));
          if ($popup.hasClass('fr-above')) top += $popup.outerHeight();
        } else {
          var $btn = editor.$tb.find('.fr-command[data-cmd="insertAudio"]');
          var _offset = $btn.offset();
          left = _offset.left + $btn.outerWidth() / 2;
          top = _offset.top + (editor.opts.toolbarBottom ? 10 : $btn.outerHeight() - 10);
        }
        $popup.find('.fr-layer').removeClass('fr-active');
        $popup.find('.fr-' + name + '-layer').addClass('fr-active');
        if (name === 'audio-upload') {
          if (currentAudio) {
            $popup.find('.fr-audio-upload-layer-transcription').addClass('fr-active');
          } else {
            $popup.find('.fr-audio-upload-layer-transcription').removeClass('fr-active');
          }
        }
        editor.popups.show('audio.insert', left, top, height);
        editor.accessibility.focusPopup($popup);
        editor.popups.refresh('audio.insert');
      },
      hideProgressBar: function hideProgressBar(dismiss) {
        var $popup = editor.popups.get('audio.insert');
        if (!$popup) return;
        $popup.find('.fr-layer.fr-pactive').addClass('fr-active').removeClass('fr-pactive');
        $popup.find('.fr-audio-progress-bar-layer').removeClass('fr-active');
        $popup.find('.fr-audio-only-play').show();
        $popup.find('.fr-buttons').show();
        var audios = editor.$el.find('audio.fr-error');
        if (dismiss || audios.length) {
          editor.events.focus();
          if (audios.length) {
            audios.parent().remove();
            editor.undo.saveStep();
            editor.undo.run();
            editor.undo.dropRedo();
          }
          editor.popups.hide('audio.insert');
        }
      },
      insertByURL: function insertByURL(link) {
        if (!link) {
          var $popup = editor.popups.get('audio.insert');
          link = ($popup.find('.fr-audio-by-url-layer input[type="text"]').val() || '').trim();
          var $inputs = $popup.find('input, button');
        }
        if (!/^http/.test(link)) link = 'https://' + link;
        insertHtmlAudio(link);
      },
      upload: function upload(audios) {
        if (!(audios && audios.length)) return false;
        if (editor.events.trigger('audio.beforeUpload', [audios]) === false) return false;
        var audio = audios[0];
        if (audio.type.indexOf('audio') >= 0 && editor.opts.audioAllowedTypes.indexOf(audio.type.replace(/audio\//g, '')) >= 0 || audio.type.indexOf('video') >= 0 && editor.opts.audioAllowedTypes.indexOf(audio.type.replace(/video\//g, '')) >= 0) ; else {
          throwError(BAD_FILE_TYPE);
          return false;
        }
        if (!editor.drag_support.formdata) return false;
        var formData = new FormData();
        Object.entries(editor.opts.audioUploadParams).forEach(function (_ref3) {
          var key = _ref3[0],
            value = _ref3[1];
          formData.append(key, value);
        });
        formData.append(editor.opts.audioUploadParam, audio);
        var url = editor.opts.audioUploadURL;
        var xhr = editor.core.getXHR(url, editor.opts.audioUploadMethod);
        xhr.onload = function () {
          showProgressMessage('Loading audio');
          var status = this.status,
            response = this.response,
            responseText = this.responseText;
          if (status === 415) {
            throwError(BAD_FILE_TYPE, JSON.parse(responseText));
            return;
          }
          if (status < 200 || status >= 300) {
            throwError(ERROR_DURING_UPLOAD, response || responseText);
            return;
          }
          try {
            var resp = parseResponse(response);
            if (resp) insertHtmlAudio(resp.link, responseText);
          } catch (ex) {
            console.log(ex);
            throwError(BAD_RESPONSE, response || responseText);
          }
        };
        xhr.onerror = function () {
          throwError(BAD_RESPONSE, this.response || this.responseText || this.responseXML);
        };
        xhr.upload.onprogress = function (e) {
          if (e.lengthComputable) showProgressMessage('Uploading', e.loaded / e.total * 100 | 0);
        };
        xhr.onabort = function () {
          editor.edit.on();
          editor.audio.hideProgressBar(true);
        };
        showProgressBar();
        editor.events.disableBlur();
        editor.edit.off();
        editor.events.enableBlur();
        var $popup = editor.popups.get('audio.insert');
        if ($popup) {
          $popup.off('abortUpload');
          $popup.on('abortUpload', function () {
            if (xhr.readyState !== 4) xhr.abort();
          });
        }
        xhr.send(formData);
        return true;
      },
      replace: function replace() {
        if (!currentAudio) return;
        editor.audio.showInsertPopup();
      },
      transcription: function transcription() {
        if (!currentAudio) return;
        editor.audio.showInsertPopup('transcription');
      },
      remove: function remove() {
        if (!currentAudio) return;
        var $audio = currentAudio;
        if (editor.events.trigger('audio.beforeRemove', [$audio]) === false) return;
        editor.popups.hideAll();
        var el = $audio[0];
        editor.selection.setBefore(el) || editor.selection.setAfter(el);
        $audio.remove();
        editor.selection.restore();
        editor.html.fillEmptyBlocks();
        editor.events.trigger('audio.removed', [$audio]);
        stopEditing($audio);
      },
      uploadTranscription: function uploadTranscription(files) {
        if (!(files && files.length)) {
          return false;
        }
        if (editor.events.trigger('transcription.beforeUpload', [files]) === false) {
          return false;
        }
        var file = files[0];
        var fileExtension = file.name.split('.').pop().toLowerCase();
        if (!editor.opts.transcriptionAllowedTypes.includes(fileExtension) && !file.type.includes('text/vtt') && !file.type.includes('text/plain')) {
          throwError(BAD_FILE_TYPE);
          return false;
        }
        if (!editor.drag_support.formdata) {
          return false;
        }
        var formData = new FormData();
        Object.entries(editor.opts.audioUploadParams).forEach(function (_ref4) {
          var key = _ref4[0],
            value = _ref4[1];
          formData.append(key, value);
        });
        formData.append(editor.opts.audioUploadParam, file);
        formData.append('type', 'transcription');
        formData.append('fileType', fileExtension);
        var url = editor.opts.audioUploadURL;
        var xhr = editor.core.getXHR(url, editor.opts.audioUploadMethod);
        xhr.onload = function () {
          showProgressMessage('Loading transcription');
          var status = this.status,
            response = this.response,
            responseText = this.responseText;
          if (status === 415) {
            throwError(BAD_FILE_TYPE, JSON.parse(responseText));
            return;
          }
          if (status < 200 || status >= 300) {
            throwError(ERROR_DURING_UPLOAD, response || responseText);
            return;
          }
          try {
            SHOW_LOG && console.log('uploadTranscription - Llamando a handleTranscriptionUpload');
            handleTranscriptionUpload(response);
          } catch (ex) {
            throwError(BAD_RESPONSE, response || responseText);
          }
        };
        xhr.onerror = function () {
          throwError(BAD_RESPONSE, this.response || this.responseText || this.responseXML);
        };
        xhr.upload.onprogress = function (e) {
          if (e.lengthComputable) {
            var progress = e.loaded / e.total * 100 | 0;
            showProgressMessage('Uploading transcription', progress);
          }
        };
        xhr.onabort = function () {
          editor.edit.on();
          editor.audio.hideProgressBar(true);
        };
        showProgressBar();
        editor.events.disableBlur();
        editor.edit.off();
        editor.events.enableBlur();
        var $popup = editor.popups.get('audio.insert');
        if ($popup) {
          $popup.off('abortUpload');
          $popup.on('abortUpload', function () {
            if (xhr.readyState !== 4) xhr.abort();
          });
        }
        xhr.send(formData);
        return true;
      },
      removeTranscription: function removeTranscription(that) {
        var currentAudio = that.audio && that.audio.currentAudio;
        if (currentAudio && currentAudio.length) {
          var player = currentAudio.find('audio');
          if (player && player.attr('data-transcription')) {
            player.removeAttr('data-transcription');
            var $popup = that.popups.get('audio.insert');
            if ($popup) {
              var $success = $popup.find('.fr-transcription-success');
              var $btn = $popup.find('.fr-remove-transcription');
              $btn.hide();
              $success.show();
              setTimeout(function () {
                $success.hide();
                $btn.show();
                that.popups.hide('audio.insert');
                currentAudio.removeClass('fr-active');
                that.audio.currentAudio = null;
                initAudio(currentAudio[0], true, that.language.translate('Transcription'));
              }, 1200);
            }
            that.events.trigger('transcription.removed', [currentAudio]);
          }
        }
      }
    };
  };
  FE.DefineIcon('insertAudio', {
    NAME: 'volume-up',
    FA5NAME: 'volume-up',
    SVG_KEY: 'insertAudio'
  });
  FE.RegisterCommand('insertAudio', {
    title: 'Insert Audio',
    undo: false,
    focus: true,
    refreshAfterCallback: false,
    popup: true,
    callback: function callback() {
      if (!this.popups.isVisible('audio.insert')) return this.audio.showInsertPopup();
      if (this.$el.find('.fr-marker').length) {
        this.events.disableBlur();
        this.selection.restore();
      }
      return this.popups.hide('audio.insert');
    },
    plugin: 'audio'
  });
  FE.DefineIcon('audioByURL', {
    NAME: 'link',
    SVG_KEY: 'insertLink'
  });
  FE.RegisterCommand('audioByURL', {
    title: 'By URL',
    undo: false,
    focus: false,
    toggle: true,
    callback: function callback() {
      this.audio.showLayer('audio-by-url');
    },
    refresh: function refresh($btn) {
      this.audio.refreshByURLButton($btn);
    }
  });
  FE.DefineIcon('audioUpload', {
    NAME: 'upload',
    SVG_KEY: 'upload'
  });
  FE.RegisterCommand('audioUpload', {
    title: 'Upload Audio',
    undo: false,
    focus: false,
    toggle: true,
    callback: function callback() {
      this.audio.showLayer('audio-upload');
    },
    refresh: function refresh($btn) {
      this.audio.refreshUploadButton($btn);
    }
  });
  FE.RegisterCommand('audioDismissError', {
    title: 'OK',
    undo: false,
    callback: function callback() {
      this.audio.hideProgressBar(true);
    }
  });
  FE.RegisterCommand('audioInsertByURL', {
    undo: true,
    focus: true,
    callback: function callback() {
      this.audio.insertByURL();
    }
  });
  FE.DefineIcon('audioAlignLeft', {
    NAME: 'align-left',
    SVG_KEY: 'alignLeft'
  });
  FE.DefineIcon('audioAlignRight', {
    NAME: 'align-right',
    SVG_KEY: 'alignRight'
  });
  FE.DefineIcon('audioAlignCenter', {
    NAME: 'align-justify',
    SVG_KEY: 'alignJustify'
  });
  FE.DefineIcon('audioAlign', {
    NAME: 'align-center',
    SVG_KEY: 'alignCenter'
  });
  FE.RegisterCommand('audioAlign', {
    type: 'dropdown',
    title: 'Align',
    options: {
      left: 'Align Left',
      center: 'None',
      right: 'Align Right'
    },
    html: function html() {
      return '';
    },
    callback: function callback(cmd, val) {
      this.audio.align(val);
    },
    refresh: function refresh($btn) {
      this.audio.refreshAlignButton($btn);
    },
    refreshOnShow: function refreshOnShow($btn, $dropdown) {
      this.audio.refreshAlignDropdown($btn, $dropdown);
    }
  });
  FE.DefineIcon('audioAutoplay', {
    NAME: 'play-circle',
    SVG_KEY: 'autoplay'
  });
  FE.RegisterCommand('audioAutoplay', {
    title: 'Autoplay',
    toggle: true,
    callback: function callback() {
      this.audio.autoplay();
    },
    refresh: function refresh($btn) {
      this.audio.refreshAutoplayButton($btn);
    }
  });
  FE.DefineIcon('audioReplace', {
    NAME: 'exchange',
    FA5NAME: 'exchange-alt',
    SVG_KEY: 'replaceImage'
  });
  FE.RegisterCommand('audioReplace', {
    title: 'Replace',
    undo: false,
    focus: false,
    popup: true,
    refreshAfterCallback: false,
    callback: function callback() {
      this.audio.replace();
    }
  });
  FE.DefineIcon('audioRemove', {
    NAME: 'trash',
    SVG_KEY: 'remove'
  });
  FE.RegisterCommand('audioRemove', {
    title: 'Remove',
    callback: function callback() {
      this.audio.remove();
    }
  });
  FE.DefineIcon('audioBack', {
    NAME: 'arrow-left',
    SVG_KEY: 'back'
  });
  FE.RegisterCommand('audioBack', {
    title: 'Back',
    undo: false,
    focus: false,
    back: true,
    callback: function callback() {
      this.audio.back();
    },
    refresh: function refresh($btn) {
      this.audio.refreshBackButton($btn);
    }
  });
  FE.DefineIcon('audioTranscription', {
    NAME: 'file-text',
    FA5NAME: 'file-alt',
    SVG_KEY: 'transcription'
  });
  FE.RegisterCommand('audioTranscription', {
    title: 'Transcription',
    undo: false,
    focus: false,
    popup: true,
    refreshAfterCallback: false,
    callback: function callback() {
      this.audio.transcription();
    }
  });
  FE.RegisterCommand('removeTranscription', {
    title: 'Remove Transcription',
    callback: function callback() {
      var $audio = this.audio && this.audio.currentAudio;
      if ($audio && $audio.length) {
        this.audio.removeTranscription(this);
      }
    }
  });
  if (!FE.RegisterQuickInsertButton) return;
  FE.RegisterQuickInsertButton('audio', {
    icon: 'insertAudio',
    requiredPlugin: 'audio',
    title: 'Insert Audio',
    undo: false,
    callback: function callback() {
      var src = prompt(this.language.translate('Paste the URL of the audio you want to insert.'));
      if (src) this.audio.insertByURL(src);
    }
  });
})(FroalaEditor);

FroalaEditor.DefineIcon('addBlank', {
  NAME: 'addBlank',
  PATH: 'M12 2C8.13 2 5 5.13 5 9c0 4.17 4.42 9.92 6.24 12.11.4.48 1.13.48 1.53 0C14.58 18.92 19 13.17 19 9c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z'
});
FroalaEditor.RegisterCommand('addBlank', {
  title: 'Add blank',
  focus: true,
  undo: true,
  refreshAfterCallback: true,
  callback: function callback() {
    this.html.insert('&nbsp;<span class="lemo-blank fr-draggable fr-embedly" draggable="true">#</span>&emsp;');
  }
});

var changeDirection = function changeDirection() {
  this.selection.save();
  this.html.wrap(true, true, true, true);
  this.selection.restore();
  var elements = this.selection.blocks();
  this.selection.save();
  for (var _iterator = _createForOfIteratorHelperLoose(elements), _step; !(_step = _iterator()).done;) {
    var element = _step.value;
    element.classList.toggle('fr-class-no-rtl');
  }
  this.html.unwrap();
  this.selection.restore();
};
FroalaEditor.DefineIcon('rtl', {
  NAME: 'rtl-icon',
  PATH: 'M14,15.6l0,-2.6l4,4l-4,4l0,-2.6l-14,0l0,-2.8l14,0Zm-4,-7.2l0,2.6l-4,-4l4,-4l0,2.6l14,0l0,2.8l-14,0Z'
});
FroalaEditor.RegisterCommand('rtl', {
  title: 'RTL',
  focus: true,
  undo: true,
  refreshAfterCallback: true,
  callback: function callback() {
    changeDirection.apply(this);
  }
});

FroalaEditor.DefineIcon('numGroup', {
  NAME: 'numGroup',
  PATH: 'M7.795,2.523l0,1.458l-3.887,0l0,16.038l3.887,0l0,1.458l-4.616,0c-0.403,0 -0.729,-0.326 -0.729,-0.729l0,-17.496c0,-0.403 0.326,-0.729 0.729,-0.729l4.616,0Zm8.748,0l4.278,0c0.403,0 0.729,0.326 0.729,0.729l0,17.496c0,0.403 -0.326,0.729 -0.729,0.729l-4.278,0l0,-1.458l3.549,0l0,-16.038l-3.549,0l0,-1.458Zm-4.543,7.804l4.601,-4.601l1.673,1.673l-4.601,4.601l4.601,4.601l-1.673,1.673l-4.601,-4.601l-4.601,4.601l-1.673,-1.673l4.601,-4.601l-4.601,-4.601l1.673,-1.673l4.601,4.601Z '
});
FroalaEditor.RegisterCommand('numGroup', {
  title: 'Number Group',
  focus: true,
  undo: true,
  refreshAfterCallback: true,
  callback: function callback() {
    if (this.selection && this.selection.text() && hasData(this.selection.text())) {
      if (!this.format.is('span', {
        "class": 'no-break'
      })) {
        this.format.toggle('span', {
          "class": 'no-break'
        });
        this.format.applyStyle('display', 'inline-block');
        this.format.applyStyle('white-space', 'nowrap');
      } else {
        this.format.removeStyle('display');
        this.format.removeStyle('white-space');
        this.format.toggle('span', {
          "class": 'no-break'
        });
      }
    }
  }
});

(function addMathPluginv3() {
  var DELIMITER_BEGIN_LATEX = '\\(';
  var DELIMITER_END_LATEX = '\\)';
  var mfes = {};
  var firstEditor = undefined;
  FroalaEditor.POPUP_TEMPLATES['mathPluginv2.popup'] = '[_BUTTONS_][_CUSTOM_LAYER_]';
  FroalaEditor.POPUP_TEMPLATES['mathPluginv2.edit'] = '[_BUTTONS_]';
  Object.assign(FroalaEditor.DEFAULTS, {
    popupButtonsv2: ['popupClosev2'],
    mathPluginEditButtonsv2: ['mathPluginv2Edit', '|', 'mathPluginv2Remove']
  });
  var delayRerender;
  FroalaEditor.PLUGINS.mathPluginv2 = function (editor) {
    function _init() {
      editor.events.$on(editor.$el, 'click touchend', 'span.fr-math-v2', touchEndElement);
      editor.events.$on(editor.$el, 'click touchend', 'span.fr-math', touchEndElement);
      editor.events.on('html.processGet', resetMathDiv);
      editor.events.on('initialized', function () {
        this.opts.htmlAllowedEmptyTags.push('span');
        setTimeout(function () {
          renderMathExpression(getMathElements(editor.el));
        }, 100);
      });
      editor.events.on('html.set', function () {
        clearTimeout(delayRerender);
        delayRerender = setTimeout(function () {
          renderMathExpression(getMathElements(editor.el));
        }, 2000);
      });
    }
    function initPopup() {
      getEventListenersPolyfill();
      var popup_buttons = '';
      if (editor.opts.popupButtonsv2.length > 1) {
        popup_buttons += '<div class="fr-buttons fr-tabs">';
        popup_buttons += editor.button.buildList(editor.opts.popupButtonsv2);
        popup_buttons += '</div>';
      }
      var template = {
        buttons: popup_buttons,
        custom_layer: '<div class="fr-math-v2-insert-layer fr-layer fr-active" id="fr-math-v2-insert-layer-"' + editor.id + '" data-mouseenter-event-set="true" data-popup-id="' + editor.id + '">' + '<div class="fr-input-line" style="display: block;">' + '<div class="fr-math-v2-field"></div>' + '</div>' + '<div class="fr-action-buttons"><button class="fr-command fr-submit fr-math-v2-action-button" role="button" data-cmd="mathInsertv2" href="#" tabindex="3" type="button">Insert</button></div>' + '</div>'
      };
      var $popup = editor.popups.create('mathPluginv2.popup', template);
      initMathField();
      return $popup;
    }
    function showPopup(isQuickInsert) {
      if (isQuickInsert === void 0) {
        isQuickInsert = false;
      }
      if (editor.selection) editor.selection.save();
      var selection = editor.selection.text();
      var $popup = editor.popups.get('mathPluginv2.popup');
      if (!$popup) $popup = initPopup();
      editor.popups.setContainer('mathPluginv2.popup', isQuickInsert ? editor.$sc : editor.$tb);
      editor.popups.refresh('mathPluginv2.popup');
      var $btn = isQuickInsert ? $('.fr-qi-helper') : editor.$tb.find('.fr-command[data-cmd="mathButtonv2"]');
      var left = $btn.offset().left + $btn.outerWidth() / 2;
      var top = $btn.offset().top + (!isQuickInsert ? editor.opts.toolbarBottom ? 10 : $btn.outerHeight() - 10 : 0);
      editor.popups.show('mathPluginv2.popup', left, top, $btn.outerHeight());
      var buttonAction = $popup.find('.fr-math-v2-action-button');
      if (buttonAction) {
        buttonAction.text('Insert');
        buttonAction.data('cmd', 'mathInsertv2');
      }
      var mfe = getMathfiledInstance();
      if (mfe) {
        if (selection.length > 0) {
          mfe.setValue(selection);
        } else mfe.setValue('');
        mfe.focus();
      }
      fixKeyboardMathDiv();
    }
    function fixKeyboardMathDiv() {
      var items = document.getElementsByClassName('fr-math-v2-insert-layer');
      for (var i = 0; i < items.length; i++) {
        if (typeof items[i].clearEventListeners !== 'undefined') {
          items[i].clearEventListeners('keydown');
        }
      }
    }
    function resetMathDiv(e) {
      if (e && (editor.node.hasClass(e, 'fr-math-v2') || editor.node.hasClass(e, 'fr-math'))) {
        e.textContent = e.getAttribute('data-original-math');
        e.setAttribute('class', (e.getAttribute('class') || '').replace('fr-math-v2-render', ''));
      } else if (e && e.nodeType === Node.ELEMENT_NODE) {
        for (var n = e.querySelectorAll('.fr-math-v2'), i = 0; i < n.length; i++) resetMathDiv(n[i]);
        for (var n = e.querySelectorAll('.fr-math'), i = 0; i < n.length; i++) resetMathDiv(n[i]);
      }
    }
    function getEditButtons() {
      var e = '';
      if (editor.opts.mathPluginEditButtonsv2.length > 0) {
        e += '<div class="fr-buttons">\n      '.concat(editor.button.buildList(editor.opts.mathPluginEditButtonsv2), '\n      </div>');
        var n = {
            buttons: e
          },
          i = editor.popups.create('mathPluginv2.edit', n);
        return editor.events.$on(editor.$wp, 'scroll.mathPluginv2-edit', function () {
          currentElement && editor.popups.isVisible('mathPluginv2.edit') && editor.events.disableBlur() && a(currentElement);
        }), i;
      }
      return !1;
    }
    function a(e) {
      touchEndElement.call(e.get(0));
    }
    function touchEndElement() {
      currentElement = $(this);
      showPopupElement();
    }
    function showPopupElement() {
      var e = editor.popups.get('mathPluginv2.edit');
      if (e || (e = getEditButtons()), e) {
        editor.popups.setContainer('mathPluginv2.edit', editor.$sc);
        editor.popups.refresh('mathPluginv2.edit');
        var left = currentElement.offset().left + currentElement.outerWidth() / 2,
          top = currentElement.offset().top + currentElement.outerHeight();
        editor.popups.show('mathPluginv2.edit', left, top, currentElement.outerHeight());
      }
    }
    function getMathliveLatexFormula() {
      var mfe = getMathfiledInstance();
      var latexFormula = mfe.getValue('latex');
      if (latexFormula.length > 1) {
        if (!latexFormula.startsWith(DELIMITER_BEGIN_LATEX) && !latexFormula.endsWith(DELIMITER_END_LATEX) && latexFormula.indexOf('`') !== 0 && latexFormula.indexOf('$$') !== 0) {
          latexFormula = DELIMITER_BEGIN_LATEX + latexFormula + DELIMITER_END_LATEX;
        }
        latexFormula = latexFormula.replaceAll('mleft', 'left');
        latexFormula = latexFormula.replaceAll('mright', 'right');
        latexFormula = latexFormula.replaceAll('\\exponentialE', '\\mathrm{e}');
        latexFormula = latexFormula.replaceAll('\\doubleprime', '\\prime\\prime');
        latexFormula = latexFormula.replaceAll('mathcolor', 'color');
        latexFormula = latexFormula.replaceAll('^^b7', ' · ');
      }
      return latexFormula;
    }
    function createFragment(markup) {
      var fragment = document.createRange().createContextualFragment(markup);
      return fragment.firstElementChild;
    }
    function insertMathLatex(latex) {
      if (latex) {
        var newElement = " <span class=\"fr-math-v2 fr-draggable\" draggable=\"true\" contenteditable=\"false\" data-original-math=\"" + latex + "\">" + latex + "</span> ";
        var newElementDom = createFragment(newElement);
        newElementDom.textContent = latex;
        if (editor.selection) editor.selection.restore();
        editor.html.insert(newElementDom.outerHTML);
        renderMathExpression(newElement);
      }
    }
    function insert() {
      var mfe = getMathfiledInstance();
      if (mfe) {
        var latexFormula = getMathliveLatexFormula();
        if (latexFormula.length > 1) {
          insertMathLatex(latexFormula);
          editor.popups.hideAll();
        }
      }
    }
    function remove() {
      if (currentElement) {
        var e = currentElement;
        editor.popups.hideAll();
        editor.selection.setBefore(e.get(0)) || editor.selection.setAfter(e.get(0));
        e.remove();
        editor.selection.restore();
        editor.html.fillEmptyBlocks();
        editor.undo.saveStep();
      }
    }
    function edit() {
      if (currentElement) {
        var latexFormula = currentElement[0].getAttribute('data-original-math');
        var left = currentElement.offset().left + currentElement.outerWidth() / 2,
          top = currentElement.offset().top + currentElement.outerHeight();
        var $popup = editor.popups.get('mathPluginv2.popup');
        if (!$popup) $popup = initPopup();
        editor.popups.setContainer('mathPluginv2.popup', editor.$sc);
        editor.popups.refresh('mathPluginv2.popup');
        editor.popups.show('mathPluginv2.popup', left, top, currentElement.outerHeight());
        var mfe = getMathfiledInstance();
        if (mfe) {
          var latexFormulaFinal = latexFormula;
          if (latexFormula.startsWith(DELIMITER_BEGIN_LATEX) && latexFormula.endsWith(DELIMITER_END_LATEX)) {
            latexFormulaFinal = latexFormulaFinal.substring(DELIMITER_BEGIN_LATEX.length, latexFormulaFinal.length - DELIMITER_END_LATEX.length);
          }
          mfe.setValue(latexFormulaFinal);
          mfe.focus();
        }
        var buttonAction = $popup.find('.fr-math-v2-action-button');
        if (buttonAction) {
          buttonAction.text('Update');
          buttonAction.data('cmd', 'mathUpdatev2');
        }
      }
      fixKeyboardMathDiv();
    }
    function update() {
      if (currentElement) {
        var latexFormula = getMathliveLatexFormula();
        currentElement[0].setAttribute('data-original-math', latexFormula);
        resetMathDiv(currentElement[0]);
        renderMathExpression([currentElement[0]]);
        editor.popups.hideAll();
      }
    }
    function hidePopup() {
      editor.popups.hide('mathPluginv2.popup');
    }
    function getMathElements(_editor) {
      return _editor.getElementsByClassName('fr-math-v2 fr-math');
    }
    function renderMathKatex(elements) {
      if (typeof renderMathInElement != 'undefined') {
        renderMathInElement(elements, {
          throwOnError: true,
          delimiters: delimitersKatex
        });
        editor.$el.find('.fr-math-v2').css('opacity', '1');
        editor.$el.find('.fr-math').css('opacity', '1');
      }
    }
    function renderMathJax(elements) {
      if (typeof MathJax != 'undefined') {
        MathJax.Hub.Queue(['Typeset', MathJax.Hub, elements, function () {}]);
      }
    }
    function renderMathExpression(elements) {
      if (elements && elements.length > 0) {
        var renderEngine = typeof mathRenderEngine != 'undefined' ? mathRenderEngine : 'mathjax';
        if (renderEngine === 'katex') {
          renderMathKatex(editor.el);
        } else {
          renderMathJax(elements);
        }
      }
    }
    function initMathField() {
      if (typeof window.MathLive !== 'undefined') {
        if (!mfes[editor.id]) {
          var mfe = new window.MathLive.MathfieldElement();
          mfe.setAttribute('virtual-keyboard-layout', 'dvorak');
          mfe.addEventListener('focusin', function () {
            return mathVirtualKeyboard.show();
          });
          mfe.setAttribute('class', 'froala-mathField__input');
          if (!firstEditor) firstEditor = editor.id;
          mfes[editor.id] = mfe;
        }
        var $popup = editor.popups.get('mathPluginv2.popup');
        var mathFieldContent = $popup.find('.fr-math-v2-field');
        mathFieldContent.append(mfes[editor.id]);
      }
    }
    function getMathfiledInstance() {
      var $popup = editor.popups.get('mathPluginv2.popup');
      var popupid = $popup ? $popup.find('.fr-math-v2-insert-layer').data('popup-id') : undefined;
      return mfes[popupid || editor.id] || mfes[firstEditor];
    }
    var currentElement,
      $ = editor.$;
    return {
      _init: _init,
      showPopup: showPopup,
      hidePopup: hidePopup,
      insert: insert,
      remove: remove,
      edit: edit,
      update: update
    };
  };
  FroalaEditor.DefineIcon('mathIcon', {
    NAME: 'mathIcon',
    SVG_KEY: 'symbols'
  });
  FroalaEditor.RegisterCommand('mathButtonv2', {
    title: 'Insert math expresion',
    icon: 'mathIcon',
    undo: false,
    focus: false,
    plugin: 'mathPluginv2',
    callback: function callback() {
      this.mathPluginv2.showPopup(false);
    }
  });
  FroalaEditor.DefineIcon('mathPluginv2Remove', {
    NAME: 'trash',
    SVG_KEY: 'remove'
  });
  FroalaEditor.RegisterCommand('mathPluginv2Remove', {
    title: 'Remove',
    undo: false,
    callback: function callback() {
      this.mathPluginv2.remove();
    }
  });
  FroalaEditor.DefineIcon('mathPluginv2Edit', {
    NAME: 'edit',
    SVG_KEY: 'edit'
  });
  FroalaEditor.RegisterCommand('mathPluginv2Edit', {
    title: 'Edit',
    undo: false,
    callback: function callback() {
      this.mathPluginv2.edit();
    }
  });
  FroalaEditor.DefineIcon('popupClosev2', {
    NAME: 'times',
    SVG_KEY: 'back'
  });
  FroalaEditor.RegisterCommand('popupClosev2', {
    title: 'Close',
    undo: false,
    focus: false,
    callback: function callback() {
      this.mathPluginv2.hidePopup();
    }
  });
  FroalaEditor.RegisterCommand('mathInsertv2', {
    focus: false,
    plugin: 'mathPluginv2',
    callback: function callback() {
      this.mathPluginv2.insert();
    }
  });
  FroalaEditor.RegisterCommand('mathUpdatev2', {
    focus: false,
    plugin: 'mathPluginv2',
    callback: function callback() {
      this.mathPluginv2.update();
    }
  });
})();
function getEventListenersPolyfill() {
  if (!Element.prototype.hasOwnProperty('getEventListeners') && !Element.prototype.hasOwnProperty('clearEventListeners')) {
    Element.prototype._addEventListener = Element.prototype.addEventListener;
    Element.prototype.addEventListener = function (a, b, c) {
      if (c == undefined) c = false;
      this._addEventListener(a, b, c);
      if (!this.eventListenerList) this.eventListenerList = {};
      if (!this.eventListenerList[a]) this.eventListenerList[a] = [];
      this.eventListenerList[a].push({
        listener: b,
        useCapture: c
      });
    };
    Element.prototype.getEventListeners = function (a) {
      if (!this.eventListenerList) this.eventListenerList = {};
      if (a == undefined) return this.eventListenerList;
      return this.eventListenerList[a];
    };
    Element.prototype.clearEventListeners = function (a) {
      if (!this.eventListenerList) this.eventListenerList = {};
      if (a == undefined) {
        for (var x in this.getEventListeners()) this.clearEventListeners(x);
        return;
      }
      var el = this.getEventListeners(a);
      if (el == undefined) return;
      for (var i = el.length - 1; i >= 0; --i) {
        var ev = el[i];
        this.removeEventListener(a, ev.listener, ev.useCapture);
      }
    };
    Element.prototype._removeEventListener = Element.prototype.removeEventListener;
    Element.prototype.removeEventListener = function (a, b, c) {
      if (c == undefined) c = false;
      this._removeEventListener(a, b, c);
      if (!this.eventListenerList) this.eventListenerList = {};
      if (!this.eventListenerList[a]) this.eventListenerList[a] = [];
      for (var i = 0; i < this.eventListenerList[a].length; i++) {
        if (this.eventListenerList[a][i].useCapture == c) {
          this.eventListenerList[a].splice(i, 1);
          break;
        }
      }
      if (this.eventListenerList[a].length == 0) delete this.eventListenerList[a];
    };
  }
}

function getEvents(setUploading, onBlur, extraButtons, maxLength, onInitialized, onMoreToolbarOpen, imageDefaultWidth, imageDefaultHeight, onSetImageHeight) {
  if (onInitialized === void 0) {
    onInitialized = null;
  }
  if (onMoreToolbarOpen === void 0) {
    onMoreToolbarOpen = null;
  }
  if (imageDefaultHeight === void 0) {
    imageDefaultHeight = null;
  }
  if (onSetImageHeight === void 0) {
    onSetImageHeight = null;
  }
  return {
    'image.beforeUpload': function imageBeforeUpload() {
      setUploading(true);
    },
    'image.inserted': function imageInserted(img, response) {
      var hasChangedHeight = false;
      if (imageDefaultHeight && img && img.length > 0 && img[0] && img[0].style) {
        img[0].style.height = imageDefaultHeight;
        hasChangedHeight = true;
      }
      setTimeout(function () {
        setUploading(false);
        if (hasChangedHeight) onSetImageHeight(img);
      }, 200);
    },
    blur: function blur() {
      onBlur(false);
    },
    focus: function focus() {
      onBlur(true);
    },
    initialized: function initialized() {
      var editor = this;
      onInitialized && onInitialized(editor);
    },
    'commands.after': function commandsAfter(cmd, param1, param2) {
      if (cmd.indexOf('more') > -1 && onMoreToolbarOpen && this && this.$tb && this.$tb.length > 0 && this.$tb[0].className) {
        onMoreToolbarOpen(this.$tb[0].className.indexOf('fr-toolbar-open') > -1);
      }
    },
    'paste.afterCleanup': function pasteAfterCleanup(clipboard_html) {
      if (clipboard_html.indexOf('data-responseid') >= 0) {
        return clipboard_html.replace(/<\/?span[^>]*>/g, '');
      }
    }
  };
}

addPortugueseLang();
addEuskeraLang();
addCatalanLang();
addGalicianLang();
addValencianLang();
var commonConfig = {
  key: 'lSA3D-17C1E1F2H2F2I1rXYb1VPUGRHYZNRJd1JVOOb1HAc1zG2B1A2B2D6B1B2C4F1D3=='
};
function getEditorConfig(setUploading, onBlur, extraButtons, maxLength, onInitialized, onMoreToolbarOpen, imageDefaultWidth, imageDefaultHeight, onSetImageHeight, assetsFroalaApi, toolbarInline, canInsertVideo) {
  if (extraButtons === void 0) {
    extraButtons = null;
  }
  if (maxLength === void 0) {
    maxLength = -1;
  }
  if (onInitialized === void 0) {
    onInitialized = null;
  }
  if (onMoreToolbarOpen === void 0) {
    onMoreToolbarOpen = null;
  }
  if (imageDefaultWidth === void 0) {
    imageDefaultWidth = null;
  }
  if (imageDefaultHeight === void 0) {
    imageDefaultHeight = null;
  }
  if (onSetImageHeight === void 0) {
    onSetImageHeight = null;
  }
  if (assetsFroalaApi === void 0) {
    assetsFroalaApi = null;
  }
  if (toolbarInline === void 0) {
    toolbarInline = false;
  }
  if (canInsertVideo === void 0) {
    canInsertVideo = false;
  }
  return _extends({
    htmlAllowedEmptyTags: ['textarea', 'a', 'iframe', 'object', 'video', 'style', 'script', '.fa', '.fr-emoticon', '.fr-inner', 'path', 'line', 'hr', '.MathJax_SVG svg *'],
    imageUploadURL: assetsFroalaApi,
    imageUploadMethod: 'POST',
    imageDefaultWidth: imageDefaultWidth || 0,
    toolbarSticky: false
  }, commonConfig, {
    language: config.lang,
    direction: config.rtl ? 'rtl' : 'ltr',
    pastePlain: true,
    charCounterMax: maxLength,
    attribution: false,
    scrollableContainer: "#" + FROALA_ID_SCROLLABLE_CONTAINER,
    editorClass: toolbarInline ? FROALA_TOOLBAR_INLINE : '',
    linkAlwaysBlank: true,
    quickInsertTags: [],
    linkInsertButtons: ['linkBack'],
    fontSize: ['8', '9', '10', '11', '12', '14', '16', '18', '20', '24', '30', '36', '48', '60', '72', '96'],
    tableStyles: {
      'fr-table-with-borders': 'With Borders',
      'fr-dashed-borders': 'Dashed Borders',
      'fr-alternate-rows': 'Alternate Rows',
      'fr-table-no-border': 'No Borders'
    },
    audioUploadURL: assetsFroalaApi,
    toolbarButtons: _extends({}, config.rtl ? {
      dirButtons: {
        buttons: ['rtl', 'numGroup']
      }
    } : {}, {
      moreText: {
        buttons: ['bold', 'italic', 'fontSize', 'underline'],
        buttonsVisible: 3
      }
    }, extraButtons !== null && {
      extraButtons: {
        buttons: extraButtons
      }
    }, {
      moreParagraph: {
        buttons: ['formatOL', 'formatUL', 'alignJustify', 'alignLeft', 'alignCenter', 'alignRight', 'paragraphFormat', 'quote'],
        buttonsVisible: 2
      },
      moreRich: {
        buttons: ['insertLink', assetsFroalaApi && 'insertImage', 'insertTable', 'insertAudio', canInsertVideo && 'insertVideo'],
        buttonsVisible: 5
      },
      moreMisc: {
        buttons: [].concat(!config.rtl ? ['numGroup'] : [], ['clearFormatting', 'outdent', 'indent', 'subscript', 'superscript', 'textColor', 'backgroundColor', 'mathButtonv2', 'html']),
        align: 'left',
        buttonsVisible: 10
      }
    }),
    events: _extends({}, getEvents(setUploading, onBlur, extraButtons, maxLength, onInitialized, onMoreToolbarOpen, imageDefaultWidth, imageDefaultHeight, onSetImageHeight))
  }, toolbarInline ? {
    toolbarInline: true,
    charCounterCount: false,
    toolbarVisibleWithoutSelection: true
  } : {}, canInsertVideo ? {
    videoUploadURL: assetsFroalaApi,
    videoUploadMethod: 'POST',
    videoInsertButtons: ['videoBack', '|', 'videoByURL', assetsFroalaApi && 'videoUpload'],
    videoAllowedProviders: ['youtube', 'vimeo'],
    videoDefaultDisplay: 'block',
    videoMaxSize: 1024 * 1024 * 520,
    videoResponsive: false
  } : {});
}

addPortugueseLang();
addEuskeraLang();
addCatalanLang();
addGalicianLang();
addValencianLang();
var commonConfig$1 = {
  key: 'lSA3D-17C1E1F2H2F2I1rXYb1VPUGRHYZNRJd1JVOOb1HAc1zG2B1A2B2D6B1B2C4F1D3=='
};
function getEditorConfigMin(setUploading, onBlur, extraButtons, maxLength, onInitialized, onMoreToolbarOpen, imageDefaultWidth, imageDefaultHeight, onSetImageHeight, assetsFroalaApi, toolbarInline) {
  if (extraButtons === void 0) {
    extraButtons = null;
  }
  if (maxLength === void 0) {
    maxLength = -1;
  }
  if (onInitialized === void 0) {
    onInitialized = null;
  }
  if (onMoreToolbarOpen === void 0) {
    onMoreToolbarOpen = null;
  }
  if (imageDefaultWidth === void 0) {
    imageDefaultWidth = null;
  }
  if (imageDefaultHeight === void 0) {
    imageDefaultHeight = null;
  }
  if (onSetImageHeight === void 0) {
    onSetImageHeight = null;
  }
  if (assetsFroalaApi === void 0) {
    assetsFroalaApi = null;
  }
  if (toolbarInline === void 0) {
    toolbarInline = false;
  }
  return _extends({
    imageUploadURL: assetsFroalaApi,
    imageUploadMethod: 'POST',
    imageDefaultWidth: imageDefaultWidth || 0,
    toolbarSticky: false
  }, commonConfig$1, {
    language: config.lang,
    direction: config.rtl ? 'rtl' : 'ltr',
    pastePlain: true,
    charCounterMax: maxLength,
    attribution: false,
    scrollableContainer: "#" + FROALA_ID_SCROLLABLE_CONTAINER,
    editorClass: toolbarInline ? FROALA_TOOLBAR_INLINE : '',
    linkAlwaysBlank: true,
    linkInsertButtons: ['linkBack'],
    toolbarButtons: _extends({}, config.rtl ? {
      dirButtons: {
        buttons: ['rtl', 'numGroup']
      }
    } : {}, {
      moreText: {
        buttons: ['bold', 'italic', 'underline'],
        buttonsVisible: 3
      }
    }, extraButtons !== null && {
      extraButtons: {
        buttons: extraButtons
      }
    }, {
      moreRich: {
        buttons: ['mathButtonv2', assetsFroalaApi && 'insertImage'],
        buttonsVisible: 2
      }
    }),
    events: _extends({}, getEvents(setUploading, onBlur, extraButtons, maxLength, onInitialized, onMoreToolbarOpen, imageDefaultWidth, imageDefaultHeight, onSetImageHeight))
  }, toolbarInline ? {
    toolbarInline: true,
    charCounterCount: false,
    toolbarVisibleWithoutSelection: true
  } : {});
}

function templateToModel(str) {
  return str.replace(/<span class="lemo-blank-cloze-math(.*?)<\/span><\/span>/g, function (match) {
    var responseId = getResponseIdFromSpanHtml(match);
    return getTagResponseToFroala(responseId);
  });
}
function updateTemplate(str, responses) {
  var counter = 0;
  return str.replace(/{{response(.*?)}}/g, function (match) {
    var dataResponseid = !!responses && responses[counter] ? responses[counter].id : null;
    if (dataResponseid === null) {
      dataResponseid = getResponseIdFromTagResponse(match);
    }
    var result = getElementBlankClozeMath(counter + 1 + '', dataResponseid);
    counter++;
    return result;
  });
}
function getElementBlankClozeMath(number, dataResponseid) {
  if (number === void 0) {
    number = '#';
  }
  if (dataResponseid === void 0) {
    dataResponseid = 'null';
  }
  return '<span class="lemo-blank-cloze-math lemo-add-response-close-math blank fr-draggable fr-embedly fr-deletable" data-responseid="' + dataResponseid + '" contenteditable="false" draggable="true">' + '<span class="lemo-add-response-cloze-math__text">' + translate('response') + '</span>' + '<span class="lemo-add-response-close-math__number">' + number + '</span>' + '<span contenteditable="true"></span>' + '</span>';
}
function getBlanksLength(template) {
  var matches = template.match(/{{response(.*?)}}/gi);
  return matches === null ? 0 : matches.length;
}
var SEPARATOR_TAG_MORE_INFO = '_-_';
function getTagResponseToFroala(responseId) {
  var moreData = '';
  if (hasData(responseId)) {
    var objToSave = {
      responseid: responseId
    };
    moreData = SEPARATOR_TAG_MORE_INFO + JSON.stringify(objToSave) + SEPARATOR_TAG_MORE_INFO;
  }
  return '{{response' + moreData + '}}';
}
function getInfoTemplateTagResponseSimply(templateTagComplex) {
  var template = '';
  if (hasData(templateTagComplex)) {
    template = templateTagComplex.replace(/{{response(.*?)}}/g, function (match) {
      var responseId = getResponseIdFromTagResponse(match);
      return '{{response}}';
    });
  }
  return {
    template: template,
    blanksResponsesId: getResponsesId(templateTagComplex)
  };
}
function getResponsesId(data) {
  var matches = data.match(/{{response(.*?)}}/g) || [];
  return matches.map(function (m) {
    var responseId = m.split('_-_');
    if (responseId.length < 3) return null;
    return responseId[1].replace(/(responseid)|(&quot;)|([{}:])/g, '');
  });
}
function getResponseIdFromTagResponse(tag) {
  var responseId = null;
  if (hasData(tag)) {
    var parts = tag.split(SEPARATOR_TAG_MORE_INFO);
    if (parts && parts.length >= 1) {
      var stringObj = parts[1];
      if (hasData(stringObj)) {
        try {
          var obj = JSON.parse(stringObj);
          if (obj && hasData(obj.responseid)) {
            responseId = obj.responseid;
          }
        } catch (error) {}
      }
    }
  }
  return responseId;
}
function getResponseIdFromSpanHtml(spanHtml) {
  var responseId = null;
  var matches = spanHtml.match(/data-responseid="(.*?)"/g) || [];
  if (matches && matches.length >= 1) {
    responseId = extractText(matches[0], 'data-responseid="', '"');
    if (responseId === 'null') responseId = null;
  }
  return responseId;
}

function focusEnd(editor) {
  if (editor && editor.$el) {
    editor.selection.setAtEnd(editor.$el.get(0));
    editor.selection.restore();
  }
}

function initFloalaAddResponseClozeMath(editor, idExternalButton) {
  renderResponsesModel(editor.$el[0].innerHTML);
  editor.events.bindClick(editor.$('body'), '#' + idExternalButton, function () {
    editor.html.insert(getElementBlankClozeMath('#', 'null'));
    renderResponses();
    focusEnd(editor);
    editor.events.trigger('contentChanged');
  });
  editor.events.on('html.processGet', function (e) {
    if (e.innerHTML) {
      e.innerHTML = templateToModel(e.innerHTML);
    }
  });
  editor.events.on('blur', function () {
    renderResponses();
  });
  editor.events.on('html.set', function () {
    renderResponses();
    focusEnd(editor);
  });
  editor.events.on('commands.undo', function () {
    renderResponses();
  });
  function renderResponsesModel(templateModel) {
    if (editor && editor.$el && editor.$el.length > 0) editor.$el[0].innerHTML = updateTemplate(templateModel, null);
  }
  function renderResponses() {
    renderResponsesModel(templateToModel(editor.$el[0].innerHTML));
  }
}

var useResizeHandler = function useResizeHandler(element, fn) {
  useEffect(function () {
    var handleSize = debounce(function () {
      fn({
        w: element.current ? element.current.offsetWidth : 0,
        h: element.current ? element.current.offsetHeight : 0
      });
    }, 240);
    window.addEventListener('resize', handleSize, false);
    handleSize();
    return function () {
      return window.removeEventListener('resize', handleSize);
    };
  }, []);
};

var offsetTop = 8;
var TextEditor = function TextEditor(_ref) {
  var model = _ref.model,
    onModelChange = _ref.onModelChange,
    config = _ref.config,
    visible = _ref.visible,
    visibleToolbar = _ref.visibleToolbar,
    _ref$visibleSecondToo = _ref.visibleSecondToolbar,
    visibleSecondToolbar = _ref$visibleSecondToo === void 0 ? false : _ref$visibleSecondToo;
  var _useState = useState(false),
    ready = _useState[0],
    setReady = _useState[1];
  var base = useRef();
  var froalaRef = useRef();
  useResizeHandler(base, function () {
    handleResizeToolbar();
  });
  useEffect(function checkReady() {
    setReady(Object.keys(config).length > 0);
  }, [config]);
  useEffect(function handleVisibility() {
    if (ready && visible) {
      var view = base.current.querySelector('.fr-view');
      setTimeout(function () {
        view.focus();
      }, 1);
    }
  }, [visible]);
  useEffect(function () {
    if (ready && visible) {
      var viewToolbar = base.current.querySelector('.fr-toolbar');
      if (viewToolbar) {
        viewToolbar.style.display = 'block';
      }
      var height = viewToolbar && viewToolbar.offsetHeight !== undefined && viewToolbar.offsetHeight !== null && viewToolbar.offsetHeight >= 0 ? viewToolbar.offsetHeight : 92;
      if (viewToolbar) {
        viewToolbar.style.display = visibleToolbar ? 'block' : 'none';
        viewToolbar.style.top = '-' + (height - offsetTop) + 'px';
      }
    }
  }, [visibleToolbar, visibleSecondToolbar]);
  function handleResizeToolbar() {
    if (visible && base && base.current) {
      var viewToolbar = base.current.querySelector('.fr-toolbar');
      var height = viewToolbar && viewToolbar.offsetHeight !== undefined && viewToolbar.offsetHeight !== null && viewToolbar.offsetHeight >= 0 ? viewToolbar.offsetHeight : 92;
      if (viewToolbar) {
        viewToolbar.style.top = '-' + (height - offsetTop) + 'px';
      }
    }
  }
  function _onModelChange(newContent) {
    var innerHTML = null;
    if (froalaRef && froalaRef.current && froalaRef.current.editor) {
      var editor = froalaRef.current.editor;
      if (editor && editor.$el && editor.$el.length > 0) {
        var _innerHtml = editor.$el[0].innerHTML;
        if (hasData(_innerHtml)) innerHTML = _innerHtml;
      }
    }
    onModelChange && onModelChange(newContent, innerHTML);
  }
  return !ready ? null : /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-froala-editor-component', {
      'lemo-is-empty': !model || model.length === 0
    }),
    ref: base,
    style: {
      display: visible ? 'block' : 'none',
      direction: config.direction === 'rtl' ? 'rtl' : 'auto'
    }
  }, /*#__PURE__*/React__default.createElement(FroalaEditorComponent, {
    ref: froalaRef,
    tag: "textarea",
    model: model,
    onModelChange: _onModelChange,
    config: config
  }));
};
var TextEditor$1 = observer(TextEditor);

var EXTERNAL_BUTTONS = {
  ADD_BLANK: 'ADD_BLANK',
  ADD_RESPONSE_CLOSE_MATH: 'ADD_RESPONSE_CLOSE_MATH'
};
var FROALA_FIELD_TYPE_CONFIG = {
  COMPLETE: 'COMPLETE',
  MIN: 'MIN'
};
var FROALA_ID_SCROLLABLE_CONTAINER = 'lemoid-fr-scrollable-container';
var FROALA_TOOLBAR_INLINE = 'lemo-fr-toolbar-inline';
var FroalaField = function FroalaField(_ref) {
  var content = _ref.content,
    _ref$setContent = _ref.setContent,
    setContent = _ref$setContent === void 0 ? noop : _ref$setContent,
    _ref$tabIndex = _ref.tabIndex,
    tabIndex = _ref$tabIndex === void 0 ? '1' : _ref$tabIndex,
    _ref$onCloseEditor = _ref.onCloseEditor,
    onCloseEditor = _ref$onCloseEditor === void 0 ? noop : _ref$onCloseEditor,
    _ref$editMode = _ref.editMode,
    editMode = _ref$editMode === void 0 ? false : _ref$editMode,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
    extraButtons = _ref.extraButtons,
    maxLength = _ref.maxLength,
    externalButtons = _ref.externalButtons,
    _ref$typeConfig = _ref.typeConfig,
    typeConfig = _ref$typeConfig === void 0 ? FROALA_FIELD_TYPE_CONFIG.COMPLETE : _ref$typeConfig,
    imageDefaultWidth = _ref.imageDefaultWidth,
    imageDefaultHeight = _ref.imageDefaultHeight,
    assetsFroalaApi = _ref.assetsFroalaApi,
    _ref$toolbarInline = _ref.toolbarInline,
    toolbarInline = _ref$toolbarInline === void 0 ? false : _ref$toolbarInline,
    _ref$canInsertVideo = _ref.canInsertVideo,
    canInsertVideo = _ref$canInsertVideo === void 0 ? false : _ref$canInsertVideo,
    handleInitialized = _ref.handleInitialized;
  var _isMounted = useRef(false);
  var editorRef = useRef(null);
  var _useState = useState('defaultkey'),
    refreshKey = _useState[0],
    setRefreshKey = _useState[1];
  var _useState2 = useState(false),
    uploading = _useState2[0],
    setUploading = _useState2[1];
  var _useState3 = useState({}),
    froalaConfig = _useState3[0],
    setFroalaConfig = _useState3[1];
  var _useState4 = useState(false),
    isFocused = _useState4[0],
    setFocus = _useState4[1];
  var _useState5 = useState(false),
    isMoreToolbar = _useState5[0],
    setIsMoreToolbar = _useState5[1];
  var _useState6 = useState(content),
    localContent = _useState6[0],
    setLocalContent = _useState6[1];
  var base = useRef(null);
  var extraButtonsLength = useMemo(function () {
    return defaultValue('length', extraButtons, 0);
  }, [extraButtons]);
  var updateContent = useCallback(function (newContent, innerHTML) {
    setLocalContent(newContent);
    setContent(newContent, innerHTML);
  }, [setLocalContent, setContent]);
  var onFocus = useCallback(function () {
    return editMode && setFocus(true);
  }, [setFocus, editMode]);
  var forceBlur = useCallback(function (e) {
    return e.keyCode === 27 && setFocus(false);
  }, [setFocus]);
  var onBlur = useCallback(function (value) {
    setFocus(value);
  }, [setFocus]);
  var onMoreToolbarOpen = useCallback(function (open) {
    setIsMoreToolbar(open);
  }, [setIsMoreToolbar]);
  var onInitialized = useCallback(function (editor) {
    editorRef.current = editor;
    if (editor && externalButtons && externalButtons.hasOwnProperty(EXTERNAL_BUTTONS.ADD_RESPONSE_CLOSE_MATH)) {
      var idExternalButton = externalButtons[EXTERNAL_BUTTONS.ADD_RESPONSE_CLOSE_MATH];
      initFloalaAddResponseClozeMath(editor, idExternalButton);
    }
    if (editor && externalButtons) {
      if (externalButtons.hasOwnProperty(EXTERNAL_BUTTONS.ADD_BLANK)) {
        var id = externalButtons[EXTERNAL_BUTTONS.ADD_BLANK];
        editor.events.bindClick(editor.$('body'), '#' + id, function () {
          editor.html.insert('&nbsp;<span class="lemo-blank fr-draggable fr-embedly" draggable="true">#</span>&emsp;');
        });
      }
    }
    if (editor && placeholder) {
      if (editor.opts) editor.opts.placeholderText = placeholder;
      if (editor.placeholder) {
        editor.placeholder.refresh();
      }
    }
    handleInitialized === null || handleInitialized === void 0 ? void 0 : handleInitialized(editor);
  }, [externalButtons, placeholder]);
  useEffect(function () {
    if (isFocused) {
      document.addEventListener('keydown', forceBlur, false);
    } else {
      document.removeEventListener('keydown', forceBlur, false);
      setTimeout(onCloseEditor, 100);
    }
    return function () {
      document.removeEventListener('keydown', forceBlur, false);
    };
  }, [isFocused, forceBlur]);
  useEffect(function () {
    _isMounted.current = true;
    return function () {
      _isMounted.current = false;
    };
  }, []);
  useEffect(function () {
    if (_isMounted && content !== localContent) {
      setLocalContent(content);
    }
  }, [content]);
  var outlineConfig = useMemo(function () {
    return editMode ? {} : {
      outline: 'none'
    };
  }, [editMode]);
  function _onSetImageHeight(img) {
    if (editorRef && editorRef.current && editorRef.current.html) {
      setLocalContent(editorRef.current.html.get());
    }
  }
  useEffect(function () {
    if (_isMounted) {
      setFroalaConfig(_extends({}, typeConfig === FROALA_FIELD_TYPE_CONFIG.MIN ? _extends({}, getEditorConfigMin(setUploading, onBlur, extraButtons, maxLength, onInitialized, onMoreToolbarOpen, imageDefaultWidth, imageDefaultHeight, _onSetImageHeight, assetsFroalaApi, toolbarInline)) : _extends({}, getEditorConfig(setUploading, onBlur, extraButtons, maxLength, onInitialized, onMoreToolbarOpen, imageDefaultWidth, imageDefaultHeight, _onSetImageHeight, assetsFroalaApi, toolbarInline, canInsertVideo)), placeholder.length > 0 && {
        placeholderText: placeholder
      }));
      setRefreshKey(Date.now().toString());
    }
  }, [placeholder, setFroalaConfig, extraButtonsLength, config.onUpdate, maxLength, imageDefaultWidth, imageDefaultHeight]);
  useEffect(function () {
    if (!isFocused) renderMath(base === null || base === void 0 ? void 0 : base.current);
    if (base !== null && base !== void 0 && base.current) initAudios(base === null || base === void 0 ? void 0 : base.current, true, translate('Transcription'));
  }, [isFocused]);
  return /*#__PURE__*/React__default.createElement("div", {
    key: refreshKey,
    ref: base,
    onClick: onFocus,
    tabIndex: tabIndex,
    style: outlineConfig
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-froala"
  }, !editMode && /*#__PURE__*/React__default.createElement("p", null, "Error no editMode"), ' ', editMode && /*#__PURE__*/React__default.createElement(TextEditor$1, {
    model: localContent,
    onModelChange: updateContent,
    config: froalaConfig,
    visible: true,
    visibleToolbar: isFocused && editMode || uploading,
    visibleSecondToolbar: isMoreToolbar
  })));
};
FroalaField.propTypes = {
  externalButtons: propTypes.object,
  typeConfig: propTypes.oneOf([FROALA_FIELD_TYPE_CONFIG.COMPLETE, FROALA_FIELD_TYPE_CONFIG.MIN]),
  imageDefaultWidth: propTypes.number,
  imageDefaultHeight: propTypes.string,
  toolbarInline: propTypes.bool
};
FroalaField.defaultProps = {
  typeConfig: FROALA_FIELD_TYPE_CONFIG.COMPLETE,
  imageDefaultWidth: null,
  imageDefaultHeight: null,
  toolbarInline: false
};
var FroalaField$1 = observer(FroalaField);

function LemonadeRenderContext(_ref) {
  var children = _ref.children;
  var rootNode = useRef(null);
  useMathRender(rootNode, [children]);
  useAudios(rootNode, [children]);
  useCharts(rootNode, [children]);
  useFractionalShapes(rootNode, [children]);
  return /*#__PURE__*/React__default.createElement("div", {
    ref: rootNode,
    className: "html-content fr-element fr-view"
  }, children);
}

function initConfig(_config) {
  config.setConfig(_config);
  return config;
}
function getConfig() {
  return config;
}
var setConfig = action(function (conf) {
  return config.setConfig(conf);
});

function Points(_ref) {
  var store = _ref.store,
    renderScore = _ref.renderScore;
  return /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-points"
  }, renderScore ? renderScore(store.points) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, translate('points'), ":", ' ', /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-points-text",
    title: "points"
  }, parseInt(store.points * 100, 10), "%")));
}
var Points$1 = observer(Points);

function HintsButton(_ref) {
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(ButtonHint$1, {
    hints: store.hints
  });
}
var HintsButton$1 = observer(HintsButton);

function CancelButton$2(_ref) {
  var onCancel = _ref.onCancel,
    disabled = _ref.disabled;
  return /*#__PURE__*/React__default.createElement(InlineButton, {
    className: "lemo-controls-button-cancel",
    onClick: onCancel,
    disabled: disabled,
    title: translate('button_cancel')
  }, translate('button_cancel'));
}
var CancelButton$3 = observer(CancelButton$2);

var QuestionControls = function QuestionControls(_ref) {
  var _store$raw;
  var disabled = _ref.disabled,
    store = _ref.store,
    showPoints = _ref.showPoints,
    _ref$showHints = _ref.showHints,
    showHints = _ref$showHints === void 0 ? true : _ref$showHints,
    _ref$onValidate = _ref.onValidate,
    onValidate = _ref$onValidate === void 0 ? null : _ref$onValidate,
    _ref$onReset = _ref.onReset,
    onReset = _ref$onReset === void 0 ? null : _ref$onReset,
    _ref$onShowSolutions = _ref.onShowSolutions,
    onShowSolutions = _ref$onShowSolutions === void 0 ? null : _ref$onShowSolutions,
    onIDK = _ref.onIDK,
    _ref$showCheckAnswer = _ref.showCheckAnswer,
    showCheckAnswer = _ref$showCheckAnswer === void 0 ? true : _ref$showCheckAnswer,
    _ref$showReset = _ref.showReset,
    showReset = _ref$showReset === void 0 ? false : _ref$showReset,
    _ref$showSolution = _ref.showSolution,
    showSolution = _ref$showSolution === void 0 ? false : _ref$showSolution,
    _ref$showRepeatAfterS = _ref.showRepeatAfterShowSolution,
    showRepeatAfterShowSolution = _ref$showRepeatAfterS === void 0 ? false : _ref$showRepeatAfterS,
    _ref$showCancel = _ref.showCancel,
    showCancel = _ref$showCancel === void 0 ? false : _ref$showCancel,
    _ref$onCancel = _ref.onCancel,
    onCancel = _ref$onCancel === void 0 ? null : _ref$onCancel,
    _ref$isScaffold = _ref.isScaffold,
    isScaffold = _ref$isScaffold === void 0 ? false : _ref$isScaffold,
    _ref$visible = _ref.visible,
    visible = _ref$visible === void 0 ? true : _ref$visible,
    children = _ref.children,
    _ref$renderScore = _ref.renderScore,
    renderScore = _ref$renderScore === void 0 ? null : _ref$renderScore;
  useDefaultProp({
    setter: store.setDisabled,
    value: disabled
  });
  var _useState = useState(false),
    wasSolutionVisible = _useState[0],
    setWasSolutionVisible = _useState[1];
  var isEvaluable = store.isEvaluable,
    isEvaluated = store.isEvaluated;
  var isOrderList = (store === null || store === void 0 ? void 0 : (_store$raw = store.raw) === null || _store$raw === void 0 ? void 0 : _store$raw.type) === 'orderlist';
  var shouldShowCheckAnswer = function shouldShowCheckAnswer() {
    return showCheckAnswer && isEvaluable && (!isEvaluated || isEvaluated && !showReset);
  };
  var shouldShowPoints = function shouldShowPoints() {
    var showingSolution = store.showSolution || store.internalAutoFeedback;
    return showPoints && isEvaluated && !showingSolution && isEvaluable;
  };
  var shouldShowReset = function shouldShowReset() {
    var checkIfShowSolution = !isScaffold || !wasSolutionVisible;
    return showReset && isEvaluated && isEvaluable && checkIfShowSolution;
  };
  var shouldShowCancel = function shouldShowCancel() {
    return showCancel && !isEvaluated;
  };
  var shouldShowSolution = function shouldShowSolution() {
    return showSolution && isEvaluated && isEvaluable;
  };
  var shouldShowHints = function shouldShowHints() {
    return showHints && store.hints.hasHints;
  };
  var shouldShowIDK = function shouldShowIDK() {
    return !isEvaluated && !!onIDK;
  };
  var areHintsAndIDKVisible = !!shouldShowIDK() && !!shouldShowHints();
  var handleValidation = useCallback(function () {
    if (store.isEvaluated) return false;
    store.checkAnswers();
    setTimeout(function () {
      onValidate === null || onValidate === void 0 ? void 0 : onValidate({
        output: store.output,
        points: store.points,
        response: store.getResponseWithKey(),
        store: store
      });
    });
  }, [store, onValidate]);
  var handleIDK = useCallback(function () {
    shouldShowIDK() && (onIDK === null || onIDK === void 0 ? void 0 : onIDK());
    store.checkAnswers();
  }, [onIDK, shouldShowIDK]);
  var handleReset = useCallback(function () {
    store.reset();
    onReset === null || onReset === void 0 ? void 0 : onReset();
  }, [store, onReset]);
  var handleShowSolution = useCallback(function () {
    store.showSolutions(!store.showSolution);
    if (!showRepeatAfterShowSolution) setWasSolutionVisible(true);
    onShowSolutions === null || onShowSolutions === void 0 ? void 0 : onShowSolutions();
  }, [store, onShowSolutions, setWasSolutionVisible]);
  useEffect(function () {
    setWasSolutionVisible(false);
  }, [store.reference]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isOrderList && children, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-controls"
  }, !isOrderList && children, visible && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-controls-wrapper"
  }, /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: shouldShowPoints()
  }, /*#__PURE__*/React__default.createElement(Points$1, {
    store: store,
    renderScore: renderScore
  })), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: shouldShowHints() && !areHintsAndIDKVisible
  }, /*#__PURE__*/React__default.createElement(HintsButton$1, {
    store: store
  })), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: shouldShowIDK() && !areHintsAndIDKVisible
  }, /*#__PURE__*/React__default.createElement(IDKButton$1, {
    onClick: handleIDK
  })), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: areHintsAndIDKVisible
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-controls-inline"
  }, /*#__PURE__*/React__default.createElement(HintsButton$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(IDKButton$1, {
    onClick: handleIDK
  }))), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: shouldShowCancel()
  }, /*#__PURE__*/React__default.createElement(CancelButton$3, {
    onCancel: onCancel,
    disabled: disabled
  })), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: shouldShowCheckAnswer()
  }, /*#__PURE__*/React__default.createElement(CheckAnswerButton$1, {
    disabled: store.disabled || store.isEvaluated,
    onClick: handleValidation
  })), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: shouldShowReset()
  }, /*#__PURE__*/React__default.createElement(ResetButton$1, {
    handleReset: handleReset,
    disabled: disabled,
    isEvaluated: isEvaluated
  })), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: shouldShowSolution()
  }, /*#__PURE__*/React__default.createElement(ShowSolutionButton$1, {
    showSolution: store.showSolution,
    onClick: handleShowSolution
  })))));
};
var QuestionControls$1 = observer(QuestionControls);

function SampleAnswer(_ref) {
  var store = _ref.store,
    _ref$isVisible = _ref.isVisible,
    isVisible = _ref$isVisible === void 0 ? true : _ref$isVisible;
  return isVisible && config.showSampleAnswer && hasData(store.sample_answer) ? /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-sample-answer"
  }, /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    className: "lemo-response-message",
    content: store.sample_answer
  })) : null;
}
var _SampleAnswer = observer(SampleAnswer);

function WithTheme(_ref) {
  var children = _ref.children;
  console.warn('[Deprecation] lemonade do not depend on WithTheme for styles configuration');
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
}

function questionBodyToImage(renderElement) {
  var questionBody = renderElement.querySelector('.lemo-question-body');
  return domToImage.toPng(questionBody).then(function (dataUrl) {
    var img = new Image();
    img.src = dataUrl;
    questionBody.remove();
    renderElement.appendChild(img);
  })["catch"](function (error) {
    console.error('oops, something went wrong!', error);
  });
}

var parser = new DOMParser();
function getFormulas(element) {
  var formulaElements = element.querySelectorAll('.fr-math, .fr-math-v2');
  formulaElements.forEach(function (formula) {
    if (formula.innerText.length > 0) {
      var htmlString = template(formula.innerText);
      var document = parser.parseFromString(htmlString, 'text/html');
      var img = document.querySelector('img');
      formula.replaceWith(img);
    }
  });
}
var replaceFormulaSeparator = function replaceFormulaSeparator(f) {
  return f.replace(/^\\\(\\(.*)\\\)$/, '$1');
};
var template = function template(formula) {
  var timeStamp = "&timestamp=" + new Date().getTime();
  var f = replaceFormulaSeparator(formula);
  var url = "https://latex.codecogs.com/png.image?\\dpi{120}\\" + f;
  return "<img src=\"" + (url + timeStamp) + "\"  alt=\"formula\" />";
};

function onRenderComplete(renderElement) {
  return new Promise(function (resolve) {
    var imageCounter = 0;
    var imageTags = renderElement.getElementsByTagName('img');
    var handleComplete = function handleComplete() {
      setTimeout(function () {
        return resolve();
      }, 1000);
    };
    var updateCounter = function updateCounter() {
      imageCounter += 1;
      if (imageCounter === imageTags.length) handleComplete();
    };
    if (imageTags.length === 0) handleComplete();
    Array.from(imageTags).forEach(function (image) {
      return image.complete ? updateCounter() : image.addEventListener('load', updateCounter);
    });
  });
}

function base64ToBrowser(buffer) {
  return window.btoa([].slice.call(new Uint8Array(buffer)).map(function (bin) {
    return String.fromCharCode(bin);
  }).join(''));
}
function imageToBase64(urlOrImage, param) {
  if (!('fetch' in window && 'Promise' in window)) {
    return Promise.reject("[*] It's image2base64 not compatible with your browser.");
  }
  return fetch(urlOrImage, param || {}).then(function (response) {
    return response.arrayBuffer();
  }).then(base64ToBrowser);
}

var isLatex = function isLatex(img) {
  return img.getAttribute('src').indexOf('https://latex.codecogs.com') > -1;
};
function getImages(_ref) {
  var renderElement = _ref.renderElement,
    withCredentials = _ref.withCredentials,
    onComplete = _ref.onComplete;
  var imageTags = renderElement.querySelectorAll('img');
  if (imageTags.length === 0) return onComplete();
  var handleComplete = createOnComplete({
    totalImages: imageTags.length,
    element: renderElement,
    onCompleteCallback: onComplete
  });
  imageTags.forEach(function (image) {
    startConversion(image, withCredentials, handleComplete);
  });
}
function startConversion(image, withCredentials, handleComplete) {
  if (image.naturalWidth < 1) return setTimeout(function () {
    return startConversion(image, withCredentials, handleComplete);
  }, 50);
  if (!isLatex(image)) {
    setLeftAlign(image);
    resizeImage(image);
  }
  convertImage(image, withCredentials).then(handleComplete);
}
function setLeftAlign(image) {
  image.parentElement.style.textAlign = 'left';
}
function resizeImage(image) {
  var newWidth = 200;
  var initialWidth = image.naturalWidth;
  var initialHeight = image.naturalHeight;
  var percent = newWidth / (initialWidth / 100);
  image.width = newWidth.toString();
  image.height = (percent * initialHeight / 100).toString();
  image.onload = null;
}
function avoidImageCache(src) {
  var concatSign = src.includes('?') ? '&' : '?';
  var timeStamp = concatSign + "timestamp=" + new Date().getTime();
  return src + timeStamp;
}
function convertImage(image, withCredentials) {
  var credentials = withCredentials && !isLatex(image) ? {
    credentials: 'include'
  } : {};
  return imageToBase64(avoidImageCache(image.src), credentials).then(function (res) {
    image.src = 'data:image/png;base64, ' + res;
  })["catch"](function (err) {
    console.log(err);
    console.log('ha habido un error con la imagen actual ->', image.src);
  });
}
var createOnComplete = function createOnComplete(_ref2) {
  var totalImages = _ref2.totalImages,
    element = _ref2.element,
    onCompleteCallback = _ref2.onCompleteCallback;
  return function () {
    totalImages -= 1;
    if (totalImages === 0) {
      return onCompleteCallback(element);
    }
  };
};

var addDelay = function addDelay(delay) {
  try {
    return Promise.resolve(new Promise(function (resolve) {
      return setTimeout(resolve, delay);
    })).then(function () {});
  } catch (e) {
    return Promise.reject(e);
  }
};

function usePrintView(_ref) {
  var onPageLoaded = function onPageLoaded() {
    try {
      return Promise.resolve(onRenderComplete(root.current)).then(function () {
        return Promise.resolve(onQuestionReady(root.current)).then(function () {
          return Promise.resolve(addDelay(500)).then(function () {
            onComplete();
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var store = _ref.store,
    credentials = _ref.credentials,
    root = _ref.root,
    response = _ref.response,
    isEvaluated = _ref.isEvaluated,
    isSolved = _ref.isSolved,
    onQuestionReady = _ref.onQuestionReady,
    onComplete = _ref.onComplete;
  var data = store.raw;
  var _useState = useState(null),
    activity = _useState[0],
    setActivity = _useState[1];
  function setActivityMode() {
    if (!activity.questionStore) return;
    var printStore = activity.questionStore;
    window.printStore = printStore;
    printStore.setIsPrintMode(true);
    when()["case"](isSolved, function () {
      var _store$getValidRespon, _data$data, _data$data$validation, _data$data$validation2;
      if (!store.isEvaluable) return false;
      var validResponse = (store === null || store === void 0 ? void 0 : (_store$getValidRespon = store.getValidResponses) === null || _store$getValidRespon === void 0 ? void 0 : _store$getValidRespon.call(store)) || ((_data$data = data.data) === null || _data$data === void 0 ? void 0 : (_data$data$validation = _data$data.validation) === null || _data$data$validation === void 0 ? void 0 : (_data$data$validation2 = _data$data$validation.valid_response) === null || _data$data$validation2 === void 0 ? void 0 : _data$data$validation2.value) || '';
      printStore.setResponse(validResponse);
      printStore.checkAnswers();
    })["case"](!isSolved, function () {
      printStore.reset();
      printStore.setDisabled(true);
    })["case"](response, function () {
      printStore.setResponse(response);
      printStore.setDisabled(true);
      isEvaluated && printStore.checkAnswers();
    }).resolve(function () {
      return printStore.setDisabled(true);
    });
  }
  useEffect(function () {
    setActivity(getActivity({
      data: data,
      basePath: store.basePath,
      assetsQuestionApi: store.assetsQuestionApi,
      assetsEditorApi: store.assetsEditorApi,
      assetsQuestionApiDrive: store.assetsQuestionApiDrive
    }));
  }, []);
  function handleLoading() {
    if (document.readyState) {
      onPageLoaded();
    } else {
      window.addEventListener('load', onPageLoaded);
    }
  }
  function removeMedia(node) {
    node.querySelectorAll('audio, video').forEach(function (mediaElement) {
      mediaElement.parentElement.removeChild(mediaElement);
    });
  }
  useEffect(function () {
    if (activity !== null) {
      removeMedia(root.current);
      setActivityMode();
      getFormulas(root.current);
      getImages({
        renderElement: root.current,
        withCredentials: credentials,
        onComplete: handleLoading
      });
    }
  }, [activity, isSolved]);
  return {
    activity: activity
  };
}

function PrintViewGeneric(_ref) {
  var store = _ref.store,
    credentials = _ref.credentials,
    response = _ref.response,
    isEvaluated = _ref.isEvaluated,
    isSolved = _ref.isSolved,
    _ref$onComplete = _ref.onComplete,
    onComplete = _ref$onComplete === void 0 ? noop : _ref$onComplete;
  var root = useRef();
  var _usePrintView = usePrintView({
      store: store,
      root: root,
      credentials: credentials,
      onComplete: onComplete,
      response: response,
      isEvaluated: isEvaluated,
      isSolved: isSolved,
      onQuestionReady: function onQuestionReady() {
        return questionBodyToImage(root.current);
      }
    }),
    activity = _usePrintView.activity;
  return activity !== null ? /*#__PURE__*/React__default.createElement("div", {
    key: isSolved ? 'solved' : 'notSolved',
    ref: root,
    className: "lemo-print-view"
  }, /*#__PURE__*/React__default.createElement(activity.Question, {
    isPrintView: true
  })) : null;
}
var _PrintView = observer(PrintViewGeneric);

function commonCreatorProps(store, props) {
  return _extends({
    store: store,
    WithTheme: WithTheme,
    Feedback: function Feedback(extraParams) {
      return /*#__PURE__*/React__default.createElement(FeedbackManager$1, _extends({
        store: store
      }, extraParams));
    },
    SampleAnswer: function SampleAnswer(extraParams) {
      return /*#__PURE__*/React__default.createElement(_SampleAnswer, _extends({
        store: store
      }, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: store
      }, extraParams));
    },
    PrintView: function PrintView(extraParams) {
      return /*#__PURE__*/React__default.createElement(_PrintView, _extends({
        store: store
      }, extraParams));
    },
    editorStore: store,
    questionStore: store
  }, props);
}

function useGetTemplateClass(store) {
  var name = store.raw.metadata.name;
  var findItem = function findItem() {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries(normalizedTypes).find(function (item) {
      return item[1].value === name;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1];
  };
  return useMemo(function () {
    var item = findItem();
    return {
      templateClass: item.className,
      subTemplateId: item.subTemplateId
    };
  }, [name]);
}

var languageNames = {
  es: 'language_spanish',
  en: 'language_english',
  pt: 'language_portuguese',
  ca: 'language_catalan',
  gl: 'language_gallego',
  eu: 'language_vasco',
  vl: 'language_valenciano'
};
var getLanguageName = (function (lang) {
  return languageNames[lang];
});

var isInit = false;
var defineIdentity = function defineIdentity() {
  var identify = new amplitude.Identify().set('lang', getLanguageName(config.lang)).set('version', window.lemonadeVersion).set('host', config.hostName).set('environment', config.amplitudeEnvironment);
  amplitude.getInstance('lemonade').identify(identify);
};
var initAmplitude = function initAmplitude(cb) {
  var _process, _process$env;
  if (!isEnvironmentInitialized()) return false;
  if (isInit) return false;
  isInit = true;
  var projectId = config.hostName;
  amplitude.getInstance().init((_process = process) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.REACT_APP_AMPLITUDE, projectId, {}, function () {
    defineIdentity();
    cb === null || cb === void 0 ? void 0 : cb();
  });
};
var logEvent = function logEvent(eventType, eventProperties) {
  if (eventProperties === void 0) {
    eventProperties = {};
  }
  if (!isEnvironmentInitialized()) return false;
  amplitude.getInstance().logEvent(eventType, eventProperties);
};

var templateNames = {
  'lemo-multiple-choice-single': 'choice_single',
  'lemo-multiple-choice-multiple': 'choice_multiple',
  'lemo-multiple-choice-true-false': 'choice_truefalse',
  'lemo-multiple-choice-block': 'choice_block',
  'lemo-multiple-choice-table': 'choice_table',
  'lemo-choice-matrix-inline': 'choice_inline',
  'lemo-essay-short-text': 'text_short',
  'lemo-cloze-text': 'text_cloze',
  'lemo-label-image-text': 'text_labelimage',
  'lemo-cloze-dropdown': 'dropdown_cloze',
  'lemo-cloze-drag': 'draganddrop_cloze',
  'lemo-label-image-dropdown': 'dropdown_labelimage',
  'lemo-label-image-drag': 'draganddrop_labelimage',
  'lemo-other-click-to-find': 'identify_click',
  'lemo-classify-order-list': 'order_list',
  'lemo-classify-match-list': 'match_list',
  'lemo-classify-linking-lines': 'match_linkinglines',
  'lemo-classify-classification': 'match_classification',
  'lemo-other-word-search': 'identify_wordssearch',
  'lemo-other-pencil': 'manual_pencil',
  'lemo-essay-rich-text': 'manual_essay',
  'lemo-other-statement': 'manual_statement',
  'lemo-other-upload-file': 'manual_upload',
  'lemo-other-audio-recorder': 'manual_audiorecorder',
  'lemo-math-cloze-math': 'math_cloze'
};
var getTemplateName = (function (name) {
  return templateNames[name];
});

var getSendLog = (function (_ref) {
  var template = _ref.template,
    context = _ref.context;
  return function (eventName) {
    return logEvent(eventName, {
      context: context,
      template: getTemplateName(template)
    });
  };
});

var getOnCallAction = (function (actionName, sendLog) {
  return function (eventName, logName) {
    return actionName === eventName && sendLog(logName);
  };
});

var contextTypes = {
  EDITOR: 'editor',
  PREVIEW: 'preview'
};

var ACTION = {
  CREATE_ALTERNATIVE_SOLUTION: 'createAlternativeSolution',
  SET_DUPLICATE_RESPONSES: 'setDuplicateResponses',
  SET_GLOBAL_FEEDBACK: 'setGlobalFeedback',
  SET_SPECIFIC_FEEDBACK: 'setSpecificFeedback',
  SET_SAMPLE_ANSWER: 'setSampleAnswer',
  SET_BACKGROUND: 'setBackground',
  SET_SHUFFLE_OPTIONS: 'setShuffleOptions',
  SET_SHOW_CHECK_ICON: 'setShowCheckIcon',
  ADD_GROUPED_SOLUTION_AT: 'addGroupedSolutionAt',
  TOGGLE_ACCENTS: 'toggleAccents',
  TOGGLE_LOWER: 'toggleLower',
  TOGGLE_SPACES: 'toggleSpaces',
  SET_PERCENT: 'setPercent',
  SET_LINE_THICKNESS: 'setLineThickness',
  SET_STACK: 'setStack',
  SET_WITH_BOX: 'setWithBox',
  SET_WORDS_LIMIT: 'setWordsLimit',
  SET_MAX_FILES: 'setMaxFiles',
  SET_DECIMAL_PLACES: 'setDecimalPlaces',
  UPDATE_WORD_SEARCH: 'updateWordSearch',
  SET_BACKWARD: 'setBackward',
  SET_EVALUATION_TYPE: 'setEvaluationType',
  SET_PENALTY_MODE: 'setPenaltyMode',
  SET_KEYBOARD_TYPE: 'setKeyboardType',
  SET_FEEDBACK_MODE: 'setFeedbackMode',
  SET_COLUMN_DIRECTION: 'setColumnDirection',
  SET_METHOD_INDEX: 'setMethodIndex',
  INTENT_SET_COLUMNS_ROWS: 'intentSetColumnsRows',
  RESET: 'reset',
  CHECK_ANSWERS: 'checkAnswers',
  SHOW_HINT: 'showHint',
  SHOW_SOLUTIONS: 'showSolutions'
};

var EVENT = {
  SOLUTION_ALTERNATIVE: 'Solution_Alternative',
  RESPONSES_DUPLICATE: 'Responses_Duplicate',
  FEEDBACK_GENERAL: 'Feedback_General',
  FEEDBACK_SPECIFIC: 'Feedback_Specific',
  SOLUTION_REFERENCE: 'Solution_Reference',
  BACKGROUND: 'Background',
  SHUFFLE: 'Shuffle',
  CHECK_ICON: 'CheckIcon',
  RESPONSES_MULTIPLE: 'Responses_Multiple',
  SENSITIVE_ACCENT: 'Sensitive_Accent',
  SENSITIVE_CASE: 'Sensitive_Case',
  SENSITIVE_SPACES: 'Sensitive_Spaces',
  BACKGROUND_SIZE: 'Background_Size',
  LINES_THICKNESS: 'Lines_Thickness',
  OPTIONS_STACK: 'Options_Stack',
  OPTIONS_FRAME: 'Options_Frame',
  COUNTER_WORD: 'Counter_Word',
  FILES_NUMBER: 'Files_Number',
  RESULT_DECIMALS: 'Result_Decimals',
  WORDSEARCH_GENERATE: 'WordSearch_Generate',
  WORDSEARCH_INVERTED: 'WordSearch_Inverted',
  VARIANT_CUSTOM: 'Variant_Custom',
  START: 'Start',
  LEAVE: 'Leave',
  MATCH_EXACT: 'Match_Exact',
  MATCH_PARTIAL: 'Match_Partial',
  MANUAL: 'Manual',
  PENALIZE_RESPONSE_SCORE: 'Penalize_ResponseScore',
  PENALIZE_CUSTOM: 'Penalize_Custom',
  PENALIZE_NONE: 'Penalize_None',
  KEYBOARD_NUMERIC: 'Keyboard_Numeric',
  KEYBOARD_BASIC: 'Keyboard_Basic',
  FEEDBACK_NONE: 'Feedback_None',
  FEEDBACK_BORDER: 'Feedback_Border',
  FEEDBACK_TICK: 'Feedback_Tick',
  COLUMN_VERTICAL: 'Column_Vertical',
  COLUMN_HORIZONTAL: 'Column_Horizontal',
  RESULT_EQUIVALENT: 'Result_Equivalent',
  RESULT_EXACT: 'Result_Exact',
  WORDSEARCH_GRID_S: 'WordSearch_GridS',
  WORDSEARCH_GRID_M: 'WordSearch_GridM',
  WORDSEARCH_GRID_L: 'WordSearch_GridL',
  CHECK_ANSWER: 'Preview_CheckAnswer',
  HINT: 'Preview_Hint',
  RESTART: 'Preview_Restart',
  SHOW_SOLUTION: 'Preview_ShowSolution'
};

function useQuestionMetrics(_ref) {
  var isPreview = _ref.isPreview,
    template = _ref.template,
    store = _ref.store;
  var context = contextTypes.PREVIEW;
  var sendLog = getSendLog({
    template: template,
    context: context
  });
  var onCheckAnswers = function onCheckAnswers(name) {
    name === ACTION.CHECK_ANSWERS && !store.showSolution && sendLog(EVENT.CHECK_ANSWER);
  };
  useEffect(function () {
    if (!isPreview) return noop;
    var tracker = onAction(store, function (_ref2) {
      var name = _ref2.name;
      var onCallAction = getOnCallAction(name, sendLog);
      onCheckAnswers(name);
      onCallAction(ACTION.CREATE_ALTERNATIVE_SOLUTION, EVENT.SHOW_SOLUTION);
      onCallAction(ACTION.SHOW_HINT, EVENT.HINT);
      onCallAction(ACTION.RESET, EVENT.RESTART);
      onCallAction(ACTION.SHOW_SOLUTIONS, EVENT.SHOW_SOLUTION);
    });
    return function () {
      return tracker();
    };
  }, []);
}

function useTokens(ref, extraThemeTokens) {
  if (extraThemeTokens === void 0) {
    extraThemeTokens = [];
  }
  var themeTokens = useMemo(function () {
    return [].concat(defaultThemeTokens, extraThemeTokens);
  }, [extraThemeTokens]);
  var parentNode = function parentNode() {
    return document.querySelector('.lemonade-exercises');
  };
  var isReady = function isReady() {
    var _parentNode$classList;
    return parentNode() && (_parentNode$classList = parentNode().classList).contains.apply(_parentNode$classList, themeTokens);
  };
  useEffect(function () {
    if (ref.current && parentNode() && !isReady()) {
      var _parentNode$classList2;
      (_parentNode$classList2 = parentNode().classList).add.apply(_parentNode$classList2, themeTokens);
    }
  }, [ref.current]);
}

function useXAPI(store, xAPI_onComplete) {
  if (xAPI_onComplete === void 0) {
    xAPI_onComplete = noop;
  }
  useEffect(function () {
    if (store.isEvaluated || store.interactionCompleted) {
      var _store$xAPI, _store$xAPI$onComplet;
      xAPI_onComplete(store === null || store === void 0 ? void 0 : (_store$xAPI = store.xAPI) === null || _store$xAPI === void 0 ? void 0 : (_store$xAPI$onComplet = _store$xAPI.onComplete) === null || _store$xAPI$onComplet === void 0 ? void 0 : _store$xAPI$onComplet.call(_store$xAPI));
    }
  }, [store.isEvaluated, store.interactionCompleted]);
}

function QuestionBase(_ref) {
  var _store$ui_style, _store$ui_style2;
  var store = _ref.store,
    disabled = _ref.disabled,
    response = _ref.response,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? '' : _ref$type,
    solutionsMode = _ref.solutionsMode,
    immediateFeedback = _ref.immediateFeedback,
    changed = _ref.changed,
    changedHandlers = _ref.changedHandlers,
    scormControls = _ref.scormControls,
    scormVersion = _ref.scormVersion,
    xAPI_onComplete = _ref.xAPI_onComplete,
    onImmediateError = _ref.onImmediateError,
    onImmediateSuccess = _ref.onImmediateSuccess,
    onComplete = _ref.onComplete,
    noHead = _ref.noHead,
    children = _ref.children,
    context = _ref.context,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? '' : _ref$theme,
    _ref$isPreview = _ref.isPreview,
    isPreview = _ref$isPreview === void 0 ? false : _ref$isPreview,
    _ref$isPrintView = _ref.isPrintView,
    isPrintView = _ref$isPrintView === void 0 ? false : _ref$isPrintView,
    _ref$changedHandlerDe = _ref.changedHandlerDebugger,
    changedHandlerDebugger = _ref$changedHandlerDe === void 0 ? false : _ref$changedHandlerDe,
    _ref$stimulusBullet = _ref.stimulusBullet,
    stimulusBullet = _ref$stimulusBullet === void 0 ? undefined : _ref$stimulusBullet,
    _ref$extraThemeTokens = _ref.extraThemeTokens,
    extraThemeTokens = _ref$extraThemeTokens === void 0 ? [] : _ref$extraThemeTokens;
  var _useGetTemplateClass = useGetTemplateClass(store),
    templateClass = _useGetTemplateClass.templateClass;
  var customClass = safeSnapshot((_store$ui_style = store.ui_style) === null || _store$ui_style === void 0 ? void 0 : _store$ui_style.customClass) || '';
  var root = useRef();
  useDefaultProp({
    setter: store.setDisabled,
    value: disabled || isPrintView
  });
  useDefaultProp({
    setter: store.setResponse,
    value: response
  });
  useDefaultProp({
    setter: store.setContext,
    value: context
  });
  useDefaultProp({
    setter: (_store$ui_style2 = store.ui_style) === null || _store$ui_style2 === void 0 ? void 0 : _store$ui_style2.setType,
    value: type
  });
  useDefaultProp({
    setter: store.validation.setImmediateFeedback,
    value: immediateFeedback
  });
  useDefaultProp({
    setter: store.setIsPreviewMode,
    value: isPreview
  });
  useChangedCallback(changed, changedHandlers, store, changedHandlerDebugger);
  useScorm(store, scormControls, scormVersion);
  useXAPI(store, xAPI_onComplete);
  useImmediateFeedback({
    store: store,
    onImmediateError: onImmediateError,
    onImmediateSuccess: onImmediateSuccess,
    onComplete: onComplete
  });
  useQuestionMetrics({
    isPreview: isPreview,
    store: store,
    template: templateClass
  });
  useTokens(root, extraThemeTokens);
  useEffect(function () {
    var _store$responseFromDa, _store$responseFromDa2;
    if (solutionsMode) store.validation.setImmediateFeedback(false);
    (_store$responseFromDa = store.responseFromData) === null || _store$responseFromDa === void 0 ? void 0 : (_store$responseFromDa2 = _store$responseFromDa.init) === null || _store$responseFromDa2 === void 0 ? void 0 : _store$responseFromDa2.call(_store$responseFromDa);
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    ref: root,
    "data-testid": "questionBase",
    className: cn$1('lemo-question', templateClass, customClass, className, theme, {
      'lemo-success-result': store.successResult,
      'lemo-error-result': store.errorResult
    }),
    lang: config.lang
  }, !noHead && !solutionsMode && /*#__PURE__*/React__default.createElement(QuestionHeader$1, {
    store: store,
    stimulusBullet: stimulusBullet
  }), children);
}
var QuestionBase$1 = observer(QuestionBase);

var RenderLabel = observer(function (_ref) {
  var labelType = _ref.labelType,
    idx = _ref.idx;
  return !labelType ? null : /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-prefix-label"
  }, getLabel(idx, labelType) + ".");
});

function OptionWrapper(_ref) {
  var option = _ref.option,
    className = _ref.className,
    labelType = _ref.labelType,
    idx = _ref.idx;
  var _useState = useState(false),
    isTouched = _useState[0],
    setIsTouched = _useState[1];
  var showFeedbackPin = option.withPin && option.isWrongCache;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-option-content-wrapper', className, {
      'lemo-touched': isTouched
    }),
    onTouchStart: function onTouchStart() {
      return setIsTouched(true);
    },
    onTouchEnd: function onTouchEnd() {
      return setIsTouched(false);
    },
    onMouseDown: function onMouseDown() {
      return setIsTouched(true);
    },
    onMouseUp: function onMouseUp() {
      return setIsTouched(false);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsTouched(false);
    },
    onMouseEnter: function onMouseEnter() {
      return setIsTouched(true);
    }
  }, /*#__PURE__*/React__default.createElement(RenderLabel, {
    labelType: labelType,
    idx: idx
  }), /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    content: option.label,
    className: "lemo-option-content lemo-text-body-m-regular lemo-color-text-02"
  }), showFeedbackPin && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-feedback-pin-wrapper",
    "data-testid": "feedbackPin"
  }, /*#__PURE__*/React__default.createElement(FeedbackPin$1, {
    idx: option.feedbackIndex,
    result: option.resultCache,
    visible: showFeedbackPin,
    classAdd: 'lemo-feedback-pin',
    feedback: option.feedback
  })));
}
var OptionWrapper$1 = observer(OptionWrapper);

function InlineFeedback(_ref) {
  var content = _ref.content;
  return /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    content: content,
    className: "lemo-inline-feedback lemo-text-body-m-bold lemo-color-text-02"
  });
}
var InlineFeedback$1 = observer(InlineFeedback);

function BlockOption(_ref) {
  var option = _ref.option,
    labelType = _ref.labelType,
    idx = _ref.idx;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-block-option-container"
  }, /*#__PURE__*/React__default.createElement(OptionWrapper$1, {
    labelType: labelType,
    idx: idx,
    option: option,
    className: "lemo-block-option"
  }), option.showInlineFeedback && option.feedback && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-option-container"
  }, /*#__PURE__*/React__default.createElement(InlineFeedback$1, {
    content: option.feedback
  })));
}
var BlockOption$1 = observer(BlockOption);

var CheckBoxSquareIcon = function CheckBoxSquareIcon(_ref) {
  var checked = _ref.checked,
    _ref$checkedShowIconX = _ref.checkedShowIconX,
    checkedShowIconX = _ref$checkedShowIconX === void 0 ? false : _ref$checkedShowIconX,
    _ref$boxSize = _ref.boxSize,
    boxSize = _ref$boxSize === void 0 ? 18 : _ref$boxSize,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? 8 : _ref$iconSize;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-check-icon lemo-checkbox-square-icon"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-shape",
    style: {
      width: boxSize,
      height: boxSize
    }
  }, checked && (checkedShowIconX ? /*#__PURE__*/React__default.createElement(SvgXBold, {
    className: "lemo-icon",
    width: iconSize,
    height: iconSize
  }) : /*#__PURE__*/React__default.createElement(SvgCheckBold, {
    className: "lemo-icon",
    width: iconSize,
    height: iconSize
  }))));
};

var MULTIPLE_CLASS_NAME = 'lemo-multiple-option';
function MultipleOption(_ref) {
  var option = _ref.option,
    labelType = _ref.labelType,
    idx = _ref.idx,
    showCheckIcon = _ref.showCheckIcon;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-option-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-option-response lemo-flex-start"
  }, /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: showCheckIcon
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-option-icon"
  }, /*#__PURE__*/React__default.createElement(CheckBoxSquareIcon, {
    checked: option.selected,
    idx: idx,
    labelType: labelType,
    checkedShowIconX: option.selected && option.isWrong
  }))), /*#__PURE__*/React__default.createElement(OptionWrapper$1, {
    labelType: labelType,
    idx: idx,
    option: option,
    className: MULTIPLE_CLASS_NAME
  })), option.showInlineFeedback && option.feedback && /*#__PURE__*/React__default.createElement(InlineFeedback$1, {
    content: option.feedback
  }));
}
var MultipleOption$1 = observer(MultipleOption);

var CheckBoxRoundedIcon = function CheckBoxRoundedIcon(_ref) {
  var checked = _ref.checked,
    isError = _ref.isError;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-check-icon lemo-checkbox-rounded-icon"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-shape"
  }, checked && (isError ? /*#__PURE__*/React__default.createElement(SvgXBold, {
    className: "lemo-icon"
  }) : /*#__PURE__*/React__default.createElement(SvgCheckBold, {
    className: "lemo-icon"
  }))));
};

var SINGLE_CLASS_NAME = 'lemo-single-option';
function SingleOption(_ref) {
  var option = _ref.option,
    labelType = _ref.labelType,
    idx = _ref.idx,
    showCheckIcon = _ref.showCheckIcon;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-option-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-option-response lemo-flex-start"
  }, /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: showCheckIcon
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-option-icon"
  }, /*#__PURE__*/React__default.createElement(CheckBoxRoundedIcon, {
    idx: idx,
    checked: option.selected,
    labelType: labelType,
    isError: option.selected && option.isWrong
  }))), /*#__PURE__*/React__default.createElement(OptionWrapper$1, {
    labelType: labelType,
    idx: idx,
    option: option,
    className: SINGLE_CLASS_NAME
  })), option.showInlineFeedback && option.feedback && /*#__PURE__*/React__default.createElement(InlineFeedback$1, {
    content: option.feedback
  }));
}
var SingleOption$1 = observer(SingleOption);

function OptionList(_ref) {
  var store = _ref.store,
    solutionsMode = _ref.solutionsMode;
  var OptionComponent = when()["case"](store.isBlockLetter, function () {
    return BlockOption$1;
  })["case"](store.isMultiple, function () {
    return MultipleOption$1;
  }).resolve(function (props) {
    return SingleOption$1;
  });
  var optionList = solutionsMode ? store.options : store.optionList;
  var columns = store.ui_style.columns;
  var mobileColumns = store.mobileColumns;
  return optionList.map(function (option, idx) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: "option_" + option.value,
      className: cn$1('lemo-option', "lemo-column-" + columns, "lemo-mobile-columns-" + mobileColumns, {
        'lemo-lock': store.disabled || store.isEvaluated,
        'lemo-selected': option.selected,
        'lemo-error': option.isWrong,
        'lemo-success': option.isSuccess,
        'lemo-color-text-01': option.selected,
        'lemo-color-text-02': !option.selected
      }),
      onClick: option.setSelected,
      "data-testid": "option_" + idx
    }, /*#__PURE__*/React__default.createElement(OptionComponent, {
      option: option,
      idx: idx,
      labelType: store.labelType,
      showCheckIcon: store.showCheckIcon,
      hasColumns: columns > 1
    }));
  });
}
var OptionList$1 = observer(OptionList);

var MultipleChoiceQuestion = function MultipleChoiceQuestion(props) {
  var store = props.store,
    _props$solutionsMode = props.solutionsMode,
    solutionsMode = _props$solutionsMode === void 0 ? false : _props$solutionsMode;
  var changedHandlers = /reset|setSelected|setTitle|setStimulus/;
  useEffect(function () {
    store.ui_style.columns === 1 && store.feedback.config.setSpecificFeedback(false);
  }, [store.ui_style.columns]);
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body lemo-with-columns', {
      'lemo-disabled': store.disabled
    })
  }, /*#__PURE__*/React__default.createElement(OptionList$1, {
    store: store,
    solutionsMode: solutionsMode
  })));
};
var MultipleChoiceQuestion$1 = observer(MultipleChoiceQuestion);

function withElementFeedbackParent(list, guidProperty) {
  if (guidProperty === void 0) {
    guidProperty = 'id';
  }
  return types$1.model({}).actions(function (state) {
    return {
      setResponsesFeedback: function setResponsesFeedback(feedbacks) {
        state[list].forEach(function (res, index) {
          var responseGuid = res[guidProperty];
          var feedbackFound = null;
          if (feedbacks) {
            feedbackFound = feedbacks.find(function (feedback) {
              return feedback.responseGuid === responseGuid;
            });
          }
          res.setFeedback(feedbackFound ? feedbackFound.text : '');
        });
        state.updateNotifier();
      }
    };
  }).views(function (state) {
    return {
      get responsesFeedback() {
        return state[list].map(function (response) {
          return {
            responseGuid: response[guidProperty],
            text: response.feedback
          };
        });
      },
      get feedbackResponsesOutput() {
        return state[list].map(function (_ref) {
          var feedback = _ref.feedback;
          return {
            feedback: feedback
          };
        });
      }
    };
  });
}
function isFeedbacksIndividual(responsesFeedback) {
  return responsesFeedback && !!responsesFeedback.find(function (feedbackIndividual) {
    return feedbackIndividual && hasData(feedbackIndividual.text);
  });
}

function customGetClosestSolutionModel() {
  function checkFunction(_ref) {
    var _ref$solution = _ref.solution,
      solution = _ref$solution === void 0 ? [] : _ref$solution,
      option = _ref.option;
    return !option.selected ? null : solution.includes(option.value);
  }
  return getClosestSolutionModel().views(function (state) {
    return {
      checkSolution: function checkSolution(solution) {
        return state.options.reduce(function (acc, option) {
          var result = checkFunction({
            solution: solution,
            option: option
          });
          return when()["case"](result, function () {
            return _extends({}, acc, {
              hits: acc.hits + 1
            });
          })["case"](result === false, function () {
            return _extends({}, acc, {
              failures: acc.failures + 1
            });
          }).resolve(function () {
            return _extends({}, acc, {
              notAnswered: acc.notAnswered + 1
            });
          });
        }, {
          hits: 0,
          failures: 0,
          notAnswered: 0
        });
      },
      get responseLength() {
        var currentResponse = state.validation.solutionList[state.closestSolutionIndex].value;
        return currentResponse.length;
      }
    };
  });
}

var customWithValidationModes = withValidationModes.views(function (state) {
  return {
    getExactMatch: function getExactMatch() {
      var closestSolutionStats = state.closestSolutionStats,
        closestSolutionIndex = state.closestSolutionIndex,
        validation = state.validation;
      var currentSolution = validation.solutionList[closestSolutionIndex];
      if (closestSolutionStats.failures > 0) return 0;
      if (currentSolution.value.length !== closestSolutionStats.hits) return 0;
      return currentSolution.score;
    }
  };
});

var NumORStr = types$1.union(types$1.number, types$1.string);
var ValueModel = types$1.model('ValueModel', {
  id: types$1.optional(types$1.identifier, function () {
    return 'ab_' + uuid();
  }),
  value: types$1.optional(NumORStr, '')
}).actions(function (state) {
  return {
    setValue: function setValue(value) {
      state.value = value;
    },
    destroy: function destroy() {
      getParent(state, 2).removeValue(state);
    }
  };
}).views(function (state) {
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    }
  };
});
var DropDownValueModel = types$1.compose(ValueModel, types$1.model().actions(function (state) {
  return {
    setValue: function setValue(value) {
      var validation = getParent(state, 4).validation;
      var parent = getParent(state, 2);
      if (validation.value[parent.index] === state.value) {
        validation.updateValueIndex(parent.index, value);
      }
      state.value = value;
      var parentDepth4 = getParent(state, 4);
      if (parentDepth4 && parentDepth4.updateNotifier) {
        parentDepth4.updateNotifier();
      }
    },
    removeValue: function removeValue() {}
  };
}));

var OptionModel$1 = types$1.compose(withElementFeedback, ValueModel, types$1.model({
  label: types$1.string,
  selected: false,
  resultCache: types$1.maybe(types$1["boolean"])
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      var parent = getParent(state, 2);
      reaction(function () {
        return parent.isEvaluated;
      }, function (value) {
        isAlive(state) && state.setResultCache(value && state.selected ? state.isSuccess : undefined);
      });
    },
    setResultCache: function setResultCache(resultCache) {
      state.resultCache = resultCache;
    },
    setLabel: function setLabel(val) {
      state.label = val;
    },
    reset: function reset() {
      state.selected = false;
    },
    triggerImmediateResponse: function triggerImmediateResponse(propagate) {
      getParent(state, 2).setImmediateResponse({
        itemRef: state.id,
        value: state.isValid,
        propagate: propagate
      });
    },
    setSelected: function setSelected() {
      var parent = getParent(state, 2);
      if (parent.disabled || parent.isEvaluated) return false;
      var value = !state.selected;
      if (parent.multiple_responses) {
        state.selected = value;
        state.triggerImmediateResponse(value);
      } else if (!state.selected) {
        state.selected = value;
        parent.uncheckAll(state.value);
        state.triggerImmediateResponse();
      }
    },
    setResponse: function setResponse(selected) {
      state.selected = selected;
    },
    destroy: function destroy() {
      getParent(state, 2).removeOption(state);
    },
    hydrate: function hydrate(data) {
      state.label = data.label;
    }
  };
}).views(function (state) {
  return {
    get isSelected() {
      var userResponse = getParent(state, 2).getUserResponse();
      return state.selected || userResponse.includes(state.value);
    },
    get index() {
      return getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get closestSolution() {
      var parent = getParent(state, 2);
      return parent.validation.solutionList[parent.closestSolution];
    },
    get validate() {
      var solution = state.closestSolution.value || [];
      return state.selected && solution.includes(state.value);
    },
    get currentSolution() {
      return getParent(state, 2).getCurrentSolution(state.index);
    },
    get isValid() {
      return state.validate;
    },
    get feedbackResult() {
      try {
        var parent = getParent(state, 2);
        var evaluationReady = parent.isEvaluated || parent.validation.immediateFeedback;
        return when()["case"](parent.isSolutionMode, function () {
          return feedback.NOT_EVALUATED;
        })["case"](!state.selected, function () {
          return feedback.NOT_EVALUATED;
        })["case"](!evaluationReady, function () {
          return feedback.NOT_EVALUATED;
        })["case"](!parent.isEvaluable, function () {
          return feedback.NOT_EVALUATED;
        })["case"](state.isValid, function () {
          return feedback.RIGHT;
        })["case"](!state.isValid, function () {
          return feedback.WRONG;
        }).resolve();
      } catch (e) {
        return feedback.NOT_EVALUATED;
      }
    },
    get isWrong() {
      return state.feedbackResult === feedback.WRONG;
    },
    get isWrongCache() {
      return state.resultCache === undefined ? state.isWrong : state.resultCache === false;
    },
    get isSuccess() {
      return state.feedbackResult === feedback.RIGHT;
    },
    get type() {
      return getParent(state, 2) && getParent(state, 2).name ? getParent(state, 2).name : null;
    },
    get parent() {
      try {
        return getParent(state, 2);
      } catch (e) {
        return undefined;
      }
    },
    get showInlineFeedback() {
      var _state$parent;
      var isSingleColumn = (_state$parent = state.parent) === null || _state$parent === void 0 ? void 0 : _state$parent.inlineFeedback;
      var isWrong = state.isWrong || state.isWrongCache;
      return isWrong && isSingleColumn;
    },
    get canShowElementFeedback() {
      var parent = state.parent,
        showInlineFeedback = state.showInlineFeedback,
        type = state.type,
        isSelected = state.isSelected,
        isValid = state.isValid,
        isWrongCache = state.isWrongCache,
        currentSolution = state.currentSolution;
      var isMultiple = types.multipleChoice.Multiple;
      if (showInlineFeedback) return false;
      if (!parent.feedback.config.hasSpecificFeedback) return false;
      if (parent.showSolution && isWrongCache) {
        return type === isMultiple ? !parent.isUnselectedAllOptions : true;
      }
      if (type === isMultiple) {
        return isSelected && !isValid || !isSelected && currentSolution && !parent.isUnselectedAllOptions;
      }
      return isSelected && !isValid && isWrongCache;
    }
  };
}));

function getWithShuffleOptions(list) {
  return types$1.model({
    optionsOrder: types$1.optional(types$1.array(types$1.number), [])
  }).actions(function (state) {
    return {
      afterCreate: function afterCreate() {
        onSnapshot(state, function (s) {
          var _s$list, _state$optionsOrder;
          if (((_s$list = s[list]) === null || _s$list === void 0 ? void 0 : _s$list.length) !== ((_state$optionsOrder = state.optionsOrder) === null || _state$optionsOrder === void 0 ? void 0 : _state$optionsOrder.length)) {
            state.updateOptionsOrder();
          }
        });
        state.updateOptionsOrder();
      },
      updateOptionsOrder: function updateOptionsOrder() {
        var indexList = state[list].map(function (_, idx) {
          return idx;
        });
        if (!state.shuffle_options) {
          state.optionsOrder = indexList;
          return;
        }
        if (state.duplicate_responses) {
          state.optionsOrder = shuffle(getGroupedList(list, state)).flat();
        } else {
          state.optionsOrder = shuffle(indexList);
        }
      }
    };
  }).views(function (state) {
    return {
      get shuffle_options() {
        return state.raw.data.shuffle_options;
      },
      get shuffledOptions() {
        return state.shuffle_options ? state[list].map(function (option, idx) {
          return state[list][state.optionsOrder[idx]];
        }) : state[list];
      }
    };
  });
}
function getCurrentIndex(currentIndex, duplicates) {
  return duplicates.reduce(function (acc, next, idx) {
    return idx < currentIndex ? acc + next : acc;
  }, 0);
}
function getRangeFrom(start, end) {
  var a = [];
  for (var index = start; index < end; index++) {
    a.push(index);
  }
  return a;
}
function getGroupedList(list, state) {
  var config = state.raw.data.possible_responses_config;
  var duplicates = config.map(function (_ref) {
    var number_duplicates = _ref.number_duplicates;
    return number_duplicates;
  });
  return duplicates.map(function (value, idx) {
    var currentIndex = getCurrentIndex(idx, duplicates);
    return getRangeFrom(currentIndex, currentIndex + value);
  });
}

var withScorm = types$1.model({
  scormData: types$1.optional(ScormModel, {})
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      state.exerciseType = state.scormType;
      state.initScorm();
      onAction(state, function (_ref) {
        var name = _ref.name,
          path = _ref.path,
          args = _ref.args;
        state.updateScorm(state.updateScormItem(name, path, args));
        if (name === 'reset' && path === '') return state.initScorm();
        if (name === 'setResponse') return state.scormOnResponse();
      }, true);
      onAction(state, function (_ref2) {
        var _state$updateResponse;
        var name = _ref2.name,
          path = _ref2.path,
          args = _ref2.args;
        state.updateScorm(state.updateScormItem(name, path, args));
        if (name === 'checkAnswers') return state === null || state === void 0 ? void 0 : (_state$updateResponse = state.updateResponseOnValidate) === null || _state$updateResponse === void 0 ? void 0 : _state$updateResponse.call(state);
      });
    },
    initScorm: function initScorm() {
      state.scormData.init(state, state.getInteractiveListInitScorm());
    },
    scormOnResponse: function scormOnResponse() {
      state.scormData.init(state, state.getInteractiveListInitScorm());
    },
    updateScorm: function updateScorm(item) {
      if (item === null) return false;
      state.scormData.updateInteractive({
        id: item.id,
        userResponse: item.userResponse,
        result: item.result
      });
      return true;
    }
  };
}).views(function () {
  return {
    getInteractiveListInitScorm: function getInteractiveListInitScorm() {
      return [];
    },
    updateScormItem: function updateScormItem(name, path) {
      return [];
    }
  };
});

var withConfigureScorm$1 = types$1.compose(withScorm, types$1.model({}).views(function (state) {
  var getSolutions = function getSolutions() {
    return state.validation.solutionList.map(function (_ref) {
      var value = _ref.value;
      return value;
    });
  };
  var getItem = function getItem() {
    return {
      userResponse: state.getUserResponse(),
      id: state.raw.reference,
      rightAnswer: getSolutions(),
      result: state.points > 0
    };
  };
  return {
    get scormType() {
      return scormTypes.CHOICE;
    },
    getInteractiveListInitScorm: function getInteractiveListInitScorm() {
      return [getItem()];
    },
    updateScormItem: function updateScormItem(name, path) {
      if (path.match(/\/options/) && name === 'setSelected') {
        return getItem();
      } else return null;
    }
  };
}));

var withXAPITypeChoice = function withXAPITypeChoice(_ref) {
  var getChoices = _ref.getChoices;
  return types$1.model({}).views(function (state) {
    return {
      getObjectDefinition: function getObjectDefinition() {
        var parent = getParent(state);
        var solution = parent.validation.value.map(function (value) {
          return OPTION + "-" + (parseInt(value, 10) + 1);
        });
        return {
          description: getXAPIDescription(parent),
          interactionType: scormTypes.CHOICE,
          choices: getXAPIOptionList(getChoices(parent)),
          correctResponsesPattern: formatResponses(solution),
          objectType: xAPI_ACTIVITY_TYPE
        };
      }
    };
  });
};
var withXAPITypeChoice$1 = (function (_ref2) {
  var getChoices = _ref2.getChoices;
  return exportXAPI(withXAPITypeChoice({
    getChoices: getChoices
  }));
});

var ResponseItem$1 = createResponseItem('options');
var MultipleChoiceQuestionStore = types$1.compose(QuestionBaseModel, customGetClosestSolutionModel(), customWithValidationModes, withElementFeedbackParent('options'), getWithShuffleOptions('options'), withConfigureScorm$1, withXAPITypeChoice$1({
  getChoices: function getChoices(state) {
    return state.options.map(function (_ref) {
      var label = _ref.label;
      return label;
    });
  }
}), types$1.model({
  options: types$1.array(OptionModel$1),
  responseList: types$1.optional(types$1.array(ResponseItem$1), [])
}).actions(function (state) {
  return {
    setImmediateResponse: function setImmediateResponse(response) {
      state.isEvaluable && state.responseList.push(response);
    },
    setResponse: function setResponse(response) {
      var singleChoice = types.multipleChoice.Single;
      var emotionsChoice = types.multipleChoice.EmotionsSingle;
      var name = state.raw.metadata.name;
      var isSingle = name === singleChoice && response.length > 1;
      var isEmotionsChoice = name === emotionsChoice && response.length > 1;
      if (!typeChecker(types$1.array(types$1.string), response)) return false;
      if (isSingle || isEmotionsChoice) {
        return false;
      }
      state.options.forEach(function (option) {
        option.setResponse(response.includes(option.value));
      });
    },
    reset: function reset(clickedValue) {
      if (clickedValue === void 0) {
        clickedValue = undefined;
      }
      state.baseReset();
      state.uncheckAll(clickedValue);
    },
    commitResponseFeedback: function commitResponseFeedback() {
      commitFeedbackMessages({
        state: state,
        collection: state.optionList,
        condition: function condition(item) {
          return item.feedback && item.isWrong;
        }
      });
    },
    uncheckAll: function uncheckAll(selected) {
      if (selected === void 0) {
        selected = '';
      }
      state.options.forEach(function (option) {
        return option.value !== selected && option.reset();
      });
    },
    uncheckAllValids: function uncheckAllValids(skipped) {
      state.options = state.options.map(function (option) {
        return _extends({}, option, {
          validate: option.value === skipped
        });
      });
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot$2(rawData);
      applySnapshot(state, data);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  return {
    get isBlockLetter() {
      return !state.showCheckIcon || state.raw.metadata.name === types.multipleChoice.BlockLetter;
    },
    get multiple_responses() {
      return state.raw.data.multiple_responses;
    },
    get isMultiple() {
      if (state.isBlockLetter) return false;
      return state.multiple_responses;
    },
    get showCheckIcon() {
      var _state$raw$data;
      return ((_state$raw$data = state.raw.data) === null || _state$raw$data === void 0 ? void 0 : _state$raw$data.showCheckIcon) !== false;
    },
    get mobileColumns() {
      var _state$ui_style;
      var defaultColumns = 1;
      return ((_state$ui_style = state.ui_style) === null || _state$ui_style === void 0 ? void 0 : _state$ui_style.mobile_columns) || defaultColumns;
    },
    get labelType() {
      var _state$ui_style2, _state$ui_style3;
      if (((_state$ui_style2 = state.ui_style) === null || _state$ui_style2 === void 0 ? void 0 : _state$ui_style2.labelType) === labelTypes.NONE) return false;
      return (_state$ui_style3 = state.ui_style) === null || _state$ui_style3 === void 0 ? void 0 : _state$ui_style3.labelType;
    },
    getUserResponse: function getUserResponse() {
      var userResponse = [].concat(getSnapshot(state.options).filter(function (option) {
        return option.selected;
      }).map(function (_ref2) {
        var value = _ref2.value;
        return value;
      }));
      return state.getRealUserResponse(userResponse);
    },
    getOptionByLabel: function getOptionByLabel(val) {
      return state.options.find(function (o) {
        return o.label === val;
      });
    },
    getSolutions: function getSolutions() {
      return state.validation.value;
    },
    get optionList() {
      return state.optionsOrder.map(function (idx) {
        return state.options[idx];
      });
    },
    get feedbackSuccessByResponses() {
      return state.getSolutions().map(function (val) {
        return state.options.find(function (option) {
          return option.value === val;
        }).feedback;
      });
    },
    get showInlineFeedback() {
      var _state$ui_style4;
      if (!((_state$ui_style4 = state.ui_style) !== null && _state$ui_style4 !== void 0 && _state$ui_style4.inlineFeedback)) return false;
      var inlineFeedbackIsDefined = state.options.reduce(function (acc, next) {
        return next.feedback.length > 0 || acc;
      }, false);
      return state.feedback.config.visibility && inlineFeedbackIsDefined;
    },
    get questionCompleted() {
      var _state$validation = state.validation,
        immediateFeedback = _state$validation.immediateFeedback,
        value = _state$validation.value;
      return immediateFeedback && value.toString() === state.getUserResponse().toString();
    },
    get isUnselectedAllOptions() {
      if (!state.showSolution) {
        var optionSelected = state.options.find(function (option) {
          return option.selected;
        });
        return !optionSelected;
      } else {
        return !(state.cacheResponse && state.cacheResponse.length > 0);
      }
    },
    get inlineFeedback() {
      var _state$ui_style5;
      return ((_state$ui_style5 = state.ui_style) === null || _state$ui_style5 === void 0 ? void 0 : _state$ui_style5.columns) === 1;
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$2(rawData);
    }
  };
}));
var createOptions = function createOptions(arr) {
  return arr.map(function (item) {
    return _extends({}, item, {
      value: item.value.toString(),
      selected: false
    });
  });
};
function _createSnapshot$2(data) {
  var _data$data = data.data,
    options = _data$data.options,
    validation = _data$data.validation;
  var responseLength = validation.valid_response.value.length;
  return _extends({}, data.data, importCommonValues(data), {
    validation: withPenaltyPoints(responseLength, validation),
    options: createOptions(options)
  });
}
function createStore$2(data) {
  return MultipleChoiceQuestionStore.create(_createSnapshot$2(data));
}

function getCreator(props, getDefaultData, defaultType) {
  var _props$data = props.data,
    data = _props$data === void 0 ? undefined : _props$data,
    _props$type = props.type,
    type = _props$type === void 0 ? defaultType : _props$type,
    lang = props.lang,
    _props$basePath = props.basePath,
    basePath = _props$basePath === void 0 ? '' : _props$basePath,
    initialProps = props.initialProps;
  if (lang) config.setLang(lang);
  var exerciseData = withBasePath(basePath, data) || getDefaultData(type);
  function setCommonParamsStore(store) {
    setCommonsParamsStoreFn(store, exerciseData, _extends({}, props));
    return store;
  }
  return {
    type: type,
    lang: lang,
    initialProps: initialProps,
    exerciseData: exerciseData,
    setCommonParamsStore: setCommonParamsStore
  };
}

var Editor = function Editor(_ref) {
  var children = _ref.children,
    reference = _ref.reference,
    className = _ref.className,
    lang = _ref.lang;
  return /*#__PURE__*/React__default.createElement("div", {
    className: className,
    ref: reference,
    lang: lang
  }, children);
};
Editor.propTypes = {
  children: propTypes.any,
  reference: propTypes.any
};
Editor.defaultProps = {};

function getAssetsQuestionApi(assetsQuestionApiExercise) {
  return hasData(assetsQuestionApiExercise) ? assetsQuestionApiExercise : config.assetsQuestionApi;
}
function getAssetsEditorApi(assetsEditorApiExercise) {
  return hasData(assetsEditorApiExercise) ? assetsEditorApiExercise : config.assetsEditorApi;
}
function getAssetsQuestionApiDrive(assetsQuestionApiDriveExercise) {
  return hasData(assetsQuestionApiDriveExercise) ? assetsQuestionApiDriveExercise : config.assetsQuestionApiDrive;
}

var EditorTitleSubtitleComponent = function EditorTitleSubtitleComponent(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    componentRight = _ref.componentRight,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-title-subtitle-component lemo-base-title-subtitle"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-title-subtitle-component__title-subtitle"
  }, /*#__PURE__*/React__default.createElement("p", {
    className: cn$1('lemo-editor-title-subtitle-component__title', 'lemo-base-title-subtitle__title', 'lemo-text-body-m-medium', 'lemo-color-text-02', {
      'lemo-editor-title-subtitle-component__title--disabled': disabled
    })
  }, title), /*#__PURE__*/React__default.createElement("p", {
    className: cn$1('lemo-editor-title-subtitle-component__subtitle', 'lemo-base-title-subtitle__subtitle', 'lemo-text-body-m-regular', 'lemo-color-text-03', {
      'lemo-editor-title-subtitle-component__subtitle--disabled': disabled
    })
  }, subtitle)), componentRight && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-title-subtitle-component__component-right"
  }, componentRight));
};

var EditorToggle = function EditorToggle(_ref) {
  var checked = _ref.checked,
    onChange = _ref.onChange,
    children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var handleChange = useCallback(function () {
    !disabled && onChange(!checked);
  }, [disabled, onChange, checked]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-editor-toggle-component', {
      'lemo-active': checked,
      'lemo-disabled': disabled
    }),
    onClick: handleChange
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-toggle-component__checkShape"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-toggle-component__checkShape__dot"
  })), children && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-toggle-component__label"
  }, children));
};

var EditorToggleTitleSubtitle = function EditorToggleTitleSubtitle(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    isChecked = _ref.isChecked,
    onChange = _ref.onChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return /*#__PURE__*/React__default.createElement(EditorTitleSubtitleComponent, {
    title: title,
    subtitle: subtitle,
    disabled: disabled,
    componentRight: /*#__PURE__*/React__default.createElement(EditorToggle, {
      checked: isChecked,
      onChange: onChange,
      disabled: disabled
    })
  });
};
var EditorToggleTitleSubtitle$1 = observer(EditorToggleTitleSubtitle);

var Line1 = function Line1(_ref) {
  var hidden = _ref.hidden;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-line1",
    style: {
      opacity: hidden ? 0 : 1
    }
  });
};

function isFileImage(file) {
  return file && file.type.split('/')[0] === 'image';
}

function sendFile(fileInfo, onChangeStatus, onChangeAbort, onSuccess, onError, onAbort, assetsApi, fileName) {
  var abortController = new AbortController();
  var signal = abortController.signal;
  var file = fileInfo.file || fileInfo;
  var formData = new FormData();
  formData.append('file', file, fileName || file.name);
  onChangeStatus && onChangeStatus(fileInfo, fileStatuses.UPLOADING);
  onChangeAbort && onChangeAbort(fileInfo, function () {
    abortController.abort();
  });
  fetch(assetsApi, {
    method: 'POST',
    body: formData,
    signal: signal
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    if (data && data.link) {
      if (isFileImage(file)) {
        var img = new Image();
        img.onload = function () {
          onSuccess({
            source: data.link,
            original_width: this.width,
            original_height: this.height,
            scale: 100
          });
          onChangeStatus && onChangeStatus(fileInfo, fileStatuses.COMPLETE);
        };
        img.src = data.link;
      } else {
        onSuccess({
          source: data.link,
          scale: 100
        });
        onChangeStatus && onChangeStatus(fileInfo, fileStatuses.COMPLETE);
      }
    }
  })["catch"](function (err) {
    if (err && DOMException && DOMException.ABORT_ERR && err.code === DOMException.ABORT_ERR) {
      onAbort && onAbort();
    } else {
      onError(err);
      onChangeStatus && onChangeStatus(fileInfo, fileStatuses.ERROR);
    }
  });
}
function sendFileWithName(_ref) {
  var file = _ref.file,
    fileName = _ref.fileName,
    onChangeStatus = _ref.onChangeStatus,
    onChangeAbort = _ref.onChangeAbort,
    onSuccess = _ref.onSuccess,
    onError = _ref.onError,
    onAbort = _ref.onAbort,
    assetsApi = _ref.assetsApi;
  sendFile({
    file: file
  }, onChangeStatus, onChangeAbort, onSuccess, onError, onAbort, assetsApi, fileName);
}

function ButtonIcon(_ref) {
  var icon = _ref.icon,
    onClick = _ref.onClick;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-button-icon lemo-base-button",
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-button-icon__button",
    type: "button"
  }, icon));
}

var colorsButton = {
  "default": 'default',
  red: 'red',
  white: 'white',
  gray: 'gray'
};

function ButtonInline(_ref) {
  var icon = _ref.icon,
    text = _ref.text,
    classNameAdd = _ref.classNameAdd,
    color = _ref.color,
    onClick = _ref.onClick,
    children = _ref.children,
    disabled = _ref.disabled,
    idButton = _ref.idButton;
  return /*#__PURE__*/React__default.createElement("button", {
    className: 'lemo-editor-inline-button ' + 'lemo-base-button ' + 'lemo-base-button--text ' + 'lemo-text-body-m-bold ' + (color ? 'lemo-editor-inline-button--color-' + color + ' ' : '') + (color === colorsButton["default"] ? 'lemo-base-button--text ' : '') + (color === colorsButton.red ? 'lemo-base-button--text-red ' : '') + (color === colorsButton.gray ? 'lemo-base-button--text-gray ' : '') + (classNameAdd ? ' ' + classNameAdd : ''),
    onClick: onClick,
    disabled: disabled,
    id: idButton,
    type: "button"
  }, icon && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-inline-button__icon"
  }, icon), text && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-inline-button__text"
  }, text), children);
}
ButtonInline.propTypes = {
  icon: propTypes.node,
  color: propTypes.oneOf([colorsButton["default"], colorsButton.red, colorsButton.white, colorsButton.gray]),
  text: propTypes.string,
  onClick: propTypes.func
};
ButtonInline.defaultProps = {
  color: colorsButton["default"],
  onClick: function onClick() {
    console.log('onClick not defined');
  }
};

function classNames() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }
  return classes.map(function (c) {
    return typeof c === 'object' ? function (itemList) {
      return itemList.map(function (val) {
        return val[1] ? val[0] : '';
      });
    }(Object.entries(c)).join(' ') : c;
  }).join(' ').replace(/\s+/g, ' ').trim();
}

function DriveButton(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? null : _ref$text,
    onClick = _ref.onClick,
    disabled = _ref.disabled;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames('lemo-drive-button', {
      'lemo-drive-button--disabled': disabled
    })
  }, /*#__PURE__*/React__default.createElement(ButtonInline, {
    onClick: onClick,
    text: text || translate('upload_file_button_drive'),
    icon: /*#__PURE__*/React__default.createElement(SvgDrive, {
      className: "lemo-icon"
    }),
    disabled: disabled
  }));
}

function MobileButton(props) {
  return /*#__PURE__*/React__default.createElement("button", _extends({
    type: "button"
  }, props, {
    className: cn$1('lemo-mobile-button', props.className)
  }), props.children);
}

function UploadIcon(_ref) {
  var status = _ref.status,
    isTouch = _ref.isTouch;
  var UPLOADING = fileStatuses.UPLOADING,
    ADDED = fileStatuses.ADDED,
    ERROR = fileStatuses.ERROR,
    START = fileStatuses.START,
    COMPLETE = fileStatuses.COMPLETE,
    FILE_LIMIT = fileStatuses.FILE_LIMIT;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-upload-icon"
  }, when()["case"](status === ADDED || status === START || status === FILE_LIMIT, function () {
    return /*#__PURE__*/React__default.createElement(SvgCloudUpload, {
      className: "lemo-start-icon"
    });
  })["case"](status === UPLOADING, function () {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-upload-progress-icon"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-spinner"
    }), /*#__PURE__*/React__default.createElement(SvgCloud, {
      className: "lemo-icon"
    }));
  })["case"](status === ERROR, function () {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-complete-icon--error"
    }, /*#__PURE__*/React__default.createElement(SvgXCircle, null));
  })["case"](status === COMPLETE && isTouch, function () {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-complete-touch-icon"
    }, /*#__PURE__*/React__default.createElement(SvgCheck, null));
  }).resolve(function () {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-complete-icon--success"
    }, /*#__PURE__*/React__default.createElement(SvgCheckCircle, null));
  }));
}

function DropArea(_ref) {
  var onDrop = _ref.onDrop,
    onDropRejected = _ref.onDropRejected,
    minFiles = _ref.minFiles,
    status = _ref.status,
    maxSize = _ref.maxSize,
    allowedFiles = _ref.allowedFiles,
    _ref$isTouch = _ref.isTouch,
    isTouch = _ref$isTouch === void 0 ? false : _ref$isTouch,
    _ref$numFilesAdd = _ref.numFilesAdd,
    numFilesAdd = _ref$numFilesAdd === void 0 ? 0 : _ref$numFilesAdd;
  var _useDropzone = useDropzone({
      accept: allowedFiles,
      maxSize: mbToBytes(maxSize),
      onDrop: onDrop,
      onDropRejected: onDropRejected
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    isDragActive = _useDropzone.isDragActive;
  var _isCompleted = isCompleted(status);
  var _isDisabled = isDisabled(status);
  var messageCompleted = '';
  if (numFilesAdd === 1) {
    messageCompleted = translate('file_uploaded_successfully');
  } else if (numFilesAdd > 1) {
    messageCompleted = translate('files_uploaded_successfully');
  }
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: cn$1('lemo-drop-area', {
      'lemo-isDragActive': isDragActive,
      'lemo-is-touch': isTouch,
      'lemo-disabled': _isDisabled
    })
  }, getRootProps()), /*#__PURE__*/React__default.createElement("input", getInputProps()), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-drop-area-icon"
  }, /*#__PURE__*/React__default.createElement(UploadIcon, {
    status: status
  })), /*#__PURE__*/React__default.createElement("p", {
    className: "lemo-drop-area-message"
  }, _isCompleted ? messageCompleted : /*#__PURE__*/React__default.createElement("span", null, translate('Drop your files here or'), " ", /*#__PURE__*/React__default.createElement("a", null, translate('browse')))), /*#__PURE__*/React__default.createElement(MobileButton, {
    className: cn$1('lemo-upload-button', {
      'lemo-disabled': _isDisabled,
      'lemo-completed': _isCompleted
    })
  }, /*#__PURE__*/React__default.createElement(UploadIcon, {
    status: status,
    isTouch: isTouch
  }), translate(_isCompleted ? 'completed' : 'upload_file')), /*#__PURE__*/React__default.createElement("p", {
    className: "lemo-drop-area-info"
  }, translate('Max file size'), ": ", maxSize, " ", translate('MB · At least'), ' ', minFiles, " ", translate('file required')));
}
DropArea.propTypes = {
  allowedFiles: propTypes.oneOfType([propTypes.string, propTypes.arrayOf(propTypes.string)])
};
DropArea.defaultProps = {
  allowedFiles: allowedFiles
};

function ErrorMessage(_ref) {
  var errorMessage = _ref.errorMessage,
    clearError = _ref.clearError;
  return !errorMessage ? null : /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-error-message"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-error-message-text"
  }, translate(errorMessage)), /*#__PURE__*/React__default.createElement(WrapButton, {
    className: "lemo-error-message-close-button",
    onClick: clearError
  }, /*#__PURE__*/React__default.createElement(SvgXCircle, null)));
}

function FileUploader(_ref) {
  var _config$googlePicker3, _config$googlePicker4;
  var store = _ref.store,
    maxSize = _ref.maxSize,
    allowedFiles = _ref.allowedFiles,
    allowedFilesText = _ref.allowedFilesText,
    _ref$showDriveButton = _ref.showDriveButton,
    showDriveButton = _ref$showDriveButton === void 0 ? false : _ref$showDriveButton,
    children = _ref.children;
  var _useDrivePicker = useDrivePicker(),
    openPicker = _useDrivePicker[0],
    authResponse = _useDrivePicker[1];
  var onDrop = store.onDrop,
    onDropRejected = store.onDropRejected,
    minFiles = store.minFiles,
    status = store.status,
    errorMessage = store.errorMessage,
    clearError = store.clearError,
    files = store.files,
    onDropGooglePicker = store.onDropGooglePicker,
    googlePickerOauthToken = store.googlePickerOauthToken,
    setGooglePickerOauthToken = store.setGooglePickerOauthToken;
  var isTouch = isTouchDevice();
  var _allowedFilesText = allowedFilesText || translate('Allowed files: images (jpg, png, gif), audio (mp3, ogg), video (mp4, ogg, webm, mkv), documents (word, excel, power point, pdf, open office, txt)');
  useEffect(function () {
    if (authResponse !== undefined) {
      setGooglePickerOauthToken(authResponse.access_token);
    }
  }, [authResponse]);
  var handleOpenPicker = function handleOpenPicker() {
    var _config$googlePicker, _config$googlePicker2;
    openPicker({
      clientId: (_config$googlePicker = config.googlePicker) === null || _config$googlePicker === void 0 ? void 0 : _config$googlePicker.clientId,
      developerKey: (_config$googlePicker2 = config.googlePicker) === null || _config$googlePicker2 === void 0 ? void 0 : _config$googlePicker2.developerKey,
      token: googlePickerOauthToken,
      showUploadView: false,
      showUploadFolders: false,
      supportDrives: true,
      multiselect: false,
      viewId: 'DOCS',
      callbackFunction: function callbackFunction(data) {
        if (data.action === 'cancel') {
          console.log('User clicked cancel/close button');
        }
        if (data.action === 'picked') {
          onDropGooglePicker(data.docs);
        }
      }
    });
  };
  var _isDisabled = isDisabled(status);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-file-uploader lemo-stack-layout"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-file-uploader__methods-add"
  }, /*#__PURE__*/React__default.createElement(DropArea, {
    onDrop: onDrop,
    onDropRejected: onDropRejected,
    minFiles: minFiles,
    status: status,
    maxSize: maxSize,
    allowedFiles: allowedFiles,
    isTouch: isTouch,
    numFilesAdd: files ? files.length : 0
  }), !isTouch && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-allowed-files"
  }, _allowedFilesText), showDriveButton && ((_config$googlePicker3 = config.googlePicker) === null || _config$googlePicker3 === void 0 ? void 0 : _config$googlePicker3.clientId) && ((_config$googlePicker4 = config.googlePicker) === null || _config$googlePicker4 === void 0 ? void 0 : _config$googlePicker4.developerKey) && /*#__PURE__*/React__default.createElement(DriveButton, {
    onClick: handleOpenPicker,
    disabled: _isDisabled
  })), /*#__PURE__*/React__default.createElement(ErrorMessage, {
    errorMessage: errorMessage,
    clearError: clearError
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-file-list lemo-stack-layout"
  }, files && files.map(function (file, idx) {
    return children ? children(file, idx) : /*#__PURE__*/React__default.createElement(FileItem$1, _extends({
      key: file.id,
      file: file
    }, file.status === fileStatuses.COMPLETE ? {
      onClick: function onClick() {
        return window.open(file.path, '_blank');
      }
    } : {}, {
      isActiveDownloadButton: false
    }));
  })));
}
FileUploader.propTypes = {
  allowedFiles: DropArea.propTypes.allowedFiles,
  allowedFilesText: propTypes.string,
  fileComponent: propTypes.element
};
FileUploader.defaultProps = {
  allowedFiles: null
};
var FileUploader$1 = observer(FileUploader);

var errorList = {
  MAX_FILES_REACHED: 'MAX_FILES_REACHED',
  INVALID_TYPE: 'INVALID_TYPE',
  MAX_SIZE_EXCEEDED: 'MAX_SIZE_EXCEEDED',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
  SERVER_ERROR: 'SERVER_ERROR',
  NONE: ''
};

var _window = window,
  FormData$1 = _window.FormData,
  XMLHttpRequest$1 = _window.XMLHttpRequest;
var FileModel = types$1.model({
  id: types$1.optional(types$1.string, function () {
    return uuid();
  }),
  name: types$1.string,
  path: types$1.string,
  size: types$1.optional(types$1.number, 0),
  status: types$1.optional(types$1.enumeration('status', Object.values(fileStatuses)), fileStatuses.ADDED),
  progress: types$1.optional(types$1.number, 0),
  isError: types$1.optional(types$1["boolean"], false),
  file: types$1.maybe(types$1.frozen()),
  drive: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    removeFile: function removeFile() {
      getParent(state, 2).removeFile(state);
    },
    setProgress: function setProgress(progress) {
      state.progress = parseInt(progress);
    },
    setError: function setError(isError) {
      state.isError = isError;
      getParent(state, 2).setError(isError ? errorList.SERVER_ERROR : '');
    },
    setStatus: function setStatus(status) {
      state.status = status;
    },
    setPath: function setPath(path) {
      state.path = path;
    },
    abortUpload: function abortUpload(file) {
      if (state.status !== fileStatuses.UPLOADING) return false;
      if (file.hasOwnProperty('onAbortFetch')) {
        file.onAbortFetch();
        delete file.onAbortFetch;
      }
      state.setStatus(fileStatuses.ADDED);
    },
    sendFile: function sendFile(onChangeAbort, onAbortSuccess, isEditor) {
      if (isEditor === void 0) {
        isEditor = false;
      }
      var assetsApi = isEditor ? 'assetsEditorApi' : 'assetsQuestionApi';
      var assetsQuestionApi = getParent(state, 2) ? getAssetsQuestionApi(getParent(state, 2)[assetsApi]) : null;
      if (!assetsQuestionApi) {
        return console.error('To send files you need to configure an API');
      } else {
        var data = new FormData$1();
        data.append('file', state.file);
        var request = new XMLHttpRequest$1();
        request.open('POST', assetsQuestionApi);
        request.upload.addEventListener('progress', function (e) {
          state.setProgress(e.loaded / e.total * 100);
        });
        request.addEventListener('load', function () {
          if (request.status === 404) {
            state.setError(true);
          } else if (request.status === 200) {
            state.setPath(JSON.parse(request.response).link);
            state.setProgress(100);
            state.setStatus(fileStatuses.COMPLETE);
          }
          delete window["request_" + state.id];
        });
        request.addEventListener('error', function () {
          state.setError(true);
          state.setStatus(fileStatuses.ERROR);
          delete window["request_" + state.id];
        });
        request.addEventListener('abort', function () {
          onAbortSuccess && onAbortSuccess();
          delete window["request_" + state.id];
        });
        state.setError(false);
        state.setStatus(fileStatuses.UPLOADING);
        request.send(data);
        window["request_" + state.id] = request;
        onChangeAbort && onChangeAbort(function () {
          request.abort();
        });
      }
    },
    sendFileDrive: function sendFileDrive(onChangeAbort, onAbortSuccess, oauthToken) {
      var assetsQuestionApiDrive = getParent(state, 2) ? getAssetsQuestionApiDrive(getParent(state, 2).assetsQuestionApiDrive) : null;
      if (!assetsQuestionApiDrive) {
        return console.error('To send files you need to configure an API');
      } else {
        var _state$file;
        var request = new XMLHttpRequest$1();
        request.open('POST', assetsQuestionApiDrive);
        request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        request.upload.addEventListener('progress', function (e) {
          state.setProgress(e.loaded / e.total * 100);
        });
        request.addEventListener('load', function () {
          if (request.status === 404) {
            state.setError(true);
          } else if (request.status === 200) {
            var response = JSON.parse(request.response);
            var data = response.data;
            if (data && data.bundle) {
              var bundle = data.bundle;
              state.setPath(bundle.url);
              state.setProgress(100);
              state.setStatus(fileStatuses.COMPLETE);
            } else {
              state.setError(true);
            }
          }
        });
        request.addEventListener('error', function () {
          state.setError(true);
          state.setStatus(fileStatuses.ERROR);
        });
        request.addEventListener('abort', function () {
          onAbortSuccess && onAbortSuccess();
        });
        state.setError(false);
        state.setStatus(fileStatuses.UPLOADING);
        request.send(JSON.stringify({
          fileId: (_state$file = state.file) === null || _state$file === void 0 ? void 0 : _state$file.id,
          oauthToken: oauthToken
        }));
        onChangeAbort && onChangeAbort(function () {
          request.abort();
        });
      }
    }
  };
}).views(function (state) {
  return {
    get ext() {
      return state.name.toLowerCase().substring(state.name.lastIndexOf('.') + 1);
    },
    get fileSize() {
      if (state.size > 200000) {
        return bytesToMB(state.size).toFixed(2) + " mb";
      } else if (state.size > 1024) {
        return bytesToKB(state.size).toFixed(2) + " kb";
      } else {
        return state.size + " bytes";
      }
    },
    get isCompleted() {
      return state.status === fileStatuses.COMPLETE && !state.isError;
    }
  };
});
var FileModel$1 = types$1.snapshotProcessor(FileModel, {
  postProcessor: function postProcessor(_ref) {
    var id = _ref.id,
      name = _ref.name,
      path = _ref.path,
      size = _ref.size,
      status = _ref.status;
    return {
      id: id,
      name: name,
      path: path,
      size: size,
      status: status
    };
  }
});

var FileUploaderModel = types$1.model({
  files: types$1.optional(types$1.array(FileModel$1), []),
  maxFiles: types$1.optional(types$1.number, 10),
  minFiles: types$1.optional(types$1.number, 1),
  errorMessage: types$1.optional(types$1.enumeration('errorMessage', Object.values(errorList)), errorList.NONE),
  googlePickerOauthToken: types$1.optional(types$1.string, '')
}).actions(function (state) {
  return {
    onAddFiles: function onAddFiles(acceptedFiles, isDrive) {
      if (isDrive === void 0) {
        isDrive = false;
      }
      if (state.maxFiles > 0 && state.files.length === state.maxFiles) {
        return state.setError(errorList.MAX_FILES_REACHED);
      } else if (state.files.length + acceptedFiles.length - state.maxFiles > 0) {
        state.addFiles(acceptedFiles.splice(0, state.maxFiles - state.files.length), isDrive);
        return state.setError(errorList.MAX_FILES_REACHED);
      } else {
        return state.addFiles(acceptedFiles, isDrive);
      }
    },
    onDrop: function onDrop(acceptedFiles, fileRejections, event) {
      state.onAddFiles(acceptedFiles, false);
    },
    onDropGooglePicker: function onDropGooglePicker(result) {
      state.onAddFiles(result, true);
    },
    onDropRejected: function onDropRejected(files) {
      var errorCode = files[0].errors[0].code;
      if (files.length === 0) return;
      state.files.forEach(function (file) {
        return file.setStatus(fileStatuses.ADDED);
      });
      state.setError(when()["case"](errorCode === 'file-invalid-type', errorList.INVALID_TYPE)["case"](errorCode === 'file-too-large', errorList.MAX_SIZE_EXCEEDED).resolve(errorList.UNKNOWN_ERROR));
    },
    addFiles: function addFiles(acceptedFiles, isDrive) {
      if (isDrive === void 0) {
        isDrive = false;
      }
      acceptedFiles.length > 0 && acceptedFiles.forEach(function (file) {
        if (!isDrive) {
          state.files.push({
            name: file.name,
            path: file.path,
            size: file.size,
            file: file,
            drive: false
          });
        } else {
          state.files.push({
            name: file.name,
            path: file.embedUrl,
            size: file.sizeBytes,
            file: file,
            drive: true
          });
        }
      });
    },
    setStatus: function setStatus(status) {
      state.files.forEach(function (file) {
        file.status = status;
      });
    },
    updateStatusFile: function updateStatusFile(fileUpdate, status) {
      state.files.forEach(function (file) {
        if (fileUpdate === file) {
          file.status = status;
        }
      });
    },
    setFiles: function setFiles(newFile) {
      if (newFile.length === 0) {
        return false;
      } else if (state.maxFiles > 0 && state.files.length + 1 > state.maxFiles) {
        state.setError(errorList.MAX_FILES_REACHED);
      } else {
        state.files.push(newFile);
      }
    },
    setError: function setError(errorMessage) {
      state.errorMessage = errorMessage;
    },
    setMaxFiles: function setMaxFiles(maxFiles) {
      state.maxFiles = maxFiles;
    },
    setMinFiles: function setMinFiles(minFiles) {
      state.minFiles = minFiles;
    },
    setGooglePickerOauthToken: function setGooglePickerOauthToken(oauthToken) {
      console.log('setGooglePickerOauthToken ===> ', oauthToken);
      state.googlePickerOauthToken = oauthToken;
    },
    clearError: function clearError() {
      state.errorMessage = '';
    },
    reset: function reset() {
      state.files.forEach(function (f) {
        return destroy(f);
      });
      state.clearError();
    },
    send: function send(ifAbortDeleteFile, isEditor) {
      if (ifAbortDeleteFile === void 0) {
        ifAbortDeleteFile = false;
      }
      if (isEditor === void 0) {
        isEditor = false;
      }
      var COMPLETE = fileStatuses.COMPLETE,
        UPLOADING = fileStatuses.UPLOADING,
        ERROR = fileStatuses.ERROR,
        ADDED = fileStatuses.ADDED;
      if (state.status === COMPLETE || state.status === UPLOADING) return false;
      state.files.forEach(function (file) {
        if (file.status === ERROR) {
          file.setStatus(ADDED);
          file.setProgress(0);
        }
        function onAbortSuccess() {
          if (ifAbortDeleteFile) {
            state.removeFile(file);
          }
        }
        function onChangeAbort(onAbort) {
          file.onAbortFetch = function () {
            onAbort && onAbort();
          };
        }
        if (file.status === fileStatuses.ADDED) {
          if (file.drive) {
            file.sendFileDrive(onChangeAbort, onAbortSuccess, state.googlePickerOauthToken);
          } else {
            file.sendFile(onChangeAbort, onAbortSuccess, isEditor);
          }
        }
      });
    },
    removeFile: function removeFile(file) {
      state.clearError();
      destroy(file);
    },
    emulateStatusChange: function emulateStatusChange(status) {
      state.files.forEach(function (file) {
        return file.setStatus(status);
      });
    }
  };
}).views(function (state) {
  return {
    get fileUploaderOutput() {
      return {
        maxFiles: state.maxFiles,
        minFiles: state.minFiles
      };
    },
    get status() {
      var COMPLETE = fileStatuses.COMPLETE,
        UPLOADING = fileStatuses.UPLOADING,
        ADDED = fileStatuses.ADDED,
        ERROR = fileStatuses.ERROR,
        START = fileStatuses.START,
        FILE_LIMIT = fileStatuses.FILE_LIMIT;
      var currentStatus = state.files.map(function (f) {
        return f.status;
      });
      if (state.files.length === 0) return START;
      if (state.maxFiles > 0 && state.files && state.files.length + 1 > state.maxFiles && currentStatus.includes(ADDED)) {
        return FILE_LIMIT;
      }
      if (currentStatus.includes(ADDED)) return ADDED;
      if (currentStatus.includes(ERROR)) return ERROR;
      if (currentStatus.includes(UPLOADING)) return UPLOADING;
      return COMPLETE;
    },
    get disableSend() {
      return state.status === fileStatuses.COMPLETE || state.files.length === 0 || state.minFiles > 0 && state.files.length < state.minFiles;
    },
    get showReset() {
      return state.status !== fileStatuses.START && state.status !== fileStatuses.COMPLETE;
    }
  };
});

function FileUploaderView(_ref) {
  var maxFiles = _ref.maxFiles,
    minFiles = _ref.minFiles,
    maxSize = _ref.maxSize,
    allowedFiles = _ref.allowedFiles,
    allowedFilesText = _ref.allowedFilesText,
    onChangeFiles = _ref.onChangeFiles,
    ifAbortReset = _ref.ifAbortReset,
    assetsApi = _ref.assetsApi;
  var store = useRef(FileUploaderModel.create({
    maxFiles: maxFiles,
    minFiles: minFiles
  }));
  useEffect(function () {
    if (hasData(assetsApi)) {
      reaction(function () {
        return store.current.files.length;
      }, function () {
        if (onChangeFiles && store.current.files) {
          onChangeFiles(store.current.files.slice(), function (fileUpdate, status) {
            store.current.updateStatusFile(fileUpdate, status);
          }, function (fileInfo, onAbort) {
            fileInfo.onAbortFetch = onAbort;
          }, function () {
            if (ifAbortReset) {
              store.current.reset();
            }
          });
        }
      });
    }
  }, [assetsApi]);
  return /*#__PURE__*/React__default.createElement(FileUploader$1, {
    store: store.current,
    maxSize: maxSize,
    allowedFiles: allowedFiles,
    allowedFilesText: allowedFilesText
  });
}
FileUploaderView.propTypes = {
  onChangeFiles: propTypes.func,
  ifAbortReset: propTypes.bool
};
FileUploaderView.defaultProps = {
  ifAbortReset: false
};
var FileUploader$2 = observer(FileUploaderView);

function FileUploaderAndUpload(_ref) {
  var onSuccess = _ref.onSuccess,
    onError = _ref.onError,
    onAbort = _ref.onAbort,
    maxFiles = _ref.maxFiles,
    allowedFiles = _ref.allowedFiles,
    allowedFilesText = _ref.allowedFilesText,
    assetsApi = _ref.assetsApi;
  function onChangeFiles(acceptedFiles, onChangeStatus, onChangeAbort, onAbortOnChangeFiles) {
    acceptedFiles.length > 0 && acceptedFiles.forEach(function (file) {
      sendFile(file, onChangeStatus, onChangeAbort, onSuccess, onError, function () {
        onAbort && onAbort(file);
        onAbortOnChangeFiles && onAbortOnChangeFiles(file);
      }, assetsApi);
    });
  }
  return /*#__PURE__*/React__default.createElement(FileUploader$2, {
    onChangeFiles: onChangeFiles,
    minFiles: 1,
    maxFiles: maxFiles,
    maxSize: config.maxUploadFileSize,
    allowedFiles: allowedFiles,
    allowedFilesText: allowedFilesText,
    ifAbortReset: true,
    assetsApi: assetsApi
  });
}
FileUploaderAndUpload.propTypes = {
  allowedFiles: FileUploader$1.propTypes.allowedFiles,
  allowedFilesText: FileUploader$1.propTypes.allowedFilesText,
  ifAbortReset: propTypes.bool,
  assetsApi: propTypes.string
};
FileUploaderAndUpload.defaultProps = {
  allowedFiles: null,
  allowedFilesText: null,
  ifAbortReset: false
};

var forceVisibilityTypes = {
  NONE: '',
  SHOW: 'show',
  HIDE: 'hide'
};
var TOOLTIP_FORCE_SHOW_CLASS = 'lemo-tooltip-icon--force-show';
var TOOLTIP_FORCE_HIDE_CLASS = 'lemo-tooltip-icon--force-hide';
var TooltipIcon = function TooltipIcon(_ref) {
  var _classNames, _classNames2;
  var text = _ref.text,
    icon = _ref.icon,
    _ref$forceVisibility = _ref.forceVisibility,
    forceVisibility = _ref$forceVisibility === void 0 ? forceVisibilityTypes.NONE : _ref$forceVisibility,
    _ref$classAdd = _ref.classAdd,
    classAdd = _ref$classAdd === void 0 ? '' : _ref$classAdd;
  var _useState = useState(uuid()),
    guid = _useState[0];
  var ref = useRef(null);
  var tooltipRef = useRef(null);
  function showTooltip() {
    var _tooltipRef$current;
    tooltipRef === null || tooltipRef === void 0 ? void 0 : (_tooltipRef$current = tooltipRef.current) === null || _tooltipRef$current === void 0 ? void 0 : _tooltipRef$current.open({
      anchorSelect: "[data-tooltip-id='" + guid + "']",
      content: text
    });
  }
  function hideTooltip() {
    var _tooltipRef$current2;
    tooltipRef === null || tooltipRef === void 0 ? void 0 : (_tooltipRef$current2 = tooltipRef.current) === null || _tooltipRef$current2 === void 0 ? void 0 : _tooltipRef$current2.close();
  }
  useEffect(function () {
    if (icon) {
      if (forceVisibility === forceVisibilityTypes.SHOW) showTooltip();else if (forceVisibility === forceVisibilityTypes.HIDE) hideTooltip();
    }
  }, [guid, forceVisibility, tooltipRef.current, icon]);
  return !icon ? null : /*#__PURE__*/React__default.createElement("div", {
    className: classNames('lemo-tooltip-icon', (_classNames = {}, _classNames[TOOLTIP_FORCE_SHOW_CLASS] = forceVisibility === forceVisibilityTypes.SHOW, _classNames), (_classNames2 = {}, _classNames2[TOOLTIP_FORCE_HIDE_CLASS] = forceVisibility === forceVisibilityTypes.HIDE, _classNames2), classAdd),
    ref: ref
  }, /*#__PURE__*/React__default.createElement("div", {
    "data-tooltip-id": guid,
    "data-tooltip-content": text
  }, icon), /*#__PURE__*/React__default.createElement(Tooltip$1, {
    ref: tooltipRef,
    effect: "solid",
    id: guid,
    hidden: forceVisibility === forceVisibilityTypes.HIDE,
    multiline: true,
    closeEvents: {
      mouseleave: forceVisibility === forceVisibilityTypes.SHOW ? false : true
    }
  }));
};
TooltipIcon.propTypes = {};
TooltipIcon.defaultProps = {};

var _excluded$1 = ["className", "min", "max", "onChange", "isError", "autoSize", "selectAllOnFocus"];
function EditorInputText(_ref) {
  var className = _ref.className,
    min = _ref.min,
    max = _ref.max,
    onChange = _ref.onChange,
    isError = _ref.isError,
    autoSize = _ref.autoSize,
    _ref$selectAllOnFocus = _ref.selectAllOnFocus,
    selectAllOnFocus = _ref$selectAllOnFocus === void 0 ? false : _ref$selectAllOnFocus,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var inputRef = useRef();
  var currentValue = props.value || props.defaultValue;
  var isEmpty = !inputRef.current || inputRef.current.value.length === 0;
  var checkLimits = useCallback(function (e) {
    if (!props.type === 'number') return;
    var value = e.target.value;
    if (value < min) {
      e.target.value = min;
      onChange({
        target: {
          value: min
        }
      });
    }
    if (value > max) {
      e.target.value = max;
      onChange({
        target: {
          value: max
        }
      });
    }
  }, []);
  var handleInputFocus = function handleInputFocus(event) {
    if (selectAllOnFocus) {
      inputRef.current.select();
    }
    if (props.onFocus) props.onFocus(event);
  };
  return /*#__PURE__*/React__default.createElement("input", _extends({
    ref: inputRef,
    className: cn$1('lemo-editor-input-text', 'lemo-base-input', 'lemo-box-small', className, {
      'lemo-error': isError,
      'lemo-is-empty': isEmpty
    }),
    type: (props === null || props === void 0 ? void 0 : props.type) || 'text',
    onBlur: checkLimits,
    onChange: onChange,
    min: min,
    max: max
  }, autoSize ? {
    size: currentValue.toString().length + 1
  } : {}, props, {
    onFocus: handleInputFocus
  }));
}
var EditorInputText$1 = observer(EditorInputText);

var EditorSlider = function EditorSlider(_ref) {
  var _ref$limitMin = _ref.limitMin,
    limitMin = _ref$limitMin === void 0 ? 1 : _ref$limitMin,
    _ref$limitMax = _ref.limitMax,
    limitMax = _ref$limitMax === void 0 ? 10 : _ref$limitMax,
    showLimitMin = _ref.showLimitMin,
    min = _ref.min,
    max = _ref.max,
    onChangeMin = _ref.onChangeMin,
    onChangeMax = _ref.onChangeMax,
    onMouseUpMax = _ref.onMouseUpMax,
    _ref$stringConcatValu = _ref.stringConcatValues,
    stringConcatValues = _ref$stringConcatValu === void 0 ? null : _ref$stringConcatValu,
    _ref$decimals = _ref.decimals,
    decimals = _ref$decimals === void 0 ? -1 : _ref$decimals;
  var _useState = useState(max),
    maxState = _useState[0],
    setMaxState = _useState[1];
  useEffect(function () {
    if (max !== maxState) {
      setMaxState(max);
    }
  }, [max]);
  function onChangeRange(value) {
    if (value && value.length === 2) {
      onChangeMin && onChangeMin(value[0]);
      onChangeMax && onChangeMax(value[1]);
    }
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-slider"
  }, showLimitMin && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-slider__min"
  }, min, stringConcatValues), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-slider__slider"
  }, showLimitMin ? /*#__PURE__*/React__default.createElement(Range, {
    min: limitMin,
    max: limitMax,
    defaultValue: [min, max],
    value: [min, max],
    onChange: onChangeRange
  }) : /*#__PURE__*/React__default.createElement(Slider$2, {
    min: limitMin,
    max: limitMax,
    defaultValue: maxState,
    value: maxState,
    onChange: function onChange(value) {
      setMaxState(value);
      onChangeMax && onChangeMax(parseInt(value));
    },
    onAfterChange: function onAfterChange(value) {
      return onMouseUpMax && onMouseUpMax(parseInt(value));
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-slider__max"
  }, decimals === -1 ? maxState : parseInt(maxState, 10).toFixed(decimals), stringConcatValues));
};

var EditorSliderTitleSubtitle = function EditorSliderTitleSubtitle(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    limitMin = _ref.limitMin,
    limitMax = _ref.limitMax,
    showLimitMin = _ref.showLimitMin,
    min = _ref.min,
    max = _ref.max,
    onChangeMin = _ref.onChangeMin,
    onChangeMax = _ref.onChangeMax,
    onMouseUpMax = _ref.onMouseUpMax,
    stringConcatValues = _ref.stringConcatValues,
    decimals = _ref.decimals;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-slider-title-subtitle"
  }, /*#__PURE__*/React__default.createElement(EditorTitleSubtitleComponent, {
    title: title,
    subtitle: subtitle,
    componentRight: /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-slider-title-subtitle__slider"
    }, /*#__PURE__*/React__default.createElement(EditorSlider, {
      limitMin: limitMin,
      limitMax: limitMax,
      showLimitMin: showLimitMin,
      min: min,
      max: max,
      onChangeMin: onChangeMin,
      onChangeMax: onChangeMax,
      onMouseUpMax: onMouseUpMax,
      stringConcatValues: stringConcatValues,
      decimals: decimals
    }))
  }));
};

function ImagePreview(_ref) {
  var source = _ref.source,
    original_width = _ref.original_width,
    scale = _ref.scale,
    alt = _ref.alt,
    componentTopRight = _ref.componentTopRight,
    componentPreview = _ref.componentPreview;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-image-preview"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-image-preview__image"
  }, componentPreview || /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("img", {
    className: "lemo-image-size",
    draggable: "false",
    src: source,
    alt: alt
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-img-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: _extends({}, original_width && scale ? {
      width: original_width * scale / 100
    } : {})
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "lemo-image",
    draggable: "false",
    src: source,
    alt: alt
  }))))), componentTopRight && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-image-preview__top-right"
  }, componentTopRight));
}
var ImagePreview$1 = observer(ImagePreview);

var scaleImageBeforeUpload = function scaleImageBeforeUpload(file, newSize) {
  try {
    var _file$type;
    if (!newSize) return Promise.resolve(file);
    if (!(file !== null && file !== void 0 && (_file$type = file.type) !== null && _file$type !== void 0 && _file$type.match(/image.*/))) return Promise.resolve(null);
    var image = new Image();
    image.src = URL.createObjectURL(file);
    return Promise.resolve(new Promise(function (res) {
      return image.onload = res;
    })).then(function () {
      image.onload = null;
      if (image.width < newSize && image.height < newSize) return Promise.resolve(file);
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d', {
        alpha: true
      });
      var imageSize = adaptImageSize(image, newSize);
      canvas.width = imageSize.width;
      canvas.height = imageSize.height;
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      return new Promise(function (res) {
        return canvas.toBlob(res);
      });
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var applyPercent = function applyPercent(percent, value) {
  return value * percent / 100;
};
var getPercent = function getPercent(newSize, originalSize) {
  return newSize * 100 / originalSize;
};
function adaptImageSize(image, newSize) {
  var width = image.width,
    height = image.height;
  if (width < newSize && height < newSize) {
    return {
      width: width,
      height: height
    };
  }
  if (width > height) {
    return {
      width: newSize,
      height: applyPercent(getPercent(newSize, width), height)
    };
  }
  return {
    width: applyPercent(getPercent(newSize, height), width),
    height: newSize
  };
}

function ImageUploadOrPreview(_ref) {
  var background = _ref.background,
    onChangeBackground = _ref.onChangeBackground,
    _ref$showSliderSizeTh = _ref.showSliderSizeThumb,
    showSliderSizeThumb = _ref$showSliderSizeTh === void 0 ? true : _ref$showSliderSizeTh,
    _ref$sliderSizeThumbT = _ref.sliderSizeThumbTitle,
    sliderSizeThumbTitle = _ref$sliderSizeThumbT === void 0 ? null : _ref$sliderSizeThumbT,
    _ref$sliderSizeThumbS = _ref.sliderSizeThumbSubtitle,
    sliderSizeThumbSubtitle = _ref$sliderSizeThumbS === void 0 ? null : _ref$sliderSizeThumbS,
    sliderSize = _ref.sliderSize,
    onChangeSliderSize = _ref.onChangeSliderSize,
    _ref$componentPreview = _ref.componentPreview,
    componentPreview = _ref$componentPreview === void 0 ? null : _ref$componentPreview,
    _ref$componentBelowPr = _ref.componentBelowPreview,
    componentBelowPreview = _ref$componentBelowPr === void 0 ? null : _ref$componentBelowPr,
    _ref$componentLeftAlt = _ref.componentLeftAltText,
    componentLeftAltText = _ref$componentLeftAlt === void 0 ? null : _ref$componentLeftAlt,
    _ref$showDeletePrevie = _ref.showDeletePreview,
    showDeletePreview = _ref$showDeletePrevie === void 0 ? true : _ref$showDeletePrevie,
    _ref$showChangePrevie = _ref.showChangePreview,
    showChangePreview = _ref$showChangePrevie === void 0 ? false : _ref$showChangePrevie,
    showAltText = _ref.showAltText,
    assetsApi = _ref.assetsApi,
    maxImageSize = _ref.maxImageSize,
    _ref$altTextPlacehold = _ref.altTextPlaceholder,
    altTextPlaceholder = _ref$altTextPlacehold === void 0 ? null : _ref$altTextPlacehold;
  var inputFileRef = useRef(null);
  var backgroundRef = useRef(background);
  backgroundRef.current = background;
  var _useState = useState(null),
    statusChangePreview = _useState[0],
    setStatusChangePreview = _useState[1];
  var loadImageSuccess = useCallback(function (_background) {
    onChangeBackground(_background);
  }, [onChangeBackground]);
  var onDeleteBackground = useCallback(function () {
    onChangeBackground(null);
  }, [onChangeBackground]);
  var onChangeImagePreview = useCallback(function () {
    inputFileRef.current.click();
  }, []);
  var onChangeMax = useCallback(function (scale) {
    onChangeBackground(_extends({}, background, {
      scale: scale
    }, background.hasOwnProperty('original_width') ? {
      width: background.original_width * scale / 100
    } : {}, background.hasOwnProperty('original_height') ? {
      height: background.original_height * scale / 100
    } : {}));
  }, [onChangeBackground]);
  var onChangeAlt = useCallback(function (alt) {
    onChangeBackground(_extends({}, background, {
      alt: alt
    }));
  }, [onChangeBackground]);
  var loadImageError = useCallback(function (error) {
    window.alert(translate('load_image_error_message'));
  }, []);
  var loadImageAbort = useCallback(function () {
    console.log('El usuario ha cancelado la descarga');
  }, []);
  var onImageSuccess = useCallback(function (value) {
    onChangeBackground(_extends({}, backgroundRef.current, value, value.hasOwnProperty('original_width') ? {
      width: value.original_width * value.scale / 100
    } : {}, value.hasOwnProperty('original_height') ? {
      height: value.original_height * value.scale / 100
    } : {}));
    setStatusChangePreview(null);
  }, [backgroundRef.current]);
  var inputFileHandler = useCallback(function () {
    try {
      var inputFile = inputFileRef.current.files[0];
      return Promise.resolve(scaleImageBeforeUpload(inputFile, maxImageSize)).then(function (file) {
        sendFileWithName({
          file: file,
          fileName: inputFile.name,
          onChangeStatus: function onChangeStatus(fileInfo, status) {
            return setStatusChangePreview(status);
          },
          onChangeAbort: function onChangeAbort() {},
          onSuccess: onImageSuccess,
          onError: function onError(error) {
            return loadImageError(error);
          },
          onAbort: function onAbort() {
            return loadImageAbort();
          },
          assetsApi: assetsApi
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }, [sendFile, assetsApi]);
  var hasBackground = background && hasData(background.source);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, hasBackground ? /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-image-upload-or-preview"
  }, /*#__PURE__*/React__default.createElement(ImagePreview$1, _extends({
    componentPreview: componentPreview,
    componentTopRight: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showDeletePreview && /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-image-upload-or-preview__icon"
    }, /*#__PURE__*/React__default.createElement(ButtonIcon, {
      icon: /*#__PURE__*/React__default.createElement(SvgTrash$1, null),
      onClick: onDeleteBackground
    })), showChangePreview && /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-image-upload-or-preview__icon"
    }, statusChangePreview && statusChangePreview === fileStatuses.UPLOADING ? /*#__PURE__*/React__default.createElement(UploadIcon, {
      status: statusChangePreview
    }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TooltipIcon, {
      text: translate('change_image'),
      icon: /*#__PURE__*/React__default.createElement(ButtonIcon, {
        icon: /*#__PURE__*/React__default.createElement(SvgPhotograph, null),
        onClick: onChangeImagePreview
      })
    }))))
  }, background)), componentBelowPreview, /*#__PURE__*/React__default.createElement("div", {
    className: 'lemo-config-background-image__alt-container' + (componentLeftAltText ? ' lemo-config-background-image__alt-container--child-50' : '')
  }, componentLeftAltText, showAltText && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-config-background-image__alt"
  }, /*#__PURE__*/React__default.createElement(EditorInputText$1, {
    value: background.alt,
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      return onChangeAlt(value);
    },
    placeholder: altTextPlaceholder || translate('background_image_alt')
  }))), showSliderSizeThumb && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(EditorSliderTitleSubtitle, {
    title: sliderSizeThumbTitle || translate('Size thumb'),
    subtitle: sliderSizeThumbSubtitle || translate('Image size'),
    limitMin: 1,
    limitMax: 100,
    showLimitMin: false,
    max: sliderSize !== undefined ? sliderSize : background && background.hasOwnProperty('scale') ? Math.round(background.scale) : 100,
    onChangeMax: onChangeSliderSize || onChangeMax,
    decimals: 0,
    stringConcatValues: "%"
  }))) : /*#__PURE__*/React__default.createElement(FileUploaderAndUpload, {
    onSuccess: loadImageSuccess,
    onError: loadImageError,
    onAbort: loadImageAbort,
    maxFiles: 1,
    allowedFiles: ['image/jpeg', 'image/png', 'image/gif'],
    allowedFilesText: translate('Allowed files: images (jpg, png, gif)'),
    inputFileRef: inputFileRef,
    assetsApi: assetsApi
  }), showChangePreview && /*#__PURE__*/React__default.createElement("input", {
    ref: inputFileRef,
    className: "image_upload_or_preview__input image_upload_or_preview__input--hide",
    type: "file",
    name: "file",
    accept: "image/jpeg, image/png, image/gif",
    onChange: inputFileHandler
  }));
}
ImageUploadOrPreview.propTypes = {
  sliderSize: propTypes.number,
  onChangeSliderSize: propTypes.func,
  showAltText: propTypes.bool,
  sliderSizeThumbTitle: propTypes.string,
  sliderSizeThumbSubtitle: propTypes.string,
  assetsApi: propTypes.string,
  altTextPlaceholder: propTypes.string
};
ImageUploadOrPreview.defaultProps = {
  sliderSize: undefined,
  onChangeSliderSize: null,
  showAltText: true,
  sliderSizeThumbTitle: null,
  sliderSizeThumbSubtitle: null,
  assetsApi: null
};
var ImageUploadOrPreview$1 = observer(ImageUploadOrPreview);

var EditorBox = function EditorBox(_ref) {
  var id = _ref.id,
    icon = _ref.icon,
    helpText = _ref.helpText,
    titleBox = _ref.titleBox,
    children = _ref.children,
    classNameAdd = _ref.classNameAdd,
    _ref$hideContentTop = _ref.hideContentTop,
    hideContentTop = _ref$hideContentTop === void 0 ? false : _ref$hideContentTop;
  var _titleBox = titleBox || translate('Title');
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'lemo-editor-box lemo-base-block-editor' + (hasData(classNameAdd) ? ' ' + classNameAdd : ''),
    "data-id": id
  }, !hideContentTop && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-horizontal-content"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-title-icon-and-text"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-title-icon"
  }, icon), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-text lemo-base-block-editor__title"
  }, _titleBox)), hasData(helpText) && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-title-icon-right"
  }, /*#__PURE__*/React__default.createElement(TooltipIcon, {
    text: helpText,
    icon: /*#__PURE__*/React__default.createElement(SvgQuestionMarkCircle, {
      className: "lemo-editor-help-icon"
    })
  }))), children);
};
EditorBox.propTypes = {
  id: propTypes.string,
  icon: propTypes.element,
  titleBox: propTypes.string,
  children: propTypes.any,
  helpText: propTypes.string,
  classNameAdd: propTypes.string,
  hideContentTop: propTypes.bool
};
EditorBox.defaultProps = {
  id: 'title',
  icon: /*#__PURE__*/React__default.createElement(SvgMenuAlt, {
    width: "24"
  }),
  children: /*#__PURE__*/React__default.createElement("p", null, "Contenido"),
  helpText: null,
  className: null
};

var EditorContent = function EditorContent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-content"
  }, children);
};
EditorContent.propTypes = {
  children: propTypes.any
};
EditorContent.defaultProps = {};

var EditorBackground = function EditorBackground(_ref) {
  var titleBox = _ref.titleBox,
    background = _ref.background,
    onChangeBackground = _ref.onChangeBackground,
    assetsApi = _ref.assetsApi;
  var _useState = useState(background),
    isChecked = _useState[0],
    setIsChecked = _useState[1];
  function onChangeToggle(isCheckedToogle) {
    setIsChecked(isCheckedToogle);
    if (!isCheckedToogle) onChangeBackground(null);
  }
  var _onChangeBackground = useCallback(function (_background) {
    if (_background) {
      onChangeBackground(_extends({}, background, _background, {
        position: 'center',
        size: 'cover'
      }));
    } else {
      onChangeBackground && onChangeBackground(_background);
    }
  }, [onChangeBackground]);
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "background",
    icon: /*#__PURE__*/React__default.createElement(SvgPhotograph, {
      className: "lemo-editor-background__icon"
    }),
    titleBox: titleBox || translate('Background image'),
    helpText: translate('config_background_help'),
    classNameAdd: "lemo-editor-background"
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-stack-layout-150"
  }, /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_background_title'),
    subtitle: translate('config_background_subtitle'),
    isChecked: isChecked,
    onChange: onChangeToggle
  }), isChecked && /*#__PURE__*/React__default.createElement(ImageUploadOrPreview$1, {
    background: background,
    onChangeBackground: _onChangeBackground,
    showSliderSizeThumb: false,
    assetsApi: assetsApi
  }))));
};
EditorBackground.propTypes = {
  titleBox: propTypes.string,
  assetsApi: propTypes.string
};
EditorBackground.defaultProps = {};
var EditorBackground$1 = observer(EditorBackground);

var EditorBackgroundStore = function EditorBackgroundStore(_ref) {
  var store = _ref.store,
    titleBox = _ref.titleBox;
  return /*#__PURE__*/React__default.createElement(EditorBackground$1, {
    titleBox: titleBox,
    onChangeBackground: function onChangeBackground(value) {
      value ? store.ui_style.setBackground({
        src: value.source,
        alt: value.alt,
        position: value.position,
        size: value.size
      }) : store.ui_style.setBackground(undefined);
    },
    background: store.ui_style.background ? {
      source: store.ui_style.background.src,
      alt: store.ui_style.background.alt,
      position: store.ui_style.background.position,
      size: store.ui_style.background.size
    } : null,
    assetsApi: getAssetsEditorApi(store.assetsEditorApi)
  });
};
EditorBackgroundStore.propTypes = {};
var EditorBackgroundStore$1 = observer(EditorBackgroundStore);

var AddResponseClozeMath = function AddResponseClozeMath(_ref) {
  var text = _ref.text,
    number = _ref.number;
  var textFinal = text || translate('response');
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-blank-cloze-math lemo-add-response-close-math blank fr-draggable fr-embedly fr-deletable"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-add-response-cloze-math__text"
  }, textFinal), /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-add-response-close-math__number"
  }, number)));
};

// A type of promise-like that resolves synchronously and supports only one observer
const _Pact = /*#__PURE__*/(function() {
	function _Pact() {}
	_Pact.prototype.then = function(onFulfilled, onRejected) {
		const result = new _Pact();
		const state = this.s;
		if (state) {
			const callback = state & 1 ? onFulfilled : onRejected;
			if (callback) {
				try {
					_settle(result, 1, callback(this.v));
				} catch (e) {
					_settle(result, 2, e);
				}
				return result;
			} else {
				return this;
			}
		}
		this.o = function(_this) {
			try {
				const value = _this.v;
				if (_this.s & 1) {
					_settle(result, 1, onFulfilled ? onFulfilled(value) : value);
				} else if (onRejected) {
					_settle(result, 1, onRejected(value));
				} else {
					_settle(result, 2, value);
				}
			} catch (e) {
				_settle(result, 2, e);
			}
		};
		return result;
	};
	return _Pact;
})();

// Settles a pact synchronously
function _settle(pact, state, value) {
	if (!pact.s) {
		if (value instanceof _Pact) {
			if (value.s) {
				if (state & 1) {
					state = value.s;
				}
				value = value.v;
			} else {
				value.o = _settle.bind(null, pact, state);
				return;
			}
		}
		if (value && value.then) {
			value.then(_settle.bind(null, pact, state), _settle.bind(null, pact, 2));
			return;
		}
		pact.s = state;
		pact.v = value;
		const observer = pact.o;
		if (observer) {
			observer(pact);
		}
	}
}

function _isSettledPact(thenable) {
	return thenable instanceof _Pact && thenable.s & 1;
}

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously implement a generic for loop
function _for(test, update, body) {
	var stage;
	for (;;) {
		var shouldContinue = test();
		if (_isSettledPact(shouldContinue)) {
			shouldContinue = shouldContinue.v;
		}
		if (!shouldContinue) {
			return result;
		}
		if (shouldContinue.then) {
			stage = 0;
			break;
		}
		var result = body();
		if (result && result.then) {
			if (_isSettledPact(result)) {
				result = result.s;
			} else {
				stage = 1;
				break;
			}
		}
		if (update) {
			var updateValue = update();
			if (updateValue && updateValue.then && !_isSettledPact(updateValue)) {
				stage = 2;
				break;
			}
		}
	}
	var pact = new _Pact();
	var reject = _settle.bind(null, pact, 2);
	(stage === 0 ? shouldContinue.then(_resumeAfterTest) : stage === 1 ? result.then(_resumeAfterBody) : updateValue.then(_resumeAfterUpdate)).then(void 0, reject);
	return pact;
	function _resumeAfterBody(value) {
		result = value;
		do {
			if (update) {
				updateValue = update();
				if (updateValue && updateValue.then && !_isSettledPact(updateValue)) {
					updateValue.then(_resumeAfterUpdate).then(void 0, reject);
					return;
				}
			}
			shouldContinue = test();
			if (!shouldContinue || (_isSettledPact(shouldContinue) && !shouldContinue.v)) {
				_settle(pact, 1, result);
				return;
			}
			if (shouldContinue.then) {
				shouldContinue.then(_resumeAfterTest).then(void 0, reject);
				return;
			}
			result = body();
			if (_isSettledPact(result)) {
				result = result.v;
			}
		} while (!result || !result.then);
		result.then(_resumeAfterBody).then(void 0, reject);
	}
	function _resumeAfterTest(shouldContinue) {
		if (shouldContinue) {
			result = body();
			if (result && result.then) {
				result.then(_resumeAfterBody).then(void 0, reject);
			} else {
				_resumeAfterBody(result);
			}
		} else {
			_settle(pact, 1, result);
		}
	}
	function _resumeAfterUpdate() {
		if (shouldContinue = test()) {
			if (shouldContinue.then) {
				shouldContinue.then(_resumeAfterTest).then(void 0, reject);
			} else {
				_resumeAfterTest(shouldContinue);
			}
		} else {
			_settle(pact, 1, result);
		}
	}
}

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

var actionPerformedTypes = {
  ON_GLOBAL_FEEDBACK_AI_GENERATED: 'onGlobalFeedbackAIGenerated'
};

var actionsPerformed = {
  onGlobalFeedbackAIGenerated: function onGlobalFeedbackAIGenerated(onActionPerformed, feedback) {
    var _onActionPerformed;
    if (onActionPerformed === void 0) {
      onActionPerformed = null;
    }
    (_onActionPerformed = onActionPerformed) === null || _onActionPerformed === void 0 ? void 0 : _onActionPerformed(actionPerformedTypes.ON_GLOBAL_FEEDBACK_AI_GENERATED, {
      feedback: feedback
    });
  }
};

var INITIAL = 'INITIAL';
var LOADING = 'LOADING';
var COMPLETED = 'COMPLETED';
function EditorAIFeedbackGenerator(_ref) {
  var getFeedback = function getFeedback() {
    try {
      if (status === LOADING) return Promise.resolve(false);
      setStatus(LOADING);
      return Promise.resolve(_catch(function () {
        return Promise.resolve(window.fetch(config.api, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(config.body)
        })).then(function (response) {
          if (!response.ok) {
            throw new Error('Network response was not ok', response);
          }
          return Promise.resolve(response.json()).then(function (json) {
            var feedback = json.data.choices[0].message.content;
            setContent(feedback);
            actionsPerformed.onGlobalFeedbackAIGenerated(onActionPerformed, feedback);
            setStatus(COMPLETED);
          });
        });
      }, function (error) {
        setStatus(INITIAL);
        console.log('There has been a problem with your fetch operation:', error);
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var setContent = _ref.setContent,
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config,
    onActionPerformed = _ref.onActionPerformed;
  var _useState = useState(INITIAL),
    status = _useState[0],
    setStatus = _useState[1];
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-ai-feedback-generator"
  }, /*#__PURE__*/React__default.createElement(SimpleButton, {
    className: "lemo-get-ai-feedback-button",
    variant: variantsSimpleButton.primary,
    onClick: getFeedback,
    disabled: status === COMPLETED
  }, status === LOADING ? /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-spinner"
  }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SvgSparkles, {
    className: "lemo-icon",
    width: 24
  }), /*#__PURE__*/React__default.createElement("span", null, translate('get_feedback')))));
}
var EditorAIFeedbackGenerator$1 = observer(EditorAIFeedbackGenerator);

var EditorFeedbackExercise = function EditorFeedbackExercise(_ref) {
  var feedback = _ref.feedback,
    onChangeFeedback = _ref.onChangeFeedback,
    showConfigFeedbacksIndividual = _ref.showConfigFeedbacksIndividual,
    feedbacksIndividual = _ref.feedbacksIndividual,
    onChangeFeedbacksIndividual = _ref.onChangeFeedbacksIndividual,
    titleBox = _ref.titleBox,
    placeholder = _ref.placeholder,
    helpText = _ref.helpText,
    assetsFroalaApi = _ref.assetsFroalaApi,
    onChangeCheckedFeedbackIndividual = _ref.onChangeCheckedFeedbackIndividual,
    feedbackIndividualLabelText = _ref.feedbackIndividualLabelText,
    hasGlobalFeedback = _ref.hasGlobalFeedback,
    setGlobalFeedback = _ref.setGlobalFeedback,
    hasSpecificFeedback = _ref.hasSpecificFeedback,
    setSpecificFeedback = _ref.setSpecificFeedback,
    AIFeedbackConfig = _ref.AIFeedbackConfig,
    icon = _ref.icon,
    onActionPerformed = _ref.onActionPerformed;
  var _useState = useState(feedback),
    feedbackLocal = _useState[0],
    setFeedbackLocal = _useState[1];
  var _useState2 = useState(feedbacksIndividual),
    feedbacksIndividualLocal = _useState2[0],
    setFeedbacksIndividualLocal = _useState2[1];
  var PanelIconComponent = icon || /*#__PURE__*/React__default.createElement(SvgExclamationCircle, {
    width: "24"
  });
  useEffect(function () {
    if (feedbacksIndividual && feedbacksIndividualLocal && (getListResponseGuid(feedbacksIndividual).toString() !== getListResponseGuid(feedbacksIndividualLocal).toString() || feedbacksIndividual.length !== feedbacksIndividualLocal.length)) {
      setFeedbacksIndividualLocal(feedbacksIndividual);
    }
  }, [feedbacksIndividual]);
  function onChangeFeedbackLocal(_feedback) {
    setFeedbackLocal(_feedback);
    onChangeFeedback(_feedback);
  }
  function getListResponseGuid(_feedbacksIndividual) {
    return _feedbacksIndividual.map(function (_feedbackIndividual) {
      return _feedbackIndividual.responseGuid;
    });
  }
  function onChangeFeedbackIndividualLocal(_feedbackTextUpdate, feedbackIndividual, index) {
    var newFeedbackIndividual = feedbacksIndividualLocal ? feedbacksIndividualLocal.map(function (item, _index) {
      return item.responseGuid === feedbackIndividual.responseGuid ? _extends({}, item, {
        text: _feedbackTextUpdate
      }) : item;
    }) : [];
    setFeedbacksIndividualLocal(newFeedbackIndividual);
    onChangeFeedbacksIndividual(newFeedbackIndividual);
  }
  function onChangeToggle(isCheckedToogle) {
    setGlobalFeedback(isCheckedToogle);
    if (!isCheckedToogle) {
      onChangeFeedback('');
    } else {
      onChangeFeedback(feedbackLocal);
    }
  }
  function onChangeToggleIndividual(isCheckedToogle) {
    setSpecificFeedback(isCheckedToogle);
    onChangeCheckedFeedbackIndividual && onChangeCheckedFeedbackIndividual(isCheckedToogle);
    if (!isCheckedToogle) {
      onChangeFeedbacksIndividual([]);
    } else {
      onChangeFeedbacksIndividual(feedbacksIndividualLocal);
    }
  }
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "feedback",
    icon: PanelIconComponent,
    titleBox: titleBox || translate('feedback_exercise_title'),
    helpText: helpText || translate('feedback_exercise_help'),
    classNameAdd: 'lemo-editor-feedback-exercise'
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-stack-layout-150"
  }, /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('feedback_exercise_toogle_title'),
    subtitle: translate('feedback_exercise_toogle_subtitle'),
    isChecked: hasGlobalFeedback,
    onChange: onChangeToggle
  }), hasGlobalFeedback && /*#__PURE__*/React__default.createElement(FroalaField$1, {
    editMode: true,
    content: feedbackLocal,
    setContent: onChangeFeedbackLocal,
    placeholder: placeholder || translate('feedback_exercise_placeholder'),
    assetsFroalaApi: assetsFroalaApi
  }), hasGlobalFeedback && config.showAIFeedbackGenerator && /*#__PURE__*/React__default.createElement(EditorAIFeedbackGenerator$1, {
    config: AIFeedbackConfig,
    setContent: onChangeFeedbackLocal,
    onActionPerformed: onActionPerformed
  })), showConfigFeedbacksIndividual && /*#__PURE__*/React__default.createElement("div", {
    className: ""
  }, /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('feedback_exercise_toogle_individual_feedback_title'),
    subtitle: translate('feedback_exercise_toogle_individual_feedback_subtitle'),
    isChecked: hasSpecificFeedback,
    onChange: onChangeToggleIndividual
  }), hasSpecificFeedback && feedbacksIndividualLocal.map(function (feedback, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-editor-feedback-exercise__feedback_individual_container",
      key: index
    }, /*#__PURE__*/React__default.createElement(AddResponseClozeMath, {
      number: index + 1,
      text: feedbackIndividualLabelText
    }), /*#__PURE__*/React__default.createElement(FroalaField$1, {
      editMode: true,
      content: feedback.text,
      setContent: function setContent(content) {
        return onChangeFeedbackIndividualLocal(content, feedback);
      },
      placeholder: translate('individual_feedback_exercise_placeholder'),
      assetsFroalaApi: assetsFroalaApi
    }));
  }))));
};
EditorFeedbackExercise.propTypes = {
  feedback: propTypes.string,
  onChangeFeedback: propTypes.func,
  showConfigFeedbacksIndividual: propTypes.bool,
  feedbacksIndividual: propTypes.arrayOf(propTypes.object),
  onChangeFeedbacksIndividual: propTypes.func,
  assetsFroalaApi: propTypes.string,
  feedbackIndividualLabelText: propTypes.string,
  AIFeedbackConfig: propTypes.any
};
EditorFeedbackExercise.defaultProps = {
  feedback: '',
  showConfigFeedbacksIndividual: false,
  onChangeFeedback: function onChangeFeedback(feedbackUpdated) {
    return console.log(feedbackUpdated);
  },
  feedbackIndividualLabelText: null,
  AIFeedbackConfig: {
    api: null,
    body: null
  }
};
var EditorFeedbackExercise$1 = observer(EditorFeedbackExercise);

var AIFeedbackGeneratorAPI = 'https://api.app-ai.oneclicklabs.es/experiments/openai';
var AIFeedbackGeneratorBody = {
  model: 'gpt-4',
  prompt: 'Eres un profesor que  está analizando actividades y vas a dar feedback constructivo sobre la respuesta incorrecta que ha dado un alumno a la siguiente actividad.\n' + 'El feedback debe ser positivo y permitir corregir los errores y avanzar hacia la respuesta correcta\n' + 'No saludes al alumno.  No le indiques cuál es la respuesta correcta, solo ayudale a llegar por si mismo a la respuesta.\n' + 'Esta es la actividad:',
  system: 'Eres un profesor, experto en pedagogía y neurociencia que analiza las respuestas de sus alumnos para dar feedback constructivo que les ayude a aprender',
  temperature: 0.4,
  max_tokens: 1000
};

var EditorFeedbackExerciseStore = function EditorFeedbackExerciseStore(_ref) {
  var store = _ref.store,
    haveFeedbackIndividual = _ref.haveFeedbackIndividual,
    showConfigFeedbacksIndividual = _ref.showConfigFeedbacksIndividual,
    onChangeCheckedFeedbackIndividual = _ref.onChangeCheckedFeedbackIndividual,
    feedbackIndividualLabelText = _ref.feedbackIndividualLabelText,
    onActionPerformed = _ref.onActionPerformed;
  function onChange(text) {
    store.feedback.setErrorString(text);
  }
  var feedbackConfig = store.feedback.config;
  return /*#__PURE__*/React__default.createElement(EditorFeedbackExercise$1, {
    feedback: store.feedback && store.feedback.errorMessages && store.feedback.errorMessages.length > 0 ? store.feedback.errorMessages[0] : '',
    onChangeFeedback: onChange,
    showConfigFeedbacksIndividual: showConfigFeedbacksIndividual,
    feedbacksIndividual: store.responsesFeedback,
    onChangeFeedbacksIndividual: store.setResponsesFeedback,
    assetsFroalaApi: getAssetsEditorApi(store.assetsEditorApi),
    helpText: haveFeedbackIndividual ? translate('feedback_exercise_help_with_individual') : translate('feedback_exercise_help'),
    onChangeCheckedFeedbackIndividual: onChangeCheckedFeedbackIndividual,
    feedbackIndividualLabelText: feedbackIndividualLabelText,
    hasGlobalFeedback: feedbackConfig.hasGlobalFeedback,
    setGlobalFeedback: function setGlobalFeedback(bool) {
      return feedbackConfig.setGlobalFeedback(bool);
    },
    hasSpecificFeedback: feedbackConfig.hasSpecificFeedback,
    setSpecificFeedback: function setSpecificFeedback(bool) {
      return feedbackConfig.setSpecificFeedback(bool);
    },
    AIFeedbackConfig: {
      api: AIFeedbackGeneratorAPI,
      body: store.AIFeedbackBody
    },
    onActionPerformed: onActionPerformed
  });
};
var EditorFeedbackExerciseStore$1 = observer(EditorFeedbackExerciseStore);

var EditorHints = function EditorHints(_ref) {
  var hints = _ref.hints,
    resetHints = _ref.resetHints,
    addHint = _ref.addHint,
    onChangeHint = _ref.onChangeHint,
    titleBox = _ref.titleBox,
    placeholder = _ref.placeholder,
    assetsFroalaApi = _ref.assetsFroalaApi,
    icon = _ref.icon;
  var _useState = useState(hints),
    _hints = _useState[0],
    _setHints = _useState[1];
  var _useState2 = useState(isCheckedToogleInit()),
    isChecked = _useState2[0],
    setIsChecked = _useState2[1];
  var PanelIconComponent = icon || /*#__PURE__*/React__default.createElement(SvgLightBulb, {
    className: "lemo-editor-hint-icon"
  });
  useEffect(function () {
    setIsChecked(isCheckedToogleInit());
    _setHints(hints);
  }, [hints.length]);
  function isCheckedToogleInit() {
    return hints && hints.length > 0;
  }
  function onChangeToggle(isCheckedToogle) {
    if (isCheckedToogle) {
      if (hints && hints.length > 0) ; else {
        addHint('');
      }
    } else {
      resetHints(null);
    }
  }
  function _onChangeHint(index, value) {
    _setHints(_hints.map(function (hint, i) {
      return i === index ? value : hint;
    }));
    onChangeHint(index, value);
  }
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "hints",
    icon: PanelIconComponent,
    titleBox: titleBox || translate('hints_title_box'),
    helpText: translate('hints_help'),
    classNameAdd: 'lemo-editor-hints'
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-stack-layout-150"
  }, /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('hints_title'),
    subtitle: translate('hints_subtitle'),
    isChecked: isChecked,
    onChange: onChangeToggle
  }), isChecked && /*#__PURE__*/React__default.createElement("div", {
    className: "editor-hints-list"
  }, _hints.map(function (hint, index) {
    return /*#__PURE__*/React__default.createElement(FroalaField$1, {
      key: index,
      editMode: true,
      content: hint,
      setContent: function setContent(value) {
        return _onChangeHint(index, value);
      },
      placeholder: placeholder || translate('hint_placeholder'),
      assetsFroalaApi: assetsFroalaApi
    });
  })))));
};
EditorHints.propTypes = {
  title: propTypes.string,
  onTitleChange: propTypes.func,
  titleBox: propTypes.string,
  placeholder: propTypes.string,
  assetsFroalaApi: propTypes.string
};
EditorHints.defaultProps = {
  title: '',
  onTitleChange: function onTitleChange(text) {
    return console.log(text);
  }
};
var EditorHints$1 = observer(EditorHints);

var EditorHintsStore = function EditorHintsStore(_ref) {
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(EditorHints$1, {
    hints: store.hints.hintList.toJSON(),
    resetHints: function resetHints() {
      return store.hints.resetHints();
    },
    addHint: function addHint(value) {
      return store.hints.addHint(value);
    },
    onChangeHint: function onChangeHint(index, value) {
      return store.hints.onUpdateHint(index, value);
    },
    assetsFroalaApi: getAssetsEditorApi(store.assetsEditorApi)
  });
};
EditorHintsStore.propTypes = {};
var EditorHintsStore$1 = observer(EditorHintsStore);

function EditorUploadContent(_ref) {
  var attachments = _ref.attachments,
    onClose = _ref.onClose;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-upload-content"
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-close-button",
    onClick: onClose
  }, /*#__PURE__*/React__default.createElement(SvgXCircle, {
    className: "lemo-icon",
    width: 24
  })), /*#__PURE__*/React__default.createElement(FileUploader$1, {
    store: attachments,
    showDriveButton: config.isGooglePickerEnabled,
    allowedFiles: allowedFiles,
    maxSize: config.maxUploadFileSize
  }, function (file) {
    return /*#__PURE__*/React__default.createElement(CustomFileItem, {
      key: file.id,
      file: file
    });
  }));
}
var CustomFileItem = observer(function (_ref2) {
  var file = _ref2.file;
  function abort(file) {
    file.abortUpload(file);
    file.removeFile();
  }
  return /*#__PURE__*/React__default.createElement(FileItem$1, {
    file: file
  }, /*#__PURE__*/React__default.createElement(ShowWhen$1, {
    condition: file.status === fileStatuses.UPLOADING
  }, /*#__PURE__*/React__default.createElement(CancelButton$1, {
    onClick: function onClick() {
      return abort(file);
    }
  })), /*#__PURE__*/React__default.createElement(ShowWhen$1, {
    condition: file.status === fileStatuses.COMPLETE
  }, /*#__PURE__*/React__default.createElement(CancelButton$1, {
    onClick: file.removeFile
  })));
});
var EditorUploadContent$1 = observer(EditorUploadContent);

function EditorStimulusAttachFiles(_ref) {
  var attachments = _ref.attachments;
  var files = (attachments === null || attachments === void 0 ? void 0 : attachments.files) || [];
  var _useState = useState(files.length > 0),
    visible = _useState[0],
    setVisible = _useState[1];
  function onClose() {
    attachments.clearAllFiles();
    setVisible(false);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-stimulus-attach-files"
  }, visible ? /*#__PURE__*/React__default.createElement(EditorUploadContent$1, {
    attachments: attachments,
    onClose: onClose
  }) : /*#__PURE__*/React__default.createElement(SimpleButton, {
    className: "lemo-show-upload-controls-button",
    onClick: function onClick() {
      return setVisible(true);
    }
  }, /*#__PURE__*/React__default.createElement(SvgCloudUpload, {
    className: "lemo-icon",
    width: 24
  }), /*#__PURE__*/React__default.createElement("span", null, translate('upload_files'))));
}
var EditorStimulusAttachFiles$1 = observer(EditorStimulusAttachFiles);

var EditorStimulus = function EditorStimulus(_ref) {
  var stimulus = _ref.stimulus,
    onStimulusChange = _ref.onStimulusChange,
    assetsFroalaApi = _ref.assetsFroalaApi,
    titleBox = _ref.titleBox,
    placeholder = _ref.placeholder,
    attachments = _ref.attachments;
  var showAttachments = attachments && config.attachmentsEnable;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "stimulus",
    icon: /*#__PURE__*/React__default.createElement(SvgSortText, {
      width: "24"
    }),
    titleBox: titleBox,
    helpText: translate('stimulus_help'),
    classNameAdd: 'lemo-editor-stimulus'
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement(FroalaField$1, {
    editMode: true,
    content: stimulus,
    setContent: onStimulusChange,
    assetsFroalaApi: assetsFroalaApi,
    toolbarInline: false,
    canInsertVideo: true,
    placeholder: placeholder
  })), showAttachments && /*#__PURE__*/React__default.createElement(EditorStimulusAttachFiles$1, {
    attachments: attachments
  }));
};
EditorStimulus.propTypes = {
  stimulus: propTypes.string,
  onStimulusChange: propTypes.func,
  assetsFroalaApi: propTypes.string,
  titleBox: propTypes.string,
  placeholder: propTypes.string,
  attachments: propTypes.any
};
EditorStimulus.defaultProps = {
  stimulus: '',
  onStimulusChange: function onStimulusChange(text) {
    return console.log(text);
  },
  titleBox: translate('stimulus'),
  placeholder: translate('group_stimulus_placeholder')
};
var EditorStimulus$1 = observer(EditorStimulus);

var EditorStimulusStore = function EditorStimulusStore(_ref) {
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(EditorStimulus$1, {
    titleBox: translate('stimulus'),
    stimulus: store.stimulus,
    onStimulusChange: store.setStimulus,
    assetsFroalaApi: getAssetsEditorApi(store.assetsEditorApi),
    attachments: store.attachments
  });
};
var EditorStimulusStore$1 = observer(EditorStimulusStore);

var EditorTitle = function EditorTitle(_ref) {
  var title = _ref.title,
    onTitleChange = _ref.onTitleChange,
    titleBox = _ref.titleBox;
  var _titleBox = titleBox || translate('title_title_box');
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "title",
    icon: /*#__PURE__*/React__default.createElement(SvgClipboard, {
      width: "24",
      height: "24"
    }),
    titleBox: _titleBox,
    helpText: translate('title_help'),
    classNameAdd: 'lemo-editor-title'
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement(EditorInputText$1, {
    value: title,
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      return onTitleChange(value);
    },
    placeholder: translate('title_placeholder')
  })));
};
EditorTitle.propTypes = {
  title: propTypes.string,
  onTitleChange: propTypes.func,
  titleBox: propTypes.string
};
EditorTitle.defaultProps = {
  title: '',
  onTitleChange: function onTitleChange(text) {
    return console.log(text);
  }
};

var EditorTitleStore = function EditorTitleStore(_ref) {
  var store = _ref.store,
    titleBox = _ref.titleBox;
  return /*#__PURE__*/React__default.createElement(EditorTitle, {
    title: store.title,
    onTitleChange: store.setTitle,
    titleBox: titleBox
  });
};
EditorTitleStore.propTypes = {
  titleBox: EditorTitle.propTypes.titleBox
};
var EditorTitleStore$1 = observer(EditorTitleStore);

var minus = '−';
var multiply = '×';
var division = '÷';
var point = function point() {
  return config.decimalSeparator;
};
var getBasicKeyboardLiterals = function getBasicKeyboardLiterals() {
  return [['7', '8', '9', '+'], ['4', '5', '6', minus, '<'], ['1', '2', '3', multiply, '>'], [point(), '0', '=', division, '%']];
};
var getResponsiveKeyboardLiterals = function getResponsiveKeyboardLiterals() {
  return [['+', minus, multiply], ['7', '8', '9', division], ['4', '5', '6', '<'], ['1', '2', '3', '>'], [point(), '0', '=', '%']];
};

function useMask(_ref) {
  var type = _ref.type,
    current = _ref.current,
    next = _ref.next;
  console.log('-> useMask', type, current, next);
  var eq = function eq(currentType) {
    return currentType === type;
  };
  return when()["case"](eq(keyboardTypes.NUMERICAL), function () {
    return getNumericalMask(next, current);
  })["case"](eq(keyboardTypes.PRIME_NUMBERS), function () {
    return getNumericalMask(next, current);
  })["case"](eq(keyboardTypes.BASIC), function () {
    return getBasicMask(next, current);
  })["case"](eq(keyboardTypes.ROMAN), function () {
    return getRomanMask(next, current);
  }).resolve(function () {
    return '';
  });
}
function getNumericalMask(next, current) {
  if (current === void 0) {
    current = '';
  }
  var value = next.trim().replace(/\s+/g, '');
  return /[^0-9]/g.test(value) ? current : value;
}
function getBasicMask(next, current) {
  var filterBasicLiterals = /[^0-9=+−×÷<>.,%/x*-]/g.test(next);
  if (filterBasicLiterals) return current;
  var separator = config.decimalSeparator;
  return next.replace(/\//g, division).replace(/x/g, multiply).replace(/\*/g, multiply).replace(/-/g, minus).replace(/,|\./g, separator);
}
function getRomanMask(next, current) {
  var upperNext = next.toUpperCase();
  return /^[IVXLCDM]/g.test(upperNext) ? upperNext : current;
}

var keyboardTypes = {
  NUMERICAL: keyboards.numerical,
  BASIC: keyboards.basic,
  INTERMEDIATE: keyboards.intermediate,
  SCIENTIFIC: keyboards.scientific,
  ROMAN: keyboards.roman,
  FUNCTIONS: keyboards.functions,
  PRIME_NUMBERS: keyboards.primeNumbers,
  NONE: ''
};
function getCustomKeyboardMathField(keyboardStore) {
  var customKeyboard;
  if (keyboardStore.type !== undefined) {
    if (keyboardStore.type === keyboardTypes.INTERMEDIATE) {
      customKeyboard = keyboards.intermediate;
    } else if (keyboardStore.type === keyboardTypes.FUNCTIONS) {
      customKeyboard = keyboards.functions;
    }
  }
  return customKeyboard;
}
var KeyboardStore = types$1.model({
  activeFieldId: types$1.optional(types$1.string, ''),
  value: types$1.optional(types$1.string, ''),
  maxLength: types$1.optional(types$1.number, -1),
  isFloating: types$1.optional(types$1["boolean"], false),
  tabList: types$1.optional(types$1.array(types$1.string), []),
  type: types$1.optional(types$1.enumeration(Object.values(keyboardTypes)), keyboardTypes.NONE)
}).actions(function (state) {
  var valueTracker = noop;
  var isSolutionsMode = false;
  return {
    afterAttach: function afterAttach() {
      var parent = getParent(state);
      isSolutionsMode = (parent === null || parent === void 0 ? void 0 : parent.isSolutionsMode) || false;
      state.updateFromUIStyle();
    },
    start: function start(_ref) {
      var id = _ref.id,
        value = _ref.value,
        setValue = _ref.setValue,
        maxLength = _ref.maxLength;
      state.activeFieldId = id;
      state.value = value;
      state.maxLength = isSolutionsMode ? undefined : maxLength;
      valueTracker();
      valueTracker = reaction(function () {
        return state.value;
      }, setValue);
    },
    finish: function finish() {
      valueTracker();
      state.reset();
    },
    setValue: function setValue(value) {
      var isMaxLengthReached = maxLengthReached(value, state.maxLength);
      var isSingleCharacter = state.maxLength === 1;
      var isNumericKeyboard = state.type === keyboardTypes.NUMERICAL;
      var isRomanKeyboard = state.type === keyboardTypes.ROMAN;
      console.log('-> init', value);
      if (value === '' && isRomanKeyboard) {
        state.value = '';
        return;
      }
      if (isSingleCharacter && isNumericKeyboard) {
        state.value = (value % 10).toString();
        return;
      }
      if (isMaxLengthReached) return state.value;
      var next = useMask({
        type: state.type,
        current: state.value,
        next: value
      });
      state.value = next;
      console.log('->', state.value);
      return next;
    },
    forceValue: function forceValue(value) {
      state.value = value;
    },
    setIsFloating: function setIsFloating(isFloating) {
      state.isFloating = isFloating;
    },
    setTabList: function setTabList(tabList) {
      state.tabList = tabList;
    },
    setType: function setType(type) {
      state.type = Object.values(keyboardTypes).includes(type) ? type : '';
    },
    reset: function reset() {
      state.activeFieldId = '';
      state.value = '';
    },
    updateFromUIStyle: function updateFromUIStyle() {
      var _getParent;
      var uiStyle = (_getParent = getParent(state)) === null || _getParent === void 0 ? void 0 : _getParent.ui_style;
      if (!uiStyle) return false;
      var _ref2 = (uiStyle === null || uiStyle === void 0 ? void 0 : uiStyle.keyboard) || {},
        _ref2$type = _ref2.type,
        type = _ref2$type === void 0 ? '' : _ref2$type,
        _ref2$isFloating = _ref2.isFloating,
        isFloating = _ref2$isFloating === void 0 ? false : _ref2$isFloating;
      state.setType(type);
      state.setIsFloating(isFloating);
    }
  };
}).views(function (state) {
  return {
    get isActive() {
      return state.activeFieldId.length > 0;
    },
    get hasTabList() {
      return state.tabList.lenght > 0;
    },
    get currentTabIndex() {
      return state.tabList.findIndex(function (element) {
        return element === state.activeFieldId;
      });
    },
    get nextFocus() {
      var isTabSelected = state.currentTabIndex > -1;
      var nextIndex = state.currentTabIndex + 1;
      var hasNextTab = nextIndex < state.tabList.length;
      return isTabSelected && hasNextTab ? state.tabList[nextIndex] : undefined;
    },
    get hasTabulator() {
      try {
        var _getParent2;
        var isSolutionsMode = (_getParent2 = getParent(state)) === null || _getParent2 === void 0 ? void 0 : _getParent2.isSolutionMode;
        var hasMultipleFields = state.tabList.length > 1;
        return isSolutionsMode || hasMultipleFields || state.isFloating;
      } catch (e) {
        return true;
      }
    }
  };
});
function maxLengthReached(value, maxLength) {
  return maxLength > 0 && value.length > maxLength;
}

var feedbackModeTypes = {
  NONE: '',
  FEEDBACK_WITH_BORDER: 'feedback-with-border',
  FEEDBACK_WITH_TICK: 'feedback-with-tick'
};

var exactOrEquivalentTypes = {
  EXACT: 'equivLiteral',
  EQUIVALENT: 'equivSymbolic'
};

var checkIOS = function checkIOS() {
  return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
};
var PopoverContext = React__default.createContext(undefined, undefined);
function Popover(_ref) {
  var children = _ref.children,
    onToggle = _ref.onToggle;
  var _useState = useState(false),
    open = _useState[0],
    setOpen = _useState[1];
  var wrapper = useRef(null);
  var toggle = useCallback(function (e) {
    setOpen(function (state) {
      onToggle === null || onToggle === void 0 ? void 0 : onToggle(!state);
      return !state;
    });
    e.preventDefault();
  }, [setOpen, onToggle]);
  var hide = useCallback(function (e) {
    return wrapper.current && !wrapper.current.contains(e.target) && setOpen(false);
  }, [setOpen]);
  var close = useCallback(function () {
    return setOpen(false);
  }, [setOpen]);
  var addCallback = useCallback(function () {
    return checkIOS() ? window.addEventListener('touchstart', hide) : window.addEventListener('click', hide);
  }, [hide]);
  var removeCallback = useCallback(function () {
    return checkIOS() ? window.removeEventListener('touchstart', hide) : window.removeEventListener('click', hide);
  }, [hide]);
  useEffect(function () {
    addCallback();
    return function () {
      return removeCallback();
    };
  }, []);
  var value = React__default.useMemo(function () {
    return {
      open: open,
      close: close,
      toggle: toggle
    };
  }, [toggle, open, close]);
  return /*#__PURE__*/React__default.createElement(PopoverContext.Provider, {
    value: value
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: wrapper
  }, children));
}
function usePopoverContext() {
  var context = React__default.useContext(PopoverContext);
  if (!context) {
    throw new Error('Popover compound inputWithKeyboard cannot be rendered outside the Popover component');
  }
  return context;
}
function Control(_ref2) {
  var children = _ref2.children;
  var _usePopoverContext = usePopoverContext(),
    toggle = _usePopoverContext.toggle,
    open = _usePopoverContext.open;
  return children({
    toggle: toggle,
    open: open
  });
}
function Content(_ref3) {
  var children = _ref3.children,
    onChangeOpen = _ref3.onChangeOpen;
  var _usePopoverContext2 = usePopoverContext(),
    close = _usePopoverContext2.close,
    open = _usePopoverContext2.open;
  useEffect(function () {
    onChangeOpen === null || onChangeOpen === void 0 ? void 0 : onChangeOpen(open);
  }, [open]);
  return /*#__PURE__*/React__default.createElement("div", {
    style: _extends({}, !open && {
      display: 'none'
    })
  }, typeof children === 'function' ? children({
    close: close,
    open: open
  }) : children);
}
Popover.Control = Control;
Popover.Content = Content;

function DropDownControl(_ref) {
  var toggle = _ref.toggle,
    disabled = _ref.disabled,
    isOpen = _ref.isOpen,
    isStyleFeedbackError = _ref.isStyleFeedbackError,
    handleToggle = _ref.handleToggle,
    isStyleFeedbackSuccess = _ref.isStyleFeedbackSuccess,
    labelTarget = _ref.labelTarget,
    selectedIndex = _ref.selectedIndex,
    itemList = _ref.itemList,
    minWidth = _ref.minWidth,
    fontSize = _ref.fontSize;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-dropdown-control', 'lemo-base-dropdown', {
      'lemo-dropdown-control--disabled lemo-base-dropdown--disabled': disabled,
      'lemo-dropdown-control--open lemo-base-dropdown--open': isOpen,
      'lemo-dropdown-control--feedback-success': isStyleFeedbackSuccess,
      'lemo-dropdown-control--feedback-error': isStyleFeedbackError
    }),
    onClick: !disabled ? function (e) {
      return handleToggle(e, toggle);
    } : undefined
  }, /*#__PURE__*/React__default.createElement("span", {
    ref: labelTarget,
    className: "lemo-dropdown-selected-label",
    dangerouslySetInnerHTML: {
      __html: selectedIndex === -1 ? '&nbsp;' : itemList[selectedIndex]
    },
    style: {
      minWidth: minWidth,
      fontSize: fontSize
    }
  }), /*#__PURE__*/React__default.createElement(SvgChevronDown, {
    className: "lemo-dropdown-icon lemo-base-dropdown__icon"
  }));
}
var DropDownControl$1 = observer(DropDownControl);

function DropDownCustomContent(_ref) {
  var close = _ref.close,
    open = _ref.open,
    handleStatus = _ref.handleStatus,
    itemList = _ref.itemList,
    handleSelect = _ref.handleSelect,
    selectedIndex = _ref.selectedIndex;
  useEffect(function () {
    handleStatus(open);
  }, [open]);
  return !open ? null : /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-dropdown-content"
  }, itemList.map(function (child, idx) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: child + "_" + idx,
      className: cn$1('lemo-dropdown-content-item', 'lemo-base-dropdown__item', {
        'lemo-selected lemo-dropdown-control__item--selected': selectedIndex === idx
      }),
      onClick: function onClick() {
        return handleSelect(idx, close);
      }
    }, child);
  }));
}
var DropDownCustomContent$1 = observer(DropDownCustomContent);

function getTextFieldMetrics(content, target) {
  if (!document || !target) return 0;
  var node = target.cloneNode();
  node.innerText = content;
  document.body.appendChild(node);
  var width = node.offsetWidth;
  document.body.removeChild(node);
  return width;
}

function useDropDownApi(_ref) {
  var itemList = _ref.itemList,
    disabled = _ref.disabled,
    onSelect = _ref.onSelect,
    onOpen = _ref.onOpen;
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var _useState2 = useState(0),
    minWidth = _useState2[0],
    setMinWidth = _useState2[1];
  var labelTarget = useRef();
  useEffect(function () {
    setMinWidth(getTextFieldMetrics(itemList.reduce(function (acc, next) {
      return next.length > acc.length ? next : acc;
    }, ''), labelTarget.current) + 6);
  }, [itemList]);
  var handleToggle = useCallback(function (e, toggle) {
    toggle(e);
  }, []);
  var handleSelect = useCallback(function (idx, close) {
    if (!disabled) {
      onSelect(idx);
      close();
    }
  }, [disabled, onSelect]);
  var handleStatus = useCallback(function (bool) {
    setIsOpen(bool);
    onOpen === null || onOpen === void 0 ? void 0 : onOpen(bool);
  }, [onOpen]);
  return {
    isOpen: isOpen,
    minWidth: minWidth,
    labelTarget: labelTarget,
    handleToggle: handleToggle,
    handleSelect: handleSelect,
    handleStatus: handleStatus
  };
}

function DropDown(_ref) {
  var itemList = _ref.itemList,
    _ref$onSelect = _ref.onSelect,
    onSelect = _ref$onSelect === void 0 ? noop : _ref$onSelect,
    _ref$onOpen = _ref.onOpen,
    onOpen = _ref$onOpen === void 0 ? noop : _ref$onOpen,
    _ref$selectedIndex = _ref.selectedIndex,
    selectedIndex = _ref$selectedIndex === void 0 ? -1 : _ref$selectedIndex,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? '1em' : _ref$fontSize,
    _ref$isStyleFeedbackE = _ref.isStyleFeedbackError,
    isStyleFeedbackError = _ref$isStyleFeedbackE === void 0 ? false : _ref$isStyleFeedbackE,
    _ref$isStyleFeedbackS = _ref.isStyleFeedbackSuccess,
    isStyleFeedbackSuccess = _ref$isStyleFeedbackS === void 0 ? false : _ref$isStyleFeedbackS;
  var _useDropDownApi = useDropDownApi({
      itemList: itemList,
      disabled: disabled,
      onSelect: onSelect,
      onOpen: onOpen
    }),
    isOpen = _useDropDownApi.isOpen,
    minWidth = _useDropDownApi.minWidth,
    labelTarget = _useDropDownApi.labelTarget,
    handleToggle = _useDropDownApi.handleToggle,
    handleSelect = _useDropDownApi.handleSelect,
    handleStatus = _useDropDownApi.handleStatus;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-dropdown"
  }, /*#__PURE__*/React__default.createElement(Popover, null, /*#__PURE__*/React__default.createElement(Popover.Control, null, function (_ref2) {
    var toggle = _ref2.toggle;
    return /*#__PURE__*/React__default.createElement(DropDownControl$1, {
      toggle: toggle,
      disabled: disabled,
      isOpen: isOpen,
      isStyleFeedbackError: isStyleFeedbackError,
      handleToggle: handleToggle,
      isStyleFeedbackSuccess: isStyleFeedbackSuccess,
      labelTarget: labelTarget,
      selectedIndex: selectedIndex,
      itemList: itemList,
      minWidth: minWidth,
      fontSize: fontSize
    });
  }), /*#__PURE__*/React__default.createElement(Popover.Content, null, function (_ref3) {
    var close = _ref3.close,
      open = _ref3.open;
    return /*#__PURE__*/React__default.createElement(DropDownCustomContent$1, {
      close: close,
      open: open,
      handleStatus: handleStatus,
      itemList: itemList,
      handleSelect: handleSelect,
      selectedIndex: selectedIndex
    });
  })));
}
var DropDown$1 = observer(DropDown);

var EditorDropdownTitleSubtitle = function EditorDropdownTitleSubtitle(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    selectedIndex = _ref.selectedIndex,
    onChange = _ref.onChange,
    itemList = _ref.itemList,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return /*#__PURE__*/React__default.createElement(EditorTitleSubtitleComponent, {
    title: title,
    subtitle: subtitle,
    disabled: disabled,
    componentRight: /*#__PURE__*/React__default.createElement(DropDown$1, {
      onSelect: onChange,
      selectedIndex: selectedIndex,
      itemList: itemList,
      disabled: disabled
    })
  });
};
var EditorDropdownTitleSubtitle$1 = observer(EditorDropdownTitleSubtitle);

function ConfirmMessage(_ref) {
  var children = _ref.children,
    onConfirm = _ref.onConfirm,
    onCancel = _ref.onCancel;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-confirm-message"
  }, children, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-controls"
  }, /*#__PURE__*/React__default.createElement(SimpleButton, {
    className: "lemo-controls-button-cancel",
    onClick: onCancel,
    variant: variantsSimpleButton.secondary,
    title: translate('button_cancel')
  }, translate('button_cancel')), /*#__PURE__*/React__default.createElement(SimpleButton, {
    className: "lemo-controls-button-confirm",
    variant: variantsSimpleButton.primary,
    onClick: onConfirm
  }, translate('button_confirm'))));
}
var ConfirmMessage$1 = observer(ConfirmMessage);

function Modal(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-modal"
  }, /*#__PURE__*/React__default.createElement("section", {
    className: "lemo-modal-main"
  }, children));
}
var Modal$1 = observer(Modal);

function ModalConfirmMessage(_ref) {
  var title = _ref.title,
    message = _ref.message,
    onConfirm = _ref.onConfirm,
    onCancel = _ref.onCancel;
  return /*#__PURE__*/React__default.createElement(Modal$1, null, /*#__PURE__*/React__default.createElement(ConfirmMessage$1, {
    onConfirm: onConfirm,
    onCancel: onCancel
  }, /*#__PURE__*/React__default.createElement("div", null, title && /*#__PURE__*/React__default.createElement("h1", {
    className: "lemo-confirm-title"
  }, title), message && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-confirm-content",
    dangerouslySetInnerHTML: {
      __html: message
    }
  }))));
}
var ModalConfirmMessage$1 = observer(ModalConfirmMessage);

var GRID_TYPES = {
  S: {
    columns: 6,
    rows: 6
  },
  M: {
    columns: 10,
    rows: 10
  },
  L: {
    columns: 15,
    rows: 15
  }
};
var EditorWordSearch = function EditorWordSearch(_ref) {
  var columns = _ref.columns,
    rows = _ref.rows,
    getInvalidWordsByLength = _ref.getInvalidWordsByLength,
    onChange = _ref.onChange;
  var _useState = useState(Object.keys(GRID_TYPES).map(function (key) {
      return translate('word_search_grid_' + key.toLowerCase());
    })),
    itemList = _useState[0];
  var _useState2 = useState(getShowConfirmMessageDefault()),
    showConfirmMessage = _useState2[0],
    setShowConfirmMessage = _useState2[1];
  var selectedIndex = useMemo(function () {
    return Object.keys(GRID_TYPES).findIndex(function (key) {
      return GRID_TYPES[key].columns === columns && GRID_TYPES[key].rows === rows;
    });
  }, [columns, rows]);
  function onChangeConfirmOk(columns, rows) {
    onChange && onChange(columns, rows);
  }
  function _onChange(index) {
    if (GRID_TYPES && index >= 0) {
      var valueChange = GRID_TYPES[Object.keys(GRID_TYPES)[index]];
      var invalidWords = getInvalidWordsByLength(valueChange.columns, valueChange.rows);
      if (invalidWords.length <= 0) {
        onChangeConfirmOk(valueChange.columns, valueChange.rows);
      } else {
        setShowConfirmMessage({
          isVisible: true,
          invalidWords: invalidWords,
          columns: valueChange.columns,
          rows: valueChange.rows
        });
      }
    }
  }
  function getShowConfirmMessageDefault() {
    return {
      isVisible: false,
      invalidWords: [],
      columns: undefined,
      rows: undefined
    };
  }
  function onConfirm() {
    onChangeConfirmOk(showConfirmMessage.columns, showConfirmMessage.rows);
    setShowConfirmMessage(getShowConfirmMessageDefault());
  }
  function onCancel() {
    setShowConfirmMessage(getShowConfirmMessageDefault());
  }
  function getInvalidWordsMessage() {
    var message = '';
    for (var index = 0; index < showConfirmMessage.invalidWords.length; index++) {
      var word = showConfirmMessage.invalidWords[index];
      message += '\n' + word.value;
    }
    return message;
  }
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "word-search",
    icon: /*#__PURE__*/React__default.createElement(SvgMenuAlt, {
      width: "24"
    }),
    titleBox: translate('word_search_title_box'),
    helpText: translate('word_search_help'),
    classNameAdd: 'lemo-editor-word-search'
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-stack-layout-150"
  }, /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('word_search_title'),
    subtitle: translate('word_search_subtitle'),
    selectedIndex: selectedIndex,
    onChange: _onChange,
    itemList: itemList
  }))), showConfirmMessage && showConfirmMessage.isVisible && /*#__PURE__*/React__default.createElement(ModalConfirmMessage$1, {
    onConfirm: onConfirm,
    onCancel: onCancel,
    title: translate('confirm_switching_columns_rows_title'),
    message: translate('confirm_switching_columns_rows_message') + ' \n' + getInvalidWordsMessage()
  }));
};
EditorWordSearch.propTypes = {
  getInvalidWordsByLength: propTypes.func
};
EditorWordSearch.defaultProps = {
  title: '',
  onTitleChange: function onTitleChange(text) {
    return console.log(text);
  }
};

var onSetScoringType = function onSetScoringType(_ref) {
  var name = _ref.name,
    args = _ref.args,
    sendLog = _ref.sendLog;
  if (name !== ACTION.SET_EVALUATION_TYPE) return false;
  var check = function check(val) {
    return args[0] === val;
  };
  if (check(validationModes.EXACT_MATCH)) return sendLog(EVENT.MATCH_EXACT);
  if (check(validationModes.PARTIAL_MATCH_V2)) return sendLog(EVENT.MATCH_PARTIAL);
  if (check(validationModes.MANUAL)) return sendLog(EVENT.MANUAL);
};
var onSetPenalty = function onSetPenalty(_ref2) {
  var name = _ref2.name,
    args = _ref2.args,
    sendLog = _ref2.sendLog;
  if (name !== ACTION.SET_PENALTY_MODE) return false;
  var check = function check(val) {
    return args[0] === val;
  };
  if (check(penaltyModes.PER_RESPONSE)) return sendLog(EVENT.PENALIZE_RESPONSE_SCORE);
  if (check(penaltyModes.CUSTOM)) return sendLog(EVENT.PENALIZE_CUSTOM);
  if (check(penaltyModes.NONE)) return sendLog(EVENT.PENALIZE_NONE);
};
var onUseLemonadeKeyboard = function onUseLemonadeKeyboard(_ref3) {
  var name = _ref3.name,
    args = _ref3.args,
    sendLog = _ref3.sendLog;
  if (name !== ACTION.SET_KEYBOARD_TYPE) return false;
  var check = function check(val) {
    return args[0] === val;
  };
  if (check(keyboardTypes.NUMERICAL)) return sendLog(EVENT.KEYBOARD_NUMERIC);
  if (check(keyboardTypes.BASIC)) return sendLog(EVENT.KEYBOARD_BASIC);
};
var onClickToFindFeedbackMode = function onClickToFindFeedbackMode(_ref4) {
  var template = _ref4.template,
    name = _ref4.name,
    args = _ref4.args,
    sendLog = _ref4.sendLog;
  if (template !== normalizedTypes.other_click_to_find.className) return false;
  if (name !== ACTION.SET_FEEDBACK_MODE) return false;
  var check = function check(val) {
    return args[0] === val;
  };
  var FEEDBACK_WITH_BORDER = feedbackModeTypes.FEEDBACK_WITH_BORDER,
    FEEDBACK_WITH_TICK = feedbackModeTypes.FEEDBACK_WITH_TICK,
    NONE = feedbackModeTypes.NONE;
  if (check(NONE)) return sendLog(EVENT.FEEDBACK_NONE);
  if (check(FEEDBACK_WITH_BORDER)) return sendLog(EVENT.FEEDBACK_BORDER);
  if (check(FEEDBACK_WITH_TICK)) return sendLog(EVENT.FEEDBACK_TICK);
};
var onColumnDirection = function onColumnDirection(_ref5) {
  var name = _ref5.name,
    args = _ref5.args,
    sendLog = _ref5.sendLog;
  if (name !== ACTION.SET_COLUMN_DIRECTION) return false;
  var check = function check(val) {
    return args[0] === val;
  };
  if (check(COLUMNS_DIRECTIONS_TYPES.VERTICAL)) return sendLog(EVENT.COLUMN_VERTICAL);
  if (check(COLUMNS_DIRECTIONS_TYPES.HORIZONTAL)) return sendLog(EVENT.COLUMN_HORIZONTAL);
};
var onClozeMathEvaluationMode = function onClozeMathEvaluationMode(_ref6) {
  var name = _ref6.name,
    args = _ref6.args,
    sendLog = _ref6.sendLog;
  if (name !== ACTION.SET_METHOD_INDEX) return false;
  var check = function check(val) {
    return Object.values(exactOrEquivalentTypes)[args[0]] === val;
  };
  if (check(exactOrEquivalentTypes.EQUIVALENT)) return sendLog(EVENT.RESULT_EQUIVALENT);
  if (check(exactOrEquivalentTypes.EXACT)) return sendLog(EVENT.RESULT_EXACT);
};
var onWordSearchChangeGridSize = function onWordSearchChangeGridSize(_ref7) {
  var name = _ref7.name,
    args = _ref7.args,
    sendLog = _ref7.sendLog;
  if (name !== ACTION.INTENT_SET_COLUMNS_ROWS) return false;
  var numColumns = args[0];
  var check = function check(val) {
    return numColumns === val;
  };
  if (check(GRID_TYPES.S.columns)) return sendLog(EVENT.WORDSEARCH_GRID_S);
  if (check(GRID_TYPES.M.columns)) return sendLog(EVENT.WORDSEARCH_GRID_M);
  if (check(GRID_TYPES.L.columns)) return sendLog(EVENT.WORDSEARCH_GRID_L);
};

function useEditorMetrics(template, store) {
  var context = contextTypes.EDITOR;
  var sendLog = getSendLog({
    template: template,
    context: context
  });
  useEffect(function () {
    initAmplitude(function () {
      sendLog(EVENT.START);
    });
    var onActionTracker = onAction(store, function (_ref) {
      var args = _ref.args,
        name = _ref.name;
      var onCallAction = getOnCallAction(name, sendLog);
      onSetPenalty({
        name: name,
        args: args,
        sendLog: sendLog
      });
      onSetScoringType({
        name: name,
        args: args,
        sendLog: sendLog
      });
      onUseLemonadeKeyboard({
        name: name,
        args: args,
        sendLog: sendLog
      });
      onClickToFindFeedbackMode({
        template: template,
        name: name,
        args: args,
        sendLog: sendLog
      });
      onColumnDirection({
        name: name,
        args: args,
        sendLog: sendLog
      });
      onClozeMathEvaluationMode({
        name: name,
        args: args,
        sendLog: sendLog
      });
      onWordSearchChangeGridSize({
        name: name,
        args: args,
        sendLog: sendLog
      });
      onCallAction(ACTION.CREATE_ALTERNATIVE_SOLUTION, EVENT.SOLUTION_ALTERNATIVE);
      onCallAction(ACTION.SET_DUPLICATE_RESPONSES, EVENT.RESPONSES_DUPLICATE);
      onCallAction(ACTION.SET_GLOBAL_FEEDBACK, EVENT.FEEDBACK_GENERAL);
      onCallAction(ACTION.SET_SPECIFIC_FEEDBACK, EVENT.FEEDBACK_SPECIFIC);
      onCallAction(ACTION.SET_SAMPLE_ANSWER, EVENT.SOLUTION_REFERENCE);
      onCallAction(ACTION.SET_BACKGROUND, EVENT.BACKGROUND);
      onCallAction(ACTION.SET_SHUFFLE_OPTIONS, EVENT.SHUFFLE);
      onCallAction(ACTION.SET_SHOW_CHECK_ICON, EVENT.CHECK_ICON);
      onCallAction(ACTION.ADD_GROUPED_SOLUTION_AT, EVENT.RESPONSES_MULTIPLE);
      onCallAction(ACTION.TOGGLE_ACCENTS, EVENT.SENSITIVE_ACCENT);
      onCallAction(ACTION.TOGGLE_LOWER, EVENT.SENSITIVE_CASE);
      onCallAction(ACTION.TOGGLE_SPACES, EVENT.SENSITIVE_SPACES);
      onCallAction(ACTION.SET_PERCENT, EVENT.BACKGROUND_SIZE);
      onCallAction(ACTION.SET_LINE_THICKNESS, EVENT.LINES_THICKNESS);
      onCallAction(ACTION.SET_STACK, EVENT.OPTIONS_STACK);
      onCallAction(ACTION.SET_WITH_BOX, EVENT.OPTIONS_FRAME);
      onCallAction(ACTION.SET_WORDS_LIMIT, EVENT.COUNTER_WORD);
      onCallAction(ACTION.SET_MAX_FILES, EVENT.FILES_NUMBER);
      onCallAction(ACTION.SET_DECIMAL_PLACES, EVENT.RESULT_DECIMALS);
      onCallAction(ACTION.UPDATE_WORD_SEARCH, EVENT.WORDSEARCH_GENERATE);
      onCallAction(ACTION.SET_BACKWARD, EVENT.WORDSEARCH_INVERTED);
    });
    var reactionTracker = reaction(function () {
      var _store$ui_style$custo;
      return (_store$ui_style$custo = store.ui_style.customClass) === null || _store$ui_style$custo === void 0 ? void 0 : _store$ui_style$custo.hasValue;
    }, function (val) {
      return val && sendLog(EVENT.VARIANT_CUSTOM);
    });
    return function () {
      onActionTracker();
      reactionTracker();
      sendLog(EVENT.LEAVE);
    };
  }, []);
}

var EditorClearAllDefault = function EditorClearAllDefault(_ref) {
  var onClickClearAll = _ref.onClickClearAll;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-clear-all-default"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-clear-all-default__left"
  }, /*#__PURE__*/React__default.createElement(ButtonInline, {
    icon: /*#__PURE__*/React__default.createElement(SvgPlusCircle, {
      className: "lemo-icon lemo-editor-answer-options__icon-plus"
    }),
    text: translate('clear_all_button'),
    color: colorsButton.red,
    onClick: onClickClearAll
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-clear-all-default__left-description"
  }, translate('clear_all_description'))), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-clear-all-default__right"
  }, /*#__PURE__*/React__default.createElement(SvgExclamation, {
    className: "lemo-icon",
    width: 24,
    height: 24
  })));
};
EditorClearAllDefault.propTypes = {};
EditorClearAllDefault.defaultProps = {};
var EditorClearAllDefault$1 = observer(EditorClearAllDefault);

var EditorClearAllConfirm = function EditorClearAllConfirm(_ref) {
  var onClickConfirm = _ref.onClickConfirm,
    onClickCancel = _ref.onClickCancel;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-clear-all-confirm"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-clear-all-confirm__left"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-clear-all-confirm__left-title"
  }, translate('clear_all_confirmation_title')), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-clear-all-confirm__left-description"
  }, translate('clear_all_confirmation_description'))), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-clear-all-confirm__right"
  }, /*#__PURE__*/React__default.createElement(SimpleButton, {
    onClick: onClickCancel,
    title: translate('clear_all_confirmation_cancel_button'),
    variant: variantsSimpleButton.secondary
  }, translate('clear_all_confirmation_cancel_button')), /*#__PURE__*/React__default.createElement(SimpleButton, {
    onClick: onClickConfirm,
    title: translate('clear_all_confirmation_confirm_button'),
    variant: variantsSimpleButton.primary
  }, translate('clear_all_confirmation_confirm_button'))));
};
EditorClearAllConfirm.propTypes = {};
EditorClearAllConfirm.defaultProps = {};
var EditorClearAllConfirm$1 = observer(EditorClearAllConfirm);

var EditorClearAll = function EditorClearAll(_ref) {
  var onClearAll = _ref.onClearAll;
  var _useState = useState(false),
    showConfirm = _useState[0],
    setShowConfirm = _useState[1];
  var _useState2 = useState(null),
    timer = _useState2[0],
    setTimer = _useState2[1];
  useEffect(function () {
    return function () {
      return clearTimeout(timer);
    };
  }, [timer]);
  function onClickClearAll() {
    setShowConfirm(true);
    setTimer(setTimeout(function () {
      setShowConfirm(false);
    }, 5000));
  }
  function onClickConfirm() {
    setShowConfirm(false);
    onClearAll();
    clearTimeout(timer);
  }
  function onClickCancel() {
    setShowConfirm(false);
    clearTimeout(timer);
  }
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "clear-all",
    classNameAdd: "lemo-editor-clear-all",
    hideContentTop: true
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-clear-all__content"
  }, !showConfirm ? /*#__PURE__*/React__default.createElement(EditorClearAllDefault$1, {
    onClickClearAll: onClickClearAll
  }) : /*#__PURE__*/React__default.createElement(EditorClearAllConfirm$1, {
    onClickConfirm: onClickConfirm,
    onClickCancel: onClickCancel
  }))));
};
EditorClearAll.propTypes = {};
EditorClearAll.defaultProps = {};
var EditorClearAll$1 = observer(EditorClearAll);

var EditorClearAllSt = function EditorClearAllSt(_ref) {
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(EditorClearAll$1, {
    onClearAll: store.clearAll
  });
};
EditorClearAllSt.propTypes = {};
var EditorClearAllSt$1 = observer(EditorClearAllSt);

var _excluded$2 = ["store", "changed", "patternParticular", "changedHandlerDebugger", "children", "infoComponentsCommon", "immediateFeedback", "onlyComponentsView"];
var _ref, _extends2;
var EDITOR_COMPONENT_COMMON = {
  TITLE: 'TITLE',
  STIMULUS: 'STIMULUS',
  BACKGROUND: 'BACKGROUND',
  FEEDBACK: 'FEEDBACK',
  HINTS: 'HINTS',
  CLEAR_ALL: 'CLEAR_ALL'
};
var MIN_ORDER = -1000000;
var POS_BEGIN = -1000;
var POS_END = 1000;
var MAX_ORDER = 1000000;
var INFO_COMPONENTS_COMMON_DEFAULT = _extends({}, config.configEditor[editorComponents.title] && config.configEditor[editorComponents.title].isVisible && (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.TITLE] = {
  order: POS_BEGIN - 1
}, _ref), (_extends2 = {}, _extends2[EDITOR_COMPONENT_COMMON.STIMULUS] = {
  order: POS_BEGIN
}, _extends2[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
  order: POS_END
}, _extends2[EDITOR_COMPONENT_COMMON.HINTS] = {
  order: POS_END + 100,
  hide: !(config.configEditor[editorComponents.hints] && config.configEditor[editorComponents.hints].isVisible)
}, _extends2[EDITOR_COMPONENT_COMMON.BACKGROUND] = {
  order: POS_END + 200
}, _extends2[EDITOR_COMPONENT_COMMON.CLEAR_ALL] = {
  order: getClearAllOrder(),
  hide: true
}, _extends2));
function getClearAllOrder() {
  var _config$configEditor$;
  return (_config$configEditor$ = config.configEditor[editorComponents.clearAll]) !== null && _config$configEditor$ !== void 0 && _config$configEditor$.isTopPosition ? MIN_ORDER : MAX_ORDER;
}
var BaseEditor = function BaseEditor(props) {
  var _config$configEditor$2;
  var store = props.store,
    changed = props.changed,
    patternParticular = props.patternParticular,
    _props$changedHandler = props.changedHandlerDebugger,
    changedHandlerDebugger = _props$changedHandler === void 0 ? false : _props$changedHandler,
    children = props.children,
    infoComponentsCommon = props.infoComponentsCommon,
    immediateFeedback = props.immediateFeedback,
    onlyComponentsView = props.onlyComponentsView,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$2);
  var onActionPerformed = otherProps.onActionPerformed;
  var rootNode = useRef(null);
  var _useGetTemplateClass = useGetTemplateClass(store),
    templateClass = _useGetTemplateClass.templateClass,
    subTemplateId = _useGetTemplateClass.subTemplateId;
  useChangedCallback(changed, new RegExp('setTemplate|addResponse|setResponses|setFeedback|setBackground|removeResponse|setValue|setStimulus|setSolution|setVariant|setClassList|setErrorString|setTitle|resetHints|addHint|onUpdateHint|setEvaluationType|setPenalty|setKeyboard' + (hasData(patternParticular) ? '|' + patternParticular : '')), store, changedHandlerDebugger, true);
  useMathLive();
  useDefaultProp({
    setter: store.validation && store.validation.setImmediateFeedback ? store.validation.setImmediateFeedback : null,
    value: immediateFeedback
  });
  useEditorMetrics(subTemplateId || templateClass, store);
  var _useState = useState(INFO_COMPONENTS_COMMON_DEFAULT),
    infoComponentsCommonDefault = _useState[0],
    setInfoComponentsCommonDefault = _useState[1];
  var _useState2 = useState(infoComponentsCommon),
    internalInfoComponentsCommon = _useState2[0],
    setInternalInfoComponentsCommon = _useState2[1];
  useEffect(function () {
    var clearAllOrder = getClearAllOrder();
    setInfoComponentsCommonDefault(function (oldState) {
      if (oldState[EDITOR_COMPONENT_COMMON.CLEAR_ALL]) {
        var _extends3;
        return _extends({}, oldState, (_extends3 = {}, _extends3[EDITOR_COMPONENT_COMMON.CLEAR_ALL] = _extends({}, oldState[EDITOR_COMPONENT_COMMON.CLEAR_ALL], {
          order: clearAllOrder
        }), _extends3));
      } else {
        return _extends({}, oldState);
      }
    });
    setInternalInfoComponentsCommon(function (oldState) {
      if (oldState[EDITOR_COMPONENT_COMMON.CLEAR_ALL]) {
        var _extends4;
        return _extends({}, oldState, (_extends4 = {}, _extends4[EDITOR_COMPONENT_COMMON.CLEAR_ALL] = _extends({}, oldState[EDITOR_COMPONENT_COMMON.CLEAR_ALL], {
          order: clearAllOrder
        }), _extends4));
      } else {
        return _extends({}, oldState);
      }
    });
  }, [(_config$configEditor$2 = config.configEditor[editorComponents.clearAll]) === null || _config$configEditor$2 === void 0 ? void 0 : _config$configEditor$2.isTopPosition]);
  useEffect(function () {
    var clearAllOrder = getClearAllOrder();
    setInternalInfoComponentsCommon(function (oldState) {
      if (oldState[EDITOR_COMPONENT_COMMON.CLEAR_ALL]) {
        var _extends5;
        return _extends({}, infoComponentsCommon, (_extends5 = {}, _extends5[EDITOR_COMPONENT_COMMON.CLEAR_ALL] = _extends({}, oldState[EDITOR_COMPONENT_COMMON.CLEAR_ALL], {
          order: clearAllOrder
        }), _extends5));
      } else {
        return _extends({}, infoComponentsCommon);
      }
    });
  }, [infoComponentsCommon]);
  var infoComponentsCommonFinal = _extends({}, infoComponentsCommonDefault, internalInfoComponentsCommon);
  var infoComponentsCommonOrder = Object.keys(infoComponentsCommonFinal).map(function (key) {
    return {
      key: key,
      value: _extends({
        order: 0
      }, infoComponentsCommonFinal[key])
    };
  }).filter(function (component) {
    if (onlyComponentsView !== undefined) {
      return onlyComponentsView.includes(component.key);
    }
    return true;
  }).sort(function (a, b) {
    return a.value.order - b.value.order;
  });
  var editorComponentsBegin = infoComponentsCommonOrder.map(function (e) {
    return e.value.order < 0 ? getComponent(e.key, e.value) : null;
  });
  var componentByOrderZero = children && children.length === undefined ? getComponentByOrder(0) : null;
  var editorComponents$1 = children ? children.length !== undefined ? children.map(function (child, index) {
    var componentByOrder = getComponentByOrder(index);
    return [child, componentByOrder && getComponent(componentByOrder.key, componentByOrder.value)];
  }) : [children, componentByOrderZero && getComponent(componentByOrderZero.key, componentByOrderZero.value)] : null;
  var editorComponentsEnd = infoComponentsCommonOrder.map(function (e) {
    return children && (children.length !== undefined ? e.value.order >= children.length : e.value.order >= 1) ? getComponent(e.key, e.value) : null;
  });
  function getComponent(key, value) {
    if (value === void 0) {
      value = null;
    }
    var toRet = value.hasOwnProperty('order') && value.order !== undefined && !value.hide ? key === EDITOR_COMPONENT_COMMON.STIMULUS ? /*#__PURE__*/React__default.createElement(EditorStimulusStore$1, {
      store: store,
      key: key
    }) : key === EDITOR_COMPONENT_COMMON.FEEDBACK ? /*#__PURE__*/React__default.createElement(EditorFeedbackExerciseStore$1, {
      store: store,
      key: key,
      haveFeedbackIndividual: value.haveFeedbackIndividual || false,
      showConfigFeedbacksIndividual: value.showConfigFeedbacksIndividual || false,
      onChangeCheckedFeedbackIndividual: value.onChangeCheckedFeedbackIndividual || null,
      feedbackIndividualLabelText: value.feedbackIndividualLabelText || null,
      onActionPerformed: onActionPerformed
    }) : key === EDITOR_COMPONENT_COMMON.BACKGROUND ? /*#__PURE__*/React__default.createElement(EditorBackgroundStore$1, {
      store: store,
      key: key
    }) : key === EDITOR_COMPONENT_COMMON.TITLE ? /*#__PURE__*/React__default.createElement(EditorTitleStore$1, {
      store: store,
      key: key,
      titleBox: translate('title_title_box')
    }) : key === EDITOR_COMPONENT_COMMON.HINTS ? /*#__PURE__*/React__default.createElement(EditorHintsStore$1, {
      store: store,
      key: key
    }) : key === EDITOR_COMPONENT_COMMON.CLEAR_ALL ? /*#__PURE__*/React__default.createElement(EditorClearAllSt$1, {
      store: store,
      key: key
    }) : null : null;
    return toRet;
  }
  function getComponentByOrder(order) {
    return infoComponentsCommonOrder.find(function (e) {
      return e.value.order === order;
    });
  }
  return /*#__PURE__*/React__default.createElement(Editor, {
    className: "lemo-editor " + templateClass,
    reference: rootNode,
    lang: config.lang
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-fr-scrollable-container",
    id: FROALA_ID_SCROLLABLE_CONTAINER
  }), editorComponentsBegin, editorComponents$1, editorComponentsEnd);
};
BaseEditor.propTypes = {
  patternParticular: propTypes.string,
  infoComponentsCommon: propTypes.object,
  changedHandlerDebugger: propTypes.bool,
  onlyComponentsView: propTypes.arrayOf(propTypes.string)
};
BaseEditor.defaultProps = {
  patternParticular: '',
  infoComponentsCommon: {},
  debugChangedCallback: false,
  onlyComponentsView: undefined
};
var BaseEditor$1 = observer(BaseEditor);

var EditorSortingList = function EditorSortingList(_ref) {
  var _ref$list = _ref.list,
    list = _ref$list === void 0 ? [] : _ref$list,
    keyId = _ref.keyId,
    onDragEnd = _ref.onDragEnd,
    children = _ref.children;
  var handleDragEnd = useCallback(function (value) {
    var source = value.source;
    var destination = value.destination;
    source && destination && onDragEnd(source.index, destination.index);
  }, [onDragEnd]);
  return list && list.length > 0 ? /*#__PURE__*/React__default.createElement(DragDropContext, {
    onDragEnd: handleDragEnd
  }, /*#__PURE__*/React__default.createElement(Droppable, {
    droppableId: "source",
    direction: "vertical"
  }, function (dropProvider) {
    return /*#__PURE__*/React__default.createElement("div", _extends({
      ref: dropProvider.innerRef
    }, dropProvider.droppableProps), list.map(function (itemList, index) {
      return /*#__PURE__*/React__default.createElement(Draggable, {
        key: itemList[keyId] + "_" + index,
        draggableId: itemList[keyId],
        index: index
      }, function (dragProvider) {
        return children(itemList, dragProvider, index);
      });
    }), dropProvider.placeholder);
  })) : null;
};
var EditorSortingList$1 = observer(EditorSortingList);

var PopoverOptions = function PopoverOptions(_ref) {
  var children = _ref.children,
    placement = _ref.placement,
    itemList = _ref.itemList,
    selectedIndex = _ref.selectedIndex,
    disabled = _ref.disabled,
    ifClickClose = _ref.ifClickClose;
  var handleSelect = function handleSelect(child, idx, close) {
    child.onClick && child.onClick(close);
    if (ifClickClose) close();
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-popover-options"
  }, /*#__PURE__*/React__default.createElement(Popover, null, /*#__PURE__*/React__default.createElement(Popover.Control, null, function (_ref2) {
    var toggle = _ref2.toggle;
    return /*#__PURE__*/React__default.createElement("div", {
      onClick: !disabled ? toggle : undefined
    }, children);
  }), /*#__PURE__*/React__default.createElement(Popover.Content, null, function (_ref3) {
    var close = _ref3.close,
      open = _ref3.open;
    return !open ? null : /*#__PURE__*/React__default.createElement("div", {
      className: 'lemo-popover-options__content ' + (placement ? 'lemo-popover-options__content--' + placement : '')
    }, itemList.map(function (child, idx) {
      return /*#__PURE__*/React__default.createElement("div", {
        key: child.name,
        className: 'lemo-popover-options__content-item' + (selectedIndex === idx ? ' selected' : ''),
        onClick: function onClick() {
          return handleSelect(child, idx, close);
        }
      }, child.icon && /*#__PURE__*/React__default.createElement("div", {
        className: "lemo-popover-options__content-icon"
      }, child.icon), /*#__PURE__*/React__default.createElement("div", {
        className: "lemo-popover-options__content-name"
      }, child.name));
    }));
  })));
};
PopoverOptions.propTypes = {
  children: propTypes.node,
  placement: propTypes.oneOf(['left']),
  itemList: propTypes.array,
  selectedIndex: propTypes.number,
  ifClickClose: propTypes.bool
};
PopoverOptions.defaultProps = {
  selectedIndex: -1,
  ifClickClose: true,
  placement: 'left',
  disabled: false
};

var NumberOption = function NumberOption(_ref) {
  var number = _ref.number;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-number-option lemo-blank-cloze-math lemo-add-response-close-math blank fr-draggable fr-embedly fr-deletable"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-number-option__number lemo-add-response-close-math__number"
  }, number)));
};

var WrapperInputFeedback = function WrapperInputFeedback(_ref) {
  var feedback = _ref.feedback,
    onChangeFeedback = _ref.onChangeFeedback,
    children = _ref.children,
    showFeedback = _ref.showFeedback,
    onChangeShowFieldFeedback = _ref.onChangeShowFieldFeedback,
    componentValueRightBegin = _ref.componentValueRightBegin,
    componentValueRightEnd = _ref.componentValueRightEnd,
    assetsFroalaApi = _ref.assetsFroalaApi;
  var _useState = useState(feedback),
    localFeedback = _useState[0];
  var _useState2 = useState(hasData(feedback)),
    showFieldFeedback = _useState2[0],
    setShowFieldFeedback = _useState2[1];
  function onClickIconFeedback() {
    setShowFieldFeedback(!showFieldFeedback);
    onChangeShowFieldFeedback(!showFieldFeedback);
    onChangeFeedback('');
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-box-list-item-content"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-box-list-item-content__value-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-box-list-item-content__value"
  }, children), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-box-list-item-content__value-right"
  }, componentValueRightBegin, showFeedback && /*#__PURE__*/React__default.createElement("div", {
    onClick: onClickIconFeedback
  }, !showFieldFeedback && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-feedback-controls lemo-add"
  }, /*#__PURE__*/React__default.createElement(TooltipIcon, {
    text: translate('individual_feedback_exercise_tooltip'),
    icon: /*#__PURE__*/React__default.createElement(SvgSpeakerNotes, {
      className: "lemo-icon"
    })
  }))), componentValueRightEnd)), showFeedback && showFieldFeedback && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-box-list-item-content__feedback"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-box-list-item-content__feedback-froala"
  }, /*#__PURE__*/React__default.createElement(FroalaField$1, {
    editMode: true,
    content: localFeedback,
    setContent: onChangeFeedback,
    placeholder: translate('individual_feedback_exercise_placeholder'),
    assetsFroalaApi: assetsFroalaApi
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-feedback-controls lemo-remove",
    onClick: onClickIconFeedback
  }, /*#__PURE__*/React__default.createElement(SvgTrash$1, {
    className: "lemo-icon"
  }))));
};
WrapperInputFeedback.propTypes = {
  showFeedback: propTypes.bool,
  componentValueRightBegin: propTypes.node,
  componentValueRightEnd: propTypes.node,
  assetsFroalaApi: propTypes.string
};
WrapperInputFeedback.defaultProps = {
  showFeedback: true
};

function UploadFileWrapper(_ref) {
  var children = _ref.children,
    maxFileSize = _ref.maxFileSize,
    acceptedFiles = _ref.acceptedFiles,
    disabled = _ref.disabled,
    onSelectFile = _ref.onSelectFile,
    onError = _ref.onError;
  var id = useRef("lemo-file-upload-input_" + uuid());
  function handleChange(event) {
    var file = event.target.files[0];
    if (checkSize(file)) return onError({
      type: 'maxFileSize',
      file: file
    });
    onSelectFile(file);
  }
  function checkSize(file) {
    return maxFileSize && file.size > maxFileSize;
  }
  return /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id.current,
    className: "lemo-custom-file-upload"
  }, children, /*#__PURE__*/React__default.createElement("input", {
    id: id.current,
    type: "file",
    accept: acceptedFiles,
    onChange: handleChange,
    style: {
      display: 'none'
    },
    disabled: disabled
  }));
}

function useUploadFile(_ref) {
  var onError = _ref.onError,
    onSuccess = _ref.onSuccess,
    assetsApi = _ref.assetsApi;
  var _useState = useState(fileStatuses.START),
    uploadStatus = _useState[0],
    setUploadStatus = _useState[1];
  function handleUpload(file) {
    return sendFileWithName({
      file: file,
      fileName: file.name,
      onChangeStatus: function onChangeStatus(file, status) {
        return setUploadStatus(status);
      },
      onSuccess: onSuccess,
      onError: onError,
      assetsApi: assetsApi
    });
  }
  return {
    uploadStatus: uploadStatus,
    handleUpload: handleUpload
  };
}

function AddImageButton(_ref) {
  var altDescription = _ref.altDescription,
    id = _ref.id,
    _ref$src = _ref.src,
    src = _ref$src === void 0 ? '' : _ref$src,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick;
  var activeClass = src.length > 0 ? 'lemo-is-active' : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'lemo-add-image-button ' + activeClass,
    onClick: onClick
  }, !isLoading ? /*#__PURE__*/React__default.createElement(SvgPhotograph, {
    className: "lemo-icon",
    "data-tooltip-content": altDescription,
    "data-tooltip-id": id
  }) : /*#__PURE__*/React__default.createElement(SvgRefresh, {
    className: "lemo-icon"
  }), /*#__PURE__*/React__default.createElement(Tooltip$1, {
    effect: "solid",
    place: "top",
    delayShow: 500,
    id: id,
    multiline: true
  }));
}
var AddImageButton$1 = observer(AddImageButton);

function OptionalImagePicker(_ref) {
  var id = _ref.id,
    imageApiKey = _ref.imageApiKey,
    addImage = _ref.addImage,
    removeImage = _ref.removeImage,
    altDescription = _ref.altDescription,
    disabled = _ref.disabled,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value;
  var _useUploadFile = useUploadFile({
      onError: onError,
      onSuccess: onSuccess,
      assetsApi: imageApiKey
    }),
    uploadStatus = _useUploadFile.uploadStatus,
    handleUpload = _useUploadFile.handleUpload;
  function onError(_ref2) {
    var type = _ref2.type;
    console.log('error type', type);
  }
  function onSuccess(_ref3) {
    var source = _ref3.source;
    addImage(source);
  }
  function isDisabled(status) {
    return status === fileStatuses.UPLOADING || status === fileStatuses.FILE_LIMIT;
  }
  function onClickAddImage(e) {
    if (removeImage && value.length > 0) {
      e.preventDefault();
      e.stopPropagation();
      removeImage();
    }
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-optional-image-picker', {
      'lemo-with-image': value.length > 0
    })
  }, /*#__PURE__*/React__default.createElement(UploadFileWrapper, {
    acceptedFiles: "image/*",
    maxFileSize: "1000000",
    onSelectFile: handleUpload,
    onError: onError,
    disabled: disabled || isDisabled(uploadStatus)
  }, /*#__PURE__*/React__default.createElement(AddImageButton$1, {
    id: id,
    altDescription: altDescription,
    src: value,
    isLoading: uploadStatus === fileStatuses.UPLOADING,
    onClick: onClickAddImage
  })), removeImage && /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-remove-image-button",
    role: "button",
    onClick: removeImage
  }, /*#__PURE__*/React__default.createElement(SvgXBold, {
    className: "lemo-icon"
  })));
}
var OptionalImagePicker$1 = observer(OptionalImagePicker);

var SimpleListValue = function SimpleListValue(_ref) {
  var item = _ref.item,
    dragProvider = _ref.dragProvider,
    modelSet = _ref.modelSet,
    modelGet = _ref.modelGet,
    showFeedback = _ref.showFeedback,
    _ref$showNumberDuplic = _ref.showNumberDuplicates,
    showNumberDuplicates = _ref$showNumberDuplic === void 0 ? false : _ref$showNumberDuplic,
    onChangeNumberDuplicates = _ref.onChangeNumberDuplicates,
    modelSetFeedback = _ref.modelSetFeedback,
    modelGetFeedback = _ref.modelGetFeedback,
    onDeleteItem = _ref.onDeleteItem,
    imageDefaultWidth = _ref.imageDefaultWidth,
    imageDefaultHeight = _ref.imageDefaultHeight,
    assetsFroalaApi = _ref.assetsFroalaApi,
    _ref$numberOption = _ref.numberOption,
    numberOption = _ref$numberOption === void 0 ? null : _ref$numberOption,
    _ref$imagePickerProps = _ref.imagePickerProps,
    imagePickerProps = _ref$imagePickerProps === void 0 ? null : _ref$imagePickerProps,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder;
  var draggableProps = dragProvider.draggableProps,
    dragHandleProps = dragProvider.dragHandleProps,
    innerRef = dragProvider.innerRef;
  var _useState = useState(modelGet ? item[modelGet] : item.value),
    local = _useState[0],
    setLocal = _useState[1];
  var _useState2 = useState(showFeedback && hasData(getFeedbackItem())),
    showFieldFeedback = _useState2[0],
    setShowFieldFeedback = _useState2[1];
  var updateStore = useMemo(function () {
    return modelSet ? item[modelSet] : item.setValue;
  }, [modelSet, item]);
  var updateStoreFeedback = useMemo(function () {
    return modelSetFeedback ? item[modelSetFeedback] : item.setFeedback;
  }, [modelSetFeedback, item]);
  var updateState = useCallback(function (value) {
    setLocal(value);
    updateStore(value);
  }, [updateStore, setLocal]);
  var updateStateFeedback = useCallback(function (value) {
    updateStoreFeedback(value);
  }, [updateStoreFeedback]);
  var onChangeShowFieldFeedback = useCallback(function (value) {
    setShowFieldFeedback(value);
  }, [setShowFieldFeedback]);
  function getFeedbackItem() {
    return modelGetFeedback ? item[modelGetFeedback] : item.feedback;
  }
  function trashComponent() {
    return /*#__PURE__*/React__default.createElement("button", {
      className: "lemo-editor-box-list-item__delete",
      onClick: onDeleteItem || item.destroy
    }, /*#__PURE__*/React__default.createElement(SvgTrash$1, {
      className: "lemo-icon",
      width: 24,
      height: 24
    }));
  }
  function NumberDuplicatesComponent() {
    var onChangeNumber = function onChangeNumber(_ref2) {
      var target = _ref2.target;
      var min = 1;
      var max = 99;
      var _final;
      if (target && target.value && target.value.indexOf('0') === 0) {
        _final = min;
      } else {
        _final = Math.min(parseInt(defaultValue('value', target, min)), max);
      }
      onChangeNumberDuplicates(_final);
    };
    return showNumberDuplicates && /*#__PURE__*/React__default.createElement("input", {
      className: "lemo-editor-box-list-item__number-drags lemo-editor-input-text lemo-base-input",
      type: "number",
      min: 1,
      value: item.numberDuplicates,
      onChange: onChangeNumber
    });
  }
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: cn$1('lemo-editor-box-list-item', {
      'lemo-with-feedback': showFieldFeedback
    })
  }, draggableProps, {
    ref: innerRef
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-box-list-item-wrapper"
  }, numberOption && /*#__PURE__*/React__default.createElement(NumberOption, {
    number: numberOption
  }), /*#__PURE__*/React__default.createElement("div", _extends({
    className: "lemo-editor-box-list-item-icon"
  }, dragHandleProps), /*#__PURE__*/React__default.createElement(SvgDrag, {
    className: "lemo-editor-box-list-item-icon-drag lemo-icon",
    width: 24,
    height: 24
  })), imagePickerProps && /*#__PURE__*/React__default.createElement(OptionalImagePicker$1, {
    id: imagePickerProps.id,
    imageApiKey: imagePickerProps.imageApiKey,
    value: item[imagePickerProps.modelGetSrc],
    addImage: function addImage(newImage) {
      item[imagePickerProps.modelSetSrc](newImage);
    },
    altDescription: translate(imagePickerProps.altTextKey),
    removeImage: imagePickerProps.removableImage ? function () {
      item[imagePickerProps.modelSetSrc]('');
    } : undefined
  }), /*#__PURE__*/React__default.createElement(WrapperInputFeedback, {
    feedback: getFeedbackItem(),
    onChangeFeedback: updateStateFeedback,
    showFeedback: showFeedback,
    onChangeShowFieldFeedback: onChangeShowFieldFeedback,
    componentValueRightBegin: NumberDuplicatesComponent(),
    componentValueRightEnd: trashComponent(),
    assetsFroalaApi: assetsFroalaApi
  }, /*#__PURE__*/React__default.createElement(FroalaField$1, {
    editMode: true,
    content: local,
    setContent: updateState,
    imageDefaultWidth: imageDefaultWidth,
    imageDefaultHeight: imageDefaultHeight,
    assetsFroalaApi: assetsFroalaApi,
    placeholder: placeholder
  }))));
};
SimpleListValue.propTypes = {
  imagePickerProps: propTypes.shape({
    id: propTypes.string.isRequired,
    imageApiKey: propTypes.string.isRequired,
    modelGetSrc: propTypes.string.isRequired,
    modelSetSrc: propTypes.string.isRequired,
    altTextKey: propTypes.string.isRequired,
    removableImage: propTypes.bool
  })
};
var SimpleListValue$1 = observer(SimpleListValue);

function AddButton(_ref) {
  var onClick = _ref.onClick,
    disabled = _ref.disabled,
    text = _ref.text;
  var defaultText = translate('add_new_response');
  return /*#__PURE__*/React__default.createElement(ButtonInline, {
    icon: /*#__PURE__*/React__default.createElement(SvgPlusCircle, {
      className: "lemo-icon lemo-editor-answer-options__icon-plus"
    }),
    text: text || defaultText,
    onClick: onClick,
    disabled: disabled
  });
}

var EditorAnswerOptions = function EditorAnswerOptions(_ref) {
  var options = _ref.options,
    onSortOptions = _ref.onSortOptions,
    onClickAddOption = _ref.onClickAddOption,
    shuffleOptions = _ref.shuffleOptions,
    onChangeShuffleOptions = _ref.onChangeShuffleOptions,
    duplicateResponses = _ref.duplicateResponses,
    onChangeDuplicateResponses = _ref.onChangeDuplicateResponses,
    modelGetListString = _ref.modelGetListString,
    modelSetListString = _ref.modelSetListString,
    showToggleShuffleOptions = _ref.showToggleShuffleOptions,
    showToggleDuplicateResponses = _ref.showToggleDuplicateResponses,
    showFeedbackAnswer = _ref.showFeedbackAnswer,
    showNumberDuplicates = _ref.showNumberDuplicates,
    modelGetListFeedbackString = _ref.modelGetListFeedbackString,
    modelSetListFeedbackString = _ref.modelSetListFeedbackString,
    onDeleteOption = _ref.onDeleteOption,
    keyIdSortingList = _ref.keyIdSortingList,
    idBox = _ref.idBox,
    iconBox = _ref.iconBox,
    titleBox = _ref.titleBox,
    helpText = _ref.helpText,
    limit = _ref.limit,
    helpTextDisabledAdd = _ref.helpTextDisabledAdd,
    _ref$imageDefaultHeig = _ref.imageDefaultHeight,
    imageDefaultHeight = _ref$imageDefaultHeig === void 0 ? config.configEditor[editorComponents.answerOptions].imageDefaultSize.height : _ref$imageDefaultHeig,
    _ref$imageDefaultWidt = _ref.imageDefaultWidth,
    imageDefaultWidth = _ref$imageDefaultWidt === void 0 ? config.configEditor[editorComponents.answerOptions].imageDefaultSize.width : _ref$imageDefaultWidt,
    assetsFroalaApi = _ref.assetsFroalaApi,
    showNumbersOptions = _ref.showNumbersOptions,
    _ref$imagePickerProps = _ref.imagePickerProps,
    imagePickerProps = _ref$imagePickerProps === void 0 ? null : _ref$imagePickerProps,
    _ref$showToggleGroupR = _ref.showToggleGroupResponses,
    showToggleGroupResponses = _ref$showToggleGroupR === void 0 ? false : _ref$showToggleGroupR,
    _ref$groupResponses = _ref.groupResponses,
    groupResponses = _ref$groupResponses === void 0 ? false : _ref$groupResponses,
    _ref$onChangeGroupRes = _ref.onChangeGroupResponses,
    onChangeGroupResponses = _ref$onChangeGroupRes === void 0 ? null : _ref$onChangeGroupRes,
    _ref$placeHolderItemL = _ref.placeHolderItemList,
    placeHolderItemList = _ref$placeHolderItemL === void 0 ? '' : _ref$placeHolderItemL;
  var isDisabledAdd = limit && options && options.length >= limit;
  var _titleBox = titleBox || translate('answer_options');
  var _helpText = helpText || translate('answer_options_help');
  function getElementButtonAdd() {
    return /*#__PURE__*/React__default.createElement(AddButton, {
      onClick: onClickAddOption,
      disabled: isDisabledAdd
    });
  }
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: idBox,
    icon: iconBox,
    titleBox: _titleBox,
    helpText: _helpText,
    classNameAdd: "lemo-editor-answer-options"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-horizontal-content-box full-width"
  }, /*#__PURE__*/React__default.createElement(EditorSortingList$1, {
    list: options,
    keyId: keyIdSortingList,
    onDragEnd: onSortOptions
  }, function (itemList, provider, index) {
    return /*#__PURE__*/React__default.createElement(SimpleListValue$1, {
      item: itemList,
      dragProvider: provider,
      modelGet: modelGetListString,
      modelSet: modelSetListString,
      showFeedback: showFeedbackAnswer,
      showNumberDuplicates: showNumberDuplicates,
      modelGetFeedback: modelGetListFeedbackString,
      modelSetFeedback: modelSetListFeedbackString,
      onDeleteItem: onDeleteOption ? function () {
        return onDeleteOption(itemList);
      } : undefined,
      onChangeNumberDuplicates: function onChangeNumberDuplicates(value) {
        return itemList.setNumberDuplicates(value);
      },
      imageDefaultHeight: imageDefaultHeight,
      imageDefaultWidth: imageDefaultWidth,
      assetsFroalaApi: assetsFroalaApi,
      numberOption: showNumbersOptions ? index + 1 : null,
      imagePickerProps: imagePickerProps ? {
        id: 'imagePicker' + index,
        imageApiKey: assetsFroalaApi,
        modelGetSrc: imagePickerProps.modelGetSrc,
        modelSetSrc: imagePickerProps.modelSetSrc,
        altTextKey: imagePickerProps.altTextKey,
        removableImage: imagePickerProps.removableImage
      } : undefined,
      placeholder: placeHolderItemList
    });
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-horizontal-content lemo-editor-horizontal-content--space-between"
  }, isDisabledAdd && hasData(helpTextDisabledAdd) ? /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-answer-options__disabled-add-tooltip"
  }, /*#__PURE__*/React__default.createElement(TooltipIcon, {
    text: helpTextDisabledAdd,
    icon: getElementButtonAdd()
  })) : getElementButtonAdd(), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-horizontal-content__toggles"
  }, showToggleDuplicateResponses && /*#__PURE__*/React__default.createElement(EditorToggle, {
    checked: duplicateResponses,
    onChange: function onChange(val) {
      return onChangeDuplicateResponses(val);
    }
  }, translate('duplicate_responses')), showToggleShuffleOptions && /*#__PURE__*/React__default.createElement(EditorToggle, {
    checked: shuffleOptions,
    onChange: function onChange(val) {
      return onChangeShuffleOptions(val);
    }
  }, translate('shuffle_options')), showToggleGroupResponses && /*#__PURE__*/React__default.createElement(EditorToggle, {
    checked: groupResponses,
    onChange: function onChange(val) {
      return onChangeGroupResponses(val);
    }
  }, translate('answer_options_group_responses_toggle')))));
};
EditorAnswerOptions.propTypes = {
  options: propTypes.any,
  onSortOptions: propTypes.func,
  onClickAddOption: propTypes.func,
  shuffleOptions: propTypes.bool,
  onChangeShuffleOptions: propTypes.func,
  duplicateResponses: propTypes.bool,
  onChangeDuplicateReponses: propTypes.func,
  modelGetListString: propTypes.string,
  modelSetListString: propTypes.string,
  showToggleShuffleOptions: propTypes.bool,
  showToggleDuplicateResponses: propTypes.bool,
  showFeedbackAnswer: propTypes.bool,
  showNumberDuplicates: propTypes.bool,
  modelGetListFeedbackString: propTypes.string,
  modelSetListFeedbackString: propTypes.string,
  onDeleteOption: propTypes.func,
  keyIdSortingList: propTypes.string,
  idBox: propTypes.string,
  iconBox: propTypes.node,
  titleBox: propTypes.node,
  helpText: propTypes.string,
  limit: propTypes.number,
  helpTextDisabledAdd: propTypes.string,
  imageDefaultWidth: propTypes.number,
  imageDefaultHeight: propTypes.string,
  assetsFroalaApi: propTypes.string,
  showNumbersOptions: propTypes.bool,
  imagePickerProps: propTypes.shape({
    modelGetSrc: propTypes.string.isRequired,
    modelSetSrc: propTypes.string.isRequired,
    altTextKey: propTypes.string.isRequired,
    removableImage: propTypes.bool
  }),
  showToggleGroupResponses: propTypes.bool,
  groupResponses: propTypes.bool,
  onChangeGroupResponses: propTypes.func,
  placeHolderItemList: propTypes.string
};
EditorAnswerOptions.defaultProps = {
  options: [],
  onSortOptions: function onSortOptions(sourceIndex, destinationIndex) {
    return console.log('SourceIndex:' + sourceIndex + ' DestinationIndex:' + destinationIndex);
  },
  onClickAddOption: function onClickAddOption() {
    return console.log('onClickAddOption');
  },
  shuffleOptions: false,
  onChangeShuffleOptions: function onChangeShuffleOptions(val) {
    return console.log(val);
  },
  duplicateResponses: false,
  onChangeDuplicateResponses: function onChangeDuplicateResponses(val) {
    return console.log(val);
  },
  modelGetListString: null,
  modelSetListString: null,
  showToggleShuffleOptions: true,
  showToggleDuplicateResponses: false,
  showFeedbackAnswer: false,
  modelGetListFeedbackString: null,
  modelSetListFeedbackString: null,
  keyIdSortingList: 'value',
  idBox: 'options',
  iconBox: /*#__PURE__*/React__default.createElement(SvgMenuAlt, {
    width: "24"
  }),
  onDeleteOption: null,
  limit: null,
  helpTextDisabledAdd: null,
  assetsFroalaApi: null,
  showNumbersOptions: false,
  imagePickerProps: null,
  showToggleGroupResponses: false,
  groupResponses: false,
  onChangeGroupResponses: null
};
var EditorAnswerOptions$1 = observer(EditorAnswerOptions);

var EditorAnswerOptionsStore = function EditorAnswerOptionsStore(_ref) {
  var store = _ref.store,
    modelGetListString = _ref.modelGetListString,
    modelSetListString = _ref.modelSetListString,
    showToggleShuffleOptions = _ref.showToggleShuffleOptions,
    showToggleDuplicateResponses = _ref.showToggleDuplicateResponses,
    showFeedbackAnswer = _ref.showFeedbackAnswer,
    showNumberDuplicates = _ref.showNumberDuplicates,
    modelGetListFeedbackString = _ref.modelGetListFeedbackString,
    modelSetListFeedbackString = _ref.modelSetListFeedbackString,
    onDeleteOption = _ref.onDeleteOption,
    options = _ref.options,
    onSortOptions = _ref.onSortOptions,
    onClickAddOption = _ref.onClickAddOption,
    keyIdSortingList = _ref.keyIdSortingList,
    idBox = _ref.idBox,
    iconBox = _ref.iconBox,
    titleBox = _ref.titleBox,
    helpText = _ref.helpText,
    limit = _ref.limit,
    helpTextDisabledAdd = _ref.helpTextDisabledAdd,
    imageDefaultWidth = _ref.imageDefaultWidth,
    imageDefaultHeight = _ref.imageDefaultHeight,
    showNumbersOptions = _ref.showNumbersOptions,
    imagePickerProps = _ref.imagePickerProps,
    showToggleGroupResponses = _ref.showToggleGroupResponses,
    placeHolderItemList = _ref.placeHolderItemList;
  return /*#__PURE__*/React__default.createElement(EditorAnswerOptions$1, {
    options: options || store.options,
    onSortOptions: onSortOptions || store.sortOptions,
    onClickAddOption: onClickAddOption || store.addOption,
    shuffleOptions: store.shuffle_options,
    onChangeShuffleOptions: store.setShuffleOptions,
    duplicateResponses: store.duplicate_responses,
    onChangeDuplicateResponses: store.setDuplicateResponses,
    modelGetListString: modelGetListString,
    modelSetListString: modelSetListString,
    showToggleShuffleOptions: showToggleShuffleOptions,
    showToggleDuplicateResponses: showToggleDuplicateResponses,
    showFeedbackAnswer: showFeedbackAnswer,
    showNumberDuplicates: showNumberDuplicates,
    modelGetListFeedbackString: modelGetListFeedbackString,
    modelSetListFeedbackString: modelSetListFeedbackString,
    onDeleteOption: onDeleteOption,
    keyIdSortingList: keyIdSortingList,
    idBox: idBox,
    iconBox: iconBox,
    titleBox: titleBox,
    helpText: helpText,
    limit: limit,
    helpTextDisabledAdd: helpTextDisabledAdd,
    imageDefaultWidth: imageDefaultWidth,
    imageDefaultHeight: imageDefaultHeight,
    assetsFroalaApi: getAssetsEditorApi(store.assetsEditorApi),
    showNumbersOptions: showNumbersOptions,
    imagePickerProps: imagePickerProps,
    showToggleGroupResponses: showToggleGroupResponses,
    groupResponses: store.group_responses,
    onChangeGroupResponses: store.setGroupResponses,
    placeHolderItemList: placeHolderItemList
  });
};
EditorAnswerOptionsStore.propTypes = {
  store: propTypes.any,
  modelGetListString: EditorAnswerOptions$1.propTypes.modelGetListString,
  modelSetListString: EditorAnswerOptions$1.propTypes.modelSetListString,
  showToggleShuffleOptions: EditorAnswerOptions$1.propTypes.showToggleShuffleOptions,
  showToggleDuplicateResponses: EditorAnswerOptions$1.propTypes.showToggleDuplicateResponses,
  showFeedbackAnswer: EditorAnswerOptions$1.propTypes.showFeedbackAnswer,
  showNumberDuplicates: propTypes.bool,
  modelGetListFeedbackString: EditorAnswerOptions$1.propTypes.modelGetListFeedbackString,
  modelSetListFeedbackString: EditorAnswerOptions$1.propTypes.modelSetListFeedbackString,
  onDeleteOption: EditorAnswerOptions$1.propTypes.onDeleteOption,
  keyIdSortingList: EditorAnswerOptions$1.propTypes.keyIdSortingList,
  idBox: EditorAnswerOptions$1.propTypes.idBox,
  iconBox: EditorAnswerOptions$1.propTypes.iconBox,
  titleBox: EditorAnswerOptions$1.propTypes.titleBox,
  helpText: EditorAnswerOptions$1.propTypes.helpText,
  limit: propTypes.number,
  helpTextDisabledAdd: propTypes.string,
  imageDefaultWidth: propTypes.number,
  imageDefaultHeight: propTypes.string,
  showNumbersOptions: propTypes.bool,
  imagePickerProps: propTypes.shape({
    modelGetSrc: propTypes.string.isRequired,
    modelSetSrc: propTypes.string.isRequired,
    altTextKey: propTypes.string.isRequired,
    removableImage: propTypes.bool
  }),
  showToggleGroupResponses: EditorAnswerOptions$1.propTypes.showToggleGroupResponses,
  groupResponses: EditorAnswerOptions$1.propTypes.groupResponses,
  onChangeGroupResponses: EditorAnswerOptions$1.propTypes.onChangeGroupResponses,
  placeHolderItemList: EditorAnswerOptions$1.propTypes.placeHolderItemList
};
EditorAnswerOptionsStore.defaultProps = {
  showNumberDuplicates: false,
  imagePickerProps: null
};
var EditorAnswerOptionsStore$1 = observer(EditorAnswerOptionsStore);

var canvasHeighDefault = 400;
var ConfigCanvasHeight = function ConfigCanvasHeight(_ref) {
  var max = _ref.max,
    onChangeMax = _ref.onChangeMax;
  var limitMin = 400;
  var limitMax = 2000;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-config-canvas-height"
  }, /*#__PURE__*/React__default.createElement(EditorSliderTitleSubtitle, {
    title: translate('config_canvas_height_title'),
    subtitle: translate('config_canvas_height_subtitle'),
    limitMin: limitMin,
    limitMax: limitMax,
    showLimitMin: false,
    max: max,
    onMouseUpMax: onChangeMax,
    stringConcatValues: "px"
  }));
};

var ConfigAccentSensitive = function ConfigAccentSensitive(_ref) {
  var isChecked = _ref.isChecked,
    onChange = _ref.onChange,
    disabled = _ref.disabled;
  return /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_accent_sensitive_title'),
    subtitle: translate('config_accent_sensitive_subtitle'),
    isChecked: isChecked,
    onChange: onChange,
    disabled: disabled
  });
};

var EditorLabelTitleSubtitle = function EditorLabelTitleSubtitle(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    label = _ref.label;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-label-title-subtitle"
  }, /*#__PURE__*/React__default.createElement(EditorTitleSubtitleComponent, {
    title: title,
    subtitle: subtitle,
    componentRight: /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-label-title-subtitle__label"
    }, label)
  }));
};

var ConfigAllowedAttachments = function ConfigAllowedAttachments(_ref) {
  var isDefault = _ref.isDefault;
  return /*#__PURE__*/React__default.createElement(EditorLabelTitleSubtitle, {
    title: translate('Types of files allowed as attachments'),
    subtitle: translate('MS Word, Excel, Power Point, jpg, png, pdf, Open Office, txt, video and audio'),
    label: isDefault ? translate('default') : ''
  });
};

var ConfigAudioDurationLimit = function ConfigAudioDurationLimit(_ref) {
  var max = _ref.max,
    onChangeMax = _ref.onChangeMax;
  var limitMin = 1;
  var limitMax = config.audioRecorderDurationLimit;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-config-audio-duration-limit"
  }, /*#__PURE__*/React__default.createElement(EditorSliderTitleSubtitle, {
    title: translate('config_audio_duration_limit_title'),
    subtitle: translate('config_audio_duration_limit_subtitle'),
    limitMin: limitMin,
    limitMax: limitMax,
    showLimitMin: false,
    max: max,
    onMouseUpMax: onChangeMax,
    stringConcatValues: "s"
  }));
};
var ConfigAudioDurationLimit$1 = observer(ConfigAudioDurationLimit);

var ConfigAutosizeResponse = function ConfigAutosizeResponse(_ref) {
  var isChecked = _ref.isChecked,
    onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_autosize_response_title'),
    subtitle: translate('config_autosize_response_subtitle'),
    isChecked: isChecked,
    onChange: onChange
  });
};

var ConfigBackgroundImage = function ConfigBackgroundImage(_ref) {
  var background = _ref.background,
    onChangeBackground = _ref.onChangeBackground,
    onChangeIsChecked = _ref.onChangeIsChecked,
    overwriteBackgroundTexts = _ref.overwriteBackgroundTexts,
    _ref$showSliderSizeTh = _ref.showSliderSizeThumb,
    showSliderSizeThumb = _ref$showSliderSizeTh === void 0 ? true : _ref$showSliderSizeTh,
    assetsApi = _ref.assetsApi;
  var _useState = useState(background),
    isChecked = _useState[0],
    setIsChecked = _useState[1];
  useEffect(function () {
    onChangeIsChecked && onChangeIsChecked(isChecked);
  }, [isChecked]);
  function onChangeToggle(isCheckedToogle) {
    setIsChecked(isCheckedToogle);
    if (!isCheckedToogle) onChangeBackground(null);
  }
  var texts = overwriteBackgroundTexts != null ? overwriteBackgroundTexts : {
    title: translate('Background image'),
    subtitle: translate('Canvas Background Image')
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-stack-layout-150"
  }, /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: texts.title,
    subtitle: texts.subtitle,
    isChecked: isChecked,
    onChange: onChangeToggle
  }), isChecked && /*#__PURE__*/React__default.createElement(ImageUploadOrPreview$1, {
    background: background,
    onChangeBackground: onChangeBackground,
    showSliderSizeThumb: showSliderSizeThumb,
    assetsApi: assetsApi
  }));
};

function ConfigBlockStyle(_ref) {
  var blockStyle = _ref.blockStyle,
    onChange = _ref.onChange;
  var _useState = useState(Object.keys(labelTypes).map(function (key) {
      return labelTypes[key] === labelTypes.NONE ? translate('style_block_none') : translate('style_block_' + labelTypes[key]);
    })),
    itemList = _useState[0];
  var selectedIndex = useMemo(function () {
    return Object.keys(labelTypes).findIndex(function (key) {
      return labelTypes[key] === blockStyle;
    });
  }, [blockStyle]);
  function _onChange(index) {
    if (labelTypes && index >= 0) {
      var valueChange = labelTypes[Object.keys(labelTypes)[index]];
      onChange && onChange(valueChange);
    }
  }
  return /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('title_block_style'),
    subtitle: translate('subtitle_block_style'),
    selectedIndex: selectedIndex,
    onChange: _onChange,
    itemList: itemList
  });
}

var ConfigCaseSensitive = function ConfigCaseSensitive(_ref) {
  var isChecked = _ref.isChecked,
    onChange = _ref.onChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_case_sensitive_title'),
    subtitle: translate('config_case_sensitive_subtitle'),
    isChecked: isChecked,
    onChange: onChange,
    disabled: disabled
  });
};

function ConfigColumnDirection(_ref) {
  var columnDirection = _ref.columnDirection,
    onChange = _ref.onChange;
  var _useState = useState(Object.keys(COLUMNS_DIRECTIONS_TYPES).map(function (key) {
      return translate('column_direction_' + COLUMNS_DIRECTIONS_TYPES[key]);
    })),
    itemList = _useState[0];
  var selectedIndex = useMemo(function () {
    return Object.keys(COLUMNS_DIRECTIONS_TYPES).findIndex(function (key) {
      return COLUMNS_DIRECTIONS_TYPES[key] === columnDirection;
    });
  }, [columnDirection]);
  function _onChange(index) {
    if (COLUMNS_DIRECTIONS_TYPES && index >= 0) {
      var valueChange = COLUMNS_DIRECTIONS_TYPES[Object.keys(COLUMNS_DIRECTIONS_TYPES)[index]];
      onChange && onChange(valueChange);
    }
  }
  return /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('config_column_direction_title'),
    subtitle: translate('config_column_direction_subtitle'),
    selectedIndex: selectedIndex,
    onChange: _onChange,
    itemList: itemList
  });
}

var columnsList = {
  COLUMN_1: 1,
  COLUMN_2: 2,
  COLUMN_3: 3,
  COLUMN_4: 4,
  COLUMN_5: 5,
  COLUMN_6: 6
};

function ConfigColumns(_ref) {
  var columns = _ref.columns,
    onChange = _ref.onChange;
  var _useState = useState(Object.keys(columnsList).map(function (key) {
      return translate(columnsList[key] + ' columns');
    })),
    itemList = _useState[0];
  var selectedIndex = useMemo(function () {
    return Object.keys(columnsList).findIndex(function (key) {
      return columnsList[key] === columns;
    });
  }, [columns]);
  function _onChange(index) {
    if (columnsList && index >= 0) {
      var valueChange = columnsList[Object.keys(columnsList)[index]];
      onChange && onChange(valueChange);
    }
  }
  return /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('Columns'),
    subtitle: translate('Choose how many columns you want the answers to be displayed into'),
    selectedIndex: selectedIndex,
    onChange: _onChange,
    itemList: itemList
  });
}

var ConfigDifferentMaxMinUpload = function ConfigDifferentMaxMinUpload(_ref) {
  var isChecked = _ref.isChecked,
    onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('Different max / min file upload'),
    subtitle: translate('Turn on if you want to allow uploading a range of files to the exercise'),
    isChecked: isChecked,
    onChange: onChange
  });
};

var ConfigDuplicateResponses = function ConfigDuplicateResponses(_ref) {
  var isChecked = _ref.isChecked,
    onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_duplicate_responses_title'),
    subtitle: translate('config_duplicate_responses_subtitle'),
    isChecked: isChecked,
    onChange: onChange
  });
};

function ConfigFeedbackModeClickToFind(_ref) {
  var feedbackMode = _ref.feedbackMode,
    onChange = _ref.onChange;
  var _useState = useState(Object.keys(feedbackModeTypes).map(function (key) {
      return feedbackModeTypes[key] === feedbackModeTypes.NONE ? translate('feedback_mode_none') : translate('feedback_mode_' + feedbackModeTypes[key]);
    })),
    itemList = _useState[0];
  var selectedIndex = useMemo(function () {
    return Object.keys(feedbackModeTypes).findIndex(function (key) {
      return feedbackModeTypes[key] === feedbackMode;
    });
  }, [feedbackMode]);
  function _onChange(index) {
    if (feedbackModeTypes && index >= 0) {
      var valueChange = feedbackModeTypes[Object.keys(feedbackModeTypes)[index]];
      onChange && onChange(valueChange);
    }
  }
  return /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('config_feedback_mode_click_to_find_title'),
    subtitle: translate('config_feedback_mode_click_to_find_subtitle'),
    selectedIndex: selectedIndex,
    onChange: _onChange,
    itemList: itemList
  });
}

var ConfigFileSizeLimit = function ConfigFileSizeLimit(_ref) {
  var size = _ref.size;
  return /*#__PURE__*/React__default.createElement(EditorLabelTitleSubtitle, {
    title: translate('File size limit'),
    subtitle: translate('Max size each file can reach. This is a default value and cannot be editted'),
    label: size + ' MB'
  });
};

var ConfigFilesLimit = function ConfigFilesLimit(_ref) {
  var showFilesLimitMin = _ref.showFilesLimitMin,
    min = _ref.min,
    max = _ref.max,
    onChangeMin = _ref.onChangeMin,
    onChangeMax = _ref.onChangeMax;
  var limitMin = 1;
  var limitMax = 10;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-config-files-limit"
  }, /*#__PURE__*/React__default.createElement(EditorSliderTitleSubtitle, {
    title: translate('Files limit'),
    subtitle: translate('Min/Max number of files the student is allowed to upload'),
    limitMin: limitMin,
    limitMax: limitMax,
    showLimitMin: showFilesLimitMin,
    min: min,
    max: max,
    onChangeMin: onChangeMin,
    onChangeMax: onChangeMax
  }));
};

var ConfigFixSpaces = function ConfigFixSpaces(_ref) {
  var isChecked = _ref.isChecked,
    onChange = _ref.onChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_fix_spaces_title'),
    subtitle: translate('config_fix_spaces_subtitle'),
    isChecked: isChecked,
    onChange: onChange,
    disabled: disabled
  });
};

var ConfigIsFloatingKeyboard = function ConfigIsFloatingKeyboard(_ref) {
  var isChecked = _ref.isChecked,
    onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_fixed_keyboard_title'),
    subtitle: translate('config_fixed_keyboard_subtitle'),
    isChecked: isChecked,
    onChange: onChange
  });
};
ConfigIsFloatingKeyboard.propTypes = {
  title: propTypes.string,
  subtitle: propTypes.string
};
ConfigIsFloatingKeyboard.defaultProps = {};
var ConfigIsFloatingKeyboard$1 = observer(ConfigIsFloatingKeyboard);

var ConfigIsMath = function ConfigIsMath(_ref) {
  var isChecked = _ref.isChecked,
    onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_is_math_title'),
    subtitle: translate('config_is_math_subtitle'),
    isChecked: isChecked,
    onChange: onChange
  });
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$1.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray_1 = isArray;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray_1(value) && isObjectLike_1(value) && _baseGetTag(value) == stringTag);
}

var isString_1 = isString;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = _createBaseFor();

var _baseFor = baseFor;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$2.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$2.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

var isArguments_1 = isArguments;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

var isLength_1 = isLength;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag$1 = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag$1] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$3.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$4;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$4.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$1 = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && _baseFor(object, iteratee, keys_1);
}

var _baseForOwn = baseForOwn;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

var identity_1 = identity;

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity_1;
}

var _castFunction = castFunction;

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && _baseForOwn(object, _castFunction(iteratee));
}

var forOwn_1 = forOwn;

/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype;

/** `Object#toString` result references. */
var objectTag$1 = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$6 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike_1(value) || _baseGetTag(value) != objectTag$1) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$5.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

var _ListCache = ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

var _stackClear = stackClear;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
    objectProto$7 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$2.call(hasOwnProperty$6).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$1;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var Map = _getNative(_root, 'Map');

var _Map = Map;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$8.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$7.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$9.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$8.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

var _Hash = Hash;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

var _MapCache = MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

var _Stack = Stack;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED$2);
  return this;
}

var _setCacheAdd = setCacheAdd;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new _MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
SetCache.prototype.has = _setCacheHas;

var _SetCache = SetCache;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new _SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!_arraySome(other, function(othValue, othIndex) {
            if (!_cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays;

/** Built-in value references. */
var Uint8Array$1 = _root.Uint8Array;

var _Uint8Array = Uint8Array$1;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    mapTag$1 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$1:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$1:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag$1:
    case dateTag$1:
    case numberTag$1:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq_1(+object, +other);

    case errorTag$1:
      return object.name == other.name && object.message == other.message;

    case regexpTag$1:
    case stringTag$2:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$1:
      var convert = _mapToArray;

    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1;
      convert || (convert = _setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$1;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

var stubArray_1 = stubArray;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$a.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray_1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};

var _getSymbols = getSymbols;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}

var _getAllKeys = getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2,
      objProps = _getAllKeys(object),
      objLength = objProps.length,
      othProps = _getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$9.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects;

/* Built-in method references that are verified to be native. */
var DataView$1 = _getNative(_root, 'DataView');

var _DataView = DataView$1;

/* Built-in method references that are verified to be native. */
var Promise$1 = _getNative(_root, 'Promise');

var _Promise = Promise$1;

/* Built-in method references that are verified to be native. */
var Set$1 = _getNative(_root, 'Set');

var _Set = Set$1;

/* Built-in method references that are verified to be native. */
var WeakMap = _getNative(_root, 'WeakMap');

var _WeakMap = WeakMap;

/** `Object#toString` result references. */
var mapTag$2 = '[object Map]',
    objectTag$2 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$2 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$2) ||
    (_Map && getTag(new _Map) != mapTag$2) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != setTag$2) ||
    (_WeakMap && getTag(new _WeakMap) != weakMapTag$1)) {
  getTag = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag$2 ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$2;
        case mapCtorString: return mapTag$2;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$2;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    objectTag$3 = '[object Object]';

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$c.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray_1(object),
      othIsArr = isArray_1(other),
      objTag = objIsArr ? arrayTag$1 : _getTag(object),
      othTag = othIsArr ? arrayTag$1 : _getTag(other);

  objTag = objTag == argsTag$2 ? objectTag$3 : objTag;
  othTag = othTag == argsTag$2 ? objectTag$3 : othTag;

  var objIsObj = objTag == objectTag$3,
      othIsObj = othTag == objectTag$3,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer_1(object)) {
    if (!isBuffer_1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new _Stack);
    return (objIsArr || isTypedArray_1(object))
      ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$3)) {
    var objIsWrapped = objIsObj && hasOwnProperty$a.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$a.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new _Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new _Stack);
  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike_1(value) && !isObjectLike_1(other))) {
    return value !== value && other !== other;
  }
  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

var _baseIsEqual = baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new _Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$4 | COMPARE_UNORDERED_FLAG$2, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

var _baseIsMatch = baseIsMatch;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject_1(value);
}

var _isStrictComparable = isStrictComparable;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys_1(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, _isStrictComparable(value)];
  }
  return result;
}

var _getMatchData = getMatchData;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

var _matchesStrictComparable = matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = _getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return _matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || _baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag$1);
}

var isSymbol_1 = isSymbol;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray_1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol_1(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache;

var memoize_1 = memoize;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize_1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _baseToString = baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray_1(value)) {
    return value;
  }
  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
}

var _castPath = castPath;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol_1(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _toKey = toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = _castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : _baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = _castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = _toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength_1(length) && _isIndex(key, length) &&
    (isArray_1(object) || isArguments_1(object));
}

var _hasPath = hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && _hasPath(object, path, _baseHasIn);
}

var hasIn_1 = hasIn;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (_isKey(path) && _isStrictComparable(srcValue)) {
    return _matchesStrictComparable(_toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get_1(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn_1(object, path)
      : _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$5 | COMPARE_UNORDERED_FLAG$3);
  };
}

var _baseMatchesProperty = baseMatchesProperty;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return _baseGet(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return _isKey(path) ? _baseProperty(_toKey(path)) : _basePropertyDeep(path);
}

var property_1 = property;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity_1;
  }
  if (typeof value == 'object') {
    return isArray_1(value)
      ? _baseMatchesProperty(value[0], value[1])
      : _baseMatches(value);
  }
  return property_1(value);
}

var _baseIteratee = baseIteratee;

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike_1(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

var _createBaseEach = createBaseEach;

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = _createBaseEach(_baseForOwn);

var _baseEach = baseEach;

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike_1(collection) ? Array(collection.length) : [];

  _baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

var _baseMap = baseMap;

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray_1(collection) ? _arrayMap : _baseMap;
  return func(collection, _baseIteratee(iteratee));
}

var map_1 = map;

var flattenNames_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenNames = undefined;



var _isString3 = _interopRequireDefault(isString_1);



var _forOwn3 = _interopRequireDefault(forOwn_1);



var _isPlainObject3 = _interopRequireDefault(isPlainObject_1);



var _map3 = _interopRequireDefault(map_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flattenNames = exports.flattenNames = function flattenNames() {
  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var names = [];

  (0, _map3.default)(things, function (thing) {
    if (Array.isArray(thing)) {
      flattenNames(thing).map(function (name) {
        return names.push(name);
      });
    } else if ((0, _isPlainObject3.default)(thing)) {
      (0, _forOwn3.default)(thing, function (value, key) {
        value === true && names.push(key);
        names.push(key + '-' + value);
      });
    } else if ((0, _isString3.default)(thing)) {
      names.push(thing);
    }
  });

  return names;
};

exports.default = flattenNames;
});

unwrapExports(flattenNames_1);

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach;

var defineProperty = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty = defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty) {
    _defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue;

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$d.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$b.call(object, key) && eq_1(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && _copyObject(source, keys_1(source), object);
}

var _baseAssign = baseAssign;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn;

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$e.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject_1(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$c.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

var keysIn_1 = keysIn;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && _copyObject(source, keysIn_1(source), object);
}

var _baseAssignIn = baseAssignIn;

var _cloneBuffer = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
});

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return _copyObject(source, _getSymbols(source), object);
}

var _copySymbols = copySymbols;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols$1 ? stubArray_1 : function(object) {
  var result = [];
  while (object) {
    _arrayPush(result, _getSymbols(object));
    object = _getPrototype(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return _copyObject(source, _getSymbolsIn(source), object);
}

var _copySymbolsIn = copySymbolsIn;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return _baseGetAllKeys(object, keysIn_1, _getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn;

/** Used for built-in method references. */
var objectProto$f = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$f.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$d.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray = initCloneArray;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp;

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    mapTag$3 = '[object Map]',
    numberTag$2 = '[object Number]',
    regexpTag$2 = '[object RegExp]',
    setTag$3 = '[object Set]',
    stringTag$3 = '[object String]',
    symbolTag$2 = '[object Symbol]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$2:
      return _cloneArrayBuffer(object);

    case boolTag$2:
    case dateTag$2:
      return new Ctor(+object);

    case dataViewTag$3:
      return _cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return _cloneTypedArray(object, isDeep);

    case mapTag$3:
      return new Ctor;

    case numberTag$2:
    case stringTag$3:
      return new Ctor(object);

    case regexpTag$2:
      return _cloneRegExp(object);

    case setTag$3:
      return new Ctor;

    case symbolTag$2:
      return _cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject_1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? _baseCreate(_getPrototype(object))
    : {};
}

var _initCloneObject = initCloneObject;

/** `Object#toString` result references. */
var mapTag$4 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike_1(value) && _getTag(value) == mapTag$4;
}

var _baseIsMap = baseIsMap;

/* Node.js helper references. */
var nodeIsMap = _nodeUtil && _nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap;

var isMap_1 = isMap;

/** `Object#toString` result references. */
var setTag$4 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike_1(value) && _getTag(value) == setTag$4;
}

var _baseIsSet = baseIsSet;

/* Node.js helper references. */
var nodeIsSet = _nodeUtil && _nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet;

var isSet_1 = isSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    boolTag$3 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    errorTag$2 = '[object Error]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    mapTag$5 = '[object Map]',
    numberTag$3 = '[object Number]',
    objectTag$4 = '[object Object]',
    regexpTag$3 = '[object RegExp]',
    setTag$5 = '[object Set]',
    stringTag$4 = '[object String]',
    symbolTag$3 = '[object Symbol]',
    weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$4 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$3] = cloneableTags[arrayTag$2] =
cloneableTags[arrayBufferTag$3] = cloneableTags[dataViewTag$4] =
cloneableTags[boolTag$3] = cloneableTags[dateTag$3] =
cloneableTags[float32Tag$2] = cloneableTags[float64Tag$2] =
cloneableTags[int8Tag$2] = cloneableTags[int16Tag$2] =
cloneableTags[int32Tag$2] = cloneableTags[mapTag$5] =
cloneableTags[numberTag$3] = cloneableTags[objectTag$4] =
cloneableTags[regexpTag$3] = cloneableTags[setTag$5] =
cloneableTags[stringTag$4] = cloneableTags[symbolTag$3] =
cloneableTags[uint8Tag$2] = cloneableTags[uint8ClampedTag$2] =
cloneableTags[uint16Tag$2] = cloneableTags[uint32Tag$2] = true;
cloneableTags[errorTag$2] = cloneableTags[funcTag$2] =
cloneableTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject_1(value)) {
    return value;
  }
  var isArr = isArray_1(value);
  if (isArr) {
    result = _initCloneArray(value);
    if (!isDeep) {
      return _copyArray(value, result);
    }
  } else {
    var tag = _getTag(value),
        isFunc = tag == funcTag$2 || tag == genTag$1;

    if (isBuffer_1(value)) {
      return _cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$4 || tag == argsTag$3 || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : _initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? _copySymbolsIn(value, _baseAssignIn(result, value))
          : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = _initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new _Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet_1(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap_1(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? _getAllKeysIn : _getAllKeys)
    : (isFlat ? keysIn_1 : keys_1);

  var props = isArr ? undefined : keysFunc(value);
  _arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
    CLONE_SYMBOLS_FLAG$1 = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return _baseClone(value, CLONE_DEEP_FLAG$1 | CLONE_SYMBOLS_FLAG$1);
}

var cloneDeep_1 = cloneDeep;

var mergeClasses_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeClasses = undefined;



var _forOwn3 = _interopRequireDefault(forOwn_1);



var _cloneDeep3 = _interopRequireDefault(cloneDeep_1);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
  activeNames.map(function (name) {
    var toMerge = classes[name];
    if (toMerge) {
      (0, _forOwn3.default)(toMerge, function (value, key) {
        if (!styles[key]) {
          styles[key] = {};
        }

        styles[key] = _extends({}, styles[key], toMerge[key]);
      });
    }

    return name;
  });
  return styles;
};

exports.default = mergeClasses;
});

unwrapExports(mergeClasses_1);

var autoprefix_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autoprefix = undefined;



var _forOwn3 = _interopRequireDefault(forOwn_1);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transforms = {
  borderRadius: function borderRadius(value) {
    return {
      msBorderRadius: value,
      MozBorderRadius: value,
      OBorderRadius: value,
      WebkitBorderRadius: value,
      borderRadius: value
    };
  },
  boxShadow: function boxShadow(value) {
    return {
      msBoxShadow: value,
      MozBoxShadow: value,
      OBoxShadow: value,
      WebkitBoxShadow: value,
      boxShadow: value
    };
  },
  userSelect: function userSelect(value) {
    return {
      WebkitTouchCallout: value,
      KhtmlUserSelect: value,
      MozUserSelect: value,
      msUserSelect: value,
      WebkitUserSelect: value,
      userSelect: value
    };
  },

  flex: function flex(value) {
    return {
      WebkitBoxFlex: value,
      MozBoxFlex: value,
      WebkitFlex: value,
      msFlex: value,
      flex: value
    };
  },
  flexBasis: function flexBasis(value) {
    return {
      WebkitFlexBasis: value,
      flexBasis: value
    };
  },
  justifyContent: function justifyContent(value) {
    return {
      WebkitJustifyContent: value,
      justifyContent: value
    };
  },

  transition: function transition(value) {
    return {
      msTransition: value,
      MozTransition: value,
      OTransition: value,
      WebkitTransition: value,
      transition: value
    };
  },

  transform: function transform(value) {
    return {
      msTransform: value,
      MozTransform: value,
      OTransform: value,
      WebkitTransform: value,
      transform: value
    };
  },
  absolute: function absolute(value) {
    var direction = value && value.split(' ');
    return {
      position: 'absolute',
      top: direction && direction[0],
      right: direction && direction[1],
      bottom: direction && direction[2],
      left: direction && direction[3]
    };
  },
  extend: function extend(name, otherElementStyles) {
    var otherStyle = otherElementStyles[name];
    if (otherStyle) {
      return otherStyle;
    }
    return {
      'extend': name
    };
  }
};

var autoprefix = exports.autoprefix = function autoprefix(elements) {
  var prefixed = {};
  (0, _forOwn3.default)(elements, function (styles, element) {
    var expanded = {};
    (0, _forOwn3.default)(styles, function (value, key) {
      var transform = transforms[key];
      if (transform) {
        expanded = _extends({}, expanded, transform(value));
      } else {
        expanded[key] = value;
      }
    });
    prefixed[element] = expanded;
  });
  return prefixed;
};

exports.default = autoprefix;
});

unwrapExports(autoprefix_1);

var hover_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hover = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React__default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hover = exports.hover = function hover(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits(Hover, _React$Component);

    function Hover() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Hover);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function () {
        return _this.setState({ hover: true });
      }, _this.handleMouseOut = function () {
        return _this.setState({ hover: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Hover;
  }(_react2.default.Component);
};

exports.default = hover;
});

unwrapExports(hover_1);

var active_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.active = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React__default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var active = exports.active = function active(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits(Active, _React$Component);

    function Active() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Active);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function () {
        return _this.setState({ active: true });
      }, _this.handleMouseUp = function () {
        return _this.setState({ active: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Active;
  }(_react2.default.Component);
};

exports.default = active;
});

unwrapExports(active_1);

var loop = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var loopable = function loopable(i, length) {
  var props = {};
  var setProp = function setProp(name) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    props[name] = value;
  };

  i === 0 && setProp('first-child');
  i === length - 1 && setProp('last-child');
  (i === 0 || i % 2 === 0) && setProp('even');
  Math.abs(i % 2) === 1 && setProp('odd');
  setProp('nth-child', i);

  return props;
};

exports.default = loopable;
});

unwrapExports(loop);

var lib = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;



var _flattenNames2 = _interopRequireDefault(flattenNames_1);



var _mergeClasses2 = _interopRequireDefault(mergeClasses_1);



var _autoprefix2 = _interopRequireDefault(autoprefix_1);



var _hover3 = _interopRequireDefault(hover_1);



var _active2 = _interopRequireDefault(active_1);



var _loop3 = _interopRequireDefault(loop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.hover = _hover3.default;
exports.handleHover = _hover3.default;
exports.handleActive = _active2.default;
exports.loop = _loop3.default;
var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    activations[_key - 1] = arguments[_key];
  }

  var activeNames = (0, _flattenNames2.default)(activations);
  var merged = (0, _mergeClasses2.default)(classes, activeNames);
  return (0, _autoprefix2.default)(merged);
};

exports.default = ReactCSS;
});

var reactCSS = unwrapExports(lib);

var EditorColor = function EditorColor(_ref) {
  var color = _ref.color,
    onChange = _ref.onChange,
    popoverRight = _ref.popoverRight;
  var _useState = useState(false),
    displayColorPicker = _useState[0],
    setDisplayColorPicker = _useState[1];
  var _useState2 = useState(color),
    colorState = _useState2[0],
    setColorState = _useState2[1];
  useEffect(function () {
    if (color !== colorState) setColorState(color);
  }, [color]);
  function handleChangeComplete(color) {
    setColorState(color);
    onChange(color);
  }
  function handleChangeCompletePicker(color) {
    handleChangeComplete(color.hex);
  }
  function handleClick() {
    setDisplayColorPicker(function (prev) {
      return !prev;
    });
  }
  function handleClose() {
    setDisplayColorPicker(false);
  }
  var styles = reactCSS({
    "default": {
      color: {
        width: '60px',
        height: '60px',
        borderRadius: '2px',
        background: "" + colorState
      },
      swatch: {
        padding: '5px',
        background: '#fff',
        borderRadius: '1px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
        display: 'inline-block',
        cursor: 'pointer'
      },
      popover: {
        position: 'absolute',
        right: popoverRight,
        zIndex: '2'
      },
      cover: {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px'
      }
    }
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-color"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-dropdown"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-dropdown-control', 'lemo-base-dropdown', {
      'lemo-dropdown-control--open lemo-base-dropdown--open': displayColorPicker
    }),
    onClick: handleClick,
    style: {
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-color__color-circle",
    style: {
      backgroundColor: colorState
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-editor-color__color-label",
    dangerouslySetInnerHTML: {
      __html: colorState
    },
    style: {
      minWidth: 0,
      fontSize: '1em'
    }
  }), /*#__PURE__*/React__default.createElement(SvgChevronDown, {
    className: "lemo-dropdown-icon lemo-base-dropdown__icon"
  }))), displayColorPicker ? /*#__PURE__*/React__default.createElement("div", {
    style: styles.popover
  }, /*#__PURE__*/React__default.createElement("div", {
    style: styles.cover,
    onClick: handleClose
  }), /*#__PURE__*/React__default.createElement(SketchPicker, {
    color: colorState,
    onChange: handleChangeCompletePicker
  })) : null);
};
EditorColor.propTypes = {
  popoverRight: propTypes.string
};
EditorColor.defaultProps = {
  popoverRight: undefined
};

var EditorColorTitleSubtitle = function EditorColorTitleSubtitle(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    color = _ref.color,
    onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-color-title-subtitle"
  }, /*#__PURE__*/React__default.createElement(EditorTitleSubtitleComponent, {
    title: title,
    subtitle: subtitle,
    componentRight: /*#__PURE__*/React__default.createElement(EditorColor, {
      color: color,
      onChange: onChange,
      popoverRight: "0px"
    })
  }));
};

var ConfigLinesColor = function ConfigLinesColor(_ref) {
  var color = _ref.color,
    onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement(EditorColorTitleSubtitle, {
    title: translate('config_lines_color_title'),
    subtitle: translate('config_lines_color_subtitle'),
    color: color,
    onChange: onChange
  });
};

function DropDownWithIcon(_ref) {
  var itemList = _ref.itemList,
    _ref$onSelect = _ref.onSelect,
    onSelect = _ref$onSelect === void 0 ? function () {
      console.log('onSelect not defined');
    } : _ref$onSelect,
    _ref$onOpen = _ref.onOpen,
    onOpen = _ref$onOpen === void 0 ? function () {} : _ref$onOpen,
    _ref$selectedIndex = _ref.selectedIndex,
    selectedIndex = _ref$selectedIndex === void 0 ? -1 : _ref$selectedIndex,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? '1em' : _ref$fontSize,
    _ref$isStyleFeedbackE = _ref.isStyleFeedbackError,
    isStyleFeedbackError = _ref$isStyleFeedbackE === void 0 ? false : _ref$isStyleFeedbackE,
    _ref$isStyleFeedbackS = _ref.isStyleFeedbackSuccess,
    isStyleFeedbackSuccess = _ref$isStyleFeedbackS === void 0 ? false : _ref$isStyleFeedbackS,
    _ref$additionalMinWid = _ref.additionalMinWidth,
    additionalMinWidth = _ref$additionalMinWid === void 0 ? 0 : _ref$additionalMinWid;
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var _useState2 = useState(0),
    minWidth = _useState2[0],
    setMinWidth = _useState2[1];
  var labelTarget = useRef();
  useEffect(function () {
    setMinWidth(getTextFieldMetrics(itemList.reduce(function (acc, next) {
      return next.length > acc.length ? next : acc;
    }, ''), labelTarget.current) + 6 + additionalMinWidth);
  }, [itemList]);
  var handleToggle = useCallback(function (e, toggle) {
    toggle(e);
  }, []);
  var handleSelect = useCallback(function (idx, close) {
    if (!disabled) {
      onSelect(idx);
      close();
    }
  }, [disabled, onOpen, onSelect]);
  var handleStatus = useCallback(function (bool) {
    return _onOpen(bool);
  }, [onOpen]);
  function _onOpen(bool) {
    setIsOpen(bool);
    onOpen && onOpen(bool);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-dropdown-with-icon lemo-dropdown"
  }, /*#__PURE__*/React__default.createElement(Popover, null, /*#__PURE__*/React__default.createElement(Popover.Control, null, function (_ref2) {
    var toggle = _ref2.toggle;
    return /*#__PURE__*/React__default.createElement("div", {
      className: cn$1('lemo-dropdown-control', 'lemo-base-dropdown', {
        'lemo-dropdown-control--disabled lemo-base-dropdown--disabled': disabled
      }, {
        'lemo-dropdown-control--open lemo-base-dropdown--open': isOpen
      }, {
        'lemo-dropdown-control--feedback-success': isStyleFeedbackSuccess
      }, {
        'lemo-dropdown-control--feedback-error': isStyleFeedbackError
      }),
      onClick: !disabled ? function (e) {
        return handleToggle(e, toggle);
      } : undefined
    }, itemList[selectedIndex].icon && /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-dropdown-with-icon-left-element"
    }, itemList[selectedIndex].icon), itemList[selectedIndex].text && /*#__PURE__*/React__default.createElement("span", {
      ref: labelTarget,
      className: "lemo-dropdown-selected-label",
      dangerouslySetInnerHTML: {
        __html: selectedIndex === -1 ? '&nbsp;' : itemList[selectedIndex].text
      },
      style: {
        minWidth: minWidth,
        fontSize: fontSize
      }
    }), /*#__PURE__*/React__default.createElement(SvgChevronDown, {
      className: "lemo-dropdown-icon lemo-base-dropdown__icon"
    }));
  }), /*#__PURE__*/React__default.createElement(Popover.Content, {
    onChangeOpen: handleStatus
  }, function (_ref3) {
    var close = _ref3.close,
      open = _ref3.open;
    return !open ? null : /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-dropdown-content"
    }, itemList.map(function (child, idx) {
      return /*#__PURE__*/React__default.createElement("div", {
        key: child.text,
        className: cn$1('lemo-dropdown-content-item', 'lemo-base-dropdown__item', {
          'lemo-selected lemo-dropdown-control__item--selected': selectedIndex === idx
        }),
        onClick: function onClick() {
          return handleSelect(idx, close);
        }
      }, child.icon && /*#__PURE__*/React__default.createElement("div", {
        className: "lemo-dropdown-with-icon-left-element"
      }, child.icon), child.text && /*#__PURE__*/React__default.createElement("div", {
        className: "lemo-dropdown-with-icon-text"
      }, child.text));
    }));
  })));
}

var EditorDropdownWithIconTitleSubtitle = function EditorDropdownWithIconTitleSubtitle(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    selectedIndex = _ref.selectedIndex,
    onChange = _ref.onChange,
    itemList = _ref.itemList,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$additionalMinWid = _ref.additionalMinWidth,
    additionalMinWidth = _ref$additionalMinWid === void 0 ? 0 : _ref$additionalMinWid;
  return /*#__PURE__*/React__default.createElement(EditorTitleSubtitleComponent, {
    title: title,
    subtitle: subtitle,
    disabled: disabled,
    componentRight: /*#__PURE__*/React__default.createElement(DropDownWithIcon, {
      onSelect: onChange,
      selectedIndex: selectedIndex,
      itemList: itemList,
      disabled: disabled,
      additionalMinWidth: additionalMinWidth
    })
  });
};
var EditorDropdownWithIconTitleSubtitle$1 = observer(EditorDropdownWithIconTitleSubtitle);

function ConfigLineThickness(_ref) {
  var lineThickness = _ref.lineThickness,
    onChange = _ref.onChange;
  var _useState = useState(Object.keys(LINES_THICKNESS_TYPES).map(function (key) {
      var height = LINES_THICKNESS_TYPES[key] === LINES_THICKNESS_TYPES.FINE ? '3px' : LINES_THICKNESS_TYPES[key] === LINES_THICKNESS_TYPES.MEDIUM ? '5px' : LINES_THICKNESS_TYPES[key] === LINES_THICKNESS_TYPES.COARSE ? '7px' : '3px';
      return {
        text: translate('line_thinckness_' + key.toLowerCase()),
        icon: /*#__PURE__*/React__default.createElement("div", {
          style: {
            width: '24px',
            height: height,
            backgroundColor: '#000000'
          }
        })
      };
    })),
    itemList = _useState[0];
  var selectedIndex = useMemo(function () {
    return Object.keys(LINES_THICKNESS_TYPES).findIndex(function (key) {
      return LINES_THICKNESS_TYPES[key] === lineThickness;
    });
  }, [lineThickness]);
  function _onChange(index) {
    if (LINES_THICKNESS_TYPES && index >= 0) {
      var valueChange = LINES_THICKNESS_TYPES[Object.keys(LINES_THICKNESS_TYPES)[index]];
      onChange && onChange(valueChange);
    }
  }
  return /*#__PURE__*/React__default.createElement(EditorDropdownWithIconTitleSubtitle$1, {
    title: translate('config_line_thickness_title'),
    subtitle: translate('config_line_thickness_subtitle'),
    selectedIndex: selectedIndex,
    onChange: _onChange,
    itemList: itemList,
    additionalMinWidth: 32
  });
}

function ConfigMaxCharacter(_ref) {
  var maxCharacter = _ref.maxCharacter,
    onChange = _ref.onChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var _useState = useState(maxCharacter >= 0),
    isChecked = _useState[0],
    setIsChecked = _useState[1];
  var _useState2 = useState(maxCharacter >= 0 ? maxCharacter : 10000),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  useEffect(function () {
    if (!isChecked) {
      onChange && onChange(-1);
    } else {
      onChange && onChange(inputValue);
    }
  }, [isChecked]);
  function handleChangeInput(event) {
    var value = parseInt(event.target.value);
    setInputValue(value);
    if (value) {
      onChange && onChange(value);
    }
  }
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_max_character_title'),
    subtitle: translate('config_max_character_subtitle'),
    isChecked: isChecked,
    onChange: setIsChecked,
    disabled: disabled
  }), isChecked && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(EditorTitleSubtitleComponent, {
    title: translate('config_max_character_input_title'),
    subtitle: translate('config_max_character_input_subtitle'),
    componentRight: /*#__PURE__*/React__default.createElement(EditorInputText$1, {
      type: "number",
      min: 1,
      value: inputValue,
      onChange: handleChangeInput,
      placeholder: translate('config_max_character_input_placeholder'),
      disabled: disabled
    })
  })));
}
var ConfigMaxCharacter$1 = observer(ConfigMaxCharacter);

var ConfigMultipleResponses = function ConfigMultipleResponses(_ref) {
  var isChecked = _ref.isChecked,
    onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_multiple_responses_title'),
    subtitle: translate('config_multiple_responses_subtitle'),
    isChecked: isChecked,
    onChange: onChange
  });
};

function ConfigNumberKeyboards(_ref) {
  var keyboardList = _ref.keyboardList,
    numberKeyboard = _ref.numberKeyboard,
    onChange = _ref.onChange;
  var INDEX_DEFAULT = 0;
  var _useState = useState(getListDropdown()),
    itemList = _useState[0];
  var _useState2 = useState(getSelectedIndexBegin()),
    selectedIndex = _useState2[0],
    setSelectedIndex = _useState2[1];
  var _useState3 = useState({
      isVisible: false,
      index: selectedIndex
    }),
    showConfirmMessage = _useState3[0],
    setShowConfirmMessage = _useState3[1];
  function getSelectedIndexBegin() {
    if (numberKeyboard) {
      if (hasData(numberKeyboard.type)) {
        return keyboardList.findIndex(function (element) {
          return element.value === numberKeyboard.type;
        });
      } else {
        return INDEX_DEFAULT;
      }
    } else {
      return INDEX_DEFAULT;
    }
  }
  function _onChange(index) {
    if (selectedIndex !== index) setShowConfirmMessage({
      isVisible: true,
      index: index
    });
  }
  function onChangeConfirmOk(index) {
    setSelectedIndex(index);
    if (index >= 0) {
      var valueChange = {
        type: '',
        fixed: false
      };
      var indexToFind = index;
      if (keyboardList && indexToFind >= 0 && indexToFind < keyboardList.length) {
        var element = keyboardList[indexToFind];
        if (element) {
          valueChange.type = element.value;
        }
      }
      onChange && onChange(valueChange);
    }
  }
  function getListDropdown() {
    var list = [];
    if (keyboardList) {
      keyboardList.forEach(function (element) {
        list.push(element.name ? translate(element.name) : translate(getKeyboardTranslate(element.value)));
      });
    }
    return list;
  }
  function onConfirm() {
    onChangeConfirmOk(showConfirmMessage.index);
    setShowConfirmMessage({
      isVisible: false,
      index: selectedIndex
    });
  }
  function onCancel() {
    setShowConfirmMessage({
      isVisible: false,
      index: selectedIndex
    });
  }
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('config_number_keyboards_title'),
    subtitle: translate('config_number_keyboards_subtitle'),
    selectedIndex: selectedIndex,
    onChange: _onChange,
    itemList: itemList
  }), showConfirmMessage && showConfirmMessage.isVisible && /*#__PURE__*/React__default.createElement(ModalConfirmMessage$1, {
    onConfirm: onConfirm,
    onCancel: onCancel,
    title: translate('confirm_switching_keyboards_title'),
    message: translate('confirm_switching_keyboards_message')
  }));
}
var ConfigNumberKeyboards$1 = observer(ConfigNumberKeyboards);

var ConfigShowCheckIcon = function ConfigShowCheckIcon(_ref) {
  var isChecked = _ref.isChecked,
    onChange = _ref.onChange,
    title = _ref.title,
    subtitle = _ref.subtitle;
  return /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: title || translate('Show check icon'),
    subtitle: subtitle || translate('When turned on the answers will have a radio button next to them'),
    isChecked: isChecked,
    onChange: onChange
  });
};
ConfigShowCheckIcon.propTypes = {
  title: propTypes.string,
  subtitle: propTypes.string
};
ConfigShowCheckIcon.defaultProps = {};

var ConfigStack = function ConfigStack(_ref) {
  var isChecked = _ref.isChecked,
    onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_stack_title'),
    subtitle: translate('config_stack_subtitle'),
    isChecked: isChecked,
    onChange: onChange
  });
};

var ConfigSuffleAnswers = function ConfigSuffleAnswers(_ref) {
  var isChecked = _ref.isChecked,
    onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('Shuffle Answers'),
    subtitle: translate('When turned on the questions will be sorted in differ order each time they are presented'),
    isChecked: isChecked,
    onChange: onChange
  });
};

var uppercaseLowercaseTypes = {
  UPPERCASE: 'uppercase',
  LOWERCASE: 'lowercase'
};
function ConfigUppercaseLowercase(_ref) {
  var isLower = _ref.isLower,
    onChange = _ref.onChange;
  var _useState = useState(Object.keys(uppercaseLowercaseTypes).map(function (key) {
      return translate('config_' + uppercaseLowercaseTypes[key]);
    })),
    itemList = _useState[0];
  var selectedIndex = useMemo(function () {
    return Object.keys(uppercaseLowercaseTypes).findIndex(function (key) {
      return isLower ? uppercaseLowercaseTypes[key] === uppercaseLowercaseTypes.LOWERCASE : uppercaseLowercaseTypes[key] === uppercaseLowercaseTypes.UPPERCASE;
    });
  }, [isLower]);
  function _onChange(index) {
    if (uppercaseLowercaseTypes && index >= 0) {
      var valueChange = uppercaseLowercaseTypes[Object.keys(uppercaseLowercaseTypes)[index]];
      onChange && onChange(valueChange === uppercaseLowercaseTypes.LOWERCASE);
    }
  }
  return /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('config_uppercase_lowercase_title'),
    subtitle: translate('config_uppercase_lowercase_subtitle'),
    selectedIndex: selectedIndex,
    onChange: _onChange,
    itemList: itemList
  });
}

function ConfigVariantStyle(_ref) {
  var variantList = _ref.variantList,
    customClass = _ref.customClass,
    onChange = _ref.onChange;
  var INDEX_STYLE_DEFAULT = 0;
  var _useState = useState(getListDropdown()),
    itemList = _useState[0];
  var _useState2 = useState(haveCustomClassList()),
    showInput = _useState2[0],
    setShowInput = _useState2[1];
  var _useState3 = useState(haveCustomClassList() ? customClass.classList.join(' ') : ''),
    inputValue = _useState3[0],
    setInputValue = _useState3[1];
  var _useState4 = useState(getSelectedIndexBegin()),
    selectedIndex = _useState4[0],
    setSelectedIndex = _useState4[1];
  if (!config.showAuthorVariantsEditor) {
    return null;
  }
  function getSelectedIndexBegin() {
    if (customClass) {
      if (haveCustomClassList()) {
        return getIndexStyleCustom();
      } else if (hasData(customClass.variant)) {
        return variantList.findIndex(function (element) {
          return element.value === customClass.variant;
        }) + 1;
      } else {
        return INDEX_STYLE_DEFAULT;
      }
    } else {
      return INDEX_STYLE_DEFAULT;
    }
  }
  function handleChangeInput(event) {
    setInputValue(event.target.value);
    var value = event.target.value;
    if (value) {
      onChange && onChange({
        variant: '',
        classList: value.split(' ')
      });
    }
  }
  function _onChange(index) {
    setSelectedIndex(index);
    if (index >= 0) {
      var valueChange = {
        variant: '',
        classList: []
      };
      if (index === INDEX_STYLE_DEFAULT) {
        setShowInput(false);
        setInputValue('');
      } else if (index === getIndexStyleCustom()) {
        setShowInput(true);
        setInputValue('');
      } else {
        setShowInput(false);
        var indexToFind = index - 1;
        if (variantList && indexToFind >= 0 && indexToFind < variantList.length) {
          var element = variantList[indexToFind];
          if (element) {
            valueChange.variant = element.value;
          }
        }
      }
      onChange && onChange(valueChange);
    }
  }
  function haveCustomClassList() {
    return customClass && customClass.classList && customClass.classList.length > 0;
  }
  function getIndexStyleCustom() {
    return itemList.length - 1;
  }
  function getListDropdown() {
    var list = [];
    list.push(translate('style_variant_default'));
    if (variantList) {
      variantList.forEach(function (element) {
        list.push(translate(element.name));
      });
    }
    list.push(translate('style_variant_custom'));
    return list;
  }
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('config_variant_style_title'),
    subtitle: translate('config_variant_style_subtitle'),
    selectedIndex: selectedIndex,
    onChange: _onChange,
    itemList: itemList
  }), showInput && /*#__PURE__*/React__default.createElement(EditorInputText$1, {
    value: inputValue,
    onChange: handleChangeInput,
    placeholder: translate('config_variant_style_input_placeholder')
  }));
}
var ConfigVariantStyle$1 = observer(ConfigVariantStyle);

var ConfigWithBox = function ConfigWithBox(_ref) {
  var isChecked = _ref.isChecked,
    onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_with_box_title'),
    subtitle: translate('config_with_box_subtitle'),
    isChecked: isChecked,
    onChange: onChange
  });
};

var ALLOWED_LETTERS_DEFAULT = {
  es: 'ABCDEFGHIJKLMNÑOPQRSTUVWXYZ',
  en: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  pt: 'ABCDEFGHIJKLMNOPQRSTUVWXYZÁÂÃÀÉÊÍÎÓÕÚÛÜÇ'
};
var MIN_LENGTH_WORD = 2;
function getDisplacements(diagonals, backward) {
  var dxs = [];
  var dys = [];
  if (diagonals) {
    if (backward) {
      dxs = [0, 1, 1, 1, 0, -1, -1, -1];
      dys = [-1, -1, 0, 1, 1, 1, 0, -1];
    } else {
      dxs = [1, 1, 1, 0];
      dys = [-1, 0, 1, 1];
    }
  } else {
    if (backward) {
      dxs = [0, 1, 0, -1];
      dys = [-1, 0, 1, 0];
    } else {
      dxs = [1, 0];
      dys = [0, 1];
    }
  }
  return {
    dxs: dxs,
    dys: dys
  };
}
function getAllowedLettersGeneral() {
  var allowedLetters = ALLOWED_LETTERS_DEFAULT[config.lang] || ALLOWED_LETTERS_DEFAULT.en;
  if (config.configExercise[types.other.WordSearch] && config.configExercise[types.other.WordSearch].allowedLetters && hasData(config.configExercise[types.other.WordSearch].allowedLetters)) allowedLetters = config.configExercise[types.other.WordSearch].allowedLetters;
  return allowedLetters;
}
function isValidString(stringInput, allowedLetters) {
  if (hasData(allowedLetters) && hasData(stringInput)) {
    var validLetters = 0;
    for (var index = 0; index < stringInput.length; index++) {
      var letterInput = stringInput[index];
      if (allowedLetters.indexOf(letterInput) >= 0) {
        validLetters++;
      }
    }
    if (validLetters >= stringInput.length) {
      return true;
    } else return false;
  } else return true;
}
function isValidStringByLength(stringInput) {
  if (hasData(stringInput) && stringInput.length >= MIN_LENGTH_WORD) {
    return true;
  } else return false;
}
function clearString(value, allowedLetters) {
  var characters = value.split('');
  var filteredCharacters = characters.filter(function (character) {
    return allowedLetters.includes(character);
  });
  var filteredValue = filteredCharacters.join('');
  return filteredValue;
}
function isSameWordDistintDirection(word1Info, word2Info) {
  return word1Info.word === word2Info.word && word1Info.startPoint[0] === word2Info.endPoint[0] && word1Info.startPoint[1] === word2Info.endPoint[1] && word1Info.endPoint[0] === word2Info.startPoint[0] && word1Info.endPoint[1] === word2Info.startPoint[1];
}

function ConfigWordSearchAllowedLetters(_ref) {
  var allowedLetters = _ref.allowedLetters,
    onChange = _ref.onChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    getInvalidWordsByAllowedLetters = _ref.getInvalidWordsByAllowedLetters;
  var _useState = useState(hasData(allowedLetters)),
    isChecked = _useState[0],
    setIsChecked = _useState[1];
  var _useState2 = useState(hasData(allowedLetters) ? allowedLetters : getAllowedLettersGeneral()),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var _useState3 = useState(getShowConfirmMessageDefault()),
    showConfirmMessage = _useState3[0],
    setShowConfirmMessage = _useState3[1];
  useEffect(function () {
    if (!isChecked) {
      onChange && onChange('');
    } else {
      onChange && onChange(inputValue);
    }
  }, [isChecked]);
  function onChangeConfirmOk(value) {
    setInputValue(value);
    if (value) {
      onChange && onChange(value);
    }
  }
  function handleChangeInput(event) {
    var value = event.target.value;
    var invalidWords = getInvalidWordsByAllowedLetters(value);
    if (invalidWords.length <= 0) {
      onChangeConfirmOk(value);
    } else {
      setShowConfirmMessage({
        isVisible: true,
        invalidWords: invalidWords,
        allowedLetters: value
      });
    }
  }
  function getShowConfirmMessageDefault() {
    return {
      isVisible: false,
      invalidWords: [],
      allowedLetters: undefined
    };
  }
  function onConfirm() {
    onChangeConfirmOk(showConfirmMessage.allowedLetters);
    setShowConfirmMessage(getShowConfirmMessageDefault());
  }
  function onCancel() {
    setShowConfirmMessage(getShowConfirmMessageDefault());
  }
  function getInvalidWordsMessage() {
    var message = '';
    for (var index = 0; index < showConfirmMessage.invalidWords.length; index++) {
      var word = showConfirmMessage.invalidWords[index];
      message += '\n' + word.value;
    }
    return message;
  }
  function handleKeyPress(e) {
    if (e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_word_search_allowed_letters_title'),
    subtitle: translate('config_word_search_allowed_letters_subtitle'),
    isChecked: isChecked,
    onChange: setIsChecked,
    disabled: disabled
  }), isChecked ? /*#__PURE__*/React__default.createElement(EditorInputText$1, {
    value: inputValue,
    onChange: handleChangeInput,
    placeholder: getAllowedLettersGeneral(),
    disabled: disabled,
    onKeyPress: handleKeyPress
  }) : null, showConfirmMessage && showConfirmMessage.isVisible && /*#__PURE__*/React__default.createElement(ModalConfirmMessage$1, {
    onConfirm: onConfirm,
    onCancel: onCancel,
    title: translate('confirm_edit_allowed_letter_title'),
    message: translate('confirm_edit_allowed_letter_message') + ' \n' + getInvalidWordsMessage()
  }));
}
var ConfigWordSearchAllowedLetters$1 = observer(ConfigWordSearchAllowedLetters);

var ConfigWordSearchBackward = function ConfigWordSearchBackward(_ref) {
  var isChecked = _ref.isChecked,
    onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_word_search_backward_title'),
    subtitle: translate('config_word_search_backward_subtitle'),
    isChecked: isChecked,
    onChange: onChange
  });
};

var ConfigWordSearchDiagonal = function ConfigWordSearchDiagonal(_ref) {
  var isChecked = _ref.isChecked,
    onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_word_search_diagonal_title'),
    subtitle: translate('config_word_search_diagonal_subtitle'),
    isChecked: isChecked,
    onChange: onChange
  });
};

var ConfigWordSearchRandom = function ConfigWordSearchRandom(_ref) {
  var isChecked = _ref.isChecked,
    onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_word_search_random_title'),
    subtitle: translate('config_word_search_random_subtitle'),
    isChecked: isChecked,
    onChange: onChange
  });
};

function ConfigWordsLimit(_ref) {
  var wordsLimit = _ref.wordsLimit,
    onChange = _ref.onChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var _useState = useState(wordsLimit !== undefined && wordsLimit > 0),
    isChecked = _useState[0],
    setIsChecked = _useState[1];
  var _useState2 = useState(hasData(wordsLimit) ? wordsLimit : 10000),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  useEffect(function () {
    if (!isChecked) {
      onChange && onChange(0);
    } else {
      onChange && onChange(inputValue);
    }
  }, [isChecked]);
  function handleChangeInput(event) {
    var value = parseInt(event.target.value);
    setInputValue(value);
    if (value) {
      onChange && onChange(value);
    }
  }
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_words_limit_title'),
    subtitle: translate('config_words_limit_subtitle'),
    isChecked: isChecked,
    onChange: setIsChecked,
    disabled: disabled
  }), isChecked && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(EditorTitleSubtitleComponent, {
    title: translate('config_words_limit_input_title'),
    subtitle: translate('config_words_limit_input_subtitle'),
    componentRight: /*#__PURE__*/React__default.createElement(EditorInputText$1, {
      type: "number",
      min: 1,
      value: inputValue,
      onChange: handleChangeInput,
      placeholder: translate('config_words_limit_input_placeholder'),
      disabled: disabled
    })
  })));
}
var ConfigWordsLimit$1 = observer(ConfigWordsLimit);

var ConfigShowSelection = function ConfigShowSelection(_ref) {
  var isChecked = _ref.isChecked,
    onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_show_selection_title'),
    subtitle: translate('config_show_selection_subtitle'),
    isChecked: isChecked,
    onChange: onChange
  });
};

var ConfigAutosizeBox = function ConfigAutosizeBox(_ref) {
  var isChecked = _ref.isChecked,
    onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_autosize_box_title'),
    subtitle: translate('config_autosize_box_subtitle'),
    isChecked: isChecked,
    onChange: onChange
  });
};

var ConfigAutoDrop = function ConfigAutoDrop(_ref) {
  var autoDrop = _ref.autoDrop,
    setAutoDrop = _ref.setAutoDrop;
  return /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_automatic_drop_title'),
    subtitle: translate('config_automatic_drop_subtitle'),
    isChecked: autoDrop,
    onChange: setAutoDrop
  });
};

var ConfigShowHotspots = function ConfigShowHotspots(_ref) {
  var showHotspots = _ref.showHotspots,
    setShowHotspots = _ref.setShowHotspots;
  return /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_show_hotspots_title'),
    subtitle: translate('config_show_hotspots_subtitle'),
    isChecked: showHotspots,
    onChange: setShowHotspots
  });
};

var ConfigShowDropIndicator = function ConfigShowDropIndicator(_ref) {
  var showDropIndicator = _ref.showDropIndicator,
    setShowDropIndicator = _ref.setShowDropIndicator;
  return /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_drop_indicator_title'),
    subtitle: translate('config_drop_indicator_subtitle'),
    isChecked: showDropIndicator,
    onChange: setShowDropIndicator
  });
};

var ConfigVerticalOriention = function ConfigVerticalOriention(_ref) {
  var isVerticalOrientation = _ref.isVerticalOrientation,
    setIsVerticalOrientation = _ref.setIsVerticalOrientation;
  return /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_vertical_orientation_title'),
    subtitle: translate('config_vertical_orientation_subtitle'),
    isChecked: isVerticalOrientation,
    onChange: setIsVerticalOrientation
  });
};

var TYPES_CONFIG = {
  CONFIG_SUFFLE_ANSWERS: 'CONFIG_SUFFLE_ANSWERS',
  CONFIG_SHOW_CHECK_ICON: 'CONFIG_SHOW_CHECK_ICON',
  CONFIG_BLOCK_STYLE: 'CONFIG_BLOCK_STYLE',
  CONFIG_COLUMNS: 'CONFIG_COLUMNS',
  CONFIG_DIFFERENT_MAX_MIN_FILE_UPLOAD: 'CONFIG_DIFFERENT_MAX_MIN_FILE_UPLOAD',
  CONFIG_FILES_LIMIT: 'CONFIG_FILES_LIMIT',
  CONFIG_FILE_SIZE_LIMIT: 'CONFIG_FILE_SIZE_LIMIT',
  CONFIG_TYPES_ALLOWED_ATTACHMENTS: 'CONFIG_TYPES_ALLOWED_ATTACHMENTS',
  CONFIG_BACKGROUND_IMAGE: 'CONFIG_BACKGROUND_IMAGE',
  CONFIG_CANVAS_HEIGHT: 'CONFIG_CANVAS_HEIGHT',
  CONFIG_VARIANT_STYLE: 'CONFIG_VARIANT_STYLE',
  CONFIG_MULTIPLE_RESPONSES: 'CONFIG_MULTIPLE_RESPONSES',
  CONFIG_DUPLICATE_RESPONSES: 'CONFIG_DUPLICATE_RESPONSES',
  CONFIG_IS_MATH: 'CONFIG_IS_MATH',
  CONFIG_ACCENT_SENSITIVE: 'CONFIG_ACCENT_SENSITIVE',
  CONFIG_CASE_SENSITIVE: 'CONFIG_CASE_SENSITIVE',
  CONFIG_FIX_SPACES: 'CONFIG_FIX_SPACES',
  CONFIG_MAX_CHARACTER: 'CONFIG_MAX_CHARACTER',
  CONFIG_WORDS_LIMIT: 'CONFIG_WORDS_LIMIT',
  CONFIG_AUTOSIZE_RESPONSE: 'CONFIG_AUTOSIZE_RESPONSE',
  CONFIG_AUTOSIZE_BOX: 'CONFIG_AUTOSIZE_BOX',
  CONFIG_STACK: 'CONFIG_STACK',
  CONFIG_WITH_BOX: 'CONFIG_WITH_BOX',
  CONFIG_LINES_COLOR: 'CONFIG_LINES_COLOR',
  CONFIG_LINE_THICKNESS: 'CONFIG_LINE_THICKNESS',
  CONFIG_FEEDBACK_MODE_CLICK_TO_FIND: 'CONFIG_FEEDBACK_MODE_CLICK_TO_FIND',
  CONFIG_COLUMN_DIRECTION: 'CONFIG_COLUMN_DIRECTION',
  CONFIG_NUMBER_KEYBOARD: 'CONFIG_NUMBER_KEYBOARD',
  CONFIG_FIXED_KEYBOARD: 'CONFIG_FIXED_KEYBOARD',
  CONFIG_AUDIO_DURATION_LIMIT: 'CONFIG_AUDIO_DURATION_LIMIT',
  CONFIG_WORD_SEARCH_RANDOM: 'CONFIG_WORD_SEARCH_RANDOM',
  CONFIG_WORD_SEARCH_BACKWARD: 'CONFIG_WORD_SEARCH_BACKWARD',
  CONFIG_WORD_SEARCH_DIAGONAL: 'CONFIG_WORD_SEARCH_DIAGONAL',
  CONFIG_WORD_SEARCH_ALLOWED_LETTERS: 'CONFIG_WORD_SEARCH_ALLOWED_LETTERS',
  CONFIG_UPPERCASE_LOWERCASE: 'CONFIG_UPPERCASE_LOWERCASE',
  CONFIG_SHOW_SELECTION: 'CONFIG_SHOW_SELECTION',
  CONFIG_AUTO_DROP: 'CONFIG_AUTO_DROP',
  CONFIG_SHOW_HOTSPOTS: 'CONFIG_SHOW_HOTSPOTS',
  CONFIG_DROP_INDICATOR: 'CONFIG_DROP_INDICATOR',
  CONFIG_VERTICAL_ORIENTATION: 'CONFIG_VERTICAL_ORIENTATION'
};
var EditorConfig = function EditorConfig(_ref) {
  var listConfig = _ref.listConfig,
    listConfigParams = _ref.listConfigParams,
    iconTitle = _ref.iconTitle,
    titleBox = _ref.titleBox,
    helpText = _ref.helpText,
    suffleAnswer = _ref.suffleAnswer,
    onChangeShuffleAnswer = _ref.onChangeShuffleAnswer,
    showCheckIcon = _ref.showCheckIcon,
    onChangeShowCheckIcon = _ref.onChangeShowCheckIcon,
    titleCheckIcon = _ref.titleCheckIcon,
    subtitleCheckIcon = _ref.subtitleCheckIcon,
    blockStyle = _ref.blockStyle,
    onChangeBlockStyle = _ref.onChangeBlockStyle,
    columns = _ref.columns,
    onChangeColumns = _ref.onChangeColumns,
    differentMaxMinUpload = _ref.differentMaxMinUpload,
    onChangeDifferentMaxMinUpload = _ref.onChangeDifferentMaxMinUpload,
    showFilesLimitMin = _ref.showFilesLimitMin,
    filesLimitMin = _ref.filesLimitMin,
    filesLimitMax = _ref.filesLimitMax,
    onChangeFilesLimitMin = _ref.onChangeFilesLimitMin,
    onChangeFilesLimitMax = _ref.onChangeFilesLimitMax,
    fileSizeLimit = _ref.fileSizeLimit,
    isDefaultAllowedAttachments = _ref.isDefaultAllowedAttachments,
    backgroundImage = _ref.backgroundImage,
    onchangeBackgroundImage = _ref.onchangeBackgroundImage,
    onChangeIsCheckedBackgroundImage = _ref.onChangeIsCheckedBackgroundImage,
    showSliderSizeThumbBackgrounImage = _ref.showSliderSizeThumbBackgrounImage,
    overwriteBackgroundTexts = _ref.overwriteBackgroundTexts,
    assetsApiBackgroundImage = _ref.assetsApiBackgroundImage,
    showCanvasHeight = _ref.showCanvasHeight,
    canvasHeight = _ref.canvasHeight,
    onChangeCanvasHeight = _ref.onChangeCanvasHeight,
    variantListVariantStyle = _ref.variantListVariantStyle,
    customClassVariantStyle = _ref.customClassVariantStyle,
    onChangeVariantStyle = _ref.onChangeVariantStyle,
    isMultipleResponses = _ref.isMultipleResponses,
    onChangeIsMultipleResponses = _ref.onChangeIsMultipleResponses,
    isDuplicateResponses = _ref.isDuplicateResponses,
    onChangeIsDuplicateResponses = _ref.onChangeIsDuplicateResponses,
    isMath = _ref.isMath,
    onChangeIsMath = _ref.onChangeIsMath,
    showIsAccentSensitive = _ref.showIsAccentSensitive,
    isAccentSensitive = _ref.isAccentSensitive,
    onChangeIsAccentSensitive = _ref.onChangeIsAccentSensitive,
    disabledIsAccentSensitive = _ref.disabledIsAccentSensitive,
    showIsCaseSensitive = _ref.showIsCaseSensitive,
    isCaseSensitive = _ref.isCaseSensitive,
    onChangeIsCaseSensitive = _ref.onChangeIsCaseSensitive,
    disabledIsCaseSensitive = _ref.disabledIsCaseSensitive,
    isLowerUppercaseLowercase = _ref.isLowerUppercaseLowercase,
    onChangeIsLowerUppercaseLowercase = _ref.onChangeIsLowerUppercaseLowercase,
    showIsFixSpaces = _ref.showIsFixSpaces,
    isFixSpaces = _ref.isFixSpaces,
    onChangeIsFixSpaces = _ref.onChangeIsFixSpaces,
    disabledIsFixSpaces = _ref.disabledIsFixSpaces,
    maxCharacter = _ref.maxCharacter,
    onChangeMaxCharacter = _ref.onChangeMaxCharacter,
    disabledMaxCharacter = _ref.disabledMaxCharacter,
    wordsLimit = _ref.wordsLimit,
    onChangeWordsLimit = _ref.onChangeWordsLimit,
    isAutosizeResponse = _ref.isAutosizeResponse,
    onChangeIsAutosizeResponse = _ref.onChangeIsAutosizeResponse,
    isAutosizeBox = _ref.isAutosizeBox,
    onChangeIsAutosizeBox = _ref.onChangeIsAutosizeBox,
    isStack = _ref.isStack,
    onChangeIsStack = _ref.onChangeIsStack,
    isWithBox = _ref.isWithBox,
    onChangeIsWithBox = _ref.onChangeIsWithBox,
    linesColor = _ref.linesColor,
    onChangeLinesColor = _ref.onChangeLinesColor,
    lineThickness = _ref.lineThickness,
    onChangeLineThickness = _ref.onChangeLineThickness,
    feedbackModeClickToFind = _ref.feedbackModeClickToFind,
    onChangeFeedbackModeClickToFind = _ref.onChangeFeedbackModeClickToFind,
    columnDirection = _ref.columnDirection,
    onChangeColumnDirection = _ref.onChangeColumnDirection,
    numberKeyboard = _ref.numberKeyboard,
    onChangeKeyboardType = _ref.onChangeKeyboardType,
    showIsFloatingKeyboard = _ref.showIsFloatingKeyboard,
    isFloatingKeyboard = _ref.isFloatingKeyboard,
    onChangeIsFloatingKeyboard = _ref.onChangeIsFloatingKeyboard,
    audioDurationLimit = _ref.audioDurationLimit,
    onChangeAudioDurationLimit = _ref.onChangeAudioDurationLimit,
    wordSearchRandom = _ref.wordSearchRandom,
    onChangeWordSearchRandom = _ref.onChangeWordSearchRandom,
    wordSearchBackward = _ref.wordSearchBackward,
    onChangeWordSearchBackward = _ref.onChangeWordSearchBackward,
    wordSearchDiagonal = _ref.wordSearchDiagonal,
    onChangeWordSearchDiagonal = _ref.onChangeWordSearchDiagonal,
    wordSearchAllowedLetters = _ref.wordSearchAllowedLetters,
    onChangeWordSearchAllowedLetters = _ref.onChangeWordSearchAllowedLetters,
    wordSearchGetInvalidWordsByAllowedLetters = _ref.wordSearchGetInvalidWordsByAllowedLetters,
    showSelection = _ref.showSelection,
    onChangeShowSelection = _ref.onChangeShowSelection,
    autoDrop = _ref.autoDrop,
    setAutoDrop = _ref.setAutoDrop,
    showHotspots = _ref.showHotspots,
    setShowHotspots = _ref.setShowHotspots,
    showDropIndicator = _ref.showDropIndicator,
    setShowDropIndicator = _ref.setShowDropIndicator,
    isVerticalOrientation = _ref.isVerticalOrientation,
    setIsVerticalOrientation = _ref.setIsVerticalOrientation,
    showAuthorVariantsEditor = _ref.showAuthorVariantsEditor;
  function getConfigType(config, params) {
    switch (config) {
      case TYPES_CONFIG.CONFIG_SUFFLE_ANSWERS:
        return /*#__PURE__*/React__default.createElement(ConfigSuffleAnswers, {
          key: config,
          isChecked: suffleAnswer,
          onChange: onChangeShuffleAnswer
        });
      case TYPES_CONFIG.CONFIG_SHOW_CHECK_ICON:
        return /*#__PURE__*/React__default.createElement(ConfigShowCheckIcon, {
          key: config,
          isChecked: showCheckIcon,
          onChange: onChangeShowCheckIcon,
          title: titleCheckIcon,
          subtitle: subtitleCheckIcon
        });
      case TYPES_CONFIG.CONFIG_BLOCK_STYLE:
        return /*#__PURE__*/React__default.createElement(ConfigBlockStyle, {
          key: config,
          blockStyle: blockStyle,
          onChange: onChangeBlockStyle
        });
      case TYPES_CONFIG.CONFIG_COLUMNS:
        return /*#__PURE__*/React__default.createElement(ConfigColumns, {
          key: config,
          columns: columns,
          onChange: onChangeColumns
        });
      case TYPES_CONFIG.CONFIG_DIFFERENT_MAX_MIN_FILE_UPLOAD:
        return /*#__PURE__*/React__default.createElement(ConfigDifferentMaxMinUpload, {
          key: config,
          isChecked: differentMaxMinUpload,
          onChange: onChangeDifferentMaxMinUpload
        });
      case TYPES_CONFIG.CONFIG_FILES_LIMIT:
        return /*#__PURE__*/React__default.createElement(ConfigFilesLimit, {
          key: config,
          showFilesLimitMin: showFilesLimitMin,
          min: filesLimitMin,
          max: filesLimitMax,
          onChangeMin: onChangeFilesLimitMin,
          onChangeMax: onChangeFilesLimitMax
        });
      case TYPES_CONFIG.CONFIG_FILE_SIZE_LIMIT:
        return /*#__PURE__*/React__default.createElement(ConfigFileSizeLimit, {
          key: config,
          size: fileSizeLimit
        });
      case TYPES_CONFIG.CONFIG_TYPES_ALLOWED_ATTACHMENTS:
        return /*#__PURE__*/React__default.createElement(ConfigAllowedAttachments, {
          key: config,
          isDefault: isDefaultAllowedAttachments
        });
      case TYPES_CONFIG.CONFIG_BACKGROUND_IMAGE:
        return /*#__PURE__*/React__default.createElement(ConfigBackgroundImage, {
          key: config,
          background: backgroundImage,
          onChangeBackground: onchangeBackgroundImage,
          onChangeIsChecked: onChangeIsCheckedBackgroundImage,
          showSliderSizeThumb: showSliderSizeThumbBackgrounImage,
          overwriteBackgroundTexts: overwriteBackgroundTexts,
          assetsApi: assetsApiBackgroundImage
        });
      case TYPES_CONFIG.CONFIG_CANVAS_HEIGHT:
        return showCanvasHeight && /*#__PURE__*/React__default.createElement(ConfigCanvasHeight, {
          key: config,
          max: canvasHeight,
          onChangeMax: onChangeCanvasHeight
        });
      case TYPES_CONFIG.CONFIG_VARIANT_STYLE:
        if (!showAuthorVariantsEditor) {
          return null;
        }
        return /*#__PURE__*/React__default.createElement(ConfigVariantStyle$1, {
          key: config,
          variantList: variantListVariantStyle,
          customClass: customClassVariantStyle,
          onChange: onChangeVariantStyle
        });
      case TYPES_CONFIG.CONFIG_MULTIPLE_RESPONSES:
        return /*#__PURE__*/React__default.createElement(ConfigMultipleResponses, {
          key: config,
          isChecked: isMultipleResponses,
          onChange: onChangeIsMultipleResponses
        });
      case TYPES_CONFIG.CONFIG_DUPLICATE_RESPONSES:
        return /*#__PURE__*/React__default.createElement(ConfigDuplicateResponses, {
          key: config,
          isChecked: isDuplicateResponses,
          onChange: onChangeIsDuplicateResponses
        });
      case TYPES_CONFIG.CONFIG_IS_MATH:
        return /*#__PURE__*/React__default.createElement(ConfigIsMath, {
          key: config,
          isChecked: isMath,
          onChange: onChangeIsMath
        });
      case TYPES_CONFIG.CONFIG_ACCENT_SENSITIVE:
        return showIsAccentSensitive && /*#__PURE__*/React__default.createElement(ConfigAccentSensitive, {
          key: config,
          isChecked: isAccentSensitive,
          onChange: onChangeIsAccentSensitive,
          disabled: disabledIsAccentSensitive
        });
      case TYPES_CONFIG.CONFIG_CASE_SENSITIVE:
        return showIsCaseSensitive && /*#__PURE__*/React__default.createElement(ConfigCaseSensitive, {
          key: config,
          isChecked: isCaseSensitive,
          onChange: onChangeIsCaseSensitive,
          disabled: disabledIsCaseSensitive
        });
      case TYPES_CONFIG.CONFIG_UPPERCASE_LOWERCASE:
        return /*#__PURE__*/React__default.createElement(ConfigUppercaseLowercase, {
          key: config,
          isLower: isLowerUppercaseLowercase,
          onChange: onChangeIsLowerUppercaseLowercase
        });
      case TYPES_CONFIG.CONFIG_FIX_SPACES:
        return showIsFixSpaces && /*#__PURE__*/React__default.createElement(ConfigFixSpaces, {
          key: config,
          isChecked: isFixSpaces,
          onChange: onChangeIsFixSpaces,
          disabled: disabledIsFixSpaces
        });
      case TYPES_CONFIG.CONFIG_MAX_CHARACTER:
        return /*#__PURE__*/React__default.createElement(ConfigMaxCharacter$1, {
          key: config,
          maxCharacter: maxCharacter,
          onChange: onChangeMaxCharacter,
          disabled: disabledMaxCharacter
        });
      case TYPES_CONFIG.CONFIG_WORDS_LIMIT:
        return /*#__PURE__*/React__default.createElement(ConfigWordsLimit$1, {
          key: config,
          wordsLimit: wordsLimit,
          onChange: onChangeWordsLimit
        });
      case TYPES_CONFIG.CONFIG_AUTOSIZE_RESPONSE:
        return /*#__PURE__*/React__default.createElement(ConfigAutosizeResponse, {
          key: config,
          isChecked: isAutosizeResponse,
          onChange: onChangeIsAutosizeResponse
        });
      case TYPES_CONFIG.CONFIG_AUTOSIZE_BOX:
        return /*#__PURE__*/React__default.createElement(ConfigAutosizeBox, {
          key: config,
          isChecked: isAutosizeBox,
          onChange: onChangeIsAutosizeBox
        });
      case TYPES_CONFIG.CONFIG_STACK:
        return /*#__PURE__*/React__default.createElement(ConfigStack, {
          key: config,
          isChecked: isStack,
          onChange: onChangeIsStack
        });
      case TYPES_CONFIG.CONFIG_WITH_BOX:
        return /*#__PURE__*/React__default.createElement(ConfigWithBox, {
          key: config,
          isChecked: isWithBox,
          onChange: onChangeIsWithBox
        });
      case TYPES_CONFIG.CONFIG_LINES_COLOR:
        return /*#__PURE__*/React__default.createElement(ConfigLinesColor, {
          key: config,
          color: linesColor,
          onChange: onChangeLinesColor
        });
      case TYPES_CONFIG.CONFIG_LINE_THICKNESS:
        return /*#__PURE__*/React__default.createElement(ConfigLineThickness, {
          key: config,
          lineThickness: lineThickness,
          onChange: onChangeLineThickness
        });
      case TYPES_CONFIG.CONFIG_FEEDBACK_MODE_CLICK_TO_FIND:
        return /*#__PURE__*/React__default.createElement(ConfigFeedbackModeClickToFind, {
          key: config,
          feedbackMode: feedbackModeClickToFind,
          onChange: onChangeFeedbackModeClickToFind
        });
      case TYPES_CONFIG.CONFIG_COLUMN_DIRECTION:
        return /*#__PURE__*/React__default.createElement(ConfigColumnDirection, {
          key: config,
          columnDirection: columnDirection,
          onChange: onChangeColumnDirection
        });
      case TYPES_CONFIG.CONFIG_NUMBER_KEYBOARD:
        return /*#__PURE__*/React__default.createElement(ConfigNumberKeyboards$1, {
          key: config,
          keyboardList: params === null || params === void 0 ? void 0 : params.keyboardList,
          numberKeyboard: numberKeyboard,
          onChange: onChangeKeyboardType
        });
      case TYPES_CONFIG.CONFIG_FIXED_KEYBOARD:
        if (!showIsFloatingKeyboard) {
          return null;
        }
        return /*#__PURE__*/React__default.createElement(ConfigIsFloatingKeyboard$1, {
          key: config,
          isChecked: isFloatingKeyboard,
          onChange: onChangeIsFloatingKeyboard
        });
      case TYPES_CONFIG.CONFIG_AUDIO_DURATION_LIMIT:
        return /*#__PURE__*/React__default.createElement(ConfigAudioDurationLimit$1, {
          key: config,
          max: audioDurationLimit,
          onChangeMax: onChangeAudioDurationLimit
        });
      case TYPES_CONFIG.CONFIG_WORD_SEARCH_RANDOM:
        return /*#__PURE__*/React__default.createElement(ConfigWordSearchRandom, {
          key: config,
          isChecked: wordSearchRandom,
          onChange: onChangeWordSearchRandom
        });
      case TYPES_CONFIG.CONFIG_WORD_SEARCH_BACKWARD:
        return /*#__PURE__*/React__default.createElement(ConfigWordSearchBackward, {
          key: config,
          isChecked: wordSearchBackward,
          onChange: onChangeWordSearchBackward
        });
      case TYPES_CONFIG.CONFIG_WORD_SEARCH_DIAGONAL:
        return /*#__PURE__*/React__default.createElement(ConfigWordSearchDiagonal, {
          key: config,
          isChecked: wordSearchDiagonal,
          onChange: onChangeWordSearchDiagonal
        });
      case TYPES_CONFIG.CONFIG_WORD_SEARCH_ALLOWED_LETTERS:
        return /*#__PURE__*/React__default.createElement(ConfigWordSearchAllowedLetters$1, {
          key: config,
          allowedLetters: wordSearchAllowedLetters,
          onChange: onChangeWordSearchAllowedLetters,
          getInvalidWordsByAllowedLetters: wordSearchGetInvalidWordsByAllowedLetters
        });
      case TYPES_CONFIG.CONFIG_SHOW_SELECTION:
        return /*#__PURE__*/React__default.createElement(ConfigShowSelection, {
          key: config,
          isChecked: showSelection,
          onChange: onChangeShowSelection
        });
      case TYPES_CONFIG.CONFIG_AUTO_DROP:
        return /*#__PURE__*/React__default.createElement(ConfigAutoDrop, {
          key: config,
          autoDrop: autoDrop,
          setAutoDrop: setAutoDrop
        });
      case TYPES_CONFIG.CONFIG_SHOW_HOTSPOTS:
        return /*#__PURE__*/React__default.createElement(ConfigShowHotspots, {
          key: config,
          showHotspots: showHotspots,
          setShowHotspots: setShowHotspots
        });
      case TYPES_CONFIG.CONFIG_DROP_INDICATOR:
        return /*#__PURE__*/React__default.createElement(ConfigShowDropIndicator, {
          key: config,
          showDropIndicator: showDropIndicator,
          setShowDropIndicator: setShowDropIndicator
        });
      case TYPES_CONFIG.CONFIG_VERTICAL_ORIENTATION:
        return /*#__PURE__*/React__default.createElement(ConfigVerticalOriention, {
          key: config,
          isVerticalOrientation: isVerticalOrientation,
          setIsVerticalOrientation: setIsVerticalOrientation
        });
      default:
        return null;
    }
  }
  function getClassAddFromConfig(config) {
    var classAdd = '';
    if (config) {
      classAdd = config.replace(/^(CONFIG_)/, '');
      classAdd = classAdd.replace(/_/g, '-');
      classAdd = classAdd.toLowerCase();
    }
    return classAdd;
  }
  var hasVisibleComponents = listConfig.some(function (config) {
    var configType = getConfigType(config, listConfigParams[config]);
    return configType !== null;
  });
  if (!hasVisibleComponents) {
    return null;
  }
  var configComponents = listConfig.map(function (config, idx) {
    var configType = getConfigType(config, listConfigParams[config]);
    var classAdd = getClassAddFromConfig(config);
    var hasVisibleAfter = false;
    if (configType) {
      for (var i = idx + 1; i < listConfig.length; i++) {
        var nextConfigType = getConfigType(listConfig[i], listConfigParams[listConfig[i]]);
        if (nextConfigType !== null) {
          hasVisibleAfter = true;
          break;
        }
      }
    }
    return /*#__PURE__*/React__default.createElement("div", {
      className: classNames('lemo-editor-config-component', 'lemo-editor-config__' + classAdd),
      key: config
    }, configType || /*#__PURE__*/React__default.createElement("p", null), configType && hasVisibleAfter && /*#__PURE__*/React__default.createElement(Line1, null));
  });
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "configuration",
    icon: iconTitle,
    helpText: helpText || translate('config_help'),
    titleBox: titleBox || translate('Configuration'),
    classNameAdd: "lemo-editor-config"
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, configComponents));
};
EditorConfig.propTypes = {
  titleBox: propTypes.string,
  helpText: propTypes.string,
  iconTitle: propTypes.node,
  listConfigParams: propTypes.object
};
EditorConfig.defaultProps = {
  iconTitle: /*#__PURE__*/React__default.createElement(SvgSettingsTipography, {
    width: "24",
    className: "lemo-icon-format-shape"
  }),
  listConfigParams: {}
};

var SHOW_SELECTION_DEFAULT = false;
var withShowSelection = types$1.model({
  showSelection: types$1.optional(types$1["boolean"], SHOW_SELECTION_DEFAULT)
}).actions(function (state) {
  return {
    setShowSelection: function setShowSelection(showSelection) {
      state.showSelection = showSelection;
      getParent(state).updateNotifier();
    }
  };
});

var WORD_SEARCH_BACKWARD_DEFAULT = false;
var WORD_SEARCH_DIAGONAL_DEFAULT = true;
var WordSearchBoard = types$1.compose(types$1.model({
  columns: types$1.optional(types$1.number, GRID_TYPES.M.columns),
  rows: types$1.optional(types$1.number, GRID_TYPES.M.rows),
  letters: types$1.optional(types$1.array(types$1.array(types$1.string)), []),
  backward: types$1.optional(types$1["boolean"], WORD_SEARCH_BACKWARD_DEFAULT),
  diagonal: types$1.optional(types$1["boolean"], WORD_SEARCH_DIAGONAL_DEFAULT),
  allowed_letters: types$1.optional(types$1.string, '')
}).actions(function (state) {
  return {
    setColumns: function setColumns(columns) {
      state.columns = columns;
      getParent(state).updateNotifier();
    },
    setRows: function setRows(rows) {
      state.rows = rows;
      getParent(state).updateNotifier();
    },
    setColumnsRows: function setColumnsRows(columns, rows) {
      state.columns = columns;
      state.rows = rows;
      getParent(state).updateNotifier();
    },
    setLetters: function setLetters(letters) {
      state.letters = letters;
      getParent(state).updateNotifier();
    },
    setBackward: function setBackward(backward) {
      state.backward = backward;
      getParent(state).updateNotifier();
      getParent(state).updateWordSearch();
    },
    setDiagonal: function setDiagonal(diagonal) {
      state.diagonal = diagonal;
      getParent(state).updateNotifier();
      getParent(state).updateWordSearch();
    },
    setAllowedLetters: function setAllowedLetters(allowedLetters) {
      state.allowed_letters = allowedLetters;
      getParent(state).updateNotifier();
    }
  };
}));
var WordSearchBoard$1 = types$1.snapshotProcessor(WordSearchBoard, {
  preProcessor: function preProcessor(sn) {
    return _extends({}, sn);
  },
  postProcessor: function postProcessor(sn) {
    return _extends({}, sn);
  }
});
var defaultBoard = {
  columns: GRID_TYPES.M.columns,
  rows: GRID_TYPES.M.rows,
  letters: [],
  backward: false,
  diagonal: true,
  allowed_letters: ''
};

var EditorConfigStore = function EditorConfigStore(_ref) {
  var _store$ui_style, _store$board, _store$board2, _store$board3, _store$ui_style2, _store$ui_style3, _store$ui_style4, _store$ui_style5, _store$ui_style6;
  var store = _ref.store,
    listConfig = _ref.listConfig,
    listConfigParams = _ref.listConfigParams,
    titleBox = _ref.titleBox,
    helpText = _ref.helpText,
    iconTitle = _ref.iconTitle,
    showSliderSizeThumbBackgrounImage = _ref.showSliderSizeThumbBackgrounImage,
    overwriteBackgroundTexts = _ref.overwriteBackgroundTexts,
    titleCheckIcon = _ref.titleCheckIcon,
    subtitleCheckIcon = _ref.subtitleCheckIcon;
  var _useState = useState(store.hasOwnProperty('minFiles') && store.minFiles > 1),
    enableDifferentMaxMinUpload = _useState[0],
    setEnableDifferentMaxMinUpload = _useState[1];
  var _useState2 = useState(store.image !== undefined),
    isCheckedBackgroundImage = _useState2[0],
    setIsCheckedBackgroundImage = _useState2[1];
  var percentImage = store.image && store.image.hasOwnProperty('percent') ? store.image.percent : 1;
  var isMath = store.normalization && store.normalization.hasOwnProperty('isMath') ? store.normalization.isMath : false;
  return /*#__PURE__*/React__default.createElement(EditorConfig, {
    titleBox: titleBox,
    iconTitle: iconTitle,
    helpText: helpText,
    listConfig: listConfig,
    listConfigParams: listConfigParams,
    suffleAnswer: store.shuffle_options,
    onChangeShuffleAnswer: store.setShuffleOptions,
    showCheckIcon: store.showCheckIcon,
    onChangeShowCheckIcon: function onChangeShowCheckIcon(val) {
      return store.setShowCheckIcon(val);
    },
    titleCheckIcon: titleCheckIcon,
    subtitleCheckIcon: subtitleCheckIcon,
    blockStyle: store.ui_style ? store.ui_style.labelType : null,
    onChangeBlockStyle: function onChangeBlockStyle(value) {
      return store.ui_style.setLabelType(value);
    },
    columns: store.ui_style ? store.ui_style.columns : null,
    onChangeColumns: function onChangeColumns(value) {
      return store.ui_style.setColumns(value);
    },
    differentMaxMinUpload: enableDifferentMaxMinUpload,
    onChangeDifferentMaxMinUpload: function onChangeDifferentMaxMinUpload(value) {
      setEnableDifferentMaxMinUpload(value);
      if (!value) {
        store.setMinFiles(1);
      }
    },
    showFilesLimitMin: enableDifferentMaxMinUpload,
    filesLimitMin: store.hasOwnProperty('minFiles') ? store.minFiles : null,
    filesLimitMax: store.hasOwnProperty('maxFiles') ? store.maxFiles : null,
    onChangeFilesLimitMin: function onChangeFilesLimitMin(value) {
      return store.setMinFiles(value);
    },
    onChangeFilesLimitMax: function onChangeFilesLimitMax(value) {
      return store.setMaxFiles(value);
    },
    fileSizeLimit: config.maxUploadFileSize,
    isDefaultAllowedAttachments: true,
    backgroundImage: store.image ? {
      source: store.image.src,
      original_width: store.image.width,
      original_height: store.image.height,
      scale: percentImage * 100,
      width: percentImage * store.image.width,
      height: percentImage * store.image.height,
      alt: store.image.alt
    } : null,
    assetsApiBackgroundImage: getAssetsEditorApi(store.assetsEditorApi),
    onchangeBackgroundImage: function onchangeBackgroundImage(value) {
      value ? store.setImage({
        src: value.source,
        width: value.original_width,
        height: value.original_height,
        percent: value.hasOwnProperty('scale') ? value.scale / 100 : 1,
        alt: value.alt
      }) : store.clearImage();
    },
    onChangeIsCheckedBackgroundImage: function onChangeIsCheckedBackgroundImage(isChecked) {
      setIsCheckedBackgroundImage(isChecked);
    },
    showSliderSizeThumbBackgrounImage: showSliderSizeThumbBackgrounImage,
    overwriteBackgroundTexts: overwriteBackgroundTexts,
    showCanvasHeight: !isCheckedBackgroundImage,
    canvasHeight: store.height,
    onChangeCanvasHeight: function onChangeCanvasHeight(value) {
      return store.setHeight(parseInt(value));
    },
    variantListVariantStyle: store.variants,
    customClassVariantStyle: {
      variant: (_store$ui_style = store.ui_style) === null || _store$ui_style === void 0 ? void 0 : _store$ui_style.customClass.variant,
      classList: store.ui_style.customClass.classList
    },
    onChangeVariantStyle: function onChangeVariantStyle(value) {
      store.ui_style.customClass.setVariant(value.variant);
      store.ui_style.customClass.setClassList(value.classList);
    },
    isMultipleResponses: store.multiple_responses,
    onChangeIsMultipleResponses: store.setMultipleResponses,
    isDuplicateResponses: store.duplicate_responses,
    onChangeIsDuplicateResponses: store.setDuplicateResponses,
    isMath: isMath,
    onChangeIsMath: function onChangeIsMath(value) {
      if (store.normalization && store.normalization.toggleIsMath) store.normalization.toggleIsMath(value);
    },
    showIsAccentSensitive: !(store.ui_style.keyboard && hasData(store.ui_style.keyboard.type) && (store.ui_style.keyboard.type === keyboards.basic || store.ui_style.keyboard.type === keyboards.numerical)),
    isAccentSensitive: store.normalization && store.normalization.hasOwnProperty('accents') ? store.normalization.accents : false,
    onChangeIsAccentSensitive: function onChangeIsAccentSensitive(value) {
      if (store.normalization && store.normalization.toggleAccents) store.normalization.toggleAccents(value);
    },
    disabledIsAccentSensitive: isMath,
    showIsCaseSensitive: !(store.ui_style.keyboard && hasData(store.ui_style.keyboard.type) && (store.ui_style.keyboard.type === keyboards.basic || store.ui_style.keyboard.type === keyboards.numerical)),
    isCaseSensitive: store.normalization && store.normalization.hasOwnProperty('lower') ? store.normalization.lower : false,
    onChangeIsCaseSensitive: function onChangeIsCaseSensitive(value) {
      if (store.normalization && store.normalization.toggleLower) store.normalization.toggleLower(value);
    },
    disabledIsCaseSensitive: isMath,
    isLowerUppercaseLowercase: store.normalization && store.normalization.hasOwnProperty('lower') ? store.normalization.lower : false,
    onChangeIsLowerUppercaseLowercase: function onChangeIsLowerUppercaseLowercase(value) {
      if (store.normalization && store.normalization.toggleLower) store.normalization.toggleLower(value);
    },
    showIsFixSpaces: !(store.ui_style.keyboard && hasData(store.ui_style.keyboard.type) && (store.ui_style.keyboard.type === keyboards.basic || store.ui_style.keyboard.type === keyboards.numerical)),
    isFixSpaces: store.normalization && store.normalization.hasOwnProperty('spaces') ? store.normalization.spaces : false,
    onChangeIsFixSpaces: function onChangeIsFixSpaces(value) {
      if (store.normalization && store.normalization.toggleSpaces) store.normalization.toggleSpaces(value);
    },
    disabledIsFixSpaces: isMath,
    maxCharacter: store.max_length,
    onChangeMaxCharacter: function onChangeMaxCharacter(value) {
      store.setMaxLength(value);
    },
    disabledMaxCharacter: isMath,
    wordsLimit: store.wordsLimit,
    onChangeWordsLimit: function onChangeWordsLimit(value) {
      store.setWordsLimit(value);
    },
    isAutosizeResponse: store.autosizeResponse,
    onChangeIsAutosizeResponse: function onChangeIsAutosizeResponse(val) {
      return store.setAutosizeResponse(val);
    },
    isAutosizeBox: store.autosizeBox,
    onChangeIsAutosizeBox: function onChangeIsAutosizeBox(val) {
      return store.setAutosizeBox(val);
    },
    isStack: store.ui_style ? store.ui_style.stack : false,
    onChangeIsStack: function onChangeIsStack(value) {
      return store.ui_style.setStack(value);
    },
    isWithBox: store.ui_style ? store.ui_style.withBox : false,
    onChangeIsWithBox: function onChangeIsWithBox(value) {
      return store.ui_style.setWithBox(value);
    },
    linesColor: store.ui_style ? store.ui_style.line_color : '#828282',
    onChangeLinesColor: function onChangeLinesColor(value) {
      return store.ui_style.setLineColor(value);
    },
    lineThickness: store.ui_style ? store.ui_style.line_thickness : LINES_THICKNESS_TYPES.FINE,
    onChangeLineThickness: function onChangeLineThickness(value) {
      return store.ui_style.setLineThickness(value);
    },
    feedbackModeClickToFind: store.ui_style ? store.ui_style.feedback_mode : feedbackModeTypes.FEEDBACK_WITH_BORDER,
    onChangeFeedbackModeClickToFind: function onChangeFeedbackModeClickToFind(value) {
      return store.ui_style.setFeedbackMode(value);
    },
    columnDirection: store.ui_style ? store.ui_style.column_direction : COLUMNS_DIRECTIONS_TYPES.VERTICAL,
    onChangeColumnDirection: function onChangeColumnDirection(value) {
      return store.ui_style.setColumnDirection(value);
    },
    numberKeyboard: store.ui_style.keyboard ? {
      type: store.ui_style.keyboard.type
    } : null,
    onChangeKeyboardType: function onChangeKeyboardType(value) {
      store.ui_style.setKeyboardType(value.type);
    },
    onChangeKeyboardIsFloating: function onChangeKeyboardIsFloating(value) {
      store.ui_style.setFloatingKeyboard(value.isFloating);
    },
    showIsFloatingKeyboard: store.ui_style.keyboard && hasData(store.ui_style.keyboard.type) && (store.ui_style.keyboard.type === keyboards.basic || store.ui_style.keyboard.type === keyboards.numerical || store.ui_style.keyboard.type === keyboards.roman),
    isFloatingKeyboard: store.ui_style.keyboard ? store.ui_style.keyboard.isFloating : false,
    onChangeIsFloatingKeyboard: function onChangeIsFloatingKeyboard(value) {
      store.ui_style.setFloatingKeyboard(value);
    },
    audioDurationLimit: store.maxTime,
    onChangeAudioDurationLimit: store.setMaxTime,
    wordSearchRandom: store.shuffle_options,
    onChangeWordSearchRandom: store.setShuffleOptions,
    wordSearchBackward: store.board ? store.board.backward : WORD_SEARCH_BACKWARD_DEFAULT,
    onChangeWordSearchBackward: (_store$board = store.board) === null || _store$board === void 0 ? void 0 : _store$board.setBackward,
    wordSearchDiagonal: store.board ? store.board.diagonal : WORD_SEARCH_DIAGONAL_DEFAULT,
    onChangeWordSearchDiagonal: (_store$board2 = store.board) === null || _store$board2 === void 0 ? void 0 : _store$board2.setDiagonal,
    wordSearchAllowedLetters: store.board ? store.board.allowed_letters : undefined,
    onChangeWordSearchAllowedLetters: (_store$board3 = store.board) === null || _store$board3 === void 0 ? void 0 : _store$board3.setAllowedLetters,
    wordSearchGetInvalidWordsByAllowedLetters: store.getInvalidWordsByAllowedLetters,
    showSelection: ((_store$ui_style2 = store.ui_style) === null || _store$ui_style2 === void 0 ? void 0 : _store$ui_style2.showSelection) !== undefined ? store.ui_style.showSelection : SHOW_SELECTION_DEFAULT,
    onChangeShowSelection: function onChangeShowSelection(value) {
      return store.ui_style.setShowSelection(value);
    },
    autoDrop: store === null || store === void 0 ? void 0 : (_store$ui_style3 = store.ui_style) === null || _store$ui_style3 === void 0 ? void 0 : _store$ui_style3.automatic_drop,
    setAutoDrop: store === null || store === void 0 ? void 0 : (_store$ui_style4 = store.ui_style) === null || _store$ui_style4 === void 0 ? void 0 : _store$ui_style4.setAutomaticDrop,
    showHotspots: (_store$ui_style5 = store.ui_style) === null || _store$ui_style5 === void 0 ? void 0 : _store$ui_style5.show_hotspots,
    setShowHotspots: (_store$ui_style6 = store.ui_style) === null || _store$ui_style6 === void 0 ? void 0 : _store$ui_style6.setShowHotspots,
    showDropIndicator: store.showDropIndicator,
    setShowDropIndicator: store.setShowDropIndicator,
    isVerticalOrientation: store.isVerticalOrientation,
    setIsVerticalOrientation: store.setIsVerticalOrientation,
    showAuthorVariantsEditor: config.showAuthorVariantsEditor
  });
};
EditorConfigStore.propTypes = {
  listConfigParams: propTypes.object
};
EditorConfigStore.defaultProps = {
  listConfigParams: {}
};
var EditorConfigStore$1 = observer(EditorConfigStore);

var DEFAULT_CONFIGS_BEGIN = [];
var DEFAULT_CONFIGS_END = [TYPES_CONFIG.CONFIG_VARIANT_STYLE];
function getConfigs(configsAditional, listConfigsHide) {
  if (listConfigsHide === void 0) {
    listConfigsHide = [];
  }
  var toRet = [].concat(DEFAULT_CONFIGS_BEGIN, configsAditional, DEFAULT_CONFIGS_END);
  if (listConfigsHide && listConfigsHide.length > 0) {
    toRet = toRet.filter(function (e) {
      return listConfigsHide.indexOf(e) <= -1;
    });
  }
  return toRet;
}

var EditorConfigStoreDefault = function EditorConfigStoreDefault(_ref) {
  var store = _ref.store,
    configsAditional = _ref.configsAditional,
    listConfigsHide = _ref.listConfigsHide,
    listConfigParams = _ref.listConfigParams,
    titleBox = _ref.titleBox,
    iconTitle = _ref.iconTitle,
    helpText = _ref.helpText,
    showSliderSizeThumbBackgrounImage = _ref.showSliderSizeThumbBackgrounImage,
    overwriteBackgroundTexts = _ref.overwriteBackgroundTexts,
    titleCheckIcon = _ref.titleCheckIcon,
    subtitleCheckIcon = _ref.subtitleCheckIcon;
  return /*#__PURE__*/React__default.createElement(EditorConfigStore$1, {
    listConfig: getConfigs(configsAditional, listConfigsHide),
    listConfigParams: listConfigParams,
    iconTitle: iconTitle,
    titleBox: titleBox,
    helpText: helpText,
    store: store,
    showSliderSizeThumbBackgrounImage: showSliderSizeThumbBackgrounImage,
    overwriteBackgroundTexts: overwriteBackgroundTexts,
    titleCheckIcon: titleCheckIcon,
    subtitleCheckIcon: subtitleCheckIcon
  });
};
EditorConfigStoreDefault.propTypes = {
  listConfigsHide: propTypes.arrayOf(propTypes.string),
  listConfigParams: propTypes.object
};
EditorConfigStoreDefault.defaultProps = {
  listConfigsHide: [],
  listConfigParams: {}
};
var EditorConfigStoreDefault$1 = observer(EditorConfigStoreDefault);

var EditorHollowComponent = function EditorHollowComponent() {
  return /*#__PURE__*/React__default.createElement("div", null);
};

function Hints(_ref) {
  var hints = _ref.hints;
  return !(hints !== null && hints !== void 0 && hints.currentHint) ? null : /*#__PURE__*/React__default.createElement(Dialog, {
    className: "lemo-hints-dialog",
    handleClose: hints.hideHint
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-hint"
  }, /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    className: "",
    content: hints.currentHint
  })));
}
var Hints$1 = observer(Hints);

var _excluded$3 = ["data", "defaultData", "lang", "basePath", "assetsQuestionApi", "assetsQuestionApiDrive"];
function useLemonadeQuestion(_ref) {
  var data = _ref.data,
    defaultData = _ref.defaultData,
    lang = _ref.lang,
    basePath = _ref.basePath,
    assetsQuestionApi = _ref.assetsQuestionApi,
    assetsQuestionApiDrive = _ref.assetsQuestionApiDrive,
    initialProps = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  var normalizedData = _extends({}, data, {
    reference: (data === null || data === void 0 ? void 0 : data.reference) || uuid()
  });
  var createExercise = function createExercise() {
    return getActivity({
      data: data && normalizedData,
      defaultData: defaultData,
      lang: lang,
      basePath: basePath,
      assetsQuestionApi: assetsQuestionApi,
      assetsQuestionApiDrive: assetsQuestionApiDrive,
      initialProps: initialProps
    });
  };
  var localState = useLocalObservable(function () {
    return {
      instance: createExercise(),
      updateExercise: function updateExercise(props) {
        this.instance = getActivity(_extends({}, props, {
          assetsQuestionApi: assetsQuestionApi,
          assetsQuestionApiDrive: assetsQuestionApiDrive,
          basePath: basePath
        }));
      },
      get questionWithHints() {
        var store = localState.instance.questionStore || localState.instance.store;
        return getQuestionWithHints({
          Question: this.instance.Question,
          questionStore: store
        });
      }
    };
  });
  return {
    exercise: {
      Controls: localState.instance.Controls,
      Question: localState.questionWithHints,
      questionApi: localState.instance.questionStore || localState.instance.store,
      Feedback: localState.instance.Feedback,
      SampleAnswer: localState.instance.SampleAnswer,
      PrintView: localState.instance.PrintView
    },
    updateExercise: localState.updateExercise
  };
}
function getQuestionWithHints(_ref2) {
  var Question = _ref2.Question,
    questionStore = _ref2.questionStore;
  return observer(function (props) {
    return /*#__PURE__*/React__default.createElement(Fragment$1, null, /*#__PURE__*/React__default.createElement(Question, props), /*#__PURE__*/React__default.createElement(Hints$1, {
      hints: questionStore.hints
    }));
  });
}

function SolutionPreview(_ref) {
  var store = _ref.store,
    idx = _ref.idx,
    onSolutionChanged = _ref.onSolutionChanged,
    updateEditor = _ref.updateEditor;
  var _useLemonadeQuestion = useLemonadeQuestion({
      data: store.output,
      lang: config.lang
    }),
    exercise = _useLemonadeQuestion.exercise,
    updateExercise = _useLemonadeQuestion.updateExercise;
  useEffect(function () {
    updateExercise({
      data: store.output,
      lang: config.lang
    });
    updateSolutionMode();
  }, [idx]);
  useEffect(function () {
    if (store.previewNeedUpdate && !areStoresEqual$1(store.output.data, exercise.questionApi.output.data)) {
      exercise.questionApi.hydrateSolutionsPreview(store.output, idx).then(function () {
        exercise.questionApi.setResponse(store.validation.solutionList[idx].value, idx);
      });
    }
    updateSolutionMode();
  }, [store.onUpdateNotifier]);
  useEffect(function () {
    if (isDeveloperMode()) {
      window.solutionStore = exercise.questionApi;
    }
    var disposer = addMiddleware(exercise.questionApi, function (call, next) {
      if (call.name === 'updateEditorStore') updateEditor(call.args);
      next(call);
    });
    updateSolutionMode();
    return function () {
      return disposer();
    };
  }, [exercise.questionApi]);
  var solutionChanged = useCallback(function () {
    onSolutionChanged(idx, exercise.questionApi.getUserResponse());
  }, [exercise.questionApi, idx, onSolutionChanged]);
  function updateSolutionMode() {
    if (exercise.questionApi && !exercise.questionApi.isSolutionMode && exercise.questionApi.setIsSolutionMode) exercise.questionApi.setIsSolutionMode(true);
  }
  return !isAlive(store) || idx >= store.validation.solutionList.length ? null : /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-solutions-preview"
  }, /*#__PURE__*/React__default.createElement(exercise.Question, {
    changed: solutionChanged,
    editorStore: store,
    response: store.validation.solutionList[idx].value,
    noHead: true,
    solutionsMode: true
  }));
}
function areStoresEqual$1(editor, solution) {
  var omittedKeys = ['type', 'title', 'feedback', 'attempts', 'stimulus', 'isEvaluable', 'validation', 'assetsQuestionApi', 'assetsEditorApi', 'assetsQuestionApiDrive', 'hints'];
  var normalize = function normalize(currentStore) {
    return JSON.stringify(omit(omittedKeys, currentStore));
  };
  return normalize(editor) === normalize(solution);
}
var SolutionPreview$1 = observer(SolutionPreview);

function SolutionTabs(_ref) {
  var store = _ref.store,
    selected = _ref.selected,
    setSelected = _ref.setSelected,
    addTab = _ref.addTab,
    _ref$showAddButton = _ref.showAddButton,
    showAddButton = _ref$showAddButton === void 0 ? true : _ref$showAddButton;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-solutions-tab-buttons lemo-editor-box-flex"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-solutions-box"
  }, store.validation.solutionList.map(function (item, idx) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: classNames('lemo-editor-solutions-tab-buttons-button', {
        'lemo-selected': idx === selected
      }),
      key: 'lemo-editor-solutions-tab-buttons-button_' + idx,
      onClick: function onClick() {
        return setSelected(idx);
      }
    }, translate('Solution') + " " + (idx === 0 ? '' : idx + 1));
  }), !store.validation.immediateFeedback && showAddButton && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-negative lemo-tab-menu__add-tab lemo-editor-solutions-tab-buttons-add",
    onClick: addTab
  }, /*#__PURE__*/React__default.createElement(SvgPlusCircle, {
    className: "lemo-icon",
    width: 24
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-add-alternative-text no-break"
  }, translate('solutions_new_alternative_text')))));
}
var SolutionTabs$1 = observer(SolutionTabs);

function ScoreInput(_ref) {
  var scoreVisibility = _ref.scoreVisibility,
    scoreDisabled = _ref.scoreDisabled,
    score = _ref.score,
    onChange = _ref.onChange,
    selected = _ref.selected;
  var scoreValue = parseInt(score * 100).toString();
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-solutions-tab-options-points",
    style: _extends({}, scoreVisibility)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classNames('lemo-editor-solutions-tab-options-points__percent-wrapper', {
      'lemo-editor-solutions-tab-options-points__percent-wrapper--disabled': scoreDisabled
    })
  }, /*#__PURE__*/React__default.createElement("input", {
    className: "lemo-editor-solutions-tab-options-points-score",
    type: "number",
    value: scoreValue,
    onChange: onChange,
    min: 0,
    disabled: scoreDisabled
  })), ' ', selected !== 0 && /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-editor-solutions-tab-options-points-label"
  }, translate('validation')));
}
ScoreInput.propTypes = {
  scoreVisibility: undefined,
  scoreDisabled: undefined,
  score: undefined,
  onChange: undefined,
  selected: undefined
};
var ScoreInput$1 = observer(ScoreInput);

function DeleteTabButton(props) {
  return /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-negative lemo-tab-menu__remove-tab lemo-editor-solutions-tab-options-delete",
    onClick: props.onClick
  }, /*#__PURE__*/React__default.createElement(SvgTrash$1, {
    width: "100%",
    fill: "white"
  }));
}
DeleteTabButton.propTypes = {
  onClick: undefined
};

function MainResponseButton(_ref) {
  var onClick = _ref.onClick,
    isMainResponse = _ref.isMainResponse;
  return /*#__PURE__*/React__default.createElement("button", {
    className: cn$1('lemo-main-response-button', {
      'lemo-selected': isMainResponse
    }),
    onClick: onClick,
    role: "button"
  }, /*#__PURE__*/React__default.createElement(CheckBoxSquareIcon, {
    checked: isMainResponse,
    boxSize: 20,
    iconSize: 9
  }), /*#__PURE__*/React__default.createElement("span", null, translate('main_response')));
}
MainResponseButton.propTypes = {
  onClick: undefined,
  isMainResponse: undefined
};
var MainResponseButton$1 = observer(MainResponseButton);

function SolutionOptions(_ref) {
  var scoreVisibility = _ref.scoreVisibility,
    scoreDisabled = _ref.scoreDisabled,
    score = _ref.score,
    onChange = _ref.onChange,
    selected = _ref.selected,
    deleteTab = _ref.deleteTab,
    hasMultipleSolutions = _ref.hasMultipleSolutions,
    setAsMainSolution = _ref.setAsMainSolution;
  var isMainResponse = selected === 0;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-solutions-tab-options"
  }, /*#__PURE__*/React__default.createElement(ScoreInput$1, {
    scoreVisibility: scoreVisibility,
    scoreDisabled: scoreDisabled,
    score: score,
    onChange: onChange,
    selected: selected
  }), hasMultipleSolutions && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-solution-controls"
  }, /*#__PURE__*/React__default.createElement(MainResponseButton$1, {
    isMainResponse: isMainResponse,
    onClick: setAsMainSolution
  }), !isMainResponse && /*#__PURE__*/React__default.createElement(DeleteTabButton, {
    onClick: deleteTab
  })));
}
SolutionOptions.propTypes = {
  scoreVisibility: undefined,
  scoreDisabled: undefined,
  score: undefined,
  onChange: undefined,
  selected: undefined,
  deleteTab: undefined,
  setAsMainSolution: undefined
};
var SolutionOptions$1 = observer(SolutionOptions);

function useSolutionsApi(store) {
  var _useState = useState(0),
    selected = _useState[0],
    setSelected = _useState[1];
  var solutionsLength = store.validation.solutionList.length;
  function selectTab(idx) {
    var _store$setActiveSolut;
    store === null || store === void 0 ? void 0 : (_store$setActiveSolut = store.setActiveSolutionIdx) === null || _store$setActiveSolut === void 0 ? void 0 : _store$setActiveSolut.call(store, idx);
    setSelected(idx);
  }
  var selectLastItem = function selectLastItem() {
    selectTab(store.validation.solutionList.length - 1);
  };
  var addTab = function addTab() {
    store.validation.createAlternativeSolution({
      value: store.validation.freshSolution,
      score: 1
    });
    selectLastItem();
  };
  window.setSolution = function (solution) {
    store.validation.updateSolution(0, solution);
  };
  var updateSolution = useCallback(function (idx, solution) {
    store.validation.updateSolution(idx, solution);
  }, [store.validation.updateSolution]);
  var updateEditor = useCallback(function (_ref) {
    var actionName = _ref[0],
      _ref$ = _ref[1],
      args = _ref$ === void 0 ? [] : _ref$;
    store.updateEditorStore(actionName, args);
  }, [store.updateEditorStore]);
  var removeTab = function removeTab(idx) {
    store.validation.removeSolution(idx);
    if (selected >= store.validation.solutionList.length) selectLastItem();
  };
  var changeScore = function changeScore(_ref2) {
    var target = _ref2.target;
    var val = target !== undefined && target.value !== undefined && Math.abs(target.value) >= 0 ? Math.abs(target.value) : 0;
    if (val > 100) val = 100;
    var scoreSave = val !== undefined && val > 0 ? roundToTwo(val * 0.01) : 0;
    store.validation.changeScore(selected, scoreSave);
  };
  useEffect(function () {
    var watchImmediateFeedback = reaction(function () {
      return store.validation.immediateFeedback;
    }, function (val) {
      return val && setSelected(0);
    });
    return function () {
      return watchImmediateFeedback();
    };
  }, []);
  useEffect(function () {
    if (solutionsLength === 1) {
      setSelected(0);
    }
  }, [solutionsLength]);
  return {
    addTab: addTab,
    updateSolution: updateSolution,
    updateEditor: updateEditor,
    removeTab: removeTab,
    changeScore: changeScore,
    selected: selected,
    selectTab: selectTab,
    solutionsLength: solutionsLength
  };
}

function Solutions(_ref) {
  var store = _ref.store,
    _ref$lang = _ref.lang,
    lang = _ref$lang === void 0 ? 'en' : _ref$lang,
    _ref$hasMultipleRespo = _ref.hasMultipleResponses,
    hasMultipleResponses = _ref$hasMultipleRespo === void 0 ? true : _ref$hasMultipleRespo,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  var _useSolutionsApi = useSolutionsApi(store),
    addTab = _useSolutionsApi.addTab,
    updateSolution = _useSolutionsApi.updateSolution,
    updateEditor = _useSolutionsApi.updateEditor,
    removeTab = _useSolutionsApi.removeTab,
    changeScore = _useSolutionsApi.changeScore,
    selected = _useSolutionsApi.selected,
    selectTab = _useSolutionsApi.selectTab,
    solutionsLength = _useSolutionsApi.solutionsLength;
  var scoreVisibility = !store.isEvaluable && {
    visibility: 'hidden'
  };
  var scoreDisabled = selected === 0;
  var setAsMainSolution = function setAsMainSolution() {
    var _store$validation;
    if (selected > 0 && store !== null && store !== void 0 && (_store$validation = store.validation) !== null && _store$validation !== void 0 && _store$validation.setAsMainSolution) {
      store.validation.setAsMainSolution(selected);
      selectTab(0);
    }
  };
  var currentSolution = selected !== undefined && store.validation.solutionList.length > selected ? store.validation.solutionList[selected] : store.validation.solutionList[0];
  return !store.isEvaluable ? null : /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-solutions-content"
  }, /*#__PURE__*/React__default.createElement(SolutionTabs$1, {
    store: store,
    selected: selected,
    setSelected: selectTab,
    addTab: addTab,
    showAddButton: hasMultipleResponses
  }), /*#__PURE__*/React__default.createElement(SolutionOptions$1, {
    scoreVisibility: scoreVisibility,
    scoreDisabled: scoreDisabled,
    score: currentSolution.score,
    hasMultipleSolutions: store.validation.alt_responses.length > 0,
    onChange: changeScore,
    selected: selected,
    validation: store.validation,
    deleteTab: function deleteTab() {
      return removeTab(selected);
    },
    setAsMainSolution: setAsMainSolution
  }), children ? /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-solutions-tab-content",
    key: "solutions_" + selected
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-solutions-preview"
  }, children)) : /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-solutions-tab-content"
  }, /*#__PURE__*/React__default.createElement(SolutionPreview$1, {
    store: store,
    lang: lang,
    idx: solutionsLength === 1 ? 0 : selected,
    onSolutionChanged: updateSolution,
    updateEditor: updateEditor
  })));
}
var Solutions$1 = observer(Solutions);

var itemList = Object.values(penaltyModes);
var translatedItemList = itemList.map(function (item) {
  return translate("penalty_mode_" + item.toLowerCase());
});
function PenaltyModes(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
  var selectedIndex = Math.max(itemList.findIndex(function (item) {
    return item === value;
  }), 0);
  var subtitle = translate("subtitle_penalty_mode_" + itemList[selectedIndex].toLowerCase());
  function _onChange(index) {
    onChange === null || onChange === void 0 ? void 0 : onChange(itemList[index]);
  }
  return /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('title_penalty_modes'),
    subtitle: subtitle,
    selectedIndex: selectedIndex,
    onChange: _onChange,
    itemList: translatedItemList
  });
}
var PenaltyModes$1 = observer(PenaltyModes);

var KEY_EVALUATION_TYPE_BEGIN = 'evaluation_type_';
var KEY_SUBTITLE_EVALUATION_TYPE_BEGIN = 'subtitle_evaluation_type_';
var keysTranslateEvaluationTypes = {
  EXACT_MATCH: KEY_EVALUATION_TYPE_BEGIN + 'exact_match',
  PARTIAL_MATCH: KEY_EVALUATION_TYPE_BEGIN + 'partial_match',
  MATCH_RESPONSE: KEY_EVALUATION_TYPE_BEGIN + 'match_response',
  MATCH_GROUP: KEY_EVALUATION_TYPE_BEGIN + 'match_group',
  MANUAL: KEY_EVALUATION_TYPE_BEGIN + 'manual'
};
var keysTranslateSubtitleEvaluationTypes = {
  EXACT_MATCH: KEY_SUBTITLE_EVALUATION_TYPE_BEGIN + 'exact_match',
  PARTIAL_MATCH: KEY_SUBTITLE_EVALUATION_TYPE_BEGIN + 'partial_match',
  MATCH_RESPONSE: KEY_SUBTITLE_EVALUATION_TYPE_BEGIN + 'match_response',
  MATCH_GROUP: KEY_SUBTITLE_EVALUATION_TYPE_BEGIN + 'match_group',
  MANUAL: KEY_SUBTITLE_EVALUATION_TYPE_BEGIN + 'manual'
};
function getEvaluationTypeOption(KeyTranslate, keyTranslateSubtitle, value) {
  return {
    keyTranslate: KeyTranslate,
    keyTranslateSubtitle: keyTranslateSubtitle,
    value: value
  };
}
function EvaluationType(_ref) {
  var evaluationType = _ref.evaluationType,
    evaluationTypes = _ref.evaluationTypes,
    onChange = _ref.onChange;
  var _useState = useState(evaluationTypes.map(function (item) {
      return translate(item.keyTranslate);
    })),
    itemList = _useState[0];
  var selectedIndex = useMemo(function () {
    return evaluationTypes.findIndex(function (item) {
      return item.value === evaluationType;
    });
  }, [evaluationType]);
  var subtitle = useMemo(function () {
    if (selectedIndex >= 0 && evaluationTypes && evaluationTypes[selectedIndex]) {
      return translate(evaluationTypes[selectedIndex].keyTranslateSubtitle);
    } else return '';
  }, [evaluationTypes, selectedIndex]);
  function _onChange(index) {
    if (evaluationTypes && index >= 0) {
      var valueChange = evaluationTypes[index].value;
      onChange && onChange(valueChange);
    }
  }
  return /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('title_evaluation_type'),
    subtitle: subtitle,
    selectedIndex: selectedIndex,
    onChange: _onChange,
    itemList: itemList
  });
}
EvaluationType.propTypes = {
  evaluationTypes: propTypes.array,
  subtitle: propTypes.string
};
EvaluationType.defaultProps = {
  evaluationTypes: []
};

function usePartialEvaluationDropdown(_ref) {
  var store = _ref.store,
    withPenaltyByResponse = _ref.withPenaltyByResponse,
    showPenalty = _ref.showPenalty;
  var isGroupValidation = store.raw.metadata.name === normalizedTypes.classify_classification.value && store.evaluationType === validationModes.PARTIAL_MATCH_V2;
  var isPartial = isEvaluationPartial(store.evaluationType);
  var showPenaltyOptions = isPartial && withPenaltyByResponse;
  var isCustomPenaltyMode = showPenaltyOptions && store.validation.penalty_mode === penaltyModes.CUSTOM;
  var isPartialWithoutPenaltyOptions = isPartial && !withPenaltyByResponse;
  var showPenaltyValue = showPenalty && !isGroupValidation && (isCustomPenaltyMode || isPartialWithoutPenaltyOptions);
  return {
    showPenaltyOptions: showPenaltyOptions,
    showPenaltyValue: showPenaltyValue
  };
}

var GROUPED_LAYOUT = 'grouped_layout';

function useFilterEvaluationTypes(_ref) {
  var layout = _ref.layout,
    evaluationTypes = _ref.evaluationTypes;
  if (layout === GROUPED_LAYOUT) {
    return evaluationTypes.filter(function (_ref2) {
      var value = _ref2.value;
      return value !== validationModes.MANUAL;
    });
  }
  return evaluationTypes;
}

var EditorSolutionsStore = function EditorSolutionsStore(_ref) {
  var store = _ref.store,
    withPenaltyByResponse = _ref.withPenaltyByResponse,
    showToggleIsEvaluable = _ref.showToggleIsEvaluable,
    showPenalty = _ref.showPenalty,
    evaluationTypes = _ref.evaluationTypes,
    subtitleEvaluationType = _ref.subtitleEvaluationType,
    showSolutions = _ref.showSolutions,
    _ref$helpText = _ref.helpText,
    helpText = _ref$helpText === void 0 ? translate('solutions_instructions') : _ref$helpText,
    hasMultipleResponses = _ref.hasMultipleResponses,
    componentButton = _ref.componentButton,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  var _usePartialEvaluation = usePartialEvaluationDropdown({
      store: store,
      showPenalty: showPenalty,
      withPenaltyByResponse: withPenaltyByResponse
    }),
    showPenaltyOptions = _usePartialEvaluation.showPenaltyOptions,
    showPenaltyValue = _usePartialEvaluation.showPenaltyValue;
  var filteredEvaluationTypes = useFilterEvaluationTypes({
    layout: store.raw.metadata.layout,
    evaluationTypes: evaluationTypes
  });
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "solutions",
    icon: /*#__PURE__*/React__default.createElement(ClipboardCheck, {
      width: "24"
    }),
    titleBox: translate('solutions'),
    helpText: helpText,
    classNameAdd: 'lemo-editor-solutions'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-horizontal-content-box"
  }, showToggleIsEvaluable && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-solutions__toggle-container"
  }, /*#__PURE__*/React__default.createElement(EvaluationType, {
    evaluationType: store.evaluationType,
    evaluationTypes: filteredEvaluationTypes,
    onChange: store.setEvaluationType,
    subtitle: subtitleEvaluationType
  })), showPenaltyOptions && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-solutions__penalty-modes-container"
  }, /*#__PURE__*/React__default.createElement(PenaltyModes$1, {
    value: store.validation.penalty_mode,
    onChange: store.validation.setPenaltyMode
  })), showPenaltyValue && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-solutions__custom-penalty-value-container"
  }, /*#__PURE__*/React__default.createElement(EditorSliderTitleSubtitle, {
    title: translate('solutions_penalty_title'),
    subtitle: translate('solutions_penalty_subtitle'),
    limitMin: 0,
    limitMax: 100,
    showLimitMin: false,
    max: store.validation.penalty * 100,
    onChangeMax: function onChangeMax(max) {
      return store.validation.setPenalty(max / 100);
    },
    decimals: 0,
    stringConcatValues: "%"
  })), showSolutions && /*#__PURE__*/React__default.createElement(Solutions$1, {
    hasMultipleResponses: hasMultipleResponses,
    store: store
  }, children), componentButton));
};
EditorSolutionsStore.propTypes = {
  store: propTypes.any,
  showToggleIsEvaluable: propTypes.bool,
  showPenalty: propTypes.bool,
  evaluationTypes: EvaluationType.propTypes.evaluationTypes,
  subtitleEvaluationType: EvaluationType.propTypes.subtitle,
  showSolutions: propTypes.bool
};
EditorSolutionsStore.defaultProps = {
  showToggleAutosizeResponse: false,
  showToggleIsEvaluable: true,
  showPenalty: true,
  evaluationTypes: [getEvaluationTypeOption(keysTranslateEvaluationTypes.EXACT_MATCH, keysTranslateSubtitleEvaluationTypes.EXACT_MATCH, validationModes.EXACT_MATCH), getEvaluationTypeOption(keysTranslateEvaluationTypes.PARTIAL_MATCH, keysTranslateSubtitleEvaluationTypes.PARTIAL_MATCH, validationModes.PARTIAL_MATCH_V2), getEvaluationTypeOption(keysTranslateEvaluationTypes.MANUAL, keysTranslateSubtitleEvaluationTypes.MANUAL, validationModes.MANUAL)],
  showSolutions: true
};
var EditorSolutionsStore$1 = observer(EditorSolutionsStore);

function useCheckedFeedbackIndividual(_ref) {
  var responsesFeedback = _ref.responsesFeedback;
  var _useState = useState(isFeedbacksIndividual(responsesFeedback)),
    isCheckedFeedbackIndividual = _useState[0],
    setIsCheckedFeedbackIndividual = _useState[1];
  return {
    isCheckedFeedbackIndividual: isCheckedFeedbackIndividual,
    setIsCheckedFeedbackIndividual: setIsCheckedFeedbackIndividual
  };
}

function useMultipleChoiseEditor(_ref) {
  var store = _ref.store,
    type = _ref.type;
  var _useCheckedFeedbackIn = useCheckedFeedbackIndividual({
      responsesFeedback: store.responsesFeedback
    }),
    isCheckedFeedbackIndividual = _useCheckedFeedbackIn.isCheckedFeedbackIndividual,
    setIsCheckedFeedbackIndividual = _useCheckedFeedbackIn.setIsCheckedFeedbackIndividual;
  var titleCheckIcon = null;
  var subtitleCheckIcon = null;
  if (type === types.multipleChoice.Single || type === types.multipleChoice.EmotionsSingle) {
    titleCheckIcon = translate('title_check_icon_single_choice');
    subtitleCheckIcon = translate('subtitle_check_icon_single_choice');
  } else if (type === types.multipleChoice.Multiple) {
    titleCheckIcon = translate('title_check_icon_multiple_choice');
    subtitleCheckIcon = translate('subtitle_check_icon_multiple_choice');
  }
  return {
    isCheckedFeedbackIndividual: isCheckedFeedbackIndividual,
    setIsCheckedFeedbackIndividual: setIsCheckedFeedbackIndividual,
    titleCheckIcon: titleCheckIcon,
    subtitleCheckIcon: subtitleCheckIcon
  };
}

var _excluded$4 = ["store", "changed", "type", "immediateFeedback"];
var MultipleChoiceEditor = function MultipleChoiceEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$4);
  var _useMultipleChoiseEdi = useMultipleChoiseEditor({
      store: store,
      type: type
    }),
    isCheckedFeedbackIndividual = _useMultipleChoiseEdi.isCheckedFeedbackIndividual,
    setIsCheckedFeedbackIndividual = _useMultipleChoiseEdi.setIsCheckedFeedbackIndividual,
    titleCheckIcon = _useMultipleChoiseEdi.titleCheckIcon,
    subtitleCheckIcon = _useMultipleChoiseEdi.subtitleCheckIcon;
  var isMultiple = type === types.multipleChoice.Multiple;
  var isEmotionsChoice = type === types.multipleChoice.EmotionsSingle;
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    changedHandlerDebugger: false,
    patternParticular: "setTitle|setStimulus|addOption|removeOption|setValidOption|shuffleOptions|updateValidation|sortOptions|setLabel|setShuffleOptions|setScore|setSelected|setValue|mute|setColumns|destroy|setShowCheckIcon|createAlternativeSolution|changeScore|updateSolution|removeSolution|setIsEvaluable|setBackground|setFeedback",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 1,
      haveFeedbackIndividual: true,
      showConfigFeedbacksIndividual: true,
      onChangeCheckedFeedbackIndividual: setIsCheckedFeedbackIndividual,
      feedbackIndividualLabelText: translate('Answer Option')
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 2,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref[EDITOR_COMPONENT_COMMON.BACKGROUND] = {
      order: 3
    }, _ref[EDITOR_COMPONENT_COMMON.CLEAR_ALL] = {
      order: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.CLEAR_ALL].order,
      hide: false
    }, _ref),
    immediateFeedback: immediateFeedback,
    onlyComponentsView: isEmotionsChoice ? ['TITLE', 'STIMULUS'] : undefined
  }), !isEmotionsChoice && /*#__PURE__*/React__default.createElement(EditorAnswerOptionsStore$1, {
    store: store,
    modelGetListString: "label",
    modelSetListString: "setLabel",
    showToggleShuffleOptions: false,
    showToggleDuplicateResponses: false,
    showFeedbackAnswer: false,
    helpText: translate('answer_options_help_multiple_choice'),
    showNumbersOptions: isCheckedFeedbackIndividual
  }), !isEmotionsChoice && /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    evaluationTypes: [getEvaluationTypeOption(keysTranslateEvaluationTypes.EXACT_MATCH, keysTranslateSubtitleEvaluationTypes.EXACT_MATCH, validationModes.EXACT_MATCH)].concat(isMultiple ? [getEvaluationTypeOption(keysTranslateEvaluationTypes.PARTIAL_MATCH, keysTranslateSubtitleEvaluationTypes.PARTIAL_MATCH, validationModes.PARTIAL_MATCH_V2)] : [], [getEvaluationTypeOption(keysTranslateEvaluationTypes.MANUAL, keysTranslateSubtitleEvaluationTypes.MANUAL, validationModes.MANUAL)]),
    withPenaltyByResponse: true,
    helpText: translate(type !== types.multipleChoice.Single && type !== types.multipleChoice.EmotionsSingle && type !== types.multipleChoice.TrueFalse && type !== types.multipleChoice.BlockLetter ? 'exact_math_or_partial_match_or_manual_solutions_help' : 'manual_or_alternative_solutions_help')
  }), !isEmotionsChoice && /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), !isEmotionsChoice && /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: [TYPES_CONFIG.CONFIG_SUFFLE_ANSWERS].concat(store.isMultipleChoiceBlock ? [] : [TYPES_CONFIG.CONFIG_SHOW_CHECK_ICON], [TYPES_CONFIG.CONFIG_BLOCK_STYLE, TYPES_CONFIG.CONFIG_COLUMNS]),
    titleCheckIcon: titleCheckIcon,
    subtitleCheckIcon: subtitleCheckIcon
  }));
};
var MultipleChoiceEditor$1 = observer(MultipleChoiceEditor);

var ExtraValuesModel = types$1.model({
  keyList: types$1.frozen({})
}).actions(function (state) {
  return {
    addKey: function addKey(key) {
      var _extends2;
      if (state.keyList.hasOwnProperty(key)) return true;
      state.keyList = _extends({}, state.keyList, (_extends2 = {}, _extends2[key] = {}, _extends2));
    },
    setValue: function setValue(pluginKey, valueKey, value) {
      var _extends3, _extends4;
      if (!state.keyList.hasOwnProperty(pluginKey)) state.addKey(pluginKey);
      state.keyList = _extends({}, state.keyList, (_extends4 = {}, _extends4[pluginKey] = _extends({}, state.keyList[pluginKey], (_extends3 = {}, _extends3[valueKey] = value, _extends3)), _extends4));
    }
  };
}).views(function (state) {
  return {
    getValue: function getValue(pluginKey, valueKey) {
      return defaultValue(pluginKey + "." + valueKey, state.keyList, undefined);
    }
  };
});
var ExtraValues = types$1.snapshotProcessor(ExtraValuesModel, {
  preProcessor: function preProcessor(sn) {
    if (sn === void 0) {
      sn = {};
    }
    return {
      keyList: sn
    };
  },
  postProcessor: function postProcessor(snapshot) {
    return {
      extraValues: snapshot.keyList
    };
  }
});

var AttachFilesEditorModel = types$1.compose(FileUploaderModel, types$1.model({}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      reaction(function () {
        return state.files.length;
      }, function () {
        state.send(false, true);
      });
      reaction(function () {
        return state.files.reduce(function (acc, next) {
          return next.status === fileStatuses.COMPLETE ? acc + 1 : acc;
        }, 0);
      }, function () {
        getParent(state).updateNotifier();
      });
    },
    clearAllFiles: function clearAllFiles() {
      state.files = [];
    },
    onDropRejected: function onDropRejected(files) {
      var errorCode = files[0].errors[0].code;
      if (files.length === 0) return;
      state.setError(when()["case"](errorCode === 'file-invalid-type', errorList.INVALID_TYPE)["case"](errorCode === 'file-too-large', errorList.MAX_SIZE_EXCEEDED).resolve(errorList.UNKNOWN_ERROR));
    }
  };
}).views(function (state) {
  return {
    get assetsEditorApi() {
      return getParent(state).assetsEditorApi;
    },
    get status() {
      var UPLOADING = fileStatuses.UPLOADING,
        ADDED = fileStatuses.ADDED,
        ERROR = fileStatuses.ERROR,
        START = fileStatuses.START;
      if (state.files.length === 0) return START;
      var currentStatus = state.files.map(function (f) {
        return f.status;
      });
      if (currentStatus.includes(ADDED)) return ADDED;
      if (currentStatus.includes(ERROR)) return ERROR;
      if (currentStatus.includes(UPLOADING)) return UPLOADING;
      return START;
    }
  };
}));

function importCommonValues$1(data) {
  var _data$extraValues = data.extraValues,
    extraValues = _data$extraValues === void 0 ? {} : _data$extraValues,
    response = data.response,
    title = data.title;
  var _data$data = data.data,
    stimulus = _data$data.stimulus,
    validation = _data$data.validation,
    ui_style = _data$data.ui_style,
    attempts = _data$data.attempts,
    feedback = _data$data.feedback,
    assetsQuestionApi = _data$data.assetsQuestionApi,
    assetsEditorApi = _data$data.assetsEditorApi,
    isEvaluable = _data$data.isEvaluable,
    scormData = _data$data.scormData,
    hints = _data$data.hints,
    sample_answer = _data$data.sample_answer,
    _data$data$attachment = _data$data.attachments,
    attachments = _data$data$attachment === void 0 ? [] : _data$data$attachment;
  return {
    stimulus: stimulus,
    validation: validation,
    ui_style: ui_style,
    attempts: attempts,
    feedback: feedback,
    assetsQuestionApi: assetsQuestionApi,
    assetsEditorApi: assetsEditorApi,
    isEvaluable: isEvaluable,
    scormData: scormData,
    responseFromData: response,
    hints: hints,
    sample_answer: sample_answer,
    title: title,
    extraValues: extraValues,
    attachments: {
      files: attachments
    },
    raw: _extends({}, data, {
      reference: (data === null || data === void 0 ? void 0 : data.reference) || uuid()
    })
  };
}
function exportCommonValues(state, values) {
  var _state$attachments, _window, _state$raw$data;
  var attachments = (state === null || state === void 0 ? void 0 : (_state$attachments = state.attachments) === null || _state$attachments === void 0 ? void 0 : _state$attachments.files) || [];
  return _extends({}, state.raw, {
    title: state.title,
    reference: state.raw.reference,
    type: state.raw.type,
    lemonadeVersion: (_window = window) === null || _window === void 0 ? void 0 : _window.lemonadeVersion
  }, safeSnapshot(state.extraValues), {
    data: _extends({}, state.raw.data, {
      stimulus: state.stimulus,
      attachments: attachments.map(function (file) {
        return safeSnapshot(file);
      }),
      validation: state.validation ? safeSnapshot(state.validation) : undefined,
      isEvaluable: state.isEvaluable
    }, state.attempts ? {
      attempts: safeSnapshot(state.attempts)
    } : {}, {
      hints: safeSnapshot(state.hints),
      feedback: safeSnapshot(state.feedback)
    }, (state.sample_answer || ((_state$raw$data = state.raw.data) === null || _state$raw$data === void 0 ? void 0 : _state$raw$data.sample_answer)) && {
      sample_answer: state.sample_answer
    }, state.ui_style && {
      ui_style: safeSnapshot(state.ui_style)
    }, values)
  });
}

var EditorBaseModel = types$1.compose(withCommonParams, types$1.model({
  title: types$1.optional(types$1.string, ''),
  stimulus: types$1.optional(types$1.string, ''),
  extraValues: ExtraValues,
  isEvaluable: types$1.optional(types$1["boolean"], true),
  feedback: types$1.optional(FeedbackModel, initialValue$1),
  validation: types$1.maybe(ValidationModel),
  assetsEditorApi: types$1.maybe(types$1.string),
  hints: types$1.maybe(HintsModel$1),
  onUpdateNotifier: types$1.optional(types$1.number, function () {
    return Date.now();
  }),
  onUpdateQuestionPreview: types$1.optional(types$1.number, function () {
    return Date.now();
  }),
  raw: types$1.frozen(),
  attachments: types$1.optional(AttachFilesEditorModel, {}),
  previewNeedUpdate: true,
  questionNeedUpdate: true
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      onAction(state, function (_ref) {
        var name = _ref.name,
          path = _ref.path;
        if (path.match('/validation')) {
          state.updateQuestionPreview();
        }
        if (name.match('setShuffleOptions|setFeedback|setVariant|setMaxLength|setButton|setMinFiles|setMaxFiles|sortDrags')) {
          state.updateQuestionPreview();
        }
      }, true);
    },
    lemoFastUpdate: function lemoFastUpdate(fn) {
      fn();
    },
    updateNotifier: function updateNotifier(previewNeedUpdate, questionNeedUpdate) {
      if (previewNeedUpdate === void 0) {
        previewNeedUpdate = true;
      }
      if (questionNeedUpdate === void 0) {
        questionNeedUpdate = true;
      }
      state.onUpdateNotifier = Date.now();
      state.previewNeedUpdate = previewNeedUpdate;
      state.questionNeedUpdate = questionNeedUpdate;
    },
    updateQuestionPreview: function updateQuestionPreview() {
      state.onUpdateQuestionPreview = Date.now();
    },
    setTitle: function setTitle(val) {
      state.title = val;
    },
    setStimulus: function setStimulus(val) {
      state.stimulus = val;
      state.updateNotifier();
    },
    setDisabled: function setDisabled(bool) {
      state._disabled = bool;
    },
    setAssetsEditorApi: function setAssetsEditorApi(assetsEditorApi) {
      state.assetsEditorApi = assetsEditorApi;
    },
    setData: function setData(data) {
      var activityData = typeof data === 'string' ? JSON.parse(data) : data;
      applySnapshot(state, activityData);
    },
    setIsEvaluable: function setIsEvaluable(isEvaluable) {
      state.isEvaluable = isEvaluable;
      state.updateQuestionPreview();
    },
    setFeedback: function setFeedback(feedback) {
      state.feedback = feedback;
    },
    setEvaluationType: function setEvaluationType(val) {
      if (val === validationModes.MANUAL) {
        state.setIsEvaluable(false);
        state.validation.setScoringType(validationModes.MANUAL);
      } else {
        state.setIsEvaluable(true);
        state.validation.setScoringType(val);
      }
      if (!isEvaluationPartial(val)) {
        state.validation.setPenalty(0);
      }
    },
    setCommonParams: function setCommonParams(params) {
      var assetsEditorApi = params.assetsEditorApi;
      state.setCommonParamsFn(params);
      state.setAssetsEditorApi(assetsEditorApi);
    },
    clearAllBase: function clearAllBase() {
      state.setTitle('');
      state.setStimulus('');
      state.setFeedback(initialValue$1);
      state.validation.clearAllSolutions();
      state.hints && state.hints.resetHints();
    }
  };
}).views(function (state) {
  return {
    get isEditor() {
      return true;
    },
    createSnapshot: function createSnapshot(rawData) {
      throw new Error('Abstract method createSnapshot not implemented');
    },
    get reference() {
      return state.raw.reference;
    },
    get name() {
      return state.raw.metadata.name;
    },
    getSolutions: function getSolutions() {
      return '';
    },
    get variants() {
      var typology = state.raw.metadata.name;
      return Object.entries(defaultValue("variants." + typology, config, [])).map(function (_ref2) {
        var key = _ref2[0],
          value = _ref2[1];
        return {
          name: key,
          value: value
        };
      });
    },
    get evaluationType() {
      if (!state.isEvaluable) {
        return validationModes.MANUAL;
      } else {
        return state.validation.scoring_type;
      }
    },
    get AIFeedbackBody() {
      var questionData = JSON.stringify(state.output);
      return _extends({}, AIFeedbackGeneratorBody, {
        prompt: AIFeedbackGeneratorBody.prompt + questionData
      });
    }
  };
}));

function getPoints(_ref) {
  var validationModel = _ref.validationModel,
    activityResults = _ref.activityResults,
    alternativePoints = _ref.alternativePoints;
  var rightAnswers = activityResults.rightAnswers,
    answered = activityResults.answered,
    wrong = activityResults.wrong;
  var score = validationModel.score,
    scoring_type = validationModel.scoring_type,
    _validationModel$pena = validationModel.penalty,
    penalty = _validationModel$pena === void 0 ? 0 : _validationModel$pena;
  var EXACT_MATCH = validationModes.EXACT_MATCH,
    PARTIAL_MATCH = validationModes.PARTIAL_MATCH,
    PARTIAL_MATCH_V2 = validationModes.PARTIAL_MATCH_V2;
  var validate = function validate(evaluationFn) {
    return when()["case"](wrong === 0, function () {
      return evaluationFn();
    })["case"](alternativePoints > 0, function () {
      return alternativePoints;
    }).resolve(function () {
      return evaluationFn();
    });
  };
  var onExactMatch = function onExactMatch() {
    return validate(function () {
      return rightAnswers === answered && wrong === 0 ? score : 0;
    });
  };
  var onPartialMatch = function onPartialMatch() {
    return Math.max(answered * score - wrong * penalty, 0);
  };
  var onPartialMatchV2 = function onPartialMatchV2() {
    return Math.max(score / (rightAnswers + wrong) * rightAnswers - wrong * penalty, 0);
  };
  return when()["case"](scoring_type === EXACT_MATCH, function () {
    return onExactMatch();
  })["case"](scoring_type === PARTIAL_MATCH, function () {
    return onPartialMatch();
  })["case"](scoring_type === PARTIAL_MATCH_V2, function () {
    return onPartialMatchV2();
  }).resolve(function () {
    return 0;
  });
}

var withHidrateQuestionPreviewLemonadeBaseModel = types$1.model({}).actions(function (state) {
  return {
    hydrateQuestionPreview: function hydrateQuestionPreview(rawData) {
      return hydrateQuestionPreviewFn(state, rawData, true);
    }
  };
});

var LemonadeBaseModel = types$1.compose(withCommonParams, withShowSolutions, withHidrateQuestionPreviewLemonadeBaseModel, types$1.model({
  title: types$1.optional(types$1.string, ''),
  stimulus: types$1.optional(types$1.string, ''),
  isEvaluated: types$1.optional(types$1["boolean"], false),
  _disabled: types$1.optional(types$1["boolean"], false),
  extraValues: ExtraValues,
  isEvaluable: types$1.optional(types$1["boolean"], true),
  feedback: types$1.optional(FeedbackModel, initialValue$1),
  attempts: types$1.optional(AttemptsModel$1, initialValue),
  validation: types$1.maybe(ValidationModel),
  assetsQuestionApi: types$1.maybe(types$1.string),
  assetsEditorApi: types$1.maybe(types$1.string),
  hints: types$1.maybe(HintsModel$1),
  onUpdateNotifier: types$1.optional(types$1.number, function () {
    return Date.now();
  }),
  onUpdateQuestionPreview: types$1.optional(types$1.number, function () {
    return Date.now();
  }),
  responseFromData: types$1.maybe(ResponseFromDataModel),
  raw: types$1.frozen(),
  attachments: types$1.optional(AttachFilesEditorModel, {}),
  previewNeedUpdate: true,
  questionNeedUpdate: true,
  isSolutionMode: false,
  questionContext: types$1.optional(ContextModel, {})
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      onAction(state, function (_ref) {
        var name = _ref.name,
          path = _ref.path;
        if (path.match('/validation')) {
          state.updateQuestionPreview();
        }
        if (name.match('setShuffleOptions|setFeedback|setVariant|setMaxLength|setButton|setMinFiles|setMaxFiles|sortDrags')) {
          state.updateQuestionPreview();
        }
      }, true);
    },
    lemoFastUpdate: function lemoFastUpdate(fn) {
      fn();
    },
    updateEditorStore: function updateEditorStore(actionName, args) {
      state[actionName].apply(state, args);
      state.updateNotifier(false);
    },
    updateNotifier: function updateNotifier(previewNeedUpdate, questionNeedUpdate) {
      if (previewNeedUpdate === void 0) {
        previewNeedUpdate = true;
      }
      if (questionNeedUpdate === void 0) {
        questionNeedUpdate = true;
      }
      state.onUpdateNotifier = Date.now();
      state.previewNeedUpdate = previewNeedUpdate;
      state.questionNeedUpdate = questionNeedUpdate;
    },
    updateQuestionPreview: function updateQuestionPreview() {
      state.onUpdateQuestionPreview = Date.now();
    },
    setTitle: function setTitle(val) {
      state.title = val;
    },
    setStimulus: function setStimulus(val) {
      state.stimulus = val;
      state.updateNotifier();
    },
    setContext: function setContext(context) {
      state.questionContext.setStatus(context);
    },
    setDisabled: function setDisabled(bool) {
      state._disabled = bool;
    },
    setAssetsQuestionApi: function setAssetsQuestionApi(assetsQuestionApi) {
      if (assetsQuestionApi === void 0) {
        assetsQuestionApi = '';
      }
      state.assetsQuestionApi = assetsQuestionApi;
    },
    setAssetsEditorApi: function setAssetsEditorApi(assetsEditorApi) {
      if (assetsEditorApi === void 0) {
        assetsEditorApi = '';
      }
      state.assetsEditorApi = assetsEditorApi;
    },
    checkAnswers: function checkAnswers() {
      state.isEvaluated = true;
      state.attempts.addAttempt();
      state.commitResponseFeedback && state.commitResponseFeedback();
    },
    baseReset: function baseReset() {
      state.isEvaluated = false;
      state.showSolution = false;
      state.tempResponse = [];
    },
    setEvaluated: function setEvaluated(bool) {
      state.isEvaluated = bool;
    },
    setData: function setData(data) {
      var activityData = typeof data === 'string' ? JSON.parse(data) : data;
      applySnapshot(state, activityData);
    },
    setIsEvaluable: function setIsEvaluable(isEvaluable) {
      state.isEvaluable = isEvaluable;
      state.updateQuestionPreview();
    },
    setFeedback: function setFeedback(feedback) {
      state.feedback = feedback;
    },
    setIsSolutionMode: function setIsSolutionMode(isSolutionMode) {
      state.isSolutionMode = isSolutionMode;
    },
    setEvaluationType: function setEvaluationType(val) {
      if (val === validationModes.MANUAL) {
        state.setIsEvaluable(false);
        state.validation.setScoringType(validationModes.MANUAL);
      } else {
        state.setIsEvaluable(true);
        state.validation.setScoringType(val);
      }
      if (!isEvaluationPartial(val)) {
        state.validation.setPenalty(0);
      }
    },
    clearAllSolutions: function clearAllSolutions() {
      if (typeof state.validation.value === 'string') {
        state.validation.setValue('');
      } else {
        throw new Error('Abstract method clearAllSolutions not implemented');
      }
      state.validation.removeAltResponses();
    },
    setCommonParams: function setCommonParams(params) {
      var assetsQuestionApi = params.assetsQuestionApi,
        assetsEditorApi = params.assetsEditorApi;
      state.setCommonParamsFn(params);
      state.setAssetsQuestionApi(assetsQuestionApi);
      state.setAssetsEditorApi(assetsEditorApi);
    }
  };
}).views(function (state) {
  return {
    getUserResponse: function getUserResponse() {
      throw new Error('Abstract method getUserResponse not implemented');
    },
    getResults: function getResults() {
      console.log('Abstract method getResults not implemented');
    },
    createSnapshot: function createSnapshot(rawData) {
      throw new Error('Abstract method createSnapshot not implemented');
    },
    get reference() {
      return state.raw.reference;
    },
    get disabled() {
      return state._disabled || state.isEvaluated;
    },
    get name() {
      return state.raw.metadata.name;
    },
    get points() {
      return when()["case"](!state.isEvaluable, function () {
        return -1;
      })["case"](!state.validation, function () {
        return 1;
      })["case"](state.showSolution, function () {
        return state.cachePoints;
      }).resolve(function () {
        return getPoints({
          validationModel: state.validation,
          activityResults: state.getResults(),
          alternativePoints: state.alternativePoints
        });
      });
    },
    getSolutions: function getSolutions() {
      return '';
    },
    getScore: function getScore() {
      return when()["case"](!state.isEvaluable, function () {
        return {
          score: -1,
          max_score: -1
        };
      })["case"](!state.validation, function () {
        return {
          score: 1,
          max_score: 1
        };
      }).resolve(function () {
        return {
          score: state.points,
          max_score: state.validation.score
        };
      });
    },
    getResponse: function getResponse() {
      var _state$validation;
      return _extends({
        reference: state.raw.reference,
        type: state.raw.metadata.name,
        apiVersion: currentVersion,
        revision: 1,
        value: state.getUserResponse(),
        scoring_type: (state === null || state === void 0 ? void 0 : (_state$validation = state.validation) === null || _state$validation === void 0 ? void 0 : _state$validation.scoring_type) || validationModes.MANUAL
      }, state.getScore());
    },
    getResponseWithKey: function getResponseWithKey() {
      var _ref2;
      return _ref2 = {}, _ref2[state.raw.reference] = state.getResponse(), _ref2;
    },
    get withMath() {
      return state.normalization && state.normalization.isMath;
    },
    get variants() {
      var typology = state.raw.metadata.name;
      return Object.entries(defaultValue("variants." + typology, config, [])).map(function (_ref3) {
        var key = _ref3[0],
          value = _ref3[1];
        return {
          name: key,
          value: value
        };
      });
    },
    get evaluationType() {
      if (!state.isEvaluable) {
        return validationModes.MANUAL;
      } else {
        return state.validation.scoring_type;
      }
    },
    get hasResponse() {
      var _state$responseFromDa;
      return (_state$responseFromDa = state.responseFromData) === null || _state$responseFromDa === void 0 ? void 0 : _state$responseFromDa.value;
    },
    get context() {
      return state.questionContext.status;
    },
    get AIFeedbackBody() {
      var questionData = JSON.stringify(state.output);
      return _extends({}, AIFeedbackGeneratorBody, {
        prompt: AIFeedbackGeneratorBody.prompt + questionData
      });
    }
  };
}));

function hydrateKeys(newValues, state, ignoredKeys) {
  if (ignoredKeys === void 0) {
    ignoredKeys = [];
  }
  Object.keys(omit(ignoredKeys, newValues)).forEach(function (key) {
    if (safeSnapshot(state[key]) !== newValues[key]) state[key] = newValues[key];
  });
}

var ImageModel = types$1.model({
  src: types$1.string,
  width: types$1.optional(types$1.number, -1),
  height: types$1.optional(types$1.number, -1),
  alt: types$1.optional(types$1.string, ''),
  title: types$1.optional(types$1.string, ''),
  percent: types$1.optional(types$1.number, 1)
}).actions(function (state) {
  return {
    setPercent: function setPercent(percent) {
      state.percent = percent;
    },
    setSrc: function setSrc(src) {
      state.src = src;
    },
    setWidth: function setWidth(width) {
      state.width = width;
    },
    setHeight: function setHeight(height) {
      state.height = height;
    },
    setSize: function setSize(_ref) {
      var width = _ref.width,
        height = _ref.height;
      state.width = width;
      state.height = height;
    },
    setAlt: function setAlt(alt) {
      state.alt = alt;
    },
    setTitle: function setTitle(title) {
      state.title = title;
    },
    hydrate: function hydrate(data) {
      hydrateKeys(data, state);
    }
  };
});

var BackgroundModel = types$1.compose(ImageModel, types$1.model({
  position: types$1.string,
  size: types$1.string
}).actions(function (state) {
  return {
    setPosition: function setPosition(val) {
      state.position = val;
    },
    setSize: function setSize(val) {
      state.size = val;
    }
  };
}));
var BackgroundModel$1 = types$1.snapshotProcessor(BackgroundModel, {
  preProcessor: function preProcessor(sn) {
    return _extends({}, getBackgroundToSnapshot(sn));
  },
  postProcessor: function postProcessor(sn) {
    return _extends({}, getBackgroundToOutput(sn));
  }
});
function getBackgroundToOutput(backgroundState) {
  return backgroundState ? {
    src: backgroundState.src,
    alt: backgroundState.alt,
    position: backgroundState.position,
    size: backgroundState.size
  } : backgroundState;
}
function getBackgroundToSnapshot(sn) {
  return getBackgroundToOutput(sn);
}

var VariantsModel = types$1.model({
  variant: types$1.optional(types$1.string, ''),
  classList: types$1.optional(types$1.array(types$1.string), []),
  raw: types$1.optional(types$1.string, '')
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      reaction(function () {
        return state.raw;
      }, function () {
        return state.updateVariantAndClassList();
      });
      state.updateVariantAndClassList();
    },
    updateVariantAndClassList: function updateVariantAndClassList() {
      var variants = getParent(state, 2).variants;
      if (variants) {
        var variantList = variants.map(function (v) {
          return v.value;
        });
        var classes = state.raw.split(' ').reduce(function (acc, next) {
          if (acc.variant.length === 0 && variantList.includes(next)) {
            return {
              variant: next,
              classList: acc.classList
            };
          } else {
            return {
              variant: acc.variant,
              classList: [].concat(acc.classList, [next])
            };
          }
        }, {
          variant: '',
          classList: []
        });
        state.variant = classes.variant;
        state.classList = classes.classList.length > 0 && classes.classList[0] === '' ? [] : classes.classList;
      }
    },
    setVariant: function setVariant(variant) {
      var _getParent, _getParent$updateNoti;
      state.variant = variant;
      (_getParent = getParent(state, 2)) === null || _getParent === void 0 ? void 0 : (_getParent$updateNoti = _getParent.updateNotifier) === null || _getParent$updateNoti === void 0 ? void 0 : _getParent$updateNoti.call(_getParent);
    },
    setClassList: function setClassList(classList) {
      state.classList = classList;
    }
  };
}).views(function (state) {
  return {
    get hasValue() {
      return state.variant.length > 0 || state.classList.length > 0;
    },
    contains: function contains(className) {
      return state.variant === className || state.classList.includes(className);
    }
  };
});
var VariantsModel$1 = types$1.snapshotProcessor(VariantsModel, {
  preProcessor: function preProcessor(sn) {
    return {
      raw: sn
    };
  },
  postProcessor: function postProcessor(sn) {
    var arrayJoin = [];
    if (hasData(sn.variant)) arrayJoin.push(sn.variant);
    arrayJoin.push.apply(arrayJoin, sn.classList);
    return arrayJoin.join(' ');
  }
});

var BlockLetter = types.multipleChoice.BlockLetter;
var BaseModel = types$1.model({
  type: types$1.maybe(types$1.string),
  columns: types$1.optional(types$1.number, 1),
  labelType: types$1.optional(types$1.enumeration(Object.values(labelTypes)), labelTypes.NONE),
  customClass: types$1.maybe(VariantsModel$1),
  background: types$1.maybe(BackgroundModel$1),
  inlineFeedback: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    setLabelType: function setLabelType(labelType) {
      state.labelType = labelType;
      getParent(state).updateNotifier();
    },
    setType: function setType(type) {
      state.type = type;
    },
    setColumns: function setColumns(columns) {
      state.columns = parseInt(columns, 10);
      getParent(state).updateNotifier();
    },
    setBackground: function setBackground(background) {
      state.background = background;
    },
    hydrate: function hydrate(data) {
      state.columns = data.columns;
      state.labelType = data.labelType;
    }
  };
}).views(function (state) {
  return {
    get columnCount() {
      return "lemo-column-" + state.columns;
    },
    get hasLabels() {
      return state.labelType !== labelTypes.NONE && state.type !== BlockLetter;
    }
  };
});
var UIStyleModel = types$1.snapshotProcessor(BaseModel, {
  preProcessor: function preProcessor(sn) {
    return _extends({}, sn);
  },
  postProcessor: function postProcessor(sn) {
    return _extends({}, sn, {
      type: sn.type || 'horizontal',
      columns: sn.columns,
      labelType: sn.labelType,
      customClass: sn.customClass
    });
  }
});

var MultipleChoiceStore = types$1.compose(EditorBaseModel, withElementFeedbackParent('options'), types$1.model({
  options: types$1.array(OptionModel$1),
  showCheckIcon: types$1.optional(types$1["boolean"], true),
  shuffle_options: types$1.optional(types$1["boolean"], false),
  ui_style: UIStyleModel
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      onAction(state, function (_ref) {
        var path = _ref.path,
          name = _ref.name;
        if (path.match(/options/) && name === 'setLabel') {
          state.updateNotifier();
        }
      }, true);
    },
    addOption: function addOption(option) {
      var indexLabel = state.options ? ' ' + (state.options.length + 1) : '';
      var label = (option === null || option === void 0 ? void 0 : option.label) || translate('option') + indexLabel;
      state.options.push({
        label: label,
        value: state.lastOptionIndex.toString()
      });
      state.updateNotifier();
    },
    removeOption: function removeOption(option) {
      state.validation.removeValue(option.value);
      destroy(option);
      state.updateNotifier();
    },
    setShuffleOptions: function setShuffleOptions(bool) {
      state.shuffle_options = bool;
    },
    setShowCheckIcon: function setShowCheckIcon(bool) {
      state.showCheckIcon = bool;
      state.updateNotifier();
    },
    updateValidation: function updateValidation(value) {
      state.validation.value = value;
    },
    sortOptions: function sortOptions(source, destination) {
      state.options = sortArrayItem(source, destination, state.options);
      state.updateNotifier();
    },
    clearAllSolutions: function clearAllSolutions() {
      state.validation.setValue([]);
      state.validation.removeAltResponses();
    },
    clearAll: function clearAll() {
      state.clearAllBase();
      state.clearAllSolutions();
      state.options.clear();
      state.updateNotifier();
    }
  };
}).views(function (state) {
  return {
    get multiple_responses() {
      var _state$raw$data;
      return ((_state$raw$data = state.raw.data) === null || _state$raw$data === void 0 ? void 0 : _state$raw$data.multiple_responses) || false;
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$3(rawData);
    },
    getOptionByLabel: function getOptionByLabel(val) {
      return state.options.find(function (o) {
        return o.label === val;
      });
    },
    get lastOptionIndex() {
      return state.options.reduce(function (acc, next) {
        return parseInt(next.value) > acc ? parseInt(next.value) : acc;
      }, 0) + 1;
    },
    get optionList() {
      return state.optionsOrder.map(function (idx) {
        return state.options[idx];
      });
    },
    get isMultipleChoiceBlock() {
      return state.raw.metadata.name === types.multipleChoice.BlockLetter;
    },
    get output() {
      return exportCommonValues(state, {
        options: state.options.map(function (_ref2) {
          var label = _ref2.label,
            value = _ref2.value,
            feedback = _ref2.feedback;
          return {
            label: label,
            value: value,
            feedback: feedback
          };
        }),
        shuffle_options: state.shuffle_options,
        showCheckIcon: state.showCheckIcon
      });
    }
  };
}));
var createOptions$1 = function createOptions(arr) {
  return arr.map(function (item) {
    return _extends({}, item, {
      value: item.value.toString(),
      selected: false
    });
  });
};
function _createSnapshot$3(data) {
  var options = data.data.options;
  return _extends({}, data.data, importCommonValues$1(data), {
    options: createOptions$1(options)
  });
}
function createStore$3(data) {
  return MultipleChoiceStore.create(_createSnapshot$3(data));
}

function getMultipleChoice(props) {
  var _getCreator = getCreator(props, getDefaultData$6, types.multipleChoice.Multiple),
    type = _getCreator.type,
    initialProps = _getCreator.initialProps,
    exerciseData = _getCreator.exerciseData,
    setCommonParamsStore = _getCreator.setCommonParamsStore;
  var questionStore = createStore$2(exerciseData);
  setCommonParamsStore(questionStore);
  var editorStore = createStore$3(exerciseData);
  setCommonParamsStore(editorStore);
  return createMultipleChoice({
    editorStore: editorStore,
    questionStore: questionStore,
    initialProps: initialProps,
    type: type
  });
}
function createMultipleChoice(_ref) {
  var editorStore = _ref.editorStore,
    questionStore = _ref.questionStore,
    initialProps = _ref.initialProps,
    type = _ref.type;
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(MultipleChoiceQuestion$1, _extends({
        store: questionStore,
        type: type
      }, initialProps, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(MultipleChoiceEditor$1, _extends({
        store: editorStore,
        type: type
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}

function RowItem(_ref) {
  var _ref$firstCellWidth = _ref.firstCellWidth,
    firstCellWidth = _ref$firstCellWidth === void 0 ? 'auto' : _ref$firstCellWidth,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var numChildren = React__default.Children.count(children) - 1;
  var cellWidth = firstCellWidth === 'auto' ? 'auto' : firstCellWidth.toString() + 'px';
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1(className, 'lemo-table-grid'),
    style: {
      gridTemplateColumns: cellWidth + " repeat(" + numChildren + ", minmax(120px, 20%)"
    }
  }, children);
}

function TableHeader(_ref) {
  var options = _ref.options,
    firstCellWidth = _ref.firstCellWidth;
  return /*#__PURE__*/React__default.createElement(RowItem, {
    className: "lemo-table-header",
    firstCellWidth: firstCellWidth
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-row-cell"
  }, "\xA0"), options.map(function (option) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: option.label + "__" + option.idx,
      className: "lemo-row-cell"
    }, /*#__PURE__*/React__default.createElement(HTMLContent$1, {
      className: "lemo-text-body-m-regular lemo-color-text-02 lemo-text-center",
      content: option.label
    }));
  }));
}

function ChoiceItem(_ref) {
  var label = _ref.label,
    isSelected = _ref.isSelected,
    isError = _ref.isError,
    Icon = _ref.Icon;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-choice-item"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    checked: isSelected,
    checkedShowIconX: isSelected && isError,
    isError: isError
  }), label && /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    content: label,
    className: "lemo-question-response-value lemo-text-body-m-regular lemo-color-text-02"
  }));
}
var ChoiceItem$1 = observer(ChoiceItem);

function ChoiceOptionWrapper(_ref) {
  var option = _ref.option,
    question = _ref.question,
    showLabel = _ref.showLabel,
    isDisabled = _ref.isDisabled,
    isMultiple = _ref.isMultiple;
  var isError = question.getOptionError(option.index);
  var isSuccess = question.getOptionSuccess(option.index);
  var Icon = isMultiple ? CheckBoxSquareIcon : CheckBoxRoundedIcon;
  var handleClick = useCallback(function (idx) {
    if (isDisabled) return false;
    return isMultiple ? question.addValue(idx) : question.setValue([idx]);
  }, [isDisabled, isMultiple, question]);
  return /*#__PURE__*/React__default.createElement("div", {
    key: option.id,
    "data-testid": "response_" + question.index + "_" + option.index,
    className: classNames('lemo-question-response lemo-row-cell', {
      'lemo-selected': question.selected[option.index],
      'lemo-success': isSuccess,
      'lemo-error': isError,
      'lemo-disabled': isDisabled
    }),
    onClick: function onClick() {
      return handleClick(option.index);
    }
  }, /*#__PURE__*/React__default.createElement(ChoiceItem$1, {
    label: showLabel ? option.label : undefined,
    isSelected: question.selected[option.index],
    isError: isError,
    Icon: Icon
  }));
}
var ChoiceOptionWrapper$1 = observer(ChoiceOptionWrapper);

function TableBodyItem(_ref) {
  var question = _ref.question,
    showLabels = _ref.showLabels,
    isDisabled = _ref.isDisabled,
    options = _ref.options,
    isMultiple = _ref.isMultiple,
    firstCellWidth = _ref.firstCellWidth;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn('lemo-table-body-item', {
      'lemo-row-success': question.isSuccess,
      'lemo-row-error': question.isWrong && !question.isEmptyResponse
    })
  }, /*#__PURE__*/React__default.createElement(RowItem, {
    firstCellWidth: firstCellWidth
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-stem lemo-row-cell"
  }, /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    className: "lemo-question-stem-content lemo-text-body-m-regular lemo-color-text-02",
    content: question.stem
  })), options.map(function (option) {
    return /*#__PURE__*/React__default.createElement(ChoiceOptionWrapper$1, {
      key: option.label + "__" + option.idx,
      option: option,
      question: question,
      showLabel: showLabels,
      isDisabled: isDisabled,
      isMultiple: isMultiple
    });
  })), question.withPin && question.isWrongCache && /*#__PURE__*/React__default.createElement(InlineFeedback$1, {
    content: question.feedback
  }));
}
var TableBodyItem$1 = observer(TableBodyItem);

var ChoiceMatrixQuestion = function ChoiceMatrixQuestion(props) {
  var store = props.store,
    type = props.type,
    solutionsMode = props.solutionsMode;
  var _useState = useState(undefined),
    firstCellWidth = _useState[0],
    setFirstCellWidht = _useState[1];
  var changedHandlers = /reset|setSelected|setTitle|setStimulus|setStem|checkAnswers|setValue|addValue/;
  var isInline = type === types.choiceMatrix.Inline;
  var wideTable = store.options.length > 3;
  var itemList = solutionsMode ? store.questions : store.optionsOrder.map(function (order) {
    return store.questions[order];
  });
  useEffect(function () {
    store.feedback.config.setSpecificFeedback(false);
  }, []);
  useEffect(function () {
    if (wideTable) {
      setFirstCellWidht(200);
    }
  }, [wideTable]);
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn('lemo-question-body', {
      'lemo-with-hScroll': wideTable
    })
  }, !isInline && /*#__PURE__*/React__default.createElement(TableHeader, {
    options: store.options,
    firstCellWidth: firstCellWidth
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn('lemo-table-body', {
      'lemo-disabled': store.disabled
    })
  }, itemList.map(function (question) {
    return /*#__PURE__*/React__default.createElement(TableBodyItem$1, {
      key: "" + question.id,
      question: question,
      showLabels: isInline,
      options: store.options,
      isDisabled: store.isDisabled,
      isMultiple: store.multiple_responses,
      firstCellWidth: firstCellWidth
    });
  }))));
};
var ChoiceMatrixQuestion$1 = observer(ChoiceMatrixQuestion);

var OptionModel$2 = types$1.model({
  id: types$1.optional(types$1.string, function () {
    return uuid();
  }),
  label: types$1.string
}).actions(function (state) {
  return {
    setLabel: function setLabel(val) {
      state.label = val;
      getParent(state, 2).updateNotifier();
    },
    destroy: function destroy() {
      getParent(state, 2).removeOption(state);
    }
  };
}).views(function (state) {
  return {
    get index() {
      var parent = getParent(state);
      return parent.findIndex(function (children) {
        return children === state;
      });
    }
  };
});

var BaseModel$1 = types$1.model({
  type: types$1.optional(types$1.string, ''),
  customClass: types$1.optional(VariantsModel$1, ''),
  background: types$1.maybe(BackgroundModel$1),
  keyboard: types$1.optional(KeyboardModel, {})
}).actions(function (state) {
  return {
    setType: function setType(type) {
      state.type = type;
    },
    setBackground: function setBackground(background) {
      state.background = background;
      getParent(state).updateNotifier();
    },
    setKeyboardType: function setKeyboardType(type) {
      var parent = getParent(state);
      parent.clearAllSolutions();
      state.keyboard.setType(type);
      if (parent.keyboard) parent.keyboard.setType(type);
      parent.updateNotifier();
    },
    setFloatingKeyboard: function setFloatingKeyboard(isFloating) {
      state.keyboard.setIsFloating(isFloating);
      getParent(state).updateNotifier();
    }
  };
});
var createUIStyleModel = function createUIStyleModel(Model) {
  if (Model === void 0) {
    Model = BaseModel$1;
  }
  return types$1.snapshotProcessor(Model, {
    preProcessor: function preProcessor(sn) {
      var keyboard = _extends({}, sn.keyboard);
      if (keyboard && hasData(keyboard.type)) {
        keyboard.type = keyboard.type.toUpperCase();
      }
      return _extends({}, sn, {
        keyboard: keyboard
      });
    },
    postProcessor: function postProcessor(sn) {
      return _extends({}, sn);
    }
  });
};
var UIStyleModel$1 = createUIStyleModel(BaseModel$1);
var defaultUIStyle = {
  type: '',
  customClass: ''
};

var QuestionModel$1 = types$1.compose(getWithFeedbackResult(sortAndStringify), withElementFeedback, withShowSolutionsParent, types$1.model('ChoiceMatrixQuestionModel', {
  id: types$1.string,
  stem: types$1.string,
  value: types$1.optional(types$1.array(types$1.number), [])
}).actions(function (state) {
  return {
    setStem: function setStem(stem) {
      state.stem = stem;
      getParent(state, 2).updateNotifier();
    },
    addValue: function addValue(val) {
      var idx = state.value.findIndex(function (v) {
        return v === val;
      });
      state.value = idx > -1 ? rmItem(idx, state.value) : [].concat(state.value, [val]).sort(function (a, b) {
        return a - b;
      });
    },
    setValue: function setValue(value) {
      state.value = when()["case"](value === null, function () {
        return [];
      })["case"](Array.isArray(value) && value[0] === '', function () {
        return [];
      })["case"](value === '', function () {
        return [];
      }).resolve(function () {
        return value;
      });
      getParent(state, 2).updateNotifier();
    },
    destroy: function destroy() {
      getParent(state, 2).removeQuestion(state);
    }
  };
}).views(function (state) {
  return {
    get index() {
      try {
        var parent = getParent(state);
        return parent.findIndex(function (children) {
          return children === state;
        });
      } catch (e) {
        return 0;
      }
    },
    get selected() {
      var options = getParent(state, 2).options;
      return options.map(function (_, idx) {
        return state.value.includes(idx);
      });
    },
    get currentResponse() {
      return getParent(state, 2).getCurrentSolution(state.index);
    },
    get evaluationReady() {
      var parent = getParent(state, 2);
      return parent.isEvaluated || parent.validation.immediateFeedback;
    },
    getOptionSuccess: function getOptionSuccess(idx) {
      var parent = getParent(state, 2);
      if (!state.evaluationReady) return false;
      var isRightAnswer = state.currentResponse.includes(idx);
      return state.value.includes(idx) && (isRightAnswer || parent.showSolution);
    },
    getOptionError: function getOptionError(idx) {
      var parent = getParent(state, 2);
      if (!state.evaluationReady) return false;
      var isRightAnswer = state.currentResponse.includes(idx);
      return state.value.includes(idx) && !isRightAnswer && !parent.showSolution;
    },
    get type() {
      return getParent(state, 2) && getParent(state, 2).name ? getParent(state, 2).name : null;
    },
    get isEmptyResponse() {
      var hasData = function hasData(response) {
        return response && response.length > 0;
      };
      var _getParent = getParent(state, 2),
        _getParent$showSoluti = _getParent.showSolution,
        showSolution = _getParent$showSoluti === void 0 ? false : _getParent$showSoluti,
        _getParent$internalAu = _getParent.internalAutoFeedback,
        internalAutoFeedback = _getParent$internalAu === void 0 ? false : _getParent$internalAu;
      return !showSolution && !internalAutoFeedback ? !hasData(state.value) : !hasData(state.cacheResponse);
    },
    get isCanShowElementFeedback() {
      return isCanShowElementFeedbackParam(state.type, state.isEmptyResponse, false);
    }
  };
}));

var ResponseModel = types$1.model({
  value: types$1.array(types$1.number)
}).actions(function (state) {
  return {
    addValue: function addValue(val) {
      var idx = state.value.findIndex(function (v) {
        return v === val;
      });
      state.value = idx > -1 ? rmItem(idx, state.value) : [].concat(state.value, [val]).sort(function (a, b) {
        return a - b;
      });
    },
    setValue: function setValue(val) {
      state.value = val.sort(function (a, b) {
        return a - b;
      });
    }
  };
}).views(function (state) {
  return {
    get index() {
      var parent = getParent(state);
      return parent.findIndex(function (children) {
        return children === state;
      });
    },
    get isValid() {
      var validation = getParent(state, 2).validation;
      return validation.value[state.index].toString() === getSnapshot(state.value).toString();
    }
  };
});

var ChoiceMatrixEditorStore = types$1.compose(EditorBaseModel, withElementFeedbackParent('questions'), types$1.model({
  options: types$1.array(OptionModel$2),
  response: types$1.array(ResponseModel),
  questions: types$1.optional(types$1.array(QuestionModel$1), []),
  shuffle_options: types$1.optional(types$1["boolean"], false),
  multiple_responses: types$1.optional(types$1["boolean"], false),
  ui_style: UIStyleModel$1
}).actions(function (state) {
  return {
    removeMultipleResponses: function removeMultipleResponses(bool) {
      if (bool) {
        state.questions.forEach(function (question) {
          question.value.length > 1 && question.setValue([question.value[0]]);
        });
        state.validation.setValue(state.validation.value.map(function (val) {
          return val.length > 0 ? [val[0]] : [];
        }));
        state.validation.alt_responses.forEach(function (altResponse) {
          altResponse.setValue(altResponse.value.map(function (val) {
            return val.length > 0 ? [val[0]] : [];
          }));
        });
      }
    },
    setMultipleResponses: function setMultipleResponses(bool) {
      state.multiple_responses = bool;
      state.removeMultipleResponses(!bool);
      state.updateNotifier();
    },
    setResponse: function setResponse(responses) {
      if (!typeChecker(types$1.array(types$1.array(types$1.number)), responses)) {
        return false;
      }
      state.questions.forEach(function (question, idx) {
        var response = responses.length > idx ? safeSnapshot(responses[idx]) : [0];
        question.setValue(!state.multiple_responses && response.length > 1 ? [response[0]] : response);
      });
    },
    setStem: function setStem(idx, val) {
      state.stems[idx] = val;
      state.updateNotifier();
    },
    addOption: function addOption() {
      var indexLabel = state.options ? ' ' + (state.options.length + 1) : '';
      state.options.push({
        label: translate('option') + indexLabel
      });
      state.updateNotifier();
    },
    removeOption: function removeOption(option) {
      destroy(option);
      state.updateNotifier();
    },
    setShuffleOptions: function setShuffleOptions(bool) {
      state.shuffle_options = bool;
      if (bool) state.updateOptionsOrder();
    },
    updateValidation: function updateValidation(value) {
      state.validation.setValue(value);
    },
    addQuestion: function addQuestion() {
      var indexLabel = state.questions ? ' ' + (state.questions.length + 1) : '';
      state.questions.push({
        id: uuid(),
        stem: translate('enunciated') + indexLabel,
        value: []
      });
      state.validation.addNewValue([0]);
      state.updateNotifier();
    },
    removeQuestion: function removeQuestion(question) {
      var index = question.index;
      state.validation.removeValueAt(index);
      destroy(question);
      state.updateNotifier();
    },
    sortOptions: function sortOptions(source, destination) {
      state.options = sortArrayItem(source, destination, state.options);
      state.updateNotifier();
    },
    sortQuestions: function sortQuestions(source, destination) {
      state.questions = sortArrayItem(source, destination, state.questions);
      state.validation.setValue(sortArrayItem(source, destination, state.validation.value));
      state.validation.alt_responses.forEach(function (resp) {
        return resp.setValue(sortArrayItem(source, destination, resp.value));
      });
      state.updateNotifier();
    },
    updateOptionsOrder: function updateOptionsOrder() {
      state.optionsOrder = function (idxArr) {
        return state.shuffle_options ? shuffle(idxArr) : idxArr;
      }(state.questions.map(function (o, idx) {
        return idx;
      }));
    },
    updateValidResponses: function updateValidResponses() {
      state.validation.setValue(state.questions.map(function (q) {
        return safeSnapshot(q.validResponse);
      }));
    }
  };
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$4(rawData);
    },
    get output() {
      return exportCommonValues(state, {
        options: state.options.map(function (o) {
          return o.label;
        }),
        stems: state.questions.map(function (q) {
          return q.stem;
        }),
        shuffle_options: state.shuffle_options,
        multiple_responses: state.multiple_responses,
        feedback_responses: state.feedbackResponsesOutput
      });
    }
  };
}));
function createQuestions$1(stems, feedbackResponses) {
  return stems.map(function (stem, idx) {
    var _feedbackResponses$id;
    return {
      id: uuid(),
      stem: stem,
      value: [],
      feedback: (feedbackResponses === null || feedbackResponses === void 0 ? void 0 : (_feedbackResponses$id = feedbackResponses[idx]) === null || _feedbackResponses$id === void 0 ? void 0 : _feedbackResponses$id.feedback) || ''
    };
  });
}
function _createSnapshot$4(data) {
  var _data$data = data.data,
    options = _data$data.options,
    stems = _data$data.stems,
    feedback_responses = _data$data.feedback_responses,
    validation = _data$data.validation,
    multiple_responses = _data$data.multiple_responses;
  return _extends({}, data.data, importCommonValues$1(data), {
    validation: withPenaltyPoints(stems.length, validation),
    questions: createQuestions$1(stems, feedback_responses),
    options: options.map(function (o) {
      return {
        label: o
      };
    }),
    response: stems.map(function () {
      return {
        value: []
      };
    }),
    multiple_responses: multiple_responses
  });
}
function createStore$4(data) {
  return ChoiceMatrixEditorStore.create(_createSnapshot$4(data));
}

var withConfigureScorm$2 = types$1.compose(withScorm, types$1.model({}).actions(function (state) {
  return {
    updateResponseOnValidate: function updateResponseOnValidate() {
      state.scormData.interactiveList.forEach(function (interactive, key) {
        var question = state.questions.find(function (item) {
          return item.id === key;
        });
        interactive.setResult(question.isValid);
      });
    }
  };
}).views(function (state) {
  var getItem = function getItem(item, idx) {
    return {
      userResponse: getSnapshot(item.value),
      id: item.id,
      rightAnswer: getAlternativeSolutions(idx, state),
      result: item.isValid
    };
  };
  return {
    get scormType() {
      return scormTypes.CHOICE;
    },
    getInteractiveListInitScorm: function getInteractiveListInitScorm() {
      return state.questions.map(getItem);
    },
    updateScormItem: function updateScormItem(name, path) {
      if (path.match(/\/questions/) && ['setValue', 'addValue'].includes(name)) {
        var item = resolvePath(state, path);
        return getItem(item, item.index);
      } else return null;
    }
  };
}));

var withXAPIMatchingType = function withXAPIMatchingType(_ref) {
  var getSolution = _ref.getSolution,
    getSource = _ref.getSource,
    getTarget = _ref.getTarget;
  return types$1.model({}).views(function (state) {
    return {
      getObjectDefinition: function getObjectDefinition() {
        var parent = getParent(state);
        var source = getXAPIOptionList(getSource(parent), SOURCE);
        var target = getXAPIOptionList(getTarget(parent), TARGET);
        var solution = getSolution({
          state: parent,
          source: source,
          target: target
        });
        return {
          description: getXAPIDescription(parent),
          interactionType: scormTypes.MATCHING,
          objectType: xAPI_ACTIVITY_TYPE,
          correctResponsesPattern: formatResponses(solution),
          source: source,
          target: target
        };
      }
    };
  });
};
var withXAPIMatchingType$1 = (function (_ref2) {
  var getSolution = _ref2.getSolution,
    getSource = _ref2.getSource,
    getTarget = _ref2.getTarget;
  return exportXAPI(withXAPIMatchingType({
    getSolution: getSolution,
    getSource: getSource,
    getTarget: getTarget
  }));
});

var ChoiceMatrixStore = types$1.compose(QuestionBaseModel, getClosestSolutionModel(checkResponse$1), withValidationModes, withElementFeedbackParent('questions'), withConfigureScorm$2, withXAPIMatchingType$1({
  getSolution: function getSolution(_ref) {
    var state = _ref.state,
      source = _ref.source,
      target = _ref.target;
    return state.getXAPISolution({
      source: source,
      target: target
    });
  },
  getSource: function getSource(state) {
    return state.questions.map(function (question) {
      return question.stem;
    });
  },
  getTarget: function getTarget(state) {
    return state.options.map(function (option) {
      return option.label;
    });
  }
}), types$1.model({
  questions: types$1.optional(types$1.array(QuestionModel$1), []),
  optionsOrder: types$1.frozen()
}).actions(function (state) {
  return {
    commitResponseFeedback: function commitResponseFeedback() {
      var itemList = state.optionsOrder.map(function (order) {
        return state.questions[order];
      });
      commitFeedbackMessages({
        state: state,
        collection: itemList,
        condition: getConditionCommitFeedbackMessages
      });
    },
    setResponse: function setResponse(responses) {
      if (!typeChecker(types$1.array(types$1.array(types$1.number)), responses)) {
        return false;
      }
      state.questions.forEach(function (question, idx) {
        var response = responses.length > idx ? safeSnapshot(responses[idx]) : [0];
        question.setValue(!state.multiple_responses && response.length > 1 ? [response[0]] : response);
      });
    },
    reset: function reset() {
      state.baseReset();
      state.uncheckAll();
    },
    uncheckAll: function uncheckAll() {
      state.questions.forEach(function (q) {
        return q.setValue([]);
      });
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot$5(rawData);
      applySnapshot(state, data);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    setAssetsEditorApi: function setAssetsEditorApi() {}
  };
}).views(function (state) {
  return {
    get options() {
      return state.raw.data.options.map(function (o, index) {
        return {
          id: uuid(),
          label: o,
          index: index
        };
      });
    },
    get multiple_responses() {
      var _state$raw$data;
      return ((_state$raw$data = state.raw.data) === null || _state$raw$data === void 0 ? void 0 : _state$raw$data.multiple_responses) || false;
    },
    getUserResponse: function getUserResponse() {
      var userResponse = state.questions.map(function (r) {
        return getSnapshot(r.value);
      });
      return state.getRealUserResponse(userResponse);
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$5(rawData);
    },
    getSolutions: function getSolutions() {
      return state.validation.value;
    },
    getXAPISolution: function getXAPISolution(_ref2) {
      var source = _ref2.source,
        target = _ref2.target;
      var solution = state.validation.value;
      return solution.reduce(function (acc, next, idx) {
        acc[source[idx].id] = next.map(function (targetIndex) {
          return target[targetIndex].id;
        });
        return acc;
      }, {});
    }
  };
}));
function createQuestions$2(stems, feedbackResponses) {
  return stems.map(function (stem, idx) {
    var _feedbackResponses$id;
    return {
      id: uuid(),
      stem: stem,
      value: [],
      feedback: (feedbackResponses === null || feedbackResponses === void 0 ? void 0 : (_feedbackResponses$id = feedbackResponses[idx]) === null || _feedbackResponses$id === void 0 ? void 0 : _feedbackResponses$id.feedback) || ''
    };
  });
}
function getListOrder(listLength, isShuffle) {
  var indexes = populate(listLength, function (i) {
    return i;
  });
  return isShuffle ? shuffle(indexes) : indexes;
}
function _createSnapshot$5(data) {
  var _data$data = data.data,
    stems = _data$data.stems,
    feedback_responses = _data$data.feedback_responses,
    validation = _data$data.validation,
    shuffle_options = _data$data.shuffle_options,
    _data$data$feedback = _data$data.feedback,
    feedback = _data$data$feedback === void 0 ? initialValue$1 : _data$data$feedback;
  var feedbackWithoutSpecific = produce(feedback, function (draft) {
    draft.config.hasSpecificFeedback = false;
  });
  return _extends({}, data.data, importCommonValues$1(data), {
    feedback: feedbackWithoutSpecific,
    validation: withPenaltyPoints(stems.length, validation),
    questions: createQuestions$2(stems, feedback_responses),
    optionsOrder: getListOrder(stems.length, shuffle_options)
  });
}
function checkResponse$1(solution, userResponse) {
  return userResponse.length > 0 ? solution.toString() === userResponse.toString() : null;
}
function createStore$5(data) {
  return ChoiceMatrixStore.create(_createSnapshot$5(data));
}

var EditorQuestionsStore = function EditorQuestionsStore(_ref) {
  var store = _ref.store,
    modelGetListString = _ref.modelGetListString,
    modelSetListString = _ref.modelSetListString,
    showToggleShuffleOptions = _ref.showToggleShuffleOptions,
    showToggleDuplicateResponses = _ref.showToggleDuplicateResponses,
    showFeedbackAnswer = _ref.showFeedbackAnswer,
    modelGetListFeedbackString = _ref.modelGetListFeedbackString,
    modelSetListFeedbackString = _ref.modelSetListFeedbackString,
    onDeleteOption = _ref.onDeleteOption,
    options = _ref.options,
    onSortOptions = _ref.onSortOptions,
    onClickAddOption = _ref.onClickAddOption,
    keyIdSortingList = _ref.keyIdSortingList,
    idBox = _ref.idBox,
    iconBox = _ref.iconBox,
    titleBox = _ref.titleBox,
    helpText = _ref.helpText,
    limit = _ref.limit,
    helpTextDisabledAdd = _ref.helpTextDisabledAdd,
    _ref$imageDefaultHeig = _ref.imageDefaultHeight,
    imageDefaultHeight = _ref$imageDefaultHeig === void 0 ? config.configEditor[editorComponents.questions].imageDefaultSize.height : _ref$imageDefaultHeig,
    _ref$imageDefaultWidt = _ref.imageDefaultWidth,
    imageDefaultWidth = _ref$imageDefaultWidt === void 0 ? config.configEditor[editorComponents.questions].imageDefaultSize.width : _ref$imageDefaultWidt,
    showNumbersOptions = _ref.showNumbersOptions;
  return /*#__PURE__*/React__default.createElement(EditorAnswerOptionsStore$1, {
    store: store,
    modelGetListString: modelGetListString,
    modelSetListString: modelSetListString,
    showToggleShuffleOptions: showToggleShuffleOptions,
    showToggleDuplicateResponses: showToggleDuplicateResponses,
    showFeedbackAnswer: showFeedbackAnswer,
    modelGetListFeedbackString: modelGetListFeedbackString,
    modelSetListFeedbackString: modelSetListFeedbackString,
    onDeleteOption: onDeleteOption,
    options: options,
    onSortOptions: onSortOptions,
    onClickAddOption: onClickAddOption,
    keyIdSortingList: keyIdSortingList,
    idBox: idBox,
    iconBox: iconBox,
    titleBox: titleBox,
    helpText: helpText,
    limit: limit,
    helpTextDisabledAdd: helpTextDisabledAdd,
    imageDefaultWidth: imageDefaultWidth,
    imageDefaultHeight: imageDefaultHeight,
    showNumbersOptions: showNumbersOptions
  });
};
EditorQuestionsStore.propTypes = {
  store: propTypes.any,
  modelGetListString: EditorAnswerOptions$1.propTypes.modelGetListString,
  modelSetListString: EditorAnswerOptions$1.propTypes.modelSetListString,
  showToggleShuffleOptions: EditorAnswerOptions$1.propTypes.showToggleShuffleOptions,
  showToggleDuplicateResponses: EditorAnswerOptions$1.propTypes.showToggleDuplicateResponses,
  showFeedbackAnswer: EditorAnswerOptions$1.propTypes.showFeedbackAnswer,
  modelGetListFeedbackString: EditorAnswerOptions$1.propTypes.modelGetListFeedbackString,
  modelSetListFeedbackString: EditorAnswerOptions$1.propTypes.modelSetListFeedbackString,
  onDeleteOption: EditorAnswerOptions$1.propTypes.onDeleteOption,
  keyIdSortingList: EditorAnswerOptions$1.propTypes.keyIdSortingList,
  idBox: EditorAnswerOptions$1.propTypes.idBox,
  iconBox: EditorAnswerOptions$1.propTypes.iconBox,
  titleBox: EditorAnswerOptions$1.propTypes.titleBox,
  helpText: EditorAnswerOptions$1.propTypes.helpText,
  limit: propTypes.number,
  helpTextDisabledAdd: propTypes.string,
  imageDefaultWidth: propTypes.number,
  imageDefaultHeight: propTypes.string,
  showNumbersOptions: EditorAnswerOptions$1.propTypes.showNumbersOptions
};
EditorQuestionsStore.defaultProps = {};
var EditorQuestionsStore$1 = observer(EditorQuestionsStore);

function useChoiseMatrixEditor(_ref) {
  var store = _ref.store;
  var _useCheckedFeedbackIn = useCheckedFeedbackIndividual({
      responsesFeedback: store.responsesFeedback
    }),
    isCheckedFeedbackIndividual = _useCheckedFeedbackIn.isCheckedFeedbackIndividual,
    setIsCheckedFeedbackIndividual = _useCheckedFeedbackIn.setIsCheckedFeedbackIndividual;
  return {
    isCheckedFeedbackIndividual: isCheckedFeedbackIndividual,
    setIsCheckedFeedbackIndividual: setIsCheckedFeedbackIndividual
  };
}

var _excluded$5 = ["store", "changed", "type"];
var ChoiceMatrixEditor = function ChoiceMatrixEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$5);
  var _useChoiseMatrixEdito = useChoiseMatrixEditor({
      store: store
    }),
    isCheckedFeedbackIndividual = _useChoiseMatrixEdito.isCheckedFeedbackIndividual,
    setIsCheckedFeedbackIndividual = _useChoiseMatrixEdito.setIsCheckedFeedbackIndividual;
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setValue|setTitle|setStimulus|setOptions|updateValidation|setShuffleOptions|setScore|setValidResponse|sortQuestions|sortOptions|addOption|addQuestion|removeQuestion|removeOption|setLabel|setStem|setMultipleResponses|setIsEvaluable|updateSolution|destroy|createAlternativeSolution|removeSolution|changeScore|addValue|setBackground",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 2,
      haveFeedbackIndividual: true,
      showConfigFeedbacksIndividual: true,
      onChangeCheckedFeedbackIndividual: setIsCheckedFeedbackIndividual,
      feedbackIndividualLabelText: translate('Text Prompt')
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 3,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref)
  }), /*#__PURE__*/React__default.createElement(EditorQuestionsStore$1, {
    store: store,
    options: store.questions,
    onSortOptions: store.sortQuestions,
    onClickAddOption: store.addQuestion,
    showToggleShuffleOptions: false,
    showToggleDuplicateResponses: false,
    modelGetListString: "stem",
    modelSetListString: "setStem",
    keyIdSortingList: "id",
    idBox: "Questions",
    titleBox: translate('Questions options'),
    helpText: translate('choice_matrix_questions_help'),
    iconBox: /*#__PURE__*/React__default.createElement(SvgFormatListBulleted, null),
    showNumbersOptions: isCheckedFeedbackIndividual
  }), /*#__PURE__*/React__default.createElement(EditorAnswerOptionsStore$1, {
    store: store,
    options: store.options,
    onSortOptions: store.sortOptions,
    onClickAddOption: store.addOption,
    showToggleShuffleOptions: false,
    showToggleDuplicateResponses: false,
    modelGetListString: "label",
    modelSetListString: "setLabel",
    keyIdSortingList: "id",
    idBox: "options",
    titleBox: translate('answer_options'),
    helpText: translate('answer_options_help'),
    iconBox: /*#__PURE__*/React__default.createElement(SvgFormatListBulleted, null)
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    helpText: translate('exact_math_or_partial_match_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: [TYPES_CONFIG.CONFIG_MULTIPLE_RESPONSES, TYPES_CONFIG.CONFIG_SUFFLE_ANSWERS]
  }));
};
var ChoiceMatrixEditor$1 = observer(ChoiceMatrixEditor);

function getChoiceMatrix(props) {
  var _getCreator = getCreator(props, getDefaultData, types.choiceMatrix.Inline),
    type = _getCreator.type,
    exerciseData = _getCreator.exerciseData,
    setCommonParamsStore = _getCreator.setCommonParamsStore;
  var questionStore = createStore$5(exerciseData);
  setCommonParamsStore(questionStore);
  var editorStore = createStore$4(exerciseData);
  setCommonParamsStore(editorStore);
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(ChoiceMatrixQuestion$1, _extends({
        store: questionStore,
        type: type
      }, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(ChoiceMatrixEditor$1, _extends({
        store: editorStore,
        type: type
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}

var controlsStatus$3 = {
  empty: {
    id: 'empty',
    visible: {
      send: true
    },
    disabled: {
      send: true
    }
  },
  notModified: {
    id: 'notModified',
    visible: {
      send: true,
      cancel: true
    },
    disabled: {
      send: true
    }
  },
  modified: {
    id: 'modified',
    visible: {
      send: true,
      cancel: true
    },
    disabled: {}
  },
  locked: {
    id: 'locked',
    visible: {
      edit: true,
      send: true
    },
    disabled: {
      send: true
    }
  }
};
function useSendControlsStatus(status) {
  return controlsStatus$3[status];
}

var SendControls = function SendControls(_ref) {
  var disabled = _ref.disabled,
    store = _ref.store,
    _ref$onSend = _ref.onSend,
    onSend = _ref$onSend === void 0 ? null : _ref$onSend,
    _ref$showHints = _ref.showHints,
    showHints = _ref$showHints === void 0 ? true : _ref$showHints,
    _ref$showSend = _ref.showSend,
    showSend = _ref$showSend === void 0 ? true : _ref$showSend,
    _ref$showEdit = _ref.showEdit,
    showEdit = _ref$showEdit === void 0 ? true : _ref$showEdit,
    _ref$showCancel = _ref.showCancel,
    showCancel = _ref$showCancel === void 0 ? true : _ref$showCancel,
    _ref$visible = _ref.visible,
    visible = _ref$visible === void 0 ? true : _ref$visible,
    _ref$renderScore = _ref.renderScore,
    renderScore = _ref$renderScore === void 0 ? null : _ref$renderScore,
    children = _ref.children;
  useDefaultProp({
    setter: store.setDisabled,
    value: disabled
  });
  var status = useSendControlsStatus(store.editableControlsStatus);
  var handleSend = useCallback(function () {
    store.send();
    onSend === null || onSend === void 0 ? void 0 : onSend(store.getResponseWithKey());
  }, [store]);
  var isVisible = visible && store.context !== questionContext.REVISION;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-send-controls"
  }, children, isVisible && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-controls-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-controls-left"
  }, renderScore && /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-points"
  }, renderScore()), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: showHints
  }, /*#__PURE__*/React__default.createElement(ButtonHint$1, {
    hints: store.hints
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-controls-right"
  }, /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: showEdit && status.visible.edit
  }, /*#__PURE__*/React__default.createElement(InlineButton, {
    className: "lemo-controls-button-edit",
    onClick: store.edit,
    title: translate('button_edit'),
    disabled: status.disabled.edit
  }, /*#__PURE__*/React__default.createElement(SvgPencil, {
    className: "lemo-icon",
    width: 22,
    heigth: 22
  }), ' ', translate('button_edit'))), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: showCancel && status.visible.cancel
  }, /*#__PURE__*/React__default.createElement(InlineButton, {
    className: "lemo-controls-button-reset",
    onClick: store.cancel,
    title: translate('button_cancel'),
    disabled: status.disabled.cancel
  }, translate('button_cancel'))), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: showSend && status.visible.send
  }, /*#__PURE__*/React__default.createElement(SimpleButton, {
    className: "lemo-controls-button-send",
    variant: variantsSimpleButton.primary,
    onClick: handleSend,
    disabled: status.disabled.send
  }, translate('send'))))));
};
var SendControls$1 = observer(SendControls);

function useFocusAddClass(baseRef, classVerifyFocus, classAddClassWhenFocus, classAddWhenFocus) {
  function setFocused() {
    if (baseRef && baseRef.current) {
      var results = baseRef.current.querySelectorAll('.' + classAddClassWhenFocus);
      for (var i = 0; i < results.length; i++) {
        results[i].classList.add(classAddWhenFocus);
      }
    }
  }
  function unsetFocused() {
    if (baseRef && baseRef.current) {
      var results = baseRef.current.querySelectorAll('.' + classAddClassWhenFocus);
      for (var i = 0; i < results.length; i++) {
        results[i].classList.remove(classAddWhenFocus);
      }
    }
  }
  useEffect(function () {
    if (baseRef && baseRef.current) {
      var results = baseRef.current.querySelectorAll(classVerifyFocus);
      for (var i = 0; i < results.length; i++) {
        results[i].addEventListener('focusin', setFocused);
        results[i].addEventListener('focusout', unsetFocused);
      }
    }
  }, [baseRef]);
  useEffect(function () {
    return function () {
      if (baseRef && baseRef.current) {
        var results = baseRef.current.querySelectorAll(classVerifyFocus);
        for (var i = 0; i < results.length; i++) {
          results[i].removeEventListener('focusin', setFocused);
          results[i].removeEventListener('focusout', unsetFocused);
        }
      }
    };
  }, []);
}

function TextCounter(_ref) {
  var count = _ref.count,
    limit = _ref.limit,
    _ref$predicate = _ref.predicate,
    predicate = _ref$predicate === void 0 ? 'words_limit' : _ref$predicate;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-text-counter-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-text-counter lemo-text-body-s-regular lemo-color-text-04"
  }, count, " / ", limit, " ", /*#__PURE__*/React__default.createElement("span", null, translate(predicate))));
}

function Icon(_ref) {
  var attributes = _ref.attributes,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement("span", _extends({
    className: "lemo-control-button-icon"
  }, attributes), when()["case"](children === 'format_bold', function () {
    return /*#__PURE__*/React__default.createElement(SvgRichtextBold, null);
  })["case"](children === 'format_italic', function () {
    return /*#__PURE__*/React__default.createElement(SvgRichtextItalic, null);
  })["case"](children === 'format_underlined', function () {
    return /*#__PURE__*/React__default.createElement(SvgRichtextUnderline, null);
  })["case"](children === 'format_superindex', function () {
    return /*#__PURE__*/React__default.createElement(SvgRichtextSuperindex, null);
  })["case"](children === 'format_subindex', function () {
    return /*#__PURE__*/React__default.createElement(SvgRichtextSubindex, null);
  })["case"](children === 'looks_one', function () {
    return /*#__PURE__*/React__default.createElement(SvgRichtextTitle, null);
  })["case"](children === 'format_quote', function () {
    return /*#__PURE__*/React__default.createElement(SvgRichtextQuote, null);
  })["case"](children === 'format_list_numbered', function () {
    return /*#__PURE__*/React__default.createElement(SvgRichtextNumberedlist, null);
  })["case"](children === 'format_list_bulleted', function () {
    return /*#__PURE__*/React__default.createElement(SvgRichtextList, null);
  }).resolve(function () {
    return null;
  }));
}

var LIST_TYPES = ['numbered-list', 'bulleted-list'];
var isBlockActive = function isBlockActive(editor, format) {
  var nodes = Editor$1.nodes(editor, {
    match: function match(n) {
      return n.type === format;
    }
  });
  return !!nodes.next().value;
};
var toggleBlock = function toggleBlock(editor, format) {
  var isActive = isBlockActive(editor, format);
  var isList = LIST_TYPES.includes(format);
  Transforms.unwrapNodes(editor, {
    match: function match(n) {
      return LIST_TYPES.includes(n.type);
    },
    split: true
  });
  Transforms.setNodes(editor, {
    type: when()["case"](isActive, function () {
      return 'paragraph';
    })["case"](isList, function () {
      return 'list-item';
    }).resolve(function () {
      return format;
    })
  });
  if (!isActive && isList) {
    var block = {
      type: format,
      children: []
    };
    Transforms.wrapNodes(editor, block);
  }
};
var toggleMark = function toggleMark(editor, format) {
  var isActive = isMarkActive(editor, format);
  if (isActive) {
    Editor$1.removeMark(editor, format);
  } else {
    Editor$1.addMark(editor, format, true);
  }
};
var removeMark = function removeMark(editor, format) {
  Editor$1.removeMark(editor, format);
};
var isMarkActive = function isMarkActive(editor, format) {
  var marks = Editor$1.marks(editor);
  if (marks && Object.keys(marks).length > 0) {
    console.log('markactives', marks);
  }
  return marks ? marks[format] === true : false;
};

function BlockButton(_ref) {
  var format = _ref.format,
    icon = _ref.icon;
  var editor = useSlate();
  return /*#__PURE__*/React__default.createElement("button", {
    className: cn$1('lemo-rt-editor-control lemo-base-essay__toolbar-button', {
      'lemo-active lemo-base-essay__toolbar-button--active': isBlockActive(editor, format)
    }),
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();
      toggleBlock(editor, format);
    },
    type: "button"
  }, /*#__PURE__*/React__default.createElement(Icon, null, icon));
}

function Element$2(_ref) {
  var attributes = _ref.attributes,
    children = _ref.children,
    element = _ref.element;
  switch (element.type) {
    case 'block-quote':
      return /*#__PURE__*/React__default.createElement("blockquote", attributes, children);
    case 'bulleted-list':
      return /*#__PURE__*/React__default.createElement("ul", attributes, children);
    case 'heading-one':
      return /*#__PURE__*/React__default.createElement("h1", attributes, children);
    case 'heading-two':
      return /*#__PURE__*/React__default.createElement("h2", attributes, children);
    case 'list-item':
      return /*#__PURE__*/React__default.createElement("li", attributes, children);
    case 'numbered-list':
      return /*#__PURE__*/React__default.createElement("ol", attributes, children);
    default:
      return /*#__PURE__*/React__default.createElement("p", attributes, children);
  }
}

function Leaf(_ref) {
  var attributes = _ref.attributes,
    children = _ref.children,
    leaf = _ref.leaf;
  if (leaf.bold) {
    children = /*#__PURE__*/React__default.createElement("strong", null, children);
  }
  if (leaf.code) {
    children = /*#__PURE__*/React__default.createElement("code", null, children);
  }
  if (leaf.italic) {
    children = /*#__PURE__*/React__default.createElement("em", null, children);
  }
  if (leaf.underline) {
    children = /*#__PURE__*/React__default.createElement("u", null, children);
  }
  if (leaf.superindex) {
    children = /*#__PURE__*/React__default.createElement("sup", null, children);
  }
  if (leaf.subindex) {
    children = /*#__PURE__*/React__default.createElement("sub", null, children);
  }
  return /*#__PURE__*/React__default.createElement("span", attributes, children);
}

function MarkButton(_ref) {
  var format = _ref.format,
    icon = _ref.icon,
    clearBefore = _ref.clearBefore;
  var editor = useSlate();
  return /*#__PURE__*/React__default.createElement("button", {
    className: cn$1('lemo-rt-editor-control lemo-base-essay__toolbar-button', {
      'lemo-active lemo-base-essay__toolbar-button--active': isMarkActive(editor, format)
    }),
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();
      if (clearBefore) {
        removeMark(editor, clearBefore);
      }
      toggleMark(editor, format);
    },
    type: "button"
  }, /*#__PURE__*/React__default.createElement(Icon, null, icon));
}

function Separator() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-rt-editor-separator lemo-base-essay__toolbar-buttons-separator"
  });
}

function RichText(_ref) {
  var _ref$initialContent = _ref.initialContent,
    initialContent = _ref$initialContent === void 0 ? [] : _ref$initialContent,
    setContent = _ref.setContent,
    wordsLimit = _ref.wordsLimit,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? translate('richText_placeholder') : _ref$placeholder,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly;
  var _useState = useState(0),
    counter = _useState[0],
    setCounter = _useState[1];
  var _useState2 = useState(initialContent),
    value = _useState2[0],
    setValue = _useState2[1];
  var renderElement = useCallback(function (props) {
    return /*#__PURE__*/React__default.createElement(Element$2, props);
  }, []);
  var renderLeaf = useCallback(function (props) {
    return /*#__PURE__*/React__default.createElement(Leaf, props);
  }, []);
  var editor = useMemo(function () {
    return withReact(createEditor());
  }, []);
  var element = useRef();
  var baseRef = useRef();
  var wordsLimitRef = useRef();
  wordsLimitRef.current = wordsLimit;
  var _useState3 = useState(0),
    numWords = _useState3[0],
    setNumWords = _useState3[1];
  var classVerifyFocus = '[data-slate-editor]';
  var classAddClassWhenFocus = 'lemo-base-essay';
  var classAddWhenFocus = 'lemo-base-essay--focused';
  useFocusAddClass(baseRef, classVerifyFocus, classAddClassWhenFocus, classAddWhenFocus);
  var countWords = useCallback(function () {
    var text = defaultValue('current.firstChild.innerText', element, '');
    setNumWords(text.trim() === placeholder ? 0 : getCountWords(text));
  }, [setNumWords, placeholder]);
  var getNumWords = useMemo(function () {
    return debounce(countWords, 100);
  }, [countWords]);
  var onChange = useCallback(function (val) {
    setContent(val);
    setValue(val);
    getNumWords();
  }, [getNumWords, setContent]);
  var onKeyDown = useCallback(function (e) {
    setCounter(function (x) {
      return x + 1;
    });
    if (wordsLimit > 0 && numWords >= wordsLimit && (e.key === ' ' || e.key === 'Enter')) {
      e.preventDefault();
    }
  }, [numWords, wordsLimit, setCounter]);
  function getTextActual() {
    var textActual = '';
    if (value) {
      value.forEach(function (_element) {
        if (_element.children) {
          _element.children.forEach(function (_children) {
            if (_children && hasData(_children.text)) {
              textActual += ' ' + _children.text;
            }
          });
        }
      });
    }
    return textActual;
  }
  function onPaste(e) {
    var pastedData = '';
    if (e.clipboardData || e.originalEvent.clipboardData) {
      pastedData = (e.originalEvent || e).clipboardData.getData('text/plain');
    } else if (window.clipboardData) {
      pastedData = window.clipboardData.getData('Text');
    }
    var _wordLimit = wordsLimitRef.current;
    var textActual = getTextActual();
    var newValue = textActual + pastedData;
    var newCountWord = getCountWords(newValue);
    if (_wordLimit > 0 && newCountWord >= _wordLimit) {
      e.stopPropagation();
      e.preventDefault();
      var countWordsActual = getCountWords(textActual);
      var numberWordsCanPaste = _wordLimit - countWordsActual;
      if (numberWordsCanPaste > 0) {
        var pasteDataCanWrite = pastedData.trim().split(/\s+/, numberWordsCanPaste).join(' ');
        try {
          Transforms.insertText(editor, pasteDataCanWrite);
        } catch (error) {}
        getNumWords();
      }
    }
  }
  useEffect(function () {
    getNumWords();
  }, [getNumWords]);
  return /*#__PURE__*/React__default.createElement("div", {
    ref: baseRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-rt-editor lemo-box-large lemo-base-essay"
  }, /*#__PURE__*/React__default.createElement(Slate, {
    editor: editor,
    initialValue: value,
    onChange: onChange
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-rt-editor-toolbar"
  }, /*#__PURE__*/React__default.createElement(MarkButton, {
    format: "bold",
    icon: "format_bold"
  }), /*#__PURE__*/React__default.createElement(MarkButton, {
    format: "italic",
    icon: "format_italic"
  }), /*#__PURE__*/React__default.createElement(MarkButton, {
    format: "underline",
    icon: "format_underlined"
  }), /*#__PURE__*/React__default.createElement(MarkButton, {
    format: "superindex",
    icon: "format_superindex",
    clearBefore: "subindex"
  }), /*#__PURE__*/React__default.createElement(MarkButton, {
    format: "subindex",
    icon: "format_subindex",
    clearBefore: "superindex"
  }), /*#__PURE__*/React__default.createElement(Separator, null), /*#__PURE__*/React__default.createElement(BlockButton, {
    format: "heading-one",
    icon: "looks_one"
  }), /*#__PURE__*/React__default.createElement(BlockButton, {
    format: "block-quote",
    icon: "format_quote"
  }), /*#__PURE__*/React__default.createElement(Separator, null), /*#__PURE__*/React__default.createElement(BlockButton, {
    format: "numbered-list",
    icon: "format_list_numbered"
  }), /*#__PURE__*/React__default.createElement(BlockButton, {
    format: "bulleted-list",
    icon: "format_list_bulleted"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-rt-editor__line-separator lemo-base-essay__line-separator"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-rt-editor-editable",
    ref: element
  }, /*#__PURE__*/React__default.createElement(Editable, {
    renderElement: renderElement,
    renderLeaf: renderLeaf,
    placeholder: placeholder,
    onKeyDown: onKeyDown,
    onPaste: onPaste,
    spellCheck: true,
    readOnly: readOnly,
    className: "lemo-rt-editor-editable__content"
  })), wordsLimit !== undefined && wordsLimit > 0 && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-base-essay__text-counter"
  }, /*#__PURE__*/React__default.createElement(TextCounter, {
    limit: wordsLimit,
    count: numWords,
    update: counter,
    predicate: "words_limit"
  })))));
}
var RichText$1 = observer(RichText);

function useLoadScript(sources) {
  var _useState = useState(false),
    isReady = _useState[0],
    setReady = _useState[1];
  var onLoadDone = function onLoadDone(source, idx) {
    if (idx > sources.length) {
      return setReady(true);
    }
    (function retry(times) {
      !(source !== null && source !== void 0 && source.readyCondition()) ? setTimeout(function () {
        return retry();
      }, 200) : loadAllResources(idx + 1);
    })();
  };
  var isElementReady = function isElementReady(source) {
    var element = document.getElementById(source.id);
    return element && source.readyCondition();
  };
  var loadScript = function loadScript(source, idx) {
    if (isElementReady(source)) return onLoadDone();
    var script = document.createElement('script');
    script.src = source.url;
    script.id = source.id;
    script.async = true;
    script.addEventListener('load', function () {
      return onLoadDone(source, idx);
    });
    document.body.appendChild(script);
  };
  var loadCSS = function loadCSS(source, idx) {
    if (isElementReady(source)) return onLoadDone();
    var link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'style';
    link.href = source.url;
    link.id = source.id;
    link.addEventListener('load', function () {
      link.rel = 'stylesheet';
      link.type = 'text/css';
      onLoadDone(source, idx);
    });
    document.head.appendChild(link);
  };
  var loadAllResources = function loadAllResources(idx) {
    if (idx === void 0) {
      idx = 0;
    }
    if (idx >= sources.length) return setReady(true);
    var source = sources[idx];
    source.type === 'script' ? loadScript(source, idx) : loadCSS(source, idx);
  };
  useEffect(function () {
    loadAllResources();
  }, []);
  return isReady;
}

function getConfig$1() {
  return {
    key: 'lSA3D-17C1E1F2H2F2I1rXYb1VPUGRHYZNRJd1JVOOb1HAc1zG2B1A2B2D6B1B2C4F1D3==',
    toolbarSticky: true,
    pastePlain: true,
    attribution: false,
    charCounterCount: false,
    documentReady: true,
    height: 500,
    language: config.lang,
    quickInsertTags: [],
    placeholderText: 'Edit Your Content Here!',
    toolbarButtons: ['bold', 'italic', 'underline', 'textColor', 'backgroundColor', 'clearFormatting', '|', 'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', '|', 'formatOL', 'formatUL', 'indent', 'outdent', '|', 'fontSize', 'insertLink', 'insertImage', 'quote']
  };
}

function RealTimeFroalaEditor(_ref) {
  var codox = _ref.codox,
    uploadAPI = _ref.uploadAPI,
    docId = _ref.docId,
    username = _ref.username,
    APIKey = _ref.APIKey,
    model = _ref.model,
    updateContent = _ref.updateContent,
    onChange = _ref.onChange;
  var _useState = useState(null),
    editor = _useState[0],
    setEditor = _useState[1];
  useEffect(function () {
    startCollaboration();
    return function () {
      return codox && codox.stop();
    };
  }, [editor, docId, codox]);
  function startCollaboration() {
    editor && codox && codox.init({
      app: 'froala',
      username: username,
      docId: docId,
      apiKey: APIKey,
      editor: editor,
      avatar: {
        left: false
      },
      hooks: {
        fetchDocOnNetworkReconnect: function fetchDocOnNetworkReconnect() {
          return {
            content: 'Hello world!',
            timestamp: 45151513513
          };
        },
        contentChanged: onChange
      }
    });
  }
  var config = _extends({}, getConfig$1(), {
    imageUploadURL: uploadAPI,
    events: {
      initialized: function initialized() {
        setEditor(this);
      }
    }
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-real-time-froala-editor-container"
  }, /*#__PURE__*/React__default.createElement(FroalaEditorComponent, {
    id: "froalaEditor",
    tag: "textarea",
    config: config,
    model: model,
    onModelChange: updateContent
  }));
}
var RealTimeFroalaEditor$1 = observer(RealTimeFroalaEditor);

function CollaborativeTextEditor(_ref) {
  var uploadAPI = _ref.uploadAPI,
    APIKey = _ref.APIKey,
    docId = _ref.docId,
    username = _ref.username,
    _ref$model = _ref.model,
    model = _ref$model === void 0 ? '' : _ref$model,
    updateContent = _ref.updateContent,
    onChange = _ref.onChange;
  var _useState = useState(null),
    codox = _useState[0],
    setCodoxInstance = _useState[1];
  var isCodoxReady = useLoadScript([{
    type: 'script',
    id: 'codoxScriptId',
    url: 'https://cdn1.codox.io/lib/2.x/api/wave.client.js',
    readyCondition: function readyCondition() {
      return typeof window.Codox !== 'undefined';
    }
  }, {
    type: 'style',
    id: 'codoxStyleId',
    url: 'https://cdn1.codox.io/lib/2.x/css/wave.client.css',
    readyCondition: function readyCondition() {
      return true;
    }
  }]);
  useEffect(function () {
    if (isCodoxReady) {
      var codoxInstance = new window.Codox();
      setCodoxInstance(codoxInstance);
    }
  }, [isCodoxReady]);
  return isCodoxReady ? /*#__PURE__*/React__default.createElement(RealTimeFroalaEditor$1, {
    codox: codox,
    uploadAPI: uploadAPI,
    docId: docId,
    username: username,
    APIKey: APIKey,
    model: model,
    updateContent: updateContent,
    onChange: onChange
  }) : null;
}

function PrintMarginBottom() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-print-margin-bottom"
  }, /*#__PURE__*/React__default.createElement("p", null, "\xA0"), /*#__PURE__*/React__default.createElement("p", null, "\xA0"), /*#__PURE__*/React__default.createElement("p", null, "\xA0"), /*#__PURE__*/React__default.createElement("p", null, "\xA0"), /*#__PURE__*/React__default.createElement("p", null, "\xA0"), /*#__PURE__*/React__default.createElement("p", null, "\xA0"), /*#__PURE__*/React__default.createElement("p", null, "\xA0"), /*#__PURE__*/React__default.createElement("p", null, "\xA0"), /*#__PURE__*/React__default.createElement("p", null, "\xA0"), /*#__PURE__*/React__default.createElement("p", null, "\xA0"), /*#__PURE__*/React__default.createElement("p", null, "\xA0"), /*#__PURE__*/React__default.createElement("p", null, "\xA0"), /*#__PURE__*/React__default.createElement("p", null, "\xA0"), /*#__PURE__*/React__default.createElement("p", null, "\xA0"), /*#__PURE__*/React__default.createElement("p", null, "\xA0"));
}

function RichTextQuestion(props) {
  var store = props.store;
  var changedHandlers = /setResponse|setContent/;
  function handleChange() {
    var _store$getResponseWit;
    props === null || props === void 0 ? void 0 : props.changed({
      output: store.output,
      points: store === null || store === void 0 ? void 0 : store.points,
      response: store === null || store === void 0 ? void 0 : (_store$getResponseWit = store.getResponseWithKey) === null || _store$getResponseWit === void 0 ? void 0 : _store$getResponseWit.call(store),
      store: store
    });
  }
  function setContent(content) {
    store.setContent(content);
    handleChange();
  }
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers
  }), /*#__PURE__*/React__default.createElement(PrintMarginBottom, null), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', {
      'lemo-disabled': store.disabled
    }),
    key: store.refreshKey.toString()
  }, store.collaborativeConfig ? /*#__PURE__*/React__default.createElement(CollaborativeTextEditor, {
    docId: store.collaborativeConfig.docId,
    username: store.collaborativeConfig.username,
    APIKey: store.collaborativeConfig.apikey,
    uploadAPI: store.assetsQuestionApi,
    model: store.response,
    updateContent: setContent,
    onChange: handleChange
  }) : /*#__PURE__*/React__default.createElement(RichText$1, {
    initialContent: store.response,
    setContent: store.setContent,
    numLetters: store.numLetters,
    wordsLimit: store.wordsLimit
  })));
}
var RichTextQuestion$1 = observer(RichTextQuestion);

var ELEMENT_TAGS = {
  A: function A(el) {
    return {
      type: 'link',
      url: el.getAttribute('href')
    };
  },
  BLOCKQUOTE: function BLOCKQUOTE() {
    return {
      type: 'block-quote'
    };
  },
  H1: function H1() {
    return {
      type: 'heading-one'
    };
  },
  H2: function H2() {
    return {
      type: 'heading-two'
    };
  },
  H3: function H3() {
    return {
      type: 'heading-three'
    };
  },
  H4: function H4() {
    return {
      type: 'heading-four'
    };
  },
  H5: function H5() {
    return {
      type: 'heading-five'
    };
  },
  H6: function H6() {
    return {
      type: 'heading-six'
    };
  },
  IMG: function IMG(el) {
    return {
      type: 'image',
      url: el.getAttribute('src')
    };
  },
  LI: function LI() {
    return {
      type: 'list-item'
    };
  },
  OL: function OL() {
    return {
      type: 'numbered-list'
    };
  },
  P: function P() {
    return {
      type: 'paragraph'
    };
  },
  PRE: function PRE() {
    return {
      type: 'code'
    };
  },
  UL: function UL() {
    return {
      type: 'bulleted-list'
    };
  }
};
var TEXT_TAGS = {
  CODE: function CODE() {
    return {
      code: true
    };
  },
  DEL: function DEL() {
    return {
      strikethrough: true
    };
  },
  EM: function EM() {
    return {
      italic: true
    };
  },
  I: function I() {
    return {
      italic: true
    };
  },
  S: function S() {
    return {
      strikethrough: true
    };
  },
  STRONG: function STRONG() {
    return {
      bold: true
    };
  },
  U: function U() {
    return {
      underline: true
    };
  }
};
var deserializeElement = function deserializeElement(el) {
  if (el.nodeType === 3) {
    return el.textContent;
  } else if (el.nodeType !== 1) {
    return null;
  } else if (el.nodeName === 'BR') {
    return '\n';
  }
  var nodeName = el.nodeName;
  var parent = el;
  if (nodeName === 'PRE' && el.childNodes[0] && el.childNodes[0].nodeName === 'CODE') {
    parent = el.childNodes[0];
  }
  var children = Array.from(parent.childNodes).map(deserializeElement).flat();
  if (children.length === 0) {
    children = [{
      text: ''
    }];
  }
  if (el.nodeName === 'BODY') {
    return jsx('fragment', {}, children);
  }
  if (ELEMENT_TAGS[nodeName]) {
    var attrs = ELEMENT_TAGS[nodeName](el);
    return jsx('element', attrs, children);
  }
  if (TEXT_TAGS[nodeName]) {
    var _attrs = TEXT_TAGS[nodeName](el);
    return children.map(function (child) {
      return jsx('text', _attrs, child);
    });
  }
  return children;
};
function deserialize(str) {
  var doc = new DOMParser().parseFromString(str, 'text/html');
  var body = doc.body;
  return deserializeElement(body);
}

function serializeElement(el, children) {
  switch (el.type) {
    case 'block-quote':
      return "<blockquote><p>" + children + "</p></blockquote>";
    case 'paragraph':
      return "<p>" + children + "</p>";
    case 'link':
      return "<a href=\"" + escapeHtml(el.url) + "\">" + children + "</a>";
    case 'heading-one':
      return "<h1>" + children + "</h1>";
    case 'numbered-list':
      return "<ol>" + children + "</ol>";
    case 'bulleted-list':
      return "<ul>" + children + "</ul>";
    case 'list-item':
      return "<li>" + children + "</li>";
    default:
      return children;
  }
}
function serializeLeaf(leaf, children) {
  var string = escapeHtml(children);
  if (leaf.bold) {
    string = "<strong>" + string + "</strong>";
  }
  if (leaf.underline) {
    string = "<u>" + string + "</u>";
  }
  if (leaf.italic) {
    string = "<em>" + string + "</em>";
  }
  return string;
}
function serializeHTML(node) {
  if (Text.isText(node)) {
    return serializeLeaf(node, node.text);
  }
  return serializeElement(node, node.children.map(serializeHTML).join(''));
}
function serialize(node) {
  if (typeof node === 'string') return node;
  return node.map(serializeHTML).join('');
}

function toHTMLString(str) {
  var node = document.createElement('div');
  node.innerHTML += str;
  var result = Array.from(node.childNodes).map(function (child) {
    if (child.nodeType === 3 && child.nodeValue !== '\n') {
      return "<p>" + child.nodeValue + "</p>";
    }
    return child.outerHTML;
  });
  return result.join('');
}

function getNumWords(txt) {
  if (txt === void 0) {
    txt = '';
  }
  if (txt.trim().length === 0) return 0;
  return txt.trim().replace(/\s\s+/g, ' ').split(' ').length;
}

var editableExerciseStatus = {
  EMPTY: 'empty',
  LOCKED: 'locked',
  MODIFIED: 'modified',
  NOT_MODIFIED: 'notModified'
};

var withEditableExercise = types$1.model({
  cacheOriginalResponse: types$1.optional(types$1.string, '')
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      if (!state.disabled) {
        state.cacheOriginalResponse = state.getUserResponse();
      }
    },
    cancel: function cancel() {
      state.setResponse(state.cacheOriginalResponse);
      if (!state.isEmpty) state.setDisabled(true);
    },
    edit: function edit() {
      var _state$onEdit;
      state.cacheOriginalResponse = state.getUserResponse();
      state.setDisabled(false);
      state.setEvaluated(false);
      state === null || state === void 0 ? void 0 : (_state$onEdit = state.onEdit) === null || _state$onEdit === void 0 ? void 0 : _state$onEdit.call(state);
    },
    setCacheOriginalResponse: function setCacheOriginalResponse(response) {
      state.cacheOriginalResponse = response;
    }
  };
}).views(function (state) {
  return {
    get editableControlsStatus() {
      var LOCKED = editableExerciseStatus.LOCKED,
        MODIFIED = editableExerciseStatus.MODIFIED,
        NOT_MODIFIED = editableExerciseStatus.NOT_MODIFIED,
        EMPTY = editableExerciseStatus.EMPTY;
      var cacheOriginalResponse = state.cacheOriginalResponse,
        isEmpty = state.isEmpty;
      var userResponse = state.getUserResponse();
      return when()["case"](state.disabled, function () {
        return LOCKED;
      })["case"](isEmpty, function () {
        return EMPTY;
      })["case"](userResponse !== cacheOriginalResponse, function () {
        return MODIFIED;
      }).resolve(function () {
        return NOT_MODIFIED;
      });
    }
  };
});

var withSampleAnswer = types$1.model({
  sample_answer: types$1.optional(types$1.string, '')
}).actions(function (state) {
  return {
    setSampleAnswer: function setSampleAnswer(sampleAnswer) {
      state.sample_answer = sampleAnswer;
      state.updateNotifier();
    }
  };
}).views(function (state) {
  return {};
});

var withConfigureScorm$3 = types$1.compose(withScorm, types$1.model({}).views(function (state) {
  var getItem = function getItem() {
    return {
      userResponse: state.getUserResponse(),
      id: state.raw.reference,
      rightAnswer: '*',
      result: 1
    };
  };
  return {
    get scormType() {
      return scormTypes.FILL_IN;
    },
    getInteractiveListInitScorm: function getInteractiveListInitScorm() {
      return [getItem()];
    },
    updateScormItem: function updateScormItem(name) {
      if (name === 'setContent') {
        return getItem();
      } else return null;
    }
  };
}));

var withXAPINoEvaluable = function withXAPINoEvaluable(_ref) {
  var _ref$interactionType = _ref.interactionType,
    interactionType = _ref$interactionType === void 0 ? '' : _ref$interactionType;
  return types$1.model({}).views(function (state) {
    return {
      getObjectDefinition: function getObjectDefinition() {
        var parent = getParent(state);
        return _extends({
          description: getXAPIDescription(parent),
          objectType: xAPI_ACTIVITY_TYPE
        }, conditionalObjectField(interactionType, {
          interactionType: interactionType
        }));
      }
    };
  });
};
var withXAPINoEvaluable$1 = (function (_temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
    interactionType = _ref2.interactionType;
  return exportXAPI(withXAPINoEvaluable({
    interactionType: interactionType
  }));
});

var emptyResponse = {
  type: 'paragraph',
  children: [{
    text: ''
  }]
};
var RichTextStore = types$1.compose(QuestionBaseModel, withEditableExercise, withSampleAnswer, withConfigureScorm$3, withXAPINoEvaluable$1({
  interactionType: scormTypes.FILL_IN
}), types$1.model({
  response: types$1.optional(types$1.frozen(), [emptyResponse]),
  refreshKey: types$1.optional(types$1.number, function () {
    return Date.now();
  }),
  collaborativeConfig: types$1.maybeNull(types$1.frozen()),
  interactionCompleted: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    setResponse: function setResponse(response) {
      if (response.length === 0) return false;
      var modelType = types$1.string;
      if (!typeChecker(modelType, response)) return false;
      state.response = deserialize(toHTMLString(response));
      state.refreshKey = Date.now();
    },
    setContent: function setContent(content) {
      state.response = content;
    },
    reset: function reset() {
      state.baseReset();
      state.setResponse('<p></p>');
      state.interactionCompleted = false;
    },
    onEdit: function onEdit() {
      state.interactionCompleted = false;
    },
    send: function send() {
      state.isEvaluated = true;
      state.setDisabled(true);
      state.interactionCompleted = true;
    },
    setCollaborativeConfig: function setCollaborativeConfig(config) {
      state.collaborativeConfig = config;
    }
  };
}).views(function (state) {
  return {
    get wordsLimit() {
      return state.raw.data.wordsLimit;
    },
    get isEvaluable() {
      return false;
    },
    getSerialize: function getSerialize() {
      return serialize(state.response);
    },
    getUserResponse: function getUserResponse() {
      var userResponse = serialize(state.response);
      return state.getRealUserResponse(userResponse);
    },
    getResults: function getResults() {
      return {};
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$6(rawData);
    },
    get numWords() {
      return getNumWords(state.response);
    },
    get numLetters() {
      var dom = document.createElement('div');
      dom.innerHTML = state.response;
      return dom.innerText.length;
    },
    get isEmpty() {
      return removeTags(state.getUserResponse()).length === 0;
    }
  };
}));
function _createSnapshot$6(data) {
  var _data$data$wordsLimit = data.data.wordsLimit,
    wordsLimit = _data$data$wordsLimit === void 0 ? 10000 : _data$data$wordsLimit;
  return _extends({}, data.data, importCommonValues$1(data), {
    wordsLimit: wordsLimit
  });
}
function createStore$6(data) {
  return RichTextStore.create(_createSnapshot$6(data));
}

var RichTextStore$1 = types$1.compose(EditorBaseModel, withSampleAnswer, types$1.model({
  wordsLimit: types$1.optional(types$1.number, 10000),
  ui_style: types$1.optional(UIStyleModel$1, defaultUIStyle)
}).actions(function (state) {
  return {
    setMaxLength: function setMaxLength(val) {
      state.max_length = val;
      state.updateNotifier();
    },
    setWordsLimit: function setWordsLimit(val) {
      state.wordsLimit = Math.max(0, parseInt(val, 10));
      state.updateNotifier();
    }
  };
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$7(rawData);
    },
    get output() {
      return exportCommonValues(state, {
        wordsLimit: state.wordsLimit
      });
    }
  };
}));
function _createSnapshot$7(data) {
  var _data$data$wordsLimit = data.data.wordsLimit,
    wordsLimit = _data$data$wordsLimit === void 0 ? 10000 : _data$data$wordsLimit;
  return _extends({}, data.data, importCommonValues$1(data), {
    wordsLimit: wordsLimit,
    isEvaluable: false
  });
}
function createStore$7(data) {
  return RichTextStore$1.create(_createSnapshot$7(data));
}

var spacingInFirefox = navigator.userAgent.search('Firefox') > -1 ? {
  whiteSpace: 'pre'
} : {};
function ShortTextQuestion(props) {
  var store = props.store,
    placeholder = props.placeholder;
  var changedHandlers = /setTitle|setStimulus|setResponse|setValue|lemoFastUpdate/;
  var handleResponse = useCallback(function (_ref) {
    var target = _ref.target;
    store.setValue(target.value);
  }, [store]);
  var isSuccess = store.success || store.internalAutoFeedback;
  var isError = store.error && !store.internalAutoFeedback;
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-body"
  }, store.max_length > 0 && /*#__PURE__*/React__default.createElement(TextCounter, {
    limit: store.max_length,
    count: store.value.length,
    predicate: "letters_limit"
  }), /*#__PURE__*/React__default.createElement("textarea", {
    className: classNames('lemo-response', 'lemo-base-input', {
      'lemo-selected': store.selected,
      'lemo-lock': store.lock,
      'lemo-success': isSuccess,
      'lemo-error': isError
    }),
    placeholder: placeholder || translate('essay_placeholder'),
    value: store.value,
    onChange: handleResponse,
    maxLength: store.max_length,
    rows: 3,
    disabled: store.disabled,
    style: _extends({}, spacingInFirefox)
  })));
}
var ShortTextQuestion$1 = observer(ShortTextQuestion);

var preProcessLatex = function preProcessLatex(expr) {
  return normalizeLatex(expr).replace(/÷/g, '/').replace(/×/g, '*').replace(/−/g, '-').replace(/\s/g, '');
};
var simplifyExpression = function simplifyExpression(expr) {
  try {
    var node = parse(expr);
    return simplify(node, {
      context: {
        x: parse('x'),
        y: parse('y')
      }
    }).toString();
  } catch (e) {
    return expr;
  }
};
function compareExpressions(a, b) {
  try {
    var processedA = preProcessLatex(a);
    var processedB = preProcessLatex(b);
    try {
      var simplifiedA = simplifyExpression(processedA);
      var simplifiedB = simplifyExpression(processedB);
      if (simplifiedA === simplifiedB) {
        return true;
      }
      var testCases = [{
        x: 1,
        y: 1
      }, {
        x: 2,
        y: 1
      }, {
        x: 3,
        y: 2
      }];
      var result = testCases.every(function (scope) {
        try {
          var evalA = evaluate(processedA, scope);
          var evalB = evaluate(processedB, scope);
          return equal(evalA, evalB);
        } catch (_unused) {
          return false;
        }
      });
      return result;
    } catch (_unused2) {
      return false;
    }
  } catch (_unused3) {
    return false;
  }
}
var normalizeFromBasicToLatex = function normalizeFromBasicToLatex(expression) {
  if (!expression) return '';
  try {
    return expression.replace(/÷/g, '\\div').replace(/×/g, '\\times');
  } catch (e) {
    return expression;
  }
};
var normalizeFromLatexToBasic = function normalizeFromLatexToBasic(expression) {
  if (!expression) return '';
  try {
    return expression.replace(/\\div/g, '÷').replace(/\\times/g, '×').replace(/-/g, '−');
  } catch (e) {
    return expression;
  }
};
var normalizeDecimalSeparator = function normalizeDecimalSeparator(expression) {
  return expression.replace(/{,}|,/g, '.');
};
var normalizeLatex = function normalizeLatex(expression) {
  try {
    var normalized = expression.replace(/\\frac{([^{}]+)\^{([^{}]+)}}{([^{}]+)}/g, '(($1^($2))/($3))').replace(/\\frac(\d)(\d)/g, '\\frac{$1}{$2}').replace(/\\frac{\\left\(([^()]+)\)}{\\left\(([^()]+)\)}/g, '(($1)/($2))').replace(/\\frac{\\left\(([^()]+)\)}{([^{}]+)}/g, '(($1)/($2))').replace(/\\frac{([^{}]+)}{\\left\(([^()]+)\)}/g, '(($1)/($2))').replace(/\\frac{([^{}]+)}{([^{}]+)}/g, '(($1)/($2))').replace(/\\left\(/g, '(').replace(/\\right\)/g, ')').replace(/÷/g, '/').replace(/×/g, '*').replace(/\\div/g, '/').replace(/\\times/g, '*').replace(/\\cdot/g, '*').replace(/\^{([^{}]+)}/g, '^($1)').replace(/([0-9])([a-zA-Z])/g, '$1*$2').replace(/([a-zA-Z])([0-9])/g, '$1*$2').replace(/([a-zA-Z])([a-zA-Z])/g, '$1*$2').replace(/\(\(([^()]+)\)\)/g, '($1)').replace(/\s/g, '');
    return normalized;
  } catch (e) {
    return expression;
  }
};
function compareDecimalExpressions(a, b, decimalPlaces) {
  try {
    var _a = evaluate(normalizeLatex(a));
    var _b = evaluate(normalizeLatex(b));
    return limitDecimalPlaces(decimalPlaces, _a) === limitDecimalPlaces(decimalPlaces, _b);
  } catch (e) {
    return false;
  }
}
function limitDecimalPlaces(decimalPlaces, n) {
  if (decimalPlaces === 0) return parseInt(n);
  var value = n.toString();
  var parts = value.split('.');
  if (parts.length > 1 && parts[1].length > decimalPlaces) {
    parts[1] = parts[1].substring(0, decimalPlaces);
    value = parts.join('.');
  }
  return Number(value);
}
function isNumeric(val) {
  try {
    var result = evaluate(normalizeLatex(val));
    return typeof result === 'number' && !isNaN(result);
  } catch (e) {
    return false;
  }
}
function clearPower1(value) {
  return value.replace(/\^1/g, '');
}
function normalizeSingleDigitPowers(value) {
  return value.replace(/\^{([0-9])}/g, '^$1');
}

function removeAccents(str) {
  try {
    return str.replace(/[àáâãäå]/g, 'a').replace(/[èéêë]/g, 'e').replace(/[ìíîï]/g, 'i').replace(/[òóôõö]/g, 'o').replace(/[ùúûü]/g, 'u').replace(/[ÀÁÂÃÄÅ]/g, 'A').replace(/[ÈÉÊË]/g, 'E').replace(/[ÌÍÎÏ]/g, 'I').replace(/[ÒÓÔÕÖ]/g, 'O').replace(/[ÙÚÛÜ]/g, 'U');
  } catch (err) {
    return str;
  }
}
function lowerCases(str) {
  try {
    return str.toLowerCase();
  } catch (err) {
    return str;
  }
}
function removeSpaces(str) {
  try {
    return str.replace(/\s+/g, ' ').trim();
  } catch (err) {
    return str;
  }
}
function removeStrangeCharacters(str) {
  return str.replace(/[\r\n]+/gm, '');
}
function normalizeString(str, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    _options$accents = _options.accents,
    accents = _options$accents === void 0 ? true : _options$accents,
    _options$lower = _options.lower,
    lower = _options$lower === void 0 ? true : _options$lower,
    _options$spaces = _options.spaces,
    spaces = _options$spaces === void 0 ? false : _options$spaces;
  var result = removeStrangeCharacters(str);
  if (!accents) result = removeAccents(result);
  if (!lower) result = lowerCases(result);
  if (spaces) result = removeSpaces(result);
  return result;
}

var InputNormalizationModel = types$1.model('InputNormalizationModel', {
  accents: types$1.optional(types$1["boolean"], true),
  spaces: types$1.optional(types$1["boolean"], true),
  lower: types$1.optional(types$1["boolean"], true),
  isMath: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    toggleAccents: function toggleAccents() {
      state.accents = !state.accents;
      state.updateNotifier();
    },
    toggleSpaces: function toggleSpaces() {
      state.spaces = !state.spaces;
      state.updateNotifier();
    },
    toggleLower: function toggleLower() {
      state.lower = !state.lower;
      state.updateNotifier();
    },
    toggleIsMath: function toggleIsMath() {
      state.isMath = !state.isMath;
      state.updateNotifier();
    },
    updateNotifier: function updateNotifier() {
      getParent(state).updateNotifier();
    }
  };
}).views(function (state) {
  return {
    resolve: function resolve(str) {
      if (state.isMath) return str;
      return normalizeString(str, {
        accents: state.accents,
        lower: state.lower,
        spaces: !state.spaces
      });
    },
    test: function test(a, b) {
      if (state.isMath) return compareExpressions(a, b);
      return state.resolve(a) === state.resolve(b);
    },
    get output() {
      return {
        normalization: getSnapshot(state)
      };
    }
  };
});

function delayedUpdate(fn, time) {
  if (time === void 0) {
    time = 500;
  }
  setTimeout(fn, time);
}

var ShortTextEditorStore = types$1.compose(EditorBaseModel, withSampleAnswer, types$1.model({
  value: types$1.optional(types$1.string, ''),
  max_length: types$1.optional(types$1.number, 10000),
  normalization: types$1.optional(InputNormalizationModel, {}),
  ui_style: types$1.optional(UIStyleModel$1, defaultUIStyle)
}).actions(function (state) {
  return {
    setValue: function setValue(str) {
      state.value = str;
      state.updateNotifier(false);
    },
    setMaxLength: function setMaxLength(num, update) {
      if (update === void 0) {
        update = false;
      }
      if (!update) return delayedUpdate(function () {
        return state.setMaxLength(num, true);
      });
      state.max_length = num;
      state.updateNotifier();
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      try {
        var data = _createSnapshot$8(rawData);
        applySnapshot(state, data);
        return Promise.resolve(new Promise(function (resolve) {
          return setTimeout(resolve, 100);
        }));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$8(rawData);
    },
    get output() {
      return exportCommonValues(state, {
        max_length: state.max_length,
        normalization: getSnapshot(state.normalization)
      });
    }
  };
}));
function _createSnapshot$8(data) {
  return _extends({}, data.data, importCommonValues$1(data));
}
function createStore$8(data) {
  return ShortTextEditorStore.create(_createSnapshot$8(data));
}

var withConfigureScorm$4 = types$1.compose(withScorm, types$1.model({}).views(function (state) {
  return {
    get scormType() {
      return scormTypes.FILL_IN;
    },
    getInteractiveListInitScorm: function getInteractiveListInitScorm() {
      return [{
        userResponse: state.value,
        id: state.raw.reference,
        rightAnswer: state.validation.solutionList.map(function (_ref) {
          var value = _ref.value;
          return value;
        }),
        result: state.points > 0
      }];
    },
    updateScormItem: function updateScormItem(name) {
      if (name === 'setValue') {
        return {
          id: state.raw.reference,
          userResponse: state.getUserResponse(),
          result: state.points > 0
        };
      } else return null;
    }
  };
}));

var withXAPITypeFillIn = function withXAPITypeFillIn(_ref) {
  var xAPISolution = _ref.xAPISolution,
    _ref$interactionType = _ref.interactionType,
    interactionType = _ref$interactionType === void 0 ? scormTypes.FILL_IN : _ref$interactionType;
  return types$1.model({}).views(function (state) {
    return {
      getObjectDefinition: function getObjectDefinition() {
        var parent = getParent(state);
        var solution = (xAPISolution === null || xAPISolution === void 0 ? void 0 : xAPISolution(parent)) || parent.validation.value;
        return {
          description: getXAPIDescription(parent),
          correctResponsesPattern: formatResponses(solution),
          objectType: xAPI_ACTIVITY_TYPE,
          interactionType: interactionType
        };
      }
    };
  });
};
var withXAPITypeFillIn$1 = (function (_temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
    xAPISolution = _ref2.xAPISolution,
    interactionType = _ref2.interactionType;
  return exportXAPI(withXAPITypeFillIn({
    xAPISolution: xAPISolution,
    interactionType: interactionType
  }));
});

var ShortTextStore = types$1.compose(QuestionBaseModel, withSampleAnswer, withConfigureScorm$4, withXAPITypeFillIn$1(), types$1.model({
  value: types$1.optional(types$1.string, ''),
  normalization: types$1.optional(InputNormalizationModel, {})
}).actions(function (state) {
  return {
    setResponse: function setResponse(str) {
      if (!typeChecker(types$1.string, str)) return false;
      state.setValue(str);
    },
    setValue: function setValue(str) {
      state.value = str;
      state.updateNotifier();
    },
    reset: function reset() {
      state.baseReset();
      state.value = '';
      state.updateNotifier();
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview() {
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  var normalize = function normalize(str) {
    return state.normalization.resolve(str);
  };
  var validateResponse = function validateResponse(solution) {
    return normalize(solution.value) === normalize(state.getUserResponse()) ? parseFloat(solution.score) : 0;
  };
  return {
    get ui_style() {
      return state.raw.data.ui_style;
    },
    get max_length() {
      return state.raw.data.max_length;
    },
    getUserResponse: function getUserResponse() {
      var userResponse = state.value;
      return state.getRealUserResponse(userResponse);
    },
    getResults: function getResults() {
      return state.validation.solutionList.reduce(function (acc, next) {
        var result = validateResponse(next);
        return acc < result ? result : acc;
      }, 0);
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$9(rawData);
    },
    get success() {
      if (state.showSolution) return true;
      return state.isEvaluated && state.isEvaluable && state.points > 0;
    },
    get error() {
      if (state.showSolution) return false;
      return state.isEvaluated && state.isEvaluable && state.points <= 0;
    },
    get selected() {
      return state.value.length > 0;
    },
    get lock() {
      return state.isEvaluated;
    }
  };
}));
function _createSnapshot$9(data) {
  return _extends({}, data.data, importCommonValues$1(data), {
    input_type: defaultValue('response_container.input_type', data.data, 'text')
  });
}
function createStore$9(data) {
  return ShortTextStore.create(_createSnapshot$9(data));
}

var EditorSampleAnswer = function EditorSampleAnswer(_ref) {
  var sampleAnswer = _ref.sampleAnswer,
    onChangeSampleAnswer = _ref.onChangeSampleAnswer,
    titleBox = _ref.titleBox,
    placeholder = _ref.placeholder,
    assetsFroalaApi = _ref.assetsFroalaApi;
  var _useState = useState(sampleAnswer),
    _sampleAnswer = _useState[0],
    _setSampleAnswer = _useState[1];
  var _useState2 = useState(isCheckedToogleInit()),
    isChecked = _useState2[0],
    setIsChecked = _useState2[1];
  function isCheckedToogleInit() {
    return hasData(_sampleAnswer);
  }
  function onChangeToggle(isCheckedToogle) {
    setIsChecked(isCheckedToogle);
    if (!isCheckedToogle) {
      onChangeSampleAnswer('');
    } else {
      onChangeSampleAnswer(_sampleAnswer);
    }
  }
  function _onChangeHint(value) {
    _setSampleAnswer(value);
    onChangeSampleAnswer(value);
  }
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "hints",
    icon: /*#__PURE__*/React__default.createElement(SvgLightBulb, {
      className: "lemo-editor-sample-answer-icon"
    }),
    titleBox: titleBox || translate('sample_answer_title_box'),
    helpText: translate('sample_answer_help')
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-stack-layout-150"
  }, /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('sample_answer_title'),
    subtitle: translate('sample_answer_subtitle'),
    isChecked: isChecked,
    onChange: onChangeToggle
  }), isChecked && /*#__PURE__*/React__default.createElement(FroalaField$1, {
    key: 'sample-answer',
    editMode: true,
    content: _sampleAnswer,
    setContent: function setContent(value) {
      return _onChangeHint(value);
    },
    placeholder: placeholder || translate('sample_answer_placeholder'),
    assetsFroalaApi: assetsFroalaApi
  }))));
};
EditorSampleAnswer.propTypes = {
  title: propTypes.string,
  onTitleChange: propTypes.func,
  titleBox: propTypes.string,
  placeholder: propTypes.string,
  assetsFroalaApi: propTypes.string
};
EditorSampleAnswer.defaultProps = {
  title: '',
  onTitleChange: function onTitleChange(text) {
    return console.log(text);
  }
};

var EditorSampleAnswerStore = function EditorSampleAnswerStore(_ref) {
  var store = _ref.store;
  return config.showSampleAnswer && /*#__PURE__*/React__default.createElement(EditorSampleAnswer, {
    sampleAnswer: store.sample_answer,
    onChangeSampleAnswer: function onChangeSampleAnswer(value) {
      return store.setSampleAnswer(value);
    },
    assetsFroalaApi: getAssetsEditorApi(store.assetsEditorApi)
  });
};
EditorSampleAnswerStore.propTypes = {};
var EditorSampleAnswerStore$1 = observer(EditorSampleAnswerStore);

var _excluded$6 = ["store", "changed", "type"];
var RichTextEditor = function RichTextEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$6);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setTitle|setStimulus|setMaxLength|setLettersLimit|setBackground|setWordsLimit|setSampleAnswer",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      hide: true
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 1,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref)
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorSampleAnswerStore$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: [TYPES_CONFIG.CONFIG_WORDS_LIMIT]
  }));
};
var RichTextEditor$1 = observer(RichTextEditor);

var _excluded$7 = ["store", "changed", "type"];
var ShortTextEditor = function ShortTextEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$7);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setTitle|setStimulus|setValue|setScore|createAlternativeSolution|changeScore|updateSolution|removeSolution|setIsEvaluable|toggleLower|toggleAccents|toggleSpaces|setBackground|toggleIsMath|setMaxLength|lemoFastUpdate|setSampleAnswer",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 0
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 1,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref)
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    evaluationTypes: [getEvaluationTypeOption(keysTranslateEvaluationTypes.EXACT_MATCH, keysTranslateSubtitleEvaluationTypes.EXACT_MATCH, validationModes.EXACT_MATCH), getEvaluationTypeOption(keysTranslateEvaluationTypes.MANUAL, keysTranslateSubtitleEvaluationTypes.MANUAL, validationModes.MANUAL)],
    helpText: translate('manual_or_alternative_solutions_help'),
    showPenalty: false
  }), /*#__PURE__*/React__default.createElement(EditorSampleAnswerStore$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: [TYPES_CONFIG.CONFIG_ACCENT_SENSITIVE, TYPES_CONFIG.CONFIG_CASE_SENSITIVE, TYPES_CONFIG.CONFIG_FIX_SPACES, TYPES_CONFIG.CONFIG_MAX_CHARACTER]
  }));
};
var ShortTextEditor$1 = observer(ShortTextEditor);

function questionBodyToEssay(renderElement) {
  return new Promise(function (resolve) {
    var _questionBody$childNo, _questionBody$childNo2;
    var questionBody = renderElement.querySelector('.lemo-question-body');
    if (!questionBody) return false;
    var response = ((_questionBody$childNo = questionBody.childNodes) === null || _questionBody$childNo === void 0 ? void 0 : (_questionBody$childNo2 = _questionBody$childNo[1]) === null || _questionBody$childNo2 === void 0 ? void 0 : _questionBody$childNo2.value) || '';
    var hasResponse = response.length > 0;
    var tableStyle = hasResponse ? 'background-color: #ffffff; border: 2px solid #28C59D;' : 'background-color: #f2f2f2;';
    var box = document.createElement('div');
    box.style.width = '100%';
    box.innerHTML = "\n      <table width=\"100%\" style=\"" + tableStyle + "\">\n        <tr><td style=\"padding: 40px 10px;\">" + response + "&nbsp;</td></tr>\n      </table>\n    ";
    questionBody.remove();
    hasResponse ? renderElement.appendChild(box) : createMarginBottom(renderElement);
    resolve();
  });
}
function createMarginBottom(renderElement) {
  renderElement.insertAdjacentHTML('beforeend', '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>');
}

function PrintViewGeneric$1(_ref) {
  var store = _ref.store,
    response = _ref.response,
    isEvaluated = _ref.isEvaluated,
    isSolved = _ref.isSolved,
    _ref$onComplete = _ref.onComplete,
    onComplete = _ref$onComplete === void 0 ? noop : _ref$onComplete;
  var root = useRef();
  var _usePrintView = usePrintView({
      store: store,
      root: root,
      onComplete: onComplete,
      response: response,
      isEvaluated: isEvaluated,
      isSolved: isSolved,
      onQuestionReady: function onQuestionReady() {
        return questionBodyToEssay(root.current);
      }
    }),
    activity = _usePrintView.activity;
  return activity !== null ? /*#__PURE__*/React__default.createElement("div", {
    key: isSolved ? 'solved' : 'notSolved',
    ref: root,
    className: "lemo-print-view"
  }, /*#__PURE__*/React__default.createElement(activity.Question, null)) : null;
}
var _PrintView$1 = observer(PrintViewGeneric$1);

function getEssay(props) {
  var _getCreator = getCreator(props, getDefaultData$3, types.essay.PlainText),
    type = _getCreator.type,
    exerciseData = _getCreator.exerciseData,
    setCommonParamsStore = _getCreator.setCommonParamsStore;
  return when()["case"](type === types.essay.PlainText || type === types.essay.RichText, function () {
    var questionStore = createStore$6(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$7(exerciseData);
    setCommonParamsStore(editorStore);
    return createRichText(editorStore, questionStore);
  })["case"](types.essay.ShortText, function () {
    var questionStore = createStore$9(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$8(exerciseData);
    setCommonParamsStore(editorStore);
    return createShortText(editorStore, questionStore);
  }).resolve(null);
}
function createRichText(editorStore, questionStore) {
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(RichTextQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(RichTextEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(SendControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    PrintView: function PrintView(extraParams) {
      return /*#__PURE__*/React__default.createElement(_PrintView$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createShortText(editorStore, questionStore) {
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(ShortTextQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(ShortTextEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    PrintView: function PrintView(extraParams) {
      return /*#__PURE__*/React__default.createElement(_PrintView$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}

var checkDropTarget = function checkDropTarget(m, target) {
  return m.x > target.left && m.x < target.right && m.y > target.top && m.y < target.bottom;
};
var checkDropTargetByBox = function checkDropTargetByBox(dragBounds, target) {
  if (dragBounds.left >= target.right || target.left >= dragBounds.right) return undefined;
  if (dragBounds.top >= target.bottom || target.top >= dragBounds.bottom) return undefined;
  return target;
};
var findDropTarget = function findDropTarget(m, targets) {
  var targetList = Array.from(targets);
  var dragBounds = m.dragTarget.getBoundingClientRect();
  return targetList.find(function (t) {
    return checkDropTarget(m, t.getBoundingClientRect());
  }) || targetList.find(function (t) {
    return checkDropTargetByBox(dragBounds, t.getBoundingClientRect());
  });
};
var getDropTarget = function getDropTarget(e, dropTargetClass) {
  return new Promise(function (resolve) {
    var dropList = document.querySelectorAll(dropTargetClass);
    var dropTarget = findDropTarget(getEventCoords(e), dropList);
    return resolve(dropTarget);
  });
};
var getEventCoords = function getEventCoords(e) {
  return e.changedTouches ? {
    x: e.changedTouches[0].clientX,
    y: e.changedTouches[0].clientY,
    dragTarget: e.target
  } : {
    x: e.clientX,
    y: e.clientY,
    dragTarget: e.target
  };
};
var getNumber = function getNumber(val) {
  return val || 0;
};
function overflowTop(a, b) {
  var difference = getNumber(a.top) - getNumber(b.top);
  return difference < 0 ? Math.abs(difference) : 0;
}
function overflowLeft(a, b) {
  var difference = getNumber(a.left) - getNumber(b.left);
  return difference < 0 ? Math.abs(difference) : 0;
}
function overflowBottom(a, b) {
  var difference = getNumber(b.bottom) - getNumber(a.bottom);
  return Math.min(difference, 0);
}
function overflowRight(a, b) {
  var difference = getNumber(b.right) - getNumber(a.right);
  return Math.min(difference, 0);
}
function fixDragPosition(_ref) {
  var position = _ref.position,
    a = _ref.dragBoundingBox,
    b = _ref.baseBoundingBox;
  var x = position.x + overflowLeft(a, b) + overflowRight(a, b);
  var y = position.y + overflowTop(a, b) + overflowBottom(a, b);
  return {
    x: x,
    y: y
  };
}

function useSimpleDragDrop(_ref) {
  var dragModel = _ref.dragModel,
    dropTargetClass = _ref.dropTargetClass,
    onDrop = _ref.onDrop,
    onDropOut = _ref.onDropOut,
    onStartDragging = _ref.onStartDragging,
    onClick = _ref.onClick,
    keepPositionAfterDrop = _ref.keepPositionAfterDrop,
    _ref$useDragModelPosi = _ref.useDragModelPosition,
    useDragModelPosition = _ref$useDragModelPosi === void 0 ? false : _ref$useDragModelPosi;
  var _useState = useState({
      x: 0,
      y: 0
    }),
    localPosition = _useState[0],
    setLocalPosition = _useState[1];
  var position = useDragModelPosition ? dragModel.position : localPosition;
  var setPosition = useDragModelPosition ? dragModel.setPosition : setLocalPosition;
  var _useState2 = useState(false),
    isDragging = _useState2[0],
    setIsDragging = _useState2[1];
  var getStore = function getStore() {
    return !isRoot(dragModel) ? getParent(dragModel, 2) : null;
  };
  function onMouseDown() {}
  function updateDragPosition(delta) {
    if (keepPositionAfterDrop) setPosition({
      x: delta.x,
      y: delta.y
    });
  }
  function onMouseUp(e, delta) {
    if (!isDragging) return onClick === null || onClick === void 0 ? void 0 : onClick(e);
    var _getParent = getParent(dragModel, 2),
      clearWhileDraggingTarget = _getParent.clearWhileDraggingTarget;
    setIsDragging(false);
    var store = getStore();
    getDropTarget(e, dropTargetClass).then(function (dropTarget) {
      if (dropTarget === undefined) onDropOut(dragModel);
      onDrop(dropTarget, delta, e);
    })["catch"](function () {
      return onDropOut();
    });
    clearWhileDraggingTarget();
    updateDragPosition(delta);
  }
  function onMouseMove(e) {
    isDragging === false && (onStartDragging === null || onStartDragging === void 0 ? void 0 : onStartDragging(e));
    setIsDragging(true);
    var store = getStore();
    if (store) {
      var setWhileDraggingTarget = store.setWhileDraggingTarget,
        clearWhileDraggingTarget = store.clearWhileDraggingTarget;
      getDropTarget(e, dropTargetClass).then(function (target) {
        return setWhileDraggingTarget(target.getAttribute('data-id'));
      })["catch"](clearWhileDraggingTarget);
    }
  }
  function onDrag(e, data) {
    if (Math.abs(data.deltaX) > 5 || Math.abs(data.deltaY) > 5) {
      onMouseMove(e);
    }
  }
  return {
    dragProps: {
      position: safeSnapshot(position),
      setPosition: setPosition,
      onStart: onMouseDown,
      onStop: onMouseUp,
      onDrag: onDrag
    },
    isDragging: isDragging
  };
}

var Drag = function Drag(_ref) {
  var _drag$value;
  var drag = _ref.drag,
    onClick = _ref.onClick,
    matchResponse = _ref.matchResponse,
    _ref$onDropOut = _ref.onDropOut,
    onDropOut = _ref$onDropOut === void 0 ? noop : _ref$onDropOut,
    dropTargets = _ref.dropTargets,
    disabled = _ref.disabled,
    hidden = _ref.hidden,
    isError = _ref.isError,
    isSuccess = _ref.isSuccess,
    _ref$overflow = _ref.overflow,
    overflow = _ref$overflow === void 0 ? false : _ref$overflow;
  var nodeRef = useRef(null);
  var isImage = drag === null || drag === void 0 ? void 0 : (_drag$value = drag.value) === null || _drag$value === void 0 ? void 0 : _drag$value.includes('<img');
  var onDrop = useCallback(function (dropTarget) {
    if (!dropTarget) return drag.resetTarget();
    var targetId = dropTarget.getAttribute('data-id');
    targetId === 'none' ? drag.resetTarget() : matchResponse(targetId, drag);
  }, [matchResponse, drag]);
  var _useSimpleDragDrop = useSimpleDragDrop({
      dragModel: drag,
      dropTargetClass: dropTargets,
      onDropOut: onDropOut,
      onDrop: onDrop,
      onClick: onClick
    }),
    dragProps = _useSimpleDragDrop.dragProps,
    isDragging = _useSimpleDragDrop.isDragging;
  useEffect(function () {
    drag.setIsDragging(isDragging);
  }, [isDragging]);
  return /*#__PURE__*/React__default.createElement(Draggable$1, _extends({}, dragProps, {
    disabled: disabled,
    nodeRef: nodeRef
  }), /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "drag",
    className: cn('lemo-drag-option', 'lemo-drag-box', {
      'lemo-dragging': isDragging,
      'lemo-selected': drag.isSelected,
      'lemo-disabled': disabled,
      'lemo-is-dropped': drag.drop,
      'lemo-no-padding': isImage,
      'lemo-overflow': overflow,
      'lemo-success': isSuccess,
      'lemo-error': isError,
      'lemo-is-highlighted': drag.isHighlighted
    }),
    style: {
      visibility: hidden ? 'hidden' : 'visible'
    }
  }, isAlive(drag) && /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    className: "lemo-drag-content lemo-text-body-m-regular lemo-color-text-02",
    content: drag.value
  })));
};
var Drag$1 = observer(Drag);

var CONTAINER_DRAGS_CLASS = 'lemo-drags-container';

var DropItem = function DropItem(_ref) {
  var response = _ref.response,
    _onClick = _ref.onClick,
    _onDropOut = _ref.onDropOut;
  var nodeRef = useRef();
  var store = useRef();
  if (isAlive(response)) {
    store.current = getParent(response, 2);
  } else {
    return null;
  }
  var dropTargets = "." + CONTAINER_DRAGS_CLASS + ", .lemo-drop-area";
  return /*#__PURE__*/React__default.createElement("div", {
    id: "drop-" + response.id,
    className: cn$1('lemo-drop-item', {
      'lemo-disabled': response.isDisabled,
      'lemo-selected': response.isSelected,
      'lemo-is-empty': !response.drag,
      'lemo-is-highlighted': response.isHighLighted,
      'lemo-is-dragging-over': response.isDraggingOver,
      'lemo-success': response.success,
      'lemo-error': response.error
    }),
    ref: nodeRef
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: 'relative'
    }
  }, response.drag && /*#__PURE__*/React__default.createElement(Drag$1, {
    drag: response.drag,
    matchResponse: store.current.matchResponse,
    onClick: response.drag.select,
    onDropOut: function onDropOut(drag) {
      return _onDropOut(drag);
    },
    dropTargets: dropTargets,
    isSuccess: response.success,
    isError: response.error
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-drop-area",
    "data-id": response.id,
    onClick: function onClick() {
      return response.drag ? null : _onClick === null || _onClick === void 0 ? void 0 : _onClick(response);
    }
  }, response.drag && /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    className: "lemo-shim lemo-text-body-m-regular lemo-color-text-02",
    content: response.drag.value
  }))), /*#__PURE__*/React__default.createElement(FeedbackPin$1, {
    idx: response.feedbackIndex,
    result: response.resultCache,
    visible: response.withPin && response.isWrongCache,
    classAdd: 'lemo-base-feedback-pin',
    feedback: response.feedback
  }));
};
DropItem.propTypes = {
  response: propTypes.object,
  onClick: propTypes.func
};
var TextBlank = observer(DropItem);

var retry = function retry(fn, tries, delay) {
  if (tries === void 0) {
    tries = 2;
  }
  if (delay === void 0) {
    delay = 100;
  }
  try {
    var _temp3 = function _temp3(_result2) {
      if (_exit) return _result2;
      throw lastError;
    };
    var _exit = false;
    var lastError;
    var _attempt = 1;
    var _temp2 = _for(function () {
      return !_exit && _attempt <= tries;
    }, function () {
      return _attempt++;
    }, function () {
      return _catch(function () {
        return Promise.resolve(fn()).then(function (_await$fn) {
          _exit = true;
          return _await$fn;
        });
      }, function (error) {
        lastError = error;
        var _temp = function () {
          if (_attempt < tries) {
            return Promise.resolve(new Promise(function (resolve) {
              return setTimeout(resolve, delay);
            })).then(function () {});
          }
        }();
        return _temp && _temp.then ? _temp.then(function () {}) : void 0;
      });
    });
    return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(_temp3) : _temp3(_temp2));
  } catch (e) {
    return Promise.reject(e);
  }
};

function TemplatePortal(_ref) {
  var children = _ref.children,
    targetId = _ref.targetId;
  var _useState = useState(null),
    targetElement = _useState[0],
    setTargetElement = _useState[1];
  function initPortal(targetId) {
    var element = document.getElementById(targetId);
    if (element) {
      setTargetElement(element);
    } else {
      retry(function () {
        return initPortal(targetId);
      }, 3, 100)["catch"](function () {
        console.error('Error al inicializar el portal');
      });
    }
  }
  useEffect(function () {
    initPortal(targetId);
  }, [targetId]);
  return targetElement ? createPortal(children, targetElement) : null;
}
var TemplatePortal$1 = observer(TemplatePortal);

function QuestionTemplate(_ref) {
  var store = _ref.store,
    children = _ref.children,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? autoFocusTypes.NONE : _ref$autoFocus;
  var _useState = useState(false),
    delayedStart = _useState[0],
    setDelayedStart = _useState[1];
  useEffect(function () {
    setDelayedStart(true);
  }, []);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    "data-testid": "template",
    className: "lemo-cloze-question-template lemo-text-body-m-regular ",
    content: store.templateToView
  })), delayedStart && store.responses.map(function (response, idx) {
    return /*#__PURE__*/React__default.createElement(TemplatePortal$1, {
      key: response.id,
      targetId: response.id
    }, /*#__PURE__*/React__default.createElement(children.type, _extends({
      key: response.id,
      response: response,
      disabled: store.disabled,
      autoFocus: autoFocus === autoFocusTypes.ENABLED && idx === 0 && !store.isEvaluated ? autoFocus : autoFocusTypes.NONE
    }, children.props)));
  }));
}
var QuestionTemplate$1 = observer(QuestionTemplate);

function useDispatchOnResponseChange(_ref) {
  var store = _ref.store,
    _ref$changed = _ref.changed,
    changed = _ref$changed === void 0 ? noop : _ref$changed;
  var _useState = useState(false),
    loaded = _useState[0],
    setLoaded = _useState[1];
  var handleChange = function handleChange() {
    var _store$getResponseWit;
    return changed === null || changed === void 0 ? void 0 : changed({
      output: store.output,
      points: store === null || store === void 0 ? void 0 : store.points,
      response: store === null || store === void 0 ? void 0 : (_store$getResponseWit = store.getResponseWithKey) === null || _store$getResponseWit === void 0 ? void 0 : _store$getResponseWit.call(store),
      store: store
    });
  };
  useEffect(function () {
    if (changed && loaded) {
      setTimeout(function () {
        return handleChange();
      }, 10);
    }
    if (!loaded) setLoaded(true);
  }, [store.getUserResponse().toString()]);
}

function getPositionBasedOnAncestor(element, ancestor) {
  var x = 0;
  var y = 0;
  while (element && element !== ancestor) {
    x += element.offsetLeft;
    y += element.offsetTop;
    element = element.offsetParent;
  }
  return {
    x: x,
    y: y
  };
}

function useAutoDrop(_ref) {
  var store = _ref.store,
    ancestor = _ref.ancestor;
  function getNextAvailableDrop() {
    if (!store.nextAvailableDrop) return;
    console.log('>>', ancestor.current.querySelector("#drop-" + store.nextAvailableDrop.id));
    return ancestor.current.querySelector("#drop-" + store.nextAvailableDrop.id);
  }
  function moveDrag(_ref2) {
    var dragElement = _ref2.dragElement,
      dropPos = _ref2.dropPos,
      dragPos = _ref2.dragPos,
      onFinish = _ref2.onFinish;
    var x = dropPos.x - dragPos.x;
    var y = dropPos.y - dragPos.y;
    var animation = dragElement.animate([{
      transform: "translate(" + x + "px, " + y + "px)"
    }], {
      duration: 300,
      easing: 'ease-in-out'
    });
    animation.onfinish = onFinish;
  }
  function autoDrop(dragElement, drag) {
    var dropElement = getNextAvailableDrop();
    if (!dropElement) return drag.select();
    var dropPos = getPositionBasedOnAncestor(dropElement, ancestor.current);
    var dragPos = getPositionBasedOnAncestor(dragElement, ancestor.current);
    var dropId = store.nextAvailableDrop.id;
    moveDrag({
      dragElement: dragElement,
      dropPos: dropPos,
      dragPos: dragPos,
      onFinish: function onFinish() {
        return store.matchResponse(dropId, drag);
      }
    });
  }
  return autoDrop;
}

function DuplicateInstance(_ref) {
  var content = _ref.content;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-drag-duplicate lemo-drag-option lemo-drag-box"
  }, /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    className: "lemo-drag-content lemo-text-body-m-regular lemo-color-text-02",
    content: content
  }));
}
var DuplicateInstance$1 = observer(DuplicateInstance);

var DragWithDuplicates = function DragWithDuplicates(_ref) {
  var drag = _ref.drag,
    onClick = _ref.onClick,
    matchResponse = _ref.matchResponse,
    dropTargets = _ref.dropTargets,
    disabled = _ref.disabled,
    hidden = _ref.hidden,
    onDropOut = _ref.onDropOut,
    _ref$showCallOut = _ref.showCallOut,
    showCallOut = _ref$showCallOut === void 0 ? false : _ref$showCallOut;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-drag-with-duplicates', {
      'lemo-callout': showCallOut
    })
  }, /*#__PURE__*/React__default.createElement(Drag$1, {
    drag: drag,
    onClick: onClick,
    matchResponse: matchResponse,
    dropTargets: dropTargets,
    disabled: disabled,
    onDropOut: onDropOut,
    hidden: hidden
  }), drag.hasDuplicates && /*#__PURE__*/React__default.createElement(DuplicateInstance$1, {
    content: drag.value
  }));
};
var DragWithDuplicates$1 = observer(DragWithDuplicates);

var CONTAINER_DRAGS_CLASS$1 = 'lemo-drags-container';
function DragsContainer(_ref) {
  var children = _ref.children,
    dragsContainer = _ref.dragsContainer,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1(CONTAINER_DRAGS_CLASS$1, {
      'lemo-disabled': dragsContainer.isDisabled,
      'lemo-is-highlighted': dragsContainer.isHighLighted,
      'lemo-is-dragging-over': dragsContainer.isDraggingOver
    }),
    "data-id": "none",
    onClick: dragsContainer.select,
    style: style
  }, children);
}
var DragsContainer$1 = observer(DragsContainer);

var ClozeAssociationQuestion = function ClozeAssociationQuestion(props) {
  var changedHandlers = /setTitle|setStimulus|setValue|checkAnswers|reset|matchResponse/;
  var store = props.store,
    _props$solutionsMode = props.solutionsMode,
    solutionsMode = _props$solutionsMode === void 0 ? false : _props$solutionsMode,
    _props$onDropOut = props.onDropOut,
    _onDropOut = _props$onDropOut === void 0 ? noop : _props$onDropOut;
  var ancestor = useRef();
  useDispatchOnResponseChange({
    store: store,
    changed: props.changed
  });
  var autoDrop = useAutoDrop({
    store: store,
    ancestor: ancestor
  });
  function onClickDrag(event, drag) {
    store.isAutomaticDrop ? autoDrop(event.target, drag) : drag.select();
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: ancestor,
    className: cn$1('lemo-question-body', {
      'lemo-disabled': store.disabled
    })
  }, /*#__PURE__*/React__default.createElement(QuestionTemplate$1, {
    store: store,
    updateBlanksWhenUpdateNotifier: true
  }, /*#__PURE__*/React__default.createElement(TextBlank, {
    isTouch: false,
    onClick: function onClick(drop) {
      return drop.select();
    },
    onDropOut: function onDropOut(drag) {
      return _onDropOut(drag);
    }
  })), /*#__PURE__*/React__default.createElement(DragsContainer$1, {
    dragsContainer: store.dragsContainer
  }, store.getDragList(solutionsMode).map(function (drag, idx) {
    return /*#__PURE__*/React__default.createElement(DragWithDuplicates$1, {
      key: drag.id,
      drag: drag,
      showCallOut: idx === 0 && !store.firstInteraction && !store.disabled,
      matchResponse: store.matchResponse,
      onClick: function onClick(event) {
        return onClickDrag(event, drag);
      },
      onDropOut: function onDropOut(drag) {
        return _onDropOut(drag);
      },
      dropTargets: ".lemo-drop-area",
      disabled: !!store.dragDroppedSelected,
      hidden: drag.drop
    });
  })))));
};
var ClozeAssociationQuestion$1 = observer(ClozeAssociationQuestion);

var ValidAlternatives = types$1.model({
  responses: types$1.array(types$1.frozen())
}).actions(function (state) {
  return {
    setValidResponses: function setValidResponses(responses) {
      state.responses = responses;
    },
    addValidResponse: function addValidResponse(response) {
      state.responses.push(response);
    }
  };
}).views(function (state) {
  return {
    validate: function validate(compareFn) {
      return state.responses.reduce(compareFn, false);
    }
  };
});
function mergeAltResponses(idx, alt_responses, defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = '';
  }
  return alt_responses.map(function (_ref) {
    var value = _ref.value;
    return value[idx] || defaultValue;
  });
}
function createSnapshot(idx, alt_responses, defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = '';
  }
  return {
    responses: mergeAltResponses(idx, alt_responses, defaultValue)
  };
}

var DRAG = 'DRAG';
var DRAG_DROPPED = 'DRAG_DROPPED';
var DROP_EMPTY = 'EMPTY_DROP';
var DROP_FILL = 'DROP_FILL';
var RESET = 'RESET';

var SelectionModel$1 = types$1.model({
  selection: types$1.optional(types$1.array(types$1.string), [])
}).actions(function (state) {
  var isDuplicated = function isDuplicated(itemId) {
    return state.selection.length > 0 && state.selection[0] === itemId;
  };
  var getItem = function getItem(itemId) {
    return state.allInteractives.find(function (d) {
      return d.id === itemId;
    }) || getEmptyInteractive();
  };
  var getSelection = function getSelection() {
    return state.selection.map(getItem);
  };
  var isMatch_A_BEmpty = function isMatch_A_BEmpty() {
    var _getSelection = getSelection(),
      a = _getSelection[0],
      b = _getSelection[1];
    return a.itemType === DRAG && b.itemType === DROP_EMPTY;
  };
  var isMatch_BEmpty_A = function isMatch_BEmpty_A() {
    var _getSelection2 = getSelection(),
      a = _getSelection2[0],
      b = _getSelection2[1];
    return a.itemType === DROP_EMPTY && b.itemType === DRAG;
  };
  var isMatch_A_BFill = function isMatch_A_BFill() {
    var _getSelection3 = getSelection(),
      a = _getSelection3[0],
      b = _getSelection3[1];
    return a.itemType === DRAG && b.itemType === DRAG_DROPPED;
  };
  var isMatch_A_A = function isMatch_A_A() {
    var _getSelection4 = getSelection(),
      a = _getSelection4[0],
      b = _getSelection4[1];
    return a.itemType === DRAG && b.itemType === DRAG;
  };
  var isMatch_BFill_BEmpty = function isMatch_BFill_BEmpty() {
    var _getSelection5 = getSelection(),
      a = _getSelection5[0],
      b = _getSelection5[1];
    return (a === null || a === void 0 ? void 0 : a.itemType) === DRAG_DROPPED && (b === null || b === void 0 ? void 0 : b.itemType) === DROP_EMPTY;
  };
  var isMatch_BEmpty_BFill = function isMatch_BEmpty_BFill() {
    var _getSelection6 = getSelection(),
      a = _getSelection6[0],
      b = _getSelection6[1];
    return a.itemType === DROP_EMPTY && b.itemType === DRAG_DROPPED;
  };
  var isMatch_BFill_BFill = function isMatch_BFill_BFill() {
    var _getSelection7 = getSelection(),
      a = _getSelection7[0],
      b = _getSelection7[1];
    return a.itemType === DRAG_DROPPED && b.itemType === DRAG_DROPPED;
  };
  var isMatch_BEmpty_BEmpty = function isMatch_BEmpty_BEmpty() {
    var _getSelection8 = getSelection(),
      a = _getSelection8[0],
      b = _getSelection8[1];
    return a.itemType === DROP_EMPTY && b.itemType === DROP_EMPTY;
  };
  var isReset = function isReset() {
    return state.selection.includes(RESET);
  };
  return {
    select: function select(itemId) {
      when()["case"](isDuplicated(itemId), function () {
        return state.clearSelection();
      }).resolve(function () {
        return state.addToSelection(itemId);
      });
      state.matchSelection();
    },
    addToSelection: function addToSelection(itemId) {
      state.selection.push(itemId);
    },
    updateSelection: function updateSelection() {
      if (state.selection.length === 2) {
        state.selection = [state.selection[1]];
      }
    },
    resetDragDropped: function resetDragDropped() {
      getItem(state.selection[0]).drop.reset();
      state.clearSelection();
    },
    swapItems: function swapItems(a, b) {
      var dropA = getItem(a).drop.id;
      var dropB = getItem(b).drop.id;
      state.matchPair({
        dragId: a,
        dropId: dropB
      });
      state.matchPair({
        dragId: b,
        dropId: dropA
      });
    },
    clearSelection: function clearSelection() {
      state.selection = [];
    },
    resetToContainer: function resetToContainer() {
      var dragId = state.selection.find(function (id) {
        return id !== RESET;
      });
      state.resetDrag(getItem(dragId));
    },
    matchSelection: function matchSelection() {
      if (state.selection.length < 2) return;
      var _state$selection = state.selection,
        a = _state$selection[0],
        b = _state$selection[1];
      when()["case"](isReset(), function () {
        return state.resetToContainer();
      })["case"](isMatch_A_BEmpty(), function () {
        return state.matchPair({
          dragId: a,
          dropId: b
        });
      })["case"](isMatch_BEmpty_A(), function () {
        return state.matchPair({
          dragId: b,
          dropId: a
        });
      })["case"](isMatch_A_BFill(), function () {
        state.matchPair({
          dragId: a,
          dropId: getItem(b).drop.id
        });
      })["case"](isMatch_A_A(), function () {
        return state.updateSelection();
      })["case"](isMatch_BFill_BEmpty(), function () {
        return state.matchPair({
          dragId: a,
          dropId: b
        });
      })["case"](isMatch_BFill_BFill(), function () {
        state.swapItems(a, b);
      })["case"](isMatch_BEmpty_BEmpty(), function () {
        state.updateSelection();
      })["case"](isMatch_BEmpty_BFill(), function () {
        state.matchPair({
          dragId: b,
          dropId: a
        });
      }).resolve(noop);
      state.selection.length === 2 && state.clearSelection();
    },
    matchPair: function matchPair(_ref) {
      var dragId = _ref.dragId,
        dropId = _ref.dropId;
      console.log('matchPair', dragId, dropId);
    }
  };
}).views(function (state) {
  return {
    get allInteractives() {
      return [];
    },
    get selectedInstances() {
      return state.selection.map(function (id) {
        return state.allInteractives.find(function (item) {
          return item.id === id;
        });
      });
    }
  };
});
function getEmptyInteractive() {
  return {
    itemType: ''
  };
}

var DRAGGING_OVER_CONTAINER_DRAGS = 'DRAGGING_OVER_CONTAINER_DRAGS';
var withWhileDraggingTarget = types$1.model({
  dragStarted: types$1.optional(types$1["boolean"], false),
  whileDraggingTarget: types$1.optional(types$1.string, '')
}).actions(function (state) {
  return {
    setDragStarted: function setDragStarted(dragStarted) {
      state.dragStarted = dragStarted;
    },
    setWhileDraggingTarget: function setWhileDraggingTarget(dragId) {
      state.whileDraggingTarget = dragId;
    },
    clearWhileDraggingTarget: function clearWhileDraggingTarget() {
      state.whileDraggingTarget = undefined;
    }
  };
});

function updateTemplate$1(str, responses) {
  var counter = 0;
  return str.replace(/{{response}}/g, function () {
    var responseId = !!responses && responses[counter] ? responses[counter].id : null;
    var result = "<span id=\"" + responseId + "\" class=\"lemo-blank fr-embedly\" data-responseid=\"" + responseId + "\">&nbsp;</span>";
    counter++;
    return result;
  });
}
function templateToPrintMode(str, responses) {
  var counter = 0;
  return str.replace(/{{response}}/g, function () {
    var currentResponse = (responses === null || responses === void 0 ? void 0 : responses[counter]) || undefined;
    var color = currentResponse ? 'dodgerblue' : 'lightgray';
    var result = "<span style=\"color: " + color + ";\">" + (currentResponse || '__________') + "</span>";
    counter++;
    return result;
  });
}
function removeOccurrence(string, pattern, index) {
  var idx = string.split(pattern, index).join(pattern).length;
  return string.substring(0, idx) + string.substring(idx + pattern.length);
}

var withZIndex = types$1.model({
  z: types$1.optional(types$1.number, 1)
}).actions(function (state) {
  return {
    setNextHighestDepth: function setNextHighestDepth() {
      state.z = state.maxDepth + 1;
    },
    setZ: function setZ(z) {
      state.z = z;
    }
  };
}).views(function (state) {
  return {
    get maxDepth() {
      return getParent(state).reduce(function (acc, next) {
        return next.z > acc ? next.z : acc;
      }, 0);
    }
  };
});

var withDuplicates = types$1.model({}).views(function (state) {
  return {
    get hasDuplicates() {
      return getParent(state).reduce(function (acc, next) {
        return when()["case"](next.isUsed, function () {
          return acc;
        })["case"](next.id === state.id, function () {
          return acc;
        })["case"](next.value === state.value, function () {
          return true;
        }).resolve(function () {
          return acc;
        });
      }, false);
    }
  };
});

var DragModel = types$1.compose(ValueModel, withZIndex, withDuplicates, types$1.model({
  isDragging: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    setIsDragging: function setIsDragging(bool) {
      state.isDragging = bool;
      if (bool) getParent(state, 2).updateFirstInteraction();
    },
    resetTarget: function resetTarget() {
      state.drop && state.drop.reset();
    },
    select: function select() {
      getParent(state, 2).select(state.id);
      getParent(state, 2).updateFirstInteraction();
    }
  };
}).views(function (state) {
  var getDropTarget = function getDropTarget() {
    return getParent(state, 2).drops.find(function (drop) {
      return drop.value === state.id;
    });
  };
  return {
    get drop() {
      return getDropTarget();
    },
    get isHighlighted() {
      if (state.itemType === DRAG_DROPPED) {
        return getParent(state, 2).dragSelected || getParent(state, 2).dropSelected || getParent(state, 2).dragDroppedSelected;
      }
      return getParent(state, 2).dropSelected;
    },
    get isUsed() {
      return !!state.drop;
    },
    get isSelected() {
      var _getParent, _getParent2;
      return ((_getParent = getParent(state, 2)) === null || _getParent === void 0 ? void 0 : _getParent.dragSelected) === state || ((_getParent2 = getParent(state, 2)) === null || _getParent2 === void 0 ? void 0 : _getParent2.dragDroppedSelected) === state;
    },
    get visible() {
      return true;
    },
    get itemType() {
      return state.drop ? DRAG_DROPPED : DRAG;
    }
  };
}));

var withCanSelectedDrop = types$1.model({
  canSelected: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    setCanSelected: function setCanSelected() {
      state.canSelected = true;
    },
    clearCanSelected: function clearCanSelected() {
      state.canSelected = false;
    }
  };
});

var withIsDraggingOver = types$1.model({}).views(function (state) {
  return {
    get isDraggingOver() {
      var store = !isRoot(state) ? getParent(state, 2) : null;
      return (store === null || store === void 0 ? void 0 : store.whileDraggingTarget) === state.id;
    }
  };
});

var DropModel = types$1.compose(withShowSolutionsParent, ValueModel, getWithFeedbackResult(normalize), withElementFeedback, withIsDraggingOver, withCanSelectedDrop, withZIndex, types$1.model({}).actions(function (state) {
  var parent = getParent(state, 2);
  return {
    setTarget: function setTarget(dragId) {
      state.setValue(dragId);
    },
    select: function select() {
      parent.select(state.id);
    },
    reset: function reset() {
      state.value = '';
    }
  };
}).views(function (state) {
  return {
    get parent() {
      return getRoot(state);
    },
    get drag() {
      return state.value.length > 0 ? getParent(state, 2).drags.find(function (item) {
        return item.id === state.value;
      }) : false;
    },
    get itemType() {
      return state.drag ? DROP_FILL : DROP_EMPTY;
    },
    get isDisabled() {
      var parent = getRoot(state);
      return parent.disabled || parent.isEvaluated;
    },
    get isValid() {
      var _state$drag;
      var parent = getParent(state, 2);
      var currentSolution = parent === null || parent === void 0 ? void 0 : parent.getCurrentSolution(state.index);
      var currentResponse = currentSolution !== undefined ? currentSolution : parent.validation.value[state.index];
      return normalize(currentResponse) === normalize(state === null || state === void 0 ? void 0 : (_state$drag = state.drag) === null || _state$drag === void 0 ? void 0 : _state$drag.value);
    },
    get success() {
      try {
        return getParent(state, 2).isEvaluated && state.isValid;
      } catch (e) {
        return false;
      }
    },
    get error() {
      try {
        return getParent(state, 2).isEvaluated && !state.isValid;
      } catch (e) {
        return false;
      }
    },
    get isDragDroppedSelected() {
      return state.drag && getParent(state, 2).dragDroppedSelected === state.drag;
    },
    get isSelected() {
      return getParent(state, 2).dropSelected === state || state.isDragDroppedSelected;
    },
    get isHighLighted() {
      return getParent(state, 2).highLightDrops;
    },
    get isImmediate() {
      var parent = getParent(state, 2);
      return parent.validation.immediateFeedback;
    },
    get lock() {
      try {
        return getParent(state, 2).isEvaluated;
      } catch (e) {
        return false;
      }
    },
    get showImmediateFeedbackError() {
      var isImmediate = getParent(state, 2).validation.immediateFeedback;
      return isImmediate && state.value.length > 0;
    },
    get isCanShowElementFeedback() {
      return isCanShowElementFeedbackParam(types.cloze.Association, state.isEmptyResponse(state.value), false);
    },
    get isSolutionMode() {
      try {
        return getParent(state, 2).isSolutionMode;
      } catch (e) {
        return false;
      }
    },
    get maxDepth() {
      return getParent(state, 2).maxDepth;
    }
  };
}));
function normalize(str) {
  return str;
}

var withConfigureScorm$5 = types$1.model({
  scormData: types$1.optional(ScormModel, {})
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      state.exerciseType = scormTypes.MATCHING;
      state.initScorm();
      onAction(state, function (_ref) {
        var _state$updateResponse;
        var name = _ref.name,
          path = _ref.path;
        if (name === 'reset' && path === '') return state.initScorm();
        if (name === 'checkAnswers') return state === null || state === void 0 ? void 0 : (_state$updateResponse = state.updateResponseOnValidate) === null || _state$updateResponse === void 0 ? void 0 : _state$updateResponse.call(state);
      }, true);
      onSnapshot(state.drops, function () {
        state.drops.forEach(function (item) {
          var _item$drag;
          state.scormData.updateInteractive({
            id: item.id,
            userResponse: (item === null || item === void 0 ? void 0 : (_item$drag = item.drag) === null || _item$drag === void 0 ? void 0 : _item$drag.value) || '',
            result: item.isValid
          });
        });
      });
    },
    initScorm: function initScorm() {
      state.scormData.init(state, state.drops.map(function (item, idx) {
        var _item$drag2;
        return {
          userResponse: (item === null || item === void 0 ? void 0 : (_item$drag2 = item.drag) === null || _item$drag2 === void 0 ? void 0 : _item$drag2.value) || '',
          id: item.id,
          rightAnswer: getAlternativeSolutions(idx, state),
          result: item.isValid
        };
      }));
    },
    updateResponseOnValidate: function updateResponseOnValidate() {
      state.scormData.interactiveList.forEach(function (interactive, key) {
        var question = state.drops.find(function (item) {
          return item.id === key;
        });
        interactive.setResult(question.isValid);
      });
    }
  };
});

var DragsContainerModel = types$1.model({
  id: DRAGGING_OVER_CONTAINER_DRAGS
}).actions(function (state) {
  return {
    select: function select() {
      if (getParent(state).dragDroppedSelected) {
        getParent(state).select(RESET);
      }
    }
  };
}).views(function (state) {
  return {
    get itemType() {
      return RESET;
    },
    get isHighLighted() {
      return getParent(state).dragDroppedSelected || getParent(state).dragIdIsDragging;
    },
    get isDraggingOver() {
      return getParent(state).whileDraggingTarget === 'none';
    },
    get isDisabled() {
      return getParent(state).disabled;
    }
  };
});

function getDragListWithDuplicates(list) {
  return list.reduce(function (acc, next) {
    var isUnique = function isUnique() {
      return !acc.find(function (_ref) {
        var value = _ref.value;
        return value === next.value;
      });
    };
    var addItem = function addItem() {
      return [].concat(acc, [next]);
    };
    var addUniqueItem = function addUniqueItem() {
      return isUnique() ? addItem() : acc;
    };
    return when()["case"](next.isUsed, function () {
      return acc;
    })["case"](next.hasDuplicates, addUniqueItem).resolve(addItem);
  }, []);
}

function getDuplicatesConfig(_ref) {
  var possible_responses = _ref.possible_responses,
    possible_responses_config = _ref.possible_responses_config,
    duplicate_responses = _ref.duplicate_responses;
  if (!duplicate_responses || !possible_responses_config) {
    return possible_responses.map(function () {
      return {
        number_duplicates: 1
      };
    });
  }
  return possible_responses_config;
}

var ClozeAssociationQuestionStore = types$1.compose(QuestionBaseModel, withImmediateHandlers('drops'), withWhileDraggingTarget, SelectionModel$1, getWithShuffleOptions('drags'), getClosestSolutionModel(checkResponse$2), withValidationModes, withConfigureScorm$5, withXAPIMatchingType$1({
  getSource: function getSource(state) {
    return getGenericSource(state.validation.value.length);
  },
  getSolution: function getSolution(props) {
    return getXAPIChoiceSolution(props);
  },
  getTarget: function getTarget(state) {
    return state.drags.map(function (drag) {
      return drag.value;
    });
  }
}), types$1.model({
  firstInteraction: types$1.optional(types$1["boolean"], false),
  template: types$1.optional(types$1.string, ''),
  drops: types$1.optional(types$1.array(DropModel), []),
  drags: types$1.array(DragModel),
  dragsContainer: types$1.optional(DragsContainerModel, {}),
  activeDrags: types$1.array(DragModel),
  selectedItem: types$1.optional(types$1.string, '')
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      state.updateOptionsOrder();
    },
    updateFirstInteraction: function updateFirstInteraction() {
      state.firstInteraction = true;
    },
    matchPair: function matchPair(_ref) {
      var dragId = _ref.dragId,
        dropId = _ref.dropId;
      state.updateFirstInteraction();
      if (!dragId || !dropId) return;
      state.matchResponse(dropId, state.getDrag(dragId));
      state.clearSelection();
    },
    matchResponse: function matchResponse(dropId, drag) {
      state.updateFirstInteraction();
      var drop = state.getDrop(dropId);
      if (drag.itemType === DRAG_DROPPED) {
        drag.drop.reset();
      }
      state.clearSelection();
      drop.setTarget(drag.id);
    },
    setSelectedItem: function setSelectedItem(selectedItem) {
      if (selectedItem === void 0) {
        selectedItem = '';
      }
      state.selectedItem = selectedItem;
    },
    resetDrag: function resetDrag(drag) {
      drag.resetTarget();
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.string), response)) return false;
      state.clearDrops();
      state.updateFirstInteraction();
      state.drops.forEach(function (item, idx) {
        var currentResponse = response[idx];
        var dropId = item.id;
        var drag = state.drags.find(function (drag) {
          return drag.value === currentResponse && !drag.isUsed;
        });
        if (drag) state.matchResponse(dropId, drag);else item.reset();
      });
    },
    commitResponseFeedback: function commitResponseFeedback() {
      commitFeedbackMessages({
        state: state,
        collection: state.drops,
        condition: getConditionCommitFeedbackMessages
      });
    },
    clearDrops: function clearDrops() {
      state.drops.forEach(function (response) {
        return response.reset();
      });
    },
    reset: function reset() {
      state.firstInteraction = false;
      state.baseReset();
      state.clearDrops();
      state.updateNotifier();
    },
    checkAnswers: function checkAnswers() {
      state.isEvaluated = true;
      state.attempts.addAttempt();
      state.commitResponseFeedback && state.commitResponseFeedback();
      state.updateFirstInteraction();
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData, idx) {
      if (idx === void 0) {
        idx = 0;
      }
      state.updateFirstInteraction();
      try {
        var validation = rawData.data.validation;
        var solution = idx === 0 ? validation.valid_response.value : validation.alt_responses[idx - 1].value;
        var data = _createSnapshot$a(rawData);
        applySnapshot(state, data);
        state.setResponse(solution);
        state.setIsSolutionMode(true);
      } catch (e) {}
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    hydrateQuestionPreview: function hydrateQuestionPreview(rawData) {
      if (!state.isSolutionMode) {
        try {
          var data = _createSnapshot$a(rawData);
          data.optionsOrder = state.optionsOrder;
          var prevAssetsQuestionApi = state.assetsQuestionApi;
          applySnapshot(state, data);
          state.setIsSolutionMode(false);
          state.setAssetsQuestionApi(prevAssetsQuestionApi);
        } catch (e) {}
      }
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  var checkSelectedType = function checkSelectedType(dragType) {
    return state.selection.length === 1 && state.selectedInstances[0].itemType === dragType;
  };
  return {
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$a(rawData);
    },
    get allInteractives() {
      return [].concat(state.drags, state.drops, [state.dragsContainer]);
    },
    get duplicate_responses() {
      return state.raw.data.duplicate_responses;
    },
    get currentResponse() {
      return state.selectedItem && state.drops.find(function (res) {
        return res.id === state.selectedItem;
      });
    },
    get templateToView() {
      return updateTemplate$1(state.template, state.drops);
    },
    getResponseById: function getResponseById(id) {
      return state.drops.find(function (response) {
        return response.id === id;
      });
    },
    getDrop: function getDrop(id) {
      return state.drops.find(function (response) {
        return response.id === id;
      });
    },
    getDrag: function getDrag(id) {
      return state.drags.find(function (drag) {
        return drag.id === id;
      });
    },
    getUserResponse: function getUserResponse() {
      var userResponse = state.drops.map(function (drop) {
        var _drop$drag;
        return (drop === null || drop === void 0 ? void 0 : (_drop$drag = drop.drag) === null || _drop$drag === void 0 ? void 0 : _drop$drag.value) || '';
      });
      return state.getRealUserResponse(userResponse);
    },
    get highLightDrops() {
      return state.selection.length === 1 ? [DRAG_DROPPED, DRAG].includes(state.selectedInstances[0].itemType) : false;
    },
    get dragSelected() {
      return checkSelectedType(DRAG) ? state.selectedInstances[0] : false;
    },
    get dropSelected() {
      return checkSelectedType(DROP_EMPTY) ? state.selectedInstances[0] : false;
    },
    get dragDroppedSelected() {
      return checkSelectedType(DRAG_DROPPED) ? state.selectedInstances[0] : false;
    },
    getDragList: function getDragList(solutionsMode) {
      var list = solutionsMode ? state.drags : state.shuffledOptions;
      return getDragListWithDuplicates(list);
    },
    get responses() {
      return state.drops;
    },
    get maxDepth() {
      return [].concat(state.drags, state.drops).reduce(function (acc, next) {
        return next.z > acc ? next.z : acc;
      }, 0);
    },
    get nextAvailableDrop() {
      return state.drops.find(function (drop) {
        return !drop.drag;
      });
    },
    get isAutomaticDrop() {
      var _state$ui_style;
      return ((state === null || state === void 0 ? void 0 : (_state$ui_style = state.ui_style) === null || _state$ui_style === void 0 ? void 0 : _state$ui_style.automatic_drop) || (config === null || config === void 0 ? void 0 : config.useAutoDrop)) && state.selection.length === 0;
    }
  };
}));
function createDropList(validResponses, altResponses, feedbackResponses) {
  return validResponses.map(function (validResponse, idx) {
    var _feedbackResponses$id;
    return {
      value: '',
      validResponse: validResponse,
      validAlternatives: createSnapshot(idx, altResponses, ['']),
      feedback: (feedbackResponses === null || feedbackResponses === void 0 ? void 0 : (_feedbackResponses$id = feedbackResponses[idx]) === null || _feedbackResponses$id === void 0 ? void 0 : _feedbackResponses$id.feedback) || ''
    };
  });
}
function createDragData(value) {
  return {
    id: uuid(),
    value: value
  };
}
function createDragList(possible_responses, possible_responses_config) {
  return possible_responses_config.reduce(function (acc, next, idx) {
    return [].concat(acc, populate(next.number_duplicates, function () {
      return createDragData(possible_responses[idx]);
    }));
  }, []);
}
function _createSnapshot$a(data) {
  var _data$data = data.data,
    possible_responses = _data$data.possible_responses,
    feedback_responses = _data$data.feedback_responses,
    rawValidation = _data$data.validation;
  var validation = produce(rawValidation, function (draft) {
    draft.valid_response.value = rawValidation.valid_response.value.map(function (v) {
      return v || '';
    });
  });
  var altResponses = defaultValue('alt_responses', validation, []);
  var validResponses = validation.valid_response.value;
  var responsesLength = validation.valid_response.value.length;
  var responseConfig = getDuplicatesConfig(data.data);
  return _extends({}, data.data, importCommonValues$1(data), {
    validation: withPenaltyPoints(responsesLength, validation),
    drops: createDropList(validResponses, altResponses, feedback_responses),
    drags: createDragList(possible_responses, responseConfig)
  });
}
function checkResponse$2(solution, userResponse) {
  return userResponse.length > 0 ? (solution === null || solution === void 0 ? void 0 : solution.toString()) === (userResponse === null || userResponse === void 0 ? void 0 : userResponse.toString()) : null;
}
function createStore$a(data) {
  var store = ClozeAssociationQuestionStore.create(_createSnapshot$a(data));
  return store;
}

function NativeDropDown(_ref) {
  var itemList = _ref.itemList,
    _ref$onSelect = _ref.onSelect,
    onSelect = _ref$onSelect === void 0 ? noop : _ref$onSelect,
    _ref$onOpen = _ref.onOpen,
    onOpen = _ref$onOpen === void 0 ? noop : _ref$onOpen,
    _ref$selectedIndex = _ref.selectedIndex,
    selectedIndex = _ref$selectedIndex === void 0 ? -1 : _ref$selectedIndex,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? '1em' : _ref$fontSize,
    _ref$isError = _ref.isError,
    isError = _ref$isError === void 0 ? false : _ref$isError,
    _ref$isSuccess = _ref.isSuccess,
    isSuccess = _ref$isSuccess === void 0 ? false : _ref$isSuccess,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
    _ref$stablePlaceholde = _ref.stablePlaceholder,
    stablePlaceholder = _ref$stablePlaceholde === void 0 ? false : _ref$stablePlaceholde,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'nativeDropdown' : _ref$testId;
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var select = useRef();
  function handleOpen() {
    onOpen === null || onOpen === void 0 ? void 0 : onOpen();
    setIsOpen(true);
  }
  function handleSelect() {
    setIsOpen(false);
    onSelect(parseInt(select.current.value));
  }
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": testId,
    className: cn$1('lemo-dropdown-native', 'lemo-box-small', {
      'lemo-is-empty': selectedIndex === -1,
      'lemo-dropdown-control--disabled lemo-base-dropdown--disabled': disabled,
      'lemo-dropdown-control--open lemo-base-dropdown--open': isOpen,
      'lemo-dropdown-control--feedback-success': isSuccess,
      'lemo-dropdown-control--feedback-error': isError
    }),
    onClick: handleOpen
  }, /*#__PURE__*/React__default.createElement("select", {
    ref: select,
    className: "lemo-dropdown-native-select",
    onFocus: handleOpen,
    onBlur: function onBlur() {
      return setIsOpen(false);
    },
    onChange: handleSelect,
    onKeyUp: function onKeyUp(_ref2) {
      var keyCode = _ref2.keyCode;
      return keyCode === 27 && setIsOpen(false);
    },
    value: selectedIndex,
    disabled: disabled,
    style: {
      fontSize: fontSize
    }
  }, (selectedIndex === -1 || stablePlaceholder) && /*#__PURE__*/React__default.createElement("option", {
    value: -1
  }, placeholder), itemList.map(function (item, idx) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: item + "__" + idx,
      value: idx,
      className: cn$1('lemo-dropdown-content-item', 'lemo-base-dropdown__item', {
        'lemo-selected lemo-dropdown-control__item--selected': selectedIndex === idx
      })
    }, item);
  })), /*#__PURE__*/React__default.createElement(SvgChevronDown, {
    className: "lemo-dropdown-icon lemo-base-dropdown__icon"
  }));
}
var NativeDropDown$1 = observer(NativeDropDown);

var DropdownBlank = function DropdownBlank(_ref) {
  var response = _ref.response;
  var _useState = useState(function () {
      return function () {};
    }),
    updateResponse = _useState[0],
    setUpdateResponse = _useState[1];
  useEffect(function () {
    if (isAlive(response)) {
      setUpdateResponse(function (idx) {
        return function (idx) {
          response.setValue(response.output[idx]);
        };
      });
    } else {
      setUpdateResponse(function () {
        return function () {};
      });
    }
  }, [response]);
  if (!isAlive(response)) return null;
  var isStyleFeedbackSuccess = response.isSuccess;
  var isStyleFeedbackError = response.isWrong;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-dropdown-blank-wrapper', {
      'lemo-selected': response.selected,
      'lemo-lock': response.isLock,
      'lemo-success': isStyleFeedbackSuccess,
      'lemo-error': isStyleFeedbackError
    })
  }, /*#__PURE__*/React__default.createElement(NativeDropDown$1, {
    onSelect: updateResponse,
    selectedIndex: response.selectedIndex,
    itemList: response.output,
    isError: isStyleFeedbackError,
    isSuccess: isStyleFeedbackSuccess
  }), /*#__PURE__*/React__default.createElement(FeedbackPin$1, {
    idx: response.feedbackIndex,
    result: response.resultCache,
    visible: response.withPin && response.isWrongCache,
    classAdd: 'lemo-base-feedback-pin__option',
    feedback: response.feedback
  }));
};
var DropdownBlank$1 = observer(DropdownBlank);

function PrintModeTemplate(_ref) {
  var store = _ref.store;
  var root = useRef();
  useEffect(function () {
    getFormulas(root.current);
  }, []);
  return /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    innerRef: root,
    className: "lemo-print-mode",
    content: store.templateToPrintMode,
    style: {
      lineHeight: 1.4
    }
  });
}
var PrintModeTemplate$1 = observer(PrintModeTemplate);

var ClozeDropDownQuestion = function ClozeDropDownQuestion(props) {
  var store = props.store;
  var changedHandlers = /setTitle|setStimulus|checkAnswers|reset|setValue/;
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', {
      'lemo-disabled': store.disabled
    })
  }, store.isPrintMode ? /*#__PURE__*/React__default.createElement(PrintModeTemplate$1, {
    store: store
  }) : /*#__PURE__*/React__default.createElement(QuestionTemplate$1, {
    store: store
  }, /*#__PURE__*/React__default.createElement(DropdownBlank$1, {
    isEvaluable: store.isEvaluable
  }))));
};
var ClozeDropDownQuestion$1 = observer(ClozeDropDownQuestion);

var ClozeStore = types$1.compose(LemonadeBaseModel, types$1.model({
  exerciseType: types$1.optional(types$1.string, ''),
  template: types$1.optional(types$1.string, ''),
  onUpdateNotifierUpdateTemplate: types$1.optional(types$1.number, function () {
    return Date.now();
  }),
  ui_style: types$1.optional(UIStyleModel$1, defaultUIStyle)
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      reaction(function () {
        return state.blanksLength;
      }, function () {
        return state.updateResponses();
      });
      onAction(state, function (_ref) {
        var name = _ref.name,
          path = _ref.path;
        if (path.match(/responses/) && name === 'setValidResponse') {
          state.updateResponses();
        }
        if (path === '/validation' && name.match(/updateSolution|setValue/)) {
          state.responses.forEach(function (response, idx) {
            response.setValidResponse(state.validation.value[idx]);
            response.validAlternatives.setValidResponses(state.validation.getAltValuesFrom(idx));
          });
        }
        if (name === 'setTemplate') {
          state.updateNotifier();
        }
        if (name.match(/addNewValue|sortValues|destroy/)) {
          state.updateNotifier();
        }
      }, true);
      state.updateResponses();
    },
    cleanRemovedResponses: function cleanRemovedResponses(data) {
      var matches = data.match(/data-responseid="(.*?)"/g) || [];
      var indexes = matches.map(function (content) {
        return content.substring(17, content.length - 1);
      });
      state.responses = state.responses.filter(function (res) {
        return indexes.includes(res.id);
      });
    },
    updateResponsesAndValidationAltResponses: function updateResponsesAndValidationAltResponses(blanksResponsesId, handleGetNewResponse) {
      var fineAdjustment = false;
      if (blanksResponsesId) {
        var actualResponsesId = [];
        state.responses.forEach(function (response) {
          if (response && response.id) {
            actualResponsesId.push(response.id);
          }
        });
        if (blanksResponsesId.length !== actualResponsesId.length || blanksResponsesId.toString() !== actualResponsesId.toString()) {
          fineAdjustment = true;
          state.responses = blanksResponsesId.map(function (blank) {
            if (blank === null) {
              return handleGetNewResponse();
            } else {
              var responseFind = state.responses.find(function (r) {
                return r.id === blank;
              });
              if (responseFind) {
                return responseFind;
              } else return handleGetNewResponse();
            }
          });
          state.validation.alt_responses.forEach(function (alt) {
            var newValue = [];
            blanksResponsesId.forEach(function (blank) {
              if (blank === null) {
                newValue.push('');
              } else {
                var responseFindIndex = actualResponsesId.findIndex(function (r) {
                  return r === blank;
                });
                if (responseFindIndex >= 0 && alt && alt.value && responseFindIndex < alt.value.length) {
                  newValue.push(alt.value[responseFindIndex]);
                } else newValue.push('');
              }
            });
            alt.setValue(newValue);
          });
        }
      }
      return fineAdjustment;
    },
    setTemplate: function setTemplate(val, blanksResponsesId) {
      if (blanksResponsesId === void 0) {
        blanksResponsesId = null;
      }
      state.template = val;
      state.updateResponses(blanksResponsesId);
    },
    addNewResponseAtTheEnd: function addNewResponseAtTheEnd() {
      var newTemplate = state.template + '<p>{{response}}</p>';
      state.template = newTemplate;
    },
    updateResponses: function updateResponses(blanksResponsesId) {
      if (blanksResponsesId === void 0) {
        blanksResponsesId = null;
      }
      var responseText = '';
      function getNewResponse() {
        return {
          validResponse: responseText,
          validAlternatives: {
            responses: state.validation.alt_responses.map(function (_) {
              return responseText;
            })
          }
        };
      }
      function addResponseAndValidation(indexAdd) {
        var newResponse = getNewResponse();
        if (indexAdd !== undefined && indexAdd >= 0) {
          state.responses.splice(indexAdd, 0, newResponse);
        } else {
          state.responses.push(newResponse);
        }
        state.validation.alt_responses.forEach(function (alt) {
          if (indexAdd !== undefined && indexAdd >= 0) {
            alt.addEmptyValueIndex(indexAdd, responseText);
          } else {
            alt.addEmptyValue(responseText);
          }
        });
      }
      var fineAdjustment = state.updateResponsesAndValidationAltResponses(blanksResponsesId, getNewResponse);
      if (!fineAdjustment) {
        while (state.responses.length !== state.blanksLength) {
          if (state.responses.length < state.blanksLength) {
            addResponseAndValidation(null);
          } else {
            state.removeResponse(last(state.responses));
          }
        }
      }
      state.validation.setValue(state.responses.map(function (_ref2) {
        var validResponse = _ref2.validResponse;
        return validResponse;
      }));
      if (fineAdjustment) {
        state.updateNotifierUpdateTemplate();
      }
    },
    updateNotifier: function updateNotifier() {
      state.onUpdateNotifier = Date.now();
    },
    updateNotifierUpdateTemplate: function updateNotifierUpdateTemplate() {
      state.onUpdateNotifierUpdateTemplate = Date.now();
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.string), response)) return false;
      state.responses.forEach(function (resp, idx) {
        return resp.setValue(response[idx]);
      });
    },
    removeResponse: function removeResponse(response) {
      state.template = removeOccurrence(state.template, '{{response}}', response.index + 1);
      destroy(response);
      state.validation.alt_responses.forEach(function (alt) {
        alt.removeValueAt(alt.value.length - 1);
      });
      state.updateNotifier();
      state.updateNotifierUpdateTemplate();
    },
    removeResponseFineAdjustement: function removeResponseFineAdjustement(indexResponseEdit) {
      if (state.responses && indexResponseEdit < state.responses.length) {
        if (indexResponseEdit < state.responses.length) {
          state.responses.splice(indexResponseEdit, 1);
        }
        state.validation.alt_responses.forEach(function (alt) {
          alt.removeValueAt(indexResponseEdit);
        });
        state.updateNotifier();
        state.updateNotifierUpdateTemplate();
      }
    },
    removeResponseByIdx: function removeResponseByIdx(idx) {
      state.removeResponse(state.responses[idx]);
    },
    sortResponses: function sortResponses(source, destination) {
      state.responses = sortArrayItem(source, destination, state.responses);
    },
    clearResponses: function clearResponses() {
      state.responses.forEach(function (response) {
        return response.reset();
      });
    },
    reset: function reset() {
      state.baseReset();
      state.clearResponses();
      state.updateNotifier();
    },
    setData: function setData(data) {
      applySnapshot(state, data);
    }
  };
}).views(function (state) {
  return {
    getUserResponse: function getUserResponse() {
      var userResponse = state.responses.map(function (_ref3) {
        var value = _ref3.value;
        return value;
      });
      return state.getRealUserResponse(userResponse);
    },
    getCurrentSolution: function getCurrentSolution(idx) {
      return state.validation.solutionList[state.closestSolution].value[idx];
    },
    checkSolution: function checkSolution(solution) {
      return state.getUserResponse().reduce(function (acc, next, idx) {
        return solution[idx] === next ? _extends({}, acc, {
          hits: acc.hits + 1
        }) : _extends({}, acc, {
          failures: acc.failures + 1
        });
      }, {
        hits: 0,
        failures: 0
      });
    },
    get closestSolution() {
      var getClosestSolutionIndex = function getClosestSolutionIndex() {
        return state.validation.solutionList.map(function (solution) {
          return state.checkSolution(solution.value);
        }).reduce(function (acc, next, idx) {
          return next.hits > acc.hits ? _extends({}, next, {
            solutionIndex: idx
          }) : acc;
        }, {
          hits: 0,
          failures: 0,
          solutionIndex: 0
        }).solutionIndex;
      };
      return when()["case"](state.validation.alt_responses.length === 0, function () {
        return 0;
      }).resolve(getClosestSolutionIndex);
    },
    get blanksLength() {
      return getBlanksLength(state.template);
    },
    get templateToView() {
      return updateTemplate$1(state.template, state.responses);
    },
    get templateWithMoreData() {
      var myTemplate = state.template;
      var rePattern = /{{response(.*?)}}/gi;
      var idx = 0;
      return myTemplate.replace(rePattern, function () {
        var responseId = null;
        if (state.responses && state.responses[idx] && state.responses[idx].id) {
          responseId = state.responses[idx].id;
        }
        idx++;
        return getTagResponseToFroala(responseId);
      });
    },
    getSolutions: function getSolutions() {
      return state.validation.value;
    },
    get alternativePoints() {
      var str = function str(val) {
        return val.toString().trim().toLocaleLowerCase();
      };
      return state.validation.alt_responses.reduce(function (acc, next) {
        return str(next.value) === str(state.getUserResponse()) ? next.score : acc;
      }, 0);
    }
  };
}));

var ResponseModel$1 = types$1.compose(withElementFeedback, getWithFeedbackResult(normalize$1), withShowSolutionsParent, types$1.model({
  id: types$1.optional(types$1.string, function () {
    return uuid();
  }),
  valueList: types$1.optional(types$1.array(DropDownValueModel), function () {
    return getDefaultOptions();
  }),
  value: types$1.optional(types$1.string, ''),
  validResponse: types$1.optional(types$1.string, ''),
  validAlternatives: types$1.optional(ValidAlternatives, {
    responses: []
  })
}).actions(function (state) {
  return {
    setValidResponse: function setValidResponse(value) {
      state.validResponse = value;
    },
    setValue: function setValue(value) {
      if (value === void 0) {
        value = '';
      }
      state.value = value;
    },
    addNewValue: function addNewValue() {
      var indexLabel = state.valueList ? ' ' + (state.valueList.length + 1) : '';
      state.valueList.push({
        value: translate('option') + indexLabel
      });
    },
    removeValue: function removeValue(item) {
      destroy(item);
    },
    sortValues: function sortValues(source, destination) {
      state.valueList = sortArrayItem(source, destination, state.valueList);
    },
    destroy: function destroy() {
      getParent(state, 2).removeResponse(state);
    },
    reset: function reset() {
      state.value = '';
    }
  };
}).views(function (state) {
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get success() {
      try {
        return getParent(state, 2).isEvaluated && state.isValid;
      } catch (e) {
        return false;
      }
    },
    get error() {
      try {
        return getParent(state, 2).isEvaluated && !state.isValid;
      } catch (e) {
        return false;
      }
    },
    get selected() {
      try {
        return state.value.length > 0;
      } catch (e) {
        return false;
      }
    },
    get selectedIndex() {
      return state.output.findIndex(function (f) {
        return f === state.value;
      });
    },
    get lock() {
      try {
        return getParent(state, 2).isEvaluated;
      } catch (e) {
        return false;
      }
    },
    get isCanShowElementFeedback() {
      return isCanShowElementFeedbackParam(types.cloze.DropDown, state.isEmptyResponse(state.value), false);
    },
    get output() {
      try {
        return state.valueList.map(function (item) {
          return item.value;
        });
      } catch (e) {
        return false;
      }
    }
  };
}));
function getDefaultOptions() {
  return new Array(3).fill(0).map(function (k, idx) {
    return {
      value: translate('option') + " " + (idx + 1)
    };
  });
}
function normalize$1(str) {
  return str;
}

function createResponses(possible_responses, altResponses, validResponses, feedbackResponses) {
  return validResponses.map(function (validResponse, idx) {
    var _feedbackResponses$id;
    return {
      valueList: possible_responses[idx].map(function (v) {
        return {
          value: v
        };
      }),
      value: '',
      validResponse: validResponse,
      validAlternatives: createSnapshot(idx, altResponses, ['']),
      feedback: (feedbackResponses === null || feedbackResponses === void 0 ? void 0 : (_feedbackResponses$id = feedbackResponses[idx]) === null || _feedbackResponses$id === void 0 ? void 0 : _feedbackResponses$id.feedback) || ''
    };
  });
}
function createSnapshot$1(data) {
  var _data$data = data.data,
    template = _data$data.template,
    possible_responses = _data$data.possible_responses,
    feedback_responses = _data$data.feedback_responses,
    rawValidation = _data$data.validation;
  var validation = produce(rawValidation, function (draft) {
    draft.valid_response.value = rawValidation.valid_response.value.map(function (v) {
      return v || '';
    });
  });
  var altResponses = defaultValue('alt_responses', validation, []);
  var validResponses = validation.valid_response.value;
  return _extends({}, data.data, importCommonValues$1(data), {
    template: template.replace(/\n/g, ''),
    responses: createResponses(possible_responses, altResponses, validResponses, feedback_responses)
  });
}

var ExtendedValidationModel = types$1.compose(ValidationBaseModel, types$1.model({}).actions(function (state) {
  return {
    createAlternativeSolution: function createAlternativeSolution(data) {
      if (state !== null && state !== void 0 && state.solutionList && (state === null || state === void 0 ? void 0 : state.solutionList.length) > 0 && state !== null && state !== void 0 && state.solutionList[0]) {
        var firstSolutionList = state === null || state === void 0 ? void 0 : state.solutionList[0];
        console.log('firstSolutionList', firstSolutionList);
        console.log(data, 'data');
        state.alt_responses = [].concat(state.alt_responses, [firstSolutionList]);
      } else {
        state.alt_responses = [].concat(state.alt_responses, [data]);
      }
    }
  };
}));
var ValidationModelExtend = types$1.snapshotProcessor(ExtendedValidationModel, {
  preProcessor: function preProcessor(snapshot) {
    return _preProcessor(snapshot);
  },
  postProcessor: function postProcessor(snapshot) {
    return _postProcessor(snapshot);
  }
});
var ClozeDropDownStore = types$1.compose(ClozeStore, withElementFeedbackParent('responses'), types$1.model({
  responses: types$1.optional(types$1.array(ResponseModel$1), []),
  validation: ValidationModelExtend
}).actions(function (state) {
  return {
    duplicateDropdown: function duplicateDropdown(response) {
      state.responses.push({
        valueList: response.valueList.map(function (_ref) {
          var value = _ref.value;
          return {
            value: value
          };
        })
      });
      state.addNewResponseAtTheEnd();
      state.updateNotifierUpdateTemplate();
    }
  };
}).views(function (state) {
  return {
    getResults: function getResults() {
      return 0;
    },
    createSnapshot: function createSnapshot(rawData) {
      return createSnapshot$1(rawData);
    },
    get output() {
      return exportCommonValues(state, {
        template: state.template,
        possible_responses: state.responses.map(function (response) {
          return response.output;
        }),
        feedback_responses: state.feedbackResponsesOutput
      });
    }
  };
}));
function createStore$b(data) {
  return ClozeDropDownStore.create(createSnapshot$1(data));
}

var withConfigureScorm$6 = types$1.compose(withScorm, types$1.model({}).actions(function (state) {
  return {
    updateResponseOnValidate: function updateResponseOnValidate() {
      state.scormData.interactiveList.forEach(function (interactive, key) {
        var question = state.responses.find(function (item) {
          return item.id === key;
        });
        interactive.setResult(question.isValid);
      });
    }
  };
}).views(function (state) {
  var getItem = function getItem(item) {
    return {
      userResponse: item.value,
      id: item.id,
      rightAnswer: getAlternativeSolutions(item.index, state),
      result: item.isValid
    };
  };
  return {
    get scormType() {
      return scormTypes.CHOICE;
    },
    getInteractiveListInitScorm: function getInteractiveListInitScorm() {
      return state.responses.map(getItem);
    },
    updateScormItem: function updateScormItem(name, path) {
      if (path.match(/\/responses/) && name === 'setValue') {
        var item = resolvePath(state, path);
        return getItem(item);
      } else return null;
    }
  };
}));

var ClozeDropDownQuestionStore = types$1.compose(QuestionBaseModel, getClosestSolutionModel(checkResponse$3), withValidationModes, withElementFeedbackParent('responses'), withConfigureScorm$6, withXAPIMatchingType$1({
  getSource: function getSource(state) {
    return getGenericSource(state.validation.value.length);
  },
  getSolution: function getSolution(props) {
    return getXAPIChoiceSolution(props);
  },
  getTarget: function getTarget(state) {
    return state.getXAPITargets();
  }
}), types$1.model({
  responses: types$1.optional(types$1.array(ResponseModel$1), []),
  template: types$1.optional(types$1.string, '')
}).actions(function (state) {
  return {
    commitResponseFeedback: function commitResponseFeedback() {
      commitFeedbackMessages({
        state: state,
        collection: state.responses,
        condition: getConditionCommitFeedbackMessages
      });
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.string), response)) return false;
      state.responses.forEach(function (resp, idx) {
        return resp.setValue(response[idx]);
      });
    },
    clearResponses: function clearResponses() {
      state.responses.forEach(function (response) {
        return response.reset();
      });
    },
    reset: function reset() {
      state.baseReset();
      state.clearResponses();
      state.updateNotifier();
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = createSnapshot$1(rawData);
      applySnapshot(state, data);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      return createSnapshot$1(rawData);
    },
    get templateToView() {
      return updateTemplate$1(state.template, state.responses);
    },
    get templateToPrintMode() {
      var responses = state.responses.map(function (response) {
        return response.value;
      });
      return templateToPrintMode(state.template, responses);
    },
    getUserResponse: function getUserResponse() {
      var userResponse = state.responses.map(function (_ref) {
        var value = _ref.value;
        return value;
      });
      return state.getRealUserResponse(userResponse);
    },
    getXAPITargets: function getXAPITargets() {
      var responses = state.responses.map(function (response) {
        return response.output;
      }).flat();
      return removeDuplicates(responses);
    }
  };
}));
function checkResponse$3(solution, userResponse) {
  return userResponse.length > 0 ? solution === userResponse : null;
}
function createStore$c(data) {
  return ClozeDropDownQuestionStore.create(createSnapshot$1(data));
}

var keyTypes = {
  DEL: 'DEL',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  TAB: 'TAB'
};
function updateKeyboardValue(updateType, value) {
  var eq = function eq(currentType) {
    return currentType === updateType;
  };
  return when()["case"](eq(keyTypes.DEL), function () {
    return del(value);
  })["case"](eq(keyTypes.LEFT), function () {
    return value;
  })["case"](eq(keyTypes.RIGHT), function () {
    return value;
  }).resolve(function () {
    return value;
  });
}
function del(value) {
  return value.length < 2 ? '' : value.slice(0, -1);
}

var defaultSetValue = function defaultSetValue(_ref) {
  var head = _ref.head,
    textContent = _ref.textContent,
    tail = _ref.tail;
  return head + textContent + tail;
};
function useKeyboard(store, onBeforeSetValue) {
  if (onBeforeSetValue === void 0) {
    onBeforeSetValue = defaultSetValue;
  }
  var replaceSeparators = function replaceSeparators(content) {
    var separator = escapeSpecialCharacter(config.thousandsSeparator);
    return content.replace(new RegExp(separator, 'g'), '');
  };
  var getSelectionStart = function getSelectionStart(input) {
    return input.selectionStart || input.textContent.length;
  };
  var getContentParts = function getContentParts() {
    if (store.activeFieldId.length === 0) return false;
    var element = document.querySelector("#" + store.activeFieldId);
    if (!element) return false;
    var input = element.nodeName === 'INPUT' ? element : element.querySelector('input');
    if (!input) return false;
    var value = input.value || input.textContent;
    var pos = value === '' ? 0 : getSelectionStart(input);
    return {
      head: replaceSeparators(value.substring(0, pos)),
      tail: replaceSeparators(value.substring(pos))
    };
  };
  var addValue = useCallback(function (e) {
    var textContent = e.target.textContent;
    var _getContentParts = getContentParts(),
      head = _getContentParts.head,
      tail = _getContentParts.tail;
    console.log('addValue', head, tail, textContent);
    store.maxLength === 1 ? store.setValue(textContent) : store.setValue(onBeforeSetValue({
      head: head,
      textContent: textContent,
      tail: tail
    }));
    e.preventDefault();
  }, [store, getContentParts]);
  var updateValue = useCallback(function (e) {
    if (store.type === keyboardTypes.ROMAN) {
      var value = store.value;
      var updatedValue = value.substring(0, value.length - 1);
      console.log('updatedValue', updatedValue);
      store.setValue(updatedValue);
    } else {
      var _updatedValue = e.currentTarget.getAttribute('data-fn');
      store.setValue(updateKeyboardValue(_updatedValue, store.value));
    }
    e.preventDefault();
  }, [store]);
  return {
    addValue: addValue,
    updateValue: updateValue
  };
}
function escapeSpecialCharacter(character) {
  return character.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

var _excluded$8 = ["children", "className"];
function KeyboardButton(_ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$8);
  return /*#__PURE__*/React__default.createElement("button", _extends({
    className: "lemo-keyboard-button " + className,
    role: "button",
    "aria-pressed": "false",
    type: "button",
    title: children
  }, props), children);
}
var KeyboardButton$1 = observer(KeyboardButton);

var isNumberRegex = /^[0-9IVXLCDM]+$/i;
function RenderKeyGroup(_ref) {
  var group = _ref.group,
    addValue = _ref.addValue,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-keys-group"
  }, group.map(function (val) {
    return /*#__PURE__*/React__default.createElement(KeyboardButton$1, {
      key: val,
      "data-isnumber": isNumberRegex.test(val),
      onMouseDown: addValue
    }, val);
  }), children);
}
var RenderKeyGroup$1 = observer(RenderKeyGroup);

function RegularTemplate(_ref) {
  var addValue = _ref.addValue,
    updateValue = _ref.updateValue,
    keyBoardStore = _ref.keyBoardStore,
    handleTab = _ref.handleTab;
  var literals = getBasicKeyboardLiterals();
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-basic-keyboard-regular"
  }, /*#__PURE__*/React__default.createElement(RenderKeyGroup$1, {
    group: literals[0],
    addValue: addValue
  }, /*#__PURE__*/React__default.createElement(KeyboardButton$1, {
    className: "lemo-keyboard-button__function-key",
    "data-fn": keyTypes.DEL,
    role: "button",
    "aria-pressed": "false",
    title: keyTypes.DEL,
    onMouseDown: updateValue
  }, /*#__PURE__*/React__default.createElement(SvgBackspace, {
    className: "lemo-icon lemo-delete-keyboard-icon",
    width: 28
  }))), /*#__PURE__*/React__default.createElement(RenderKeyGroup$1, {
    group: literals[1],
    addValue: addValue
  }), /*#__PURE__*/React__default.createElement(RenderKeyGroup$1, {
    group: literals[2],
    addValue: addValue
  }), /*#__PURE__*/React__default.createElement(RenderKeyGroup$1, {
    group: literals[3],
    addValue: addValue
  }, /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: keyBoardStore.hasTabulator
  }, /*#__PURE__*/React__default.createElement(KeyboardButton$1, {
    className: "lemo-keyboard-button__function-key lemo-primary",
    role: "button",
    "aria-pressed": "false",
    title: keyTypes.TAB,
    onMouseDown: handleTab
  }, /*#__PURE__*/React__default.createElement(SvgArrowSmRight, {
    className: "lemo-icon lemo-tab-keyboard-icon",
    width: 48,
    height: 70
  })))));
}
var RegularTemplate$1 = observer(RegularTemplate);

function MobileTemplate(_ref) {
  var addValue = _ref.addValue,
    updateValue = _ref.updateValue,
    keyBoardStore = _ref.keyBoardStore,
    handleTab = _ref.handleTab;
  var literals = getResponsiveKeyboardLiterals();
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-basic-keyboard-mobile"
  }, /*#__PURE__*/React__default.createElement(RenderKeyGroup$1, {
    group: literals[0],
    addValue: addValue
  }, /*#__PURE__*/React__default.createElement(KeyboardButton$1, {
    className: "lemo-keyboard-button__function-key",
    "data-fn": keyTypes.DEL,
    role: "button",
    "aria-pressed": "false",
    title: keyTypes.DEL,
    onMouseDown: updateValue
  }, /*#__PURE__*/React__default.createElement(SvgBackspace, {
    className: "lemo-icon lemo-delete-keyboard-icon",
    width: 28
  }))), /*#__PURE__*/React__default.createElement(RenderKeyGroup$1, {
    group: literals[1],
    addValue: addValue
  }), /*#__PURE__*/React__default.createElement(RenderKeyGroup$1, {
    group: literals[2],
    addValue: addValue
  }), /*#__PURE__*/React__default.createElement(RenderKeyGroup$1, {
    group: literals[3],
    addValue: addValue
  }), /*#__PURE__*/React__default.createElement(RenderKeyGroup$1, {
    group: literals[4],
    addValue: addValue
  }), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: keyBoardStore.hasTabulator
  }, /*#__PURE__*/React__default.createElement(KeyboardButton$1, {
    className: "lemo-keyboard-button__function-key lemo-primary",
    role: "button",
    "aria-pressed": "false",
    title: keyTypes.TAB,
    onMouseDown: handleTab
  }, /*#__PURE__*/React__default.createElement(SvgArrowSmRight, {
    className: "lemo-icon lemo-tab-keyboard-icon",
    width: 48,
    height: 70
  }))));
}
var MobileTemplate$1 = observer(MobileTemplate);

var mobileMediaQuery = window.matchMedia('(max-width: 420px)');
function BasicKeyboard(_ref) {
  var keyBoardStore = _ref.keyBoardStore,
    handleTab = _ref.handleTab,
    onBeforeSetValue = _ref.onBeforeSetValue;
  var _useKeyboard = useKeyboard(keyBoardStore, onBeforeSetValue),
    addValue = _useKeyboard.addValue,
    updateValue = _useKeyboard.updateValue;
  var _useState = useState(false),
    isMobile = _useState[0],
    setIsMobile = _useState[1];
  function checkMedia(mediaStatus) {
    setIsMobile(mediaStatus.matches);
  }
  useEffect(function () {
    checkMedia(mobileMediaQuery);
    mobileMediaQuery.addListener(checkMedia);
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-basic-keyboard', {
      'lemo-with-tabulator-key': keyBoardStore.hasTabulator
    }),
    "data-testid": "basic-keyboard"
  }, isMobile ? /*#__PURE__*/React__default.createElement(MobileTemplate$1, {
    addValue: addValue,
    updateValue: updateValue,
    keyBoardStore: keyBoardStore,
    handleTab: handleTab
  }) : /*#__PURE__*/React__default.createElement(RegularTemplate$1, {
    addValue: addValue,
    updateValue: updateValue,
    keyBoardStore: keyBoardStore,
    handleTab: handleTab
  }));
}
var BasicKeyboard$1 = observer(BasicKeyboard);

function useTextMetrics(_ref) {
  var elementRef = _ref.elementRef,
    value = _ref.value,
    _ref$initialValue = _ref.initialValue,
    initialValue = _ref$initialValue === void 0 ? 80 : _ref$initialValue,
    _ref$maxValue = _ref.maxValue,
    maxValue = _ref$maxValue === void 0 ? 400 : _ref$maxValue;
  var _useState = useState(initialValue),
    textMetrics = _useState[0],
    setTextMetrics = _useState[1];
  var getParent = function getParent() {
    return elementRef.current.parentNode;
  };
  function createClone() {
    var _clone$classList;
    var classes = Array.from(elementRef.current.classList) || [];
    var clone = document.createElement('span');
    clone.style.position = 'absolute';
    clone.style.whiteSpace = 'no-wrap';
    (_clone$classList = clone.classList).add.apply(_clone$classList, classes);
    clone.style.width = 'max-content';
    getParent().appendChild(clone);
    clone.innerHTML = elementRef.current.value || elementRef.current.innerHTML;
    return clone;
  }
  useEffect(function () {
    if (!elementRef.current) return false;
    var clone = createClone();
    var cloneWidth = Math.max(Math.ceil(clone.clientWidth), initialValue) || initialValue;
    getParent().removeChild(clone);
    var textMetricsValue = Math.min(maxValue, cloneWidth) + 5;
    setTextMetrics(isNaN(textMetricsValue) ? 10 : textMetricsValue);
  }, [value]);
  return {
    textMetrics: textMetrics
  };
}

var removeThousandSeparators = function removeThousandSeparators(value) {
  return value.replace(config.thousandsSeparatorRegx, '');
};
var hasSeparator = function hasSeparator(idx) {
  return idx !== 0 && idx % 3 === 0;
};
var addThousandsSeparator = function addThousandsSeparator(value) {
  return value.toString().split('').reverse().map(function (character, idx) {
    return hasSeparator(idx) ? character + config.thousandsSeparator : character;
  }).reverse().join('');
};

var numericInputMask = {
  get: function get(value) {
    return removeThousandSeparators(value);
  },
  set: function set(value) {
    return addThousandsSeparator(value);
  }
};

var COMMA = ',';
var POINT = '.';
function updateDecimalSeparators(separator, value) {
  if (separator !== COMMA && separator !== POINT) return false;
  var oldSeparator = separator === COMMA ? POINT : COMMA;
  return value.replaceAll(oldSeparator, separator);
}

var basicInputMask = {
  get: function get(value) {
    return updateDecimalSeparators(POINT, value);
  },
  set: function set(value) {
    return updateDecimalSeparators(config.decimalSeparator, value).replace(/\\div/g, division).replace(/\\times/g, multiply);
  }
};

var romanInputMask = {
  get: function get(value) {
    return value;
  },
  set: function set(value) {
    return value;
  }
};

var NUMERICAL = keyboardTypes.NUMERICAL,
  BASIC = keyboardTypes.BASIC,
  ROMAN = keyboardTypes.ROMAN;
function useInputMask(keyboardType) {
  if (keyboardType === NUMERICAL) return numericInputMask;
  if (keyboardType === BASIC) return basicInputMask;
  if (keyboardType === ROMAN) return romanInputMask;
}

var globalEmToPx = parseFloat(getComputedStyle(document.body).fontSize);
var getPixelsFromEM = function getPixelsFromEM(em) {
  return em * globalEmToPx;
};

var defaultInitialWidth = 6;
function InputKeyboard(_ref) {
  var _inputMask$set;
  var id = _ref.id,
    value = _ref.value,
    keyboardType = _ref.keyboardType,
    setValue = _ref.setValue,
    selectedInput = _ref.selectedInput,
    showSuccess = _ref.showSuccess,
    showError = _ref.showError,
    onStart = _ref.onStart,
    onFinish = _ref.onFinish,
    onWrite = _ref.onWrite,
    isFloating = _ref.isFloating,
    isFloatingPreview = _ref.isFloatingPreview,
    maxLength = _ref.maxLength,
    handleTab = _ref.handleTab,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$autoSize = _ref.autoSize,
    autoSize = _ref$autoSize === void 0 ? true : _ref$autoSize,
    _ref$initialWidth = _ref.initialWidth,
    initialWidth = _ref$initialWidth === void 0 ? defaultInitialWidth : _ref$initialWidth,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? autoFocusTypes.NONE : _ref$autoFocus,
    _ref$autoFocusFakeEna = _ref.autoFocusFakeEnabled,
    autoFocusFakeEnabled = _ref$autoFocusFakeEna === void 0 ? false : _ref$autoFocusFakeEna,
    _ref$handleFocus = _ref.handleFocus,
    handleFocus = _ref$handleFocus === void 0 ? noop : _ref$handleFocus,
    _ref$resetNotifier = _ref.resetNotifier,
    resetNotifier = _ref$resetNotifier === void 0 ? null : _ref$resetNotifier;
  var input = useRef();
  var _useState = useState(false),
    isWriting = _useState[0],
    setIsWriting = _useState[1];
  var _useTextMetrics = useTextMetrics({
      elementRef: input,
      value: value,
      initialValue: getPixelsFromEM(initialWidth)
    }),
    textMetrics = _useTextMetrics.textMetrics;
  var inputMask = useInputMask(keyboardType);
  var numericMaxLength = useNumericMaxLength(maxLength);
  function onFocus() {
    handleStart();
    handleFocus(true);
  }
  function onBlur() {
    handleFinish();
    handleFocus(false);
  }
  var handleStart = useCallback(function () {
    onStart === null || onStart === void 0 ? void 0 : onStart({
      id: id,
      value: value,
      setValue: setValue,
      maxLength: maxLength
    });
  }, [onStart, id, value, setValue, maxLength]);
  var handleFinish = useCallback(function () {
    (!isFloating || !config.inputMathFloating) && onFinish();
  }, [onFinish, isFloating]);
  var handleUserTab = useCallback(function (e) {
    if (e.which === 9 && handleTab) {
      e.preventDefault();
      handleTab();
      return true;
    }
    return false;
  }, [handleTab]);
  var handleWrite = useCallback(function (e) {
    var newValue = inputMask.get(e.currentTarget.value.trim());
    var next = onWrite(newValue);
    setIsWriting(true);
    setValue(next);
  }, [setValue, onWrite, isWriting, handleUserTab]);
  var handleEdit = useCallback(function (e) {
    document.activeElement !== input.current ? input.current.focus() : input.current.blur();
    e.preventDefault();
  }, [setValue, onWrite]);
  useEffect(function () {
    isWriting ? setIsWriting(false) : input.current.scrollLeft = input.current.scrollWidth;
  }, [value]);
  useEffect(function () {
    return onFinish;
  }, []);
  useEffect(function () {
    if (autoFocus === autoFocusTypes.ENABLED && input.current) {
      input.current.focus();
    }
  }, []);
  useEffect(function () {
    if (resetNotifier) {
      if (autoFocus === autoFocusTypes.ENABLED && input.current) {
        input.current.focus();
      }
    }
  }, [resetNotifier]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-input-keyboard', 'lemo-box-small', {
      'lemo-is-empty': value.toString().length === 0,
      'lemo-selected': selectedInput === id || autoFocusFakeEnabled && !selectedInput,
      'lemo-floating-preview': isFloatingPreview,
      'lemo-success': showSuccess,
      'lemo-error': showError
    })
  }, /*#__PURE__*/React__default.createElement("input", _extends({
    id: id,
    className: "lemo-input-keyboard__input",
    ref: input,
    "data-testid": id,
    type: "text",
    onFocus: onFocus,
    onBlur: onBlur,
    onChange: handleWrite,
    onKeyDown: handleUserTab,
    value: inputMask === null || inputMask === void 0 ? void 0 : (_inputMask$set = inputMask.set) === null || _inputMask$set === void 0 ? void 0 : _inputMask$set.call(inputMask, value),
    autoComplete: "off",
    maxLength: numericMaxLength,
    disabled: disabled,
    tabIndex: disabled ? -1 : 0,
    style: {
      width: autoSize ? safeNumber(textMetrics, initialWidth) : '100%'
    }
  }, isTouchDevice() ? {
    readOnly: 'readonly'
  } : undefined)), /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-input-keyboard__button",
    onMouseDown: handleEdit,
    tabIndex: -1,
    type: "button"
  }, /*#__PURE__*/React__default.createElement(SvgTable, {
    className: "lemo-input-keyboard__icon",
    width: 24,
    height: 24
  })));
}
function safeNumber(value, defaultValue) {
  return isNaN(value) || !value ? defaultValue : value;
}
function useNumericMaxLength(maxLength) {
  if (!maxLength || maxLength === -1) return 524288;
  var countThousandSeparators = function countThousandSeparators(digits) {
    return Math.floor((digits - 1) / 3);
  };
  var hasThousandSeparator = config.thousandsSeparator !== undefined;
  return hasThousandSeparator ? maxLength + countThousandSeparators(maxLength) : maxLength;
}
var InputKeyboard$1 = observer(InputKeyboard);

var useAutoFocusText = function useAutoFocusText(_ref) {
  var _ref$handleFocus = _ref.handleFocus,
    handleFocus = _ref$handleFocus === void 0 ? noop : _ref$handleFocus,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    autoFocus = _ref.autoFocus,
    _ref$resetNotifier = _ref.resetNotifier,
    resetNotifier = _ref$resetNotifier === void 0 ? null : _ref$resetNotifier;
  var _useState = useState(getForceVisibilityDefault()),
    forceVisibility = _useState[0],
    setForceVisibility = _useState[1];
  useEffect(function () {
    if (resetNotifier) {
      setForceVisibility(getForceVisibilityDefault());
    }
  }, [resetNotifier]);
  function getForceVisibilityDefault() {
    return text.length === 0 ? forceVisibilityTypes.SHOW : forceVisibilityTypes.HIDE;
  }
  useEffect(function () {
    if (forceVisibility === forceVisibilityTypes.SHOW && text.length > 0) setForceVisibility(forceVisibilityTypes.HIDE);
  }, [text]);
  function handleFocusFinal(focus) {
    if (handleFocus) handleFocus(focus);
    if (autoFocus === autoFocusTypes.ENABLED && !focus) {
      setForceVisibility(forceVisibilityTypes.HIDE);
    }
  }
  return {
    forceVisibility: forceVisibility,
    handleFocusFinal: handleFocusFinal
  };
};

var useAutoFocus = function useAutoFocus(_ref) {
  var _ref$handleFocus = _ref.handleFocus,
    handleFocus = _ref$handleFocus === void 0 ? noop : _ref$handleFocus,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    autoFocus = _ref.autoFocus,
    selectedInput = _ref.selectedInput,
    isFloating = _ref.isFloating,
    _ref$resetNotifier = _ref.resetNotifier,
    resetNotifier = _ref$resetNotifier === void 0 ? null : _ref$resetNotifier;
  var prevSelectedInputRef = useRef();
  var _useAutoFocusText = useAutoFocusText({
      text: text,
      autoFocus: autoFocus,
      handleFocus: handleFocus,
      resetNotifier: resetNotifier
    }),
    forceVisibility = _useAutoFocusText.forceVisibility,
    handleFocusFinal = _useAutoFocusText.handleFocusFinal;
  useEffect(function () {
    prevSelectedInputRef.current = selectedInput;
  }, [selectedInput]);
  var autoFocusBaseEditableText = autoFocus === autoFocusTypes.ENABLED && isFloating && !prevSelectedInputRef.current ? autoFocusTypes.NONE : autoFocus;
  var autoFocusFakeEnabled = autoFocus === autoFocusTypes.ENABLED && isFloating && forceVisibility === forceVisibilityTypes.SHOW && !prevSelectedInputRef.current;
  var forceVisibilityTooltip = autoFocus === autoFocusTypes.ENABLED ? forceVisibilityTypes.HIDE : forceVisibilityTypes.NONE;
  if (isFloating && !selectedInput && !prevSelectedInputRef.current) {
    forceVisibilityTooltip = forceVisibility;
  }
  return {
    autoFocusBaseEditableText: autoFocusBaseEditableText,
    autoFocusFakeEnabled: autoFocusFakeEnabled,
    handleFocusFinal: handleFocusFinal,
    forceVisibilityTooltip: forceVisibilityTooltip,
    forceVisibility: forceVisibility
  };
};

function InputWithAutofocus(props) {
  var value = props.value,
    selectedInput = props.selectedInput,
    isFloating = props.isFloating,
    _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? autoFocusTypes.NONE : _props$autoFocus,
    _props$handleFocus = props.handleFocus,
    handleFocus = _props$handleFocus === void 0 ? noop : _props$handleFocus,
    _props$resetNotifier = props.resetNotifier,
    resetNotifier = _props$resetNotifier === void 0 ? null : _props$resetNotifier;
  var isTouch = isTouchDevice();
  var _useAutoFocus = useAutoFocus({
      text: (value === null || value === void 0 ? void 0 : value.toString()) || '',
      autoFocus: autoFocus,
      handleFocus: handleFocus,
      selectedInput: selectedInput,
      isFloating: isFloating,
      resetNotifier: resetNotifier
    }),
    autoFocusBaseEditableText = _useAutoFocus.autoFocusBaseEditableText,
    autoFocusFakeEnabled = _useAutoFocus.autoFocusFakeEnabled,
    handleFocusFinal = _useAutoFocus.handleFocusFinal,
    forceVisibilityTooltip = _useAutoFocus.forceVisibilityTooltip;
  var baseEditableText = /*#__PURE__*/React__default.createElement(InputKeyboard$1, _extends({}, props, {
    autoFocus: autoFocusBaseEditableText,
    autoFocusFakeEnabled: autoFocusFakeEnabled,
    handleFocus: handleFocusFinal,
    resetNotifier: resetNotifier
  }));
  var tooltipTextKey;
  if (isFloating && isTouch) {
    tooltipTextKey = 'input_floating_tootltip_help_touch_devices';
  } else if (isFloating && !isTouch) {
    tooltipTextKey = 'input_floating_tootltip_help';
  } else if (!isFloating && isTouch) {
    tooltipTextKey = 'input_tootltip_help_touch_devices';
  } else {
    tooltipTextKey = 'input_tootltip_help';
  }
  var tooltipText = translate(tooltipTextKey);
  return autoFocus === autoFocusTypes.ENABLED ? /*#__PURE__*/React__default.createElement(TooltipIcon, {
    text: tooltipText,
    icon: baseEditableText,
    forceVisibility: forceVisibilityTooltip
  }) : baseEditableText;
}
var InputKeyboard$2 = observer(InputWithAutofocus);

var keyboardLiterals = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
var keyGroups = [keyboardLiterals.slice(0, 3), keyboardLiterals.slice(3, 6), keyboardLiterals.slice(6, 9), keyboardLiterals.slice(9, 10)];
function NumericKeyboard(_ref) {
  var keyBoardStore = _ref.keyBoardStore,
    handleTab = _ref.handleTab,
    handleDelete = _ref.handleDelete,
    onBeforeSetValue = _ref.onBeforeSetValue;
  var _useKeyboard = useKeyboard(keyBoardStore, onBeforeSetValue),
    addValue = _useKeyboard.addValue,
    updateValue = _useKeyboard.updateValue;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-numeric-keyboard",
    "data-testid": "numeric-keyboard"
  }, /*#__PURE__*/React__default.createElement(RenderKeyGroup$1, {
    group: keyGroups[0],
    addValue: addValue
  }), /*#__PURE__*/React__default.createElement(RenderKeyGroup$1, {
    group: keyGroups[1],
    addValue: addValue
  }), /*#__PURE__*/React__default.createElement(RenderKeyGroup$1, {
    group: keyGroups[2],
    addValue: addValue
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-keys-group"
  }, /*#__PURE__*/React__default.createElement(RenderKeyGroup$1, {
    group: keyGroups[3],
    addValue: addValue
  }), /*#__PURE__*/React__default.createElement(KeyboardButton$1, {
    className: "lemo-keyboard-button__function-key",
    "data-fn": keyTypes.DEL,
    role: "button",
    "aria-pressed": "false",
    title: keyTypes.DEL,
    onMouseDown: handleDelete || updateValue
  }, /*#__PURE__*/React__default.createElement(SvgBackspace, {
    className: "lemo-icon lemo-delete-keyboard-icon",
    width: 28
  })), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: keyBoardStore.hasTabulator
  }, /*#__PURE__*/React__default.createElement(KeyboardButton$1, {
    className: "lemo-keyboard-button__function-key lemo-primary",
    role: "button",
    "aria-pressed": "false",
    title: keyTypes.TAB,
    onMouseDown: handleTab
  }, /*#__PURE__*/React__default.createElement(SvgArrowSmRight, {
    className: "lemo-icon lemo-tab-keyboard-icon",
    width: 48,
    height: 70
  })))));
}
var NumericKeyboard$1 = observer(NumericKeyboard);

var keyboardLiterals$1 = ['I', 'V', 'X', 'L', 'C', 'D', 'M'];
var keyGroups$1 = [keyboardLiterals$1.slice(0, 2), keyboardLiterals$1.slice(2, 4), keyboardLiterals$1.slice(4)];
function RomanKeyboard(_ref) {
  var keyBoardStore = _ref.keyBoardStore,
    handleTab = _ref.handleTab,
    handleDelete = _ref.handleDelete,
    onBeforeSetValue = _ref.onBeforeSetValue;
  var _useKeyboard = useKeyboard(keyBoardStore, onBeforeSetValue),
    addValue = _useKeyboard.addValue,
    updateValue = _useKeyboard.updateValue;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-roman-keyboard",
    "data-testid": "roman-keyboard"
  }, /*#__PURE__*/React__default.createElement(RenderKeyGroup$1, {
    group: keyGroups$1[0],
    addValue: addValue
  }), /*#__PURE__*/React__default.createElement(RenderKeyGroup$1, {
    group: keyGroups$1[1],
    addValue: addValue
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-keys-group"
  }, /*#__PURE__*/React__default.createElement(RenderKeyGroup$1, {
    group: keyGroups$1[2],
    addValue: addValue
  }), /*#__PURE__*/React__default.createElement(KeyboardButton$1, {
    className: "lemo-keyboard-button__function-key",
    "data-fn": keyTypes.DEL,
    role: "button",
    "aria-pressed": "false",
    title: keyTypes.DEL,
    onMouseDown: handleDelete || updateValue
  }, /*#__PURE__*/React__default.createElement(SvgBackspace, {
    className: "lemo-icon lemo-delete-keyboard-icon",
    width: 28
  })), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: keyBoardStore.hasTabulator
  }, /*#__PURE__*/React__default.createElement(KeyboardButton$1, {
    className: "lemo-keyboard-button__function-key lemo-primary",
    role: "button",
    "aria-pressed": "false",
    title: keyTypes.TAB,
    onMouseDown: handleTab
  }, /*#__PURE__*/React__default.createElement(SvgArrowSmRight, {
    className: "lemo-icon lemo-tab-keyboard-icon",
    width: 48,
    height: 70
  })))));
}
var RomanKeyboard$1 = observer(RomanKeyboard);

var keyboardLiterals$2 = ['2', '3', '5', '7', '11'];
var keyGroups$2 = [keyboardLiterals$2.slice(0, 3), keyboardLiterals$2.slice(3, 5)];
function PrimeNumbersKeyboard(_ref) {
  var keyBoardStore = _ref.keyBoardStore,
    handleDelete = _ref.handleDelete,
    onBeforeSetValue = _ref.onBeforeSetValue;
  var _useKeyboard = useKeyboard(keyBoardStore, onBeforeSetValue),
    addValue = _useKeyboard.addValue,
    updateValue = _useKeyboard.updateValue;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-roman-keyboard",
    "data-testid": "roman-keyboard"
  }, /*#__PURE__*/React__default.createElement(RenderKeyGroup$1, {
    group: keyGroups$2[0],
    addValue: addValue
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-keys-group"
  }, /*#__PURE__*/React__default.createElement(RenderKeyGroup$1, {
    group: keyGroups$2[1],
    addValue: addValue
  }), /*#__PURE__*/React__default.createElement(KeyboardButton$1, {
    className: "lemo-keyboard-button__function-key",
    "data-fn": keyTypes.DEL,
    role: "button",
    "aria-pressed": "false",
    title: keyTypes.DEL,
    onMouseDown: handleDelete || updateValue
  }, /*#__PURE__*/React__default.createElement(SvgBackspace, {
    className: "lemo-icon lemo-delete-keyboard-icon",
    width: 28
  }))));
}
var PrimeNumbersKeyboard$1 = observer(PrimeNumbersKeyboard);

function LemonadeKeyboard(_ref) {
  var type = _ref.type,
    isActive = _ref.isActive,
    keyboardStore = _ref.keyboardStore,
    tabList = _ref.tabList,
    onKeyboardVisible = _ref.onKeyboardVisible,
    handleDelete = _ref.handleDelete,
    onBeforeSetValue = _ref.onBeforeSetValue,
    _ref$testFloating = _ref.testFloating,
    testFloating = _ref$testFloating === void 0 ? false : _ref$testFloating,
    _ref$forceFloating = _ref.forceFloating,
    forceFloating = _ref$forceFloating === void 0 ? false : _ref$forceFloating;
  useDefaultProp({
    value: tabList,
    setter: keyboardStore.setTabList
  });
  var eq = function eq(current) {
    return type === current;
  };
  var inputContainer = useRef();
  var isFloating = forceFloating || keyboardStore.isFloating;
  var getFocus = useCallback(function () {
    var _inputContainer$curre, _inputContainer$curre2, _inputContainer$curre3;
    (_inputContainer$curre = inputContainer.current) === null || _inputContainer$curre === void 0 ? void 0 : (_inputContainer$curre2 = _inputContainer$curre.querySelector('input')) === null || _inputContainer$curre2 === void 0 ? void 0 : (_inputContainer$curre3 = _inputContainer$curre2.focus) === null || _inputContainer$curre3 === void 0 ? void 0 : _inputContainer$curre3.call(_inputContainer$curre2);
  }, []);
  var handleTab = useCallback(function (e) {
    if (keyboardStore.nextFocus) {
      var _document$querySelect, _document$querySelect2;
      (_document$querySelect = document.querySelector("input#" + keyboardStore.nextFocus)) === null || _document$querySelect === void 0 ? void 0 : (_document$querySelect2 = _document$querySelect.focus) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.call(_document$querySelect);
      e === null || e === void 0 ? void 0 : e.preventDefault();
    } else {
      keyboardStore.finish();
    }
  }, [keyboardStore]);
  useEffect(function () {
    if (isActive && isFloating) setTimeout(getFocus, 10);
  }, [isActive, keyboardStore.activeFieldId]);
  useEffect(function () {
    if (isFloating || testFloating) {
      onKeyboardVisible && onKeyboardVisible(isActive && isFloating, type);
    }
  }, [isActive, isFloating, testFloating]);
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "lemo-keyboard",
    className: cn$1('lemo-keyboard', {
      'lemo-active': isActive || testFloating,
      'lemo-floating-keyboard': isFloating || testFloating,
      'lemo-no-interactive': !config.inputMathFloating
    })
  }, /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: isFloating && config.inputMathFloating
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: inputContainer,
    className: "lemo-floating-input-preview"
  }, /*#__PURE__*/React__default.createElement(InputKeyboard$2, {
    id: "floating-input",
    value: keyboardStore.value,
    setValue: keyboardStore.setValue,
    keyboardType: keyboardStore.type,
    onFinish: keyboardStore.finish,
    onWrite: keyboardStore.setValue,
    handleTab: handleTab,
    isFloatPreview: true
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-background', {
      'lemo-fix-bottom': !config.inputMathFloating
    })
  }, /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: eq(keyboardTypes.NUMERICAL)
  }, /*#__PURE__*/React__default.createElement(NumericKeyboard$1, {
    handleDelete: handleDelete,
    keyBoardStore: keyboardStore,
    handleTab: handleTab,
    onBeforeSetValue: onBeforeSetValue
  })), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: eq(keyboardTypes.BASIC)
  }, /*#__PURE__*/React__default.createElement(BasicKeyboard$1, {
    keyBoardStore: keyboardStore,
    handleTab: handleTab,
    onBefore: true
  })), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: eq(keyboardTypes.ROMAN)
  }, /*#__PURE__*/React__default.createElement(RomanKeyboard$1, {
    handleDelete: handleDelete,
    keyBoardStore: keyboardStore,
    handleTab: handleTab,
    onBeforeSetValue: onBeforeSetValue
  })), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: eq(keyboardTypes.PRIME_NUMBERS)
  }, /*#__PURE__*/React__default.createElement(PrimeNumbersKeyboard$1, {
    handleDelete: handleDelete,
    keyBoardStore: keyboardStore,
    handleTab: handleTab,
    onBeforeSetValue: onBeforeSetValue
  }))));
}
var LemonadeKeyboard$1 = observer(LemonadeKeyboard);

function AddAlternativeResponseButton(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React__default.createElement("button", {
    onClick: onClick,
    className: "lemo-add-alternative-response-button",
    "data-testid": "plusIcon"
  }, /*#__PURE__*/React__default.createElement(SvgPlusCircle, {
    className: "lemo-icon"
  }));
}
var AddAlternativeResponseButton$1 = observer(AddAlternativeResponseButton);

function InputWithKeyboard(_ref) {
  var response = _ref.response,
    keyboardStore = _ref.keyboardStore,
    initialWidth = _ref.initialWidth,
    solutionsMode = _ref.solutionsMode,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? autoFocusTypes.NONE : _ref$autoFocus,
    _ref$handleFocus = _ref.handleFocus,
    handleFocus = _ref$handleFocus === void 0 ? noop : _ref$handleFocus,
    _ref$resetNotifier = _ref.resetNotifier,
    resetNotifier = _ref$resetNotifier === void 0 ? null : _ref$resetNotifier;
  return /*#__PURE__*/React__default.createElement(InputKeyboard$2, {
    id: response.id,
    value: response.value,
    setValue: response.setValue,
    keyboardType: keyboardStore.type,
    selectedInput: keyboardStore.activeFieldId,
    showSuccess: response.isSuccess,
    showError: response.isWrong,
    onFinish: keyboardStore.finish,
    onStart: keyboardStore.start,
    onWrite: keyboardStore.setValue,
    isFloating: solutionsMode || keyboardStore.isFloating,
    maxLength: response.responseLength,
    initialWidth: initialWidth,
    autoFocus: autoFocus,
    handleFocus: handleFocus,
    resetNotifier: resetNotifier
  });
}
var InputWithKeyboard$1 = observer(InputWithKeyboard);

function GroupedResponsesCounter(_ref) {
  var responses = _ref.responses,
    onClick = _ref.onClick;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-grouped-responses-counter lemo-text-blank"
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-pill",
    role: "button",
    "data-testid": "labelTextResponseCounter",
    onClick: onClick
  }, responses, " ", translate('responses')));
}

function BaseEditableText(_ref) {
  var response = _ref.response,
    solutionsMode = _ref.solutionsMode,
    isDisabled = _ref.isDisabled,
    _ref$initialWidth = _ref.initialWidth,
    initialWidth = _ref$initialWidth === void 0 ? 6 : _ref$initialWidth,
    _ref$handleFocus = _ref.handleFocus,
    handleFocus = _ref$handleFocus === void 0 ? noop : _ref$handleFocus,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? autoFocusTypes.NONE : _ref$autoFocus,
    _ref$resetNotifier = _ref.resetNotifier,
    resetNotifier = _ref$resetNotifier === void 0 ? null : _ref$resetNotifier;
  var input = useRef();
  var getText = function getText() {
    var _input$current;
    return ((_input$current = input.current) === null || _input$current === void 0 ? void 0 : _input$current.innerText) || '';
  };
  var isEmpty = getText().trim().length === 0;
  var maxLength = solutionsMode ? -1 : response.responseLength;
  var minWidth = initialWidth + "em";
  function canWrite() {
    return maxLength === -1 || getText().length < maxLength;
  }
  var handleKeyDown = useCallback(function (e) {
    if (specialKeys[e.key]) {
      return true;
    }
    if (e.key === 'Enter') {
      e.preventDefault();
      return false;
    }
    if (!canWrite()) {
      e.preventDefault();
      return false;
    }
    return true;
  }, [response]);
  var handleInput = useCallback(function (e) {
    response.setValue(e.target.innerText);
  }, [response]);
  function syncValue() {
    response.value.length > 0 ? input.current.innerText = response.value : input.current.innerHTML = '&nbsp;';
  }
  function onFocus() {
    if (input.current.innerHTML === '&nbsp;') {
      input.current.innerText = '';
    }
    handleFocus(true);
  }
  function onBlur() {
    if (input.current.innerText === '') {
      input.current.innerHTML = '&nbsp;';
    }
    handleFocus(false);
  }
  useEffect(function () {
    if (getText() !== response.value) syncValue();
  }, [response.value]);
  useEffect(function () {
    syncValue();
  }, [isDisabled]);
  useEffect(function () {
    if (autoFocus === autoFocusTypes.ENABLED && input.current) {
      input.current.focus();
    }
  }, []);
  useEffect(function () {
    if (resetNotifier) {
      if (autoFocus === autoFocusTypes.ENABLED && input.current) {
        input.current.focus();
      }
    }
  }, [resetNotifier]);
  return /*#__PURE__*/React__default.createElement("span", {
    className: classNames('lemo-editable-text', 'lemo-cloze-text-blank', 'lemo-box-small', 'response', {
      'lemo-selected': response.selected,
      'lemo-lock': response.isLock,
      'lemo-success': response.isSuccess,
      'lemo-error': response.isWrong,
      'lemo-is-empty': isEmpty
    }),
    ref: input,
    role: "textbox",
    contentEditable: !isDisabled,
    onKeyDown: handleKeyDown,
    onInput: handleInput,
    onFocus: onFocus,
    onBlur: onBlur,
    style: {
      minWidth: minWidth,
      hyphens: 'auto'
    }
  });
}
var specialKeys = {
  ArrowRight: true,
  ArrowLeft: true,
  ArrowDown: true,
  ArrowUp: true,
  Delete: true,
  Backspace: true,
  Shift: true,
  Control: true,
  Alt: true,
  Tab: true
};
var BaseEditableText$1 = observer(BaseEditableText);

function EditableText(_ref) {
  var response = _ref.response,
    solutionsMode = _ref.solutionsMode,
    isDisabled = _ref.isDisabled,
    _ref$initialWidth = _ref.initialWidth,
    initialWidth = _ref$initialWidth === void 0 ? 6 : _ref$initialWidth,
    _ref$handleFocus = _ref.handleFocus,
    handleFocus = _ref$handleFocus === void 0 ? noop : _ref$handleFocus,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? autoFocusTypes.NONE : _ref$autoFocus,
    _ref$resetNotifier = _ref.resetNotifier,
    resetNotifier = _ref$resetNotifier === void 0 ? null : _ref$resetNotifier;
  var isTouch = isTouchDevice();
  var text = (response === null || response === void 0 ? void 0 : response.value) || '';
  var _useAutoFocus = useAutoFocus({
      handleFocus: handleFocus,
      text: text,
      autoFocus: autoFocus,
      resetNotifier: resetNotifier,
      selectedInput: null,
      isFloating: false
    }),
    forceVisibility = _useAutoFocus.forceVisibility,
    handleFocusFinal = _useAutoFocus.handleFocusFinal;
  var baseEditableText = /*#__PURE__*/React__default.createElement(BaseEditableText$1, {
    response: response,
    solutionsMode: solutionsMode,
    isDisabled: isDisabled,
    initialWidth: initialWidth,
    handleFocus: handleFocusFinal,
    autoFocus: autoFocus,
    resetNotifier: resetNotifier
  });
  return autoFocus === autoFocusTypes.ENABLED && baseEditableText ? /*#__PURE__*/React__default.createElement(TooltipIcon, {
    text: translate(isTouch ? 'input_tootltip_help_touch_devices' : 'input_tootltip_help'),
    icon: baseEditableText,
    forceVisibility: forceVisibility
  }) : baseEditableText;
}
var EditableText$1 = observer(EditableText);

function Blank(_ref) {
  var store = _ref.store,
    response = _ref.response,
    solutionsMode = _ref.solutionsMode,
    onAddAlternativeResponse = _ref.onAddAlternativeResponse,
    keyboardStore = _ref.keyboardStore,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? autoFocusTypes.NONE : _ref$autoFocus;
  var _useState = useState(false),
    withPlusIcon = _useState[0],
    setWithPlusIcon = _useState[1];
  if (!isAlive(response)) return null;
  var isSelected = response.id === store.selectedResponseID;
  function handleFocus(bool) {
    if (!store.isEditor || store.isPreviewMode) return false;
    bool ? setWithPlusIcon(bool) : setTimeout(function () {
      return setWithPlusIcon(bool);
    }, 200);
  }
  function openGroupedResponsesPanel() {
    onAddAlternativeResponse(response);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    id: "wrapper__" + response.id,
    "data-testid": "blank",
    className: cn$1('text-blank-wrapper', {
      'lemo-with-plus-icon': withPlusIcon,
      'lemo-selected': isSelected,
      'text-blank-wrapper--is-floating': (keyboardStore === null || keyboardStore === void 0 ? void 0 : keyboardStore.isFloating) || false
    })
  }, withPlusIcon && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-alternative-response-wrapper"
  }, /*#__PURE__*/React__default.createElement(AddAlternativeResponseButton$1, {
    onClick: openGroupedResponsesPanel
  })), when()["case"](solutionsMode && response.hasGroupedResponses, function () {
    return /*#__PURE__*/React__default.createElement(GroupedResponsesCounter, {
      responses: response.solutionList.length,
      onClick: openGroupedResponsesPanel
    });
  })["case"](store.hasLemonadeKeyboard, function () {
    return /*#__PURE__*/React__default.createElement(InputWithKeyboard$1, {
      response: response,
      solutionsMode: solutionsMode,
      initialWidth: store.inputWidth / 2,
      keyboardStore: keyboardStore,
      handleFocus: handleFocus,
      autoFocus: autoFocus,
      resetNotifier: store.resetNotifier
    });
  }).resolve(function () {
    return /*#__PURE__*/React__default.createElement(EditableText$1, {
      response: response,
      solutionsMode: solutionsMode,
      isDisabled: store.isEvaluated || store.disabled,
      initialWidth: store.inputWidth,
      handleFocus: handleFocus,
      autoFocus: autoFocus,
      resetNotifier: store.resetNotifier
    });
  }), /*#__PURE__*/React__default.createElement(FeedbackPin$1, {
    idx: response.feedbackIndex,
    result: response.resultCache,
    visible: response.withPin && response.isWrongCache,
    classAdd: 'lemo-base-feedback-pin__option',
    feedback: response.feedback
  }));
}
var Blank$1 = observer(Blank);

var ClozeTextQuestion = function ClozeTextQuestion(props) {
  var store = props.store,
    solutionsMode = props.solutionsMode,
    isPreview = props.isPreview,
    onKeyboardVisible = props.onKeyboardVisible,
    _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? autoFocusTypes.NONE : _props$autoFocus;
  var changedHandlers = /setTitle|setStimulus|checkAnswers|reset|setValue/;
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', {
      'lemo-disabled': store.disabled
    })
  }, store.isPrintMode ? /*#__PURE__*/React__default.createElement(PrintModeTemplate$1, {
    store: store
  }) : /*#__PURE__*/React__default.createElement(QuestionTemplate$1, {
    store: store,
    autoFocus: isPreview ? autoFocusTypes.NONE : autoFocus
  }, /*#__PURE__*/React__default.createElement(Blank$1, {
    store: store,
    solutionsMode: solutionsMode,
    keyboardStore: store.hasLemonadeKeyboard,
    onAddAlternativeResponse: noop
  }))), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: store.hasLemonadeKeyboard
  }, /*#__PURE__*/React__default.createElement(LemonadeKeyboard$1, {
    type: store.keyboard.type,
    keyboardStore: store.keyboard,
    isActive: store.keyboard.isActive,
    tabList: store.responses.map(function (_ref) {
      var id = _ref.id;
      return id;
    }),
    forceFloating: solutionsMode,
    testFloating: false,
    onKeyboardVisible: onKeyboardVisible
  })));
};
var ClozeTextQuestion$1 = observer(ClozeTextQuestion);

var withHasLemonadeKeyboard = types$1.model({}).views(function (state) {
  return {
    get hasLemonadeKeyboard() {
      var _state$ui_style, _state$ui_style$keybo;
      var validKeyboardTypes = omit(['SCIENTIFIC', 'NONE'], keyboardTypes);
      var lemoKeyboardTypes = Object.values(validKeyboardTypes);
      return lemoKeyboardTypes.includes((_state$ui_style = state.ui_style) === null || _state$ui_style === void 0 ? void 0 : (_state$ui_style$keybo = _state$ui_style.keyboard) === null || _state$ui_style$keybo === void 0 ? void 0 : _state$ui_style$keybo.type) ? state.keyboard : false;
    }
  };
});

var keyboardList = Object.values(keyboardTypes);
var keyboardLowercaseList = keyboardList.map(function (k) {
  return k.toLowerCase();
});
var getDefaultKeyboard = function getDefaultKeyboard(data) {
  return produce(data, function (draft) {
    draft.ui_style.keyboard = {
      type: keyboards.scientific,
      isFixed: true
    };
  });
};
var getKeyboardTypeInUppercase = function getKeyboardTypeInUppercase(data) {
  return produce(data, function (draft) {
    draft.ui_style.keyboard.type = draft.ui_style.keyboard.type.toUpperCase();
  });
};
function addDefaultKeyboard(data) {
  var _data$ui_style, _data$ui_style$keyboa;
  var currentKeyboard = data === null || data === void 0 ? void 0 : (_data$ui_style = data.ui_style) === null || _data$ui_style === void 0 ? void 0 : (_data$ui_style$keyboa = _data$ui_style.keyboard) === null || _data$ui_style$keyboa === void 0 ? void 0 : _data$ui_style$keyboa.type;
  if (currentKeyboard === undefined) return getDefaultKeyboard(data);
  if (keyboardList.includes(currentKeyboard)) return data;
  if (Object.values(keyboardLowercaseList).includes(currentKeyboard)) return getKeyboardTypeInUppercase(data);
  return getDefaultKeyboard(data);
}

var ExtendedValidationModel$1 = types$1.compose(ValidationBaseModel, types$1.model({}).actions(function (state) {
  return {
    createAlternativeSolution: function createAlternativeSolution(data) {
      if (state !== null && state !== void 0 && state.solutionList && (state === null || state === void 0 ? void 0 : state.solutionList.length) > 0 && state !== null && state !== void 0 && state.solutionList[0]) {
        var firstSolutionList = state === null || state === void 0 ? void 0 : state.solutionList[0];
        state.alt_responses = [].concat(state.alt_responses, [firstSolutionList]);
      } else {
        state.alt_responses = [].concat(state.alt_responses, [data]);
      }
    }
  };
}));
var ValidationModelExtend$1 = types$1.snapshotProcessor(ExtendedValidationModel$1, {
  preProcessor: function preProcessor(snapshot) {
    return _preProcessor(snapshot);
  },
  postProcessor: function postProcessor(snapshot) {
    return _postProcessor(snapshot);
  }
});
var ClozeEditorStore = types$1.compose(EditorBaseModel, types$1.model({
  exerciseType: types$1.optional(types$1.string, ''),
  template: types$1.optional(types$1.string, ''),
  validation: ValidationModelExtend$1,
  onUpdateNotifierUpdateTemplate: types$1.optional(types$1.number, 1),
  ui_style: types$1.optional(UIStyleModel$1, defaultUIStyle)
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      reaction(function () {
        return state.blanksLength;
      }, function () {
        return state.updateResponses();
      });
      state.updateResponses();
    },
    setTemplate: function setTemplate(val, blanksResponsesId) {
      if (blanksResponsesId === void 0) {
        blanksResponsesId = null;
      }
      state.template = val;
      state.updateResponses(blanksResponsesId);
      state.updateNotifier();
    },
    updateResponses: function updateResponses(blanks) {
      var _state$syncWithTempla;
      if (blanks === void 0) {
        blanks = null;
      }
      if (blanks === null) return false;
      var responsesSnapShot = getSnapshot(state.responses);
      var indexList = blanks.reduce(function (acc, next) {
        var responseFound = responsesSnapShot.findIndex(function (_ref) {
          var id = _ref.id;
          return next === id;
        });
        return [].concat(acc, [responseFound === -1 ? undefined : responseFound]);
      }, []);
      state.responses = indexList.map(function (index) {
        return index !== undefined ? responsesSnapShot[index] : {};
      });
      state.updateValidation(indexList);
      state.updateAlternatives(indexList);
      (_state$syncWithTempla = state.syncWithTemplate) === null || _state$syncWithTempla === void 0 ? void 0 : _state$syncWithTempla.call(state);
      state.updateNotifier();
      state.updateNotifierUpdateTemplate();
    },
    updateValidation: function updateValidation() {
      state.validation.setValue(state.responses.map(function (_ref2) {
        var validResponse = _ref2.validResponse;
        return validResponse;
      }));
    },
    updateAlternatives: function updateAlternatives() {
      state.validation.alt_responses.forEach(function (alt, idx) {
        alt.setValue(state.responses.map(function (r) {
          if (r.validAlternatives) {
            return r.validAlternatives.responses[idx];
          }
          return '';
        }));
      });
    },
    syncGroupedResponsesWithTemplate: function syncGroupedResponsesWithTemplate() {
      if (state.validation.grouped_responses) {
        state.validation.syncGroupedResponses(state.responses);
      }
    },
    updateNotifierUpdateTemplate: function updateNotifierUpdateTemplate() {
      state.onUpdateNotifierUpdateTemplate = Date.now();
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.string), response)) return false;
      state.responses.forEach(function (resp, idx) {
        return resp.setValue(response[idx]);
      });
    },
    clearResponses: function clearResponses() {
      state.responses.forEach(function (response) {
        return response.reset();
      });
    },
    reset: function reset() {
      state.baseReset();
      state.clearResponses();
      state.updateNotifier();
    },
    setData: function setData(data) {
      applySnapshot(state, data);
    }
  };
}).views(function (state) {
  return {
    getUserResponse: function getUserResponse() {},
    get blanksLength() {
      return getBlanksLength(state.template);
    },
    get templateToView() {
      return updateTemplate$1(state.template, state.responses);
    },
    get templateWithMoreData() {
      var myTemplate = state.template;
      var rePattern = /{{response(.*?)}}/gi;
      var idx = 0;
      return myTemplate.replace(rePattern, function () {
        var responseId = null;
        if (state.responses && state.responses[idx] && state.responses[idx].id) {
          responseId = state.responses[idx].id;
        }
        idx++;
        return getTagResponseToFroala(responseId);
      });
    }
  };
}));

var withActiveSolution = types$1.model({
  activeSolutionIdx: types$1.optional(types$1.number, 0)
}).actions(function (state) {
  return {
    setActiveSolutionIdx: function setActiveSolutionIdx(activeSolutionIdx) {
      state.activeSolutionIdx = activeSolutionIdx;
    }
  };
}).views(function (state) {
  return {
    getActiveSolution: function getActiveSolution() {
      return state.validation.solutionList[state.activeSolutionIdx];
    }
  };
});

var GroupedValueModel = types$1.model('GroupedValueModel', {
  id: types$1.optional(types$1.string, function () {
    return uuid();
  }),
  values: types$1.optional(types$1.array(types$1.string), [])
}).actions(function (state) {
  return {
    setId: function setId(id) {
      state.id = id;
    },
    setValue: function setValue(values) {
      state.values = values;
    },
    addValue: function addValue(newItem) {
      if (newItem === void 0) {
        newItem = '';
      }
      if (state.values.length >= 10) return false;
      state.values.push(newItem);
    },
    removeValueAt: function removeValueAt(idx) {
      state.values = rmItem(idx, state.values);
    },
    editValueAt: function editValueAt(idx, value) {
      state.values[idx] = value;
    },
    clearEmptyResponses: function clearEmptyResponses() {
      state.values = state.values.reduce(function (acc, next) {
        return next.length === 0 ? acc : [].concat(acc, [next]);
      }, []);
    }
  };
});

var GroupedSolutionModel = types$1.model('GroupedSolutionModel', {
  score: types$1.number,
  value: types$1.array(GroupedValueModel)
}).actions(function (state) {
  return {
    setValue: function setValue(val) {
      console.log(val);
    },
    addGroupedSolutionAt: function addGroupedSolutionAt(solutionIdx, newItem) {
      if (newItem === void 0) {
        newItem = '';
      }
      state.value[solutionIdx].addValue(newItem);
    },
    removeGroupedSolutionAt: function removeGroupedSolutionAt(solutionIdx, valueIndex) {
      state.value[solutionIdx].removeValueAt(valueIndex);
    },
    editGroupedSolutionAt: function editGroupedSolutionAt(solutionIdx, valueIndex, value) {
      state.value[solutionIdx].editValueAt(valueIndex, value);
    },
    clearEmptyResponses: function clearEmptyResponses(solutionIdx) {
      state.value[solutionIdx].clearEmptyResponses();
    },
    clear: function clear() {
      state.value.forEach(function (val) {
        val.values = [''];
      });
    },
    addEmptyValue: function addEmptyValue() {
      state.value.push({
        values: ['']
      });
    },
    addNewValue: function addNewValue() {
      state.addEmptyValue();
    },
    removeValueAt: function removeValueAt(idx) {
      destroy(state.value[idx]);
    }
  };
}).views(function (state) {
  return {
    get info() {
      return {
        score: state.score,
        value: state.value.map(function (val) {
          return {
            id: val.id,
            values: val.values.toJSON()
          };
        })
      };
    },
    get values() {
      return state.value.map(function (_ref) {
        var values = _ref.values;
        return values.map(function (value) {
          return value;
        });
      });
    },
    get xx() {
      return state.value.map(function (_ref2) {
        var values = _ref2.values;
        return getSnapshot(values);
      });
    },
    get output() {
      return getSnapshot(state);
    },
    get output2() {
      var valueList = state.value.map(function (val) {
        return val.values.toJSON();
      });
      var value = valueList.map(function (val) {
        return val.length > 0 ? val[0] : '';
      });
      var grouped_responses = valueList.map(function (val) {
        return val.length > 1 ? val.slice(1) : [];
      });
      return {
        score: state.score,
        value: value,
        grouped_responses: grouped_responses
      };
    }
  };
});
function mergeSolution(_ref3) {
  var value = _ref3.value,
    _ref3$grouped_respons = _ref3.grouped_responses,
    grouped_responses = _ref3$grouped_respons === void 0 ? [] : _ref3$grouped_respons;
  return value.map(function (solution, idx) {
    return {
      values: [solution].concat((grouped_responses === null || grouped_responses === void 0 ? void 0 : grouped_responses[idx]) || [])
    };
  });
}
var GroupedSolutionModel$1 = types$1.snapshotProcessor(GroupedSolutionModel, {
  preProcessor: function preProcessor(snapshot) {
    return snapshot.isSnapshotFromUpdate ? snapshot : {
      score: snapshot.score,
      value: mergeSolution(snapshot)
    };
  },
  postProcessor: function postProcessor(snapshot) {
    return {
      score: snapshot.score,
      value: snapshot.value.map(function (value) {
        return value.values && value.values.length > 0 ? value.values[0] : '';
      }),
      grouped_responses: snapshot.value.map(function (value) {
        return value.values && value.values.length > 0 ? value.values.slice(1) : [];
      })
    };
  }
});

var editorWithGroupedValuesModel = types$1.model({
  id: types$1.optional(types$1.string, function () {
    return uuid();
  })
}).actions(function (state) {
  var parent = getParent(state, 2);
  return {
    setValue: function setValue(value) {
      state.editSolutionAt(0, value);
      parent.updateNotifier();
    },
    editSolutionAt: function editSolutionAt(idx, value) {
      state.activeSolution.editGroupedSolutionAt(state.index, idx, value);
      parent.updateNotifier(false);
    },
    removeSolutionAt: function removeSolutionAt(idx) {
      state.activeSolution.removeGroupedSolutionAt(state.index, idx);
      parent.updateNotifier(false);
    },
    clearEmptyResponses: function clearEmptyResponses() {
      state.activeSolution.clearEmptyResponses(state.index);
    }
  };
}).views(function (state) {
  var parent = getParent(state, 2);
  return {
    get value() {
      var _state$activeSolution, _state$activeSolution2, _state$activeSolution3;
      if (!((_state$activeSolution = state.activeSolution) !== null && _state$activeSolution !== void 0 && (_state$activeSolution2 = _state$activeSolution.value[state.index]) !== null && _state$activeSolution2 !== void 0 && (_state$activeSolution3 = _state$activeSolution2.values) !== null && _state$activeSolution3 !== void 0 && _state$activeSolution3[0])) return '';
      return state.activeSolution.value[state.index].values[0];
    },
    get activeSolution() {
      return parent.getActiveSolution();
    },
    get currentSolution() {
      return state.activeSolution.value[state.index];
    },
    get solutionList() {
      return parent.getActiveSolution().value[state.index].values;
    },
    get hasGroupedResponses() {
      return parent.getActiveSolution().value[state.index].values.length > 1;
    }
  };
});

var ResponseModel$2 = types$1.compose(withElementFeedback, editorWithGroupedValuesModel, types$1.model({}).actions(function () {
  return {
    reset: function reset() {}
  };
}).views(function (state) {
  return {
    get index() {
      try {
        return getParent(state).findIndex(function (i) {
          return i.id === state.id;
        });
      } catch (e) {
        return -1;
      }
    }
  };
}));

function getUpdatedSolutionList(_ref) {
  var solutionList = _ref.solutionList,
    responses = _ref.responses;
  return solutionList.map(function (solution) {
    return {
      isSnapshotFromUpdate: true,
      score: solution.score,
      value: getSolutionValueFromResponseList({
        solution: solution,
        responses: responses
      })
    };
  });
}
function getSolutionValueFromResponseList(_ref2) {
  var solution = _ref2.solution,
    responses = _ref2.responses;
  return responses.map(function (_ref3) {
    var id = _ref3.id;
    var solutionFound = solution.value.find(function (val) {
      return val.id === id;
    });
    return solutionFound ? getSolutionData(solutionFound) : createNewSolution(id);
  });
}
function getSolutionData(solution) {
  return {
    id: solution.id,
    values: solution.values.slice()
  };
}
function createNewSolution(id) {
  return {
    id: id,
    values: ['']
  };
}

var DEFAULT_INPUT_WIDTH = 6;

var withInputWidth = types$1.model({}).views(function (state) {
  return {
    get inputWidth() {
      if (!state.autosizeBox) return DEFAULT_INPUT_WIDTH;
      var allValues = flatten(flatten(state.validation.solutionList.map(function (s) {
        return s.values;
      })));
      var higherLength = allValues.reduce(function (acc, next) {
        return Math.max(acc, next.length);
      }, 0);
      return Math.min(higherLength, DEFAULT_INPUT_WIDTH);
    }
  };
});

function getEditorValidationModelBase(ResponseModel) {
  var EditorValidationModel = types$1.compose(withPenalty, types$1.model({
    scoring_type: types$1.optional(types$1.enumeration(Object.values(validationModes$1)), 'exactMatch'),
    solutionList: types$1.optional(types$1.array(ResponseModel), []),
    immediateFeedback: types$1.optional(types$1["boolean"], false),
    penalty: types$1.optional(types$1.number, 0)
  }).actions(function (state) {
    return {
      setSolutionList: function setSolutionList(solutionList) {
        state.solutionList = solutionList;
      },
      setScore: function setScore(val) {
        var currentVal = val || 1;
        state.mainSolution.setValue(parseInt(currentVal, 10));
      },
      setImmediateFeedback: function setImmediateFeedback(value) {
        state.immediateFeedback = value;
        if (value) state.removeAltResponses();
      },
      setScoringType: function setScoringType(val) {
        state.scoring_type = val;
      },
      setPenalty: function setPenalty(penalty) {
        state.penalty = penalty;
      },
      removeValue: function removeValue(val) {
        state.solutionList.forEach(function (res) {
          return res.removeValue(val);
        });
      },
      resetValues: function resetValues(len, empty) {
        var resetVal = new Array(len).fill(empty);
        state.solutionList.forEach(function (res) {
          res.setValue(resetVal);
        });
      },
      addValue: function addValue(val) {
        if (!state.hasValue(val)) state.mainSolution.setValue([].concat(state.value, [val]));
      },
      addNewValue: function addNewValue(val) {
        state.solutionList.forEach(function (solution) {
          return solution.addNewValue(val);
        });
      },
      createAlternativeSolution: function createAlternativeSolution(data) {
        state.solutionList = [].concat(state.solutionList, [data]);
      },
      updateSolution: function updateSolution(idx, value) {
        state.solutionList[idx].setValue(value);
      },
      findAndUpdateValue: function findAndUpdateValue(oldValue, newValue) {
        var replaceValue = function replaceValue(valueList) {
          return valueList.map(function (val) {
            return val.toString() === oldValue.toString() ? newValue : val;
          });
        };
        state.solutionList.forEach(function (solution) {
          solution.setValue(replaceValue(solution.value));
        });
      },
      updateValueIndex: function updateValueIndex(idx, newValue) {
        var replaceValue = function replaceValue(valueList) {
          return function (arr) {
            arr[idx] = newValue;
            return arr;
          }([].concat(valueList));
        };
        state.solutionList.forEach(function (solution) {
          solution.value = replaceValue(solution.value);
        });
      },
      changeScore: function changeScore(idx, score) {
        state.solutionList[idx].score = score;
      },
      removeSolution: function removeSolution(idx) {
        if (idx > 0) state.solutionList = rmItem(idx, state.solutionList);
      },
      setValue: function setValue(val) {
        state.mainSolution.setValue(val);
      },
      removeValueAt: function removeValueAt(idx) {
        state.solutionList.forEach(function (solution) {
          return solution.removeValueAt(idx);
        });
      },
      updateNotifier: function updateNotifier() {
        getParent(state).updateNotifier();
      },
      removeAltResponses: function removeAltResponses() {
        if (state.solutionList.length === 1) return false;
        while (state.solutionList.length > 1) {
          var idx = state.solutionList.length - 1;
          destroy(state.solutionList[idx]);
        }
      },
      deleteValuesDuplicate: function deleteValuesDuplicate() {
        function getValueWithoutDuplicates(value) {
          var valuesUsed = [];
          return value.map(function (item) {
            return item.filter(function (val) {
              var toRet = valuesUsed.indexOf(val) < 0;
              if (valuesUsed.indexOf(val) < 0) valuesUsed.push(val);
              return toRet;
            });
          });
        }
        state.solutionList.forEach(function (res) {
          res.setValue(getValueWithoutDuplicates(res.value));
        });
      },
      clearAllSolutions: function clearAllSolutions() {
        state.solutionList.forEach(function (solution) {
          return solution.setValue('');
        });
      },
      setAsMainSolution: function setAsMainSolution(idx) {
        if (idx === 0) return false;
        var itemToMove = detach(state.solutionList[idx]);
        state.solutionList.splice(idx, 1);
        state.solutionList.unshift(itemToMove);
        state.solutionList[0].score = 1;
        return true;
      }
    };
  }).views(function (state) {
    return {
      get alt_responses() {
        return state.solutionList.length > 1 ? state.solutionList.slice(1) : [];
      },
      get mainSolution() {
        return state.solutionList[0];
      },
      get value() {
        return state.mainSolution.value;
      },
      get score() {
        return state.mainSolution.score;
      },
      hasValue: function hasValue(val) {
        return state.value.indexOf(val) > -1;
      },
      checkValidResponse: function checkValidResponse(val) {
        return state.solutionList.reduce(function (acc, next) {
          return next.value.includes(val) || acc;
        }, false);
      },
      getSolutionPoints: function getSolutionPoints(idx) {
        if (idx >= state.solutionList.length) return 0;
        return state.solutionList[idx].score;
      },
      getSolutionPointsPercent: function getSolutionPointsPercent(idx) {
        return Math.round(this.getSolutionPoints(idx) * 100);
      },
      get freshSolution() {
        return when()["case"](typeof state.value === 'string', function () {
          return '';
        })["case"](Array.isArray(state.value) && Array.isArray(state.value[0]), function () {
          return state.value.map(function () {
            return [''];
          });
        }).resolve(function () {
          return state.value.map(function () {
            return '';
          });
        });
      },
      getAltValuesFrom: function getAltValuesFrom(idx) {
        return state.alt_responses.map(function (alt) {
          return alt.value[idx];
        });
      },
      get output() {
        return {
          scoring_type: state.scoring_type,
          immediateFeedback: state.immediateFeedback,
          alt_responses: getSnapshot(state.alt_responses),
          valid_response: {
            score: state.score,
            value: state.value
          },
          penalty: state.penalty
        };
      }
    };
  }));
  return EditorValidationModel;
}
function getEditorValidationModel(ResponseModel) {
  var EditorValidationModel = getEditorValidationModelBase(ResponseModel);
  return types$1.snapshotProcessor(EditorValidationModel, {
    preProcessor: preProcessor,
    postProcessor: postProcessor
  });
}
function preProcessor(snapshot) {
  if (!snapshot) return emptyStore;
  return _extends({}, snapshot, {
    solutionList: [snapshot.valid_response].concat(snapshot.alt_responses || [])
  });
}
function postProcessor(snapshot) {
  return omit(['solutionList'], _extends({}, snapshot, {
    valid_response: snapshot.solutionList[0],
    alt_responses: snapshot.solutionList.slice(1)
  }));
}
var emptyStore = {
  solutionList: [{
    value: '',
    score: 0
  }]
};

var ExtendedValidationModel$2 = types$1.compose(getEditorValidationModelBase(GroupedSolutionModel$1), types$1.model({}).actions(function (state) {
  return {
    createAlternativeSolution: function createAlternativeSolution(data) {
      var _state$solutionList$;
      if (state !== null && state !== void 0 && state.solutionList && (state === null || state === void 0 ? void 0 : state.solutionList.length) > 0 && state !== null && state !== void 0 && (_state$solutionList$ = state.solutionList[0]) !== null && _state$solutionList$ !== void 0 && _state$solutionList$.output2) {
        var _state$solutionList$2;
        var output2 = state === null || state === void 0 ? void 0 : (_state$solutionList$2 = state.solutionList[0]) === null || _state$solutionList$2 === void 0 ? void 0 : _state$solutionList$2.output2;
        state.solutionList = [].concat(state.solutionList, [output2]);
      } else {
        state.solutionList = [].concat(state.solutionList, [data]);
      }
    }
  };
}));
var ValidationModelExtend$2 = types$1.snapshotProcessor(ExtendedValidationModel$2, {
  preProcessor: function preProcessor$1(snapshot) {
    return preProcessor(snapshot);
  },
  postProcessor: function postProcessor$1(snapshot) {
    return postProcessor(snapshot);
  }
});
var ClozeTextEditorStore = types$1.compose(ClozeEditorStore, getClosestSolutionModel(checkResponse$4), withValidationModes, withElementFeedbackParent('responses'), withHasLemonadeKeyboard, withActiveSolution, withInputWidth, types$1.model({
  responses: types$1.optional(types$1.array(ResponseModel$2), []),
  selectedResponseID: types$1.optional(types$1.string, ''),
  input_type: types$1.optional(types$1.enumeration(['text', 'number']), 'text'),
  max_length: types$1.optional(types$1.number, -1),
  autosizeResponse: types$1.optional(types$1["boolean"], false),
  autosizeBox: types$1.optional(types$1["boolean"], false),
  normalization: types$1.optional(InputNormalizationModel, {}),
  validation: ValidationModelExtend$2,
  keyboard: types$1.optional(KeyboardStore, {})
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      state.syncValidationIds();
      reaction(function () {
        return state.validation.solutionList.length;
      }, function () {
        return state.syncValidationIds();
      });
    },
    syncValidationIds: function syncValidationIds() {
      state.validation.solutionList.forEach(function (solution) {
        return solution.value.forEach(function (value, idx) {
          return value.setId(state.responses[idx].id);
        });
      });
    },
    setAutosizeResponse: function setAutosizeResponse(autosizeResponse) {
      state.autosizeResponse = autosizeResponse;
      state.updateNotifier();
    },
    setAutosizeBox: function setAutosizeBox(autosizeBox) {
      state.autosizeBox = autosizeBox;
      state.updateNotifier();
    },
    commitResponseFeedback: function commitResponseFeedback() {
      commitFeedbackMessages({
        state: state,
        collection: state.responses,
        condition: function condition(item) {
          return item.error && item.feedback && item.isCanShowElementFeedback;
        }
      });
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot$b(rawData);
      applySnapshot(state, data);
      state.keyboard.updateFromUIStyle(data.ui_style);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    clearAllSolutions: function clearAllSolutions() {
      state.setActiveSolutionIdx(0);
      state.validation.solutionList.map(function (solution) {
        return solution.clear();
      });
    },
    updateGroupedResponses: function updateGroupedResponses(groups) {
      if (!groups) return false;
      state.validation.updateGroupedResponses(groups);
    },
    syncWithTemplate: function syncWithTemplate() {
      var solutionList = getUpdatedSolutionList({
        solutionList: state.validation.solutionList,
        responses: state.responses
      });
      state.validation.setSolutionList(solutionList);
    },
    setSelectedResponseID: function setSelectedResponseID(selectedResponseID) {
      if (selectedResponseID === void 0) {
        selectedResponseID = '';
      }
      state.selectedResponseID = selectedResponseID;
    }
  };
}).views(function (state) {
  return {
    get isEditor() {
      return true;
    },
    get templateToView() {
      return updateTemplate$1(state.template, state.responses);
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$b(rawData);
    },
    get selectedResponse() {
      return state.responses.find(function (resp) {
        return resp.id === state.selectedResponseID;
      });
    },
    get solutionsn() {
      var solution = state.validation.solutionList.map(function (solution) {
        return solution.value[0].values.toJSON();
      });
      return solution;
    },
    get output() {
      var solutions = state.validation.solutionList.map(function (solution) {
        return solution.output2;
      });
      var valid_response = solutions[0];
      var alt_responses = solutions.slice(1);
      return exportCommonValues(state, {
        template: state.template,
        feedback_responses: state.feedbackResponsesOutput,
        autosizeResponse: state.autosizeResponse,
        autosizeBox: state.autosizeBox,
        normalization: getSnapshot(state.normalization),
        validation: _extends({}, getSnapshot(state.validation), {
          valid_response: valid_response,
          alt_responses: alt_responses
        })
      });
    }
  };
}));
function createResponses$1(validResponses, feedback_responses) {
  return validResponses.map(function (validResponse, idx) {
    var _feedback_responses$i;
    return {
      id: uuid(),
      feedback: feedback_responses === null || feedback_responses === void 0 ? void 0 : (_feedback_responses$i = feedback_responses[idx]) === null || _feedback_responses$i === void 0 ? void 0 : _feedback_responses$i.feedback
    };
  });
}
function _createSnapshot$b(data) {
  var _data$data = data.data,
    response_container = _data$data.response_container,
    _data$data$normalizat = _data$data.normalization,
    normalization = _data$data$normalizat === void 0 ? {} : _data$data$normalizat,
    feedback_responses = _data$data.feedback_responses;
  var initialValidation = data.data.validation;
  var validation = produce(initialValidation, function (draft) {
    draft.valid_response.value = initialValidation.valid_response.value.map(function (value) {
      return value || '';
    });
  });
  var validResponses = validation.valid_response.value;
  var input_type = defaultValue('input_type', response_container, 'text');
  var exerciseData = _extends({}, data.data, importCommonValues$1(data), {
    responses: createResponses$1(validResponses, feedback_responses),
    input_type: input_type,
    normalization: normalization
  });
  return addDefaultKeyboard(exerciseData);
}
function checkResponse$4(solution, userResponse, state) {
  var normalize = function normalize(str) {
    return state.normalization.resolve(str);
  };
  return userResponse.length > 0 ? normalize(solution) === normalize(userResponse) : null;
}
function createStore$d(data) {
  return ClozeTextEditorStore.create(_createSnapshot$b(data));
}

var questionWithGroupedValuesModel = types$1.model({}).views(function (state) {
  var parent = getParent(state, 2);
  return {
    get allResponses() {
      var getValues = function getValues(solution) {
        return solution.value[state.index].values.slice();
      };
      return parent.validation.solutionList.reduce(function (acc, next) {
        return [].concat(acc, getValues(next));
      }, []);
    },
    get responseLength() {
      var maxResponseLength = state.allResponses.reduce(function (acc, next) {
        var nextLength = (next === null || next === void 0 ? void 0 : next.length) || 0;
        return nextLength > acc ? nextLength : acc;
      }, 0);
      var isAutosizeResponse = getParent(state, 2).autosizeResponse;
      return isAutosizeResponse ? maxResponseLength : -1;
    },
    get isValid() {
      var _parent$getCurrentSol;
      var possibleSolutions = (parent === null || parent === void 0 ? void 0 : (_parent$getCurrentSol = parent.getCurrentSolution(state.index)) === null || _parent$getCurrentSol === void 0 ? void 0 : _parent$getCurrentSol.values) || [];
      var responseValue = normalize$2(state.value, state);
      return possibleSolutions.reduce(function (acc, next) {
        return normalize$2(next, state) === responseValue ? true : acc;
      }, false);
    },
    get validate() {
      return state.solutionList.reduce(function (acc, next) {
        return normalize$2(state.value, state) === normalize$2(next, state) || acc;
      }, false);
    }
  };
});
function normalize$2(str, state) {
  return getParent(state, 2).normalization.resolve(Array.isArray(str) ? str[0] : str);
}

var ResponseQuestionModel = types$1.compose(withElementFeedback, withShowSolutionsParent, getWithFeedbackResult(normalize$3), questionWithGroupedValuesModel, types$1.model({
  id: types$1.optional(types$1.string, function () {
    return 'ab_' + uuid();
  }),
  value: types$1.optional(types$1.string, '')
}).actions(function (state) {
  var parent = getParent(state, 2);
  return {
    setValue: function setValue(value) {
      state.value = value;
      getParent(state, 2).updateNotifier(true);
    },
    destroy: function destroy() {
      getParent(state, 2).removeResponse(state);
    },
    setValidResponse: function setValidResponse(response) {
      parent.validation.setValue(response);
    },
    reset: function reset() {
      state.value = '';
    }
  };
}).views(function (state) {
  var parent = getParent(state, 2);
  return {
    get index() {
      try {
        return getParent(state).findIndex(function (i) {
          return i.id === state.id;
        });
      } catch (e) {
        return -1;
      }
    },
    get selected() {
      try {
        return state.value.length > 0;
      } catch (e) {
        return false;
      }
    },
    get isCanShowElementFeedback() {
      return isCanShowElementFeedbackParam(types.cloze.Text, state.isEmptyResponse(state.value), false);
    },
    get groupedResponses() {
      var _parent$validation, _parent$validation$gr;
      return (_parent$validation = parent.validation) === null || _parent$validation === void 0 ? void 0 : (_parent$validation$gr = _parent$validation.grouped_responses) === null || _parent$validation$gr === void 0 ? void 0 : _parent$validation$gr[state.index];
    },
    get hasGroupedResponses() {
      var _state$groupedRespons, _state$groupedRespons2;
      return ((_state$groupedRespons = state.groupedResponses) === null || _state$groupedRespons === void 0 ? void 0 : (_state$groupedRespons2 = _state$groupedRespons.group) === null || _state$groupedRespons2 === void 0 ? void 0 : _state$groupedRespons2.length) > 0;
    },
    get solutionList() {
      var solution = state.value;
      var groupedValues = state.hasGroupedResponses ? state.groupedResponses.values : [];
      return [solution].concat(groupedValues);
    }
  };
}));
function normalize$3(str, state) {
  return getParent(state, 2).normalization.resolve(Array.isArray(str) ? str[0] : str);
}

function getQuestionValidationModel(ResponseModel) {
  var QuestionValidationModel = types$1.compose(withPenalty, types$1.model({
    scoring_type: types$1.optional(types$1.enumeration(Object.values(validationModes$1)), 'exactMatch'),
    solutionList: types$1.optional(types$1.array(ResponseModel), []),
    immediateFeedback: types$1.optional(types$1["boolean"], false),
    penalty: types$1.optional(types$1.number, 0)
  }).actions(function (state) {
    return {
      setImmediateFeedback: function setImmediateFeedback(immediateFeedback) {
        state.immediateFeedback = immediateFeedback;
      },
      setPenalty: function setPenalty(penalty) {
        state.penalty = penalty;
      }
    };
  }).views(function (state) {
    return {
      get alt_responses() {
        return state.solutionList.length > 1 ? state.solutionList.slice(1) : [];
      },
      get mainSolution() {
        return state.solutionList[0];
      },
      get value() {
        return state.mainSolution.value;
      },
      get score() {
        return state.mainSolution.score;
      },
      hasValue: function hasValue(val) {
        return state.value.indexOf(val) > -1;
      },
      checkValidResponse: function checkValidResponse(val) {
        return state.solutionList.reduce(function (acc, next) {
          return next.value.includes(val) || acc;
        }, false);
      },
      getSolutionAt: function getSolutionAt(idx) {
        var _state$solutionList;
        return (_state$solutionList = state.solutionList) === null || _state$solutionList === void 0 ? void 0 : _state$solutionList[idx];
      }
    };
  }));
  return types$1.snapshotProcessor(QuestionValidationModel, {
    preProcessor: function preProcessor(snapshot) {
      if (!snapshot) return {};
      var altResponses = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.alt_responses) || [];
      return {
        scoring_type: snapshot.scoring_type,
        solutionList: [snapshot.valid_response].concat(altResponses),
        immediateFeedback: snapshot.immediateFeedback,
        penalty: snapshot.penalty
      };
    },
    postProcessor: function postProcessor(snapshot) {
      return {
        scoring_type: snapshot.scoring_type,
        immediateFeedback: snapshot.immediateFeedback,
        valid_response: snapshot.solutionList[0],
        alt_responses: snapshot.solutionList.slice(1),
        penalty: snapshot.penalty
      };
    }
  });
}

var withConfigureScorm$7 = types$1.compose(withScorm, types$1.model({}).actions(function (state) {
  return {
    updateResponseOnValidate: function updateResponseOnValidate() {
      state.scormData.interactiveList.forEach(function (interactive, key) {
        var question = state.responses.find(function (item) {
          return item.id === key;
        });
        interactive.setResult(question.isValid);
      });
    }
  };
}).views(function (state) {
  return {
    get scormType() {
      return scormTypes.FILL_IN;
    },
    getInteractiveListInitScorm: function getInteractiveListInitScorm() {
      return state.responses.map(function (item, idx) {
        return {
          userResponse: item.value,
          id: item.id,
          rightAnswer: getAlternativeTextSolutions(idx, state),
          result: item.isValid
        };
      });
    },
    updateScormItem: function updateScormItem(name, path) {
      if (path.match(/\/responses/) && name === 'setValue') {
        var item = resolvePath(state, path);
        return {
          id: item.id,
          userResponse: item.value,
          result: item.isValid
        };
      } else return null;
    }
  };
}));

var ClozeTextQuestionStore = types$1.compose(QuestionBaseModel, getClosestSolutionModel(checkResponse$5), withValidationModes, withElementFeedbackParent('responses'), withHasLemonadeKeyboard, withInputWidth, withConfigureScorm$7, withXAPITypeFillIn$1({
  xAPISolution: function xAPISolution(state) {
    return state.xAPISolution;
  }
}), types$1.model({
  template: types$1.optional(types$1.string, ''),
  responses: types$1.optional(types$1.array(ResponseQuestionModel), []),
  normalization: types$1.optional(InputNormalizationModel, {}),
  validation: getQuestionValidationModel(GroupedSolutionModel$1),
  keyboard: types$1.optional(KeyboardStore, {})
}).actions(function (state) {
  return {
    commitResponseFeedback: function commitResponseFeedback() {
      commitFeedbackMessages({
        state: state,
        collection: state.responses,
        condition: function condition(item) {
          return item.isWrong && item.feedback && item.isCanShowElementFeedback;
        }
      });
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.string), response)) return false;
      state.responses.forEach(function (resp, idx) {
        return resp.setValue(response[idx]);
      });
      return true;
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot$c(rawData);
      applySnapshot(state, data);
      state.keyboard.updateFromUIStyle(data.ui_style);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    clearAllSolutions: function clearAllSolutions() {
      state.setActiveSolutionIdx(0);
      state.validation.solutionList.map(function (solution) {
        return solution.clear();
      });
      state.validation.removeAltResponses();
    },
    clearResponses: function clearResponses() {
      state.responses.forEach(function (response) {
        return response.reset();
      });
    },
    reset: function reset() {
      state.baseReset();
      state.clearResponses();
      state.updateNotifier();
    }
  };
}).views(function (state) {
  return {
    getSolutions: function getSolutions() {
      return state.validation.value.map(function (v) {
        return v.values[0];
      });
    },
    getValidResponses: function getValidResponses() {
      return state.responses.map(function (response) {
        if (response.isValid) {
          return response.value;
        } else {
          return getSnapshot(state.solution).value[response.index];
        }
      });
    },
    get autosizeResponse() {
      return state.raw.data.autosizeResponse;
    },
    get autosizeBox() {
      return state.raw.data.autosizeBox;
    },
    get templateToView() {
      return updateTemplate$1(state.template, state.responses);
    },
    get templateToPrintMode() {
      var responses = state.responses.map(function (response) {
        return response.value;
      });
      return templateToPrintMode(state.template, responses);
    },
    getUserResponse: function getUserResponse() {
      var userResponse = state.responses.map(function (_ref) {
        var value = _ref.value;
        return value;
      });
      return state.getRealUserResponse(userResponse);
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$c(rawData);
    },
    get xAPISolution() {
      return state.validation.mainSolution.output.value;
    }
  };
}));
function _createSnapshot$c(data) {
  var _data$data = data.data,
    feedback_responses = _data$data.feedback_responses,
    _data$data$normalizat = _data$data.normalization,
    normalization = _data$data$normalizat === void 0 ? {} : _data$data$normalizat,
    validation = _data$data.validation;
  var validResponses = validation.valid_response.value;
  var exerciseData = _extends({}, data.data, importCommonValues$1(data), {
    feedback_responses: feedback_responses,
    normalization: normalization,
    responses: validResponses.map(function (_, idx) {
      var _feedback_responses$i;
      return {
        feedback: feedback_responses === null || feedback_responses === void 0 ? void 0 : (_feedback_responses$i = feedback_responses[idx]) === null || _feedback_responses$i === void 0 ? void 0 : _feedback_responses$i.feedback
      };
    })
  });
  return addDefaultKeyboard(exerciseData);
}
function checkResponse$5(solution, userResponse, state) {
  var normalize = function normalize(str) {
    return state.normalization.resolve(str);
  };
  var matchSolution = solution.values.reduce(function (acc, next) {
    return normalize(userResponse) === normalize(next) || acc;
  }, false);
  return matchSolution;
}
function createStore$e(data) {
  return ClozeTextQuestionStore.create(_createSnapshot$c(data));
}

var TemplateExerciseMarkup = function TemplateExerciseMarkup(_ref) {
  var _ref2;
  var store = _ref.store,
    typeConfig = _ref.typeConfig;
  var _useState = useState('add-blank-' + uuid()),
    idExternalButtonAddBlank = _useState[0];
  var _useState2 = useState(store.templateWithMoreData),
    contentInitial = _useState2[0],
    setContentInitial = _useState2[1];
  function isChanged() {
    var a = getInfoTemplateTagResponseSimply(store.templateWithMoreData);
    var b = getInfoTemplateTagResponseSimply(contentInitial);
    return a.blanksResponsesId.length !== b.blanksResponsesId.length;
  }
  useEffect(function () {
    if (isChanged()) {
      setContentInitial(store.templateWithMoreData);
    }
  }, [store.onUpdateNotifierUpdateTemplate]);
  var updateContent = useCallback(function (newContent, innerHTML) {
    var infoTemplateTagResponseSimply = getInfoTemplateTagResponseSimply(newContent);
    store.setTemplate(infoTemplateTagResponseSimply.template, infoTemplateTagResponseSimply.blanksResponsesId);
  }, [store]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(FroalaField$1, {
    content: contentInitial,
    setContent: updateContent,
    externalButtons: (_ref2 = {}, _ref2[EXTERNAL_BUTTONS.ADD_RESPONSE_CLOSE_MATH] = idExternalButtonAddBlank, _ref2),
    editMode: true,
    typeConfig: typeConfig,
    assetsFroalaApi: getAssetsEditorApi(store.assetsEditorApi)
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(ButtonInline, {
    classNameAdd: 'lemo-template-markup-add-blank',
    idButton: idExternalButtonAddBlank,
    text: translate('template_exercise_markup_add_blank'),
    icon: /*#__PURE__*/React__default.createElement(SvgPlusCircle, {
      className: "lemo-icon lemo-template-markup-add-blank__icon-plus"
    })
  })));
};
TemplateExerciseMarkup.propTypes = {
  typeConfig: propTypes.string
};
TemplateExerciseMarkup.defaultProps = {
  typeConfig: FROALA_FIELD_TYPE_CONFIG.MIN
};
var TemplateExerciseMarkup$1 = observer(TemplateExerciseMarkup);

var EditorTemplateMarkupClozeStore = function EditorTemplateMarkupClozeStore(_ref) {
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: 'paragraph',
    icon: /*#__PURE__*/React__default.createElement(SvgFormatListBulleted, null),
    titleBox: translate('Exercise'),
    helpText: translate('cloze_exercise_help'),
    classNameAdd: 'lemo-editor-template-markup-cloze'
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement(TemplateExerciseMarkup$1, {
    store: store,
    typeConfig: FROALA_FIELD_TYPE_CONFIG.COMPLETE
  })));
};
var EditorTemplateMarkupClozeStore$1 = observer(EditorTemplateMarkupClozeStore);

var _excluded$9 = ["store", "changed", "type", "immediateFeedback"];
var ClozeAssociationEditor = function ClozeAssociationEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$9);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setTitle|setStimulus|setValue|setScore|removeResponseByIdx|setTemplate|sortResponses|destroy|setValidResponse|addOption|setDuplicateResponses|setShuffleOptions|createAlternativeSolution|changeScore|updateSolution|removeSolution|setIsEvaluable|setBackground|setFeedback|sortOptions|setNumberDuplicates|setAutomaticDrop",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 2,
      haveFeedbackIndividual: true,
      showConfigFeedbacksIndividual: true
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 3,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(EditorTemplateMarkupClozeStore$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorAnswerOptionsStore$1, {
    store: store,
    showToggleShuffleOptions: false,
    showToggleDuplicateResponses: true,
    showNumberDuplicates: store.duplicate_responses,
    keyIdSortingList: "id",
    helpText: translate('answer_options_help')
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    helpText: translate('exact_math_or_partial_match_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: [TYPES_CONFIG.CONFIG_SUFFLE_ANSWERS, TYPES_CONFIG.CONFIG_AUTO_DROP]
  }));
};
var ClozeAssociationEditor$1 = observer(ClozeAssociationEditor);

function createOptionsFromPossibleResponses(possible_responses, possible_responses_config) {
  return possible_responses.map(function (posibleResponse, idx) {
    return {
      value: posibleResponse,
      numberDuplicates: possible_responses_config && possible_responses_config.length > idx && possible_responses_config[idx] && possible_responses_config[idx].number_duplicates ? possible_responses_config[idx].number_duplicates : 1
    };
  });
}

var withNumberDuplicates = types$1.model({
  numberDuplicates: types$1.optional(types$1.number, 1)
}).actions(function (state) {
  return {
    setNumberDuplicates: function setNumberDuplicates(numberDuplicates) {
      state.numberDuplicates = numberDuplicates;
      if (state.parent) state.parent.updateNotifier();
    }
  };
}).views(function (state) {
  return {
    get parent() {
      return !isRoot(state) ? getParent(state, 2) : null;
    },
    exportToPossibleResponsesConfig: function exportToPossibleResponsesConfig(duplicateResponseEnabled) {
      return {
        number_duplicates: duplicateResponseEnabled ? state.numberDuplicates : 1
      };
    }
  };
});

var DragModel$1 = types$1.compose(ValueModel, withNumberDuplicates, types$1.model({
  target: types$1.optional(types$1.string, '')
}).actions(function (state) {
  return {
    setTarget: function setTarget(target) {
      state.target = target;
      getParent(state, 2).updateNotifier();
    },
    setValue: function setValue(value) {
      if (!isAlive(state)) return false;
      getParent(state, 2).validation.findAndUpdateValue(state.value, value);
      state.value = value;
    }
  };
}).views(function (state) {
  return {
    get dropTarget() {
      return state.target ? getParent(state, 2).responses.find(function (drop) {
        return drop.id === state.target;
      }) : false;
    },
    get dropped() {
      return !!state.dropTarget && state.dropTarget.value === state.value;
    },
    get visible() {
      var parent = getParent(state, 2);
      return (!state.dropped || parent.duplicate_responses) && !parent.showSolution;
    }
  };
}));

var feedback$1 = {
  NOT_EVALUATED: 'NOT_EVALUATED',
  RIGHT: 'RIGHT',
  WRONG: 'WRONG'
};

var ResponseModel$3 = types$1.compose(ValueModel, withIsDraggingOver, withElementFeedback, types$1.model({
  validResponse: types$1.optional(types$1.string, ''),
  validAlternatives: types$1.optional(ValidAlternatives, {
    responses: []
  })
}).actions(function (state) {
  return {
    setValue: function setValue(value) {
      var parent = getParent(state, 2);
      parent.setImmediateResponse({
        itemRef: state.id,
        value: value === parent.validation.value[state.index]
      });
      state.value = value;
    },
    setValidResponse: function setValidResponse(value) {
      state.validResponse = value;
    },
    reset: function reset() {
      state.value = '';
    }
  };
}).views(function (state) {
  return {
    get validate() {
      var parent = getParent(state, 2);
      return parent.validation.value[state.index] === state.value;
    },
    get isValid() {
      var parent = getParent(state, 2);
      var currentResponse = parent.getCurrentSolution(state.index);
      return currentResponse === state.value;
    },
    get feedbackResult() {
      try {
        var parent = getParent(state, 2);
        var evaluationReady = parent.isEvaluated || parent.validation.immediateFeedback && state.value.length > 0;
        return when()["case"](!evaluationReady, function () {
          return feedback$1.NOT_EVALUATED;
        })["case"](!parent.isEvaluable, function () {
          return feedback$1.NOT_EVALUATED;
        })["case"](state.isValid, function () {
          return feedback$1.RIGHT;
        })["case"](!state.isValid, function () {
          return feedback$1.WRONG;
        }).resolve();
      } catch (e) {
        return feedback$1.NOT_EVALUATED;
      }
    },
    get parent() {
      return getRoot(state);
    },
    get isDisabled() {
      var parent = getRoot(state);
      return parent.disabled || parent.isEvaluated;
    },
    get success() {
      try {
        return getParent(state, 2).isEvaluated && state.isValid;
      } catch (e) {
        return false;
      }
    },
    get error() {
      try {
        return getParent(state, 2).isEvaluated && !state.isValid;
      } catch (e) {
        return false;
      }
    },
    get selected() {
      try {
        return state.value.length > 0 && getParent(state, 2).isEvaluable;
      } catch (e) {
        return false;
      }
    },
    get lock() {
      try {
        return getParent(state, 2).isEvaluated;
      } catch (e) {
        return false;
      }
    }
  };
}));

var withAutomaticDrop = types$1.model({
  automatic_drop: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    setAutomaticDrop: function setAutomaticDrop(value) {
      getParent(state).updateNotifier();
      state.automatic_drop = value;
    }
  };
});

var UIStyle = types$1.compose(BaseModel$1, withAutomaticDrop);

var ResponseItem$2 = createResponseItem('responses');
var ClozeAssociationEditorStore = types$1.compose(ClozeEditorStore, withWhileDraggingTarget, withElementFeedbackParent('responses'), types$1.model({
  responses: types$1.optional(types$1.array(ResponseModel$3), []),
  options: types$1.array(DragModel$1),
  duplicate_responses: types$1.optional(types$1["boolean"], true),
  shuffle_options: types$1.optional(types$1["boolean"], true),
  optionsOrder: types$1.optional(types$1.array(types$1.number), []),
  onUpdateNotifier: types$1.optional(types$1.number, function () {
    return Date.now();
  }),
  selectedItem: types$1.optional(types$1.string, ''),
  responseList: types$1.optional(types$1.array(ResponseItem$2), []),
  ui_style: types$1.optional(UIStyle, {})
}).actions(function (state) {
  function getNumberDuplicatesDefault() {
    return state.responses.length + 1;
  }
  return {
    afterCreate: function afterCreate() {
      onAction(state, function (_ref) {
        var name = _ref.name,
          path = _ref.path;
        if (name.match(/setValue/)) {
          state.updateNotifier();
        }
        if (path === '/validation' && name.match(/updateSolution|setValue/)) {
          state.updateResponsesFromValidation();
        }
      });
      onSnapshot(state, function (s) {
        if (s.options.length !== state.optionsOrder.length) {
          state.updateOptionsOrder();
        }
      });
      state.updateOptionsOrder();
    },
    updateValidation: function updateValidation(indexList) {
      var solutionSnapshot = state.validation.value;
      state.validation.setValue(indexList.map(function (index) {
        return index !== undefined ? solutionSnapshot[index] : '';
      }));
    },
    updateAlternatives: function updateAlternatives(indexList) {
      var getSolutionSnapshot = function getSolutionSnapshot(idx) {
        if (state.validation.alt_responses.length < idx) {
          return indexList.map(function (x) {
            return '';
          });
        }
        return state.validation.alt_responses[idx].value;
      };
      state.validation.alt_responses.forEach(function (alt, idx) {
        var solution = getSolutionSnapshot(idx);
        var newValue = indexList.map(function (index) {
          return index !== undefined ? solution[index] : '';
        });
        alt.setValue(newValue);
      });
    },
    updateResponsesFromValidation: function updateResponsesFromValidation() {},
    matchResponse: function matchResponse(responseId, option) {
      var response = state.getResponseById(responseId);
      response.setValue(option.value);
      option.setTarget(response.id);
    },
    setShuffleOptions: function setShuffleOptions(bool) {
      state.shuffle_options = bool;
    },
    updateOptionsOrder: function updateOptionsOrder() {
      state.optionsOrder = function (idxArr) {
        return state.shuffle_options ? shuffle(idxArr) : idxArr;
      }(state.options.map(function (_, idx) {
        return idx;
      }));
    },
    setDuplicateResponses: function setDuplicateResponses(bool) {
      state.options.forEach(function (option) {
        return option.setNumberDuplicates(bool ? getNumberDuplicatesDefault() : 1);
      });
      state.duplicate_responses = bool;
      state.updateNotifier();
    },
    addOption: function addOption() {
      var indexLabel = state.options ? state.options.length + 1 : '';
      state.options.push({
        value: "<p>" + translate('option') + " " + indexLabel + "</p>",
        numberDuplicates: getNumberDuplicatesDefault()
      });
      state.updateNotifier();
    },
    setOption: function setOption(option) {
      state.options.push({
        value: option
      });
    },
    removeOption: function removeOption(option) {
      destroy(option);
      state.updateNotifier();
    },
    removeValue: function removeValue(option) {
      destroy(option);
      state.updateNotifier();
    },
    removeResponseByIdx: function removeResponseByIdx(idx) {
      state.removOption(state.options[idx]);
    },
    sortOptions: function sortOptions(source, destination) {
      state.options = sortArrayItem(source, destination, state.options);
      state.updateNotifier();
    },
    setImmediateResponse: function setImmediateResponse(response) {
      state.isEvaluable && state.responseList.push(response);
    }
  };
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$d(rawData);
    },
    get currentResponse() {
      return state.selectedItem && state.responses.find(function (res) {
        return res.id === state.selectedItem;
      });
    },
    getResponseById: function getResponseById(id) {
      return state.responses.find(function (response) {
        return response.id === id;
      });
    },
    get output() {
      return exportCommonValues(state, {
        template: state.template,
        possible_responses: state.options.map(function (o) {
          return o.value;
        }),
        possible_responses_config: state.options.map(function (o) {
          return o.exportToPossibleResponsesConfig(state.duplicate_responses);
        }),
        shuffle_options: state.shuffle_options,
        duplicate_responses: state.duplicate_responses,
        feedback_responses: state.feedbackResponsesOutput
      });
    }
  };
}));
function createResponses$2(validResponses, altResponses, feedback_responses) {
  return validResponses.map(function (validResponse, idx) {
    var _feedback_responses$i;
    return {
      value: '',
      validResponse: validResponse,
      validAlternatives: createSnapshot(idx, altResponses, ['']),
      feedback: feedback_responses === null || feedback_responses === void 0 ? void 0 : (_feedback_responses$i = feedback_responses[idx]) === null || _feedback_responses$i === void 0 ? void 0 : _feedback_responses$i.feedback
    };
  });
}
function _createSnapshot$d(data) {
  var _data$data = data.data,
    possible_responses = _data$data.possible_responses,
    possible_responses_config = _data$data.possible_responses_config,
    rawValidation = _data$data.validation,
    feedback_responses = _data$data.feedback_responses;
  var validation = produce(rawValidation, function (draft) {
    draft.valid_response.value = rawValidation.valid_response.value.map(function (v) {
      return v || '';
    });
  });
  var altResponses = defaultValue('alt_responses', validation, []);
  var validResponses = validation.valid_response.value;
  return _extends({}, data.data, importCommonValues$1(data), {
    responses: createResponses$2(validResponses, altResponses, feedback_responses),
    options: createOptionsFromPossibleResponses(possible_responses, possible_responses_config)
  });
}
function createStore$f(data) {
  var store = ClozeAssociationEditorStore.create(_createSnapshot$d(data));
  return store;
}

var Accordion = function Accordion(_ref) {
  var title = _ref.title,
    isOpenInit = _ref.isOpenInit,
    startControls = _ref.startControls,
    children = _ref.children;
  var _useState = useState(isOpenInit),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  function onClickTitle() {
    setIsOpen(!isOpen);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-accordion"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-accordion__head-wrapper"
  }, startControls, /*#__PURE__*/React__default.createElement("div", {
    className: 'lemo-accordion__head' + (isOpen ? ' lemo-accordion__head--open' : ''),
    onClick: onClickTitle
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-accordion__head-title"
  }, title), /*#__PURE__*/React__default.createElement("div", {
    className: 'lemo-accordion__head-icon' + (isOpen ? ' lemo-accordion__head-icon--open' : '')
  }, /*#__PURE__*/React__default.createElement(SvgChevronDown, null)))), isOpen && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-accordion__children"
  }, children));
};
Accordion.propTypes = {
  title: propTypes.string,
  open: propTypes.bool,
  children: propTypes.node
};
Accordion.defaultProps = {
  isOpenInit: false
};
var Accordion$1 = observer(Accordion);

var EditorDropDownResponseItem = function EditorDropDownResponseItem(_ref) {
  var item = _ref.item,
    dragProvider = _ref.dragProvider;
  var draggableProps = dragProvider.draggableProps,
    dragHandleProps = dragProvider.dragHandleProps,
    innerRef = dragProvider.innerRef;
  var removeResponse = useCallback(function () {
    return item.destroy();
  }, [item]);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: "lemo-cloze-editor-wrapper"
  }, draggableProps, {
    ref: innerRef
  }), /*#__PURE__*/React__default.createElement("div", dragHandleProps, /*#__PURE__*/React__default.createElement(SvgDrag, {
    className: "lemo-cloze-editor-drag-indicator"
  })), /*#__PURE__*/React__default.createElement("input", {
    className: "lemo-cloze-editor-input lemo-base-input",
    placeholder: translate('Type something'),
    value: item.value,
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      item.setValue(value);
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-icon-button"
  }, /*#__PURE__*/React__default.createElement(SvgTrash$1, {
    onClick: removeResponse
  })));
};
var EditorDropDownResponseItem$1 = observer(EditorDropDownResponseItem);

var DuplicateControls = observer(function (_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-duplicate-controls lemo-start-controls",
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(SvgDocumentDuplicate, {
    className: "lemo-icon",
    width: 24
  }));
});

var EditorResponseInput = function EditorResponseInput(_ref) {
  var response = _ref.response,
    title = _ref.title,
    isOpenInit = _ref.isOpenInit,
    duplicateDropDown = _ref.duplicateDropDown,
    _ref$withAccordion = _ref.withAccordion,
    withAccordion = _ref$withAccordion === void 0 ? false : _ref$withAccordion;
  var componentResponse = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(EditorSortingList$1, {
    list: response.valueList,
    keyId: "id",
    onDragEnd: response.sortValues
  }, function (itemList, provider) {
    return /*#__PURE__*/React__default.createElement(EditorDropDownResponseItem$1, {
      item: itemList,
      dragProvider: provider
    });
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-horizontal-content",
    style: {
      marginLeft: 10
    }
  }, /*#__PURE__*/React__default.createElement(ButtonInline, {
    onClick: response.addNewValue,
    text: translate('add_new_response'),
    icon: /*#__PURE__*/React__default.createElement(SvgPlusCircle, {
      className: "lemo-icon lemo-editor-response-input__icon-plus"
    })
  })));
  return withAccordion ? /*#__PURE__*/React__default.createElement(Accordion$1, {
    title: title,
    isOpenInit: isOpenInit,
    startControls: duplicateDropDown && /*#__PURE__*/React__default.createElement(DuplicateControls, {
      onClick: duplicateDropDown
    })
  }, componentResponse) : /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-cloze-editor-box",
    key: response.id
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-horizontal-content lemo-cloze-editor-space-between"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-text"
  }, title), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-icon-button"
  }, /*#__PURE__*/React__default.createElement(SvgTrash$1, {
    onClick: response.destroy
  }))), componentResponse);
};
EditorResponseInput.propTypes = {};
EditorResponseInput.defaultProps = {
  isOpenInit: false
};
var EditorResponseInput$1 = observer(EditorResponseInput);

var EditorAnswerOptionsMultiple = function EditorAnswerOptionsMultiple(_ref) {
  var responses = _ref.responses,
    withAccordion = _ref.withAccordion,
    icon = _ref.icon,
    titleBox = _ref.titleBox,
    helpText = _ref.helpText,
    openFirstAccordionStart = _ref.openFirstAccordionStart,
    duplicateDropDown = _ref.duplicateDropDown,
    componentTop = _ref.componentTop;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "options",
    icon: icon,
    titleBox: titleBox || translate('answer_options'),
    helpText: helpText,
    classNameAdd: "lemo-editor-answer-options-multiple"
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, componentTop, responses.map(function (response, idx) {
    return /*#__PURE__*/React__default.createElement(EditorResponseInput$1, {
      key: response.id,
      response: response,
      title: translate('response') + " " + (idx + 1),
      withAccordion: withAccordion,
      isOpenInit: openFirstAccordionStart && idx === 0,
      duplicateDropDown: duplicateDropDown ? function () {
        return duplicateDropDown(response);
      } : null
    });
  })));
};
EditorAnswerOptionsMultiple.propTypes = {
  responses: propTypes.any,
  icon: propTypes.node,
  withAccordion: propTypes.bool,
  titleBox: propTypes.string,
  helpText: propTypes.string,
  openFirstAccordionStart: propTypes.bool,
  componentTop: propTypes.node
};
EditorAnswerOptionsMultiple.defaultProps = {
  responses: [],
  icon: /*#__PURE__*/React__default.createElement(SvgFormatListBulleted, null),
  withAccordion: false,
  openFirstAccordionStart: false,
  helpText: null
};
var EditorAnswerOptionsMultiple$1 = observer(EditorAnswerOptionsMultiple);

var EditorExerciseClozeDropDownStore = function EditorExerciseClozeDropDownStore(_ref) {
  var store = _ref.store,
    duplicateDropDown = _ref.duplicateDropDown;
  return /*#__PURE__*/React__default.createElement(EditorAnswerOptionsMultiple$1, {
    responses: store.responses,
    withAccordion: true,
    openFirstAccordionStart: true,
    icon: /*#__PURE__*/React__default.createElement(SvgFormatListBulleted, null),
    titleBox: translate('Exercise'),
    helpText: translate('cloze_dropdown_exercise_help'),
    duplicateDropDown: duplicateDropDown,
    componentTop: /*#__PURE__*/React__default.createElement(TemplateExerciseMarkup$1, {
      store: store,
      typeConfig: FROALA_FIELD_TYPE_CONFIG.COMPLETE
    })
  });
};
EditorExerciseClozeDropDownStore.propTypes = {
  store: propTypes.any
};
var EditorExerciseClozeDropDownStore$1 = observer(EditorExerciseClozeDropDownStore);

var _excluded$a = ["store", "changed", "type", "immediateFeedback"];
var ClozeDropDownEditor = function ClozeDropDownEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$a);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setTitle|setStimulus|setValue|setScore|removeResponseByIdx|setTemplate|sortResponses|destroy|setValidResponse|createAlternativeSolution|changeScore|updateSolution|removeSolution|setIsEvaluable|setBackground|addNewValue|setIsEvaluable|sortValues|duplicateDropdown",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 1,
      haveFeedbackIndividual: true,
      showConfigFeedbacksIndividual: true
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 2,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(EditorExerciseClozeDropDownStore$1, {
    store: store,
    duplicateDropDown: store.duplicateDropdown
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    showToggleIsEvaluable: true,
    helpText: translate('exact_math_or_partial_match_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: []
  }));
};
var ClozeDropDownEditor$1 = observer(ClozeDropDownEditor);

var PopoverWrapper = function PopoverWrapper(_ref) {
  var targetElement = _ref.targetElement,
    children = _ref.children,
    _ref$onClickOutside = _ref.onClickOutside,
    onClickOutside = _ref$onClickOutside === void 0 ? noop : _ref$onClickOutside,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'auto' : _ref$position;
  var _useState = useState(null),
    popperElement = _useState[0],
    setPopperElement = _useState[1];
  var _usePopper = usePopper(targetElement, popperElement, getPopoverConfig$1(position)),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes;
  useOnClickOutside({
    current: popperElement
  }, onClickOutside);
  var isPopperVisible = !targetElement && {
    display: 'none'
  };
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: "popover-wrapper",
    ref: setPopperElement,
    style: _extends({}, styles.popper, isPopperVisible)
  }, attributes.popper), children);
};
function getPopoverConfig$1(position) {
  return {
    placement: position,
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 16]
      }
    }, {
      name: 'preventOverflow',
      options: {
        padding: {
          top: 5,
          bottom: 5,
          left: 70,
          right: 5
        }
      }
    }]
  };
}
var PopoverWrapper$1 = observer(PopoverWrapper);

function GroupedResponseItem(_ref) {
  var id = _ref.id,
    solution = _ref.solution,
    handleChange = _ref.handleChange,
    handleRemove = _ref.handleRemove,
    removeDisabled = _ref.removeDisabled,
    keyboardStore = _ref.keyboardStore;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-grouped-response-item",
    "data-testid": "groupedResponseItem"
  }, /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: keyboardStore.type.length > 0
  }, /*#__PURE__*/React__default.createElement(InputKeyboard$2, {
    id: id,
    value: solution,
    setValue: handleChange,
    keyboardType: keyboardStore.type,
    selectedInput: keyboardStore.activeFieldId,
    showSuccess: false,
    showError: false,
    maxLength: -1,
    onFinish: keyboardStore.finish,
    onStart: keyboardStore.start,
    onWrite: keyboardStore.setValue,
    isFloating: true,
    autoSize: false
  })), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: keyboardStore.type.length === 0
  }, /*#__PURE__*/React__default.createElement(EditorInputText$1, {
    value: solution,
    onChange: function onChange(e) {
      return handleChange(e.target.value);
    },
    placeholder: translate('alternative_response')
  })), /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-delete-icon",
    onClick: handleRemove,
    disabled: removeDisabled,
    role: "button"
  }, /*#__PURE__*/React__default.createElement(SvgTrash$1, null)));
}
var GroupedResponseItem$1 = observer(GroupedResponseItem);

function GroupedResponsePanel(_ref) {
  var response = _ref.response,
    keyboardStore = _ref.keyboardStore;
  var panel = useRef();
  var responseLength = response.solutionList.length;
  function _handleRemove(idx) {
    response.removeSolutionAt(idx);
  }
  function _handleChange(idx, value) {
    response.editSolutionAt(idx, value);
  }
  function handleAddResponse() {
    response.activeSolution.addGroupedSolutionAt(response.index);
  }
  function getResponseId(idx) {
    return response.id + "__" + idx;
  }
  return /*#__PURE__*/React__default.createElement("div", {
    ref: panel,
    className: "lemo-grouped-response-panel",
    "data-testid": "groupedResponsePanel"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-grouped-response-panel__header"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-text lemo-base-block-editor__title"
  }, translate('alternative_responses'), " (", responseLength, ")"), /*#__PURE__*/React__default.createElement(AddAlternativeResponseButton$1, {
    onClick: handleAddResponse
  })), /*#__PURE__*/React__default.createElement("hr", {
    className: "lemo-hline"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-response-list"
  }, response.solutionList.map(function (solution, idx) {
    var id = getResponseId(idx);
    return /*#__PURE__*/React__default.createElement(GroupedResponseItem$1, {
      key: id,
      id: id,
      solution: solution,
      handleChange: function handleChange(value) {
        return _handleChange(idx, value);
      },
      handleRemove: function handleRemove() {
        return _handleRemove(idx);
      },
      removeDisabled: responseLength < 2,
      keyboardStore: keyboardStore
    });
  })));
}
var GroupedResponsePanel$1 = observer(GroupedResponsePanel);

var EditorTextSolutions = function EditorTextSolutions(_ref) {
  var store = _ref.store,
    showToggleIsEvaluable = _ref.showToggleIsEvaluable,
    withPenaltyByResponse = _ref.withPenaltyByResponse,
    showPenalty = _ref.showPenalty,
    evaluationTypes = _ref.evaluationTypes,
    subtitleEvaluationType = _ref.subtitleEvaluationType,
    showSolutions = _ref.showSolutions,
    _ref$helpText = _ref.helpText,
    helpText = _ref$helpText === void 0 ? translate('solutions_instructions') : _ref$helpText,
    SolutionEditorComponent = _ref.SolutionEditorComponent,
    componentButton = _ref.componentButton;
  var _usePartialEvaluation = usePartialEvaluationDropdown({
      store: store,
      showPenalty: showPenalty,
      withPenaltyByResponse: withPenaltyByResponse
    }),
    showPenaltyOptions = _usePartialEvaluation.showPenaltyOptions,
    showPenaltyValue = _usePartialEvaluation.showPenaltyValue;
  var filteredEvaluationTypes = useFilterEvaluationTypes({
    layout: store.raw.metadata.layout,
    evaluationTypes: evaluationTypes
  });
  var getPopoverTarget = function getPopoverTarget() {
    return document.getElementById("wrapper__" + store.selectedResponse.id);
  };
  function closePanel() {
    var _store$keyboard;
    if (store !== null && store !== void 0 && (_store$keyboard = store.keyboard) !== null && _store$keyboard !== void 0 && _store$keyboard.activeFieldId) return false;
    store.selectedResponse.clearEmptyResponses();
    store.setSelectedResponseID(undefined);
  }
  function addAlternativeResponse(response) {
    store.setSelectedResponseID(response.id);
  }
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "solutions",
    icon: /*#__PURE__*/React__default.createElement(SvgFormatListBulleted, null),
    titleBox: translate('solutions'),
    helpText: helpText,
    classNameAdd: 'lemo-editor-responses'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-horizontal-content-box"
  }, showToggleIsEvaluable && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-solutions__toggle-container"
  }, /*#__PURE__*/React__default.createElement(EvaluationType, {
    evaluationType: store.evaluationType,
    evaluationTypes: filteredEvaluationTypes,
    onChange: store.setEvaluationType,
    subtitle: subtitleEvaluationType
  })), showPenaltyOptions && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-solutions__penalty-modes-container"
  }, /*#__PURE__*/React__default.createElement(PenaltyModes$1, {
    value: store.validation.penalty_mode,
    onChange: store.validation.setPenaltyMode
  })), showPenaltyValue && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-solutions__custom-penalty-value-container"
  }, /*#__PURE__*/React__default.createElement(EditorSliderTitleSubtitle, {
    title: translate('solutions_penalty_title'),
    subtitle: translate('solutions_penalty_subtitle'),
    limitMin: 0,
    limitMax: 100,
    showLimitMin: false,
    max: store.validation.penalty * 100,
    onChangeMax: function onChangeMax(max) {
      return store.validation.setPenalty(max / 100);
    },
    decimals: 0,
    stringConcatValues: "%"
  })), showSolutions && /*#__PURE__*/React__default.createElement(Solutions$1, {
    store: store
  }, /*#__PURE__*/React__default.createElement(SolutionEditorComponent, {
    store: store,
    addAlternativeResponse: addAlternativeResponse
  })), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: store.hasLemonadeKeyboard
  }, /*#__PURE__*/React__default.createElement(LemonadeKeyboard$1, {
    type: store.keyboard.type,
    keyboardStore: store.keyboard,
    isActive: store.keyboard.isActive,
    tabList: store.responses.map(function (_ref2) {
      var id = _ref2.id;
      return id;
    }),
    forceFloating: true,
    testFloating: false
  })), store.selectedResponse && /*#__PURE__*/React__default.createElement(PopoverWrapper$1, {
    targetElement: getPopoverTarget(),
    position: 'bottom-start',
    onClickOutside: closePanel
  }, /*#__PURE__*/React__default.createElement(GroupedResponsePanel$1, {
    response: store.selectedResponse,
    keyboardStore: store.keyboard
  })), componentButton));
};
EditorTextSolutions.propTypes = {
  store: propTypes.any,
  showToggleIsEvaluable: propTypes.bool,
  showPenalty: propTypes.bool,
  evaluationTypes: EvaluationType.propTypes.evaluationTypes,
  subtitleEvaluationType: EvaluationType.propTypes.subtitle,
  showSolutions: propTypes.bool,
  SolutionEditorComponent: propTypes.elementType
};
EditorTextSolutions.defaultProps = {
  showToggleAutosizeResponse: false,
  showToggleIsEvaluable: true,
  showPenalty: true,
  evaluationTypes: [getEvaluationTypeOption(keysTranslateEvaluationTypes.EXACT_MATCH, keysTranslateSubtitleEvaluationTypes.EXACT_MATCH, validationModes.EXACT_MATCH), getEvaluationTypeOption(keysTranslateEvaluationTypes.PARTIAL_MATCH, keysTranslateSubtitleEvaluationTypes.PARTIAL_MATCH, validationModes.PARTIAL_MATCH_V2), getEvaluationTypeOption(keysTranslateEvaluationTypes.MANUAL, keysTranslateSubtitleEvaluationTypes.MANUAL, validationModes.MANUAL)],
  showSolutions: true
};
var EditorTextSolutions$1 = observer(EditorTextSolutions);

function QuestionTemplate$2(_ref) {
  var _store$keyboard;
  var store = _ref.store,
    children = _ref.children,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? autoFocusTypes.NONE : _ref$autoFocus;
  var node = useRef(null);
  var updateBlanks = useCallback(function () {
    if (node.current) {
      var nodes = node.current.querySelectorAll('.lemo-blank');
      nodes.forEach(function (element, idx) {
        var item = store.responses[idx];
        if (!(item !== null && item !== void 0 && item.id)) return null;
        element.dataset.responseid = item === null || item === void 0 ? void 0 : item.id;
        render( /*#__PURE__*/React__default.createElement(Observer, null, function () {
          return /*#__PURE__*/React__default.createElement(children.type, _extends({
            key: item.index,
            response: item,
            disabled: store.disabled,
            autoFocus: autoFocus === autoFocusTypes.ENABLED && idx === 0 && !store.isEvaluated ? autoFocus : autoFocusTypes.NONE
          }, children.props));
        }), element);
      });
    }
  }, [node, store, children, autoFocus]);
  useEffect(function () {
    var timeout = setTimeout(updateBlanks, 100);
    return function () {
      return clearTimeout(timeout);
    };
  }, [store.templateToView, store === null || store === void 0 ? void 0 : (_store$keyboard = store.keyboard) === null || _store$keyboard === void 0 ? void 0 : _store$keyboard.type, store.onUpdateNotifier]);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    innerRef: node,
    className: "lemo-cloze-question-template lemo-text-body-m-regular ",
    content: store.templateToView
  }));
}
var QuestionTemplate$3 = observer(QuestionTemplate$2);

function ClozeTextSolutionEditor(_ref) {
  var store = _ref.store,
    addAlternativeResponse = _ref.addAlternativeResponse;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-body"
  }, /*#__PURE__*/React__default.createElement(QuestionTemplate$3, {
    store: store
  }, /*#__PURE__*/React__default.createElement(Blank$1, {
    store: store,
    solutionsMode: true,
    keyboardStore: store.hasLemonadeKeyboard,
    onAddAlternativeResponse: addAlternativeResponse
  })));
}
var ClozeTextSolutionEditor$1 = observer(ClozeTextSolutionEditor);

var ErrorBoundary = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ErrorBoundary, _Component);
  function ErrorBoundary(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.state = {
      hasError: false
    };
    return _this;
  }
  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
    return {
      hasError: true
    };
  };
  var _proto = ErrorBoundary.prototype;
  _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
  };
  _proto.render = function render() {
    if (this.state.hasError) {
      console.log('Something went wrong');
    }
    return this.props.children;
  };
  return ErrorBoundary;
}(Component);

var _excluded$b = ["store", "changed", "type", "immediateFeedback"];
var ShortTextEditor$2 = function ShortTextEditor(props) {
  var _ref, _ref2;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$b);
  return /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setTitle|setStimulus|setValue|setScore|removeResponseByIdx|setTemplate|sortResponses|destroy|setValidResponse|createAlternativeSolution|changeScore|updateSolution|removeSolution|setIsEvaluable|setAutosizeResponse|toggleLower|toggleAccents|toggleSpaces|setBackground|toggleIsMath|setAutosizeBox|editSolutionAt",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 1,
      haveFeedbackIndividual: true,
      showConfigFeedbacksIndividual: true
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 2,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(EditorTemplateMarkupClozeStore$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorTextSolutions$1, {
    store: store,
    showToggleAutosizeResponse: false,
    SolutionEditorComponent: ClozeTextSolutionEditor$1,
    withPenaltyByResponse: false,
    helpText: translate('exact_math_or_partial_match_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: [TYPES_CONFIG.CONFIG_ACCENT_SENSITIVE, TYPES_CONFIG.CONFIG_CASE_SENSITIVE, TYPES_CONFIG.CONFIG_FIX_SPACES, TYPES_CONFIG.CONFIG_AUTOSIZE_RESPONSE, TYPES_CONFIG.CONFIG_AUTOSIZE_BOX, TYPES_CONFIG.CONFIG_NUMBER_KEYBOARD, TYPES_CONFIG.CONFIG_FIXED_KEYBOARD],
    listConfigParams: (_ref2 = {}, _ref2[TYPES_CONFIG.CONFIG_NUMBER_KEYBOARD] = {
      keyboardList: [{
        value: keyboards.none
      }, {
        value: keyboards.numerical
      }, {
        value: keyboards.basic
      }, {
        value: keyboards.roman
      }]
    }, _ref2)
  })));
};
var ClozeTextEditor = observer(ShortTextEditor$2);

function PrintViewGeneric$2(_ref) {
  var store = _ref.store,
    response = _ref.response,
    isEvaluated = _ref.isEvaluated,
    isSolved = _ref.isSolved,
    _ref$onComplete = _ref.onComplete,
    onComplete = _ref$onComplete === void 0 ? noop : _ref$onComplete;
  var root = useRef();
  var _usePrintView = usePrintView({
      store: store,
      root: root,
      onComplete: onComplete,
      response: response,
      isEvaluated: isEvaluated,
      isSolved: isSolved,
      onQuestionReady: function onQuestionReady() {
        return Promise.resolve();
      }
    }),
    activity = _usePrintView.activity;
  return activity !== null ? /*#__PURE__*/React__default.createElement("div", {
    key: isSolved ? 'solved' : 'notSolved',
    ref: root,
    className: "lemo-print-view"
  }, /*#__PURE__*/React__default.createElement(activity.Question, null)) : null;
}
var PrintViewClozeText = observer(PrintViewGeneric$2);

function DropdownTable(_ref) {
  var possibleResponses = _ref.possibleResponses,
    tableIdx = _ref.tableIdx;
  var columnData = getColumnData(possibleResponses);
  var styles = {
    textAlign: 'center',
    border: '1px solid lightgrey',
    padding: '5px 0'
  };
  return /*#__PURE__*/React__default.createElement("table", {
    width: "100%",
    style: {
      fontSize: 14
    }
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      borderCollapse: 'collapse'
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, possibleResponses.map(function (_, idx) {
    return /*#__PURE__*/React__default.createElement("th", {
      key: "header_" + idx,
      style: styles
    }, translate('option') + " " + (tableIdx + idx + 1));
  }))), /*#__PURE__*/React__default.createElement("tbody", null, columnData.map(function (column, columnIdx) {
    return /*#__PURE__*/React__default.createElement("tr", {
      key: "column_" + columnIdx
    }, column.map(function (value, valueIdx) {
      return /*#__PURE__*/React__default.createElement("td", {
        key: "value_" + columnIdx + "_" + valueIdx,
        style: styles
      }, value);
    }));
  })));
}
function getColumnData(data) {
  var maxLength = data.reduce(function (acc, next) {
    return Math.max(acc, next.length);
  }, 0);
  var result = [];
  for (var i = 0; i < maxLength; i++) {
    result[i] = [];
    for (var j = 0; j < data.length; j++) {
      var currentItem = data[j];
      result[i][j] = currentItem.length <= i ? '' : currentItem[i];
    }
  }
  return result;
}

var tableLength = 4;
function RenderTables(_ref) {
  var possibleResponses = _ref.possibleResponses;
  var tableList = splitAt(possibleResponses, tableLength);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, tableList.map(function (table, idx) {
    return /*#__PURE__*/React__default.createElement(DropdownTable, {
      key: "table_" + idx,
      possibleResponses: table,
      tableIdx: tableLength * idx
    });
  }));
}

function PrintViewGeneric$3(_ref) {
  var store = _ref.store,
    response = _ref.response,
    isEvaluated = _ref.isEvaluated,
    isSolved = _ref.isSolved,
    _ref$onComplete = _ref.onComplete,
    onComplete = _ref$onComplete === void 0 ? noop : _ref$onComplete;
  var root = useRef();
  var _usePrintView = usePrintView({
      store: store,
      root: root,
      onComplete: onComplete,
      response: response,
      isEvaluated: isEvaluated,
      isSolved: isSolved,
      onQuestionReady: function onQuestionReady() {
        return Promise.resolve();
      }
    }),
    activity = _usePrintView.activity;
  var possibleResponses = store.raw.data.possible_responses;
  return activity !== null ? /*#__PURE__*/React__default.createElement("div", {
    key: isSolved ? 'solved' : 'notSolved',
    ref: root,
    className: "lemo-print-view"
  }, /*#__PURE__*/React__default.createElement(activity.Question, null), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: 10
    }
  }, /*#__PURE__*/React__default.createElement(RenderTables, {
    possibleResponses: possibleResponses
  }))) : null;
}
var PrintViewClozeDropDown = observer(PrintViewGeneric$3);

function getAutoFocus(autoFocusQuestion) {
  var autoFocusFinal = autoFocusQuestion || autoFocusTypes.NONE;
  if (autoFocusQuestion !== autoFocusTypes.NONE) ; else {
    autoFocusFinal = config.autoFocus;
  }
  return autoFocusFinal;
}

var _excluded$c = ["autoFocus"];
function getCloze(props) {
  var _getCreator = getCreator(props, getDefaultData$2, types.cloze.Text),
    type = _getCreator.type,
    lang = _getCreator.lang,
    initialProps = _getCreator.initialProps,
    exerciseData = _getCreator.exerciseData,
    setCommonParamsStore = _getCreator.setCommonParamsStore;
  return when()["case"](type === types.cloze.Text, function () {
    var editorStore = createStore$d(exerciseData);
    setCommonParamsStore(editorStore);
    var questionStore = createStore$e(exerciseData);
    setCommonParamsStore(questionStore);
    return createClozeText(editorStore, questionStore, initialProps, lang);
  })["case"](type === types.cloze.DropDown, function () {
    var editorStore = createStore$b(exerciseData);
    setCommonParamsStore(editorStore);
    var questionStore = createStore$c(exerciseData);
    setCommonParamsStore(questionStore);
    return createClozeDropDown(editorStore, questionStore, initialProps, lang);
  })["case"](type === types.cloze.Association, function () {
    var editorStore = createStore$f(exerciseData);
    setCommonParamsStore(editorStore);
    var questionStore = createStore$a(exerciseData);
    setCommonParamsStore(questionStore);
    return createClozeDragDrop(editorStore, questionStore, initialProps, lang);
  }).resolve(null);
}
function createClozeText(editorStore, questionStore, initialProps, lang) {
  return commonCreatorProps(editorStore, {
    Question: function Question(extraParams) {
      var _extraParams$autoFocu = extraParams.autoFocus,
        autoFocus = _extraParams$autoFocu === void 0 ? autoFocusTypes.NONE : _extraParams$autoFocu,
        restExtraParams = _objectWithoutPropertiesLoose(extraParams, _excluded$c);
      return /*#__PURE__*/React__default.createElement(ClozeTextQuestion$1, _extends({
        store: questionStore
      }, initialProps, restExtraParams, {
        autoFocus: getAutoFocus(autoFocus)
      }));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(ClozeTextEditor, _extends({
        store: editorStore,
        lang: lang
      }, initialProps, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Feedback: function Feedback(extraParams) {
      return /*#__PURE__*/React__default.createElement(FeedbackManager$1, _extends({
        store: questionStore
      }, extraParams));
    },
    PrintView: function PrintView(extraParams) {
      return /*#__PURE__*/React__default.createElement(PrintViewClozeText, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createClozeDragDrop(editorStore, questionStore, initialProps, lang) {
  return commonCreatorProps(editorStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(ClozeAssociationQuestion$1, _extends({
        store: questionStore
      }, initialProps, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(ClozeAssociationEditor$1, _extends({
        store: editorStore,
        lang: lang
      }, initialProps, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Feedback: function Feedback(extraParams) {
      return /*#__PURE__*/React__default.createElement(FeedbackManager$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createClozeDropDown(editorStore, questionStore, initialProps, lang) {
  return commonCreatorProps(editorStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(ClozeDropDownQuestion$1, _extends({
        store: questionStore
      }, initialProps, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(ClozeDropDownEditor$1, _extends({
        store: editorStore,
        lang: lang
      }, initialProps, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    PrintView: function PrintView(extraParams) {
      return /*#__PURE__*/React__default.createElement(PrintViewClozeDropDown, _extends({
        store: questionStore
      }, extraParams));
    },
    Feedback: function Feedback(extraParams) {
      return /*#__PURE__*/React__default.createElement(FeedbackManager$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}

var DragModel$2 = types$1.compose(ValueModel, withNumberDuplicates, types$1.model().views(function (state) {
  return {
    get dropTarget() {
      return getParent(state, 2).getDropTarget(state);
    },
    get visible() {
      return true;
    }
  };
}));

var RIGHT$4 = feedback.RIGHT,
  WRONG$1 = feedback.WRONG,
  NOT_EVALUATED = feedback.NOT_EVALUATED;
var DropValueModel = types$1.model({
  id: types$1.optional(types$1.string, function () {
    return uuid();
  }),
  index: types$1.number,
  text: types$1.string
}).actions(function (state) {
  return {
    reset: function reset() {
      return getParent(state, 2).removeChild(state);
    }
  };
}).views(function (state) {
  return {
    get idx() {
      return getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get feedbackResult() {
      return getParent(state, 2).dragsFeedback[state.idx];
    }
  };
});
var DropModel$1 = types$1.compose(getWithFeedbackResult(sortAndStringify), withIsDraggingOver, types$1.model({
  id: types$1.optional(types$1.string, function () {
    return uuid();
  }),
  value: types$1.optional(types$1.array(DropValueModel), [])
}).actions(function (state) {
  return {
    setValue: function setValue(value) {
      state.value = value && value.length === 1 && value[0] === '' ? [] : value;
    },
    addValue: function addValue(value) {
      state.value.push(value);
      var currentItem = last(state.value);
      state.triggerImmediateResponse({
        itemRef: currentItem.id,
        isValid: currentItem.feedbackResult === feedback.RIGHT,
        propagate: true
      });
    },
    removeValue: function removeValue(idx) {
      var itemRef = state.value[idx].id;
      state.value.splice(idx, 1);
      state.triggerImmediateResponse({
        itemRef: itemRef,
        isValid: state.isValid,
        propagate: false
      });
    },
    removeValueByIdx: function removeValueByIdx(idx) {
      state.value = state.value.filter(function (item, itemIdx) {
        return idx !== itemIdx;
      });
    },
    removeChild: function removeChild(item) {
      destroy(item);
    },
    reset: function reset() {
      state.value = [];
    },
    triggerImmediateResponse: function triggerImmediateResponse(_ref) {
      var itemRef = _ref.itemRef,
        isValid = _ref.isValid,
        propagate = _ref.propagate;
      getParent(state, 2).setImmediateResponse({
        value: isValid,
        dropIdx: state.index,
        itemRef: itemRef,
        propagate: propagate
      });
    }
  };
}).views(function (state) {
  return {
    get index() {
      return getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get valueText() {
      return state.value.map(function (v) {
        return v.text;
      }).sort(function (a, b) {
        return a < b ? -1 : 1;
      });
    },
    get valueIdx() {
      return state.value.map(function (v) {
        return v.index;
      }).sort(function (a, b) {
        return a - b;
      });
    },
    get responseValues() {
      return state.value.map(function (item) {
        return item.index;
      });
    },
    get validResponse() {
      var parent = getParent(state, 2);
      return parent.getCurrentSolution(state.index);
    },
    get hasResponses() {
      return state.responseValues.length > 0;
    },
    get isImmediate() {
      var parent = getParent(state, 2);
      return parent.validation.immediateFeedback;
    },
    get validate() {
      try {
        var solution = getParent(state, 2).validation.value[state.index];
        return sortAndStringify(solution) === sortAndStringify(state.responseValues);
      } catch (e) {
        console.log('error trying to validate ...', e);
        return false;
      }
    },
    get isValid() {
      var currentResponse = getParent(state, 2).getCurrentSolution(state.index);
      return sortAndStringify(currentResponse) === sortAndStringify(state.responseValues);
    },
    get parent() {
      return getParent(state, 2);
    },
    get dragsFeedback() {
      var feedbackResult = state.feedbackResult,
        value = state.value,
        validResponse = state.validResponse;
      var fill = function fill(val) {
        return new Array(value.length).fill(val);
      };
      return when()["case"](feedbackResult === RIGHT$4, function () {
        return fill(RIGHT$4);
      })["case"](feedbackResult === WRONG$1, function () {
        return validateList(value.map(function (val) {
          return val.index;
        }), validResponse);
      }).resolve(function () {
        return fill(NOT_EVALUATED);
      });
    }
  };
}));

var TextListModel = types$1.model({
  list: types$1.optional(types$1.array(ValueModel), []),
  minValue: types$1.optional(types$1.number, 0)
}).actions(function (state) {
  return {
    addItem: function addItem(value) {
      if (value === void 0) {
        value = '';
      }
      state.list.push({
        value: value
      });
      state.updateNotifier();
    },
    removeValue: function removeValue(value) {
      state.list.length - 1 >= state.minValue && destroy(value);
      state.updateNotifier();
    },
    clearExtraElements: function clearExtraElements(maxElements) {
      state.list = state.list.filter(function (_, idx) {
        return idx < maxElements;
      });
    },
    sortColumns: function sortColumns(source, destination) {
      state.list = sortArrayItem(source, destination, state.list);
      state.updateNotifier();
    },
    updateNotifier: function updateNotifier() {
      getParent(state, 2).updateNotifier();
    }
  };
}).views(function (state) {
  return {
    get arrayList() {
      return state.list.map(function (item) {
        return item.value;
      });
    },
    get length() {
      return state.list.length;
    }
  };
});

var defaultTextListModel = {
  list: [],
  minValue: 0
};
var UIStyleModel$2 = types$1.model({
  column_count: types$1.optional(types$1.number, 1),
  column_titles: types$1.optional(TextListModel, defaultTextListModel),
  row_count: types$1.optional(types$1.number, 1),
  row_titles: types$1.optional(TextListModel, defaultTextListModel),
  stack: types$1.optional(types$1["boolean"], false),
  withBox: types$1.optional(types$1["boolean"], true),
  customClass: types$1.maybe(VariantsModel$1),
  background: types$1.maybe(BackgroundModel$1)
}).actions(function (state) {
  return {
    setColumnCount: function setColumnCount(n) {
      state.column_count = Math.max(n, 1);
      state.column_titles.clearExtraElements(state.column_count);
      state.updateNotifier();
    },
    setRowCount: function setRowCount(n) {
      state.row_count = Math.max(n, 1);
      state.row_titles.clearExtraElements(state.row_count);
      state.updateNotifier();
    },
    setStack: function setStack(value) {
      state.stack = value;
      state.updateNotifier();
    },
    toggleStack: function toggleStack() {
      state.stack = !state.stack;
      state.updateNotifier();
    },
    setWithBox: function setWithBox(value) {
      state.withBox = value;
      state.updateNotifier();
    },
    toggleWithBox: function toggleWithBox() {
      state.withBox = !state.withBox;
      state.updateNotifier();
    },
    setBackground: function setBackground(background) {
      state.background = background;
    },
    updateNotifier: function updateNotifier() {
      getParent(state).updateNotifier();
    }
  };
}).views(function (state) {
  return {
    get titlesUpdate() {
      var data = getSnapshot(state);
      var getListToString = function getListToString(textList) {
        return textList.itemList.map(function (l) {
          return l.value;
        }).toString();
      };
      return getListToString(defaultValue('columns_titles', data, {
        list: []
      })) + ", " + getListToString(defaultValue('row_titles', data, {
        list: []
      }));
    },
    get hasColumns() {
      return state.column_titles.arrayList.reduce(function (acc, next) {
        return next.toString().length > 0 || acc;
      }, false);
    },
    get hasRows() {
      return state.row_titles.arrayList.reduce(function (acc, next) {
        return next.toString().length > 0 || acc;
      }, false);
    },
    get cTitles() {
      return getTitles(state.column_count, state.column_titles.list);
    },
    get rTitles() {
      return getTitles(state.row_count, state.row_titles.itemList);
    },
    get output() {
      var getList = function getList(item) {
        return defaultValue('list', item, []).map(function (c) {
          return c.value;
        });
      };
      return {
        column_count: state.column_count,
        column_titles: getList(state.column_titles),
        row_count: state.row_count,
        row_titles: getList(state.row_titles),
        stack: state.stack,
        withBox: state.withBox,
        background: getSnapshot(state.background)
      };
    }
  };
});
function getTitles(len, list, result, counter) {
  if (result === void 0) {
    result = [];
  }
  if (counter === void 0) {
    counter = 0;
  }
  if (result.length === len) return result;
  return getTitles(len, list, [].concat(result, [list.length > counter ? list[counter].value : '']), counter + 1);
}
var UIStyleModel$3 = types$1.snapshotProcessor(UIStyleModel$2, {
  preProcessor: function preProcessor(sn) {
    var columns = sn.column_titles || [];
    var rows = sn.row_titles || [];
    return _extends({}, sn, {
      column_count: defaultValue('column_count', sn, 1),
      row_count: defaultValue('row_count', sn, 1),
      column_titles: {
        list: columns.map(function (v) {
          return {
            value: v
          };
        }),
        minValue: 0
      },
      row_titles: {
        list: rows.map(function (v) {
          return {
            value: v
          };
        }),
        minValue: 0
      }
    });
  },
  postProcessor: function postProcessor(sn) {
    var getList = function getList(item) {
      return defaultValue('list', item, []).map(function (c) {
        return c.value;
      });
    };
    return _extends({}, sn, {
      column_titles: getList(sn.column_titles),
      row_titles: getList(sn.row_titles)
    });
  }
});

var ClassificationEditorStore = types$1.compose(withImmediateHandlers('drops'), withWhileDraggingTarget, EditorBaseModel, types$1.model({
  drops: types$1.optional(types$1.array(DropModel$1), []),
  drags: types$1.array(DragModel$2),
  duplicate_responses: types$1.optional(types$1["boolean"], false),
  shuffle_options: types$1.optional(types$1["boolean"], false),
  validation: ValidationModel,
  ui_style: UIStyleModel$3
}).actions(function (state) {
  function getNumberDuplicatesDefault() {
    return state.drops.length + 1;
  }
  return {
    afterCreate: function afterCreate() {
      reaction(function () {
        return state.ui_style.row_count * state.ui_style.column_count;
      }, function (length) {
        state.setDrops(createDrops(length));
        state.updateNotifier();
      });
      onAction(state, function (_ref) {
        var name = _ref.name,
          path = _ref.path;
        if (name.match(/addDrag|setValue|toggleStack|toggleWithBox/)) {
          state.updateNotifier();
        }
        if (path.match(/validation/)) {
          state.updateNotifier();
        }
      }, true);
    },
    setShuffleOptions: function setShuffleOptions(bool) {
      state.shuffle_options = bool;
    },
    setDuplicateResponses: function setDuplicateResponses(bool) {
      state.duplicate_responses = bool;
      if (!bool) state.validation.deleteValuesDuplicate();
      state.drags.forEach(function (drag) {
        return drag.setNumberDuplicates(bool ? getNumberDuplicatesDefault() : 1);
      });
      state.updateNotifier();
    },
    setOption: function setOption(option) {
      state.options.push({
        value: option
      });
    },
    updateSolutions: function updateSolutions(optionIndex) {
      var updateSolutionRow = function updateSolutionRow(row) {
        return row.reduce(function (acc, next) {
          if (next > optionIndex) return [].concat(acc, [next - 1]);
          if (next < optionIndex) return [].concat(acc, [next]);
          return acc;
        }, []);
      };
      var updateSolution = function updateSolution(solution) {
        return solution.map(updateSolutionRow);
      };
      state.validation.solutionList.forEach(function (solution, idx) {
        var currentSolution = state.validation.solutionList[idx].value;
        console.log('🚀 ~ state.validation.solutionList.forEach ~ currentSolution:', currentSolution);
        var updated = updateSolution(currentSolution);
        console.log('🚀 ~ state.validation.solutionList.forEach ~ updated:', updated);
        state.validation.updateSolution(idx, updateSolution(currentSolution));
      });
    },
    removeOption: function removeOption(option) {
      destroy(option);
      state.updateNotifier();
    },
    removeValue: function removeValue(item) {
      var itemIndex = item.index;
      state.updateSolutions(itemIndex);
      destroy(item);
      state.updateNotifier();
    },
    removeResponseByIdx: function removeResponseByIdx(idx) {
      state.removOption(state.options[idx]);
    },
    sortResponses: function sortResponses(source, destination) {
      state.options = sortArrayItem(source, destination, state.options);
    },
    reset: function reset() {
      state.isEvaluated = false;
      state.showSolution = false;
      state.tempResponse = [];
      state.clearDrops();
    },
    setDrops: function setDrops(drops) {
      state.drops = drops;
    },
    clearDrops: function clearDrops() {
      state.drops.forEach(function (drop) {
        return drop.reset();
      });
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.array(types$1.number)), response)) {
        return false;
      }
      state.clearDrops();
      response.forEach(function (dropValue, idx) {
        if (state.drops.length >= idx + 1 && dropValue.length > 0 && dropValue[0] !== '') {
          state.drops[idx].setValue(dropValue.map(function (dropIdx) {
            return state.drags[dropIdx] ? {
              text: state.drags[dropIdx].value,
              index: state.drags[dropIdx].index
            } : [];
          }));
        }
      });
    },
    addDrag: function addDrag(value) {
      var indexLabel = state.drags ? state.drags.length + 1 : '';
      state.drags.push({
        value: value || "<p>" + translate('option') + " " + indexLabel + "</p>",
        numberDuplicates: getNumberDuplicatesDefault()
      });
      state.updateNotifier();
    },
    sortDrags: function sortDrags(source, destination) {
      var initialDragsOrder = state.drags.map(function (drag) {
        return drag;
      });
      var updateIndexes = function updateIndexes(list) {
        return list.map(function (idx) {
          return initialDragsOrder[idx].index;
        });
      };
      state.drags = sortArrayItem(source, destination, state.drags);
      state.validation.solutionList.forEach(function (solution, idx) {
        var newOrder = solution.value.map(updateIndexes);
        state.validation.updateSolution(idx, newOrder);
      });
    },
    onDeleteDrag: function onDeleteDrag(drag) {
      destroy(drag);
      state.updateNotifier();
    },
    deleteDrag: function deleteDrag(drag) {
      setTimeout(function () {
        return state.onDeleteDrag(drag);
      }, 50);
    },
    setData: function setData(data) {
      applySnapshot(state, data);
      state.updateNotifier();
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot$e(rawData);
      applySnapshot(state, data);
      state.setIsSolutionMode(true);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    clearAllSolutions: function clearAllSolutions() {
      state.validation.setValue([]);
      state.validation.removeAltResponses();
    },
    clearAll: function clearAll() {
      state.clearAllBase();
      state.clearAllSolutions();
      state.drops.clear();
      state.drags.clear();
      state.ui_style.setColumnCount(1);
      state.ui_style.setRowCount(1);
      state.duplicate_responses = false;
      state.shuffle_options = false;
      state.updateNotifier();
    }
  };
}).views(function (state) {
  var normalizeResult = function normalizeResult(arr) {
    console.log('arr', arr);
    return arr.map(sortAndStringify).toString();
  };
  return {
    getUserResponse: function getUserResponse() {
      return state.drops.map(function (drop) {
        return drop.valueIdx;
      });
    },
    getResults: function getResults() {
      return {};
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$e(rawData);
    },
    getDropTarget: function getDropTarget(drag) {
      return state.drops.find(function (drop) {
        return drop.valueText.includes(drag.value);
      });
    },
    getResponseById: function getResponseById(id) {
      return state.drops.find(function (drop) {
        return drop.id === id;
      });
    },
    getSolutions: function getSolutions() {
      return state.validation.value;
    },
    get alternativePoints() {
      return state.validation.alt_responses.reduce(function (acc, next) {
        return normalizeResult(next.value) === normalizeResult(state.getUserResponse()) ? next.score : acc;
      }, 0);
    },
    get output() {
      return exportCommonValues(state, {
        template: state.template,
        possible_responses: state.drags.map(function (val) {
          return val.value;
        }),
        possible_responses_config: state.drags.map(function (o) {
          return o.exportToPossibleResponsesConfig(state.duplicate_responses);
        }),
        shuffle_options: state.shuffle_options,
        duplicate_responses: state.duplicate_responses
      });
    }
  };
}));
function createDrops(length) {
  return new Array(length).fill({
    value: []
  });
}
function _createSnapshot$e(data) {
  var _data$data = data.data,
    possible_responses = _data$data.possible_responses,
    possible_responses_config = _data$data.possible_responses_config,
    ui_style = _data$data.ui_style;
  var _ui_style$column_coun = ui_style.column_count,
    column_count = _ui_style$column_coun === void 0 ? 2 : _ui_style$column_coun,
    _ui_style$row_count = ui_style.row_count,
    row_count = _ui_style$row_count === void 0 ? 1 : _ui_style$row_count;
  return _extends({}, data.data, importCommonValues$1(data), {
    drops: createDrops(column_count * row_count),
    drags: createOptionsFromPossibleResponses(possible_responses, possible_responses_config)
  });
}
function createStore$g(data) {
  var store = ClassificationEditorStore.create(_createSnapshot$e(data));
  return store;
}

var ColumnsHeader = function ColumnsHeader(_ref) {
  var store = _ref.store;
  return !store.hasColumns ? null : /*#__PURE__*/React__default.createElement("thead", {
    className: "lemo-classification-thead"
  }, /*#__PURE__*/React__default.createElement("tr", {
    className: "lemo-classification-tr"
  }, store.hasRows && /*#__PURE__*/React__default.createElement("th", null), store.column_titles.map(function (content, idx) {
    return /*#__PURE__*/React__default.createElement("th", {
      className: "lemo-classification-th",
      key: "tableHeader_" + idx
    }, /*#__PURE__*/React__default.createElement(HTMLContent$1, {
      className: "lemo-classification-th-content lemo-text-body-m-regular lemo-color-text-02",
      content: content
    }));
  })));
};
var ColumnsHeader$1 = observer(ColumnsHeader);

var RowsHeader = function RowsHeader(_ref) {
  var store = _ref.store,
    idx = _ref.idx;
  return /*#__PURE__*/React__default.createElement("th", {
    className: "lemo-classification-rows-header"
  }, /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    className: "lemo-classification-rows-header-content lemo-text-body-m-regular lemo-color-text-02",
    content: store.getRowContent(idx)
  }));
};
var RowsHeader$1 = observer(RowsHeader);

function TableBody(_ref) {
  var store = _ref.store,
    row = _ref.row,
    solutionsMode = _ref.solutionsMode;
  var RIGHT = feedback.RIGHT,
    WRONG = feedback.WRONG;
  var dropTargets = "." + CONTAINER_DRAGS_CLASS + ", .lemo-drop-area";
  function selectDrag(e, drag) {
    e.stopPropagation();
    drag.select();
  }
  return row.map(function (drop) {
    var showSuccess = drop.isImmediate ? drop.hasResponses && drop.feedbackResult === RIGHT : drop.feedbackResult === RIGHT;
    var showError = !drop.isImmediate && drop.feedbackResult === WRONG;
    return /*#__PURE__*/React__default.createElement("td", {
      className: cn$1('lemo-classification-drop', {
        'lemo-selected': drop.isSelected,
        'lemo-lock': store.isEvaluated,
        'lemo-success': !solutionsMode && showSuccess,
        'lemo-error': !solutionsMode && showError,
        'lemo-is-dragging-over': drop.isDraggingOver,
        'lemo-disabled': store.disabled,
        'lemo-is-highlighted': drop.isHighLighted,
        'lemo-drop-area--can-selected': drop.canSelected
      }),
      key: drop.id,
      style: {
        width: store.cellWidth
      },
      onClick: drop.select
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-classification-dropped-item-container lemo-drop-area",
      "data-id": drop.id || 'null',
      style: {
        flexDirection: store.ui_style.stack ? 'column' : 'row'
      }
    }, drop.value.map(function (dragValue) {
      var drag = store.drags.find(function (_ref2) {
        var id = _ref2.id;
        return id === dragValue.id;
      });
      if (!drag) return null;
      return /*#__PURE__*/React__default.createElement("div", {
        key: "" + drag.id,
        className: cn$1('lemo-drop-container', {
          'lemo-without-box': !store.ui_style.withBox && !store.isEvaluated,
          'lemo-success': dragValue.success,
          'lemo-error': dragValue.error
        }),
        onClick: function onClick(e) {
          return selectDrag(e, drag);
        }
      }, /*#__PURE__*/React__default.createElement(Drag$1, {
        drag: drag,
        matchResponse: store.matchResponse,
        dropTargets: dropTargets
      }));
    })));
  });
}
var TableBody$1 = observer(TableBody);

function ClassificationQuestion(props) {
  var store = props.store,
    solutionsMode = props.solutionsMode;
  var changedHandlers = /setTitle|setStimulus|setTarget|updateDrag|removeValue|setValue|matchResponse|onClickDrop|onClickContainerDrags|onDropOut/;
  useDispatchOnResponseChange({
    store: store,
    changed: props.changed
  });
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-body"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-table-wrapper"
  }, /*#__PURE__*/React__default.createElement("table", {
    className: "lemo-classification-table"
  }, /*#__PURE__*/React__default.createElement(ColumnsHeader$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement("tbody", {
    className: "lemo-classification-tbody"
  }, store.tableRows.map(function (row, idx) {
    return /*#__PURE__*/React__default.createElement("tr", {
      className: "lemo-classification-tr",
      key: "row__" + idx
    }, store.hasRows && /*#__PURE__*/React__default.createElement(RowsHeader$1, {
      store: store,
      idx: idx
    }), /*#__PURE__*/React__default.createElement(TableBody$1, {
      store: store,
      row: row,
      solutionsMode: solutionsMode
    }));
  })))), /*#__PURE__*/React__default.createElement(DragsContainer$1, {
    dragsContainer: store.dragsContainer
  }, store.getDragList(solutionsMode).map(function (drag, idx) {
    return /*#__PURE__*/React__default.createElement(DragWithDuplicates$1, {
      key: drag.id,
      drag: drag,
      showCallOut: idx === 0 && !store.firstInteraction && !store.disabled,
      matchResponse: store.matchResponse,
      onClick: drag.select,
      dropTargets: ".lemo-drop-area",
      disabled: !!store.dragDroppedSelected,
      hidden: drag.drop
    });
  }))));
}
var ClassificationQuestion$1 = observer(ClassificationQuestion);

var withNumberDuplicatesParent = types$1.model({}).actions(function (state) {
  return {};
}).views(function (state) {
  return {
    getNumUsesOption: function getNumUsesOption(option) {
      throw new Error('Abstract method getNumUsesOption not implemented');
    },
    isVisibleCascade: function isVisibleCascade(option) {
      if (state.duplicate_responses) {
        return option.numberDuplicates - state.getNumUsesOption(option) > 1;
      } else return false;
    },
    isVisibleCascadeDragging: function isVisibleCascadeDragging(option) {
      if (state.duplicate_responses) {
        return option.numberDuplicates - state.getNumUsesOption(option) > 2;
      } else return false;
    },
    canUseOption: function canUseOption(option) {
      if (state.duplicate_responses) {
        return state.getNumUsesOption(option) < option.numberDuplicates;
      } else {
        return state.getNumUsesOption(option) === 0;
      }
    }
  };
});

var DragModel$3 = types$1.compose(withDuplicates, withZIndex, types$1.model({
  id: types$1.string,
  index: types$1.number,
  value: types$1.string,
  isDragging: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    select: function select() {
      getParent(state, 2).select(state.id);
      getParent(state, 2).updateFirstInteraction();
    },
    setIsDragging: function setIsDragging(bool) {
      state.isDragging = bool;
      if (bool) getParent(state, 2).updateFirstInteraction();
    },
    resetTarget: function resetTarget() {
      var _state$drop, _state$drop$removeVal;
      state === null || state === void 0 ? void 0 : (_state$drop = state.drop) === null || _state$drop === void 0 ? void 0 : (_state$drop$removeVal = _state$drop.removeValue) === null || _state$drop$removeVal === void 0 ? void 0 : _state$drop$removeVal.call(_state$drop, state);
    }
  };
}).views(function (state) {
  return {
    get drop() {
      return getParent(state, 2).drops.find(function (drop) {
        return drop.value.find(function (_ref) {
          var id = _ref.id;
          return id === state.id;
        });
      });
    },
    get isUsed() {
      return state.drop;
    },
    get itemType() {
      return state.drop ? DRAG_DROPPED : DRAG;
    },
    get isSelected() {
      return getParent(state, 2).dragSelected === state || getParent(state, 2).dragDroppedSelected === state;
    },
    get isHighlighted() {
      var dropSelected = getParent(state, 2).dropSelected;
      return dropSelected && dropSelected !== state.drop;
    },
    get visible() {
      return true;
    },
    get maxDepth() {
      return getParent(state, 2).maxDepth;
    }
  };
}));

var withSelectedDragDrop = types$1.model({
  selectedDrag: types$1.maybe(DragModel$3),
  selectedDropId: types$1.optional(types$1.string, ''),
  canSelectedContainerDrags: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  function isEqualsDragInsideDrop(dragInsideDrop, drag) {
    if (dragInsideDrop && drag) {
      if (dragInsideDrop.id === drag.id && dragInsideDrop.instanceId === drag.instanceId) {
        return true;
      }
    }
    return false;
  }
  return {
    isDropContainsDrag: function isDropContainsDrag(drop, drag) {
      if (drag) {
        return isEqualsDragInsideDrop(drop.drag, drag);
      } else return false;
    },
    setSelectedDragSimply: function setSelectedDragSimply(dragItem) {
      state.selectedDrag = _extends({}, dragItem);
    },
    setSelectedDrag: function setSelectedDrag(dragItem, canSelectedContainerDrags) {
      state.setSelectedDragSimply(dragItem);
      state.drops.forEach(function (drop, idx) {
        if (!state.isDropContainsDrag(drop, dragItem)) drop.setCanSelected();
      });
      state.setCanSelectedContainerDrags(canSelectedContainerDrags);
    },
    setSelectedDropId: function setSelectedDropId(dropId) {
      if (dropId === void 0) {
        dropId = '';
      }
      state.selectedDropId = dropId;
    },
    clearSelectedDrag: function clearSelectedDrag() {
      state.selectedDrag = undefined;
      state.drops.forEach(function (item, idx) {
        var _item$clearCanSelecte;
        item === null || item === void 0 ? void 0 : (_item$clearCanSelecte = item.clearCanSelected) === null || _item$clearCanSelecte === void 0 ? void 0 : _item$clearCanSelecte.call(item);
      });
      state.setCanSelectedContainerDrags(false);
    },
    clearSelectedDropId: function clearSelectedDropId() {
      state.selectedDropId = undefined;
    },
    removeDragInsideDrop: function removeDragInsideDrop(drag) {
      var idsDropsRemove = [];
      state.drops.forEach(function (drop, idx) {
        if (isEqualsDragInsideDrop(drop.drag, drag)) {
          idsDropsRemove.push(drop.id);
        }
      });
      var _loop = function _loop() {
        var _drop$drag, _drop$drag$dropTarget;
        var dropId = idsDropsRemove[index];
        var drop = state.drops.find(function (drop) {
          return drop.id === dropId;
        });
        if (drop) (_drop$drag = drop.drag) === null || _drop$drag === void 0 ? void 0 : (_drop$drag$dropTarget = _drop$drag.dropTarget) === null || _drop$drag$dropTarget === void 0 ? void 0 : _drop$drag$dropTarget.removeValue();
      };
      for (var index = 0; index < idsDropsRemove.length; index++) {
        _loop();
      }
    },
    setCanSelectedContainerDrags: function setCanSelectedContainerDrags(canSelected) {
      state.canSelectedContainerDrags = canSelected;
    },
    isEqualsSelectedDrag: function isEqualsSelectedDrag(dragItem) {
      if (state.selectedDrag) {
        if (state.selectedDrag.id === dragItem.id && state.selectedDrag.instanceId === dragItem.instanceId) {
          return true;
        }
      }
      return false;
    },
    onClickDrag: function onClickDrag(dragModel) {
      console.log('onClickDrag! ->', state.selectedDropId);
      if (state.selectedDropId.length !== 0) {
        console.log('pasa');
        return state.matchResponse(state.selectedDropId, dragModel);
      }
      if (state.isEqualsSelectedDrag(dragModel)) {
        state.clearSelectedDrag();
      } else {
        state.setSelectedDrag(dragModel, false);
      }
    },
    onClickOutsideDrag: function onClickOutsideDrag(dragModel, event) {
      if (state.isEqualsSelectedDrag(dragModel)) {
        if (!state.isNodeDrop(event) && !state.isNodeDropWithDrag(event) && !state.isNodeContainerDrags(event)) {
          state.clearSelectedDrag();
        }
      }
    },
    onClickDragInsideDrop: function onClickDragInsideDrop(dropItem, dragValue) {
      if (dragValue) {
        if (state.isEqualsSelectedDrag(dragValue)) {
          console.log('clearSelectedDrag');
          state.clearSelectedDrag();
        } else {
          if (state.selectedDrag) {
            var dragSelected = state.getDragById(state.selectedDrag.id);
            if (dragSelected) {
              if (state.isRemoveDragClickDragInsideDrop) state.removeDragInsideDrop(dragValue);
              state.removeDragInsideDrop(state.selectedDrag);
              state.matchResponse(dropItem.id, dragSelected);
              state.clearSelectedDrag();
            }
          } else {
            state.setSelectedDrag(dragValue, true);
          }
        }
      }
    },
    onClickOutsideDragInsideDrop: function onClickOutsideDragInsideDrop(dropItem, event) {
      if (dropItem.drag) {
        if (state.isEqualsSelectedDrag(dropItem.drag)) {
          if (!state.isNodeContainerDrags(event) && !state.isNodeDrop(event) && !state.isNodeDropWithDrag(event)) {
            state.clearSelectedDrag();
          }
        }
      }
    },
    onClickDrop: function onClickDrop(dropItem) {
      if (dropItem.canSelected) {
        var dragSelected = state.getDragById(state.selectedDrag.id);
        if (dragSelected) {
          if (state.isRemoveSelectedDragClickDrop) state.removeDragInsideDrop(state.selectedDrag);
          state.matchResponse(dropItem.id, dragSelected);
          state.clearSelectedDrag();
        }
      } else {
        console.log('drop clicked is empty');
        state.setSelectedDropId(dropItem.id);
      }
    },
    onClickContainerDrags: function onClickContainerDrags() {
      if (state.canSelectedContainerDrags) {
        var dragSelected = state.getDragById(state.selectedDrag.id);
        if (dragSelected) {
          state.removeDragInsideDrop(state.selectedDrag);
          state.clearSelectedDrag();
        }
      } else {
        if (state.selectedDrag) {
          state.clearSelectedDrag();
        }
      }
    }
  };
}).views(function (state) {
  return {
    isNodeDrop: function isNodeDrop(event) {
      return (event === null || event === void 0 ? void 0 : event.target.classList.contains('html-content')) && !(event !== null && event !== void 0 && event.target.classList.contains('lemo-cloze-question-template'));
    },
    isNodeDropWithDrag: function isNodeDropWithDrag(event) {
      return event === null || event === void 0 ? void 0 : event.target.classList.contains('lemo-content-wrapper');
    },
    isNodeContainerDrags: function isNodeContainerDrags(event) {
      return event === null || event === void 0 ? void 0 : event.target.classList.contains(CONTAINER_DRAGS_CLASS);
    },
    getDragById: function getDragById(id) {
      return state.drags.find(function (drag) {
        return drag.id === id;
      });
    },
    get isRemoveSelectedDragClickDrop() {
      return true;
    },
    get isRemoveDragClickDragInsideDrop() {
      return true;
    }
  };
});

var RIGHT$5 = 'RIGHT';
var WRONG$2 = 'WRONG';
var DropValueModel$1 = types$1.model('DropValueModel', {
  id: types$1.optional(types$1.string, function () {
    return uuid();
  }),
  index: types$1.number,
  text: types$1.string
}).actions(function (state) {
  return {
    reset: function reset() {
      return getParent(state, 2).removeChild(state);
    }
  };
}).views(function (state) {
  return {
    get idx() {
      return getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get feedbackResult() {
      return getParent(state, 2).dragsFeedback[state.idx];
    },
    get success() {
      try {
        return state.feedbackResult === RIGHT$5;
      } catch (e) {
        return false;
      }
    },
    get error() {
      try {
        return state.feedbackResult === WRONG$2;
      } catch (e) {
        return false;
      }
    }
  };
});

var RIGHT$6 = feedback.RIGHT,
  WRONG$3 = feedback.WRONG,
  NOT_EVALUATED$1 = feedback.NOT_EVALUATED;
var DropModel$2 = types$1.compose(getWithFeedbackResult(sortAndStringify), withIsDraggingOver, withCanSelectedDrop, withZIndex, types$1.model('DropModel', {
  id: types$1.optional(types$1.string, function () {
    return uuid();
  }),
  value: types$1.optional(types$1.array(DropValueModel$1), []),
  isMovingDrag: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    setTarget: function setTarget(drag) {
      state.addValue({
        id: drag.id,
        index: drag.index,
        text: drag.value
      });
    },
    addValue: function addValue(value) {
      state.value.push(value);
      var currentItem = last(state.value);
      state.triggerImmediateResponse({
        itemRef: currentItem.id,
        isValid: currentItem.feedbackResult === feedback.RIGHT,
        propagate: true
      });
    },
    removeValue: function removeValue(drag) {
      var idx = state.value.findIndex(function (_ref) {
        var id = _ref.id;
        return id === drag.id;
      });
      state.value.splice(idx, 1);
      state.triggerImmediateResponse({
        itemRef: drag.id,
        isValid: state.isValid,
        propagate: false
      });
    },
    select: function select() {
      getParent(state, 2).select(state.id);
    },
    reset: function reset() {
      state.value = [];
    },
    triggerImmediateResponse: function triggerImmediateResponse(_ref2) {
      var itemRef = _ref2.itemRef,
        isValid = _ref2.isValid,
        propagate = _ref2.propagate;
      getParent(state, 2).setImmediateResponse({
        value: isValid,
        dropIdx: state.index,
        itemRef: itemRef,
        propagate: propagate
      });
    },
    setIsMovingDrag: function setIsMovingDrag(isMovingDrag) {
      state.isMovingDrag = isMovingDrag;
    }
  };
}).views(function (state) {
  return {
    get index() {
      return getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get itemType() {
      return DROP_EMPTY;
    },
    get isHighLighted() {
      var parent = getParent(state, 2);
      if (parent !== null && parent !== void 0 && parent.dragIdIsDragging && state.valueIds.includes(parent.dragIdIsDragging)) {
        return false;
      }
      var drag = parent.dragDroppedSelected || parent.dragSelected;
      return drag && (drag === null || drag === void 0 ? void 0 : drag.drop) !== state || (parent === null || parent === void 0 ? void 0 : parent.dragIdIsDragging);
    },
    get valueText() {
      return state.value.map(function (v) {
        return v.text;
      }).sort(function (a, b) {
        return a < b ? -1 : 1;
      });
    },
    get valueIdx() {
      return state.value.map(function (v) {
        return v.index;
      }).sort(function (a, b) {
        return a - b;
      });
    },
    get responseValues() {
      return state.value.map(function (item) {
        return item.index;
      });
    },
    get isSelected() {
      return getParent(state, 2).dropSelected === state;
    },
    get validResponse() {
      var parent = getParent(state, 2);
      return parent.getCurrentSolution(state.index);
    },
    get hasResponses() {
      return state.responseValues.length > 0;
    },
    get isImmediate() {
      var parent = getParent(state, 2);
      return parent.validation.immediateFeedback;
    },
    get validate() {
      try {
        var solution = getParent(state, 2).validation.value[state.index];
        return sortAndStringify(solution) === sortAndStringify(state.responseValues);
      } catch (e) {
        console.log('error trying to validate ...', e);
        return false;
      }
    },
    get isValid() {
      var currentResponse = getParent(state, 2).getCurrentSolution(state.index);
      return sortAndStringify(currentResponse) === sortAndStringify(state.responseValues);
    },
    get parent() {
      return getParent(state, 2);
    },
    get dragsFeedback() {
      var feedbackResult = state.feedbackResult,
        value = state.value,
        validResponse = state.validResponse;
      var fill = function fill(val) {
        return new Array(value.length).fill(val);
      };
      return when()["case"](feedbackResult === RIGHT$6, function () {
        return fill(RIGHT$6);
      })["case"](feedbackResult === WRONG$3, function () {
        return validateList(value.map(function (val) {
          return val.index;
        }), validResponse);
      }).resolve(function () {
        return fill(NOT_EVALUATED$1);
      });
    },
    get maxDepth() {
      return getParent(state, 2).maxDepth;
    },
    get valueIds() {
      return state.value.map(function (item) {
        return item.id;
      });
    }
  };
}));

var ClassificationUIStyleViews = types$1.model({}).views(function (state) {
  function getData() {
    return state.ui_style;
  }
  return {
    get titlesUpdate() {
      var getListToString = function getListToString(textList) {
        return textList.itemList.map(function (l) {
          return l.value;
        }).toString();
      };
      return getListToString(defaultValue('columns_titles', getData(), {
        list: []
      })) + ", " + getListToString(defaultValue('row_titles', getData(), {
        list: []
      }));
    },
    get hasColumns() {
      return getData().column_titles.reduce(function (acc, next) {
        return next.toString().length > 0 || acc;
      }, false);
    },
    get hasRows() {
      var _getData, _getData$row_titles;
      return ((_getData = getData()) === null || _getData === void 0 ? void 0 : (_getData$row_titles = _getData.row_titles) === null || _getData$row_titles === void 0 ? void 0 : _getData$row_titles.reduce(function (acc, next) {
        return next.toString().length > 0 || acc;
      }, false)) || false;
    },
    get column_titles() {
      return fillTitles(getData().column_count, getData().column_titles);
    },
    get row_titles() {
      return fillTitles(getData().row_count, getData().row_titles);
    }
  };
});
function fillTitles(counter, values) {
  return new Array(counter).fill(null).map(function (item, idx) {
    return (values === null || values === void 0 ? void 0 : values[idx]) || null;
  });
}

var withDragList = types$1.model({}).views(function (state) {
  var uniqueDrags = function uniqueDrags() {
    return state.drags.reduce(function (acc, next) {
      return !acc.find(function (d) {
        return d.value === next.value;
      }) ? [].concat(acc, [next]) : acc;
    }, []);
  };
  var getDragByIdx = function getDragByIdx(idx) {
    return state.baseDrags.find(function (d) {
      return d.index === idx;
    });
  };
  var shuffleBaseDrags = function shuffleBaseDrags() {
    return state.optionsOrder.reduce(function (acc, next) {
      var item = getDragByIdx(next);
      return item ? [].concat(acc, [item]) : acc;
    }, []);
  };
  return {
    canUseOption: function canUseOption(option) {
      return true;
    },
    get baseDrags() {
      var dropped = state.drops.reduce(function (acc, next) {
        return acc.concat(next.valueText);
      }, []);
      return (state.duplicate_responses ? uniqueDrags() : state.drags.filter(function (drag) {
        return !dropped.includes(drag.value);
      })).filter(function (option) {
        return state.canUseOption(option);
      });
    },
    get dragList() {
      return state.shuffle_options ? shuffleBaseDrags() : state.baseDrags;
    }
  };
});

var withConfigureScorm$8 = types$1.model({
  scormData: types$1.optional(ScormModel, {})
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      state.exerciseType = scormTypes.MATCHING;
      state.initScorm();
      onAction(state, function (_ref) {
        var name = _ref.name,
          path = _ref.path;
        if (name === 'reset' && path === '') state.initScorm();
      }, true);
      onSnapshot(state.drops, function () {
        state.drops.forEach(function (item) {
          state.scormData.updateInteractive({
            id: item.id,
            userResponse: item.responseValues,
            result: item.isValid
          });
        });
      });
    },
    initScorm: function initScorm() {
      state.scormData.init(state, state.drops.map(function (item, idx) {
        return {
          userResponse: item.responseValues,
          id: item.id,
          rightAnswer: getAlternativeSolutions(idx, state),
          result: item.isValid
        };
      }));
    }
  };
});

function getCurrentEditorSolution(rawData, idx) {
  var validation = rawData.data.validation;
  return idx === 0 ? validation.valid_response.value : validation.alt_responses[idx - 1].value;
}

var withIsDragging = types$1.model({}).actions(function (state) {
  return {};
}).views(function (state) {
  return {
    get dragIdIsDragging() {
      var draggingDrag = state.drags.find(function (drag) {
        return drag.isDragging;
      });
      return draggingDrag ? draggingDrag.id : '';
    }
  };
});

var ClassificationQuestionStore = types$1.compose(withImmediateHandlers('drops'), withWhileDraggingTarget, QuestionBaseModel, withSelectedDragDrop, getWithShuffleOptions('drags'), withDragList, getClosestSolutionModel(checkFunction), ClassificationUIStyleViews, withNumberDuplicatesParent, withValidationModes, withConfigureScorm$8, SelectionModel$1, withIsDragging, types$1.model({
  firstInteraction: types$1.optional(types$1["boolean"], false),
  dragsContainer: types$1.optional(DragsContainerModel, {}),
  drops: types$1.optional(types$1.array(DropModel$2), []),
  drags: types$1.array(DragModel$3),
  activeDrags: types$1.array(DragModel$3)
}).actions(function (state) {
  var getDrag = function getDrag(id) {
    return state.drags.find(function (drag) {
      return drag.id === id;
    });
  };
  var getDrop = function getDrop(id) {
    return state.drops.find(function (drop) {
      return drop.id === id;
    });
  };
  return {
    reset: function reset() {
      state.baseReset();
      state.tempResponse = [];
      state.firstInteraction = false;
      state.clearDrops();
    },
    clearDrops: function clearDrops() {
      state.drops.forEach(function (drop) {
        return drop.reset();
      });
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.array(types$1.number)), response)) {
        return false;
      }
      state.updateFirstInteraction();
      state.clearDrops();
      var hasValue = function hasValue(v) {
        return v.length > 0 && (v === null || v === void 0 ? void 0 : v[0]) !== '';
      };
      response.forEach(function (dropValues, idx) {
        if (state.drops.length >= idx + 1 && hasValue(dropValues)) {
          var dropId = state.drops[idx].id;
          dropValues.forEach(function (value, idx) {
            var drag = state.drags.find(function (drag) {
              return drag.index === value && !drag.isUsed;
            });
            if (drag) state.matchResponse(dropId, drag);
          });
        }
      });
    },
    resetDrag: function resetDrag(drag) {
      drag.resetTarget();
    },
    updateFirstInteraction: function updateFirstInteraction() {
      state.firstInteraction = true;
    },
    matchPair: function matchPair(_ref) {
      var dragId = _ref.dragId,
        dropId = _ref.dropId;
      state.updateFirstInteraction();
      if (!dragId || !dropId) return;
      state.matchResponse(dropId, getDrag(dragId));
      state.clearSelection();
    },
    matchResponse: function matchResponse(dropId, drag) {
      drag.drop && drag.drop.removeValue(drag);
      var drop = getDrop(dropId);
      state.clearSelection();
      drop.setTarget(drag);
      state.updateFirstInteraction();
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData, idx) {
      var data = _createSnapshot$f(rawData);
      applySnapshot(state, data);
      var solution = getCurrentEditorSolution(rawData, idx);
      state.setIsSolutionMode(true);
      state.setResponse(solution);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    hydrateQuestionPreview: function hydrateQuestionPreview(rawData) {
      try {
        var data = state.createSnapshot(rawData);
        data.optionsOrder = state.optionsOrder;
        var prevAssetsQuestionApi = state.assetsQuestionApi;
        var prevShuffleOptions = state.shuffle_options;
        applySnapshot(state, data);
        state.setIsSolutionMode(false);
        state.setAssetsQuestionApi(prevAssetsQuestionApi);
        if (prevShuffleOptions !== state.shuffle_options) {
          state.updateOptionsOrder();
        }
      } catch (e) {}
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  var checkSelectedType = function checkSelectedType(dragType) {
    return state.selection.length === 1 && state.selectedInstances[0].itemType === dragType;
  };
  return {
    get allInteractives() {
      return [].concat(state.drags, state.drops, [state.dragsContainer]);
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$f(rawData);
    },
    getUserResponse: function getUserResponse() {
      var userResponse = state.drops.map(function (drop) {
        return drop.valueIdx;
      });
      return state.getRealUserResponse(userResponse);
    },
    get duplicate_responses() {
      return state.raw.data.duplicate_responses;
    },
    get shuffle_options() {
      return state.raw.data.shuffle_options;
    },
    getTableByRowIdx: function getTableByRowIdx(idx) {
      var init = idx * state.ui_style.column_count;
      var limit = init + state.ui_style.column_count;
      var getRowList = function getRowList(list, current) {
        if (list === void 0) {
          list = [];
        }
        if (current === void 0) {
          current = init;
        }
        return current === limit ? list : getRowList([].concat(list, [state.drops[current]]), current + 1);
      };
      return getRowList();
    },
    get tableRows() {
      return new Array(state.ui_style.row_count).fill('').map(function (_, idx) {
        return state.getTableByRowIdx(idx);
      });
    },
    getRowContent: function getRowContent(idx) {
      return state.row_titles[idx];
    },
    get cellWidth() {
      return Math.floor(100 / state.ui_style.column_count) + '%';
    },
    getDropTarget: function getDropTarget(dropId) {
      return state.drops.find(function (drop) {
        return drop.id === dropId;
      });
    },
    getResponseById: function getResponseById(id) {
      return state.drops.find(function (drop) {
        return drop.id === id;
      });
    },
    get maxDepth() {
      return [].concat(state.drags, state.activeDrags).reduce(function (acc, next) {
        return next.z > acc ? next.z : acc;
      }, 0);
    },
    get highLightDrops() {
      return state.dragSelected || state.dragDropSelected;
    },
    get dragSelected() {
      return checkSelectedType(DRAG) ? state.selectedInstances[0] : false;
    },
    get dropSelected() {
      return checkSelectedType(DROP_EMPTY) ? state.selectedInstances[0] : false;
    },
    get dragDroppedSelected() {
      return checkSelectedType(DRAG_DROPPED) ? state.selectedInstances[0] : false;
    },
    getDragList: function getDragList(solutionsMode) {
      var list = solutionsMode ? state.drags : state.shuffledOptions;
      return getDragListWithDuplicates(list);
    }
  };
}));
function createDragData$1(index, value) {
  return {
    id: uuid(),
    index: index,
    value: value
  };
}
function createDragList$1(possible_responses, possible_responses_config) {
  return possible_responses_config.reduce(function (acc, next, idx) {
    return [].concat(acc, populate(next.number_duplicates, function () {
      return createDragData$1(idx, possible_responses[idx]);
    }));
  }, []);
}
function createDrops$1(length) {
  return new Array(length).fill({
    value: []
  });
}
function checkFunction(solution, userResponse) {
  var emptyResponse = userResponse && userResponse.length === 0;
  var bothEmpty = (solution === null || solution === void 0 ? void 0 : solution.length) === 0 && emptyResponse;
  var solve = function solve() {
    return (solution === null || solution === void 0 ? void 0 : solution.toString()) === (userResponse === null || userResponse === void 0 ? void 0 : userResponse.toString());
  };
  return when()["case"](bothEmpty, function () {
    return true;
  })["case"](emptyResponse, function () {
    return null;
  }).resolve(solve);
}
function _createSnapshot$f(data) {
  var _data$data = data.data,
    possible_responses = _data$data.possible_responses,
    ui_style = _data$data.ui_style,
    validation = _data$data.validation;
  var _ui_style$column_coun = ui_style.column_count,
    column_count = _ui_style$column_coun === void 0 ? 2 : _ui_style$column_coun,
    _ui_style$row_count = ui_style.row_count,
    row_count = _ui_style$row_count === void 0 ? 1 : _ui_style$row_count;
  var responsesLength = validation.valid_response.value.length;
  var responseConfig = getDuplicatesConfig(data.data);
  return _extends({}, data.data, importCommonValues$1(data), {
    validation: withPenaltyPoints(responsesLength, validation),
    drops: createDrops$1(column_count * row_count),
    drags: createDragList$1(possible_responses, responseConfig)
  });
}
function createStore$h(data) {
  return ClassificationQuestionStore.create(_createSnapshot$f(data));
}

function useSize(target, redraw) {
  var _React$useState = React__default.useState(),
    size = _React$useState[0],
    setSize = _React$useState[1];
  React__default.useLayoutEffect(function () {
    setSize(target.current.getBoundingClientRect());
  }, [target, redraw]);
  useResizeObserver(target, function () {
    return setSize(target.current.getBoundingClientRect());
  });
  return size;
}

function Option(_ref) {
  var option = _ref.option,
    store = _ref.store,
    solutionsMode = _ref.solutionsMode,
    listLength = _ref.listLength,
    onClick = _ref.onClick,
    _ref$isOrigin = _ref.isOrigin,
    isOrigin = _ref$isOrigin === void 0 ? false : _ref$isOrigin,
    _ref$onSuccessRenderM = _ref.onSuccessRenderMathJax,
    onSuccessRenderMathJax = _ref$onSuccessRenderM === void 0 ? null : _ref$onSuccessRenderM;
  var setIsDragging = store.setIsDragging,
    isDragging = store.isDragging,
    isHorizontal = store.isHorizontal,
    disabled = store.disabled;
  var success = !solutionsMode && option.value.length > 0 && option.feedbackResult === feedback.RIGHT;
  var error = !solutionsMode && option.value.length > 0 && option.feedbackResult === feedback.WRONG;
  var handleDragStart = useCallback(function () {
    setIsDragging(true);
    document.removeEventListener('mousemove', handleDragStart);
  }, [setIsDragging]);
  var handleMouseDown = useCallback(function () {
    setIsDragging(false);
    document.addEventListener('mousemove', handleDragStart, false);
    onClick();
  }, [option, onClick, setIsDragging]);
  var handleMouseUp = useCallback(function () {
    document.removeEventListener('mousemove', handleDragStart);
    !option.isSelected && isDragging && onClick();
    setIsDragging(false);
  }, [option, onClick, setIsDragging]);
  var optionWidth = isHorizontal ? "row-" + listLength : '';
  var isDisabled = {
    pointerEvents: disabled ? 'none' : 'all'
  };
  var itemAlignment = when()["case"](isOrigin && !isHorizontal, function () {
    return 'lemo-horizontal-left';
  })["case"](!isHorizontal, function () {
    return 'lemo-horizontal-right';
  })["case"](isOrigin, function () {
    return 'lemo-vertical-top';
  }).resolve(function () {
    return 'lemo-vertical-bottom';
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-option', optionWidth),
    style: isDisabled
  }, option.hasFeedback && /*#__PURE__*/React__default.createElement(FeedbackPin$1, {
    idx: option.feedbackIndex,
    result: option.resultCache,
    visible: option.withPin && option.isWrongCache,
    classAdd: 'lemo-base-feedback-pin__option',
    feedback: option.feedback,
    mirrorIcon: true
  }), /*#__PURE__*/React__default.createElement("div", {
    className: 'lemo-option-wrapper ' + itemAlignment,
    onMouseDown: handleMouseDown,
    onMouseUp: handleMouseUp,
    role: "button"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-option-content lemo-drag-box', {
      'lemo-selected': option.isSelected,
      'lemo-is-waiting-for-match': option.isWaitingForMatch,
      'lemo-is-matched': option.isMatched,
      'lemo-success': success,
      'lemo-error': error
    })
  }, /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    className: "lemo-text-body-m-medium lemo-color-text-02",
    content: option.label,
    onSuccessRenderMathJax: onSuccessRenderMathJax
  }))));
}
var Option$1 = observer(Option);

var SVG_PROPS = {
  INPUT: 'left',
  OUTPUT: 'right',
  DOT_SIZE: [14, 16, 18],
  VISIBLE_LINE: [3, 5, 7],
  HIDDEN_LINE: [12, 14, 16]
};

var emDistance = 16;
function DotVerticalList(_ref) {
  var parentBox = _ref.parentBox,
    wrapper = _ref.wrapper,
    columnId = _ref.columnId,
    itemList = _ref.itemList,
    orientation = _ref.orientation,
    store = _ref.store;
  var _store$ui_style = store.ui_style,
    line_thickness = _store$ui_style.line_thickness,
    line_color = _store$ui_style.line_color;
  var evaluationReady = store.isEvaluated || store.validation.immediateFeedback;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, Array.from(wrapper.children).map(function (__element, idx) {
    var box = __element.querySelector('.lemo-option-content').getBoundingClientRect();
    var dotSize = SVG_PROPS.DOT_SIZE[line_thickness];
    var option = itemList[idx];
    var id = "option_" + option.id;
    var x = getXPos({
      columnId: columnId,
      box: box,
      parentBox: parentBox,
      orientation: orientation,
      dotSize: dotSize
    });
    var y = getYPos({
      element: __element,
      columnId: columnId,
      box: box,
      parentBox: parentBox,
      orientation: orientation,
      dotSize: dotSize
    });
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: id
    }, /*#__PURE__*/React__default.createElement("circle", {
      id: id,
      className: cn$1('lemo-dot-highlight', {
        'lemo-selected': option.isSelected || option.isWaitingForMatch
      }),
      cx: x || 0,
      cy: y || 0,
      r: SVG_PROPS.DOT_SIZE[line_thickness]
    }), /*#__PURE__*/React__default.createElement("circle", {
      id: id,
      className: cn$1('lemo-dot', {
        'lemo-selected': option.isSelected || option.isWaitingForMatch
      }),
      cx: x || 0,
      cy: y || 0,
      r: SVG_PROPS.DOT_SIZE[line_thickness] / 2,
      style: _extends({}, !evaluationReady && !(option.isSelected || option.isWaitingForMatch) && {
        fill: line_color
      })
    }));
  }));
}
function getYPos(_ref2) {
  var element = _ref2.element,
    columnId = _ref2.columnId,
    box = _ref2.box,
    orientation = _ref2.orientation,
    dotSize = _ref2.dotSize;
  return when()["case"](orientation !== COLUMNS_DIRECTIONS_TYPES.HORIZONTAL, function () {
    return element.offsetTop + (box.height + dotSize) / 2;
  })["case"](columnId === SVG_PROPS.INPUT, function () {
    return element.offsetTop + box.height + dotSize + emDistance;
  })["case"](columnId === SVG_PROPS.OUTPUT, function () {
    return element.offsetTop + emDistance;
  }).resolve(function () {
    return 0;
  });
}
function getXPos(_ref3) {
  var columnId = _ref3.columnId,
    box = _ref3.box,
    parentBox = _ref3.parentBox,
    orientation = _ref3.orientation,
    dotSize = _ref3.dotSize;
  return when()["case"](orientation === COLUMNS_DIRECTIONS_TYPES.HORIZONTAL, function () {
    return box.left + box.width / 2 - parentBox.left;
  })["case"](columnId === SVG_PROPS.INPUT, function () {
    return box.right + dotSize * 2 - parentBox.left;
  })["case"](columnId === SVG_PROPS.OUTPUT, function () {
    return box.left - dotSize * 2 - parentBox.left;
  }).resolve(function () {
    return 0;
  });
}
var DotVerticalList$1 = observer(DotVerticalList);

function getBox(itemId) {
  var dom = document.getElementById(itemId);
  return dom !== null && dom !== void 0 && dom.getBBox ? dom.getBBox() : {
    top: 0,
    left: 0,
    height: 0,
    width: 0
  };
}

function RelationLine(_ref) {
  var question = _ref.question,
    answer = _ref.answer,
    evaluationReady = _ref.evaluationReady,
    disabled = _ref.disabled,
    ui_style = _ref.ui_style;
  var inputBox = getBox("option_" + question.id);
  var outputBox = getBox("option_" + answer.id);
  var lineProps = {
    x1: getValidNumber(inputBox.x + inputBox.width / 2),
    y1: getValidNumber(inputBox.y + inputBox.height / 2),
    x2: getValidNumber(outputBox.x + outputBox.width / 2),
    y2: getValidNumber(outputBox.y + outputBox.height / 2)
  };
  var line_thickness = ui_style.line_thickness,
    line_color = ui_style.line_color;
  function resetLine() {
    !disabled && question.removeLink(answer.index);
  }
  return /*#__PURE__*/React__default.createElement("g", {
    key: question.id,
    id: "line_" + question.id
  }, /*#__PURE__*/React__default.createElement("line", _extends({
    "data-testid": "line",
    className: cn$1('lemo-visible-line', {
      'lemo-selected': question.isSelected
    }),
    style: _extends({
      strokeWidth: SVG_PROPS.VISIBLE_LINE[line_thickness]
    }, !evaluationReady && {
      stroke: line_color
    })
  }, lineProps)), /*#__PURE__*/React__default.createElement("line", _extends({
    className: cn$1('lemo-hidden-line'),
    style: {
      stroke: 'red',
      strokeWidth: SVG_PROPS.HIDDEN_LINE[line_thickness],
      cursor: disabled ? 'auto' : 'pointer'
    },
    onClick: resetLine
  }, lineProps)));
}
function getValidNumber(val) {
  return isNaN(val) ? '' : val;
}

function Relations(_ref) {
  var store = _ref.store,
    solutionsMode = _ref.solutionsMode;
  var localState = useLocalObservable(function () {
    var timer;
    return {
      redraw: false,
      updateRedraw: function updateRedraw() {
        var _this = this;
        timer = setTimeout(function () {
          return _this.doUpdate();
        }, 4);
      },
      doUpdate: function doUpdate() {
        this.redraw = true;
      },
      cancelRedraw: function cancelRedraw() {
        clearTimeout(timer);
      }
    };
  });
  var evaluationReady = store.isEvaluated || store.validation.immediateFeedback;
  var disabled = store.isEvaluated || store.disabled;
  useEffect(function () {
    if (!localState.redraw) localState.updateRedraw();
    return function () {
      return localState.cancelRedraw();
    };
  }, [localState.redraw]);
  return !localState.redraw ? null : store.questionOptions.map(function (question) {
    if (!question.answer) return null;
    if (question.value.length === 0) return null;
    return question.answerList.map(function (answer) {
      return /*#__PURE__*/React__default.createElement(RelationLine, {
        key: question.id + "_" + answer.id,
        disabled: disabled,
        ui_style: store.ui_style,
        evaluationReady: evaluationReady,
        question: question,
        answer: answer,
        solutionsMode: solutionsMode
      });
    });
  });
}
var Relations$1 = observer(Relations);

function LineProgress(_ref) {
  var origin = _ref.origin,
    parentElement = _ref.parentElement,
    store = _ref.store;
  var _useState = useState(null),
    cursor = _useState[0],
    setCursor = _useState[1];
  var parentBox = parentElement.current.getBoundingClientRect();
  var trackCursor = useCallback(function (e) {
    return setCursor({
      x: e.clientX - parentBox.left,
      y: e.clientY - parentBox.top
    });
  }, [setCursor]);
  var debounced = debounce(trackCursor, 6);
  var line_thickness = store.ui_style.line_thickness;
  useEffect(function () {
    document.body.addEventListener('mousemove', debounced, false);
    return function () {
      return document.body.removeEventListener('mousemove', debounced);
    };
  }, []);
  return cursor === null ? null : /*#__PURE__*/React__default.createElement("line", {
    className: "lemo-line-progress",
    x1: origin.x,
    y1: origin.y,
    x2: cursor.x,
    y2: cursor.y,
    style: {
      strokeWidth: SVG_PROPS.VISIBLE_LINE[line_thickness]
    }
  });
}
var LineProgress$1 = observer(LineProgress);

var repeat$1 = function repeat(fn, times, timeOut, i) {
  try {
    if (times === void 0) {
      times = 0;
    }
    if (timeOut === void 0) {
      timeOut = 0;
    }
    if (i === void 0) {
      i = 0;
    }
    return Promise.resolve(new Promise(function (resolve) {
      return setTimeout(resolve, timeOut);
    })).then(function () {
      var _temp2 = function () {
        if (times > 0) {
          var _temp = _catch(function () {
            fn(i);
            return Promise.resolve(repeat(fn, times - 1, timeOut, i + 1)).then(function () {});
          }, function () {});
          if (_temp && _temp.then) return _temp.then(function () {});
        }
      }();
      if (_temp2 && _temp2.then) return _temp2.then(function () {});
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

function Stage(_ref) {
  var _target$current;
  var store = _ref.store,
    target = _ref.target,
    solutionsMode = _ref.solutionsMode,
    parentBox = _ref.parentBox;
  var parentElement = useRef(null);
  var _useState = useState(null),
    origin = _useState[0],
    setOrigin = _useState[1];
  var parentBoxChange = JSON.stringify(parentBox);
  var onResize = useCallback(function () {
    store.onRedraw();
  }, [store]);
  var getOriginPoint = useCallback(function () {
    var originId = store.selection.originInstance.id;
    var inputElement = document.getElementById("option_" + originId);
    return inputElement !== null ? {
      x: parseFloat(inputElement.getAttribute('cx')),
      y: parseFloat(inputElement.getAttribute('cy'))
    } : {
      x: 0,
      y: 0
    };
  }, [store.selection.inputInstance]);
  useEffect(function () {
    setOrigin(store.selection.isDrawing ? getOriginPoint() : null);
  }, [store.selection.isDrawing, store.selection.input, store.selection.output]);
  useEffect(function () {
    onResize();
  }, [store.orientation, store.ui_style.column_direction, parentBoxChange]);
  useEffect(function () {
    repeat$1(onResize, 10, 300);
  }, []);
  if (store.redraw === 0 || !(target !== null && target !== void 0 && (_target$current = target.current) !== null && _target$current !== void 0 && _target$current.children)) return null;
  var _target$current$child = target.current.children,
    questions = _target$current$child[0],
    answers = _target$current$child[1];
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-stage', {
      'lemo-is-dragging': store.isDragging
    }),
    ref: parentElement
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: "100%",
    height: parentBox.height,
    onClick: store.clearLine
  }, origin !== null && !store.isEvaluated && /*#__PURE__*/React__default.createElement(LineProgress$1, {
    origin: origin,
    parentElement: parentElement,
    store: store
  }), /*#__PURE__*/React__default.createElement(DotVerticalList$1, {
    parentBox: parentBox,
    solutionsMode: solutionsMode,
    wrapper: questions,
    columnId: SVG_PROPS.INPUT,
    itemList: store.questionOptions,
    orientation: store.ui_style.column_direction,
    store: store
  }), /*#__PURE__*/React__default.createElement(DotVerticalList$1, {
    parentBox: parentBox,
    solutionsMode: solutionsMode,
    wrapper: answers,
    columnId: SVG_PROPS.OUTPUT,
    itemList: solutionsMode ? store.answerOptions : store.answerList,
    orientation: store.ui_style.column_direction,
    store: store
  }), /*#__PURE__*/React__default.createElement(Relations$1, {
    key: store.redraw,
    solutionsMode: solutionsMode,
    store: store,
    parentBox: parentBox
  })));
}
var Stage$1 = observer(Stage);

function LinkingLinesQuestion(props) {
  var store = props.store,
    _props$solutionsMode = props.solutionsMode,
    solutionsMode = _props$solutionsMode === void 0 ? false : _props$solutionsMode;
  var optionsWrapper = useRef(null);
  var size = useSize(optionsWrapper, store.redraw);
  var changedHandlers = /setInput|setOutput|reset|clearLine/;
  var clearSelection = useCallback(function (e) {
    e.key === 'Escape' && store.selection.isDrawing && store.selection.reset();
  }, [store.selection]);
  function onSuccessRenderMathJaxOption() {
    store.onRedraw();
  }
  useEffect(function () {
    document.addEventListener('keydown', clearSelection, false);
    return function () {
      return document.removeEventListener('keydown', clearSelection);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', {
      'lemo-disabled': store.disabled
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: optionsWrapper,
    className: cn$1('lemo-options-wrapper', {
      'lemo-horizontal-direction': store.isHorizontal
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-list lemo-list"
  }, store.questionOptions.map(function (option) {
    return /*#__PURE__*/React__default.createElement(Option$1, {
      key: option.id,
      isOrigin: true,
      option: option,
      store: store,
      solutionsMode: solutionsMode,
      listLength: store.questionOptions.length,
      onClick: function onClick() {
        return store.selection.setInput(option.index);
      },
      onSuccessRenderMathJax: onSuccessRenderMathJaxOption
    });
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-answer-list lemo-list"
  }, (solutionsMode ? store.answerOptions : store.answerList).map(function (option) {
    return /*#__PURE__*/React__default.createElement(Option$1, {
      key: option.id,
      option: option,
      store: store,
      solutionsMode: solutionsMode,
      listLength: store.answerOptions.length,
      onClick: function onClick() {
        return store.selection.setOutput(option.index);
      },
      onSuccessRenderMathJax: function onSuccessRenderMathJax() {
        return onSuccessRenderMathJaxOption();
      }
    });
  }))), /*#__PURE__*/React__default.createElement(Stage$1, {
    store: store,
    target: optionsWrapper,
    solutionsMode: solutionsMode,
    parentBox: size
  })), /*#__PURE__*/React__default.createElement("div", {
    "data-isdragging": store.isDragging ? 'YES' : 'NO'
  }));
}
var LinkingLinesQuestion$1 = observer(LinkingLinesQuestion);

function Drop(_ref) {
  var drop = _ref.drop,
    isEvaluated = _ref.isEvaluated,
    _onClick = _ref.onClick,
    matchResponse = _ref.matchResponse,
    _onDropOut = _ref.onDropOut,
    hasPinVisible = _ref.hasPinVisible;
  var dropTargets = "." + CONTAINER_DRAGS_CLASS + ", .lemo-drop-area";
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-drop-area-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-drop-area', {
      'lemo-selected': drop.isSelected,
      'lemo-lock': isEvaluated,
      'lemo-success': drop.isSuccess,
      'lemo-error': drop.isWrong,
      'lemo-is-empty': !drop.drag,
      'lemo-is-dragging-over': drop.isDraggingOver,
      'lemo-is-highlighted': drop.isHighLighted
    }),
    id: "drop-" + drop.id,
    "data-id": drop.id,
    onClick: function onClick() {
      return drop.drag ? noop : _onClick === null || _onClick === void 0 ? void 0 : _onClick(drop);
    }
  }, drop.drag && /*#__PURE__*/React__default.createElement(Drag$1, {
    drag: drop.drag,
    matchResponse: matchResponse,
    onDropOut: function onDropOut(drag) {
      return _onDropOut(drag);
    },
    onClick: drop.drag.select,
    dropTargets: dropTargets,
    isSuccess: drop.isSuccess,
    isError: drop.isWrong
  })), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-feedback-pin-wrapper', {
      'lemo-has-pin-visible': hasPinVisible
    })
  }, /*#__PURE__*/React__default.createElement(FeedbackPin$1, {
    idx: drop.feedbackIndex,
    result: drop.resultCache,
    visible: drop.withPin && drop.isWrongCache,
    classAdd: 'lemo-base-feedback-pin__option',
    feedback: drop.feedback
  })));
}
var Drop$1 = observer(Drop);

var MatchListRow = function MatchListRow(_ref) {
  var _drop$drag;
  var drop = _ref.drop,
    onClick = _ref.onClick,
    onDropOut = _ref.onDropOut,
    hasPinVisible = _ref.hasPinVisible,
    isEvaluated = _ref.isEvaluated,
    matchResponse = _ref.matchResponse;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-match-list-row', {
      'lemo-disabled': isEvaluated
    }),
    style: {
      zIndex: ((_drop$drag = drop.drag) === null || _drop$drag === void 0 ? void 0 : _drop$drag.z) || 1
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-steam-wrapper lemo-text-body-m-regular lemo-color-text-02"
  }, /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    className: "lemo-steam",
    content: drop.stem
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-arrow-icon-wrapper"
  }, /*#__PURE__*/React__default.createElement(SvgArrowSmRight, {
    className: "lemo-arrow-icon",
    width: 24,
    height: 24
  })), /*#__PURE__*/React__default.createElement(Drop$1, {
    drop: drop,
    isEvaluated: isEvaluated,
    onClick: onClick,
    matchResponse: matchResponse,
    onDropOut: onDropOut,
    hasPinVisible: hasPinVisible
  }));
};
var MatchListRow$1 = observer(MatchListRow);

function MatchListQuestion(props) {
  var _props$store = props.store,
    store = _props$store === void 0 ? false : _props$store,
    solutionsMode = props.solutionsMode,
    _props$onDropOut = props.onDropOut,
    _onDropOut = _props$onDropOut === void 0 ? noop : _props$onDropOut;
  var changedHandlers = /setTitle|setStimulus|setTarget|updateDrag|reset|removeValue|matchResponse|onClickDrop|onClickContainerDrags/;
  var base = useRef(null);
  var autoDrop = useAutoDrop({
    store: store,
    ancestor: base
  });
  useDispatchOnResponseChange({
    store: store,
    changed: props.changed
  });
  function onClickDrag(event, drag) {
    console.log('onClickDrag', store.isAutomaticDrop);
    store.isAutomaticDrop ? autoDrop(event.target, drag) : drag.select();
  }
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', {
      'lemo-disabled': store.disabled
    }),
    ref: base
  }, store.drops.map(function (drop) {
    return /*#__PURE__*/React__default.createElement(MatchListRow$1, {
      key: drop.id,
      drop: drop,
      isEvaluated: store.isEvaluated,
      matchResponse: store.matchResponse,
      onDropOut: _onDropOut,
      hasPinVisible: store.hasPinVisible,
      onClick: drop.select
    });
  }), /*#__PURE__*/React__default.createElement(DragsContainer$1, {
    dragsContainer: store.dragsContainer
  }, store.getDragList(solutionsMode).map(function (drag, idx) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-option-scale",
      key: drag.id
    }, /*#__PURE__*/React__default.createElement(DragWithDuplicates$1, {
      key: drag.id,
      drag: drag,
      showCallOut: idx === 0 && !store.firstInteraction && !store.disabled,
      matchResponse: store.matchResponse,
      onDropOut: function onDropOut(drag) {
        return _onDropOut(drag);
      },
      onClick: function onClick(e) {
        return onClickDrag(e, drag);
      },
      dropTargets: ".lemo-drop-area",
      disabled: !!store.dragDroppedSelected,
      hidden: drag.drop
    }));
  }))));
}
var MatchListQuestion$1 = observer(MatchListQuestion);

function FeedbackPinWrapper(_ref) {
  var item = _ref.item;
  var isVisible = item.withPin && item.isWrongCache;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-feedback-pin-wrapper', {
      'lemo-has-pin-visible': isVisible
    })
  }, /*#__PURE__*/React__default.createElement(FeedbackPin$1, {
    idx: item.feedbackIndex,
    result: item.resultCache,
    visible: isVisible,
    classAdd: 'lemo-base-feedback-pin__option',
    feedback: item.feedback
  }));
}
var FeedbackPinWrapper$1 = observer(FeedbackPinWrapper);

var ColumnItem = function ColumnItem(_ref) {
  var item = _ref.item,
    isMatchList = _ref.isMatchList,
    isLinkingLines = _ref.isLinkingLines;
  var matchClass = item.matchIdx > -1 ? "lemo-match-" + item.matchIdx : '';
  var matchListFeedback = isMatchList && item.columnIdx === 1;
  var linkingLinesFeedback = isLinkingLines && item.columnIdx === 0;
  var enableFeedbackPin = matchListFeedback || linkingLinesFeedback;
  function handleSelect() {
    if (item.isDisabled) return false;
    item.select();
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-column-item', matchClass, {
      'lemo-selected': item.selected,
      'lemo-success': item.isSuccess,
      'lemo-error': item.isWrong
    }),
    "data-testid": "item",
    onClick: handleSelect
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-background"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-text"
  }, /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    content: item.label
  })), enableFeedbackPin && /*#__PURE__*/React__default.createElement(FeedbackPinWrapper$1, {
    item: item
  }));
};
var ColumnItem$1 = observer(ColumnItem);

var Column = function Column(_ref) {
  var testId = _ref.testId,
    column = _ref.column,
    store = _ref.store;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-column-2",
    "data-testid": testId
  }, column.map(function (item) {
    return /*#__PURE__*/React__default.createElement(ColumnItem$1, {
      item: item,
      key: item.id,
      isMatchList: store.isMatchList,
      isLinkingLines: store.isLinkingLines
    });
  }));
};
var Column$1 = observer(Column);

function MatchListMobileQuestion(props) {
  var _props$store = props.store,
    store = _props$store === void 0 ? false : _props$store;
  var changedHandlers = /setTitle|setStimulus|setTarget|updateDrag|reset|removeValue|matchResponse/;
  useEffect(function () {
    if (props.solutionsMode) {
      var _props$changed;
      props === null || props === void 0 ? void 0 : (_props$changed = props.changed) === null || _props$changed === void 0 ? void 0 : _props$changed.call(props);
    }
  }, [store.selectionToString]);
  useEffect(function () {
    var isEmptyResponse = store.getUserResponse().reduce(function (acc, next) {
      return acc + next;
    }, '').length === 0;
    var firstTime = isEmptyResponse && store.workingPair.length === 0;
    if (!props.solutionsMode && !firstTime) {
      var _props$changed2, _store$getResponseWit;
      props === null || props === void 0 ? void 0 : (_props$changed2 = props.changed) === null || _props$changed2 === void 0 ? void 0 : _props$changed2.call(props, {
        output: store.output,
        points: store === null || store === void 0 ? void 0 : store.points,
        response: store === null || store === void 0 ? void 0 : (_store$getResponseWit = store.getResponseWithKey) === null || _store$getResponseWit === void 0 ? void 0 : _store$getResponseWit.call(store),
        store: store
      });
    }
  }, [store.workingPair.length]);
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body lemo-match-list-mobile-question', {
      'lemo-disabled': store.disabled
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-column-container"
  }, /*#__PURE__*/React__default.createElement(Column$1, {
    testId: "leftColumn",
    column: store.leftColumn,
    store: store
  }), /*#__PURE__*/React__default.createElement(Column$1, {
    testId: "rightColumn",
    column: store.rightColumn,
    store: store
  }))));
}
var MatchListMobileQuestion$1 = observer(MatchListMobileQuestion);

var DragModel$4 = types$1.compose(ValueModel, withDuplicates, withZIndex, types$1.model({
  isDragging: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    setIsDragging: function setIsDragging(bool) {
      state.isDragging = bool;
      if (bool) getParent(state, 2).updateFirstInteraction();
    },
    resetTarget: function resetTarget() {
      state.drop && state.drop.reset();
    },
    select: function select() {
      getParent(state, 2).select(state.id);
      getParent(state, 2).updateFirstInteraction();
    },
    setValue: function setValue(value) {
      state.value = value;
      getParent(state, 2).updateNotifier();
    }
  };
}).views(function (state) {
  var getDropTarget = function getDropTarget() {
    return getParent(state, 2).drops.find(function (drop) {
      return drop.value === state.id;
    });
  };
  return {
    get drop() {
      return getDropTarget();
    },
    get isUsed() {
      return !!state.drop;
    },
    get isHighlighted() {
      if (state.itemType === DRAG_DROPPED) {
        return getParent(state, 2).dragSelected || getParent(state, 2).dropSelected || getParent(state, 2).dragDroppedSelected;
      }
      return getParent(state, 2).dropSelected;
    },
    get isSelected() {
      var _getParent, _getParent2;
      return ((_getParent = getParent(state, 2)) === null || _getParent === void 0 ? void 0 : _getParent.dragSelected) === state || ((_getParent2 = getParent(state, 2)) === null || _getParent2 === void 0 ? void 0 : _getParent2.dragDroppedSelected) === state;
    },
    get itemType() {
      return state.drop ? DRAG_DROPPED : DRAG;
    },
    get isValid() {
      return state.dropTarget && state.dropTarget.validResponse === state.value;
    },
    get maxDepth() {
      return isAlive(state) ? getParent(state, 2).maxDepth : state.z;
    }
  };
}));

var DropModel$3 = types$1.compose(withIsDraggingOver, getWithFeedbackResult(normalize$4), withElementFeedback, withZIndex, types$1.model({
  id: types$1.optional(types$1.string, function () {
    return uuid();
  }),
  stem: types$1.string,
  value: types$1.optional(types$1.string, '')
}).actions(function (state) {
  return {
    removeValue: function removeValue() {
      state.value = '';
    },
    select: function select() {
      getParent(state, 2).select(state.id);
    },
    reset: function reset() {
      state.value = '';
    },
    setTarget: function setTarget(dragId) {
      state.value = dragId;
    }
  };
}).views(function (state) {
  return {
    get isDragDroppedSelected() {
      return state.drag && getParent(state, 2).dragDroppedSelected === state.drag;
    },
    get isSelected() {
      return getParent(state, 2).dropSelected === state || state.isDragDroppedSelected;
    },
    get isHighLighted() {
      return getParent(state, 2).highLightDrops;
    },
    get itemType() {
      return state.drag ? DROP_FILL : DROP_EMPTY;
    },
    get index() {
      return getParent(state).findIndex(function (i) {
        return i.id === state.id;
      });
    },
    get isValid() {
      var validResponse = getParent(state, 2).getCurrentSolution(state.index);
      return state.drag && validResponse === state.drag.value;
    },
    get drag() {
      if (!isAlive(state)) return null;
      return state.value.length > 0 && getParent(state, 2).drags.find(function (item) {
        return item.id === state.value;
      });
    },
    get isCanShowElementFeedback() {
      return isCanShowElementFeedbackParam(types.classify.MatchList, state.value === '', false);
    },
    get maxDepth() {
      return getParent(state, 2).maxDepth;
    }
  };
}));
function normalize$4(str) {
  return str.replace(/['|"]/g, '');
}

var withConfigureStore = types$1.model({
  scormData: types$1.optional(ScormModel, {})
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      state.exerciseType = scormTypes.MATCHING;
      state.initScorm();
      onAction(state, function (_ref) {
        var name = _ref.name,
          path = _ref.path;
        if (name === 'reset' && path === '') state.initScorm();
      }, true);
      onSnapshot(state.drops, function () {
        state.drops.forEach(function (item) {
          var _item$drag;
          state.scormData.updateInteractive({
            id: item.id,
            userResponse: (item === null || item === void 0 ? void 0 : (_item$drag = item.drag) === null || _item$drag === void 0 ? void 0 : _item$drag.value) || '',
            result: item.isValid
          });
        });
      });
    },
    initScorm: function initScorm() {
      state.scormData.init(state, state.drops.map(function (item, idx) {
        var _item$drag2;
        return {
          userResponse: (item === null || item === void 0 ? void 0 : (_item$drag2 = item.drag) === null || _item$drag2 === void 0 ? void 0 : _item$drag2.value) || '',
          id: item.id,
          rightAnswer: getAlternativeSolutions(idx, state),
          result: item.isValid
        };
      }));
    }
  };
});

var MatchListStore = types$1.compose(QuestionBaseModel, withWhileDraggingTarget, withSelectedDragDrop, getClosestSolutionModel(checkResponse$6), getWithShuffleOptions('drags'), withValidationModes, withElementFeedbackParent('drops'), SelectionModel$1, withConfigureStore, types$1.model({
  firstInteraction: types$1.optional(types$1["boolean"], false),
  dragsContainer: types$1.optional(DragsContainerModel, {}),
  drops: types$1.optional(types$1.array(DropModel$3), []),
  drags: types$1.array(DragModel$4)
}).actions(function (state) {
  var getDrop = function getDrop(id) {
    return state.drops.find(function (drop) {
      return drop.id === id;
    });
  };
  var getDrag = function getDrag(id) {
    return state.drags.find(function (drag) {
      return drag.id === id;
    });
  };
  return {
    updateFirstInteraction: function updateFirstInteraction() {
      state.firstInteraction = true;
    },
    matchPair: function matchPair(_ref) {
      var dragId = _ref.dragId,
        dropId = _ref.dropId;
      state.updateFirstInteraction();
      if (!dragId || !dropId) return;
      state.matchResponse(dropId, getDrag(dragId));
      state.clearSelection();
    },
    matchResponse: function matchResponse(dropId, drag) {
      var _drag$dropTarget;
      state.updateFirstInteraction();
      if (!!dropId && dropId === ((_drag$dropTarget = drag.dropTarget) === null || _drag$dropTarget === void 0 ? void 0 : _drag$dropTarget.id)) return false;
      var drop = getDrop(dropId);
      if (drag.itemType === DRAG_DROPPED) {
        drag.drop.reset();
      }
      state.clearSelection();
      drop.setTarget(drag.id);
    },
    resetDrag: function resetDrag(drag) {
      drag.resetTarget();
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.string), response)) return false;
      state.clearDrops();
      state.updateFirstInteraction();
      state.drops.forEach(function (item, idx) {
        var currentResponse = response[idx];
        var dropId = item.id;
        var drag = state.drags.find(function (drag) {
          return drag.value === currentResponse && !drag.isUsed;
        });
        if (drag) state.matchResponse(dropId, drag);else item.reset();
      });
    },
    clearDrops: function clearDrops() {
      state.drops.forEach(function (drop) {
        return drop.removeValue();
      });
    },
    reset: function reset() {
      state.baseReset();
      state.clearDrops();
      state.updateNotifier();
      state.firstInteraction = false;
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData, idx) {
      var data = createSnapshot$2(rawData);
      var solution = getCurrentEditorSolution(rawData, idx);
      applySnapshot(state, data);
      state.setResponse(solution);
      state.setIsSolutionMode(true);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    hydrateQuestionPreview: function hydrateQuestionPreview(rawData) {
      try {
        var data = createSnapshot$2(rawData);
        var prevAssetsQuestionApi = state.assetsQuestionApi;
        applySnapshot(state, data);
        state.setIsSolutionMode(false);
        state.setAssetsQuestionApi(prevAssetsQuestionApi);
      } catch (e) {}
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    commitResponseFeedback: function commitResponseFeedback() {
      commitFeedbackMessages({
        state: state,
        collection: state.drops,
        condition: getConditionCommitFeedbackMessages
      });
    }
  };
}).views(function (state) {
  var checkSelectedType = function checkSelectedType(dragType) {
    return state.selection.length === 1 && state.selectedInstances[0].itemType === dragType;
  };
  var getDrag = function getDrag(dragId) {
    return dragId ? state.drags.find(function (_ref2) {
      var id = _ref2.id;
      return id === dragId;
    }) : '';
  };
  return {
    get allInteractives() {
      return [].concat(state.drags, state.drops, [state.dragsContainer]);
    },
    get highLightDrops() {
      return state.selection.length === 1 ? [DRAG_DROPPED, DRAG].includes(state.selectedInstances[0].itemType) : false;
    },
    get dragSelected() {
      return checkSelectedType(DRAG) ? state.selectedInstances[0] : false;
    },
    get dropSelected() {
      return checkSelectedType(DROP_EMPTY) ? state.selectedInstances[0] : false;
    },
    get dragDroppedSelected() {
      return checkSelectedType(DRAG_DROPPED) ? state.selectedInstances[0] : false;
    },
    getUserResponse: function getUserResponse() {
      var userResponse = state.drops.map(function (drop) {
        var _getDrag;
        return ((_getDrag = getDrag(drop.value)) === null || _getDrag === void 0 ? void 0 : _getDrag.value) || '';
      });
      return state.getRealUserResponse(userResponse);
    },
    get dragsOrder() {
      return state.optionsOrder.map(function (idx) {
        return state.drags[idx];
      });
    },
    get baseDrags() {
      return (state.duplicate_responses ? state.dragsOrder : state.dragsOrder.filter(function (drag) {
        return !drag.dropTarget;
      })).filter(function (option) {
        return state.canUseOption(option);
      });
    },
    getDragList: function getDragList(solutionsMode) {
      var list = solutionsMode ? state.drags : state.shuffledOptions;
      return getDragListWithDuplicates(list);
    },
    getDrop: function getDrop(id) {
      return state.drops.find(function (drop) {
        return drop.id === id;
      });
    },
    getDropById: function getDropById(id) {
      return state.drops.find(function (drop) {
        return drop.id === id;
      });
    },
    getSolutions: function getSolutions() {
      return state.validation.value;
    },
    getNumUsesOption: function getNumUsesOption(option) {
      return state.drops.filter(function (drop) {
        return drop.valueId === option.id;
      }).length;
    },
    isNodeDropWithDrag: function isNodeDropWithDrag(event) {
      return (event === null || event === void 0 ? void 0 : event.target.classList.contains('lemo-base-drag-and-drop__drag')) || (event === null || event === void 0 ? void 0 : event.target.classList.contains('lemo-content-wrapper'));
    },
    isNodeDrop: function isNodeDrop(event) {
      return (event === null || event === void 0 ? void 0 : event.target.classList.contains('lemo-drag-dropped-content')) || (event === null || event === void 0 ? void 0 : event.target.classList.contains('lemo-drop-area'));
    },
    get maxDepth() {
      return [].concat(state.drags, state.activeDrags).reduce(function (acc, next) {
        return next.z > acc ? next.z : acc;
      }, 0);
    },
    get hasPinVisible() {
      var getPin = function getPin(drop) {
        return drop.withPin && drop.isWrongCache;
      };
      return state.drops.reduce(function (acc, next) {
        return acc || getPin(next);
      }, false);
    },
    get nextAvailableDrop() {
      return state.drops.find(function (drop) {
        return !drop.drag;
      });
    },
    get isAutomaticDrop() {
      var _state$ui_style;
      return ((state === null || state === void 0 ? void 0 : (_state$ui_style = state.ui_style) === null || _state$ui_style === void 0 ? void 0 : _state$ui_style.automatic_drop) || (config === null || config === void 0 ? void 0 : config.useAutoDrop)) && state.selection.length === 0;
    }
  };
}));
function createDragData$2(value) {
  return {
    id: uuid(),
    value: value
  };
}
function createDragList$2(possible_responses, possible_responses_config) {
  if (!possible_responses_config) {
    return possible_responses.map(createDragData$2);
  }
  return possible_responses_config.reduce(function (acc, next, idx) {
    return [].concat(acc, populate(next.number_duplicates, function () {
      return createDragData$2(possible_responses[idx]);
    }));
  }, []);
}
function checkResponse$6(solution, userResponse) {
  return userResponse.length > 0 ? solution === userResponse : null;
}
function createDrops$2(stimulusList, feedback_responses) {
  return stimulusList.map(function (stem, idx) {
    var _feedback_responses$i;
    return {
      stem: stem,
      feedback: feedback_responses === null || feedback_responses === void 0 ? void 0 : (_feedback_responses$i = feedback_responses[idx]) === null || _feedback_responses$i === void 0 ? void 0 : _feedback_responses$i.feedback
    };
  });
}
function createSnapshot$2(data) {
  var _data$data = data.data,
    possible_responses = _data$data.possible_responses,
    stimulus_list = _data$data.stimulus_list,
    feedback_responses = _data$data.feedback_responses,
    validation = _data$data.validation;
  var responsesLength = validation.valid_response.value.length;
  var responseConfig = getDuplicatesConfig(data.data);
  return _extends({}, data.data, importCommonValues$1(data), {
    validation: withPenaltyPoints(responsesLength, validation),
    drops: createDrops$2(stimulus_list, feedback_responses),
    drags: createDragList$2(possible_responses, responseConfig)
  });
}
function createStore$i(data) {
  return MatchListStore.create(createSnapshot$2(data));
}

function withMatchList() {
  return types$1.model({
    matchList: types$1.optional(types$1.array(types$1.array(types$1.string)), []),
    workingPair: types$1.optional(types$1.array(types$1.string), [])
  }).actions(function (state) {
    var is_repeated = function is_repeated(itemId) {
      return state.workingPair.find(function (i) {
        return i === itemId;
      });
    };
    var is_sameColumn = function is_sameColumn(item) {
      if (state.workingPair.length === 0) return false;
      return getItem(state.workingPair[0]).columnIdx === item.columnIdx;
    };
    var is_removeMatch = function is_removeMatch(item) {
      return state.workingPair.length === 0 && item.matchIdx > -1;
    };
    var is_rematching = function is_rematching(item) {
      return state.workingPair.length > 0 && item.matchIdx > -1;
    };
    var getItem = function getItem(itemId) {
      return state.allItems.find(function (i) {
        return i.id === itemId;
      });
    };
    return {
      select: function select(item) {
        when()["case"](is_removeMatch(item), function () {
          return state.removeMatch(item);
        })["case"](is_rematching(item), function () {
          return state.rematch(item);
        })["case"](state.workingPair.length === 0, function () {
          return state.addToSelection(item.id);
        })["case"](is_repeated(item.id), function () {
          return state.clearSelection();
        })["case"](is_sameColumn(item), function () {
          return state.updateSelection(item.id);
        }).resolve(function () {
          return state.addToSelection(item.id);
        });
        state.matchPair();
      },
      addToSelection: function addToSelection(itemId) {
        state.workingPair.push(itemId);
      },
      updateSelection: function updateSelection(itemId) {
        state.workingPair = [itemId];
      },
      clearSelection: function clearSelection() {
        state.workingPair = [];
      },
      removeMatch: function removeMatch(item) {
        state.matchList = rmItem(item.matchIdx, getSnapshot(state.matchList));
        state.addToSelection(item.id);
      },
      rematch: function rematch(item) {
        state.matchList = rmItem(item.matchIdx, getSnapshot(state.matchList));
        is_sameColumn(item) ? state.updateSelection(item.id) : state.addToSelection(item.id);
      },
      matchPair: function matchPair() {
        if (state.workingPair.length < 2) return false;
        state.matchList.push(getSnapshot(state.workingPair));
        state.clearSelection();
      },
      addToMatchList: function addToMatchList(leftItemId, rightItemId) {
        state.matchList.push([leftItemId, rightItemId]);
      },
      resetMatchList: function resetMatchList() {
        state.matchList = [];
        state.workingPair = [];
      }
    };
  }).views(function (state) {
    return {
      get allSelectedItems() {
        return state.matchList.reduce(function (acc, next) {
          return acc.concat(next);
        }, []).concat(state.workingPair);
      },
      get selectionToString() {
        return state.matchList.reduce(function (acc, next) {
          return acc.concat(next[0], next[1]);
        }, '');
      }
    };
  });
}

var getItemByLabel = function getItemByLabel(value, collection) {
  return collection.find(function (item) {
    return item.label === value;
  });
};
function setResponse(response, state) {
  if (!typeChecker(types$1.array(types$1.string), response)) return false;
  state.resetMatchList();
  response.forEach(function (value, idx) {
    if (state.leftColumn.length > idx) {
      var leftItem = state.inputOrderedList[idx];
      var rightItem = getItemByLabel(value, state.rightColumn);
      if (leftItem && rightItem) {
        state.addToMatchList(leftItem.id, rightItem.id);
      }
    }
  });
}
function getUserResponse(state) {
  var result = [];
  state.leftColumn.forEach(function (item) {
    var _item$target;
    result[item.originalIndex] = (item === null || item === void 0 ? void 0 : (_item$target = item.target) === null || _item$target === void 0 ? void 0 : _item$target.label) || '';
  });
  return result;
}
function checkResponse$7(solution, userResponse) {
  return userResponse.length > 0 ? solution === userResponse : null;
}
function isValid(state) {
  var _state$target, _state$target2;
  if (!state.target || !isAlive(state.target)) return false;
  return state.columnIdx === 0 ? (state === null || state === void 0 ? void 0 : (_state$target = state.target) === null || _state$target === void 0 ? void 0 : _state$target.label) === state.currentResponse : (state === null || state === void 0 ? void 0 : (_state$target2 = state.target) === null || _state$target2 === void 0 ? void 0 : _state$target2.isValid) || false;
}
var matchListUtils = {
  setResponse: setResponse,
  getUserResponse: getUserResponse,
  checkResponse: checkResponse$7,
  isValid: isValid
};

var getItemByOriginalIndex = function getItemByOriginalIndex(value, collection) {
  return collection.find(function (item) {
    return item.originalIndex === value;
  });
};
function setResponse$1(response, state) {
  if (!typeChecker(types$1.array(types$1.array(types$1.number)), response)) return false;
  state.resetMatchList();
  response.forEach(function (value, idx) {
    if (state.leftColumn.length > idx) {
      var leftItem = state.inputOrderedList[idx];
      var itemIndex = value.length > 0 ? value === null || value === void 0 ? void 0 : value[0] : -1;
      var rightItem = getItemByOriginalIndex(itemIndex, state.rightColumn);
      if (leftItem && rightItem) {
        state.addToMatchList(leftItem.id, rightItem.id);
      }
    }
  });
}
function getUserResponse$1(state) {
  var result = [];
  state.leftColumn.forEach(function (item) {
    var _item$target;
    var value = item === null || item === void 0 ? void 0 : (_item$target = item.target) === null || _item$target === void 0 ? void 0 : _item$target.originalIndex;
    result[item.originalIndex] = value !== undefined ? [value] : [];
  });
  return result;
}
function checkResponse$8(solution, userResponse) {
  return userResponse[0] === solution[0];
}
function isValid$1(state) {
  var _state$target, _state$target2;
  if (!state.target || !isAlive(state.target)) return false;
  return state.columnIdx === 0 ? (state === null || state === void 0 ? void 0 : (_state$target = state.target) === null || _state$target === void 0 ? void 0 : _state$target.originalIndex) === state.currentResponse[0] : (state === null || state === void 0 ? void 0 : (_state$target2 = state.target) === null || _state$target2 === void 0 ? void 0 : _state$target2.isValid) || false;
}
var linkingLineUtils = {
  setResponse: setResponse$1,
  getUserResponse: getUserResponse$1,
  checkResponse: checkResponse$8,
  isValid: isValid$1
};

var ItemModel = types$1.compose(getWithFeedbackResult(function (a) {
  return a;
}), withElementFeedback, types$1.model({
  id: types$1.optional(types$1.identifier, function () {
    return uuid();
  }),
  label: types$1.string,
  originalIndex: types$1.number,
  columnIdx: types$1.number
}).actions(function (state) {
  var parent = getParent(state, 2);
  return {
    select: function select() {
      parent.select(state);
    }
  };
}).views(function (state) {
  var parent = getParent(state, 2);
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get selected() {
      if (!isAlive(state)) return false;
      return parent.allSelectedItems.find(function (i) {
        return i === state.id;
      }) !== undefined;
    },
    get matchIdx() {
      if (!isAlive(state)) return -1;
      return parent.matchList.reduce(function (acc, next, idx) {
        if (acc > -1) return acc;
        return next.includes(state.id) ? idx : -1;
      }, -1);
    },
    get targetColumn() {
      return state.columnIdx === 0 ? parent.rightColumn : parent.leftColumn;
    },
    get targetId() {
      if (state.matchIdx === -1) return undefined;
      var matchRow = parent.matchList[state.matchIdx];
      if (matchRow.length < 2) return undefined;
      return matchRow[0] === state.id ? matchRow[1] : matchRow[0];
    },
    get target() {
      if (!state.targetId) return undefined;
      return state.targetColumn.find(function (item) {
        return item.id === state.targetId;
      });
    },
    get currentResponse() {
      var currentSolution = parent === null || parent === void 0 ? void 0 : parent.getCurrentSolution(state.originalIndex);
      return currentSolution !== undefined ? currentSolution : parent.validation.value[state.originalIndex];
    },
    get isValid() {
      return parent.isMatchList ? matchListUtils.isValid(state) : linkingLineUtils.isValid(state);
    },
    get isDisabled() {
      return !parent.isSolutionMode && parent.disabled;
    },
    get isResponseCached() {
      var _getParent = getParent(state, 2),
        isLinkingLines = _getParent.isLinkingLines,
        cacheResponse = _getParent.cacheResponse;
      return isLinkingLines ? cacheResponse[state.originalIndex].length > 0 : cacheResponse.find(function (x) {
        return x === state.label;
      }) !== undefined;
    },
    get isCanShowElementFeedback() {
      var parent = getParent(state, 2);
      var showSolution = parent.showSolution || parent.isAutoFeedbackRunning;
      if (showSolution && !state.isResponseCached) return false;
      var metaName = parent.raw.metadata.name;
      return isCanShowElementFeedbackParam(metaName, !state.selected, false);
    },
    get isWrong() {
      return state.selected && state.feedbackResult === feedback.WRONG;
    }
  };
}));

var withConfigureScorm$9 = types$1.model({
  scormData: types$1.optional(ScormModel, {})
}).actions(function (state) {
  var getItem = function getItem(item, idx) {
    return {
      userResponse: state.getUserResponse()[item.index],
      id: item.id,
      rightAnswer: getAlternativeSolutions(idx, state),
      result: item.isValid
    };
  };
  return {
    afterCreate: function afterCreate() {
      state.exerciseType = scormTypes.MATCHING;
      state.initScorm();
      onAction(state, function (_ref) {
        var name = _ref.name,
          path = _ref.path;
        if (name === 'reset' && path === '') state.initScorm();
      }, true);
      onSnapshot(state.matchList, function () {
        state.leftColumn.forEach(function (item, idx) {
          state.scormData.updateInteractive(getItem(item, idx));
        });
      });
    },
    initScorm: function initScorm() {
      state.scormData.init(state, state.leftColumn.map(function (item, idx) {
        return getItem(item, idx);
      }));
    }
  };
});

var MatchListMobileStore = types$1.compose(QuestionBaseModel, withWhileDraggingTarget, withValidationModes, withShowSolutions, getClosestSolutionModel(checkResponse$9), withMatchList(), withConfigureScorm$9, types$1.model({
  leftColumn: types$1.array(ItemModel),
  rightColumn: types$1.array(ItemModel)
}).actions(function (state) {
  return {
    reset: function reset() {
      state.baseReset();
      state.resetMatchList();
    },
    setResponse: function setResponse(response) {
      if (state.isLinkingLines) return linkingLineUtils.setResponse(response, state);
      if (state.isMatchList) return matchListUtils.setResponse(response, state);
    },
    commitResponseFeedback: function commitResponseFeedback() {
      function getCondition(item) {
        if (!item) return false;
        return (!item.target || !item.isSuccess) && item.feedback && item.isCanShowElementFeedback;
      }
      var collection = state.isMatchList ? state.rightColumn : state.leftColumn;
      commitFeedbackMessages({
        state: state,
        collection: collection,
        condition: getCondition
      });
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var matchList = getSnapshot(state.matchList);
      var workingPair = getSnapshot(state.workingPair);
      var data = _extends({}, createSnapshot$3(rawData), {
        matchList: matchList,
        workingPair: workingPair
      });
      applySnapshot(state, data);
      state.setIsSolutionMode(true);
      state.setResponse(rawData.data.validation.valid_response.value);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    hydrateQuestionPreview: function hydrateQuestionPreview(rawData) {
      try {
        var data = createSnapshot$3(rawData);
        var prevAssetsQuestionApi = state.assetsQuestionApi;
        applySnapshot(state, data);
        state.setIsSolutionMode(false);
        state.setAssetsQuestionApi(prevAssetsQuestionApi);
      } catch (e) {}
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  var metaName = state.raw.metadata.name;
  return {
    get isMatchList() {
      return metaName === normalizedTypes.classify_match_list.value || metaName === normalizedTypes.classify_match_list_mobile.value;
    },
    get isLinkingLines() {
      return metaName === normalizedTypes.classify_linking_lines.value;
    },
    get allItems() {
      return state.leftColumn.concat(state.rightColumn);
    },
    get inputOrderedList() {
      var list = [];
      state.leftColumn.forEach(function (item) {
        list[item.originalIndex] = item;
      });
      return list;
    },
    getUserResponse: function getUserResponse() {
      var userResponse = state.isLinkingLines ? linkingLineUtils.getUserResponse(state) : matchListUtils.getUserResponse(state);
      return state.getRealUserResponse(userResponse);
    }
  };
}));
function createItems(_ref) {
  var items = _ref.items,
    columnIdx = _ref.columnIdx,
    isShuffled = _ref.isShuffled,
    feedbackResponses = _ref.feedbackResponses;
  var list = items.map(function (label, idx) {
    var _feedbackResponses$id;
    return {
      label: label,
      columnIdx: columnIdx,
      originalIndex: idx,
      feedback: feedbackResponses === null || feedbackResponses === void 0 ? void 0 : (_feedbackResponses$id = feedbackResponses[idx]) === null || _feedbackResponses$id === void 0 ? void 0 : _feedbackResponses$id.feedback
    };
  });
  return isShuffled ? shuffle(list) : list;
}
function createSnapshot$3(data) {
  var itemProps = {
    isShuffled: data.data.shuffle_options,
    feedbackResponses: data.data.feedback_responses
  };
  return _extends({}, data.data, importCommonValues$1(data), {
    leftColumn: createItems(_extends({}, itemProps, {
      items: data.data.stimulus_list,
      columnIdx: 0
    })),
    rightColumn: createItems(_extends({}, itemProps, {
      items: data.data.possible_responses,
      columnIdx: 1
    })),
    matchList: []
  });
}
function checkResponse$9(solution, userResponse) {
  return Array.isArray(solution) ? linkingLineUtils.checkResponse(solution, userResponse) : matchListUtils.checkResponse(solution, userResponse);
}
function createStore$j(data) {
  return MatchListMobileStore.create(createSnapshot$3(data));
}

var valueAnswerEmpty = '';
var validationManager = {
  _getNewValidationElementGuid: function _getNewValidationElementGuid(questionGuid, answerGuid) {
    return {
      questionGuid: questionGuid,
      answerGuid: answerGuid
    };
  },
  _getValidationGuid: function _getValidationGuid(validationValueArray, questionsOptions, answersOptions) {
    try {
      var answersOptionGuidsUsed = [];
      var validationGuid = [];
      if (validationValueArray) {
        validationValueArray.forEach(function (value, index) {
          var answerGuid = null;
          answersOptions.forEach(function (answersOption) {
            if (!answerGuid && value && value.toString() && answersOption && answersOption.value && answersOption.value.toString() === value.toString() && answersOptionGuidsUsed.indexOf(answersOption.id) < 0) {
              answersOptionGuidsUsed.push(answersOption.id);
              answerGuid = answersOption.id;
            }
          });
          validationGuid.push({
            questionGuid: questionsOptions[index].id,
            answerGuid: answerGuid
          });
        });
      }
      return validationGuid;
    } catch (error) {
      return null;
    }
  },
  _getValidationAnswerValue: function _getValidationAnswerValue(validationGuid, questionsOptions, answersOptions) {
    var validationIndex = [];
    if (validationGuid) {
      validationGuid.forEach(function (value, index) {
        var answer = answersOptions.find(function (answerOption) {
          return answerOption.id === value.answerGuid;
        });
        validationIndex.push(answer ? answer.value : valueAnswerEmpty);
      });
    }
    return validationIndex;
  },
  _doActionAndUpdateValidationParticular: function _doActionAndUpdateValidationParticular(validationGuid, questionsOptionsAfter, answersOptionsAfter, validationObj, doAction, updateValidationGuid) {
    if (validationGuid) {
      var doActionResult = doAction(validationGuid);
      if (doActionResult) {
        validationGuid = doActionResult;
        updateValidationGuid(validationGuid);
      }
      validationObj.setValue(validationManager._getValidationAnswerValue(validationGuid, questionsOptionsAfter, answersOptionsAfter));
    }
  },
  _doActionAndUpdateValidation: function _doActionAndUpdateValidation(state, validationGuids, questionsOptionsAfter, answersOptionsAfter, doAction) {
    validationManager._doActionAndUpdateValidationParticular(validationGuids.validationValue, questionsOptionsAfter, answersOptionsAfter, state.validation, doAction, function (newValidationGuid) {
      validationGuids.setValidationValue(newValidationGuid);
    });
    if (state.validation.alt_responses) {
      state.validation.alt_responses.forEach(function (alt_response, index) {
        validationManager._doActionAndUpdateValidationParticular(validationGuids.validationAltResponses[index], questionsOptionsAfter, answersOptionsAfter, alt_response, doAction, function (newValidationGuid) {
          var newValidationAltResponses = validationGuids.validationAltResponses;
          newValidationAltResponses[index] = newValidationGuid;
          validationGuids.setValidationAltResponses(newValidationAltResponses);
        });
      });
    }
  },
  _getNewValidationGuidAltResponse: function _getNewValidationGuidAltResponse(state, questionsOptions, answersOptions) {
    var lastValidationAltResponse = state.validation.alt_responses[state.validation.alt_responses.length - 1];
    var valueLastAltResponse = lastValidationAltResponse ? lastValidationAltResponse.value : null;
    var validationAltResponse = validationManager._getValidationGuid(valueLastAltResponse, questionsOptions, answersOptions);
    return validationAltResponse;
  },
  _printVars: function _printVars(state, answersOptions) {
    answersOptions.forEach(function (ans) {
      console.log(ans.id, ans.label);
    });
    console.log('validation', JSON.stringify(state.validation.value));
  },
  onCreateAlternativeSolution: function onCreateAlternativeSolution(state, questionsOptions, answersOptions) {
    state.validationGuids.addValidationAltResponse(validationManager._getNewValidationGuidAltResponse(state, questionsOptions, answersOptions));
  },
  onRemoveAlternativeSolution: function onRemoveAlternativeSolution(state, index) {
    state.validationGuids.removeValidationAltResponse(index);
  },
  onUpdateSolution: function onUpdateSolution(state, questionsOptions, answersOptions, index, solution) {
    if (index === 0) {
      var validationValue = validationManager._getValidationGuid(state.validation.value, questionsOptions, answersOptions);
      state.validationGuids.setValidationValue(validationValue);
    } else if (index > 0 && state.validation.alt_responses && state.validation.alt_responses.length > index - 1) {
      var validationAltResponse = validationManager._getValidationGuid(state.validation.alt_responses[index - 1].value, questionsOptions, answersOptions);
      state.validationGuids.updateValidationAltResponse(validationAltResponse, index - 1);
    }
  },
  onEditAnswer: function onEditAnswer(state, questionsOptionsAfter, answersOptionsAfter) {
    validationManager._doActionAndUpdateValidation(state, state.validationGuids, questionsOptionsAfter, answersOptionsAfter, function (validationGuid) {});
  },
  getValidationGuids: function getValidationGuids(state, questionsOptions, answersOptions) {
    var validationToRet = {};
    var validationValue = validationManager._getValidationGuid(state.validation.value, questionsOptions, answersOptions);
    validationToRet.validationValue = validationValue;
    var validationAltResponses = [];
    if (state.validation.alt_responses) {
      state.validation.alt_responses.forEach(function (alt_response) {
        var validationAltResponse = validationManager._getValidationGuid(alt_response.value, questionsOptions, answersOptions);
        validationAltResponses.push(validationAltResponse);
      });
    }
    validationToRet.validationAltResponses = validationAltResponses;
    return validationToRet;
  },
  addQuestionOption: function addQuestionOption(state, questionsOptionsAfter, answersOptionsAfter, questionInsert) {
    validationManager._doActionAndUpdateValidation(state, state.validationGuids, questionsOptionsAfter, answersOptionsAfter, function (validationGuid) {
      validationGuid.push(validationManager._getNewValidationElementGuid(questionInsert.id, valueAnswerEmpty));
    });
  },
  removeQuestionOption: function removeQuestionOption(state, questionsOptionsAfter, answersOptionsAfter, option) {
    validationManager._doActionAndUpdateValidation(state, state.validationGuids, questionsOptionsAfter, answersOptionsAfter, function (validationGuid) {
      return validationGuid.filter(function (validationElement) {
        return validationElement.questionGuid !== option.id;
      });
    });
  },
  sortQuestionsOptions: function sortQuestionsOptions(state, questionsOptionsAfter, answersOptionsAfter, source, destination) {
    validationManager._doActionAndUpdateValidation(state, state.validationGuids, questionsOptionsAfter, answersOptionsAfter, function (validationGuid) {
      return sortArrayItem(source, destination, validationGuid);
    });
  },
  addAnswerOption: function addAnswerOption(state, questionsOptionsAfter, answersOptionsAfter, answerInsert) {},
  removeAnswerOption: function removeAnswerOption(state, questionsOptionsAfter, answersOptionsAfter, option) {
    validationManager._doActionAndUpdateValidation(state, state.validationGuids, questionsOptionsAfter, answersOptionsAfter, function (validationGuid) {
      return validationGuid.map(function (validationElement) {
        return _extends({}, validationElement, {
          answerGuid: validationElement.answerGuid === option.id ? null : validationElement.answerGuid
        });
      });
    });
  },
  sortAnswerOptions: function sortAnswerOptions(state, questionsOptionsAfter, answersOptionsAfter, source, destination) {
    validationManager._doActionAndUpdateValidation(state, state.validationGuids, questionsOptionsAfter, answersOptionsAfter, function (validationGuid) {});
  }
};

var ValidationGuidModel = types$1.model({
  validationValue: types$1.array(types$1.frozen()),
  validationAltResponses: types$1.array(types$1.frozen())
}).actions(function (state) {
  return {
    setValidationValue: function setValidationValue(validationValue) {
      state.validationValue = validationValue;
    },
    setValidationAltResponses: function setValidationAltResponses(validationAltResponses) {
      state.validationAltResponses = validationAltResponses;
    },
    addValidationAltResponse: function addValidationAltResponse(value) {
      if (!state.validationAltResponses) state.validationAltResponses = [];
      state.validationAltResponses.push(value);
    },
    removeValidationAltResponse: function removeValidationAltResponse(index) {
      if (index >= 0 && index < state.validationAltResponses.length) {
        state.validationAltResponses = state.validationAltResponses.filter(function (_, i) {
          return i !== index;
        });
      }
    },
    updateValidationAltResponse: function updateValidationAltResponse(value, index) {
      if (index >= 0 && state.validationAltResponses && state.validationAltResponses.length > index) {
        state.validationAltResponses[index] = value;
      }
    }
  };
}).views(function (state) {
  return {};
});
var defaultValidationGuisModel = {
  validationValue: [],
  validationAltResponses: []
};

var DragModel$5 = types$1.compose(ValueModel, withNumberDuplicates, types$1.model({}).actions(function (state) {
  return {
    setValue: function setValue(value) {
      state.value = value;
      getParent(state, 2).onUpdateDrag(state.id, state.value, value);
      getParent(state, 2).updateNotifier();
    }
  };
}));

var ResponseModel$4 = types$1.model({
  id: types$1.optional(types$1.string, function () {
    return uuid();
  }),
  value: types$1.optional(types$1.string, ''),
  validResponse: types$1.optional(types$1.string, ''),
  validAlternatives: types$1.optional(ValidAlternatives, {
    responses: []
  })
}).actions(function (state) {
  return {
    setValue: function setValue(value) {
      state.value = value;
    },
    setValidResponse: function setValidResponse(value) {
      state.validResponse = value;
    },
    destroy: function destroy() {
      getParent(state, 2).removeResponse(state);
    }
  };
}).views(function (state) {
  return {
    get index() {
      return getParent(state).findIndex(function (i) {
        return i.id === state.id;
      });
    },
    get validate() {
      return state.value.trim().toLowerCase() === state.validResponse.trim().toLowerCase();
    },
    get isValid() {
      var compareAlternatives = function compareAlternatives(acc, next) {
        return next[0] === state.value ? true : acc;
      };
      return state.validate || state.validAlternatives.validate(compareAlternatives);
    }
  };
});

var withValueId = types$1.model({
  valueId: types$1.optional(types$1.string, ''),
  instanceId: types$1.optional(types$1.string, '')
}).actions(function (state) {
  return {
    setValueId: function setValueId(id) {
      state.valueId = id;
    },
    setInstanceId: function setInstanceId(id) {
      state.instanceId = id;
    },
    resetValueId: function resetValueId() {
      state.valueId = '';
      state.instanceId = '';
    }
  };
});

var DropModel$4 = types$1.compose(withShowSolutionsParent, ResponseModel$4, withIsDraggingOver, withValueId, getWithFeedbackResult(normalize$5), withElementFeedback, withCanSelectedDrop, withZIndex, types$1.model({
  stem: types$1.string,
  value: types$1.optional(types$1.string, '')
}).actions(function (state) {
  return {
    setStem: function setStem(stem) {
      state.stem = stem;
      getParent(state, 2).updateNotifier();
    },
    removeValue: function removeValue() {
      state.value = '';
      state.resetValueId();
    },
    destroy: function destroy() {
      getParent(state, 2).removeValue(state);
    },
    setTarget: function setTarget(drag) {
      state.setValue(drag.value);
      state.setInstanceId(drag.instanceId);
      state.setValueId(drag.id);
    }
  };
}).views(function (state) {
  return {
    get index() {
      return getParent(state).findIndex(function (i) {
        return i.id === state.id;
      });
    },
    get currentValue() {
      return defaultValue('drag.value', state, '');
    },
    get drag() {
      return state.valueId.length > 0 ? getParent(state, 2).activeDrags.find(function (item) {
        return item.instanceId === state.instanceId;
      }) : false;
    },
    get isCanShowElementFeedback() {
      return isCanShowElementFeedbackParam(types.classify.MatchList, state.isEmptyResponse(state.value), false);
    },
    get maxDepth() {
      return getParent(state, 2).maxDepth;
    }
  };
}));
function normalize$5(str) {
  return str.replace(/['|"]/g, '');
}

var MathListBaseModel = types$1.compose(BaseModel$1, withAutomaticDrop);
var MathListUIStyle = createUIStyleModel(MathListBaseModel);

var MatchListEditorStore = types$1.compose(EditorBaseModel, withWhileDraggingTarget, getClosestSolutionModel(checkResponse$a), withValidationModes, withElementFeedbackParent('drops'), types$1.model({
  drops: types$1.optional(types$1.array(DropModel$4), []),
  drags: types$1.array(DragModel$5),
  duplicate_responses: types$1.optional(types$1["boolean"], false),
  shuffle_options: types$1.optional(types$1["boolean"], false),
  optionsOrder: types$1.optional(types$1.array(types$1.number), []),
  validation: ValidationModel,
  ui_style: types$1.optional(MathListUIStyle, defaultUIStyle),
  onUpdateNotifier: types$1.optional(types$1.number, function () {
    return Date.now();
  }),
  validationGuids: types$1.optional(ValidationGuidModel, defaultValidationGuisModel)
}).actions(function (state) {
  function getNumberDuplicatesDefault() {
    return state.drops.length + 1;
  }
  return {
    afterCreate: function afterCreate() {
      state.updateOptionsOrder();
      state.updateValidationGuids();
      onAction(state, function (infoAction) {
        var name = infoAction.name;
        if (name.match(/createAlternativeSolution/)) {
          validationManager.onCreateAlternativeSolution(state, state.drops, state.drags);
        }
        if (name.match(/removeSolution/)) {
          var args = infoAction.args;
          if (args && args.length > 0) {
            var idx = args[0];
            validationManager.onRemoveAlternativeSolution(state, idx - 1);
          }
        }
        if (name.match(/updateSolution/)) {
          var _args = infoAction.args;
          if (_args && _args.length > 1) {
            var _idx = _args[0];
            var solution = _args[1];
            validationManager.onUpdateSolution(state, state.drops, state.drags, _idx, solution);
          }
        }
      }, true);
      onSnapshot(state, function (s) {
        var _s$drags, _state$optionsOrder;
        if (((_s$drags = s.drags) === null || _s$drags === void 0 ? void 0 : _s$drags.length) !== ((_state$optionsOrder = state.optionsOrder) === null || _state$optionsOrder === void 0 ? void 0 : _state$optionsOrder.length)) {
          state.updateOptionsOrder();
        }
      });
    },
    updateValidationGuids: function updateValidationGuids() {},
    updateOptionsOrder: function updateOptionsOrder() {
      state.optionsOrder = function (idxArr) {
        return state.shuffle_options ? shuffle(idxArr) : idxArr;
      }(state.drags.map(function (_, idx) {
        return idx;
      }));
    },
    addDrop: function addDrop() {
      var indexLabel = state.drops ? ' ' + (state.drops.length + 1) : '';
      state.drops.push({
        stem: "" + translate('enunciated') + indexLabel,
        validResponse: ''
      });
      state.updateOptionsOrder();
      state.updateNotifier();
    },
    sortDrops: function sortDrops(source, destination) {
      state.drops = sortArrayItem(source, destination, state.drops);
      state.validation.solutionList.forEach(function (_ref, idx) {
        var value = _ref.value;
        var newSolution = sortArrayItem(source, destination, value);
        state.validation.updateSolution(idx, newSolution);
      });
      state.updateNotifier();
    },
    addDrag: function addDrag() {
      var indexLabel = state.drags ? state.drags.length + 1 : '';
      state.drags.push({
        value: "<p>" + translate('option') + " " + indexLabel + "</p>",
        numberDuplicates: getNumberDuplicatesDefault()
      });
      var elementInsert = state.drags[state.drags.length - 1];
      validationManager.addAnswerOption(state, state.drops, state.drags, elementInsert);
      state.updateOptionsOrder();
      state.updateNotifier();
    },
    sortDrags: function sortDrags(source, destination) {
      state.drags = sortArrayItem(source, destination, state.drags);
      validationManager.sortAnswerOptions(state, state.drops, state.drags, source, destination);
      state.updateNotifier();
    },
    matchResponse: function matchResponse(responseId, option) {
      var response = state.getResponseById(responseId);
      if (response) {
        response.setValue(option.value);
        response.setValueId(option.id);
        state.updateNotifier();
      }
    },
    removeValue: function removeValue(instance) {
      if (getType(instance) === DragModel$5) {
        state.validation.findAndUpdateValue(instance.value, '');
      } else if (getType(instance) === DropModel$4) ;
      destroy(instance);
      state.updateOptionsOrder();
      state.updateNotifier();
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.string), response)) return false;
      response.forEach(function (value, idx) {
        if (state.drops.length > idx && state.drops[idx] && state.drops[idx].setValue) {
          var option = getOptionByValue(value, state.drags);
          state.drops[idx].setValue(value);
          if (option) state.drops[idx].setValueId(option.id);
        }
      });
    },
    clearDrops: function clearDrops() {
      state.drops.forEach(function (drop) {
        return drop.removeValue();
      });
    },
    reset: function reset() {
      state.baseReset();
      state.clearDrops();
      state.updateNotifier();
    },
    setShuffleOptions: function setShuffleOptions(bool) {
      state.shuffle_options = bool;
      state.updateOptionsOrder();
    },
    setDuplicateResponses: function setDuplicateResponses(bool) {
      state.drags.forEach(function (drag) {
        return drag.setNumberDuplicates(bool ? getNumberDuplicatesDefault() : 1);
      });
      state.duplicate_responses = bool;
      state.updateNotifier();
    },
    setData: function setData(data) {
      applySnapshot(state, data);
    },
    updateNotifier: function updateNotifier() {
      state.onUpdateNotifier = Date.now();
    },
    onUpdateDrag: function onUpdateDrag() {
      validationManager.onEditAnswer(state, state.drops, state.drags);
    }
  };
}).views(function (state) {
  return {
    getUserResponse: function getUserResponse() {
      return {};
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$g(rawData);
    },
    get dragsOrder() {
      return state.optionsOrder.map(function (idx) {
        return state.drags[idx];
      });
    },
    get baseDrags() {
      return (state.duplicate_responses ? state.dragsOrder : state.dragsOrder.filter(function (drag) {
        return !drag.dropTarget;
      })).filter(function (option) {
        return state.canUseOption(option);
      });
    },
    getResponseById: function getResponseById(id) {
      return state.drops.find(function (drop) {
        return drop.id === id;
      });
    },
    getDropById: function getDropById(id) {
      return state.drops.find(function (drop) {
        return drop.id === id;
      });
    },
    getSolutions: function getSolutions() {
      return state.validation.value;
    },
    getNumUsesOption: function getNumUsesOption(option) {
      return state.drops.filter(function (drop) {
        return drop.valueId === option.id;
      }).length;
    },
    get output() {
      return exportCommonValues(state, {
        stimulus_list: state.drops.map(function (drop) {
          return drop.stem;
        }),
        possible_responses: state.drags.map(function (drag) {
          return drag.value;
        }),
        possible_responses_config: state.drags.map(function (o) {
          return o.exportToPossibleResponsesConfig(state.duplicate_responses);
        }),
        shuffle_options: state.shuffle_options,
        duplicate_responses: state.duplicate_responses,
        feedback_responses: state.feedbackResponsesOutput
      });
    }
  };
}));
function getOptionByValue(value, list) {
  return list.find(function (item) {
    return item.value === value;
  });
}
function checkResponse$a(a, b) {
  return a === b;
}
function createDrops$3(stimulusList, feedback_responses) {
  return stimulusList.map(function (stem, idx) {
    var _feedback_responses$i;
    return {
      stem: stem,
      feedback: feedback_responses === null || feedback_responses === void 0 ? void 0 : (_feedback_responses$i = feedback_responses[idx]) === null || _feedback_responses$i === void 0 ? void 0 : _feedback_responses$i.feedback
    };
  });
}
function _createSnapshot$g(data) {
  var _data$data = data.data,
    possible_responses = _data$data.possible_responses,
    possible_responses_config = _data$data.possible_responses_config,
    stimulus_list = _data$data.stimulus_list,
    feedback_responses = _data$data.feedback_responses;
  return _extends({}, data.data, importCommonValues$1(data), {
    drops: createDrops$3(stimulus_list, feedback_responses),
    drags: createOptionsFromPossibleResponses(possible_responses, possible_responses_config)
  });
}
function createStore$k(data) {
  var store = MatchListEditorStore.create(_createSnapshot$g(data));
  return store;
}

function DragOption(_ref) {
  var drag = _ref.drag,
    idx = _ref.idx,
    store = _ref.store,
    onClick = _ref.onClick,
    onClickOutsideDrag = _ref.onClickOutsideDrag;
  var _useState = useState(false),
    hasImage = _useState[0],
    sethasImage = _useState[1];
  var _useState2 = useState(false),
    isSelected = _useState2[0],
    setIsSelected = _useState2[1];
  var contentWrapper = useRef();
  var nodeRef = useRef(null);
  var showFeedbackPin = drag.withPin && drag.isWrongCache;
  var isDisabled = store.disabled || store.isEvaluated ? 'lemo-disabled' : '';
  useEffect(function () {
    sethasImage(contentWrapper.current.querySelector('img'));
  }, []);
  useEffect(function () {
    var _store$isEqualsSelect;
    setIsSelected((_store$isEqualsSelect = store.isEqualsSelectedDrag) === null || _store$isEqualsSelect === void 0 ? void 0 : _store$isEqualsSelect.call(store, drag));
  }, [store.selectedDragId]);
  useOnClickOutside(nodeRef, function (event) {
    onClickOutsideDrag === null || onClickOutsideDrag === void 0 ? void 0 : onClickOutsideDrag(event);
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: isDisabled,
    ref: nodeRef
  }, /*#__PURE__*/React__default.createElement(Draggable, {
    key: drag.id,
    draggableId: drag.id,
    index: idx,
    isDragDisabled: store.isEvaluated || store.disabled
  }, function (dragProvider, snapshot) {
    return /*#__PURE__*/React__default.createElement("div", _extends({
      className: 'lemo-drag-wrapper',
      ref: dragProvider.innerRef
    }, dragProvider.draggableProps, dragProvider.dragHandleProps, {
      onClick: onClick
    }), /*#__PURE__*/React__default.createElement("div", {
      ref: contentWrapper,
      className: cn$1('lemo-drag-instance lemo-base-drag-and-drop__drag', {
        'lemo-error': drag.isWrong,
        'lemo-success': drag.isSuccess,
        'lemo-dragging': snapshot.draggingOver
      }, {
        'lemo-base-drag-and-drop__drag--selected': isSelected
      })
    }, /*#__PURE__*/React__default.createElement(HTMLContent$1, {
      className: cn$1('lemo-drag-instance-content', {
        'lemo-has-image': hasImage
      }),
      content: drag.stem
    })), /*#__PURE__*/React__default.createElement("div", {
      className: cn$1('lemo-feedback-pin-wrapper', {
        'lemo-with-feedback-pin': showFeedbackPin
      })
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-feedback-pin-position"
    }, /*#__PURE__*/React__default.createElement(FeedbackPin$1, {
      idx: drag.feedbackIndex,
      result: drag.resultCache,
      visible: showFeedbackPin,
      classAdd: 'lemo-base-feedback-pin__option',
      feedback: drag.feedback
    }))));
  }));
}
var DragOption$1 = observer(DragOption);

function DragList(_ref) {
  var store = _ref.store;
  function onClickDrag(drag, e) {
    if (store && store.onClickDrag) {
      store.onClickDrag(drag);
    }
  }
  function _onClickOutsideDrag(drag, e) {
    if (store && store.onClickOutsideDrag) {
      store.onClickOutsideDrag(drag, e);
    }
  }
  return store.response.map(function (dragIndex, idx) {
    var drag = store.drags.length > dragIndex ? store.drags[dragIndex] : null;
    if (!drag || !isAlive(drag)) return null;
    return /*#__PURE__*/React__default.createElement(DragOption$1, {
      key: drag.id,
      idx: idx,
      drag: drag,
      store: store,
      onClick: function onClick(e) {
        return onClickDrag(drag);
      },
      onClickOutsideDrag: function onClickOutsideDrag(e) {
        return _onClickOutsideDrag(drag, e);
      }
    });
  });
}
var DragList$1 = observer(DragList);

var HORIZONTAL$1 = COLUMNS_DIRECTIONS_TYPES.HORIZONTAL,
  VERTICAL = COLUMNS_DIRECTIONS_TYPES.VERTICAL;
function OrderListQuestion(props) {
  var store = props.store;
  var changedHandlers = /setTitle|setStimulus|setTarget|sortDrags|setStem|setValue|onClickDrag/;
  var forceUpdate = useForceUpdate();
  var onDragEnd = useCallback(function (value) {
    var source = value.source;
    var destination = value.destination;
    source && destination && store.setValue(source.index, destination.index);
  }, [store]);
  useEffect(function () {
    var tracker = reaction(function () {
      return store.drags.map(function (drag) {
        return drag.id;
      });
    }, forceUpdate);
    return function () {
      return tracker();
    };
  }, [store]);
  var isHorizontal = store.ui_style.column_direction === HORIZONTAL$1;
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body')
  }, /*#__PURE__*/React__default.createElement(DragDropContext, {
    onDragEnd: onDragEnd
  }, /*#__PURE__*/React__default.createElement(Droppable, {
    droppableId: "droppable",
    direction: isHorizontal ? HORIZONTAL$1 : VERTICAL,
    ignoreContainerClipping: true
  }, function (dropProvider) {
    return /*#__PURE__*/React__default.createElement("div", _extends({
      className: cn$1('lemo-option-list', {
        'lemo-horizontal-list': isHorizontal
      })
    }, dropProvider.droppableProps, {
      ref: dropProvider.innerRef
    }), /*#__PURE__*/React__default.createElement(DragList$1, {
      store: store
    }), dropProvider.placeholder);
  }))));
}
var OrderListQuestion$1 = observer(OrderListQuestion);

function updateOptionsOrder(random, list) {
  var order = list.map(function (item, idx) {
    return idx;
  });
  return random ? shuffle(order) : order;
}

var withSelectedDrag = types$1.model({
  selectedDragId: types$1.maybe(types$1.string)
}).actions(function (state) {
  return {
    setSelectedDrag: function setSelectedDrag(dragItem) {
      state.selectedDragId = dragItem.id;
    },
    clearSelectedDrag: function clearSelectedDrag() {
      state.selectedDragId = undefined;
    },
    isEqualsSelectedDrag: function isEqualsSelectedDrag(dragItem) {
      if (state.selectedDragId) {
        if (state.selectedDragId === dragItem.id) {
          return true;
        }
      }
      return false;
    },
    onClickDrag: function onClickDrag(dragModel) {
      if (state.isEqualsSelectedDrag(dragModel)) {
        state.clearSelectedDrag();
      } else {
        if (state.selectedDragId) {
          var sourceIndex = state.getIndexDragById(state.selectedDragId);
          var destinationIndex = state.getIndexDragById(dragModel.id);
          sourceIndex >= 0 && destinationIndex >= 0 && state.swapDrags(sourceIndex, destinationIndex);
          state.clearSelectedDrag();
        } else {
          state.setSelectedDrag(dragModel, false);
        }
      }
    },
    onClickOutsideDrag: function onClickOutsideDrag(dragModel, event) {
      if (state.isEqualsSelectedDrag(dragModel)) {
        if (!state.isNodeDrag(event)) {
          state.clearSelectedDrag();
        }
      }
    }
  };
}).views(function (state) {
  return {
    getDragById: function getDragById(id) {
      return state.drags.find(function (drag) {
        return drag.id === id;
      });
    },
    getIndexDragById: function getIndexDragById(id) {
      var collectionOrder = state.response.map(function (dragIndex) {
        return state.drags[dragIndex];
      });
      return collectionOrder.findIndex(function (drag) {
        return drag.id === id;
      });
    },
    isNodeDrag: function isNodeDrag(event) {
      return findUpClass(event === null || event === void 0 ? void 0 : event.target, 'lemo-base-drag-and-drop__drag');
    }
  };
});

var DragModel$6 = types$1.compose(withElementFeedback, withShowSolutionsParent, getWithFeedbackResult(noop), types$1.model({
  id: types$1.optional(types$1.string, function () {
    return uuid();
  }),
  stem: types$1.string
}).views(function (state) {
  var parent = getParent(state, 2);
  return {
    get index() {
      return getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get currentPosition() {
      return parent.response.findIndex(function (i) {
        return i === state.index;
      });
    },
    get currentResponse() {
      return parent.getCurrentSolution(state.index);
    },
    get isValid() {
      return state.currentPosition === state.currentResponse;
    },
    get parent() {
      return parent;
    },
    get isCanShowElementFeedback() {
      return isCanShowElementFeedbackParam(types.classify.OrderList, !parent.hasUpdateResponse, true);
    }
  };
}));

var withConfigureScorm$a = types$1.compose(withScorm, types$1.model({}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      onAction(state, function (_ref) {
        var name = _ref.name,
          path = _ref.path;
        if (name === 'setValue') {
          state.updateScormAfterUserResponse();
        }
        if (name === 'reset' && path === '') state.initScorm();
      }, true);
      setTimeout(state.updateScormAfterUserResponse, 100);
    },
    updateScormAfterUserResponse: function updateScormAfterUserResponse() {
      state.updateScorm(state.getScormStatus());
    }
  };
}).views(function (state) {
  var getSolutions = function getSolutions() {
    return state.validation.solutionList.map(function (_ref2) {
      var value = _ref2.value;
      return value;
    });
  };
  return {
    getScormStatus: function getScormStatus() {
      return {
        id: state.raw.reference,
        userResponse: state.getUserResponse(),
        rightAnswer: getSolutions(),
        result: state.points > 0
      };
    },
    get scormType() {
      return scormTypes.MATCHING;
    },
    getInteractiveListInitScorm: function getInteractiveListInitScorm() {
      return [state.getScormStatus()];
    }
  };
}));

var OrderListQuestionStore = types$1.compose(QuestionBaseModel, getClosestSolutionModel(checkResponse$b), withSelectedDrag, withValidationModes, withElementFeedbackParent('drags'), withSetPrintMode, withConfigureScorm$a, types$1.model({
  drags: types$1.array(DragModel$6),
  response: types$1.optional(types$1.array(types$1.number), []),
  optionsOrder: types$1.optional(types$1.array(types$1.number), []),
  hasUpdateResponse: false
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      state.updateResponse();
    },
    commitResponseFeedback: function commitResponseFeedback() {
      var collectionOrder = state.response.map(function (dragIndex) {
        return state.drags[dragIndex];
      });
      commitFeedbackMessages({
        state: state,
        collection: collectionOrder,
        condition: getConditionCommitFeedbackMessages
      });
    },
    updateResponse: function updateResponse() {
      var indexes = updateOptionsOrder(state.shuffle_options, state.drags);
      state.optionsOrder = indexes;
      state.response = indexes;
    },
    setValue: function setValue(source, destination) {
      state.response = sortArrayItem(source, destination, state.response);
      state.hasUpdateResponse = true;
      state.updateNotifier();
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.number), response)) return false;
      var validResponse = response.reduce(function (acc, next, idx) {
        return [].concat(acc, [typeof next === 'number' ? next : idx]);
      }, []);
      if (validResponse.length !== state.drags.length) return false;
      state.response = validResponse;
      state.updateNotifier();
    },
    resetResponse: function resetResponse() {
      state.response = getSnapshot(state.optionsOrder);
    },
    reset: function reset() {
      state.baseReset();
      state.resetResponse();
      state.hasUpdateResponse = false;
    },
    swapDrags: function swapDrags(source, destination) {
      state.response = swapArrayElements(source, destination, state.response);
      state.updateNotifier();
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot$h(rawData);
      applySnapshot(state, data);
      state.setIsSolutionMode(true);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    hydrateQuestionPreview: function hydrateQuestionPreview(rawData) {
      try {
        var data = state.createSnapshot(rawData);
        var prevAssetsQuestionApi = state.assetsQuestionApi;
        applySnapshot(state, data);
        state.updateResponse();
        state.setIsSolutionMode(false);
        state.setAssetsQuestionApi(prevAssetsQuestionApi);
      } catch (e) {}
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  return {
    getUserResponse: function getUserResponse() {
      var userResponse = getSnapshot(state.response);
      return state.getRealUserResponse(userResponse);
    },
    get shuffle_options() {
      return state.raw.data.shuffle_options;
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$h(rawData);
    },
    getCurrentSolution: function getCurrentSolution(idx) {
      return state.validation.solutionList[state.closestSolution].value.findIndex(function (i) {
        return i === idx;
      });
    },
    getSolutions: function getSolutions() {
      return state.validation.value;
    }
  };
}));
function createDrags(list, validation, feedbackResponses) {
  return list.map(function (stem, idx) {
    var _feedbackResponses$id;
    return {
      stem: stem,
      feedback: (feedbackResponses === null || feedbackResponses === void 0 ? void 0 : (_feedbackResponses$id = feedbackResponses[idx]) === null || _feedbackResponses$id === void 0 ? void 0 : _feedbackResponses$id.feedback) || '',
      validResponse: function (valid) {
        return valid.findIndex(function (item) {
          return item === idx;
        });
      }(validation.valid_response.value)
    };
  });
}
function _createSnapshot$h(data) {
  var _data$data = data.data,
    validation = _data$data.validation,
    list = _data$data.list,
    feedback_responses = _data$data.feedback_responses;
  var responsesLength = validation.valid_response.value.length;
  var drags = createDrags(list, validation, feedback_responses);
  return _extends({}, data.data, importCommonValues$1(data), {
    validation: withPenaltyPoints(responsesLength, validation),
    drags: drags
  });
}
function checkResponse$b(a, b) {
  return a === b;
}
function createStore$l(data) {
  return OrderListQuestionStore.create(_createSnapshot$h(data));
}

var DragModel$7 = types$1.compose(withElementFeedback, types$1.model({
  id: types$1.optional(types$1.string, function () {
    return uuid();
  }),
  stem: types$1.string
}).actions(function (state) {
  return {
    setStem: function setStem(str) {
      state.stem = str;
    },
    destroy: function destroy() {
      getParent(state, 2).removeValue(state);
    }
  };
}).views(function (state) {
  return {
    get index() {
      return getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get currentPosition() {
      return getParent(state, 2).response.findIndex(function (i) {
        return i === state.index;
      });
    }
  };
}));

var OrderListUIStyles = types$1.compose(BaseModel$1, withColumnDirection, types$1.model({}).actions(function (state) {
  return {};
}));

var OrderList = types$1.compose(EditorBaseModel, withElementFeedbackParent('drags'), withSetPrintMode, types$1.model({
  drags: types$1.array(DragModel$7),
  shuffle_options: types$1.optional(types$1["boolean"], true),
  duplicate_responses: types$1.optional(types$1["boolean"], false),
  ui_style: types$1.optional(OrderListUIStyles, defaultUIStyle)
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      onAction(state, function (_ref) {
        var name = _ref.name;
        if (name.match(/createAlternativeSolution/)) {
          state.validation.alt_responses[state.validation.alt_responses.length - 1].setValue(state.drags.map(function (_, idx) {
            return idx;
          }));
        }
        if (name.match(/addDrag/)) {
          state.validation.addNewValue(state.drags.length - 1);
        }
        if (name.match(/destroy/)) {
          state.validation.removeValue(state.drags.length);
        }
        if (name.match(/setStem|addDrag|destroy|sortDrags/)) {
          state.updateNotifier();
        }
      }, true);
    },
    addDrag: function addDrag() {
      var indexLabel = state.drags ? ' ' + (state.drags.length + 1) : '';
      state.drags.push({
        stem: translate('option') + " " + indexLabel,
        validResponse: state.drags.length
      });
      state.updateNotifier();
    },
    sortDrags: function sortDrags(source, destination) {
      state.drags = sortArrayItem(source, destination, state.drags);
      state.updateNotifier();
    },
    swapDrags: function swapDrags(source, destination) {
      state.response = swapArrayElements(source, destination, state.response);
      state.updateNotifier();
    },
    removeValue: function removeValue(instance) {
      destroy(instance);
      state.updateNotifier();
    },
    setShuffleOptions: function setShuffleOptions(bool) {
      state.shuffle_options = bool;
      state.updateQuestionPreview();
    },
    setDuplicateResponses: function setDuplicateResponses(bool) {
      state.duplicate_responses = bool;
    }
  };
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$i(rawData);
    },
    get output() {
      return exportCommonValues(state, {
        list: state.drags.map(function (drag) {
          return drag.stem;
        }),
        shuffle_options: state.shuffle_options,
        duplicate_responses: state.duplicate_responses,
        feedback_responses: state.feedbackResponsesOutput
      });
    }
  };
}));
function createDrags$1(list, validation, feedbackResponses) {
  return list.map(function (stem, idx) {
    var _feedbackResponses$id;
    return {
      stem: stem,
      feedback: (feedbackResponses === null || feedbackResponses === void 0 ? void 0 : (_feedbackResponses$id = feedbackResponses[idx]) === null || _feedbackResponses$id === void 0 ? void 0 : _feedbackResponses$id.feedback) || '',
      validResponse: function (valid) {
        return valid.findIndex(function (item) {
          return item === idx;
        });
      }(validation.valid_response.value)
    };
  });
}
function _createSnapshot$i(data) {
  var _data$data = data.data,
    validation = _data$data.validation,
    list = _data$data.list,
    feedback_responses = _data$data.feedback_responses;
  var responsesLength = validation.valid_response.value.length;
  return _extends({}, data.data, importCommonValues$1(data), {
    validation: withPenaltyPoints(responsesLength, validation),
    drags: createDrags$1(list, validation, feedback_responses)
  });
}
function createStore$m(data) {
  return OrderList.create(_createSnapshot$i(data));
}

var classificationConfig = config.configExercise[types.classify.Classification];
var TableConfig = function TableConfig(_ref) {
  var store = _ref.store;
  var ui_style = store.ui_style;
  var addColumnTitle = useCallback(function () {
    if (ui_style.column_titles.length < ui_style.column_count) {
      ui_style.column_titles.addItem(translate('column') + " " + (ui_style.column_titles.length + 1));
    }
  }, [store]);
  var addRowTitle = useCallback(function () {
    if (ui_style.row_titles.length < ui_style.row_count) {
      ui_style.row_titles.addItem(translate('row') + " " + (ui_style.row_titles.length + 1));
    }
  }, [store]);
  var onChangeColumnCount = function onChangeColumnCount(_ref2) {
    var target = _ref2.target;
    var min = 1;
    var max = classificationConfig.columnCountMax || 5;
    ui_style.setColumnCount(Math.min(parseInt(defaultValue('value', target, min)), max));
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-table-config"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-table-config lemo-flex-row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-column-left lemo-col-2 lemo-stack-layout"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-input-with-label"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-column-label"
  }, translate('column_count')), /*#__PURE__*/React__default.createElement("input", {
    className: "lemo-editor-input-text lemo-base-input",
    type: "number",
    min: 1,
    value: ui_style.column_count.toString(),
    onChange: onChangeColumnCount
  })), /*#__PURE__*/React__default.createElement(EditorSortingList$1, {
    list: ui_style.column_titles.list,
    keyId: "id",
    onDragEnd: ui_style.column_titles.sortColumns
  }, function (itemList, provider) {
    return /*#__PURE__*/React__default.createElement(SimpleListValue$1, {
      item: itemList,
      dragProvider: provider,
      showFeedback: false,
      assetsFroalaApi: getAssetsEditorApi(store.assetsEditorApi)
    });
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-flex-center"
  }, /*#__PURE__*/React__default.createElement(ButtonInline, {
    onClick: addColumnTitle,
    text: translate('add_new_column'),
    icon: /*#__PURE__*/React__default.createElement(SvgPlusCircle, {
      className: "lemo-icon lemo-table-config__icon-plus"
    }),
    disabled: ui_style.column_titles.length >= ui_style.column_count
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-column-right lemo-col-2 lemo-stack-layout"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-input-with-label"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-column-label"
  }, translate('row_count')), /*#__PURE__*/React__default.createElement("input", {
    className: "lemo-editor-input-text lemo-base-input",
    type: "number",
    min: 1,
    value: ui_style.row_count,
    onChange: function onChange(_ref3) {
      var value = _ref3.target.value;
      return ui_style.setRowCount(+value);
    }
  })), /*#__PURE__*/React__default.createElement(EditorSortingList$1, {
    list: ui_style.row_titles.list,
    keyId: "id",
    onDragEnd: ui_style.row_titles.sortColumns
  }, function (itemList, provider) {
    return /*#__PURE__*/React__default.createElement(SimpleListValue$1, {
      item: itemList,
      dragProvider: provider,
      showFeedback: false,
      assetsFroalaApi: getAssetsEditorApi(store.assetsEditorApi)
    });
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-flex-center"
  }, /*#__PURE__*/React__default.createElement(ButtonInline, {
    onClick: addRowTitle,
    text: translate('add_new_row'),
    icon: /*#__PURE__*/React__default.createElement(SvgPlusCircle, {
      className: "lemo-icon lemo-icon lemo-table-config__icon-plus"
    }),
    disabled: ui_style.row_titles.length >= ui_style.row_count
  })))));
};
var TableConfig$1 = observer(TableConfig);

var EditorTableStore = function EditorTableStore(_ref) {
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "lemoid-editor-table",
    icon: /*#__PURE__*/React__default.createElement(SvgFormatListBulleted, null),
    titleBox: translate('table_editor'),
    helpText: translate('table_editor_help'),
    classNameAdd: 'lemo-editor-table'
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement(TableConfig$1, {
    store: store
  })));
};
var EditorTableStore$1 = observer(EditorTableStore);

var _excluded$d = ["store", "changed", "type", "immediateFeedback"];
var ClassificationEditor = function ClassificationEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$d);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setTitle|setStimulus|setValue|setScore|removeResponseByIdx|setTemplate|sortResponses|destroy|setValidResponse|setColumnCount|setRowCount|addItem|sortDrags|addDrag|setShuffleOptions|setDuplicateResponses|setIsEvaluable|updateSolution|createAlternativeSolution|removeSolution|setBackground|toggleWithBox|toggleStack|setStack|setWithBox|sortColumns",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 2
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 3,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref[EDITOR_COMPONENT_COMMON.BACKGROUND] = {
      order: 4
    }, _ref[EDITOR_COMPONENT_COMMON.CLEAR_ALL] = {
      order: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.CLEAR_ALL].order,
      hide: false
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(EditorTableStore$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorAnswerOptionsStore$1, {
    store: store,
    options: store.drags,
    onSortOptions: store.sortDrags,
    onClickAddOption: function onClickAddOption() {
      return store.addDrag();
    },
    showToggleShuffleOptions: false,
    showToggleDuplicateResponses: true,
    showNumberDuplicates: store.duplicate_responses,
    keyIdSortingList: "id",
    idBox: "drags",
    titleBox: translate('answer_options'),
    helpText: translate('answer_options_help')
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    evaluationTypes: [getEvaluationTypeOption(keysTranslateEvaluationTypes.EXACT_MATCH, keysTranslateSubtitleEvaluationTypes.EXACT_MATCH, validationModes.EXACT_MATCH), getEvaluationTypeOption(keysTranslateEvaluationTypes.MATCH_RESPONSE, keysTranslateSubtitleEvaluationTypes.MATCH_RESPONSE, validationModes.PARTIAL_MATCH_ELEMENT_V2), getEvaluationTypeOption(keysTranslateEvaluationTypes.MATCH_GROUP, keysTranslateSubtitleEvaluationTypes.MATCH_GROUP, validationModes.PARTIAL_MATCH_V2), getEvaluationTypeOption(keysTranslateEvaluationTypes.MANUAL, keysTranslateSubtitleEvaluationTypes.MANUAL, validationModes.MANUAL)],
    helpText: translate('exact_math_or_match_response_or_match_group_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: [TYPES_CONFIG.CONFIG_SUFFLE_ANSWERS, TYPES_CONFIG.CONFIG_STACK, TYPES_CONFIG.CONFIG_WITH_BOX]
  }));
};
var ClassificationEditor$1 = observer(ClassificationEditor);

function useLinkingLinesEditor(_ref) {
  var store = _ref.store;
  var _useCheckedFeedbackIn = useCheckedFeedbackIndividual({
      responsesFeedback: store.responsesFeedback
    }),
    isCheckedFeedbackIndividual = _useCheckedFeedbackIn.isCheckedFeedbackIndividual,
    setIsCheckedFeedbackIndividual = _useCheckedFeedbackIn.setIsCheckedFeedbackIndividual;
  return {
    isCheckedFeedbackIndividual: isCheckedFeedbackIndividual,
    setIsCheckedFeedbackIndividual: setIsCheckedFeedbackIndividual
  };
}

var _excluded$e = ["store", "changed", "type", "immediateFeedback"];
var LinkingLinesEditor = function LinkingLinesEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$e);
  var _useLinkingLinesEdito = useLinkingLinesEditor({
      store: store
    }),
    isCheckedFeedbackIndividual = _useLinkingLinesEdito.isCheckedFeedbackIndividual,
    setIsCheckedFeedbackIndividual = _useLinkingLinesEdito.setIsCheckedFeedbackIndividual;
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setLabel|sortAnswersOptions|addAnswerOption|setErrorString|setShuffleOptions|sortQuestionsOptions|addQuestionOption|removeQuestionOption|removeAnswerOption|setLineColor|setLineThickness|updateSolution|setFeedbackMode|setIsEvaluable|setColumnDirection",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.STIMULUS] = {
      order: 0
    }, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 3,
      haveFeedbackIndividual: true,
      showConfigFeedbacksIndividual: true,
      onChangeCheckedFeedbackIndividual: setIsCheckedFeedbackIndividual,
      feedbackIndividualLabelText: translate('Text Prompt')
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 4,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref[EDITOR_COMPONENT_COMMON.BACKGROUND] = {
      order: 5
    }, _ref[EDITOR_COMPONENT_COMMON.CLEAR_ALL] = {
      order: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.CLEAR_ALL].order,
      hide: false
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorQuestionsStore$1, {
    store: store,
    options: store.questionsOptions,
    onSortOptions: store.sortQuestionsOptions,
    onClickAddOption: store.addQuestionOption,
    showToggleShuffleOptions: false,
    showToggleDuplicateResponses: false,
    modelGetListString: "label",
    modelSetListString: "setLabel",
    onDeleteOption: store.removeQuestionOption,
    keyIdSortingList: "id",
    idBox: "questions",
    titleBox: translate('Questions options'),
    helpText: translate('linking_lines_questions_help'),
    limit: 6,
    helpTextDisabledAdd: translate('linking_lines_limit_options_help'),
    showNumbersOptions: isCheckedFeedbackIndividual
  }), /*#__PURE__*/React__default.createElement(EditorAnswerOptionsStore$1, {
    store: store,
    options: store.answersOptions,
    onSortOptions: store.sortAnswersOptions,
    onClickAddOption: store.addAnswerOption,
    showToggleShuffleOptions: false,
    showToggleDuplicateResponses: false,
    modelGetListString: "label",
    modelSetListString: "setLabel",
    onDeleteOption: store.removeAnswerOption,
    keyIdSortingList: "id",
    idBox: "answers",
    titleBox: translate('Answer options'),
    helpText: translate('answer_options_help'),
    limit: 6,
    helpTextDisabledAdd: translate('linking_lines_limit_options_help')
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    helpText: translate('exact_math_or_partial_match_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: [TYPES_CONFIG.CONFIG_SUFFLE_ANSWERS, TYPES_CONFIG.CONFIG_LINES_COLOR, TYPES_CONFIG.CONFIG_LINE_THICKNESS, TYPES_CONFIG.CONFIG_COLUMN_DIRECTION]
  }));
};
var LinkingLinesEditor$1 = observer(LinkingLinesEditor);

var LinkedLinesUIStyles = types$1.compose(BaseModel$1, withColumnDirection, types$1.model({
  line_thickness: types$1.optional(types$1.number, LINES_THICKNESS_TYPES.FINE),
  line_color: types$1.optional(types$1.string, '#828282')
}).actions(function (state) {
  return {
    setLineThickness: function setLineThickness(lineThickness) {
      state.line_thickness = lineThickness;
      getParent(state).updateNotifier();
    },
    setLineColor: function setLineColor(lineColor) {
      state.line_color = lineColor;
      getParent(state).updateNotifier();
    }
  };
}));

var QuestionOptionModel$1 = types$1.compose(withElementFeedback, types$1.model({
  id: types$1.optional(types$1.string, function () {
    return uuid();
  }),
  label: types$1.string
}).actions(function (state) {
  return {
    setLabel: function setLabel(val) {
      state.label = val;
      getParent(state, 2).updateNotifier();
    },
    destroy: function destroy() {
      getParent(state, 2).removeOption(state);
    }
  };
}).views(function (state) {
  return {
    get index() {
      var parent = getParent(state);
      return parent.findIndex(function (children) {
        return children === state;
      });
    }
  };
}));

var validationManager$1 = {
  _getNewValidationElementGuid: function _getNewValidationElementGuid(questionGuid, answersGuids) {
    return {
      questionGuid: questionGuid,
      answersGuids: answersGuids
    };
  },
  _getValidationGuid: function _getValidationGuid(validationValueArray, questionsOptions, answersOptions) {
    try {
      var validationGuid = [];
      if (validationValueArray) {
        validationValueArray.forEach(function (value, index) {
          var answersGuids = value.map(function (v) {
            return answersOptions[v].id;
          });
          validationGuid.push({
            questionGuid: questionsOptions[index].id,
            answersGuids: answersGuids
          });
        });
      }
      return validationGuid;
    } catch (error) {
      return null;
    }
  },
  _getValidationIndex: function _getValidationIndex(validationGuid, questionsOptions, answersOptions) {
    var validationIndex = [];
    if (validationGuid) {
      validationGuid.forEach(function (value, index) {
        var answersIds = value.answersGuids.map(function (answerGuid) {
          return answersOptions.findIndex(function (answerOption) {
            return answerOption.id === answerGuid;
          });
        });
        validationIndex.push(answersIds);
      });
    }
    return validationIndex;
  },
  _doActionAndUpdateValidationParticular: function _doActionAndUpdateValidationParticular(questionsOptionsBefore, answersOptionsBefore, questionsOptionsAfter, answersOptionsAfter, validationObj, doAction) {
    var validationGuid = validationManager$1._getValidationGuid(validationObj.value, questionsOptionsBefore, answersOptionsBefore);
    if (validationGuid) {
      var doActionResult = doAction(validationGuid);
      if (doActionResult) {
        validationGuid = doActionResult;
      }
      validationObj.setValue(validationManager$1._getValidationIndex(validationGuid, questionsOptionsAfter, answersOptionsAfter));
    }
  },
  _doActionAndUpdateValidation: function _doActionAndUpdateValidation(state, questionsOptionsBefore, answersOptionsBefore, questionsOptionsAfter, answersOptionsAfter, doAction) {
    validationManager$1._doActionAndUpdateValidationParticular(questionsOptionsBefore, answersOptionsBefore, questionsOptionsAfter, answersOptionsAfter, state.validation, doAction);
    if (state.validation.alt_responses) {
      state.validation.alt_responses.forEach(function (alt_response) {
        validationManager$1._doActionAndUpdateValidationParticular(questionsOptionsBefore, answersOptionsBefore, questionsOptionsAfter, answersOptionsAfter, alt_response, doAction);
      });
    }
  },
  _printVars: function _printVars(state, answersOptions) {
    answersOptions.forEach(function (ans) {
      console.log(ans.id, ans.label);
    });
    console.log('validation', JSON.stringify(state.validation.value));
  },
  addQuestionOption: function addQuestionOption(state, questionsOptionsBefore, answersOptionsBefore, questionsOptionsAfter, answersOptionsAfter, questionInsert) {
    validationManager$1._doActionAndUpdateValidation(state, questionsOptionsBefore, answersOptionsBefore, questionsOptionsAfter, answersOptionsAfter, function (validationGuid) {
      validationGuid.push(validationManager$1._getNewValidationElementGuid(questionInsert.id, []));
    });
  },
  removeQuestionOption: function removeQuestionOption(state, questionsOptionsBefore, answersOptionsBefore, questionsOptionsAfter, answersOptionsAfter, option) {
    validationManager$1._doActionAndUpdateValidation(state, questionsOptionsBefore, answersOptionsBefore, questionsOptionsAfter, answersOptionsAfter, function (validationGuid) {
      return validationGuid.filter(function (validationElement) {
        return validationElement.questionGuid !== option.id;
      });
    });
  },
  sortQuestionsOptions: function sortQuestionsOptions(state, questionsOptionsBefore, answersOptionsBefore, questionsOptionsAfter, answersOptionsAfter, source, destination) {
    validationManager$1._doActionAndUpdateValidation(state, questionsOptionsBefore, answersOptionsBefore, questionsOptionsAfter, answersOptionsAfter, function (validationGuid) {
      return sortArrayItem(source, destination, validationGuid);
    });
  },
  addAnswerOption: function addAnswerOption(state, questionsOptionsBefore, answersOptionsBefore, questionsOptionsAfter, answersOptionsAfter, answerInsert) {},
  removeAnswerOption: function removeAnswerOption(state, questionsOptionsBefore, answersOptionsBefore, questionsOptionsAfter, answersOptionsAfter, option) {
    validationManager$1._doActionAndUpdateValidation(state, questionsOptionsBefore, answersOptionsBefore, questionsOptionsAfter, answersOptionsAfter, function (validationGuid) {
      return validationGuid.map(function (validationElement) {
        return _extends({}, validationElement, {
          answersGuids: validationElement.answersGuids.filter(function (answerGuidElement) {
            return answerGuidElement !== option.id;
          })
        });
      });
    });
  },
  sortAnswerOptions: function sortAnswerOptions(state, questionsOptionsBefore, answersOptionsBefore, questionsOptionsAfter, answersOptionsAfter, source, destination) {
    validationManager$1._doActionAndUpdateValidation(state, questionsOptionsBefore, answersOptionsBefore, questionsOptionsAfter, answersOptionsAfter, function (validationGuid) {});
  }
};

var LinkingLinesStore = types$1.compose(EditorBaseModel, withElementFeedbackParent('questionsOptions'), types$1.model({
  questionsOptions: types$1.array(QuestionOptionModel$1),
  answersOptions: types$1.array(OptionModel$2),
  shuffle_options: types$1.optional(types$1["boolean"], false),
  ui_style: types$1.optional(LinkedLinesUIStyles, defaultUIStyle)
}).actions(function (state) {
  return {
    sortQuestionsOptions: function sortQuestionsOptions(source, destination) {
      var questionsOptionsBefore = JSON.parse(JSON.stringify(state.questionsOptions));
      var answersOptionsBefore = JSON.parse(JSON.stringify(state.answersOptions));
      state.questionsOptions = sortArrayItem(source, destination, state.questionsOptions);
      validationManager$1.sortQuestionsOptions(state, questionsOptionsBefore, answersOptionsBefore, state.questionsOptions, state.answersOptions, source, destination);
      state.updateNotifier();
    },
    addQuestionOption: function addQuestionOption() {
      var questionsOptionsBefore = JSON.parse(JSON.stringify(state.questionsOptions));
      var answersOptionsBefore = JSON.parse(JSON.stringify(state.answersOptions));
      var nextIndexLabel = state.questionsOptions ? ' ' + (state.questionsOptions.length + 1) : '';
      state.questionsOptions.push({
        label: translate('linking_lines_question_option') + nextIndexLabel
      });
      var elementInsert = state.questionsOptions[state.questionsOptions.length - 1];
      validationManager$1.addQuestionOption(state, questionsOptionsBefore, answersOptionsBefore, state.questionsOptions, state.answersOptions, elementInsert);
      state.updateNotifier();
    },
    removeQuestionOption: function removeQuestionOption(option) {
      var questionsOptionsBefore = JSON.parse(JSON.stringify(state.questionsOptions));
      var answersOptionsBefore = JSON.parse(JSON.stringify(state.answersOptions));
      validationManager$1.removeQuestionOption(state, questionsOptionsBefore, answersOptionsBefore, state.questionsOptions, state.answersOptions, option);
      destroy(option);
      state.updateNotifier();
    },
    sortAnswersOptions: function sortAnswersOptions(source, destination) {
      var questionsOptionsBefore = JSON.parse(JSON.stringify(state.questionsOptions));
      var answersOptionsBefore = JSON.parse(JSON.stringify(state.answersOptions));
      state.answersOptions = sortArrayItem(source, destination, state.answersOptions);
      validationManager$1.sortAnswerOptions(state, questionsOptionsBefore, answersOptionsBefore, state.questionsOptions, state.answersOptions, source, destination);
      state.updateNotifier();
    },
    addAnswerOption: function addAnswerOption() {
      var questionsOptionsBefore = JSON.parse(JSON.stringify(state.questionsOptions));
      var answersOptionsBefore = JSON.parse(JSON.stringify(state.answersOptions));
      var nextIndexLabel = state.answersOptions ? ' ' + (state.answersOptions.length + 1) : '';
      state.answersOptions.push({
        label: translate('Answer') + nextIndexLabel
      });
      var elementInsert = state.answersOptions[state.answersOptions.length - 1];
      validationManager$1.addAnswerOption(state, questionsOptionsBefore, answersOptionsBefore, state.questionsOptions, state.answersOptions, elementInsert);
      state.updateNotifier();
    },
    removeAnswerOption: function removeAnswerOption(option) {
      var questionsOptionsBefore = JSON.parse(JSON.stringify(state.questionsOptions));
      var answersOptionsBefore = JSON.parse(JSON.stringify(state.answersOptions));
      destroy(option);
      validationManager$1.removeAnswerOption(state, questionsOptionsBefore, answersOptionsBefore, state.questionsOptions, state.answersOptions, option);
      state.updateNotifier();
    },
    setShuffleOptions: function setShuffleOptions(bool) {
      state.shuffle_options = bool;
      state.updateNotifier();
    },
    clearAll: function clearAll() {
      state.clearAllBase();
      state.questionsOptions.forEach(function (question) {
        return state.removeQuestionOption(question);
      });
      state.answersOptions.forEach(function (answer) {
        return state.removeAnswerOption(answer);
      });
      state.shuffle_options = false;
      state.updateNotifier();
    }
  };
}).views(function (state) {
  return {
    getResults: function getResults() {
      return {};
    },
    getUserResponse: function getUserResponse() {
      return '';
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$j(rawData);
    },
    get output() {
      return exportCommonValues(state, {
        stimulus_list: state.questionsOptions.map(function (question) {
          return question.label;
        }),
        possible_responses: state.answersOptions.map(function (answer) {
          return answer.label;
        }),
        shuffle_options: state.shuffle_options,
        feedback_responses: state.feedbackResponsesOutput
      });
    }
  };
}));
function createQuestionsOptionsFromStimulusList(stimulusList, feedback_responses) {
  return stimulusList.map(function (_stimulus, idx) {
    var _feedback_responses$i;
    return {
      label: _stimulus,
      feedback: feedback_responses === null || feedback_responses === void 0 ? void 0 : (_feedback_responses$i = feedback_responses[idx]) === null || _feedback_responses$i === void 0 ? void 0 : _feedback_responses$i.feedback
    };
  });
}
function createAnswersOptionsFromStimulusList(possibleResponses) {
  return possibleResponses.map(function (_posibleResponse) {
    return {
      label: _posibleResponse
    };
  });
}
function _createSnapshot$j(data) {
  var _data$data = data.data,
    stimulus_list = _data$data.stimulus_list,
    possible_responses = _data$data.possible_responses,
    feedback_responses = _data$data.feedback_responses;
  return _extends({}, data.data, importCommonValues$1(data), {
    questionsOptions: createQuestionsOptionsFromStimulusList(stimulus_list, feedback_responses),
    answersOptions: createAnswersOptionsFromStimulusList(possible_responses)
  });
}
function createStore$n(data) {
  var store = LinkingLinesStore.create(_createSnapshot$j(data));
  return store;
}

function useMatchListEditor(_ref) {
  var store = _ref.store;
  var _useCheckedFeedbackIn = useCheckedFeedbackIndividual({
      responsesFeedback: store.responsesFeedback
    }),
    isCheckedFeedbackIndividual = _useCheckedFeedbackIn.isCheckedFeedbackIndividual,
    setIsCheckedFeedbackIndividual = _useCheckedFeedbackIn.setIsCheckedFeedbackIndividual;
  return {
    isCheckedFeedbackIndividual: isCheckedFeedbackIndividual,
    setIsCheckedFeedbackIndividual: setIsCheckedFeedbackIndividual
  };
}

var _excluded$f = ["store", "changed", "type", "immediateFeedback"];
var MatchListEditor = function MatchListEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$f);
  var _useMatchListEditor = useMatchListEditor({
      store: store
    }),
    isCheckedFeedbackIndividual = _useMatchListEditor.isCheckedFeedbackIndividual,
    setIsCheckedFeedbackIndividual = _useMatchListEditor.setIsCheckedFeedbackIndividual;
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setTitle|setStimulus|setValue|setScore|removeResponseByIdx|setTemplate|sortResponses|destroy|setValidResponse|setStem|sortDrops|addDrag|setShuffleOptions|setDuplicateResponses|addDrop|setIsEvaluable|updateSolution|createAlternativeSolution|removeSolution|setBackground|setDuplicateResponses|matchResponse|removeValue|sortDrags|setNumberDuplicates",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 2,
      haveFeedbackIndividual: true,
      showConfigFeedbacksIndividual: true,
      onChangeCheckedFeedbackIndividual: setIsCheckedFeedbackIndividual,
      feedbackIndividualLabelText: translate('Text Prompt')
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 3,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(EditorQuestionsStore$1, {
    store: store,
    options: store.drops,
    onSortOptions: store.sortDrops,
    onClickAddOption: function onClickAddOption() {
      return store.addDrop();
    },
    showToggleShuffleOptions: false,
    showToggleDuplicateResponses: false,
    modelGetListString: "stem",
    modelSetListString: "setStem",
    keyIdSortingList: "id",
    idBox: "questions",
    titleBox: translate('Questions options'),
    helpText: translate('match_list_questions_help'),
    showNumbersOptions: isCheckedFeedbackIndividual
  }), /*#__PURE__*/React__default.createElement(EditorAnswerOptionsStore$1, {
    store: store,
    options: store.drags,
    onSortOptions: store.sortDrags,
    onClickAddOption: function onClickAddOption() {
      return store.addDrag('');
    },
    showToggleShuffleOptions: false,
    showToggleDuplicateResponses: true,
    showNumberDuplicates: store.duplicate_responses,
    keyIdSortingList: "id",
    idBox: "drags",
    titleBox: translate('answer_options'),
    helpText: translate('answer_options_help')
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    helpText: translate('exact_math_or_partial_match_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: [TYPES_CONFIG.CONFIG_SUFFLE_ANSWERS, TYPES_CONFIG.CONFIG_AUTO_DROP]
  }));
};
var MatchListEditor$1 = observer(MatchListEditor);

function useOrderListEditor(_ref) {
  var store = _ref.store;
  var _useCheckedFeedbackIn = useCheckedFeedbackIndividual({
      responsesFeedback: store.responsesFeedback
    }),
    isCheckedFeedbackIndividual = _useCheckedFeedbackIn.isCheckedFeedbackIndividual,
    setIsCheckedFeedbackIndividual = _useCheckedFeedbackIn.setIsCheckedFeedbackIndividual;
  return {
    isCheckedFeedbackIndividual: isCheckedFeedbackIndividual,
    setIsCheckedFeedbackIndividual: setIsCheckedFeedbackIndividual
  };
}

var _excluded$g = ["store", "changed", "type", "immediateFeedback"];
var OrderListEditor = function OrderListEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$g);
  var _useOrderListEditor = useOrderListEditor({
      store: store
    }),
    isCheckedFeedbackIndividual = _useOrderListEditor.isCheckedFeedbackIndividual,
    setIsCheckedFeedbackIndividual = _useOrderListEditor.setIsCheckedFeedbackIndividual;
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setTitle|setStimulus|setValue|setScore|removeResponseByIdx|setTemplate|sortResponses|destroy|setValidResponse|updateNotifier|addDrag|setShuffleOptions|setIsEvaluable|updateSolution|createAlternativeSolution|removeSolution|setStem|setBackground|setDuplicateResponses|sortDrags|setColumnDirection",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 1,
      haveFeedbackIndividual: true,
      showConfigFeedbacksIndividual: true,
      onChangeCheckedFeedbackIndividual: setIsCheckedFeedbackIndividual,
      feedbackIndividualLabelText: translate('Answer Option')
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 2,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(EditorAnswerOptionsStore$1, {
    store: store,
    options: store.drags,
    onSortOptions: store.sortDrags,
    onClickAddOption: function onClickAddOption() {
      return store.addDrag('');
    },
    showToggleShuffleOptions: false,
    showToggleDuplicateResponses: false,
    modelGetListString: "stem",
    modelSetListString: "setStem",
    keyIdSortingList: "id",
    helpText: translate('answer_options_help'),
    showNumbersOptions: isCheckedFeedbackIndividual
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    helpText: translate('exact_math_or_partial_match_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: [TYPES_CONFIG.CONFIG_SUFFLE_ANSWERS, TYPES_CONFIG.CONFIG_COLUMN_DIRECTION]
  }));
};
var OrderListEditor$1 = observer(OrderListEditor);

function renderClassificationTable(element) {
  var tableWrapper = element.querySelector('.lemo-table-wrapper');
  var table = element.querySelector('.lemo-classification-table');
  return domToImage.toPng(tableWrapper).then(function (dataUrl) {
    var img = new Image();
    img.src = dataUrl;
    table.remove();
    tableWrapper.appendChild(img);
  })["catch"](function (error) {
    console.error('oops, something went wrong!', error);
  });
}

function PrintViewGeneric$4(_ref) {
  var store = _ref.store,
    credentials = _ref.credentials,
    response = _ref.response,
    isEvaluated = _ref.isEvaluated,
    isSolved = _ref.isSolved,
    _ref$onComplete = _ref.onComplete,
    onComplete = _ref$onComplete === void 0 ? noop : _ref$onComplete;
  var root = useRef();
  var _usePrintView = usePrintView({
      store: store,
      root: root,
      credentials: credentials,
      onComplete: onComplete,
      response: response,
      isEvaluated: isEvaluated,
      isSolved: isSolved,
      onQuestionReady: function onQuestionReady() {
        renderClassificationTable(root.current)["finally"](function () {
          return questionBodyToImage(root.current);
        });
      }
    }),
    activity = _usePrintView.activity;
  return activity !== null ? /*#__PURE__*/React__default.createElement("div", {
    key: isSolved ? 'solved' : 'notSolved',
    ref: root,
    className: "lemo-print-view"
  }, /*#__PURE__*/React__default.createElement(activity.Question, null)) : null;
}
var _PrintView$2 = observer(PrintViewGeneric$4);

function DragList$2(_ref) {
  var store = _ref.store,
    matchResponse = _ref.matchResponse;
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "dragList",
    className: cn$1('lemo-drag-list lemo-drop-area', {
      'lemo-selected': store.highlightDragList
    }),
    onClick: store.highlightDragList ? store.resetDragDropped : null,
    "data-id": "none"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-drag-list-container', {
      'lemo-disabled': store.highlightDragList
    })
  }, store.drags.map(function (drag) {
    return /*#__PURE__*/React__default.createElement(Drag$1, {
      key: drag.id,
      drag: drag,
      matchResponse: matchResponse,
      onClick: function onClick() {
        return drag.select();
      },
      dropTargets: ".lemo-drop-area",
      hidden: drag.drop
    });
  })));
}
var DragList$3 = observer(DragList$2);

function Drop$2(_ref) {
  var drop = _ref.drop,
    onClick = _ref.onClick,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "drop",
    onClick: !children ? onClick : null,
    className: cn$1('lemo-drop lemo-drop-area', {
      'lemo-selected': drop.selected,
      'lemo-is-empty': !drop.drag,
      'lemo-success': drop.feedbackResult === feedback.RIGHT,
      'lemo-error': drop.feedbackResult === feedback.WRONG,
      'lemo-is-dragging-over': drop.isDraggingOver,
      'lemo-is-highlighted': drop.isHighlighted
    }),
    "data-id": drop.id
  }, children, !children && /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-drop-index"
  }, drop.index + 1), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-feedback-pin-wrapper', {
      'lemo-with-feedback-pin': drop.isCanShowElementFeedback
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-feedback-pin-position"
  }, /*#__PURE__*/React__default.createElement(FeedbackPin$1, {
    idx: drop.feedbackIndex,
    result: drop.resultCache,
    visible: drop.isCanShowElementFeedback,
    classAdd: 'lemo-base-feedback-pin__option',
    feedback: drop.feedback
  }))));
}
var Drop$3 = observer(Drop$2);

function DropList(_ref) {
  var store = _ref.store,
    matchResponse = _ref.matchResponse;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-drop-list"
  }, store.drops.map(function (drop) {
    var drag = drop.drag;
    return /*#__PURE__*/React__default.createElement(Drop$3, {
      key: drop.id,
      drop: drop,
      onClick: drop.select
    }, drag && /*#__PURE__*/React__default.createElement(Drag$1, {
      key: drag.id,
      drag: drag,
      onClick: function onClick() {
        return drag.select();
      },
      matchResponse: matchResponse,
      dropTargets: ".lemo-drop-area",
      disabled: false
    }));
  }));
}
var DropList$1 = observer(DropList);

function OrderListMobileQuestion(props) {
  var _props$store = props.store,
    store = _props$store === void 0 ? false : _props$store;
  var changedHandlers = /setTitle|setStimulus|setTarget|updateDrag|reset|removeValue|matchResponse|matchPair|setIsDragging|select/;
  function matchResponse(dropId, drag) {
    var drop = store.getDrop(dropId);
    if (dropId === 'drag-list') {
      return drag.resetTarget();
    }
    if (drag.drop && drop.drag) {
      store.swapItems(drag.id, drop.drag.id);
    }
    var dragId = drag.id;
    store.matchPair({
      dropId: dropId,
      dragId: dragId
    });
  }
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', {
      'lemo-disabled': store.disabled
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-column-container"
  }, /*#__PURE__*/React__default.createElement(DragList$3, {
    store: store,
    matchResponse: matchResponse
  }), /*#__PURE__*/React__default.createElement(DropList$1, {
    store: store,
    matchResponse: matchResponse
  }))));
}
var OrderListMobileQuestion$1 = observer(OrderListMobileQuestion);

var DragModel$8 = types$1.compose(withZIndex, types$1.model({
  id: types$1.optional(types$1.identifier, function () {
    return uuid();
  }),
  originalIndex: types$1.number,
  label: types$1.string,
  index: types$1.number,
  isDragging: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  var parent = getParent(state, 2);
  return {
    select: function select() {
      parent.select(state.id);
    },
    setIsDragging: function setIsDragging(bool) {
      state.isDragging = bool;
    },
    resetTarget: function resetTarget() {
      if (state.drop) {
        state.drop.reset();
      }
    }
  };
}).views(function (state) {
  var parent = getParent(state, 2);
  return {
    get isHighlighted() {
      var selectedDrop = parent.selectedDrop,
        selection = parent.selection;
      return !!(selection.length === 1 && selectedDrop);
    },
    get isSelected() {
      var _parent$selectedDrag;
      return ((_parent$selectedDrag = parent.selectedDrag) === null || _parent$selectedDrag === void 0 ? void 0 : _parent$selectedDrag.id) === state.id;
    },
    get drop() {
      if (!isAlive(state)) return null;
      var dropList = parent.drops;
      return dropList.find(function (item) {
        return item.value === state.originalIndex;
      });
    },
    get maxDepth() {
      return isAlive(state) ? parent.maxDepth : state.z;
    },
    get itemType() {
      return state.drop ? DRAG_DROPPED : DRAG;
    },
    get visible() {
      return true;
    },
    get isValid() {
      var _state$drop;
      return state === null || state === void 0 ? void 0 : (_state$drop = state.drop) === null || _state$drop === void 0 ? void 0 : _state$drop.isValid;
    },
    get isWrong() {
      return !state.isValid;
    },
    get value() {
      return state.label;
    }
  };
}));

var DropModel$5 = types$1.compose(withIsDraggingOver, getWithFeedbackResult(function (x) {
  return x;
}), withElementFeedback, types$1.model({
  id: types$1.optional(types$1.identifier, function () {
    return uuid();
  }),
  value: types$1.optional(types$1.number, -1)
}).actions(function (state) {
  var parent = getParent(state, 2);
  return {
    setValue: function setValue(value) {
      state.value = value;
    },
    reset: function reset() {
      state.value = -1;
    },
    select: function select() {
      parent.select(state.id);
    }
  };
}).views(function (state) {
  var parent = getParent(state, 2);
  return {
    get index() {
      return getParent(state).findIndex(function (i) {
        return i.id === state.id;
      });
    },
    get isValid() {
      var index = getParent(state).findIndex(function (i) {
        return i.id === state.id;
      });
      var _getParent = getParent(state, 2),
        solution = _getParent.solution;
      var currentSolution = solution.value[index];
      return currentSolution === state.value;
    },
    get isHighlighted() {
      var selectedDrag = parent.selectedDrag;
      var drop = selectedDrag === null || selectedDrag === void 0 ? void 0 : selectedDrag.drop;
      return when()["case"](!selectedDrag, function () {
        return false;
      })["case"](!drop, function () {
        return true;
      })["case"]((drop === null || drop === void 0 ? void 0 : drop.id) !== state.id, function () {
        return true;
      }).resolve(function () {
        return false;
      });
    },
    get selected() {
      var _parent$selectedDrop;
      return ((_parent$selectedDrop = parent.selectedDrop) === null || _parent$selectedDrop === void 0 ? void 0 : _parent$selectedDrop.id) === state.id;
    },
    get drag() {
      if (!isAlive(state)) return undefined;
      return parent.drags.find(function (_ref) {
        var originalIndex = _ref.originalIndex;
        return originalIndex === state.value;
      });
    },
    get itemType() {
      return state.drag ? DROP_FILL : DROP_EMPTY;
    },
    get label() {
      return state.drag ? state.drag.label : '';
    },
    get answerCache() {
      var _getParent2 = getParent(state, 2),
        cacheResponse = _getParent2.cacheResponse;
      return cacheResponse[state.index];
    },
    get isEmptyResponse() {
      var _getParent3 = getParent(state, 2),
        _getParent3$showSolut = _getParent3.showSolution,
        showSolution = _getParent3$showSolut === void 0 ? false : _getParent3$showSolut,
        _getParent3$internalA = _getParent3.internalAutoFeedback,
        internalAutoFeedback = _getParent3$internalA === void 0 ? false : _getParent3$internalA;
      return !showSolution && !internalAutoFeedback ? state.value === -1 : state.answerCache === -1;
    },
    get feedbackIndex() {
      if (!state.feedback) return -1;
      var match = parent.feedback.responseMessages.findIndex(function (_ref2) {
        var value = _ref2.value;
        return value === state.feedback;
      });
      return match >= 0 ? match + 1 : -1;
    },
    get isCanShowElementFeedback() {
      var templateType = normalizedTypes.classify_order_list_mobile.value;
      if (!getParent(state, 2).isEvaluated) return false;
      if (!state.isEmptyResponse && state.answerCache !== state.value) return true;
      if (state.feedbackResult !== feedback.WRONG) return false;
      if (state.feedback.length === 0) return false;
      return isCanShowElementFeedbackParam(templateType, state.isEmptyResponse, false);
    }
  };
}));

var withConfigureScorm$b = types$1.model({
  scormData: types$1.optional(ScormModel, {})
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      state.exerciseType = scormTypes.MATCHING;
      state.initScorm();
      onAction(state, function (_ref) {
        var name = _ref.name,
          path = _ref.path;
        if (name === 'reset' && path === '') state.initScorm();
      }, true);
      onSnapshot(state.drops, function () {
        state.drops.forEach(function (item) {
          state.scormData.updateInteractive({
            id: item.id,
            userResponse: item.value,
            result: item.isValid
          });
        });
      });
    },
    initScorm: function initScorm() {
      state.scormData.init(state, state.drops.map(function (item, idx) {
        return {
          userResponse: item.value,
          id: item.id,
          rightAnswer: getAlternativeSolutions(idx, state),
          result: item.isValid
        };
      }));
    }
  };
});

var MatchListStore$1 = types$1.compose(QuestionBaseModel, withWhileDraggingTarget, withValidationModes, withShowSolutions, getClosestSolutionModel(checkResponse$c), withElementFeedbackParent('drops'), withConfigureScorm$b, SelectionModel$1, types$1.model({
  drags: types$1.array(DragModel$8),
  drops: types$1.array(DropModel$5),
  selection: types$1.optional(types$1.array(types$1.string), [])
}).actions(function (state) {
  return {
    matchPair: function matchPair(_ref) {
      var dragId = _ref.dragId,
        dropId = _ref.dropId;
      if (!dragId || !dropId) return;
      var drag = state.getDrag(dragId);
      var drop = state.getDrop(dropId);
      drag.resetTarget(drop);
      drop.setValue(drag.originalIndex);
      state.clearSelection();
    },
    reset: function reset() {
      state.baseReset();
      state.clearSelection();
      state.drops.forEach(function (drop, idx) {
        drop.reset();
      });
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.number), response)) return false;
      if (response.length !== state.drags.length) return false;
      state.drops.forEach(function (drop, idx) {
        var currentResponse = response[idx];
        drop.setValue(currentResponse);
      });
    },
    commitResponseFeedback: function commitResponseFeedback() {
      function condition(item) {
        if (!item) return false;
        return item.isWrong && item.feedback && item.isCanShowElementFeedback;
      }
      commitFeedbackMessages({
        state: state,
        condition: condition,
        collection: state.drops
      });
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot$k(rawData);
      applySnapshot(state, data);
      state.setIsSolutionMode(true);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    hydrateQuestionPreview: function hydrateQuestionPreview(rawData) {
      try {
        var data = state.createSnapshot(rawData);
        var prevAssetsQuestionApi = state.assetsQuestionApi;
        applySnapshot(state, data);
        state.setIsSolutionMode(false);
        state.setAssetsQuestionApi(prevAssetsQuestionApi);
      } catch (e) {}
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  return {
    get allInteractives() {
      return [].concat(state.drags, state.drops);
    },
    get highlightDragList() {
      var _state$draggingItem;
      var isMovingDragDropped = ((_state$draggingItem = state.draggingItem) === null || _state$draggingItem === void 0 ? void 0 : _state$draggingItem.drop) || false;
      var whileDraggingOverDragList = state.whileDraggingTarget === 'none' && isMovingDragDropped;
      var bFillSelected = state.selection.length === 1 && state.getItem(state.selection[0]).itemType === DRAG_DROPPED;
      return bFillSelected || whileDraggingOverDragList;
    },
    get selectedDrag() {
      return state.selection.length === 1 ? state.getDrag(state.selection[0]) : undefined;
    },
    get selectedDrop() {
      return state.selection.length === 1 ? state.getDrop(state.selection[0]) : undefined;
    },
    getItem: function getItem(itemId) {
      return state.allInteractives.find(function (d) {
        return d.id === itemId;
      });
    },
    getDrag: function getDrag(itemId) {
      return state.drags.find(function (d) {
        return d.id === itemId;
      });
    },
    getDrop: function getDrop(itemId) {
      return state.drops.find(function (d) {
        return d.id === itemId;
      });
    },
    get draggingItem() {
      return state.drags.find(function (d) {
        return !!d.isDragging;
      });
    },
    getCurrentSolution: function getCurrentSolution(idx) {
      return state.validation.solutionList[state.closestSolution].value.findIndex(function (i) {
        return i === idx;
      });
    },
    getUserResponse: function getUserResponse() {
      return state.drops.map(function (drop) {
        var _drop$drag;
        var index = drop === null || drop === void 0 ? void 0 : (_drop$drag = drop.drag) === null || _drop$drag === void 0 ? void 0 : _drop$drag.originalIndex;
        return typeof index === 'number' ? index : -1;
      });
    },
    getSolutions: function getSolutions() {
      return state.validation.value;
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$k(rawData);
    }
  };
}));
function createDragList$3(list, feedbackList, isShuffle) {
  var defaultList = list.map(function (label, originalIndex) {
    var _feedbackList$origina;
    return {
      originalIndex: originalIndex,
      label: label,
      feedback: feedbackList === null || feedbackList === void 0 ? void 0 : (_feedbackList$origina = feedbackList[originalIndex]) === null || _feedbackList$origina === void 0 ? void 0 : _feedbackList$origina.feedback
    };
  });
  var itemList = isShuffle ? shuffle(defaultList) : defaultList;
  return itemList.map(function (item, index) {
    return _extends({}, item, {
      index: index
    });
  });
}
function createDropList$1(drags, feedbackList) {
  return drags.map(function (_, originalIndex) {
    var _feedbackList$origina2;
    return {
      originalIndex: originalIndex,
      feedback: feedbackList === null || feedbackList === void 0 ? void 0 : (_feedbackList$origina2 = feedbackList[originalIndex]) === null || _feedbackList$origina2 === void 0 ? void 0 : _feedbackList$origina2.feedback
    };
  });
}
function _createSnapshot$k(data) {
  var isShuffle = data.data.shuffle_options;
  var feedbacks = data.data.feedback_responses;
  var drags = createDragList$3(data.data.list, feedbacks, isShuffle);
  var drops = createDropList$1(drags, feedbacks);
  return _extends({}, data.data, importCommonValues$1(data), {
    drags: drags,
    drops: drops
  });
}
function checkResponse$c(a, b) {
  return a === b;
}
function createStore$o(data) {
  return MatchListStore$1.create(_createSnapshot$k(data));
}

function getResponsiveTemplate(templateName, templateProps) {
  var data;
  if (templateProps.data) {
    data = produce(templateProps.data, function (draft) {
      draft.metadata.name = templateName;
    });
  }
  var type = templateName;
  return _extends({}, templateProps, {
    type: type,
    data: data
  });
}

var MAX_WIDTH = 768;
function isMobileResolution() {
  return window.innerWidth < MAX_WIDTH;
}

var XYModel = types$1.model({
  x: types$1.number,
  y: types$1.number
}).actions(function (state) {
  return {
    setPosition: function setPosition(_ref) {
      var x = _ref.x,
        y = _ref.y;
      state.x = x;
      state.y = y;
    },
    setX: function setX(x) {
      state.x = x;
    },
    setY: function setY(y) {
      state.y = y;
    }
  };
});

var withChildrenDuplicates = types$1.model({}).views(function (state) {
  return {
    get hasDuplicates() {
      return getParent(state).reduce(function (acc, next) {
        return when()["case"](next.isUsed, function () {
          return acc;
        })["case"](next.id === state.id, function () {
          return acc;
        })["case"](next.value === state.value, function () {
          return acc + 1;
        }).resolve(function () {
          return acc;
        });
      }, 0);
    }
  };
});

var withStickerProps = types$1.model({
  id: types$1.string,
  key: types$1.string,
  position: types$1.optional(XYModel, {
    x: 0,
    y: 0
  }),
  stickerSize: types$1.maybe(types$1.array(types$1.number)),
  isDragging: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    setStickerSize: function setStickerSize(size) {
      state.stickerSize = size;
    },
    setIsDragging: function setIsDragging(bool) {
      if (!isAlive(state)) return;
      state.isDragging = bool;
      if (bool) getParent(state, 2).updateFirstInteraction();
    },
    setDrop: function setDrop(dropId) {
      state.drop = dropId;
    }
  };
}).views(function (state) {
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get isUsed() {
      return !!state.drop;
    },
    get value() {
      return state.key;
    },
    get itemType() {
      var _getParent = getParent(state, 2),
        dropsZone = _getParent.dropsZone;
      var isDropped = dropsZone.value.includes(state.id);
      return isDropped ? DRAG_DROPPED : DRAG;
    },
    get data() {
      var drags = getParent(state, 2).raw.data.possible_responses;
      return drags.find(function (drag) {
        return drag.id === state.key;
      });
    },
    get imageAlt() {
      return state.data.label;
    },
    get imageSrc() {
      return state.data.image.src;
    },
    get sizeStyles() {
      if (!state.stickerSize) return {};
      return {
        width: state.stickerSize[0] + "em",
        height: state.stickerSize[1] + "em"
      };
    },
    get feedbackStyles() {
      if (!state.stickerSize) return {};
      var padding = 16;
      return {
        width: "calc(" + state.stickerSize[0] + "em + " + padding + "px)",
        height: "calc(" + state.stickerSize[1] + "em + " + padding + "px)"
      };
    }
  };
});

var DragModel$9 = types$1.compose(withChildrenDuplicates, withStickerProps, types$1.model({}).actions(function (state) {
  return {
    setInitialPosition: function setInitialPosition(_ref) {
      var x = _ref.x,
        y = _ref.y;
      var _getParent = getParent(state, 2),
        scaleFactor = _getParent.scaleFactor;
      state.position.setX(x / scaleFactor);
      state.position.setY(y / scaleFactor);
    },
    setPosition: function setPosition(_ref2) {
      var x = _ref2.x,
        y = _ref2.y;
      state.position.setX(x);
      state.position.setY(y);
    },
    resetTarget: function resetTarget() {
      state.position.setX(0);
      state.position.setY(0);
    }
  };
}).views(function (state) {
  return {
    get drop() {
      var drops = getParent(state, 2).drops;
      return drops.find(function (_ref3) {
        var value = _ref3.value;
        return value.find(function (id) {
          return state.id === id;
        });
      });
    },
    get showValidation() {
      var _getParent2 = getParent(state, 2),
        isEvaluated = _getParent2.isEvaluated,
        validation = _getParent2.validation;
      var isImmediate = validation.immediateFeedback;
      return !!state.drop && (isImmediate || isEvaluated);
    }
  };
}));

var HORIZONTAL$2 = 'horizontal';
var DropModel$6 = types$1.compose(withIsDraggingOver, types$1.model({
  id: types$1.string,
  label: types$1.maybe(types$1.string),
  value: types$1.optional(types$1.array(types$1.string), [])
}).actions(function (state) {
  return {
    setValue: function setValue(value) {
      state.value.push(value);
      state.triggerImmediateResponse();
    },
    triggerImmediateResponse: function triggerImmediateResponse() {
      getParent(state, 2).setImmediateResponse(state);
    },
    removeValue: function removeValue(value) {
      state.value = state.value.filter(function (item) {
        return item !== value;
      });
    },
    resetDragPosition: function resetDragPosition(value) {
      var drags = getParent(state, 2).drags;
      var target = drags.find(function (_ref) {
        var id = _ref.id;
        return id === value;
      });
      target === null || target === void 0 ? void 0 : target.resetTarget();
    },
    resetTarget: function resetTarget(value) {
      state.removeValue(value);
      state.resetDragPosition(value);
      state.triggerImmediateResponse();
    },
    clearResponses: function clearResponses() {
      state.value.forEach(function (dragId) {
        return state.resetDragPosition(dragId);
      });
      state.value = [];
      state.triggerImmediateResponse();
    }
  };
}).views(function (state) {
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get data() {
      return getParent(state, 2).raw.data.containers[state.index];
    },
    get x() {
      return state.data.x;
    },
    get y() {
      return state.data.y;
    },
    get width() {
      return state.data.width;
    },
    get height() {
      return state.data.height;
    },
    get orientation() {
      var _state$data;
      return ((_state$data = state.data) === null || _state$data === void 0 ? void 0 : _state$data.orientation) || HORIZONTAL$2;
    },
    get dragList() {
      var dragList = getParent(state, 2).drags;
      return state.value.map(function (dragId) {
        return dragList.find(function (drag) {
          return drag.id === dragId;
        });
      });
    },
    get solution() {
      var mainSolution = getParent(state, 2).validation.value;
      return mainSolution[state.id];
    },
    get maxItems() {
      return state.solution.responses.length;
    },
    get isFullFilled() {
      if (getParent(state, 2).isSolutionMode) return false;
      var _state$data$fixed_ele = state.data.fixed_elements,
        fixed_elements = _state$data$fixed_ele === void 0 ? 0 : _state$data$fixed_ele;
      var maxResponses = state.maxItems - fixed_elements;
      return state.value.length === maxResponses;
    },
    get sequenceList() {
      if (!state.solution) return [];
      var responses = state.solution.responses;
      var _state$data$fixed_ele2 = state.data.fixed_elements,
        fixed_elements = _state$data$fixed_ele2 === void 0 ? 0 : _state$data$fixed_ele2;
      if (responses.length === 0) return [];
      return responses.slice(0, fixed_elements);
    },
    get sequenceDescription() {
      var options = getParent(state, 2).raw.data.possible_responses;
      return state.sequenceList.map(function (itemId) {
        var item = options.find(function (_ref2) {
          var id = _ref2.id;
          return id === itemId;
        });
        return {
          id: uuid(),
          key: itemId,
          imageAlt: item.label,
          imageSrc: item.image.src
        };
      });
    },
    get userResponse() {
      var drags = getParent(state, 2).drags;
      var getDragKey = function getDragKey(dragId) {
        var _drags$find;
        return (_drags$find = drags.find(function (_ref3) {
          var id = _ref3.id;
          return id === dragId;
        })) === null || _drags$find === void 0 ? void 0 : _drags$find.key;
      };
      return [].concat(state.sequenceList, state.value.map(getDragKey));
    },
    get isValid() {
      if (!state.isFullFilled) return false;
      var currentSolution = getParent(state, 2).solutionList[state.index];
      return currentSolution.reduce(function (acc, next) {
        return next ? acc : false;
      }, true);
    },
    get dragDroppedSizeStyle() {
      var itemsLength = getParent(state, 2).isSolutionMode ? state.value.length : state.maxItems;
      var itemSize = 100 / itemsLength;
      return state.orientation === HORIZONTAL$2 ? {
        width: itemSize + "%"
      } : {
        height: itemSize + "%"
      };
    },
    get dropStyle() {
      return {
        flexDirection: state.orientation === HORIZONTAL$2 ? 'row' : 'column',
        height: '100%'
      };
    }
  };
}));

function getContainersFeedback(state) {
  var responseKeys = state.drops.map(function (drop) {
    return drop.id;
  });
  return responseKeys.map(function (dropId) {
    var currentDrop = state.drops.find(function (_ref) {
      var id = _ref.id;
      return id === dropId;
    });
    var solution = getSolutionByDrop(state, currentDrop);
    var userResponse = getResponseByDrop(currentDrop);
    return getFeedbackList(userResponse, solution);
  });
}
function getSolutionByDrop(state, drop) {
  var responses = state.validation.value[drop.id].responses;
  var _drop$data$fixed_elem = drop.data.fixed_elements,
    fixed_elements = _drop$data$fixed_elem === void 0 ? 0 : _drop$data$fixed_elem;
  return responses.slice(fixed_elements);
}
function getResponseByDrop(drop) {
  var _drop$data$fixed_elem2 = drop.data.fixed_elements,
    fixed_elements = _drop$data$fixed_elem2 === void 0 ? 0 : _drop$data$fixed_elem2;
  return drop.userResponse.slice(fixed_elements);
}
function getFeedbackList(response, solution) {
  return solution.map(function (key, idx) {
    return response.length <= idx ? false : response[idx] === key;
  });
}

function withCustomImmediateHandlers() {
  return types$1.model({
    responseList: types$1.optional(types$1.array(ResponseItem), [])
  }).actions(function (state) {
    return {
      setImmediateResponse: function setImmediateResponse(response) {
        if (response.isValid) {
          state.responseList.push({
            itemRef: response.id,
            value: true,
            propagate: false
          });
        } else {
          state.responseList = state.responseList.filter(function (item) {
            return item.itemRef !== response.id;
          });
        }
      }
    };
  }).views(function (state) {
    return {
      get questionCompleted() {
        if (!state.validation.immediateFeedback) return false;
        return state.drops.reduce(function (acc, next) {
          return next.isValid ? acc : false;
        }, true);
      }
    };
  });
}

var withCustomValidationModes = types$1.model().views(function (state) {
  return {
    getExactMatch: function getExactMatch() {
      var solution = state.validation.value;
      return getPartialStats(state.drops, solution).failures === 0 ? state.validation.score : 0;
    },
    getPartialMatch: function getPartialMatch() {
      var _state$validation = state.validation,
        score = _state$validation.score,
        value = _state$validation.value;
      var _getPartialStats = getPartialStats(state.drops, value),
        hits = _getPartialStats.hits;
      var questionsLength = state.drops.length;
      return score / questionsLength * hits;
    },
    getResults: function getResults() {
      var EXACT_MATCH = validationModes$1.EXACT_MATCH,
        PARTIAL_MATCH_V2 = validationModes$1.PARTIAL_MATCH_V2;
      var eq = function eq(type) {
        return type === state.validation.scoring_type;
      };
      if (eq(EXACT_MATCH)) return state.getExactMatch();
      if (eq(PARTIAL_MATCH_V2)) return state.getPartialMatch();
      return 0;
    }
  };
});
function validateDrop(drop, solution) {
  var id = drop.id,
    userResponse = drop.userResponse;
  var currentSolution = solution[id].responses;
  return compareArray(userResponse, currentSolution) ? 1 : 0;
}
function getPartialStats(drops, solution) {
  return drops.reduce(function (acc, next) {
    return validateDrop(next, solution) ? _extends({}, acc, {
      hits: acc.hits + 1
    }) : _extends({}, acc, {
      failures: acc.failures + 1
    });
  }, {
    hits: 0,
    failures: 0
  });
}

var StickersSeriesQuestionStore = types$1.compose(QuestionBaseModel, withCustomImmediateHandlers(), withWhileDraggingTarget, getWithShuffleOptions('drags'), withCustomValidationModes, withXAPIMatchingType$1({
  getSource: function getSource(state) {
    return state.drops.map(function (drop) {
      return drop.id;
    });
  },
  getTarget: function getTarget(state) {
    return state.getDragList().map(function (drag) {
      return drag.key;
    });
  },
  getSolution: function getSolution(props) {
    return props.state.getXAPISolution(props);
  }
}), types$1.model({
  drags: types$1.array(DragModel$9),
  drops: types$1.array(DropModel$6),
  dragsContainer: types$1.optional(DragsContainerModel, {}),
  scaleFactor: types$1.optional(types$1.number, 1),
  temporalMouseCoordinates: types$1.optional(XYModel, {
    x: 0,
    y: 0
  })
}).actions(function (state) {
  return {
    updateFirstInteraction: function updateFirstInteraction() {},
    reset: function reset() {
      state.baseReset();
      state.clearResponses();
    },
    clearResponses: function clearResponses() {
      state.drops.forEach(function (drop) {
        return drop.clearResponses();
      });
    },
    matchResponse: function matchResponse(dropId, drag) {
      if (dropId) {
        var drop = state.drops.find(function (drop) {
          return drop.id === dropId;
        });
        drop.isFullFilled ? drag.resetTarget() : drop.setValue(drag.id);
      }
    },
    setScaleFactor: function setScaleFactor(scaleFactor) {
      state.scaleFactor = scaleFactor;
    },
    setResponse: function setResponse(response) {
      var responseModel = types$1.model({
        responses: types$1.optional(types$1.array(types$1.string), [])
      });
      if (!typeChecker(types$1.map(responseModel), response)) return false;
      state.clearResponses();
      Object.keys(response).forEach(function (dropId, idx) {
        var drop = state.drops.find(function (_ref) {
          var id = _ref.id;
          return id === dropId;
        });
        if (!drop) return;
        var _drop$data$fixed_elem = drop.data.fixed_elements,
          fixed_elements = _drop$data$fixed_elem === void 0 ? 0 : _drop$data$fixed_elem;
        var keyList = response[dropId].responses.slice(fixed_elements);
        keyList.forEach(function (key) {
          var drag = state.drags.find(function (drag) {
            return drag.key === key && !drag.isUsed;
          });
          if (!drag) return;
          drop.setValue(drag.id);
        });
      });
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData, idx) {
      var data = _createSnapshot$l(rawData);
      applySnapshot(state, data);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  return {
    get image() {
      return _extends({}, state.raw.data.image);
    },
    get domContext() {
      return 'context_' + uuid();
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$l(rawData);
    },
    get groupedResponses() {
      return state.raw.data.group_responses;
    },
    getUserResponse: function getUserResponse() {
      return state.drops.reduce(function (acc, next) {
        var _extends2;
        return _extends({}, acc, (_extends2 = {}, _extends2[next.id] = {
          responses: next.userResponse
        }, _extends2));
      }, {});
    },
    getDragList: function getDragList(solutionsMode) {
      var list = solutionsMode ? state.drags : state.shuffledOptions;
      return state.groupedResponses ? getDragListWithDuplicates(list) : state.drags.filter(function (drag) {
        return !drag.drop;
      });
    },
    get dragDroppedList() {
      return state.drags.filter(function (drag) {
        return drag.drop !== undefined;
      });
    },
    get solutionList() {
      return getContainersFeedback(state);
    },
    getResponseById: function getResponseById(id) {
      return state.drops.find(function (response) {
        return response.id === id;
      });
    },
    get draggingOverId() {
      var show_drag_over = state.raw.data.show_drag_over;
      return show_drag_over && state.whileDraggingTarget;
    },
    getXAPISolution: function getXAPISolution(_ref2) {
      var state = _ref2.state,
        source = _ref2.source,
        target = _ref2.target;
      var solution = state.validation.value;
      var langString = getLangString();
      var findTarget = function findTarget(value) {
        return target.find(function (item) {
          return item.description[langString] === value;
        });
      };
      return source.reduce(function (acc, next, idx) {
        var groupName = next.description[langString];
        acc[groupName] = solution[groupName].responses.map(function (item) {
          var _findTarget;
          return ((_findTarget = findTarget(item)) === null || _findTarget === void 0 ? void 0 : _findTarget.id) || '_';
        });
        return acc;
      }, {});
    }
  };
}));
function getDrag(item) {
  return {
    id: uuid(),
    key: item.id
  };
}
function createDrags$2(possible_responses) {
  return possible_responses.reduce(function (acc, next) {
    var itemsLength = next.number_duplicates;
    return [].concat(acc, populate(itemsLength, function () {
      return getDrag(next);
    }));
  }, []);
}
function _createSnapshot$l(data) {
  var _data$data = data.data,
    possible_responses = _data$data.possible_responses,
    validation = _data$data.validation;
  var responsesLength = validation.valid_response.value.length;
  return _extends({}, data.data, importCommonValues$1(data), {
    validation: withPenaltyPoints(responsesLength, validation),
    drags: createDrags$2(possible_responses),
    drops: data.data.containers
  });
}
function createStore$p(data) {
  return StickersSeriesQuestionStore.create(_createSnapshot$l(data));
}

function StickerDragFeedback(_ref) {
  var size = _ref.size,
    isSuccess = _ref.isSuccess,
    isError = _ref.isError;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-sticker-drag-feedback', {
      'lemo-success': isSuccess,
      'lemo-error': isError
    }),
    style: size
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-sticker-drag-feedback-border"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-icon"
  }, isSuccess && /*#__PURE__*/React__default.createElement(SvgCheckBold, {
    className: "lemo-success-icon"
  }), isError && /*#__PURE__*/React__default.createElement(SvgXBold, {
    className: "lemo-error-icon"
  })));
}

function StickerDragContent(_ref) {
  var drag = _ref.drag,
    isError = _ref.isError,
    isSuccess = _ref.isSuccess;
  var imgRef = useRef();
  function updateStickerSize() {
    var imgElement = imgRef.current;
    if (imgElement) {
      imgElement.onload = function () {
        if (!isAlive(drag)) return;
        var widthInPx = imgElement.naturalWidth;
        var heightInPx = imgElement.naturalHeight;
        var fontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
        drag.setStickerSize([widthInPx / fontSize, heightInPx / fontSize]);
      };
    }
  }
  useEffect(function () {
    updateStickerSize();
  }, []);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, drag.showValidation && /*#__PURE__*/React__default.createElement(StickerDragFeedback, {
    size: drag.feedbackStyles,
    isSuccess: isSuccess,
    isError: isError
  }), /*#__PURE__*/React__default.createElement("img", {
    ref: imgRef,
    className: "lemo-sticker-drag-content",
    src: drag.imageSrc,
    alt: drag.imageAlt,
    draggable: false,
    style: drag.sizeStyles
  }));
}
var StickerDragContent$1 = observer(StickerDragContent);

function StickerDrag(_ref) {
  var drag = _ref.drag,
    onClick = _ref.onClick,
    matchResponse = _ref.matchResponse,
    dropTargets = _ref.dropTargets,
    disabled = _ref.disabled,
    hidden = _ref.hidden,
    isError = _ref.isError,
    isSuccess = _ref.isSuccess,
    _ref$onDrop = _ref.onDrop,
    onDrop = _ref$onDrop === void 0 ? noop : _ref$onDrop,
    _ref$keepPositionAfte = _ref.keepPositionAfterDrop,
    keepPositionAfterDrop = _ref$keepPositionAfte === void 0 ? false : _ref$keepPositionAfte;
  var element = useRef(null);
  function handleDrop(dropTarget, delta, e) {
    if (!dropTarget) return drag.resetTarget();
    var targetId = dropTarget.getAttribute('data-id');
    if (targetId === 'none') return drag.resetTarget();
    onDrop({
      targetId: targetId,
      drag: drag,
      delta: delta,
      event: e
    });
    matchResponse(targetId, drag);
  }
  function handleStartDragging(e) {
    var _drag$setMouseDistanc;
    var rect = element.current.getBoundingClientRect();
    var mouseX = event.clientX;
    var mouseY = event.clientY;
    var distanceX = mouseX - rect.left;
    var distanceY = mouseY - rect.top;
    drag === null || drag === void 0 ? void 0 : (_drag$setMouseDistanc = drag.setMouseDistanceShift) === null || _drag$setMouseDistanc === void 0 ? void 0 : _drag$setMouseDistanc.call(drag, {
      x: distanceX,
      y: distanceY
    });
  }
  var _useSimpleDragDrop = useSimpleDragDrop({
      dragModel: drag,
      onStartDragging: handleStartDragging,
      useDragModelPosition: true,
      keepPositionAfterDrop: keepPositionAfterDrop,
      dropTargetClass: dropTargets,
      onDrop: handleDrop,
      onClick: onClick,
      onDropOut: drag.resetTarget
    }),
    dragProps = _useSimpleDragDrop.dragProps,
    isDragging = _useSimpleDragDrop.isDragging;
  useEffect(function () {
    if (isAlive(drag)) {
      drag.setIsDragging(isDragging);
    }
  }, [isDragging, drag]);
  return /*#__PURE__*/React__default.createElement(Draggable$1, _extends({}, dragProps, {
    position: getSnapshot(drag.position),
    disabled: disabled,
    nodeRef: element
  }), /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "drag",
    ref: element,
    className: cn('lemo-sticker-drag', {
      'lemo-dragging': isDragging,
      'lemo-is-dropped': drag.drop,
      'lemo-success': isSuccess,
      'lemo-error': isError
    }),
    style: {
      visibility: hidden ? 'hidden' : 'visible'
    }
  }, /*#__PURE__*/React__default.createElement(StickerDragContent$1, {
    drag: drag,
    isDragging: isDragging,
    hidden: hidden,
    isError: isError,
    isSuccess: isSuccess
  })));
}
var StickerDrag$1 = observer(StickerDrag);

var DROP_AREA = 'lemo-drop-area';
var DROP_TARGET_CLASSES = "." + DROP_AREA + ", ." + CONTAINER_DRAGS_CLASS$1;

function StickerDuplicateInstance(_ref) {
  var src = _ref.src,
    alt = _ref.alt,
    size = _ref.size;
  return /*#__PURE__*/React__default.createElement("img", {
    className: "lemo-sticker-drag-content",
    src: src,
    alt: alt,
    draggable: false,
    style: size
  });
}
var StickerDuplicateInstance$1 = observer(StickerDuplicateInstance);

var DragWithDuplicatesForChildren = function DragWithDuplicatesForChildren(_ref) {
  var drag = _ref.drag,
    matchResponse = _ref.matchResponse,
    dropTargets = _ref.dropTargets,
    disabled = _ref.disabled,
    onDrop = _ref.onDrop,
    _ref$showCallOut = _ref.showCallOut,
    showCallOut = _ref$showCallOut === void 0 ? false : _ref$showCallOut;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-drag-with-duplicates-for-children', {
      'lemo-callout': showCallOut
    })
  }, /*#__PURE__*/React__default.createElement(StickerDrag$1, {
    drag: drag,
    onDrop: onDrop,
    matchResponse: matchResponse,
    dropTargets: dropTargets,
    disabled: disabled,
    keepPositionAfterDrop: true,
    isSuccess: drag.showValidation && drag.isValid,
    isError: drag.showValidation && !drag.isValid
  }), drag.hasDuplicates > 1 && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-sticker-second-drag-duplicate"
  }, /*#__PURE__*/React__default.createElement(StickerDuplicateInstance$1, {
    src: drag.imageSrc,
    alt: drag.imageAlt,
    size: drag.sizeStyles
  })), drag.hasDuplicates > 0 && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-sticker-first-drag-duplicate"
  }, /*#__PURE__*/React__default.createElement(StickerDuplicateInstance$1, {
    src: drag.imageSrc,
    alt: drag.imageAlt,
    size: drag.sizeStyles
  })));
};
var DragWithDuplicatesForChildren$1 = observer(DragWithDuplicatesForChildren);

var useResizeHandler2 = function useResizeHandler2(element, fn) {
  useEffect(function () {
    var handleSize = debounce(function (_ref) {
      var _ref$width = _ref.width,
        width = _ref$width === void 0 ? 0 : _ref$width,
        _ref$height = _ref.height,
        height = _ref$height === void 0 ? 0 : _ref$height,
        element = _ref.element;
      if (element.current) {
        fn({
          w: width,
          h: height
        });
      }
    }, 240);
    var resizeObserver = new ResizeObserver(function (entries) {
      for (var _iterator = _createForOfIteratorHelperLoose(entries), _step; !(_step = _iterator()).done;) {
        var entry = _step.value;
        if (entry && entry.contentRect) {
          var _entry$contentRect = entry.contentRect,
            _entry$contentRect$wi = _entry$contentRect.width,
            width = _entry$contentRect$wi === void 0 ? 0 : _entry$contentRect$wi,
            _entry$contentRect$he = _entry$contentRect.height,
            height = _entry$contentRect$he === void 0 ? 0 : _entry$contentRect$he;
          handleSize({
            width: width,
            height: height,
            element: element
          });
        }
      }
    });
    resizeObserver.observe(element.current);
    return function () {
      return resizeObserver.disconnect();
    };
  }, [element]);
};

function DropArea$1(_ref) {
  var drop = _ref.drop,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: DROP_AREA,
    "data-id": drop.id,
    style: {
      left: drop.x,
      top: drop.y
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-drop-container",
    style: {
      width: drop.width,
      height: drop.height
    }
  }, children));
}
var DropArea$2 = observer(DropArea$1);

var Arrow = function Arrow(_ref) {
  var parentElement = _ref.parentElement;
  return /*#__PURE__*/createElement("svg", {
    className: cn('lemo-arrow', {
      'lemo-visible': parentElement
    }),
    width: 61,
    height: 69,
    fill: "none"
  }, /*#__PURE__*/createElement("path", {
    fill: "#4F4FFF",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 2,
    d: "M58.827 41.373 33.333 66.828a4.01 4.01 0 0 1-5.666 0L2.173 41.373a3.996 3.996 0 0 1 0-5.657 4.01 4.01 0 0 1 5.666 0l18.655 18.627V5c0-2.21 1.794-4 4.006-4a4.003 4.003 0 0 1 4.006 4v49.343l18.655-18.627a4.01 4.01 0 0 1 5.666 0 3.996 3.996 0 0 1 0 5.657Z",
    clipRule: "evenodd"
  }));
};
var Arrow$1 = observer(Arrow);

function DropsZone(_ref) {
  var store = _ref.store;
  var imgRef = useRef();
  var dropsContainerRef = useRef();
  useResizeHandler2(imgRef, function (_ref2) {
    var w = _ref2.w;
    store.setScaleFactor(w / store.image.width);
  });
  useEffect(function () {
    store.setScaleFactor(imgRef.current.clientWidth / store.image.width);
  }, [store.onUpdateNotifier]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-drops-zone",
    style: {
      maxWidth: store.image.width,
      maxHeight: store.image.height
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    ref: imgRef,
    className: "lemo-background",
    src: store.image.src,
    alt: translate('background')
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-drops",
    ref: dropsContainerRef,
    style: {
      transform: "scale(" + store.scaleFactor + ")"
    }
  }, store.drops.map(function (drop, dropIdx) {
    return /*#__PURE__*/React__default.createElement(DropArea$2, {
      key: drop.id,
      drop: drop
    }, /*#__PURE__*/React__default.createElement(Arrow$1, {
      parentElement: store.draggingOverId === drop.id
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-drag-dropped-list",
      style: drop.dropStyle
    }, drop.sequenceDescription.map(function (drag) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "lemo-drag-dropped-container lemo-description",
        key: drag.id,
        onClick: function onClick() {
          return drop.resetTarget(drag.id);
        },
        style: drop.dragDroppedSizeStyle
      }, /*#__PURE__*/React__default.createElement(StickerDragContent$1, {
        drag: drag
      }));
    }), drop.dragList.map(function (drag, dragIdx) {
      var isValid = store.solutionList[dropIdx][dragIdx];
      var isSuccess = drag.showValidation && isValid;
      var isError = drag.showValidation && !isValid;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "lemo-drag-dropped-container",
        key: drag.id,
        onClick: function onClick() {
          return drop.resetTarget(drag.id);
        },
        style: drop.dragDroppedSizeStyle
      }, /*#__PURE__*/React__default.createElement(StickerDragContent$1, {
        drag: drag,
        isSuccess: isSuccess,
        isError: isError
      }));
    })));
  })));
}
var DropsZone$1 = observer(DropsZone);

function StickersSeriesQuestion(props) {
  var _props$store = props.store,
    store = _props$store === void 0 ? false : _props$store,
    solutionsMode = props.solutionsMode;
  var DragItem = store.groupedResponses ? DragWithDuplicatesForChildren$1 : StickerDrag$1;
  var changedHandlers = /setTitle|setStimulus|setTarget|updateDrag|reset|removeValue|matchResponse|onClickDrop|onClickContainerDrags/;
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    id: store.domContext,
    className: cn$1('lemo-question-body', {
      'lemo-disabled': !isDeveloperMode() && store.disabled
    })
  }, /*#__PURE__*/React__default.createElement(DropsZone$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(DragsContainer$1, {
    dragsContainer: store.dragsContainer
  }, store.getDragList(solutionsMode).map(function (drag) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-option-scale",
      key: drag.id,
      style: {
        fontSize: store.scaleFactor * 100 + '%'
      }
    }, /*#__PURE__*/React__default.createElement(DragItem, {
      drag: drag,
      matchResponse: store.matchResponse,
      dropTargets: DROP_TARGET_CLASSES,
      disabled: store.disabled,
      isSuccess: drag.showValidation && drag.isValid,
      isError: drag.showValidation && !drag.isValid
    }));
  }))));
}
var StickersSeriesQuestion$1 = observer(StickersSeriesQuestion);

var DROPS_ZONE = 'dropsZone';
var DROP_AREA$1 = 'lemo-drop-area';
var DROP_TARGET_CLASSES$1 = "." + DROP_AREA$1 + ", ." + CONTAINER_DRAGS_CLASS$1;

var arrowSize = 60;
var Arrow$2 = function Arrow(_ref) {
  var parentId = _ref.parentId,
    isVisible = _ref.isVisible,
    domContext = _ref.domContext;
  var polygon = document.querySelector("#" + domContext + " .lemo-polygon-area[data-id=\"" + parentId + "\"]");
  if (!polygon) return null;
  var bbox = polygon.getBBox();
  var x = bbox.x + bbox.width / 2;
  var y = bbox.y + bbox.height / 2;
  return /*#__PURE__*/createElement("svg", {
    className: cn('lemo-arrow', {
      'lemo-visible': isVisible
    }),
    width: 61,
    height: 69,
    fill: "none",
    x: isVisible ? x - arrowSize / 2 : 0,
    y: isVisible ? y - arrowSize : 0
  }, /*#__PURE__*/createElement("path", {
    fill: "#4F4FFF",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 2,
    d: "M58.827 41.373 33.333 66.828a4.01 4.01 0 0 1-5.666 0L2.173 41.373a3.996 3.996 0 0 1 0-5.657 4.01 4.01 0 0 1 5.666 0l18.655 18.627V5c0-2.21 1.794-4 4.006-4a4.003 4.003 0 0 1 4.006 4v49.343l18.655-18.627a4.01 4.01 0 0 1 5.666 0 3.996 3.996 0 0 1 0 5.657Z",
    clipRule: "evenodd"
  }));
};
var Arrow$3 = observer(Arrow$2);

function DropArea$3(_ref) {
  var drop = _ref.drop,
    domContext = _ref.domContext,
    showArrow = _ref.showArrow,
    showArea = _ref.showArea;
  var showAreaClass = showArea && drop.isDraggingOver ? 'lemo-show-area' : '';
  return /*#__PURE__*/React__default.createElement("g", {
    id: drop.id
  }, /*#__PURE__*/React__default.createElement("polygon", {
    className: "lemo-polygon-area " + showAreaClass + " " + DROP_AREA$1,
    points: drop.polygon,
    "data-id": drop.id
  }), showArrow && /*#__PURE__*/React__default.createElement(Arrow$3, {
    parentId: drop.id,
    isVisible: drop.isDraggingOver,
    domContext: domContext
  }));
}
var DropArea$4 = observer(DropArea$3);

function DropsZone$2(_ref) {
  var store = _ref.store;
  var imgRef = useRef();
  useResizeHandler2(imgRef, function (_ref2) {
    var w = _ref2.w;
    var newScaleFactor = w / store.image.width;
    store.setScaleFactor(newScaleFactor);
    store.dragDroppedList.forEach(function (drag) {
      drag.updatePositionOnResize();
    });
  });
  useEffect(function () {
    store.setScaleFactor(imgRef.current.clientWidth / store.image.width);
  });
  var containerSize = {
    maxWidth: store.image.width,
    maxHeight: store.image.height
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-drops-zone",
    "data-id": DROPS_ZONE,
    style: containerSize
  }, /*#__PURE__*/React__default.createElement("img", {
    ref: imgRef,
    className: "lemo-background",
    src: store.image.src,
    alt: translate('background')
  }), /*#__PURE__*/React__default.createElement("svg", {
    className: "lemo-drops",
    viewBox: "0 0 " + store.image.width + " " + store.image.height,
    xmlns: "http://www.w3.org/2000/svg"
  }, store.drops.map(function (drop) {
    return /*#__PURE__*/React__default.createElement(DropArea$4, {
      key: drop.id,
      drop: drop,
      domContext: store.domContext,
      showArea: store.ui_style.show_hotspots,
      showArrow: store.ui_style.show_drag_over
    });
  }), /*#__PURE__*/React__default.createElement("rect", {
    className: DROP_AREA$1,
    "data-id": 'drop-empty-zone',
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-drag-dropped-list",
    style: {
      fontSize: store.scaleFactor * 100 + '%'
    }
  }, store.dragDroppedList.map(function (drag) {
    return /*#__PURE__*/React__default.createElement(StickerDrag$1, {
      key: drag.id,
      drag: drag,
      matchResponse: store.matchResponse,
      dropTargets: DROP_TARGET_CLASSES$1,
      disabled: false,
      keepPositionAfterDrop: true,
      isSuccess: drag.showValidation && drag.isValid,
      isError: drag.showValidation && !drag.isValid
    });
  })));
}
var DropsZone$3 = observer(DropsZone$2);

function StickersQuestion(props) {
  var _props$store = props.store,
    store = _props$store === void 0 ? false : _props$store,
    solutionsMode = props.solutionsMode;
  var dropsContainer = useRef();
  var DragItem = store.groupedResponses ? DragWithDuplicatesForChildren$1 : StickerDrag$1;
  var changedHandlers = /setTitle|setStimulus|setTarget|updateDrag|reset|resetTarget|removeValue|matchResponse|onClickDrop|onClickContainerDrags/;
  function updateMouseCoords(_ref) {
    var targetId = _ref.targetId,
      event = _ref.event,
      drag = _ref.drag;
    var element = dropsContainer.current.firstChild;
    if (targetId && element) {
      var rect = element.getBoundingClientRect();
      var globalMouseX = event.clientX - drag.mouseDistanceShift.x;
      var globalMouseY = event.clientY - drag.mouseDistanceShift.y;
      var localMouseX = globalMouseX - rect.left;
      var localMouseY = globalMouseY - rect.top;
      drag.setPosition({
        x: localMouseX,
        y: localMouseY
      });
    }
  }
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    id: store.domContext,
    className: cn$1('lemo-question-body', {
      'lemo-disabled': !isDeveloperMode() && store.disabled
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: dropsContainer,
    className: "lemo-drops-container"
  }, /*#__PURE__*/React__default.createElement(DropsZone$3, {
    store: store
  })), /*#__PURE__*/React__default.createElement(DragsContainer$1, {
    dragsContainer: store.dragsContainer
  }, store.getDragList(solutionsMode).map(function (drag) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-option-scale",
      key: drag.id,
      style: {
        fontSize: store.scaleFactor * 100 + '%'
      }
    }, /*#__PURE__*/React__default.createElement(DragItem, {
      drag: drag,
      onDrop: updateMouseCoords,
      matchResponse: store.matchResponse,
      dropTargets: DROP_TARGET_CLASSES$1,
      disabled: store.disabled,
      keepPositionAfterDrop: true,
      isSuccess: drag.showValidation && drag.isValid,
      isError: drag.showValidation && !drag.isValid
    }));
  }))));
}
var StickersQuestion$1 = observer(StickersQuestion);

var DragModel$a = types$1.compose(withChildrenDuplicates, withStickerProps, types$1.model({
  realPosition: types$1.optional(XYModel, {
    x: 0,
    y: 0
  }),
  mouseDistanceShift: types$1.optional(XYModel, {
    x: 0,
    y: 0
  }),
  drop: types$1.maybe(types$1.string)
}).actions(function (state) {
  return {
    setPosition: function setPosition(_ref) {
      var x = _ref.x,
        y = _ref.y;
      state.position.setX(x);
      state.position.setY(y);
      state.setRealPosition({
        x: x,
        y: y
      });
    },
    setRealPosition: function setRealPosition(_ref2) {
      var x = _ref2.x,
        y = _ref2.y;
      var scaleFactor = getParent(state, 2).scaleFactor;
      var scaleMultiplier = 100 / (scaleFactor * 100);
      state.realPosition.setX(x * scaleMultiplier);
      state.realPosition.setY(y * scaleMultiplier);
    },
    updatePositionOnResize: function updatePositionOnResize() {
      var scaleFactor = getParent(state, 2).scaleFactor;
      var scaleMultiplier = 100 / (scaleFactor * 100);
      state.position.setX(state.realPosition.x / scaleMultiplier);
      state.position.setY(state.realPosition.y / scaleMultiplier);
    },
    applyRealPosition: function applyRealPosition(_ref3) {
      var x = _ref3.x,
        y = _ref3.y;
      state.realPosition.setX(x);
      state.realPosition.setY(y);
      state.updatePositionOnResize();
    },
    setMouseDistanceShift: function setMouseDistanceShift(_ref4) {
      var x = _ref4.x,
        y = _ref4.y;
      state.mouseDistanceShift.setX(x);
      state.mouseDistanceShift.setY(y);
    },
    resetTarget: function resetTarget() {
      state.realPosition.setPosition({
        x: 0,
        y: 0
      });
      state.position.setPosition({
        x: 0,
        y: 0
      });
      state.mouseDistanceShift.setPosition({
        x: 0,
        y: 0
      });
      state.drop = undefined;
    }
  };
}).views(function (state) {
  return {
    get showValidation() {
      var _getParent = getParent(state, 2),
        isEvaluated = _getParent.isEvaluated;
      return !!state.drop && isEvaluated;
    },
    get isValid() {
      if (!state.showValidation) return false;
      return getParent(state, 2).solutionsByItem.find(function (id) {
        return id === state.id;
      });
    }
  };
}));

var DropModel$7 = types$1.compose(withIsDraggingOver, types$1.model({
  id: types$1.string,
  area: types$1.array(XYModel),
  label: types$1.maybe(types$1.string),
  polygon: types$1.string
}));

function getCustomClosestSolution() {
  return types$1.compose(getClosestSolutionModel(noop), types$1.model({}).views(function (state) {
    return {
      checkSolution: function checkSolution(solution) {
        var normalizedSolution = normalizeSolution(solution);
        var solutionLength = normalizedSolution.length;
        var result = state.getUserResponse().reduce(function (acc, next) {
          var findItemIndex = normalizedSolution.findIndex(function (_ref) {
            var dragId = _ref.dragId,
              dropId = _ref.dropId;
            return dragId === next.dragId && dropId === next.dropId;
          });
          if (findItemIndex > -1) {
            normalizedSolution = rmItem(findItemIndex, normalizedSolution);
          }
          return {
            hits: acc.hits + (findItemIndex > -1 ? 1 : 0),
            failures: acc.failures + (findItemIndex === -1 ? 1 : 0)
          };
        }, {
          hits: 0,
          failures: 0
        });
        return _extends({}, result, {
          notAnswered: Math.max(solutionLength - result.hits, 0)
        });
      }
    };
  }));
}
function normalizeSolution(solution) {
  return solution.map(function (_ref2) {
    var dragId = _ref2.dragId,
      dropId = _ref2.dropId;
    return {
      dragId: dragId,
      dropId: dropId
    };
  });
}

var withCustomValidationModes$1 = types$1.compose(withValidationModes, types$1.model().views(function (state) {
  return {
    getPartialMatch: function getPartialMatch() {
      var _state$validation;
      var score = state.solution.score;
      var _state$closestSolutio = state.closestSolutionStats,
        failures = _state$closestSolutio.failures,
        hits = _state$closestSolutio.hits,
        notAnswered = _state$closestSolutio.notAnswered;
      var solutionLength = hits + notAnswered;
      var penalty = ((_state$validation = state.validation) === null || _state$validation === void 0 ? void 0 : _state$validation.penalty) || 0;
      var partialPointsPerHits = score / solutionLength * hits;
      var penalizationPoints = score * penalty * failures;
      var partialResult = partialPointsPerHits - penalizationPoints;
      var resultOutput = config.negativeScore ? partialResult : Math.max(partialResult, 0);
      return state.isSolvedCorrectly ? score : resultOutput;
    },
    get isSolvedCorrectly() {
      var _state$closestSolutio2 = state.closestSolutionStats,
        failures = _state$closestSolutio2.failures,
        hits = _state$closestSolutio2.hits,
        notAnswered = _state$closestSolutio2.notAnswered;
      var solutionLength = hits + notAnswered;
      return solutionLength === hits && failures === 0;
    }
  };
}));

function getSolutionsByItem(state) {
  var dragList = state.drags.filter(function (drag) {
    return drag.isUsed;
  }).map(function (drag) {
    return {
      dragId: drag.key,
      dropId: drag.drop,
      id: drag.id
    };
  });
  return state.solution.value.reduce(function (acc, next) {
    var itemIndex = findItemIndex(next, dragList);
    if (itemIndex === -1) return acc;
    var dragId = dragList[itemIndex].id;
    dragList.splice(itemIndex, 1);
    return [].concat(acc, [dragId]);
  }, []);
}
function findItemIndex(item, list) {
  return list.findIndex(function (_ref) {
    var dragId = _ref.dragId,
      dropId = _ref.dropId;
    return dragId === item.dragId && dropId === item.dropId;
  });
}

var StickersQuestionStore = types$1.compose(QuestionBaseModel, withWhileDraggingTarget, getWithShuffleOptions('drags'), getCustomClosestSolution(), withCustomValidationModes$1, types$1.model({
  drags: types$1.array(DragModel$a),
  drops: types$1.array(DropModel$7),
  dragsContainer: types$1.optional(DragsContainerModel, {}),
  scaleFactor: types$1.optional(types$1.number, 1),
  temporalMouseCoordinates: types$1.optional(XYModel, {
    x: 0,
    y: 0
  })
}).actions(function (state) {
  return {
    matchResponse: function matchResponse(dropId, drag) {
      if (dropId) {
        drag.setDrop(dropId);
      }
    },
    setScaleFactor: function setScaleFactor(newFactor) {
      state.scaleFactor = newFactor;
    },
    updateAfterScaleFactor: function updateAfterScaleFactor(oldFactor, newFactor) {
      var normalizeAxis = function normalizeAxis(value) {
        return value * newFactor / oldFactor;
      };
      state.dragDroppedList.forEach(function (drag) {
        drag.setPosition({
          x: normalizeAxis(drag.x),
          y: normalizeAxis(drag.y)
        });
      });
    },
    updateFirstInteraction: function updateFirstInteraction() {},
    reset: function reset() {
      state.baseReset();
      state.clearResponses();
    },
    clearResponses: function clearResponses() {
      state.drags.forEach(function (drag) {
        return drag.resetTarget();
      });
    },
    resetDrag: function resetDrag(drag) {
      state.position.setX(0);
      state.position.setY(0);
      state.drop = undefined;
    },
    setResponse: function setResponse(response) {
      var responseModel = types$1.model({
        dragId: types$1.string,
        dropId: types$1.string,
        x: types$1.number,
        y: types$1.number
      });
      if (!typeChecker(types$1.array(responseModel), response)) return false;
      state.clearResponses();
      response.forEach(function (currentResponse, idx) {
        var drag = state.drags.find(function (drag) {
          return drag.key === currentResponse.dragId && !drag.isUsed;
        });
        if (drag) {
          drag.applyRealPosition({
            x: currentResponse.x,
            y: currentResponse.y
          });
          drag.setDrop(currentResponse.dropId);
        }
      });
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData, idx) {
      var data = _createSnapshot$m(rawData);
      applySnapshot(state, data);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  return {
    get image() {
      return _extends({}, state.raw.data.image);
    },
    get domContext() {
      return 'context_' + uuid();
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$m(rawData);
    },
    get groupedResponses() {
      return state.raw.data.group_responses;
    },
    getUserResponse: function getUserResponse() {
      return state.drags.reduce(function (acc, next) {
        if (!next.drop) return acc;
        return [].concat(acc, [{
          x: next.realPosition.x,
          y: next.realPosition.y,
          dropId: next.drop,
          dragId: next.value
        }]);
      }, []);
    },
    getDragList: function getDragList(solutionsMode) {
      var list = solutionsMode ? state.drags : state.shuffledOptions;
      return state.groupedResponses ? getDragListWithDuplicates(list) : state.drags.filter(function (drag) {
        return !drag.drop;
      });
    },
    get dragDroppedList() {
      return state.drags.filter(function (drag) {
        return drag.drop !== undefined;
      });
    },
    get solutionsByItem() {
      return getSolutionsByItem(state);
    },
    getResponseById: function getResponseById(id) {
      return state.drops.find(function (response) {
        return response.id === id;
      });
    },
    getValidResponses: function getValidResponses() {
      return state.validation.value;
    }
  };
}));
function getDrag$1(item) {
  return {
    id: uuid(),
    key: item.id
  };
}
function getDrops(hotspots) {
  return hotspots.map(function (hotspot) {
    return _extends({}, hotspot, {
      polygon: hotspot.area.map(function (point) {
        return point.x + "," + point.y;
      }).join(' ')
    });
  });
}
function createDrags$3(possible_responses) {
  return possible_responses.reduce(function (acc, next) {
    var itemsLength = next.number_duplicates;
    return [].concat(acc, populate(itemsLength, function () {
      return getDrag$1(next);
    }));
  }, []);
}
function transformInitialData(data) {
  return produce(data, function (draft) {
    draft.data.possible_responses_config = data.data.possible_responses.map(function (r) {
      return {
        number_duplicates: r.number_duplicates
      };
    });
  });
}
function _createSnapshot$m(data) {
  var _data$data = data.data,
    possible_responses = _data$data.possible_responses,
    validation = _data$data.validation;
  var responsesLength = validation.valid_response.value.length;
  var transformedData = transformInitialData(data);
  return _extends({}, transformedData.data, importCommonValues$1(transformedData), {
    validation: withPenaltyPoints(responsesLength, validation),
    drags: createDrags$3(possible_responses),
    drops: getDrops(transformedData.data.hotspots)
  });
}
function createStore$q(data) {
  return StickersQuestionStore.create(_createSnapshot$m(data));
}

function TabsOptions(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-tabs-options"
  }, children);
}

function Tabs(_ref) {
  var tabs = _ref.tabs;
  var _useState = useState(tabs[0].id),
    activeTabId = _useState[0],
    setActiveTabId = _useState[1];
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-tabs"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-tabs__buttons"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-tabs__box"
  }, tabs.map(function (tab) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: tab.id,
      onClick: function onClick() {
        return setActiveTabId(tab.id);
      },
      className: classNames('lemo-tabs__button', {
        'lemo-tabs__button--selected': tab.id === activeTabId
      })
    }, tab.title, ' ');
  }))), !tabs.find(function (tab) {
    return tab.id === activeTabId;
  }).hideOptions && /*#__PURE__*/React__default.createElement(TabsOptions, null, tabs.find(function (tab) {
    return tab.id === activeTabId;
  }).options), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-tabs__content",
    key: "contents_" + activeTabId
  }, tabs.find(function (tab) {
    return tab.id === activeTabId;
  }).content));
}

var EditorDropImage = function EditorDropImage(_ref) {
  var background = _ref.background,
    onChangeBackground = _ref.onChangeBackground,
    assetsApi = _ref.assetsApi;
  var _onChangeBackground = useCallback(function (_background) {
    if (_background) {
      onChangeBackground(_extends({}, background, _background));
    } else {
      onChangeBackground && onChangeBackground(_background);
    }
  }, [onChangeBackground]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-drop-image"
  }, /*#__PURE__*/React__default.createElement(ImageUploadOrPreview$1, {
    background: background,
    onChangeBackground: _onChangeBackground,
    showSliderSizeThumb: false,
    assetsApi: assetsApi,
    showDeletePreview: false,
    showChangePreview: true,
    altTextPlaceholder: translate('stickers_drop_editor_image_placeholder')
  }));
};
EditorDropImage.propTypes = {};
var EditorDropImage$1 = observer(EditorDropImage);

var EditorDropImageSt = function EditorDropImageSt(_ref) {
  var store = _ref.store;
  var percentImage = store.image && store.image.hasOwnProperty('percent') ? store.image.percent : 1;
  return /*#__PURE__*/React__default.createElement(EditorDropImage$1, {
    onChangeBackground: function onChangeBackground(value) {
      value ? store.setImage({
        src: value.source,
        width: value.original_width,
        height: value.original_height,
        percent: value.hasOwnProperty('scale') ? value.scale / 100 : 1,
        alt: value.alt
      }) : store.setImage(undefined);
    },
    background: store.image ? {
      source: store.image.src,
      original_width: store.image.width,
      original_height: store.image.height,
      scale: percentImage * 100,
      width: percentImage * store.image.width,
      height: percentImage * store.image.height,
      alt: store.image.alt
    } : null,
    assetsApi: getAssetsEditorApi(store.assetsEditorApi)
  });
};
EditorDropImageSt.propTypes = {};
var EditorDropImageSt$1 = observer(EditorDropImageSt);

var hotspotPropTypes = propTypes.shape({
  id: propTypes.string.isRequired,
  label: propTypes.string,
  area: propTypes.arrayOf(propTypes.shape({
    x: propTypes.number.isRequired,
    y: propTypes.number.isRequired
  })).isRequired
});

var HotspotsPainterToolbar = function HotspotsPainterToolbar(_ref) {
  var undo = _ref.undo,
    redo = _ref.redo,
    draw = _ref.draw,
    select = _ref.select,
    deleteItem = _ref.deleteItem,
    canUndo = _ref.canUndo,
    canRedo = _ref.canRedo,
    canDraw = _ref.canDraw,
    canSelect = _ref.canSelect,
    canDelete = _ref.canDelete,
    isDrawing = _ref.isDrawing,
    isSelecting = _ref.isSelecting;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "hotspots-painter-toolbar"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "hotspots-painter-toolbar__left-container"
  }, /*#__PURE__*/React__default.createElement(ButtonInline, {
    onClick: undo,
    disabled: !canUndo,
    text: translate('hotspots_painter_button_undo'),
    icon: /*#__PURE__*/React__default.createElement(SvgReply, {
      className: "lemo-icon"
    }),
    classNameAdd: classNames('hotspots-painter-toolbar__button-undo-redo', {
      'hotspots-painter-toolbar__button--disabled': !canUndo
    })
  }), /*#__PURE__*/React__default.createElement(ButtonInline, {
    onClick: redo,
    disabled: !canRedo,
    text: translate('hotspots_painter_button_redo'),
    icon: /*#__PURE__*/React__default.createElement(SvgReply, {
      className: "lemo-icon",
      style: {
        transform: 'scaleX(-1)'
      }
    }),
    classNameAdd: classNames('hotspots-painter-toolbar__button-undo-redo', {
      'hotspots-painter-toolbar__button--disabled': !canRedo
    })
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "hotspots-painter-toolbar__right-container"
  }, /*#__PURE__*/React__default.createElement(SimpleButton, {
    onClick: draw,
    disabled: !canDraw,
    className: classNames('hotspots-painter-toolbar__button-draw-select', {
      'hotspots-painter-toolbar__button--active': isDrawing,
      'hotspots-painter-toolbar__button--disabled': !canDraw
    })
  }, /*#__PURE__*/React__default.createElement(SvgPencil, {
    className: "lemo-icon"
  }), translate('hotspots_painter_button_draw')), /*#__PURE__*/React__default.createElement(SimpleButton, {
    onClick: select,
    disabled: !canSelect,
    className: classNames('hotspots-painter-toolbar__button-draw-select', {
      'hotspots-painter-toolbar__button--active': isSelecting,
      'hotspots-painter-toolbar__button--disabled': !canSelect
    })
  }, /*#__PURE__*/React__default.createElement(SvgCursorClick, {
    className: "lemo-icon"
  }), translate('hotspots_painter_button_select')), /*#__PURE__*/React__default.createElement(SimpleButton, {
    onClick: deleteItem,
    disabled: !canDelete,
    title: translate('hotspots-hotspots_painter_button_delete'),
    className: classNames('hotspots-painter-toolbar__button-delete', {
      'hotspots-painter-toolbar__button--disabled': !canDelete
    })
  }, /*#__PURE__*/React__default.createElement(SvgTrash$1, {
    className: "lemo-icon"
  }))));
};
HotspotsPainterToolbar.propTypes = {
  undo: propTypes.func.isRequired,
  redo: propTypes.func.isRequired,
  draw: propTypes.func.isRequired,
  select: propTypes.func.isRequired,
  deleteItem: propTypes.func.isRequired,
  canUndo: propTypes.bool.isRequired,
  canRedo: propTypes.bool.isRequired,
  canDraw: propTypes.bool.isRequired,
  canSelect: propTypes.bool.isRequired,
  canDelete: propTypes.bool.isRequired,
  isDrawing: propTypes.bool.isRequired,
  isSelecting: propTypes.bool.isRequired
};

var HotspotsPainterDropInfo = function HotspotsPainterDropInfo(_ref) {
  var text = _ref.text,
    number = _ref.number;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "hotspots-painter-drop-info"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "hotspots-painter-drop-info__text"
  }, text), /*#__PURE__*/React__default.createElement("span", {
    className: "hotspots-painter-drop-info__number"
  }, number));
};
HotspotsPainterDropInfo.propTypes = {
  text: propTypes.string,
  number: propTypes.number
};

function isInsidePolygon(point, polygon) {
  var x = point.x,
    y = point.y;
  var inside = false;
  for (var i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    var xi = polygon[i].x,
      yi = polygon[i].y;
    var xj = polygon[j].x,
      yj = polygon[j].y;
    var intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}
function isPointInPolygon(vertices, pt) {
  var isInside = false;
  var minX = vertices[0].x,
    maxX = vertices[0].x;
  var minY = vertices[0].y,
    maxY = vertices[0].y;
  for (var i = 1; i < vertices.length; i++) {
    var q = vertices[i];
    minX = Math.min(q.x, minX);
    maxX = Math.max(q.x, maxX);
    minY = Math.min(q.y, minY);
    maxY = Math.max(q.y, maxY);
  }
  if (pt.x < minX || pt.x > maxX || pt.y < minY || pt.y > maxY) {
    return false;
  }
  var i = 0,
    j = vertices.length - 1;
  for (j; i < vertices.length; j = i++) {
    if (vertices[i].y > pt.y != vertices[j].y > pt.y && pt.x < (vertices[j].x - vertices[i].x) * (pt.y - vertices[i].y) / (vertices[j].y - vertices[i].y) + vertices[i].x) {
      isInside = !isInside;
    }
  }
  return isInside;
}
function doLinesIntersect(a, b, c, d) {
  var crossproduct1 = crossProduct(c.x - a.x, c.y - a.y, b.x - a.x, b.y - a.y);
  var crossproduct2 = crossProduct(d.x - a.x, d.y - a.y, b.x - a.x, b.y - a.y);
  var crossproduct3 = crossProduct(a.x - c.x, a.y - c.y, d.x - c.x, d.y - c.y);
  var crossproduct4 = crossProduct(b.x - c.x, b.y - c.y, d.x - c.x, d.y - c.y);
  if (crossproduct1 * crossproduct2 < 0 && crossproduct3 * crossproduct4 < 0) {
    return true;
  }
  return false;
}
function crossProduct(x1, y1, x2, y2) {
  return x1 * y2 - y1 * x2;
}

function useMoveHotspot(_ref) {
  var svgRef = _ref.svgRef,
    mode = _ref.mode,
    selectedHotspotIndex = _ref.selectedHotspotIndex,
    image = _ref.image,
    setHotspotsState = _ref.setHotspotsState,
    hotspotsState = _ref.hotspotsState,
    isMoveEnabled = _ref.isMoveEnabled,
    setMoveHoveringOther = _ref.setMoveHoveringOther;
  var _useState = useState(null),
    dragDelta = _useState[0],
    setDragDelta = _useState[1];
  var _useState2 = useState(null),
    initialHotspot = _useState2[0],
    setInitialHotspot = _useState2[1];
  var modeRef = useRef(mode);
  var isMoveEnabledRef = useRef(isMoveEnabled);
  var selectedHotspotIndexRef = useRef(selectedHotspotIndex);
  var dragDeltaRef = useRef(dragDelta);
  var initialHotspotRef = useRef(initialHotspot);
  var imageRef = useRef(image);
  var hotspotsStateRef = useRef(hotspotsState);
  var setMoveHoveringOtherRef = useRef(setMoveHoveringOther);
  var isDragging = useRef(false);
  useEffect(function () {
    isMoveEnabledRef.current = isMoveEnabled;
    modeRef.current = mode;
    selectedHotspotIndexRef.current = selectedHotspotIndex;
    dragDeltaRef.current = dragDelta;
    imageRef.current = image;
    hotspotsStateRef.current = hotspotsState;
    setMoveHoveringOtherRef.current = setMoveHoveringOther;
  }, [mode, selectedHotspotIndex, dragDelta, image, hotspotsState, isMoveEnabled, setMoveHoveringOther]);
  useEffect(function () {
    initialHotspotRef.current = initialHotspot;
  }, [initialHotspot]);
  var handleDragStart = function handleDragStart(e) {
    if (isMoveEnabledRef.current && modeRef.current === 'select' && selectedHotspotIndexRef.current !== null) {
      var rect = svgRef.current.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width * imageRef.current.width;
      var y = (e.clientY - rect.top) / rect.height * imageRef.current.height;
      setDragDelta({
        x: x,
        y: y
      });
      setInitialHotspot(_extends({}, hotspotsStateRef.current[selectedHotspotIndexRef.current]));
    }
  };
  var handleDragMove = function handleDragMove(e) {
    if (isMoveEnabledRef.current && modeRef.current === 'select' && selectedHotspotIndexRef.current !== null && dragDeltaRef.current) {
      var rect = svgRef.current.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width * imageRef.current.width;
      var y = (e.clientY - rect.top) / rect.height * imageRef.current.height;
      x = Math.max(0, Math.min(imageRef.current.width, x));
      y = Math.max(0, Math.min(imageRef.current.height, y));
      var deltaX = x - dragDeltaRef.current.x;
      var deltaY = y - dragDeltaRef.current.y;
      setDragDelta({
        x: x,
        y: y
      });
      setHotspotsState(function (currentHotspots) {
        var newHotspots = [].concat(currentHotspots);
        newHotspots[selectedHotspotIndexRef.current] = _extends({}, newHotspots[selectedHotspotIndexRef.current], {
          area: newHotspots[selectedHotspotIndexRef.current].area.map(function (point) {
            return {
              x: point.x + deltaX,
              y: point.y + deltaY
            };
          }),
          isMoving: true
        });
        return newHotspots;
      });
      setMoveHoveringOtherRef.current(!canMove(deltaX, deltaY));
      isDragging.current = true;
    }
  };
  function canMove(deltaX, deltaY) {
    var newHotspots = [].concat(hotspotsStateRef.current);
    var newPolygon = newHotspots[selectedHotspotIndexRef.current].area.map(function (point) {
      return {
        x: point.x + deltaX,
        y: point.y + deltaY
      };
    });
    if (newPolygon.some(function (point) {
      return point.x < 0 || point.y < 0 || point.x > imageRef.current.width || point.y > imageRef.current.height;
    })) {
      return false;
    }
    for (var i = 0; i < newPolygon.length; i++) {
      if (hotspotsStateRef.current.some(function (otherHotspot, j) {
        return j !== selectedHotspotIndexRef.current && isPointInPolygon(otherHotspot.area, newPolygon[i]);
      })) {
        return false;
      }
    }
    for (var _i = 0; _i < newPolygon.length; _i++) {
      for (var j = 0; j < hotspotsStateRef.current.length; j++) {
        if (j !== selectedHotspotIndexRef.current) {
          var otherPolygon = hotspotsStateRef.current[j].area;
          for (var k = 0; k < otherPolygon.length; k++) {
            if (doLinesIntersect(newPolygon[_i], newPolygon[(_i + 1) % newPolygon.length], otherPolygon[k], otherPolygon[(k + 1) % otherPolygon.length])) {
              return false;
            }
          }
        }
      }
    }
    return true;
  }
  var handleDragEnd = function handleDragEnd(e) {
    if (!isDragging.current) return;
    if (isMoveEnabled && isMoveEnabledRef.current && modeRef.current === 'select' && selectedHotspotIndexRef.current !== null) {
      setDragDelta(null);
      if (!canMove(0, 0)) {
        if (isMoveEnabled && isMoveEnabledRef.current && initialHotspotRef.current) {
          setHotspotsState(function (currentHotspots) {
            var newHotspots = [].concat(currentHotspots);
            newHotspots[selectedHotspotIndexRef.current] = initialHotspotRef.current;
            return newHotspots;
          });
        }
      } else {
        setHotspotsState(function (currentHotspots) {
          var newHotspots = [].concat(currentHotspots);
          var currentHotspot = _extends({}, newHotspots[selectedHotspotIndexRef.current]);
          delete currentHotspot.isMoving;
          newHotspots[selectedHotspotIndexRef.current] = currentHotspot;
          return newHotspots;
        });
      }
      setInitialHotspot(null);
      setMoveHoveringOtherRef.current(false);
    }
  };
  useEffect(function () {
    if (svgRef.current) {
      svgRef.current.addEventListener('mousedown', handleDragStart);
      svgRef.current.addEventListener('mousemove', handleDragMove);
      svgRef.current.addEventListener('mouseup', handleDragEnd);
      svgRef.current.addEventListener('mouseleave', handleDragEnd);
    }
    return function () {
      if (svgRef.current) {
        svgRef.current.removeEventListener('mousedown', handleDragStart);
        svgRef.current.removeEventListener('mousemove', handleDragMove);
        svgRef.current.removeEventListener('mouseup', handleDragEnd);
        svgRef.current.removeEventListener('mouseleave', handleDragEnd);
      }
    };
  }, [svgRef, svgRef.current]);
  return {};
}

function useMoveVertex(_ref) {
  var svgRef = _ref.svgRef,
    selectedHotspotIndex = _ref.selectedHotspotIndex,
    selectedVertexIndex = _ref.selectedVertexIndex,
    setSelectedVertexIndex = _ref.setSelectedVertexIndex,
    image = _ref.image,
    setHotspotsState = _ref.setHotspotsState,
    hotspotsState = _ref.hotspotsState;
  var _useState = useState(null),
    dragDelta = _useState[0],
    setDragDelta = _useState[1];
  var modeEditRef = useRef(false);
  var selectedHotspotIndexRef = useRef(selectedHotspotIndex);
  var selectedVertexIndexRef = useRef(selectedVertexIndex);
  var setSelectedVertexIndexRef = useRef(setSelectedVertexIndex);
  var dragDeltaRef = useRef(dragDelta);
  var imageRef = useRef(image);
  var hotspotsStateRef = useRef(hotspotsState);
  useEffect(function () {
    selectedHotspotIndexRef.current = selectedHotspotIndex;
    selectedVertexIndexRef.current = selectedVertexIndex;
    setSelectedVertexIndexRef.current = setSelectedVertexIndex;
    dragDeltaRef.current = dragDelta;
    imageRef.current = image;
    hotspotsStateRef.current = hotspotsState;
  }, [selectedHotspotIndex, dragDelta, image, hotspotsState, selectedVertexIndex, setSelectedVertexIndex]);
  var handleDragStart = function handleDragStart(e) {
    var rect = svgRef.current.getBoundingClientRect();
    var x = (e.clientX - rect.left) / rect.width * imageRef.current.width;
    var y = (e.clientY - rect.top) / rect.height * imageRef.current.height;
    if (!modeEditRef.current) {
      var vertexIndex = e.target.getAttribute('data-index');
      selectedVertexIndexRef.current = vertexIndex;
      setSelectedVertexIndexRef.current(vertexIndex);
      modeEditRef.current = true;
    }
    if (selectedHotspotIndexRef.current !== null && selectedVertexIndexRef.current !== null) {
      setDragDelta({
        x: x,
        y: y
      });
    }
  };
  var handleDragMove = function handleDragMove(e) {
    if (modeEditRef.current && selectedHotspotIndexRef.current !== null && selectedVertexIndexRef.current !== null && dragDeltaRef.current) {
      var rect = svgRef.current.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width * imageRef.current.width;
      var y = (e.clientY - rect.top) / rect.height * imageRef.current.height;
      x = Math.max(0, Math.min(imageRef.current.width, x));
      y = Math.max(0, Math.min(imageRef.current.height, y));
      var deltaX = x - dragDeltaRef.current.x;
      var deltaY = y - dragDeltaRef.current.y;
      if (canMove(deltaX, deltaY)) {
        setDragDelta({
          x: x,
          y: y
        });
        setHotspotsState(function (currentHotspots) {
          var newHotspots = JSON.parse(JSON.stringify(currentHotspots));
          if (canMove(deltaX, deltaY)) {
            newHotspots[selectedHotspotIndexRef.current].area[selectedVertexIndexRef.current] = {
              x: newHotspots[selectedHotspotIndexRef.current].area[selectedVertexIndexRef.current].x + deltaX,
              y: newHotspots[selectedHotspotIndexRef.current].area[selectedVertexIndexRef.current].y + deltaY
            };
          }
          return newHotspots;
        });
      }
    }
  };
  function canMove(deltaX, deltaY) {
    var newHotspots = [].concat(hotspotsStateRef.current);
    var vertexIndex = selectedVertexIndexRef.current;
    var hotspotIndex = selectedHotspotIndexRef.current;
    var newPoint = {
      x: newHotspots[hotspotIndex].area[vertexIndex].x + deltaX,
      y: newHotspots[hotspotIndex].area[vertexIndex].y + deltaY
    };
    if (newPoint.x < 0 || newPoint.y < 0 || newPoint.x > imageRef.current.width || newPoint.y > imageRef.current.height || newHotspots.some(function (otherHotspot, j) {
      return j !== hotspotIndex && isPointInPolygon(otherHotspot.area, newPoint);
    })) {
      return false;
    }
    for (var k = 0; k < newHotspots.length; k++) {
      if (k !== hotspotIndex) {
        for (var i = 0; i < newHotspots[k].area.length; i++) {
          var line1 = [newHotspots[k].area[i], newHotspots[k].area[(i + 1) % newHotspots[k].area.length]];
          for (var j = 0; j < newHotspots[hotspotIndex].area.length; j++) {
            if (j !== vertexIndex) {
              var line2 = [newPoint, newHotspots[hotspotIndex].area[j]];
              if (doLinesIntersect(line1[0], line1[1], line2[0], line2[1])) {
                return false;
              }
            }
          }
        }
      }
    }
    return true;
  }
  var handleDragEnd = function handleDragEnd(e) {
    if (modeEditRef.current && selectedHotspotIndexRef.current !== null) {
      setDragDelta(null);
      modeEditRef.current = false;
      selectedHotspotIndexRef.current = null;
      setSelectedVertexIndexRef.current(null);
      selectedVertexIndexRef.current = null;
    }
  };
  useEffect(function () {
    if (svgRef.current) {
      var vertices = svgRef.current.querySelectorAll('.hotspots-painter__selected-hotspot-vertex');
      vertices.forEach(function (vertex) {
        vertex.addEventListener('mousedown', handleDragStart);
      });
      svgRef.current.addEventListener('mousemove', handleDragMove);
      svgRef.current.addEventListener('mouseup', handleDragEnd);
      svgRef.current.addEventListener('mouseleave', handleDragEnd);
    }
    return function () {
      if (svgRef.current) {
        var _vertices = svgRef.current.querySelectorAll('.hotspots-painter__selected-hotspot-vertex');
        _vertices.forEach(function (vertex) {
          vertex.removeEventListener('mousedown', handleDragStart);
        });
        svgRef.current.removeEventListener('mousemove', handleDragMove);
        svgRef.current.removeEventListener('mouseup', handleDragEnd);
        svgRef.current.removeEventListener('mouseleave', handleDragEnd);
      }
    };
  }, [svgRef, svgRef.current, selectedHotspotIndex]);
  return {};
}

function HotspotsPainter(_ref) {
  var image = _ref.image,
    hotspots = _ref.hotspots,
    setHotspots = _ref.setHotspots,
    getIdToNewHotspot = _ref.getIdToNewHotspot,
    getInfoFromIdDrop = _ref.getInfoFromIdDrop;
  var svgRef = useRef();
  var containerRef = useRef();
  var _useState = useState(hotspots),
    hotspotsState = _useState[0],
    setHotspotsState = _useState[1];
  var _useState2 = useState([]),
    activePoints = _useState2[0],
    setActivePoints = _useState2[1];
  var _useState3 = useState(null),
    mousePos = _useState3[0],
    setMousePos = _useState3[1];
  var _useState4 = useState(null),
    selectedHotspotIndex = _useState4[0],
    setSelectedHotspotIndex = _useState4[1];
  var _useState5 = useState(null),
    selectedVertexIndex = _useState5[0],
    _setSelectedVertexIndex = _useState5[1];
  var selectedVertexIndexRef = useRef(selectedVertexIndex);
  var _useState6 = useState('draw'),
    mode = _useState6[0],
    setMode = _useState6[1];
  var _useState7 = useState(false),
    isMouseInsideAnotherHotspot = _useState7[0],
    setMouseIsInsideAnotherHotspot = _useState7[1];
  var _useState8 = useState(false),
    isMoveHoveringOther = _useState8[0],
    setMoveHoveringOther = _useState8[1];
  var _useState9 = useState([]),
    undonePoints = _useState9[0],
    setUndonePoints = _useState9[1];
  useMoveHotspot({
    svgRef: svgRef,
    mode: mode,
    selectedHotspotIndex: selectedHotspotIndex,
    image: image,
    setHotspotsState: setHotspotsState,
    hotspotsState: hotspotsState,
    isMoveEnabled: !selectedVertexIndex,
    setMoveHoveringOther: setMoveHoveringOther
  });
  useMoveVertex({
    svgRef: svgRef,
    mode: mode,
    selectedHotspotIndex: selectedHotspotIndex,
    selectedVertexIndex: selectedVertexIndexRef.current,
    setSelectedVertexIndex: function setSelectedVertexIndex(value) {
      _setSelectedVertexIndex(value);
      selectedVertexIndexRef.current = value;
    },
    image: image,
    setHotspotsState: setHotspotsState,
    hotspotsState: hotspotsState
  });
  useEffect(function () {
    selectedVertexIndexRef.current = selectedVertexIndex;
  }, [selectedVertexIndex]);
  var onDraw = function onDraw() {
    setMode('draw');
    setSelectedHotspotIndex(null);
    setActivePoints([]);
  };
  var onSelect = function onSelect(e) {
    onConfirmHotspot(e);
    setMode('select');
    setSelectedHotspotIndex(null);
    setActivePoints([]);
  };
  function isAnyHotspotMoving() {
    return hotspotsState.some(function (hotspot) {
      return hotspot.isMoving;
    });
  }
  useEffect(function () {
    if (!isAnyHotspotMoving()) setHotspots(hotspotsState);
  }, [hotspotsState]);
  var handleClickSvg = function handleClickSvg(e) {
    var clientX = e.clientX,
      clientY = e.clientY;
    if (isMouseInsideAnotherHotspot) {
      return;
    }
    if (mode === 'draw') {
      if (!svgRef.current) {
        return;
      }
      var rect = svgRef.current.getBoundingClientRect();
      var x = (clientX - rect.left) / rect.width * image.width;
      var y = (clientY - rect.top) / rect.height * image.height;
      setActivePoints(function (activePoints) {
        return [].concat(activePoints, [{
          x: x,
          y: y
        }]);
      });
      setUndonePoints([]);
    }
  };
  var onConfirmHotspot = function onConfirmHotspot(e) {
    e.preventDefault();
    e.stopPropagation();
    if (activePoints.length < 3) ; else if (activePoints.length > 0) {
      setHotspotsState(function (hotspots) {
        return [].concat(hotspots, [getNewHotspot(activePoints)]);
      });
      setActivePoints([]);
    }
  };
  var handleMouseMove = function handleMouseMove(_ref2) {
    var clientX = _ref2.clientX,
      clientY = _ref2.clientY;
    if (mode === 'draw') {
      if (!svgRef.current) {
        return;
      }
      var rect = svgRef.current.getBoundingClientRect();
      var x = (clientX - rect.left) / rect.width * image.width;
      var y = (clientY - rect.top) / rect.height * image.height;
      setMousePos({
        x: x,
        y: y
      });
      var insideAnotherHotspot = false;
      for (var i = 0; i < hotspotsState.length; i++) {
        if (isInsidePolygon({
          x: x,
          y: y
        }, hotspotsState[i].area)) {
          insideAnotherHotspot = true;
          break;
        }
      }
      setMouseIsInsideAnotherHotspot(insideAnotherHotspot);
    }
  };
  var handleHotspotClick = function handleHotspotClick(hotspotIndex) {
    return function (e) {
      if (mode === 'select') {
        e.stopPropagation();
        setSelectedHotspotIndex(hotspotIndex);
      }
    };
  };
  var popLast = function popLast(arr) {
    if (arr === void 0) {
      arr = [];
    }
    var newArr = arr.slice(0, -1);
    var lastItem = arr[arr.length - 1];
    return [newArr, lastItem];
  };
  function onUndo() {
    if (mode === 'draw') {
      if (activePoints.length === 1) {
        var newActivePoints = [].concat(activePoints);
        var lastPoint = newActivePoints[0];
        setActivePoints([]);
        setUndonePoints([].concat(undonePoints, [lastPoint]));
      } else if (activePoints.length > 1) {
        var _newActivePoints = [].concat(activePoints);
        var _lastPoint = _newActivePoints.pop();
        setActivePoints(_newActivePoints);
        setUndonePoints([].concat(undonePoints, [_lastPoint]));
      }
    } else {
      if (selectedHotspotIndex !== null) {
        setHotspotsState(function (currentHotspots) {
          var newHotspots = JSON.parse(JSON.stringify(currentHotspots));
          var activeHotspot = newHotspots[selectedHotspotIndex];
          if (activeHotspot.area.length > 3) {
            setUndonePoints([].concat(undonePoints, [activeHotspot.area[activeHotspot.area.length - 1]]));
            activeHotspot.area.pop();
          }
          return newHotspots;
        });
      }
    }
  }
  function onRedo() {
    if (mode === 'draw') {
      if (undonePoints.length > 0) {
        var _popLast = popLast(undonePoints),
          newUndonePoints = _popLast[0],
          lastUndonePoint = _popLast[1];
        setUndonePoints(newUndonePoints);
        setActivePoints([].concat(activePoints, [lastUndonePoint]));
      }
    } else {
      if (undonePoints.length > 0 && selectedHotspotIndex !== null) {
        var _popLast2 = popLast(undonePoints),
          _newUndonePoints = _popLast2[0],
          _lastUndonePoint = _popLast2[1];
        setUndonePoints(_newUndonePoints);
        setHotspotsState(function (currentHotspots) {
          var newHotspots = JSON.parse(JSON.stringify(currentHotspots));
          newHotspots[selectedHotspotIndex].area.push(_lastUndonePoint);
          return newHotspots;
        });
      }
    }
  }
  function getNewHotspot(points) {
    if (points === void 0) {
      points = {
        x: 0,
        y: 0
      };
    }
    return {
      area: points,
      id: getIdToNewHotspot(),
      label: ''
    };
  }
  function onDelete() {
    if (mode === 'draw') {
      setActivePoints([]);
      setUndonePoints([]);
    } else {
      if (selectedHotspotIndex !== null) {
        setHotspotsState(function (currentHotspots) {
          var newHotspots = [].concat(currentHotspots);
          newHotspots.splice(selectedHotspotIndex, 1);
          return newHotspots;
        });
        setSelectedHotspotIndex(null);
      }
    }
  }
  function HotspotInfo(_ref3) {
    var x = _ref3.x,
      y = _ref3.y,
      id = _ref3.id;
    var text = id;
    var number = null;
    if (getInfoFromIdDrop) {
      var info = getInfoFromIdDrop(id);
      text = info.text;
      number = info.number;
    }
    return /*#__PURE__*/React__default.createElement("div", {
      style: {
        position: 'absolute',
        left: x + "px",
        top: y + "px",
        lineHeight: '1em',
        textAlign: 'center',
        transform: "translateX(-50%) translateY(-300%)"
      }
    }, /*#__PURE__*/React__default.createElement(HotspotsPainterDropInfo, {
      text: text,
      number: number || ''
    }));
  }
  function getPosToHotspotInfo(hotspot) {
    var _hotspot$area$ = hotspot.area[0],
      x = _hotspot$area$.x,
      y = _hotspot$area$.y;
    var point = svgRef.current.createSVGPoint();
    point.x = x;
    point.y = y;
    var svgP = point.matrixTransform(svgRef.current.getScreenCTM());
    var containerRect = containerRef.current.getBoundingClientRect();
    var posX = svgP.x - containerRect.x;
    var posY = svgP.y - containerRect.y;
    var containerWidth = containerRef.current.offsetWidth;
    var containerHeight = containerRef.current.offsetHeight;
    var safeMargin = 10;
    var textWidthEst = 93;
    posX = Math.min(Math.max(posX, safeMargin), containerWidth - textWidthEst / 2 - safeMargin);
    posY = Math.min(Math.max(posY, safeMargin), containerHeight);
    if (posY < 100) {
      posY = 100;
    }
    if (posX < 45) {
      posX = 45;
    }
    return {
      posX: posX,
      posY: posY
    };
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "hotspots-painter",
    ref: containerRef
  }, /*#__PURE__*/React__default.createElement(TabsOptions, null, /*#__PURE__*/React__default.createElement("div", {
    className: "hotspots-painter__tab-content"
  }, /*#__PURE__*/React__default.createElement(HotspotsPainterToolbar, {
    undo: onUndo,
    redo: onRedo,
    draw: onDraw,
    select: onSelect,
    deleteItem: onDelete,
    canUndo: !(mode === 'draw' ? activePoints.length < 1 : selectedHotspotIndex === null || hotspotsState[selectedHotspotIndex].area.length <= 3),
    canRedo: undonePoints.length > 0,
    canDraw: mode !== 'draw',
    canSelect: mode !== 'select',
    canDelete: !(mode === 'draw' ? activePoints.length < 1 : selectedHotspotIndex === null),
    isDrawing: mode === 'draw',
    isSelecting: mode === 'select'
  }))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: 'relative',
      width: '100%',
      paddingBottom: image.height / image.width * 100 + '%'
    }
  }, /*#__PURE__*/React__default.createElement("svg", {
    ref: svgRef,
    onClick: handleClickSvg,
    onContextMenu: onConfirmHotspot,
    viewBox: "0 0 " + image.width + " " + image.height,
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      cursor: isMouseInsideAnotherHotspot ? 'not-allowed' : mode === 'draw' ? 'crosshair' : 'default'
    },
    onMouseMove: handleMouseMove,
    preserveAspectRatio: "xMidYMid meet"
  }, /*#__PURE__*/React__default.createElement("image", {
    href: image.src,
    x: "0",
    y: "0",
    width: image.width,
    height: image.height
  }), hotspotsState.map(function (hotspot, hotspotIndex) {
    return /*#__PURE__*/React__default.createElement("polygon", {
      key: hotspotIndex,
      points: hotspot.area.map(function (p) {
        return p.x + "," + p.y;
      }).join(' '),
      fill: hotspotIndex === selectedHotspotIndex && isMoveHoveringOther ? 'var(--lemo-color-error-light-alpha)' : hotspotIndex === selectedHotspotIndex ? 'var(--lemo-color-corporate-light-alpha)' : 'var(--lemo-color-corporate-light-alpha)',
      stroke: hotspotIndex === selectedHotspotIndex && isMoveHoveringOther ? 'var(--lemo-color-error)' : hotspotIndex === selectedHotspotIndex ? 'var(--lemo-color-corporate)' : 'var(--lemo-color-corporate)',
      onClick: handleHotspotClick(hotspotIndex),
      style: mode === 'select' && hotspotIndex === selectedHotspotIndex ? {
        cursor: 'move'
      } : {}
    });
  }), activePoints.length > 0 && mousePos && /*#__PURE__*/React__default.createElement("polygon", {
    points: activePoints.map(function (p) {
      return p.x + "," + p.y;
    }).join(' ') + (" " + mousePos.x + "," + mousePos.y),
    fill: isMouseInsideAnotherHotspot ? 'var(--lemo-color-error-light-alpha)' : 'var(--lemo-color-corporate-light-alpha)',
    stroke: "none"
  }), activePoints.length > 0 && mousePos && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("polyline", {
    points: activePoints.map(function (p) {
      return p.x + "," + p.y;
    }).join(' '),
    fill: "none",
    stroke: isMouseInsideAnotherHotspot ? 'var(--lemo-color-error)' : 'var(--lemo-color-corporate)'
  }), /*#__PURE__*/React__default.createElement("line", {
    x1: activePoints[activePoints.length - 1].x,
    y1: activePoints[activePoints.length - 1].y,
    x2: mousePos.x,
    y2: mousePos.y,
    strokeDasharray: "6",
    fill: "none",
    stroke: isMouseInsideAnotherHotspot ? 'var(--lemo-color-error)' : 'var(--lemo-color-corporate)'
  })), activePoints.map(function (point, index) {
    return /*#__PURE__*/React__default.createElement("circle", {
      key: index,
      cx: point.x,
      cy: point.y,
      r: "4",
      fill: isMouseInsideAnotherHotspot ? 'var(--lemo-color-error)' : 'var(--lemo-color-corporate)',
      className: index === 0 ? 'hotspots-painter__first-vertex' : '',
      onClick: index === 0 ? onConfirmHotspot : null
    });
  }), selectedHotspotIndex !== null && hotspotsState[selectedHotspotIndex].area.map(function (point, index) {
    return /*#__PURE__*/React__default.createElement("circle", {
      key: index,
      cx: point.x,
      cy: point.y,
      r: "4",
      className: "hotspots-painter__selected-hotspot-vertex",
      "data-index": index,
      fill: isMoveHoveringOther ? 'var(--lemo-color-error)' : 'var(--lemo-color-corporate)'
    });
  })), hotspotsState.map(function (hotspot, hotspotIndex) {
    if (hotspotIndex === selectedHotspotIndex && !selectedVertexIndex) {
      var _getPosToHotspotInfo = getPosToHotspotInfo(hotspot),
        posX = _getPosToHotspotInfo.posX,
        posY = _getPosToHotspotInfo.posY;
      return /*#__PURE__*/React__default.createElement(HotspotInfo, {
        x: posX,
        y: posY,
        id: hotspot.id,
        key: hotspot.id
      });
    }
    return null;
  })));
}
HotspotsPainter.propTypes = {
  hotspots: propTypes.arrayOf(hotspotPropTypes).isRequired,
  getInfoFromIdDrop: propTypes.func.isRequired
};
HotspotsPainter.defaultProps = {
  hotspots: [],
  onClickHotspot: function onClickHotspot() {},
  onHoverHotspot: function onHoverHotspot() {},
  hotspotStyles: {}
};

var ImageModel$1 = types$1.model({
  src: types$1.string
}).actions(function (state) {
  return {
    setSrc: function setSrc(src) {
      state.src = src;
    },
    hydrate: function hydrate(data) {
      hydrateKeys(data, state);
    }
  };
});

var DragModel$b = types$1.compose(withNumberDuplicates, withElementFeedback, types$1.model({
  id: types$1.optional(types$1.string, function () {
    return uuid();
  }),
  label: types$1.optional(types$1.string, ''),
  image: types$1.maybe(ImageModel$1)
}).actions(function (state) {
  return {
    setLabel: function setLabel(label) {
      state.label = label;
    },
    setImageSrc: function setImageSrc(src) {
      state.image = ImageModel$1.create({
        src: src
      });
      getParent(state, 2).updateNotifier();
    }
  };
}).views(function (state) {
  return {
    exportToPossibleResponses: function exportToPossibleResponses(duplicateResponseEnabled) {
      return {
        id: state.id,
        label: state.label,
        feedback: state.feedback,
        image: safeSnapshot(state.image),
        number_duplicates: duplicateResponseEnabled ? state.numberDuplicates : 1
      };
    },
    get imageSrc() {
      var _state$image;
      return (_state$image = state.image) === null || _state$image === void 0 ? void 0 : _state$image.src;
    }
  };
}));

var DropModel$8 = types$1.compose(getWithFeedbackResult(sortAndStringify), withIsDraggingOver, types$1.model({
  id: types$1.optional(types$1.string, function () {
    return uuid();
  }),
  label: types$1.optional(types$1.string, ''),
  area: types$1.optional(types$1.array(XYModel), [])
}).actions(function (state) {
  return {
    setLabel: function setLabel(label) {
      state.label = label;
    },
    removeChild: function removeChild(item) {
      destroy(item);
    },
    reset: function reset() {
      state.area = [];
    }
  };
}).views(function (state) {
  return {
    get index() {
      return getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get parent() {
      return getParent(state, 2);
    },
    exportToHotspots: function exportToHotspots() {
      return {
        id: state.id,
        label: state.label,
        area: safeSnapshot(state.area)
      };
    }
  };
}));

var StickersUIStyles = types$1.compose(BaseModel$1, types$1.model({
  show_hotspots: types$1.optional(types$1["boolean"], true),
  show_drag_over: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    setShowHotspots: function setShowHotspots(show_hotspots) {
      state.show_hotspots = show_hotspots;
      getParent(state).updateNotifier();
    },
    setShowDragOver: function setShowDragOver(show_drag_over) {
      state.show_drag_over = show_drag_over;
      getParent(state).updateNotifier();
    }
  };
}));

var withShowDropIndicator = types$1.model({}).actions(function (state) {
  return {
    setShowDropIndicator: function setShowDropIndicator(showDropIndicator) {
      state.show_drag_over = showDropIndicator;
      state.updateNotifier();
    }
  };
}).views(function (state) {
  return {
    get showDropIndicator() {
      return state.show_drag_over;
    }
  };
});

var PREFIX_ID_HOTSPOT = 'DROP_';
var PREFIX_ID_DRAG = 'DRAG_';
var StickersEditorStore = types$1.compose(withImmediateHandlers('drops'), withWhileDraggingTarget, EditorBaseModel, withShowDropIndicator, types$1.model({
  drops: types$1.optional(types$1.array(DropModel$8), []),
  drags: types$1.array(DragModel$b),
  duplicate_responses: types$1.optional(types$1["boolean"], false),
  group_responses: types$1.optional(types$1["boolean"], false),
  shuffle_options: types$1.optional(types$1["boolean"], false),
  image: ImageModel,
  validation: ValidationModel,
  ui_style: StickersUIStyles
}).actions(function (state) {
  function getNumberDuplicatesDefault() {
    return 4;
  }
  return {
    afterCreate: function afterCreate() {
      onAction(state, function (_ref) {
        var name = _ref.name,
          path = _ref.path;
        if (name.match(/addDrag|setValue|toggleStack|toggleWithBox/)) {
          state.updateNotifier();
        }
        if (path.match(/validation/)) {
          state.updateQuestionPreview();
        }
      }, true);
    },
    setImage: function setImage(_ref2) {
      var src = _ref2.src,
        width = _ref2.width,
        height = _ref2.height,
        percent = _ref2.percent,
        alt = _ref2.alt;
      console.log({
        src: src,
        width: width,
        height: height,
        percent: percent,
        alt: alt
      });
      state.image = {
        src: src,
        width: width,
        height: height,
        percent: percent,
        alt: alt,
        title: ''
      };
      state.updateNotifier();
    },
    setShuffleOptions: function setShuffleOptions(bool) {
      state.shuffle_options = bool;
    },
    deleteDuplicatesValidation: function deleteDuplicatesValidation() {
      function removeDuplicates(arr) {
        var seen = {};
        var result = [];
        for (var i = 0; i < arr.length; i++) {
          if (!seen[arr[i]['dragId']]) {
            seen[arr[i]['dragId']] = true;
            result.push(arr[i]);
          }
        }
        return result;
      }
      var updateSolution = function updateSolution(solution) {
        var updatedSolution = removeDuplicates([].concat(solution));
        return updatedSolution;
      };
      state.validation.solutionList.forEach(function (solution, idx) {
        var currentSolution = state.validation.solutionList[idx].value;
        var updated = updateSolution(currentSolution);
        state.validation.updateSolution(idx, updated);
      });
    },
    setDuplicateResponses: function setDuplicateResponses(bool) {
      state.duplicate_responses = bool;
      if (!bool) state.deleteDuplicatesValidation();
      state.drags.forEach(function (drag) {
        return drag.setNumberDuplicates(bool ? getNumberDuplicatesDefault() : 1);
      });
      state.updateNotifier();
    },
    setGroupResponses: function setGroupResponses(bool) {
      state.group_responses = bool;
      state.updateNotifier();
    },
    reset: function reset() {
      state.isEvaluated = false;
      state.showSolution = false;
      state.tempResponse = [];
      state.clearDrops();
    },
    setDrops: function setDrops(drops) {
      state.drops = drops;
    },
    clearDrops: function clearDrops() {
      state.drops.forEach(function (drop) {
        return drop.reset();
      });
    },
    addDrag: function addDrag(value) {
      var indexLabel = state.drags ? state.drags.length + 1 : '';
      var maxNumberIdDrags = state.getMaxNumberIdDrags();
      function getIdToNewHotspot() {
        return PREFIX_ID_DRAG + (maxNumberIdDrags + 1);
      }
      state.drags.push({
        id: getIdToNewHotspot(),
        label: value || "<p>" + translate('option') + " " + indexLabel + "</p>",
        numberDuplicates: getNumberDuplicatesDefault(),
        image: {
          src: 'https://lemonade-assets-prod-content.s3.eu-central-1.amazonaws.com/manzana-small.png'
        }
      });
      state.updateNotifier();
    },
    sortDrags: function sortDrags(source, destination) {
      state.drags = sortArrayItem(source, destination, state.drags);
    },
    deleteDragIdsSolutions: function deleteDragIdsSolutions(dragId) {
      function filterByDragId(arr, dragIdToRemove) {
        return arr.filter(function (obj) {
          return obj.dragId !== dragIdToRemove;
        });
      }
      var updateSolution = function updateSolution(solution) {
        var updatedSolution = filterByDragId(solution, dragId);
        return updatedSolution;
      };
      state.validation.solutionList.forEach(function (solution, idx) {
        var currentSolution = state.validation.solutionList[idx].value;
        var updated = updateSolution(currentSolution);
        state.validation.updateSolution(idx, updated);
      });
    },
    onDeleteDrag: function onDeleteDrag(drag) {
      state.deleteDragIdsSolutions(drag.id);
      destroy(drag);
      state.updateNotifier();
    },
    deleteDrag: function deleteDrag(drag) {
      setTimeout(function () {
        return state.onDeleteDrag(drag);
      }, 50);
    },
    deleteDropIdsSolutions: function deleteDropIdsSolutions(dropId) {
      function filterByDropId(arr, dropIdToRemove) {
        return arr.filter(function (obj) {
          return obj.dropId !== dropIdToRemove;
        });
      }
      var updateSolution = function updateSolution(solution) {
        var updatedSolution = filterByDropId(solution, dropId);
        return updatedSolution;
      };
      state.validation.solutionList.forEach(function (solution, idx) {
        var currentSolution = state.validation.solutionList[idx].value;
        var updated = updateSolution(currentSolution);
        state.validation.updateSolution(idx, updated);
      });
    },
    setData: function setData(data) {
      applySnapshot(state, data);
      state.updateNotifier();
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot$n(rawData);
      applySnapshot(state, data);
      state.setIsSolutionMode(true);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    setDropsFromHostpots: function setDropsFromHostpots(hotspots) {
      var newDropIds = hotspots.map(function (hotspot) {
        return hotspot.id;
      });
      var currentDropIds = [];
      state.validation.solutionList.forEach(function (solution) {
        solution.value.forEach(function (drop) {
          currentDropIds.push(drop.dropId);
        });
      });
      state.drops = createDrops$4(hotspots);
      var dropIdsToRemove = currentDropIds.filter(function (dropId) {
        return !newDropIds.includes(dropId);
      });
      dropIdsToRemove.forEach(function (dropId) {
        state.deleteDropIdsSolutions(dropId);
      });
      state.updateNotifier();
    },
    setShowDropIndicator: function setShowDropIndicator(showDropIndicator) {
      state.ui_style.setShowDragOver(showDropIndicator);
      state.updateNotifier();
    }
  };
}).views(function (state) {
  return {
    getUserResponse: function getUserResponse() {
      return '';
    },
    getResults: function getResults() {
      return {};
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$n(rawData);
    },
    getDropTarget: function getDropTarget(drag) {
      return state.drops.find(function (drop) {
        return drop.valueText.includes(drag.value);
      });
    },
    getResponseById: function getResponseById(id) {
      return state.drops.find(function (drop) {
        return drop.id === id;
      });
    },
    getSolutions: function getSolutions() {
      return state.validation.value;
    },
    getMaxNumberIdDrags: function getMaxNumberIdDrags() {
      return getMaxNumberIdElements(state.drags);
    },
    get showDropIndicator() {
      return state.ui_style.show_drag_over;
    },
    get output() {
      return exportCommonValues(state, {
        template: state.template,
        possible_responses: state.drags.map(function (val) {
          return val.exportToPossibleResponses(state.duplicate_responses);
        }),
        hotspots: state.drops.map(function (drop) {
          return drop.exportToHotspots();
        }),
        shuffle_options: state.shuffle_options,
        duplicate_responses: state.duplicate_responses,
        group_responses: state.group_responses,
        image: getSnapshot(state.image),
        validation: _extends({}, getSnapshot(state.validation))
      });
    }
  };
}));
function getMaxNumberIdElements(elements) {
  var numbers = elements.map(function (obj) {
    var parts = obj.id.split('_');
    return Number(parts[parts.length - 1]);
  });
  var maxNumber = numbers.length > 0 ? Math.max.apply(Math, numbers) : undefined;
  return maxNumber || 0;
}
function createDrops$4(hotspots) {
  return hotspots.map(function (hotspot, idx) {
    return hotspot;
  });
}
function createDragsFromPossibleResponses(possible_responses) {
  return possible_responses.map(function (posibleResponse, idx) {
    return {
      id: posibleResponse.id,
      label: posibleResponse.label,
      image: posibleResponse.image,
      feedback: posibleResponse.feedback,
      numberDuplicates: posibleResponse.number_duplicates !== undefined ? posibleResponse.number_duplicates : 1
    };
  });
}
function _createSnapshot$n(data) {
  var _data$data = data.data,
    possible_responses = _data$data.possible_responses,
    hotspots = _data$data.hotspots;
  return _extends({}, data.data, importCommonValues$1(data), {
    drops: createDrops$4(hotspots),
    drags: createDragsFromPossibleResponses(possible_responses),
    image: _extends({}, data.data.image)
  });
}
function createStore$r(data) {
  var store = StickersEditorStore.create(_createSnapshot$n(data));
  return store;
}

var EditorDropHotspot = function EditorDropHotspot(_ref) {
  var image = _ref.image,
    hotspots = _ref.hotspots,
    setHotspots = _ref.setHotspots;
  function setPolygons(polygons) {
    setHotspots(polygons);
  }
  function getIdToNewHotspot() {
    return PREFIX_ID_HOTSPOT + (getMaxNumberIdHotspots() + 1);
  }
  function getInfoFromIdDrop(idDrop) {
    var splittedText = idDrop.split('_');
    if (splittedText.length > 1 && !isNaN(splittedText[1])) {
      return {
        text: splittedText[0],
        number: parseInt(splittedText[1])
      };
    } else {
      return {
        text: inputText,
        number: null
      };
    }
  }
  function getMaxNumberIdHotspots() {
    return getMaxNumberIdElements(hotspots);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-drop-hotspot"
  }, /*#__PURE__*/React__default.createElement(HotspotsPainter, {
    image: image,
    hotspots: hotspots,
    setHotspots: setPolygons,
    getIdToNewHotspot: getIdToNewHotspot,
    getInfoFromIdDrop: getInfoFromIdDrop
  }));
};
EditorDropHotspot.propTypes = {};
var EditorDropHotspot$1 = observer(EditorDropHotspot);

var EditorDropHotspotSt = function EditorDropHotspotSt(_ref) {
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(EditorDropHotspot$1, {
    image: store.image,
    hotspots: store.drops.map(function (drop) {
      return drop.exportToHotspots();
    }),
    setHotspots: store.setDropsFromHostpots
  });
};
EditorDropHotspotSt.propTypes = {};
var EditorDropHotspotSt$1 = observer(EditorDropHotspotSt);

var idBox = 'EditorStickersDrop';
var titleBoxRef = 'stickers_drop_editor_title';
var titleBoxHelpRef = 'stickers_drop_editor_help';
function EditorDrop(_ref) {
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: idBox,
    icon: /*#__PURE__*/React__default.createElement(SvgPhotograph, {
      className: "lemo-editor-background__icon"
    }),
    titleBox: translate(titleBoxRef),
    helpText: translate(titleBoxHelpRef),
    classNameAdd: "lemo-editor-stickers-drop"
  }, /*#__PURE__*/React__default.createElement(Tabs, {
    tabs: [{
      id: 'uploadImage',
      title: translate('stickers_drop_editor_tab_upload_image'),
      content: /*#__PURE__*/React__default.createElement(EditorDropImageSt$1, {
        store: store
      })
    }, {
      id: 'hotspots',
      title: translate('stickers_drop_editor_tab_hotspots'),
      hideOptions: true,
      content: /*#__PURE__*/React__default.createElement(EditorDropHotspotSt$1, {
        store: store
      })
    }]
  }));
}
var EditorDrop$1 = observer(EditorDrop);

var _excluded$h = ["store", "changed", "type", "immediateFeedback"];
var StickersEditor = function StickersEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$h);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setTitle|setStimulus|setValue|setScore|removeResponseByIdx|setTemplate|sortResponses|destroy|setValidResponse|setColumnCount|setRowCount|addItem|sortDrags|addDrag|setShuffleOptions|setDuplicateResponses|setIsEvaluable|updateSolution|createAlternativeSolution|removeSolution|setBackground|toggleWithBox|toggleStack|setStack|setWithBox|sortColumns|setLabel|onDeleteDrag|setImageSrc|setGroupResponses|setImage|setDropsFromHostpots|setShowDropIndicator|setShowHotspots",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 2
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 3,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(EditorAnswerOptionsStore$1, {
    store: store,
    options: store.drags,
    onSortOptions: store.sortDrags,
    onClickAddOption: function onClickAddOption() {
      return store.addDrag();
    },
    showToggleShuffleOptions: false,
    showToggleDuplicateResponses: true,
    showNumberDuplicates: store.duplicate_responses,
    keyIdSortingList: "id",
    idBox: "drags",
    titleBox: translate('answer_options'),
    helpText: translate('answer_options_help'),
    modelGetListString: "label",
    modelSetListString: "setLabel",
    onDeleteOption: store.onDeleteDrag,
    imagePickerProps: {
      altTextKey: 'change_image',
      modelGetSrc: 'imageSrc',
      modelSetSrc: 'setImageSrc',
      removableImage: false
    },
    showToggleGroupResponses: true,
    groupResponses: store.group_responses,
    onChangeGroupResponses: store.setGroupResponses,
    placeHolderItemList: translate('stickers_answer_options_placeholder')
  }), /*#__PURE__*/React__default.createElement(EditorDrop$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    evaluationTypes: [getEvaluationTypeOption(keysTranslateEvaluationTypes.EXACT_MATCH, keysTranslateSubtitleEvaluationTypes.EXACT_MATCH, validationModes.EXACT_MATCH)],
    helpText: translate('exact_math_or_match_response_or_match_group_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: [TYPES_CONFIG.CONFIG_SHOW_HOTSPOTS, TYPES_CONFIG.CONFIG_DROP_INDICATOR]
  }));
};
var StickersEditor$1 = observer(StickersEditor);

var pointerList = ['', 'left', 'right', 'top', 'bottom'];

var withFixDropPositions = types$1.model().actions(function (state) {
  return {
    fixPosition: function fixPosition(imgAttributes) {
      var right = state.x + state.width;
      var top = state.y + state.height;
      right > imgAttributes.width && state.setX(imgAttributes.width - state.width);
      top > imgAttributes.height && state.setY(imgAttributes.height - state.height);
    }
  };
});

var BlankModel = types$1.compose(withShowSolutionsParent, ValueModel, withIsDraggingOver, withElementFeedback, getWithFeedbackResult(normalize$6), withFixDropPositions, types$1.model({
  x: types$1.number,
  y: types$1.number,
  z: 0,
  width: types$1.number,
  height: types$1.number,
  pointer: types$1.optional(types$1.enumeration(pointerList), ''),
  inputType: types$1.optional(types$1.string, 'text')
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      state.z = state.z === 0 ? state.maxDepth + 1 : state.z;
    },
    getNextDepth: function getNextDepth() {
      if (state.maxDepth !== state.z) {
        state.z = state.maxDepth + 1;
      }
    },
    setZ: function setZ(z) {
      state.z = z;
    },
    setX: function setX(x) {
      state.x = parseInt(x, 10);
      state.updateNotifier();
    },
    setY: function setY(y) {
      state.y = parseInt(y, 10);
      state.updateNotifier();
    },
    setPosition: function setPosition(_ref) {
      var x = _ref.x,
        y = _ref.y;
      state.x = parseInt(x, 10);
      state.y = parseInt(y, 10);
      state.updateNotifier();
    },
    setWidth: function setWidth(width) {
      state.width = parseInt(width, 10);
      state.updateNotifier();
    },
    setHeight: function setHeight(height) {
      state.height = parseInt(height, 10);
      state.updateNotifier();
    },
    setSize: function setSize(_ref2) {
      var width = _ref2.width,
        height = _ref2.height;
      state.width = parseInt(width, 10);
      state.height = parseInt(height, 10);
      state.updateNotifier();
    },
    select: function select() {
      getParent(state, 2).setSelected(state.id);
    },
    setPointer: function setPointer(pointer) {
      state.pointer = pointer;
      state.updateNotifier();
    },
    destroy: function destroy() {
      getParent(state, 2).setSelected('');
      getParent(state, 2).removeValue(state);
    },
    triggerImmediateResponse: function triggerImmediateResponse() {
      getParent(state, 2).setImmediateResponse({
        itemRef: state.id,
        value: state.isValid
      });
    },
    setValue: function setValue(value) {
      state.value = value;
      state.triggerImmediateResponse();
      state.updateNotifier(false);
    },
    setValidResponse: function setValidResponse(validResponse) {},
    updateDropPositionsOnBGChange: function updateDropPositionsOnBGChange() {},
    reset: function reset() {
      state.value = '';
    },
    updateNotifier: function updateNotifier(bool) {
      if (bool === void 0) {
        bool = true;
      }
      getParent(state, 2).updateNotifier(bool);
    },
    hydrate: function hydrate(data) {
      hydrateKeys(data, state, ['value']);
    }
  };
}).views(function (state) {
  return {
    get templateName() {
      return getParent(state, 2).raw.metadata.name;
    },
    get maxDepth() {
      return getParent(state).reduce(function (acc, next) {
        return next.z > acc ? next.z : acc;
      }, 0);
    },
    get isSelected() {
      return getParent(state, 2).selected === state.id;
    },
    get pointerIndex() {
      return pointerList.findIndex(function (p) {
        return p === state.pointer;
      });
    },
    get sizeToString() {
      return "" + state.width + state.height;
    },
    get fontSize() {
      return getParent(state, 2).fontSize;
    },
    get selected() {
      return state.value.length > 0;
    },
    get responseLength() {
      var parent = getParent(state, 2);
      if (parent.isSolutionMode) return -1;
      var validation = parent.validation;
      var maxResponseLength = [validation.value[state.index]].concat(validation.alt_responses.map(function (response) {
        return response.value[state.index];
      })).reduce(function (acc, next) {
        return next && next.length > acc ? next.length : acc;
      }, 0);
      return getParent(state, 2).autosizeResponse ? maxResponseLength : -1;
    },
    get validResponse() {
      return getParent(state, 2).validation.value[state.index];
    },
    get validAlternatives() {
      return getParent(state, 2).validation.alt_responses.map(function (response) {
        return response.index;
      });
    },
    get parent() {
      return getParent(state, 2);
    },
    get isImmediate() {
      return getParent(state, 2).validation.immediateFeedback;
    },
    get type() {
      return getParent(state, 2) && getParent(state, 2).raw && getParent(state, 2).raw.type ? getParent(state, 2).raw.type : null;
    },
    get isCanShowElementFeedback() {
      return isCanShowElementFeedbackParam(state.type, state.isEmptyResponse(state.value), false);
    },
    get output() {
      return {
        width: state.width,
        height: state.height,
        x: state.x,
        y: state.y,
        pointer: state.pointer,
        value: state.value,
        validResponse: state.validResponse
      };
    }
  };
}));
function normalize$6(str, state) {
  var normalization = getParent(state, 2).normalization;
  return normalization ? normalization.resolve(str) : str;
}

function getPx(base, item) {
  return item / 100 * base;
}

function updateDrops(blankList, state) {
  blankList.forEach(function (drop, idx) {
    state.blankList[idx].setPosition([drop.x, drop.y]);
    state.blankList[idx].setSize([getPx(state.image.width, drop.size.width), getPx(state.image.height, drop.size.height)]);
    state.blankList[idx].setPointer(drop.pointer);
  });
  state.updateNotifier();
}

function getPercentImageFromData(data) {
  var percentImage = null;
  if (data) {
    var imageSizeOld = data.data && data.data.hasOwnProperty('imageSize') && data.data.imageSize >= 0 ? data.data.imageSize : null;
    if (data.data && data.data.image && data.data.image.hasOwnProperty('percent')) {
      percentImage = data.data.image.percent;
    } else if (imageSizeOld) {
      percentImage = imageSizeOld / 100;
    }
  }
  return percentImage;
}

var ImageModel$2 = types$1.model({
  src: types$1.string
}).actions(function (state) {
  return {
    setSrc: function setSrc(src) {
      state.src = src;
    },
    hydrate: function hydrate(data) {
      hydrateKeys(data, state);
    }
  };
});

var DragModel$c = types$1.compose(withNumberDuplicates, withElementFeedback, types$1.model({
  id: types$1.optional(types$1.string, function () {
    return uuid();
  }),
  label: types$1.optional(types$1.string, ''),
  image: types$1.maybe(ImageModel$2)
}).actions(function (state) {
  return {
    setLabel: function setLabel(label) {
      state.label = label;
    },
    setImageSrc: function setImageSrc(src) {
      state.image = ImageModel$2.create({
        src: src
      });
      getParent(state, 2).updateNotifier();
    }
  };
}).views(function (state) {
  return {
    exportToPossibleResponses: function exportToPossibleResponses(duplicateResponseEnabled) {
      return {
        id: state.id,
        label: state.label,
        feedback: state.feedback,
        image: safeSnapshot(state.image),
        number_duplicates: duplicateResponseEnabled ? state.numberDuplicates : 1
      };
    },
    get imageSrc() {
      var _state$image;
      return (_state$image = state.image) === null || _state$image === void 0 ? void 0 : _state$image.src;
    }
  };
}));

var DROP_ORIENTATIONS = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal'
};
var DropModel$9 = types$1.compose(withShowSolutionsParent, ValueModel, withIsDraggingOver, withElementFeedback, getWithFeedbackResult(normalize$7), withFixDropPositions, types$1.model({
  x: types$1.number,
  y: types$1.number,
  z: 0,
  width: types$1.number,
  height: types$1.number,
  fixed_elements: types$1.optional(types$1.number, 0),
  orientation: types$1.optional(types$1.enumeration('orientation', [DROP_ORIENTATIONS.VERTICAL, DROP_ORIENTATIONS.HORIZONTAL]), DROP_ORIENTATIONS.HORIZONTAL),
  inputType: types$1.optional(types$1.string, 'text')
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      state.z = state.z === 0 ? state.maxDepth + 1 : state.z;
    },
    getNextDepth: function getNextDepth() {
      if (state.maxDepth !== state.z) {
        state.z = state.maxDepth + 1;
      }
    },
    setZ: function setZ(z) {
      state.z = z;
    },
    setX: function setX(x) {
      state.x = parseInt(x, 10);
      state.updateNotifier();
    },
    setY: function setY(y) {
      state.y = parseInt(y, 10);
      state.updateNotifier();
    },
    setPosition: function setPosition(_ref) {
      var x = _ref.x,
        y = _ref.y;
      state.x = parseInt(x, 10);
      state.y = parseInt(y, 10);
      state.updateNotifier();
    },
    setWidth: function setWidth(width) {
      state.width = parseInt(width, 10);
      state.updateNotifier();
    },
    setHeight: function setHeight(height) {
      state.height = parseInt(height, 10);
      state.updateNotifier();
    },
    setFixedElement: function setFixedElement(fixed_elements) {
      state.fixed_elements = fixed_elements;
      state.updateNotifier();
    },
    setSize: function setSize(_ref2) {
      var width = _ref2.width,
        height = _ref2.height;
      state.width = parseInt(width, 10);
      state.height = parseInt(height, 10);
      state.updateNotifier();
    },
    select: function select() {
      getParent(state, 2).setSelected(state.id);
    },
    destroy: function destroy() {
      getParent(state, 2).setSelected('');
      getParent(state, 2).removeValue(state);
    },
    triggerImmediateResponse: function triggerImmediateResponse() {
      getParent(state, 2).setImmediateResponse({
        itemRef: state.id,
        value: state.isValid
      });
    },
    setValue: function setValue(value) {
      state.value = value;
      state.triggerImmediateResponse();
      state.updateNotifier(false);
    },
    setValidResponse: function setValidResponse(validResponse) {},
    updateDropPositionsOnBGChange: function updateDropPositionsOnBGChange() {},
    reset: function reset() {
      state.value = '';
    },
    updateNotifier: function updateNotifier(bool) {
      if (bool === void 0) {
        bool = true;
      }
      getParent(state, 2).updateNotifier(bool);
    },
    hydrate: function hydrate(data) {
      hydrateKeys(data, state, ['value']);
    }
  };
}).views(function (state) {
  return {
    get templateName() {
      return getParent(state, 2).raw.metadata.name;
    },
    get maxDepth() {
      return getParent(state).reduce(function (acc, next) {
        return next.z > acc ? next.z : acc;
      }, 0);
    },
    get isSelected() {
      return getParent(state, 2).selected === state.id;
    },
    get sizeToString() {
      return "" + state.width + state.height;
    },
    get fontSize() {
      return getParent(state, 2).fontSize;
    },
    get selected() {
      return state.value.length > 0;
    },
    get responseLength() {
      var parent = getParent(state, 2);
      if (parent.isSolutionMode) return -1;
      var validation = parent.validation;
      var maxResponseLength = [validation.value[state.index]].concat(validation.alt_responses.map(function (response) {
        return response.value[state.index];
      })).reduce(function (acc, next) {
        return next && next.length > acc ? next.length : acc;
      }, 0);
      return getParent(state, 2).autosizeResponse ? maxResponseLength : -1;
    },
    get validResponse() {
      return getParent(state, 2).validation.value[state.index];
    },
    get validAlternatives() {
      return getParent(state, 2).validation.alt_responses.map(function (response) {
        return response.index;
      });
    },
    get parent() {
      return getParent(state, 2);
    },
    get isImmediate() {
      return getParent(state, 2).validation.immediateFeedback;
    },
    get type() {
      return getParent(state, 2) && getParent(state, 2).raw && getParent(state, 2).raw.type ? getParent(state, 2).raw.type : null;
    },
    get isCanShowElementFeedback() {
      return isCanShowElementFeedbackParam(state.type, state.isEmptyResponse(state.value), false);
    }
  };
}));
function normalize$7(str, state) {
  var normalization = getParent(state, 2).normalization;
  return normalization ? normalization.resolve(str) : str;
}

var Z_INDEX_BEGIN_DROP_LIST_DEFAULT = 10;
var POSITION_AUTO_DROP_LIST = 10;
function getPositionByIndex(index) {
  return {
    x: index * POSITION_AUTO_DROP_LIST,
    y: index * POSITION_AUTO_DROP_LIST
  };
}
function resetDropPositions(state, modelGetList) {
  var blankList = modelGetList ? state[modelGetList] : state.blankList;
  blankList.forEach(function (drop, index) {
    drop.setPointer('');
    drop.setZ(Z_INDEX_BEGIN_DROP_LIST_DEFAULT + index);
    drop.setPosition(getPositionByIndex(index));
  });
}
function updateDropPositionsOnBGChange(state, modelGetList) {
  var blankList = modelGetList ? state[modelGetList] : state.blankList;
  blankList.forEach(function (drop) {
    drop.updateDropPositionsOnBGChange();
  });
}
function setImage(state, _ref, modelGetList) {
  var src = _ref.src,
    width = _ref.width,
    height = _ref.height,
    percent = _ref.percent,
    alt = _ref.alt;
  var oldSrc = state.image ? state.image.src : '';
  var isSrcChanged = src !== oldSrc;
  state.image = {
    src: src,
    width: width,
    height: height,
    percent: percent,
    alt: alt,
    title: ''
  };
  if (isSrcChanged) {
    updateDropPositionsOnBGChange(state, modelGetList);
    setTimeout(function () {
      updateDropPositionsOnBGChange(state, modelGetList);
    }, 1);
  }
}

var withIsVerticalOrientation = types$1.model({}).actions(function (state) {
  return {
    setIsVerticalOrientation: function setIsVerticalOrientation(isVerticalOrientation) {
      state.drops = state.drops.map(function (container) {
        return _extends({}, container, {
          orientation: isVerticalOrientation ? DROP_ORIENTATIONS.VERTICAL : DROP_ORIENTATIONS.HORIZONTAL
        });
      });
      state.updateNotifier();
    }
  };
}).views(function (state) {
  return {
    get isVerticalOrientation() {
      return !state.drops.every(function (container) {
        return container.orientation === DROP_ORIENTATIONS.HORIZONTAL;
      });
    }
  };
});

var PREFIX_ID_DROP = 'DROP_';
var PREFIX_ID_DRAG$1 = 'DRAG_';
var StickersSeriesEditorStore = types$1.compose(EditorBaseModel, withImmediateHandlers('drops'), withWhileDraggingTarget, withElementFeedbackParent('drops'), withIsVerticalOrientation, withShowDropIndicator, types$1.model({
  drops: types$1.optional(types$1.array(DropModel$9), []),
  drags: types$1.array(DragModel$c),
  image: types$1.maybe(ImageModel),
  selected: types$1.optional(types$1.string, ''),
  fontSize: types$1.optional(types$1.number, 10),
  sampleText: types$1.optional(types$1.string, translate('series')),
  validation: ValidationModel,
  group_responses: types$1.optional(types$1["boolean"], false),
  duplicate_responses: types$1.optional(types$1["boolean"], false),
  shuffle_options: types$1.optional(types$1["boolean"], false),
  show_drag_over: types$1.optional(types$1["boolean"], false),
  onUpdateNotifier: types$1.optional(types$1.number, 0),
  ui_style: types$1.optional(UIStyleModel$1, defaultUIStyle)
}).actions(function (state) {
  function getNumberDuplicatesDefault() {
    return 4;
  }
  return {
    afterCreate: function afterCreate() {
      onAction(state, function (_ref) {
        var name = _ref.name,
          path = _ref.path;
        if (name.match(/addBlank|setValidResponse|removeValue|destroy|removeSelected/)) {
          state.updateNotifier();
        }
        if (path.match(/\/drops|\/drags/) && name === 'setValue') {
          state.updateNotifier();
        }
        if (name === 'updateSolution') state.updateResponses();
      }, true);
    },
    setShuffleOptions: function setShuffleOptions(bool) {
      state.shuffle_options = bool;
    },
    setShowDragOver: function setShowDragOver(bool) {
      state.show_drag_over = bool;
    },
    deleteDuplicatesValidation: function deleteDuplicatesValidation() {
      var removeDuplicatesRow = function removeDuplicatesRow(responses) {
        return [].concat(new Set(responses));
      };
      var updateSolution = function updateSolution(solution) {
        var updatedSolution = {};
        for (var key in solution) {
          updatedSolution[key] = _extends({}, solution[key]);
          updatedSolution[key].responses = removeDuplicatesRow(updatedSolution[key].responses);
        }
        return updatedSolution;
      };
      state.validation.solutionList.forEach(function (solution, idx) {
        var currentSolution = state.validation.solutionList[idx].value;
        var updated = updateSolution(currentSolution);
        state.validation.updateSolution(idx, updated);
      });
    },
    setDuplicateResponses: function setDuplicateResponses(bool) {
      state.duplicate_responses = bool;
      if (!bool) state.deleteDuplicatesValidation();
      state.drags.forEach(function (drag) {
        return drag.setNumberDuplicates(bool ? getNumberDuplicatesDefault() : 1);
      });
      state.updateNotifier();
    },
    updateResponses: function updateResponses() {
      state.drops.forEach(function (response, idx) {
        var valid = defaultValue("validation.value." + idx, state, '');
        response.setValidResponse(valid.length === 0 ? '' : valid);
      });
    },
    updateNotifier: function updateNotifier() {
      state.onUpdateNotifier = Date.now();
    },
    updateDrops: function updateDrops$1(drops) {
      updateDrops(drops, state);
    },
    resetDropPositions: function resetDropPositions$1() {
      resetDropPositions(state, 'drops');
    },
    addNewSolution: function addNewSolution(dropId) {
      var newValue = _extends({}, state.validation.value);
      newValue[dropId] = {
        responses: []
      };
      state.validation.setValue(newValue);
      state.updateNotifier();
    },
    addDrop: function addDrop() {
      function getMaxNumberIdHotspots() {
        return getMaxNumberIdElements(state.drops);
      }
      function getIdToNewHotspot() {
        return PREFIX_ID_DROP + (getMaxNumberIdHotspots() + 1);
      }
      var position = getPositionByIndex(state.drops.length);
      var dropId = getIdToNewHotspot();
      state.drops.push({
        id: dropId,
        x: position.x,
        y: position.y,
        width: 230,
        height: 114
      });
      state.addNewSolution(dropId);
    },
    sortResponses: function sortResponses(source, destination) {
      state.drops = sortArrayItem(source, destination, state.drops);
    },
    clearResponses: function clearResponses() {
      state.drops.forEach(function (response) {
        return response.reset();
      });
    },
    getMaxNumberIdDrags: function getMaxNumberIdDrags() {
      return getMaxNumberIdElements(state.drags);
    },
    addDrag: function addDrag(value) {
      var indexLabel = state.drags ? state.drags.length + 1 : '';
      var maxNumberIdDrags = state.getMaxNumberIdDrags();
      function getIdToNewHotspot() {
        return PREFIX_ID_DRAG$1 + (maxNumberIdDrags + 1);
      }
      state.drags.push({
        id: getIdToNewHotspot(),
        label: value || "<p>" + translate('option') + " " + indexLabel + "</p>",
        numberDuplicates: getNumberDuplicatesDefault(),
        image: {
          src: 'https://lemonade-assets.oneclick.es/fruits/manzana-1.png'
        }
      });
      state.updateNotifier();
    },
    sortDrags: function sortDrags(source, destination) {
      state.drags = sortArrayItem(source, destination, state.drags);
      state.updateNotifier();
    },
    deleteDragIdsSolutions: function deleteDragIdsSolutions(dragId) {
      var updateSolutionRow = function updateSolutionRow(responses) {
        return responses.filter(function (responseId) {
          return responseId !== dragId;
        });
      };
      var updateSolution = function updateSolution(solution) {
        var updatedSolution = {};
        for (var key in solution) {
          updatedSolution[key] = _extends({}, solution[key]);
          updatedSolution[key].responses = updateSolutionRow(updatedSolution[key].responses);
        }
        return updatedSolution;
      };
      state.validation.solutionList.forEach(function (solution, idx) {
        var currentSolution = state.validation.solutionList[idx].value;
        var updated = updateSolution(currentSolution);
        state.validation.updateSolution(idx, updated);
      });
    },
    onDeleteDrag: function onDeleteDrag(drag) {
      state.deleteDragIdsSolutions(drag.id);
      destroy(drag);
      state.updateNotifier();
    },
    removeValue: function removeValue(instance) {
      if (getType(instance) === DragModel$c) {
        state.validation.findAndUpdateValue(instance.value, '');
      } else if (getType(instance) === BlankModel) {
        state.validation.removeValueAt(instance.index);
      }
      destroy(instance);
      state.updateNotifier();
    },
    removeSelected: function removeSelected() {
      if (!state.selected) return false;
      var selectedIdx = state.selectedBlank.index;
      state.removeValue(state.selectedBlank);
      state.validation.alt_responses.forEach(function (alt) {
        return alt.removeValueAt(selectedIdx);
      });
    },
    setData: function setData(data) {
      applySnapshot(state, _createSnapshot$o(data));
    },
    setSelected: function setSelected(itemId) {
      if (itemId === void 0) {
        itemId = '';
      }
      state.selected = itemId;
    },
    setSampleText: function setSampleText(value) {
      state.sampleText = value;
    },
    setFontSize: function setFontSize(fontSize) {
      state.fontSize = parseInt(fontSize, 10);
      state.updateNotifier();
    },
    setImagePercentBaseCent: function setImagePercentBaseCent(imagePercentBaseCent) {
      state.image = _extends({}, state.image, {
        percent: imagePercentBaseCent ? imagePercentBaseCent / 100 : 1
      });
      state.updateNotifier();
    },
    setImage: function setImage$1(imageAttributes) {
      setImage(state, imageAttributes, 'drops');
      state.drops.forEach(function (blank) {
        return blank.fixPosition(imageAttributes);
      });
      state.updateNotifier();
    },
    clearImage: function clearImage() {
      state.image = undefined;
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot$o(rawData);
      applySnapshot(state, data);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    commitResponseFeedback: function commitResponseFeedback() {
      commitFeedbackMessages({
        state: state,
        collection: state.drops,
        condition: getConditionCommitFeedbackMessages
      });
    },
    setGroupResponses: function setGroupResponses(bool) {
      state.group_responses = bool;
      state.updateNotifier();
    }
  };
}).views(function (state) {
  var normalize = function normalize(str) {
    return str;
  };
  return {
    getUserResponse: function getUserResponse() {
      return '';
    },
    getResults: function getResults() {
      return {};
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$o(rawData);
    },
    get containerSize() {
      return state.image.width * (state.getPercentImage() * 100) / 100;
    },
    getPercentImage: function getPercentImage() {
      var _state$image;
      return (state === null || state === void 0 ? void 0 : (_state$image = state.image) === null || _state$image === void 0 ? void 0 : _state$image.percent) || 1;
    },
    get imageSrc() {
      return findAbsolutePath(state.image.src) ? state.image.src : "" + addLastSlash(state.basePath) + state.image.src;
    },
    getDropTarget: function getDropTarget(dragValue) {
      return state.drops.find(function (blank) {
        return blank.value === dragValue;
      });
    },
    getDropById: function getDropById(id) {
      return state.drops.find(function (drop) {
        return drop.id === id;
      });
    },
    get currentResponse() {
      return state.selected && state.drops.find(function (res) {
        return res.id === state.selected;
      });
    },
    get selectedBlank() {
      return state.selected ? state.drops.find(function (d) {
        return d.id === state.selected;
      }) : undefined;
    },
    getSolutions: function getSolutions() {
      return state.validation.value;
    },
    get alternativePoints() {
      var validateAlternative = function validateAlternative(alt) {
        return alt.value.reduce(function (acc, next, idx) {
          return normalize(next) === normalize(state.getUserResponse()[idx]) ? acc : false;
        }, true);
      };
      return state.validation.alt_responses.reduce(function (acc, next) {
        return validateAlternative(next) ? next.score : acc;
      }, 0);
    },
    get percentImageBaseCent() {
      return state.getPercentImage() * 100;
    },
    get output() {
      var toRet = exportCommonValues(state, {
        image: getSnapshot(state.image),
        fontSize: state.fontSize,
        sampleText: state.sampleText,
        containers: state.drops.map(function (_ref2) {
          var x = _ref2.x,
            y = _ref2.y,
            z = _ref2.z,
            width = _ref2.width,
            height = _ref2.height,
            id = _ref2.id,
            label = _ref2.label,
            fixed_elements = _ref2.fixed_elements,
            orientation = _ref2.orientation;
          return {
            id: id,
            label: label,
            x: x,
            y: y,
            z: z,
            width: width,
            height: height,
            fixed_elements: fixed_elements,
            orientation: orientation
          };
        }),
        possible_responses: state.drags.map(function (val) {
          return val.exportToPossibleResponses(state.duplicate_responses);
        }),
        duplicate_responses: state.duplicate_responses,
        group_responses: state.group_responses,
        shuffle_options: state.shuffle_options,
        show_drag_over: state.show_drag_over,
        feedback_responses: state.feedbackResponsesOutput,
        validation: _extends({}, getSnapshot(state.validation))
      });
      if (toRet.data && toRet.data.hasOwnProperty('imageSize')) {
        delete toRet.data.imageSize;
      }
      return toRet;
    }
  };
}));
function createDrops$5(containers) {
  return containers.map(function (response, idx) {
    return _extends({}, response, {
      value: ''
    });
  });
}
function createDragsFromPossibleResponses$1(possible_responses) {
  return possible_responses.map(function (posibleResponse, idx) {
    return {
      id: posibleResponse.id,
      label: posibleResponse.label,
      image: posibleResponse.image,
      feedback: posibleResponse.feedback,
      numberDuplicates: posibleResponse.number_duplicates !== undefined ? posibleResponse.number_duplicates : 1
    };
  });
}
function _createSnapshot$o(data) {
  var _data$data = data.data,
    containers = _data$data.containers,
    possible_responses = _data$data.possible_responses;
  var percentImage = getPercentImageFromData(data);
  return _extends({}, data.data, importCommonValues$1(data), {
    drops: createDrops$5(containers),
    drags: createDragsFromPossibleResponses$1(possible_responses),
    image: _extends({}, data.data.image, percentImage ? {
      percent: percentImage
    } : {})
  });
}
function createStore$s(data) {
  return StickersSeriesEditorStore.create(_createSnapshot$o(data));
}

var _excluded$i = ["title", "subtitle", "value", "className", "inputType", "onChange", "autoSize", "placeholder", "selectAllOnFocus"];
var EditorInputTextTitleSubtitle = function EditorInputTextTitleSubtitle(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    value = _ref.value,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$inputType = _ref.inputType,
    inputType = _ref$inputType === void 0 ? 'text' : _ref$inputType,
    onChange = _ref.onChange,
    _ref$autoSize = _ref.autoSize,
    autoSize = _ref$autoSize === void 0 ? false : _ref$autoSize,
    placeholder = _ref.placeholder,
    _ref$selectAllOnFocus = _ref.selectAllOnFocus,
    selectAllOnFocus = _ref$selectAllOnFocus === void 0 ? false : _ref$selectAllOnFocus,
    extraProps = _objectWithoutPropertiesLoose(_ref, _excluded$i);
  function handleChange(event) {
    var value = event.target.value;
    if (inputType === 'number') return handleInputNumberChange(event);
    onChange(value);
  }
  function handleInputNumberChange(event) {
    var value = event.target.value;
    if (!value || isNaN(value)) return event.preventDefault();
    var val = Number(value);
    onChange(val);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn('lemo-input-text-title-subtitle', className, {
      'lemo-autosize': autoSize
    })
  }, /*#__PURE__*/React__default.createElement(EditorTitleSubtitleComponent, {
    title: title,
    subtitle: subtitle,
    componentRight: /*#__PURE__*/React__default.createElement(EditorInputText$1, _extends({
      value: value,
      type: inputType,
      autoSize: autoSize,
      onChange: handleChange,
      placeholder: placeholder,
      selectAllOnFocus: selectAllOnFocus
    }, extraProps))
  }));
};
var EditorInputTextTitleSubtitle$1 = observer(EditorInputTextTitleSubtitle);

function Pointer(_ref) {
  var _ref$scaleFactor = _ref.scaleFactor,
    scaleFactor = _ref$scaleFactor === void 0 ? 1 : _ref$scaleFactor;
  var dotSize = Math.max(scaleFactor, 0.6) * 100 + "%";
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-label-image-pointer-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-label-image-pointer",
    style: {
      width: dotSize,
      height: dotSize
    }
  }));
}

var POINTER_DISTANCE = 30;
function getDraggablePosition(height, width, pointer, scaleFactor) {
  var scaledPointerDistance = POINTER_DISTANCE * scaleFactor;
  switch (pointer) {
    case 'left':
      return {
        left: scaledPointerDistance,
        top: height / 2 * -1
      };
    case 'right':
      return {
        left: (width + scaledPointerDistance) * -1,
        top: height / 2 * -1
      };
    case 'top':
      return {
        left: width / 2 * -1,
        top: scaledPointerDistance
      };
    case 'bottom':
      return {
        left: width / 2 * -1,
        top: (height + scaledPointerDistance) * -1
      };
    default:
      return {
        left: 0,
        top: 0
      };
  }
}
function getNumber$1(val) {
  return hasData(val) ? val : 0;
}
function getBoundingBoxFatherResponsePointer(divResponse, divPointer, pointer) {
  if (divPointer) {
    var newHeight = getNumber$1(divResponse.height);
    if (pointer == 'top' || pointer == 'bottom') {
      newHeight = newHeight + getNumber$1(divPointer.height);
    }
    var newWidth = getNumber$1(divResponse.width);
    if (pointer == 'left' || pointer == 'right') {
      newWidth = newWidth + getNumber$1(divPointer.width);
    }
    var newLeft = Math.min(getNumber$1(divResponse.left), getNumber$1(divPointer.left));
    var newTop = Math.min(getNumber$1(divResponse.top), getNumber$1(divPointer.top));
    var dragBoundingBox = {
      bottom: newTop + newHeight,
      height: newHeight,
      left: newLeft,
      right: newLeft + newWidth,
      top: newTop,
      width: newWidth,
      x: newLeft,
      y: newTop
    };
    return dragBoundingBox;
  } else return divResponse;
}
function getMaxDimensionDrag(_ref) {
  var a = _ref.dragBoundingBox,
    b = _ref.baseBoundingBox,
    pointer = _ref.pointer,
    scaleFactor = _ref.scaleFactor;
  var width = 0;
  if (pointer === 'left') {
    width = getNumber$1(b.right) - getNumber$1(a.right) + a.width;
  } else if (pointer === 'right') {
    width = getNumber$1(a.left) - getNumber$1(b.left) + a.width;
  } else if (pointer === 'top' || pointer === 'bottom') {
    width = Math.min(getNumber$1(a.left) - getNumber$1(b.left), getNumber$1(b.right) - getNumber$1(a.right)) * 2 + a.width;
  } else {
    width = getNumber$1(b.right) - getNumber$1(a.right) + a.width;
  }
  if (scaleFactor && scaleFactor > 0 && width) {
    width = width / scaleFactor;
  }
  var height = 0;
  if (pointer === 'left' || pointer === 'right') {
    height = Math.min(getNumber$1(a.top) - getNumber$1(b.top), getNumber$1(b.bottom) - getNumber$1(a.bottom)) * 2 + a.height;
  } else if (pointer === 'top') {
    height = getNumber$1(b.bottom) - getNumber$1(a.bottom) + a.height;
  } else if (pointer === 'bottom') {
    height = getNumber$1(a.top) - getNumber$1(b.top) + a.height;
  } else {
    height = getNumber$1(b.bottom) - getNumber$1(a.bottom) + a.height;
  }
  if (scaleFactor && scaleFactor > 0 && height) {
    height = height / scaleFactor;
  }
  return {
    width: width,
    height: height
  };
}
function getWidthSafe(width, dropItemRefSelected, baseBoxRef, pointer, scaleFactor) {
  var newWidth = width;
  try {
    var divResponseBoundingBox = getDivResponseBoundingBox(dropItemRefSelected);
    if (divResponseBoundingBox) {
      var baseBoundingBox = getBaseBoundingBox(baseBoxRef);
      var maxDimensionDrag = getMaxDimensionDrag({
        dragBoundingBox: divResponseBoundingBox,
        baseBoundingBox: baseBoundingBox,
        pointerBoundingBox: getDivPointerBoundingBox(dropItemRefSelected),
        pointer: pointer,
        scaleFactor: scaleFactor
      });
      if (maxDimensionDrag && newWidth > maxDimensionDrag.width) {
        newWidth = maxDimensionDrag.width;
      }
    }
  } catch (error) {
    console.error(error);
  }
  if (newWidth < 0) newWidth = 0;
  return newWidth;
}
function getHeightSafe(height, dropItemRefSelected, baseBoxRef, pointer, scaleFactor) {
  var newHeight = height;
  try {
    var divResponseBoundingBox = getDivResponseBoundingBox(dropItemRefSelected);
    if (divResponseBoundingBox) {
      var baseBoundingBox = getBaseBoundingBox(baseBoxRef);
      var maxDimensionDrag = getMaxDimensionDrag({
        dragBoundingBox: divResponseBoundingBox,
        baseBoundingBox: baseBoundingBox,
        pointerBoundingBox: getDivPointerBoundingBox(dropItemRefSelected),
        pointer: pointer,
        scaleFactor: scaleFactor
      });
      if (maxDimensionDrag && newHeight > maxDimensionDrag.height) {
        newHeight = maxDimensionDrag.height;
      }
    }
  } catch (error) {
    console.error(error);
  }
  if (newHeight < 0) newHeight = 0;
  return newHeight;
}
function getDivResponseBoundingBox(dropItemRefSelected) {
  var divResponse = null;
  if (dropItemRefSelected !== null && dropItemRefSelected.children[0] && dropItemRefSelected.children[0].children[0] && dropItemRefSelected.children[0].children[0].children[0]) {
    var rect = dropItemRefSelected.children[0].children[0].children[0].getBoundingClientRect();
    if (rect.width !== 0 && rect.height !== 0) {
      divResponse = rect;
    }
  }
  return divResponse;
}
function getDivPointerBoundingBox(dropItemRefSelected) {
  var divPointer = null;
  if (dropItemRefSelected !== null && dropItemRefSelected.children[0] && dropItemRefSelected.children[0].children[1]) {
    var rect = dropItemRefSelected.children[0].children[1].getBoundingClientRect();
    if (rect.width !== 0 && rect.height !== 0) {
      divPointer = rect;
    }
  }
  return divPointer;
}
function getBaseBoundingBox(baseBoxRef) {
  return baseBoxRef.current.getBoundingClientRect();
}

var DIRECTIONS = {
  TOP: 'top',
  LEFT: 'left',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  TOP_LEFT: 'topLeft',
  TOP_RIGHT: 'topRight',
  BOTTOM_LEFT: 'bottomLeft',
  BOTTOM_RIGHT: 'bottomRight'
};
var useResizableBox = function useResizableBox(initialTop, initialLeft, initialWidth, initialHeight, onFinishMove, onStartMove, dropItemRefSelected, baseBoxRef, pointer, scaleFactor) {
  var _useState = useState({
      top: initialTop,
      left: initialLeft,
      width: initialWidth,
      height: initialHeight
    }),
    rect = _useState[0],
    setRect = _useState[1];
  var rectRef = useRef(rect);
  rectRef.current = rect;
  var onStartMoveRef = useRef(onStartMove);
  onStartMoveRef.current = onStartMove;
  var onFinishMoveRef = useRef(onFinishMove);
  onFinishMoveRef.current = onFinishMove;
  var handleMouseDown = function handleMouseDown(direction) {
    return function (e) {
      e.persist();
      var startX = e.clientX;
      var startY = e.clientY;
      var rect = rectRef.current;
      var startTop = rect.top;
      var startLeft = rect.left;
      var startWidth = rect.width;
      var startHeight = rect.height;
      function handleMouseMove(e) {
        onStartMoveRef.current && onStartMoveRef.current(rectRef.current);
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        try {
          var canvasWidth, canvasHeight;
          var divResponseBoundingBox = getDivResponseBoundingBox(dropItemRefSelected);
          if (divResponseBoundingBox) {
            var baseBoundingBox = getBaseBoundingBox(baseBoxRef);
            var maxDimensionDrag = getMaxDimensionDrag({
              dragBoundingBox: divResponseBoundingBox,
              baseBoundingBox: baseBoundingBox,
              pointerBoundingBox: getDivPointerBoundingBox(dropItemRefSelected),
              pointer: pointer,
              scaleFactor: scaleFactor
            });
            if (maxDimensionDrag) {
              canvasWidth = maxDimensionDrag.width;
              canvasHeight = maxDimensionDrag.height;
            }
            if (canvasWidth && startLeft + dx + startWidth > canvasWidth) {
              dx = canvasWidth - startLeft - startWidth;
            }
            if (canvasHeight && startTop + dy + startHeight > canvasHeight) {
              dy = canvasHeight - startTop - startHeight;
            }
          }
        } catch (error) {
          console.error(error);
        }
        setRect(function (prevState) {
          switch (direction) {
            case DIRECTIONS.TOP:
              return _extends({}, prevState, {
                top: startTop + dy,
                height: Math.max(startHeight - dy, 0)
              });
            case DIRECTIONS.LEFT:
              return _extends({}, prevState, {
                left: startLeft + dx,
                width: Math.max(startWidth - dx, 0)
              });
            case DIRECTIONS.RIGHT:
              return _extends({}, prevState, {
                width: Math.max(startWidth + dx, 0)
              });
            case DIRECTIONS.BOTTOM:
              return _extends({}, prevState, {
                height: Math.max(startHeight + dy, 0)
              });
            case DIRECTIONS.TOP_LEFT:
              return _extends({}, prevState, {
                top: startTop + dy,
                left: startLeft + dx,
                width: Math.max(startWidth - dx, 0),
                height: Math.max(startHeight - dy, 0)
              });
            case DIRECTIONS.TOP_RIGHT:
              return _extends({}, prevState, {
                top: startTop + dy,
                width: Math.max(startWidth + dx, 0),
                height: Math.max(startHeight - dy, 0)
              });
            case DIRECTIONS.BOTTOM_LEFT:
              return _extends({}, prevState, {
                left: startLeft + dx,
                width: Math.max(startWidth - dx, 0),
                height: Math.max(startHeight + dy, 0)
              });
            case DIRECTIONS.BOTTOM_RIGHT:
              return _extends({}, prevState, {
                width: Math.max(startWidth + dx, 0),
                height: Math.max(startHeight + dy, 0)
              });
            default:
              return prevState;
          }
        });
      }
      function handleMouseUp() {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
        onFinishMoveRef.current && onFinishMoveRef.current(rectRef.current);
      }
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    };
  };
  return {
    rect: rect,
    handleMouseDown: handleMouseDown
  };
};

function DropEditorItem(_ref) {
  var blank = _ref.blank,
    textSample = _ref.textSample,
    index = _ref.index,
    scaleFactor = _ref.scaleFactor,
    dropItemRefSelected = _ref.dropItemRefSelected,
    baseBoxRef = _ref.baseBoxRef,
    bounds = _ref.bounds,
    myDropItemsArray = _ref.myDropItemsArray,
    _ref$onPositionChange = _ref.onPositionChange,
    onPositionChange = _ref$onPositionChange === void 0 ? null : _ref$onPositionChange,
    _ref$listHasChanged = _ref.listHasChanged,
    listHasChanged = _ref$listHasChanged === void 0 ? null : _ref$listHasChanged,
    _ref$shouldCheckColli = _ref.shouldCheckCollisions,
    shouldCheckCollisions = _ref$shouldCheckColli === void 0 ? false : _ref$shouldCheckColli,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? null : _ref$onChange,
    _ref$canResizableBox = _ref.canResizableBox,
    canResizableBox = _ref$canResizableBox === void 0 ? false : _ref$canResizableBox,
    _ref$onIsResizingChan = _ref.onIsResizingChange,
    onIsResizingChange = _ref$onIsResizingChan === void 0 ? null : _ref$onIsResizingChan,
    _ref$onIsDraggingChan = _ref.onIsDraggingChange,
    onIsDraggingChange = _ref$onIsDraggingChan === void 0 ? null : _ref$onIsDraggingChan;
  var _useState = useState(false),
    isResizing = _useState[0],
    setIsResizing = _useState[1];
  var _useState2 = useState(false),
    isOverlapping = _useState2[0],
    setIsOverlapping = _useState2[1];
  var isOverlappingRef = useRef(isOverlapping);
  var scaleFactorRef = useRef(scaleFactor);
  scaleFactorRef.current = scaleFactor;
  useEffect(function () {
    isOverlappingRef.current = isOverlapping;
  }, [isOverlapping]);
  useEffect(function () {
    checkOverlapping(myDropItemsArray);
  }, [listHasChanged]);
  useEffect(function () {
    return function () {
      if (window.onStop) delete window.onStop;
    };
  }, []);
  var _useState3 = useState(true),
    firstTime = _useState3[0],
    setFirstTime = _useState3[1];
  var _useState4 = useState(getLocalScaleFromProps()),
    localScale = _useState4[0],
    setLocalScale = _useState4[1];
  var localScaleRef = useRef(localScale);
  localScaleRef.current = localScale;
  var dragBoxRef = useRef();
  var pointerBoxRef = useRef();
  var width = blank.width * scaleFactor;
  var height = blank.height * scaleFactor;
  var _useResizableBox = useResizableBox(0, 0, blank.width, blank.height, onFinishMove, onStartMove, dropItemRefSelected, baseBoxRef, blank.pointer, scaleFactor),
    rect = _useResizableBox.rect,
    handleMouseDownResizableBox = _useResizableBox.handleMouseDown;
  useEffect(function () {
    setLocalScale(getLocalScaleFromProps());
  }, [blank.x, blank.y, scaleFactor]);
  var setPositionLocalScale = useCallback(function (x, y) {
    setLocalScale({
      x: x,
      y: y
    });
  }, []);
  var updateIsResizingState = function updateIsResizingState(newState) {
    setIsResizing(newState);
    onIsResizingChange && onIsResizingChange(newState);
  };
  function getLocalScaleFromProps() {
    return {
      x: blank.x * scaleFactor,
      y: blank.y * scaleFactor
    };
  }
  function onFinishMove(rect) {
    var newWidth = getWidthSafe(rect.width, dropItemRefSelected, baseBoxRef, blank.pointer, scaleFactor);
    var newHeight = getHeightSafe(rect.height, dropItemRefSelected, baseBoxRef, blank.pointer, scaleFactor);
    blank.setSize({
      width: newWidth,
      height: newHeight
    });
    onChange && onChange({
      width: newWidth,
      height: newHeight
    });
    updateIsResizingState(false);
    if (window.lemonadeOnStop) {
      window.lemonadeOnStop(null, {
        x: localScale.x,
        y: localScale.y
      });
      delete window.lemonadeOnStop;
    }
  }
  function onStartMove(rect) {
    window.lemonadeOnStop = onStop;
    updateIsResizingState(true);
  }
  var handleOnStopPosition = function handleOnStopPosition(p) {
    setPositionLocalScale(p.x, p.y);
    var newPosition = {
      x: p.x / scaleFactorRef.current,
      y: p.y / scaleFactorRef.current
    };
    blank.setPosition(newPosition);
    onPositionChange && onPositionChange(newPosition);
    checkOverlapping(myDropItemsArray);
  };
  var onStop = function onStop(e, position) {
    if (!isResizing) {
      var dragBoundingBox = dragBoxRef.current.getBoundingClientRect();
      var pointerBoundingBox = pointerBoxRef && pointerBoxRef.current ? pointerBoxRef.current.getBoundingClientRect() : null;
      var boundingBoxFather = getBoundingBoxFatherResponsePointer(dragBoundingBox, pointerBoundingBox, blank.pointer);
      var baseBoundingBox = baseBoxRef.current.getBoundingClientRect();
      var safePosition = fixDragPosition({
        position: position,
        dragBoundingBox: boundingBoxFather,
        baseBoundingBox: baseBoundingBox
      });
      handleOnStopPosition(safePosition);
    }
    onIsDraggingChange(false);
  };
  var onStart = useCallback(function () {
    blank.getNextDepth();
    blank.select();
  }, [blank]);
  var getPosition = useCallback(function () {
    return getDraggablePosition(height, width, blank.pointer, scaleFactor);
  }, [blank, width, height, scaleFactor]);
  useEffect(function () {
    if (firstTime) {
      setFirstTime(false);
    } else {
      onStop(null, {
        x: localScale.x,
        y: localScale.y
      });
    }
  }, [blank.pointer]);
  function checkOverlap(drop1, drop2) {
    var doesOverlap = drop1.x < drop2.x + drop2.width && drop1.x + drop1.width > drop2.x && drop1.y < drop2.y + drop2.height && drop1.y + drop1.height > drop2.y;
    return doesOverlap;
  }
  function checkOverlapping(myDropItemsArray) {
    if (shouldCheckCollisions) {
      var overlapped = false;
      for (var i = 0; i < myDropItemsArray.length; i++) {
        if (i === index) continue;
        if (checkOverlap(myDropItemsArray[i], blank)) {
          overlapped = true;
          break;
        }
      }
      setIsOverlapping(overlapped);
    }
  }
  function handleMouseDown(e, resizeType) {
    e.stopPropagation();
    setIsResizing(true);
    handleMouseDownResizableBox(resizeType)(e);
  }
  return /*#__PURE__*/React__default.createElement(Draggable$1, {
    position: {
      x: localScale.x,
      y: localScale.y
    },
    onStop: onStop,
    onStart: onStart,
    onDrag: function onDrag() {
      return onIsDraggingChange(true);
    },
    grid: [2, 2],
    handle: ".lemo-drag-box",
    bounds: bounds
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-drop-editor-item",
    style: {
      zIndex: blank.z
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-draggable-position",
    style: _extends({}, getPosition())
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: dragBoxRef,
    className: cn$1('lemo-drag-box', {
      'lemo-overlap': isOverlappingRef.current || isOverlapping,
      'lemo-selected': blank.isSelected,
      'lemo-resizable-box': canResizableBox
    }),
    style: _extends({
      width: rect.width * scaleFactor,
      height: rect.height * scaleFactor
    }, isResizing && {
      top: rect.top * scaleFactor,
      left: rect.left * scaleFactor
    })
  }, canResizableBox && blank.isSelected && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-vertex-controller lemo-vertex-controller__top-left",
    onMouseDown: function onMouseDown(e) {
      return handleMouseDown(e, DIRECTIONS.TOP_LEFT);
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-vertex-controller lemo-vertex-controller__top-right",
    onMouseDown: function onMouseDown(e) {
      return handleMouseDown(e, DIRECTIONS.TOP_RIGHT);
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-vertex-controller lemo-vertex-controller__bottom-left",
    onMouseDown: function onMouseDown(e) {
      return handleMouseDown(e, DIRECTIONS.BOTTOM_LEFT);
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-vertex-controller lemo-vertex-controller__bottom-right",
    onMouseDown: function onMouseDown(e) {
      return handleMouseDown(e, DIRECTIONS.BOTTOM_RIGHT);
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-edge-controller lemo-edge-controller__left-edge",
    onMouseDown: function onMouseDown(e) {
      return handleMouseDown(e, DIRECTIONS.LEFT);
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-edge-controller lemo-edge-controller__right-edge",
    onMouseDown: function onMouseDown(e) {
      return handleMouseDown(e, DIRECTIONS.RIGHT);
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-edge-controller lemo-edge-controller__top-edge",
    onMouseDown: function onMouseDown(e) {
      return handleMouseDown(e, DIRECTIONS.TOP);
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-edge-controller lemo-edge-controller__bottom-edge",
    onMouseDown: function onMouseDown(e) {
      return handleMouseDown(e, DIRECTIONS.BOTTOM);
    }
  })), /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-draggable-text"
  }, textSample + " " + (index + 1)))), !!blank.pointer && /*#__PURE__*/React__default.createElement("div", {
    ref: pointerBoxRef,
    className: "lemo-pointer-wrapper"
  }, /*#__PURE__*/React__default.createElement(Pointer, {
    scaleFactor: scaleFactor
  }))));
}
var DropEditorItem$1 = observer(DropEditorItem);

function DropsEditorControl(_ref) {
  var model = _ref.model,
    setModel = _ref.setModel,
    icon = _ref.icon,
    leftComponent = _ref.leftComponent,
    disabledKeyDown = _ref.disabledKeyDown,
    min = _ref.min,
    hideNumberControls = _ref.hideNumberControls;
  function onKeyDown(e) {
    if (disabledKeyDown) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-drop-editor-control"
  }, leftComponent, icon && /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-icon"
  }, icon), /*#__PURE__*/React__default.createElement("span", {
    className: cn$1('lemo-drop-editor-control__input-wrapper', {
      'lemo-drop-editor-control__input-wrapper--disabled-key-down': disabledKeyDown
    })
  }, /*#__PURE__*/React__default.createElement("input", {
    className: cn$1('lemo-input', {
      'lemo-input--hide-number-controls': hideNumberControls,
      'lemo-input--show-number-controls': !hideNumberControls,
      'lemo-input--disabled-key-down': disabledKeyDown
    }),
    type: "number",
    value: model,
    onChange: function onChange(e) {
      return setModel(e.target.value);
    },
    onKeyDown: onKeyDown,
    min: min
  })));
}
DropsEditorControl.propTypes = {
  disabledKeyDown: propTypes.bool,
  min: propTypes.number,
  hideNumberControls: propTypes.bool
};
DropsEditorControl.defaultProps = {
  disabledKeyDown: false,
  min: 0,
  hideNumberControls: true
};

function PointerEditor(_ref) {
  var store = _ref.store;
  var _useState = useState(pointerList.map(function (pointer) {
      return pointer === '' ? translate('none') : translate(pointer);
    })),
    pointerLabels = _useState[0];
  var onSelect = useCallback(function (idx) {
    store.selectedBlank.setPointer(pointerList[idx]);
  }, [store]);
  return store.selected && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-pointer-editor"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-dropdown-wrapper"
  }, /*#__PURE__*/React__default.createElement(DropDown$1, {
    selectedIndex: store.selectedBlank.pointerIndex,
    onSelect: onSelect,
    itemList: pointerLabels
  })));
}
var PointerEditor$1 = observer(PointerEditor);

function DropsEditorItemProps(_ref) {
  var store = _ref.store,
    _ref$withSize = _ref.withSize,
    withSize = _ref$withSize === void 0 ? true : _ref$withSize,
    scaleFactor = _ref.scaleFactor,
    dropItemRefSelected = _ref.dropItemRefSelected,
    baseBoxRef = _ref.baseBoxRef,
    _ref$withPointerEdito = _ref.withPointerEditor,
    withPointerEditor = _ref$withPointerEdito === void 0 ? true : _ref$withPointerEdito,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? null : _ref$onChange,
    _ref$withCopy = _ref.withCopy,
    withCopy = _ref$withCopy === void 0 ? false : _ref$withCopy;
  var isVisible = store.selected && store.selectedBlank;
  var setX = useCallback(function (x) {
    var newX = x;
    try {
      var dragBoundingBox = getDragBoundingBox();
      if (dragBoundingBox) {
        var baseBoundingBox = getBaseBoundingBox(baseBoxRef);
        var position = {
          x: parseInt(getNumber$1(x)),
          y: getNumber$1(store.selectedBlank.y)
        };
        var xDiference = parseInt(getNumber$1(x)) - getNumber$1(store.selectedBlank.x);
        var dragBoundingBoxEdit = {
          bottom: dragBoundingBox.bottom,
          height: dragBoundingBox.height,
          left: getNumber$1(dragBoundingBox.left) + xDiference,
          right: getNumber$1(dragBoundingBox.right) + xDiference,
          top: dragBoundingBox.top,
          width: dragBoundingBox.width,
          x: getNumber$1(dragBoundingBox.x) + xDiference,
          y: dragBoundingBox.y
        };
        var safePosition = fixDragPosition({
          position: position,
          dragBoundingBox: dragBoundingBoxEdit,
          baseBoundingBox: baseBoundingBox
        });
        if (safePosition) {
          newX = safePosition.x;
        }
      }
    } catch (error) {}
    store.selectedBlank.setX(newX);
    onChange && onChange({
      x: newX
    });
  }, [store.image, dropItemRefSelected, baseBoxRef, store.selectedBlank]);
  var setY = useCallback(function (y) {
    var newY = y;
    try {
      var dragBoundingBox = getDragBoundingBox();
      if (dragBoundingBox) {
        var baseBoundingBox = getBaseBoundingBox(baseBoxRef);
        var position = {
          x: getNumber$1(store.selectedBlank.x),
          y: parseInt(getNumber$1(y))
        };
        var yDiference = parseInt(getNumber$1(y)) - getNumber$1(store.selectedBlank.y);
        var dragBoundingBoxEdit = {
          bottom: getNumber$1(dragBoundingBox.bottom) + yDiference,
          height: dragBoundingBox.height,
          left: dragBoundingBox.left,
          right: dragBoundingBox.right,
          top: getNumber$1(dragBoundingBox.top) + yDiference,
          width: dragBoundingBox.width,
          x: dragBoundingBox.x,
          y: getNumber$1(dragBoundingBox.y) + yDiference
        };
        var safePosition = fixDragPosition({
          position: position,
          dragBoundingBox: dragBoundingBoxEdit,
          baseBoundingBox: baseBoundingBox
        });
        if (safePosition) {
          newY = safePosition.y;
        }
      }
    } catch (error) {}
    store.selectedBlank.setY(newY);
    onChange && onChange({
      y: newY
    });
  }, [store.image, dropItemRefSelected, baseBoxRef, store.selectedBlank]);
  function setWidth(width) {
    var newWidth = getWidthSafe(width, dropItemRefSelected, baseBoxRef, getPointer(), scaleFactor);
    store.selectedBlank.setWidth(newWidth);
    onChange && onChange({
      width: newWidth
    });
  }
  function setHeight(height) {
    var newHeight = getHeightSafe(height, dropItemRefSelected, baseBoxRef, getPointer(), scaleFactor);
    store.selectedBlank.setHeight(newHeight);
    onChange && onChange({
      height: newHeight
    });
  }
  function getDragBoundingBox() {
    var dragBoundingBox = null;
    var divResponse = getDivResponseBoundingBox(dropItemRefSelected);
    var divPointer = getDivPointerBoundingBox(dropItemRefSelected);
    if (divResponse) {
      dragBoundingBox = getBoundingBoxFatherResponsePointer(divResponse, divPointer, getPointer());
    }
    return dragBoundingBox;
  }
  function getPointer() {
    return store.selectedBlank.pointer;
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-drops-editor-item-props"
  }, isVisible && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-drops-config-wrapper"
  }, withPointerEditor && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(PointerEditor$1, {
    store: store
  })), withPointerEditor && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-divider"
  }), withSize && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-controls-wrapper "
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(DropsEditorControl, {
    icon: /*#__PURE__*/React__default.createElement(SvgDobleArrow, {
      width: 22,
      className: 'lemo-drops-editor-item-props__icon-width'
    }),
    type: "number",
    model: store.selectedBlank.width,
    setModel: setWidth
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(DropsEditorControl, {
    icon: /*#__PURE__*/React__default.createElement(SvgDobleArrowVertical, {
      height: 22,
      className: 'lemo-drops-editor-item-props__icon-height'
    }),
    type: "number",
    model: store.selectedBlank.height,
    setModel: setHeight
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-divider"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-controls-wrapper "
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(DropsEditorControl, {
    leftComponent: /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-drop-editor-control__left-text"
    }, 'X'),
    type: "number",
    model: store.selectedBlank.x,
    setModel: setX,
    disabled: true,
    hideNumberControls: false,
    disabledKeyDown: true
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(DropsEditorControl, {
    leftComponent: /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-drop-editor-control__left-text"
    }, 'Y'),
    type: "number",
    model: store.selectedBlank.y,
    setModel: setY,
    disabled: true,
    hideNumberControls: false,
    disabledKeyDown: true
  }))), withCopy && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-divider"
  }), withCopy && /*#__PURE__*/React__default.createElement("div", {
    className: "buttons-wrapper"
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-copy-button",
    onClick: store.copySelected,
    type: "button"
  }, /*#__PURE__*/React__default.createElement(SvgDocumentDuplicate, null))), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-divider"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "buttons-wrapper"
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-trash-button",
    onClick: store.removeSelected,
    type: "button"
  }, /*#__PURE__*/React__default.createElement(SvgTrash$1, null)))));
}
var DropsEditorItemProps$1 = observer(DropsEditorItemProps);

var ITEM_PROPS_DISTANCE = 10;
function DropsEditor(_ref) {
  var _base$current, _store$selectedBlank, _store$selectedBlank2;
  var store = _ref.store,
    _ref$withSize = _ref.withSize,
    withSize = _ref$withSize === void 0 ? true : _ref$withSize,
    contentReadyUpdated = _ref.contentReadyUpdated,
    _ref$textSample = _ref.textSample,
    textSample = _ref$textSample === void 0 ? translate('label_drop_item') : _ref$textSample,
    modelGetList = _ref.modelGetList,
    _ref$withPointerEdito = _ref.withPointerEditor,
    withPointerEditor = _ref$withPointerEdito === void 0 ? true : _ref$withPointerEdito,
    _ref$shouldCheckColli = _ref.shouldCheckCollisions,
    shouldCheckCollisions = _ref$shouldCheckColli === void 0 ? false : _ref$shouldCheckColli,
    _ref$withCopy = _ref.withCopy,
    withCopy = _ref$withCopy === void 0 ? false : _ref$withCopy,
    _ref$canResizableBox = _ref.canResizableBox,
    canResizableBox = _ref$canResizableBox === void 0 ? false : _ref$canResizableBox;
  var base = useRef(null);
  var img = useRef(null);
  var dropItemsRefs = useRef([]);
  var itemsPropsRefSelected = useRef(null);
  var _useState = useState(0),
    setContentReady = _useState[1];
  var _useState2 = useState(null),
    listHasChanged = _useState2[0],
    setListHasChanged = _useState2[1];
  var _useState3 = useState(null),
    dropItemIsResizing = _useState3[0],
    setDropItemIsResizing = _useState3[1];
  var _useState4 = useState(null),
    dropItemIsDragging = _useState4[0],
    setDropItemIsDragging = _useState4[1];
  useDispatchOnResize(function () {
    return setContentReady(Date.now());
  }, img);
  var fontSize = store.fontSize / config.labelImageFontSizeMultiplier;
  var applyContentReady = useCallback(function (val) {
    return setTimeout(function () {
      setContentReady(val || Date.now());
    }, 300);
  }, [setContentReady]);
  useEffect(function () {
    applyContentReady();
  }, []);
  var dropList = modelGetList ? store[modelGetList] : store.blankList;
  useEffect(function () {
    dropItemsRefs.current = dropItemsRefs.current.slice(0, dropList.length);
    setListHasChanged(Date.now());
  }, [dropList.length]);
  useEffect(function () {
    applyContentReady(contentReadyUpdated);
  }, [contentReadyUpdated]);
  var onLoadImage = useCallback(function (e) {
    store.image.setSize({
      width: e.target.naturalWidth,
      height: e.target.naturalHeight
    });
    applyContentReady();
  }, [applyContentReady, store]);
  var unsel = useCallback(function () {
    return store && store.setSelected();
  }, [store]);
  var containerWidth = (base === null || base === void 0 ? void 0 : (_base$current = base.current) === null || _base$current === void 0 ? void 0 : _base$current.offsetWidth) || 1;
  var scalableContainerMaxWidth = Math.min(store.containerSize, containerWidth);
  var containerHeight = getContainerHeight({
    containerWidth: containerWidth,
    imageWidth: store.image.width,
    imageHeight: store.image.height
  });
  var scaleFactor = getScaleFactor(Math.min(containerWidth, scalableContainerMaxWidth), store.image.width);
  var indexBlankSelected = store.selectedBlank && dropList ? dropList.findIndex(function (blankItem) {
    return blankItem.id === store.selectedBlank.id;
  }) : null;
  var dropItemsRefSelected = indexBlankSelected !== null ? dropItemsRefs.current[indexBlankSelected] : null;
  function onPositionChange(newPosition) {
    setListHasChanged(Date.now());
  }
  function onItemProps(newProps) {
    setListHasChanged(Date.now());
  }
  var getPositionDropEditorItem = useCallback(function () {
    if (!store.selectedBlank) return null;
    var width = store.selectedBlank.width * scaleFactor;
    var height = store.selectedBlank.height * scaleFactor;
    return getDraggablePosition(height, width, store.selectedBlank.pointer, scaleFactor);
  }, [store.selectedBlank, scaleFactor]);
  var getPositionItemProps = useCallback(function () {
    var _itemsPropsRefSelecte;
    var position = store.selectedBlank.y * scaleFactor + getPositionDropEditorItem().top - (itemsPropsRefSelected === null || itemsPropsRefSelected === void 0 ? void 0 : (_itemsPropsRefSelecte = itemsPropsRefSelected.current) === null || _itemsPropsRefSelecte === void 0 ? void 0 : _itemsPropsRefSelecte.offsetHeight) - ITEM_PROPS_DISTANCE * scaleFactor - (store.selectedBlank.pointer === 'top' ? POINTER_DISTANCE * scaleFactor : 0);
    if (position === null || isNaN(position)) position = null;
    return position;
  }, [store.selectedBlank, (_store$selectedBlank = store.selectedBlank) === null || _store$selectedBlank === void 0 ? void 0 : _store$selectedBlank.y, itemsPropsRefSelected === null || itemsPropsRefSelected === void 0 ? void 0 : itemsPropsRefSelected.current, (_store$selectedBlank2 = store.selectedBlank) === null || _store$selectedBlank2 === void 0 ? void 0 : _store$selectedBlank2.pointer, scaleFactor]);
  return !store ? null : /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-drops-editor",
    ref: base
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-scalable-wrapper",
    style: {
      height: containerHeight
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-scalable-content-wrapper",
    style: {
      fontSize: fontSize * scaleFactor + "em",
      maxWidth: scalableContainerMaxWidth
    },
    key: listHasChanged
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "lemo-drops-editor-background",
    ref: img,
    draggable: false,
    onLoad: onLoadImage,
    onClick: unsel,
    src: store.image.src,
    alt: ""
  }), dropList.map(function (blank, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: blank.id,
      ref: function ref(el) {
        return dropItemsRefs.current[index] = el;
      }
    }, /*#__PURE__*/React__default.createElement(DropEditorItem$1, {
      blank: blank,
      textSample: textSample,
      index: index,
      scaleFactor: scaleFactor,
      _SF: scaleFactor,
      dropItemRefSelected: dropItemsRefSelected,
      baseBoxRef: img,
      bounds: ".lemo-drops-editor",
      myDropItemsArray: dropList,
      onPositionChange: onPositionChange,
      listHasChanged: listHasChanged,
      shouldCheckCollisions: shouldCheckCollisions,
      onChange: onItemProps,
      canResizableBox: canResizableBox,
      onIsResizingChange: function onIsResizingChange(isResizing) {
        if (isResizing) {
          setDropItemIsResizing(blank);
        } else {
          if (dropItemIsResizing && dropItemIsResizing.id === blank.id) {
            setDropItemIsResizing(null);
          }
        }
      },
      onIsDraggingChange: function onIsDraggingChange(isDragging) {
        if (isDragging) {
          setDropItemIsDragging(blank);
        } else {
          if (dropItemIsDragging && dropItemIsDragging.id === blank.id) {
            setDropItemIsDragging(null);
          }
        }
      }
    }));
  }), !dropItemIsResizing && !dropItemIsDragging && store.selectedBlank && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-item-props-wrapper",
    ref: itemsPropsRefSelected,
    style: {
      top: getPositionItemProps() + 'px'
    }
  }, /*#__PURE__*/React__default.createElement(DropsEditorItemProps$1, {
    store: store,
    withSize: withSize,
    scaleFactor: scaleFactor,
    dropItemRefSelected: dropItemsRefSelected,
    baseBoxRef: img,
    withPointerEditor: withPointerEditor,
    onChange: onItemProps,
    withCopy: withCopy
  })))));
}
function getContainerHeight(_ref2) {
  var containerWidth = _ref2.containerWidth,
    imageWidth = _ref2.imageWidth,
    imageHeight = _ref2.imageHeight;
  var currentSizeFactor = Math.min(1, containerWidth / imageWidth);
  return currentSizeFactor * imageHeight;
}
function getScaleFactor(containerWidth, imageWidth) {
  return Math.min(1, containerWidth / imageWidth);
}
var DropsEditor$1 = observer(DropsEditor);

var EditorExerciseLabel = function EditorExerciseLabel(_ref) {
  var background = _ref.background,
    onChangeBackground = _ref.onChangeBackground,
    store = _ref.store,
    showExampleText = _ref.showExampleText,
    showSliderSizeThumb = _ref.showSliderSizeThumb,
    showLabelFontSize = _ref.showLabelFontSize,
    labelFontSize = _ref.labelFontSize,
    onChangeLabelFontSize = _ref.onChangeLabelFontSize,
    withSizeDrops = _ref.withSizeDrops,
    sampleText = _ref.sampleText,
    onChangeSampleText = _ref.onChangeSampleText,
    assetsApi = _ref.assetsApi,
    modelAddNew = _ref.modelAddNew,
    modelGetList = _ref.modelGetList,
    _ref$withPointerEdito = _ref.withPointerEditorDrops,
    withPointerEditorDrops = _ref$withPointerEdito === void 0 ? true : _ref$withPointerEdito,
    _ref$classNameAddEdit = _ref.classNameAddEditorBox,
    classNameAddEditorBox = _ref$classNameAddEdit === void 0 ? 'lemo-editor-exercise-label' : _ref$classNameAddEdit,
    _ref$shouldCheckColli = _ref.shouldCheckCollisions,
    shouldCheckCollisions = _ref$shouldCheckColli === void 0 ? false : _ref$shouldCheckColli,
    _ref$titleBox = _ref.titleBox,
    titleBox = _ref$titleBox === void 0 ? null : _ref$titleBox,
    _ref$helpText = _ref.helpText,
    helpText = _ref$helpText === void 0 ? null : _ref$helpText,
    _ref$withCopy = _ref.withCopy,
    withCopy = _ref$withCopy === void 0 ? false : _ref$withCopy,
    _ref$canResizableBox = _ref.canResizableBox,
    canResizableBox = _ref$canResizableBox === void 0 ? false : _ref$canResizableBox;
  var _useState = useState(0),
    contentReady = _useState[0],
    setContentReady = _useState[1];
  var updateSize = useCallback(function (scale) {
    setContentReady(Date.now());
    store.setImagePercentBaseCent(scale);
  }, [store]);
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "lemoid-upload-image",
    icon: /*#__PURE__*/React__default.createElement(SvgPhotograph, {
      className: "lemo-editor-exercise-label__icon"
    }),
    titleBox: titleBox || translate('Exercise'),
    classNameAdd: classNameAddEditorBox,
    helpText: helpText || translate('label_exercise_help')
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement(ImageUploadOrPreview$1, {
    background: background,
    maxImageSize: 760,
    onChangeBackground: onChangeBackground,
    showSliderSizeThumb: showSliderSizeThumb,
    sliderSize: store.percentImageBaseCent,
    onChangeSliderSize: updateSize,
    showDeletePreview: false,
    showChangePreview: true,
    componentPreview: /*#__PURE__*/React__default.createElement(DropsEditor$1, {
      store: store,
      withSize: withSizeDrops,
      showRange: false,
      contentReadyUpdated: contentReady,
      textSample: sampleText,
      modelGetList: modelGetList,
      withPointerEditor: withPointerEditorDrops,
      shouldCheckCollisions: shouldCheckCollisions,
      withCopy: withCopy,
      canResizableBox: canResizableBox
    }),
    componentLeftAltText: /*#__PURE__*/React__default.createElement(ButtonInline, {
      icon: /*#__PURE__*/React__default.createElement(SvgPlusCircle, {
        className: "lemo-icon lemo-editor-exercise-label__icon-plus"
      }),
      onClick: function onClick() {
        return modelAddNew ? store[modelAddNew]() : store.addBlank();
      },
      text: translate('add_new_question'),
      disabled: (modelGetList ? store[modelGetList].length : store.blankList.length) >= 40
    }),
    assetsApi: assetsApi
  }), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showExampleText && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-exercise-label__place_holder"
  }, /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    title: translate('exercise_example_text_title'),
    subtitle: translate('exercise_example_text_subtitle'),
    value: sampleText,
    onChange: onChangeSampleText,
    placeholder: translate('response')
  }))), showLabelFontSize && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(EditorSliderTitleSubtitle, {
    title: translate('exercise_label_font_size_title'),
    subtitle: translate('exercise_label_font_size_subtitle'),
    limitMin: 6,
    limitMax: 60,
    showLimitMin: false,
    max: labelFontSize,
    onMouseUpMax: onChangeLabelFontSize,
    stringConcatValues: "px"
  })))));
};
EditorExerciseLabel.propTypes = {
  withSizeDrops: propTypes.bool,
  assetsApi: propTypes.string
};
EditorExerciseLabel.defaultProps = {
  withSizeDrops: false,
  showSliderSizeThumb: true
};
var EditorExerciseLabel$1 = observer(EditorExerciseLabel);

var EditorExerciseLabelStore = function EditorExerciseLabelStore(_ref) {
  var store = _ref.store,
    showExampleText = _ref.showExampleText,
    showLabelFontSize = _ref.showLabelFontSize,
    showSliderSizeThumb = _ref.showSliderSizeThumb,
    withSizeDrops = _ref.withSizeDrops,
    modelAddNew = _ref.modelAddNew,
    modelGetList = _ref.modelGetList,
    _ref$withPointerEdito = _ref.withPointerEditorDrops,
    withPointerEditorDrops = _ref$withPointerEdito === void 0 ? true : _ref$withPointerEdito,
    _ref$classNameAddEdit = _ref.classNameAddEditorBox,
    classNameAddEditorBox = _ref$classNameAddEdit === void 0 ? 'lemo-editor-exercise-label' : _ref$classNameAddEdit,
    _ref$shouldCheckColli = _ref.shouldCheckCollisions,
    shouldCheckCollisions = _ref$shouldCheckColli === void 0 ? false : _ref$shouldCheckColli,
    _ref$titleBox = _ref.titleBox,
    titleBox = _ref$titleBox === void 0 ? null : _ref$titleBox,
    _ref$helpText = _ref.helpText,
    helpText = _ref$helpText === void 0 ? null : _ref$helpText,
    _ref$withCopy = _ref.withCopy,
    withCopy = _ref$withCopy === void 0 ? false : _ref$withCopy,
    _ref$canResizableBox = _ref.canResizableBox,
    canResizableBox = _ref$canResizableBox === void 0 ? false : _ref$canResizableBox;
  var percentImage = store.image && store.image.hasOwnProperty('percent') ? store.image.percent : 1;
  return /*#__PURE__*/React__default.createElement(EditorExerciseLabel$1, {
    background: store.image ? {
      source: store.image.src,
      original_width: store.image.width,
      original_height: store.image.height,
      scale: percentImage * 100,
      width: percentImage * store.image.width,
      height: percentImage * store.image.height,
      alt: store.image.alt
    } : null,
    onChangeBackground: function onChangeBackground(value) {
      value ? store.setImage({
        src: value.source,
        width: value.original_width,
        height: value.original_height,
        percent: value.hasOwnProperty('scale') ? value.scale / 100 : 1,
        alt: value.alt
      }) : store.clearImage();
    },
    store: store,
    showExampleText: showExampleText,
    showSliderSizeThumb: showSliderSizeThumb,
    showLabelFontSize: showLabelFontSize,
    labelFontSize: store.fontSize,
    onChangeLabelFontSize: store.setFontSize,
    sampleText: store.sampleText,
    onChangeSampleText: store.setSampleText,
    withSizeDrops: withSizeDrops,
    assetsApi: getAssetsEditorApi(store.assetsEditorApi),
    modelAddNew: modelAddNew,
    modelGetList: modelGetList,
    withPointerEditorDrops: withPointerEditorDrops,
    classNameAddEditorBox: classNameAddEditorBox,
    shouldCheckCollisions: shouldCheckCollisions,
    titleBox: titleBox,
    helpText: helpText,
    withCopy: withCopy,
    canResizableBox: canResizableBox
  });
};
var EditorExerciseLabelStore$1 = observer(EditorExerciseLabelStore);

function EditorExerciseStickersSeries(_ref) {
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(EditorExerciseLabelStore$1, {
    store: store,
    showExampleText: false,
    withSizeDrops: true,
    showSliderSizeThumb: false,
    showLabelFontSize: false,
    modelAddNew: 'addDrop',
    modelGetList: 'drops',
    withPointerEditorDrops: false,
    classNameAddEditorBox: "lemo-editor-exercise-stickers-series",
    shouldCheckCollisions: true,
    titleBox: translate('stickers_series_exercise_title_box'),
    helpText: translate('stickers_series_exercise_help'),
    canResizableBox: true
  });
}
var EditorExerciseStickersSeries$1 = observer(EditorExerciseStickersSeries);

var _excluded$j = ["store", "changed", "type", "immediateFeedback"];
var StickersSeriesEditor = function StickersSeriesEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$j);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setTitle|setStimulus|setValue|setScore|removeResponseByIdx|setTemplate|sortResponses|destroy|setValidResponse|updateDrops|addResponse|setPosition|setSize|setFontSize|setWidth|setHeight|setPointer|addDrop|createAlternativeSolution|changeScore|updateSolution|removeSolution|removeSelected|setImagePercentBaseCent|setIsEvaluable|setDuplicateResponses|setShuffleOptions|setAlt|setImage|clearImage|updateDrag|addDrag|addBlank|setSampleText|sortDrags|setX|setY|setNumberDuplicates|setLabel|setGroupResponses|onDeleteDrag|setIsVerticalOrientation|setShowDropIndicator",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 2,
      haveFeedbackIndividual: false,
      showConfigFeedbacksIndividual: false
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 3,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref[EDITOR_COMPONENT_COMMON.BACKGROUND] = {
      hide: true
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(EditorAnswerOptionsStore$1, {
    store: store,
    options: store.drags,
    onSortOptions: store.sortDrags,
    onClickAddOption: function onClickAddOption() {
      return store.addDrag();
    },
    showToggleShuffleOptions: false,
    showToggleDuplicateResponses: true,
    showNumberDuplicates: store.duplicate_responses,
    keyIdSortingList: "id",
    idBox: "drags",
    titleBox: translate('answer_options'),
    helpText: translate('answer_options_help'),
    modelGetListString: "label",
    modelSetListString: "setLabel",
    onDeleteOption: store.onDeleteDrag,
    imagePickerProps: {
      altTextKey: 'change_image',
      modelGetSrc: 'imageSrc',
      modelSetSrc: 'setImageSrc',
      removableImage: false
    },
    showToggleGroupResponses: true,
    groupResponses: store.group_responses,
    onChangeGroupResponses: store.setGroupResponses,
    placeHolderItemList: translate('stickers_answer_options_placeholder')
  }), /*#__PURE__*/React__default.createElement(EditorExerciseStickersSeries$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    helpText: translate('exact_math_or_partial_match_or_manual_solutions_help'),
    hasMultipleResponses: false,
    showToggleIsEvaluable: false
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: [TYPES_CONFIG.CONFIG_VERTICAL_ORIENTATION, TYPES_CONFIG.CONFIG_DROP_INDICATOR]
  }));
};
var StickersSeriesEditor$1 = observer(StickersSeriesEditor);

function getClassify(props) {
  var _getCreator = getCreator(props, getDefaultData$1, types.classify.Text),
    type = _getCreator.type,
    initialProps = _getCreator.initialProps,
    exerciseData = _getCreator.exerciseData,
    setCommonParamsStore = _getCreator.setCommonParamsStore;
  return when()["case"](type === types.classify.Classification, function () {
    var editorStore = createStore$g(exerciseData);
    setCommonParamsStore(editorStore);
    var questionStore = createStore$h(exerciseData);
    setCommonParamsStore(questionStore);
    return createClassification(editorStore, questionStore, initialProps);
  })["case"](type === types.classify.LinkingLines, function () {
    var editorStore = createStore$n(exerciseData);
    setCommonParamsStore(editorStore);
    var getQuestionStore = function getQuestionStore() {
      return isMobileResolution() ? createStore$j(exerciseData) : createStore(exerciseData);
    };
    var getQuestionComponent = function getQuestionComponent() {
      return isMobileResolution() ? MatchListMobileQuestion$1 : LinkingLinesQuestion$1;
    };
    return createLinkingLines({
      editorStore: editorStore,
      initialProps: initialProps,
      questionStore: setCommonParamsStore(getQuestionStore()),
      QuestionComponent: getQuestionComponent()
    });
  })["case"](type === types.classify.OrderList, function () {
    var _exerciseData$data, _exerciseData$data$ui;
    if (isMobileResolution()) {
      return getClassify(getResponsiveTemplate(types.classify.OrderListMobile, props));
    }
    var dataIsMobileMode = (_exerciseData$data = exerciseData.data) === null || _exerciseData$data === void 0 ? void 0 : (_exerciseData$data$ui = _exerciseData$data.ui_style) === null || _exerciseData$data$ui === void 0 ? void 0 : _exerciseData$data$ui.mobile_mode;
    var configIsMobileMode = config.useOrderListInMobileMode;
    var isMobileMode = dataIsMobileMode !== undefined ? dataIsMobileMode : configIsMobileMode;
    var data = !isMobileMode ? exerciseData : produce(exerciseData, function (draft) {
      draft.metadata.name = types.classify.OrderListMobile;
    });
    var getQuestionStore = function getQuestionStore() {
      return isMobileResolution() || isMobileMode ? createStore$o(data) : createStore$l(data);
    };
    var getQuestionComponent = function getQuestionComponent() {
      return isMobileResolution() || isMobileMode ? OrderListMobileQuestion$1 : OrderListQuestion$1;
    };
    var editorStore = createStore$m(data);
    setCommonParamsStore(editorStore);
    return createOrderList({
      editorStore: editorStore,
      initialProps: initialProps,
      questionStore: setCommonParamsStore(getQuestionStore()),
      QuestionComponent: getQuestionComponent()
    });
  })["case"](type === types.classify.OrderListMobile, function () {
    if (!isMobileResolution()) {
      return getClassify(getResponsiveTemplate(types.classify.OrderList, props));
    }
    var editorStore = createStore$m(exerciseData);
    setCommonParamsStore(editorStore);
    var questionStore = createStore$o(exerciseData);
    setCommonParamsStore(questionStore);
    return createOrderListMobile(editorStore, questionStore, initialProps);
  })["case"](type === types.classify.MatchList, function () {
    var _exerciseData$data2, _exerciseData$data2$u;
    var editorStore = createStore$k(exerciseData);
    setCommonParamsStore(editorStore);
    var dataIsMobileMode = (_exerciseData$data2 = exerciseData.data) === null || _exerciseData$data2 === void 0 ? void 0 : (_exerciseData$data2$u = _exerciseData$data2.ui_style) === null || _exerciseData$data2$u === void 0 ? void 0 : _exerciseData$data2$u.mobile_mode;
    var configIsMobileMode = config.useMatchListInMobileMode;
    var isMobileMode = dataIsMobileMode !== undefined ? dataIsMobileMode : configIsMobileMode;
    var getQuestionStore = function getQuestionStore() {
      return isMobileResolution() || isMobileMode ? createStore$j(exerciseData) : createStore$i(exerciseData);
    };
    var getQuestionComponent = function getQuestionComponent() {
      return isMobileResolution() || isMobileMode ? MatchListMobileQuestion$1 : MatchListQuestion$1;
    };
    return createMatchList({
      editorStore: editorStore,
      initialProps: initialProps,
      questionStore: setCommonParamsStore(getQuestionStore()),
      QuestionComponent: getQuestionComponent()
    });
  })["case"](type === types.classify.MatchListMobile, function () {
    var editorStore = createStore$k(exerciseData);
    setCommonParamsStore(editorStore);
    var questionStore = createStore$j(exerciseData);
    return createMatchList({
      editorStore: editorStore,
      initialProps: initialProps,
      questionStore: setCommonParamsStore(questionStore),
      QuestionComponent: MatchListMobileQuestion$1
    });
  })["case"](type === types.classify.Stickers, function () {
    var questionStore = createStore$q(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$r(exerciseData);
    setCommonParamsStore(editorStore);
    return createStickers(editorStore, questionStore);
  })["case"](type === types.classify.StickersSeries, function () {
    var questionStore = createStore$p(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$s(exerciseData);
    setCommonParamsStore(editorStore);
    return createStickersSeries(editorStore, questionStore);
  }).resolve(null);
}
function createClassification(editorStore, questionStore, initialProps) {
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(ClassificationQuestion$1, _extends({
        store: questionStore
      }, initialProps, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, initialProps, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(ClassificationEditor$1, _extends({
        store: editorStore
      }, initialProps, extraParams));
    },
    PrintView: function PrintView(extraParams) {
      return /*#__PURE__*/React__default.createElement(_PrintView$2, _extends({
        store: questionStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createOrderList(_ref) {
  var editorStore = _ref.editorStore,
    questionStore = _ref.questionStore,
    initialProps = _ref.initialProps,
    QuestionComponent = _ref.QuestionComponent;
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionComponent, _extends({
        store: questionStore
      }, initialProps, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, initialProps, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(OrderListEditor$1, _extends({
        store: editorStore
      }, initialProps, extraParams));
    },
    PrintView: function PrintView(extraParams) {
      return /*#__PURE__*/React__default.createElement(_PrintView$2, _extends({
        store: questionStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createOrderListMobile(editorStore, questionStore, initialProps) {
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(OrderListMobileQuestion$1, _extends({
        store: questionStore
      }, initialProps, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, initialProps, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(OrderListEditor$1, _extends({
        store: editorStore
      }, initialProps, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createLinkingLines(_ref2) {
  var editorStore = _ref2.editorStore,
    questionStore = _ref2.questionStore,
    initialProps = _ref2.initialProps,
    QuestionComponent = _ref2.QuestionComponent;
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionComponent, _extends({
        store: questionStore
      }, initialProps, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, initialProps, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(LinkingLinesEditor$1, _extends({
        store: editorStore
      }, initialProps, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createMatchList(_ref3) {
  var editorStore = _ref3.editorStore,
    questionStore = _ref3.questionStore,
    initialProps = _ref3.initialProps,
    QuestionComponent = _ref3.QuestionComponent;
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionComponent, _extends({
        store: questionStore
      }, initialProps, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, initialProps, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(MatchListEditor$1, _extends({
        store: editorStore
      }, initialProps, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createStickers(editorStore, questionStore) {
  return commonCreatorProps(editorStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(StickersQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(StickersEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Feedback: function Feedback(extraParams) {
      return /*#__PURE__*/React__default.createElement(FeedbackManager$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createStickersSeries(editorStore, questionStore, initialProps) {
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(StickersSeriesQuestion$1, _extends({
        store: questionStore
      }, initialProps, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, initialProps, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(StickersSeriesEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    PrintView: function PrintView(extraParams) {
      return /*#__PURE__*/React__default.createElement(_PrintView$2, _extends({
        store: questionStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}

function OnLoadShow(_ref) {
  var children = _ref.children,
    _ref$isReady = _ref.isReady,
    isReady = _ref$isReady === void 0 ? false : _ref$isReady,
    _ref$ignore = _ref.ignore,
    ignore = _ref$ignore === void 0 ? false : _ref$ignore;
  var _useState = useState(''),
    ready = _useState[0],
    setReady = _useState[1];
  useEffect(function () {
    if (isReady) setReady('lemo-ready');
  }, [isReady]);
  return ignore ? children : /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-onLoadShow " + ready
  }, children);
}
var OnLoadShow$1 = observer(OnLoadShow);

function getDropPosition(blank) {
  var shift = 30;
  var width = blank.width,
    height = blank.height;
  switch (blank.pointer) {
    case 'left':
      return {
        left: shift,
        top: height / 2 * -1
      };
    case 'right':
      return {
        left: (width + shift) * -1,
        top: height / 2 * -1
      };
    case 'top':
      return {
        left: width / 2 * -1,
        top: shift
      };
    case 'bottom':
      return {
        left: width / 2 * -1,
        top: (height + shift) * -1
      };
    default:
      return {
        left: 0,
        top: 0
      };
  }
}

function LabelBlankItemWrapper(_ref) {
  var blank = _ref.blank,
    scaleFactor = _ref.scaleFactor,
    fontSize = _ref.fontSize,
    customWidth = _ref.customWidth,
    children = _ref.children;
  var blankItemStyles = {
    left: blank.x * scaleFactor,
    top: blank.y * scaleFactor
  };
  var width = (customWidth || blank.width) * scaleFactor;
  var height = blank.height * scaleFactor;
  var pointerClass = blank.pointer.length > 0 && "lemo-" + blank.pointer;
  var labelWrapperStyles = _extends({
    width: width,
    height: height,
    fontSize: fontSize
  }, getDropPosition(_extends({}, getSnapshot(blank), {
    width: width,
    height: height
  })));
  return /*#__PURE__*/React__default.createElement("div", {
    id: "drop-" + blank.id,
    className: "lemo-label-blank-item",
    style: blankItemStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'lemo-label-blank-item-wrapper ' + pointerClass,
    style: labelWrapperStyles
  }, children), blank.pointer && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-pointer-wrapper"
  }, /*#__PURE__*/React__default.createElement(Pointer, {
    scaleFactor: scaleFactor
  })));
}
var LabelBlankItemWrapper$1 = observer(LabelBlankItemWrapper);

function useScaleFactor(_ref) {
  var _imgRef$current, _imgRef$current2;
  var imgRef = _ref.imgRef,
    maxSize = _ref.maxSize;
  var _useState = useState(maxSize),
    scaleFactor = _useState[0],
    setScaleFactor = _useState[1];
  var currentSize = (_imgRef$current = imgRef.current) === null || _imgRef$current === void 0 ? void 0 : _imgRef$current.offsetWidth;
  var naturalWidth = ((_imgRef$current2 = imgRef.current) === null || _imgRef$current2 === void 0 ? void 0 : _imgRef$current2.naturalWidth) || 600;
  var updateScaleFactor = useCallback(function () {
    setScaleFactor(Math.min(currentSize / naturalWidth, maxSize));
  }, [imgRef, maxSize, currentSize, naturalWidth]);
  useEffect(function () {
    if (currentSize) updateScaleFactor();
  }, [currentSize, naturalWidth, maxSize]);
  return {
    scaleFactor: scaleFactor,
    maxWidth: naturalWidth * maxSize
  };
}

function useLabelImage(_ref) {
  var store = _ref.store,
    solutionsMode = _ref.solutionsMode;
  var imgRef = useRef(null);
  var base = useRef(null);
  var mounted = useRef(true);
  var _useState = useState(0),
    setContentReady = _useState[1];
  var _useState2 = useState(false),
    imageReady = _useState2[0],
    setImageReady = _useState2[1];
  useEffect(function () {
    mounted.current = true;
    return function () {
      mounted.current = false;
    };
  }, []);
  var _useScaleFactor = useScaleFactor({
      imgRef: imgRef,
      maxSize: solutionsMode ? 1 : store.maxImageSize
    }),
    scaleFactor = _useScaleFactor.scaleFactor,
    maxWidth = _useScaleFactor.maxWidth;
  var sliderFontSize = store.fontSize / config.labelImageFontSizeMultiplier;
  var fontSize = solutionsMode ? scaleFactor * (sliderFontSize * 100) + "%" : scaleFactor * (sliderFontSize * 100) / store.maxImageSize + "%";
  var safeSetState = useCallback(function (setter) {
    if (mounted.current) {
      setter();
    }
  }, []);
  var onLoadImage = useCallback(function () {
    var timeoutId = setTimeout(function () {
      safeSetState(function () {
        setContentReady(Date.now());
        setImageReady(true);
      });
    }, 300);
    return function () {
      return clearTimeout(timeoutId);
    };
  }, [safeSetState]);
  useDispatchOnResize(function () {
    if (mounted.current) {
      setContentReady(Date.now());
    }
  }, base);
  useEffect(function () {
    var tracker = reaction(function () {
      return store.image.percent;
    }, function () {
      if (mounted.current) {
        setContentReady(Date.now());
      }
    });
    if (solutionsMode) store.validation.setImmediateFeedback(false);
    return function () {
      return tracker();
    };
  }, [solutionsMode, store.percentImageBaseCent, store.validation]);
  useEffect(function () {
    if (!imageReady && imgRef.current && imgRef.current.complete) {
      var cleanup = onLoadImage();
      return function () {
        return cleanup === null || cleanup === void 0 ? void 0 : cleanup();
      };
    }
  }, [store.reference, imageReady, onLoadImage]);
  return {
    base: base,
    imageReady: imageReady,
    maxWidth: maxWidth,
    imgRef: imgRef,
    fontSize: fontSize,
    scaleFactor: scaleFactor,
    onLoadImage: onLoadImage
  };
}

var RIGHT$7 = feedback.RIGHT;
var Drop$4 = function Drop(_ref) {
  var drop = _ref.drop,
    solutionsMode = _ref.solutionsMode,
    isEvaluable = _ref.isEvaluable,
    _onClick = _ref.onClick,
    matchResponse = _ref.matchResponse,
    _onDropOut = _ref.onDropOut;
  var checkSuccess = function checkSuccess() {
    return drop.feedbackResult === RIGHT$7;
  };
  var checkError = function checkError() {
    var isImmediate = drop.isImmediate,
      value = drop.value,
      isWrong = drop.isWrong;
    if (!isWrong) return false;
    return !(isImmediate && value.length === 0);
  };
  var isSelected = !solutionsMode && isEvaluable && drop.isSelected;
  var isLock = !solutionsMode && drop.lock;
  var isSuccess = !solutionsMode && checkSuccess();
  var isError = !solutionsMode && checkError();
  var dropTargets = "." + CONTAINER_DRAGS_CLASS + ", .lemo-drop-area";
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    "data-id": drop.id,
    className: cn$1('lemo-label-box', 'lemo-drop-area', {
      'lemo-selected': isSelected,
      'lemo-lock': isLock,
      'lemo-is-empty': !drop.drag,
      'lemo-is-dragging-over': drop.isDraggingOver,
      'lemo-is-highlighted': drop.isHighLighted
    }),
    onClick: function onClick() {
      return drop.drag ? noop : _onClick === null || _onClick === void 0 ? void 0 : _onClick(drop);
    }
  }), drop.drag && /*#__PURE__*/React__default.createElement(Drag$1, {
    drag: drop.drag,
    matchResponse: matchResponse,
    onDropOut: function onDropOut(drag) {
      return _onDropOut(drag);
    },
    onClick: drop.drag.select,
    dropTargets: dropTargets,
    isSuccess: isSuccess,
    isError: isError,
    overflow: true
  }), /*#__PURE__*/React__default.createElement(FeedbackPin$1, {
    idx: drop.feedbackIndex,
    result: drop.resultCache,
    visible: drop.withPin && drop.isWrongCache,
    classAdd: 'lemo-base-feedback-pin__option',
    feedback: drop.feedback
  }));
};
var Drop$5 = observer(Drop$4);

function LabelDragDropQuestion(props) {
  var store = props.store,
    _props$solutionsMode = props.solutionsMode,
    solutionsMode = _props$solutionsMode === void 0 ? false : _props$solutionsMode,
    _props$onDropOut = props.onDropOut,
    _onDropOut = _props$onDropOut === void 0 ? noop : _props$onDropOut;
  var changedHandlers = /setTitle|setStimulus|setTarget|updateDrag|reset|setWidth|setHeight|setValue|updateSolution|modifySolution|matchResponse|removeValue|onClickDrop|onClickContainerDrags/;
  var _useLabelImage = useLabelImage({
      store: store,
      solutionsMode: solutionsMode
    }),
    base = _useLabelImage.base,
    imageReady = _useLabelImage.imageReady,
    maxWidth = _useLabelImage.maxWidth,
    imgRef = _useLabelImage.imgRef,
    fontSize = _useLabelImage.fontSize,
    scaleFactor = _useLabelImage.scaleFactor,
    onLoadImage = _useLabelImage.onLoadImage;
  var autoDrop = useAutoDrop({
    store: store,
    ancestor: base
  });
  useDispatchOnResponseChange({
    store: store,
    changed: props.changed
  });
  function onClickDrag(event, drag) {
    store.isAutomaticDrop ? autoDrop(event.target, drag) : drag.select();
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: base,
    className: cn$1('lemo-question-body', {
      'lemo-disabled': store.disabled
    })
  }, /*#__PURE__*/React__default.createElement(OnLoadShow$1, {
    isReady: imageReady,
    ignore: false
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-scalable-content-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-scalable-content-center",
    style: {
      maxWidth: maxWidth
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "lemo-label-image-background-img",
    ref: imgRef,
    src: store.withBasePath(store.image.src),
    draggable: "false",
    onLoad: onLoadImage,
    alt: store.image.alt
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-label-image-drops-list"
  }, store.drops.map(function (drop) {
    return /*#__PURE__*/React__default.createElement(LabelBlankItemWrapper$1, {
      key: drop.id,
      blank: drop,
      fontSize: fontSize,
      scaleFactor: scaleFactor
    }, /*#__PURE__*/React__default.createElement(Drop$5, {
      drop: drop,
      disabled: store.disabled || store.isEvaluated,
      isEvaluable: store.isEvaluable,
      matchResponse: store.matchResponse,
      onDropOut: _onDropOut,
      solutionsMode: solutionsMode,
      onClick: drop.select
    }));
  })))), /*#__PURE__*/React__default.createElement(DragsContainer$1, {
    dragsContainer: store.dragsContainer,
    style: {
      fontSize: fontSize
    }
  }, store.getDragList(solutionsMode).map(function (drag, idx) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-option-scale",
      key: drag.id
    }, /*#__PURE__*/React__default.createElement(DragWithDuplicates$1, {
      key: drag.id,
      drag: drag,
      showCallOut: idx === 0 && !store.firstInteraction && !store.disabled,
      matchResponse: store.matchResponse,
      onDropOut: function onDropOut(drag) {
        return _onDropOut(drag);
      },
      onClick: function onClick(e) {
        return onClickDrag(e, drag);
      },
      dropTargets: ".lemo-drop-area",
      disabled: !!store.dragDroppedSelected,
      hidden: drag.drop
    }));
  }))))));
}
var LabelDragDropV2Question = observer(LabelDragDropQuestion);

var DragModel$d = types$1.compose(ValueModel, withDuplicates, types$1.model({
  isDragging: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    setIsDragging: function setIsDragging(bool) {
      state.isDragging = bool;
      if (bool) getParent(state, 2).updateFirstInteraction();
    },
    resetTarget: function resetTarget() {
      state.drop && state.drop.reset();
    },
    select: function select() {
      getParent(state, 2).select(state.id);
      getParent(state, 2).updateFirstInteraction();
    },
    hydrate: function hydrate(data) {
      state.value = data.value;
    }
  };
}).views(function (state) {
  var parent = getParent(state, 2);
  var getDropTarget = function getDropTarget() {
    return getParent(state, 2).drops.find(function (drop) {
      return drop.value === state.id;
    });
  };
  return {
    get drop() {
      return getDropTarget();
    },
    get isValid() {
      return state.dropTarget && state.dropTarget.isValid;
    },
    get isUsed() {
      return !!state.drop;
    },
    get isHighlighted() {
      var dropSelected = getParent(state, 2).dropSelected;
      var dragDroppedSelected = getParent(state, 2).dragDroppedSelected;
      var dragSelected = getParent(state, 2).dragSelected;
      if (dropSelected) {
        return dropSelected !== state.drop;
      }
      if (dragDroppedSelected) {
        return state.itemType === DRAG_DROPPED && dragDroppedSelected !== state;
      }
      return dragSelected && state.itemType === DRAG_DROPPED;
    },
    get isSelected() {
      return (parent === null || parent === void 0 ? void 0 : parent.dragSelected) === state;
    },
    get itemType() {
      return state.drop ? DRAG_DROPPED : DRAG;
    },
    get maxDepth() {
      return getParent(state, 2).maxDepth;
    }
  };
}));

var DropModel$a = types$1.compose(withShowSolutionsParent, ValueModel, withIsDraggingOver, withElementFeedback, getWithFeedbackResult(noop), types$1.model({
  raw: types$1.frozen()
}).actions(function (state) {
  return {
    setTarget: function setTarget(dragId) {
      state.setValue(dragId);
    },
    select: function select() {
      getParent(state, 2).select(state.id);
    },
    triggerImmediateResponse: function triggerImmediateResponse() {
      getParent(state, 2).setImmediateResponse({
        itemRef: state.id,
        value: state.isValid
      });
    },
    setValue: function setValue(value) {
      if (value === '') {
        state.reset();
      } else {
        state.value = value;
      }
      state.triggerImmediateResponse();
      state.updateNotifier();
    },
    reset: function reset() {
      state.value = '';
    },
    updateNotifier: function updateNotifier() {
      getParent(state, 2).updateNotifier(state);
    },
    hydrate: function hydrate(data) {
      hydrateKeys(data, state, ['value']);
    }
  };
}).views(function (state) {
  return {
    get isDragDroppedSelected() {
      return state.drag && getParent(state, 2).dragDroppedSelected === state.drag;
    },
    get isSelected() {
      return getParent(state, 2).dropSelected === state || state.isDragDroppedSelected;
    },
    get isHighLighted() {
      return getParent(state, 2).highLightDrops;
    },
    get itemType() {
      return state.drag ? DROP_FILL : DROP_EMPTY;
    },
    get isValid() {
      var _state$drag;
      var parent = getParent(state, 2);
      var currentSolution = parent === null || parent === void 0 ? void 0 : parent.getCurrentSolution(state.index);
      var solution = currentSolution !== undefined ? currentSolution : parent.validation.value[state.index];
      return solution === (state === null || state === void 0 ? void 0 : (_state$drag = state.drag) === null || _state$drag === void 0 ? void 0 : _state$drag.value);
    },
    get x() {
      return state.raw.x;
    },
    get y() {
      return state.raw.y;
    },
    get width() {
      return state.raw.width;
    },
    get height() {
      return state.raw.height;
    },
    get pointer() {
      return state.raw.pointer;
    },
    get pointerIndex() {
      return pointerList.findIndex(function (p) {
        return p === state.pointer;
      });
    },
    get sizeToString() {
      return "" + state.width + state.height;
    },
    get parent() {
      return getParent(state, 2);
    },
    get isImmediate() {
      return getParent(state, 2).validation.immediateFeedback;
    },
    get type() {
      var _getParent, _getParent$raw;
      return (getParent === null || getParent === void 0 ? void 0 : (_getParent = getParent(state, 2)) === null || _getParent === void 0 ? void 0 : (_getParent$raw = _getParent.raw) === null || _getParent$raw === void 0 ? void 0 : _getParent$raw.type) || null;
    },
    get showImmediateFeedbackError() {
      return state.isImmediate && !state.isEmptyResponse(state.value);
    },
    get drag() {
      if (!isAlive(state)) return false;
      return state.value.length > 0 ? getParent(state, 2).drags.find(function (_ref) {
        var id = _ref.id;
        return id === state.value;
      }) : false;
    },
    get isCanShowElementFeedback() {
      return isCanShowElementFeedbackParam(state.type, state.isEmptyResponse(state.value), false);
    }
  };
}));
var DropModel$b = types$1.snapshotProcessor(DropModel$a, {
  preProcessor: function preProcessor(snapshot) {
    return {
      raw: omit(['z'], snapshot),
      feedback: snapshot.feedback,
      z: snapshot.z || 0
    };
  },
  postProcessor: function postProcessor(snapshot) {
    return omit(['value'], _extends({}, snapshot.raw, {
      z: snapshot.z
    }));
  }
});

var withConfigureScorm$c = types$1.model({
  scormData: types$1.optional(ScormModel, {})
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      state.exerciseType = scormTypes.MATCHING;
      state.initScorm();
      onAction(state, function (_ref) {
        var name = _ref.name,
          path = _ref.path;
        if (name === 'reset' && path === '') state.initScorm();
      }, true);
      onSnapshot(state.drops, function () {
        state.drops.forEach(function (item) {
          var _item$drag;
          state.scormData.updateInteractive({
            id: item.id,
            userResponse: (item === null || item === void 0 ? void 0 : (_item$drag = item.drag) === null || _item$drag === void 0 ? void 0 : _item$drag.value) || '',
            result: item.isValid
          });
        });
      });
    },
    initScorm: function initScorm() {
      state.scormData.init(state, state.drops.map(function (item, idx) {
        return {
          userResponse: item.responseValues,
          id: item.id,
          rightAnswer: getAlternativeSolutions(idx, state),
          result: item.isValid
        };
      }));
    }
  };
});

var LabelDragDropQuestionStore = types$1.compose(QuestionBaseModel, withImmediateHandlers('drops'), withWhileDraggingTarget, getWithShuffleOptions('drags'), getClosestSolutionModel(checkResponse$d), withValidationModes, withSelectedDragDrop, withConfigureScorm$c, SelectionModel$1, withXAPIMatchingType$1({
  getSource: function getSource(state) {
    return getGenericSource(state.validation.value.length);
  },
  getTarget: function getTarget(state) {
    return state.drags.map(function (drag) {
      return drag.value;
    });
  },
  getSolution: function getSolution(props) {
    return getXAPIChoiceSolution(props);
  }
}), types$1.model({
  firstInteraction: types$1.optional(types$1["boolean"], false),
  drops: types$1.optional(types$1.array(DropModel$b), []),
  drags: types$1.array(DragModel$d),
  dragsContainer: types$1.optional(DragsContainerModel, {}),
  selected: types$1.optional(types$1.string, '')
}).actions(function (state) {
  var getDrag = function getDrag(id) {
    return state.drags.find(function (drag) {
      return drag.id === id;
    });
  };
  return {
    updateFirstInteraction: function updateFirstInteraction() {
      state.firstInteraction = true;
    },
    resetDropPositions: function resetDropPositions$1() {
      resetDropPositions(state);
    },
    reset: function reset() {
      state.baseReset();
      state.clearResponses();
      state.firstInteraction = false;
    },
    clearResponses: function clearResponses() {
      state.drops.forEach(function (response) {
        return response.reset();
      });
    },
    matchPair: function matchPair(_ref) {
      var dragId = _ref.dragId,
        dropId = _ref.dropId;
      state.updateFirstInteraction();
      if (!dragId || !dropId) return;
      state.matchResponse(dropId, getDrag(dragId));
      state.clearSelection();
    },
    matchResponse: function matchResponse(dropId, drag) {
      var _drag$dropTarget;
      state.updateFirstInteraction();
      if (!!dropId && dropId === ((_drag$dropTarget = drag.dropTarget) === null || _drag$dropTarget === void 0 ? void 0 : _drag$dropTarget.id)) return false;
      var drop = state.getResponseById(dropId);
      if (drag.itemType === DRAG_DROPPED) {
        drag.drop.reset();
      }
      state.clearSelection();
      drop.setTarget(drag.id);
    },
    resetDrag: function resetDrag(drag) {
      drag.resetTarget();
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.string), response)) return false;
      state.clearResponses();
      state.updateFirstInteraction();
      state.drops.forEach(function (item, idx) {
        var currentResponse = response[idx];
        var dropId = item.id;
        var drag = state.drags.find(function (drag) {
          return drag.value === currentResponse && !drag.isUsed;
        });
        if (drag) state.matchResponse(dropId, drag);else item.reset();
      });
    },
    setSelected: function setSelected(itemId) {
      if (itemId === void 0) {
        itemId = '';
      }
      state.selected = itemId;
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData, idx) {
      var data = _createSnapshot$p(rawData);
      var solution = getCurrentEditorSolution(rawData, idx);
      applySnapshot(state, data);
      state.updateOptionsOrder();
      state.setResponse(solution);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    commitResponseFeedback: function commitResponseFeedback() {
      commitFeedbackMessages({
        state: state,
        collection: state.drops,
        condition: getConditionCommitFeedbackMessages
      });
    }
  };
}).views(function (state) {
  var checkSelectedType = function checkSelectedType(dragType) {
    return state.selection.length === 1 && state.selectedInstances[0].itemType === dragType;
  };
  return {
    get allInteractives() {
      return [].concat(state.drags, state.drops, [state.dragsContainer]);
    },
    get highLightDrops() {
      return state.selection.length === 1 ? [DRAG_DROPPED, DRAG].includes(state.selectedInstances[0].itemType) : false;
    },
    get dragSelected() {
      return checkSelectedType(DRAG) ? state.selectedInstances[0] : false;
    },
    get dropSelected() {
      return checkSelectedType(DROP_EMPTY) ? state.selectedInstances[0] : false;
    },
    get dragDroppedSelected() {
      return checkSelectedType(DRAG_DROPPED) ? state.selectedInstances[0] : false;
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$p(rawData);
    },
    getUserResponse: function getUserResponse() {
      var userResponse = state.drops.map(function (res) {
        var _res$drag;
        return ((_res$drag = res.drag) === null || _res$drag === void 0 ? void 0 : _res$drag.value) || '';
      });
      return state.getRealUserResponse(userResponse);
    },
    get maxImageSize() {
      var _state$image;
      return ((_state$image = state.image) === null || _state$image === void 0 ? void 0 : _state$image.percent) || 1;
    },
    getDropTarget: function getDropTarget(dragValue) {
      return state.drops.find(function (drop) {
        return drop.value === dragValue;
      });
    },
    getDropById: function getDropById(id) {
      return state.drops.find(function (drop) {
        return drop.id === id;
      });
    },
    get image() {
      return state.raw.data.image;
    },
    get fontSize() {
      return state.raw.data.fontSize;
    },
    get containerSize() {
      return state.image.width * (state.getPercentImage() * 100) / 100;
    },
    getDragList: function getDragList(solutionsMode) {
      var list = solutionsMode ? state.drags : state.shuffledOptions;
      return getDragListWithDuplicates(list);
    },
    getResponseById: function getResponseById(id) {
      return state.drops.find(function (response) {
        return response.id === id;
      });
    },
    get currentResponse() {
      return state.selected && state.drops.find(function (res) {
        return res.id === state.selected;
      });
    },
    get selectedBlank() {
      return state.selected ? state.drops.find(function (d) {
        return d.id === state.selected;
      }) : undefined;
    },
    get maxDepth() {
      return [].concat(state.baseDrags, state.drops).reduce(function (acc, next) {
        return next.z > acc ? next.z : acc;
      }, 0);
    },
    get nextAvailableDrop() {
      return state.drops.find(function (drop) {
        return !drop.drag;
      });
    },
    get isAutomaticDrop() {
      var _state$ui_style;
      return ((state === null || state === void 0 ? void 0 : (_state$ui_style = state.ui_style) === null || _state$ui_style === void 0 ? void 0 : _state$ui_style.automatic_drop) || (config === null || config === void 0 ? void 0 : config.useAutoDrop)) && state.selection.length === 0;
    }
  };
}));
function createDragData$3(value) {
  return {
    id: uuid(),
    value: value
  };
}
function createDragList$4(possible_responses, possible_responses_config) {
  if (!possible_responses_config) {
    return possible_responses.map(createDragData$3);
  }
  return possible_responses_config.reduce(function (acc, next, idx) {
    return [].concat(acc, populate(next.number_duplicates, function () {
      return createDragData$3(possible_responses[idx]);
    }));
  }, []);
}
function createDrops$6(responses, feedback_responses) {
  return responses.map(function (response, idx) {
    var _feedback_responses$i;
    return _extends({}, response, {
      pointer: anyOrDefault('pointer', response, /top|left|right|bottom/, ''),
      value: '',
      feedback: feedback_responses === null || feedback_responses === void 0 ? void 0 : (_feedback_responses$i = feedback_responses[idx]) === null || _feedback_responses$i === void 0 ? void 0 : _feedback_responses$i.feedback
    });
  });
}
function _createSnapshot$p(data) {
  var _data$data = data.data,
    responses = _data$data.responses,
    possible_responses = _data$data.possible_responses,
    feedback_responses = _data$data.feedback_responses,
    validation = _data$data.validation;
  var percentImage = getPercentImageFromData(data);
  var responsesLength = validation.valid_response.value.length;
  var responseConfig = getDuplicatesConfig(data.data);
  return _extends({}, data.data, importCommonValues$1(data), {
    validation: withPenaltyPoints(responsesLength, validation),
    drops: createDrops$6(responses, feedback_responses),
    drags: createDragList$4(possible_responses, responseConfig),
    image: _extends({}, data.data.image, percentImage ? {
      percent: percentImage
    } : {})
  });
}
function checkResponse$d(solution, userResponse) {
  if (solution === void 0) {
    solution = '';
  }
  if (userResponse === void 0) {
    userResponse = '';
  }
  return userResponse.length > 0 ? solution.toString() === userResponse.toString() : null;
}
function createStore$t(data) {
  return LabelDragDropQuestionStore.create(_createSnapshot$p(data));
}

function DropDownWrapper(_ref) {
  var blank = _ref.blank,
    disabled = _ref.disabled,
    fontSize = _ref.fontSize,
    solutionsMode = _ref.solutionsMode;
  var base = useRef(null);
  var forceUpdate = useForceUpdate();
  var handleChange = useCallback(blank.setValueByIdx, [blank]);
  var handleOpen = useCallback(function (bool) {
    blank.handleOpen(bool);
  }, [blank]);
  useEffect(function () {
    var st = setTimeout(function () {
      try {
        forceUpdate();
        blank.setComponentWidth(base.current.firstChild.offsetWidth);
      } catch (e) {}
    }, 100);
    return function () {
      clearTimeout(st);
    };
  }, []);
  var isStyleFeedbackError = !solutionsMode && blank.feedbackResult === feedback.WRONG;
  var isStyleFeedbackSuccess = !solutionsMode && blank.feedbackResult === feedback.RIGHT;
  return !isAlive(blank) ? null : /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-blank-item-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-blank', {
      'lemo-selected': blank.selected,
      'lemo-lock': !solutionsMode && blank.lock,
      'lemo-success': !solutionsMode && blank.feedbackResult === feedback.RIGHT,
      'lemo-error': isStyleFeedbackError
    }),
    ref: base
  }, /*#__PURE__*/React__default.createElement(NativeDropDown$1, {
    onSelect: handleChange,
    selectedIndex: blank.selectedIndex,
    disabled: disabled,
    itemList: blank.itemList,
    fontSize: fontSize + "em",
    onOpen: handleOpen,
    isError: isStyleFeedbackError,
    isSuccess: isStyleFeedbackSuccess
  })), /*#__PURE__*/React__default.createElement(FeedbackPin$1, {
    idx: blank.feedbackIndex,
    result: blank.resultCache,
    visible: blank.withPin && blank.isWrongCache,
    classAdd: 'lemo-base-feedback-pin__option',
    feedback: blank.feedback
  }));
}
var DropDownWrapper$1 = observer(DropDownWrapper);

function LabelDropDownV2Question(props) {
  var store = props.store,
    solutionsMode = props.solutionsMode;
  var changedHandlers = /setTitle|setStimulus|setTarget|setValue/;
  var _useLabelImage = useLabelImage({
      store: store,
      solutionsMode: solutionsMode
    }),
    base = _useLabelImage.base,
    imageReady = _useLabelImage.imageReady,
    maxWidth = _useLabelImage.maxWidth,
    imgRef = _useLabelImage.imgRef,
    fontSize = _useLabelImage.fontSize,
    scaleFactor = _useLabelImage.scaleFactor,
    onLoadImage = _useLabelImage.onLoadImage;
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: base,
    className: cn$1('lemo-question-body', {
      'lemo-disabled': store.disabled
    })
  }, /*#__PURE__*/React__default.createElement(OnLoadShow$1, {
    isReady: imageReady,
    ignore: false
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-scalable-content-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-scalable-content-center",
    style: {
      maxWidth: maxWidth
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "lemo-label-image-background-img",
    ref: imgRef,
    src: store.withBasePath(store.image.src),
    draggable: "false",
    onLoad: onLoadImage,
    alt: store.image.alt
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-label-image-blanks-list"
  }, store.blankList.map(function (blank) {
    return /*#__PURE__*/React__default.createElement(LabelBlankItemWrapper$1, {
      key: blank.id,
      blank: blank,
      fontSize: fontSize,
      maxImageSize: store.maxImageSize,
      scaleFactor: scaleFactor,
      customWidth: blank.componentWidth
    }, /*#__PURE__*/React__default.createElement(DropDownWrapper$1, {
      blank: blank,
      fontSize: fontSize,
      disabled: store.disabled,
      solutionsMode: solutionsMode
    }));
  })))))));
}
var LabelDropDownV2Question$1 = observer(LabelDropDownV2Question);

var QuestionBlankModel = types$1.compose(withShowSolutionsParent, withElementFeedback, getWithFeedbackResult(normalize$8), withZIndex, types$1.model({
  raw: types$1.frozen()
}).actions(function (state) {
  return {
    select: function select() {
      getParent(state, 2).setSelected(state.id);
    },
    triggerImmediateResponse: function triggerImmediateResponse() {
      getParent(state, 2).setImmediateResponse({
        itemRef: state.id,
        value: state.isValid
      });
    },
    updateNotifier: function updateNotifier() {
      getParent(state, 2).updateNotifier(state);
    },
    updateDropPositionsOnBGChange: function updateDropPositionsOnBGChange() {},
    hydrate: function hydrate(data) {
      hydrateKeys(data, state, ['value']);
    }
  };
}).views(function (state) {
  return {
    get x() {
      return state.raw.x;
    },
    get y() {
      return state.raw.y;
    },
    get width() {
      return state.raw.width;
    },
    get height() {
      return state.raw.height;
    },
    get pointer() {
      return state.raw.pointer;
    },
    get templateName() {
      return getParent(state, 2).raw.metadata.name;
    },
    get isSelected() {
      return state.value.length > 0;
    },
    get pointerIndex() {
      return pointerList.findIndex(function (p) {
        return p === state.pointer;
      });
    },
    get sizeToString() {
      return "" + state.width + state.height;
    },
    get fontSize() {
      return getParent(state, 2).fontSize;
    },
    get selected() {
      return state.value.length > 0;
    },
    get parent() {
      return getParent(state, 2);
    },
    get isImmediate() {
      return getParent(state, 2).validation.immediateFeedback;
    },
    get type() {
      var _getParent, _getParent$raw;
      return (getParent === null || getParent === void 0 ? void 0 : (_getParent = getParent(state, 2)) === null || _getParent === void 0 ? void 0 : (_getParent$raw = _getParent.raw) === null || _getParent$raw === void 0 ? void 0 : _getParent$raw.type) || null;
    },
    get showImmediateFeedbackError() {
      return state.isImmediate && !state.isEmptyResponse(state.value);
    },
    get isCanShowElementFeedback() {
      return isCanShowElementFeedbackParam(state.type, state.isEmptyResponse(state.value), false);
    },
    get maxDepth() {
      return getParent(state, 2).maxDepth;
    }
  };
}));
function normalize$8(str, state) {
  var normalization = getParent(state, 2).normalization;
  return normalization ? normalization.resolve(str) : str;
}

var BlankQuestionModel = types$1.compose(QuestionBlankModel, getWithFeedbackResult(normalize$9), withElementFeedback, types$1.model({
  id: types$1.optional(types$1.identifier, function () {
    return uuid();
  }),
  raw: types$1.frozen(),
  componentWidth: types$1.optional(types$1.number, 0),
  value: types$1.optional(types$1.string, '')
})).actions(function (state) {
  return {
    handleOpen: function handleOpen(bool) {
      state.z = bool ? 10 : 5;
    },
    triggerImmediateResponse: function triggerImmediateResponse() {
      getParent(state, 2).setImmediateResponse({
        itemRef: state.id,
        value: state.isValid
      });
    },
    setValue: function setValue(value) {
      state.value = value;
      state.triggerImmediateResponse();
    },
    setValueByIdx: function setValueByIdx(idx) {
      state.value = state.valueList[idx].value;
      state.triggerImmediateResponse();
    },
    setComponentWidth: function setComponentWidth(componentWidth) {
      state.componentWidth = componentWidth;
    },
    reset: function reset() {
      state.value = '';
    },
    hydrate: function hydrate(data) {
      hydrateKeys(data, state, ['value']);
    },
    updateDropPositionsOnBGChange: function updateDropPositionsOnBGChange() {}
  };
}).views(function (state) {
  var normalize = function normalize(str) {
    try {
      return str.trim().toLowerCase();
    } catch (e) {
      return str;
    }
  };
  return {
    get index() {
      var parent = getParent(state);
      return parent.findIndex(function (children) {
        return children === state;
      });
    },
    get valueList() {
      return state.raw.valueList;
    },
    get maxDepth() {
      return getParent(state).reduce(function (acc, next) {
        return next.z > acc ? next.z : acc;
      }, 0);
    },
    get itemList() {
      return state.valueList.map(function (_ref) {
        var value = _ref.value;
        return value;
      });
    },
    get validResponse() {
      return getParent(state, 2).getCurrentSolution(state.index);
    },
    get validAlternatives() {
      return getParent(state, 2).validation.alt_responses.map(function (res) {
        return res.value;
      });
    },
    get validate() {
      var solution = getParent(state, 2).validation.value[state.index];
      return normalize(solution) === normalize(state.value);
    },
    get isValid() {
      return normalize(state.value) === normalize(state.validResponse);
    },
    get feedbackResult() {
      try {
        var parent = getParent(state, 2);
        var evaluationReady = parent.isEvaluated || state.isImmediate && state.value.length > 0;
        return when()["case"](!evaluationReady, function () {
          return feedback.NOT_EVALUATED;
        })["case"](!parent.isEvaluable, function () {
          return feedback.NOT_EVALUATED;
        })["case"](parent.showSolution, function () {
          return feedback.RIGHT;
        })["case"](state.isValid, function () {
          return feedback.RIGHT;
        })["case"](!state.isValid, function () {
          return feedback.WRONG;
        }).resolve();
      } catch (e) {
        return feedback.NOT_EVALUATED;
      }
    },
    get selectedIndex() {
      return state.itemList.findIndex(function (f) {
        return f === state.value;
      });
    },
    get type() {
      var _getParent, _getParent$raw;
      return (getParent === null || getParent === void 0 ? void 0 : (_getParent = getParent(state, 2)) === null || _getParent === void 0 ? void 0 : (_getParent$raw = _getParent.raw) === null || _getParent$raw === void 0 ? void 0 : _getParent$raw.type) || null;
    },
    get isCanShowElementFeedback() {
      var templateType = normalizedTypes.label_image_dropdown_v2.value;
      return isCanShowElementFeedbackParam(templateType, state.isEmptyResponse(state.value), false);
    }
  };
});
function normalize$9(str) {
  return str;
}
var BlankQuestionModel$1 = types$1.snapshotProcessor(BlankQuestionModel, {
  preProcessor: function preProcessor(snapshot) {
    return {
      raw: omit(['z'], snapshot),
      feedback: snapshot.feedback,
      z: snapshot.z || 0,
      value: snapshot.value
    };
  },
  postProcessor: function postProcessor(snapshot) {
    return omit(['value'], _extends({}, snapshot.raw, {
      z: snapshot.z
    }));
  }
});

var withConfigureScorm$d = types$1.compose(withScorm, types$1.model({}).actions(function (state) {
  return {
    updateResponseOnValidate: function updateResponseOnValidate() {
      state.scormData.interactiveList.forEach(function (interactive, key) {
        var question = state.blankList.find(function (item) {
          return item.id === key;
        });
        interactive.setResult(question.isValid);
      });
    }
  };
}).views(function (state) {
  var getItemData = function getItemData(item, idx) {
    return {
      id: item.id,
      userResponse: item.value,
      rightAnswer: getAlternativeSolutions(idx, state),
      result: item.isValid
    };
  };
  return {
    get scormType() {
      return scormTypes.CHOICE;
    },
    getInteractiveListInitScorm: function getInteractiveListInitScorm() {
      return state.blankList.map(getItemData);
    },
    updateScormItem: function updateScormItem(name, path) {
      if (path.match(/\/blankList/) && name === 'setValueByIdx') {
        var item = resolvePath(state, path);
        return getItemData(item, item.index);
      } else return null;
    }
  };
}));

var LabelDropDownStore = types$1.compose(QuestionBaseModel, withImmediateHandlers('blankList'), getClosestSolutionModel(checkResponse$e), withValidationModes, withElementFeedbackParent('blankList'), withConfigureScorm$d, withXAPIMatchingType$1({
  getSource: function getSource(state) {
    return getGenericSource(state.validation.value.length);
  },
  getSolution: function getSolution(props) {
    return getXAPIChoiceSolution(props);
  },
  getTarget: function getTarget(state) {
    return state.getXAPITargets();
  }
}), types$1.model({
  blankList: types$1.optional(types$1.array(BlankQuestionModel$1), [])
}).actions(function (state) {
  return {
    reset: function reset() {
      state.baseReset();
      state.clearResponses();
    },
    clearResponses: function clearResponses() {
      state.blankList.forEach(function (response) {
        return response.reset();
      });
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.string), response)) return false;
      state.clearResponses();
      state.blankList.forEach(function (res, idx) {
        return res.setValue(response[idx]);
      });
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot$q(rawData);
      applySnapshot(state, data);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    commitResponseFeedback: function commitResponseFeedback() {
      commitFeedbackMessages({
        state: state,
        collection: state.blankList,
        condition: getConditionCommitFeedbackMessages
      });
    }
  };
}).views(function (state) {
  return {
    get image() {
      return state.raw.data.image;
    },
    get fontSize() {
      return state.raw.data.fontSize;
    },
    getUserResponse: function getUserResponse() {
      var userResponse = state.blankList.map(function (res) {
        return res.value;
      });
      return state.getRealUserResponse(userResponse);
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$q(rawData);
    },
    get containerSize() {
      return state.image.width * (state.getPercentImage() * 100) / 100;
    },
    getPercentImage: function getPercentImage() {
      return defaultValue('image.percent', state, 1);
    },
    get imageSrc() {
      return findAbsolutePath(state.image.src) ? state.image.src : "" + addLastSlash(state.basePath) + state.image.src;
    },
    getSolutions: function getSolutions() {
      return state.validation.value;
    },
    get maxImageSize() {
      var _state$image;
      return ((_state$image = state.image) === null || _state$image === void 0 ? void 0 : _state$image.percent) || 1;
    },
    getXAPITargets: function getXAPITargets() {
      var responses = state.blankList.map(function (response) {
        return response.itemList;
      }).flat();
      return removeDuplicates(responses);
    }
  };
}));
function createBlanks(responses, feedback_responses) {
  return responses.map(function (response, idx) {
    var _feedback_responses$i;
    var valueList = defaultValue('valueList', response, []);
    return _extends({}, response, {
      valueList: valueList.map(function (value) {
        return {
          value: value
        };
      }),
      pointer: anyOrDefault('pointer', response, /top|left|right|bottom/, ''),
      value: '',
      feedback: feedback_responses === null || feedback_responses === void 0 ? void 0 : (_feedback_responses$i = feedback_responses[idx]) === null || _feedback_responses$i === void 0 ? void 0 : _feedback_responses$i.feedback
    });
  });
}
function _createSnapshot$q(data) {
  var _data$data = data.data,
    responses = _data$data.responses,
    feedback_responses = _data$data.feedback_responses,
    validation = _data$data.validation;
  var percentImage = getPercentImageFromData(data);
  var responsesLength = validation.valid_response.value.length;
  return _extends({}, data.data, importCommonValues$1(data), {
    validation: withPenaltyPoints(responsesLength, validation),
    blankList: createBlanks(responses, feedback_responses),
    image: _extends({}, data.data.image, percentImage ? {
      percent: percentImage
    } : {})
  });
}
function checkResponse$e(solution, userResponse) {
  if (solution === void 0) {
    solution = [];
  }
  if (userResponse === void 0) {
    userResponse = [];
  }
  return userResponse.length > 0 ? solution.toString() === userResponse.toString() : null;
}
function createStore$u(data) {
  return LabelDropDownStore.create(_createSnapshot$q(data));
}

var BlankModel$1 = types$1.compose(withElementFeedback, withFixDropPositions, types$1.model({
  id: types$1.optional(types$1.string, function () {
    return uuid();
  }),
  x: types$1.number,
  y: types$1.number,
  z: 0,
  width: types$1.number,
  height: types$1.number,
  pointer: types$1.optional(types$1.enumeration(pointerList), ''),
  inputType: types$1.optional(types$1.string, 'text'),
  valueList: types$1.optional(types$1.array(DropDownValueModel), [])
})).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      state.z = state.z === 0 ? state.maxDepth + 1 : state.z;
    },
    getNextDepth: function getNextDepth() {
      if (state.maxDepth !== state.z) {
        state.z = state.maxDepth + 1;
      }
    },
    setZ: function setZ(z) {
      state.z = z;
    },
    handleOpen: function handleOpen(bool) {
      state.z = bool ? 10 : 5;
    },
    setX: function setX(x) {
      state.x = parseInt(x, 10);
      getParent(state, 2).updateNotifier();
    },
    setY: function setY(y) {
      state.y = parseInt(y, 10);
      getParent(state, 2).updateNotifier();
    },
    setPosition: function setPosition(_ref) {
      var x = _ref.x,
        y = _ref.y;
      state.x = parseInt(x, 10);
      state.y = parseInt(y, 10);
      getParent(state, 2).updateNotifier();
    },
    setWidth: function setWidth(width) {
      state.width = parseInt(width, 10);
      getParent(state, 2).updateNotifier();
    },
    setHeight: function setHeight(height) {
      state.height = parseInt(height, 10);
      getParent(state, 2).updateNotifier();
    },
    setSize: function setSize(_ref2) {
      var width = _ref2.width,
        height = _ref2.height;
      state.width = parseInt(width, 10);
      state.height = parseInt(height, 10);
      getParent(state, 2).updateNotifier();
    },
    select: function select() {
      getParent(state, 2).setSelected(state.id);
    },
    setPointer: function setPointer(pointer) {
      state.pointer = pointer;
      getParent(state, 2).updateNotifier();
    },
    addNewValue: function addNewValue() {
      var indexLabel = state.valueList ? ' ' + (state.valueList.length + 1) : '';
      state.valueList.push({
        value: translate('option') + indexLabel
      });
      getParent(state, 2).updateNotifier();
    },
    removeValue: function removeValue(item) {
      destroy(item);
      getParent(state, 2).updateNotifier();
    },
    sortValues: function sortValues(source, destination) {
      state.valueList = sortArrayItem(source, destination, state.valueList);
      getParent(state, 2).updateNotifier();
    },
    destroy: function destroy() {
      getParent(state, 2).setSelected('');
      getParent(state, 2).removeValue(state);
    },
    hydrate: function hydrate(data) {
      hydrateKeys(data, state, ['value']);
    },
    updateDropPositionsOnBGChange: function updateDropPositionsOnBGChange() {}
  };
}).views(function (state) {
  return {
    get index() {
      var parent = getParent(state);
      return parent.findIndex(function (children) {
        return children === state;
      });
    },
    get maxDepth() {
      return getParent(state).reduce(function (acc, next) {
        return next.z > acc ? next.z : acc;
      }, 0);
    },
    get isSelected() {
      return getParent(state, 2).selected === state.id;
    },
    get pointerIndex() {
      return pointerList.findIndex(function (p) {
        return p === state.pointer;
      });
    },
    get sizeToString() {
      return "" + state.width + state.height;
    },
    get fontSize() {
      return getParent(state, 2).fontSize;
    },
    get itemList() {
      return state.valueList.map(function (_ref3) {
        var value = _ref3.value;
        return value;
      });
    },
    get parent() {
      return getParent(state, 2);
    },
    get type() {
      var _getParent, _getParent$raw;
      return (getParent === null || getParent === void 0 ? void 0 : (_getParent = getParent(state, 2)) === null || _getParent === void 0 ? void 0 : (_getParent$raw = _getParent.raw) === null || _getParent$raw === void 0 ? void 0 : _getParent$raw.type) || null;
    },
    get output() {
      return {
        width: state.width,
        height: state.height,
        x: state.x,
        y: state.y,
        z: state.z,
        pointer: state.pointer,
        valueList: state.itemList
      };
    }
  };
});

var LabelDropDownStore$1 = types$1.compose(EditorBaseModel, withElementFeedbackParent('blankList'), types$1.model({
  blankList: types$1.optional(types$1.array(BlankModel$1), []),
  image: types$1.maybe(ImageModel),
  selected: types$1.optional(types$1.string, ''),
  fontSize: types$1.optional(types$1.number, 10),
  responseAutoSize: types$1.optional(types$1["boolean"], true),
  ui_style: types$1.optional(UIStyleModel$1, defaultUIStyle)
}).actions(function (state) {
  return {
    updateNotifier: function updateNotifier() {
      state.onUpdateNotifier = Date.now();
    },
    updateDrops: function updateDrops$1(blankList) {
      updateDrops(blankList, state);
    },
    resetDropPositions: function resetDropPositions$1() {
      resetDropPositions(state);
    },
    setPointer: function setPointer(pointer) {
      state.pointer = pointer;
    },
    addBlank: function addBlank() {
      var position = getPositionByIndex(state.blankList.length);
      state.blankList.push(createNewBlank({
        position: position,
        state: state
      }));
      state.validation.addNewValue('');
      state.updateNotifier();
    },
    copyBlank: function copyBlank(selectedBlank) {
      var newBlank = JSON.parse(JSON.stringify(selectedBlank));
      newBlank.x += POSITION_AUTO_DROP_LIST;
      newBlank.y += POSITION_AUTO_DROP_LIST;
      delete newBlank.id;
      var index = selectedBlank.index;
      state.blankList.push(newBlank);
      if (index >= 0 && index < state.validation.value.length) {
        state.validation.addNewValue(state.validation.value[index]);
      } else {
        state.validation.addNewValue('');
      }
      state.setSelected('');
      state.updateNotifier();
    },
    sortResponses: function sortResponses(source, destination) {
      state.blankList = sortArrayItem(source, destination, state.blankList);
      state.updateNotifier();
    },
    reset: function reset() {
      state.baseReset();
      state.clearResponses();
    },
    clearResponses: function clearResponses() {
      state.blankList.forEach(function (response) {
        return response.reset();
      });
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.string), response)) return false;
      state.clearResponses();
      state.blankList.forEach(function (res, idx) {
        return res.setValue(response[idx]);
      });
    },
    removeValue: function removeValue(instance) {
      destroy(instance);
      state.updateNotifier();
    },
    clearAllResponses: function clearAllResponses() {},
    removeSelected: function removeSelected() {
      if (!state.selected) return false;
      var selectedIdx = state.selectedBlank.index;
      state.removeValue(state.selectedBlank);
      state.validation.removeValueAt(selectedIdx);
    },
    copySelected: function copySelected() {
      if (!state.selected) return false;
      if (state.selectedBlank) {
        state.copyBlank(state.selectedBlank);
      }
    },
    setSelected: function setSelected(itemId) {
      if (itemId === void 0) {
        itemId = '';
      }
      state.selected = itemId;
    },
    setFontSize: function setFontSize(fontSize) {
      state.fontSize = parseInt(fontSize, 10);
      state.updateNotifier();
    },
    setImagePercentBaseCent: function setImagePercentBaseCent(imagePercentBaseCent) {
      state.image = _extends({}, state.image, {
        percent: imagePercentBaseCent ? imagePercentBaseCent / 100 : 1
      });
      state.updateNotifier();
    },
    setImage: function setImage$1(imageAttributes) {
      setImage(state, imageAttributes);
      state.blankList.forEach(function (blank) {
        return blank.fixPosition(imageAttributes);
      });
      state.updateNotifier();
    },
    clearImage: function clearImage() {
      state.image = undefined;
    },
    updateDropPositionsOnBGChange: function updateDropPositionsOnBGChange() {},
    clearAll: function clearAll() {
      state.clearAllBase();
      state.setSelected('');
      state.blankList.clear();
      state.updateNotifier();
    }
  };
}).views(function (state) {
  return {
    get containerSize() {
      return state.image.width * (state.getPercentImage() * 100) / 100;
    },
    getPercentImage: function getPercentImage() {
      return defaultValue('image.percent', state, 1);
    },
    get imageSrc() {
      return findAbsolutePath(state.image.src) ? state.image.src : "" + addLastSlash(state.basePath) + state.image.src;
    },
    get selectedBlank() {
      return state.selected ? state.blankList.find(function (d) {
        return d.id === state.selected;
      }) : undefined;
    },
    getSolutions: function getSolutions() {
      return state.validation.value;
    },
    get percentImageBaseCent() {
      return state.getPercentImage() * 100;
    },
    get maxImageSize() {
      var _state$image;
      return ((_state$image = state.image) === null || _state$image === void 0 ? void 0 : _state$image.percent) || 1;
    },
    get output() {
      var toRet = exportCommonValues(state, {
        image: state.image ? getSnapshot(state.image) : undefined,
        fontSize: state.fontSize,
        responses: state.blankList.map(function (blank) {
          return blank.output;
        }),
        feedback_responses: state.feedbackResponsesOutput
      });
      if (toRet.data && toRet.data.imageSize) delete toRet.data.imageSize;
      return toRet;
    }
  };
}));
function createBlanks$1(responses, feedback_responses) {
  return responses.map(function (response, idx) {
    var _feedback_responses$i;
    var valueList = defaultValue('valueList', response, []);
    return _extends({}, response, {
      valueList: valueList.map(function (value) {
        return {
          value: value
        };
      }),
      pointer: anyOrDefault('pointer', response, /top|left|right|bottom/, ''),
      feedback: feedback_responses === null || feedback_responses === void 0 ? void 0 : (_feedback_responses$i = feedback_responses[idx]) === null || _feedback_responses$i === void 0 ? void 0 : _feedback_responses$i.feedback
    });
  });
}
function createSnapshot$4(data) {
  var _data$data = data.data,
    responses = _data$data.responses,
    feedback_responses = _data$data.feedback_responses;
  var percentImage = getPercentImageFromData(data);
  return _extends({}, data.data, importCommonValues$1(data), {
    blankList: createBlanks$1(responses, feedback_responses),
    image: _extends({}, data.data.image, percentImage ? {
      percent: percentImage
    } : {})
  });
}
function getResponseSize(state) {
  var getDefaultSize = function getDefaultSize() {
    return {
      width: 120,
      height: 50
    };
  };
  var getFirstItemSize = function getFirstItemSize() {
    return {
      width: state.blankList[0].width,
      height: state.blankList[0].height
    };
  };
  return state.blankList.length > 0 ? getFirstItemSize() : getDefaultSize();
}
function createNewBlank(_ref) {
  var position = _ref.position,
    state = _ref.state;
  return _extends({
    x: position.x,
    y: position.y,
    valueList: [{
      value: translate('option') + ' 1'
    }, {
      value: translate('option') + ' 2'
    }, {
      value: translate('option') + ' 3'
    }],
    value: ''
  }, getResponseSize(state));
}
function createStore$v(data) {
  return LabelDropDownStore$1.create(createSnapshot$4(data));
}

function getResponseSize$1(state) {
  return state.blankList.length > 0 ? {
    width: state.blankList[0].width,
    height: state.blankList[0].height
  } : {
    width: 120,
    height: 50
  };
}
function getEmptyAlternatives(state) {
  return state.validation.alt_responses.map(function (_) {
    return '';
  });
}
function createNewBlank$1(state, x, y) {
  if (x === void 0) {
    x = 0;
  }
  if (y === void 0) {
    y = 0;
  }
  state.blankList.push(_extends({
    x: x,
    y: y,
    validAlternatives: {
      responses: getEmptyAlternatives(state)
    }
  }, getResponseSize$1(state)));
  state.validation.alt_responses.forEach(function (alt) {
    return alt.addEmptyValue('');
  });
}

var BlankModel$2 = types$1.compose(editorWithGroupedValuesModel, withElementFeedback, withFixDropPositions, types$1.model({
  x: types$1.number,
  y: types$1.number,
  z: 0,
  width: types$1.number,
  height: types$1.number,
  pointer: types$1.optional(types$1.enumeration(pointerList), '')
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      state.z = state.z === 0 ? state.maxDepth + 1 : state.z;
    },
    getNextDepth: function getNextDepth() {
      if (state.maxDepth !== state.z) {
        state.z = state.maxDepth + 1;
      }
    },
    setZ: function setZ(z) {
      state.z = z;
    },
    setX: function setX(x) {
      state.x = parseInt(x, 10);
      state.updateNotifier();
    },
    setY: function setY(y) {
      state.y = parseInt(y, 10);
      state.updateNotifier();
    },
    setPosition: function setPosition(_ref) {
      var x = _ref.x,
        y = _ref.y;
      state.x = parseInt(x, 10);
      state.y = parseInt(y, 10);
      state.updateNotifier();
    },
    setWidth: function setWidth(width) {
      state.width = parseInt(width, 10);
      state.updateNotifier();
    },
    setHeight: function setHeight(height) {
      state.height = parseInt(height, 10);
      state.updateNotifier();
    },
    setSize: function setSize(_ref2) {
      var width = _ref2.width,
        height = _ref2.height;
      state.width = parseInt(width, 10);
      state.height = parseInt(height, 10);
      state.updateNotifier();
    },
    select: function select() {
      getParent(state, 2).setSelected(state.id);
    },
    setPointer: function setPointer(pointer) {
      state.pointer = pointer;
      state.updateNotifier();
    },
    destroy: function destroy() {
      getParent(state, 2).setSelected('');
      getParent(state, 2).removeValue(state);
    },
    updateDropPositionsOnBGChange: function updateDropPositionsOnBGChange() {},
    reset: function reset() {},
    updateNotifier: function updateNotifier(bool) {
      if (bool === void 0) {
        bool = true;
      }
      getParent(state, 2).updateNotifier(bool);
    }
  };
}).views(function (state) {
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get maxDepth() {
      return getParent(state).reduce(function (acc, next) {
        return next.z > acc ? next.z : acc;
      }, 0);
    },
    get isSelected() {
      return getParent(state, 2).selected === state.id;
    },
    get pointerIndex() {
      return pointerList.findIndex(function (p) {
        return p === state.pointer;
      });
    },
    get sizeToString() {
      return "" + state.width + state.height;
    },
    get fontSize() {
      return getParent(state, 2).fontSize;
    },
    get selected() {
      return state.value.length > 0;
    },
    get parent() {
      return getParent(state, 2);
    },
    get responseLength() {
      return -1;
    }
  };
}));

var LabelTextStore = types$1.compose(EditorBaseModel, withElementFeedbackParent('blankList'), withActiveSolution, withHasLemonadeKeyboard, types$1.model({
  selectedResponseID: types$1.optional(types$1.string, ''),
  blankList: types$1.optional(types$1.array(BlankModel$2), []),
  image: types$1.maybe(ImageModel),
  selected: types$1.optional(types$1.string, ''),
  keyboard: types$1.optional(KeyboardStore, {}),
  validation: getEditorValidationModel(GroupedSolutionModel$1),
  normalization: InputNormalizationModel,
  autosizeResponse: types$1.optional(types$1["boolean"], false),
  ui_style: types$1.optional(UIStyleModel$1, defaultUIStyle)
}).actions(function (state) {
  return {
    updateDrops: function updateDrops$1(blankList) {
      updateDrops(blankList, state);
    },
    resetDropPositions: function resetDropPositions$1() {
      resetDropPositions(state);
    },
    addValidationValue: function addValidationValue() {
      state.validation.addNewValue('');
    },
    setPointer: function setPointer(pointer) {
      state.pointer = pointer;
    },
    setAutosizeResponse: function setAutosizeResponse(autosizeResponse) {
      state.autosizeResponse = autosizeResponse;
      state.updateNotifier();
    },
    createNewBlank: function createNewBlank(blankProps) {
      state.blankList.push(blankProps);
    },
    addBlank: function addBlank() {
      var position = getPositionByIndex(state.blankList.length);
      state.createNewBlank(_extends({}, position, getResponseSize$1(state)));
      state.updateNotifier();
      state.addValidationValue();
    },
    sortResponses: function sortResponses(source, destination) {
      state.blankList = sortArrayItem(source, destination, state.blankList);
    },
    reset: function reset() {
      state.baseReset();
      state.clearResponses();
    },
    clearResponses: function clearResponses() {
      state.blankList.forEach(function (response) {
        return response.reset();
      });
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.string), response)) return false;
      state.clearResponses();
      state.blankList.forEach(function (res, idx) {
        return res.setValue(response[idx]);
      });
    },
    removeValue: function removeValue(instance) {
      destroy(instance);
      state.updateNotifier();
    },
    clearAllResponses: function clearAllResponses() {},
    clearAllSolutions: function clearAllSolutions() {
      state.setActiveSolutionIdx(0);
      state.validation.solutionList.map(function (solution) {
        return solution.clear();
      });
      state.validation.removeAltResponses();
    },
    removeSelected: function removeSelected() {
      if (!state.selected) return false;
      var selectedIdx = state.selectedBlank.index;
      state.removeValue(state.selectedBlank);
      state.validation.removeValueAt(selectedIdx);
    },
    setData: function setData(data) {
      applySnapshot(state, data);
    },
    setSelected: function setSelected(itemId) {
      if (itemId === void 0) {
        itemId = '';
      }
      state.selected = itemId;
    },
    addDrop: function addDrop() {
      state.blankList.push({
        x: 0,
        y: 0,
        width: 90,
        height: 40
      });
    },
    setImage: function setImage$1(imageAttributes) {
      setImage(state, imageAttributes);
      state.blankList.forEach(function (blank) {
        return blank.fixPosition(imageAttributes);
      });
      state.updateNotifier(true);
    },
    clearImage: function clearImage() {
      state.image = undefined;
    },
    setSelectedResponseID: function setSelectedResponseID(selectedResponseID) {
      if (selectedResponseID === void 0) {
        selectedResponseID = '';
      }
      state.selectedResponseID = selectedResponseID;
    },
    clearAllBlankList: function clearAllBlankList() {
      state.blankList.forEach(function (blank) {
        var selectedIdx = blank.index;
        state.removeValue(blank);
        state.validation.removeValueAt(selectedIdx);
      });
    },
    clearAll: function clearAll() {
      state.clearAllBase();
      state.clearAllBlankList();
      state.duplicate_responses = false;
      state.shuffle_options = false;
      state.updateNotifier();
    }
  };
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$r(rawData);
    },
    get containerSize() {
      return state.image.width * (state.getPercentImage() * 100) / 100;
    },
    getPercentImage: function getPercentImage() {
      return state.image && state.image.hasOwnProperty('percent') ? state.image.percent : 1;
    },
    getCurrentSolution: function getCurrentSolution(idx) {
      return state.validation.solutionList[state.closestSolution].value[idx];
    },
    get selectedBlank() {
      return state.selected ? state.blankList.find(function (d) {
        return d.id === state.selected;
      }) : undefined;
    },
    get selectedResponse() {
      return state.blankList.find(function (resp) {
        return resp.id === state.selectedResponseID;
      });
    },
    get percentImageBaseCent() {
      return state.getPercentImage() * 100;
    },
    get responses() {
      return state.blankList;
    },
    get maxImageSize() {
      var _state$image;
      return ((_state$image = state.image) === null || _state$image === void 0 ? void 0 : _state$image.percent) || 1;
    },
    get output() {
      var _toRet$data;
      var toRet = exportCommonValues(state, {
        image: getSnapshot(state.image),
        responses: getSnapshot(state.blankList),
        autosizeResponse: state.autosizeResponse,
        normalization: getSnapshot(state.normalization),
        feedback_responses: state.feedbackResponsesOutput,
        validation: getGroupedValidationOutput(state.validation)
      });
      if (toRet !== null && toRet !== void 0 && (_toRet$data = toRet.data) !== null && _toRet$data !== void 0 && _toRet$data.hasOwnProperty('imageSize')) {
        delete toRet.data.imageSize;
      }
      return toRet;
    }
  };
}));
function getGroupedValidationOutput(validation) {
  var solutions = validation.solutionList.map(function (solution) {
    return solution.output2;
  });
  var valid_response = solutions[0];
  var alt_responses = solutions.slice(1);
  return _extends({}, getSnapshot(validation), {
    valid_response: valid_response,
    alt_responses: alt_responses
  });
}
function createBlanks$2(responses, feedback_responses) {
  return responses.map(function (response, idx) {
    var _feedback_responses$i;
    return _extends({}, response, {
      pointer: anyOrDefault('pointer', response, /top|left|right|bottom/, ''),
      value: '',
      feedback: feedback_responses === null || feedback_responses === void 0 ? void 0 : (_feedback_responses$i = feedback_responses[idx]) === null || _feedback_responses$i === void 0 ? void 0 : _feedback_responses$i.feedback
    });
  });
}
function _createSnapshot$r(data) {
  var _data$data = data.data,
    responses = _data$data.responses,
    image = _data$data.image,
    feedback_responses = _data$data.feedback_responses,
    _data$data$normalizat = _data$data.normalization,
    normalization = _data$data$normalizat === void 0 ? {} : _data$data$normalizat;
  var percentImage = getPercentImageFromData(data);
  var exerciseData = _extends({}, data.data, importCommonValues$1(data), {
    normalization: normalization,
    blankList: createBlanks$2(responses, feedback_responses),
    image: _extends({}, image, percentImage ? {
      percent: percentImage
    } : {})
  });
  return addDefaultKeyboard(exerciseData);
}
function createStore$w(data) {
  return LabelTextStore.create(_createSnapshot$r(data));
}

var TextBlankModel = types$1.compose(QuestionBlankModel, ValueModel, questionWithGroupedValuesModel, types$1.model().actions(function (state) {
  return {
    setValue: function setValue(value) {
      state.value = value;
      state.isValid && state.triggerImmediateResponse();
      state.updateNotifier(false);
    },
    reset: function reset() {
      state.value = '';
    }
  };
}));
var TextBlankModel$1 = types$1.snapshotProcessor(TextBlankModel, {
  preProcessor: function preProcessor(snapshot) {
    return {
      raw: omit(['z'], snapshot),
      feedback: snapshot.feedback,
      z: snapshot.z || 0
    };
  },
  postProcessor: function postProcessor(snapshot) {
    return omit(['value'], _extends({}, snapshot.raw, {
      z: snapshot.z
    }));
  }
});

var withConfigureScorm$e = types$1.compose(withScorm, types$1.model({}).actions(function (state) {
  return {
    updateResponseOnValidate: function updateResponseOnValidate() {
      state.scormData.interactiveList.forEach(function (interactive, key) {
        var question = state.blankList.find(function (item) {
          return item.id === key;
        });
        interactive.setResult(question.isValid);
      });
    }
  };
}).views(function (state) {
  return {
    get scormType() {
      return scormTypes.FILL_IN;
    },
    getInteractiveListInitScorm: function getInteractiveListInitScorm() {
      return state.blankList.map(function (item, idx) {
        return {
          userResponse: item.value,
          id: item.id,
          rightAnswer: getAlternativeTextSolutions(idx, state),
          result: item.isValid
        };
      });
    },
    updateScormItem: function updateScormItem(name, path) {
      if (path.match(/\/blankList/) && name === 'setValue') {
        var item = resolvePath(state, path);
        return {
          id: item.id,
          userResponse: item.value,
          result: item.isValid
        };
      } else return null;
    }
  };
}));

var LabelTextQuestionStore = types$1.compose(QuestionBaseModel, withImmediateHandlers('blankList'), getClosestSolutionModel(checkResponse$f), withValidationModes, withElementFeedbackParent('blankList'), withHasLemonadeKeyboard, withConfigureScorm$e, withXAPITypeFillIn$1({
  xAPISolution: function xAPISolution(state) {
    return state.xAPISolution;
  }
}), types$1.model({
  blankList: types$1.optional(types$1.array(TextBlankModel$1), []),
  keyboard: types$1.optional(KeyboardStore, {}),
  validation: getQuestionValidationModel(GroupedSolutionModel$1),
  normalization: InputNormalizationModel
}).actions(function (state) {
  return {
    reset: function reset() {
      state.baseReset();
      state.clearResponses();
    },
    clearResponses: function clearResponses() {
      state.blankList.forEach(function (response) {
        return response.reset();
      });
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.string), response)) return false;
      state.clearResponses();
      state.blankList.forEach(function (res, idx) {
        return res.setValue(response[idx]);
      });
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot$s(rawData);
      applySnapshot(state, data);
      state.keyboard.updateFromUIStyle(data.ui_style);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    commitResponseFeedback: function commitResponseFeedback() {
      commitFeedbackMessages({
        state: state,
        collection: state.blankList,
        condition: getConditionCommitFeedbackMessages
      });
    }
  };
}).views(function (state) {
  return {
    get image() {
      return state.raw.data.image;
    },
    get fontSize() {
      return state.raw.data.fontSize;
    },
    get autosizeResponse() {
      return state.raw.data.autosizeResponse;
    },
    getUserResponse: function getUserResponse() {
      var userResponse = state.blankList.map(function (res) {
        return res.value;
      });
      return state.getRealUserResponse(userResponse);
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$s(rawData);
    },
    get questionCompleted() {
      var _state$validation = state.validation,
        immediateFeedback = _state$validation.immediateFeedback,
        value = _state$validation.value;
      var resultCheckSolution = state.checkSolution(value);
      return immediateFeedback && resultCheckSolution && resultCheckSolution.failures === 0 && resultCheckSolution.notAnswered === 0;
    },
    get containerSize() {
      return state.image.width * (state.getPercentImage() * 100) / 100;
    },
    getPercentImage: function getPercentImage() {
      return state.image && state.image.hasOwnProperty('percent') ? state.image.percent : 1;
    },
    getCurrentSolution: function getCurrentSolution(idx) {
      return state.validation.solutionList[state.closestSolution].value[idx];
    },
    getSolutions: function getSolutions() {
      return getSnapshot(state.solution).value;
    },
    getValidResponses: function getValidResponses() {
      return state.blankList.map(function (blank) {
        if (blank.isValid) {
          return blank.value;
        } else {
          return getSnapshot(state.solution).value[blank.index];
        }
      });
    },
    get maxImageSize() {
      var _state$image;
      return ((_state$image = state.image) === null || _state$image === void 0 ? void 0 : _state$image.percent) || 1;
    },
    get xAPISolution() {
      return state.validation.mainSolution.output.value;
    }
  };
}));
function createBlanks$3(responses, feedback_responses) {
  return responses.map(function (response, idx) {
    var _feedback_responses$i;
    return _extends({}, response, {
      pointer: (response === null || response === void 0 ? void 0 : response.pointer) || '',
      value: '',
      feedback: feedback_responses === null || feedback_responses === void 0 ? void 0 : (_feedback_responses$i = feedback_responses[idx]) === null || _feedback_responses$i === void 0 ? void 0 : _feedback_responses$i.feedback
    });
  });
}
function _createSnapshot$s(data) {
  var _data$data = data.data,
    responses = _data$data.responses,
    image = _data$data.image,
    validation = _data$data.validation,
    feedback_responses = _data$data.feedback_responses,
    _data$data$normalizat = _data$data.normalization,
    normalization = _data$data$normalizat === void 0 ? {} : _data$data$normalizat;
  var percentImage = getPercentImageFromData(data);
  var responseLength = validation.valid_response.value.length;
  var exerciseData = _extends({}, data.data, importCommonValues$1(data), {
    normalization: normalization,
    validation: withPenaltyPoints(responseLength, validation),
    blankList: createBlanks$3(responses, feedback_responses),
    image: _extends({}, image, percentImage ? {
      percent: percentImage
    } : {})
  });
  return addDefaultKeyboard(exerciseData);
}
function checkResponse$f(solution, userResponse, state) {
  var normalize = function normalize(str) {
    return state.normalization.resolve(str);
  };
  var matchSolution = solution.values.reduce(function (acc, next) {
    return normalize(userResponse) === normalize(next) || acc;
  }, false);
  return userResponse.length > 0 ? matchSolution : null;
}
function createStore$x(data) {
  return LabelTextQuestionStore.create(_createSnapshot$s(data));
}

var isSafari = function (ua) {
  return ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1;
}(navigator.userAgent.toLowerCase());
function DefaultTextInput(_ref) {
  var disabled = _ref.disabled,
    showSuccess = _ref.showSuccess,
    showError = _ref.showError,
    blank = _ref.blank,
    solutionsMode = _ref.solutionsMode,
    handleFocus = _ref.handleFocus;
  var handleResponse = useCallback(function (_ref2) {
    var target = _ref2.target;
    blank.setValue(target.value);
  }, [blank]);
  return /*#__PURE__*/React__default.createElement("input", _extends({
    "data-testid": "labelTextBlank",
    className: cn$1('lemo-label-text-input', {
      'lemo-is-safari': isSafari,
      'lemo-lock': disabled,
      'lemo-selected': blank.value.length > 0,
      'lemo-success': showSuccess,
      'lemo-error': showError
    }),
    type: "text",
    value: blank.value,
    onFocus: function onFocus() {
      return handleFocus(true);
    },
    onBlur: function onBlur() {
      return handleFocus(false);
    },
    onChange: handleResponse
  }, !solutionsMode && blank.responseLength > -1 && !disabled && {
    maxLength: blank.responseLength
  }));
}
var DefaultTextInput$1 = observer(DefaultTextInput);

var BlankItem = function BlankItem(_ref) {
  var store = _ref.store,
    blank = _ref.blank,
    disabled = _ref.disabled,
    solutionsMode = _ref.solutionsMode,
    scaleFactor = _ref.scaleFactor,
    keyboardStore = _ref.keyboardStore,
    onAddAlternativeResponse = _ref.onAddAlternativeResponse;
  var _useState = useState(false),
    withPlusIcon = _useState[0],
    setWithPlusIcon = _useState[1];
  if (!isAlive(blank)) return null;
  function handleFocus(bool) {
    if (!store.isEditor) return false;
    bool ? setWithPlusIcon(bool) : setTimeout(function () {
      return setWithPlusIcon(bool);
    }, 200);
  }
  var showSuccess = when()["case"](solutionsMode, function () {
    return false;
  })["case"](blank.isImmediate, function () {
    return blank.feedbackResult === feedback.RIGHT;
  }).resolve(blank.feedbackResult === feedback.RIGHT);
  var showError = !solutionsMode && !blank.isImmediate && blank.feedbackResult === feedback.WRONG;
  var isVisibleFeedbackPin = blank.withPin && blank.isWrongCache;
  function openGroupedResponsesPanel() {
    onAddAlternativeResponse(blank);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    id: "wrapper__" + blank.id,
    className: "lemo-blank-item-container"
  }, withPlusIcon && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-alternative-response-wrapper"
  }, /*#__PURE__*/React__default.createElement(AddAlternativeResponseButton$1, {
    onClick: openGroupedResponsesPanel
  })), when()["case"](solutionsMode && blank.hasGroupedResponses, function () {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-grouped-response-counter-wrapper lemo-label-text-input"
    }, /*#__PURE__*/React__default.createElement(GroupedResponsesCounter, {
      responses: blank.solutionList.length,
      onClick: openGroupedResponsesPanel
    }));
  })["case"](store.hasLemonadeKeyboard, function () {
    return /*#__PURE__*/React__default.createElement(InputKeyboard$2, {
      id: blank.id,
      value: blank.value,
      setValue: blank.setValue,
      keyboardType: keyboardStore.type,
      selectedInput: keyboardStore === null || keyboardStore === void 0 ? void 0 : keyboardStore.activeFieldId,
      showSuccess: showSuccess,
      showError: showError,
      onFinish: keyboardStore.finish,
      onStart: keyboardStore.start,
      onWrite: keyboardStore.setValue,
      isFloating: solutionsMode || keyboardStore.isFloating,
      autoSize: false,
      maxLength: blank.responseLength
    });
  }).resolve(function () {
    return /*#__PURE__*/React__default.createElement(DefaultTextInput$1, {
      disabled: disabled,
      showSuccess: showSuccess,
      showError: showError,
      blank: blank,
      solutionsMode: solutionsMode,
      scaleFactor: scaleFactor,
      handleFocus: handleFocus
    });
  }), /*#__PURE__*/React__default.createElement(FeedbackPin$1, {
    idx: blank.feedbackIndex,
    result: blank.resultCache,
    visible: isVisibleFeedbackPin,
    classAdd: 'lemo-base-feedback-pin__option',
    feedback: blank.feedback
  }));
};
var BlankItem$1 = observer(BlankItem);

function LabelTextQuestion(props) {
  var store = props.store,
    _props$solutionsMode = props.solutionsMode,
    solutionsMode = _props$solutionsMode === void 0 ? false : _props$solutionsMode,
    onKeyboardVisible = props.onKeyboardVisible;
  var changedHandlers = /setTitle|setStimulus|setTarget|setValue/;
  var _useLabelImage = useLabelImage({
      store: store,
      solutionsMode: solutionsMode
    }),
    base = _useLabelImage.base,
    imageReady = _useLabelImage.imageReady,
    maxWidth = _useLabelImage.maxWidth,
    imgRef = _useLabelImage.imgRef,
    fontSize = _useLabelImage.fontSize,
    scaleFactor = _useLabelImage.scaleFactor,
    onLoadImage = _useLabelImage.onLoadImage;
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: base,
    className: cn$1('lemo-question-body', {
      'lemo-disabled': store.disabled
    })
  }, /*#__PURE__*/React__default.createElement(OnLoadShow$1, {
    isReady: imageReady,
    ignore: false
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-scalable-content-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-scalable-content-center",
    style: {
      maxWidth: maxWidth
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "lemo-label-image-background-img",
    ref: imgRef,
    src: store.withBasePath(store.image.src),
    draggable: "false",
    onLoad: onLoadImage,
    alt: store.image.alt
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-label-image-blanks-list"
  }, store.blankList.map(function (blank) {
    return /*#__PURE__*/React__default.createElement(LabelBlankItemWrapper$1, {
      key: blank.id,
      blank: blank,
      fontSize: fontSize,
      maxImageSize: store.maxImageSize,
      scaleFactor: scaleFactor
    }, /*#__PURE__*/React__default.createElement(BlankItem$1, {
      store: store,
      blank: blank,
      disabled: store.disabled || store.isEvaluated,
      scaleFactor: scaleFactor,
      solutionsMode: solutionsMode,
      keyboardStore: store.hasLemonadeKeyboard
    }));
  })))))), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: store.hasLemonadeKeyboard
  }, /*#__PURE__*/React__default.createElement(LemonadeKeyboard$1, {
    type: store.keyboard.type,
    keyboardStore: store.keyboard,
    isActive: store.keyboard.isActive,
    tabList: store.blankList.map(function (_ref) {
      var id = _ref.id;
      return id;
    }),
    forceFloating: solutionsMode,
    onKeyboardVisible: onKeyboardVisible
  })));
}
var LabelTextQuestion$1 = observer(LabelTextQuestion);

function LabelTextSolutionEditor(_ref) {
  var store = _ref.store,
    addAlternativeResponse = _ref.addAlternativeResponse;
  var _useLabelImage = useLabelImage({
      store: store,
      solutionsMode: true
    }),
    base = _useLabelImage.base,
    imageReady = _useLabelImage.imageReady,
    maxWidth = _useLabelImage.maxWidth,
    imgRef = _useLabelImage.imgRef,
    fontSize = _useLabelImage.fontSize,
    scaleFactor = _useLabelImage.scaleFactor,
    onLoadImage = _useLabelImage.onLoadImage;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-body",
    ref: base
  }, /*#__PURE__*/React__default.createElement(OnLoadShow$1, {
    isReady: imageReady,
    ignore: false
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-scalable-content-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-scalable-content-center",
    style: {
      maxWidth: maxWidth
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "lemo-label-image-background-img",
    ref: imgRef,
    src: store.withBasePath(store.image.src),
    draggable: "false",
    onLoad: onLoadImage,
    alt: store.image.alt
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-label-image-blanks-list"
  }, store.blankList.map(function (blank) {
    return /*#__PURE__*/React__default.createElement(LabelBlankItemWrapper$1, {
      key: blank.id,
      blank: blank,
      fontSize: fontSize,
      maxImageSize: store.maxImageSize,
      scaleFactor: scaleFactor
    }, /*#__PURE__*/React__default.createElement(BlankItem$1, {
      store: store,
      blank: blank,
      disabled: store.disabled || store.isEvaluated,
      scaleFactor: scaleFactor,
      solutionsMode: true,
      keyboardStore: store.hasLemonadeKeyboard,
      onAddAlternativeResponse: addAlternativeResponse
    }));
  }))))));
}
var LabelTextSolutionEditor$1 = observer(LabelTextSolutionEditor);

var _excluded$k = ["store", "changed", "type", "immediateFeedback"];
var LabelTextEditor = function LabelTextEditor(props) {
  var _ref, _ref2;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$k);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setTitle|setStimulus|setValue|setScore|removeResponseByIdx|setTemplate|sortResponses|destroy|setValidResponse|updateDrops|addResponse|setPosition|setSize|setFontSize|setWidth|setHeight|setPointer|addDrop|createAlternativeSolution|changeScore|updateSolution|removeSolution|removeSelected|setImagePercentBaseCent|setIsEvaluable|setAutosizeResponse|toggleLower|toggleAccents|toggleSpaces|setAlt|setImage|clearImage|addBlank|toggleIsMath|setSampleText|setX|setY|editSolutionAt",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 1,
      haveFeedbackIndividual: true,
      showConfigFeedbacksIndividual: true
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 2,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref[EDITOR_COMPONENT_COMMON.BACKGROUND] = {
      hide: true
    }, _ref[EDITOR_COMPONENT_COMMON.CLEAR_ALL] = {
      order: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.CLEAR_ALL].order,
      hide: false
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(EditorExerciseLabelStore$1, {
    store: store,
    showExampleText: false,
    withSizeDrops: true,
    showSliderSizeThumb: false,
    showLabelFontSize: false,
    canResizableBox: true
  }), /*#__PURE__*/React__default.createElement(EditorTextSolutions$1, {
    store: store,
    SolutionEditorComponent: LabelTextSolutionEditor$1,
    helpText: translate('exact_math_or_partial_match_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: [TYPES_CONFIG.CONFIG_ACCENT_SENSITIVE, TYPES_CONFIG.CONFIG_CASE_SENSITIVE, TYPES_CONFIG.CONFIG_FIX_SPACES, TYPES_CONFIG.CONFIG_AUTOSIZE_RESPONSE, TYPES_CONFIG.CONFIG_NUMBER_KEYBOARD, TYPES_CONFIG.CONFIG_FIXED_KEYBOARD],
    listConfigParams: (_ref2 = {}, _ref2[TYPES_CONFIG.CONFIG_NUMBER_KEYBOARD] = {
      keyboardList: [{
        value: keyboards.none
      }, {
        value: keyboards.numerical
      }, {
        value: keyboards.basic
      }]
    }, _ref2)
  }));
};
var LabelTextEditor$1 = observer(LabelTextEditor);

var _excluded$l = ["store", "changed", "type", "immediateFeedback"];
var LabelDragDropEditor = function LabelDragDropEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$l);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setTitle|setStimulus|setValue|setScore|removeResponseByIdx|setTemplate|sortResponses|destroy|setValidResponse|updateDrops|addResponse|setPosition|setSize|setFontSize|setWidth|setHeight|setPointer|addDrop|createAlternativeSolution|changeScore|updateSolution|removeSolution|removeSelected|setImagePercentBaseCent|setIsEvaluable|setDuplicateResponses|setShuffleOptions|setAlt|setImage|clearImage|updateDrag|addDrag|addBlank|setSampleText|sortDrags|setX|setY|setNumberDuplicates|setAutomaticDrop",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 2,
      haveFeedbackIndividual: true,
      showConfigFeedbacksIndividual: true
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 3,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref[EDITOR_COMPONENT_COMMON.BACKGROUND] = {
      hide: true
    }, _ref[EDITOR_COMPONENT_COMMON.CLEAR_ALL] = {
      order: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.CLEAR_ALL].order,
      hide: false
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(EditorExerciseLabelStore$1, {
    store: store,
    showExampleText: false,
    withSizeDrops: true,
    showSliderSizeThumb: false,
    showLabelFontSize: false,
    canResizableBox: true,
    withCopy: true
  }), /*#__PURE__*/React__default.createElement(EditorAnswerOptionsStore$1, {
    store: store,
    options: store.drags,
    onSortOptions: store.sortDrags,
    keyIdSortingList: "id",
    onClickAddOption: function onClickAddOption() {
      return store.addDrag('');
    },
    showToggleShuffleOptions: false,
    showToggleDuplicateResponses: true,
    showNumberDuplicates: store.duplicate_responses,
    titleBox: translate('answer_options'),
    helpText: translate('answer_options_help')
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    helpText: translate('exact_math_or_partial_match_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: [TYPES_CONFIG.CONFIG_SUFFLE_ANSWERS, TYPES_CONFIG.CONFIG_AUTO_DROP]
  }));
};
var LabelDragDropV2Editor = observer(LabelDragDropEditor);

var DragModel$e = types$1.compose(ValueModel, withNumberDuplicates, withZIndex, types$1.model({
  target: types$1.optional(types$1.string, ''),
  instanceId: types$1.optional(types$1.string, '')
}).actions(function (state) {
  return {
    setTarget: function setTarget(target) {
      state.target = target;
    },
    setValue: function setValue(value) {
      getParent(state, 2).validation.findAndUpdateValue(state.value, value);
      state.value = value;
    },
    hydrate: function hydrate(data) {
      state.value = data.value;
    }
  };
}).views(function (state) {
  return {
    get dropTarget() {
      return state.target ? getParent(state, 2).drops.find(function (drop) {
        return drop.id === state.target;
      }) : false;
    },
    get isValid() {
      return state.dropTarget && state.dropTarget.isValid;
    },
    get maxDepth() {
      return getParent(state, 2).maxDepth;
    }
  };
}));

var LabelDragDropBaseModel = types$1.compose(BaseModel$1, withAutomaticDrop);
var LabelDragDropUIStyle = createUIStyleModel(LabelDragDropBaseModel);

var LabelDragDropEditorStore = types$1.compose(EditorBaseModel, withImmediateHandlers('blankList'), withWhileDraggingTarget, withElementFeedbackParent('blankList'), types$1.model({
  blankList: types$1.optional(types$1.array(BlankModel), []),
  drags: types$1.array(DragModel$e),
  image: types$1.maybe(ImageModel),
  selected: types$1.optional(types$1.string, ''),
  fontSize: types$1.optional(types$1.number, 10),
  sampleText: types$1.optional(types$1.string, translate('response')),
  validation: ValidationModel,
  duplicate_responses: types$1.optional(types$1["boolean"], false),
  shuffle_options: types$1.optional(types$1["boolean"], false),
  onUpdateNotifier: types$1.optional(types$1.number, 0),
  ui_style: types$1.optional(LabelDragDropUIStyle, defaultUIStyle)
}).actions(function (state) {
  function getNumberDuplicatesDefault() {
    return state.blankList.length + 1;
  }
  return {
    afterCreate: function afterCreate() {
      onAction(state, function (_ref) {
        var name = _ref.name,
          path = _ref.path;
        if (name.match(/addBlank|setValidResponse|removeValue|destroy|removeSelected/)) {
          state.updateNotifier();
        }
        if (path.match(/\/blankList|\/drags/) && name === 'setValue') {
          state.updateNotifier();
        }
        if (name === 'updateSolution') state.updateResponses();
      }, true);
    },
    setShuffleOptions: function setShuffleOptions(bool) {
      state.shuffle_options = bool;
    },
    setDuplicateResponses: function setDuplicateResponses(bool) {
      state.drags.forEach(function (drag) {
        return drag.setNumberDuplicates(bool ? getNumberDuplicatesDefault() : 1);
      });
      state.duplicate_responses = bool;
      state.updateNotifier();
    },
    updateResponses: function updateResponses() {
      state.blankList.forEach(function (response, idx) {
        var valid = defaultValue("validation.value." + idx, state, '');
        response.setValidResponse(valid.length === 0 ? '' : valid);
      });
    },
    updateNotifier: function updateNotifier() {
      state.onUpdateNotifier = Date.now();
    },
    updateDrops: function updateDrops$1(blankList) {
      updateDrops(blankList, state);
    },
    resetDropPositions: function resetDropPositions$1() {
      resetDropPositions(state);
    },
    setPointer: function setPointer(pointer) {
      state.pointer = pointer;
    },
    addBlank: function addBlank() {
      var position = getPositionByIndex(state.blankList.length);
      createNewBlank$1(state, position.x, position.y);
      state.updateNotifier();
    },
    copyBlank: function copyBlank(selectedBlank) {
      var newBlank = JSON.parse(JSON.stringify(selectedBlank));
      newBlank.x += POSITION_AUTO_DROP_LIST;
      newBlank.y += POSITION_AUTO_DROP_LIST;
      delete newBlank.id;
      state.blankList.push(newBlank);
      state.setSelected('');
      state.updateNotifier();
    },
    sortResponses: function sortResponses(source, destination) {
      state.blankList = sortArrayItem(source, destination, state.blankList);
    },
    clearResponses: function clearResponses() {
      state.blankList.forEach(function (response) {
        return response.reset();
      });
    },
    addDrag: function addDrag(value) {
      var indexLabel = state.drags ? state.drags.length + 1 : '';
      state.drags.push({
        value: value || "<p>" + translate('option') + " " + indexLabel + "</p>",
        numberDuplicates: getNumberDuplicatesDefault()
      });
      state.updateNotifier();
    },
    sortDrags: function sortDrags(source, destination) {
      state.drags = sortArrayItem(source, destination, state.drags);
      state.updateNotifier();
    },
    updateDrag: function updateDrag(drag, currentDrop, nextDrop) {
      !state.duplicate_responses && currentDrop && currentDrop.reset();
      nextDrop && nextDrop.setValue(drag.value);
      state.updateNotifier();
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.string), response)) return false;
      state.clearResponses();
      state.blankList.forEach(function (res, idx) {
        return res.setValue(response[idx]);
      });
    },
    removeValue: function removeValue(instance) {
      if (getType(instance) === DragModel$e) {
        state.validation.findAndUpdateValue(instance.value, '');
      } else if (getType(instance) === BlankModel) {
        state.validation.removeValueAt(instance.index);
      }
      destroy(instance);
      state.updateNotifier();
    },
    removeSelected: function removeSelected() {
      if (!state.selected) return false;
      var selectedIdx = state.selectedBlank.index;
      state.removeValue(state.selectedBlank);
      state.validation.alt_responses.forEach(function (alt) {
        return alt.removeValueAt(selectedIdx);
      });
    },
    setData: function setData(data) {
      applySnapshot(state, _createSnapshot$t(data));
    },
    setSelected: function setSelected(itemId) {
      if (itemId === void 0) {
        itemId = '';
      }
      state.selected = itemId;
    },
    copySelected: function copySelected() {
      if (!state.selected) return false;
      if (state.selectedBlank) {
        state.copyBlank(state.selectedBlank);
      }
    },
    setSampleText: function setSampleText(value) {
      state.sampleText = value;
    },
    setFontSize: function setFontSize(fontSize) {
      state.fontSize = parseInt(fontSize, 10);
      state.updateNotifier();
    },
    setImagePercentBaseCent: function setImagePercentBaseCent(imagePercentBaseCent) {
      state.image = _extends({}, state.image, {
        percent: imagePercentBaseCent ? imagePercentBaseCent / 100 : 1
      });
      state.updateNotifier();
    },
    addDrop: function addDrop() {
      state.blankList.push({
        x: 0,
        y: 0,
        width: 90,
        height: 40
      });
    },
    setImage: function setImage$1(imageAttributes) {
      setImage(state, imageAttributes);
      state.blankList.forEach(function (blank) {
        return blank.fixPosition(imageAttributes);
      });
      state.updateNotifier();
    },
    clearImage: function clearImage() {
      state.image = undefined;
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot$t(rawData);
      applySnapshot(state, data);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    commitResponseFeedback: function commitResponseFeedback() {
      commitFeedbackMessages({
        state: state,
        collection: state.blankList,
        condition: getConditionCommitFeedbackMessages
      });
    },
    clearAll: function clearAll() {
      state.clearAllBase();
      state.blankList.clear();
      state.drags.clear();
      state.duplicate_responses = false;
      state.shuffle_options = false;
      state.updateNotifier();
    }
  };
}).views(function (state) {
  var normalize = function normalize(str) {
    return str;
  };
  return {
    getUserResponse: function getUserResponse() {
      var userResponse = state.blankList.map(function (res) {
        return res.value;
      });
      return state.getRealUserResponse(userResponse);
    },
    getResults: function getResults() {
      return {};
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$t(rawData);
    },
    get containerSize() {
      return state.image.width * (state.getPercentImage() * 100) / 100;
    },
    getPercentImage: function getPercentImage() {
      var _state$image;
      return (state === null || state === void 0 ? void 0 : (_state$image = state.image) === null || _state$image === void 0 ? void 0 : _state$image.percent) || 1;
    },
    get imageSrc() {
      return findAbsolutePath(state.image.src) ? state.image.src : "" + addLastSlash(state.basePath) + state.image.src;
    },
    getDropTarget: function getDropTarget(dragValue) {
      return state.blankList.find(function (blank) {
        return blank.value === dragValue;
      });
    },
    getDropById: function getDropById(id) {
      return state.blankList.find(function (drop) {
        return drop.id === id;
      });
    },
    get currentResponse() {
      return state.selected && state.blankList.find(function (res) {
        return res.id === state.selected;
      });
    },
    get selectedBlank() {
      return state.selected ? state.blankList.find(function (d) {
        return d.id === state.selected;
      }) : undefined;
    },
    getSolutions: function getSolutions() {
      return state.validation.value;
    },
    get alternativePoints() {
      var validateAlternative = function validateAlternative(alt) {
        return alt.value.reduce(function (acc, next, idx) {
          return normalize(next) === normalize(state.getUserResponse()[idx]) ? acc : false;
        }, true);
      };
      return state.validation.alt_responses.reduce(function (acc, next) {
        return validateAlternative(next) ? next.score : acc;
      }, 0);
    },
    get percentImageBaseCent() {
      return state.getPercentImage() * 100;
    },
    get output() {
      var toRet = exportCommonValues(state, {
        image: getSnapshot(state.image),
        fontSize: state.fontSize,
        sampleText: state.sampleText,
        responses: state.blankList.map(function (_ref2) {
          var x = _ref2.x,
            y = _ref2.y,
            z = _ref2.z,
            width = _ref2.width,
            height = _ref2.height,
            _ref2$pointer = _ref2.pointer,
            pointer = _ref2$pointer === void 0 ? '' : _ref2$pointer;
          return {
            x: x,
            y: y,
            z: z,
            width: width,
            height: height,
            pointer: pointer
          };
        }),
        possible_responses: state.drags.map(function (_ref3) {
          var value = _ref3.value;
          return value;
        }),
        possible_responses_config: state.drags.map(function (o) {
          return o.exportToPossibleResponsesConfig(state.duplicate_responses);
        }),
        duplicate_responses: state.duplicate_responses,
        shuffle_options: state.shuffle_options,
        feedback_responses: state.feedbackResponsesOutput
      });
      if (toRet.data && toRet.data.hasOwnProperty('imageSize')) {
        delete toRet.data.imageSize;
      }
      return toRet;
    }
  };
}));
function createBlanks$4(responses, feedback_responses) {
  return responses.map(function (response, idx) {
    var _feedback_responses$i;
    return _extends({}, response, {
      pointer: anyOrDefault('pointer', response, /top|left|right|bottom/, ''),
      value: '',
      feedback: feedback_responses === null || feedback_responses === void 0 ? void 0 : (_feedback_responses$i = feedback_responses[idx]) === null || _feedback_responses$i === void 0 ? void 0 : _feedback_responses$i.feedback
    });
  });
}
function _createSnapshot$t(data) {
  var _data$data = data.data,
    responses = _data$data.responses,
    possible_responses = _data$data.possible_responses,
    possible_responses_config = _data$data.possible_responses_config,
    feedback_responses = _data$data.feedback_responses;
  var percentImage = getPercentImageFromData(data);
  return _extends({}, data.data, importCommonValues$1(data), {
    blankList: createBlanks$4(responses, feedback_responses),
    drags: createOptionsFromPossibleResponses(possible_responses, possible_responses_config),
    image: _extends({}, data.data.image, percentImage ? {
      percent: percentImage
    } : {})
  });
}
function createStore$y(data) {
  return LabelDragDropEditorStore.create(_createSnapshot$t(data));
}

var EditorAnswerOptionsLabelDropdownStore = function EditorAnswerOptionsLabelDropdownStore(_ref) {
  var store = _ref.store,
    titleBox = _ref.titleBox,
    helpText = _ref.helpText;
  return /*#__PURE__*/React__default.createElement(EditorAnswerOptionsMultiple$1, {
    responses: store.blankList,
    withAccordion: true,
    openFirstAccordionStart: true,
    icon: /*#__PURE__*/React__default.createElement(SvgPhotograph, {
      className: "lemo-editor-answer-options-multiple__photograph-icon"
    }),
    titleBox: titleBox || translate('Exercise'),
    helpText: helpText
  });
};
EditorAnswerOptionsLabelDropdownStore.propTypes = {
  store: propTypes.any,
  titleBox: propTypes.string,
  helpText: propTypes.string
};
EditorAnswerOptionsLabelDropdownStore.defaultProps = {
  helpText: null
};
var EditorAnswerOptionsLabelDropdownStore$1 = observer(EditorAnswerOptionsLabelDropdownStore);

var _excluded$m = ["store", "changed", "type", "immediateFeedback"];
var LabelDropDownEditor = function LabelDropDownEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$m);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setTitle|setStimulus|setValue|setScore|removeResponseByIdx|setTemplate|sortResponses|destroy|setValidResponse|updateDrops|addResponse|setPosition|setSize|setFontSize|setWidth|setHeight|setPointer|addDrop|createAlternativeSolution|changeScore|updateSolution|removeSolution|removeSelected|setImagePercentBaseCent|setIsEvaluable|addNewValue|setAlt|setImage|clearImage|addBlank|updateNotifier|sortValues|setX|setY",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 2,
      haveFeedbackIndividual: true,
      showConfigFeedbacksIndividual: true
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 3,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref[EDITOR_COMPONENT_COMMON.BACKGROUND] = {
      hide: true
    }, _ref[EDITOR_COMPONENT_COMMON.CLEAR_ALL] = {
      order: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.CLEAR_ALL].order,
      hide: false
    }, _ref),
    immediateFeedback: immediateFeedback,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement(EditorExerciseLabelStore$1, {
    store: store,
    showSliderSizeThumb: false,
    showLabelFontSize: false,
    withCopy: true
  }), /*#__PURE__*/React__default.createElement(EditorAnswerOptionsLabelDropdownStore$1, {
    store: store,
    titleBox: translate('answer_options'),
    helpText: translate('answer_options_help')
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    helpText: translate('exact_math_or_partial_match_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: []
  }));
};
var LabelDropDownV2Editor = observer(LabelDropDownEditor);

function getLabelImage(props) {
  var _getCreator = getCreator(props, getDefaultData$4, types.labelImage.DragDrop),
    type = _getCreator.type,
    lang = _getCreator.lang,
    initialProps = _getCreator.initialProps,
    exerciseData = _getCreator.exerciseData,
    setCommonParamsStore = _getCreator.setCommonParamsStore;
  return when()["case"](type === types.labelImage.TextV2, function () {
    var editorStore = createStore$w(exerciseData);
    setCommonParamsStore(editorStore);
    var questionStore = createStore$x(exerciseData);
    setCommonParamsStore(questionStore);
    return createLabelTextV2({
      lang: lang,
      questionStore: questionStore,
      editorStore: editorStore,
      initialProps: initialProps
    });
  })["case"](type === types.labelImage.DropDownV2, function () {
    var editorStore = createStore$v(exerciseData);
    setCommonParamsStore(editorStore);
    var questionStore = createStore$u(exerciseData);
    setCommonParamsStore(questionStore);
    return createLabelDropDownV2({
      lang: lang,
      questionStore: questionStore,
      editorStore: editorStore,
      initialProps: initialProps
    });
  })["case"](type === types.labelImage.DragDropV2, function () {
    var editorStore = createStore$y(exerciseData);
    setCommonParamsStore(editorStore);
    var questionStore = createStore$t(exerciseData);
    setCommonParamsStore(questionStore);
    return createLabelDragDropV2({
      lang: lang,
      questionStore: questionStore,
      editorStore: editorStore,
      initialProps: initialProps
    });
  }).resolve(null);
}
function templateCreator(_ref) {
  var QuestionComponent = _ref.QuestionComponent,
    EditorComponent = _ref.EditorComponent;
  return function (_ref2) {
    var lang = _ref2.lang,
      questionStore = _ref2.questionStore,
      editorStore = _ref2.editorStore,
      initialProps = _ref2.initialProps;
    return commonCreatorProps(editorStore, {
      Question: function Question(extraParams) {
        return /*#__PURE__*/React__default.createElement(QuestionComponent, _extends({
          store: questionStore
        }, initialProps, extraParams));
      },
      Editor: function Editor(extraParams) {
        return /*#__PURE__*/React__default.createElement(EditorComponent, _extends({
          store: editorStore,
          lang: lang
        }, initialProps, extraParams));
      },
      Controls: function Controls(extraParams) {
        return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
          store: questionStore
        }, extraParams));
      },
      Feedback: function Feedback(extraParams) {
        return /*#__PURE__*/React__default.createElement(FeedbackManager$1, _extends({
          store: questionStore
        }, extraParams));
      },
      editorStore: editorStore,
      questionStore: questionStore
    });
  };
}
function createLabelTextV2(props) {
  var creator = templateCreator({
    QuestionComponent: LabelTextQuestion$1,
    EditorComponent: LabelTextEditor$1
  });
  return creator(props);
}
function createLabelDragDropV2(props) {
  var creator = templateCreator({
    QuestionComponent: LabelDragDropV2Question,
    EditorComponent: LabelDragDropV2Editor
  });
  return creator(props);
}
function createLabelDropDownV2(props) {
  var creator = templateCreator({
    QuestionComponent: LabelDropDownV2Question$1,
    EditorComponent: LabelDropDownV2Editor
  });
  return creator(props);
}

var KEYBOARD_INTERMEDIATE = {
  layouts: {
    label: 'intermediate',
    rows: [[{
      label: '7',
      key: '7'
    }, {
      label: '8',
      key: '8'
    }, {
      label: '9',
      key: '9'
    }, {
      label: '+',
      key: '+'
    }, {
      "class": 'separator w5'
    }, {
      "class": 'keycap',
      latex: '<'
    }, {
      "class": 'action',
      command: ['performWithFeedback', 'deleteBackward'],
      label: "<?xml version='1.0' ?><svg class='feather feather-delete' fill='none' height='20' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' viewBox='0 0 24 24' width='20' xmlns='http://www.w3.org/2000/svg'><path d='M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z'/><line x1='18' x2='12' y1='9' y2='15'/><line x1='12' x2='18' y1='9' y2='15'/></svg>"
    }], [{
      label: '4',
      key: '4'
    }, {
      label: '5',
      key: '5'
    }, {
      label: '6',
      key: '6'
    }, {
      label: '&#x2212;',
      key: '-'
    }, {
      "class": 'separator w5'
    }, {
      "class": 'keycap',
      latex: '>'
    }, {
      "class": 'keycap small',
      latex: '\\frac{#0}{#0}',
      height: 2
    }], [{
      label: '1',
      key: '1'
    }, {
      label: '2',
      key: '2'
    }, {
      label: '3',
      key: '3'
    }, {
      "class": 'keycap',
      latex: '\\times'
    }, {
      "class": 'separator w5'
    }, {
      "class": 'keycap tex',
      label: '('
    }, {
      "class": 'keycap tex',
      insert: '$$#@^{2}$$',
      label: '<span><i>x</i>&thinsp;²</span>'
    }], [{
      "class": 'keycap',
      latex: '.'
    }, {
      label: '0',
      key: '0'
    }, {
      "class": 'keycap',
      latex: '='
    }, {
      "class": 'keycap',
      latex: '\\div'
    }, {
      "class": 'separator w5'
    }, {
      "class": 'keycap tex',
      label: ')'
    }, {
      "class": 'action',
      command: ['commit'],
      label: "<?xml version='1.0' ?><svg data-name='Layer 1' id='Layer_1' viewBox='0 0 32 32' width='18' height='18' xmlns='http://www.w3.org/2000/svg'><defs><style>.cls-1{fill:#000000;}</style></defs><title/><path class='cls-1' d='M27,2a2,2,0,0,0-2,2V15c0,2.73-1.27,4-4,4H8.92l2-1,2.57-2.57a2,2,0,0,0-2.83-2.83l-7,7a2,2,0,0,0,0,2.83l7,7a2,2,0,0,0,2.83-2.83L10.79,24,8.85,23H21c4.93,0,8-3.07,8-8V4A2,2,0,0,0,27,2Z'/></svg>"
    }]]
  }
};
var decimalSeparator = function decimalSeparator() {
  var _window$MathfieldElem;
  return ((_window$MathfieldElem = window.MathfieldElement) === null || _window$MathfieldElem === void 0 ? void 0 : _window$MathfieldElem.decimalSeparator) || decimalSeparatorTypes.POINT;
};
var getKeyboardIntermediate = function getKeyboardIntermediate() {
  var keyboard = KEYBOARD_INTERMEDIATE;
  if (decimalSeparator() === decimalSeparatorTypes.COMMA) keyboard.layouts.rows[3][0].latex = '{,}';else keyboard.layouts.rows[3][0].latex = '.';
  return keyboard;
};

var KEYBOARD_FUNCTIONS = function KEYBOARD_FUNCTIONS() {
  return {
    layouts: {
      label: 'functions',
      rows: [[{
        label: '7',
        key: '7'
      }, {
        label: '8',
        key: '8'
      }, {
        label: '9',
        key: '9'
      }, {
        label: '+',
        key: '+'
      }, {
        "class": 'separator w5'
      }, {
        latex: 'x'
      }, {
        latex: 'y'
      }, {
        "class": 'action',
        command: ['performWithFeedback', 'deleteBackward'],
        label: "<?xml version='1.0' ?><svg class='feather feather-delete' fill='none' height='20' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' viewBox='0 0 24 24' width='20' xmlns='http://www.w3.org/2000/svg'><path d='M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z'/><line x1='18' x2='12' y1='9' y2='15'/><line x1='12' x2='18' y1='9' y2='15'/></svg>"
      }], [{
        label: '4',
        key: '4'
      }, {
        label: '5',
        key: '5'
      }, {
        label: '6',
        key: '6'
      }, {
        label: '&#x2212;',
        key: '-'
      }, {
        "class": 'separator w5'
      }, {
        "class": 'keycap',
        latex: '<'
      }, {
        "class": 'keycap',
        latex: '>'
      }, {
        "class": 'keycap small',
        latex: '\\frac{#0}{#0}',
        height: 2
      }], [{
        label: '1',
        key: '1'
      }, {
        label: '2',
        key: '2'
      }, {
        label: '3',
        key: '3'
      }, {
        "class": 'keycap',
        latex: multiplicationSymbol[config.keyboards.functions.multiplicationSymbol]
      }, {
        "class": 'separator w5'
      }, {
        "class": 'keycap tex',
        label: '('
      }, {
        "class": 'keycap tex',
        label: ')'
      }, {
        "class": 'keycap tex',
        insert: '$$#@^{2}$$',
        label: '<span><i>x</i>&thinsp;²</span>'
      }], [{
        "class": 'keycap',
        latex: '.'
      }, {
        label: '0',
        key: '0'
      }, {
        "class": 'keycap',
        latex: '='
      }, {
        "class": 'keycap',
        latex: '\\div'
      }, {
        "class": 'separator w5'
      }, {
        latex: '#@^{#0}}'
      }, {
        latex: '\\sqrt{#0}'
      }, {
        "class": 'action',
        command: ['commit'],
        label: "<?xml version='1.0' ?><svg data-name='Layer 1' id='Layer_1' viewBox='0 0 32 32' width='18' height='18' xmlns='http://www.w3.org/2000/svg'><defs><style>.cls-1{fill:#000000;}</style></defs><title/><path class='cls-1' d='M27,2a2,2,0,0,0-2,2V15c0,2.73-1.27,4-4,4H8.92l2-1,2.57-2.57a2,2,0,0,0-2.83-2.83l-7,7a2,2,0,0,0,0,2.83l7,7a2,2,0,0,0,2.83-2.83L10.79,24,8.85,23H21c4.93,0,8-3.07,8-8V4A2,2,0,0,0,27,2Z'/></svg>"
      }]]
    }
  };
};
var decimalSeparator$1 = function decimalSeparator() {
  var _window$MathfieldElem;
  return ((_window$MathfieldElem = window.MathfieldElement) === null || _window$MathfieldElem === void 0 ? void 0 : _window$MathfieldElem.decimalSeparator) || decimalSeparatorTypes.POINT;
};
var getKeyboardFunctions = function getKeyboardFunctions() {
  var keyboard = KEYBOARD_FUNCTIONS();
  if (decimalSeparator$1() === decimalSeparatorTypes.COMMA) keyboard.layouts.rows[3][0].latex = '{,}';else keyboard.layouts.rows[3][0].latex = '.';
  return keyboard;
};

var getKeyboard = function getKeyboard() {
  return window.mathVirtualKeyboard;
};
var MathField = function MathField(_ref) {
  var text = _ref.text,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    onKeyboardVisible = _ref.onKeyboardVisible,
    _ref$customKeyboard = _ref.customKeyboard,
    customKeyboard = _ref$customKeyboard === void 0 ? keyboards.scientific : _ref$customKeyboard,
    _ref$autoFocusFakeEna = _ref.autoFocusFakeEnabled,
    autoFocusFakeEnabled = _ref$autoFocusFakeEna === void 0 ? false : _ref$autoFocusFakeEna,
    _ref$handleFocus = _ref.handleFocus,
    handleFocus = _ref$handleFocus === void 0 ? noop : _ref$handleFocus,
    selectedInput = _ref.selectedInput;
  var _useMathLive = useMathLive(),
    mathLiveReady = _useMathLive.mathLiveReady;
  var _useState = useState(false),
    withFocus = _useState[0],
    setWithFocus = _useState[1];
  var mf = useRef();
  function setKeyboardVisible(visible) {
    var keyboard = getKeyboard();
    if (!keyboard) return;
    visible ? keyboard === null || keyboard === void 0 ? void 0 : keyboard.show() : keyboard === null || keyboard === void 0 ? void 0 : keyboard.hide();
    onKeyboardVisible === null || onKeyboardVisible === void 0 ? void 0 : onKeyboardVisible(visible, customKeyboard || keyboards.scientific);
  }
  var getValue = function getValue() {
    var _mf$current, _mf$current$getValue;
    return (_mf$current = mf.current) === null || _mf$current === void 0 ? void 0 : (_mf$current$getValue = _mf$current.getValue) === null || _mf$current$getValue === void 0 ? void 0 : _mf$current$getValue.call(_mf$current, 'latex-expanded');
  };
  function handleChange() {
    onChange === null || onChange === void 0 ? void 0 : onChange(getValue());
  }
  function selectLayout() {
    var keyboard = getKeyboard();
    if (keyboard) {
      if (customKeyboard === keyboardTypes.INTERMEDIATE) {
        keyboard.layouts = getKeyboardIntermediate().layouts;
      } else if (customKeyboard === keyboardTypes.FUNCTIONS) {
        keyboard.layouts = getKeyboardFunctions().layouts;
      } else {
        keyboard.layouts = 'default';
      }
    }
  }
  var setFocus = function setFocus(bool) {
    if (disabled) return false;
    handleFocus(bool);
    setWithFocus(bool);
    if (bool) {
      selectLayout();
      setKeyboardVisible(true);
    } else {
      onChange === null || onChange === void 0 ? void 0 : onChange(getValue());
      setKeyboardVisible(false);
    }
  };
  useEffect(function () {
    if (mathLiveReady) {
      mf.current.mathVirtualKeyboardPolicy = 'sandboxed';
      mf.current.addEventListener('focusin', function (evt) {
        return setFocus(true);
      });
      mf.current.addEventListener('blur', function (evt) {
        return setFocus(false);
      });
      mf.current.addEventListener('change', function (evt) {
        return setFocus(false);
      });
    }
  }, [mathLiveReady]);
  useEffect(function () {
    if (mathLiveReady) {
      selectLayout();
    }
  }, [customKeyboard, mathLiveReady]);
  useEffect(function () {
    if (mathLiveReady) {
      window.MathfieldElement.decimalSeparator = config.decimalSeparator;
    }
  }, [config.decimalSeparator, mathLiveReady]);
  useEffect(function () {
    if (mathLiveReady) {
      mf.current.disabled = disabled;
      var firstItem = mf.current.shadowRoot.firstChild;
      firstItem.style.pointerEvents = disabled ? 'none' : 'auto';
    }
  }, [mathLiveReady, disabled]);
  useEffect(function () {
    if (mathLiveReady) {
      mf.current.value !== text && mf.current.setValue(text);
    }
  }, [text, mathLiveReady]);
  function buttonShow() {
    if (!getKeyboard()) {
      return console.error('Lemonade: Virtual keyboard not found');
    }
    getKeyboard().show();
    setTimeout(function () {
      mf.current.focus();
    }, 100);
  }
  function buttonHide() {
    if (!getKeyboard()) {
      return console.error('Lemonade: Virtual keyboard not found');
    }
    getKeyboard().hide();
    mf.current.blur();
  }
  function handleShowButton() {
    withFocus ? buttonHide() : buttonShow();
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames('lemo-mathField', 'lemo-box-small', {
      'lemo-with-focus': config.inputMathFloating && withFocus,
      'lemo-selected': withFocus || autoFocusFakeEnabled && !selectedInput,
      'lemo-mathField--hide-keyboard-toggle': !config.mathFieldIcon,
      'lemo-is-empty': getValue() === '',
      'lemo-disabled': disabled
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-mathField-background"
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-calc-button",
    onMouseDown: handleShowButton
  }, /*#__PURE__*/React__default.createElement(SvgTable, {
    width: 24
  })), /*#__PURE__*/React__default.createElement("math-field", {
    ref: mf,
    onInput: handleChange
  }, text)));
};
var BaseMathField = observer(MathField);

function MathField$1(props) {
  var _props$text = props.text,
    text = _props$text === void 0 ? '' : _props$text,
    _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? autoFocusTypes.NONE : _props$autoFocus,
    _props$handleFocus = props.handleFocus,
    handleFocus = _props$handleFocus === void 0 ? noop : _props$handleFocus,
    selectedInput = props.selectedInput,
    _props$isFloating = props.isFloating,
    isFloating = _props$isFloating === void 0 ? true : _props$isFloating,
    _props$resetNotifier = props.resetNotifier,
    resetNotifier = _props$resetNotifier === void 0 ? null : _props$resetNotifier;
  var isTouch = isTouchDevice();
  var _useAutoFocus = useAutoFocus({
      text: text,
      autoFocus: autoFocus,
      handleFocus: handleFocus,
      selectedInput: selectedInput,
      isFloating: isFloating,
      resetNotifier: resetNotifier
    }),
    autoFocusBaseEditableText = _useAutoFocus.autoFocusBaseEditableText,
    autoFocusFakeEnabled = _useAutoFocus.autoFocusFakeEnabled,
    handleFocusFinal = _useAutoFocus.handleFocusFinal,
    forceVisibilityTooltip = _useAutoFocus.forceVisibilityTooltip;
  var baseEditableText = /*#__PURE__*/React__default.createElement(BaseMathField, _extends({}, props, {
    autoFocus: autoFocusBaseEditableText,
    autoFocusFakeEnabled: autoFocusFakeEnabled,
    handleFocus: handleFocusFinal,
    selectedInput: selectedInput
  }));
  return autoFocus === autoFocusTypes.ENABLED ? /*#__PURE__*/React__default.createElement(TooltipIcon, {
    text: translate(isTouch ? 'input_floating_tootltip_help_touch_devices' : 'input_floating_tootltip_help'),
    icon: baseEditableText,
    forceVisibility: forceVisibilityTooltip,
    classAdd: "lemo-mathField__tooltip"
  }) : baseEditableText;
}
var MathField$2 = observer(MathField$1);

var TextBlank$1 = function TextBlank(_ref) {
  var response = _ref.response,
    keyboard = _ref.keyboard,
    disabled = _ref.disabled,
    onKeyboardVisible = _ref.onKeyboardVisible,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? autoFocusTypes.NONE : _ref$autoFocus,
    _ref$handleFocus = _ref.handleFocus,
    handleFocus = _ref$handleFocus === void 0 ? noop : _ref$handleFocus,
    inputKeyFocus = _ref.inputKeyFocus,
    _ref$resetNotifier = _ref.resetNotifier,
    resetNotifier = _ref$resetNotifier === void 0 ? null : _ref$resetNotifier;
  if (!isAlive(response)) return null;
  var showSuccess = response.feedbackResult === feedback.RIGHT;
  var showError = response.feedbackResult === feedback.WRONG;
  function setResponse(val) {
    response.setValue(val);
  }
  var isMathField = keyboard.type === undefined || keyboard.type === keyboardTypes.SCIENTIFIC || keyboard.type === keyboardTypes.INTERMEDIATE || keyboard.type === keyboardTypes.FUNCTIONS;
  function handleFocusFinal(focus) {
    handleFocus && handleFocus(focus, response.id);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-text-blank', {
      'lemo-selected': response.selected,
      'lemo-lock': response.lock,
      'lemo-success': showSuccess,
      'lemo-error': showError,
      'lemo-text-blank--is-floating': keyboard.isFloating
    })
  }, /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: !isMathField
  }, /*#__PURE__*/React__default.createElement(InputKeyboard$2, {
    id: response.id,
    value: response.value,
    setValue: response.setValue,
    keyboardType: keyboard.type,
    selectedInput: keyboard.activeFieldId,
    showSuccess: showSuccess,
    showError: showError,
    onFinish: keyboard.finish,
    onStart: keyboard.start,
    onWrite: keyboard.setValue,
    disabled: disabled,
    isFloating: keyboard.isFloating,
    autoFocus: autoFocus,
    handleFocus: handleFocusFinal,
    resetNotifier: resetNotifier
  })), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: isMathField
  }, /*#__PURE__*/React__default.createElement(MathField$2, {
    text: response.value,
    disabled: response.lock,
    onChange: setResponse,
    onKeyboardVisible: onKeyboardVisible,
    customKeyboard: getCustomKeyboardMathField(keyboard),
    selectedInput: inputKeyFocus,
    autoFocus: autoFocus,
    handleFocus: handleFocusFinal,
    resetNotifier: resetNotifier
  })), /*#__PURE__*/React__default.createElement(FeedbackPin$1, {
    idx: response.feedbackIndex,
    result: response.resultCache,
    visible: response.withPin && response.isWrongCache,
    classAdd: 'lemo-base-feedback-pin__option',
    feedback: response.feedback
  }));
};
var TextBlank$2 = observer(TextBlank$1);

function ClozeMathQuestion(props) {
  var store = props.store,
    onKeyboardVisible = props.onKeyboardVisible,
    _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? autoFocusTypes.NONE : _props$autoFocus;
  var node = useRef(null);
  var changedHandlers = /setTitle|setStimulus|setTarget|updateDrag|removeValue|setValue|hydrateQuestionPreview/;
  var _React$useState = React__default.useState(false),
    hasAnyInputFocus = _React$useState[0],
    setHasAnyInputFocus = _React$useState[1];
  var _React$useState2 = React__default.useState(undefined),
    inputKeyFocus = _React$useState2[0],
    setInputKeyFocus = _React$useState2[1];
  var _useState = useState(false),
    isKeyboardVisible = _useState[0],
    setIsKeyboardVisible = _useState[1];
  function handleKeyboardVisible(isVisible) {
    setIsKeyboardVisible(isVisible);
    onKeyboardVisible === null || onKeyboardVisible === void 0 ? void 0 : onKeyboardVisible(isVisible);
  }
  useEffect(function () {
    if (hasAnyInputFocus && autoFocus === autoFocusTypes.ENABLED) {
      var elements = node.current.querySelectorAll('.' + TOOLTIP_FORCE_SHOW_CLASS);
      elements.forEach(function (element) {
        element.classList.remove(TOOLTIP_FORCE_SHOW_CLASS);
        element.classList.add(TOOLTIP_FORCE_HIDE_CLASS);
        var childWithSelected = element.querySelector('.lemo-selected');
        if (childWithSelected) {
          childWithSelected.classList.remove('lemo-selected');
        }
      });
    }
  }, [hasAnyInputFocus]);
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    className: isKeyboardVisible ? 'lemo-with-keyboard' : '',
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', {
      'lemo-disabled': store.disabled
    }),
    ref: node
  }, store.isPrintMode ? /*#__PURE__*/React__default.createElement(PrintModeTemplate$1, {
    store: store
  }) : /*#__PURE__*/React__default.createElement(QuestionTemplate$3, {
    store: store,
    autoFocus: autoFocus
  }, /*#__PURE__*/React__default.createElement(TextBlank$2, {
    keyboard: store.hasLemonadeKeyboard,
    onKeyboardVisible: handleKeyboardVisible,
    handleFocus: function handleFocus(focus, id) {
      if (focus) {
        setHasAnyInputFocus(true);
      }
      setInputKeyFocus(focus ? id : undefined);
    },
    inputKeyFocus: inputKeyFocus,
    resetNotifier: store.resetNotifier
  }))), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: store.hasLemonadeKeyboard
  }, /*#__PURE__*/React__default.createElement(LemonadeKeyboard$1, {
    type: store.keyboard.type,
    keyboardStore: store.keyboard,
    isActive: store.keyboard.isActive,
    tabList: store.tabList,
    onKeyboardVisible: onKeyboardVisible
  })));
}
var ClozeMathQuestion$1 = observer(ClozeMathQuestion);

var defaultDecimals = 0;
var OptionsModel = types$1.model({
  decimalPlaces: types$1.optional(types$1.number, defaultDecimals),
  ignoreTrailingZeros: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  var notify = function notify() {
    getParent(state, 3).updateNotifier();
    getParent(state, 3).updateNotifierUpdateTemplate();
  };
  return {
    setDecimalPlaces: function setDecimalPlaces(decimalPlaces) {
      state.decimalPlaces = decimalPlaces;
      notify();
    },
    setIgnoreTrailingZeros: function setIgnoreTrailingZeros(bool) {
      state.ignoreTrailingZeros = bool;
      notify();
    }
  };
});

function removeTrailingZeros(val) {
  var normalizedValue = normalizeDecimalSeparator(val);
  return isNaN(normalizedValue) ? val : Number(normalizedValue).toString();
}

var ResponseModel$5 = types$1.compose(withShowSolutionsParent, ValueModel, withElementFeedback, getWithFeedbackResult(function () {}), types$1.model({
  method: types$1.optional(types$1.enumeration(Object.values(exactOrEquivalentTypes)), exactOrEquivalentTypes.EXACT),
  options: types$1.optional(OptionsModel, {}),
  withFeedback: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    setMethod: function setMethod(method) {
      state.method = method;
      getParent(state, 2).updateNotifier();
    },
    setMethodIndex: function setMethodIndex(idx) {
      state.method = Object.values(exactOrEquivalentTypes)[idx];
      if (state.method === exactOrEquivalentTypes.EXACT) {
        state.options.setDecimalPlaces(0);
      }
      getParent(state, 2).updateNotifier();
    },
    setSolution: function setSolution(val) {
      var parent = getParent(state, 2);
      parent.validation.updateValueIndex(state.index, val);
      parent.updateNotifier();
    },
    destroy: function destroy() {
      if (isAlive(state)) getParent(state, 2).removeResponse(state);
    },
    setFeedback: function setFeedback(val) {
      state.feedback = val;
      getParent(state, 2).updateNotifier();
    },
    setWithFeedback: function setWithFeedback(withFeedback) {
      state.withFeedback = withFeedback;
      getParent(state, 2).updateNotifier();
    },
    reset: function reset() {
      state.value = '';
    }
  };
}).views(function (state) {
  return {
    get index() {
      try {
        return getParent(state).findIndex(function (i) {
          return i.id === state.id;
        });
      } catch (e) {
        return -1;
      }
    },
    get solution() {
      return defaultValue("validation.value." + state.index, getParent(state, 2), '');
    },
    get valueOutput() {
      return _extends({}, omit(['id', 'withFeedback', 'feedback', 'resultCache'], getSnapshot(state)), {
        value: state.solution
      });
    },
    get validate() {
      var normalizedSolution = normalizeLatex(state.solution);
      var normalizedValue = normalizeLatex(state.value);
      var _state$options$decima = state.options.decimalPlaces,
        decimalPlaces = _state$options$decima === void 0 ? 0 : _state$options$decima;
      var isExact = state.method === exactOrEquivalentTypes.EXACT;
      var isEquivalent = state.method === exactOrEquivalentTypes.EQUIVALENT;
      var ignoreTrailingZeros = state.options.ignoreTrailingZeros;
      var isNumericOperation = isNumeric(normalizedValue) && isNumeric(normalizedSolution);
      if (!isAlive(state)) return false;
      if (state.value.length === 0) return false;
      if (isExact) {
        return compareExactValues(normalizedSolution, normalizedValue, {
          ignoreTrailingZeros: ignoreTrailingZeros
        });
      }
      if (isEquivalent) {
        return decimalPlaces > 0 && isNumericOperation ? compareDecimalExpressions(normalizedSolution, normalizedValue, decimalPlaces) : compareExpressions(normalizedSolution, normalizedValue);
      }
      return false;
    },
    get isValid() {
      return state.validate;
    },
    get numericResult() {
      if (!isAlive(state)) return;
      try {
        var decimals = state.options.decimalPlaces;
        if (decimals) return false;
        var response = isNumeric(state.value);
        var solution = isNumeric(state.solution);
        if (solution === false && response === false) return false;
        return parseInt(response).toFixed(decimals) === parseInt(solution).toFixed(decimals);
      } catch (e) {
        return false;
      }
    },
    get withDecimals() {
      return state.numericResult !== false;
    },
    get selected() {
      try {
        return state.value.length > 0;
      } catch (e) {
        return false;
      }
    },
    get lock() {
      try {
        var parent = getParent(state, 2);
        return parent.isEvaluated || parent.disabled;
      } catch (e) {
        return false;
      }
    },
    get methodList() {
      return Object.values(exactOrEquivalentTypes).map(function (v) {
        return translate('response_exact_or_equivalent_subtitle_option_' + v.toLowerCase());
      });
    },
    get selectedIndex() {
      return Object.values(exactOrEquivalentTypes).findIndex(function (v) {
        return v === state.method;
      });
    },
    get isCanShowElementFeedback() {
      return isCanShowElementFeedbackParam(types.math.ClozeMath, state.isEmptyResponse(state.value), false);
    }
  };
}));
function isNumericString(value) {
  var regex = /^[+-]?\d+(\.\d+)?$/;
  return regex.test(value);
}
function compareExactValues(a, b, _ref) {
  var ignoreTrailingZeros = _ref.ignoreTrailingZeros;
  var values = [a, b];
  if (ignoreTrailingZeros) {
    values = values.map(removeTrailingZeros);
  }
  if (isNumericString(values[0]) && isNumericString(values[1])) {
    return parseFloat(values[0]) === parseFloat(values[1]);
  }
  return values[0] === values[1];
}

var pipe = function pipe() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function (x) {
    return fns.reduce(function (y, f) {
      return f(y);
    }, x);
  };
};

function getResponseData(response) {
  return {
    feedback: response.feedback,
    withFeedback: response.feedback.length > 0
  };
}
function getFeedbackResponses(data) {
  var responsesLength = data.data.validation.valid_response.value.length;
  return data.data.feedback_responses ? data.data.feedback_responses : populate(responsesLength, function () {
    return {
      feedback: ''
    };
  });
}
function getResponses(data) {
  var feedbackResponses = getFeedbackResponses(data);
  var value = data.data.validation.valid_response.value;
  return value.map(function (response, idx) {
    var feedback = getResponseData(feedbackResponses[idx]);
    return _extends({}, omit(['value'], response), feedback);
  });
}
function getNormalizedValidation(data) {
  var _data$data$ui_style, _data$data$ui_style$k;
  var isBasicKeyboard = ((_data$data$ui_style = data.data.ui_style) === null || _data$data$ui_style === void 0 ? void 0 : (_data$data$ui_style$k = _data$data$ui_style.keyboard) === null || _data$data$ui_style$k === void 0 ? void 0 : _data$data$ui_style$k.type.toUpperCase()) === keyboardTypes.BASIC;
  return produce(data.data.validation, function (draft) {
    draft.valid_response.value = draft.valid_response.value.map(function (_ref) {
      var value = _ref.value;
      if (isBasicKeyboard) return normalizeFromLatexToBasic(value);
      return pipe(normalizeSingleDigitPowers, clearPower1)(value);
    });
  });
}
function getCreateSnapshot(data) {
  var exerciseData = _extends({}, data.data, importCommonValues$1(data), {
    responses: getResponses(data),
    validation: getNormalizedValidation(data)
  });
  return addDefaultKeyboard(exerciseData);
}

function removeOccurrence$1(string, pattern, index) {
  var idx = string.split(pattern, index).join(pattern).length;
  return string.substring(0, idx) + string.substring(idx + pattern.length);
}

var ClozeMathEditorStore = types$1.compose(ClozeEditorStore, getClosestSolutionModel(checkResponse$g), withValidationModes, withElementFeedbackParent('responses'), withHasLemonadeKeyboard, types$1.model({
  responses: types$1.optional(types$1.array(ResponseModel$5), []),
  keyboard: types$1.optional(KeyboardStore, {})
}).actions(function (state) {
  var getCurrentValues = function getCurrentValues() {
    return state.responses.reduce(function (acc, next) {
      var _extends2;
      return _extends({}, acc, (_extends2 = {}, _extends2[next.id] = next.solution, _extends2));
    }, {});
  };
  return {
    afterCreate: function afterCreate() {
      state.updateResponses();
      reaction(function () {
        return state.ui_style.keyboard.type;
      }, function (type) {
        return state.keyboard.setType(type);
      });
    },
    setTemplate: function setTemplate(val, blanksResponsesId) {
      if (blanksResponsesId === void 0) {
        blanksResponsesId = null;
      }
      var values = getCurrentValues();
      state.template = val;
      state.updateResponses(blanksResponsesId);
      state.updateSolution(values);
      state.updateNotifier();
    },
    updateSolution: function updateSolution(values) {
      state.validation.setValue(state.responses.map(function (response) {
        return values[response.id] || '';
      }));
    },
    clearResponses: function clearResponses() {
      state.responses.forEach(function (response) {
        return response.reset();
      });
    },
    removeResponse: function removeResponse(response) {
      state.validation.removeValueAt(response.index);
      state.template = removeOccurrence$1(state.template, '{{response}}', response.index + 1);
      state.updateNotifier();
      state.updateNotifierUpdateTemplate();
      destroy(response);
    },
    setKeyboard: function setKeyboard(keyboard) {
      state.keyboard = keyboard;
    },
    setKeyboardFloating: function setKeyboardFloating(floating) {
      state.keyboard.setIsFloating(floating);
    },
    clearAllSolutions: function clearAllSolutions() {
      state.validation.setValue(state.validation.value.map(function () {
        return '';
      }));
      state.validation.removeAltResponses();
    }
  };
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$u(rawData);
    },
    get output() {
      var _state$ui_style, _state$ui_style$keybo;
      var isBasicKeyboard = ((_state$ui_style = state.ui_style) === null || _state$ui_style === void 0 ? void 0 : (_state$ui_style$keybo = _state$ui_style.keyboard) === null || _state$ui_style$keybo === void 0 ? void 0 : _state$ui_style$keybo.type) === keyboardTypes.BASIC;
      return exportCommonValues(state, {
        template: state.template,
        validation: produce(getSnapshot(state.validation), function (draft) {
          draft.valid_response.value = state.responses.map(function (_ref) {
            var valueOutput = _ref.valueOutput,
              method = _ref.method;
            return _extends({}, valueOutput, {
              value: isBasicKeyboard && method === exactOrEquivalentTypes.EQUIVALENT ? normalizeFromBasicToLatex(valueOutput.value) : valueOutput.value
            });
          });
        }),
        feedback_responses: state.feedbackResponsesOutput
      });
    },
    get lemonadeKeyboard() {
      var lemoKeyboardTypes = Object.values(keyboardTypes);
      if (state.ui_style.keyboard.type.length === 0) return false;
      return lemoKeyboardTypes.includes(state.ui_style.keyboard.type) ? state.keyboard : false;
    },
    get tabList() {
      return state.responses.map(function (_ref2) {
        var id = _ref2.id;
        return id;
      });
    }
  };
}));
function checkResponse$g(a, b, state, idx) {
  if (state.responses[idx].value.length === 0) return null;
  return state.responses[idx].isValid;
}
function _createSnapshot$u(data) {
  return getCreateSnapshot(data);
}
function createStore$z(data) {
  return ClozeMathEditorStore.create(_createSnapshot$u(data));
}

var withConfigureScorm$f = types$1.compose(withScorm, types$1.model({}).views(function (state) {
  var getItem = function getItem(item) {
    return {
      userResponse: item.value,
      id: item.id,
      rightAnswer: state.validation.value[item.index],
      result: item.isValid
    };
  };
  return {
    get scormType() {
      return scormTypes.CHOICE;
    },
    getInteractiveListInitScorm: function getInteractiveListInitScorm() {
      return state.responses.map(getItem);
    },
    updateScormItem: function updateScormItem(name, path) {
      if (path.match(/\/responses/) && name === 'setValue') {
        var item = resolvePath(state, path);
        return getItem(item);
      } else return null;
    }
  };
}));

var ClozeMathQuestionStore = types$1.compose(QuestionBaseModel, getClosestSolutionModel(checkResponse$h), withValidationModes, withElementFeedbackParent('responses'), withHasLemonadeKeyboard, withConfigureScorm$f, types$1.model({
  template: types$1.optional(types$1.string, ''),
  responses: types$1.optional(types$1.array(ResponseModel$5), []),
  keyboard: types$1.optional(KeyboardStore, {})
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      reaction(function () {
        var _state$ui_style$keybo;
        return (_state$ui_style$keybo = state.ui_style.keyboard) === null || _state$ui_style$keybo === void 0 ? void 0 : _state$ui_style$keybo.type;
      }, function (type) {
        return state.keyboard.setType(type);
      });
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.string), response)) return false;
      state.responses.forEach(function (resp, idx) {
        return resp.setValue(response[idx]);
      });
    },
    getUserResponse: function getUserResponse() {
      var userResponse = state.responses.map(function (_ref) {
        var value = _ref.value;
        return value;
      });
      return state.getRealUserResponse(userResponse);
    },
    clearResponses: function clearResponses() {
      state.responses.forEach(function (response) {
        return response.reset();
      });
    },
    reset: function reset() {
      state.baseReset();
      state.clearResponses();
      state.updateNotifier();
    },
    commitResponseFeedback: function commitResponseFeedback() {
      commitFeedbackMessages({
        state: state,
        collection: state.responses,
        condition: getConditionCommitFeedbackMessages
      });
    },
    hydrateQuestionPreview: function hydrateQuestionPreview(rawData) {
      var data = _createSnapshot$v(rawData);
      var prevAssetsQuestionApi = state.assetsQuestionApi;
      applySnapshot(state, data);
      state.keyboard.updateFromUIStyle(data.ui_style);
      var validResponse = rawData.data.validation.valid_response.value.map(function (_ref2) {
        var value = _ref2.value;
        return value;
      });
      state.validation.setValue(validResponse);
      state.setIsSolutionMode(false);
      state.setAssetsQuestionApi(prevAssetsQuestionApi);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$v(rawData);
    },
    get templateToView() {
      return updateTemplate$1(state.template);
    },
    getValidResponses: function getValidResponses() {
      return state.validation.value;
    },
    get templateToPrintMode() {
      var responses = state.responses.map(function (_ref3) {
        var value = _ref3.value;
        return value;
      });
      return templateToPrintMode$1(state.template, responses);
    }
  };
}));
function createFormula(value) {
  return "<span class=\"fr-math-v2 fr-draggable\" contentEditable=\"false\" data-original-math=\"" + value + "\">\n        " + value + "\n    </span>";
}
function templateToPrintMode$1(str, responses) {
  var counter = 0;
  return str.replace(/{{response}}/g, function () {
    var currentResponse = responses === null || responses === void 0 ? void 0 : responses[counter];
    var result = currentResponse ? createFormula(currentResponse) : '<span style="color: lightgray;">__________</span>';
    counter++;
    return result;
  });
}
function checkResponse$h(a, b, state, idx) {
  if (state.responses[idx].value.length === 0) return null;
  return state.responses[idx].isValid;
}
function _createSnapshot$v(data) {
  return getCreateSnapshot(data);
}
function createStore$A(data) {
  return ClozeMathQuestionStore.create(_createSnapshot$v(data));
}

var CountItemModel = types$1.model({
  id: types$1.optional(types$1.identifier, function () {
    return uuid();
  }),
  selected: types$1.optional(types$1.number, 0)
}).actions(function (state) {
  return {
    toggle: function toggle() {
      state.selected = state.selected === 0 ? 1 : 0;
    },
    setSelected: function setSelected(selected) {
      state.selected = selected ? 1 : 0;
    }
  };
}).views(function (state) {
  var root = getParent(state, 4);
  return {
    get operation() {
      return root.operation;
    },
    get itemClassName() {
      return "lemo-operation-" + state.operation;
    },
    get feedbackProps() {
      return root.feedbackBySelection.find(function (item) {
        return item.id === state.id;
      });
    },
    get isSuccess() {
      var _state$feedbackProps;
      if (state.selected === 0) return false;
      return ((_state$feedbackProps = state.feedbackProps) === null || _state$feedbackProps === void 0 ? void 0 : _state$feedbackProps.isSuccess) === true;
    },
    get isError() {
      var _state$feedbackProps2;
      if (state.selected === 0) return false;
      return ((_state$feedbackProps2 = state.feedbackProps) === null || _state$feedbackProps2 === void 0 ? void 0 : _state$feedbackProps2.isSuccess) === false;
    }
  };
});

var operationTypes = {
  ADD: 'add',
  SUBTRACTION: 'subtract',
  COUNT: 'count'
};

var ADD = operationTypes.ADD,
  SUBTRACTION = operationTypes.SUBTRACTION,
  COUNT = operationTypes.COUNT;
var CountGroupModel = types$1.model({
  id: types$1.optional(types$1.identifier, function () {
    return uuid();
  }),
  src: types$1.string,
  countItems: types$1.array(CountItemModel)
}).actions(function (state) {
  return {
    reset: function reset() {
      state.countItems.forEach(function (item) {
        return item.setSelected(false);
      });
    },
    applyResponse: function applyResponse(response) {
      state.countItems.forEach(function (item, idx) {
        return item.setSelected(response[idx]);
      });
    }
  };
}).views(function (state) {
  return {
    get selectedItemsLength() {
      return state.countItems.reduce(function (acc, next) {
        return acc + (next.selected ? 1 : 0);
      }, 0);
    },
    get itemsLength() {
      return state.countItems.length;
    },
    get value() {
      var _getParent = getParent(state, 2),
        operation = _getParent.operation;
      var selectedItems = state.selectedItemsLength;
      var itemsLength = state.itemsLength;
      return when()["case"](operation === ADD, function () {
        return selectedItems;
      })["case"](operation === COUNT, function () {
        return selectedItems;
      })["case"](operation === SUBTRACTION, function () {
        return itemsLength - selectedItems;
      }).resolve(0);
    }
  };
});

var ADD$1 = 'add';
var COUNT$1 = 'count';
var SUBTRACT = 'subtract';
var operationList = [ADD$1, COUNT$1, SUBTRACT];

function createCountGroups(options) {
  return options.map(function (_ref) {
    var src = _ref.src,
      value = _ref.value;
    return {
      src: src,
      countItems: Array(value).fill({
        selected: 0
      }, 0, value)
    };
  });
}

function GroupSpace(availableSpace) {
  var storage = 0;
  function addItems(items) {
    var queue = storage + items;
    var overflow = queue - availableSpace;
    storage = Math.min(availableSpace, queue);
    return Math.max(0, overflow);
  }
  function processStorage(n, result) {
    if (n === void 0) {
      n = 0;
    }
    if (result === void 0) {
      result = [];
    }
    if (n === availableSpace) return result;
    return processStorage(n + 1, [].concat(result, [storage > n ? 1 : 0]));
  }
  return {
    addItems: addItems,
    get storage() {
      return storage;
    },
    get available() {
      return availableSpace;
    },
    get isBusy() {
      return storage === availableSpace;
    },
    get result() {
      return processStorage();
    }
  };
}

function createDefaultSolution(_ref) {
  var groups = _ref.groups,
    response = _ref.response;
  var initialDistribution = parseInt(response / groups.length);
  var initialOverflow = response % groups.length;
  var distributionOverflow = 0;
  return groups.map(function (_ref2, idx) {
    var value = _ref2.value;
    var space = new GroupSpace(value);
    var baggage = idx === 0 ? initialDistribution + initialOverflow : initialDistribution + distributionOverflow;
    distributionOverflow = space.addItems(baggage);
    return space.result;
  });
}
function createDefaultSolution$1 (data) {
  return createDefaultSolution({
    groups: data.options,
    response: data.validation.valid_response.value
  });
}

function createSubtractSolution(data) {
  var options = data.options,
    validation = data.validation;
  var validResponse = validation.valid_response.value;
  var minuend = options[0].value;
  var subtracting = minuend - validResponse;
  var arrLength = new Array(minuend).fill({});
  return arrLength.reduce(function (acc, next, idx) {
    return [].concat(acc, [idx < subtracting ? 1 : 0]);
  }, []);
}

function createSnapshot$5(data) {
  var options = data.data.options;
  return _extends({}, data.data, importCommonValues$1(data), {
    countGroups: createCountGroups(options),
    defaultSolution: createSolution(data.data)
  });
}
function createSolution(data) {
  return data.operation === SUBTRACT ? [createSubtractSolution(data)] : createDefaultSolution$1(data);
}

function validateResponse(_ref) {
  var userResponse = _ref.userResponse,
    options = _ref.options;
  if (typeof userResponse === 'number') return [];
  return userResponse.reduce(function (acc, next, idx) {
    var maxOptionsInGroup = options[idx].value;
    var result = next.length > maxOptionsInGroup ? next.slice(0, maxOptionsInGroup) : incrementItems(maxOptionsInGroup, next);
    return [].concat(acc, [result]);
  }, []);
}
function incrementItems(count, list) {
  var rest = populate(count - list.length, function () {
    return 0;
  });
  return [].concat(list, rest);
}

var CountingQuestionStore = types$1.compose(QuestionBaseModel, types$1.model({
  countGroups: types$1.array(CountGroupModel),
  defaultSolution: types$1.array(types$1.array(types$1.number))
}).actions(function (state) {
  var normalizeSolution = function normalizeSolution(response) {
    if (Array.isArray(response)) return response;
    var data = produce(state.raw.data, function (draft) {
      draft.validation.valid_response.value = response;
    });
    return createSolution(data);
  };
  return {
    setResponse: function setResponse(_response) {
      var response = normalizeSolution(_response);
      if (!typeChecker(types$1.array(types$1.array(types$1.number)), response)) return false;
      state.countGroups.forEach(function (group, idx) {
        group.reset();
        var currentResponse = (response === null || response === void 0 ? void 0 : response[idx]) || [];
        group.applyResponse(currentResponse);
      });
    },
    reset: function reset() {
      state.baseReset();
      return state.countGroups.forEach(function (group) {
        return group.reset();
      });
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var userResponse = state.getUserResponse();
      var _rawData$data = rawData.data,
        options = _rawData$data.options,
        operation = _rawData$data.operation;
      var data = createSnapshot$5(rawData);
      var validationNeedUpdate = state.operation === operation;
      applySnapshot(state, data);
      if (validationNeedUpdate) {
        validateResponse({
          userResponse: userResponse,
          options: options
        }).forEach(function (response, idx) {
          return setTimeout(function () {
            state.countGroups[idx].applyResponse(response);
          }, 20);
        });
      }
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  return {
    get showResult() {
      return state.raw.data.showResult;
    },
    get operation() {
      return state.raw.data.operation;
    },
    get isHiddenResult() {
      return !state.showResult && !state.isEvaluated && !state.isSolutionMode;
    },
    get isSuccess() {
      return when()["case"](state.isSolutionMode, function () {
        return false;
      })["case"](!state.isEvaluated, function () {
        return false;
      }).resolve(state.getResults() === 1);
    },
    get isError() {
      return when()["case"](state.isSolutionMode, function () {
        return false;
      })["case"](!state.isEvaluated, function () {
        return false;
      }).resolve(state.getResults() === 0);
    },
    get allItems() {
      return state.countGroups.map(function (group) {
        return group.countItems.map(function (item) {
          return item;
        });
      }).flat();
    },
    get selectedItemList() {
      return state.allItems.filter(function (item) {
        return item.selected;
      });
    },
    get feedbackBySelection() {
      if (!state.isEvaluated) return [];
      var validResponse = state.validation.value;
      return state.selectedItemList.map(function (item, idx) {
        return {
          id: item.id,
          isSuccess: idx < validResponse
        };
      });
    },
    get areAllGroupsResponded() {
      return state.countGroups.reduce(function (acc, next) {
        return next.value === 0 ? false : acc;
      }, true);
    },
    get terms() {
      return state.countGroups.map(function (_ref) {
        var value = _ref.value;
        return value;
      });
    },
    get sumTerms() {
      return state.countGroups.reduce(function (acc, next) {
        return acc + next.value;
      }, 0);
    },
    createSnapshot: function createSnapshot(rawData) {
      return createSnapshot$5(rawData);
    },
    get minuend() {
      return state.countGroups[0].itemsLength;
    },
    get subtracting() {
      return state.countGroups[0].selectedItemsLength;
    },
    get subtractTerms() {
      return state.countGroups[0].value;
    },
    get resultTerm() {
      if (state.operation === SUBTRACT) {
        return state.isHiddenResult ? 0 : state.subtractTerms;
      }
      return state.isHiddenResult ? 0 : state.sumTerms;
    },
    getUserResponse: function getUserResponse() {
      var userResponse = state.countGroups.map(function (group) {
        return group.countItems.map(function (item) {
          return item.selected ? 1 : 0;
        });
      });
      return state.getRealUserResponse(userResponse);
    },
    getResults: function getResults() {
      if (!state.areAllGroupsResponded) return 0;
      var solution = state.validation.value;
      var responseValue = state.countGroups.reduce(function (acc, next) {
        return acc + next.value;
      }, 0);
      return solution === responseValue ? 1 : 0;
    },
    getSolutions: function getSolutions() {
      return state.getResults() === 1 ? state.getUserResponse() : getSnapshot(state.defaultSolution);
    }
  };
}));
function createStore$B(data) {
  var store = CountingQuestionStore.create(createSnapshot$5(data));
  return store;
}

var ItemModel$1 = types$1.model({
  value: types$1.number,
  src: types$1.string
}).actions(function (state) {
  return {
    setValue: function setValue(value) {
      state.value = parseInt(value);
      getParent(state, 2).updateNotifier();
    },
    setSrc: function setSrc(src) {
      state.src = src;
      getParent(state, 2).updateNotifier();
    }
  };
});

var defaultOperationData = {
  add: {
    options: [{
      value: 6,
      src: 'https://lemonade-assets.oneclick.es/fruits/manzana-1.png'
    }, {
      value: 6,
      src: 'https://lemonade-assets.oneclick.es/fruits/limon-1.png'
    }],
    solution: 6
  },
  count: {
    options: [{
      value: 10,
      src: 'https://lemonade-assets.oneclick.es/fruits/manzana-1.png'
    }],
    solution: 6
  },
  subtract: {
    options: [{
      value: 5,
      src: 'https://blueberry-assets.oneclick.es/M1_NyO_18a_2.svg'
    }],
    solution: 4
  }
};

var CountingEditorStore = types$1.compose(EditorBaseModel, types$1.model({
  operation: types$1.enumeration(operationList),
  options: types$1.array(ItemModel$1),
  showResult: types$1["boolean"],
  ui_style: BaseModel$1
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      onAction(state, function (_ref) {
        var name = _ref.name,
          args = _ref.args;
        if (name === 'updateSolution' && state.operation === SUBTRACT) {
          var originalSolutionLength = args[1][0].length;
          var selectedItems = args[1][0].reduce(function (acc, next) {
            return acc + parseInt(next);
          }, 0);
          var currentSolutionValue = originalSolutionLength - selectedItems;
          state.validation.setValue(populate(originalSolutionLength, function (idx) {
            return idx < currentSolutionValue ? 1 : 0;
          }));
        }
      }, true);
    },
    setOperationIndex: function setOperationIndex(idx) {
      state.changeOperation(operationList[idx]);
    },
    changeOperation: function changeOperation(operation) {
      if (operation === state.operation) return;
      if (!operationList.includes(operation)) return;
      var _defaultOperationData = defaultOperationData[operation],
        value = _defaultOperationData.value,
        options = _defaultOperationData.options;
      state.operation = operation;
      state.validation.setValue(value);
      state.options = options;
      state.updateNotifier();
    },
    setShowResult: function setShowResult(showResult) {
      state.showResult = showResult;
      state.updateNotifier();
    }
  };
}).views(function (state) {
  return {
    get operationIndex() {
      return operationList.findIndex(function (x) {
        return x === state.operation;
      });
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$w(rawData);
    },
    get output() {
      return exportCommonValues(state, {
        operation: state.operation,
        options: getSnapshot(state.options),
        showResult: state.showResult,
        ui_style: getSnapshot(state.ui_style),
        validation: getValidation(state.validation)
      });
    }
  };
}));
function getValidation(validation) {
  var sn = getSnapshot(validation);
  var _sn$valid_response = sn.valid_response,
    _sn$valid_response$va = _sn$valid_response.value,
    value = _sn$valid_response$va === void 0 ? 0 : _sn$valid_response$va,
    score = _sn$valid_response.score;
  return _extends({}, sn, {
    valid_response: {
      score: score,
      value: typeof value === 'number' ? value : value.flat().reduce(function (acc, next) {
        return acc + next;
      }, 0)
    }
  });
}
function _createSnapshot$w(data) {
  return _extends({}, data.data, importCommonValues$1(data));
}
function createStore$C(data) {
  var store = CountingEditorStore.create(_createSnapshot$w(data));
  return store;
}

var decimalTypes = {
  DECIMAL_0: 0,
  DECIMAL_1: 1,
  DECIMAL_2: 2,
  DECIMAL_3: 3,
  DECIMAL_4: 4,
  DECIMAL_5: 5,
  DECIMAL_6: 6
};
var EditorResponseDecimals = function EditorResponseDecimals(_ref) {
  var decimals = _ref.decimals,
    onChange = _ref.onChange,
    disabled = _ref.disabled;
  var _useState = useState(Object.keys(decimalTypes).map(function (key) {
      return translate('response_decimal_option_' + decimalTypes[key]);
    })),
    itemListDecimal = _useState[0];
  var selectedIndexDecimal = useMemo(function () {
    return Object.keys(decimalTypes).findIndex(function (key) {
      return decimalTypes[key] === decimals;
    });
  }, [decimals]);
  function onChangeDecimals(index) {
    if (decimalTypes && index >= 0) {
      var valueChange = decimalTypes[Object.keys(decimalTypes)[index]];
      onChange && onChange(valueChange);
    }
  }
  return /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('response_decimals_title'),
    subtitle: translate('response_decimals_subtitle'),
    selectedIndex: selectedIndexDecimal,
    onChange: onChangeDecimals,
    itemList: itemListDecimal,
    disabled: disabled
  });
};
EditorResponseDecimals.propTypes = {
  decimals: propTypes.number,
  disabled: propTypes.bool
};
EditorResponseDecimals.defaultProps = {
  decimals: 2,
  disabled: false
};

var EditorResponseExactOrEquivalent = function EditorResponseExactOrEquivalent(_ref) {
  var response = _ref.response;
  return /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('response_exact_or_equivalent_title'),
    subtitle: translate('response_exact_or_equivalent_subtitle'),
    selectedIndex: response.selectedIndex,
    onChange: function onChange(val) {
      return response.setMethodIndex(val);
    },
    itemList: response.methodList
  });
};
var EditorResponseExactOrEquivalent$1 = observer(EditorResponseExactOrEquivalent);

var EditorResponseIgnoreTrailingZeros = function EditorResponseIgnoreTrailingZeros(_ref) {
  var isChecked = _ref.isChecked,
    onChange = _ref.onChange,
    disabled = _ref.disabled;
  return /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('response_ignore_trailing_zeros_title'),
    subtitle: translate('response_ignore_trailing_zeros_subtitle'),
    isChecked: isChecked,
    onChange: onChange,
    disabled: disabled
  });
};
EditorResponseIgnoreTrailingZeros.propTypes = {};
EditorResponseIgnoreTrailingZeros.defaultProps = {};

var EditorResponse = function EditorResponse(_ref) {
  var response = _ref.response,
    title = _ref.title,
    removeResponse = _ref.removeResponse,
    showExactOrEquivalent = _ref.showExactOrEquivalent,
    showResponseDecimals = _ref.showResponseDecimals,
    showIgnoreTrailingZeros = _ref.showIgnoreTrailingZeros,
    keyboard = _ref.keyboard;
  var isMathField = keyboard.type === undefined || keyboard.type === keyboardTypes.SCIENTIFIC || keyboard.type === keyboardTypes.INTERMEDIATE || keyboard.type === keyboardTypes.FUNCTIONS;
  return /*#__PURE__*/React__default.createElement(Accordion$1, {
    title: title,
    isOpenInit: false
  }, /*#__PURE__*/React__default.createElement("div", null, showExactOrEquivalent && /*#__PURE__*/React__default.createElement(EditorResponseExactOrEquivalent$1, {
    response: response
  }), showExactOrEquivalent && /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: !isMathField
  }, /*#__PURE__*/React__default.createElement(InputKeyboard$2, {
    id: response.id,
    value: response.solution,
    setValue: function setValue(val) {
      return response.setSolution(val);
    },
    keyboardType: keyboard.type,
    selectedInput: keyboard.activeFieldId,
    showSuccess: false,
    showError: false,
    onFinish: keyboard.finish,
    onStart: keyboard.start,
    onWrite: function onWrite(val) {
      return response.setSolution(val);
    },
    isFloating: true,
    autoSize: false
  })), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: isMathField
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-math-field-wrapper"
  }, /*#__PURE__*/React__default.createElement(MathField$2, {
    text: response.solution,
    onChange: function onChange(val) {
      return response.setSolution(val);
    },
    customKeyboard: getCustomKeyboardMathField(keyboard)
  }))), /*#__PURE__*/React__default.createElement(Line1, null), showResponseDecimals && /*#__PURE__*/React__default.createElement(EditorResponseDecimals, {
    disabled: !(response.method && response.method === exactOrEquivalentTypes.EQUIVALENT),
    decimals: response.options.decimalPlaces,
    onChange: function onChange(val) {
      return response.options.setDecimalPlaces(val);
    }
  }), showIgnoreTrailingZeros && /*#__PURE__*/React__default.createElement(Line1, null), showIgnoreTrailingZeros && /*#__PURE__*/React__default.createElement(EditorResponseIgnoreTrailingZeros, {
    disabled: !(response.method && response.method === exactOrEquivalentTypes.EXACT),
    isChecked: response.options.ignoreTrailingZeros,
    onChange: function onChange(val) {
      return response.options.setIgnoreTrailingZeros(val);
    }
  }), showResponseDecimals && /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(ButtonInline, {
    icon: /*#__PURE__*/React__default.createElement(SvgTrash$1, {
      className: "lemo-icon"
    }),
    text: translate('response_result_button_delete'),
    color: colorsButton.red,
    onClick: function onClick() {
      return removeResponse();
    }
  })));
};
EditorResponse.propTypes = {};
EditorResponse.defaultProps = {
  showExactOrEquivalent: true,
  showResponseDecimals: true
};
var EditorResponse$1 = observer(EditorResponse);

var EditorResponses = function EditorResponses(_ref) {
  var store = _ref.store;
  return store.responses.map(function (response, idx) {
    var isKeyboardNumeric = store.ui_style.keyboard && hasData(store.ui_style.keyboard.type) && store.ui_style.keyboard.type === keyboards.numerical;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-editor-responses__response",
      key: response.id
    }, /*#__PURE__*/React__default.createElement(EditorResponse$1, {
      response: response,
      title: translate('editor_response_title_accordion') + ' ' + (idx + 1),
      showExactOrEquivalent: !isKeyboardNumeric,
      showResponseDecimals: !isKeyboardNumeric,
      showIgnoreTrailingZeros: !isKeyboardNumeric,
      removeResponse: response.destroy,
      keyboard: store.hasLemonadeKeyboard
    }));
  });
};
EditorResponses.propTypes = {};
EditorResponses.defaultProps = {};
var EditorResponses$1 = observer(EditorResponses);

var EditorQuestionClozeMathStore = function EditorQuestionClozeMathStore(_ref) {
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "paragraph",
    icon: /*#__PURE__*/React__default.createElement(SvgFormatListBulleted, null),
    titleBox: translate('Exercise'),
    helpText: translate('cloze_math_exercise_help'),
    classNameAdd: 'lemo-editor-question-cloze-math'
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement(TemplateExerciseMarkup$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorResponses$1, {
    store: store,
    onChangeResponses: store.setResponses
  }), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: store.hasLemonadeKeyboard
  }, /*#__PURE__*/React__default.createElement(LemonadeKeyboard$1, {
    type: store.ui_style.keyboard.type,
    keyboardStore: store.keyboard,
    isActive: store.keyboard.isActive,
    forceFloating: true,
    tabList: ['none']
  }))));
};
var EditorQuestionClozeMathStore$1 = observer(EditorQuestionClozeMathStore);

var _excluded$n = ["store", "changed", "type"];
var ClozeMathEditor = function ClozeMathEditor(props) {
  var _ref, _ref2;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$n);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    changedHandlerDebugger: false,
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setTemplate|addResponse|setResponses|setFeedback|setBackground|removeResponse|setValue|setStimulus|setSolution|setMethodIndex|setDecimalPlaces|destroy|setWithFeedback|setEvaluationType",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 0,
      haveFeedbackIndividual: true,
      showConfigFeedbacksIndividual: true
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 1,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref)
  }), /*#__PURE__*/React__default.createElement(EditorQuestionClozeMathStore$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    showSolutions: false,
    helpText: translate('exact_math_or_partial_match_or_manual_solutions_help'),
    evaluationTypes: [getEvaluationTypeOption(keysTranslateEvaluationTypes.EXACT_MATCH, keysTranslateSubtitleEvaluationTypes.EXACT_MATCH, validationModes.EXACT_MATCH), getEvaluationTypeOption(keysTranslateEvaluationTypes.PARTIAL_MATCH, keysTranslateSubtitleEvaluationTypes.PARTIAL_MATCH, validationModes.PARTIAL_MATCH_V2)]
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: [TYPES_CONFIG.CONFIG_NUMBER_KEYBOARD, TYPES_CONFIG.CONFIG_FIXED_KEYBOARD],
    listConfigParams: (_ref2 = {}, _ref2[TYPES_CONFIG.CONFIG_NUMBER_KEYBOARD] = {
      keyboardList: [{
        value: keyboards.numerical
      }, {
        value: keyboards.basic
      }, {
        value: keyboards.intermediate
      }, {
        value: keyboards.scientific
      }, {
        value: keyboards.roman
      }, {
        value: keyboards.functions
      }]
    }, _ref2)
  }));
};
var ClozeMathEditor$1 = observer(ClozeMathEditor);

function CircleIcon() {
  return /*#__PURE__*/React__default.createElement("svg", {
    className: "lemo-decoration-icon lemo-svg-circle-icon",
    viewBox: "0 0 70 70"
  }, /*#__PURE__*/React__default.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 33
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 32
  }));
}

function SlashIcon() {
  return /*#__PURE__*/React__default.createElement("svg", {
    className: "lemo-decoration-icon lemo-svg-slash-icon",
    viewBox: "0 0 44 47"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M2.06113 45.5398C0.478215 44.2052 0.348525 41.8122 1.77793 40.3143L39.0629 1.2446C40.0823 0.176382 41.7812 0.156528 42.8253 1.20064C43.8098 2.18516 43.8564 3.7664 42.9316 4.80723L7.06109 45.1794C5.7677 46.6351 3.54988 46.795 2.06113 45.5398Z"
  }));
}

var ADD$2 = operationTypes.ADD,
  SUBTRACTION$1 = operationTypes.SUBTRACTION,
  COUNT$2 = operationTypes.COUNT;
function DecorationIcon(_ref) {
  var type = _ref.type,
    selected = _ref.selected;
  var eq = function eq(current) {
    return type === current;
  };
  return when()["case"](!selected, function () {
    return null;
  })["case"](eq(ADD$2), function () {
    return /*#__PURE__*/React__default.createElement(CircleIcon, null);
  })["case"](eq(COUNT$2), function () {
    return /*#__PURE__*/React__default.createElement(CircleIcon, null);
  })["case"](eq(SUBTRACTION$1), function () {
    return /*#__PURE__*/React__default.createElement(SlashIcon, null);
  }).resolve(null);
}
var DecorationIcon$1 = observer(DecorationIcon);

function CountingItem(_ref) {
  var item = _ref.item,
    src = _ref.src;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-counting-item', item.itemClassName, {
      'lemo-selected': item.selected,
      'lemo-success': item.isSuccess,
      'lemo-error': item.isError
    }),
    onClick: function onClick() {
      return item.toggle();
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: src,
    alt: ""
  }), /*#__PURE__*/React__default.createElement(DecorationIcon$1, {
    type: item.operation,
    selected: item.selected
  }));
}
var CountingItem$1 = observer(CountingItem);

function CountingGroup(_ref) {
  var group = _ref.group,
    isSingle = _ref.isSingle,
    withBasePath = _ref.withBasePath;
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "countingGroup",
    className: cn$1('lemo-counting-group', 'lemo-box-light', {
      'lemo-single-group': isSingle
    })
  }, group.countItems.map(function (item) {
    return /*#__PURE__*/React__default.createElement(CountingItem$1, {
      key: item.id,
      item: item,
      src: withBasePath ? withBasePath(group.src) : group.src
    });
  }));
}
var CountingGroup$1 = observer(CountingGroup);

function Term(_ref) {
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? 0 : _ref$value,
    isSuccess = _ref.isSuccess,
    isError = _ref.isError,
    _ref$showZero = _ref.showZero,
    showZero = _ref$showZero === void 0 ? false : _ref$showZero,
    _ref$showZeroWhenComp = _ref.showZeroWhenComplete,
    showZeroWhenComplete = _ref$showZeroWhenComp === void 0 ? false : _ref$showZeroWhenComp;
  var isEmpty = value === 0 || value.length === 0;
  var isCompleted = isSuccess || isError;
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "term",
    className: cn$1('lemo-term', {
      'lemo-is-empty': isEmpty,
      'lemo-success': isSuccess,
      'lemo-error': isError,
      'lemo-show-zero': isCompleted && showZeroWhenComplete || showZero
    })
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-term-value"
  }, value));
}
var Term$1 = observer(Term);

function Sign(_ref) {
  var symbol = _ref.symbol;
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "sign",
    className: "lemo-sign"
  }, /*#__PURE__*/React__default.createElement("span", null, symbol));
}

function Operation(_ref) {
  var _ref$terms = _ref.terms,
    terms = _ref$terms === void 0 ? [] : _ref$terms,
    result = _ref.result,
    isSuccess = _ref.isSuccess,
    isError = _ref.isError;
  var OperationComponents = useMemo(function () {
    return terms.reduce(function (acc, next, idx, arr) {
      var TermComponent = /*#__PURE__*/React__default.createElement(Term$1, {
        key: "term_" + idx,
        value: next
      });
      var PlusSign = /*#__PURE__*/React__default.createElement(Sign, {
        key: "plus_sing_" + idx,
        symbol: '+'
      });
      var EqualSign = /*#__PURE__*/React__default.createElement(Sign, {
        key: "equal_sing_" + idx,
        symbol: '='
      });
      if (idx === arr.length) return [].concat(acc, [TermComponent]);
      if (idx === arr.length - 1) return [].concat(acc, [TermComponent, EqualSign]);
      return [].concat(acc, [TermComponent, PlusSign]);
    }, []);
  }, [terms]);
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "operation",
    className: cn$1('lemo-operation', 'lemo-box-light', {
      'lemo-success': isSuccess,
      'lemo-error': isError
    })
  }, OperationComponents, /*#__PURE__*/React__default.createElement(Term$1, {
    key: 'resultTerm',
    value: result,
    isSuccess: isSuccess,
    isError: isError
  }));
}
var Operation$1 = observer(Operation);

function CountingAddQuestion(_ref) {
  var store = _ref.store;
  var isSingleGroup = store.countGroups.length === 1;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-operation-container lemo-counting-add-question"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-counting-groups"
  }, store.countGroups.map(function (group) {
    return /*#__PURE__*/React__default.createElement(CountingGroup$1, {
      key: group.id,
      group: group,
      isSingle: isSingleGroup,
      withBasePath: store.withBasePath
    });
  })), /*#__PURE__*/React__default.createElement(Operation$1, {
    terms: store.terms,
    result: store.resultTerm,
    isSuccess: store.isSuccess,
    isError: store.isError
  }));
}
var CountingAddQuestion$1 = observer(CountingAddQuestion);

function Operation$2(_ref) {
  var minuend = _ref.minuend,
    subtracting = _ref.subtracting,
    result = _ref.result,
    isSuccess = _ref.isSuccess,
    isError = _ref.isError,
    showResult = _ref.showResult;
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "operation",
    className: cn$1('lemo-operation', {
      'lemo-success': isSuccess,
      'lemo-error': isError
    })
  }, /*#__PURE__*/React__default.createElement(Term$1, {
    key: 'minuend',
    value: minuend
  }), /*#__PURE__*/React__default.createElement(Sign, {
    key: 'minus_sing',
    symbol: '−'
  }), /*#__PURE__*/React__default.createElement(Term$1, {
    key: 'subtracting',
    value: subtracting
  }), /*#__PURE__*/React__default.createElement(Sign, {
    key: 'equal_sing',
    symbol: '='
  }), /*#__PURE__*/React__default.createElement(Term$1, {
    key: 'resultTerm',
    value: result,
    isSuccess: isSuccess,
    isError: isError,
    showZero: showResult,
    showZeroWhenComplete: true
  }));
}
var Operation$3 = observer(Operation$2);

function CountingSubtractQuestion(_ref) {
  var store = _ref.store;
  var group = store.countGroups[0];
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-operation-container lemo-counting-subtract-question"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-counting-groups"
  }, /*#__PURE__*/React__default.createElement(CountingGroup$1, {
    key: group.id,
    group: group,
    isSingle: true,
    withBasePath: store.withBasePath
  })), /*#__PURE__*/React__default.createElement(Operation$3, {
    minuend: store.minuend,
    subtracting: store.subtracting,
    result: store.resultTerm,
    isSuccess: store.isSuccess,
    isError: store.isError,
    showResult: store.showResult
  }));
}
var CountingSubtractQuestion$1 = observer(CountingSubtractQuestion);

function CountingCountQuestion(_ref) {
  var store = _ref.store;
  var isSingleGroup = store.countGroups.length === 1;
  return (
    /*#__PURE__*/
    React__default.createElement("div", {
      className: cn$1('lemo-operation-container lemo-counting-count-question', {
        'lemo-show-solution': store.showSolution
      })
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-counting-groups"
    }, store.countGroups.map(function (group) {
      return /*#__PURE__*/React__default.createElement(CountingGroup$1, {
        key: group.id,
        group: group,
        isSingle: isSingleGroup,
        withBasePath: store.withBasePath
      });
    })))
  );
}
var CountingCountQuestion$1 = observer(CountingCountQuestion);

function CountingQuestion(props) {
  var store = props.store,
    _props$solutionsMode = props.solutionsMode,
    solutionsMode = _props$solutionsMode === void 0 ? false : _props$solutionsMode;
  var changedHandlers = /toggle|setSelected|applyResponse/;
  var eq = function eq(type) {
    return store.operation === type;
  };
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', {
      'lemo-disabled': !solutionsMode && store.disabled,
      'lemo-solutions-mode': solutionsMode
    })
  }, when()["case"](eq(operationTypes.ADD), function () {
    return /*#__PURE__*/React__default.createElement(CountingAddQuestion$1, {
      store: store,
      solutionsMode: solutionsMode
    });
  })["case"](eq(operationTypes.SUBTRACTION), function () {
    return /*#__PURE__*/React__default.createElement(CountingSubtractQuestion$1, {
      store: store
    });
  })["case"](eq(operationTypes.COUNT), function () {
    return /*#__PURE__*/React__default.createElement(CountingCountQuestion$1, {
      store: store
    });
  }).resolve(function () {
    return null;
  })));
}
var CountingQuestion$1 = observer(CountingQuestion);

function RenderFraction(_ref) {
  var numerator = _ref.numerator,
    denominator = _ref.denominator;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-render-fraction"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-fraction-value",
    dangerouslySetInnerHTML: {
      __html: numerator
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-fraction-line"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-fraction-value"
  }, denominator));
}
var RenderFraction$1 = observer(RenderFraction);

function Label(_ref) {
  var value = _ref.value,
    showLabel = _ref.showLabel,
    mode = _ref.mode,
    isFirst = _ref.isFirst,
    isLast = _ref.isLast,
    segmentWidth = _ref.segmentWidth,
    denominator = _ref.denominator,
    showIntegerValues = _ref.showIntegerValues,
    className = _ref.className;
  var root = useRef(null);
  var _useState = useState(false),
    isOverflow = _useState[0],
    setIsOverflow = _useState[1];
  var isIntValue = showIntegerValues && value % denominator === 0;
  var isFractionValue = mode === FRACTION && value !== 0 && !isIntValue;
  useEffect(function () {
    if (isFirst || isLast) {
      setIsOverflow(root.current.offsetWidth > segmentWidth);
    }
  }, [segmentWidth]);
  return /*#__PURE__*/React__default.createElement("div", {
    ref: root,
    "data-testid": 'label',
    className: cn$1('lemo-number-line-label', className, {
      'lemo-show': showLabel,
      'lemo-is-first': isFirst && isOverflow,
      'lemo-is-last': isLast && isOverflow
    })
  }, isFractionValue ? /*#__PURE__*/React__default.createElement(RenderFraction$1, {
    numerator: value,
    denominator: denominator
  }) : /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    className: "lemo-label",
    content: isIntValue ? value / denominator : value
  }));
}
var Label$1 = observer(Label);

var SimpleTooltipWrapper = function SimpleTooltipWrapper(_ref) {
  var text = _ref.text,
    children = _ref.children;
  var _useState = useState(uuid()),
    guid = _useState[0];
  var withTooltipProps = text ? {
    'data-tooltip-content': text,
    'data-tooltip-id': guid
  } : {};
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-simple-tooltip-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", withTooltipProps, children), text && /*#__PURE__*/React__default.createElement(Tooltip$1, {
    effect: "solid",
    id: guid,
    multiline: true
  }));
};

function Labels(_ref) {
  var labels = _ref.labels,
    mode = _ref.mode,
    denominator = _ref.denominator,
    showIntegerValues = _ref.showIntegerValues;
  var itemsLength = labels.length;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-number-line-labels",
    "data-testid": "labels"
  }, /*#__PURE__*/React__default.createElement(SimpleTooltipWrapper, {
    text: translate('move_bottom_handle')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-flex-center lemo-flex-align-center lemo-flex-wrap"
  }, labels.map(function (label, idx) {
    return /*#__PURE__*/React__default.createElement(Label$1, {
      key: "label_" + idx,
      className: "lemo-h1-medium",
      value: label,
      showLabel: true,
      mode: mode,
      denominator: denominator,
      showIntegerValues: showIntegerValues,
      itemsLength: itemsLength
    });
  }))));
}

function Segment(_ref) {
  var segmentSize = _ref.segmentSize,
    segment = _ref.segment,
    isSelecting = _ref.isSelecting,
    isDragging = _ref.isDragging,
    children = _ref.children,
    showLabel = _ref.showLabel;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-segment', {
      'lemo-selected': segment.isSelected,
      'lemo-is-used': segment.isUsed,
      'lemo-success': segment.isSuccess,
      'lemo-error': segment.isWrong,
      'lemo-selecting': isSelecting,
      'lemo-dragging': isDragging
    }),
    "data-index": segment.index,
    style: {
      width: segmentSize + "%"
    },
    onClick: segment.moveTo,
    onTouchStart: segment.moveTo,
    onMouseEnter: segment.dragTo,
    onMouseUp: segment.stopDrag
  }, children, /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-vertical-line', {
      'lemo-with-label': showLabel,
      'lemo-label-visible': showLabel
    })
  }));
}
var Segment$1 = observer(Segment);

function useSegmentsVisibility(_ref) {
  var segments = _ref.segments,
    isSmallScreen = _ref.isSmallScreen;
  var segmentsLength = segments.length;
  var isFirst = function isFirst(idx) {
    return idx === 0;
  };
  var isLast = function isLast(idx) {
    return idx === segmentsLength - 1;
  };
  var isLabelVisible = function isLabelVisible(segment, idx) {
    return isSmallScreen ? isFirst(idx) || isLast(idx) : segment.showLabel;
  };
  return {
    isLabelVisible: isLabelVisible,
    isFirst: isFirst,
    isLast: isLast
  };
}

function Line(_ref) {
  var segments = _ref.segments,
    segmentSize = _ref.segmentSize,
    segmentWidth = _ref.segmentWidth,
    isSelecting = _ref.isSelecting,
    isDragging = _ref.isDragging,
    mode = _ref.mode,
    isSmallScreen = _ref.isSmallScreen,
    showIntegerValues = _ref.showIntegerValues;
  var _useSegmentsVisibilit = useSegmentsVisibility({
      segments: segments,
      isSmallScreen: isSmallScreen
    }),
    isFirst = _useSegmentsVisibilit.isFirst,
    isLast = _useSegmentsVisibilit.isLast;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-number-line__line"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-horizontal-line"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-segment-list",
    draggable: false
  }, segments.map(function (segment, idx) {
    var labelVisibility = segment.showLabel;
    return /*#__PURE__*/React__default.createElement(Segment$1, {
      key: segment.id,
      segment: segment,
      segmentSize: segmentSize,
      isSelecting: isSelecting,
      isDragging: isDragging,
      showLabel: labelVisibility
    }, /*#__PURE__*/React__default.createElement(Label$1, {
      className: "lemo-text-body-m-medium",
      value: segment.value,
      denominator: segment.denominator,
      showLabel: labelVisibility,
      segmentWidth: segmentWidth,
      isFirst: isFirst(idx),
      isLast: isLast(idx),
      showIntegerValues: showIntegerValues,
      mode: mode
    }));
  })));
}
var Line$1 = observer(Line);

var handAnimationImage = 'https://lemonade-assets-prod-content.s3.eu-central-1.amazonaws.com/hand-animation.gif';
function HandAnimation(_ref) {
  var _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-hand-animation",
    "data-testid": "handAnimation",
    style: style
  }, /*#__PURE__*/React__default.createElement("img", {
    src: handAnimationImage,
    alt: ""
  }));
}

function useVectorDrag(_ref) {
  var clickEnd = _ref.clickEnd,
    clickStart = _ref.clickStart,
    updatePosition = _ref.updatePosition;
  var _useState = useState(false),
    isDragging = _useState[0],
    setIsDragging = _useState[1];
  function handleUp(e) {
    clickEnd(e);
    document.removeEventListener('mouseup', handleUp);
    setIsDragging(false);
  }
  function handleDown(e) {
    clickStart(e);
    document.addEventListener('mouseup', handleUp, false);
    setIsDragging(true);
  }
  function handleMove(e) {
    if (!isDragging) return;
    var coordsHolder = e.touches ? e.touches[0] : e;
    var coords = {
      x: coordsHolder.clientX,
      y: coordsHolder.clientY
    };
    var target = document.elementFromPoint(coords.x, coords.y);
    updatePosition({
      e: e,
      target: target,
      coords: coords
    });
  }
  return {
    handleDown: handleDown,
    handleUp: handleUp,
    handleMove: handleMove,
    isDragging: isDragging
  };
}

function Bullet(_ref) {
  var bullet = _ref.bullet,
    segmentWidth = _ref.segmentWidth,
    handleOnTouchEnter = _ref.handleOnTouchEnter,
    isTouch = _ref.isTouch,
    showHandAnimation = _ref.showHandAnimation;
  var bulletWidth = 37;
  var xPositionFix = Math.max(0, (bulletWidth - segmentWidth) / 2);
  var _useVectorDrag = useVectorDrag({
      clickEnd: bullet.clickEnd,
      clickStart: bullet.clickStart,
      updatePosition: updatePosition
    }),
    handleDown = _useVectorDrag.handleDown,
    handleUp = _useVectorDrag.handleUp,
    handleMove = _useVectorDrag.handleMove;
  var bulletStyle = {
    width: segmentWidth,
    transform: "translate(" + (bullet.position * segmentWidth - xPositionFix) + "px)"
  };
  function updatePosition(_ref2) {
    var _target$classList, _target$classList$con;
    var target = _ref2.target;
    (target === null || target === void 0 ? void 0 : (_target$classList = target.classList) === null || _target$classList === void 0 ? void 0 : (_target$classList$con = _target$classList.contains) === null || _target$classList$con === void 0 ? void 0 : _target$classList$con.call(_target$classList, 'lemo-segment')) && handleOnTouchEnter(target.dataset.index);
  }
  return isAlive(bullet) ? /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-number-line__bullet', bullet.groupedPositionClass, {
      'lemo-selected': bullet.isSelected,
      'lemo-disabled': bullet.disabled,
      'lemo-success': bullet.isSuccess,
      'lemo-disabled-while-dragging': bullet.disabledWhileDragging,
      'lemo-first-interaction-done': bullet.isModified,
      'lemo-is-touch': isTouch,
      'lemo-error': bullet.isWrong
    }),
    style: bulletStyle
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-bullet",
    onMouseDown: !isTouch ? handleDown : null,
    onTouchStart: handleDown,
    onMouseUp: !isTouch ? handleUp : null,
    onTouchEnd: handleUp,
    onTouchMove: handleMove,
    draggable: false
  }, /*#__PURE__*/React__default.createElement(SvgRangeHandlerMobile, {
    className: "lemo-tracker"
  }), showHandAnimation && bullet.index === 0 && /*#__PURE__*/React__default.createElement(HandAnimation, null), /*#__PURE__*/React__default.createElement(ShowIndex, {
    visible: false,
    index: bullet.index
  }))) : null;
}
function ShowIndex(_ref3) {
  var visible = _ref3.visible,
    index = _ref3.index;
  return visible ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: 'absolute',
      top: 15,
      left: 0,
      right: 0,
      margin: 'auto',
      textAlign: 'center',
      color: 'white',
      pointerEvents: 'none'
    }
  }, index) : null;
}
var Bullet$1 = observer(Bullet);

var SMALL_SCREEN_SIZE = 500;
function useLineInitialization(lineWrapper, store, solutionsMode) {
  var _useState = useState(false),
    isSmallScreen = _useState[0],
    setIsSmallScreen = _useState[1];
  var _useState2 = useState(0),
    segmentWidth = _useState2[0],
    setSegmentWidth = _useState2[1];
  var updateSegmentSize = function updateSegmentSize() {
    var lineWidth = lineWrapper.current.clientWidth;
    var clientWidthWithMargins = lineWidth * 96 / 100;
    setSegmentWidth(clientWidthWithMargins / store.divisions);
  };
  var checkScreenSize = function checkScreenSize(w) {
    setIsSmallScreen(w < SMALL_SCREEN_SIZE);
  };
  useResizeHandler2(lineWrapper, function (_ref) {
    var w = _ref.w;
    checkScreenSize(w);
    updateSegmentSize();
  });
  useEffect(function () {
    updateSegmentSize();
  }, [store.divisions]);
  useEffect(function () {
    var tracker = noop;
    if (!solutionsMode) {
      tracker = onAction(store, function (_ref2) {
        var name = _ref2.name;
        if (name === 'hydrateQuestionPreview') {
          store.selectNextBulletAvailable();
        }
      }, true);
    }
    return function () {
      return tracker();
    };
  }, [store.bullets.length]);
  return {
    isSmallScreen: isSmallScreen,
    segmentWidth: segmentWidth
  };
}

var isTouch$1 = isTouchDevice();
function NumberLineQuestion(props) {
  var store = props.store,
    _props$solutionsMode = props.solutionsMode,
    solutionsMode = _props$solutionsMode === void 0 ? false : _props$solutionsMode;
  var lineWrapper = useRef(null);
  var changedHandlers = /reset|clickEnd|clickStart|stopDrag|updateValidationFromSolutions/;
  var _useLineInitializatio = useLineInitialization(lineWrapper, store, solutionsMode),
    isSmallScreen = _useLineInitializatio.isSmallScreen,
    segmentWidth = _useLineInitializatio.segmentWidth;
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', {
      'lemo-solutions-mode': solutionsMode,
      'lemo-success': store.isSuccess,
      'lemo-error': store.isError,
      'lemo-disabled': store.disabled,
      'lemo-dragging': store.isDragging
    })
  }, store.labelsVisibility ? /*#__PURE__*/React__default.createElement(Labels, {
    labels: store.labels,
    mode: store.mode,
    denominator: store.denominator,
    showIntegerValues: store.showIntegerValues
  }) : /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: 100
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: lineWrapper,
    className: "lemo-number-line-wrapper"
  }, /*#__PURE__*/React__default.createElement(Line$1, {
    segments: store.segments,
    segmentSize: store.segmentSize,
    segmentWidth: segmentWidth,
    isSelecting: store.selectedBullet,
    isDragging: store.isDragging,
    mode: store.mode,
    isSmallScreen: isSmallScreen,
    showIntegerValues: store.showIntegerValues
  }), store.bulletList.map(function (bullet) {
    return /*#__PURE__*/React__default.createElement(Bullet$1, {
      key: bullet.id,
      bullet: bullet,
      segmentWidth: segmentWidth,
      handleOnTouchEnter: function handleOnTouchEnter(n) {
        return store.dragTo(parseInt(n));
      },
      isTouch: isTouch$1,
      showHandAnimation: store.showHandAnimation
    });
  }))));
}
var NumberLineQuestion$1 = observer(NumberLineQuestion);

var BulletModel = types$1.model('Bullet', {
  id: types$1.optional(types$1.identifier, function () {
    return uuid();
  }),
  position: types$1.optional(types$1.number, 0),
  modified: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  var parent = getParent(state, 2);
  var updateNotifier = debounce(function () {
    state.callUpdateNotifier();
  });
  return {
    callUpdateNotifier: function callUpdateNotifier() {
      parent.updateNotifier();
    },
    moveTo: function moveTo(position) {
      state.position = position;
      state.setModified(true);
      updateNotifier();
    },
    reset: function reset() {
      state.moveTo(0);
      state.setModified(false);
    },
    clickStart: function clickStart() {
      parent.selectBullet(state.id);
    },
    exitPress: function exitPress() {
      parent.exitPress();
    },
    clickEnd: function clickEnd() {
      setTimeout(function () {
        return state.exitPress();
      }, 100);
    },
    setModified: function setModified(bool) {
      state.modified = bool;
    }
  };
}).views(function (state) {
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get groupedPositionClass() {
      var groupedValues = getParent(state, 2).groupedValues[state.position];
      var currentPosition = groupedValues.indexOf(state.index);
      if (groupedValues.length === 1) return '';
      return currentPosition > 0 ? "lemo-grouped-position_" + (currentPosition + 1) : '';
    },
    get value() {
      var parent = getParent(state, 2);
      var idx = Math.max(state.position, 0);
      return parent.segments[idx].value;
    },
    get disabledWhileDragging() {
      return getParent(state, 2).isDragging && !state.isSelected;
    },
    get isSelected() {
      var parent = getParent(state, 2);
      return parent.selectedBullet === state.id;
    },
    get isDisabled() {
      var parent = getParent(state, 2);
      return parent.isPressing && !state.isSelected;
    },
    get isValid() {
      var parent = getParent(state, 2);
      return parent.solution.value.find(function (_ref) {
        var position = _ref.position;
        return position === state.value;
      });
    },
    get isModified() {
      return state.modified || parent.isEvaluated;
    },
    get feedbackResult() {
      var parent = getParent(state, 2);
      try {
        var evaluationReady = parent.isEvaluated && !parent.isSolutionMode;
        return when()["case"](!evaluationReady, function () {
          return feedback.NOT_EVALUATED;
        })["case"](state.isValid, function () {
          return feedback.RIGHT;
        })["case"](!state.isValid, function () {
          return feedback.WRONG;
        }).resolve();
      } catch (e) {
        return feedback.NOT_EVALUATED;
      }
    },
    get isWrong() {
      return state.feedbackResult === feedback.WRONG;
    },
    get isSuccess() {
      return state.feedbackResult === feedback.RIGHT;
    }
  };
});

function customGetClosestSolutionModel$1() {
  function getValidationResult(userResponse, solution, result) {
    if (result === void 0) {
      result = [];
    }
    var idx = result.length;
    if (idx >= userResponse.length) return result;
    var matchResponseIndex = solution.findIndex(function (_ref) {
      var position = _ref.position;
      return position === userResponse[idx].position;
    });
    return matchResponseIndex > -1 ? getValidationResult(userResponse, rmItem(matchResponseIndex, solution), [].concat(result, [true])) : getValidationResult(userResponse, solution, [].concat(result, [false]));
  }
  return getClosestSolutionModel().views(function (state) {
    return {
      checkSolution: function checkSolution(solution) {
        var validationResult = getValidationResult(state.getUserResponse(), solution);
        var initialValue = {
          hits: 0,
          failures: 0,
          notAnswered: 0
        };
        return validationResult.reduce(function (acc, result) {
          return result ? Object.assign(acc, {
            hits: acc.hits + 1
          }) : Object.assign(acc, {
            failures: acc.failures + 1
          });
        }, initialValue);
      }
    };
  });
}

var SegmentModel = types$1.model('Segment', {
  id: types$1.optional(types$1.string, function () {
    return uuid();
  }),
  value: types$1.union(types$1.number, types$1.string),
  showLabel: types$1["boolean"]
}).actions(function (state) {
  var parent = getParent(state, 2);
  return {
    moveTo: function moveTo() {
      parent.moveTo(state.index);
    },
    dragTo: function dragTo() {
      parent.dragTo(state.index);
    },
    stopDrag: function stopDrag() {
      parent.stopDrag();
    }
  };
}).views(function (state) {
  var parent = getParent(state, 2);
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get denominator() {
      return getParent(state, 2).line.denominator;
    },
    get label() {
      return isAlive(state) ? state.value : '';
    },
    get isValid() {
      if (!isAlive(state)) return false;
      return parent.solution.value.find(function (_ref) {
        var position = _ref.position;
        return position === state.value;
      });
    },
    get isUsed() {
      if (!isAlive(state)) return false;
      return parent.userResponse.find(function (val) {
        return val === state.value;
      }) !== undefined;
    },
    get isSelected() {
      if (!isAlive(state)) return false;
      var currentPosition = getParent(state, 2).currentPosition;
      return currentPosition === state.index && state.isUsed;
    },
    get type() {
      return getType(state);
    },
    get feedbackResult() {
      try {
        var isSegment = getType(state).name === 'Segment';
        var evaluationReady = parent.isEvaluated && !parent.isSolutionMode;
        return when()["case"](!evaluationReady, function () {
          return feedback.NOT_EVALUATED;
        })["case"](isSegment && !state.isUsed, function () {
          return feedback.NOT_EVALUATED;
        })["case"](state.isValid, function () {
          return feedback.RIGHT;
        })["case"](!state.isValid, function () {
          return feedback.WRONG;
        }).resolve();
      } catch (e) {
        return feedback.NOT_EVALUATED;
      }
    },
    get isWrong() {
      return state.feedbackResult === feedback.WRONG;
    },
    get isSuccess() {
      return state.feedbackResult === feedback.RIGHT;
    }
  };
});

function getNumberLineBaseModel(_createSnapshot, bulletModel) {
  if (bulletModel === void 0) {
    bulletModel = BulletModel;
  }
  return types$1.compose(QuestionBaseModel, customGetClosestSolutionModel$1(), withValidationModes, withShowSolutions, types$1.model({
    bullets: types$1.array(bulletModel),
    selectedBullet: types$1.maybe(types$1.string),
    isPressing: types$1.optional(types$1["boolean"], false),
    isDragging: types$1.optional(types$1["boolean"], false),
    segments: types$1.array(SegmentModel)
  }).actions(function (state) {
    return {
      afterCreate: function afterCreate() {
        state.selectNextBulletAvailable();
      },
      selectNextBulletAvailable: function selectNextBulletAvailable() {
        var _state$bulletAvailabl;
        state.selectBullet((_state$bulletAvailabl = state.bulletAvailable) === null || _state$bulletAvailabl === void 0 ? void 0 : _state$bulletAvailabl.id);
        state.isDragging = false;
        state.isPressing = false;
      },
      selectBullet: function selectBullet(id) {
        state.selectedBullet = id;
        state.isPressing = true;
      },
      exitPress: function exitPress() {
        state.isPressing = false;
        if (state.isDragging) {
          state.exitInteraction();
        }
      },
      stopDrag: function stopDrag() {
        state.isPressing = false;
      },
      exitInteraction: function exitInteraction() {
        state.selectBullet(undefined);
        state.selectNextBulletAvailable();
      },
      moveTo: function moveTo(position) {
        if (state.selectedBullet) {
          state.currentBullet.moveTo(position);
          state.exitInteraction();
        }
      },
      dragTo: function dragTo(position) {
        if (!state.isPressing) return false;
        if (!state.selectedBullet) return false;
        if (state.selectedBullet.position === position) return false;
        state.isDragging = true;
        state.currentBullet.moveTo(position);
      },
      reset: function reset() {
        state.baseReset();
        state.bullets.forEach(function (bullet) {
          return bullet.reset();
        });
        state.selectNextBulletAvailable();
      },
      afterCheckAnswers: function afterCheckAnswers() {
        state.bullets.forEach(function (bullet) {
          return bullet.setModified(true);
        });
      },
      setResponse: function setResponse(response, force) {
        if (force === void 0) {
          force = false;
        }
        if (!typeChecker(types$1.array(ResponseModel$6), response)) return false;
        if (!force && interruptIfSolutionsMode(state)) return false;
        state.bullets.forEach(function (bullet, idx) {
          if (response.length > idx) {
            var bulletValue = response[idx].position;
            var bulletPosition = state.segments.findIndex(function (_ref) {
              var value = _ref.value;
              return value === bulletValue;
            });
            return bullet.moveTo(Math.max(bulletPosition, 0));
          }
        });
      },
      updateValidationFromSolutions: function updateValidationFromSolutions() {},
      hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
        var data = _createSnapshot(rawData);
        var newData = produce(data, function (draft) {
          draft.bullets = rawData.data.points.map(function (bullet, idx) {
            var currentPosition = state.bullets.length > idx ? state.bullets[idx].position : 0;
            return {
              position: Math.min(currentPosition, data.line.divisions - 1),
              modified: true
            };
          });
          draft.validation.valid_response.value = draft.bullets.map(function (bullet) {
            return data.segments[bullet.position].value;
          });
        });
        state.raw = rawData;
        applySnapshot(state, newData);
        state.bullets.forEach(function (bullet) {
          return bullet.reset();
        });
        setTimeout(function () {
          state.updateValidationFromSolutions();
        }, 110);
        return new Promise(function (resolve) {
          return setTimeout(resolve, 100);
        });
      }
    };
  }).views(function (state) {
    return {
      get showHandAnimation() {
        return !state.bullets.find(function (b) {
          return b.isModified;
        });
      },
      get bulletAvailable() {
        return state.bullets.find(function (b) {
          return !b.isModified;
        });
      },
      get bulletList() {
        return state.bullets.reduce(function (acc, next) {
          return [next].concat(acc);
        }, []);
      },
      get groupedValues() {
        return state.bullets.reduce(function (acc, next, index) {
          var position = next.position;
          if (!acc[position]) {
            acc[position] = [];
          }
          next.isSelected ? acc[position].unshift(index) : acc[position].push(index);
          return acc;
        }, []);
      },
      get currentPosition() {
        var currentBullet = state.bullets.find(function (_ref2) {
          var id = _ref2.id;
          return state.selectedBullet === id;
        });
        return currentBullet === null || currentBullet === void 0 ? void 0 : currentBullet.position;
      },
      get divisions() {
        return state.raw.data.line.divisions;
      },
      get currentBullet() {
        return state.selectedBullet ? state.bullets.find(function (_ref3) {
          var id = _ref3.id;
          return state.selectedBullet === id;
        }) : undefined;
      },
      get line() {
        return state.raw.data.line;
      },
      get segmentSize() {
        return 96 / state.line.divisions;
      },
      get mode() {
        var _state$raw$data;
        return ((_state$raw$data = state.raw.data) === null || _state$raw$data === void 0 ? void 0 : _state$raw$data.mode) || NUMBER;
      },
      get denominator() {
        return state.raw.data.line.denominator;
      },
      get showIntegerValues() {
        var _state$raw$data2;
        return ((_state$raw$data2 = state.raw.data) === null || _state$raw$data2 === void 0 ? void 0 : _state$raw$data2.show_integer_values) === true;
      },
      get labels() {
        return state.raw.data.points;
      },
      get labelsVisibility() {
        return !state.ui_style.hide_labels;
      },
      get userResponse() {
        return state.bullets.map(function (_ref4) {
          var value = _ref4.value;
          return value;
        }).sort(function (a, b) {
          return a - b;
        });
      },
      get selectedBulletIndex() {
        return state.bullets.findIndex(function (_ref5) {
          var id = _ref5.id;
          return id === state.selectedBullet;
        });
      },
      getUserResponse: function getUserResponse() {
        return state.userResponse.map(function (position) {
          return {
            position: position
          };
        });
      },
      createSnapshot: function createSnapshot(rawData) {
        return _createSnapshot(rawData);
      }
    };
  }));
}
var ResponseModel$6 = types$1.model({
  position: types$1.union(types$1.number, types$1.string)
});
function interruptIfSolutionsMode(state) {
  if (!state.isSolutionMode) return false;
  if (state.bullets.length === 0) return false;
  var bulletsPosition = state.bullets.reduce(function (acc, next) {
    return next.position + acc;
  }, 0);
  return bulletsPosition > 0;
}

var NumberLineIntegersModel = getNumberLineBaseModel(createSnapshot$6);
function createSegments(line, labels) {
  var min = line.min,
    max = line.max,
    divisions = line.divisions;
  var frequency = labels.frequency,
    show_min = labels.show_min,
    show_max = labels.show_max;
  var step = (max - min) / (divisions - 1);
  var showLabel = function showLabel(idx) {
    return when()["case"](idx === 0 && show_min, function () {
      return true;
    })["case"](idx === 0 && !show_min, function () {
      return false;
    })["case"](idx === divisions - 1 && show_max, function () {
      return true;
    })["case"](idx === divisions - 1 && !show_max, function () {
      return false;
    })["case"](idx % frequency === 0, function () {
      return true;
    }).resolve(function () {
      return false;
    });
  };
  return new Array(divisions).fill('').map(function (_, index) {
    return {
      value: parseFloat((min + step * index).toFixed(3)),
      showLabel: showLabel(index)
    };
  });
}
function getFixedDecimals(data) {
  return produce(data, function (draft) {
    var _data$data$validation, _data$data$validation2;
    draft.data.validation.valid_response.value = data.data.validation.valid_response.value.map(function (n) {
      return {
        position: parseFloat(n.position.toFixed(3))
      };
    });
    draft.data.validation.alt_responses = (_data$data$validation = data.data.validation) === null || _data$data$validation === void 0 ? void 0 : (_data$data$validation2 = _data$data$validation.alt_responses) === null || _data$data$validation2 === void 0 ? void 0 : _data$data$validation2.map(function (_ref) {
      var score = _ref.score,
        value = _ref.value;
      return {
        score: score,
        value: {
          position: parseFloat(value.position.toFixed(3))
        }
      };
    });
  });
}
function createSnapshot$6(data) {
  var fixedDecimalsData = getFixedDecimals(data);
  var _fixedDecimalsData$da = fixedDecimalsData.data,
    validation = _fixedDecimalsData$da.validation,
    line = _fixedDecimalsData$da.line,
    labels = _fixedDecimalsData$da.labels;
  var validResponse = validation.valid_response.value;
  var responsesLength = validation.valid_response.value.length;
  return _extends({}, fixedDecimalsData.data, importCommonValues(fixedDecimalsData), {
    validation: withPenaltyPoints(responsesLength, validation),
    bullets: validResponse.map(function () {
      return {
        position: 0
      };
    }),
    segments: createSegments(line, labels)
  });
}
function createStore$D(data) {
  return NumberLineIntegersModel.create(createSnapshot$6(data));
}

var NumberLineFractionsModel = getNumberLineBaseModel(createSnapshot$7);
function createSegments$1(line, labels) {
  var divisions = line.divisions,
    min = line.min;
  var frequency = labels.frequency;
  var showLabel = function showLabel(idx) {
    return when()["case"](idx === 0, function () {
      return true;
    })["case"](idx === divisions - 1, function () {
      return true;
    })["case"](idx % frequency === 0, function () {
      return true;
    }).resolve(function () {
      return false;
    });
  };
  return populate(divisions, function (index) {
    return {
      value: min + index,
      showLabel: showLabel(index)
    };
  });
}
function createSnapshot$7(data) {
  var _data$data = data.data,
    validation = _data$data.validation,
    line = _data$data.line,
    labels = _data$data.labels;
  var validResponse = validation.valid_response.value;
  var responsesLength = validation.valid_response.value.length;
  return _extends({}, data.data, importCommonValues(data), {
    validation: withPenaltyPoints(responsesLength, validation),
    bullets: validResponse.map(function () {
      return {
        position: 0
      };
    }),
    segments: createSegments$1(line, labels)
  });
}
function createStore$E(data) {
  return NumberLineFractionsModel.create(createSnapshot$7(data));
}

function createStore$F(data) {
  var _data$data;
  var mode = ((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.mode) || NUMBER;
  return mode === NUMBER ? createStore$D(data) : createStore$E(data);
}

var LineModel = types$1.model({
  divisions: types$1.number,
  max: types$1.number,
  min: types$1.number,
  denominator: types$1.optional(types$1.number, 0)
}).actions(function (state) {
  return {
    setDivisions: function setDivisions(divisions) {
      var value = parseInt(divisions);
      if (typeof value === 'number') {
        state.divisions = value;
        getParent(state).updateNotifier();
      }
    },
    setMax: function setMax(max) {
      var value = parseFloat(max);
      if (typeof value === 'number') {
        state.max = value;
        if (value <= state.min) state.min = value - 1;
        getParent(state).updateNotifier();
      }
    },
    setMin: function setMin(min) {
      var value = parseFloat(min);
      if (typeof value === 'number') {
        state.min = value;
        if (value >= state.max) state.max = value + 1;
        getParent(state).updateNotifier();
      }
    },
    setDenominator: function setDenominator(denomimator) {
      var value = parseFloat(denomimator);
      if (typeof value === 'number') {
        state.denominator = value;
        getParent(state).updateNotifier();
      }
    }
  };
});

var LabelsModel = types$1.model({
  showMax: types$1["boolean"],
  showMin: types$1["boolean"],
  frequency: types$1.number
}).actions(function (state) {
  return {
    setShowMax: function setShowMax(showMax) {
      state.showMax = showMax;
    },
    setShowMin: function setShowMin(showMin) {
      state.showMin = showMin;
    },
    setFrequency: function setFrequency(frequency) {
      var value = parseInt(frequency);
      if (typeof value === 'number') {
        state.frequency = value;
        getParent(state).updateNotifier();
      }
    }
  };
});
var LabelsModel$1 = types$1.snapshotProcessor(LabelsModel, {
  preProcessor: function preProcessor(sn) {
    return {
      showMax: sn.show_max,
      showMin: sn.show_min,
      frequency: sn.frequency
    };
  },
  postProcessor: function postProcessor(sn) {
    return {
      show_max: sn.showMax,
      show_min: sn.showMin,
      frequency: sn.frequency
    };
  }
});

function createItemListModel(modelType) {
  return types$1.model({
    list: types$1.array(modelType)
  }).actions(function (state) {
    return {
      updateNotifier: function updateNotifier() {
        console.log('TODO:: getParent(state, 2).updateNotifier()');
      },
      sortItems: function sortItems(source, destination) {
        state.list = sortArrayItem(source, destination, state.list);
        state.updateNotifier();
      },
      removeItem: function removeItem(idx) {
        destroy(state.list[idx]);
        state.updateNotifier();
      }
    };
  });
}

var ItemModel$2 = ValueModel.actions(function (state) {
  return {
    setValue: function setValue(value) {
      state.value = value;
      getParent(state, 2).updateNotifier();
    }
  };
});
var PointLabelsModel = types$1.compose(createItemListModel(ItemModel$2), types$1.model('DataItemModel', {}).actions(function (state) {
  var testMode = !hasParent(state);
  var getMin = function getMin() {
    return testMode ? 0 : getParent(state).line.min;
  };
  var incrementValidation = function incrementValidation(diff) {
    var addedValue = populate(Math.abs(diff), function () {
      return {
        position: getMin()
      };
    });
    return [].concat(getParent(state).validation.value, addedValue);
  };
  var decrementValidation = function decrementValidation() {
    return getParent(state).validation.value.slice(0, state.list.length);
  };
  return {
    updateNotifier: function updateNotifier() {
      !testMode && getParent(state).updateNotifier();
    },
    updateValidation: function updateValidation() {
      if (testMode) return;
      var _getParent = getParent(state),
        validation = _getParent.validation;
      var diff = validation.value.length - state.list.length;
      if (diff === 0) return;
      validation.setValue(diff < 0 ? incrementValidation(diff) : decrementValidation());
    },
    addItem: function addItem() {
      var newItem = {
        value: getMin().toString()
      };
      state.list.push(newItem);
      state.updateValidation();
      state.updateNotifier();
    },
    removeItem: function removeItem(idx) {
      destroy(state.list[idx]);
      state.updateValidation();
      state.updateNotifier();
    }
  };
}));
var PointLabelsModel$1 = types$1.snapshotProcessor(PointLabelsModel, {
  preProcessor: function preProcessor(sn) {
    return {
      list: sn.map(function (value) {
        return {
          value: value
        };
      })
    };
  },
  postProcessor: function postProcessor(sn) {
    return sn.list.map(function (_ref) {
      var value = _ref.value;
      return value;
    });
  }
});

var NumberLineEditorStore = types$1.compose(EditorBaseModel, types$1.model({
  pointLabels: PointLabelsModel$1,
  line: LineModel,
  labels: LabelsModel$1,
  mode: types$1.optional(types$1.enumeration([NUMBER, FRACTION]), NUMBER),
  showIntegerValues: types$1.optional(types$1["boolean"], true),
  ui_style: BaseModel$1
}).actions(function (state) {
  return {
    setMode: function setMode(mode) {
      state.mode = mode;
      state.updateNotifier();
    },
    setShowIntegerValues: function setShowIntegerValues(showIntegerValues) {
      state.showIntegerValues = showIntegerValues;
      state.updateNotifier();
    }
  };
}).views(function (state) {
  var getLine = function getLine() {
    return _extends({}, getSnapshot(state.line), {
      denominator: state.mode === FRACTION ? state.line.denominator : undefined
    });
  };
  return {
    get output() {
      return exportCommonValues(state, {
        validation: getSnapshot(state.validation),
        points: getSnapshot(state.pointLabels),
        line: getLine(),
        labels: getSnapshot(state.labels),
        mode: state.mode,
        show_integer_values: state.mode === FRACTION && state.showIntegerValues
      });
    }
  };
}));
function createSnapshot$8(data) {
  var _data$data = data.data,
    points = _data$data.points,
    line = _data$data.line,
    labels = _data$data.labels;
  return _extends({}, data.data, importCommonValues$1(data), {
    pointLabels: points,
    line: line,
    labels: labels
  });
}
function createStore$G(data) {
  var store = NumberLineEditorStore.create(createSnapshot$8(data));
  return store;
}

function fixLimits(data) {
  return produce(data, function (draft) {
    var shape = data.data.shape;
    var isGeometry = ![TENTHS, HUNDREDTHS].includes(shape.type);
    var MAX_DIVISIONS = 12;
    var MIN_DIVISIONS = 2;
    var TENTH_DIVISIONS = 10;
    var HUNDREDTHS_DIVISIONS = 100;
    if (shape.type === TENTHS) {
      draft.data.shape.divisions = TENTH_DIVISIONS;
    }
    if (shape.type === HUNDREDTHS) {
      draft.data.shape.divisions = HUNDREDTHS_DIVISIONS;
    }
    if (isGeometry) {
      draft.data.shape.divisions = Math.max(MIN_DIVISIONS, Math.min(shape.divisions, MAX_DIVISIONS));
    }
  });
}

var FractionQuestionStore = types$1.compose(QuestionBaseModel, withValidationModes, types$1.model({
  graph: types$1.array(types$1.number)
}).actions(function (state) {
  return {
    updateGraph: function updateGraph(graph) {
      state.graph = graph;
    },
    fixGraph: function fixGraph() {
      var currentValue = state.validation.value;
      var newValue = typeof currentValue === 'number' ? currentValue : currentValue.reduce(function (acc, next) {
        return acc + next;
      }, 0);
      state.updateGraph(getInitialGraphValue(state.divisions, newValue));
    },
    selectSector: function selectSector(idx) {
      if (state.disabled) return false;
      if (idx < state.graph.length) {
        state.graph[idx] = state.graph[idx] === 0 ? 1 : 0;
      }
    },
    setSector: function setSector(idx, newValue) {
      if (state.disabled) return false;
      if (idx < state.graph.length) {
        state.graph[idx] = newValue;
      }
    },
    setResponse: function setResponse(response) {
      if (typeChecker(types$1.array(types$1.number), response)) return state.setSpecificResponse(response);
      if (typeChecker(types$1.number, response)) return state.setBasicResponse(response);
      return false;
    },
    setSpecificResponse: function setSpecificResponse(response) {
      state.graph = response;
    },
    setBasicResponse: function setBasicResponse(response) {
      state.graph = populate(state.divisions, function (i) {
        return i < response ? 1 : 0;
      });
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot$x(rawData);
      applySnapshot(state, data);
      state.setIsSolutionMode(true);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    reset: function reset() {
      state.baseReset();
      state.graph = getInitialGraphValue(state.divisions);
    }
  };
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$x(rawData);
    },
    get divisions() {
      return state.raw.data.shape.divisions;
    },
    get shape() {
      return state.raw.data.shape.type;
    },
    get graphChanged() {
      return getSnapshot(state.graph).toString();
    },
    getUserResponse: function getUserResponse() {
      var userResponse = getSnapshot(state.graph);
      return state.getRealUserResponse(userResponse);
    },
    getResults: function getResults() {
      var responseValue = state.graph.reduce(function (acc, next) {
        return next === 1 ? acc + 1 : acc;
      }, 0);
      return responseValue === state.validation.value ? 1 : 0;
    },
    getValidResponses: function getValidResponses() {
      return state.getResults() === 1 ? state.getUserResponse() : state.validation.value;
    },
    get isSuccess() {
      if (state.showSolution) return true;
      return state.isEvaluated && state.points > 0;
    },
    get isError() {
      if (state.showSolution) return false;
      return state.isEvaluated && state.points === 0;
    },
    get feedbackResult() {
      return when()["case"](state.isSuccess, function () {
        return 'isSuccess';
      })["case"](state.isError, function () {
        return 'isError';
      }).resolve(function () {
        return '';
      });
    },
    get theme() {
      return state.ui_style.theme;
    }
  };
}));
function getInitialGraphValue(divisions, solution) {
  if (solution === void 0) {
    solution = 0;
  }
  return populate(divisions, function (i) {
    return i < solution ? 1 : 0;
  });
}
function _createSnapshot$x(_data) {
  var data = fixLimits(_data);
  var shape = data.data.shape;
  return _extends({}, data.data, importCommonValues(data), {
    graph: getInitialGraphValue(shape.divisions)
  });
}
function createStore$H(data) {
  return FractionQuestionStore.create(_createSnapshot$x(data));
}

var SHAPE_LIST = [TRIANGLE, QUAD, RECTANGLE, PENTAGON, HEXAGON, CIRCLE, HUNDREDTHS, TENTHS, RANDOM];

var shapes = SHAPE_LIST.filter(function (s) {
  return s !== RANDOM;
});
var ShapeModel = types$1.model({
  type: types$1.enumeration(SHAPE_LIST),
  divisions: types$1.number
}).actions(function (state) {
  return {
    setDivisions: function setDivisions(divisions) {
      var value = parseInt(divisions);
      if (typeof value !== 'number') return;
      state.divisions = value;
      getParent(state).updateNotifier();
    },
    changeShape: function changeShape(shapeIdx) {
      var shapeName = shapes[parseInt(shapeIdx)];
      var divisionsConfig = getShapeDivisionsConfig(shapeName);
      state.setType(shapeName);
      if (divisionsConfig.isFixed) {
        state.updateDivisionsWhenShapeChangesToFixed(divisionsConfig.divisionList);
      }
      if (divisionsConfig.isVariable) {
        state.updateDivisionsWhenShapeChangesToVariable(divisionsConfig.max);
      }
      if (divisionsConfig.hideDivisions) {
        state.updateDivisionsWhenShapeChangesToHidden(divisionsConfig.divisionList[0]);
      }
    },
    updateDivisionsWhenShapeChangesToFixed: function updateDivisionsWhenShapeChangesToFixed(divisionList) {
      if (!divisionList.includes(state.divisions)) {
        var newValue = divisionList[0];
        state.setDivisions(newValue);
        state.updateValidation(newValue);
      }
    },
    updateDivisionsWhenShapeChangesToHidden: function updateDivisionsWhenShapeChangesToHidden(divisions) {
      var newValue = Math.min(divisions, state.divisions);
      state.setDivisions(divisions);
      state.updateValidation(newValue);
    },
    updateDivisionsWhenShapeChangesToVariable: function updateDivisionsWhenShapeChangesToVariable(max) {
      var newValue = Math.min(max, state.divisions);
      state.setDivisions(newValue);
      state.updateValidation(newValue);
    },
    updateValidation: function updateValidation(maxValue) {
      var _getParent = getParent(state),
        validation = _getParent.validation,
        selectedDivisionsLength = _getParent.selectedDivisionsLength;
      var maxDivisions = Math.min(maxValue, selectedDivisionsLength);
      validation.setValue(maxDivisions);
    },
    setType: function setType(type) {
      state.type = type;
      getParent(state).updateNotifier();
    },
    changeDivisions: function changeDivisions(divisionIndex) {
      var value = parseInt(divisionIndex);
      if (typeof value !== 'number') return;
      var _getShapeDivisionsCon = getShapeDivisionsConfig(state.type),
        divisionList = _getShapeDivisionsCon.divisionList;
      state.setDivisions(divisionList[value]);
    }
  };
}).views(function (state) {
  return {
    get currentShapeIndex() {
      return SHAPE_LIST.findIndex(function (s) {
        return s === state.type;
      });
    },
    get currentDivisionIndex() {
      return state.shapeDivisionsConfig.isFixed ? state.shapeDivisionsConfig.divisionList.findIndex(function (s) {
        return s === state.divisions;
      }) : 0;
    },
    get shapeDivisionsConfig() {
      return getShapeDivisionsConfig(state.type);
    }
  };
});
function getShapeDivisionsConfig(shape) {
  var eq = function eq(x) {
    return shape === x;
  };
  return when()["case"](eq(TRIANGLE), function () {
    return {
      hideDivisions: true,
      divisionList: [2]
    };
  })["case"](eq(QUAD), function () {
    return {
      isFixed: true,
      divisionList: [4, 8]
    };
  })["case"](eq(PENTAGON), function () {
    return {
      isFixed: true,
      divisionList: [5, 10]
    };
  })["case"](eq(HEXAGON), function () {
    return {
      isFixed: true,
      divisionList: [6, 12]
    };
  })["case"](eq(TENTHS), function () {
    return {
      hideDivisions: true,
      divisionList: [10]
    };
  })["case"](eq(HUNDREDTHS), function () {
    return {
      hideDivisions: true,
      divisionList: [100]
    };
  })["case"](eq(RECTANGLE), function () {
    return {
      isVariable: true,
      min: 2,
      max: 12
    };
  }).resolve(function () {
    return {
      isVariable: true,
      min: 2,
      max: 12
    };
  });
}

var FractionUIStyles = types$1.compose(BaseModel$1, types$1.model({
  theme: types$1.optional(types$1.enumeration(COLOR_THEMES), 'theme-light-orange')
}).actions(function (state) {
  return {
    changeTheme: function changeTheme(themeIndex) {
      state.setTheme(COLOR_THEMES[parseInt(themeIndex)]);
    },
    setTheme: function setTheme(theme) {
      state.theme = theme;
      getParent(state).updateNotifier();
    }
  };
}).views(function (state) {
  return {
    get colorThemeIndex() {
      return COLOR_THEMES.findIndex(function (s) {
        return s === state.theme;
      });
    }
  };
}));

var FractionEditorStore = types$1.compose(EditorBaseModel, types$1.model({
  shape: ShapeModel,
  ui_style: FractionUIStyles
}).actions(function (state) {
  return {
    setNothing: function setNothing() {}
  };
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$y(rawData);
    },
    get selectedDivisionsLength() {
      var value = state.validation.value;
      return Array.isArray(value) ? value.reduce(function (acc, next) {
        return acc + next;
      }, 0) : value;
    },
    get output() {
      var validation = normalizeValidation(getSnapshot(state.validation));
      return exportCommonValues(state, {
        shape: getSnapshot(state.shape),
        validation: validation
      });
    }
  };
}));
function normalizeValidation(data) {
  var value = data.valid_response.value;
  if (typeof value === 'number') return data;
  return produce(data, function (draft) {
    draft.valid_response.value = value.reduce(function (acc, next) {
      return acc + next;
    }, 0);
  });
}
function getInitialTheme(theme) {
  if (!theme) return COLOR_THEMES[0];
  if (theme.indexOf('theme-') > -1) return theme;
  return "theme-" + theme;
}
function _createSnapshot$y(data) {
  var ui_style = _extends({}, data.data.ui_style, {
    theme: getInitialTheme(data.data.ui_style.theme)
  });
  return _extends({}, data.data, importCommonValues$1(data), {
    shape: data.data.shape,
    ui_style: ui_style
  });
}
function createStore$I(data) {
  var store = FractionEditorStore.create(_createSnapshot$y(data));
  return store;
}

function QuadrantVerticalLabels(_ref) {
  var grid = _ref.grid,
    coordinateSize = _ref.coordinateSize,
    orientation = _ref.orientation,
    selectedValue = _ref.selectedValue,
    classAdd = _ref.classAdd;
  var arePositiveValues = ['lemo-top_right', 'lemo-top_left'].includes(orientation);
  var normalizeSelectedValue = arePositiveValues ? grid.length - 1 - selectedValue : selectedValue;
  function getLabelPosition(percent) {
    return arePositiveValues ? coordinateSize - coordinateSize * percent : coordinateSize * percent;
  }
  return /*#__PURE__*/React__default.createElement("g", {
    className: cn$1('lemo-quadrant-vertical-labels', classAdd),
    "data-testid": "verticalLabels"
  }, grid.map(function (percent, idx) {
    var labelPosition = getLabelPosition(percent);
    var isSelected = !!config.graphsHelpMarks && idx === normalizeSelectedValue;
    return idx === 0 ? null : /*#__PURE__*/React__default.createElement("text", {
      className: cn$1('lemo-quadrant-label lemo-text-body-s-regular lemo-color-text-04', {
        'lemo-selected': isSelected
      }),
      key: "vertical_label_" + idx,
      filter: isSelected ? 'url(#lemo-selected-filter)' : '',
      x: 0,
      y: labelPosition
    }, !arePositiveValues ? '-' : '', idx);
  }));
}

var NORMAL_QUADRANT_SIZE = 480;
var NORMAL_COORDINATE_SIZE = 430;
var SMALL_QUADRANT_SIZE = 360;
var SMALL_COORDINATE_SIZE = 286;
var NORMAL_DOT_RADIUS = 8;
var SMALL_DOT_RADIUS = 12;
var DOT_HANDLER_RADIUS = 12;
var TOP_RIGHT = 'TOP_RIGHT';
var TOP_LEFT = 'TOP_LEFT';
var BOTTOM_RIGHT = 'BOTTOM_RIGHT';
var BOTTOM_LEFT = 'BOTTOM_LEFT';
var QUADRANT_ALL = 'QUADRANT_ALL';
var LINE_EXTRA_SIZE = 5;
var AXIS_EXTRA_SIZE = LINE_EXTRA_SIZE * 2;

function Line$2(_ref) {
  var className = _ref.className,
    isSelected = _ref.isSelected,
    x1 = _ref.x1,
    x2 = _ref.x2,
    y1 = _ref.y1,
    y2 = _ref.y2;
  return /*#__PURE__*/React__default.createElement("line", {
    className: cn$1(className, {
      'lemo-selected': isSelected
    }),
    x1: x1,
    x2: x2,
    y1: y1,
    y2: y2
  });
}
var Line$3 = observer(Line$2);

var checkMainXAxisSelected = function checkMainXAxisSelected(_ref) {
  var orientation = _ref.orientation,
    activeXGrid = _ref.activeXGrid,
    gridLength = _ref.gridLength;
  return when()["case"](!config.graphsHelpMarks, function () {
    return false;
  })["case"](orientation[1] === LEFT && activeXGrid === gridLength, function () {
    return true;
  })["case"](orientation[1] === RIGHT$2 && activeXGrid === 0, function () {
    return true;
  }).resolve(function () {
    return false;
  });
};
var checkMainYAxisSelected = function checkMainYAxisSelected(_ref2) {
  var orientation = _ref2.orientation,
    activeYGrid = _ref2.activeYGrid,
    gridLength = _ref2.gridLength;
  return when()["case"](!config.graphsHelpMarks, function () {
    return false;
  })["case"](orientation[0] === TOP && activeYGrid === gridLength, function () {
    return true;
  })["case"](orientation[0] === BOTTOM && activeYGrid === 0, function () {
    return true;
  }).resolve(function () {
    return false;
  });
};

function QuadrantGrid(_ref) {
  var grid = _ref.grid,
    size = _ref.size,
    activeXGrid = _ref.activeXGrid,
    activeYGrid = _ref.activeYGrid,
    orientation = _ref.orientation;
  var gridLength = grid.length - 1;
  var mainXAxisSelected = checkMainXAxisSelected({
    orientation: orientation,
    activeXGrid: activeXGrid,
    gridLength: gridLength
  });
  var mainYAxisSelected = checkMainYAxisSelected({
    orientation: orientation,
    activeYGrid: activeYGrid,
    gridLength: gridLength
  });
  return /*#__PURE__*/React__default.createElement("g", {
    className: "lemo-quadrant-grid"
  }, grid.map(function (percent, idx) {
    var position = size.COORDINATE_SIZE * percent;
    var horizontalSelected = activeXGrid === idx;
    var verticalSelected = activeYGrid === idx;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: "line_" + idx
    }, /*#__PURE__*/React__default.createElement(Line$3, {
      className: "lemo-quadrant-line",
      isSelected: horizontalSelected,
      x1: position,
      x2: position,
      y1: 0 - LINE_EXTRA_SIZE,
      y2: size.COORDINATE_SIZE + LINE_EXTRA_SIZE
    }), /*#__PURE__*/React__default.createElement(Line$3, {
      className: "lemo-quadrant-line",
      isSelected: verticalSelected,
      y1: position,
      y2: position,
      x1: 0 - LINE_EXTRA_SIZE,
      x2: size.COORDINATE_SIZE + LINE_EXTRA_SIZE
    }));
  }), /*#__PURE__*/React__default.createElement(Line$3, {
    className: "lemo-vertical-line lemo-quadrant-axis-line",
    isSelected: mainXAxisSelected,
    x1: 0,
    x2: 0,
    y1: 0 - AXIS_EXTRA_SIZE,
    y2: size.COORDINATE_SIZE
  }), /*#__PURE__*/React__default.createElement(Line$3, {
    className: "lemo-horizontal-line lemo-quadrant-axis-line",
    isSelected: mainYAxisSelected,
    x1: 0,
    x2: size.COORDINATE_SIZE + AXIS_EXTRA_SIZE,
    y1: size.COORDINATE_SIZE,
    y2: size.COORDINATE_SIZE
  }));
}
var QuadrantGrid$1 = observer(QuadrantGrid);

function QuadrantHorizontalLabels(_ref) {
  var grid = _ref.grid,
    coordinateSize = _ref.coordinateSize,
    orientation = _ref.orientation,
    selectedValue = _ref.selectedValue;
  var arePositiveValues = ['lemo-top_right', 'lemo-bottom_right'].includes(orientation);
  var normalizeSelectedValue = arePositiveValues ? selectedValue : grid.length - 1 - selectedValue;
  function getLabelPosition(percent) {
    return arePositiveValues ? coordinateSize * percent : coordinateSize - coordinateSize * percent;
  }
  return /*#__PURE__*/React__default.createElement("g", {
    className: "lemo-quadrant-horizontal-labels",
    "data-testid": "horizontalLabels"
  }, grid.map(function (percent, idx) {
    var labelPosition = getLabelPosition(percent);
    var isSelected = !!config.graphsHelpMarks && idx === normalizeSelectedValue;
    return idx === 0 ? null : /*#__PURE__*/React__default.createElement("text", {
      key: "vertical_label_" + idx,
      className: cn$1('lemo-quadrant-label', {
        'lemo-selected': isSelected
      }),
      filter: isSelected ? 'url(#lemo-selected-filter)' : '',
      x: labelPosition,
      y: 0
    }, !arePositiveValues ? '-' : '', idx);
  }));
}

function OriginLabel(_ref) {
  var activeXGrid = _ref.activeXGrid,
    activeYGrid = _ref.activeYGrid,
    orientation = _ref.orientation,
    gridLength = _ref.gridLength;
  var mainXAxisSelected = checkMainXAxisSelected({
    orientation: orientation,
    activeXGrid: activeXGrid,
    gridLength: gridLength
  });
  var mainYAxisSelected = checkMainYAxisSelected({
    orientation: orientation,
    activeYGrid: activeYGrid,
    gridLength: gridLength
  });
  var isSelected = mainYAxisSelected || mainXAxisSelected;
  return /*#__PURE__*/React__default.createElement("g", {
    className: "lemo-quadrant-origin-label"
  }, /*#__PURE__*/React__default.createElement("text", {
    className: cn$1('lemo-quadrant-label', {
      'lemo-selected': isSelected
    }),
    filter: isSelected ? 'url(#lemo-selected-filter)' : '',
    x: 0,
    y: 0
  }, "0"));
}

function GridHighlightFilters() {
  return /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("filter", {
    x: "-.2",
    y: "-.1",
    width: "1.4",
    height: "1.2",
    id: "lemo-selected-filter"
  }, /*#__PURE__*/React__default.createElement("feFlood", {
    floodColor: "#4F4FFF",
    result: "bg"
  }), /*#__PURE__*/React__default.createElement("feMerge", null, /*#__PURE__*/React__default.createElement("feMergeNode", {
    "in": "bg"
  }), /*#__PURE__*/React__default.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))));
}

function SingleQuadrant(_ref) {
  var grid = _ref.grid,
    orientation = _ref.orientation,
    orientationClassName = _ref.orientationClassName,
    size = _ref.size,
    activeXGrid = _ref.activeXGrid,
    activeYGrid = _ref.activeYGrid;
  var orientationAxis = orientation.split('_');
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size.QUADRANT_SIZE,
    height: size.QUADRANT_SIZE,
    className: "lemo-single-quadrant",
    "data-testid": "graph"
  }, /*#__PURE__*/React__default.createElement(GridHighlightFilters, null), /*#__PURE__*/React__default.createElement("rect", {
    width: size.QUADRANT_SIZE,
    height: size.QUADRANT_SIZE,
    className: "lemo-single-quadrant-bounds"
  }), /*#__PURE__*/React__default.createElement("rect", {
    width: size.COORDINATE_SIZE,
    height: size.COORDINATE_SIZE,
    className: "lemo-base-quadrant"
  }), /*#__PURE__*/React__default.createElement(QuadrantGrid$1, {
    grid: grid,
    size: size,
    activeXGrid: activeXGrid,
    activeYGrid: activeYGrid,
    orientation: orientationAxis
  }), /*#__PURE__*/React__default.createElement(QuadrantVerticalLabels, {
    grid: grid,
    coordinateSize: size.COORDINATE_SIZE,
    orientation: orientationClassName,
    selectedValue: activeYGrid
  }), /*#__PURE__*/React__default.createElement(QuadrantHorizontalLabels, {
    grid: grid,
    coordinateSize: size.COORDINATE_SIZE,
    orientation: orientationClassName,
    selectedValue: activeXGrid
  }), /*#__PURE__*/React__default.createElement(OriginLabel, {
    activeXGrid: activeXGrid,
    activeYGrid: activeYGrid,
    orientation: orientationAxis,
    gridLength: grid.length - 1
  }));
}

var isTouch$2 = isTouchDevice();
function DotAtom(_ref) {
  var theme = _ref.theme,
    isSuccess = _ref.isSuccess,
    isWrong = _ref.isWrong,
    x = _ref.x,
    y = _ref.y,
    size = _ref.size,
    onMouseDown = _ref.onMouseDown,
    onMouseUp = _ref.onMouseUp,
    onMouseOver = _ref.onMouseOver,
    onMouseOut = _ref.onMouseOut,
    isActive = _ref.isActive;
  return /*#__PURE__*/React__default.createElement("g", {
    "data-testid": "dot",
    className: cn('lemo-dot-atom', theme, {
      'lemo-success': isSuccess,
      'lemo-error': isWrong
    })
  }, /*#__PURE__*/React__default.createElement("circle", {
    className: "lemo-dot-handler",
    cx: x,
    cy: y,
    r: size + 6,
    onMouseDown: !isTouch$2 ? onMouseDown : null,
    onMouseUp: !isTouch$2 ? onMouseUp : null,
    onMouseOver: onMouseOver,
    onMouseOut: onMouseOut,
    onTouchStart: onMouseDown,
    onTouchEnd: onMouseUp
  }), /*#__PURE__*/React__default.createElement("circle", {
    className: cn('lemo-dot', {
      'lemo-active': isActive
    }),
    cx: x,
    cy: y,
    r: size
  }));
}
var DotAtom$1 = observer(DotAtom);

var isTouch$3 = isTouchDevice();
var eventMove = isTouch$3 ? 'touchmove' : 'mousemove';
var eventUp = isTouch$3 ? 'touchend' : 'mouseup';
function Dot(_ref) {
  var dot = _ref.dot,
    unitSize = _ref.unitSize,
    getCursorPoint = _ref.getCursorPoint,
    canvas = _ref.canvas,
    gridSize = _ref.gridSize,
    theme = _ref.theme,
    size = _ref.size,
    setActiveDotIndex = _ref.setActiveDotIndex,
    gridFull = _ref.gridFull;
  var _useState = useState(false),
    isMouseOver = _useState[0],
    _onMouseOver = _useState[1];
  var x = dot.x * unitSize + DOT_HANDLER_RADIUS;
  var y = dot.y * unitSize + DOT_HANDLER_RADIUS;
  var isActive = isMouseOver && !isTouch$3 || dot.selected;
  function getValidValue(value, isX) {
    if (!gridFull) {
      return Math.max(Math.min(value, gridSize), 0);
    } else {
      if (value < 0) return 0;
      if (value > gridSize * 2) return gridSize * 2;
      return value;
    }
  }
  function getPositionValue(evt) {
    var _getCursorPoint = getCursorPoint(evt),
      x = _getCursorPoint.x,
      y = _getCursorPoint.y;
    return {
      x: getValidValue(Math.round((x - DOT_HANDLER_RADIUS) / unitSize)),
      y: getValidValue(Math.round((y - DOT_HANDLER_RADIUS) / unitSize))
    };
  }
  function moveDot(evt) {
    dot.setPosition(getPositionValue(evt));
    evt.preventDefault();
  }
  function handleMouseDown() {
    setActiveDotIndex(dot.index);
    canvas.current.addEventListener(eventMove, moveDot, {
      passive: false
    });
    window.addEventListener(eventUp, onMouseUp, false);
    dot.setSelected(true);
  }
  function onMouseUp() {
    canvas.current.removeEventListener(eventMove, moveDot, {
      passive: false
    });
    window.removeEventListener(eventUp, onMouseUp);
    if (isAlive(dot)) {
      dot.setSelected(false);
    }
  }
  return /*#__PURE__*/React__default.createElement(DotAtom$1, {
    theme: theme,
    isSuccess: dot.isSuccess,
    isWrong: dot.isWrong,
    x: x,
    y: y,
    size: size.DOT_RADIUS,
    onMouseDown: handleMouseDown,
    onMouseUp: onMouseUp,
    onMouseOver: function onMouseOver() {
      return _onMouseOver(true);
    },
    onMouseOut: function onMouseOut() {
      return _onMouseOver(false);
    },
    isActive: isActive
  });
}
var Dot$1 = observer(Dot);

var isTouch$4 = isTouchDevice();
function DotList(_ref) {
  var store = _ref.store,
    size = _ref.size,
    setActiveDotIndex = _ref.setActiveDotIndex;
  var dotList = store.dotList,
    unitSizePercent = store.unitSizePercent,
    addDot = store.addDot,
    gridSize = store.gridSize,
    theme = store.theme,
    gridFull = store.gridFull;
  var canvas = useRef();
  var unitSize = size.COORDINATE_SIZE * unitSizePercent;
  var canvasWidth = size.COORDINATE_SIZE + DOT_HANDLER_RADIUS * 2;
  function getCursorPoint(evt, adjustX, adjustY) {
    if (adjustX === void 0) {
      adjustX = 0;
    }
    if (adjustY === void 0) {
      adjustY = 0;
    }
    var pt = canvas.current.createSVGPoint();
    var currentEvt = isTouch$4 ? evt.touches[0] : evt;
    pt.x = currentEvt.clientX;
    pt.y = currentEvt.clientY;
    var cursorPoint = pt.matrixTransform(canvas.current.getScreenCTM().inverse());
    if (gridFull) {
      cursorPoint = {
        x: cursorPoint.x + adjustX,
        y: cursorPoint.y + adjustY
      };
    }
    return cursorPoint;
  }
  function mouseDown(evt) {
    var cursorPoint = getCursorPoint(evt, gridFull ? -12.73 : 0, gridFull ? -10.71 : 0);
    addDot({
      x: Math.round(cursorPoint.x / unitSize),
      y: Math.round(cursorPoint.y / unitSize)
    });
    setActiveDotIndex(store.dotList.length - 1);
  }
  return /*#__PURE__*/React__default.createElement("svg", {
    ref: canvas,
    className: "lemo-dot-list",
    width: canvasWidth,
    height: canvasWidth
  }, /*#__PURE__*/React__default.createElement("rect", {
    "data-testid": "canvas",
    className: "lemo-dot-list-bounds",
    width: canvasWidth,
    height: canvasWidth,
    onMouseDown: !isTouch$4 ? mouseDown : null,
    onTouchStart: mouseDown
  }), dotList.map(function (dot) {
    return /*#__PURE__*/React__default.createElement(Dot$1, {
      key: dot.id,
      dot: dot,
      unitSize: unitSize,
      gridSize: gridSize,
      theme: theme,
      canvas: canvas,
      getCursorPoint: getCursorPoint,
      setActiveDotIndex: setActiveDotIndex,
      size: size,
      gridFull: gridFull
    });
  }));
}
var DotList$1 = observer(DotList);

function LegendItem(_ref) {
  var theme = _ref.theme,
    value = _ref.value,
    _ref$onDelete = _ref.onDelete,
    onDelete = _ref$onDelete === void 0 ? null : _ref$onDelete;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-legend-item"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-circle " + theme
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-text"
  }, "(", value.x, ", ", value.y, ")"), onDelete && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-legend-item__delete"
  }, /*#__PURE__*/React__default.createElement(SvgTrash$1, {
    className: "lemo-icon",
    width: 24,
    height: 24,
    onClick: onDelete
  })));
}

function Legend(_ref) {
  var theme = _ref.theme,
    values = _ref.values,
    onDeleteItem = _ref.onDeleteItem;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-legend",
    "data-testid": "legend"
  }, values.map(function (value, idx) {
    return value ? /*#__PURE__*/React__default.createElement(LegendItem, {
      key: "legendItem_" + value.x + "_" + value.y + "_" + idx,
      theme: theme,
      value: value,
      onDelete: onDeleteItem ? function () {
        return onDeleteItem(value, idx);
      } : null
    }) : /*#__PURE__*/React__default.createElement("p", null, "nada");
  }));
}

function QuadrantAllVerticalLabels(_ref) {
  var grid = _ref.grid,
    coordinateSize = _ref.coordinateSize,
    selectedValue = _ref.selectedValue;
  var normalizeSelectedValue = grid.length - 1 - selectedValue;
  function getLabelPosition(percent) {
    return coordinateSize - coordinateSize * percent;
  }
  return /*#__PURE__*/React__default.createElement("g", {
    className: cn$1('lemo-quadrant-all-vertical-labels'),
    "data-testid": "verticalLabels"
  }, grid.map(function (percent, idx) {
    var labelPosition = getLabelPosition(percent);
    var isSelected = !!config.graphsHelpMarks && idx === normalizeSelectedValue;
    var label = idx - (grid.length - 1) / 2;
    return label === 0 ? null : /*#__PURE__*/React__default.createElement("text", {
      className: cn$1('lemo-quadrant-label', {
        'lemo-selected': isSelected
      }),
      key: "vertical_label_" + idx,
      filter: isSelected ? 'url(#lemo-selected-filter)' : '',
      x: 0,
      y: labelPosition
    }, label);
  }));
}

function QuadrantAllHorizontalLabels(_ref) {
  var grid = _ref.grid,
    coordinateSize = _ref.coordinateSize,
    selectedValue = _ref.selectedValue;
  var normalizeSelectedValue = grid.length - 1 - selectedValue;
  function getLabelPosition(percent) {
    return coordinateSize - coordinateSize * percent;
  }
  return /*#__PURE__*/React__default.createElement("g", {
    className: cn$1('lemo-quadrant-all-horizontal-labels'),
    "data-testid": "horizontalLabels"
  }, grid.map(function (percent, idx) {
    var labelPosition = getLabelPosition(percent);
    var isSelected = !!config.graphsHelpMarks && idx === normalizeSelectedValue;
    var label = (idx - (grid.length - 1) / 2) * -1;
    label = Object.is(label, -0) ? 0 : label;
    return label === 0 ? null : /*#__PURE__*/React__default.createElement("text", {
      key: "horizontal_label_" + idx,
      className: cn$1('lemo-quadrant-label', {
        'lemo-selected': isSelected
      }),
      filter: isSelected ? 'url(#lemo-selected-filter)' : '',
      x: labelPosition,
      y: 0
    }, label);
  }));
}

function FourQuadrant(_ref) {
  var grid = _ref.grid,
    orientation = _ref.orientation,
    size = _ref.size,
    activeXGrid = _ref.activeXGrid,
    activeYGrid = _ref.activeYGrid;
  var quadrantGrid = size.QUADRANT_SIZE;
  var totalSize = quadrantGrid;
  var orientationAxis = orientation.split('_');
  return /*#__PURE__*/React__default.createElement("svg", {
    width: totalSize,
    height: totalSize,
    className: "lemo-four-quadrant",
    "data-testid": "graph"
  }, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("filter", {
    x: "-.2",
    y: "-.1",
    width: "1.4",
    height: "1.2",
    id: "lemo-selected-filter"
  }, /*#__PURE__*/React__default.createElement("feFlood", {
    floodColor: "#4F4FFF",
    result: "bg"
  }), /*#__PURE__*/React__default.createElement("feMerge", null, /*#__PURE__*/React__default.createElement("feMergeNode", {
    "in": "bg"
  }), /*#__PURE__*/React__default.createElement("feMergeNode", {
    "in": "SourceGraphic"
  })))), /*#__PURE__*/React__default.createElement("rect", {
    width: totalSize,
    height: totalSize,
    className: "lemo-four-quadrant-bounds"
  }), /*#__PURE__*/React__default.createElement("rect", {
    width: totalSize,
    height: totalSize,
    className: "lemo-base-quadrant"
  }), /*#__PURE__*/React__default.createElement(QuadrantGrid$1, {
    grid: grid,
    size: size,
    activeXGrid: activeXGrid,
    activeYGrid: activeYGrid,
    orientation: orientationAxis
  }), /*#__PURE__*/React__default.createElement(QuadrantAllVerticalLabels, {
    grid: grid,
    coordinateSize: size.COORDINATE_SIZE,
    selectedValue: activeYGrid
  }), /*#__PURE__*/React__default.createElement(QuadrantAllHorizontalLabels, {
    grid: grid,
    coordinateSize: size.COORDINATE_SIZE,
    selectedValue: activeXGrid
  }));
}

var SMALL_VIEW = 560;
var normalSize = {
  QUADRANT_SIZE: NORMAL_QUADRANT_SIZE,
  COORDINATE_SIZE: NORMAL_COORDINATE_SIZE,
  DOT_RADIUS: NORMAL_DOT_RADIUS
};
var smallSize = {
  QUADRANT_SIZE: SMALL_QUADRANT_SIZE,
  COORDINATE_SIZE: SMALL_COORDINATE_SIZE,
  DOT_RADIUS: SMALL_DOT_RADIUS
};
var minDotsSolutionsMode = 1;
var maxDotsSolutionsMode = 5;
var defaultNumberOfDots = 4;
function CoordinateAxesQuestion(props) {
  var sizeRef = useRef();
  var _useState = useState(normalSize),
    size = _useState[0],
    setSize = _useState[1];
  var container = useRef(null);
  useResizeHandler2(sizeRef, function (_ref) {
    var w = _ref.w;
    setSize(w > SMALL_VIEW ? normalSize : smallSize);
  });
  var store = props.store,
    _props$solutionsMode = props.solutionsMode,
    solutionsMode = _props$solutionsMode === void 0 ? false : _props$solutionsMode;
  var changedHandlers = /reset|addDot|setSelected|setPosition|removeDot/;
  function handleClickOutside(e) {
    if (!container.current.contains(e.target)) {
      store.setActiveDotIndex();
    }
  }
  useEffect(function () {
    document.addEventListener('click', handleClickOutside);
    return function () {
      return document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: sizeRef,
    "data-testid": "exerciseBody",
    className: cn$1('lemo-question-body', {
      'lemo-disabled': !solutionsMode && store.disabled,
      'lemo-solutions-mode': solutionsMode,
      'lemo-test-mode': false
    })
  }, /*#__PURE__*/React__default.createElement(Legend, {
    theme: store.theme,
    values: solutionsMode ? store.getUserResponse() : store.validation.value,
    onDeleteItem: solutionsMode && store.dotList.length > minDotsSolutionsMode ? function (value, idx) {
      store.dotList[idx].removeDot();
    } : null
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-quadrant-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: store.orientationClassName + ' lemo-center-container',
    ref: container
  }, store.gridFull ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(FourQuadrant, {
    grid: store.grid,
    gridFullLabels: store.gridFullLabels,
    orientation: store.orientation,
    orientationClassName: store.orientationClassName,
    points: store.values,
    activeXGrid: store.activeXGrid,
    activeYGrid: store.activeYGrid,
    size: size
  }), /*#__PURE__*/React__default.createElement(DotList$1, {
    store: store,
    size: size,
    setActiveDotIndex: store.setActiveDotIndex
  })) : store.isSingleQuadrant ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SingleQuadrant, {
    grid: store.grid,
    orientation: store.orientation,
    orientationClassName: store.orientationClassName,
    points: store.values,
    activeXGrid: store.activeXGrid,
    activeYGrid: store.activeYGrid,
    size: size
  }), /*#__PURE__*/React__default.createElement(DotList$1, {
    store: store,
    size: size,
    setActiveDotIndex: store.setActiveDotIndex
  })) : /*#__PURE__*/React__default.createElement("div", null, translate('lemo-coordinate-axes-multiple-quadrant-error'))))));
}
var CoordinateAxesQuestion$1 = observer(CoordinateAxesQuestion);

var themeNames = ['theme-light-orange', 'theme-dark-orange', 'theme-light-blue', 'theme-dark-blue', 'theme-turquoise', 'theme-violet', 'theme-bordeaux', 'theme-green'];

var CoordinateAxesUIStyles = types$1.compose(BaseModel$1, types$1.model({
  theme: types$1.optional(types$1.enumeration(themeNames), 'theme-bordeaux')
}).actions(function (state) {
  return {
    changeTheme: function changeTheme(themeIndex) {
      state.setTheme(themeNames[parseInt(themeIndex)]);
    },
    setTheme: function setTheme(theme) {
      state.theme = theme;
      getParent(state).updateNotifier();
    }
  };
}).views(function (state) {
  return {
    get colorThemeIndex() {
      return themeNames.findIndex(function (s) {
        return s === state.theme;
      });
    }
  };
}));

var CoordinateAxesEditorStore = types$1.compose(EditorBaseModel, types$1.model({
  gridSize: types$1.optional(types$1.number, 10),
  gridFull: types$1.optional(types$1["boolean"], false),
  gridQuadrant: types$1.optional(types$1.enumeration('Quadrant', Object.values(quadrantList)), quadrantList.I),
  ui_style: CoordinateAxesUIStyles
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      onAction(state, function (_ref) {
        var name = _ref.name;
        if (name.match('setGridSize|setGridQuadrant|setGridFull')) {
          state.validation.setValue(generateRandomPoints(defaultNumberOfDots, state.gridSize, state.gridFull, state.gridQuadrant));
          state.updateNotifier();
        }
      }, true);
    },
    setGridSize: function setGridSize(value) {
      state.gridSize = value;
      state.updateNotifier();
    },
    setGridFull: function setGridFull(value) {
      state.gridFull = value;
      state.updateNotifier();
    },
    setGridQuadrant: function setGridQuadrant(value) {
      state.gridQuadrant = value;
      state.updateNotifier();
    },
    hydrateQuestionPreview: function hydrateQuestionPreview(rawData) {
      try {
        var data = createSnapshot$9(rawData);
        var prevAssetsQuestionApi = state.assetsQuestionApi;
        applySnapshot(state, data);
        state.setIsSolutionMode(false);
        state.setAssetsQuestionApi(prevAssetsQuestionApi);
      } catch (e) {}
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  return {
    get output() {
      return exportCommonValues(state, {
        grid_size: state.gridSize,
        grid_full: state.gridFull,
        grid_quadrant: state.gridQuadrant,
        validation: getSnapshot(state.validation)
      });
    }
  };
}));
function generateRandomPoints(quantity, gridSize, gridFull, quadrant) {
  if (gridFull === void 0) {
    gridFull = false;
  }
  if (quadrant === void 0) {
    quadrant = quadrantList.I;
  }
  var points = [];
  var pointSet = new Set();
  var attempts = 0;
  var maxAttempts = quantity * 3;
  while (points.length < quantity && attempts < maxAttempts) {
    attempts++;
    var x = secureRandomInt(0, gridSize - 1);
    var y = secureRandomInt(0, gridSize - 1);
    var activeQuadrant = quadrant;
    if (gridFull) {
      var quadrantKeys = Object.keys(quadrantList);
      var randomKey = quadrantKeys[secureRandomInt(0, quadrantKeys.length - 1)];
      activeQuadrant = quadrantList[randomKey];
    }
    switch (activeQuadrant) {
      case quadrantList.II:
        x *= -1;
        break;
      case quadrantList.III:
        x *= -1;
        y *= -1;
        break;
      case quadrantList.IV:
        y *= -1;
        break;
    }
    if (Object.is(x, -0)) x = 0;
    if (Object.is(y, -0)) y = 0;
    var pointKey = x + "," + y;
    if (!pointSet.has(pointKey)) {
      pointSet.add(pointKey);
      var point = {
        x: x,
        y: y
      };
      points.push(point);
    }
  }
  if (attempts >= maxAttempts) {
    console.warn('Se alcanzó el límite máximo de intentos. Es posible que no se hayan generado todos los puntos únicos solicitados.');
  }
  return points;
}
function createSnapshot$9(data) {
  return _extends({}, data.data, importCommonValues$1(data), {
    gridSize: data.data.grid_size,
    gridFull: data.data.grid_full,
    gridQuadrant: data.data.grid_quadrant
  });
}
function createStore$J(data) {
  var store = CoordinateAxesEditorStore.create(createSnapshot$9(data));
  return store;
}

var SLICE_CLASS_NAME = 'fractional-shape-slice';
var FILLED_CLASS_NAME = 'filled';
function useFigure(store) {
  var base = useRef();
  var touchMoved = false;
  var lastTouchStartIdx = null;
  var stateGraphIdxStart = null;
  var isMouseDown = false;
  var visitedSlices = [];
  useEffect(function () {
    renderFractionalShape(base.current, {
      type: store.shape,
      divisions: store.divisions,
      fill: 0
    });
    addInteraction();
  }, [store.shape, store.divisions, store.ui_style.theme]);
  useEffect(function () {
    updateFigureFromStore();
  }, [store.graphChanged]);
  useEffect(function () {
    createBorderElements();
  }, [store.feedbackResult]);
  function updateFigureFromStore() {
    if (store.graph.length !== store.divisions) store.fixGraph();
    getSlices().forEach(function (slice, idx) {
      store.graph[idx] === 1 ? slice.classList.add(FILLED_CLASS_NAME) : slice.classList.remove(FILLED_CLASS_NAME);
    });
  }
  function addInteraction() {
    var slices = getSlices();
    var isTouchDevice = typeof window.ontouchstart !== 'undefined';
    slices.forEach(function (slice, idx) {
      if (!isTouchDevice) {
        slice.addEventListener('mousedown', function () {
          startSelection(idx);
        });
        slice.addEventListener('mouseover', selectSlice.bind(null, idx));
        slice.addEventListener('mouseup', endSelection);
      } else {
        slice.addEventListener('touchstart', function (e) {
          touchMoved = false;
          lastTouchStartIdx = idx;
          startSelection(idx);
        });
        slice.addEventListener('touchend', function (e) {
          if (!touchMoved && lastTouchStartIdx === idx) {
            var touchIdx = getSliceFromCoordinates(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
            if (touchIdx !== -1 && lastTouchStartIdx === touchIdx) selectSlice(touchIdx);
          }
        });
      }
    });
    if (isTouchDevice) {
      document.addEventListener('touchmove', function (e) {
        if (!isMouseDown) return;
        touchMoved = true;
        var touch = e.touches[0];
        var x = touch.clientX;
        var y = touch.clientY;
        var idx = getSliceFromCoordinates(x, y);
        if (idx !== -1) selectSlice(idx);
        e.preventDefault();
      }, {
        passive: false
      });
      document.addEventListener('touchend', endSelection, {
        passive: false
      });
    }
  }
  function startSelection(idx) {
    isMouseDown = true;
    stateGraphIdxStart = store.graph[idx];
    selectSlice(idx);
  }
  function endSelection() {
    isMouseDown = false;
    visitedSlices = [];
    lastTouchStartIdx = null;
  }
  function selectSlice(idx) {
    if (isMouseDown && !visitedSlices.includes(idx)) {
      store.setSector(idx, stateGraphIdxStart === 0 ? 1 : 0);
      visitedSlices.push(idx);
    }
  }
  function getSliceFromCoordinates(x, y) {
    var slices = getSlices();
    for (var i = 0; i < slices.length; i++) {
      var rect = slices[i].getBoundingClientRect();
      if (x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom) {
        return i;
      }
    }
    return -1;
  }
  function getSlices() {
    return base.current.querySelectorAll("." + SLICE_CLASS_NAME);
  }
  function getSVG() {
    return base.current.querySelector('svg');
  }
  function resetBorders() {
    var svg = getSVG();
    var className = "." + FEEDBACK_BORDER_CLASS;
    var elements = svg.querySelectorAll(className);
    elements.forEach(function (element) {
      element.remove();
    });
  }
  function createBorderElements() {
    resetBorders();
    var svg = getSVG();
    var className = "." + SLICE_CLASS_NAME + "." + FILLED_CLASS_NAME;
    var elements = svg.querySelectorAll(className);
    elements.forEach(function (element) {
      var clon = element.cloneNode();
      clon.classList.remove(SLICE_CLASS_NAME);
      clon.classList.remove(FILLED_CLASS_NAME);
      clon.classList.add(FEEDBACK_BORDER_CLASS);
      svg.appendChild(clon);
    });
  }
  return {
    base: base
  };
}

function Figure(_ref) {
  var store = _ref.store;
  var _useFigure = useFigure(store),
    base = _useFigure.base;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-fraction-figure', {
      'lemo-success': store.isSuccess,
      'lemo-error': store.isError
    }),
    ref: base
  });
}
var Figure$1 = observer(Figure);

function FractionQuestion(props) {
  var store = props.store,
    _props$solutionsMode = props.solutionsMode,
    solutionsMode = _props$solutionsMode === void 0 ? false : _props$solutionsMode;
  var changedHandlers = /reset|selectSector|setSector/;
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', store.theme, {
      'lemo-disabled': !solutionsMode && store.disabled,
      'lemo-solutions-mode': solutionsMode
    })
  }, /*#__PURE__*/React__default.createElement(Figure$1, {
    store: store
  })));
}
var FractionsQuestion = observer(FractionQuestion);

function getResults(_ref) {
  var userResponse = _ref.userResponse,
    validResponse = _ref.validResponse;
  if (validResponse.length === 0) return 1;
  if (validResponse.length !== userResponse.length) return 0;
  return userResponse.reduce(function (acc, next) {
    return acc === false ? false : checkValue({
      validResponse: validResponse,
      currentResponse: next
    });
  }, true) ? 1 : 0;
}
function checkValue(_ref2) {
  var validResponse = _ref2.validResponse,
    currentResponse = _ref2.currentResponse;
  return validResponse.find(function (value) {
    return value.x === currentResponse.x && value.y === currentResponse.y;
  }) !== undefined;
}

function toGlobalCoordinates(_ref) {
  var orientation = _ref.orientation,
    gridSize = _ref.gridSize,
    coordinates = _ref.coordinates;
  var eq = function eq(val) {
    return val === orientation;
  };
  var reverse = function reverse(val) {
    return gridSize - val;
  };
  var asNegative = function asNegative(val) {
    return val === 0 ? 0 : val * -1;
  };
  return when()["case"](eq(TOP_RIGHT), function () {
    return {
      x: coordinates.x,
      y: reverse(coordinates.y)
    };
  })["case"](eq(TOP_LEFT), function () {
    return {
      x: asNegative(reverse(coordinates.x)),
      y: reverse(coordinates.y)
    };
  })["case"](eq(BOTTOM_RIGHT), function () {
    return {
      x: coordinates.x,
      y: asNegative(coordinates.y)
    };
  })["case"](eq(BOTTOM_LEFT), function () {
    return {
      x: asNegative(reverse(coordinates.x)),
      y: asNegative(coordinates.y)
    };
  })["case"](eq(QUADRANT_ALL), function () {
    return {
      x: coordinates.x - gridSize,
      y: reverse(coordinates.y)
    };
  }).resolve();
}

var DotModel = types$1.compose(getWithFeedbackResult(), types$1.model({
  id: types$1.optional(types$1.identifier, function () {
    return uuid();
  }),
  x: types$1.number,
  y: types$1.number,
  selected: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    setPosition: function setPosition(_ref) {
      var x = _ref.x,
        y = _ref.y;
      state.x = x;
      state.y = y;
    },
    removeDot: function removeDot() {
      getParent(state, 2).removeDot(state);
    },
    setSelected: function setSelected(selected) {
      if (!isAlive(state)) return false;
      state.selected = selected;
      if (!selected) state.checkOverlapping();
    },
    checkOverlapping: function checkOverlapping() {
      if (!isAlive(state)) return false;
      var parent = getParent(state);
      var comparePosition = function comparePosition(element) {
        return element !== state && state.x === element.x && state.y === element.y;
      };
      parent.find(comparePosition) && state.removeDot();
    }
  };
}).views(function (state) {
  var parent = getParent(state, 2);
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get value() {
      var _getParent = getParent(state, 2),
        orientation = _getParent.orientation,
        gridSize = _getParent.gridSize;
      var coordinates = {
        x: state.x,
        y: state.y
      };
      return toGlobalCoordinates({
        orientation: orientation,
        gridSize: gridSize,
        coordinates: coordinates
      });
    },
    get isValid() {
      var validResponse = parent.validation.value;
      var currentResponse = state.value;
      return checkValue({
        validResponse: validResponse,
        currentResponse: currentResponse
      });
    },
    get isActive() {
      return state.selected;
    }
  };
}));

var LEFT_RIGHT = 'LEFT_RIGHT';
var LEFT$2 = 'LEFT';
var RIGHT$8 = 'RIGHT';
var TOP$1 = 'TOP';
var BOTTOM$1 = 'BOTTOM';
var TOP_BOTTOM = 'TOP_BOTTOM';
function getOrientation(coordinates) {
  var _coordinateToNumbers = coordinateToNumbers(coordinates),
    horizontal = _coordinateToNumbers[0],
    vertical = _coordinateToNumbers[1];
  return getVerticalAxisString(vertical) + "_" + getHorizontalAxisString(horizontal);
}
function coordinateToNumbers(coordinates) {
  return coordinates.reduce(function (acc, next) {
    return [compareValue(acc[0], next.x), compareValue(acc[1], next.y)];
  }, [0, 0]);
}
function getNumericValue(val) {
  if (val === 0) return 0;
  return val > 0 ? 1 : -1;
}
function getVerticalAxisString(val) {
  if (val === 0 || val === 1) return TOP$1;
  if (val === -1) return BOTTOM$1;
  return TOP_BOTTOM;
}
function getHorizontalAxisString(val) {
  if (val === 0 || val === 1) return RIGHT$8;
  if (val === -1) return LEFT$2;
  return LEFT_RIGHT;
}
function compareValue(previous, current) {
  var BOTH = 2;
  var nextValue = getNumericValue(current);
  if (previous === BOTH) return BOTH;
  if (nextValue === 0) return previous;
  if (previous === 0) return nextValue;
  if (nextValue !== previous) return BOTH;
  return nextValue;
}

function toLocalCoordinates(_ref) {
  var orientation = _ref.orientation,
    gridSize = _ref.gridSize,
    coordinates = _ref.coordinates;
  var eq = function eq(val) {
    return val === orientation;
  };
  var reverse = function reverse(val) {
    return gridSize - Math.abs(val);
  };
  return when()["case"](eq(TOP_RIGHT), function () {
    return {
      x: coordinates.x,
      y: reverse(coordinates.y)
    };
  })["case"](eq(TOP_LEFT), function () {
    return {
      x: reverse(coordinates.x),
      y: reverse(coordinates.y)
    };
  })["case"](eq(BOTTOM_RIGHT), function () {
    return {
      x: coordinates.x,
      y: Math.abs(coordinates.y)
    };
  })["case"](eq(BOTTOM_LEFT), function () {
    return {
      x: reverse(coordinates.x),
      y: Math.abs(coordinates.y)
    };
  })["case"](eq(QUADRANT_ALL), function () {
    return {
      x: coordinates.x + gridSize,
      y: gridSize - coordinates.y
    };
  }).resolve();
}

var CoordinateAxesQuestionStore = types$1.compose(QuestionBaseModel, types$1.model({
  dotList: types$1.optional(types$1.array(DotModel), []),
  activeDotIndex: types$1.maybe(types$1.number)
}).actions(function (state) {
  var isOverlapping = function isOverlapping(_ref) {
    var x = _ref.x,
      y = _ref.y;
    return state.dotList.reduce(function (acc, next, idx, arr) {
      return acc || arr.find(function (dot) {
        return dot.x === x && dot.y === y;
      });
    }, false);
  };
  return {
    addDot: function addDot(_ref2) {
      var x = _ref2.x,
        y = _ref2.y;
      if (state.maxDotsReached) return false;
      if (isOverlapping({
        x: x,
        y: y
      })) return false;
      state.dotList.push({
        x: x,
        y: y
      });
    },
    removeDot: function removeDot(dot) {
      destroy(dot);
    },
    clearDots: function clearDots() {
      state.dotList = [];
    },
    setResponse: function setResponse(response) {
      var responseModel = types$1.model({
        x: types$1.number,
        y: types$1.number
      });
      if (response.length > state.validation.value.length) return false;
      if (!typeChecker(types$1.array(responseModel), response)) return false;
      state.clearDots();
      response.forEach(function (coordinates) {
        var newValue = toLocalCoordinates({
          orientation: state.orientation,
          gridSize: state.gridSize,
          coordinates: coordinates
        });
        state.addDot(newValue);
      });
    },
    reset: function reset() {
      state.clearDots();
      state.baseReset();
    },
    setActiveDotIndex: function setActiveDotIndex(idx) {
      if (idx === void 0) {
        idx = undefined;
      }
      state.activeDotIndex = idx;
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot$z(rawData);
      applySnapshot(state, data);
      state.setIsSolutionMode(true);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  return {
    get maxDotsReached() {
      return state.isSolutionMode ? state.dotList.length >= maxDotsSolutionsMode : state.dotList.length >= state.validation.value.length;
    },
    get gridSize() {
      return state.raw.data.grid_size;
    },
    get gridFull() {
      return state.raw.data.grid_full;
    },
    get activeXGrid() {
      return state.activeDotIndex !== undefined && state.dotList[state.activeDotIndex] !== undefined ? state.dotList[state.activeDotIndex].x : -1;
    },
    get activeYGrid() {
      return state.activeDotIndex !== undefined && state.dotList[state.activeDotIndex] !== undefined ? state.dotList[state.activeDotIndex].y : -1;
    },
    get unitSizePercent() {
      return state.gridFull ? 1 / (state.gridSize * 2) : 1 / state.gridSize;
    },
    get grid() {
      return state.gridFull ? populate(state.gridSize * 2 + 1, function (i) {
        return i * state.unitSizePercent;
      }) : populate(state.gridSize + 1, function (i) {
        return i * state.unitSizePercent;
      });
    },
    get gridFullLabels() {
      var unitSizePercent = 1 / state.gridSize;
      return populate(state.gridSize + 1, function (i) {
        return i * unitSizePercent;
      });
    },
    get orientation() {
      return state.gridFull ? QUADRANT_ALL : getOrientation(state.validation.value);
    },
    get isSingleQuadrant() {
      return [BOTTOM_RIGHT, BOTTOM_LEFT, TOP_RIGHT, TOP_LEFT].includes(state.orientation);
    },
    get theme() {
      return state.ui_style.theme;
    },
    get isDragging() {
      return state.dotList.find(function (_ref3) {
        var selected = _ref3.selected;
        return selected === true;
      });
    },
    get orientationClassName() {
      return "lemo-" + state.orientation.toLowerCase();
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$z(rawData);
    },
    getUserResponse: function getUserResponse() {
      return state.dotList.map(function (_ref4) {
        var value = _ref4.value;
        return value;
      });
    },
    getResults: function getResults$1() {
      var userResponse = state.getUserResponse();
      var validResponse = state.validation.value;
      return userResponse.length === validResponse.length ? getResults({
        userResponse: userResponse,
        validResponse: validResponse
      }) : 0;
    }
  };
}));
function _createSnapshot$z(data) {
  return _extends({}, data.data, importCommonValues(data));
}
function createStore$K(data) {
  return CoordinateAxesQuestionStore.create(_createSnapshot$z(data));
}

var SegmentModel$1 = types$1.model('Segment', {
  value: types$1.number
}).views(function (state) {
  var parent = getParent(state, 2);
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get isValid() {
      return parent.solution.value.find(function (_ref) {
        var position = _ref.position;
        return position === state.value;
      });
    },
    get isSelected() {
      return parent.getUserResponse().includes(state.value);
    },
    get type() {
      return getType(state);
    },
    get feedbackResult() {
      try {
        var isSegment = getType(state).name === 'Segment';
        var evaluationReady = parent.isEvaluated && !parent.isSolutionMode;
        return when()["case"](!evaluationReady, function () {
          return feedback.NOT_EVALUATED;
        })["case"](isSegment && !state.isSelected, function () {
          return feedback.NOT_EVALUATED;
        })["case"](state.isValid, function () {
          return feedback.RIGHT;
        })["case"](!state.isValid, function () {
          return feedback.WRONG;
        }).resolve();
      } catch (e) {
        return feedback.NOT_EVALUATED;
      }
    },
    get isWrong() {
      return state.feedbackResult === feedback.WRONG;
    },
    get isSuccess() {
      return state.feedbackResult === feedback.RIGHT;
    }
  };
});

var BulletModel$1 = types$1.model('Bullet', {
  id: types$1.optional(types$1.identifier, function () {
    return uuid();
  }),
  position: types$1.number,
  isModified: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  var parent = getParent(state, 2);
  return {
    forcePosition: function forcePosition(position) {
      state.position = position;
    },
    setPosition: function setPosition(position) {
      var _state$limits = state.limits,
        min = _state$limits.min,
        max = _state$limits.max;
      if (position < min || position > max) return false;
      state.position = position;
      state.isModified = true;
      return true;
    },
    setValue: function setValue(value) {
      state.position = parent.segments.findIndex(function (segment) {
        return segment.value === value;
      });
      state.isModified = true;
    },
    reset: function reset() {
      state.position = parent.initialBulletsPosition[state.index];
      state.isModified = false;
    },
    setSelected: function setSelected(bool) {
      parent.setSelectedBullet(bool ? state.index : -1);
    },
    exitPress: function exitPress() {
      parent.exitPress();
    }
  };
}).views(function (state) {
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get value() {
      var parent = getParent(state, 2);
      if (!isAlive(state)) return 0;
      return parent.segments[Math.max(state.position, 0)].value;
    },
    get isSelected() {
      var parent = getParent(state, 2);
      if (!isAlive(state)) return false;
      return parent.selectedBullet === state.index;
    },
    get isDisabled() {
      var parent = getParent(state, 2);
      return parent.isPressing && !state.isSelected;
    },
    get x() {
      if (!isAlive(state)) return 0;
      var parent = getParent(state, 2);
      var margin = 4;
      var lineWidth = 100 - margin * 2;
      var divisionWidth = lineWidth / (parent.segments.length - 1);
      return state.position * divisionWidth + margin;
    },
    get divisions() {
      var parent = getParent(state, 2);
      return parent.segments.length;
    },
    get isValid() {
      var parent = getParent(state, 2);
      return parent.getSolutions()[state.index] === state.value;
    },
    get feedbackResult() {
      var parent = getParent(state, 2);
      try {
        var evaluationReady = parent.isEvaluated && !parent.isSolutionMode;
        return when()["case"](!evaluationReady, function () {
          return feedback.NOT_EVALUATED;
        })["case"](state.isValid, function () {
          return feedback.RIGHT;
        })["case"](!state.isValid, function () {
          return feedback.WRONG;
        }).resolve();
      } catch (e) {
        return feedback.NOT_EVALUATED;
      }
    },
    get limits() {
      var bulletList = getParent(state);
      return {
        min: state.index === 0 ? 0 : getBulletPosition(state.index - 1, bulletList) + 1,
        max: state.index === 4 ? state.divisions - 1 : getBulletPosition(state.index + 1, bulletList) - 1
      };
    },
    get isWrong() {
      return state.feedbackResult === feedback.WRONG;
    },
    get isSuccess() {
      return state.feedbackResult === feedback.RIGHT;
    }
  };
});
function getBulletPosition(idx, bulletList) {
  return bulletList[idx].position;
}

var BoxplotQuestionStore = types$1.compose(QuestionBaseModel, withShowSolutions, types$1.model({
  bullets: types$1.array(BulletModel$1),
  segments: types$1.array(SegmentModel$1),
  selectedBullet: types$1.optional(types$1.number, -1),
  isPressing: types$1.optional(types$1["boolean"], false),
  isDragging: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    setSelectedBullet: function setSelectedBullet(selectedBullet) {
      state.selectedBullet = selectedBullet;
    },
    reset: function reset() {
      state.baseReset();
      state.bullets.forEach(function (bullet) {
        return bullet.reset();
      });
    },
    normalizeSolutionOutsideLimits: function normalizeSolutionOutsideLimits() {
      var minBullet = state.bullets[0];
      var maxBullet = state.bullets[4];
      if (minBullet.position < 0 || maxBullet.position < 0) {
        var positions = [1, 2, 4, 5, 6];
        var values = positions.map(function (val) {
          return state.segments[val].value;
        });
        state.setResponse(values);
      }
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot$A(rawData);
      state.raw = rawData;
      console.log('hydrateSolutionsPreview', rawData.data.plot.data);
      applySnapshot(state, data);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.number), response)) return false;
      state.bullets.forEach(function (bullet, idx) {
        return bullet.setValue(response[idx]);
      });
      state.normalizeSolutionOutsideLimits();
    }
  };
}).views(function (state) {
  return {
    get min() {
      return state.raw.data.plot.min;
    },
    get max() {
      return state.raw.data.plot.max;
    },
    get divisions() {
      return state.max - state.min;
    },
    get initialBulletsPosition() {
      var totalSegments = state.segments.length;
      return createBullets(totalSegments).map(function (bullet) {
        return bullet.position;
      });
    },
    get initialBulletsValue() {
      return state.initialBulletsPosition.map(function (bullet) {
        return state.segments[bullet].value;
      });
    },
    getUserResponse: function getUserResponse() {
      return state.bullets.map(function (bullet) {
        return bullet.value;
      });
    },
    get bulletSelection() {
      return state.bullets.reduce(function (acc, next) {
        return next.isModified ? [].concat(acc, [next.position]) : acc;
      }, []);
    },
    get currentBulletSelection() {
      return [];
    },
    getResults: function getResults() {
      var rightAnswer = state.validation.value;
      return compareArray(rightAnswer, state.getUserResponse()) ? 1 : 0;
    },
    get bulletsFeedback() {
      return state.bullets.reduce(function (acc, next) {
        return next.isSuccess ? {
          success: acc.success.concat(next.position),
          error: acc.error
        } : {
          success: acc.success,
          error: acc.error.concat(next.position)
        };
      }, {
        success: [],
        error: []
      });
    },
    get labels() {
      var _state$raw$data = state.raw.data,
        shuffle_options = _state$raw$data.shuffle_options,
        plot = _state$raw$data.plot;
      return shuffle_options ? shuffle(plot.data) : plot.data;
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$A(rawData);
    }
  };
}));
function createBullets(totalSegments) {
  var totalBullets = 5;
  var firstPosition = Math.floor(totalSegments / 2) - 2;
  return populate(totalBullets, function (idx) {
    return {
      position: idx + firstPosition
    };
  });
}
function createSegments$2(min, totalSegments) {
  return populate(totalSegments, function (idx) {
    return {
      value: min + idx
    };
  });
}
function _createSnapshot$A(data) {
  var plot = data.data.plot;
  var totalSegments = plot.max - plot.min + 1;
  return _extends({}, data.data, importCommonValues(data), {
    bullets: createBullets(totalSegments),
    segments: createSegments$2(plot.min, totalSegments)
  });
}
function createStore$L(data) {
  return BoxplotQuestionStore.create(_createSnapshot$A(data));
}

function Labels$1(_ref) {
  var labels = _ref.labels;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-boxplot-labels"
  }, labels.map(function (label, idx) {
    var separator = idx < labels.length - 1 ? ', ' : '';
    return /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-label",
      key: label + "__" + idx
    }, label + separator);
  }));
}

function Line$4(_ref) {
  var store = _ref.store;
  var root = useRef();
  var lineApi = useRef();
  useEffect(function () {
    var _lineApi$current;
    var distance = 1;
    var divisions = store.segments.length;
    var min = store.raw.data.plot.min;
    (_lineApi$current = lineApi.current) === null || _lineApi$current === void 0 ? void 0 : _lineApi$current.clear();
    root.current.innerHTML = '';
    lineApi.current = renderNumberLineView(root.current, {
      distance: distance,
      divisions: divisions,
      min: min
    });
  }, [store.min, store.max]);
  useEffect(function () {
    reaction(function () {
      return store.getUserResponse().toString();
    }, function () {
      lineApi.current.clear();
      if (!store.isEvaluated) {
        var _store$bullets$store$;
        var selectedPos = (_store$bullets$store$ = store.bullets[store.selectedBullet]) === null || _store$bullets$store$ === void 0 ? void 0 : _store$bullets$store$.position;
        if (selectedPos !== undefined) {
          lineApi.current.fixValue(store.bulletSelection, selectedPos);
        }
      }
    });
    reaction(function () {
      return store.selectedBullet === -1;
    }, function () {
      lineApi.current.clear();
      if (!store.isEvaluated) {
        lineApi.current.fixValue(store.bulletSelection);
      }
    });
    onAction(store, function (_ref2) {
      var name = _ref2.name;
      if (name === 'reset') {
        return lineApi.current.clear();
      }
      if (name === 'checkAnswers') {
        return lineApi.current.showFeedback(store.bulletsFeedback);
      }
      if (name === 'showSolutions') {
        return lineApi.current.showFeedback(store.bulletsFeedback);
      }
    }, true);
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    ref: root
  });
}
var Line$5 = observer(Line$4);

var isTouch$5 = isTouchDevice();
var eventMove$1 = isTouch$5 ? 'touchmove' : 'mousemove';
var eventUp$1 = isTouch$5 ? 'touchend' : 'mouseup';
var yPosition = 40;
function Bullet$2(_ref) {
  var bullet = _ref.bullet,
    canvas = _ref.canvas,
    _ref$canvasWidth = _ref.canvasWidth,
    canvasWidth = _ref$canvasWidth === void 0 ? 0 : _ref$canvasWidth;
  var bulletRadius = when()["case"](bullet.isSelected, 12)["case"](bullet.isModified, 8)["case"](bullet.isWrong || bullet.isSuccess, 8).resolve(4);
  var _useState = useState(0),
    xPos = _useState[0],
    setXPos = _useState[1];
  useEffect(function () {
    if (canvasWidth > 0) {
      setXPos(canvasWidth * bullet.x / 100);
    }
  }, [canvasWidth, bullet.x]);
  function getCursorPoint(evt) {
    var pt = canvas.current.createSVGPoint();
    var currentEvt = isTouch$5 ? evt.touches[0] : evt;
    pt.x = currentEvt.clientX;
    pt.y = currentEvt.clientY;
    return pt.matrixTransform(canvas.current.getScreenCTM().inverse());
  }
  function getPositionValue(evt) {
    var _getCursorPoint = getCursorPoint(evt),
      x = _getCursorPoint.x;
    var steps = bullet.divisions;
    var stepValue = canvasWidth / steps;
    return Math.round(x / stepValue - 0.5);
  }
  function moveDot(evt) {
    bullet.setPosition(getPositionValue(evt));
    evt.preventDefault();
  }
  function mouseDown() {
    canvas.current.addEventListener(eventMove$1, moveDot, false);
    window.addEventListener(eventUp$1, mouseUp, false);
    bullet.setSelected(true);
  }
  function mouseUp() {
    canvas.current.removeEventListener(eventMove$1, moveDot);
    window.removeEventListener(eventUp$1, mouseUp);
    bullet.setSelected(false);
  }
  return /*#__PURE__*/React__default.createElement("g", {
    className: cn$1('lemo-bullet-group', {
      'lemo-modified': bullet.isModified,
      'lemo-selected': bullet.isSelected,
      'lemo-disabled': bullet.isDisabled,
      'lemo-success': bullet.isSuccess,
      'lemo-error': bullet.isWrong
    })
  }, /*#__PURE__*/React__default.createElement("circle", {
    className: "lemo-bullet-handler",
    r: bulletRadius * 2,
    cy: yPosition,
    transform: "translate(" + xPos + ", 0)",
    onMouseDown: !isTouch$5 ? mouseDown : null,
    onTouchStart: mouseDown
  }), /*#__PURE__*/React__default.createElement("circle", {
    className: "lemo-bullet",
    r: bulletRadius,
    cy: yPosition,
    transform: "translate(" + xPos + ", 0)"
  }));
}
var Bullet$3 = observer(Bullet$2);

function Bullets(_ref) {
  var bullets = _ref.bullets,
    canvas = _ref.canvas,
    canvasWidth = _ref.canvasWidth;
  return bullets.map(function (bullet) {
    return /*#__PURE__*/React__default.createElement(Bullet$3, {
      key: bullet.id,
      bullet: bullet,
      canvas: canvas,
      canvasWidth: canvasWidth
    });
  });
}
var Bullets$1 = observer(Bullets);

var y$1 = 40;
function HorizontalUnions(_ref) {
  var bullets = _ref.bullets;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("line", {
    className: "lemo-horizontal-union",
    x1: bullets[0].x + "%",
    x2: bullets[1].x + "%",
    y1: y$1,
    y2: y$1
  }), /*#__PURE__*/React__default.createElement("line", {
    className: "lemo-horizontal-union",
    x1: bullets[3].x + "%",
    x2: bullets[4].x + "%",
    y1: y$1,
    y2: y$1
  }));
}
var HorizontalUnions$1 = observer(HorizontalUnions);

function Boxes(_ref) {
  var bullets = _ref.bullets;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("rect", {
    className: "lemo-box",
    x: bullets[1].x + "%",
    y: 10,
    width: bullets[2].x - bullets[1].x + "%",
    height: 60
  }), /*#__PURE__*/React__default.createElement("rect", {
    className: "lemo-box",
    x: bullets[2].x + "%",
    y: 10,
    width: bullets[3].x - bullets[2].x + "%",
    height: 60
  }));
}
var Boxes$1 = observer(Boxes);

function Boxplot(_ref) {
  var store = _ref.store;
  var canvas = useRef();
  var _useState = useState(1),
    canvasWidth = _useState[0],
    setCanvasWidth = _useState[1];
  function updateCanvasWidth() {
    setCanvasWidth(canvas.current.clientWidth);
  }
  useLayoutEffect(function () {
    updateCanvasWidth();
    window.addEventListener('resize', updateCanvasWidth, false);
    return function () {
      return window.removeEventListener('resize', updateCanvasWidth);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement("svg", {
    ref: canvas,
    width: "100%",
    height: 80
  }, /*#__PURE__*/React__default.createElement("rect", {
    className: "lemo-canvas-base",
    width: "100%",
    height: "100%",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement(HorizontalUnions$1, {
    bullets: store.bullets
  }), /*#__PURE__*/React__default.createElement(Boxes$1, {
    bullets: store.bullets
  }), /*#__PURE__*/React__default.createElement(Bullets$1, {
    bullets: store.bullets,
    canvas: canvas,
    canvasWidth: canvasWidth
  }));
}
var Boxplot$1 = observer(Boxplot);

function BoxplotQuestion(props) {
  var store = props.store,
    _props$solutionsMode = props.solutionsMode,
    solutionsMode = _props$solutionsMode === void 0 ? false : _props$solutionsMode;
  var changedHandlers = /reset|setSelected|setPosition/;
  useEffect(function () {
    if (solutionsMode) {
      setTimeout(function () {
        props.changed({
          output: {},
          points: 0,
          response: {},
          store: store
        });
      }, 110);
    }
  }, [store.min, store.max]);
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', {
      'lemo-solutions-mode': solutionsMode,
      'lemo-success': store.isSuccess,
      'lemo-error': store.isError,
      'lemo-disabled': store.disabled
    })
  }, !solutionsMode && /*#__PURE__*/React__default.createElement(Labels$1, {
    labels: store.labels
  }), /*#__PURE__*/React__default.createElement(Boxplot$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(Line$5, {
    store: store
  })));
}
var BoxplotQuestion$1 = observer(BoxplotQuestion);

function generateBoxplotData(data) {
  var init = data[0],
    q1 = data[1],
    q2 = data[2],
    q3 = data[3],
    end = data[4];
  return [init, q1, getLowerIntermediateValue(q1, q2), q2, getHigerIntermediateValue(q3, q2), q3, end];
}
function getLowerIntermediateValue(q1, q2) {
  var difference = (q2 - q1) / 2;
  return Math.ceil(q1 + difference);
}
function getHigerIntermediateValue(q3, q2) {
  var difference = (q3 - q2) / 2;
  return Math.floor(q2 + difference);
}

var minDivisions = 8;
var maxDivisions = 16;
var minValue = -99;
var maxValue = 99;

var BoxplotEditorStore = types$1.compose(EditorBaseModel, types$1.model({
  min: types$1.number,
  max: types$1.number,
  ui_style: UIStyleModel$1
}).actions(function (state) {
  return {
    setMin: function setMin(min) {
      state.min = parseInt(min);
      var difference = state.max - state.min;
      if (difference < minDivisions) state.max = state.min + minDivisions;
      if (difference > maxDivisions) state.max = state.min + maxDivisions;
      state.updateNotifier(true);
    },
    setMax: function setMax(max) {
      state.max = parseInt(max);
      var difference = state.max - state.min;
      if (difference < minDivisions) state.min = state.max - minDivisions;
      if (difference > maxDivisions) state.min = state.max - maxDivisions;
      state.updateNotifier(true);
    }
  };
}).views(function (state) {
  return {
    get data() {
      return generateBoxplotData(state.validation.value);
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$B(rawData);
    },
    get output() {
      return exportCommonValues(state, {
        plot: {
          min: state.min,
          max: state.max,
          data: generateBoxplotData(state.validation.value)
        }
      });
    }
  };
}));
function _createSnapshot$B(data) {
  var _data$data$plot = data.data.plot,
    min = _data$data$plot.min,
    max = _data$data$plot.max;
  return _extends({}, data.data, importCommonValues$1(data), {
    min: min,
    max: max
  });
}
function createStore$M(data) {
  var store = BoxplotEditorStore.create(_createSnapshot$B(data));
  return store;
}

var iconTitle = /*#__PURE__*/React__default.createElement(SvgSettingsTipography, {
  width: "24",
  className: "lemo-icon-format-shape"
});
var titleBox = 'boxplot_editor_title';
var helpText = 'boxplot_editor_help';
function EditorBoxplotLimits(_ref) {
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "configuration",
    icon: iconTitle,
    titleBox: translate(titleBox),
    helpText: translate(helpText),
    classNameAdd: "lemo-editor-config"
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: 'lemo-small-input',
    title: translate('boxplot_editor_min_title'),
    subtitle: translate('boxplot_editor_min_description'),
    inputType: 'number',
    value: store.min,
    min: minValue,
    max: maxValue - minDivisions,
    onChange: store.setMin,
    placeholder: translate('title_placeholder')
  }), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: 'lemo-small-input',
    title: translate('boxplot_editor_max_title'),
    subtitle: translate('boxplot_editor_max_description'),
    inputType: 'number',
    value: store.max,
    min: minValue + minDivisions,
    max: maxValue,
    onChange: store.setMax,
    placeholder: translate('title_placeholder')
  })));
}
var EditorBoxplotLimits$1 = observer(EditorBoxplotLimits);

var _excluded$o = ["store", "changed", "type", "immediateFeedback"];
function BoxplotEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$o);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "adItem|addItemToResponse|sortItems|removeItem|removeItemToResponse|setSrc|setLabel|setTheme|setXAxisLabel|setXAxisName|setYAxisName|setYMax|setYMin|setYMultiplier|",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 1
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 2,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(EditorBoxplotLimits$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    hasMultipleResponses: false,
    evaluationTypes: [getEvaluationTypeOption(keysTranslateEvaluationTypes.EXACT_MATCH, keysTranslateSubtitleEvaluationTypes.EXACT_MATCH, validationModes.EXACT_MATCH)],
    helpText: translate('exact_math_or_match_response_or_match_group_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null));
}
var BoxplotEditor$1 = observer(BoxplotEditor);

var idBox$1 = 'FractionShapeEditor';
function FractionShapeEditor(_ref) {
  var store = _ref.store;
  var titleBox = 'fraction_editor';
  var helpText = 'fraction_editor_help';
  var shapeDivisionsConfig = store.shape.shapeDivisionsConfig;
  var listNames = useMemo(function () {
    var shapes = SHAPE_LIST.reduce(function (acc, next) {
      return next !== 'RANDOM' ? [].concat(acc, [translate(next)]) : acc;
    }, []);
    return {
      shapes: shapes,
      themes: COLOR_THEMES.map(translate)
    };
  }, [config.lang]);
  var getTheme = function getTheme(color) {
    return "var(--lemo-" + color + "-out)";
  };
  var colorItemList = useMemo(function () {
    return COLOR_THEMES.map(function (color) {
      return {
        icon: /*#__PURE__*/React__default.createElement("div", {
          className: "lemo-color-pattern-icon",
          style: {
            backgroundColor: getTheme(color)
          }
        }),
        text: translate(color)
      };
    });
  }, [config.lang]);
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: idBox$1,
    icon: /*#__PURE__*/React__default.createElement(SvgMenuAlt, {
      width: "24"
    }),
    titleBox: translate(titleBox),
    helpText: translate(helpText),
    classNameAdd: "lemo-editor-fraction-shape"
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('fractions_shape_editor_title'),
    subtitle: translate('fractions_shape_editor_description'),
    selectedIndex: store.shape.currentShapeIndex,
    itemList: listNames.shapes,
    onChange: store.shape.changeShape
  }), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: shapeDivisionsConfig.isVariable
  }, /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: 'lemo-small-input',
    title: translate('fractions_divisions_editor_title'),
    subtitle: translate('fractions_divisions_editor_description'),
    inputType: 'number',
    min: shapeDivisionsConfig.min,
    max: shapeDivisionsConfig.max,
    value: store.shape.divisions,
    onChange: store.shape.setDivisions,
    placeholder: translate('title_placeholder')
  }), /*#__PURE__*/React__default.createElement(Line1, null)), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: shapeDivisionsConfig.isFixed
  }, /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('fractions_divisions_editor_title'),
    subtitle: translate('fractions_divisions_editor_description'),
    selectedIndex: store.shape.currentDivisionIndex,
    itemList: shapeDivisionsConfig.divisionList,
    onChange: store.shape.changeDivisions
  }), /*#__PURE__*/React__default.createElement(Line1, null)), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-color-selector-dropdown"
  }, /*#__PURE__*/React__default.createElement(EditorDropdownWithIconTitleSubtitle$1, {
    title: translate('select_color_theme_title'),
    subtitle: translate('select_color_theme_description'),
    selectedIndex: store.ui_style.colorThemeIndex,
    itemList: colorItemList,
    onChange: store.ui_style.changeTheme
  }))));
}
var FractionShapeEditor$1 = observer(FractionShapeEditor);

var _excluded$p = ["store", "changed", "type", "immediateFeedback"];
var FractionEditor = function FractionEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$p);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setTitle|setStimulus|setValue|setScore|removeResponseByIdx|setTemplate|sortResponses|destroy|setValidResponse|setColumnCount|setRowCount|addItem|sortDrags|addDrag|setShuffleOptions|setDuplicateResponses|setIsEvaluable|updateSolution|createAlternativeSolution|removeSolution|setBackground|toggleWithBox|toggleStack|setStack|setWithBox|sortColumns",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 1
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 2,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(FractionShapeEditor$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    hasMultipleResponses: false,
    evaluationTypes: [getEvaluationTypeOption(keysTranslateEvaluationTypes.EXACT_MATCH, keysTranslateSubtitleEvaluationTypes.EXACT_MATCH, validationModes.EXACT_MATCH)],
    helpText: translate('exact_math_or_match_response_or_match_group_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null));
};
var FractionEditor$1 = observer(FractionEditor);

function IconImagePicker(_ref) {
  var id = _ref.id,
    imageApiKey = _ref.imageApiKey,
    addImage = _ref.addImage,
    altDescription = _ref.altDescription,
    disabled = _ref.disabled,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value;
  var _useUploadFile = useUploadFile({
      onError: onError,
      onSuccess: onSuccess,
      assetsApi: imageApiKey
    }),
    uploadStatus = _useUploadFile.uploadStatus,
    handleUpload = _useUploadFile.handleUpload;
  function onError(_ref2) {
    var type = _ref2.type;
    console.log('error type', type);
  }
  function onSuccess(_ref3) {
    var source = _ref3.source;
    console.log('done!');
    addImage(source);
  }
  function isDisabled(status) {
    return status === fileStatuses.UPLOADING || status === fileStatuses.FILE_LIMIT;
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-icon-image-picker', {
      'lemo-with-image': value.length > 0
    })
  }, /*#__PURE__*/React__default.createElement(UploadFileWrapper, {
    acceptedFiles: "image/*",
    maxFileSize: "1000000",
    onSelectFile: handleUpload,
    onError: onError,
    disabled: disabled || isDisabled(uploadStatus)
  }, /*#__PURE__*/React__default.createElement(AddImageButton$1, {
    id: id,
    altDescription: altDescription,
    src: value,
    isLoading: uploadStatus === fileStatuses.UPLOADING
  })), /*#__PURE__*/React__default.createElement("img", {
    className: "lemo-image-preview",
    src: value,
    alt: "icon"
  }));
}
var IconImageLoader = observer(IconImagePicker);

function EditorImageTitleSubtitle(_ref) {
  var value = _ref.value,
    addImage = _ref.addImage,
    id = _ref.id,
    imageApiKey = _ref.imageApiKey,
    title = _ref.title,
    subtitle = _ref.subtitle;
  var defaultTitle = translate('change_image_title');
  var defaultSubTitle = translate('change_image_subtitle');
  var altDescription = translate('change_image_alt');
  return /*#__PURE__*/React__default.createElement(EditorTitleSubtitleComponent, {
    title: title || defaultTitle,
    subtitle: subtitle || defaultSubTitle,
    componentRight: /*#__PURE__*/React__default.createElement(IconImageLoader, {
      id: id,
      altDescription: altDescription,
      imageApiKey: imageApiKey,
      addImage: addImage,
      value: value
    })
  });
}

function AddOptions(_ref) {
  var options = _ref.options,
    imageApiKey = _ref.imageApiKey;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-counting-add-options"
  }, /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: 'lemo-small-input',
    title: translate('counting_editor_summand_title') + " #01",
    subtitle: translate('counting_editor_summand_subtitle'),
    inputType: 'number',
    min: 2,
    max: 8,
    value: options[0].value,
    onChange: options[0].setValue,
    placeholder: translate('title_placeholder')
  }), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(EditorImageTitleSubtitle, {
    imageApiKey: imageApiKey,
    id: options[0].id,
    value: options[0].src,
    addImage: options[0].setSrc
  }), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: 'lemo-small-input',
    title: translate('counting_editor_summand_title') + " #02",
    subtitle: translate('counting_editor_summand_subtitle'),
    inputType: 'number',
    min: 2,
    max: 8,
    value: options[1].value,
    onChange: options[1].setValue,
    placeholder: translate('title_placeholder')
  }), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(EditorImageTitleSubtitle, {
    imageApiKey: imageApiKey,
    id: options[1].id,
    value: options[1].src,
    addImage: options[1].setSrc
  }));
}
var AddOptions$1 = observer(AddOptions);

function CountingOptions(_ref) {
  var options = _ref.options,
    imageApiKey = _ref.imageApiKey;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-counting-count-options"
  }, /*#__PURE__*/React__default.createElement(EditorImageTitleSubtitle, {
    imageApiKey: imageApiKey,
    id: options[0].id,
    value: options[0].src,
    addImage: options[0].setSrc
  }), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: 'lemo-small-input',
    title: translate('items_to_show_title'),
    subtitle: translate('items_to_show_description'),
    inputType: 'number',
    min: 2,
    max: 12,
    value: options[0].value,
    onChange: options[0].setValue,
    placeholder: translate('title_placeholder')
  }));
}
var CountOptions = observer(CountingOptions);

function SubtractOptions(_ref) {
  var options = _ref.options,
    imageApiKey = _ref.imageApiKey;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-counting-count-options"
  }, /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: 'lemo-small-input',
    title: translate('minuend_title'),
    subtitle: translate('select_a_quantity'),
    inputType: 'number',
    min: 2,
    max: 8,
    value: options[0].value,
    onChange: options[0].setValue,
    placeholder: translate('title_placeholder')
  }), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(EditorImageTitleSubtitle, {
    imageApiKey: imageApiKey,
    id: options[0].id,
    value: options[0].src,
    addImage: options[0].setSrc
  }));
}
var SubtractOptions$1 = observer(SubtractOptions);

var idBox$2 = 'Table';
var titleBoxRef$1 = 'operations_editor_title';
var titleBoxHelpRef$1 = 'operations_editor_help';
function OperationEditor(_ref) {
  var store = _ref.store;
  var translatedOperationsList = operationList.map(translate);
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: idBox$2,
    icon: /*#__PURE__*/React__default.createElement(SvgMenuAlt, {
      width: "24"
    }),
    titleBox: translate(titleBoxRef$1),
    helpText: translate(titleBoxHelpRef$1),
    classNameAdd: "lemo-editor-counting-operations"
  }, /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('counting_editor_operation_title'),
    subtitle: translate('counting_editor_operation_subtitle'),
    selectedIndex: store.operationIndex,
    itemList: translatedOperationsList,
    onChange: store.setOperationIndex
  }), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: store.operation === ADD$1
  }, /*#__PURE__*/React__default.createElement(AddOptions$1, {
    options: store.options,
    imageApiKey: store.assetsEditorApi
  })), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: store.operation === COUNT$1
  }, /*#__PURE__*/React__default.createElement(CountOptions, {
    options: store.options,
    imageApiKey: store.assetsEditorApi
  })), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: store.operation === SUBTRACT
  }, /*#__PURE__*/React__default.createElement(SubtractOptions$1, {
    options: store.options,
    imageApiKey: store.assetsEditorApi
  })));
}
var OperationsEditor = observer(OperationEditor);

var iconTitle$1 = /*#__PURE__*/React__default.createElement(SvgAdjustments, {
  width: "24",
  className: "lemo-icon-format-shape"
});
var titleBox$1 = 'Configuration';
var helpText$1 = 'config_help';
function CountingEditorConfig(_ref) {
  var _store$ui_style;
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "configuration",
    icon: iconTitle$1,
    helpText: translate(helpText$1),
    titleBox: translate(titleBox$1),
    classNameAdd: "lemo-editor-config"
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, store.operation !== COUNT$1 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ConfigShowCheckIcon, {
    title: translate('show_result_title'),
    subtitle: translate('show_result_subtitle'),
    isChecked: store.showResult,
    onChange: store.setShowResult
  }), config.showAuthorVariantsEditor && /*#__PURE__*/React__default.createElement(Line1, null)), /*#__PURE__*/React__default.createElement(ConfigVariantStyle$1, {
    onChange: function onChange(value) {
      store.ui_style.customClass.setVariant(value.variant);
      store.ui_style.customClass.setClassList(value.classList);
    },
    variantList: store.variants,
    customClass: {
      variant: (_store$ui_style = store.ui_style) === null || _store$ui_style === void 0 ? void 0 : _store$ui_style.customClass.variant,
      classList: store.ui_style.customClass.classList
    }
  })));
}
var CountingEditorConfig$1 = observer(CountingEditorConfig);

var _excluded$q = ["store", "changed", "type", "immediateFeedback"];
function CountingEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$q);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "adItem|addItemToResponse|sortItems|removeItem|removeItemToResponse|setSrc|setLabel|setTheme|setXAxisLabel|setXAxisName|setYAxisName|setYMax|setYMin|setYMultiplier|",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 1
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 2,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(OperationsEditor, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    hasMultipleResponses: false,
    evaluationTypes: [getEvaluationTypeOption(keysTranslateEvaluationTypes.EXACT_MATCH, keysTranslateSubtitleEvaluationTypes.EXACT_MATCH, validationModes.EXACT_MATCH)],
    helpText: translate('exact_math_or_match_response_or_match_group_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(CountingEditorConfig$1, {
    store: store
  }));
}
var CountingEditor$1 = observer(CountingEditor);

function ErrorMessage$1(_ref) {
  var message = _ref.message,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return message ? /*#__PURE__*/React__default.createElement("p", {
    className: "lemo-error-message " + className
  }, message) : null;
}
var ErrorMessage$2 = observer(ErrorMessage$1);

function DraggableListItem(_ref) {
  var dragProvider = _ref.dragProvider,
    item = _ref.item,
    onRemove = _ref.onRemove,
    listLength = _ref.listLength,
    children = _ref.children,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 1 : _ref$min;
  var draggableProps = dragProvider.draggableProps,
    dragHandleProps = dragProvider.dragHandleProps,
    innerRef = dragProvider.innerRef;
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: cn$1('lemo-draggable-list-item'),
    ref: innerRef
  }, draggableProps), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-item-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", _extends({
    className: "lemo-editor-box-list-item-icon"
  }, dragHandleProps), listLength > 1 && /*#__PURE__*/React__default.createElement(SvgDrag, {
    className: "lemo-editor-box-list-item-icon-drag lemo-icon",
    width: 24,
    height: 24
  })), children, listLength > min && /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-delete-button",
    onClick: onRemove
  }, /*#__PURE__*/React__default.createElement(SvgTrash$1, {
    className: "lemo-icon",
    width: 24,
    height: 24
  }))), /*#__PURE__*/React__default.createElement(ErrorMessage$2, {
    className: "lemo-draggable-item-list-error",
    message: translate(item.errorMessage)
  }));
}
var DraggableListItem$1 = observer(DraggableListItem);

var keyIdSortingList = 'id';
function EditorItemList(_ref) {
  var itemList = _ref.itemList,
    onDragItem = _ref.onDragItem,
    onRemoveItem = _ref.onRemoveItem,
    onAddItem = _ref.onAddItem,
    addButtonDisabled = _ref.addButtonDisabled,
    addButtonText = _ref.addButtonText,
    children = _ref.children,
    min = _ref.min,
    _ref$addButtonTooltip = _ref.addButtonTooltipDescription,
    addButtonTooltipDescription = _ref$addButtonTooltip === void 0 ? '' : _ref$addButtonTooltip;
  var listLength = itemList.length;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-item-list"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-horizontal-content-box full-width"
  }, /*#__PURE__*/React__default.createElement(EditorSortingList$1, {
    list: itemList,
    keyId: keyIdSortingList,
    onDragEnd: onDragItem
  }, function (item, provider, index) {
    return /*#__PURE__*/React__default.createElement(DraggableListItem$1, {
      listLength: listLength,
      dragProvider: provider,
      onRemove: function onRemove() {
        return onRemoveItem(index);
      },
      min: min,
      item: item
    }, children(item, index));
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-horizontal-content lemo-editor-horizontal-content--space-between"
  }, /*#__PURE__*/React__default.createElement(SimpleTooltipWrapper, {
    text: addButtonTooltipDescription
  }, /*#__PURE__*/React__default.createElement(AddButton, {
    text: addButtonText,
    onClick: onAddItem,
    disabled: addButtonDisabled
  }))));
}
var EditorItemList$1 = observer(EditorItemList);

function LabelItem(_ref) {
  var item = _ref.item,
    assetsApi = _ref.assetsApi;
  return /*#__PURE__*/React__default.createElement(FroalaField$1, {
    editMode: true,
    assetsFroalaApi: assetsApi,
    content: item.value,
    setContent: item.setValue
  });
}
var LabelItem$1 = observer(LabelItem);

var idBox$3 = 'Table';
var titleBoxRef$2 = 'answer_options';
var titleBoxHelpRef$2 = 'number_line_editor_help';
var maxPointLabels = 3;
function AnswerOptionsEditor(_ref) {
  var pointLabels = _ref.pointLabels,
    assetsApi = _ref.assetsApi;
  var disableAddPointLabels = pointLabels.list.length >= maxPointLabels;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: idBox$3,
    icon: /*#__PURE__*/React__default.createElement(SvgClipboardList, {
      width: "24"
    }),
    titleBox: translate(titleBoxRef$2),
    helpText: translate(titleBoxHelpRef$2),
    classNameAdd: "lemo-editor-line-chart-table"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-answer-options-editor"
  }, /*#__PURE__*/React__default.createElement(EditorItemList$1, {
    itemList: pointLabels.list,
    addButtonText: translate('add_row'),
    addButtonDisabled: disableAddPointLabels,
    onAddItem: pointLabels.addItem,
    onDragItem: pointLabels.sortItems,
    onRemoveItem: pointLabels.removeItem
  }, function (item) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-label-wrapper"
    }, /*#__PURE__*/React__default.createElement(LabelItem$1, {
      item: item,
      assetsApi: assetsApi
    }));
  })));
}
var AnswerOptionsEditor$1 = observer(AnswerOptionsEditor);

var iconTitle$2 = /*#__PURE__*/React__default.createElement(SvgSettingsTipography, {
  width: "24",
  className: "lemo-icon-format-shape"
});
var titleBox$2 = 'Configuration';
var helpText$2 = 'config_help';
var maxDivisions$1 = 21;
function NumberLineEditorConfig(_ref) {
  var _store$ui_style;
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "configuration",
    icon: iconTitle$2,
    titleBox: translate(titleBox$2),
    helpText: translate(helpText$2),
    classNameAdd: "lemo-editor-config"
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: 'lemo-small-input',
    title: translate('number_line_starting_number'),
    subtitle: translate('number_line_starting_number_description'),
    inputType: 'number',
    value: store.line.min,
    onChange: store.line.setMin,
    placeholder: translate('title_placeholder')
  }), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: 'lemo-small-input',
    title: translate('number_line_finishing_number'),
    subtitle: translate('number_line_finishing_number_description'),
    inputType: 'number',
    value: store.line.max,
    onChange: store.line.setMax,
    placeholder: translate('title_placeholder')
  }), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: 'lemo-small-input',
    title: translate('divisions'),
    subtitle: translate('number_line_divisions_description'),
    inputType: 'number',
    min: 3,
    max: maxDivisions$1,
    value: store.line.divisions,
    onChange: store.line.setDivisions,
    placeholder: translate('title_placeholder')
  }), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: 'lemo-small-input',
    title: translate('number_line_distance'),
    subtitle: translate('number_line_distance_description'),
    inputType: 'number',
    min: 1,
    max: maxDivisions$1,
    value: store.labels.frequency,
    onChange: store.labels.setFrequency,
    placeholder: translate('title_placeholder')
  }), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(ConfigShowCheckIcon, {
    title: translate('number_line_fractions'),
    subtitle: translate('number_line_fractions_description'),
    isChecked: store.mode === FRACTION,
    onChange: function onChange(bool) {
      return store.setMode(bool ? FRACTION : NUMBER);
    }
  }), /*#__PURE__*/React__default.createElement(ShowWhen$1, {
    condition: store.mode === FRACTION
  }, /*#__PURE__*/React__default.createElement(Line1, {
    hidden: true
  }), /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: 'lemo-small-input',
    title: translate('number_line_denominator'),
    subtitle: translate('number_line_denominator_description'),
    inputType: 'number',
    value: store.line.denominator,
    onChange: store.line.setDenominator,
    placeholder: translate('title_placeholder')
  }), /*#__PURE__*/React__default.createElement(Line1, {
    hidden: true
  }), /*#__PURE__*/React__default.createElement(ConfigShowCheckIcon, {
    title: translate('number_line_fractions_as_integers'),
    subtitle: translate('number_line_fractions_as_integers_description'),
    isChecked: store.showIntegerValues,
    onChange: store.setShowIntegerValues
  })), config.showAuthorVariantsEditor && /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(ConfigVariantStyle$1, {
    onChange: function onChange(value) {
      store.ui_style.customClass.setVariant(value.variant);
      store.ui_style.customClass.setClassList(value.classList);
    },
    variantList: store.variants,
    customClass: {
      variant: (_store$ui_style = store.ui_style) === null || _store$ui_style === void 0 ? void 0 : _store$ui_style.customClass.variant,
      classList: store.ui_style.customClass.classList
    }
  })));
}
var NumberLineEditorConfig$1 = observer(NumberLineEditorConfig);

var _excluded$r = ["store", "changed", "type", "immediateFeedback"];
function CountingEditor$2(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$r);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "adItem|addItemToResponse|sortItems|removeItem|removeItemToResponse|setSrc|setLabel|setTheme|setXAxisLabel|setXAxisName|setYAxisName|setYMax|setYMin|setYMultiplier|",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 1
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 2,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(AnswerOptionsEditor$1, {
    pointLabels: store.pointLabels,
    assetsApi: getAssetsEditorApi(store.assetsEditorApi)
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    hasMultipleResponses: false,
    evaluationTypes: [getEvaluationTypeOption(keysTranslateEvaluationTypes.EXACT_MATCH, keysTranslateSubtitleEvaluationTypes.EXACT_MATCH, validationModes.EXACT_MATCH)],
    helpText: translate('exact_math_or_match_response_or_match_group_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(NumberLineEditorConfig$1, {
    store: store
  }));
}
var NumberLineEditor = observer(CountingEditor$2);

var iconTitle$3 = /*#__PURE__*/React__default.createElement(SvgAdjustments, {
  width: "24",
  className: "lemo-icon-format-shape"
});
var titleBox$3 = 'Configuration';
var helpText$3 = 'config_help';
function CoordinateAxesConfig(_ref) {
  var _store$ui_style;
  var store = _ref.store;
  if (!config.showAuthorVariantsEditor) return null;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "configuration",
    icon: iconTitle$3,
    titleBox: translate(titleBox$3),
    helpText: translate(helpText$3),
    classNameAdd: "lemo-editor-config"
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement(ConfigVariantStyle$1, {
    onChange: function onChange(value) {
      store.ui_style.customClass.setVariant(value.variant);
      store.ui_style.customClass.setClassList(value.classList);
    },
    variantList: store.variants,
    customClass: {
      variant: (_store$ui_style = store.ui_style) === null || _store$ui_style === void 0 ? void 0 : _store$ui_style.customClass.variant,
      classList: store.ui_style.customClass.classList
    }
  })));
}
var CoordinateAxesConfig$1 = observer(CoordinateAxesConfig);

var gridList = {
  SIZE_5x5: 5,
  SIZE_6X6: 6,
  SIZE_7X7: 7,
  SIZE_8X8: 8,
  SIZE_9X9: 9,
  SIZE_10X10: 10
};

function ConfigGridSize(_ref) {
  var columns = _ref.columns,
    onChange = _ref.onChange;
  var _useState = useState(Object.keys(gridList).map(function (key) {
      return gridList[key] + 'x' + gridList[key];
    })),
    itemList = _useState[0];
  var selectedIndex = useMemo(function () {
    return Object.keys(gridList).findIndex(function (key) {
      return gridList[key] === columns;
    });
  }, [columns]);
  function _onChange(index) {
    if (gridList && index >= 0) {
      var valueChange = gridList[Object.keys(gridList)[index]];
      onChange && onChange(valueChange);
    }
  }
  return /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('editor_coordinate_axes_grid_size_title'),
    subtitle: translate('editor_coordinate_axes_grid_size_subtitle'),
    selectedIndex: selectedIndex,
    onChange: _onChange,
    itemList: itemList
  });
}

function ConfigQuadrant(_ref) {
  var gridFull = _ref.gridFull,
    gridQuadrant = _ref.gridQuadrant,
    setGridFull = _ref.setGridFull,
    setGridQuadrant = _ref.setGridQuadrant;
  var _useState = useState([].concat(Object.keys(quadrantList).map(function (key) {
      return key;
    }), [translate('editor_coordinate_axes_quadrant_all')])),
    itemList = _useState[0];
  var selectedIndex = useMemo(function () {
    return itemList.findIndex(function (key) {
      return gridFull ? key === translate('editor_coordinate_axes_quadrant_all') : key === gridQuadrant;
    });
  }, [gridQuadrant, gridFull]);
  function _onChange(index) {
    if (itemList && index >= 0) {
      var valueChange = itemList[index];
      if (valueChange === translate('editor_coordinate_axes_quadrant_all')) {
        setGridFull(true);
      } else {
        setGridFull(false);
        setGridQuadrant(valueChange);
      }
    }
  }
  return /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('editor_coordinate_axes_quadrant_title'),
    subtitle: translate('editor_coordinate_axes_quadrant_subtitle'),
    selectedIndex: selectedIndex,
    onChange: _onChange,
    itemList: itemList
  });
}

function ConfigDotColor(_ref) {
  var dotColor = _ref.dotColor,
    onChange = _ref.onChange;
  var _useState = useState(themeNames.map(function (key) {
      return {
        text: translate(key.toLowerCase()),
        icon: /*#__PURE__*/React__default.createElement("div", {
          className: 'lemo-editor-theme ' + key,
          style: {
            width: '24px',
            height: '24px',
            borderRadius: '4px'
          }
        })
      };
    })),
    itemList = _useState[0];
  var selectedIndex = useMemo(function () {
    return themeNames.findIndex(function (key) {
      return key === dotColor;
    });
  }, [dotColor]);
  function _onChange(index) {
    if (themeNames && index >= 0) {
      var valueChange = themeNames[index];
      onChange && onChange(valueChange);
    }
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-coordinate-axes-config-dot-color"
  }, /*#__PURE__*/React__default.createElement(EditorDropdownWithIconTitleSubtitle$1, {
    title: translate('editor_coordinate_axes_dot_color_title'),
    subtitle: translate('editor_coordinate_axes_dot_color_subtitle'),
    selectedIndex: selectedIndex,
    onChange: _onChange,
    itemList: itemList,
    additionalMinWidth: 80
  }));
}

var titleBox$4 = 'axis_editor_title';
var helpText$4 = 'axis_editor_help';
function AxisEditor(_ref) {
  var _store$ui_style, _store$ui_style2;
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "configuration",
    icon: /*#__PURE__*/React__default.createElement(SvgMenuAlt, {
      width: "24"
    }),
    titleBox: translate(titleBox$4),
    helpText: translate(helpText$4),
    classNameAdd: "lemo-editor-config"
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement(ConfigGridSize, {
    columns: store.gridSize,
    onChange: store.setGridSize
  }), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(ConfigQuadrant, {
    gridFull: store.gridFull,
    gridQuadrant: store.gridQuadrant,
    setGridFull: store.setGridFull,
    setGridQuadrant: store.setGridQuadrant
  }), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(ConfigDotColor, {
    dotColor: (_store$ui_style = store.ui_style) === null || _store$ui_style === void 0 ? void 0 : _store$ui_style.theme,
    onChange: (_store$ui_style2 = store.ui_style) === null || _store$ui_style2 === void 0 ? void 0 : _store$ui_style2.setTheme
  })));
}
var AxisEditor$1 = observer(AxisEditor);

var _excluded$s = ["store", "changed", "type", "immediateFeedback"];
function CoordinateAxesEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$s);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "adItem|addItemToResponse|sortItems|removeItem|removeItemToResponse|setSrc|setLabel|setTheme|setXAxisLabel|setXAxisName|setYAxisName|setYMax|setYMin|setYMultiplier|removeDot|setGridSize|setGridFull|setGridQuadrant|",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 1
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 2,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(AxisEditor$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    hasMultipleResponses: false,
    evaluationTypes: [getEvaluationTypeOption(keysTranslateEvaluationTypes.EXACT_MATCH, keysTranslateSubtitleEvaluationTypes.EXACT_MATCH, validationModes.EXACT_MATCH)],
    helpText: translate('exact_math_or_match_response_or_match_group_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(CoordinateAxesConfig$1, {
    store: store
  }));
}
var CoordinateAxesEditor$1 = observer(CoordinateAxesEditor);

var EmptyEditorStore = types$1.compose(EditorBaseModel, types$1.model({
  ui_style: types$1.optional(UIStyleModel$1, defaultUIStyle)
}).views(function (state) {
  return {
    get output() {
      return state.raw;
    }
  };
}));
function createSnapshot$a(data) {
  return _extends({}, data.data, importCommonValues$1(data));
}
function createStore$N(data) {
  var store = EmptyEditorStore.create(createSnapshot$a(data));
  return store;
}

var CELL_SIZE = 50;

function Cell(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'lemo-operation-cell ' + className,
    style: {
      width: CELL_SIZE,
      height: CELL_SIZE
    }
  }, children);
}
var Cell$1 = observer(Cell);

function CellOperationInput(_ref) {
  var id = _ref.id,
    className = _ref.className,
    value = _ref.value,
    maxLength = _ref.maxLength,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? noop : _ref$onFocus,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? noop : _ref$onBlur,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled;
  var element = useRef(null);
  function handleChange(e) {
    var value = e.target.value;
    if (isNaN(value)) return;
    onChange(e.target.value);
  }
  function handleKeyDown(e) {
    var key = e.key;
    var allowedKeys = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Backspace', 'Delete'];
    if (!key.match(/[0-9]/) && !allowedKeys.includes(key)) {
      e.preventDefault();
    }
    var value = element.current.value;
    if (value.length === maxLength && key === value) {
      e.preventDefault();
      onChange(value);
    }
  }
  useEffect(function () {
    var currentValue = element.current.value;
    if (currentValue.length > 0 && currentValue === '') {
      element.current.value = '';
      onChange('');
    }
  }, [value]);
  return /*#__PURE__*/React__default.createElement("input", {
    id: id,
    ref: element,
    role: "textbox",
    className: 'lemo-cell-input ' + className,
    onKeyDown: handleKeyDown,
    onChange: handleChange,
    onFocus: onFocus,
    onBlur: onBlur,
    value: value,
    size: maxLength,
    disabled: isDisabled,
    maxLength: maxLength,
    style: {
      width: CELL_SIZE - 2,
      height: CELL_SIZE - 2
    }
  });
}
var CellOperationInput$1 = observer(CellOperationInput);

function FlagButton(_ref) {
  var onClick = _ref.onClick,
    isDisabled = _ref.isDisabled;
  return /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-flag-button",
    disabled: isDisabled,
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(SvgTrash, {
    className: "lemo-icon",
    width: '1.25em'
  }));
}
var FlagButton$1 = observer(FlagButton);

function setFocusById(id, selectContent) {
  if (selectContent === void 0) {
    selectContent = false;
  }
  if (!id) return;
  setTimeout(function () {
    return focusElement(id, selectContent);
  }, 10);
}
function focusElement(id, selectContent) {
  if (selectContent === void 0) {
    selectContent = false;
  }
  var inputElement = document.getElementById(id);
  if (inputElement) {
    inputElement.focus();
    selectContent && inputElement.select();
  }
}

function AnnotationCell(_ref) {
  var annotation = _ref.annotation,
    isDisabled = _ref.isDisabled,
    onFullFilled = _ref.onFullFilled;
  var isEmpty = annotation.value.length === 0;
  var _useState = useState(false),
    active = _useState[0],
    setActive = _useState[1];
  function onClickFlagButton() {
    setActive(true);
    setFocusById(annotation.id, true);
    setTimeout(function () {
      annotation.activeKeyboard();
    }, 10);
  }
  function onInputBlur(e) {
    if (e.target.value.length === 0) {
      setActive(false);
    }
    annotation.disableKeyboard();
  }
  function handleChange(value) {
    if (value.length === 2) onFullFilled(annotation);
    annotation.setValue(value);
  }
  useEffect(function () {
    if (annotation.value.length === 2) onFullFilled(annotation);
    if (annotation.value.length === 0) setActive(false);
  }, [annotation.value]);
  useEffect(function () {
    if (isDisabled && annotation.value.length === 0) setActive(false);
  }, [isDisabled]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-annotation-cell', {
      'lemo-is-empty': isEmpty,
      'lemo-is-active': active
    })
  }, isEmpty && !active ? /*#__PURE__*/React__default.createElement(FlagButton$1, {
    onClick: onClickFlagButton,
    isDisabled: isDisabled
  }) : /*#__PURE__*/React__default.createElement(CellOperationInput$1, {
    id: annotation.id,
    className: "lemo-h3-medium lemo-color-text-04",
    onChange: handleChange,
    onBlur: onInputBlur,
    onFocus: onClickFlagButton,
    value: annotation.value,
    maxLength: 2
  }));
}
var AnnotationCell$1 = observer(AnnotationCell);

function AnnotationsRow(_ref) {
  var annotations = _ref.annotations,
    annotationEnabledRange = _ref.annotationEnabledRange,
    onAnnotationFullFilled = _ref.onAnnotationFullFilled;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-flags-row",
    "data-testid": "annotationsRow"
  }, annotations.map(function (annotation) {
    var hasAnnotation = typeof annotation !== 'string';
    var isDisabled = annotationEnabledRange < annotation.index;
    var key = hasAnnotation ? annotation.id : annotation;
    return /*#__PURE__*/React__default.createElement(Cell$1, {
      className: "lemo-row",
      key: key
    }, hasAnnotation ? /*#__PURE__*/React__default.createElement(AnnotationCell$1, {
      annotation: annotation,
      onFullFilled: onAnnotationFullFilled,
      isDisabled: isDisabled
    }) : null);
  }));
}
var AnnotationsRow$1 = observer(AnnotationsRow);

function ResponseCell(_ref) {
  var response = _ref.response,
    maxLength = _ref.maxLength,
    isDisabled = _ref.isDisabled,
    selectNextResponse = _ref.selectNextResponse;
  var isEmpty = response.value.length === 0;
  var _useState = useState(false),
    active = _useState[0],
    setActive = _useState[1];
  function onInputFocus(e) {
    setActive(true);
    e.target.select();
    response.activeKeyboard();
  }
  function handleChange(value) {
    if (value.length > 0) selectNextResponse();
    response.setValue(value);
  }
  function onInputBlur(e) {
    if (e.target.value.length === 0) {
      setActive(false);
    }
    response.disableKeyboard();
  }
  useEffect(function () {
    if (response.value.length > 0) selectNextResponse();
  }, [response.value]);
  useEffect(function () {
    if (isDisabled && response.value.length === 0) setActive(false);
  }, [isDisabled, response.value]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-response-cell', {
      'lemo-disabled': isDisabled,
      'lemo-success': response.isSuccess,
      'lemo-error': response.isError
    })
  }, isEmpty && !active && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-icon"
  }), /*#__PURE__*/React__default.createElement(CellOperationInput$1, {
    id: response.id,
    className: "lemo-h1-medium lemo-color-text-02",
    onChange: handleChange,
    value: response.value,
    onFocus: onInputFocus,
    onBlur: onInputBlur,
    isDisabled: isDisabled,
    maxLength: maxLength
  }));
}
var ResponseCell$1 = observer(ResponseCell);

function clearFocus() {
  if (document.activeElement) {
    document.activeElement.blur();
  }
}

function ResponseRow(_ref) {
  var responses = _ref.responses,
    currentColumn = _ref.currentColumn,
    selectColumn = _ref.selectColumn,
    isDisabled = _ref.isDisabled;
  function _selectNextResponse(response) {
    selectColumn(response.index + 1);
    setTimeout(function () {
      response.nextResponseId ? setFocusById(response.nextResponseId, true) : clearFocus();
    }, 50);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-flags-row",
    "data-testid": "responseRow"
  }, responses.map(function (response) {
    var hasResponseCell = isResponseCell(response);
    var key = hasResponseCell ? response.id : response;
    return /*#__PURE__*/React__default.createElement(Cell$1, {
      className: "lemo-row",
      key: key
    }, hasResponseCell ? /*#__PURE__*/React__default.createElement(ResponseCell$1, {
      response: response,
      maxLength: 1,
      selectNextResponse: function selectNextResponse() {
        return _selectNextResponse(response);
      },
      isDisabled: response.index > currentColumn || isDisabled
    }) : null);
  }));
}
function isResponseCell(response) {
  return typeof response !== 'string';
}
var ResponseRow$1 = observer(ResponseRow);

function EmptyRow(_ref) {
  var row = _ref.row;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-empty-row",
    "data-testid": "emptyRow"
  }, row.map(function (cell) {
    return /*#__PURE__*/React__default.createElement(Cell$1, {
      className: "lemo-row",
      key: cell
    });
  }));
}
var EmptyRow$1 = observer(EmptyRow);

function OperandRow(_ref) {
  var operand = _ref.operand,
    _ref$crossOut = _ref.crossOut,
    crossOut = _ref$crossOut === void 0 ? noop : _ref$crossOut;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'lemo-operand-row',
    "data-testid": "operandRow"
  }, operand.map(function (cell, idx) {
    return /*#__PURE__*/React__default.createElement(Cell$1, {
      key: "operand-" + idx
    }, crossOut(idx) && /*#__PURE__*/React__default.createElement("svg", {
      className: "lemo-cross-out",
      width: CELL_SIZE,
      height: CELL_SIZE
    }, /*#__PURE__*/React__default.createElement("line", {
      x1: 10,
      x2: 40,
      y1: 40,
      y2: 10
    })), /*#__PURE__*/React__default.createElement("span", {
      className: "lemo-h1-medium lemo-color-text-02"
    }, cell));
  }));
}
var OperandRow$1 = observer(OperandRow);

function Grid(_ref) {
  var width = _ref.width,
    height = _ref.height;
  var xLines = populate(width + 1, function (idx) {
    return "xlines_" + idx;
  });
  var yLines = populate(height + 1, function (idx) {
    return "ylines_" + idx;
  });
  var operationLineIndex = yLines.length - 3;
  return /*#__PURE__*/React__default.createElement("svg", {
    "data-testid": "grid",
    className: "lemo-grid",
    width: width * CELL_SIZE,
    height: height * CELL_SIZE
  }, xLines.map(function (line, idx) {
    return /*#__PURE__*/React__default.createElement("line", {
      key: line,
      x1: idx * CELL_SIZE,
      y1: 0,
      x2: idx * CELL_SIZE,
      y2: height * CELL_SIZE,
      className: "lemo-grid-line"
    });
  }), yLines.map(function (line, idx) {
    return /*#__PURE__*/React__default.createElement("line", {
      key: line,
      x1: 0,
      y1: idx * CELL_SIZE,
      x2: width * CELL_SIZE,
      y2: idx * CELL_SIZE,
      className: cn$1('lemo-grid-line', {
        'lemo-operation-line': idx === operationLineIndex
      })
    });
  }));
}
var Grid$1 = observer(Grid);

function VisualHelp(_ref) {
  var currentColumn = _ref.currentColumn;
  var right = (currentColumn + 1) * CELL_SIZE;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-visual-help",
    "data-testid": "visualHelp",
    style: {
      right: right
    }
  });
}

function OperationSign(_ref) {
  var sign = _ref.sign;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-operation-sign",
    "data-testid": "operationSign",
    style: {
      width: CELL_SIZE,
      height: CELL_SIZE,
      bottom: CELL_SIZE * 2,
      left: 0
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-h1-medium lemo-color-text-01"
  }, sign));
}
var OperationSign$1 = observer(OperationSign);

function SumQuestion(props) {
  var store = props.store,
    onKeyboardVisible = props.onKeyboardVisible,
    autoFocus = props.autoFocus;
  var changedHandlers = /reset|setValue/;
  useEffect(function () {
    if (autoFocus === autoFocusTypes.ENABLED) {
      setFocusById(store.responses[0].id);
    }
  }, []);
  useEffect(function () {
    if (!store.disabled) setFocusById(store.responses[0].id);
  }, [store.disabled]);
  function onAnnotationFullFilled(annotation) {
    var annotationColumn = annotation.index + 1;
    var response = store.responses[annotationColumn];
    setFocusById(response.id, true);
  }
  function handleKeyboardDelete(e) {
    var value = store.keyboard.value;
    var newValue = value.toString().slice(1);
    store.keyboard.forceValue(value.length > 0 ? newValue : '');
    e.preventDefault();
  }
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body lemo-vertical-operation-question', {
      'lemo-disabled': store.disabled
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-operation-wrapper",
    style: {
      width: store.gridSize.width * CELL_SIZE,
      height: store.gridSize.height * CELL_SIZE
    }
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    width: store.gridSize.width,
    height: store.gridSize.height
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-operation",
    style: {
      width: store.gridSize.width * CELL_SIZE,
      height: store.gridSize.height * CELL_SIZE
    }
  }, /*#__PURE__*/React__default.createElement(AnnotationsRow$1, {
    annotations: store.annotationList,
    annotationEnabledRange: store.annotationEnabledRange,
    onAnnotationFullFilled: onAnnotationFullFilled
  }), store.operands.map(function (operand, idx) {
    return /*#__PURE__*/React__default.createElement(OperandRow$1, {
      key: "operan_" + idx,
      operand: operand
    });
  }), /*#__PURE__*/React__default.createElement(ResponseRow$1, {
    isDisabled: store.disabled,
    responses: store.responseList,
    currentColumn: store.currentColumn,
    selectColumn: store.selectColumn
  }), /*#__PURE__*/React__default.createElement(EmptyRow$1, {
    row: store.row
  }), /*#__PURE__*/React__default.createElement(OperationSign$1, {
    sign: store.sign
  }), store.showVisualHelp && /*#__PURE__*/React__default.createElement(VisualHelp, {
    currentColumn: store.currentColumn
  }))), /*#__PURE__*/React__default.createElement(LemonadeKeyboard$1, {
    type: store.keyboard.type,
    keyboardStore: store.keyboard,
    isActive: store.disabled ? false : store.keyboard.isActive,
    handleDelete: handleKeyboardDelete,
    onKeyboardVisible: onKeyboardVisible
  })));
}
var SumQuestion$1 = observer(SumQuestion);

function withCustomInputKeyboard(_ref) {
  var maxLength = _ref.maxLength;
  return types$1.model({}).actions(function (state) {
    return {
      activeKeyboard: function activeKeyboard() {
        state.keyboard.start({
          id: state.id,
          value: state.value,
          setValue: state.setValue,
          maxLength: maxLength
        });
      },
      disableKeyboard: function disableKeyboard() {
        if (state.keyboard.activeFieldId === state.id) {
          state.keyboard.finish();
        }
      }
    };
  });
}

function checkEmptyOrZero(_ref) {
  var index = _ref.index,
    value = _ref.value,
    reverseSolution = _ref.reverseSolution;
  var currentValue = reverseSolution[index];
  var _value = value === '' ? '0' : value.toString();
  if (currentValue !== '0' || currentValue !== _value) return false;
  return reverseSolution.slice(index).reverse().reduce(function (acc, next) {
    return next !== '0' ? false : acc;
  }, true);
}

var ResponseModel$7 = types$1.compose(ValueModel, withCustomInputKeyboard({
  maxLength: 1
}), types$1.model('ResponseModel', {}).views(function (state) {
  return {
    get keyboard() {
      return getParent(state, 2).keyboard;
    },
    get rightValue() {
      var _getParent$getSolutio = getParent(state, 2).getSolutions(),
        value = _getParent$getSolutio.value;
      return value[state.index];
    },
    get isValid() {
      var _getParent = getParent(state, 2),
        reverseSolution = _getParent.reverseSolution;
      var currentValue = reverseSolution[state.index];
      var emptyOrZero = checkEmptyOrZero({
        index: state.index,
        value: state.value,
        reverseSolution: reverseSolution
      });
      return emptyOrZero || currentValue === state.value;
    },
    get feedbackResult() {
      if (!isAlive(state)) return feedback.NOT_EVALUATED;
      try {
        var parent = getParent(state, 2);
        var evaluationReady = parent.isEvaluated;
        var isSuccess = state.isValid;
        return when()["case"](!evaluationReady, function () {
          return feedback.NOT_EVALUATED;
        })["case"](!isSuccess, function () {
          return feedback.WRONG;
        })["case"](isSuccess, function () {
          return feedback.RIGHT;
        }).resolve();
      } catch (e) {
        console.log(e);
        return feedback.NOT_EVALUATED;
      }
    },
    get isSuccess() {
      return state.feedbackResult === feedback.RIGHT;
    },
    get isError() {
      return state.feedbackResult === feedback.WRONG;
    },
    get isEmpty() {
      return state.value.length === '';
    },
    get nextResponseId() {
      var _getParent2 = getParent(state, 2),
        responses = _getParent2.responses;
      var nextIndex = state.index + 1;
      return responses.length > nextIndex ? responses[nextIndex].id : undefined;
    }
  };
}));

var AnnotationModel = types$1.compose(ValueModel, withCustomInputKeyboard({
  maxLength: 2
}), types$1.model('AnnotationModel', {}).views(function (state) {
  return {
    get keyboard() {
      return getParent(state, 2).keyboard;
    },
    get rightValue() {
      var _getParent$getSolutio = getParent(state, 2).getSolutions(),
        annotations = _getParent$getSolutio.annotations;
      return annotations[state.index];
    }
  };
}));

function getSign(operationName) {
  var eq = function eq(value) {
    return value === operationName;
  };
  return when()["case"](eq('Addition'), function () {
    return '+';
  })["case"](eq('Subtraction'), function () {
    return '−';
  })["case"](eq('Multiplication'), function () {
    return 'x';
  })["case"](eq('Division'), function () {
    return '÷';
  }).resolve('');
}

var VerticalOperationQuestionStore = types$1.compose(QuestionBaseModel, withHasLemonadeKeyboard, types$1.model({
  responses: types$1.array(ResponseModel$7),
  annotations: types$1.array(AnnotationModel),
  currentColumn: 0,
  keyboard: types$1.optional(KeyboardStore, {})
}).actions(function (state) {
  return {
    clearAnnotations: function clearAnnotations() {
      state.annotations.forEach(function (r) {
        return r.setValue('');
      });
    },
    clearResponses: function clearResponses() {
      state.responses.forEach(function (r) {
        return r.setValue('');
      });
    },
    reset: function reset() {
      state.baseReset();
      state.clearResponses();
      state.clearAnnotations();
      state.currentColumn = 0;
    },
    selectColumn: function selectColumn(column) {
      if (column < state.maxOperandLength) {
        state.currentColumn = Math.max(column, state.currentColumn);
        return;
      }
      state.currentColumn = state.maxOperandLength + 1;
    },
    enableAllColumns: function enableAllColumns() {
      state.currentColumn = state.row.length;
    },
    setResponse: function setResponse(_response) {
      var _response$annotations;
      var defaultAnnotations = state.annotations.map(function () {
        return '';
      });
      var response = hasKey('annotations', _response) ? _response : _extends({}, _response, {
        annotations: defaultAnnotations
      });
      var responseModel = types$1.model({
        value: types$1.string,
        annotations: types$1.array(types$1.string)
      });
      if (!response || !response.value || !response.annotations) return false;
      if (!typeChecker(responseModel, response)) return false;
      if (!response.value) return false;
      if ((response === null || response === void 0 ? void 0 : (_response$annotations = response.annotations) === null || _response$annotations === void 0 ? void 0 : _response$annotations.length) !== state.annotations.length) return false;
      state.clearResponses();
      state.clearAnnotations();
      state.enableAllColumns();
      var validResponseLength = state.getSolutions().length;
      var normalizedResponseValue = response.value.padStart(validResponseLength, '_');
      state.responses = setResponseValue(normalizedResponseValue);
      state.annotations = response.annotations.map(function (a) {
        return {
          value: a
        };
      }).reverse();
    }
  };
}).views(function (state) {
  return {
    get sign() {
      return getSign(state.name);
    },
    get operation() {
      return state.raw.data.operation;
    },
    get maxOperandLength() {
      return getOperatorsLength(state.operation.operands);
    },
    get row() {
      return populate(state.maxOperandLength + 2, function (idx) {
        return "cell_" + idx;
      });
    },
    get gridSize() {
      return {
        width: state.row.length,
        height: state.operation.operands.length + 3
      };
    },
    get operands() {
      var operands = state.operation.operands;
      return state.ui_style.order_terms ? operands.slice().sort(function (a, b) {
        return b - a;
      }) : operands;
    },
    get annotationList() {
      return [];
    },
    get responseList() {
      return state.row.map(function (cell, idx) {
        if (idx === 0) return cell;
        if (idx > state.responses.length) return cell;
        return state.responses[idx - 1];
      }).reverse();
    },
    getValidResponses: function getValidResponses() {
      return {
        value: '',
        annotations: []
      };
    },
    getSolutions: function getSolutions() {
      return '0';
    },
    get reverseSolution() {
      return state.getSolutions().toString().split('').reverse();
    },
    createSnapshot: function createSnapshot(rawData) {
      return rawData;
    },
    getResults: function getResults() {
      return state.getSolutions().toString() === state.getUserResponse().value ? 1 : 0;
    },
    getUserResponse: function getUserResponse() {
      if (state.showSolution) return state.cacheResponse;
      return {
        value: state.responses.map(function (r) {
          return r.value === '' ? '_' : r.value;
        }).reverse().join(''),
        annotations: state.annotations.map(function (r) {
          return r.value;
        }).reverse()
      };
    },
    get configShowColumnHelpValue() {
      return false;
    },
    get showVisualHelp() {
      var columnVisualHelp = state.ui_style.column_help !== undefined ? state.ui_style.column_help : state.configShowColumnHelpValue;
      if (state.disabled) return false;
      if (!columnVisualHelp) return false;
      return state.currentColumn < state.maxOperandLength + 1;
    }
  };
}));
function getOperatorsLength(operands) {
  return Math.max.apply(Math, operands).toString().length;
}
function setResponseValue(value) {
  return value.split('').reverse().map(function (v) {
    return {
      value: v === '_' ? '' : v
    };
  });
}

function getSumAnnotations(operands) {
  var maxLength = Math.max.apply(Math, operands).toString().split('').slice(1);
  return maxLength.reduce(function (acc, next, index) {
    var sum = getVerticalSumAtPosition(index, operands);
    return [getNumberPosition(1, sum).toString()].concat(acc);
  }, []);
}
function getVerticalSumAtPosition(index, operands) {
  var values = operands.map(function (operand) {
    return getNumberPosition(index, operand);
  });
  return values.reduce(function (acc, value) {
    return acc + value;
  }, 0);
}
function getNumberPosition(position, num) {
  var multiplier = Math.pow(10, position);
  return Math.floor(num / multiplier) % 10;
}

function getOperandArray(row, operand) {
  var operandLength = operand.toString().length;
  var headLength = row.length - (operandLength + 1);
  return [].concat(populate(headLength, function () {
    return '';
  }), operand.toString().split(''), ['']);
}

var SumQuestionStore = types$1.compose(VerticalOperationQuestionStore, withXAPITypeFillIn$1({
  xAPISolution: function xAPISolution(state) {
    return state.getSolutions();
  }
}), types$1.model({}).views(function (state) {
  return {
    get annotationEnabledRange() {
      return state.isEvaluated ? -1 : state.currentColumn - 1;
    },
    get annotationList() {
      var reverseList = state.annotations.slice().reverse();
      return state.row.map(function (cell, idx) {
        if (idx === 0) return cell;
        if (idx > reverseList.length) return cell;
        return reverseList[idx - 1];
      });
    },
    get operands() {
      var operands = state.operation.operands;
      var orderTerms = state.ui_style.order_terms ? operands.slice().sort(function (a, b) {
        return b - a;
      }) : operands;
      return orderTerms.map(function (operand) {
        return getOperandArray(state.row, operand);
      });
    },
    getValidResponses: function getValidResponses() {
      return {
        value: state.getSolutions(),
        annotations: getSumAnnotations(state.operation.operands)
      };
    },
    getSolutions: function getSolutions() {
      var operands = state.operation.operands;
      return operands.reduce(function (acc, operand) {
        return acc + operand;
      }, 0).toString();
    },
    get reverseSolution() {
      return state.getSolutions().toString().split('').reverse();
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$C(rawData);
    },
    getResults: function getResults() {
      return state.getSolutions().toString() === state.getUserResponse().value ? 1 : 0;
    },
    get configShowColumnHelpValue() {
      var sum = normalizedTypes.math_sum.value;
      return config.configExercise[sum].showColumnHelp;
    }
  };
}));
function _createSnapshot$C(data) {
  var operands = data.data.operation.operands;
  var validation = data.data.validation;
  var responseLength = getResponseLength(operands);
  var maxOperandLength = getOperatorsLength$1(operands);
  var annotationsLength = maxOperandLength - 1;
  var validationValue = operands.reduce(function (acc, operand) {
    return acc + operand;
  }, 0).toString();
  return _extends({}, data.data, importCommonValues(data), {
    responses: populate(responseLength, function () {
      return {
        value: ''
      };
    }),
    annotations: populate(annotationsLength, function () {
      return {
        value: ''
      };
    }),
    validation: produce$1(validation, function (draft) {
      draft.valid_response.value = {
        value: validationValue,
        annotations: getSumAnnotations(operands)
      };
    })
  });
}
function getResponseLength(operands) {
  return operands.reduce(function (acc, next) {
    return acc + next;
  }, 0).toString().length;
}
function getOperatorsLength$1(operands) {
  return Math.max.apply(Math, operands).toString().length;
}
function createStore$O(data) {
  return SumQuestionStore.create(_createSnapshot$C(data));
}

var CustomUIStyles = types$1.compose(BaseModel$1, types$1.model({
  column_help: types$1.optional(types$1["boolean"], true),
  order_terms: types$1.optional(types$1["boolean"], true),
  keyboard: types$1.frozen({
    type: 'NUMERICAL',
    isFloating: false
  })
}).actions(function (state) {
  return {
    setColumnHelp: function setColumnHelp(value) {
      state.column_help = value;
      getParent(state).updateNotifier();
    },
    setOrderTerms: function setOrderTerms(value) {
      state.order_terms = value;
      getParent(state).updateNotifier();
    }
  };
}));

var FunctionsEditorStore = types$1.compose(EditorBaseModel, types$1.model({
  responses: types$1.array(ValueModel),
  isDynamic: types$1["boolean"],
  addendCount: types$1.number,
  digitsPerAddend: types$1.number,
  ui_style: CustomUIStyles
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      onAction(state, function (_ref) {
        var name = _ref.name;
        if (name === 'setValue') {
          state.setDigitsPerAddend(getHigerNum(state.responses));
          state.updateNotifier();
        }
      }, false);
    },
    setDynamicOperation: function setDynamicOperation(value) {
      state.isDynamic = value;
      state.updateNotifier();
    },
    setDigitsPerAddend: function setDigitsPerAddend(value) {
      state.digitsPerAddend = value.toString().length;
    },
    addResponse: function addResponse() {
      var valueLength = state.higerResponseValue.toString().length;
      var value = generateRandomNumberWithDigits(valueLength);
      state.responses.push(ValueModel.create({
        value: value
      }));
      state.addendCount = state.responses.length;
      state.setDigitsPerAddend(getHigerNum(state.responses));
      state.updateNotifier();
    },
    removeResponse: function removeResponse(index) {
      state.responses.splice(index, 1);
      state.addendCount = state.responses.length;
      state.setDigitsPerAddend(getHigerNum(state.responses));
      state.updateNotifier();
    },
    sortResponse: function sortResponse(source, destination) {
      state.responses = sortArrayItem(source, destination, state.responses);
      state.updateNotifier();
    },
    updateAddendCount: function updateAddendCount(value) {
      var val = normalizeValue(value, state.addendCountLimits);
      state.addendCount = val;
      state.responses = populate(val, function () {
        return {
          value: generateRandomNumberWithDigits(state.digitsPerAddend)
        };
      });
      state.updateNotifier();
    },
    updateDigitsPerAddend: function updateDigitsPerAddend(value) {
      var val = normalizeValue(value, state.digitsPerAddendLimits);
      state.digitsPerAddend = val;
      state.updateAddendCount(state.addendCount);
      state.updateNotifier();
    }
  };
}).views(function (state) {
  return {
    get operationType() {
      return state.raw.data.operation.type;
    },
    get isSum() {
      return state.operationType === 'Addition';
    },
    get isSubtraction() {
      return state.operationType === 'Subtraction';
    },
    get addendCountLimits() {
      return {
        min: 2,
        max: 5
      };
    },
    get digitsPerAddendLimits() {
      return {
        min: 1,
        max: 6
      };
    },
    get higerResponseValue() {
      return getHigerNum(state.responses);
    },
    get maxValuePerAddend() {
      return 999999;
    },
    get output() {
      var sortOperands = state.isSubtraction || state.ui_style.order_terms;
      var operands = state.responses.map(function (response) {
        return parseInt(response.value);
      });
      var sortedOperands = state.responses.map(function (response) {
        return parseInt(response.value);
      }).sort(function (a, b) {
        return b - a;
      });
      return omit(['isDynamic', 'addendCount', 'digitsPerAddend'], exportCommonValues(state, {
        operation: {
          type: state.operationType,
          operands: sortOperands ? sortedOperands : operands
        }
      }));
    }
  };
}));
function getHigerNum(list) {
  return Math.max.apply(Math, list.map(function (item) {
    return parseInt(item.value);
  }));
}
function normalizeValue(value, limits) {
  return Math.min(Math.max(parseInt(value), limits.min), limits.max);
}
function createSnapshot$b(data) {
  var _data$data = data.data,
    operation = _data$data.operation,
    ui_style = _data$data.ui_style;
  var addendCount = operation.operands.length;
  var responses = operation.operands.map(function (operand) {
    return {
      value: operand
    };
  });
  var digitsPerAddend = getHigerNum(responses).toString().length;
  return _extends({}, data.data, importCommonValues$1(data), {
    ui_style: ui_style,
    addendCount: addendCount,
    digitsPerAddend: digitsPerAddend,
    responses: responses,
    isDynamic: true
  });
}
function createStore$P(data) {
  var store = FunctionsEditorStore.create(createSnapshot$b(data));
  return store;
}

function SubtractionQuestion(props) {
  var store = props.store,
    onKeyboardVisible = props.onKeyboardVisible,
    autoFocus = props.autoFocus;
  var changedHandlers = /reset|setValue/;
  useEffect(function () {
    if (autoFocus === autoFocusTypes.ENABLED) {
      setFocusById(store.responses[0].id);
    }
  }, []);
  useEffect(function () {
    if (!store.disabled) setFocusById(store.responses[0].id);
  }, [store.disabled]);
  function onAnnotationFullFilled(annotation) {
    var annotationColumn = annotation.index;
    var response = store.responses[annotationColumn];
    setFocusById(response.id, true);
  }
  function handleKeyboardDelete(e) {
    var value = store.keyboard.value;
    var newValue = value.toString().slice(1);
    store.keyboard.forceValue(value.length > 0 ? newValue : '');
    e.preventDefault();
  }
  function crossOutItemIndex(index) {
    var _index = index - 1;
    var len = store.annotations.length;
    if (_index < 0 || index > len) return false;
    return store.annotations[len - index].value.length > 0;
  }
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body lemo-vertical-operation-question', {
      'lemo-disabled': store.disabled
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-operation-wrapper",
    style: {
      width: store.gridSize.width * CELL_SIZE,
      height: store.gridSize.height * CELL_SIZE
    }
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    width: store.gridSize.width,
    height: store.gridSize.height
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-operation",
    style: {
      width: store.gridSize.width * CELL_SIZE,
      height: store.gridSize.height * CELL_SIZE
    }
  }, /*#__PURE__*/React__default.createElement(AnnotationsRow$1, {
    annotations: store.annotationList,
    annotationEnabledRange: store.annotationEnabledRange,
    onAnnotationFullFilled: onAnnotationFullFilled
  }), /*#__PURE__*/React__default.createElement(OperandRow$1, {
    operand: store.minuend,
    crossOut: crossOutItemIndex
  }), /*#__PURE__*/React__default.createElement(OperandRow$1, {
    operand: store.subtrahend
  }), /*#__PURE__*/React__default.createElement(ResponseRow$1, {
    isDisabled: store.disabled,
    responses: store.responseList,
    currentColumn: store.currentColumn,
    selectColumn: store.selectColumn
  }), /*#__PURE__*/React__default.createElement(EmptyRow$1, {
    row: store.row
  }), /*#__PURE__*/React__default.createElement(OperationSign$1, {
    sign: store.sign
  }), store.showVisualHelp && /*#__PURE__*/React__default.createElement(VisualHelp, {
    currentColumn: store.currentColumn
  }))), /*#__PURE__*/React__default.createElement(LemonadeKeyboard$1, {
    type: store.keyboard.type,
    keyboardStore: store.keyboard,
    isActive: store.disabled ? false : store.keyboard.isActive,
    handleDelete: handleKeyboardDelete,
    onKeyboardVisible: onKeyboardVisible
  })));
}
var SubtractionQuestion$1 = observer(SubtractionQuestion);

function getSubtractionAnnotation(operands) {
  var maxLength = Math.max.apply(Math, operands).toString().length - 1;
  var iteration = function iteration(_ref) {
    var _ref$rest = _ref.rest,
      rest = _ref$rest === void 0 ? 0 : _ref$rest,
      _ref$result = _ref.result,
      result = _ref$result === void 0 ? [] : _ref$result,
      index = _ref.index;
    if (index < 0) return result.reverse();
    var idx = maxLength - index;
    var minuend = getNumberPosition$1(idx, operands[0]) - rest;
    var subtrahend = getNumberPosition$1(idx, operands[1]);
    var _rest = minuend < subtrahend ? 1 : 0;
    var _result = index === 0 ? minuend : getAnnotation(minuend, subtrahend, 0);
    return iteration({
      rest: _rest,
      result: [].concat(result, [_result]),
      index: index - 1
    });
  };
  return iteration({
    operands: operands,
    index: maxLength
  });
}
function getAnnotation(a, b, r) {
  var _a = a - r;
  return _a < b ? _a + 10 : _a;
}
function getNumberPosition$1(position, num) {
  var multiplier = Math.pow(10, position);
  return Math.floor(num / multiplier) % 10;
}

var SubtractionQuestionStore = types$1.compose(VerticalOperationQuestionStore, withXAPITypeFillIn$1({
  xAPISolution: function xAPISolution(state) {
    return state.getSolutions();
  }
}), types$1.model({}).views(function (state) {
  return {
    get annotationEnabledRange() {
      return state.isEvaluated ? -1 : state.currentColumn;
    },
    get annotationList() {
      var reverseList = state.annotations.slice().reverse();
      return state.row.map(function (cell, idx) {
        if (idx === 0) return cell;
        if (idx > reverseList.length) return cell;
        return reverseList[idx - 1];
      });
    },
    get operands() {
      var operands = state.operation.operands;
      var orderTerms = state.ui_style.order_terms ? operands.slice().sort(function (a, b) {
        return b - a;
      }) : operands;
      return orderTerms.map(function (operand) {
        return getOperandArray(state.row, operand);
      });
    },
    get minuend() {
      return state.operands[0];
    },
    get subtrahend() {
      return state.operands[1];
    },
    get annotationsResponse() {
      var operands = state.operation.operands;
      var minuend = operands[0].toString().split('');
      var annotations = getSubtractionAnnotation(operands);
      return annotations.map(function (annotation, idx) {
        var _annotation = annotation.toString();
        return _annotation === minuend[idx] ? '' : _annotation;
      });
    },
    getValidResponses: function getValidResponses() {
      return {
        value: state.getSolutions(),
        annotations: state.annotationsResponse
      };
    },
    getSolutions: function getSolutions() {
      var operands = state.operation.operands;
      var result = (operands[0] - operands[1]).toString();
      return result.length < state.maxOperandLength ? result.padStart(state.maxOperandLength, '0').toString() : result;
    },
    get reverseSolution() {
      return state.getSolutions().toString().split('').reverse();
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$D(rawData);
    },
    getResults: function getResults() {
      var formatValue = state.getUserResponse().value.replace(/_/g, '0');
      return state.getSolutions().toString() === formatValue ? 1 : 0;
    },
    get configShowColumnHelpValue() {
      var subtraction = normalizedTypes.math_subtraction.value;
      return config.configExercise[subtraction].showColumnHelp;
    }
  };
}));
function _createSnapshot$D(data) {
  var operands = data.data.operation.operands;
  var validation = data.data.validation;
  var responseLength = getResponseLength$1(operands);
  var maxOperandLength = getOperatorsLength$2(operands);
  var validationValue = operands[0] - operands[1];
  return _extends({}, data.data, importCommonValues(data), {
    responses: populate(responseLength, function () {
      return {
        value: ''
      };
    }),
    annotations: populate(maxOperandLength, function () {
      return {
        value: ''
      };
    }),
    validation: produce$1(validation, function (draft) {
      draft.valid_response.value = {
        value: validationValue,
        annotations: getSubtractionAnnotation(operands).map(function (annotation) {
          return annotation.toString();
        })
      };
    })
  });
}
function getResponseLength$1(operands) {
  return Math.max.apply(Math, operands).toString().length;
}
function getOperatorsLength$2(operands) {
  return Math.max.apply(Math, operands).toString().length;
}
function createStore$Q(data) {
  return SubtractionQuestionStore.create(_createSnapshot$D(data));
}

var HORIZONTAL$3 = 'HORIZONTAL';
var VERTICAL$1 = 'VERTICAL';
var NONE$1 = 'NONE';

function LineCreator(_ref) {
  var quantity = _ref.quantity,
    orientation = _ref.orientation,
    markMiddleLine = _ref.markMiddleLine,
    _ref$highLighted = _ref.highLighted,
    highLighted = _ref$highLighted === void 0 ? null : _ref$highLighted,
    _ref$overflow = _ref.overflow,
    overflow = _ref$overflow === void 0 ? 0 : _ref$overflow;
  var lineList = populate(quantity, function (x) {
    return x * (100 / (quantity - 1));
  });
  var keyName = orientation + "-line}";
  var midLine = markMiddleLine ? Math.ceil(quantity / 2) - 1 : null;
  var highValue = 100 + overflow + "%";
  var horientationClassName = orientation === HORIZONTAL$3 ? 'lemo-grid-line-horizontal' : 'lemo-grid-line-vertical';
  var getLinePosition = function getLinePosition(idx) {
    var position = lineList[idx];
    return orientation === HORIZONTAL$3 ? {
      x1: position + "%",
      x2: position + "%",
      y1: -overflow + "%",
      y2: highValue
    } : {
      x1: -overflow + "%",
      x2: highValue,
      y1: position + "%",
      y2: position + "%"
    };
  };
  return lineList.map(function (_, idx) {
    return /*#__PURE__*/React__default.createElement("line", _extends({
      key: keyName + "-" + idx,
      className: cn('lemo-grid-line', horientationClassName, {
        'lemo-grid-line-symmetry': idx === midLine,
        'lemo-highlighted': idx === highLighted
      })
    }, getLinePosition(idx)));
  });
}

function Grid$2(_ref) {
  var grid = _ref.grid,
    isEvaluated = _ref.isEvaluated,
    result = _ref.result;
  var width = grid.width,
    height = grid.height,
    symmetry = grid.symmetry;
  return /*#__PURE__*/React__default.createElement("svg", {
    className: "lemo-grid",
    "data-testid": "grid",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React__default.createElement(LineCreator, {
    quantity: height + 1,
    orientation: VERTICAL$1,
    markMiddleLine: symmetry === VERTICAL$1
  }), /*#__PURE__*/React__default.createElement(LineCreator, {
    quantity: width + 1,
    orientation: HORIZONTAL$3,
    markMiddleLine: symmetry === HORIZONTAL$3
  }), isEvaluated && /*#__PURE__*/React__default.createElement("rect", {
    "data-testid": "feedbackBorder",
    className: cn('lemo-feedback-border', {
      'lemo-success': result === 1,
      'lemo-error': result < 1
    }),
    width: "100%",
    height: "100%"
  }));
}
var Grid$3 = observer(Grid$2);

function DrawPolygon(_ref) {
  var points = _ref.points,
    theme = _ref.theme,
    isStatic = _ref.isStatic,
    result = _ref.result;
  var colorMode = isStatic ? 'out' : 'over';
  return /*#__PURE__*/React__default.createElement("polygon", {
    fill: "var(--lemo-" + theme + "-" + colorMode + ")",
    points: points,
    className: cn$1('lemo-polygon', {
      'lemo-user-element': !isStatic,
      'lemo-success': result === feedback.RIGHT,
      'lemo-error': result === feedback.WRONG
    })
  });
}
var DrawPolygon$1 = observer(DrawPolygon);

var cellSize = 25;
var TRANSLATION = 'TRANSLATION';
var ROTATION = 'ROTATION';
var SYMMETRY = 'SYMMETRY';

var labelPositions = {
  LEFT: {
    dx: -18,
    dy: 5
  },
  RIGHT: {
    dx: 18,
    dy: 5
  },
  TOP: {
    dx: 5,
    dy: -18
  },
  BOTTOM: {
    dx: 5,
    dy: 18
  },
  TOP_LEFT: {
    dx: -14,
    dy: -14
  },
  TOP_RIGHT: {
    dx: 14,
    dy: -14
  },
  BOTTOM_LEFT: {
    dx: -14,
    dy: 14
  },
  BOTTOM_RIGHT: {
    dx: 14,
    dy: 14
  }
};
function DrawPivot(_ref) {
  var x = _ref.x,
    y = _ref.y,
    label = _ref.label,
    pivotPosition = _ref.pivotPosition,
    rotation = _ref.rotation,
    isFlipped = _ref.isFlipped;
  var _labelPositions$pivot = labelPositions[pivotPosition],
    dx = _labelPositions$pivot.dx,
    dy = _labelPositions$pivot.dy;
  var _useState = useState(null),
    textCenter = _useState[0],
    setTextCenter = _useState[1];
  var textElement = useRef(null);
  var flip = isFlipped ? -1 : 1;
  var rotate = useMemo(function () {
    return when()["case"](rotation === 1, function () {
      return 3;
    })["case"](rotation === 3, function () {
      return 1;
    }).resolve(function () {
      return rotation;
    });
  }, [rotation]);
  var style = useMemo(function () {
    return textElement.current && {
      transform: "\n        rotate(" + rotate * 90 + "deg)\n        scaleX(" + flip + ")",
      transformOrigin: textCenter.x + "px " + textCenter.y + "px"
    };
  }, [rotate, flip, textCenter]);
  useEffect(function () {
    if (textElement.current !== null) {
      var box = textElement.current.getBBox();
      setTextCenter({
        x: box.x + box.width / 2,
        y: box.y + box.height / 2
      });
    }
  }, [textElement.current]);
  return /*#__PURE__*/React__default.createElement("g", {
    className: "lemo-figure-pivot"
  }, /*#__PURE__*/React__default.createElement("circle", {
    cx: x,
    cy: y,
    r: 5
  }), /*#__PURE__*/React__default.createElement("text", {
    ref: textElement,
    x: x,
    y: y,
    dx: dx,
    dy: dy,
    dominantBaseline: "middle",
    style: style || {}
  }, label));
}
var DrawPivot$1 = observer(DrawPivot);

function Figure$2(_ref) {
  var figure = _ref.figure,
    _ref$isStatic = _ref.isStatic,
    isStatic = _ref$isStatic === void 0 ? false : _ref$isStatic;
  var currentFigure = isStatic ? figure.initialData : figure;
  var x = currentFigure.x,
    y = currentFigure.y,
    rotation = currentFigure.rotation,
    isFlipped = currentFigure.isFlipped;
  var figureWidth = figure.width * cellSize;
  var figureHeight = figure.height * cellSize;
  var figureCenter = figure.centerCoordinates;
  var xPos = x * cellSize;
  var yPos = y * cellSize;
  var showPivot = isStatic && figure.pivot.position !== null;
  var style = {
    transform: "\n      translate(" + xPos + "px, " + yPos + "px)\n      " + (isFlipped ? 'scaleX(-1)' : '') + "\n    ",
    transformOrigin: 'center'
  };
  var rotationTransform = "rotate(" + rotation * 90 + "deg)";
  return /*#__PURE__*/React__default.createElement("svg", {
    "data-testid": isStatic ? 'staticFigure' : 'interactiveFigure',
    id: isStatic ? "static_" + figure.id : figure.id,
    className: "lemo-figure-container",
    width: figureWidth,
    height: figureHeight,
    style: style
  }, /*#__PURE__*/React__default.createElement("g", {
    style: {
      transform: rotationTransform,
      transformOrigin: "\n          " + figureCenter.x * cellSize + "px \n          " + figureCenter.y * cellSize + "px"
    }
  }, /*#__PURE__*/React__default.createElement(DrawPolygon$1, {
    points: figure.points,
    rotation: rotation,
    theme: figure.theme,
    result: figure.currentFeedback,
    isStatic: isStatic
  }), showPivot && /*#__PURE__*/React__default.createElement(DrawPivot$1, {
    x: figure.pivotX * cellSize,
    y: figure.pivotY * cellSize,
    pivotPosition: figure.pivotPosition,
    label: figure.pivotLabel,
    rotation: currentFigure.rotation,
    isFlipped: currentFigure.isFlipped
  })));
}
var Figure$3 = observer(Figure$2);

function KeyButton(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    isDisabled = _ref.isDisabled,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'keyButton' : _ref$testId;
  return /*#__PURE__*/React__default.createElement("button", {
    className: 'lemo-key-button ' + className,
    "data-testid": testId,
    onClick: onClick,
    disabled: isDisabled
  }, children);
}
var KeyButton$1 = observer(KeyButton);

function FigureControls(_ref) {
  var controls = _ref.controls;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-figure-controls",
    "data-testid": "figureControls"
  }, /*#__PURE__*/React__default.createElement(KeyButton$1, {
    className: 'lemo-flip-horizontal',
    onClick: controls.flipHorizontal,
    testId: 'flip-horizontal'
  }, /*#__PURE__*/React__default.createElement(SwitchHorizontal, {
    className: 'lemo-icon'
  })), /*#__PURE__*/React__default.createElement(KeyButton$1, {
    className: 'lemo-flip-vertical',
    onClick: controls.flipVertical,
    testId: 'flip-vertical'
  }, /*#__PURE__*/React__default.createElement(SwitchHorizontal$1, {
    className: 'lemo-icon'
  })), /*#__PURE__*/React__default.createElement(KeyButton$1, {
    className: 'lemo-rotate',
    onClick: controls.rotate,
    testId: 'rotate'
  }, /*#__PURE__*/React__default.createElement(SvgRefresh, {
    className: 'lemo-icon'
  })), /*#__PURE__*/React__default.createElement(KeyButton$1, {
    className: 'lemo-left',
    isDisabled: !controls.canMoveLeft,
    onClick: function onClick() {
      return controls.moveLeft();
    },
    testId: 'move-left'
  }, /*#__PURE__*/React__default.createElement(SvgArrowSmRight, {
    className: 'lemo-icon',
    style: {
      transform: 'rotate(180deg)'
    }
  })), /*#__PURE__*/React__default.createElement(KeyButton$1, {
    className: 'lemo-right',
    onClick: function onClick() {
      return controls.moveRight();
    },
    isDisabled: !controls.canMoveRight,
    testId: 'move-right'
  }, /*#__PURE__*/React__default.createElement(SvgArrowSmRight, {
    className: 'lemo-icon'
  })), /*#__PURE__*/React__default.createElement(KeyButton$1, {
    className: 'lemo-up',
    onClick: function onClick() {
      return controls.moveUp();
    },
    isDisabled: !controls.canMoveUp,
    testId: 'move-up'
  }, /*#__PURE__*/React__default.createElement(SvgArrowSmRight, {
    className: 'lemo-icon',
    style: {
      transform: 'rotate(-90deg)'
    }
  })), /*#__PURE__*/React__default.createElement(KeyButton$1, {
    className: 'lemo-down',
    onClick: function onClick() {
      return controls.moveDown();
    },
    isDisabled: !controls.canMoveDown,
    testId: 'move-down'
  }, /*#__PURE__*/React__default.createElement(SvgArrowSmRight, {
    className: 'lemo-icon',
    style: {
      transform: 'rotate(90deg)'
    }
  })));
}
var FigureControls$1 = observer(FigureControls);

function FeedbackIcon(_ref) {
  var isSuccess = _ref.isSuccess,
    isError = _ref.isError;
  if (!(isSuccess || isError)) return null;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-feedback-icon"
  }, when()["case"](isSuccess, function () {
    return /*#__PURE__*/React__default.createElement(SvgCheckCircle, {
      className: "lemo-success-icon",
      "data-testid": "successIcon"
    });
  })["case"](isError, function () {
    return /*#__PURE__*/React__default.createElement(SvgXCircle, {
      className: "lemo-error-icon",
      "data-testid": "errorIcon"
    });
  }).resolve(function () {
    return null;
  }));
}

var TABLE_POSITION_ABOVE$2 = 'lemo-table_position_above';
var TABLE_POSITION_BELOW$2 = 'lemo-table_position_below';
var TABLE_POSITION_LEFT$2 = 'lemo-table_position_left';
var TABLE_POSITION_RIGHT$2 = 'lemo-table_position_right';
var ABOVE$2 = 'ABOVE';
var BELOW$2 = 'BELOW';
var LEFT$3 = 'LEFT';
var RIGHT$9 = 'RIGHT';

function RotationReference(_ref) {
  var coords = _ref.coords;
  var x = coords.x * cellSize - 5 + "px";
  var y = coords.y * cellSize - 5 + "px";
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "rotationReference",
    className: "lemo-rotation-reference",
    style: {
      transform: "translate(" + x + ", " + y + ")"
    }
  });
}

var isTouch$6 = isTouchDevice();
function Vector(_ref) {
  var vector = _ref.vector;
  var container = useRef();
  var _useState = useState(undefined),
    bounds = _useState[0],
    setBounds = _useState[1];
  var _useState2 = useState(undefined),
    shiftPosition = _useState2[0],
    setShiftPosition = _useState2[1];
  var _useState3 = useState(false),
    isHover = _useState3[0],
    setHover = _useState3[1];
  var _useVectorDrag = useVectorDrag({
      clickStart: onClickStart,
      clickEnd: onClickEnd,
      updatePosition: noop
    }),
    handleDown = _useVectorDrag.handleDown,
    handleUp = _useVectorDrag.handleUp,
    handleMove = _useVectorDrag.handleMove,
    isDragging = _useVectorDrag.isDragging;
  function onClickStart(e) {
    var _bounds = container.current.getBoundingClientRect();
    setBounds(_bounds);
    setShiftPosition(getShiftPosition(e, _bounds));
  }
  function onClickEnd() {
    setShiftPosition(undefined);
    setBounds(undefined);
  }
  function getShiftPosition(e, _bounds) {
    if (_bounds === void 0) {
      _bounds = bounds;
    }
    var rect = container.current.querySelector('rect');
    var coords = getMouseSvg(e, _bounds);
    return {
      x: coords.x - rect.x.baseVal.value,
      y: coords.y - rect.y.baseVal.value
    };
  }
  function normalizeCoords(e) {
    var coordsHolder = e.touches ? e.touches[0] : e;
    return {
      x: coordsHolder.clientX,
      y: coordsHolder.clientY
    };
  }
  function getMouseSvg(e, _bounds) {
    if (_bounds === void 0) {
      _bounds = bounds;
    }
    var coords = normalizeCoords(e);
    return {
      x: coords.x - _bounds.left,
      y: coords.y - _bounds.top
    };
  }
  function updatePosition(e) {
    var coords = getMouseSvg(e);
    var updatedCoords = {
      x: Math.ceil((coords.x + 0.5 - shiftPosition.x) / cellSize),
      y: Math.ceil((coords.y + 0.5 - shiftPosition.y) / cellSize)
    };
    vector.setPosition(updatedCoords);
  }
  return /*#__PURE__*/React__default.createElement("svg", {
    ref: container,
    "data-testid": "vector",
    className: cn('lemo-vector', {
      'lemo-hover': isHover,
      'lemo-dragging': isDragging
    }),
    width: '100%',
    height: '100%',
    onMouseMove: function onMouseMove(e) {
      return isDragging ? updatePosition(e) : noop();
    }
  }, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("marker", {
    id: "arrowhead",
    markerWidth: "9",
    markerHeight: "16",
    refX: "4",
    refY: "4",
    orient: "auto"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0,0L7.998,7.998L0.019,15.977"
  }))), /*#__PURE__*/React__default.createElement("line", {
    x1: vector.head.x * cellSize,
    y1: vector.head.y * cellSize,
    x2: vector.tail.x * cellSize,
    y2: vector.tail.y * cellSize,
    markerEnd: "url(#arrowhead)"
  }), /*#__PURE__*/React__default.createElement("rect", {
    className: "lemo-bounds",
    onMouseDown: !isTouch$6 ? handleDown : null,
    onTouchStart: handleDown,
    onMouseUp: !isTouch$6 ? handleUp : null,
    onTouchEnd: handleUp,
    onTouchMove: handleMove,
    onMouseOver: function onMouseOver() {
      return setHover(true);
    },
    onMouseOut: function onMouseOut() {
      return !isDragging && setHover(false);
    },
    x: vector.bounds.transformHandlerX * cellSize,
    y: vector.bounds.transformHandlerY * cellSize,
    width: vector.bounds.transformHandlerWidth * cellSize,
    height: vector.bounds.transformHandlerHeight * cellSize,
    fill: 'transparent'
  }));
}
var Vector$1 = observer(Vector);

function TransformationsInPlaneQuestion(props) {
  var store = props.store;
  var changedHandlers = /reset|setValue|moveLeft|moveRight|moveDown|moveUp|rotate|flipVertical|flipHorizontal/;
  var result = store.getResults();
  function checkPosition(position) {
    if (store.grid.width > 10) return undefined;
    return store.ui_style.controls_position === position;
  }
  var grid = store.grid;
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', {
      'lemo-disabled': store.disabled
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-columns-layout', {
      'lemo-position-right': checkPosition(RIGHT$9),
      'lemo-position-left': checkPosition(LEFT$3)
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-main-contents-block"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-canvas",
    style: {
      width: grid.width * cellSize,
      height: grid.height * cellSize
    }
  }, /*#__PURE__*/React__default.createElement(Grid$3, {
    grid: store.grid,
    isEvaluated: store.isEvaluated,
    result: result
  }), /*#__PURE__*/React__default.createElement(Figure$3, {
    figure: store.figure,
    grid: store.grid,
    isStatic: true
  }), /*#__PURE__*/React__default.createElement(Figure$3, {
    figure: store.figure,
    grid: store.grid
  }), store.vector && /*#__PURE__*/React__default.createElement(Vector$1, {
    vector: store.vector
  }), store.rotationPivot !== null && /*#__PURE__*/React__default.createElement(RotationReference, {
    coords: store.rotationPivot
  }), store.isEvaluated && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-feedback-icon-position"
  }, /*#__PURE__*/React__default.createElement(FeedbackIcon, {
    isSuccess: result === 1,
    isError: result < 1
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-controls-block"
  }, /*#__PURE__*/React__default.createElement(FigureControls$1, {
    controls: store.controls
  })))));
}
var TransformationsInPlaneQuestion$1 = observer(TransformationsInPlaneQuestion);

var LEFT$4 = 'LEFT';
var RIGHT$a = 'RIGHT';
var TOP_LEFT$1 = 'TOP_LEFT';
var TOP_RIGHT$1 = 'TOP_RIGHT';
var BOTTOM_LEFT$1 = 'BOTTOM_LEFT';
var BOTTOM_RIGHT$1 = 'BOTTOM_RIGHT';

var defaultGeometry = [{
  center: {
    x: 1.5,
    y: 1.5
  },
  geometry: [{
    x: 0,
    y: 0,
    pivotPosition: LEFT$4
  }, {
    x: 1,
    y: 0,
    pivotPosition: RIGHT$a
  }, {
    x: 1,
    y: 1,
    pivotPosition: TOP_RIGHT$1
  }, {
    x: 3,
    y: 1,
    pivotPosition: RIGHT$a
  }, {
    x: 3,
    y: 3,
    pivotPosition: RIGHT$a
  }, {
    x: 0,
    y: 3,
    pivotPosition: LEFT$4
  }]
}, {
  center: {
    x: 1.5,
    y: 1.5
  },
  geometry: [{
    x: 0,
    y: 0,
    pivotPosition: LEFT$4
  }, {
    x: 2,
    y: 0,
    pivotPosition: RIGHT$a
  }, {
    x: 2,
    y: 1,
    pivotPosition: TOP_RIGHT$1
  }, {
    x: 3,
    y: 1,
    pivotPosition: RIGHT$a
  }, {
    x: 3,
    y: 3,
    pivotPosition: RIGHT$a
  }, {
    x: 0,
    y: 3,
    pivotPosition: LEFT$4
  }, {
    x: 0,
    y: 2,
    pivotPosition: LEFT$4
  }, {
    x: 1,
    y: 2,
    pivotPosition: TOP_LEFT$1
  }, {
    x: 1,
    y: 1,
    pivotPosition: BOTTOM_LEFT$1
  }, {
    x: 0,
    y: 1,
    pivotPosition: LEFT$4
  }]
}, {
  center: {
    x: 1.5,
    y: 1.5
  },
  geometry: [{
    x: 1,
    y: 0,
    pivotPosition: LEFT$4
  }, {
    x: 2,
    y: 0,
    pivotPosition: RIGHT$a
  }, {
    x: 2,
    y: 1,
    pivotPosition: TOP_RIGHT$1
  }, {
    x: 3,
    y: 1,
    pivotPosition: RIGHT$a
  }, {
    x: 3,
    y: 3,
    pivotPosition: RIGHT$a
  }, {
    x: 0,
    y: 3,
    pivotPosition: LEFT$4
  }, {
    x: 0,
    y: 2,
    pivotPosition: TOP_LEFT$1
  }, {
    x: 1,
    y: 2,
    pivotPosition: TOP_LEFT$1
  }]
}, {
  center: {
    x: 1.5,
    y: 1.5
  },
  geometry: [{
    x: 0,
    y: 0,
    pivotPosition: LEFT$4
  }, {
    x: 2,
    y: 0,
    pivotPosition: RIGHT$a
  }, {
    x: 2,
    y: 1,
    pivotPosition: TOP_RIGHT$1
  }, {
    x: 3,
    y: 1,
    pivotPosition: RIGHT$a
  }, {
    x: 3,
    y: 2,
    pivotPosition: RIGHT$a
  }, {
    x: 2,
    y: 2,
    pivotPosition: BOTTOM_RIGHT$1
  }, {
    x: 2,
    y: 3,
    pivotPosition: RIGHT$a
  }, {
    x: 1,
    y: 3,
    pivotPosition: LEFT$4
  }, {
    x: 1,
    y: 2,
    pivotPosition: BOTTOM_LEFT$1
  }, {
    x: 0,
    y: 2,
    pivotPosition: LEFT$4
  }]
}, {
  center: {
    x: 1.5,
    y: 1.5
  },
  geometry: [{
    x: 0,
    y: 0,
    pivotPosition: LEFT$4
  }, {
    x: 1,
    y: 0,
    pivotPosition: RIGHT$a
  }, {
    x: 1,
    y: 1,
    pivotPosition: TOP_RIGHT$1
  }, {
    x: 2,
    y: 1,
    pivotPosition: RIGHT$a
  }, {
    x: 2,
    y: 2,
    pivotPosition: TOP_RIGHT$1
  }, {
    x: 3,
    y: 2,
    pivotPosition: RIGHT$a
  }, {
    x: 3,
    y: 3,
    pivotPosition: RIGHT$a
  }, {
    x: 0,
    y: 3,
    pivotPosition: LEFT$4
  }]
}, {
  center: {
    x: 1.5,
    y: 1.5
  },
  geometry: [{
    x: 0,
    y: 0,
    pivotPosition: LEFT$4
  }, {
    x: 1,
    y: 0,
    pivotPosition: RIGHT$a
  }, {
    x: 1,
    y: 1,
    pivotPosition: TOP_RIGHT$1
  }, {
    x: 2,
    y: 1,
    pivotPosition: RIGHT$a
  }, {
    x: 2,
    y: 2,
    pivotPosition: TOP_RIGHT$1
  }, {
    x: 3,
    y: 2,
    pivotPosition: RIGHT$a
  }, {
    x: 3,
    y: 3,
    pivotPosition: RIGHT$a
  }, {
    x: 1,
    y: 3,
    pivotPosition: LEFT$4
  }, {
    x: 1,
    y: 2,
    pivotPosition: BOTTOM_LEFT$1
  }, {
    x: 0,
    y: 2,
    pivotPosition: LEFT$4
  }]
}, {
  center: {
    x: 1.5,
    y: 1.5
  },
  geometry: [{
    x: 0,
    y: 0,
    pivotPosition: LEFT$4
  }, {
    x: 2,
    y: 0,
    pivotPosition: RIGHT$a
  }, {
    x: 2,
    y: 1,
    pivotPosition: TOP_RIGHT$1
  }, {
    x: 3,
    y: 1,
    pivotPosition: RIGHT$a
  }, {
    x: 3,
    y: 3,
    pivotPosition: RIGHT$a
  }, {
    x: 0,
    y: 3,
    pivotPosition: LEFT$4
  }]
}, {
  center: {
    x: 1.5,
    y: 1.5
  },
  geometry: [{
    x: 0,
    y: 0,
    pivotPosition: LEFT$4
  }, {
    x: 2,
    y: 0,
    pivotPosition: RIGHT$a
  }, {
    x: 2,
    y: 1,
    pivotPosition: TOP_RIGHT$1
  }, {
    x: 1,
    y: 1,
    pivotPosition: TOP_RIGHT$1
  }, {
    x: 1,
    y: 2,
    pivotPosition: TOP_RIGHT$1
  }, {
    x: 3,
    y: 2,
    pivotPosition: TOP_RIGHT$1
  }, {
    x: 3,
    y: 3,
    pivotPosition: RIGHT$a
  }, {
    x: 0,
    y: 3,
    pivotPosition: LEFT$4
  }]
}, {
  center: {
    x: 1.5,
    y: 1.5
  },
  geometry: [{
    x: 0,
    y: 0,
    pivotPosition: LEFT$4
  }, {
    x: 1,
    y: 0,
    pivotPosition: RIGHT$a
  }, {
    x: 1,
    y: 1,
    pivotPosition: TOP_RIGHT$1
  }, {
    x: 3,
    y: 1,
    pivotPosition: RIGHT$a
  }, {
    x: 3,
    y: 2,
    pivotPosition: RIGHT$a
  }, {
    x: 2,
    y: 2,
    pivotPosition: BOTTOM_RIGHT$1
  }, {
    x: 2,
    y: 3,
    pivotPosition: RIGHT$a
  }, {
    x: 1,
    y: 3,
    pivotPosition: LEFT$4
  }, {
    x: 1,
    y: 2,
    pivotPosition: BOTTOM_LEFT$1
  }, {
    x: 0,
    y: 2,
    pivotPosition: LEFT$4
  }]
}, {
  center: {
    x: 1.5,
    y: 1.5
  },
  geometry: [{
    x: 0,
    y: 0,
    pivotPosition: LEFT$4
  }, {
    x: 2,
    y: 0,
    pivotPosition: RIGHT$a
  }, {
    x: 2,
    y: 1,
    pivotPosition: TOP_RIGHT$1
  }, {
    x: 3,
    y: 1,
    pivotPosition: RIGHT$a
  }, {
    x: 3,
    y: 3,
    pivotPosition: RIGHT$a
  }, {
    x: 0,
    y: 3,
    pivotPosition: BOTTOM_RIGHT$1
  }]
}];

var FigureModel = types$1.model({
  id: types$1.optional(types$1.identifier, function () {
    return uuid();
  }),
  x: types$1.number,
  y: types$1.number,
  rotation: types$1.number,
  isFlipped: types$1["boolean"]
}).actions(function (state) {
  return {
    moveLeft: function moveLeft() {
      state.x -= 1;
    },
    moveRight: function moveRight() {
      state.x += 1;
    },
    moveDown: function moveDown() {
      state.y += 1;
    },
    moveUp: function moveUp() {
      state.y -= 1;
    },
    rotate: function rotate() {
      state.isFlipped ? state.adjustRotation(-1) : state.adjustRotation(1);
    },
    adjustRotation: function adjustRotation(inc) {
      var range = 4;
      state.rotation = (state.rotation + inc + range) % range;
    },
    flipVertical: function flipVertical() {
      state.isFlipped ? state.adjustRotation(-2) : state.adjustRotation(2);
      state.isFlipped = !state.isFlipped;
    },
    flipHorizontal: function flipHorizontal() {
      state.isFlipped = !state.isFlipped;
    },
    reset: function reset() {
      var _state$initialData = state.initialData,
        x = _state$initialData.x,
        y = _state$initialData.y,
        rotation = _state$initialData.rotation,
        flippedHorizontally = _state$initialData.flippedHorizontally,
        flippedVertically = _state$initialData.flippedVertically;
      state.x = x;
      state.y = y;
      state.rotation = rotation;
      state.isFlipped = flippedHorizontally || flippedVertically;
    },
    setValue: function setValue(_ref) {
      var x = _ref.x,
        y = _ref.y,
        rotation = _ref.rotation,
        isFlipped = _ref.isFlipped;
      state.x = x;
      state.y = y;
      state.rotation = rotation;
      state.isFlipped = isFlipped;
    }
  };
}).views(function (state) {
  var randomTheme = getRandomColorTheme();
  return {
    get initialData() {
      var parent = getParent(state);
      var figure = parent.raw.data.figure;
      return _extends({}, figure, {
        flippedHorizontally: figure.isFlipped,
        flippedVertically: false
      });
    },
    get transformationData() {
      return {
        x: state.x,
        y: state.y,
        rotation: state.rotation,
        isFlipped: state.isFlipped
      };
    },
    get preset() {
      return state.initialData.preset;
    },
    get pivot() {
      return state.initialData.pivot;
    },
    get theme() {
      return state.initialData.theme === '' ? randomTheme : state.initialData.theme;
    },
    get width() {
      var _state$geometry$reduc = state.geometry.reduce(function (acc, next) {
          return {
            min: acc.min > next.x ? next.x : acc.min,
            max: acc.max < next.x ? next.x : acc.max
          };
        }, {
          min: 0,
          max: 0
        }),
        min = _state$geometry$reduc.min,
        max = _state$geometry$reduc.max;
      return max - min;
    },
    get height() {
      var _state$geometry$reduc2 = state.geometry.reduce(function (acc, next) {
          return {
            min: acc.min > next.y ? next.y : acc.min,
            max: acc.max < next.y ? next.y : acc.max
          };
        }, {
          min: 0,
          max: 0
        }),
        min = _state$geometry$reduc2.min,
        max = _state$geometry$reduc2.max;
      return max - min;
    },
    get figureDefinition() {
      return defaultGeometry[state.preset];
    },
    get geometry() {
      return state.figureDefinition.geometry;
    },
    get points() {
      return state.geometry.map(function (_ref2) {
        var x = _ref2.x,
          y = _ref2.y;
        return x * cellSize + "," + y * cellSize;
      }).join(' ');
    },
    get currentVertex() {
      var position = state.pivot.position < state.geometry.length ? state.pivot.position : 0;
      return state.geometry[position];
    },
    get pivotX() {
      return state.currentVertex.x;
    },
    get pivotY() {
      return state.currentVertex.y;
    },
    get pivotPosition() {
      return state.currentVertex.pivotPosition;
    },
    get pivotLabel() {
      return state.pivot.label;
    },
    get centerCoordinates() {
      return defaultGeometry[state.preset].center;
    },
    get currentFeedback() {
      var parent = getParent(state);
      if (!parent.isEvaluated) return feedback.NOT_EVALUATED;
      if (parent.showSolution) return feedback.RIGHT;
      if (parent.internalAutoFeedback) return feedback.RIGHT;
      if (parent.points === 0) return feedback.WRONG;
      return feedback.RIGHT;
    },
    get bounds() {
      return {
        left: state.x,
        right: state.x + state.width,
        top: state.y,
        bottom: state.y + state.height
      };
    }
  };
});

var ControlsModel = types$1.model().actions(function (state) {
  return {
    moveLeft: function moveLeft() {
      if (state.canMoveLeft) state.figure.moveLeft();
    },
    moveRight: function moveRight() {
      if (state.canMoveRight) state.figure.moveRight();
    },
    moveUp: function moveUp() {
      if (state.canMoveUp) state.figure.moveUp();
    },
    moveDown: function moveDown() {
      if (state.canMoveDown) state.figure.moveDown();
    },
    rotate: function rotate() {
      state.figure.rotate();
    },
    flipHorizontal: function flipHorizontal() {
      state.figure.flipHorizontal();
    },
    flipVertical: function flipVertical() {
      state.figure.flipVertical();
    },
    flipRotate: function flipRotate() {
      state.figure.flipRotate();
    }
  };
}).views(function (state) {
  return {
    get figure() {
      return getParent(state).figure;
    },
    get canMoveLeft() {
      return state.figure.bounds.left > 0;
    },
    get canMoveRight() {
      var gridWidth = getParent(state).grid.width;
      return state.figure.bounds.right < gridWidth;
    },
    get canMoveUp() {
      return state.figure.bounds.top > 0;
    },
    get canMoveDown() {
      var gridHeight = getParent(state).grid.height;
      return state.figure.bounds.bottom < gridHeight;
    }
  };
});

function applyTransformation(figure, transformation) {
  var x = transformation.x,
    y = transformation.y,
    rotation = transformation.rotation,
    isFlipped = transformation.isFlipped;
  var radians = rotation * 90 * Math.PI / 180;
  var cos = Math.cos(radians);
  var sin = Math.sin(radians);
  return figure.geometry.map(function (point) {
    var newX = point.x - figure.center.x;
    var newY = point.y - figure.center.y;
    var rotatedX = newX * cos - newY * sin;
    var rotatedY = newX * sin + newY * cos;
    if (isFlipped) {
      newX = -rotatedX;
    } else {
      newX = rotatedX;
    }
    newY = rotatedY;
    newX += figure.center.x + x;
    newY += figure.center.y + y;
    return {
      x: Math.round(newX),
      y: Math.round(newY)
    };
  });
}
function computeTranslation(transformations, initialData) {
  return _extends({}, initialData, {
    x: initialData.x + transformations.x,
    y: initialData.y + transformations.y
  });
}
function computeRotation(_ref) {
  var pivot = _ref.pivot,
    rotation = _ref.rotation,
    geometry = _ref.geometry;
  var angle = rotation % 4 * 90 * (Math.PI / 180);
  var rotatePoint = function rotatePoint(_ref2, pivot, angle) {
    var x = _ref2.x,
      y = _ref2.y;
    var translatedX = x - pivot.x;
    var translatedY = y - pivot.y;
    var rotatedX = translatedX * Math.cos(angle) - translatedY * Math.sin(angle);
    var rotatedY = translatedX * Math.sin(angle) + translatedY * Math.cos(angle);
    return {
      x: Math.round(rotatedX + pivot.x),
      y: Math.round(rotatedY + pivot.y)
    };
  };
  return geometry.map(function (point) {
    return rotatePoint(point, pivot, angle);
  });
}
function computeSymmetry(_ref3) {
  var transformations = _ref3.transformations,
    grid = _ref3.grid,
    initialData = _ref3.initialData;
  var axis = transformations.axis;
  var centerX = grid.width / 2;
  var centerY = grid.height / 2;
  return initialData.map(function (point) {
    var newX = point.x;
    var newY = point.y;
    if (axis === VERTICAL$1) {
      newY = 2 * centerY - point.y;
    } else if (axis === HORIZONTAL$3) {
      newX = 2 * centerX - point.x;
    }
    return {
      x: Math.round(newX),
      y: Math.round(newY)
    };
  });
}
function getSymmetryValidResponse(_ref4) {
  var initialPosition = _ref4.initialPosition,
    symmetry = _ref4.symmetry,
    grid = _ref4.grid,
    figureHeight = _ref4.figureHeight,
    figureWidth = _ref4.figureWidth;
  var initialX = initialPosition.x,
    initialY = initialPosition.y,
    rotation = initialPosition.rotation,
    isFlipped = initialPosition.isFlipped;
  var width = grid.width,
    height = grid.height;
  var centerX = width / 2;
  var centerY = height / 2;
  var newX = initialX;
  var newY = initialY;
  var newRotation = rotation;
  if (symmetry === VERTICAL$1) {
    newY = 2 * centerY - initialY - figureHeight;
    newRotation = (rotation + 2) % 4;
  } else if (symmetry === HORIZONTAL$3) {
    newX = 2 * centerX - initialX - figureWidth;
    newRotation = (rotation + 180) % 360;
  }
  return {
    x: newX,
    y: newY,
    rotation: newRotation,
    isFlipped: !isFlipped
  };
}

function initVector(data) {
  var _data$data$validation = data.data.validation.valid_response.value[0],
    type = _data$data$validation.type,
    transformations = _data$data$validation.transformations;
  if (type !== TRANSLATION) return undefined;
  var _data$data = data.data,
    figure = _data$data.figure,
    grid = _data$data.grid;
  var vector = {
    head: {
      x: 0,
      y: 0
    },
    tail: {
      x: transformations.x,
      y: transformations.y
    }
  };
  var origin = getOrigin({
    figure: figure,
    grid: grid
  });
  var centered = centerVector({
    vector: vector,
    origin: origin
  });
  var xPos = Math.min(centered.head.x, centered.tail.x);
  var yPos = Math.min(centered.head.y, centered.tail.y);
  return _extends({}, centered, {
    position: {
      x: xPos,
      y: yPos
    }
  });
}
function getOrigin(_ref) {
  var figure = _ref.figure,
    grid = _ref.grid;
  var isHorizontalGrid = grid.width > grid.height;
  var midWidth = grid.width / 2;
  var midHeight = grid.height / 2;
  if (isHorizontalGrid) {
    return figure.x < midWidth ? {
      x: grid.width / 4 + midWidth,
      y: midHeight
    } : {
      x: midWidth,
      y: midHeight
    };
  }
  return figure.y < midHeight ? {
    x: midWidth,
    y: grid.height / 4 + midHeight
  } : {
    x: midWidth,
    y: midHeight
  };
}
function centerVector(_ref2) {
  var vector = _ref2.vector,
    origin = _ref2.origin;
  var vectorWidth = Math.abs(vector.tail.x) / 2;
  var vectorHeight = Math.abs(vector.tail.y) / 2;
  var centerX = parseInt(origin.x - vectorWidth);
  var centerY = parseInt(origin.y - vectorHeight);
  return {
    head: {
      x: vector.head.x + centerX,
      y: vector.head.y + centerY
    },
    tail: {
      x: vector.tail.x + centerX,
      y: vector.tail.y + centerY
    }
  };
}

var VectorModel = types$1.model('VectorModel', {
  head: XYModel,
  tail: XYModel,
  position: XYModel,
  isDragging: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    setDragging: function setDragging(bool) {
      state.isDragging = bool;
    },
    setPosition: function setPosition(_ref) {
      var x = _ref.x,
        y = _ref.y;
      var _getParent = getParent(state),
        grid = _getParent.grid;
      var limitX = x < 0 || state.bounds.width + x > grid.width;
      var limitY = y < 0 || state.bounds.height + y > grid.height;
      if (limitX || limitY) return;
      var displacement = {
        x: x - state.position.x,
        y: y - state.position.y
      };
      if (displacement.x === 0 && displacement.y === 0) return;
      state.position.setPosition({
        x: x,
        y: y
      });
      state.head.setPosition({
        x: state.head.x + displacement.x,
        y: state.head.y + displacement.y
      });
      state.tail.setPosition({
        x: state.tail.x + displacement.x,
        y: state.tail.y + displacement.y
      });
    }
  };
}).views(function (state) {
  return {
    get initialPosition() {
      return false;
    },
    get bounds() {
      var _state$position = state.position,
        x = _state$position.x,
        y = _state$position.y;
      var minX = Math.min(state.head.x, state.tail.x);
      var maxX = Math.max(state.head.x, state.tail.x);
      var minY = Math.min(state.head.y, state.tail.y);
      var maxY = Math.max(state.head.y, state.tail.y);
      var width = maxX - minX;
      var height = maxY - minY;
      return {
        x: x,
        y: y,
        width: width,
        height: height,
        transformHandlerX: width === 0 ? x - 0.5 : x,
        transformHandlerY: height === 0 ? y - 0.5 : y,
        transformHandlerWidth: width === 0 ? 1 : width,
        transformHandlerHeight: height === 0 ? 1 : height
      };
    }
  };
});

var TransformationsInPlaneQuestionStore = types$1.compose(QuestionBaseModel, withXAPITypeOther$1({
  xAPISolution: function xAPISolution(state) {
    return state.getValidResponses();
  }
}), types$1.model({
  figure: FigureModel,
  controls: ControlsModel,
  vector: types$1.maybe(VectorModel)
}).actions(function (state) {
  return {
    reset: function reset() {
      state.baseReset();
      state.figure.reset();
    },
    setResponse: function setResponse(response) {
      if (isEqual(response, state.validation.value)) {
        return state.setResponse(state.getValidResponses());
      }
      if (!typeChecker(responseModel, response)) return false;
      state.figure.setValue(response);
    }
  };
}).views(function (state) {
  return {
    get grid() {
      var _state$validation$val;
      var symmetry = ((_state$validation$val = state.validation.value[0].transformations) === null || _state$validation$val === void 0 ? void 0 : _state$validation$val.axis) || NONE$1;
      return _extends({}, state.raw.data.grid, {
        symmetry: symmetry
      });
    },
    get initialTransform() {
      var _state$raw$data$figur = state.raw.data.figure,
        x = _state$raw$data$figur.x,
        y = _state$raw$data$figur.y,
        rotation = _state$raw$data$figur.rotation,
        isFlipped = _state$raw$data$figur.isFlipped;
      return {
        x: x,
        y: y,
        rotation: rotation,
        isFlipped: isFlipped
      };
    },
    get figureDefinition() {
      return state.figure.figureDefinition;
    },
    get originalVertexPositions() {
      var transformation = state.initialTransform;
      return applyTransformation(state.figureDefinition, transformation);
    },
    get rotationPivot() {
      var value = state.validation.value[0];
      return value.type === ROTATION ? value.transformations.pivot : null;
    },
    get userVertexPositions() {
      var transformation = getSnapshot(state.figure);
      return applyTransformation(state.figureDefinition, transformation);
    },
    get expectedVertexPositions() {
      var value = state.validation.value[0];
      var initialTransform = state.initialTransform;
      var eq = function eq(expected) {
        return expected === value.type;
      };
      if (eq(TRANSLATION)) {
        var computedTransformation = computeTranslation(value.transformations, initialTransform);
        return applyTransformation(state.figureDefinition, computedTransformation);
      }
      if (eq(ROTATION)) {
        return computeRotation({
          pivot: value.transformations.pivot,
          rotation: value.transformations.rotation,
          geometry: state.originalVertexPositions
        });
      }
      if (eq(SYMMETRY)) {
        return computeSymmetry({
          transformations: value.transformations,
          grid: state.grid,
          initialData: state.originalVertexPositions
        });
      }
      return [];
    },
    getValidResponses: function getValidResponses() {
      var validResponse = state.validation.value[0];
      var initialTransform = state.initialTransform,
        expectedVertexPositions = state.expectedVertexPositions;
      if (validResponse.type === TRANSLATION) {
        return computeTranslation(validResponse.transformations, initialTransform);
      }
      if (validResponse.type === ROTATION) {
        var validRotation = validResponse.transformations.rotation;
        var expectedRotation = initialTransform.isFlipped ? initialTransform.rotation - validRotation : initialTransform.rotation + validRotation;
        var _expectedVertexPositi = expectedVertexPositions.reduce(function (acc, next) {
            return {
              x: Math.min(acc.x, next.x),
              y: Math.min(acc.y, next.y)
            };
          }, {
            x: 1000,
            y: 1000
          }),
          x = _expectedVertexPositi.x,
          y = _expectedVertexPositi.y;
        return {
          x: x,
          y: y,
          rotation: expectedRotation % 4,
          isFlipped: initialTransform.isFlipped
        };
      }
      if (validResponse.type === SYMMETRY) {
        return getSymmetryValidResponse({
          initialPosition: state.initialTransform,
          symmetry: validResponse.transformations.axis,
          grid: state.grid,
          figureHeight: state.figure.height,
          figureWidth: state.figure.width
        });
      }
      return {};
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$E(rawData);
    },
    getResults: function getResults() {
      if (state.internalAutoFeedback || state.showSolution) return state.cachePoints;
      var result = validateResponse$1(state.userVertexPositions, state.expectedVertexPositions);
      return result ? 1 : 0;
    },
    getUserResponse: function getUserResponse() {
      return state.figure.transformationData;
    }
  };
}));
var responseModel = types$1.model({
  x: types$1.number,
  y: types$1.number,
  rotation: types$1.number,
  isFlipped: types$1["boolean"]
});
function validateResponse$1(userResponse, validResponse) {
  return validResponse.reduce(function (acc, next) {
    var isFound = userResponse.find(function (p) {
      return p.x === next.x && p.y === next.y;
    });
    return isFound ? acc : false;
  }, true);
}
function _createSnapshot$E(data) {
  var figure = data.data.figure;
  var vector = initVector(data);
  return _extends({}, data.data, importCommonValues$1(data), {
    figure: figure,
    controls: {},
    vector: vector
  });
}
function createStore$R(data) {
  return TransformationsInPlaneQuestionStore.create(_createSnapshot$E(data));
}

function Controls(_ref) {
  var removeDot = _ref.removeDot,
    redo = _ref.redo,
    undo = _ref.undo,
    canUndo = _ref.canUndo,
    canRedo = _ref.canRedo,
    isDotSelected = _ref.isDotSelected;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-math-functions-controls"
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-math-functions-button",
    onClick: undo,
    disabled: !canUndo
  }, /*#__PURE__*/React__default.createElement(SvgReply, {
    className: "lemo-icon"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-label lemo-text-body-m-bold lemo-color-text-02"
  }, translate('undo'))), /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-math-functions-button",
    onClick: redo,
    disabled: !canRedo
  }, /*#__PURE__*/React__default.createElement(SvgReply, {
    className: "lemo-icon",
    style: {
      transform: 'scaleX(-100%)'
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-label lemo-text-body-m-bold lemo-color-text-02"
  }, translate('redo'))), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-right-align-controls"
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-math-functions-button lemo-circular-button",
    onClick: removeDot,
    disabled: !isDotSelected
  }, /*#__PURE__*/React__default.createElement(SvgTrash$1, {
    className: "lemo-icon",
    transform: "scale(-1,1)"
  }))));
}
var Controls$1 = observer(Controls);

function AxisCreator(_ref) {
  var orientation = _ref.orientation,
    values = _ref.values,
    highLighted = _ref.highLighted,
    x = _ref.x,
    y = _ref.y;
  var keyName = orientation + "-label}";
  var getPosition = function getPosition(idx) {
    return idx * (100 / (values.length - 1));
  };
  var getLinePosition = function getLinePosition(idx) {
    return orientation === HORIZONTAL$3 ? {
      x: getPosition(idx) + "%",
      y: y
    } : {
      y: getPosition(idx) + "%",
      dy: '.1em',
      x: x
    };
  };
  return values.map(function (value, idx) {
    var isHighLighted = highLighted === idx;
    return /*#__PURE__*/React__default.createElement("text", _extends({
      key: keyName + "_" + idx,
      className: cn('lemo-axis-label lemo-text-body-s-regular lemo-no-selection', {
        'lemo-highlighted': isHighLighted
      }),
      textAnchor: "middle",
      dominantBaseline: "middle",
      filter: isHighLighted ? 'url(#lemo-selected-filter)' : ''
    }, getLinePosition(idx)), value);
  });
}

var isTouch$7 = isTouchDevice();
function Grid$4(_ref) {
  var children = _ref.children,
    gridSize = _ref.gridSize,
    gridDivisions = _ref.gridDivisions,
    grid = _ref.grid,
    onClick = _ref.onClick,
    squareSize = _ref.squareSize,
    dragHandler = _ref.dragHandler;
  var _useState = useState(false),
    withHighlights = _useState[0],
    handleWithHighlights = _useState[1];
  var svgRef = useRef(null);
  var _useMemo = useMemo(function () {
      console.log('pasa por hook');
      return getAxisValues(gridDivisions);
    }, [gridDivisions]),
    verticalNumberList = _useMemo.verticalNumberList,
    horizontalNumberList = _useMemo.horizontalNumberList;
  var roundPosition = function roundPosition(position) {
    return Math.round(position / squareSize);
  };
  function getCoordinates(e) {
    var svg = svgRef.current;
    var point = svg.createSVGPoint();
    point.x = e.clientX;
    point.y = e.clientY;
    var cursorPoint = point.matrixTransform(svg.getScreenCTM().inverse());
    return {
      x: roundPosition(cursorPoint.x),
      y: roundPosition(cursorPoint.y)
    };
  }
  function handleMove(e) {
    if (dragHandler.isDragging) e.preventDefault();
    var currentEvt = e.touches ? e.touches[0] : e;
    var coordinates = getCoordinates(currentEvt);
    grid.setPosition(coordinates);
    dragHandler.setPosition(coordinates);
    if (!withHighlights) handleWithHighlights(true);
  }
  function onMouseUp(e) {
    var currentEvt = e.changedTouches ? e.changedTouches[0] : e;
    var coordinates = getCoordinates(currentEvt);
    dragHandler.isDragging ? dragHandler.completeDotPosition() : onClick(coordinates);
  }
  function hideBlueLines() {
    if (withHighlights) handleWithHighlights(false);
  }
  useEffect(function () {
    var svgElement = svgRef.current;
    if (svgElement) {
      var handleMoveWrapper = function handleMoveWrapper(e) {
        return handleMove(e);
      };
      svgElement.addEventListener('touchmove', handleMoveWrapper, {
        passive: false
      });
      return function () {
        svgElement.removeEventListener('touchmove', handleMoveWrapper);
      };
    }
  }, [svgRef.current]);
  return /*#__PURE__*/React__default.createElement("svg", {
    ref: svgRef,
    className: cn('lemo-grid', {
      'lemo-show-highlight': withHighlights
    }),
    width: gridSize,
    height: gridSize,
    onMouseMove: !isTouch$7 ? handleMove : null,
    onMouseOut: hideBlueLines,
    onMouseUp: !isTouch$7 ? onMouseUp : null,
    onTouchEnd: onMouseUp
  }, withHighlights && /*#__PURE__*/React__default.createElement(GridHighlightFilters, null), /*#__PURE__*/React__default.createElement(LineCreator, {
    quantity: gridDivisions * 2 + 1,
    orientation: VERTICAL$1,
    markMiddleLine: true,
    highLighted: grid.position.y,
    overflow: 2
  }), /*#__PURE__*/React__default.createElement(LineCreator, {
    quantity: gridDivisions * 2 + 1,
    orientation: HORIZONTAL$3,
    markMiddleLine: true,
    highLighted: grid.position.x,
    overflow: 2
  }), /*#__PURE__*/React__default.createElement(AxisCreator, {
    orientation: VERTICAL$1,
    x: '47.5%',
    values: verticalNumberList,
    highLighted: grid.position.y
  }), /*#__PURE__*/React__default.createElement(AxisCreator, {
    orientation: HORIZONTAL$3,
    y: '52.5%',
    values: horizontalNumberList,
    highLighted: grid.position.x
  }), children);
}
function getAxisValues(gridDivisions) {
  var positiveNumbers = populate(gridDivisions, function (i) {
    return i + 1;
  });
  var negativeNumbers = positiveNumbers.map(function (num) {
    return -num;
  });
  return {
    verticalNumberList: [].concat(positiveNumbers.slice().reverse(), [null], negativeNumbers),
    horizontalNumberList: [].concat(negativeNumbers.slice().reverse(), [null], positiveNumbers)
  };
}
var Grid$5 = observer(Grid$4);

function Dot$2(_ref) {
  var dot = _ref.dot,
    dragHandler = _ref.dragHandler,
    squareSize = _ref.squareSize,
    theme = _ref.theme,
    isSuccess = _ref.isSuccess,
    isError = _ref.isError;
  var _useState = useState(false),
    isHover = _useState[0],
    handleHover = _useState[1];
  function onMouseDown() {
    dot.select();
    dragHandler.setIsDragging(true);
  }
  return /*#__PURE__*/React__default.createElement(DotAtom$1, {
    x: dot.x * squareSize,
    y: dot.y * squareSize,
    isSuccess: isSuccess,
    isWrong: isError,
    isActive: isHover || dot.isSelected,
    size: 8,
    onMouseOver: function onMouseOver() {
      return handleHover(true);
    },
    onMouseOut: function onMouseOut() {
      return handleHover(false);
    },
    setMouseOver: handleHover,
    onMouseDown: onMouseDown,
    theme: theme
  });
}
var Dot$3 = observer(Dot$2);

function LinealConnector(_ref) {
  var dotList = _ref.dotList,
    squareSize = _ref.squareSize,
    gridSize = _ref.gridSize,
    theme = _ref.theme,
    isPreview = _ref.isPreview,
    isSuccess = _ref.isSuccess,
    isError = _ref.isError;
  var _useExtendedLine = useExtendedLine(dotList, squareSize, gridSize),
    x1 = _useExtendedLine.x1,
    y1 = _useExtendedLine.y1,
    x2 = _useExtendedLine.x2,
    y2 = _useExtendedLine.y2;
  return /*#__PURE__*/React__default.createElement("svg", {
    className: cn('lemo-line-connector', theme, {
      'lemo-is-preview': isPreview,
      'lemo-success': isSuccess,
      'lemo-error': isError
    }),
    width: '102%',
    height: '102%',
    style: {
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React__default.createElement("line", {
    className: "lemo-line",
    x1: x1,
    y1: y1,
    x2: x2,
    y2: y2
  }));
}
function useExtendedLine(dotList, squareSize, gridSize) {
  var dot1 = dotList[0],
    dot2 = dotList[1];
  var x1 = dot1.x * squareSize;
  var y1 = dot1.y * squareSize;
  var x2 = dot2.x * squareSize;
  var y2 = dot2.y * squareSize;
  var dx = x2 - x1;
  var dy = y2 - y1;
  var x1Extended = x1;
  var y1Extended = y1;
  var x2Extended = x2;
  var y2Extended = y2;
  if (dx !== 0) {
    if (x1 < x2) {
      x1Extended = 0;
      y1Extended = y1 - x1 / dx * dy;
      x2Extended = gridSize;
      y2Extended = y1 + (gridSize - x1) / dx * dy;
    } else {
      x1Extended = gridSize;
      y1Extended = y1 + (gridSize - x1) / dx * dy;
      x2Extended = 0;
      y2Extended = y1 - x1 / dx * dy;
    }
  } else {
    if (y1 < y2) {
      y1Extended = 0;
      y2Extended = gridSize;
    } else {
      y1Extended = gridSize;
      y2Extended = 0;
    }
  }
  return {
    x1: x1Extended,
    y1: y1Extended,
    x2: x2Extended,
    y2: y2Extended
  };
}
var LinealConnector$1 = observer(LinealConnector);

function QuadraticConnector(_ref) {
  var dotList = _ref.dotList,
    squareSize = _ref.squareSize,
    theme = _ref.theme,
    isPreview = _ref.isPreview,
    isSuccess = _ref.isSuccess,
    isError = _ref.isError;
  var svgSize = 550;
  var V = dotList[0],
    P = dotList[1];
  var vertex = {
    x: V.x * squareSize,
    y: V.y * squareSize
  };
  var point = {
    x: P.x * squareSize,
    y: P.y * squareSize
  };
  var pathData = useQuadraticPath({
    vertex: vertex,
    point: point,
    svgSize: svgSize,
    iterations: 100
  });
  return /*#__PURE__*/React__default.createElement("svg", {
    className: cn('lemo-line-connector', theme, {
      'lemo-is-preview': isPreview,
      'lemo-success': isSuccess,
      'lemo-error': isError
    }),
    width: svgSize,
    height: svgSize,
    style: {
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React__default.createElement("path", {
    className: "lemo-line",
    d: pathData,
    fill: "none"
  }));
}
function useQuadraticPath(_ref2) {
  var vertex = _ref2.vertex,
    point = _ref2.point,
    svgSize = _ref2.svgSize,
    _ref2$iterations = _ref2.iterations,
    iterations = _ref2$iterations === void 0 ? 50 : _ref2$iterations;
  var a = (point.y - vertex.y) / Math.pow(point.x - vertex.x, 2);
  var pathData = "M0," + (a * Math.pow(0 - vertex.x, 2) + vertex.y);
  var step = svgSize / iterations;
  for (var i = 1; i <= iterations; i += 1) {
    var x = i * step;
    var y = a * Math.pow(x - vertex.x, 2) + vertex.y;
    pathData += " L" + x + "," + y;
  }
  return pathData;
}
var QuadraticConnector$1 = observer(QuadraticConnector);

var isTouch$8 = isTouchDevice();
function Line$6(_ref) {
  var line = _ref.line,
    dragHandler = _ref.dragHandler,
    squareSize = _ref.squareSize,
    gridSize = _ref.gridSize,
    theme = _ref.theme,
    gridDivisions = _ref.gridDivisions;
  var isQuadratic = !line.isLineal;
  var ConnectorComponent = line.isLineal ? LinealConnector$1 : QuadraticConnector$1;
  return /*#__PURE__*/React__default.createElement("g", {
    className: "lemo-line"
  }, line.dotList.length > 1 && /*#__PURE__*/React__default.createElement(ConnectorComponent, {
    dotList: line.dotList,
    squareSize: squareSize,
    gridSize: gridSize,
    gridDivisions: gridDivisions,
    isPreview: dragHandler.isDragging,
    theme: theme,
    isSuccess: line.isSuccess,
    isError: line.isError
  }), !isTouch$8 && line.dotList.length === 1 && line.isSelected && /*#__PURE__*/React__default.createElement(ConnectorComponent, {
    dotList: line.temporalDotList,
    squareSize: squareSize,
    gridSize: gridSize,
    gridDivisions: gridDivisions,
    isPreview: true,
    theme: theme
  }), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: line.showDotsAfterEvaluation
  }, line.dotList.map(function (dot) {
    return /*#__PURE__*/React__default.createElement(Dot$3, {
      key: dot.id,
      dot: dot,
      theme: theme,
      isSuccess: line.isSuccess,
      isError: line.isError,
      squareSize: squareSize,
      dragHandler: dragHandler
    });
  })), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: isQuadratic && !line.realSuccess
  }, line.dotList.map(function (dot, idx) {
    return idx > 0 ? null : /*#__PURE__*/React__default.createElement(Dot$3, {
      key: dot.id,
      dot: dot,
      theme: theme,
      isSuccess: line.isSuccess,
      isError: line.isError,
      squareSize: squareSize,
      dragHandler: dragHandler
    });
  })));
}
var Line$7 = observer(Line$6);

function LineList(_ref) {
  var lineList = _ref.lineList,
    dragHandler = _ref.dragHandler,
    squareSize = _ref.squareSize,
    gridSize = _ref.gridSize,
    gridDivisions = _ref.gridDivisions;
  return /*#__PURE__*/React__default.createElement("g", {
    className: "lemo-line-list"
  }, lineList.map(function (line) {
    return /*#__PURE__*/React__default.createElement(Line$7, {
      key: line.id,
      line: line,
      gridSize: gridSize,
      gridDivisions: gridDivisions,
      squareSize: squareSize,
      dragHandler: dragHandler,
      theme: line.color
    });
  }));
}
var LineList$1 = observer(LineList);

var showHistoryTest = false;
function SymmetryQuestion(props) {
  var store = props.store;
  var changedHandlers = /reset|setValue|redo|undo|selectDot|createDot|removeDot|setPosition|completeDotPosition/;
  var squareSize = store.gridSize / (store.gridDivisions * 2);
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body lemo-question-name', {
      'lemo-disabled': store.disabled
    }),
    style: {
      width: store.gridSize
    }
  }, /*#__PURE__*/React__default.createElement(Controls$1, {
    removeDot: store.removeDot,
    redo: store.history.redo,
    undo: store.history.undo,
    canUndo: store.history.canUndo,
    canRedo: store.history.canRedo,
    isDotSelected: store.selectedDot !== undefined
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-grid-container"
  }, /*#__PURE__*/React__default.createElement(Grid$5, {
    gridSize: store.gridSize,
    gridDivisions: store.gridDivisions,
    onClick: store.createDot,
    squareSize: squareSize,
    dragHandler: store.dragHandler,
    grid: store.grid
  }, /*#__PURE__*/React__default.createElement(LineList$1, {
    lineList: store.lineList,
    gridSize: store.gridSize,
    gridDivisions: store.gridDivisions,
    squareSize: squareSize,
    dragHandler: store.dragHandler
  }))), showHistoryTest ));
}
var FunctionsQuestion = observer(SymmetryQuestion);

var DRAW_DOT = 'DRAW_DOT';
var MOVE_DOT = 'MOVE_DOT';
var REMOVE_DOT = 'REMOVE_DOT';
var SELECT_DOT = 'SELECT_DOT';
var INITIAL_STATE = 'INITIAL_STATE';

var MoveDotModel = types$1.model('MoveDotModel', {
  type: types$1.literal(MOVE_DOT),
  lineId: types$1.string,
  dotId: types$1.string,
  x: types$1.number,
  y: types$1.number,
  prevX: types$1.number,
  prevY: types$1.number
});

var RemoveDotModel = types$1.model('RemoveDotModel', {
  type: types$1.literal(REMOVE_DOT),
  lineId: types$1.string,
  dotId: types$1.string,
  index: types$1.number,
  x: types$1.number,
  y: types$1.number
});

var SelectDotModel = types$1.model('SelectDotModel', {
  type: types$1.literal(SELECT_DOT),
  lineId: types$1.string,
  dotId: types$1.string,
  prevSelection: types$1.maybe(types$1.string)
});

var DrawDotModel = types$1.model('DrawDotModel', {
  type: types$1.literal(DRAW_DOT),
  lineId: types$1.string,
  dotId: types$1.string,
  x: types$1.number,
  y: types$1.number
});

var InitialStateModel = types$1.model('InitialStateModel', {
  type: types$1.literal(INITIAL_STATE)
});

var UnionModel = types$1.union(DrawDotModel, MoveDotModel, RemoveDotModel, SelectDotModel, InitialStateModel);
var HistoryModel = types$1.model('HistoryModel', {
  entryList: types$1.optional(types$1.array(UnionModel), [{
    type: INITIAL_STATE
  }]),
  currentEntryIndex: types$1.optional(types$1.number, 0)
}).actions(function (state) {
  return {
    addEntry: function addEntry(entry) {
      state.clearStackAbove();
      state.createEntry(entry);
    },
    createEntry: function createEntry(entry) {
      state.entryList.push(entry);
      state.currentEntryIndex = state.entryList.length - 1;
    },
    clearStackAbove: function clearStackAbove() {
      if (state.canRedo) state.entryList.splice(state.currentEntryIndex + 1);
    },
    undo: function undo() {
      if (!state.canUndo) return;
      if (state.currentEntry.type === SELECT_DOT) {
        getParent(state).selectEntry({
          dotId: state.currentEntry.prevSelection,
          lineId: state.currentEntry.lineId
        });
      }
      if (state.currentEntry.type === REMOVE_DOT) {
        getParent(state).undoRemoveEntry(state.currentEntry);
      }
      if (state.currentEntry.type === DRAW_DOT) {
        getParent(state).undoCreationEntry(state.currentEntry);
      }
      if (state.currentEntry.type === MOVE_DOT) {
        var entry = {
          lineId: state.currentEntry.lineId,
          dotId: state.currentEntry.dotId,
          x: state.currentEntry.prevX,
          y: state.currentEntry.prevY
        };
        getParent(state).moveEntry(entry);
      }
      state.currentEntryIndex -= 1;
    },
    redo: function redo() {
      if (!state.canRedo) return;
      state.currentEntryIndex += 1;
      if (state.currentEntry.type === SELECT_DOT) {
        getParent(state).selectEntry({
          dotId: state.currentEntry.dotId,
          lineId: state.currentEntry.lineId
        });
      }
      if (state.currentEntry.type === REMOVE_DOT) {
        getParent(state).redoRemoveEntry(state.currentEntry);
      }
      if (state.currentEntry.type === DRAW_DOT) {
        getParent(state).redoCreationEntry(state.currentEntry);
      }
      if (state.currentEntry.type === MOVE_DOT) {
        getParent(state).moveEntry(state.currentEntry);
      }
    },
    clear: function clear() {
      state.entryList = [{
        type: INITIAL_STATE
      }];
      state.currentEntryIndex = 0;
    }
  };
}).views(function (state) {
  return {
    get currentEntry() {
      return state.entryList[state.currentEntryIndex];
    },
    get previousEntry() {
      return state.currentEntryIndex - 1 > 0 ? state.entryList[state.currentEntryIndex - 1] : {};
    },
    get nextEntry() {
      return state.entryList.length > state.currentEntryIndex + 1 ? state.entryList[state.currentEntryIndex + 1] : {};
    },
    get canUndo() {
      return state.currentEntryIndex > 0;
    },
    get canRedo() {
      return state.currentEntryIndex + 1 < state.entryList.length;
    }
  };
});

function getElementIndex(state) {
  return isAlive(state) && getParent(state).findIndex(function (item) {
    return item === state;
  });
}

var DotModel$1 = types$1.model('DotModel', {
  id: types$1.optional(types$1.identifier, function () {
    return uuid();
  }),
  x: types$1.number,
  y: types$1.number,
  prevX: types$1.optional(types$1.number, 0),
  prevY: types$1.optional(types$1.number, 0)
}).actions(function (state) {
  return {
    select: function select() {
      if (state.isSelected) return;
      state.history.addEntry({
        type: SELECT_DOT,
        dotId: state.id,
        lineId: state.parentLine.id,
        prevSelection: state.rootStore.selectedDot
      });
      state.rootStore.selectDot(state.id);
      state.parentLine.select();
    },
    updatePosition: function updatePosition(_ref) {
      var x = _ref.x,
        y = _ref.y;
      if (x === state.prevX && y === state.prevY) return;
      state.setPosition({
        x: x,
        y: y
      });
      state.history.addEntry({
        type: MOVE_DOT,
        lineId: state.parentLine.id,
        dotId: state.id,
        x: state.x,
        y: state.y,
        prevX: state.prevX,
        prevY: state.prevY
      });
      state.prevX = state.x;
      state.prevY = state.y;
    },
    setPosition: function setPosition(_ref2) {
      var x = _ref2.x,
        y = _ref2.y;
      state.x = x;
      state.y = y;
    }
  };
}).views(function (state) {
  return {
    get index() {
      return getElementIndex(state);
    },
    get rootStore() {
      return getParent(state, 4);
    },
    get history() {
      return state.rootStore.history;
    },
    get isSelected() {
      return getParent(state, 4).selectedDot === state.id;
    },
    get parentLine() {
      return getParent(state, 2);
    },
    get values() {
      return {
        x: state.x,
        y: state.y
      };
    },
    get normalizedValues() {
      var normalizeX = function normalizeX(x) {
        return -state.rootStore.gridDivisions + x;
      };
      var normalizeY = function normalizeY(x) {
        return state.rootStore.gridDivisions - x;
      };
      return {
        x: normalizeX(state.x),
        y: normalizeY(state.y)
      };
    }
  };
});

var LineModel$1 = types$1.model('LineModel', {
  id: types$1.optional(types$1.identifier, function () {
    return uuid();
  }),
  dotList: types$1.optional(types$1.array(DotModel$1), [])
}).actions(function (state) {
  return {
    createDot: function createDot(_ref) {
      var x = _ref.x,
        y = _ref.y;
      if (state.isCompleted) return;
      state.dotList.push({
        x: x,
        y: y,
        prevX: x,
        prevY: y
      });
      var currentDot = state.dotList[state.dotList.length - 1];
      state.history.addEntry({
        type: DRAW_DOT,
        lineId: state.id,
        dotId: currentDot.id,
        x: x,
        y: y,
        prevX: x,
        prevY: y
      });
    },
    select: function select() {
      getParent(state, 2).selectLine(state.id);
    },
    clear: function clear() {
      state.dotList = [];
    },
    appendDot: function appendDot(dot) {
      state.dotList.push(dot);
    },
    prependDot: function prependDot(dot) {
      state.dotList.unshift(dot);
    }
  };
}).views(function (state) {
  function createTemporalDotList() {
    var _getParent$grid = getParent(state, 2).grid,
      _getParent$grid$mouse = _getParent$grid.mouseX,
      mouseX = _getParent$grid$mouse === void 0 ? 0 : _getParent$grid$mouse,
      _getParent$grid$mouse2 = _getParent$grid.mouseY,
      mouseY = _getParent$grid$mouse2 === void 0 ? 0 : _getParent$grid$mouse2;
    var temporalDot = DotModel$1.create({
      x: mouseX,
      y: mouseY
    });
    return [state.dotList[0], temporalDot];
  }
  return {
    get index() {
      return getElementIndex(state);
    },
    get history() {
      return getParent(state, 2).history;
    },
    get color() {
      return getParent(state, 2).theme[state.index];
    },
    get isCompleted() {
      return state.dotList.length > 1;
    },
    get isSelected() {
      return getParent(state, 2).currentLine === state;
    },
    get isValid() {
      var parent = getParent(state, 2);
      return parent.feedbackResults[state.index];
    },
    get isSuccess() {
      var parent = getParent(state, 2);
      return parent.isEvaluated && parent.feedbackResults[state.index];
    },
    get isError() {
      var parent = getParent(state, 2);
      return parent.isEvaluated && !parent.feedbackResults[state.index];
    },
    get realSuccess() {
      var _getParent = getParent(state, 2),
        realUserResults = _getParent.realUserResults;
      return realUserResults && realUserResults[state.index];
    },
    get showPreview() {
      return state.isSelected && !state.isCompleted;
    },
    get values() {
      return state.dotList.map(function (dot) {
        return dot.values;
      });
    },
    get temporalDotList() {
      return state.dotList.length === 1 ? createTemporalDotList() : [];
    },
    get isLineal() {
      return getParent(state, 2).isLineal;
    },
    get allSuccess() {
      return getParent(state).every(function (line) {
        return line.realSuccess;
      });
    },
    get showDotsAfterEvaluation() {
      var isMultipleLines = getParent(state).length > 1;
      var _getParent2 = getParent(state, 2),
        showSolution = _getParent2.showSolution,
        isEvaluated = _getParent2.isEvaluated;
      if (!isEvaluated) return true;
      if (isMultipleLines && state.allSuccess) return true;
      if (isMultipleLines && showSolution) return false;
      if (isMultipleLines && !showSolution) return true;
      if (!showSolution) return true;
      if (showSolution && state.realSuccess) return true;
      return false;
    }
  };
});

function checkLinearFunction(line, solution) {
  if (line.length < 2) return false;
  return line.every(function (point) {
    return validateY(point, solution);
  });
}
function validateY(point, solution) {
  var m = solution[0],
    b = solution[1];
  var x = point.x,
    y = point.y;
  return y === m * x + b;
}
function getLinealResults(lines, solutions, results) {
  if (results === void 0) {
    results = [];
  }
  if (results.length === lines.length) return results;
  var line = lines[results.length];
  var validateLine = solutions.reduce(function (acc, next, idx) {
    return checkLinearFunction(line, next) ? {
      result: true,
      idx: idx
    } : acc;
  }, {
    result: false,
    idx: null
  });
  var updatedSolutions = validateLine.result ? rmItem(validateLine.idx, solutions) : solutions;
  return getLinealResults(lines, updatedSolutions, [].concat(results, [validateLine.result]));
}

function pointIsAvailable(dotPosition, lineList) {
  var x = dotPosition.x,
    y = dotPosition.y;
  var allDots = lineList.flatMap(function (line) {
    return line.dotList;
  });
  return allDots.every(function (dot) {
    return dot.x !== x || dot.y !== y;
  });
}

var DragHandlerModel = types$1.model({
  isDragging: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    setIsDragging: function setIsDragging(bool) {
      state.isDragging = bool;
    },
    setPosition: function setPosition(_ref) {
      var x = _ref.x,
        y = _ref.y;
      var parent = getParent(state);
      if (!state.isDragging || !parent.currentDot) return;
      if (!pointIsAvailable({
        x: x,
        y: y
      }, parent.lineList)) return;
      getParent(state).currentDot.setPosition({
        x: x,
        y: y
      });
    },
    completeDotPosition: function completeDotPosition() {
      state.isDragging = false;
      var dot = getParent(state).currentDot;
      if (!dot) return;
      var x = dot.x,
        y = dot.y;
      getParent(state).currentDot.updatePosition({
        x: x,
        y: y
      });
    }
  };
});

var GridModel = types$1.model('GridModel', {
  mouseX: types$1.number,
  mouseY: types$1.number
}).actions(function (state) {
  return {
    setPosition: function setPosition(_ref) {
      var x = _ref.x,
        y = _ref.y;
      state.mouseX = x;
      state.mouseY = y;
    }
  };
}).views(function (state) {
  return {
    get position() {
      return {
        x: state.mouseX,
        y: state.mouseY
      };
    }
  };
});

function getQuadraticResults(lines, solutions) {
  if (lines[0].length < 2) return [false];
  var _solutions$ = solutions[0],
    A = _solutions$[0],
    B = _solutions$[1],
    C = _solutions$[2];
  var _lines$ = lines[0],
    V = _lines$[0],
    P = _lines$[1];
  return [checkVertex({
    V: V,
    A: A,
    B: B,
    C: C
  }) && checkPoint({
    P: P,
    A: A,
    B: B,
    C: C
  })];
}
function checkVertex(_ref) {
  var V = _ref.V,
    A = _ref.A,
    B = _ref.B,
    C = _ref.C;
  var checkX = B * -1 / (2 * A) === V.x;
  var checkY = A * Math.pow(V.x, 2) + B * V.x + C === V.y;
  return checkX && checkY;
}
function checkPoint(_ref2) {
  var P = _ref2.P,
    A = _ref2.A,
    B = _ref2.B,
    C = _ref2.C;
  return A * Math.pow(P.x, 2) + B * P.x + C === P.y;
}

var FunctionsQuestionStore = types$1.compose(QuestionBaseModel, withXAPITypeOther$1({
  xAPISolution: function xAPISolution(state) {
    return state.getValidResponses();
  }
}), types$1.model('LinealFunctionQuestionStore', {
  lineList: types$1.array(LineModel$1),
  history: HistoryModel,
  selectedLine: types$1.string,
  grid: types$1.optional(GridModel, {
    mouseX: 0,
    mouseY: 0
  }),
  dragHandler: types$1.optional(DragHandlerModel, {}),
  selectedDot: types$1.maybe(types$1.string),
  realUserResults: types$1.maybe(types$1.array(types$1["boolean"]))
}).actions(function (state) {
  return {
    selectDot: function selectDot(dotId) {
      state.selectedDot = dotId;
    },
    selectLine: function selectLine(lineId) {
      state.selectedLine = lineId;
    },
    createDot: function createDot(dotPosition) {
      if (!pointIsAvailable(dotPosition, state.lineList)) return;
      if (!state.availableLine) return state.selectDot(undefined);
      state.availableLine.select();
      return state.availableLine.createDot(dotPosition);
    },
    removeDot: function removeDot() {
      var selectedDot = state.selectedDot,
        currentDot = state.currentDot,
        selectedLine = state.selectedLine;
      if (!selectedDot) return;
      state.history.addEntry({
        type: REMOVE_DOT,
        lineId: selectedLine,
        dotId: selectedDot,
        x: currentDot.x,
        y: currentDot.y,
        index: currentDot.index
      });
      destroy(currentDot);
      state.selectedDot = undefined;
      state.updateLineSelection();
    },
    afterCheckAnswers: function afterCheckAnswers() {
      if (state.realUserResults) return;
      state.selectedDot = undefined;
      state.history.clear();
      state.grid.setPosition({
        x: 10,
        y: 10
      });
      state.realUserResults = state.lineList.map(function (line) {
        return line.isSuccess;
      });
    },
    clearResponses: function clearResponses() {
      state.lineList.forEach(function (line) {
        return line.clear();
      });
      state.history.clear();
    },
    reset: function reset() {
      state.selectedDot = undefined;
      state.selectedLine = state.lineList[0].id;
      state.baseReset();
      state.clearResponses();
      state.realUserResults = undefined;
    },
    updateLineSelection: function updateLineSelection() {
      var currentLine = state.currentLine;
      if (currentLine.index === 1 && currentLine.dotList.length === 0) {
        state.selectedLine = state.lineList[0].id;
      }
    },
    selectEntry: function selectEntry(_ref) {
      var dotId = _ref.dotId,
        lineId = _ref.lineId;
      state.selectedLine = lineId;
      state.selectedDot = dotId;
    },
    moveEntry: function moveEntry(_ref2) {
      var lineId = _ref2.lineId,
        dotId = _ref2.dotId,
        x = _ref2.x,
        y = _ref2.y;
      var line = state.lineList.find(function (_ref3) {
        var id = _ref3.id;
        return id === lineId;
      });
      var dot = line.dotList.find(function (_ref4) {
        var id = _ref4.id;
        return id === dotId;
      });
      dot.setPosition({
        x: x,
        y: y
      });
    },
    undoRemoveEntry: function undoRemoveEntry(_ref5) {
      var lineId = _ref5.lineId,
        dotId = _ref5.dotId,
        x = _ref5.x,
        y = _ref5.y,
        index = _ref5.index;
      var line = state.lineList.find(function (_ref6) {
        var id = _ref6.id;
        return id === lineId;
      });
      var dot = {
        id: dotId,
        x: x,
        y: y
      };
      index === 0 ? line.prependDot(dot) : line.appendDot(dot);
      state.selectedDot = dotId;
      state.selectedLine = lineId;
    },
    redoRemoveEntry: function redoRemoveEntry() {
      var dot = state.currentDot;
      state.selectedDot = undefined;
      destroy(dot);
    },
    undoCreationEntry: function undoCreationEntry(_ref7) {
      var lineId = _ref7.lineId,
        dotId = _ref7.dotId;
      var line = state.lineList.find(function (_ref8) {
        var id = _ref8.id;
        return id === lineId;
      });
      var dot = line.dotList.find(function (_ref9) {
        var id = _ref9.id;
        return id === dotId;
      });
      destroy(dot);
    },
    redoCreationEntry: function redoCreationEntry(_ref10) {
      var lineId = _ref10.lineId,
        dotId = _ref10.dotId,
        x = _ref10.x,
        y = _ref10.y;
      var line = state.lineList.find(function (_ref11) {
        var id = _ref11.id;
        return id === lineId;
      });
      var dot = {
        id: dotId,
        x: x,
        y: y
      };
      line.appendDot(dot);
      state.selectedLine = lineId;
    },
    setResponse: function setResponse(response) {
      var responseModel = types$1.array(types$1.array(DotModel$1));
      if (response.length > state.maxLines) return false;
      if (!typeChecker(responseModel, response)) return false;
      state.clearResponses();
      var deNormalize = function deNormalize(p) {
        return {
          x: p.x + state.gridDivisions,
          y: state.gridDivisions - p.y
        };
      };
      response.flat().forEach(function (dot) {
        return state.createDot(deNormalize(dot));
      });
      state.afterCheckAnswers();
    },
    hydrateQuestionPreview: function hydrateQuestionPreview(rawData) {
      try {
        var data = _createSnapshot$F(rawData);
        var prevAssetsQuestionApi = state.assetsQuestionApi;
        applySnapshot(state, data);
        state.setIsSolutionMode(false);
        state.setAssetsQuestionApi(prevAssetsQuestionApi);
      } catch (e) {}
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  return {
    get availableLine() {
      var currentLine = state.currentLine,
        lineList = state.lineList;
      if (!currentLine.isCompleted) return currentLine;
      if (lineList.length === 1) return undefined;
      return lineList.find(function (line) {
        return !line.isCompleted;
      }) || undefined;
    },
    get currentLine() {
      return state.lineList.find(function (_ref12) {
        var id = _ref12.id;
        return id === state.selectedLine;
      });
    },
    get currentDot() {
      return state.currentLine.dotList.find(function (dot) {
        return dot.id === state.selectedDot;
      });
    },
    get gridSize() {
      return state.raw.data.grid_size;
    },
    get gridDivisions() {
      var _state$raw$data;
      return ((_state$raw$data = state.raw.data) === null || _state$raw$data === void 0 ? void 0 : _state$raw$data.grid_divisions) || 10;
    },
    get maxLines() {
      return state.validation.value.length;
    },
    get theme() {
      var totalLines = state.validation.value.length;
      var theme = state.ui_style.theme;
      return (theme === null || theme === void 0 ? void 0 : theme.length) === totalLines ? theme.map(function (t) {
        return "theme-" + t;
      }) : getRandomColorThemeList(totalLines);
    },
    getValidResponses: function getValidResponses() {
      if (state.points === 1) return state.getUserResponse();
      if (state.isLineal) {
        return state.validation.value.map(function (p) {
          var m = p[0],
            b = p[1];
          return generateLinePoints(m, b, state.gridDivisions);
        });
      }
      if (!state.isLineal) {
        return generateQuadraticPoints(state.validation.value[0]);
      }
      return null;
    },
    getUserResponse: function getUserResponse() {
      var normalizeX = function normalizeX(x) {
        return -state.gridDivisions + x;
      };
      var normalizeY = function normalizeY(x) {
        return state.gridDivisions - x;
      };
      return state.lineList.map(function (line) {
        return line.values.map(function (_ref13) {
          var x = _ref13.x,
            y = _ref13.y;
          return {
            x: normalizeX(x),
            y: normalizeY(y)
          };
        });
      });
    },
    get isLineal() {
      var linealName = normalizedTypes.math_lineal_function.value;
      return state.name === linealName;
    },
    get feedbackResults() {
      var defaultResults = populate(state.validation.value.length, function () {
        return false;
      });
      if (!state.isEvaluated) return defaultResults;
      return state.isLineal ? getLinealResults(state.getUserResponse(), state.validation.value) : getQuadraticResults(state.getUserResponse(), state.validation.value);
    },
    getResults: function getResults() {
      var value = state.validation.value;
      var pointsPerLine = 1 / value.length;
      return state.feedbackResults.reduce(function (acc, next) {
        return acc + (next ? pointsPerLine : 0);
      }, 0);
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$F(rawData);
    }
  };
}));
function generateLinePoints(m, b, divisions) {
  var points = [];
  var x = -divisions;
  while (points.length < 2) {
    var y = m * x + b;
    if (x >= -divisions && x <= divisions && y >= -divisions && y <= divisions) {
      points.push({
        x: x,
        y: y
      });
    }
    x++;
  }
  return points;
}
function generateQuadraticPoints(solution) {
  var A = solution[0],
    B = solution[1],
    C = solution[2];
  var points = [];
  var vertexX = -B / (2 * A);
  var vertexY = A * Math.pow(vertexX, 2) + B * vertexX + C;
  points.push({
    x: vertexX,
    y: vertexY
  });
  var additionalX = vertexX + 1;
  var additionalY = A * Math.pow(additionalX, 2) + B * additionalX + C;
  points.push({
    x: additionalX,
    y: additionalY
  });
  return [points];
}
function _createSnapshot$F(data) {
  var value = data.data.validation.valid_response.value;
  var lineList = populate(value.length, function () {
    return {
      id: uuid()
    };
  });
  return _extends({}, data.data, importCommonValues(data), {
    history: {},
    selectedLine: lineList[0].id,
    lineList: lineList
  });
}
function createStore$S(data) {
  return FunctionsQuestionStore.create(_createSnapshot$F(data));
}

var FunctionConfig = types$1.model({
  id: types$1.optional(types$1.identifier, function () {
    return 'ab_' + uuid();
  }),
  values: types$1.array(ValueModel)
}).views(function (state) {
  return {
    get output() {
      return state.values.map(function (value) {
        return Number(value.value);
      });
    }
  };
});

var LINEAL = 'LINEAL';
var QUADRATIC = 'QUADRATIC';
var FunctionsEditorStore$1 = types$1.compose(EditorBaseModel, types$1.model({
  gridDivisions: types$1.number,
  gridSize: types$1.number,
  functionList: types$1.array(FunctionConfig),
  ui_style: BaseModel$1
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      onAction(state, function (_ref) {
        var name = _ref.name;
        if (name === 'setValue') {
          state.updateNotifier();
        }
      });
    },
    setGridDivisions: function setGridDivisions(gridDivisions) {
      state.gridDivisions = gridDivisions;
      state.updateNotifier();
    },
    setGridSize: function setGridSize(gridSize) {
      state.gridSize = gridSize;
      state.updateNotifier();
    },
    addFunction: function addFunction() {
      state.functionList.push(createFunctionConfig(state.functionList[0].output));
      state.updateNotifier();
    },
    removeFunction: function removeFunction(idx) {
      destroy(state.functionList[idx]);
      state.updateNotifier();
    }
  };
}).views(function (state) {
  return {
    get functionType() {
      return state.functionList[0].values.length === 2 ? LINEAL : QUADRATIC;
    },
    get addButtonAvailable() {
      return state.functionType === LINEAL;
    },
    get addButtonDisabled() {
      return state.functionList.length > 1;
    },
    get functionsOutput() {
      return state.functionList.map(function (_ref2) {
        var output = _ref2.output;
        return output;
      });
    },
    get output() {
      var validation = produce$1(state.validation.output, function (draft) {
        draft.scoring_type = validationModes.EXACT_MATCH;
        draft.valid_response.value = state.functionList.map(function (_ref3) {
          var output = _ref3.output;
          return output;
        });
      });
      return omit(['gridDivisions', 'gridSize', 'functionList'], exportCommonValues(state, {
        grid_divisions: state.gridDivisions,
        grid_size: state.gridSize,
        validation: validation
      }));
    }
  };
}));
function createFunctionConfig(solution) {
  return {
    values: solution.map(function (value) {
      return {
        value: value
      };
    })
  };
}
function createSnapshot$c(data) {
  var _data$data = data.data,
    grid_size = _data$data.grid_size,
    grid_divisions = _data$data.grid_divisions,
    validation = _data$data.validation;
  var solutions = validation.valid_response.value;
  return _extends({}, data.data, importCommonValues$1(data), {
    gridSize: grid_size,
    gridDivisions: grid_divisions,
    functionList: solutions.map(createFunctionConfig)
  });
}
function createStore$T(data) {
  var store = FunctionsEditorStore$1.create(createSnapshot$c(data));
  return store;
}

function QuotientList(_ref) {
  var quotientList = _ref.quotientList;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-quotient-list"
  }, quotientList.map(function (quotient, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: "quotient_" + index,
      className: "lemo-quotient",
      "data-testid": "quotient"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "lemo-h1-medium lemo-color-text-02"
    }, quotient));
  }));
}
var QuotientList$1 = observer(QuotientList);

function BasicInputKeyboard(_ref) {
  var id = _ref.id,
    className = _ref.className,
    value = _ref.value,
    maxLength = _ref.maxLength,
    tabIndex = _ref.tabIndex,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? noop : _ref$onFocus,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? noop : _ref$onBlur,
    _ref$onEnter = _ref.onEnter,
    onEnter = _ref$onEnter === void 0 ? noop : _ref$onEnter,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$hideKeyboard = _ref.hideKeyboard,
    hideKeyboard = _ref$hideKeyboard === void 0 ? false : _ref$hideKeyboard;
  var _useState = useState('1em'),
    width = _useState[0],
    setWidth = _useState[1];
  var element = useRef(null);
  function handleChange() {
    var newValue = element.current.value;
    if (isNaN(newValue)) return;
    onChange(newValue);
  }
  function handleKeyDown(e) {
    var key = e.key;
    var allowedKeys = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Backspace', 'Tab', 'Delete'];
    var isNumber = key.match(/[0-9]/);
    if (key === 'Enter') {
      e.preventDefault();
      return onEnter();
    }
    if (!isNumber && !allowedKeys.includes(key)) {
      e.preventDefault();
    }
  }
  useEffect(function () {
    if (element.current) {
      setWidth('1em');
      if (value.length > 0) {
        setWidth(element.current.scrollWidth + "px");
      }
      handleChange();
    }
  }, [value]);
  return /*#__PURE__*/React__default.createElement("input", _extends({
    id: id,
    ref: element,
    "data-testid": "basicInputKeyboard",
    className: 'lemo-basic-input-keyboard ' + className,
    onKeyDown: handleKeyDown,
    onInput: handleChange,
    onFocus: onFocus,
    onBlur: onBlur,
    value: value,
    disabled: isDisabled,
    maxLength: maxLength,
    tabIndex: tabIndex,
    style: {
      width: width
    }
  }, hideKeyboard && {
    inputMode: 'none'
  }));
}
var BasicInputKeyboard$1 = observer(BasicInputKeyboard);

function DivisorList(_ref) {
  var store = _ref.store,
    isTouch = _ref.isTouch;
  var _useState = useState(store.responseList.length),
    lastLength = _useState[0],
    setLastLength = _useState[1];
  function handleFocus(response) {
    response.activeKeyboard();
  }
  function handleBlur(response) {
    response.disableKeyboard();
  }
  function handleChange(response, value) {
    response.setValue(value);
    if (value.length === 0 || parseInt(value) <= 1) return;
    if (store.responseList.length - 1 > response.index) {
      setFocusById(store.responseList[response.index + 1].id);
    }
  }
  useEffect(function () {
    if (lastLength < store.responseList.length && store.isEnabled) {
      var lastItem = store.responseList[store.responseList.length - 1];
      setFocusById(lastItem.id);
    }
    setLastLength(store.responseList.length);
  }, [store.responseList.length]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-divisor-list"
  }, store.responseList.map(function (response) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: response.id,
      className: cn('lemo-divisor', {
        'lemo-selected': response.id === store.keyboard.activeFieldId,
        'lemo-success': response.isSuccess,
        'lemo-error': response.isError
      })
    }, /*#__PURE__*/React__default.createElement(BasicInputKeyboard$1, {
      id: response.id,
      tabIndex: response.index + 1,
      className: "lemo-h1-medium lemo-color-text-02",
      value: response.value,
      onChange: function onChange(value) {
        return handleChange(response, value);
      },
      onFocus: function onFocus() {
        return handleFocus(response);
      },
      onBlur: function onBlur() {
        return handleBlur(response);
      },
      isDisabled: store.isEvaluated,
      maxLength: 2,
      hideKeyboard: isTouch
    }));
  }));
}
var DivisorList$1 = observer(DivisorList);

function MiddleLine() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-middle-line"
  });
}
var MiddleLine$1 = observer(MiddleLine);

function OperationLayout(_ref) {
  var store = _ref.store,
    isTouch = _ref.isTouch;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-operation-layout"
  }, /*#__PURE__*/React__default.createElement(QuotientList$1, {
    quotientList: store.quotientList
  }), /*#__PURE__*/React__default.createElement(MiddleLine$1, {
    elementsLength: store.quotientList.length
  }), /*#__PURE__*/React__default.createElement(DivisorList$1, {
    store: store,
    isTouch: isTouch
  }));
}
var OperationLayout$1 = observer(OperationLayout);

function ResponsePreview(_ref) {
  var _ref$responsePreview = _ref.responsePreview,
    responsePreview = _ref$responsePreview === void 0 ? '' : _ref$responsePreview;
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "responsePreview",
    className: "lemo-h1-medium lemo-color-text-02",
    style: {
      textAlign: 'center'
    },
    dangerouslySetInnerHTML: {
      __html: responsePreview
    }
  });
}
var ResponsePreview$1 = observer(ResponsePreview);

function PrimeNumberDecompositionQuestion(props) {
  var store = props.store;
  var changedHandlers = /reset|setValue/;
  var isTouch = isTouchDevice();
  useEffect(function () {
    store.keyboard.setType(keyboardTypes.PRIME_NUMBERS);
    setFocusById(store.responseList[0].id);
  }, []);
  useEffect(function () {
    if (store.isDisabled && store.currentResponse) {
      clearFocus();
    }
  }, [store.isDisabled]);
  function onBeforeSetValue(_ref) {
    var textContent = _ref.textContent;
    return textContent;
  }
  function handleKeyboardDelete(e) {
    store.keyboard.forceValue('');
    store.currentResponse.setValue('');
    e.preventDefault();
  }
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body lemo-question-name', {})
  }, /*#__PURE__*/React__default.createElement(OperationLayout$1, {
    store: store,
    isTouch: isTouch
  }), /*#__PURE__*/React__default.createElement(ResponsePreview$1, {
    responsePreview: store.responsePreview
  }), /*#__PURE__*/React__default.createElement(LemonadeKeyboard$1, {
    type: keyboardTypes.PRIME_NUMBERS,
    keyboardStore: store.keyboard,
    isActive: store.disabled ? false : store.keyboard.isActive,
    handleDelete: handleKeyboardDelete,
    onKeyboardVisible: function onKeyboardVisible() {
      return console.log('visible');
    },
    tabList: store.tabList,
    onBeforeSetValue: onBeforeSetValue
  })));
}
var PrimeNumberDecompositionQuestion$1 = observer(PrimeNumberDecompositionQuestion);

function isPrimeNumber(n) {
  if (n <= 1) return false;
  if (n === 2 || n === 3) return true;
  if (n % 2 === 0 || n % 3 === 0) return false;
  for (var i = 5; i <= Math.sqrt(n); i = i + 6) if (n % i === 0 || n % (i + 2) === 0) return false;
  return true;
}

var ResponseModel$8 = types$1.compose(ValueModel, withCustomInputKeyboard({
  maxLength: 2
}), types$1.model('ResponseModel', {}).views(function (state) {
  return {
    get keyboard() {
      return getParent(state, 2).keyboard;
    },
    get quotient() {
      var _getParent = getParent(state, 2),
        quotientList = _getParent.quotientList;
      return quotientList[state.index];
    },
    get isEvaluated() {
      return getParent(state, 2).isEvaluated;
    },
    get hasCascadeError() {
      if (state.index === 0) return false;
      var isInteger = function isInteger(v) {
        return Number.isInteger(parseFloat(v));
      };
      var checkErrorRecursive = function checkErrorRecursive(itemList, index) {
        if (index === void 0) {
          index = state.index;
        }
        if (index < 0) return false;
        var currentResponse = itemList[index];
        if (!currentResponse.isValid) return true;
        return isInteger(currentResponse.quotient) ? checkErrorRecursive(itemList, index - 1) : true;
      };
      return checkErrorRecursive(getParent(state));
    },
    get isValid() {
      var isPrime = isPrimeNumber(parseInt(state.value));
      var isFactor = state.quotient % parseInt(state.value) === 0;
      return isPrime && isFactor;
    },
    get isSuccess() {
      if (!state.isEvaluated || state.hasCascadeError) return false;
      return state.isValid;
    },
    get isError() {
      if (!state.isEvaluated) return false;
      return state.hasCascadeError || !state.isValid;
    },
    get isEmpty() {
      return state.value.length === '';
    },
    get isLast() {
      return getParent(state).length - 1 === state.index;
    }
  };
}));

function getPrimeDecomposition(number) {
  var factors = [];
  var divisor = 2;
  while (number >= 2) {
    if (number % divisor === 0) {
      factors.push(divisor);
      number = number / divisor;
    } else {
      divisor++;
    }
  }
  return factors;
}

function getRandomItem$1(arr) {
  var index = Math.floor(Math.random() * arr.length);
  return arr[index];
}
function getDynamicPrimeNumber(_ref) {
  var prime_list = _ref.prime_list,
    factors_length = _ref.factors_length;
  var value = 1;
  for (var i = factors_length - 1; i >= 0; i--) {
    value *= getRandomItem$1(prime_list);
  }
  return value;
}

var PrimeNumberDecompositionQuestionStore = types$1.compose(QuestionBaseModel, withXAPITypeFillIn$1({
  xAPISolution: function xAPISolution(state) {
    return state.getValidResponses();
  }
}), types$1.model({
  responseList: types$1.array(ResponseModel$8),
  keyboard: KeyboardStore
}).actions(function (state) {
  var updateResponseListObserver, editResponseObserver;
  return {
    afterCreate: function afterCreate() {
      updateResponseListObserver = reaction(function () {
        return state.keyboard.activeFieldId;
      }, function () {
        return state.updateResponseList();
      });
      editResponseObserver = reaction(function () {
        var _state$currentRespons;
        return (_state$currentRespons = state.currentResponse) === null || _state$currentRespons === void 0 ? void 0 : _state$currentRespons.value;
      }, function (val) {
        var _state$currentRespons2;
        return ((_state$currentRespons2 = state.currentResponse) === null || _state$currentRespons2 === void 0 ? void 0 : _state$currentRespons2.isLast) && state.createResponse();
      });
    },
    afterDestroy: function afterDestroy() {
      editResponseObserver();
      updateResponseListObserver();
    },
    updateResponseList: function updateResponseList() {
      var isEmpty = function isEmpty(item) {
        return !item ? false : item.value === '';
      };
      var maxIndex = state.responseList.length - 1;
      var lastIndex = maxIndex;
      while (lastIndex >= 0) {
        var lastResponse = state.responseList[lastIndex];
        if (isEmpty(lastResponse) && lastIndex < maxIndex) {
          return state.destroyResponsesFrom(lastResponse.index + 1);
        }
        if (lastResponse.quotient <= 1) {
          destroy(lastResponse);
        }
        lastIndex--;
      }
    },
    destroyResponsesFrom: function destroyResponsesFrom(index) {
      state.responseList.slice(index).forEach(function (response) {
        return destroy(response);
      });
    },
    createResponse: function createResponse() {
      if (state.currentResponse && parseInt(state.currentResponse.value) > 1 && state.lastQuotient > 1) {
        state.responseList.push(getNewResponse());
      }
    },
    clearResponses: function clearResponses() {
      state.responseList.forEach(function (r) {
        return destroy(r);
      });
    },
    reset: function reset() {
      state.clearResponses();
      state.responseList.push(getNewResponse());
      state.baseReset();
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(NumORStr), response)) return false;
      state.clearResponses();
      response.forEach(function (value) {
        return state.responseList.push(getNewResponse(value.toString()));
      });
    },
    onHydrateQuestionPreview: function onHydrateQuestionPreview() {
      console.log('yeahhh');
      state.keyboard.setType(keyboardTypes.PRIME_NUMBERS);
    }
  };
}).views(function (state) {
  return {
    get currentResponse() {
      var id = state.keyboard.activeFieldId;
      return state.responseList.find(function (response) {
        return response.id === id;
      });
    },
    get quotientList() {
      return state.responseList.reduce(function (acc, next) {
        if (!hasContent(next.value)) return acc;
        var value = parseInt(next.value);
        var lastNumber = last(acc);
        var result = lastNumber / value;
        return acc.concat(Number.isInteger(result) ? result : result.toFixed(1));
      }, [state.initialNumber]);
    },
    get lastQuotient() {
      return last(state.quotientList);
    },
    get isDivisible() {
      return state.lastQuotient > 1;
    },
    get responsePreview() {
      var head = state.initialNumber + " = ";
      var body = state.responseList.reduce(function (acc, next) {
        var value = getSnapshot(next).value;
        return value.length > 0 ? acc.concat(value) : acc;
      }, []).join(' &middot; ');
      return head + body;
    },
    get tabList() {
      state.responseList.map(function (r) {
        return r.id;
      });
    },
    getValidResponses: function getValidResponses() {
      return state.points === 1 ? state.getUserResponse() : getPrimeDecomposition(state.initialNumber);
    },
    get initialNumber() {
      if (state.raw.data.initialNumber === -1) {
        return getDynamicPrimeNumber(state.raw.data.dynamic_generator);
      }
      return state.raw.data.initialNumber;
    },
    getSolutions: function getSolutions() {
      return state.getValidResponses();
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$G(rawData);
    },
    get hasErrors() {
      return !!state.responseList.find(function (r) {
        return r.isError;
      });
    },
    getResults: function getResults() {
      var isSolved = state.lastQuotient === 1;
      return !state.hasErrors && isSolved ? 1 : 0;
    },
    getUserResponse: function getUserResponse() {
      return state.responseList.map(function (r) {
        return r.value;
      });
    }
  };
}));
var getNewResponse = function getNewResponse(value) {
  if (value === void 0) {
    value = '';
  }
  return {
    value: value
  };
};
function hasContent(val) {
  return val.length > 0;
}
function _createSnapshot$G(data) {
  return _extends({}, data.data, importCommonValues(data), {
    responseList: [getNewResponse()],
    keyboard: {
      type: keyboardTypes.PRIME_NUMBERS
    }
  });
}
function createStore$U(data) {
  return PrimeNumberDecompositionQuestionStore.create(_createSnapshot$G(data));
}

var PrimeNumberModel = types$1.model({
  number: types$1.number,
  enabled: types$1["boolean"]
}).actions(function (state) {
  return {
    setEnabled: function setEnabled(bool) {
      state.enabled = bool;
      getParent(state, 2).updateNotifier();
    }
  };
}).views(function (state) {
  return {
    get isControlDisabled() {
      return state.enabled && getParent(state, 2).selectionControlsDisabled;
    }
  };
});

var minFactorsLimit = 2;
var minSelectionCount = 1;
var maxFactorsLimit = 6;
var completePrimeNumberList = [2, 3, 5, 7, 11];
var PrimeNumberDecompositionEditorStore = types$1.compose(EditorBaseModel, types$1.model({
  primeList: types$1.array(PrimeNumberModel),
  factorsLength: types$1.number,
  ui_style: BaseModel$1
}).actions(function (state) {
  return {
    setFactorsLength: function setFactorsLength(factorsLength) {
      state.factorsLength = minMax(minFactorsLimit, maxFactorsLimit, factorsLength);
      state.updateNotifier();
    }
  };
}).views(function (state) {
  return {
    get primesSelection() {
      return state.primeList.reduce(function (acc, next) {
        return next.enabled ? [].concat(acc, [next.number]) : acc;
      }, []);
    },
    get selectionControlsDisabled() {
      return state.primesSelection.length === minSelectionCount;
    },
    get output() {
      return exportCommonValues(state, {
        dynamic_generator: {
          prime_list: state.primesSelection,
          factors_length: state.factorsLength
        },
        initialNumber: -1,
        ui_style: getSnapshot(state.ui_style)
      });
    }
  };
}));
function getDynamicGenerator(_ref) {
  var _ref$prime_list = _ref.prime_list,
    prime_list = _ref$prime_list === void 0 ? completePrimeNumberList : _ref$prime_list,
    _ref$factors_length = _ref.factors_length,
    factors_length = _ref$factors_length === void 0 ? 4 : _ref$factors_length;
  return {
    primeList: completePrimeNumberList.map(function (number) {
      return {
        number: number,
        enabled: prime_list.includes(number)
      };
    }),
    factorsLength: factors_length
  };
}
function createSnapshot$d(data) {
  var _data$data$dynamic_ge = data.data.dynamic_generator,
    dynamic_generator = _data$data$dynamic_ge === void 0 ? {} : _data$data$dynamic_ge;
  var _getDynamicGenerator = getDynamicGenerator(dynamic_generator),
    primeList = _getDynamicGenerator.primeList,
    factorsLength = _getDynamicGenerator.factorsLength;
  return _extends({}, data.data, importCommonValues$1(data), {
    primeList: primeList,
    factorsLength: factorsLength
  });
}
function createStore$V(data) {
  return PrimeNumberDecompositionEditorStore.create(createSnapshot$d(data));
}

function Segment$2(_ref) {
  var segmentSize = _ref.segmentSize,
    index = _ref.index,
    children = _ref.children,
    showLabel = _ref.showLabel;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-segment",
    "data-testid": 'segment',
    "data-index": index,
    style: {
      width: segmentSize + "%"
    }
  }, children, /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-vertical-line', {
      'lemo-with-label': showLabel,
      'lemo-label-visible': showLabel
    })
  }));
}
var Segment$3 = observer(Segment$2);

function Line$8(_ref) {
  var segments = _ref.segments,
    segmentSize = _ref.segmentSize,
    segmentWidth = _ref.segmentWidth,
    mode = _ref.mode,
    isSmallScreen = _ref.isSmallScreen,
    showIntegerValues = _ref.showIntegerValues;
  var _useSegmentsVisibilit = useSegmentsVisibility({
      segments: segments,
      isSmallScreen: isSmallScreen
    }),
    isFirst = _useSegmentsVisibilit.isFirst,
    isLast = _useSegmentsVisibilit.isLast;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-find-closest-value__line",
    "data-testid": "line"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-horizontal-line"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-segment-list",
    draggable: false
  }, segments.map(function (segment, idx) {
    var labelVisibility = segment.showLabel;
    return /*#__PURE__*/React__default.createElement(Segment$3, {
      key: segment.id,
      index: segment.index,
      segmentSize: segmentSize,
      showLabel: labelVisibility
    }, /*#__PURE__*/React__default.createElement(Label$1, {
      className: "lemo-text-body-m-medium",
      value: segment.value,
      denominator: segment.denominator,
      showLabel: labelVisibility,
      segmentWidth: segmentWidth,
      isFirst: isFirst(idx),
      isLast: isLast(idx),
      showIntegerValues: showIntegerValues,
      mode: mode
    }));
  })));
}
var Line$9 = observer(Line$8);

function RangePointer() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'lemo-range-pointer'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-range-pointer-inner"
  }));
}
var RangePointer$1 = observer(RangePointer);

var bulletWidth = 37;
function Slider(_ref) {
  var bullet = _ref.bullet,
    width = _ref.width,
    showHandAnimation = _ref.showHandAnimation;
  var _useBulletPosition = useBulletPosition(bullet.position),
    bulletPosition = _useBulletPosition.bulletPosition,
    min = _useBulletPosition.min,
    max = _useBulletPosition.max;
  var _useState = useState(false),
    isSelected = _useState[0],
    setIsSelected = _useState[1];
  function handleRangeChange(e) {
    var value = parseInt(e.target.value);
    bullet.moveTo(value);
  }
  return isAlive(bullet) ? /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-slider', bullet.groupedPositionClass, {
      'lemo-disabled': bullet.disabled,
      'lemo-first-interaction-done': bullet.isModified,
      'lemo-selected': isSelected,
      'lemo-success': bullet.isSuccess,
      'lemo-error': bullet.isWrong
    }),
    style: {
      width: width + "%"
    }
  }, /*#__PURE__*/React__default.createElement("input", {
    "data-testid": "slider",
    type: "range",
    className: "lemo-range",
    min: min,
    max: max,
    value: bullet.position,
    onChange: handleRangeChange,
    onMouseDown: function onMouseDown() {
      return setIsSelected(true);
    },
    onMouseUp: function onMouseUp() {
      return setIsSelected(false);
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-bullet",
    draggable: false
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-bullet-head-wrapper",
    style: {
      left: bulletPosition,
      width: bulletWidth
    }
  }, /*#__PURE__*/React__default.createElement(RangePointer$1, null), /*#__PURE__*/React__default.createElement(SvgRangeHandlerMobile, {
    className: "lemo-tracker"
  })), showHandAnimation && bullet.index === 0 && /*#__PURE__*/React__default.createElement(HandAnimation, null))) : null;
}
function useBulletPosition(position) {
  var min = 0;
  var max = 1000;
  var clampedPosition = Math.max(min, Math.min(max, position));
  return {
    bulletPosition: clampedPosition / 10 + "%",
    min: min,
    max: max
  };
}
var Slider$1 = observer(Slider);

function ExactPosition(_ref) {
  var position = _ref.position,
    width = _ref.width;
  var left = position / 10 + "%";
  var marginLeft = "calc(" + (100 - width) / 2 + "% - 1.5px)";
  console.log('marginLeft', marginLeft);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-exact-position",
    style: {
      left: marginLeft,
      width: width + "%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-exact-position-line",
    style: {
      left: left
    }
  }));
}

function FindClosestValueQuestion(props) {
  var store = props.store,
    _props$solutionsMode = props.solutionsMode,
    solutionsMode = _props$solutionsMode === void 0 ? false : _props$solutionsMode;
  var lineWrapper = useRef(null);
  var changedHandlers = /reset|clickEnd|clickStart|stopDrag|moveTo|updateValidationFromSolutions/;
  var _useLineInitializatio = useLineInitialization(lineWrapper, store, solutionsMode),
    isSmallScreen = _useLineInitializatio.isSmallScreen,
    segmentWidth = _useLineInitializatio.segmentWidth;
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', {
      'lemo-success': store.isSuccess,
      'lemo-error': store.isError,
      'lemo-disabled': store.disabled,
      'lemo-dragging': store.isDragging
    })
  }, /*#__PURE__*/React__default.createElement(Labels, {
    labels: store.labels,
    mode: store.mode,
    denominator: store.denominator,
    showIntegerValues: store.showIntegerValues
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: lineWrapper,
    className: "lemo-number-line-wrapper"
  }, /*#__PURE__*/React__default.createElement(Line$9, {
    segments: store.segments,
    segmentSize: store.segmentSize,
    segmentWidth: segmentWidth,
    isSelecting: store.selectedBullet,
    isDragging: store.isDragging,
    mode: store.mode,
    isSmallScreen: isSmallScreen,
    showIntegerValues: store.showIntegerValues
  }), /*#__PURE__*/React__default.createElement(Slider$1, {
    bullet: store.bullet,
    width: 100 - (4 + store.segmentSize),
    showHandAnimation: store.showHandAnimation
  }), store.showExactPoint && /*#__PURE__*/React__default.createElement(ExactPosition, {
    position: store.solutionPercent,
    width: 100 - (4 + store.segmentSize)
  }))));
}
var FindClosestValueQuestion$1 = observer(FindClosestValueQuestion);

var FCVBulletModel = BulletModel.views(function (state) {
  return {
    get value() {
      var parent = getParent(state, 2);
      var _parent$line = parent.line,
        min = _parent$line.min,
        max = _parent$line.max;
      return min + (max - min) * (state.position / 1000);
    },
    get isValid() {
      var parent = getParent(state, 2);
      var solution = parent.validation.value[0].position;
      var marginOfError = parent.marginOfError;
      return inRange(solution - marginOfError, solution + marginOfError, state.value);
    }
  };
});

var withXAPITypeNumeric = function withXAPITypeNumeric(_ref) {
  var xAPISolution = _ref.xAPISolution;
  return withXAPITypeFillIn$1({
    interactionType: scormTypes.NUMERIC,
    xAPISolution: xAPISolution
  });
};
var withXAPITypeNumeric$1 = (function (_temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
    xAPISolution = _ref2.xAPISolution;
  return withXAPITypeNumeric({
    xAPISolution: xAPISolution
  });
});

var FindClosestValueQuestionStore = types$1.compose(getNumberLineBaseModel(createSnapshot$e, FCVBulletModel), withXAPITypeNumeric$1({
  xAPISolution: function xAPISolution(state) {
    return state.solutionValue;
  }
}), types$1.model({}).actions(function (state) {
  return {
    setResponse: function setResponse(response, force) {
      if (force === void 0) {
        force = false;
      }
      if (!typeChecker(types$1.array(ResponseModel$6), response)) return false;
      if (!force && interruptIfSolutionsMode(state)) return false;
      var _state$line = state.line,
        min = _state$line.min,
        max = _state$line.max;
      var position = (response[0].position - min) / (max - min) * 1000;
      state.bullet.moveTo(position);
    }
  };
}).views(function (state) {
  return {
    get bullet() {
      return state.bullets[0];
    },
    get marginOfError() {
      return state.line.margin_of_error;
    },
    get userResponse() {
      return [{
        position: state.bullet.value
      }];
    },
    get showExactPoint() {
      if (!state.isEvaluated || state.getResults() === 0) return false;
      var margin = 12;
      return !inRange(state.solutionPercent - margin, state.solutionPercent + margin, state.bullet.position);
    },
    get solutionPercent() {
      var _state$line2 = state.line,
        min = _state$line2.min,
        max = _state$line2.max;
      return (state.solutionValue - min) / (max - min) * 1000;
    },
    get solutionValue() {
      return state.validation.value[0].position;
    },
    getFormatedUserResponse: function getFormatedUserResponse() {
      return [{
        position: state.bullet.value
      }];
    },
    getResults: function getResults() {
      return state.bullet.isValid ? 1 : 0;
    },
    getValidResponses: function getValidResponses() {
      return state.bullet.isValid ? state.getUserResponse() : state.validation.value;
    }
  };
}));
function createSegments$3(line, labels) {
  var min = line.min,
    max = line.max,
    divisions = line.divisions;
  var frequency = labels.frequency,
    show_min = labels.show_min,
    show_max = labels.show_max;
  var step = (max - min) / (divisions - 1);
  var showLabel = function showLabel(idx) {
    return when()["case"](idx === 0 && show_min, function () {
      return true;
    })["case"](idx === 0 && !show_min, function () {
      return false;
    })["case"](idx === divisions - 1 && show_max, function () {
      return true;
    })["case"](idx === divisions - 1 && !show_max, function () {
      return false;
    })["case"](idx % frequency === 0, function () {
      return true;
    }).resolve(function () {
      return false;
    });
  };
  return new Array(divisions).fill('').map(function (_, index) {
    return {
      value: parseFloat((min + step * index).toFixed(3)),
      showLabel: showLabel(index)
    };
  });
}
function getFixedDecimals$1(data) {
  return produce(data, function (draft) {
    var _data$data$validation, _data$data$validation2;
    draft.data.validation.valid_response.value = data.data.validation.valid_response.value.map(function (n) {
      return {
        position: parseFloat(n.position.toFixed(3))
      };
    });
    draft.data.validation.alt_responses = (_data$data$validation = data.data.validation) === null || _data$data$validation === void 0 ? void 0 : (_data$data$validation2 = _data$data$validation.alt_responses) === null || _data$data$validation2 === void 0 ? void 0 : _data$data$validation2.map(function (_ref) {
      var score = _ref.score,
        value = _ref.value;
      return {
        score: score,
        value: {
          position: parseFloat(value.position.toFixed(3))
        }
      };
    });
  });
}
function createSnapshot$e(data) {
  var fixedDecimalsData = getFixedDecimals$1(data);
  var _fixedDecimalsData$da = fixedDecimalsData.data,
    validation = _fixedDecimalsData$da.validation,
    line = _fixedDecimalsData$da.line,
    labels = _fixedDecimalsData$da.labels;
  var validResponse = validation.valid_response.value;
  var responsesLength = validation.valid_response.value.length;
  return _extends({}, fixedDecimalsData.data, importCommonValues(fixedDecimalsData), {
    validation: withPenaltyPoints(responsesLength, validation),
    bullets: validResponse.map(function () {
      return {
        position: 0
      };
    }),
    segments: createSegments$3(line, labels)
  });
}
function createStore$W(data) {
  return FindClosestValueQuestionStore.create(createSnapshot$e(data));
}

var iconTitle$4 = /*#__PURE__*/React__default.createElement(SvgSettingsTipography, {
  width: "24",
  className: "lemo-icon-format-shape"
});
var titleBox$5 = 'Configuration';
var helpText$5 = 'config_help';
function FunctionsEditorConfig(_ref) {
  var _store$ui_style;
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "configuration",
    icon: iconTitle$4,
    titleBox: translate(titleBox$5),
    helpText: translate(helpText$5),
    classNameAdd: "lemo-editor-config"
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: 'lemo-small-input',
    title: translate('grid_size_title'),
    subtitle: translate('grid_size_subtitle'),
    inputType: 'number',
    min: 350,
    max: 800,
    value: store.gridSize,
    onChange: store.setGridSize,
    placeholder: translate('title_placeholder')
  }), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: 'lemo-small-input',
    title: translate('grid_divisions_title'),
    subtitle: translate('grid_divisions_description'),
    inputType: 'number',
    min: 8,
    max: 12,
    value: store.gridDivisions,
    onChange: store.setGridDivisions,
    placeholder: translate('title_placeholder')
  }), config.showAuthorVariantsEditor && /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(ConfigVariantStyle$1, {
    onChange: function onChange(value) {
      store.ui_style.customClass.setVariant(value.variant);
      store.ui_style.customClass.setClassList(value.classList);
    },
    variantList: store.variants,
    customClass: {
      variant: (_store$ui_style = store.ui_style) === null || _store$ui_style === void 0 ? void 0 : _store$ui_style.customClass.variant,
      classList: store.ui_style.customClass.classList
    }
  })));
}
var FunctionsEditorConfig$1 = observer(FunctionsEditorConfig);

function NumericInput(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    _ref$characterSet = _ref.characterSet,
    characterSet = _ref$characterSet === void 0 ? defaultCharacterSet : _ref$characterSet,
    _ref$isValidContent = _ref.isValidContent,
    isValidContent = _ref$isValidContent === void 0 ? defaultValidateContent : _ref$isValidContent,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? -1 : _ref$max,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  var _useState = useState(false),
    hasError = _useState[0],
    setHasError = _useState[1];
  var inputRef = useRef(null);
  var isEditingRef = useRef(false);
  useEffect(function () {
    if (inputRef.current && !isEditingRef.current) {
      inputRef.current.textContent = value;
    }
  }, [value]);
  function handleKeyDown(e) {
    var val = e.target.textContent;
    var key = e.key;
    var allowedEntry = key.match(characterSet);
    if (key === 'Enter') {
      return e.preventDefault();
    }
    if (!allowedEntry && !allowedKeys.includes(key)) {
      return e.preventDefault();
    }
    if (max !== -1 && Number(val + e.key) > max) {
      return e.preventDefault();
    }
  }
  function handleChange(e) {
    var val = e.target.textContent;
    var allowedEntry = val.match(characterSet);
    if (!allowedEntry) return e.preventDefault();
    isValidContent(val) && onChange(val);
  }
  function handleFocus() {
    isEditingRef.current = true;
    setHasError(false);
  }
  function handleBlur(e) {
    isEditingRef.current = false;
    var val = e.target.textContent;
    setHasError(!isValidContent(val));
  }
  return /*#__PURE__*/React__default.createElement("div", {
    ref: inputRef,
    className: cn$1(defaultClassList, {
      'lemo-error': hasError,
      'lemo-full-width': fullWidth
    }),
    style: style,
    onKeyDown: handleKeyDown,
    contentEditable: true,
    onInput: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus,
    suppressContentEditableWarning: true
  });
}
var defaultCharacterSet = /[0-9.+-]/;
var allowedKeys = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Backspace', 'Tab', 'Delete'];
var defaultClassList = ['lemo-numeric-input', 'lemo-base-input', 'lemo-box-small', 'lemo-is-empty'].join(' ');
function defaultValidateContent(value) {
  var validFormat = /^[-+]?\d+(\.\d+)?$/.test(value);
  if (!validFormat) return false;
  var asNumber = Number(value);
  return !isNaN(asNumber);
}
var NumericInput$1 = observer(NumericInput);

function SolutionLineal(_ref) {
  var solution = _ref.solution;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-function-list-solution"
  }, /*#__PURE__*/React__default.createElement(NumericInput$1, {
    value: solution[0].value,
    onChange: solution[0].setValue
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-text-body-l-bold lemo-color-text-02"
  }, "x + "), /*#__PURE__*/React__default.createElement(NumericInput$1, {
    value: solution[1].value,
    onChange: solution[1].setValue
  }));
}
var SolutionLineal$1 = observer(SolutionLineal);

function SolutionQuadratic(_ref) {
  var solution = _ref.solution;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(NumericInput$1, {
    value: solution[0].value,
    onChange: solution[0].setValue
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-text-body-l-bold lemo-color-text-02"
  }, "x", /*#__PURE__*/React__default.createElement("sup", null, "2"), " +", ' '), /*#__PURE__*/React__default.createElement(NumericInput$1, {
    value: solution[1].value,
    onChange: solution[1].setValue
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-text-body-l-bold lemo-color-text-02"
  }, "x + "), /*#__PURE__*/React__default.createElement(NumericInput$1, {
    value: solution[2].value,
    onChange: solution[2].setValue
  }));
}
var SolutionQuadratic$1 = observer(SolutionQuadratic);

var addButtonTooltipDescription = 'add_function';
var addButtonText = 'add_function';
function FunctionList(_ref) {
  var store = _ref.store;
  var SolutionComponent = store.functionType === 'LINEAL' ? SolutionLineal$1 : SolutionQuadratic$1;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-function-list"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-function-list-container"
  }, store.functionList.map(function (solution, idx) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-function-item-container lemo-box-light",
      key: idx
    }, /*#__PURE__*/React__default.createElement(SolutionComponent, {
      solution: solution.values
    }), idx > 0 && /*#__PURE__*/React__default.createElement("button", {
      className: "lemo-delete-button lemo-button-icon__button",
      onClick: function onClick() {
        return store.removeFunction(idx);
      }
    }, /*#__PURE__*/React__default.createElement(SvgTrash$1, {
      className: "lemo-icon",
      width: 24,
      height: 24,
      fill: "var(--lemo-color-gray-03)"
    })));
  })), store.addButtonAvailable && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-horizontal-content lemo-editor-horizontal-content--space-between"
  }, /*#__PURE__*/React__default.createElement(SimpleTooltipWrapper, {
    text: translate(addButtonTooltipDescription)
  }, /*#__PURE__*/React__default.createElement(AddButton, {
    text: translate(addButtonText),
    onClick: store.addFunction,
    disabled: store.addButtonDisabled
  }))));
}
var FunctionList$1 = observer(FunctionList);

function FunctionPreview(_ref) {
  var functionList = _ref.functionList;
  var validateInput = function validateInput(value) {
    return value.reduce(function (acc, next) {
      return !isNaN(Number(next) ? acc : true);
    }, true);
  };
  var createFormula = function createFormula(value) {
    return value.length === 2 ? "\"" + value[0] + "x + " + value[1] + "\"" : "\"" + value[0] + "x^2 + " + value[1] + "x + " + value[2] + "\"";
  };
  var createLatex = function createLatex(value) {
    return functionList.map(createFormula).toString();
  };
  var createFragment = function createFragment(value) {
    return validateInput(value) ? "<div class='lemo-math-expression-view' data-latex='[" + createLatex() + "]'></div>" : '';
  };
  return /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    content: createFragment(functionList),
    style: {
      maxWidth: 400,
      margin: '0 auto'
    }
  });
}
var FunctionPreview$1 = observer(FunctionPreview);

var idBox$4 = 'Functions';
var titleBoxRef$3 = 'functions_editor';
var titleBoxHelpRef$3 = 'functions_editor_help';
function FunctionsConfigurator(_ref) {
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: idBox$4,
    icon: /*#__PURE__*/React__default.createElement(SvgMenuAlt, {
      width: "24"
    }),
    titleBox: translate(titleBoxRef$3),
    helpText: translate(titleBoxHelpRef$3),
    classNameAdd: "lemo-editor-line-chart-table"
  }, /*#__PURE__*/React__default.createElement(FunctionPreview$1, {
    functionList: store.functionsOutput
  }), /*#__PURE__*/React__default.createElement(FunctionList$1, {
    store: store
  }));
}
var FunctionsConfigurator$1 = observer(FunctionsConfigurator);

var _excluded$t = ["store", "changed", "type", "immediateFeedback"];
function CountingEditor$3(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$t);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setGridSize|setGridDivisions|addFunction|removeFunction|setValue",
    changedHandlerDebugger: false,
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 1
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 2,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(FunctionsConfigurator$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(FunctionsEditorConfig$1, {
    store: store
  }));
}
var FunctionsEditor = observer(CountingEditor$3);

function StaticOperationConfig(_ref) {
  var itemList = _ref.itemList,
    onAddItem = _ref.onAddItem,
    onSortItems = _ref.onSortItems,
    onRemoveItem = _ref.onRemoveItem,
    max = _ref.max;
  var isDisabled = itemList.length >= 5;
  return /*#__PURE__*/React__default.createElement(EditorItemList$1, {
    itemList: itemList,
    addButtonText: translate('add_row'),
    addButtonTooltipDescription: translate('linechart_add_row_description'),
    addButtonDisabled: isDisabled,
    onAddItem: onAddItem,
    onDragItem: onSortItems,
    onRemoveItem: onRemoveItem,
    min: 2
  }, function (item) {
    return /*#__PURE__*/React__default.createElement("div", {
      style: {
        margin: '0.4em',
        width: '100%'
      }
    }, /*#__PURE__*/React__default.createElement(NumericInput$1, {
      value: item.value,
      onChange: item.setValue,
      max: max,
      characterSet: /[0-9]/,
      fullWidth: true,
      style: {
        margin: 0,
        padding: '0.8em'
      }
    }));
  });
}
var StaticOperationConfig$1 = observer(StaticOperationConfig);

function DynamicOperationConfig(_ref) {
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: 'lemo-small-input',
    title: translate('digits_per_addend_title'),
    subtitle: translate('digits_per_addend_subtitle'),
    inputType: 'number',
    min: store.digitsPerAddendLimits.min,
    max: store.digitsPerAddendLimits.max,
    value: store.digitsPerAddend,
    onChange: store.updateDigitsPerAddend,
    selectAllOnFocus: true,
    placeholder: translate('title_placeholder')
  }), /*#__PURE__*/React__default.createElement(ShowWhen$1, {
    condition: !store.isSubtraction
  }, /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: 'lemo-small-input',
    title: translate('addend_count_title'),
    subtitle: translate('addend_count_subtitle'),
    inputType: 'number',
    min: store.addendCountLimits.min,
    max: store.addendCountLimits.max,
    value: store.addendCount,
    onChange: store.updateAddendCount,
    selectAllOnFocus: true,
    placeholder: translate('title_placeholder')
  })));
}
var DynamicOperationConfig$1 = observer(DynamicOperationConfig);

function StaticSubtractionConfig(_ref) {
  var itemList = _ref.itemList,
    max = _ref.max;
  return /*#__PURE__*/React__default.createElement("div", null, itemList.map(function (item) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: item.id,
      style: {
        margin: '0.4em',
        width: '100%'
      }
    }, /*#__PURE__*/React__default.createElement(NumericInput$1, {
      value: item.value,
      onChange: item.setValue,
      max: max,
      characterSet: /[0-9]/,
      fullWidth: true,
      style: {
        margin: 0,
        padding: '0.8em'
      }
    }));
  }));
}
var StaticSubtractionConfig$1 = observer(StaticSubtractionConfig);

var idBox$5 = 'OperationEditor';
var titleBoxRef$4 = 'operation_editor';
var titleBoxHelpRef$4 = 'operation_editor_help';
function OperationConfigurator(_ref) {
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: idBox$5,
    icon: /*#__PURE__*/React__default.createElement(SvgMenuAlt, {
      width: "24"
    }),
    titleBox: translate(titleBoxRef$4),
    helpText: translate(titleBoxHelpRef$4)
  }, /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('config_operation_title'),
    subtitle: translate('config_operation_subtitle'),
    isChecked: store.isDynamic,
    onChange: store.setDynamicOperation
  }), /*#__PURE__*/React__default.createElement(ShowWhen$1, {
    condition: store.isDynamic
  }, /*#__PURE__*/React__default.createElement(DynamicOperationConfig$1, {
    store: store
  })), /*#__PURE__*/React__default.createElement(ShowWhen$1, {
    condition: !store.isDynamic
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: '1em'
    }
  }, !store.isSubtraction ? /*#__PURE__*/React__default.createElement(StaticOperationConfig$1, {
    itemList: store.responses,
    onAddItem: store.addResponse,
    onSortItems: store.sortResponse,
    onRemoveItem: store.removeResponse,
    max: store.maxValuePerAddend
  }) : /*#__PURE__*/React__default.createElement(StaticSubtractionConfig$1, {
    itemList: store.responses,
    max: store.maxValuePerAddend
  }))));
}
var OperationConfig = observer(OperationConfigurator);

var iconTitle$5 = /*#__PURE__*/React__default.createElement(SvgSettingsTipography, {
  width: "24",
  className: "lemo-icon-format-shape"
});
var titleBox$6 = 'Configuration';
var helpText$6 = 'config_help';
function VerticalOperationEditorConfig(_ref) {
  var _store$ui_style;
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "configuration",
    icon: iconTitle$5,
    titleBox: translate(titleBox$6),
    helpText: translate(helpText$6),
    classNameAdd: "lemo-editor-config"
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement(ConfigShowCheckIcon, {
    title: translate('column_help_title'),
    subtitle: translate('column_help_subtitle'),
    isChecked: store.ui_style.column_help,
    onChange: function onChange(bool) {
      return store.ui_style.setColumnHelp(bool);
    }
  }), /*#__PURE__*/React__default.createElement(ShowWhen$1, {
    condition: !store.isSubtraction
  }, /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(ConfigShowCheckIcon, {
    title: translate('order_terms_title'),
    subtitle: translate('order_terms_subtitle'),
    isChecked: store.ui_style.order_terms,
    onChange: function onChange(bool) {
      return store.ui_style.setOrderTerms(bool);
    }
  })), config.showAuthorVariantsEditor && /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(ConfigVariantStyle$1, {
    onChange: function onChange(value) {
      store.ui_style.customClass.setVariant(value.variant);
      store.ui_style.customClass.setClassList(value.classList);
    },
    variantList: store.variants,
    customClass: {
      variant: (_store$ui_style = store.ui_style) === null || _store$ui_style === void 0 ? void 0 : _store$ui_style.customClass.variant,
      classList: store.ui_style.customClass.classList
    }
  })));
}
var VerticalOperationEditorConfig$1 = observer(VerticalOperationEditorConfig);

var _excluded$u = ["store", "changed", "type", "immediateFeedback"];
function VerticalOperationEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$u);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setDynamicOperation|setValue|removeResponse|addResponse|sortResponse|updateDigitsPerAddend|updateAddendCount|setColumnHelp|setOrderTerms",
    changedHandlerDebugger: false,
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 0
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 1,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref[EDITOR_COMPONENT_COMMON.BACKGROUND] = {
      order: 3
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(OperationConfig, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(VerticalOperationEditorConfig$1, {
    store: store
  }));
}
var VerticalOperationEditor$1 = observer(VerticalOperationEditor);

function CheckBoxSquareLabel(_ref) {
  var label = _ref.label,
    onChange = _ref.onChange,
    checked = _ref.checked,
    isDisabled = _ref.isDisabled,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  function handleClick() {
    if (isDisabled) return;
    onChange(!checked);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames('lemo-checkbox-square-label', className, {
      'lemo-selected': checked,
      'lemo-disabled': isDisabled
    }),
    onClick: handleClick
  }, /*#__PURE__*/React__default.createElement(CheckBoxSquareIcon, {
    checked: checked
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-text-body-m-regular lemo-color-text-02"
  }, label));
}
var CheckBoxSquareLabel$1 = observer(CheckBoxSquareLabel);

var idBox$6 = 'Functions';
var titleBoxRef$5 = 'prime_number_generator_editor';
var titleBoxHelpRef$5 = 'prime_number_generator_editor_help';
var enabledPrimesTitle = 'enabled_factors_title';
var enabledPrimesSubTitle = 'enabled_factors_subtitle';
var factorsLengthTitle = 'factors_length_title';
var factorsLengthSubtitle = 'factors_length_subtitle';
function PrimeNumberConfigurator(_ref) {
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: idBox$6,
    icon: /*#__PURE__*/React__default.createElement(SvgMenuAlt, {
      width: "24"
    }),
    titleBox: translate(titleBoxRef$5),
    helpText: translate(titleBoxHelpRef$5),
    classNameAdd: "lemo-editor-line-chart-table"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      lineHeight: 1.4
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "lemo-text-body-m-medium lemo-color-text-02"
  }, translate(enabledPrimesTitle)), /*#__PURE__*/React__default.createElement("p", {
    className: " lemo-text-body-m-regular lemo-color-text-03"
  }, translate(enabledPrimesSubTitle)), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-prime-number-list"
  }, store.primeList.map(function (item) {
    return /*#__PURE__*/React__default.createElement(CheckBoxSquareLabel$1, {
      key: 'primeNumberIndex_' + item.number,
      label: item.number,
      checked: item.enabled,
      onChange: item.setEnabled,
      isDisabled: item.isControlDisabled
    });
  }))), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: "lemo-small-input",
    title: translate(factorsLengthTitle),
    subtitle: translate(factorsLengthSubtitle),
    value: store.factorsLength,
    onChange: store.setFactorsLength,
    inputType: 'number',
    selectAllOnFocus: true
  }));
}
var PrimeNumberConfigurator$1 = observer(PrimeNumberConfigurator);

var _excluded$v = ["store", "changed", "type", "immediateFeedback"];
function PrimeNumberDecompositionEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$v);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    changedHandlerDebugger: false,
    type: type,
    patternParticular: "setEnabled|setType|setFactorsLength",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 0
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 1,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref[EDITOR_COMPONENT_COMMON.BACKGROUND] = {
      order: 3
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(PrimeNumberConfigurator$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: []
  }));
}
var PrimeNumberDecompositionEditor$1 = observer(PrimeNumberDecompositionEditor);

var _excluded$w = ["autoFocus"];
function getMath(props) {
  var _getCreator = getCreator(props, getDefaultData$5, types.math.ClozeMath),
    type = _getCreator.type,
    exerciseData = _getCreator.exerciseData,
    setCommonParamsStore = _getCreator.setCommonParamsStore;
  return when()["case"](type === types.math.ClozeMath, function () {
    var questionStore = createStore$A(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$z(exerciseData);
    setCommonParamsStore(editorStore);
    return createClozeMath(editorStore, questionStore);
  })["case"](type === types.math.Counting, function () {
    var questionStore = createStore$B(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$C(exerciseData);
    setCommonParamsStore(editorStore);
    return createCounting(editorStore, questionStore);
  })["case"](type === types.math.NumberLine, function () {
    var questionStore = createStore$F(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$G(exerciseData);
    setCommonParamsStore(editorStore);
    return createNumberLine(editorStore, questionStore);
  })["case"](type === types.math.Fraction, function () {
    var questionStore = createStore$H(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$I(exerciseData);
    setCommonParamsStore(editorStore);
    return createFractions(editorStore, questionStore);
  })["case"](type === types.math.CoordinateAxes, function () {
    var questionStore = createStore$K(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$J(exerciseData);
    setCommonParamsStore(editorStore);
    return createCoordinateAxes(editorStore, questionStore);
  })["case"](type === types.math.Boxplot, function () {
    var questionStore = createStore$L(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$M(exerciseData);
    setCommonParamsStore(editorStore);
    return createBoxplot(editorStore, questionStore);
  })["case"](type === types.math.Sum, function () {
    var questionStore = createStore$O(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$P(exerciseData);
    setCommonParamsStore(editorStore);
    return createSum(editorStore, questionStore);
  })["case"](type === types.math.Subtraction, function () {
    var questionStore = createStore$Q(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$P(exerciseData);
    setCommonParamsStore(editorStore);
    return createSubtraction(editorStore, questionStore);
  })["case"](type === types.math.TransformationsInPlane, function () {
    var questionStore = createStore$R(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$N(exerciseData);
    setCommonParamsStore(editorStore);
    return createTransformationsInPlane(editorStore, questionStore);
  })["case"](type === types.math.LinealFunction, function () {
    var questionStore = createStore$S(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$T(exerciseData);
    setCommonParamsStore(editorStore);
    return createFunctions(editorStore, questionStore);
  })["case"](type === types.math.QuadraticFunction, function () {
    var questionStore = createStore$S(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$T(exerciseData);
    setCommonParamsStore(editorStore);
    return createFunctions(editorStore, questionStore);
  })["case"](type === types.math.PrimeNumberDecomposition, function () {
    var questionStore = createStore$U(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$V(exerciseData);
    setCommonParamsStore(editorStore);
    return createPrimeNumberDecomposition(editorStore, questionStore);
  })["case"](type === types.math.FindClosestValue, function () {
    var questionStore = createStore$W(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$N(exerciseData);
    setCommonParamsStore(editorStore);
    return createFindClosestValue(editorStore, questionStore);
  }).resolve(null);
}
function createClozeMath(editorStore, questionStore) {
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      var _extraParams$autoFocu = extraParams.autoFocus,
        autoFocus = _extraParams$autoFocu === void 0 ? autoFocusTypes.NONE : _extraParams$autoFocu,
        restExtraParams = _objectWithoutPropertiesLoose(extraParams, _excluded$w);
      return /*#__PURE__*/React__default.createElement(ClozeMathQuestion$1, _extends({
        store: questionStore
      }, restExtraParams, {
        autoFocus: getAutoFocus(autoFocus)
      }));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(ClozeMathEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createCounting(editorStore, questionStore) {
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(CountingQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(CountingEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createNumberLine(editorStore, questionStore) {
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(NumberLineQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(NumberLineEditor, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createFractions(editorStore, questionStore, initialProps, lang) {
  return commonCreatorProps(editorStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(FractionsQuestion, _extends({
        store: questionStore
      }, initialProps, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(FractionEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Feedback: function Feedback(extraParams) {
      return /*#__PURE__*/React__default.createElement(FeedbackManager$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createCoordinateAxes(editorStore, questionStore) {
  return commonCreatorProps(editorStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(CoordinateAxesQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(CoordinateAxesEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Feedback: function Feedback(extraParams) {
      return /*#__PURE__*/React__default.createElement(FeedbackManager$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createBoxplot(editorStore, questionStore) {
  return commonCreatorProps(editorStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(BoxplotQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(BoxplotEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Feedback: function Feedback(extraParams) {
      return /*#__PURE__*/React__default.createElement(FeedbackManager$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createSum(editorStore, questionStore) {
  return commonCreatorProps(editorStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(SumQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(VerticalOperationEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Feedback: function Feedback(extraParams) {
      return /*#__PURE__*/React__default.createElement(FeedbackManager$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createSubtraction(editorStore, questionStore) {
  return commonCreatorProps(editorStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(SubtractionQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(VerticalOperationEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Feedback: function Feedback(extraParams) {
      return /*#__PURE__*/React__default.createElement(FeedbackManager$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createTransformationsInPlane(editorStore, questionStore) {
  return commonCreatorProps(editorStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(TransformationsInPlaneQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Editor: function Editor() {
      return /*#__PURE__*/React__default.createElement("p", null, "Editor in progress");
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Feedback: function Feedback(extraParams) {
      return /*#__PURE__*/React__default.createElement(FeedbackManager$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createFunctions(editorStore, questionStore) {
  return commonCreatorProps(editorStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(FunctionsQuestion, _extends({
        store: questionStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(FunctionsEditor, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Feedback: function Feedback(extraParams) {
      return /*#__PURE__*/React__default.createElement(FeedbackManager$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createPrimeNumberDecomposition(editorStore, questionStore) {
  return commonCreatorProps(editorStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(PrimeNumberDecompositionQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(PrimeNumberDecompositionEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Feedback: function Feedback(extraParams) {
      return /*#__PURE__*/React__default.createElement(FeedbackManager$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createFindClosestValue(editorStore, questionStore) {
  return commonCreatorProps(editorStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(FindClosestValueQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Editor: function Editor() {
      return /*#__PURE__*/React__default.createElement("p", null, "Editor in progress");
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Feedback: function Feedback(extraParams) {
      return /*#__PURE__*/React__default.createElement(FeedbackManager$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}

var controlsStatus$4 = {
  empty: {
    id: 'empty',
    visible: {
      send: true
    },
    disabled: {
      send: true
    }
  },
  notAllowed: {
    id: 'notAllowed',
    visible: {
      tryAgain: true,
      cantSpeakNow: true
    },
    disabled: {}
  },
  notAvailable: {
    id: 'notAvailable',
    visible: {
      tryAgain: true,
      cantSpeakNow: true
    },
    disabled: {}
  },
  notModified: {
    id: 'notModified',
    visible: {
      send: true
    },
    disabled: {
      send: true
    }
  },
  modified: {
    id: 'modified',
    visible: {
      send: true
    },
    disabled: {}
  },
  locked: {
    id: 'locked',
    visible: {
      repeat: true,
      send: true
    },
    disabled: {
      send: true
    }
  }
};
function useRecordAudioControlsStatus(status) {
  return controlsStatus$4[status];
}

var RecordAudioControls = function RecordAudioControls(_ref) {
  var disabled = _ref.disabled,
    store = _ref.store,
    _ref$onSend = _ref.onSend,
    onSend = _ref$onSend === void 0 ? null : _ref$onSend,
    _ref$onBeforeSend = _ref.onBeforeSend,
    onBeforeSend = _ref$onBeforeSend === void 0 ? null : _ref$onBeforeSend,
    _ref$onEdit = _ref.onEdit,
    onEdit = _ref$onEdit === void 0 ? null : _ref$onEdit,
    _ref$onTryAgain = _ref.onTryAgain,
    onTryAgain = _ref$onTryAgain === void 0 ? null : _ref$onTryAgain,
    _ref$onCantSpeakNow = _ref.onCantSpeakNow,
    onCantSpeakNow = _ref$onCantSpeakNow === void 0 ? null : _ref$onCantSpeakNow,
    _ref$showHints = _ref.showHints,
    showHints = _ref$showHints === void 0 ? true : _ref$showHints,
    _ref$showSend = _ref.showSend,
    showSend = _ref$showSend === void 0 ? true : _ref$showSend,
    _ref$showRepeat = _ref.showRepeat,
    showRepeat = _ref$showRepeat === void 0 ? true : _ref$showRepeat,
    _ref$visible = _ref.visible,
    visible = _ref$visible === void 0 ? true : _ref$visible,
    _ref$renderScore = _ref.renderScore,
    renderScore = _ref$renderScore === void 0 ? null : _ref$renderScore,
    children = _ref.children;
  useDefaultProp({
    setter: store.setDisabled,
    value: disabled
  });
  var status = useRecordAudioControlsStatus(store.controlsStatus);
  var isRepeatInProgress = store.showRepeatControls && {
    visibility: 'hidden'
  };
  var handleSend = useCallback(function () {
    var next = function next() {
      store.send();
      onSend === null || onSend === void 0 ? void 0 : onSend(store.getResponse());
    };
    onBeforeSend ? onBeforeSend(next) : next();
  }, [store]);
  var handleEdit = useCallback(function () {
    store.repeat();
    onEdit === null || onEdit === void 0 ? void 0 : onEdit(store.getResponse());
  }, [store]);
  var handleTryAgain = useCallback(function () {
    store.tryAgain();
    onTryAgain === null || onTryAgain === void 0 ? void 0 : onTryAgain(store.getResponse());
  }, [store]);
  var handleOnCantSpeakNow = useCallback(function () {
    onCantSpeakNow === null || onCantSpeakNow === void 0 ? void 0 : onCantSpeakNow();
  }, [store]);
  var isVisible = visible && store.context !== questionContext.REVISION;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-send-controls"
  }, children, isVisible && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-controls-wrapper",
    style: _extends({}, isRepeatInProgress)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-controls-left"
  }, renderScore && /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-points"
  }, renderScore()), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: showHints
  }, /*#__PURE__*/React__default.createElement(ButtonHint$1, {
    hints: store.hints
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-controls-right"
  }, /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: showRepeat && status.visible.repeat
  }, /*#__PURE__*/React__default.createElement(InlineButton, {
    className: "lemo-controls-button-edit",
    onClick: handleEdit,
    title: translate('button_edit'),
    disabled: status.disabled.repeat
  }, /*#__PURE__*/React__default.createElement(SvgReplay, {
    className: "lemo-icon",
    width: 22,
    heigth: 22
  }), ' ', translate('button_repeat'))), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: showSend && status.visible.send
  }, /*#__PURE__*/React__default.createElement(SimpleButton, {
    className: "lemo-controls-button-send",
    variant: variantsSimpleButton.primary,
    onClick: handleSend,
    disabled: status.disabled.send
  }, translate('send'))), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: showRepeat && status.visible.cantSpeakNow
  }, /*#__PURE__*/React__default.createElement(InlineButton, {
    className: "lemo-controls-button-cant-speak-now",
    onClick: handleOnCantSpeakNow,
    title: translate('button_cant_speak_now'),
    disabled: status.disabled.cantSpeakNow
  }, translate('button_cant_speak_now'))), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: showRepeat && status.visible.tryAgain
  }, /*#__PURE__*/React__default.createElement(SimpleButton, {
    className: "lemo-controls-button-try-again",
    variant: variantsSimpleButton.primary,
    onClick: handleTryAgain,
    title: translate('button_try-again'),
    disabled: status.disabled.tryAgain
  }, /*#__PURE__*/React__default.createElement(SvgReplay, {
    className: "lemo-icon",
    width: 22,
    heigth: 22
  }), ' ', translate('button_try_again'))))));
};
var RecordAudioControls$1 = observer(RecordAudioControls);

var StatementControls = function StatementControls(_ref) {
  var disabled = _ref.disabled,
    store = _ref.store,
    _ref$onSend = _ref.onSend,
    onSend = _ref$onSend === void 0 ? null : _ref$onSend,
    _ref$showHints = _ref.showHints,
    showHints = _ref$showHints === void 0 ? true : _ref$showHints,
    _ref$visible = _ref.visible,
    visible = _ref$visible === void 0 ? true : _ref$visible,
    _ref$renderScore = _ref.renderScore,
    renderScore = _ref$renderScore === void 0 ? null : _ref$renderScore,
    children = _ref.children;
  useDefaultProp({
    setter: store.setDisabled,
    value: disabled
  });
  var handleSend = useCallback(function () {
    store.send();
    onSend !== null && onSend(store);
  }, [store]);
  var shouldShowHints = function shouldShowHints() {
    return showHints;
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-send-controls"
  }, children, visible && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-controls-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-controls-left"
  }, renderScore && /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-points"
  }, renderScore()), shouldShowHints() && /*#__PURE__*/React__default.createElement(ButtonHint$1, {
    hints: store.hints
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-controls-right"
  }, /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: store.button.length
  }, /*#__PURE__*/React__default.createElement(SimpleButton, {
    className: "lemo-controls-button-send",
    variant: variantsSimpleButton.primary,
    onClick: handleSend,
    disabled: disabled || store.disableSend
  }, defaultValue('buttonActionName', store, translate('send')))))));
};
var StatementControls$1 = observer(StatementControls);

function noFN$1() {}
function useUploadStatus(_ref) {
  var store = _ref.store,
    _ref$onChangeStatus = _ref.onChangeStatus,
    onChangeStatus = _ref$onChangeStatus === void 0 ? noFN$1 : _ref$onChangeStatus,
    _ref$onUploadComplete = _ref.onUploadComplete,
    onUploadComplete = _ref$onUploadComplete === void 0 ? noFN$1 : _ref$onUploadComplete,
    _ref$onUploadError = _ref.onUploadError,
    onUploadError = _ref$onUploadError === void 0 ? noFN$1 : _ref$onUploadError;
  useEffect(function () {
    var tracker = reaction(function () {
      return store.status;
    }, function (newStatus) {
      onChangeStatus === null || onChangeStatus === void 0 ? void 0 : onChangeStatus(newStatus);
      if (newStatus === fileStatuses.COMPLETE) {
        onUploadComplete === null || onUploadComplete === void 0 ? void 0 : onUploadComplete(store.getResponse());
      }
      if (newStatus === fileStatuses.ERROR) {
        onUploadError === null || onUploadError === void 0 ? void 0 : onUploadError(store.getResponse());
      }
    });
    return function () {
      return tracker();
    };
  }, []);
}

var controlsStatus$5 = {
  empty: {
    id: 'empty',
    visible: {
      send: true
    },
    disabled: {
      send: true
    }
  },
  initial: {
    id: 'initial',
    visible: {
      send: true
    },
    disabled: {}
  },
  sending: {
    id: 'sending',
    visible: {
      sending: true
    },
    disabled: {
      sending: true
    }
  },
  complete: {
    id: 'complete',
    visible: {
      send: true,
      repeat: true
    },
    disabled: {
      send: true
    }
  }
};
var UploadFileControls = function UploadFileControls(_ref) {
  var disabled = _ref.disabled,
    store = _ref.store,
    onSend = _ref.onSend,
    onRepeat = _ref.onRepeat,
    onChangeStatus = _ref.onChangeStatus,
    onUploadComplete = _ref.onUploadComplete,
    onBeforeSend = _ref.onBeforeSend,
    _ref$showHints = _ref.showHints,
    showHints = _ref$showHints === void 0 ? true : _ref$showHints,
    _ref$showSend = _ref.showSend,
    showSend = _ref$showSend === void 0 ? true : _ref$showSend,
    _ref$showRepeat = _ref.showRepeat,
    showRepeat = _ref$showRepeat === void 0 ? true : _ref$showRepeat,
    _ref$visible = _ref.visible,
    visible = _ref$visible === void 0 ? true : _ref$visible,
    _ref$renderScore = _ref.renderScore,
    renderScore = _ref$renderScore === void 0 ? null : _ref$renderScore,
    children = _ref.children;
  useDefaultProp({
    setter: store.setDisabled,
    value: disabled
  });
  useUploadStatus({
    store: store,
    onChangeStatus: onChangeStatus,
    onUploadComplete: onUploadComplete
  });
  var START = fileStatuses.START,
    ERROR = fileStatuses.ERROR,
    ADDED = fileStatuses.ADDED,
    UPLOADING = fileStatuses.UPLOADING,
    COMPLETE = fileStatuses.COMPLETE,
    FILE_LIMIT = fileStatuses.FILE_LIMIT;
  var eq = function eq(currentState) {
    return store.status === currentState;
  };
  var isEmpty = eq(START) || eq(ERROR);
  var isInitial = eq(ADDED) || eq(FILE_LIMIT);
  var isSending = eq(UPLOADING);
  var isComplete = eq(COMPLETE);
  var status = when()["case"](isEmpty, function () {
    return controlsStatus$5.empty;
  })["case"](isInitial, function () {
    return controlsStatus$5.initial;
  })["case"](isSending, function () {
    return controlsStatus$5.sending;
  })["case"](isComplete, function () {
    return controlsStatus$5.complete;
  }).resolve();
  var handleSend = useCallback(function () {
    var next = function next() {
      var ifAbortDeleteFile = true;
      store.send(ifAbortDeleteFile);
      onSend === null || onSend === void 0 ? void 0 : onSend(store.getResponse());
    };
    onBeforeSend ? onBeforeSend(next) : next();
  }, [store, onSend]);
  var handleRepeat = useCallback(function () {
    store.reset();
    onRepeat === null || onRepeat === void 0 ? void 0 : onRepeat();
  }, [store, onRepeat]);
  var isVisible = visible && store.context !== questionContext.REVISION;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-send-controls"
  }, children, isVisible && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-controls-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-controls-left"
  }, renderScore && /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-points"
  }, renderScore()), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: showHints
  }, /*#__PURE__*/React__default.createElement(ButtonHint$1, {
    hints: store.hints
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-controls-right"
  }, /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: showRepeat && status.visible.repeat
  }, /*#__PURE__*/React__default.createElement(InlineButton, {
    className: "lemo-controls-button-reset",
    onClick: handleRepeat,
    disabled: status.disabled.repeat,
    title: translate('button_repeat')
  }, /*#__PURE__*/React__default.createElement(SvgReply, {
    className: "lemo-icon"
  }), " ", translate('button_repeat'))), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: showSend && status.visible.send
  }, /*#__PURE__*/React__default.createElement(SimpleButton, {
    className: "lemo-controls-button-send",
    variant: variantsSimpleButton.primary,
    onClick: handleSend,
    disabled: status.disabled.send
  }, translate('send'))), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: status.visible.sending
  }, /*#__PURE__*/React__default.createElement(SimpleButton, {
    className: "lemo-controls-button-send",
    variant: variantsSimpleButton.primary,
    disabled: status.disabled.sending
  }, translate('sending_button'))))));
};
var UploadFileControls$1 = observer(UploadFileControls);

var AudioRecorderUIStyles = types$1.compose(BaseModel$1, types$1.model({}).actions(function (state) {
  return {};
}));

var AudioRecorderEditorStore = types$1.compose(EditorBaseModel, withSampleAnswer, types$1.model({
  isEvaluable: false,
  maxTime: types$1.optional(types$1.number, config.audioRecorderDurationLimit),
  ui_style: types$1.optional(AudioRecorderUIStyles, defaultUIStyle)
}).actions(function (state) {
  return {
    setMaxTime: function setMaxTime(maxTime) {
      state.maxTime = maxTime;
      state.updateNotifier();
    }
  };
}).views(function (state) {
  return {
    getUserResponse: function getUserResponse() {
      return '';
    },
    getResults: function getResults() {
      return {};
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$H(rawData);
    },
    get output() {
      return exportCommonValues(state, {
        sample_answer: state.sample_answer,
        maxTime: state.maxTime
      });
    }
  };
}));
function _createSnapshot$H(data) {
  return _extends({}, data.data, importCommonValues$1(data), {
    maxTime: Math.min(data.data.maxTime, config.audioRecorderDurationLimit)
  });
}
function createStore$X(data) {
  var store = AudioRecorderEditorStore.create(_createSnapshot$H(data));
  return store;
}

var ClockUIStyles = types$1.compose(BaseModel$1, types$1.model({
  type: types$1.optional(types$1.enumeration(Object.values(CLOCK_TYPES)), CLOCK_TYPES.ANALOG),
  time_system: types$1.optional(types$1.enumeration(Object.values(CLOCK_TIME_SYSTEMS)), CLOCK_TIME_SYSTEMS.HOUR_24),
  theme: types$1.optional(types$1.enumeration(Object.values(CLOCK_THEMES)), CLOCK_THEMES.DARK),
  step: types$1.optional(types$1.number, 5)
}).actions(function (state) {
  return {
    setTimeSystem: function setTimeSystem(timeSystem) {
      state.time_system = timeSystem;
      getParent(state).updateNotifier();
    },
    setTheme: function setTheme(theme) {
      state.theme = theme;
      getParent(state).updateNotifier();
    },
    setStep: function setStep(step) {
      state.step = step;
      getParent(state).updateNotifier();
    },
    setType: function setType(type) {
      state.type = type;
      getParent(state).updateNotifier();
    }
  };
}));
var ClockUIStyles$1 = types$1.snapshotProcessor(ClockUIStyles, {
  preProcessor: function preProcessor(sn) {
    return _extends({}, sn);
  },
  postProcessor: function postProcessor(sn) {
    return _extends({}, sn);
  }
});
var defaultUIStyle$1 = {
  type: CLOCK_TYPES.ANALOG,
  time_system: CLOCK_TIME_SYSTEMS.HOUR_24,
  theme: CLOCK_THEMES.DARK,
  step: 5,
  customClass: ''
};

var ClockEditorStore = types$1.compose(EditorBaseModel, types$1.model({
  ui_style: types$1.optional(ClockUIStyles$1, defaultUIStyle$1)
}).actions(function (state) {
  return {};
}).views(function (state) {
  return {
    getUserResponse: function getUserResponse() {
      return '';
    },
    getResults: function getResults() {
      return {};
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$I(rawData);
    },
    get output() {
      return exportCommonValues(state, {});
    }
  };
}));
function _createSnapshot$I(data) {
  return _extends({}, data.data, importCommonValues$1(data));
}
function createStore$Y(data) {
  var store = ClockEditorStore.create(_createSnapshot$I(data));
  return store;
}

var _excluded$x = ["store", "changed", "type"];
var PencilEditor = function PencilEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$x);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setTitle|setStimulus|setImage|clearImage|setHeight|setValue|reset|setSampleAnswer",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 1,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      hide: true
    }, _ref[EDITOR_COMPONENT_COMMON.BACKGROUND] = {
      hide: true
    }, _ref)
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorSampleAnswerStore$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: [TYPES_CONFIG.CONFIG_BACKGROUND_IMAGE, TYPES_CONFIG.CONFIG_CANVAS_HEIGHT]
  }));
};
var PencilEditor$1 = observer(PencilEditor);

function add2Digits(n) {
  return function (num) {
    return num.length === 1 ? "0" + num : num;
  }(n.toString());
}

function fromMS(ms) {
  var s = Math.floor(ms / 1000);
  var m = Math.floor(s / 60);
  var h = Math.floor(m / 60);
  return {
    milliseconds: ms % 1000,
    seconds: s % 60,
    minutes: m % 60,
    hours: h % 24
  };
}
function fromS(_s) {
  var s = Math.floor(_s);
  var m = Math.floor(s / 60);
  var h = Math.floor(m / 60);
  return {
    seconds: s % 60,
    minutes: m % 60,
    hours: h % 24
  };
}
function joinTimeParts() {
  return Array.from(arguments).map(add2Digits).join(':');
}

function AudioPlayerSlider(_ref) {
  var progress = _ref.progress,
    onChangeStart = _ref.onChangeStart,
    onChangeEnd = _ref.onChangeEnd;
  var slider = useRef();
  var _useState = useState(-1),
    seek = _useState[0],
    setSeek = _useState[1];
  var progressPosition = {
    width: (seek > -1 ? seek : progress) + "%"
  };
  var handleMouseDown = useCallback(function (_ref2) {
    var target = _ref2.target;
    onChangeStart();
    setSeek(parseInt(target.value));
  }, [onChangeStart, setSeek]);
  var handleMouseUp = useCallback(function (_ref3) {
    var target = _ref3.target;
    onChangeEnd(parseInt(target.value));
    setSeek(-1);
  }, [onChangeEnd]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-audio-player-slider"
  }, /*#__PURE__*/React__default.createElement("input", {
    ref: slider,
    className: "lemo-input-slider",
    type: "range",
    min: 0,
    max: 100,
    onChange: handleMouseDown,
    onMouseUp: handleMouseUp
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-slider-progress-bar",
    style: progressPosition
  }));
}
var AudioPlayerSlider$1 = observer(AudioPlayerSlider);

function AudioPlayer(_ref) {
  var _audio$current6, _audio$current7;
  var store = _ref.store;
  var audio = useRef();
  var audioWrapper = useRef();
  var _useState = useState(true),
    duration = _useState[0],
    setDuration = _useState[1];
  var _useState2 = useState(true),
    isPaused = _useState2[0],
    setIsPaused = _useState2[1];
  var _useState3 = useState(true),
    progress = _useState3[0],
    setProgress = _useState3[1];
  var restartAudioIfFinished = useCallback(function () {
    var _audio$current, _audio$current2;
    if (((_audio$current = audio.current) === null || _audio$current === void 0 ? void 0 : _audio$current.currentTime) === ((_audio$current2 = audio.current) === null || _audio$current2 === void 0 ? void 0 : _audio$current2.duration)) audio.current.currentTime = 0;
  }, [audio]);
  var play = useCallback(function () {
    var _audio$current3;
    restartAudioIfFinished();
    (_audio$current3 = audio.current) === null || _audio$current3 === void 0 ? void 0 : _audio$current3.play().then(function () {
      return setIsPaused(false);
    })["catch"](function (e) {
      return console.log(e);
    });
  }, [audio, setIsPaused, restartAudioIfFinished]);
  var pause = useCallback(function () {
    var _audio$current4;
    (_audio$current4 = audio.current) === null || _audio$current4 === void 0 ? void 0 : _audio$current4.pause();
    setIsPaused(true);
  }, [audio, setIsPaused]);
  var seek = useCallback(function (position) {
    audio.current.currentTime = duration * position / 100;
    play();
  }, [audio, play, duration]);
  var removeAudio = useCallback(function () {
    pause();
    store.cancel();
  }, [store.cancel, pause]);
  var rewind = useCallback(function () {
    pause();
    audio.current.currentTime = 0;
  }, [pause, audio]);
  function updateProgress() {
    setProgress(audio.current.currentTime / audio.current.duration * 100);
  }
  function getDuration() {
    audio.current.currentTime = 0;
    audio.current.removeEventListener('timeupdate', getDuration);
    setDuration(audio.current.duration);
    audio.current.addEventListener('timeupdate', updateProgress);
  }
  useEffect(function () {
    audio.current.addEventListener('loadedmetadata', function () {
      if (audio.current.duration === Infinity) {
        audio.current.currentTime = 1e101;
        audio.current.addEventListener('timeupdate', getDuration);
      }
    });
    audio.current.addEventListener('durationchange', function () {
      var _audio$current5;
      if (((_audio$current5 = audio.current) === null || _audio$current5 === void 0 ? void 0 : _audio$current5.duration) !== Infinity) {
        getDuration();
      }
    });
    audio.current.addEventListener('error', function () {
      return console.log('could not load audio source');
    }, true);
    audio.current.addEventListener('ended', rewind);
    return function () {
      pause();
      if (audio.current) {
        audio.current.removeEventListener('timeupdate', updateProgress);
        audio.current.removeEventListener('ended', rewind);
      }
    };
  }, []);
  useEffect(function () {
    store.disabled && pause();
  }, [store.disabled]);
  return store.file.length === 0 ? null : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-audio-player"
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: audioWrapper
  }, /*#__PURE__*/React__default.createElement("audio", {
    ref: audio
  }, /*#__PURE__*/React__default.createElement("source", {
    src: store.file,
    type: "audio/mp3"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-audio-player-left"
  }, isPaused ? /*#__PURE__*/React__default.createElement(WrapButton, {
    onClick: play
  }, /*#__PURE__*/React__default.createElement(SvgPlay, {
    className: "lemo-play-icon",
    width: 62
  })) : /*#__PURE__*/React__default.createElement(WrapButton, {
    onClick: pause
  }, /*#__PURE__*/React__default.createElement(SvgPause, {
    className: "lemo-pause-icon",
    width: 62
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-audio-player-middle"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-audio-player-middle-top"
  }, /*#__PURE__*/React__default.createElement("span", null, formatTime(((_audio$current6 = audio.current) === null || _audio$current6 === void 0 ? void 0 : _audio$current6.currentTime) || 0)), /*#__PURE__*/React__default.createElement("span", null, formatTime(((_audio$current7 = audio.current) === null || _audio$current7 === void 0 ? void 0 : _audio$current7.duration) || 0))), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-audio-player-middle-bottom"
  }, /*#__PURE__*/React__default.createElement(AudioPlayerSlider$1, {
    progress: progress,
    onChangeStart: pause,
    onChangeEnd: seek
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-audio-player-right"
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-trash-audio",
    type: "button",
    onClick: removeAudio,
    disabled: store.disabled,
    style: store.disabled ? {
      visibility: 'hidden'
    } : {}
  }, /*#__PURE__*/React__default.createElement(SvgTrash$1, {
    className: "lemo-trash-icon",
    width: 32
  })))));
}
function formatTime(time) {
  if (time === void 0) {
    time = 0;
  }
  var _fromS = fromS(parseFloat(time)),
    minutes = _fromS.minutes,
    seconds = _fromS.seconds;
  return joinTimeParts(minutes, seconds);
}
var AudioPlayer$1 = observer(AudioPlayer);

var getAudioDuration = function getAudioDuration(blob) {
  try {
    var audioElement = document.createElement('audio');
    var durationP = new Promise(function (resolve, reject) {
      audioElement.addEventListener('loadedmetadata', function () {
        if (audioElement.duration === Infinity) {
          audioElement.currentTime = Number.MAX_SAFE_INTEGER;
          audioElement.ontimeupdate = function () {
            audioElement.ontimeupdate = null;
            resolve(audioElement.duration);
            audioElement.currentTime = 0;
          };
        } else resolve(audioElement.duration);
      });
      audioElement.onerror = function (event) {
        return reject(event.target.error);
      };
    });
    audioElement.src = typeof blob === 'string' || blob instanceof String ? blob : window.URL.createObjectURL(blob);
    return Promise.resolve(durationP);
  } catch (e) {
    return Promise.reject(e);
  }
};

var recordingStatus = {
  INACTIVE: 'inactive',
  RECORDING: 'recording',
  PAUSED: 'paused',
  NOT_AVAILABLE: 'notAvailable',
  NOT_ALLOWED: 'notAllowed',
  LOCKED: 'locked'
};
var AudioRecorderQuestionStore = types$1.compose(QuestionBaseModel, withEditableExercise, withSampleAnswer, withXAPINoEvaluable$1(), types$1.model({
  file: types$1.optional(types$1.string, ''),
  currentTime: types$1.optional(types$1.number, 0),
  maxTime: types$1.optional(types$1.number, 1000 * 60),
  progress: types$1.optional(types$1.number, 0),
  showRepeatControls: false,
  duration: types$1.optional(types$1.number, 0),
  status: types$1.optional(types$1.enumeration('status', Object.values(fileStatuses)), fileStatuses.START),
  recordingStatus: types$1.optional(types$1.enumeration(Object.values(recordingStatus)), recordingStatus.INACTIVE),
  errorMessage: types$1.optional(types$1.enumeration('errorMessage', Object.values(errorList)), errorList.NONE),
  onTryAgain: 0
}).actions(function (state) {
  var counter;
  return {
    setFile: function setFile(file) {
      state.file = file;
    },
    setRecordingStatus: function setRecordingStatus(status) {
      state.recordingStatus = status;
      status === recordingStatus.RECORDING ? state.startTimer() : state.stopTimer();
    },
    resetRecording: function resetRecording() {
      state.recordingStatus = recordingStatus.INACTIVE;
      state.stopTimer();
      state.setStatus(fileStatuses.START);
    },
    setIncrement: function setIncrement(val) {
      state.duration = state.duration + val;
    },
    startTimer: function startTimer() {
      state.duration = 0;
      var timerTick = 200;
      var increment = function increment() {
        return state.setIncrement(timerTick);
      };
      counter = setInterval(increment, timerTick);
    },
    setProgress: function setProgress(progress) {
      state.progress = parseInt(progress);
    },
    stopTimer: function stopTimer() {
      clearInterval(counter);
      state.onTryAgain = 0;
    },
    setErrorMessage: function setErrorMessage(isError) {
      state.errorMessage = isError ? errorList.SERVER_ERROR : errorList.NONE;
    },
    setStatus: function setStatus(status) {
      state.status = status;
    },
    setPath: function setPath(path) {
      state.file = path;
    },
    send: function send() {
      state.setDisabled(true);
      state.setCacheOriginalResponse(state.file);
      if (!state.assetsQuestionApi) return console.error('To send files you need to configure an API');
      var data = new FormData();
      data.append('file', window["audioBlob__" + state.file], "audio_" + Date.now() + ".mp3");
      var request = new XMLHttpRequest();
      request.open('POST', state.assetsQuestionApi);
      request.upload.addEventListener('progress', function (e) {
        state.setProgress(e.loaded / e.total * 100);
      });
      request.addEventListener('load', function () {
        if (request.status === 404) {
          state.setErrorMessage(true);
        } else if (request.status === 200) {
          state.setPath(JSON.parse(request.response).link);
          state.setProgress(100);
          state.setStatus(fileStatuses.COMPLETE);
        }
      });
      request.addEventListener('error', function () {
        state.setErrorMessage(true);
        state.setStatus(fileStatuses.ERROR);
        delete window["audioBlob__" + state.reference];
      });
      state.setErrorMessage(false);
      state.setStatus(fileStatuses.UPLOADING);
      request.send(data);
    },
    repeat: function repeat() {
      state.showRepeatControls = true;
    },
    cancelRepeat: function cancelRepeat() {
      state.showRepeatControls = false;
    },
    tryAgain: function tryAgain() {
      state.onTryAgain += 1;
    },
    confirmRepeat: function confirmRepeat() {
      state.cancel();
      state.showRepeatControls = false;
      state.setPath('');
      state.setDisabled(false);
      state.onTryAgain = 0;
    },
    cancel: function cancel() {
      state.resetRecording();
      state.file = '';
      state.duration = 0;
    },
    setDuration: function setDuration(duration) {
      state.duration = duration * 1000;
    },
    hydrateQuestionPreview: function hydrateQuestionPreview(rawData) {
      state.stopTimer();
      return hydrateQuestionPreviewFn(state, rawData, false);
    },
    setResponse: function setResponse(response) {
      if (typeof response !== 'string' && response && response.length === 0) return false;
      state.file = response || '';
      state.setRecordingStatus(recordingStatus.LOCKED);
      state.setDisabled(true);
      return true;
    }
  };
}).views(function (state) {
  return {
    get isRecording() {
      return state.recordingStatus === recordingStatus.RECORDING;
    },
    get formattedCurrentTime() {
      var _fromMS = fromMS(state.duration),
        minutes = _fromMS.minutes,
        seconds = _fromMS.seconds;
      return joinTimeParts(minutes, seconds);
    },
    get formattedMaxTime() {
      var _fromMS2 = fromMS(state.maxTime),
        minutes = _fromMS2.minutes,
        seconds = _fromMS2.seconds;
      return joinTimeParts(minutes, seconds);
    },
    get timeout() {
      return state.duration > state.maxTime + 500;
    },
    getUserResponse: function getUserResponse() {
      return state.getRealUserResponse(state.file);
    },
    getResults: function getResults() {
      return {};
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$J(rawData);
    },
    get isEmpty() {
      return state.file.length === 0;
    },
    get isNotMicAvailable() {
      return state.recordingStatus === recordingStatus.NOT_AVAILABLE;
    },
    get controlsStatus() {
      if (state.recordingStatus === recordingStatus.NOT_AVAILABLE) {
        return recordingStatus.NOT_AVAILABLE;
      }
      if (state.recordingStatus === recordingStatus.NOT_ALLOWED) {
        return recordingStatus.NOT_ALLOWED;
      }
      return state.editableControlsStatus;
    },
    get interactionCompleted() {
      return state.status === fileStatuses.COMPLETE;
    }
  };
}));
function _createSnapshot$J(data) {
  var _data = produce(data, function (draft) {
    draft.data.isEvaluable = false;
  });
  return _extends({}, _data.data, {
    maxTime: _data.data.maxTime * 1000
  }, importCommonValues(_data), {
    sample_answer: _data.data.sample_answer,
    ui_style: _data.data.ui_style,
    raw: _data
  });
}
function createStore$Z(data) {
  return AudioRecorderQuestionStore.create(_createSnapshot$J(data));
}

function useAudioRecorder(_ref) {
  var handleStartRecording = function handleStartRecording() {
    try {
      return Promise.resolve(initRecorder().then(function () {
        mediaRecorder.current.start();
        setFile('');
        updateMediaRecorderStatus();
      })["catch"](function (e) {
        setRecordingStatus(e);
      })).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var initRecorder = function initRecorder() {
    try {
      return Promise.resolve(_catch(function () {
        return Promise.resolve(navigator.mediaDevices.getUserMedia({
          audio: true
        })).then(function (_navigator$mediaDevic) {
          stream.current = _navigator$mediaDevic;
          mediaRecorder.current = new MediaRecorder(stream.current);
          mediaRecorder.current.addEventListener('dataavailable', onDataAvailable);
          return Promise.resolve();
        });
      }, function (e) {
        return Promise.reject(e.name === 'NotAllowedError' ? recordingStatus.NOT_ALLOWED : recordingStatus.NOT_AVAILABLE);
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var setFile = _ref.setFile,
    setRecordingStatus = _ref.setRecordingStatus,
    resetRecording = _ref.resetRecording,
    timeout = _ref.timeout,
    setDuration = _ref.setDuration,
    cancel = _ref.cancel;
  var stream = useRef(null);
  var audioChunks = useRef([]);
  var mediaRecorder = useRef(null);
  function resetState() {
    var _stream$current;
    audioChunks.current = [];
    (_stream$current = stream.current) === null || _stream$current === void 0 ? void 0 : _stream$current.getTracks().forEach(function (track) {
      return track.stop();
    });
    resetRecording();
  }
  function handleStopRecording() {
    mediaRecorder.current.stop();
    mediaRecorder.current.addEventListener('stop', onRecordComplete);
  }
  function onCancelComplete() {
    mediaRecorder.current.removeEventListener('stop', onCancelComplete);
    resetState();
    cancel();
  }
  function handleCancel() {
    mediaRecorder.current.stop();
    mediaRecorder.current.addEventListener('stop', onCancelComplete);
  }
  function saveAudio() {
    var options = {
      type: 'audio/mpeg'
    };
    var audioBlob = new Blob(audioChunks.current, options);
    getAudioDuration(audioBlob).then(setDuration)["catch"](console.log);
    var fileUrl = URL.createObjectURL(audioBlob);
    window["audioBlob__" + fileUrl] = audioBlob;
    setFile(fileUrl);
    resetState();
  }
  function updateMediaRecorderStatus() {
    setRecordingStatus(mediaRecorder.current.state);
  }
  function onDataAvailable(e) {
    audioChunks.current.push(e.data);
  }
  function onRecordComplete() {
    mediaRecorder.current.removeEventListener('stop', onRecordComplete);
    saveAudio();
    updateMediaRecorderStatus();
  }
  useEffect(function () {
    if (timeout) {
      handleStopRecording();
    }
  }, [timeout]);
  return {
    handleStartRecording: handleStartRecording,
    handleStopRecording: handleStopRecording,
    handleCancel: handleCancel
  };
}

function CircularButton(_ref) {
  var size = _ref.size,
    onClick = _ref.onClick,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    children = _ref.children;
  var buttonSize = size ? {
    width: size,
    height: size
  } : {};
  return /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-circular-button " + className,
    onClick: onClick,
    style: buttonSize,
    type: "button"
  }, children);
}

function PlayControls(_ref) {
  var handleStartRecording = _ref.handleStartRecording;
  return /*#__PURE__*/React__default.createElement(CircularButton, {
    className: "lemo-start-recording",
    onClick: handleStartRecording
  }, /*#__PURE__*/React__default.createElement(SvgMicrophone, {
    width: 42
  }));
}
var PlayControls$1 = observer(PlayControls);

function NoMicAvailableMessage(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-no-mic-available-message"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-icon-wrapper"
  }, /*#__PURE__*/React__default.createElement(SvgExclamation, {
    className: "lemo-no-mic-icon",
    width: 32,
    height: 32
  })), /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-text"
  }, translate(message)));
}

function NoMicControls(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-no-mic-controls"
  }, /*#__PURE__*/React__default.createElement(CircularButton, {
    className: "lemo-mic-no-available-button"
  }, /*#__PURE__*/React__default.createElement(SvgMicrophoneOff, {
    className: "lemo-mic-off-icon",
    width: 42
  })), /*#__PURE__*/React__default.createElement(NoMicAvailableMessage, {
    message: message
  }));
}
var NoMicControls$1 = observer(NoMicControls);

function CancelAudioButton(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React__default.createElement(WrapButton, {
    className: "lemo-cancel-audio-button",
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(SvgXCircle, {
    className: "lemo-icon"
  }));
}

function RedCircleIcon(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    className: "lemo-red-circle-icon",
    viewBox: "0 0 10 10",
    fill: "red"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5
  }));
}

function Timer(_ref) {
  var _ref$currentTime = _ref.currentTime,
    currentTime = _ref$currentTime === void 0 ? '00:00' : _ref$currentTime,
    _ref$maxTime = _ref.maxTime,
    maxTime = _ref$maxTime === void 0 ? '01:00' : _ref$maxTime;
  var _useState = useState(''),
    activeClass = _useState[0],
    setActiveClass = _useState[1];
  useEffect(function () {
    setTimeout(function () {
      return setActiveClass('active');
    });
    return function () {
      return setActiveClass('');
    };
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-timer " + activeClass
  }, /*#__PURE__*/React__default.createElement(RedCircleIcon, {
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-current-time"
  }, currentTime), /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-max-time"
  }, "\xA0/\xA0", maxTime));
}

function StopControls(_ref) {
  var handleCancel = _ref.handleCancel,
    handleStopRecording = _ref.handleStopRecording,
    store = _ref.store;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-stop-controls-button-wrapper"
  }, /*#__PURE__*/React__default.createElement(CancelAudioButton, {
    onClick: handleCancel
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-stop-button-circles"
  }, /*#__PURE__*/React__default.createElement(WrapButton, {
    className: "lemo-stop-recording",
    onClick: handleStopRecording
  }, /*#__PURE__*/React__default.createElement(SvgStop, {
    width: 120
  })))), /*#__PURE__*/React__default.createElement(Timer, {
    currentTime: store.formattedCurrentTime,
    maxTime: store.formattedMaxTime
  }));
}
var StopControls$1 = observer(StopControls);

var RECORDING = recordingStatus.RECORDING,
  NOT_AVAILABLE = recordingStatus.NOT_AVAILABLE,
  NOT_ALLOWED = recordingStatus.NOT_ALLOWED,
  INACTIVE = recordingStatus.INACTIVE,
  PAUSED = recordingStatus.PAUSED;
var noop$1 = function noop() {};
function AudioRecorderControls(_ref) {
  var store = _ref.store;
  var _useAudioRecorder = useAudioRecorder({
      setRecordingStatus: store.setRecordingStatus,
      resetRecording: store.resetRecording,
      setFile: function setFile(file) {
        return store.setFile(file);
      },
      timeout: store.timeout,
      setDuration: store.setDuration,
      cancel: store.cancel
    }),
    handleStartRecording = _useAudioRecorder.handleStartRecording,
    handleStopRecording = _useAudioRecorder.handleStopRecording,
    handleCancel = _useAudioRecorder.handleCancel;
  var eq = function eq(status) {
    return status === store.recordingStatus;
  };
  useEffect(function () {
    if (store.onTryAgain > 0) store.setRecordingStatus(INACTIVE);
  }, [store.onTryAgain]);
  function handlePermissions(permissionStatus) {
    permissionStatus.onchange = function () {
      var permission = permissionStatus.state === 'denied' ? NOT_ALLOWED : INACTIVE;
      store.setRecordingStatus(permission);
    };
  }
  useEffect(function () {
    var _navigator, _navigator$permission, _navigator$permission2, _navigator$permission3;
    (_navigator = navigator) === null || _navigator === void 0 ? void 0 : (_navigator$permission = _navigator.permissions) === null || _navigator$permission === void 0 ? void 0 : (_navigator$permission2 = _navigator$permission.query({
      name: 'microphone'
    })) === null || _navigator$permission2 === void 0 ? void 0 : (_navigator$permission3 = _navigator$permission2.then(handlePermissions)) === null || _navigator$permission3 === void 0 ? void 0 : _navigator$permission3["catch"](noop$1);
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-audio-recorder-controls"
  }, when()["case"](eq(RECORDING), function () {
    return /*#__PURE__*/React__default.createElement(StopControls$1, {
      handleCancel: handleCancel,
      handleStopRecording: handleStopRecording,
      store: store
    });
  })["case"](eq(INACTIVE) || eq(PAUSED), function () {
    return /*#__PURE__*/React__default.createElement(PlayControls$1, {
      handleStartRecording: handleStartRecording
    });
  })["case"](eq(NOT_AVAILABLE), function () {
    return /*#__PURE__*/React__default.createElement(NoMicControls$1, {
      message: 'no_mic_available'
    });
  })["case"](eq(NOT_ALLOWED), function () {
    return /*#__PURE__*/React__default.createElement(NoMicControls$1, {
      message: 'no_mic_permission'
    });
  }).resolve(function () {
    return null;
  }));
}
var AudioRecorderControls$1 = observer(AudioRecorderControls);

function AudioRecorderWidget(_ref) {
  var store = _ref.store,
    onNoMicrophone = _ref.onNoMicrophone;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-audio-recorder-widget"
  }, store.file ? /*#__PURE__*/React__default.createElement(AudioPlayer$1, {
    store: store,
    key: store.file
  }) : /*#__PURE__*/React__default.createElement(AudioRecorderControls$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(ButtonInline, {
    classNameAdd: "lemo-no-mic-button",
    onClick: onNoMicrophone
  }, translate('no_microphone')));
}
var AudioRecorderWidget$1 = observer(AudioRecorderWidget);

function RepeatConfirmationPanel(_ref) {
  var cancelRepeat = _ref.cancelRepeat,
    confirmRepeat = _ref.confirmRepeat;
  return /*#__PURE__*/React__default.createElement(ConfirmMessage$1, {
    onConfirm: confirmRepeat,
    onCancel: cancelRepeat
  }, /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    content: translate('confirm_replace_audio_message')
  }));
}
var RepeatConfirmationPanel$1 = observer(RepeatConfirmationPanel);

function ShowUserResponse(_ref) {
  var store = _ref.store;
  useEffect(function () {
    store.setDisabled(true);
  }, []);
  return /*#__PURE__*/React__default.createElement(AudioPlayer$1, {
    store: store
  });
}

function QuestionContextEmptyResponse(_ref) {
  var children = _ref.children,
    message = _ref.message;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-context-empty-response"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-icon-wrapper"
  }, children), /*#__PURE__*/React__default.createElement("span", null, message));
}

function ContextRevision(_ref) {
  var store = _ref.store;
  var EmptyContext = function EmptyContext() {
    return /*#__PURE__*/React__default.createElement(QuestionContextEmptyResponse, {
      message: translate('no_audio_uploaded')
    }, /*#__PURE__*/React__default.createElement(SvgMicrophone, {
      width: 22
    }));
  };
  return store.getUserResponse().length === 0 ? /*#__PURE__*/React__default.createElement(EmptyContext, null) : /*#__PURE__*/React__default.createElement(ShowUserResponse, {
    store: store
  });
}

function AudioRecorderQuestion(props) {
  var store = props.store,
    onNoMicrophone = props.onNoMicrophone,
    onUploadError = props.onUploadError,
    onUploadComplete = props.onUploadComplete,
    onChangeStatus = props.onChangeStatus;
  var changedHandlers = /setFile|setPath/;
  useUploadStatus({
    store: store,
    onChangeStatus: onChangeStatus,
    onUploadComplete: onUploadComplete,
    onUploadError: onUploadError
  });
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers
  }), /*#__PURE__*/React__default.createElement(PrintMarginBottom, null), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body')
  }, when()["case"](store.context === questionContext.REVISION, function () {
    return /*#__PURE__*/React__default.createElement(ContextRevision, {
      store: store
    });
  })["case"](store.showRepeatControls, function () {
    return /*#__PURE__*/React__default.createElement(RepeatConfirmationPanel$1, {
      cancelRepeat: store.cancelRepeat,
      confirmRepeat: store.confirmRepeat
    });
  }).resolve(function () {
    return /*#__PURE__*/React__default.createElement(AudioRecorderWidget$1, {
      store: store,
      onNoMicrophone: onNoMicrophone
    });
  })));
}
var AudioRecorderQuestion$1 = observer(AudioRecorderQuestion);

var controlsWidth = 80;
function EvaluationControls(_ref) {
  var store = _ref.store,
    solutionsMode = _ref.solutionsMode;
  if (!solutionsMode || !store.hoveredOption) return null;
  var option = store.hoveredOption;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-evaluation-controls",
    style: {
      width: controlsWidth,
      top: option.y + option.height - 4 + "%",
      left: "calc(" + option.x + "% + (" + option.width + "% - " + controlsWidth + "px) / 2 )"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("button", {
    className: cn$1('lemo-evaluation-button', {
      'lemo-selected': !option.value
    }),
    onClick: option.select,
    "data-tooltip-content": translate('click_to_find_solutions_tooltip_incorrect'),
    type: "button"
  }, /*#__PURE__*/React__default.createElement(SvgXBold, {
    width: 14
  })), /*#__PURE__*/React__default.createElement(Tooltip$1, {
    effect: "solid"
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("button", {
    className: cn$1('lemo-evaluation-button', {
      'lemo-selected': option.value
    }),
    onClick: option.select,
    "data-tooltip-content": translate('click_to_find_solutions_tooltip_correct'),
    type: "button"
  }, /*#__PURE__*/React__default.createElement(SvgCheckBold, {
    width: 14
  })), /*#__PURE__*/React__default.createElement(Tooltip$1, {
    effect: "solid"
  }))));
}
var EvaluationControls$1 = observer(EvaluationControls);

function FeedbackBorder(_ref) {
  var option = _ref.option,
    solutionsMode = _ref.solutionsMode,
    error = _ref.error,
    success = _ref.success,
    noBoxPadding = _ref.noBoxPadding;
  var NOT_EVALUATED = feedback.NOT_EVALUATED;
  var hideFeedback = !solutionsMode && option.feedbackResult === NOT_EVALUATED;
  var positionAdjustment = noBoxPadding ? 0 : 10;
  var sizeAdjustment = noBoxPadding ? 0 : 20;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-evaluation-box', {
      'lemo-error': error,
      'lemo-success': success,
      'lemo-hide-feedback': hideFeedback
    }),
    style: {
      top: "calc(" + option.y + "% - " + positionAdjustment + "px)",
      left: "calc(" + option.x + "% - " + positionAdjustment + "px)",
      width: "calc(" + option.width + "% + " + sizeAdjustment + "px)",
      height: "calc(" + option.height + "% + " + sizeAdjustment + "px)"
    }
  });
}
var FeedbackBorder$1 = observer(FeedbackBorder);

function Option$2(_ref) {
  var option = _ref.option,
    solutionsMode = _ref.solutionsMode,
    withBasePath = _ref.withBasePath,
    noBoxPadding = _ref.noBoxPadding;
  var RIGHT = feedback.RIGHT,
    WRONG = feedback.WRONG;
  var feedbackIsRight = option.feedbackResult === RIGHT;
  var feedbackIsError = option.feedbackResult === WRONG;
  var showError = solutionsMode ? !option.value : feedbackIsError;
  var showSuccess = solutionsMode ? option.value : feedbackIsRight;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(FeedbackBorder$1, {
    option: option,
    solutionsMode: solutionsMode,
    error: showError,
    success: showSuccess,
    noBoxPadding: noBoxPadding
  }), /*#__PURE__*/React__default.createElement("div", {
    onClick: option.select,
    onMouseOver: function onMouseOver() {
      return option.onHover();
    },
    className: cn$1('lemo-option', {
      'lemo-selected': option.selected
    }),
    style: {
      top: option.y + "%",
      left: option.x + "%",
      width: option.width + "%",
      height: option.height + "%",
      zIndex: option.z,
      outlineOffset: noBoxPadding ? 0 : 6
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "lemo-option-image",
    src: withBasePath(option.src),
    alt: "",
    style: {
      opacity: solutionsMode ? 1 : option.opacity
    }
  })));
}
var Option$3 = observer(Option$2);

function ClickToFindQuestion(props) {
  var _store$ui_style, _cn;
  var store = props.store,
    _props$solutionsMode = props.solutionsMode,
    solutionsMode = _props$solutionsMode === void 0 ? false : _props$solutionsMode;
  var changedHandlers = /reset|select/;
  var stage = useRef(null);
  var handleError = useCallback(function () {
    if (store.isEvaluated || !store.validation.immediateFeedback) return false;
    store.clickOutside({
      itemRef: 'outside',
      value: false,
      propagate: true
    });
  }, [store]);
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', {
      'lemo-disabled': !solutionsMode && store.disabled,
      'lemo-solutions-mode': solutionsMode
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: stage,
    className: "stage"
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "lemo-background",
    src: store.withBasePath(store.image.src),
    alt: store.image.alt,
    style: _extends({
      maxWidth: '100%'
    }, !solutionsMode && {
      width: store.backgroundSize
    })
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-option-list', (_cn = {}, _cn[store.ui_style.feedback_mode] = !solutionsMode, _cn['lemo-option-list--show-selection'] = !solutionsMode && !store.disabled && ((_store$ui_style = store.ui_style) === null || _store$ui_style === void 0 ? void 0 : _store$ui_style.showSelection), _cn))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-option-list-base",
    onClick: handleError
  }), store.options.map(function (option) {
    return /*#__PURE__*/React__default.createElement(Option$3, {
      key: option.id,
      option: option,
      solutionsMode: solutionsMode,
      withBasePath: store.withBasePath,
      noBoxPadding: store.noBoxPadding
    });
  }), /*#__PURE__*/React__default.createElement(EvaluationControls$1, {
    store: store,
    solutionsMode: solutionsMode
  })))));
}
var ClickToFindQuestion$1 = observer(ClickToFindQuestion);

var OptionModel$3 = types$1.model({
  id: types$1.optional(types$1.string, function () {
    return uuid();
  }),
  value: types$1.optional(types$1["boolean"], false),
  src: types$1.string,
  x: types$1.optional(types$1.number, 0),
  y: types$1.optional(types$1.number, 0),
  width: types$1.optional(types$1.number, 100),
  height: types$1.optional(types$1.number, 100),
  z: types$1.optional(types$1.number, 1)
}).actions(function (state) {
  return {
    setValue: function setValue(bool) {
      state.value = bool;
    },
    select: function select() {
      state.value = !state.value;
      state.triggerImmediateResponse(state.value);
    },
    triggerImmediateResponse: function triggerImmediateResponse(propagate) {
      getParent(state, 2).setImmediateResponse({
        itemRef: state.id,
        value: state.isValid,
        propagate: propagate
      });
    },
    reset: function reset() {
      state.value = false;
    },
    onHover: function onHover() {
      getParent(state, 2).setHovered(state.index);
    }
  };
}).views(function (state) {
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get validate() {
      var isInSolution = getParent(state, 2).validation.value.includes(state.index);
      return when()["case"](isInSolution && !state.value, function () {
        return false;
      })["case"](!isInSolution && state.value, function () {
        return false;
      }).resolve(true);
    },
    get isValid() {
      var parent = getParent(state, 2);
      var currentResponse = parent.getCurrentSolution(state.index);
      return currentResponse === state.value;
    },
    get feedbackResult() {
      try {
        var parent = getParent(state, 2);
        var evaluationReady = parent.isEvaluated || parent.validation.immediateFeedback;
        return when()["case"](!evaluationReady, function () {
          return feedback.NOT_EVALUATED;
        })["case"](!parent.isEvaluable, function () {
          return feedback.NOT_EVALUATED;
        })["case"](parent.showSolution && state.value, function () {
          return feedback.RIGHT;
        })["case"](!state.value, function () {
          return feedback.NOT_EVALUATED;
        })["case"](state.isValid, function () {
          return feedback.RIGHT;
        })["case"](!state.isValid, function () {
          return feedback.WRONG;
        }).resolve();
      } catch (e) {
        return feedback.NOT_EVALUATED;
      }
    },
    get lock() {
      var parent = getParent(state, 2);
      return parent.isEvaluated || parent.disabled;
    },
    get selected() {
      return state.value;
    },
    get opacity() {
      return state.value ? 1 : 0;
    }
  };
});

function customGetClosestSolutionModel$2() {
  return getClosestSolutionModel().views(function (state) {
    return {
      checkSolution: function checkSolution(solution) {
        return state.getUserResponse().reduce(function (acc, next) {
          var result = solution.includes(next);
          return when()["case"](result, function () {
            return _extends({}, acc, {
              hits: acc.hits + 1
            });
          })["case"](result === false, function () {
            return _extends({}, acc, {
              failures: acc.failures + 1
            });
          }).resolve(function () {
            return _extends({}, acc, {
              notAnswered: acc.notAnswered + 1
            });
          });
        }, {
          hits: 0,
          failures: 0,
          notAnswered: 0
        });
      }
    };
  });
}

var withConfigureScorm$g = types$1.compose(withScorm, types$1.model({}).views(function (state) {
  var updateScormData = function updateScormData() {
    return {
      id: state.reference,
      userResponse: sortNumberArray(state.getUserResponse()),
      rightAnswer: state.validation.solutionList.map(function (_ref) {
        var value = _ref.value;
        return sortNumberArray(value);
      }),
      result: state.points > 0
    };
  };
  return {
    get scormType() {
      return scormTypes.CHOICE;
    },
    getInteractiveListInitScorm: function getInteractiveListInitScorm() {
      return [updateScormData()];
    },
    updateScormItem: function updateScormItem(name, path) {
      if (path.match(/\/options/) && name === 'select') {
        return updateScormData();
      } else return null;
    }
  };
}));
function sortNumberArray(a) {
  return [].concat(a).sort(function (a, b) {
    return a - b;
  });
}

var ClickToFindQuestionStore = types$1.compose(customGetClosestSolutionModel$2(), QuestionBaseModel, withImmediateHandlers('options'), withValidationModes, withConfigureScorm$g, withXAPITypeChoice$1({
  getChoices: function getChoices(state) {
    return getGenericSource(state.options.length);
  }
}), types$1.model({
  options: types$1.optional(types$1.array(OptionModel$3), []),
  hoveredId: types$1.optional(types$1.number, 0)
}).actions(function (state) {
  return {
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.number), response)) return false;
      state.options.forEach(function (option) {
        response.includes(option.index) ? option.setValue(true) : option.reset();
      });
    },
    clickOutside: function clickOutside(response) {
      state.setImmediateResponse(response);
    },
    reset: function reset() {
      state.baseReset();
      state.options.forEach(function (option) {
        option.reset();
      });
    },
    setHovered: function setHovered(idx) {
      state.hoveredId = idx;
    },
    unsetHovered: function unsetHovered() {
      state.hoveredId = -1;
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot$K(rawData);
      applySnapshot(state, data);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$K(rawData);
    },
    get hoveredOption() {
      var hovered = state.hoveredId;
      return hovered > -1 ? state.options[hovered] : undefined;
    },
    getCurrentSolution: function getCurrentSolution(idx) {
      return state.validation.solutionList[state.closestSolution].value.includes(idx);
    },
    getUserResponse: function getUserResponse() {
      var userResponse = state.options.reduce(function (acc, next) {
        return next.value ? [].concat(acc, [next.index]) : acc;
      }, []).sort(function (a, b) {
        return a < b;
      });
      return state.getRealUserResponse(userResponse);
    },
    get questionCompleted() {
      var _state$validation = state.validation,
        immediateFeedback = _state$validation.immediateFeedback,
        value = _state$validation.value;
      var isSolved = compareArrayByString(state.getUserResponse(), value);
      return immediateFeedback && isSolved;
    },
    get image() {
      return state.raw.data.image;
    },
    get noBoxPadding() {
      var _state$ui_style;
      return (_state$ui_style = state.ui_style) === null || _state$ui_style === void 0 ? void 0 : _state$ui_style.no_box_padding;
    },
    get backgroundSize() {
      return state.raw.data.image.width * defaultValue('percent', state.raw.data.image, 1);
    }
  };
}));
var compareArrayByString = function compareArrayByString(a, b) {
  return sortAndStringify(a) === sortAndStringify(b);
};
function _createSnapshot$K(data) {
  var _data$data = data.data,
    hotspots = _data$data.hotspots,
    image = _data$data.image,
    validation = _data$data.validation;
  var responsesLength = validation.valid_response.value.length;
  return _extends({}, data.data, importCommonValues(data), {
    validation: withPenaltyPoints(responsesLength, validation),
    image: image,
    options: hotspots
  });
}
function createStore$_(data) {
  return ClickToFindQuestionStore.create(_createSnapshot$K(data));
}

var HAND_MINUTES = 'hand-minutes';
var HAND_HOURS = 'hand-hours';
var Clock = function Clock(_ref) {
  var time = _ref.time,
    onChange = _ref.onChange,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? '' : _ref$status,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'dark' : _ref$theme,
    _ref$disable = _ref.disable,
    disable = _ref$disable === void 0 ? false : _ref$disable,
    _ref$realHour = _ref.realHour,
    realHour = _ref$realHour === void 0 ? true : _ref$realHour;
  var svgRef = useRef(null);
  var _useState = useState({
      type: null,
      el: null
    }),
    handActive = _useState[0],
    setHandActive = _useState[1];
  var onMouseMove = function onMouseMove(evt) {
    var loc = cursorPoint(evt);
    updateTimeByCursor(handActive, 150, 150, loc.x, loc.y);
  };
  useEffect(function () {
    var svg = svgRef.current;
    if (handActive.type) ['mousemove', 'touchmove'].forEach(function (event) {
      return svg.addEventListener(event, onMouseMove);
    });else ['mousemove', 'touchmove'].forEach(function (event) {
      return svg.removeEventListener(event, onMouseMove, true);
    });
    return function () {
      return ['mousemove', 'touchmove'].forEach(function (event) {
        return svg.removeEventListener(event, onMouseMove);
      });
    };
  }, [handActive.type]);
  function updateTimeByCursor(element, originX, originY, towardsX, towardsY) {
    var el = element.el,
      type = element.type;
    if (el) {
      var degrees = Math.atan2(towardsY - originY, towardsX - originX) * 180 / Math.PI + 90;
      if (degrees < 0) degrees += 360;
      var _newTime = null;
      if (type === HAND_MINUTES) {
        var _minutes = Math.floor(degrees / 6);
        _newTime = _extends({}, time, {
          minutes: _minutes
        });
      } else if (type === HAND_HOURS) {
        var _hours = Math.floor(degrees / 30) || 12;
        _newTime = _extends({}, time, {
          hours: _hours
        });
      }
      onChange && onChange(_newTime);
    }
  }
  function cursorPoint(evt) {
    var _evt$touches, _evt$touches2;
    var svg = svgRef.current;
    var pt = svg.createSVGPoint();
    pt.x = evt.clientX || ((_evt$touches = evt.touches) === null || _evt$touches === void 0 ? void 0 : _evt$touches[0].clientX);
    pt.y = evt.clientY || ((_evt$touches2 = evt.touches) === null || _evt$touches2 === void 0 ? void 0 : _evt$touches2[0].clientY);
    return pt.matrixTransform(svg.getScreenCTM().inverse());
  }
  function activeHand(e) {
    var _e$target$parentNode$;
    if (disable) return;
    e.stopPropagation();
    var type = (((_e$target$parentNode$ = e.target.parentNode.className) === null || _e$target$parentNode$ === void 0 ? void 0 : _e$target$parentNode$.baseVal) || '').indexOf(HAND_HOURS) > -1 ? HAND_HOURS : HAND_MINUTES;
    if (type !== handActive.type) setHandActive({
      type: type,
      el: e.target.parentNode,
      timestamp: new Date().getTime()
    });
  }
  function desactiveHand(e) {
    if (disable && !handActive.type) return;
    e.stopPropagation();
    var timestamp = new Date().getTime();
    if (timestamp - (handActive.timestamp || 0) > 300) setHandActive({
      type: null,
      el: null
    });
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-clock lemo-clock--" + theme + (handActive.type ? ' lemo-clock--active' : '') + (status ? " lemo-" + status : '')
  }, /*#__PURE__*/React__default.createElement("svg", {
    viewBox: "0 0 300 300",
    ref: svgRef,
    onClick: desactiveHand
  }, /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(150,150)"
  }, /*#__PURE__*/React__default.createElement("circle", {
    className: "lemo-clock__frame",
    r: "145"
  }), /*#__PURE__*/React__default.createElement("circle", {
    className: "lemo-clock__frame-status",
    r: "140"
  }), minuteMarkers.map(function (m, i) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: i
    }, drawMinuteMarker(m - 15, m === time.minutes));
  }), fiveMinuteMarkers.map(function (m, i) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: i
    }, draw5MinMarker(m - 15, m === time.minutes));
  }), hourLabels.map(function (l, i) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: i
    }, drawHourLabel(l, i, l === time.hours + ''));
  }), /*#__PURE__*/React__default.createElement("g", {
    className: "lemo-clock__" + HAND_MINUTES + (handActive.type === HAND_MINUTES ? " lemo-clock__" + HAND_MINUTES + "--active" : ''),
    transform: "rotate(" + time.minutes * 6 + ",0,0)",
    onMouseDown: activeHand,
    onMouseUp: desactiveHand,
    onTouchStart: activeHand,
    onTouchEnd: desactiveHand
  }, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("marker", {
    id: "arrow-minutes",
    viewBox: "0 -5 10 10",
    refX: "5",
    refY: "0",
    markerWidth: "3",
    markerHeight: "3",
    orient: "auto"
  }, /*#__PURE__*/React__default.createElement("path", {
    className: "lemo-clock__arrow",
    d: "M0,-5L10,0L0,5"
  }))), /*#__PURE__*/React__default.createElement("rect", {
    x: "-20",
    y: "-100",
    width: "40",
    height: "120",
    fillOpacity: "0",
    strokeOpacity: "0"
  }), /*#__PURE__*/React__default.createElement("line", {
    strokeWidth: "6",
    x1: "0",
    y1: "15",
    x2: "0",
    y2: "-90",
    markerEnd: "url(#arrow-minutes)"
  })), /*#__PURE__*/React__default.createElement("g", {
    className: "lemo-clock__" + HAND_HOURS + (handActive.type === HAND_HOURS ? " lemo-clock__" + HAND_HOURS + "--active" : ''),
    transform: "rotate(" + (time.hours * 30 + (realHour ? time.minutes / 60 * 30 : 0)) + ",0,0)",
    onMouseDown: activeHand,
    onMouseUp: desactiveHand,
    onTouchStart: activeHand,
    onTouchEnd: desactiveHand
  }, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("marker", {
    id: "arrow-hours",
    viewBox: "0 -5 10 10",
    refX: "5",
    refY: "0",
    markerWidth: "3",
    markerHeight: "3",
    orient: "auto"
  }, /*#__PURE__*/React__default.createElement("path", {
    className: "lemo-clock__arrow",
    d: "M0,-5L10,0L0,5"
  }))), /*#__PURE__*/React__default.createElement("rect", {
    x: "-20",
    y: "-70",
    width: "40",
    height: "90",
    fillOpacity: "0",
    strokeOpacity: "0"
  }), /*#__PURE__*/React__default.createElement("line", {
    strokeWidth: "6",
    x1: "0",
    y1: "15",
    x2: "0",
    y2: "-55",
    markerEnd: "url(#arrow-hours)"
  })), /*#__PURE__*/React__default.createElement("circle", {
    className: "lemo-clock__center",
    r: "6"
  }))));
};
var minuteMarkers = Array.from(new Array(60), function (x, i) {
  return i;
});
var fiveMinuteMarkers = minuteMarkers.filter(function (m) {
  return m % 5 === 0;
});
var markerIndexToRadians = function markerIndexToRadians(markerIndex) {
  return Math.PI * markerIndex / 30;
};
var drawMinuteMarker = function drawMinuteMarker(markerIndex, active) {
  if (active === void 0) {
    active = false;
  }
  return /*#__PURE__*/React__default.createElement("g", {
    className: "lemo-clock__min-marker" + (active ? ' lemo-clock__min-marker--active' : '')
  }, /*#__PURE__*/React__default.createElement("line", {
    x1: 124 * Math.cos(markerIndexToRadians(markerIndex)),
    y1: 124 * Math.sin(markerIndexToRadians(markerIndex)),
    x2: 126 * Math.cos(markerIndexToRadians(markerIndex)),
    y2: 126 * Math.sin(markerIndexToRadians(markerIndex))
  }));
};
var draw5MinMarker = function draw5MinMarker(markerIndex, active) {
  if (active === void 0) {
    active = false;
  }
  return /*#__PURE__*/React__default.createElement("g", {
    className: "lemo-clock__five-min-marker" + (active ? ' lemo-clock__min-marker--active' : '')
  }, /*#__PURE__*/React__default.createElement("line", {
    strokeWidth: "3",
    x1: 121 * Math.cos(markerIndexToRadians(markerIndex)),
    y1: 121 * Math.sin(markerIndexToRadians(markerIndex)),
    x2: 126 * Math.cos(markerIndexToRadians(markerIndex)),
    y2: 126 * Math.sin(markerIndexToRadians(markerIndex))
  }));
};
var hourLabels = ['3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '1', '2'];
var drawHourLabel = function drawHourLabel(label, hourLabelIndex, active) {
  if (active === void 0) {
    active = false;
  }
  return /*#__PURE__*/React__default.createElement("text", {
    className: "lemo-clock__text" + (active ? ' lemo-clock__text--active' : ''),
    textAnchor: "middle",
    alignmentBaseline: "central",
    dominantBaseline: "central",
    x: 102 * Math.cos(markerIndexToRadians(hourLabelIndex * 5)),
    y: 102 * Math.sin(markerIndexToRadians(hourLabelIndex * 5))
  }, label);
};

var waitTimeout = 600;
var speedButtonsUpDown = 130;
var isTouch$9 = isTouchDevice();
var ClockDigitalDigits = function ClockDigitalDigits(_ref) {
  var number = _ref.number,
    maxNumber = _ref.maxNumber,
    minNumber = _ref.minNumber,
    _ref$isTwoDigits = _ref.isTwoDigits,
    isTwoDigits = _ref$isTwoDigits === void 0 ? true : _ref$isTwoDigits,
    onChange = _ref.onChange;
  var numberRef = useRef(number);
  numberRef.current = number;
  var timeout = useRef(null);
  useEffect(function () {
    return function () {
      if (timeout !== null && timeout !== void 0 && timeout.current) clearTimeout(timeout.current);
    };
  }, []);
  function getNumberWithDigits(_number) {
    var numberString = isTwoDigits && _number < 10 ? '0' + _number : _number;
    return numberString;
  }
  function isValidFnNumber(seconds) {
    return seconds !== undefined && seconds >= minNumber && seconds <= maxNumber;
  }
  function add() {
    handleChange(numberRef.current + 1 > maxNumber ? 0 : numberRef.current + 1);
  }
  function subtract() {
    handleChange(numberRef.current - 1 < minNumber ? maxNumber : numberRef.current - 1);
  }
  function startAutoClick(fn) {
    timeout.current = setInterval(fn, speedButtonsUpDown);
  }
  function startingAutoClick(eventType, fn) {
    if (isTouch$9 && eventType === 'mousedown') return false;
    fn();
    clearTimeouts();
    timeout.current = setTimeout(function () {
      return startAutoClick(fn);
    }, waitTimeout);
  }
  function clearTimeouts() {
    clearTimeout(timeout.current);
    clearInterval(timeout.current);
  }
  function handleBtnUp(e) {
    startingAutoClick(e.type, add);
  }
  function handleBtnDown(e) {
    startingAutoClick(e.type, subtract);
  }
  function handleChange(_seconds) {
    if (isValidFnNumber(_seconds)) {
      onChange && onChange(_seconds);
    }
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'lemo-clock-digital-digits lemo-no-selection'
  }, /*#__PURE__*/React__default.createElement("button", {
    role: "button",
    className: "lemo-clock-digital-digits__arrow lemo-clock-digital-digits__arrow-up",
    onMouseDown: handleBtnUp,
    onMouseUp: clearTimeouts,
    onMouseLeave: clearTimeouts,
    onTouchStart: handleBtnUp,
    onTouchEnd: clearTimeouts,
    onTouchCancel: clearTimeouts
  }, /*#__PURE__*/React__default.createElement(SvgChevronUp, null)), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-clock-digital-digits__digits"
  }, getNumberWithDigits(number)), /*#__PURE__*/React__default.createElement("button", {
    role: "button",
    className: "lemo-clock-digital-digits__arrow lemo-clock-digital-digits__arrow-down",
    onMouseDown: handleBtnDown,
    onMouseUp: clearTimeouts,
    onMouseLeave: clearTimeouts,
    onTouchStart: handleBtnDown,
    onTouchEnd: clearTimeouts,
    onTouchCancel: clearTimeouts
  }, /*#__PURE__*/React__default.createElement(SvgChevronUp, null)));
};

var ClockDigital = function ClockDigital(_ref) {
  var _ref$time = _ref.time,
    time = _ref$time === void 0 ? {
      hours: 0,
      minutes: 0,
      seconds: 0
    } : _ref$time,
    onChange = _ref.onChange,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? '' : _ref$status,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'dark' : _ref$theme;
  var _useState = useState(time.hours),
    hours = _useState[0],
    setHours = _useState[1];
  var _useState2 = useState(time.minutes),
    minutes = _useState2[0],
    setMinutes = _useState2[1];
  useEffect(function () {
    if (time.hours !== hours) setHours(time.hours);
    if (time.minutes !== minutes) setMinutes(time.minutes);
  }, [time]);
  function onChangeHours(_hours) {
    setHours(_hours);
    onChange && onChange(_extends({}, time, {
      hours: _hours,
      minutes: minutes
    }));
  }
  function onChangeMinutes(_minutes) {
    setMinutes(_minutes);
    onChange && onChange(_extends({}, time, {
      hours: hours,
      minutes: _minutes
    }));
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-clock-digital lemo-clock-digital--" + theme + (status ? " lemo-" + status : '')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-clock-digital__wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-clock-digital__hours"
  }, /*#__PURE__*/React__default.createElement(ClockDigitalDigits, {
    number: hours,
    maxNumber: 23,
    minNumber: 0,
    onChange: onChangeHours
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-clock-digital__two_points lemo-no-selection"
  }, ":"), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-clock-digital__minutes"
  }, /*#__PURE__*/React__default.createElement(ClockDigitalDigits, {
    number: minutes,
    maxNumber: 59,
    minNumber: 0,
    onChange: onChangeMinutes
  }))));
};

var TimeInput = function TimeInput(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? '00' : _ref$text,
    _onChange = _ref.onChange,
    _ref$minLength = _ref.minLength,
    minLength = _ref$minLength === void 0 ? 2 : _ref$minLength,
    _ref$maxLength = _ref.maxLength,
    maxLength = _ref$maxLength === void 0 ? 2 : _ref$maxLength,
    _ref$fillChar = _ref.fillChar,
    fillChar = _ref$fillChar === void 0 ? '0' : _ref$fillChar,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? undefined : _ref$onFocus,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? undefined : _ref$onBlur;
  var _useState = useState(false),
    isFocused = _useState[0],
    setIsFocused = _useState[1];
  var handleInputFocus = function handleInputFocus() {
    setIsFocused(true);
    onFocus && onFocus();
  };
  var handleInputBlur = function handleInputBlur() {
    setIsFocused(false);
    onBlur && onBlur();
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames('lemo-time-input', {
      'lemo-time-input--focused': isFocused
    })
  }, /*#__PURE__*/React__default.createElement(EditorInputText$1, {
    value: isFocused || !fillChar ? text : text.padStart(minLength, fillChar),
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      return _onChange && _onChange(value);
    },
    placeholder: '00',
    maxLength: maxLength,
    minLength: minLength,
    style: {
      width: 2 + Math.max(text.length, minLength) * 26 + 'px'
    },
    onFocus: handleInputFocus,
    onBlur: handleInputBlur,
    selectAllOnFocus: true
  }));
};
TimeInput.propTypes = {
  onChange: propTypes.func,
  text: propTypes.string,
  minLength: propTypes.number,
  maxLength: propTypes.number,
  fillChar: propTypes.string,
  selectAllOnFocus: propTypes.bool
};
TimeInput.defaultProps = {};
var TimeInput$1 = observer(TimeInput);

var ClockTimeInputs = function ClockTimeInputs(_ref) {
  var _ref$time = _ref.time,
    time = _ref$time === void 0 ? {
      hours: 11,
      minutes: 0,
      seconds: 0
    } : _ref$time,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? null : _ref$onChange;
  var _React$useState = React__default.useState(getTextToTimeInput(time.hours)),
    hoursState = _React$useState[0],
    setHoursState = _React$useState[1];
  var _React$useState2 = React__default.useState(getTextToTimeInput(time.minutes)),
    minutesState = _React$useState2[0],
    setMinutesState = _React$useState2[1];
  useEffect(function () {
    if (time.hours !== hoursState) setHoursState(getTextToTimeInput(time.hours));
    if (time.minutes !== minutesState) setMinutesState(getTextToTimeInput(time.minutes));
  }, [time]);
  function updateState(nameObjectUpdate, value) {
    if (nameObjectUpdate === 'hours') {
      setHoursState(value);
    } else {
      setMinutesState(value);
    }
  }
  function onChangeInputGeneric(valueString, nameObjectUpdate, minNumber, maxNumber) {
    if (valueString === '') {
      updateState(nameObjectUpdate, '');
      return;
    }
    var number = Number(valueString);
    if (number < minNumber) {
      updateState(nameObjectUpdate, '');
      return;
    }
    if (!isNaN(number) && number >= minNumber && number <= maxNumber) {
      var _extends2;
      updateState(nameObjectUpdate, getTextToTimeInput(number));
      onChange && onChange(_extends({}, time, (_extends2 = {}, _extends2[nameObjectUpdate] = number, _extends2)));
    }
  }
  function onChangeHours(hoursString) {
    onChangeInputGeneric(hoursString, 'hours', 0, 23);
  }
  function onChangeMinutes(minutesString) {
    onChangeInputGeneric(minutesString, 'minutes', 0, 59);
  }
  function getTextToTimeInput(number) {
    return number.toString();
  }
  function _onBlur(nameObjectUpdate) {
    setHoursState(getTextToTimeInput(time.hours));
    setMinutesState(getTextToTimeInput(time.minutes));
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-clock-time-inputs"
  }, /*#__PURE__*/React__default.createElement(TimeInput$1, {
    text: hoursState,
    onChange: onChangeHours,
    onBlur: function onBlur() {
      return _onBlur();
    },
    selectAllOnFocus: true
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-clock-time-inputs__separator"
  }, ":"), /*#__PURE__*/React__default.createElement(TimeInput$1, {
    text: minutesState,
    onChange: onChangeMinutes,
    selectAllOnFocus: true,
    onBlur: function onBlur() {
      return _onBlur();
    }
  }));
};
ClockTimeInputs.propTypes = {
  onChange: propTypes.func,
  time: propTypes.shape({
    hours: propTypes.number,
    minutes: propTypes.number,
    seconds: propTypes.number
  })
};
ClockTimeInputs.defaultProps = {};
var ClockTimeInputs$1 = observer(ClockTimeInputs);

function ClockQuestion(props) {
  var _store$ui_style, _store$ui_style2;
  var store = props.store;
  var changedHandlers = /setTime/;
  function onChange(time) {
    store.setTime(time);
  }
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', {
      'lemo-disabled': store.disabled
    })
  }, store.isSolutionMode && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-other-clock__time-inputs"
  }, /*#__PURE__*/React__default.createElement(ClockTimeInputs$1, {
    time: {
      hours: store.hours,
      minutes: store.minutes,
      seconds: 0
    },
    onChange: onChange
  })), store.ui_style.type && store.ui_style.type === CLOCK_TYPES.DIGITAL ? /*#__PURE__*/React__default.createElement(ClockDigital, {
    time: {
      hours: store.hours,
      minutes: store.minutes,
      seconds: 0
    },
    onChange: onChange,
    theme: (_store$ui_style = store.ui_style) === null || _store$ui_style === void 0 ? void 0 : _store$ui_style.theme,
    status: store.feedbackStatus
  }) : /*#__PURE__*/React__default.createElement(Clock, {
    time: {
      hours: store.hours,
      minutes: store.minutes,
      seconds: 0
    },
    onChange: onChange,
    theme: (_store$ui_style2 = store.ui_style) === null || _store$ui_style2 === void 0 ? void 0 : _store$ui_style2.theme,
    status: store.feedbackStatus
  })));
}
var ClockQuestion$1 = observer(ClockQuestion);

var Cursor16 = "cursor-16~AGsHhqmX.png";

var Cursor2 = "cursor-2~VEZXblmC.png";

var Cursor4 = "cursor-4~CPelNFny.png";

var Cursor8 = "cursor-8~uhcuPFyF.png";

var drawOperationTypes = {
  ERASER: 'eraser',
  MARKER: 'marker',
  PAINTER: 'painter',
  NONE: null
};

var _window$1 = window,
  Image$1 = _window$1.Image;
function DrawingCanvas(_ref) {
  var store = _ref.store,
    color = _ref.color,
    brushSize = _ref.brushSize,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? drawOperationTypes.NONE : _ref$type,
    drawingService = _ref.drawingService,
    isPressing = _ref.isPressing,
    setIsPressing = _ref.setIsPressing,
    onDrawEnd = _ref.onDrawEnd,
    isDisabled = _ref.isDisabled;
  var _useState = useState(0),
    canvasTop = _useState[0],
    setCanvasTop = _useState[1];
  var _useState2 = useState(0),
    canvasLeft = _useState2[0],
    setCanvasLeft = _useState2[1];
  var _useState3 = useState(true),
    isLoading = _useState3[0],
    showLoading = _useState3[1];
  var holder = useRef(null);
  var fg = useRef(null);
  var bg = useRef(null);
  var resizeCanvas = useCallback(function () {
    if (!holder.current) return false;
    drawingService.current.resizeCanvas();
  }, [drawingService]);
  var redraw = useCallback(function (w, h) {
    var ctx = bg.current.getContext('2d');
    var img = new Image$1();
    img.onload = function () {
      return store.image ? ctx.drawImage(img, 0, 0, w, h) : ctx.drawImage(img, 0, 0);
    };
    img.src = store.drawData;
  }, [store]);
  var updateDrawFromStore = useCallback(function (drawData) {
    if (drawData.length === 0) return drawingService.current.clearCanvas();
    var img = new Image$1();
    img.onload = function () {
      drawingService.current.clearCanvas();
      bg.current.getContext('2d').drawImage(img, 0, 0);
    };
    img.src = drawData;
  }, [drawingService, bg]);
  var updateOffset = useCallback(function () {
    var bounds = holder.current.getBoundingClientRect();
    setCanvasLeft(bounds.left);
    setCanvasTop(bounds.top);
    return bounds;
  }, [setCanvasTop, canvasLeft]);
  var handleResize = useCallback(function () {
    resizeCanvas();
    if (holder.current !== null) {
      var bounds = updateOffset();
      redraw(bounds.width, bounds.height);
    }
    setTimeout(function () {
      return showLoading(false);
    }, 100);
  }, [resizeCanvas, redraw, updateOffset, showLoading]);
  var onResize = useMemo(function () {
    return debounce(handleResize, 100);
  }, [updateOffset]);
  var getMouseCoords = useCallback(function (e) {
    try {
      return getMousePos(bg.current, e);
    } catch (err) {
      return {
        mouseX: null,
        mouseY: null
      };
    }
  }, [canvasTop, canvasLeft]);
  var handlePress = function handlePress(e) {
    if (isDisabled) return false;
    setIsPressing(true);
    drawingService.current.handlePress(getMouseCoords(e));
    if (e.type !== 'touchstart') e.preventDefault();
    e.stopPropagation();
    return false;
  };
  var handleRelease = function handleRelease(e) {
    var canvas = bg.current;
    setIsPressing(false);
    drawingService.current.mergeLayers();
    e.stopPropagation();
    e.preventDefault();
    setTimeout(function () {
      return onDrawEnd({
        drawData: canvas.toDataURL('image/png'),
        width: canvas.offsetWidth,
        height: canvas.offsetHeight
      });
    }, 100);
    return false;
  };
  var handleMove = function handleMove(e) {
    if (isPressing) {
      drawingService.current.handleMove(getMouseCoords(e));
      if (e.type !== 'touchmove') e.preventDefault();
      e.stopPropagation();
    }
    return false;
  };
  useEffect(function () {
    if (type) {
      drawingService.current.setCurrentTool({
        color: color,
        brushSize: brushSize,
        type: type
      });
    }
  }, [type, color, brushSize, drawingService]);
  useEffect(function () {
    drawingService.current.setPaintCanvas({
      holder: holder,
      bg: bg,
      fg: fg
    });
    drawingService.current.setCurrentTool({
      color: color,
      brushSize: brushSize,
      type: type
    });
    updateOffset();
    window.addEventListener('resize', onResize, false);
    return function () {
      window.removeEventListener('resize', onResize);
    };
  }, []);
  useEffect(function () {
    showLoading(true);
    setTimeout(function () {
      handleResize();
    }, 1000);
  }, []);
  useEffect(function () {
    var tracker = onAction(store, function (_ref2) {
      var name = _ref2.name;
      if (['setResponse', 'cancel'].includes(name)) {
        console.log('set new response??', name);
        setTimeout(function () {
          return updateDrawFromStore(store.drawData);
        }, 100);
      }
    });
    return function () {
      return tracker();
    };
  }, []);
  useEffect(function () {
    onResize();
  }, [store.height]);
  return /*#__PURE__*/React__default.createElement("div", {
    ref: holder,
    id: "drawing-canvas-holder"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-drawing-canvas-loading', {
      'lemo-is-loading': isLoading
    })
  }, isLoading && /*#__PURE__*/React__default.createElement("span", null, "...loading")), /*#__PURE__*/React__default.createElement("canvas", {
    ref: fg,
    id: "drawing-app-overlay",
    className: cn$1('lemo-drawing-app-canvas', {
      'lemo-disabled': isDisabled
    }),
    onClick: handleRelease,
    onMouseLeave: handleRelease,
    onTouchEnd: handleRelease,
    onMouseDown: handlePress,
    onTouchStart: handlePress,
    onMouseMove: handleMove,
    onTouchMove: handleMove
  }), /*#__PURE__*/React__default.createElement("canvas", {
    ref: bg,
    id: "drawing-app-background",
    className: "lemo-drawing-app-canvas"
  }));
}
function getMousePos(canvas, e) {
  var rect = canvas.getBoundingClientRect();
  var currentEvent = e.changedTouches ? e.changedTouches[0] : e;
  return {
    mouseX: currentEvent.clientX - rect.left,
    mouseY: currentEvent.clientY - rect.top
  };
}
var DrawingCanvas$1 = observer(DrawingCanvas);

var ERASER = drawOperationTypes.ERASER,
  MARKER = drawOperationTypes.MARKER;
var DrawingService = /*#__PURE__*/function () {
  function DrawingService() {
    this.canvas = null;
    this.currentTool = null;
    this.points = [];
  }
  var _proto = DrawingService.prototype;
  _proto.setPaintCanvas = function setPaintCanvas(canvasRefs) {
    this.canvas = canvasRefs;
    this.resizeCanvas();
  };
  _proto.setCurrentTool = function setCurrentTool(_ref) {
    var color = _ref.color,
      type = _ref.type,
      brushSize = _ref.brushSize;
    this.currentTool = {
      color: color,
      type: type,
      brushSize: brushSize
    };
  };
  _proto.handlePress = function handlePress(_ref2) {
    var mouseX = _ref2.mouseX,
      mouseY = _ref2.mouseY;
    if (!this.currentTool || mouseX === null) return false;
    var ctx = this.canvas.fg.current.getContext('2d');
    if (this.currentTool.type === ERASER) this.onRenderToFG();
    ctx.globalAlpha = this.currentTool.type === MARKER ? 0.02 : 1;
    ctx.beginPath();
    ctx.lineWidth = this.currentTool.brushSize;
    ctx.strokeStyle = this.currentTool.color;
    this.points.push({
      x: mouseX,
      y: mouseY
    });
    ctx.moveTo(mouseX, mouseY);
  };
  _proto.handleMove = function handleMove(_ref3) {
    var mouseX = _ref3.mouseX,
      mouseY = _ref3.mouseY;
    if (this.currentTool === null) return false;
    var ctx = this.canvas.fg.current.getContext('2d');
    ctx.globalCompositeOperation = this.currentTool.type === ERASER ? 'destination-out' : 'source-over';
    this.points.push({
      x: mouseX,
      y: mouseY
    });
    ctx.beginPath();
    ctx.moveTo(this.points[0].x, this.points[0].y);
    for (var i = 1, len = this.points.length; i < len; i++) {
      ctx.lineTo(this.points[i].x, this.points[i].y);
    }
    ctx.stroke();
  };
  _proto.swapCanvas = function swapCanvas(a, b) {
    var context = a.current.getContext('2d');
    context.drawImage(b.current, 0, 0);
    b.current.width = a.current.width;
  };
  _proto.mergeLayers = function mergeLayers() {
    this.points = [];
    this.swapCanvas(this.canvas.bg, this.canvas.fg);
  };
  _proto.onRenderToFG = function onRenderToFG() {
    this.swapCanvas(this.canvas.fg, this.canvas.bg);
  };
  _proto.resizeCanvas = function resizeCanvas() {
    var holder = this.canvas.holder.current;
    var setSize = function setSize(element) {
      try {
        element.setAttribute('width', holder.offsetWidth);
        element.setAttribute('height', holder.offsetHeight);
      } catch (e) {}
    };
    setSize(this.canvas.fg.current);
    setSize(this.canvas.bg.current);
  };
  _proto.clearCanvas = function clearCanvas() {
    this.resizeCanvas();
  };
  return DrawingService;
}();

var white = '#fff';
function ColorPanel(_ref) {
  var onChange = _ref.onChange,
    selected = _ref.selected;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-color-panel"
  }, /*#__PURE__*/React__default.createElement("ul", {
    className: "lemo-drawing-tool-panel"
  }, /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("button", {
    className: cn$1('lemo-color-swatch lemo-with-border', {
      'lemo-selected': selected === white
    }),
    onClick: onChange(white),
    style: {
      backgroundColor: white
    },
    type: "button"
  })), config.pencilColorList.map(function (color, idx) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: "color_" + color
    }, /*#__PURE__*/React__default.createElement("button", {
      className: cn$1("lemo-color-swatch-" + idx, 'lemo-color-swatch', {
        'lemo-selected': color === selected
      }),
      onClick: onChange(color),
      style: {
        backgroundColor: color
      },
      type: "button"
    }));
  })));
}
var ColorPanel$1 = observer(ColorPanel);

function Stroke(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 24 24",
    style: "enable-background:new 0 0 24 24;"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M22.9,10.1c-1.2,0.1-2.9,1-4.3,1.8l0.1,0.1v0l-0.1-0.1c-0.6,0.3-1,0.6-1.4,0.8c-1.1,0.5-2,0.9-2.9,0.9\nc-0.4,0-0.7-0.1-0.9-0.4c-0.4-0.4-0.4-1.1-0.2-1.9c0.1-0.9,0-1.7-0.3-2C12.7,9,12.4,8.9,12,8.9c-0.9,0.1-2.6,1.3-5.9,4.4l-1.3,1.2\nl2.1-5.3c0.4-1.1,0.1-2.3-0.8-3.1c-0.7-0.6-2-1-3.3-0.1L1,7.3C0.9,7.4,0.8,7.5,0.9,7.6l0.6,1c0,0.1,0.1,0.1,0.2,0l2.2-1.4\nc0.4-0.3,1-0.2,1.4,0.1c0.4,0.3,0.5,0.9,0.3,1.3l-3.5,8.8C2,17.7,2,18,2.2,18.2c0.1,0.2,0.3,0.3,0.5,0.3c0,0,0.1,0,0.1,0\nc0.2,0,0.4-0.1,0.5-0.2c1.5-1.5,5.6-5.4,7.6-7.1l0.7-0.5l-0.1,0.9c-0.1,0.9-0.1,1.9,0.6,2.7c0.5,0.5,1.2,0.8,2.1,0.8\nc1.2,0,2.3-0.5,3.5-1c0.4-0.2,0.9-0.5,1.4-0.8c1.2-0.7,2.6-1.5,3.7-1.6c0.1,0,0.2-0.1,0.2-0.2v-1.2C23.1,10.2,23,10.1,22.9,10.1z"
  }));
}

function ThicknessIcon(_ref) {
  var value = _ref.value,
    className = _ref.className;
  return when()["case"](value === 2, function () {
    return /*#__PURE__*/React__default.createElement(Stroke, {
      className: className,
      style: {
        strokeWidth: 0
      }
    });
  })["case"](value === 4, function () {
    return /*#__PURE__*/React__default.createElement(Stroke, {
      className: className,
      style: {
        strokeWidth: 0.5
      }
    });
  })["case"](value === 8, function () {
    return /*#__PURE__*/React__default.createElement(Stroke, {
      className: className,
      style: {
        strokeWidth: 1
      }
    });
  })["case"](value === 16, function () {
    return /*#__PURE__*/React__default.createElement(Stroke, {
      className: className,
      style: {
        strokeWidth: 1.5
      }
    });
  }).resolve(function () {
    return null;
  });
}

var thicknessList = [2, 4, 8, 16];

function ThicknessPanel(_ref) {
  var onChange = _ref.onChange,
    selected = _ref.selected;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-thickness-panel"
  }, /*#__PURE__*/React__default.createElement("ul", {
    className: "lemo-drawing-tool-panel"
  }, thicknessList.map(function (value, idx) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: "thickness_" + value
    }, /*#__PURE__*/React__default.createElement("button", {
      className: cn$1("lemo-thickness-icon-" + idx + " ", 'lemo-tool-button', {
        'lemo-selected': value === selected
      }),
      onClick: onChange(value),
      type: "button"
    }, /*#__PURE__*/React__default.createElement(ThicknessIcon, {
      value: value,
      className: "lemo-tool-icon"
    })));
  })));
}

var panelList = {
  NONE: 'NONE',
  THICKNESS: 'THICKNESS',
  COLOR: 'COLOR'
};
function DrawingTools(_ref) {
  var color = _ref.color,
    thickness = _ref.thickness,
    tool = _ref.tool,
    changeTool = _ref.changeTool,
    changeColor = _ref.changeColor,
    changeThickness = _ref.changeThickness,
    eraseAll = _ref.eraseAll;
  var _useState = useState(panelList.NONE),
    panel = _useState[0],
    openPanel = _useState[1];
  var withBorder = color === '#fff' && {
    border: '1px solid'
  };
  var handleColor = useCallback(function (value) {
    return function () {
      openPanel(panelList.NONE);
      changeColor(value);
    };
  }, [changeColor]);
  var handleThickness = useCallback(function (value) {
    return function () {
      openPanel(panelList.NONE);
      changeThickness(value);
    };
  }, [changeThickness, openPanel]);
  var handleTool = useCallback(function (value) {
    return function () {
      console.log('changeTool(value)', value);
      changeTool(value);
    };
  }, [changeTool]);
  var handlePanel = useCallback(function (panelId) {
    return function () {
      console.log('changePanel -> ', panelId);
      openPanel(panelId);
    };
  }, [openPanel]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-drawing-tools"
  }, /*#__PURE__*/React__default.createElement("ul", {
    className: "lemo-drawing-tool-panel"
  }, /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("button", {
    className: cn$1('lemo-pencil-icon', 'lemo-tool-button', {
      'lemo-selected': tool === drawOperationTypes.PAINTER
    }),
    onClick: handleTool(drawOperationTypes.PAINTER),
    type: "button"
  }, /*#__PURE__*/React__default.createElement(SvgPencil, {
    className: "lemo-tool-icon"
  }))), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("button", {
    className: cn$1('lemo-eraser-icon', 'lemo-tool-button', {
      'lemo-selected': tool === drawOperationTypes.ERASER
    }),
    onClick: handleTool(drawOperationTypes.ERASER),
    type: "button"
  }, /*#__PURE__*/React__default.createElement(SvgEraser, {
    className: "lemo-tool-icon"
  }))), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-separator"
  })), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("button", {
    className: cn$1('lemo-thickness-icon', 'lemo-tool-button', {
      'lemo-selected': panel === panelList.THICKNESS
    }),
    onClick: handlePanel(panelList.THICKNESS),
    type: "button"
  }, /*#__PURE__*/React__default.createElement(ThicknessIcon, {
    className: "lemo-tool-icon",
    value: thickness
  }))), /*#__PURE__*/React__default.createElement("li", {
    className: cn$1('lemo-optional-item', {
      'lemo-hide': tool === drawOperationTypes.ERASER,
      'lemo-show': tool !== drawOperationTypes.ERASER
    })
  }, /*#__PURE__*/React__default.createElement("button", {
    className: cn$1('lemo-color-swatch', {
      'lemo-selected': panel === panelList.COLOR
    }),
    onClick: handlePanel(panelList.COLOR),
    style: _extends({
      backgroundColor: color
    }, withBorder),
    type: "button"
  })), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-trash-icon lemo-tool-button",
    onClick: eraseAll,
    type: "button"
  }, /*#__PURE__*/React__default.createElement(SvgTrash$1, {
    className: "lemo-tool-icon"
  })))), panel === panelList.THICKNESS && /*#__PURE__*/React__default.createElement(ThicknessPanel, {
    onChange: handleThickness,
    selected: thickness
  }), panel === panelList.COLOR && /*#__PURE__*/React__default.createElement(ColorPanel$1, {
    onChange: handleColor,
    selected: color
  }));
}

function PencilQuestion(props) {
  var store = props.store;
  var changedHandlers = /setTitle|setDrawData|reset/;
  var _useState = useState('#000'),
    color = _useState[0],
    setColor = _useState[1];
  var _useState2 = useState(4),
    thickness = _useState2[0],
    setThickness = _useState2[1];
  var _useState3 = useState(drawOperationTypes.PAINTER),
    tool = _useState3[0],
    setTool = _useState3[1];
  var drawingService = useRef(new DrawingService());
  var _useState4 = useState(false),
    isPressing = _useState4[0],
    setIsPressing = _useState4[1];
  var _useState5 = useState(Date.now().toString()),
    refreshKey = _useState5[0],
    setRefreshKey = _useState5[1];
  var eraseAll = useCallback(function () {
    drawingService.current.clearCanvas();
  }, []);
  var handleRefresh = useCallback(function () {
    return setRefreshKey(Date.now() + "_" + mathRandom() * 5000);
  }, [setRefreshKey]);
  var onRefresh = useMemo(function () {
    return debounce(handleRefresh, 50);
  }, [handleRefresh]);
  useEffect(function () {
    var tracker = onAction(store, function (_ref) {
      var name = _ref.name;
      if (name.match(/setImage|clearImage|setHeight/)) {
        onRefresh();
      }
      if (name === 'reset') {
        eraseAll();
      }
    });
    return function () {
      tracker();
    };
  }, []);
  var currentCursor = when()["case"](thickness === 2, function () {
    return Cursor2;
  })["case"](thickness === 4, function () {
    return Cursor4;
  })["case"](thickness === 8, function () {
    return Cursor8;
  }).resolve(function () {
    return Cursor16;
  });
  var isRevisionContext = store.context === questionContext.REVISION;
  var hasResponse = store.getUserResponse().length > 0;
  var isDisabled = store.disabled || isRevisionContext;
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers
  }), /*#__PURE__*/React__default.createElement(PrintMarginBottom, null), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', {
      'lemo-disabled': isDisabled
    })
  }, !isDisabled && /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-drawing-tools-wrapper', {
      'lemo-isPressing': isPressing
    })
  }, /*#__PURE__*/React__default.createElement(DrawingTools, {
    color: color,
    thickness: thickness,
    tool: tool,
    changeTool: setTool,
    changeColor: setColor,
    changeThickness: setThickness,
    eraseAll: eraseAll,
    isPressing: isPressing
  })), isRevisionContext && !hasResponse ? /*#__PURE__*/React__default.createElement(EmptyContext, null) : /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-canvas-wrapper",
    style: store.canvasSize
  }, /*#__PURE__*/React__default.createElement(DrawingCanvas$1, {
    key: refreshKey,
    store: store,
    brushSize: thickness,
    color: color,
    type: tool,
    drawingService: drawingService,
    isPressing: isPressing,
    setIsPressing: setIsPressing,
    onDrawEnd: store.updateDraw,
    cursor: currentCursor,
    isDisabled: isDisabled
  }), !!store.image && /*#__PURE__*/React__default.createElement("img", {
    className: "lemo-background-image",
    onLoad: onRefresh,
    src: store.withBasePath(store.image.src),
    alt: store.image.alt
  }))));
}
var EmptyContext = function EmptyContext() {
  return /*#__PURE__*/React__default.createElement(QuestionContextEmptyResponse, {
    message: translate('not_completed')
  }, /*#__PURE__*/React__default.createElement(SvgPencil, {
    width: 28
  }));
};
var PencilQuestion$1 = observer(PencilQuestion);

var PencilQuestionStore = types$1.compose(QuestionBaseModel, withEditableExercise, withSampleAnswer, withSetPrintMode, withXAPINoEvaluable$1(), types$1.model({
  drawData: types$1.string,
  width: types$1.maybe(types$1.number),
  isEmpty: types$1["boolean"],
  interactionCompleted: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    updateDraw: function updateDraw(_ref) {
      var drawData = _ref.drawData,
        width = _ref.width;
      state.drawData = drawData;
      state.width = width;
      state.isEmpty = false;
    },
    setDrawData: function setDrawData(drawData) {
      state.drawData = drawData;
      state.updateNotifier();
    },
    setResponse: function setResponse(response) {
      if (response === void 0) {
        response = '';
      }
      if (Array.isArray(response)) return;
      state.drawData = response;
      state.isEmpty = response.length === 0;
      state.setCacheOriginalResponse(response);
      state.updateNotifier();
    },
    reset: function reset() {
      console.log('reset');
      state.interactionCompleted = false;
    },
    onEdit: function onEdit() {
      state.interactionCompleted = false;
    },
    send: function send() {
      state.setDisabled(true);
      state.setCacheOriginalResponse(state.drawData);
      state.interactionCompleted = true;
    },
    hydrateQuestionPreview: function hydrateQuestionPreview(rawData) {
      try {
        var data = _createSnapshot$L(rawData);
        var prevAssetsQuestionApi = state.assetsQuestionApi;
        applySnapshot(state, data);
        state.setAssetsQuestionApi(prevAssetsQuestionApi);
      } catch (e) {}
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  return {
    getUserResponse: function getUserResponse() {
      var userResponse = state.drawData;
      return state.getRealUserResponse(userResponse);
    },
    getResults: function getResults() {
      return {};
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$L(rawData);
    },
    get image() {
      return state.raw.data.image;
    },
    get height() {
      return state.raw.data.height || 400;
    },
    get canvasSize() {
      var percent = defaultValue('image.percent', state, 1);
      return !state.image ? {
        height: state.height
      } : {
        maxWidth: state.image.width * percent
      };
    },
    get hasDraw() {
      return defaultValue('drawData.length', state, 0);
    }
  };
}));
function _createSnapshot$L(data) {
  var _data = produce(data, function (draft) {
    draft.data.isEvaluable = false;
  });
  var _data$data = _data.data,
    height = _data$data.height,
    _data$data$drawData = _data$data.drawData,
    drawData = _data$data$drawData === void 0 ? '' : _data$data$drawData;
  return _extends({}, _data.data, importCommonValues$1(_data), {
    drawData: drawData,
    height: height,
    isEmpty: drawData.length === 0
  });
}
function createStore$$(data) {
  return PencilQuestionStore.create(_createSnapshot$L(data));
}

var PencilEditorStore = types$1.compose(EditorBaseModel, withSampleAnswer, types$1.model({
  image: types$1.maybe(ImageModel),
  isEvaluable: false,
  height: types$1.optional(types$1.number, canvasHeighDefault),
  ui_style: types$1.optional(UIStyleModel$1, defaultUIStyle)
}).actions(function (state) {
  return {
    setImage: function setImage(_ref) {
      var src = _ref.src,
        width = _ref.width,
        height = _ref.height,
        percent = _ref.percent,
        alt = _ref.alt;
      state.image = {
        src: src,
        width: width,
        height: height,
        percent: percent,
        alt: alt,
        title: ''
      };
      state.updateNotifier();
    },
    clearImage: function clearImage() {
      state.image = undefined;
      state.updateNotifier();
    },
    setHeight: function setHeight(height) {
      state.height = height;
      state.updateNotifier();
    }
  };
}).views(function (state) {
  return {
    getUserResponse: function getUserResponse() {
      return '';
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$M(rawData);
    },
    get output() {
      return exportCommonValues(state, {
        image: state.image ? getSnapshot(state.image) : undefined,
        height: state.height
      });
    }
  };
}));
function _createSnapshot$M(data) {
  var _data$data = data.data,
    image = _data$data.image,
    height = _data$data.height;
  return _extends({}, data.data, importCommonValues$1(data), {
    image: image,
    height: height
  });
}
function createStore$10(data) {
  return PencilEditorStore.create(_createSnapshot$M(data));
}

function StatementQuestion(props) {
  var store = props.store,
    solutionsMode = props.solutionsMode;
  var changedHandlers = /setTitle/;
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', {
      'lemo-disabled': !solutionsMode && store.disabled
    })
  }, defaultValue('image.src', store, '').length > 0 && /*#__PURE__*/React__default.createElement("img", {
    className: "lemo-statement-image",
    src: store.withBasePath(store.image.src),
    alt: store.image.alt
  })));
}
var StatementQuestion$1 = observer(StatementQuestion);

var StatementQuestionStore = types$1.compose(QuestionBaseModel, withSampleAnswer, withSetPrintMode, types$1.model({}).actions(function (state) {
  return {
    send: function send() {}
  };
}).views(function (state) {
  return {
    get image() {
      return state.raw.data.image;
    },
    get isEvaluable() {
      return false;
    },
    get button() {
      return state.raw.data.button || '';
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$N(rawData);
    },
    get buttonActionName() {
      return state.button;
    },
    getUserResponse: function getUserResponse() {
      return '';
    }
  };
}));
function _createSnapshot$N(data) {
  return _extends({}, data.data, importCommonValues$1(data));
}
function createStore$11(data) {
  var store = StatementQuestionStore.create(_createSnapshot$N(data));
  return store;
}

var StatementEditorStore = types$1.compose(EditorBaseModel, withSampleAnswer, types$1.model({
  image: types$1.optional(ImageModel, {
    src: ''
  }),
  ui_style: types$1.optional(UIStyleModel$1, defaultUIStyle),
  button: types$1.optional(types$1.string, '')
}).actions(function (state) {
  return {
    setButton: function setButton(button) {
      state.button = button;
    },
    setImage: function setImage(_ref) {
      var src = _ref.src,
        width = _ref.width,
        height = _ref.height,
        percent = _ref.percent,
        alt = _ref.alt;
      state.image = {
        src: src,
        width: width,
        height: height,
        percent: percent,
        alt: alt,
        title: ''
      };
      state.updateNotifier();
    },
    clearImage: function clearImage() {
      state.image = undefined;
      state.updateNotifier();
    }
  };
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$O(rawData);
    },
    get output() {
      return exportCommonValues(state, {
        image: state.image ? getSnapshot(state.image) : undefined,
        button: state.button
      });
    }
  };
}));
function _createSnapshot$O(data) {
  var image = data.data.image;
  return _extends({}, data.data, importCommonValues$1(data), {
    image: image
  });
}
function createStore$12(data) {
  var store = StatementEditorStore.create(_createSnapshot$O(data));
  return store;
}

function ShowUserResponse$1(_ref) {
  var store = _ref.store;
  useEffect(function () {
    store.setDisabled(true);
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-file-uploader"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-file-list lemo-stack-layout"
  }, store.files && store.files.map(function (file) {
    return /*#__PURE__*/React__default.createElement(FileItem$1, {
      key: file.id,
      file: file
    });
  })));
}

function ContextRevision$1(_ref) {
  var store = _ref.store;
  return store.getUserResponse().length === 0 ? /*#__PURE__*/React__default.createElement(QuestionContextEmptyResponse, {
    message: translate('no_file_uploaded')
  }, /*#__PURE__*/React__default.createElement(SvgDocument, {
    width: 32
  })) : /*#__PURE__*/React__default.createElement(ShowUserResponse$1, {
    store: store
  });
}

function UploadFileQuestion(props) {
  var store = props.store,
    onChangeStatus = props.onChangeStatus,
    onUploadComplete = props.onUploadComplete,
    onUploadError = props.onUploadError;
  var changedHandlers = /setTitle/;
  useUploadStatus({
    store: store,
    onChangeStatus: onChangeStatus,
    onUploadComplete: onUploadComplete,
    onUploadError: onUploadError
  });
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', {
      'lemo-disabled': store.disabled
    })
  }, store.context === questionContext.REVISION ? /*#__PURE__*/React__default.createElement(ContextRevision$1, {
    store: store
  }) : /*#__PURE__*/React__default.createElement(FileUploader$1, {
    store: store,
    maxSize: config.maxUploadFileSize,
    allowedFiles: allowedFiles,
    showDriveButton: true
  })));
}
var UploadFileQuestion$1 = observer(UploadFileQuestion);

var withAssetsQuestionApiDrive = types$1.model({
  assetsQuestionApiDrive: types$1.maybe(types$1.string)
}).actions(function (state) {
  return {
    setAssetsQuestionApiDrive: function setAssetsQuestionApiDrive(assetsQuestionApiDrive) {
      state.assetsQuestionApiDrive = assetsQuestionApiDrive;
    }
  };
}).views(function (state) {
  return {};
});

var UploadFileQuestionStore = types$1.compose(QuestionBaseModel, FileUploaderModel, withSampleAnswer, withAssetsQuestionApiDrive, withXAPINoEvaluable$1(), types$1.model().actions(function (state) {
  return {
    setEvaluated: function setEvaluated(bool) {
      state.isEvaluated = bool;
      if (bool) state.setStatus(fileStatuses.COMPLETE);
    },
    checkAnswers: function checkAnswers() {
      state.setEvaluated(true);
    },
    setResponse: function setResponse(response) {
      state.files = [];
      response.forEach(function (file) {
        return state.files.push({
          name: file.name,
          path: file.path,
          drive: !!file.drive,
          status: fileStatuses.COMPLETE,
          size: file.size || 0
        });
      });
    }
  };
}).views(function (state) {
  return {
    getUserResponse: function getUserResponse() {
      var addFile = function addFile(_ref) {
        var name = _ref.name,
          path = _ref.path,
          drive = _ref.drive,
          size = _ref.size;
        return {
          name: name,
          path: path,
          drive: drive,
          size: size
        };
      };
      return state.files.reduce(function (acc, next) {
        return next.status !== fileStatuses.COMPLETE ? acc : [].concat(acc, [addFile(next)]);
      }, []);
    },
    getResults: function getResults() {
      return {};
    },
    get isEvaluable() {
      return false;
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$P(rawData);
    },
    get interactionCompleted() {
      return state.status === fileStatuses.COMPLETE;
    }
  };
}));
function _createSnapshot$P(data) {
  var _data$data = data.data,
    maxFiles = _data$data.maxFiles,
    minFiles = _data$data.minFiles,
    sample_answer = _data$data.sample_answer;
  return _extends({}, data.data, importCommonValues(data), {
    maxFiles: maxFiles,
    minFiles: minFiles,
    sample_answer: sample_answer,
    raw: data
  });
}
function createStore$13(data) {
  return UploadFileQuestionStore.create(_createSnapshot$P(data));
}

var UploadFileEditorStore = types$1.compose(EditorBaseModel, FileUploaderModel, withSampleAnswer, withAssetsQuestionApiDrive, types$1.model({
  isEvaluable: false,
  ui_style: types$1.optional(UIStyleModel$1, defaultUIStyle)
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$Q(rawData);
    },
    get output() {
      var result = exportCommonValues(state, _extends({}, state.fileUploaderOutput));
      delete result.data.validation;
      delete result.maxFiles;
      delete result.minFiles;
      delete result.scormData;
      return result;
    }
  };
}));
function _createSnapshot$Q(data) {
  var title = data.title;
  var _data$data = data.data,
    stimulus = _data$data.stimulus,
    maxFiles = _data$data.maxFiles,
    minFiles = _data$data.minFiles,
    ui_style = _data$data.ui_style,
    sample_answer = _data$data.sample_answer;
  return {
    title: title,
    stimulus: stimulus,
    maxFiles: maxFiles,
    minFiles: minFiles,
    isEvaluable: false,
    ui_style: ui_style,
    sample_answer: sample_answer,
    raw: data
  };
}
function createStore$14(data) {
  return UploadFileEditorStore.create(_createSnapshot$Q(data));
}

function Cell$2(_ref) {
  var letter = _ref.letter,
    selectPoint = _ref.selectPoint,
    hoverPoint = _ref.hoverPoint,
    isDragging = _ref.isDragging,
    isHovered = _ref.isHovered,
    idx = _ref.idx,
    testMode = _ref.testMode;
  function handleMouseUp(e) {
    e.stopPropagation();
    e.preventDefault();
    isDragging && selectPoint();
    return false;
  }
  function handleMouseDown(e) {
    e.stopPropagation();
    e.preventDefault();
    selectPoint();
    return false;
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-word-search-cell', {
      'lemo-is-hovered': isHovered
    }),
    "data-idx": idx,
    onMouseDown: handleMouseDown,
    onMouseEnter: hoverPoint,
    onMouseUp: handleMouseUp
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-word-search-cell__text"
  }, testMode ? idx : letter));
}
var Cell$3 = observer(Cell$2);

function Board(_ref) {
  var board = _ref.board,
    _selectPoint = _ref.selectPoint,
    hoverPoint = _ref.hoverPoint,
    isDragging = _ref.isDragging,
    workingSelection = _ref.workingSelection,
    id = _ref.id,
    testMode = _ref.testMode,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var letterList = useMemo(function () {
    return board.letters.flat();
  }, [board.letters]);
  var boardStyle = useMemo(getBoardStyle(board.columns), [board.columns]);
  function handleHover(idx) {
    hoverPoint(idx);
  }
  function getTargetElement(e) {
    var _e$touches, _e$changedTouches;
    var touch = (e === null || e === void 0 ? void 0 : (_e$touches = e.touches) === null || _e$touches === void 0 ? void 0 : _e$touches[0]) || (e === null || e === void 0 ? void 0 : (_e$changedTouches = e.changedTouches) === null || _e$changedTouches === void 0 ? void 0 : _e$changedTouches[0]);
    if (touch) {
      var _element$dataset;
      var element = document.elementFromPoint(touch.clientX, touch.clientY);
      return parseInt(element === null || element === void 0 ? void 0 : (_element$dataset = element.dataset) === null || _element$dataset === void 0 ? void 0 : _element$dataset.idx);
    }
  }
  function handleTouchStart(e) {
    var letterIdx = getTargetElement(e);
    e.stopPropagation();
    if (letterIdx) _selectPoint(letterIdx);
    return false;
  }
  function handleTouchEnd(e) {
    var letterIdx = getTargetElement(e);
    e.stopPropagation();
    _selectPoint(letterIdx);
    return false;
  }
  function handleTouchMove(e) {
    var letterIdx = getTargetElement(e);
    e.stopPropagation();
    if (letterIdx) handleHover(letterIdx);
    return false;
  }
  return /*#__PURE__*/React__default.createElement("div", {
    id: id,
    className: cn$1('lemo-word-search-board', {
      'lemo-disabled': disabled
    }),
    onTouchStart: handleTouchStart,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    style: boardStyle
  }, letterList.map(function (letter, idx) {
    return /*#__PURE__*/React__default.createElement(Cell$3, {
      key: "letter_" + idx,
      idx: idx,
      letter: letter,
      isDragging: isDragging,
      selectPoint: function selectPoint() {
        return _selectPoint(idx);
      },
      hoverPoint: function hoverPoint() {
        return handleHover(idx);
      },
      isHovered: workingSelection.has(idx),
      testMode: testMode
    });
  }));
}
function getBoardStyle(columns) {
  return function () {
    return {
      gridTemplateColumns: "repeat(" + columns + ", min-content)",
      width: 'fit-content'
    };
  };
}
var Board$1 = observer(Board);

var getColorTheme = function getColorTheme(index, isWorkingSelection) {
  return ['var(--lemo-', COLOR_THEMES[index], isWorkingSelection ? '-over' : '-out', ')'].join('').toString();
};

function Line$a(_ref) {
  var selectionLine = _ref.selectionLine,
    colorIndex = _ref.colorIndex,
    word = _ref.word,
    isShowSolution = _ref.isShowSolution;
  var isWorkingSelection = !word;
  var selectedCoords = selectionLine.selectedCoords;
  var stroke = useMemo(function () {
    if (isShowSolution) return 'var(--lemo-color-success-light)';
    return getColorTheme(colorIndex, isWorkingSelection);
  }, [colorIndex, isWorkingSelection, isShowSolution]);
  var opacity = when()["case"](isWorkingSelection, function () {
    return 1;
  })["case"](isShowSolution, function () {
    return 0.7;
  }).resolve(0.5);
  return !selectedCoords ? null : /*#__PURE__*/React__default.createElement("line", {
    className: cn$1('lemo-word-search-selection', {
      'lemo-show-solution': isShowSolution
    }),
    "data-word": word,
    x1: selectedCoords.x1 + '%',
    x2: selectedCoords.x2 + '%',
    y1: selectedCoords.y1 + '%',
    y2: selectedCoords.y2 + '%',
    strokeLinecap: "round",
    style: {
      stroke: stroke,
      opacity: opacity
    }
  });
}
var Line$b = observer(Line$a);

function Selection(_ref) {
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement("svg", {
    className: "lemo-word-search-selection-container"
  }, store.responses.map(function (response, idx) {
    return /*#__PURE__*/React__default.createElement(Line$b, {
      key: response.word + "_" + idx,
      selectionLine: response,
      colorIndex: response.selectionColor,
      word: response.word,
      isShowSolution: store.showSolution
    });
  }), /*#__PURE__*/React__default.createElement(Line$b, {
    selectionLine: store.selection,
    colorIndex: store.selectionColor,
    isWorkingSelection: true
  }));
}
var Selection$1 = observer(Selection);

function WordSearchQuestion(props) {
  var store = props.store,
    _props$solutionsMode = props.solutionsMode,
    solutionsMode = _props$solutionsMode === void 0 ? false : _props$solutionsMode;
  var changedHandlers = /reset|selectPoint/;
  function clearSelection() {
    store.clearSelection();
  }
  useEffect(function () {
    if (store.questionCompleted && store.validation.immediateFeedback) {
      store.checkAnswers();
    }
  }, [store.questionCompleted]);
  useEffect(function () {
    window.addEventListener('mouseup', clearSelection, false);
    window.addEventListener('mousedown', clearSelection, false);
    return function () {
      window.removeEventListener('mouseup', clearSelection);
      window.removeEventListener('mousedown', clearSelection);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', store.boardSizeClassName, {
      'lemo-solutions-mode': solutionsMode
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-word-search-board-wrapper"
  }, /*#__PURE__*/React__default.createElement(Board$1, {
    board: store.board,
    selectPoint: store.selectPoint,
    hoverPoint: store.hoverPoint,
    isDragging: store.isDragging,
    workingSelection: store.workingSelection,
    testMode: store.testMode,
    disabled: !solutionsMode && store.disabled
  }), /*#__PURE__*/React__default.createElement(Selection$1, {
    store: store
  }))));
}
var WordSearchQuestion$1 = observer(WordSearchQuestion);

function findWord(grid, word, x, y, dx, dy) {
  var xIndex = x;
  var yIndex = y;
  var ocurrences = 0;
  var toRet = {
    found: false
  };
  for (var actualWordIndex = 0; actualWordIndex < word.length; actualWordIndex++) {
    if (word[actualWordIndex] && grid[yIndex] && grid[yIndex][xIndex] && word[actualWordIndex].toUpperCase() === grid[yIndex][xIndex].toUpperCase()) {
      ocurrences++;
      if (actualWordIndex + 1 < word.length) {
        xIndex += dx;
        yIndex += dy;
      }
    } else {
      return toRet;
    }
  }
  if (ocurrences === word.length) {
    toRet = {
      found: true,
      word: word,
      startPoint: [x, y],
      endPoint: [xIndex, yIndex],
      displacementX: dx,
      displacementY: dy
    };
  }
  return toRet;
}
function _getWordSearchSolution(grid, words, diagonals, backward) {
  if (grid === void 0) {
    grid = [];
  }
  if (words === void 0) {
    words = [];
  }
  if (diagonals === void 0) {
    diagonals = true;
  }
  if (backward === void 0) {
    backward = false;
  }
  var solutionInfo = [];
  var height = grid.length;
  var width = grid.length > 0 && grid[0] ? grid[0].length : height;
  var displacement = getDisplacements(diagonals, backward);
  var dxs = displacement.dxs;
  var dys = displacement.dys;
  for (var yIndex = 0; yIndex < height; yIndex++) {
    for (var xIndex = 0; xIndex < width; xIndex++) {
      for (var wordIndex = 0; wordIndex < words.length; wordIndex++) {
        var _loop = function _loop() {
          if (isValidStringByLength(words[wordIndex])) {
            var result = findWord(grid, words[wordIndex], xIndex, yIndex, dxs[directionIndex], dys[directionIndex]);
            if (result !== null && result !== void 0 && result.found) {
              var wordSolutionInfo = solutionInfo.filter(function (wordSolutionInfo) {
                return isSameWordDistintDirection(wordSolutionInfo, result);
              });
              if (wordSolutionInfo && wordSolutionInfo.length > 0) ; else {
                solutionInfo.push(result);
              }
            }
          }
        };
        for (var directionIndex = 0; directionIndex < dxs.length; directionIndex++) {
          _loop();
        }
      }
    }
  }
  return solutionInfo;
}
function isWordSelftContent(solutionFound, solutions) {
  var solutionFind = solutions.find(function (solution) {
    return solution.word !== solutionFound.word && isPointInsideLine(solutionFound.startPoint, solution) && isPointInsideLine(solutionFound.endPoint, solution);
  });
  return !!solutionFind;
}
function isPointInsideLine(point, line) {
  var found = false;
  var pointLine = line.startPoint;
  for (var index = 0; index < line.word.length; index++) {
    if (pointLine[0] === point[0] && pointLine[1] === point[1]) {
      found = true;
      break;
    } else {
      pointLine = [pointLine[0] + line.displacementX, pointLine[1] + line.displacementY];
    }
  }
  return found;
}
function getWordSearchSolution(grid, words, diagonals, backward, removeSelfContainer) {
  if (grid === void 0) {
    grid = [];
  }
  if (words === void 0) {
    words = [];
  }
  if (diagonals === void 0) {
    diagonals = true;
  }
  if (backward === void 0) {
    backward = false;
  }
  if (removeSelfContainer === void 0) {
    removeSelfContainer = false;
  }
  var solutions = _getWordSearchSolution(grid, words, diagonals, backward);
  if (removeSelfContainer) {
    var solutionsToRet = [];
    var _loop2 = function _loop2() {
      var word = words[index];
      var findSolution = solutions.filter(function (solution) {
        return solution.found && solution.word === word;
      });
      var bestSolutionsWord = [];
      var bestContainsSelf = false;
      for (var indexSolution = 0; indexSolution < findSolution.length; indexSolution++) {
        var findSolutionElement = findSolution[indexSolution];
        var _isWordSelfContent = isWordSelftContent(findSolutionElement, solutions);
        findSolutionElement.isSelfContent = _isWordSelfContent;
        if (bestSolutionsWord.length === 0) {
          bestSolutionsWord.push(findSolutionElement);
          bestContainsSelf = _isWordSelfContent;
        } else {
          if (bestContainsSelf) {
            if (_isWordSelfContent) ; else {
              bestSolutionsWord = [];
              bestContainsSelf = false;
              bestSolutionsWord.push(findSolutionElement);
            }
          } else {
            if (_isWordSelfContent) ; else {
              bestSolutionsWord.push(findSolutionElement);
            }
          }
        }
      }
      solutionsToRet.push.apply(solutionsToRet, bestSolutionsWord);
    };
    for (var index = 0; index < words.length; index++) {
      _loop2();
    }
    return solutionsToRet;
  } else {
    return solutions;
  }
}

var WordSearch = /*#__PURE__*/function () {
  function WordSearch(width, height, grid, words, wordsMoreInfo) {
    this.width = width;
    this.height = height;
    this.grid = grid;
    this.words = words;
    this.wordsMoreInfo = wordsMoreInfo;
  }
  var _proto = WordSearch.prototype;
  _proto.get = function get(x, y) {
    return this.grid[y * this.width + x];
  };
  _proto.toString = function toString() {
    var result = '';
    for (var y = 0; y < this.height; y++) {
      for (var x = 0; x < this.width; x++) {
        result += this.get(x, y) + ' ';
      }
      result += '\n';
    }
    return result;
  };
  return WordSearch;
}();
var defaultMinLength = MIN_LENGTH_WORD;
var defaultSize = 10;
var effort = 10000;
var numRetryMinRepeated = 1;
var numRetryValidWordSearch = 10000;
var maxMiliseconds = 100;
function generate(options) {
  var startTime = Date.now();
  if (options == null) options = {};
  if (options.diagonals == null) options.diagonals = true;
  if (options.backward == null) options.backward = false;
  if (options.minLength == null) options.minLength = defaultMinLength;
  if (options.maxLength != null && options.maxLength < options.minLength) options.maxLength = options.minLength;
  if (options.width == null) {
    if (options.height != null) options.width = options.height;else options.width = defaultSize;
  }
  if (options.height == null) options.height = options.width;
  var words = options.words.slice().filter(function (w) {
    return w.length >= options.minLength && (options.maxLength == null || w.length <= options.maxLength);
  });
  var wordsPending = [].concat(words);
  var _options = options,
    width = _options.width,
    height = _options.height,
    diagonals = _options.diagonals,
    backward = _options.backward,
    allowedLetters = _options.allowedLetters;
  var grid = [];
  var used = [];
  var usedMap = {};
  for (var i = 0; i < width * height; i++) {
    grid[i] = ' ';
  }
  var displacement = getDisplacements(diagonals, backward);
  var dxs = displacement.dxs;
  var dys = displacement.dys;
  function rand(max) {
    return secureRandomInt(0, max - 1);
  }
  function get(x, y) {
    return grid[y * width + x];
  }
  function set(x, y, letter) {
    grid[y * width + x] = letter;
  }
  function tryword(x, y, dx, dy, word) {
    var ok = false;
    for (var _i = 0; _i < word.length; _i++) {
      var l = word[_i];
      if (x < 0 || y < 0 || x >= width || y >= height) return false;
      var cur = get(x, y);
      if (cur === ' ' || cur === l) {
        ok = true;
      } else {
        return false;
      }
      x += dx;
      y += dy;
    }
    return ok;
  }
  function putword(x, y, dx, dy, word) {
    var initialX = x;
    var initialY = y;
    for (var _i2 = 0; _i2 < word.length; _i2++) {
      var l = word[_i2];
      set(x, y, l);
      if (_i2 + 1 < word.length) {
        x += dx;
        y += dy;
      }
    }
    wordsPending = wordsPending.filter(function (wordPending) {
      return wordPending !== word;
    });
    used.push(word);
    usedMap[word] = {
      used: true,
      startPoint: [initialX, initialY],
      endPoint: [x, y],
      displacementX: dx,
      displacementY: dy
    };
  }
  for (var _i3 = 0; _i3 < width * height * effort; _i3++) {
    var _usedMap$word;
    if (Date.now() - startTime > maxMiliseconds) break;
    if (used.length === words.length) break;
    var word = wordsPending[rand(wordsPending.length)];
    if ((_usedMap$word = usedMap[word]) !== null && _usedMap$word !== void 0 && _usedMap$word.used) continue;
    var x = rand(width);
    var y = rand(height);
    var d = rand(dxs.length);
    var dx = dxs[d];
    var dy = dys[d];
    if (tryword(x, y, dx, dy, word)) putword(x, y, dx, dy, word);
  }
  for (var _i4 = 0; _i4 < grid.length; _i4++) {
    if (grid[_i4] === ' ') grid[_i4] = allowedLetters[rand(allowedLetters.length)];
  }
  used.sort();
  return new WordSearch(width, height, grid, used, usedMap);
}
function _generateWordSearch(words, allowedLetters, width, height, diagonals, backward) {
  if (words === void 0) {
    words = [];
  }
  if (allowedLetters === void 0) {
    allowedLetters = getAllowedLettersGeneral();
  }
  if (width === void 0) {
    width = 10;
  }
  if (height === void 0) {
    height = 10;
  }
  if (diagonals === void 0) {
    diagonals = true;
  }
  if (backward === void 0) {
    backward = false;
  }
  var options = {};
  if (words) options.words = words;
  if (width) options.width = width;
  if (height) options.height = height;
  options.diagonals = diagonals;
  options.backward = backward;
  options.allowedLetters = allowedLetters;
  var wordSearch = generate(options);
  var arrayOfArrays = [];
  var size = wordSearch.width;
  var bigarray = wordSearch.grid;
  for (var i = 0; i < bigarray.length; i += size) {
    arrayOfArrays.push(bigarray.slice(i, i + size));
  }
  return {
    grid: arrayOfArrays,
    wordsMoreInfo: wordSearch.wordsMoreInfo
  };
}
function findWordsInsideSolution(words, solutions) {
  var countWordsFound = 0;
  var wordsNotFound = [];
  var _loop = function _loop(index) {
    if (solutions.find(function (solution) {
      return solution.found && solution.word === words[index];
    })) {
      countWordsFound++;
    } else {
      wordsNotFound.push(words[index]);
    }
  };
  for (var index = 0; index < words.length; index++) {
    _loop(index);
  }
  return {
    countWordsFound: countWordsFound,
    wordsNotFound: wordsNotFound
  };
}
function generateWordSearch(words, allowedLetters, width, height, diagonals, backward) {
  if (words === void 0) {
    words = [];
  }
  if (allowedLetters === void 0) {
    allowedLetters = getAllowedLettersGeneral();
  }
  if (width === void 0) {
    width = 10;
  }
  if (height === void 0) {
    height = 10;
  }
  if (diagonals === void 0) {
    diagonals = true;
  }
  if (backward === void 0) {
    backward = false;
  }
  var bestGenerate = null;
  var solutionBestGenerate = null;
  var countRetryMinRepeated = 0;
  for (var index = 0; index < numRetryValidWordSearch && countRetryMinRepeated < numRetryMinRepeated; index++) {
    var _generate = _generateWordSearch(words, allowedLetters, width, height, diagonals, backward);
    var solutions = getWordSearchSolution(_generate.grid, words, true, true, false);
    var findInfo = findWordsInsideSolution(words, solutions);
    if (findInfo.countWordsFound >= words.length) {
      if (solutions.length > words.length) {
        countRetryMinRepeated++;
        if (!solutionBestGenerate || solutions.length < solutionBestGenerate.length) {
          bestGenerate = _generate;
          solutionBestGenerate = solutions;
        }
      } else {
        bestGenerate = _generate;
        solutionBestGenerate = solutions;
        break;
      }
    }
  }
  return bestGenerate;
}

var SelectionModel$2 = types$1.model({
  startPoint: types$1.maybe(types$1.array(types$1.number)),
  endPoint: types$1.maybe(types$1.array(types$1.number))
}).actions(function (state) {
  return {
    setStartPoint: function setStartPoint(startPoint) {
      state.startPoint = state.parent.getCoord(startPoint);
    },
    setEndPoint: function setEndPoint(endPoint) {
      state.endPoint = state.parent.getCoord(endPoint);
    },
    clearEntryPoints: function clearEntryPoints() {
      var output = {
        startPoint: getSnapshot(state.startPoint),
        endPoint: state.endPoint ? getSnapshot(state.endPoint) : []
      };
      state.clearSelection();
      return output;
    },
    clearSelection: function clearSelection() {
      state.startPoint = undefined;
      state.endPoint = undefined;
    }
  };
}).views(function (state) {
  return {
    get parent() {
      return getCurrentParent(state);
    },
    get boardSize() {
      return state.parent.board.columns;
    },
    get isDiagonal() {
      var startPoint = state.startPoint,
        endPoint = state.endPoint;
      return startPoint[0] - endPoint[0] === startPoint[1] - endPoint[1] || startPoint[0] - endPoint[0] === endPoint[1] - startPoint[1];
    },
    get selectedCoords() {
      var boardSize = state.boardSize,
        startPoint = state.startPoint,
        endPoint = state.endPoint;
      var getPercent = function getPercent(val) {
        return val * 100 / boardSize;
      };
      if (!startPoint) return false;
      var x1 = getPercent(startPoint[0]);
      var y1 = getPercent(startPoint[1]);
      var x2 = endPoint ? getPercent(endPoint[0]) : x1;
      var y2 = endPoint ? getPercent(endPoint[1]) : y1;
      return state.startPoint && {
        x1: x1,
        x2: x2,
        y1: y1,
        y2: y2
      };
    }
  };
});
function getCurrentParent(state) {
  return getParent(state).length ? getParent(state, 2) : getParent(state);
}

var UserResponseModel = types$1.compose(SelectionModel$2, types$1.model({
  word: types$1.string
}).views(function (state) {
  return {
    get selectionColor() {
      var currentResponseIndex = getParent(state).findIndex(function (response) {
        return response === state;
      });
      return currentResponseIndex % COLORS_LENGTH;
    }
  };
}));

function getLetterSelection(start, end, boardSize) {
  var data = {
    low: Math.min(start, end),
    high: Math.max(start, end),
    boardSize: boardSize
  };
  return when()["case"](isHorizontal(data), function () {
    return getFromHorizontal(data);
  })["case"](isVertical(data), function () {
    return getFromVertical(data);
  })["case"](isDiagonalLeft(data), function () {
    return getFromDiagonalLeft(data);
  })["case"](isDiagonalRight(data), function () {
    return getFromDiagonalRight(data);
  }).resolve(function () {
    return new Set();
  });
}
var isHorizontal = function isHorizontal(_ref) {
  var low = _ref.low,
    high = _ref.high,
    boardSize = _ref.boardSize;
  return parseInt(low / boardSize) === parseInt(high / boardSize);
};
var isVertical = function isVertical(_ref2) {
  var low = _ref2.low,
    high = _ref2.high,
    boardSize = _ref2.boardSize;
  return (high - low) % boardSize === 0;
};
var isDiagonalLeft = function isDiagonalLeft(_ref3) {
  var low = _ref3.low,
    high = _ref3.high,
    boardSize = _ref3.boardSize;
  return low % boardSize < high % boardSize;
};
var isDiagonalRight = function isDiagonalRight(_ref4) {
  var low = _ref4.low,
    high = _ref4.high,
    boardSize = _ref4.boardSize;
  return low % boardSize > high % boardSize;
};
var selectionIterator = function selectionIterator(fn, data) {
  var low = data.low,
    high = data.high;
  var recursive = function recursive(result) {
    if (last(result) === high) return result;
    return recursive([].concat(result, [fn(last(result))]));
  };
  return new Set(recursive([low]));
};
var getFromHorizontal = function getFromHorizontal(data) {
  return selectionIterator(function (next) {
    return next + 1;
  }, data);
};
var getFromVertical = function getFromVertical(data) {
  return selectionIterator(function (next) {
    return next + data.boardSize;
  }, data);
};
var getFromDiagonalLeft = function getFromDiagonalLeft(data) {
  return selectionIterator(function (next) {
    return next + data.boardSize + 1;
  }, data);
};
var getFromDiagonalRight = function getFromDiagonalRight(data) {
  return selectionIterator(function (next) {
    return next + data.boardSize - 1;
  }, data);
};

var isHorizontal$1 = function isHorizontal(start, end) {
  return start[0] === end[0];
};
var isVertical$1 = function isVertical(start, end) {
  return start[1] === end[1];
};
var isDiagonal_LR = function isDiagonal_LR(start, end) {
  return start[0] - end[0] === start[1] - end[1];
};
var isDiagonal_RL = function isDiagonal_RL(start, end) {
  return start[0] - end[0] === end[1] - start[1];
};

function moveIsAllowed(start, end) {
  return isHorizontal$1(start, end) || isVertical$1(start, end) || isDiagonal_LR(start, end) || isDiagonal_RL(start, end);
}

var withConfigureScorm$h = types$1.model({
  scormData: types$1.optional(ScormModel, {})
}).actions(function (state) {
  var checkIsSolved = function checkIsSolved(item) {
    return state.getUserResponse().includes(item.word);
  };
  var getItem = function getItem(item) {
    var isSolved = checkIsSolved(item);
    return {
      id: item.word,
      userResponse: isSolved ? item.word : '',
      rightAnswer: item.word,
      result: isSolved
    };
  };
  return {
    afterCreate: function afterCreate() {
      state.exerciseType = scormTypes.MATCHING;
      state.initScorm();
      onAction(state, function (_ref) {
        var name = _ref.name,
          path = _ref.path;
        if (name === 'reset' && path === '') state.initScorm();
      }, true);
      onSnapshot(state.responses, function () {
        if (state.responses.length === 0) return;
        var lastWord = last(state.responses).word;
        var item = state.solutions.find(function (_ref2) {
          var word = _ref2.word;
          return word === lastWord;
        });
        state.scormData.updateInteractive(getItem(item));
      });
    },
    initScorm: function initScorm() {
      state.scormData.init(state, state.solutions.map(getItem));
    }
  };
});

var COLORS_LENGTH = 8;
var WordSearchQuestionStore = types$1.compose(QuestionBaseModel, withValidationModes, withShowSolutions, withConfigureScorm$h, withXAPITypeOther$1({
  xAPISolution: function xAPISolution(state) {
    return formatResponses(state.validation.value);
  }
}), types$1.model({
  responses: types$1.array(UserResponseModel),
  solutions: types$1.array(UserResponseModel),
  selection: types$1.optional(SelectionModel$2, {}),
  responseList: types$1.optional(types$1.array(types$1.string), []),
  testMode: false
}).actions(function (state) {
  return {
    setTestMode: function setTestMode(bool) {
      state.testMode = bool;
    },
    setUserResponse: function setUserResponse(response) {
      if (!response) return false;
      state.responses.push(response);
      state.removeDuplicates(response);
    },
    validateWord: function validateWord() {
      var currentResponse = state.selection.clearEntryPoints();
      if (findInResponse(currentResponse, state.responses)) return false;
      state.setUserResponse(findInResponse(currentResponse, getSnapshot(state.solutions)));
    },
    removeDuplicates: function removeDuplicates(response) {
      var compareLimits = function compareLimits(a, b) {
        return a.startPoint.toString() === b.startPoint.toString() && a.endPoint.toString() === b.endPoint.toString();
      };
      state.solutions = reject(function (solution) {
        return (solution === null || solution === void 0 ? void 0 : solution.word) === (response === null || response === void 0 ? void 0 : response.word) && !compareLimits(solution, response);
      }, state.solutions);
    },
    selectPoint: function selectPoint(point) {
      if (!state.selection.startPoint) return state.selection.setStartPoint(point);
      state.selection.setEndPoint(point);
      state.validateWord();
    },
    hoverPoint: function hoverPoint(point) {
      var startPoint = state.selection.startPoint;
      var currentPoint = state.getCoord(point);
      if (!startPoint) return false;
      moveIsAllowed(getSnapshot(startPoint), currentPoint) && state.selection.setEndPoint(point);
    },
    clearSelection: function clearSelection() {
      state.selection.clearSelection();
    },
    reset: function reset() {
      state.baseReset();
      state.responses = [];
      state.solutions = state.raw.solutions;
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot$R(rawData);
      applySnapshot(state, data);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.string), response)) return false;
      var findSolutionByWord = function findSolutionByWord(search) {
        return state.solutions.find(function (_ref) {
          var word = _ref.word;
          return word.toUpperCase() === search.toUpperCase();
        });
      };
      state.responses = response.reduce(function (acc, next) {
        var currentSolution = safeSnapshot(findSolutionByWord(next));
        return currentSolution ? [].concat(acc, [currentSolution]) : acc;
      }, []);
      state.removeDuplicates();
    }
  };
}).views(function (state) {
  return {
    get board() {
      return state.raw.data.board;
    },
    get boardSizeClassName() {
      return when()["case"](state.board.columns === 6, function () {
        return 'lemo-size-S';
      })["case"](state.board.columns === 10, function () {
        return 'lemo-size-M';
      })["case"](state.board.columns === 15, function () {
        return 'lemo-size-L';
      }).resolve();
    },
    get foundWords() {
      return state.responses.map(function (_ref2) {
        var word = _ref2.word;
        return word;
      });
    },
    getCoord: function getCoord(tileIndex) {
      var boardSize = state.board.columns;
      return [tileIndex % boardSize, parseInt(tileIndex / boardSize)];
    },
    getPoint: function getPoint(position) {
      if (!position || position.length === 0) return undefined;
      var x = position[0],
        y = position[1];
      var boardSize = state.board.columns;
      return boardSize * y + x;
    },
    get workingSelection() {
      var selection = state.selection;
      if (!selection.startPoint && !selection.endPoint) return new Set();
      if (!!selection.startPoint && !selection.endPoint) return new Set([state.getPoint(selection.startPoint)]);
      return getLetterSelection(state.getPoint(selection.startPoint), state.getPoint(selection.endPoint), state.board.columns);
    },
    get selectionColor() {
      var currentResponseIndex = state.responses.length;
      return currentResponseIndex % COLORS_LENGTH;
    },
    get isSearching() {
      return state.selection.startPoint;
    },
    get isDragging() {
      return state.isSearching && state.selection.endPoint;
    },
    getUserResponse: function getUserResponse() {
      var userResponse = state.responses.map(function (_ref3) {
        var word = _ref3.word;
        return word;
      });
      return state.getRealUserResponse(userResponse);
    },
    get solution() {
      return state.validation;
    },
    get closestSolutionStats() {
      return {
        hits: state.responses.length,
        failures: 0,
        notAnswered: state.solutions.length - state.responses.length
      };
    },
    get questionCompleted() {
      return state.responses.length === state.solutions.length;
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$R(rawData);
    }
  };
}));
function findSolutions(validResponses, gameBoard) {
  return getWordSearchSolution(gameBoard, validResponses, true, true, false);
}
function getGameBoard(validResponses, board, shuffle_options) {
  return shuffle_options ? generateWordSearch(validResponses, board.allowed_letters || getAllowedLettersGeneral(), board.columns, board.rows, board.diagonal, board.backward).grid : board.letters;
}
function _createSnapshot$R(data) {
  var _data$data = data.data,
    validation = _data$data.validation,
    board = _data$data.board,
    shuffle_options = _data$data.shuffle_options;
  var validResponses = validation.valid_response.value;
  var gameBoard = getGameBoard(validResponses, board, shuffle_options);
  var storeData = produce(data, function (draft) {
    draft.data.board.letters = gameBoard;
  });
  var solutions = findSolutions(validResponses, gameBoard);
  return _extends({}, storeData.data, importCommonValues(_extends({}, storeData, {
    solutions: solutions
  })), {
    solutions: solutions
  });
}
function findInResponse(response, solutionList) {
  var flattenResponse = response.startPoint.concat(response.endPoint);
  return solutionList.find(function (solution) {
    var flattenSolution = solution.startPoint.concat(solution.endPoint);
    var flattenSolutionReverse = solution.endPoint.concat(solution.startPoint);
    return compareFlatArray(flattenResponse, flattenSolution) || compareFlatArray(flattenResponse, flattenSolutionReverse);
  });
}
function createStore$15(data) {
  return WordSearchQuestionStore.create(_createSnapshot$R(data));
}

var _excluded$y = ["store", "changed", "type"];
var AudioRecorderEditor = function AudioRecorderEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$y);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setStimulus|setMaxFiles|setMinFiles|setMaxTime|setSampleAnswer",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      hide: true
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 1,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref[EDITOR_COMPONENT_COMMON.BACKGROUND] = {
      hide: true
    }, _ref)
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorSampleAnswerStore$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: [TYPES_CONFIG.CONFIG_AUDIO_DURATION_LIMIT]
  }));
};
var AudioRecorderEditor$1 = observer(AudioRecorderEditor);

function Control$1(_ref) {
  var model = _ref.model,
    setModel = _ref.setModel,
    label = _ref.label,
    type = _ref.type,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 80 : _ref$width,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? null : _ref$min,
    _ref$textRight = _ref.textRight,
    textRight = _ref$textRight === void 0 ? null : _ref$textRight,
    disabledKeyDown = _ref.disabledKeyDown,
    hideNumberControls = _ref.hideNumberControls;
  var _useState = useState(model),
    modelLocal = _useState[0],
    setModelLocal = _useState[1];
  useEffect(function () {
    setModelLocal(model);
  }, [model]);
  var condicionalPropsInput = {};
  if (min !== null) condicionalPropsInput.min = min;
  function onKeyDown(e) {
    if (disabledKeyDown) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames('lemo-control', {
      'lemo-control--disabled-key-down': disabledKeyDown
    })
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-text"
  }, translate(label)), /*#__PURE__*/React__default.createElement("input", _extends({}, condicionalPropsInput, {
    className: classNames('lemo-input', {
      'lemo-input--hide-number-controls': hideNumberControls,
      'lemo-input--show-number-controls': !hideNumberControls,
      'lemo-input--disabled-key-down': disabledKeyDown
    }),
    type: type,
    value: model,
    onChange: function onChange(e) {
      return disabledKeyDown && !hideNumberControls ? setModelLocal(e.target.value) : setModel(e.target.value);
    },
    style: {
      width: width
    },
    onClick: function onClick(e) {
      return disabledKeyDown && !hideNumberControls ? setModel(modelLocal) : null;
    },
    onKeyDown: onKeyDown
  })), textRight && /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-text"
  }, textRight));
}
Control$1.propTypes = {
  disabledKeyDown: propTypes.bool,
  hideNumberControls: propTypes.bool
};
Control$1.defaultProps = {
  disabledKeyDown: false,
  hideNumberControls: true
};

var PopoverHotspot = function PopoverHotspot(_ref) {
  var children = _ref.children,
    disabled = _ref.disabled,
    x = _ref.x,
    setX = _ref.setX,
    y = _ref.y,
    setY = _ref.setY,
    onRemove = _ref.onRemove,
    onChangeOpen = _ref.onChangeOpen;
  var getPercentValue = function getPercentValue(value) {
    var val = value !== undefined && Math.abs(value) >= 0 ? Math.abs(value) : 0;
    if (val > 100) val = 100;
    var toRet = val !== undefined && val > 0 ? val : 0;
    return toRet;
  };
  function _onChangeOpen(open) {
    onChangeOpen && onChangeOpen(open);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-popover-hotspot"
  }, /*#__PURE__*/React__default.createElement(Popover, null, /*#__PURE__*/React__default.createElement(Popover.Control, null, function (_ref2) {
    var toggle = _ref2.toggle;
    return /*#__PURE__*/React__default.createElement("div", {
      onClick: !disabled ? toggle : undefined
    }, children);
  }), /*#__PURE__*/React__default.createElement(Popover.Content, {
    onChangeOpen: _onChangeOpen
  }, function (_ref3) {
    var open = _ref3.open;
    return !open ? null : /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-popover-hotspot__content",
      style: _extends({}, x > 36 ? {
        right: 0
      } : {}),
      onMouseDown: function onMouseDown(e) {
        e.stopPropagation();
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-popover-hotspot__content-controls"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-popover-hotspot__content-controls-xy"
    }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Control$1, {
      label: "X",
      type: "number",
      model: x,
      setModel: function setModel(value) {
        return setX(getPercentValue(value));
      },
      min: 0,
      textRight: " %",
      disabledKeyDown: true,
      hideNumberControls: false
    })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Control$1, {
      label: "Y",
      type: "number",
      model: y,
      setModel: function setModel(value) {
        return setY(getPercentValue(value));
      },
      min: 0,
      textRight: " %",
      disabledKeyDown: true,
      hideNumberControls: false
    })))), /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-popover-hotspot__content-controls-separator"
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-popover-hotspot__content-controls-button"
    }, /*#__PURE__*/React__default.createElement(ButtonInline, {
      onClick: onRemove,
      icon: /*#__PURE__*/React__default.createElement(SvgTrash$1, {
        className: "lemo-icon"
      }),
      color: colorsButton.white
    })));
  })));
};
PopoverHotspot.propTypes = {
  disabled: propTypes.bool
};
PopoverHotspot.defaultProps = {
  disabled: false,
  rightContent: 0
};

var offsetPin = 0;
var EditorExerciseClickToFindMapHotspots = function EditorExerciseClickToFindMapHotspots(_ref) {
  var background = _ref.background,
    hotspots = _ref.hotspots,
    onEditHotspot = _ref.onEditHotspot,
    onDeleteHotspot = _ref.onDeleteHotspot,
    noBoxPadding = _ref.noBoxPadding;
  var _useState = useState(null),
    hotspotIdSelected = _useState[0],
    setHotspotIdSelected = _useState[1];
  var nodeSelectedRef = useRef();
  var clientRectRef = useRef();
  var parentRectRef = useRef();
  var widthBackground = background ? background.width : 1280;
  var heightBackgroundOriginal = background ? background.original_height : 800;
  var contentItems = React__default.createRef();
  function onDrop(event, node, hotspot) {
    nodeSelectedRef.current = node;
    clientRectRef.current = node.getBoundingClientRect();
    parentRectRef.current = node.offsetParent.getBoundingClientRect();
    setHotspotIdSelected(hotspot.id);
    var xyNode = getXYNode(node);
    var _x = xyNode.x;
    var _y = xyNode.y;
    if (hotspot.x !== roundToTwo(_x) && hotspot.y !== roundToTwo(_y)) {
      onEditHotspot(_extends({}, hotspot, {
        y: _y,
        x: _x
      }));
    }
  }
  function getXYNode(node) {
    var clientRect = node.getBoundingClientRect();
    var parentRect = node.offsetParent.getBoundingClientRect();
    var draggingPosition = {
      x: clientRect.left - parentRect.left,
      y: clientRect.top - parentRect.top + offsetPin
    };
    var draggingPositionRelative = {
      x: pxToPercentX(draggingPosition.x, parentRect),
      y: pxToPercentY(draggingPosition.y, parentRect)
    };
    var _x = draggingPositionRelative.x;
    var _y = draggingPositionRelative.y;
    return {
      x: _x,
      y: _y
    };
  }
  function pxToPercentX(positionXPx, parentRect) {
    return positionXPx / parentRect.width * 100;
  }
  function pxToPercentY(positionYPx, parentRect) {
    return positionYPx / parentRect.height * 100;
  }
  function _onEditHotspotX(hotspot, valueX) {
    var newX = valueX;
    if (clientRectRef && clientRectRef.current && parentRectRef && parentRectRef.current) {
      try {
        var dragBoundingBox = clientRectRef.current;
        if (dragBoundingBox) {
          var baseBoundingBox = parentRectRef.current;
          var percentWidthDrag = dragBoundingBox.width * 100 / baseBoundingBox.width;
          var maxX = 100 - percentWidthDrag;
          newX = valueX > maxX ? maxX : valueX;
          if (newX < 0) newX = 0;
        }
      } catch (error) {}
    }
    onEditHotspot(_extends({}, hotspot, {
      x: newX
    }));
  }
  function _onEditHotspotY(hotspot, valueY) {
    var newY = valueY;
    if (clientRectRef && clientRectRef.current && parentRectRef && parentRectRef.current) {
      try {
        var dragBoundingBox = clientRectRef.current;
        if (dragBoundingBox) {
          var baseBoundingBox = parentRectRef.current;
          var percentHeightDrag = dragBoundingBox.height * 100 / baseBoundingBox.height;
          var maxY = 100 - percentHeightDrag;
          newY = valueY > maxY ? maxY : valueY;
          if (newY < 0) newY = 0;
        }
      } catch (error) {}
    }
    onEditHotspot(_extends({}, hotspot, {
      y: newY
    }));
  }
  function _onStart(hotspot) {
    hotspot.getNextDepth();
  }
  function onChangeOpenHotspot(hotspot, open) {
    if (!open && hotspotIdSelected === hotspot.id) {
      setHotspotIdSelected(null);
    } else if (open) {
      setHotspotIdSelected(hotspot.id);
    }
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-exercise-click-to-find-map-hotspot-wrapper",
    style: {
      height: heightBackgroundOriginal + 'px'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-exercise-click-to-find-map-hotspots",
    style: {
      maxWidth: widthBackground + 'px'
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "lemo-editor-exercise-click-to-find-map-hotspots__img",
    draggable: false,
    src: background ? background.source : null,
    ref: contentItems,
    alt: ""
  }), hotspots.map(function (hotspot) {
    var isSelected = hotspotIdSelected && hotspotIdSelected === hotspot.id;
    return /*#__PURE__*/React__default.createElement(Draggable$1, {
      key: hotspot.id ? hotspot.id : hotspot.src,
      bounds: "parent",
      positionOffset: {
        x: -0,
        y: -offsetPin
      },
      position: {
        x: 0,
        y: 0
      },
      onStart: function onStart(e, _ref2) {
        return _onStart(hotspot);
      },
      onStop: function onStop(e, _ref3) {
        var node = _ref3.node;
        return onDrop(e, node, hotspot);
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: cn$1('lemo-editor-exercise-click-to-find-map-hotspots__draggable', {
        'lemo-editor-exercise-click-to-find-map-hotspots__draggable--selected': isSelected,
        'lemo-no-box-padding': noBoxPadding
      }),
      style: {
        top: hotspot.y + '%',
        left: hotspot.x + '%',
        height: hotspot.height + '%',
        width: hotspot.width + '%',
        zIndex: hotspot.z
      }
    }, /*#__PURE__*/React__default.createElement(PopoverHotspot, {
      x: hotspot.x,
      setX: function setX(valueX) {
        return _onEditHotspotX(hotspot, valueX);
      },
      y: hotspot.y,
      setY: function setY(valueY) {
        return _onEditHotspotY(hotspot, valueY);
      },
      width: hotspot.width,
      setWidth: function setWidth(value) {
        return onEditHotspot(_extends({}, hotspot, {
          width: value
        }));
      },
      height: hotspot.height,
      setHeight: function setHeight(value) {
        return onEditHotspot(_extends({}, hotspot, {
          height: value
        }));
      },
      onRemove: function onRemove() {
        return onDeleteHotspot(hotspot);
      },
      onChangeOpen: function onChangeOpen(open) {
        return onChangeOpenHotspot(hotspot, open);
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      className: "lemo-editor-exercise-click-to-find-map-hotspots__draggable-img",
      src: hotspot.src,
      alt: ""
    }))));
  })));
};
EditorExerciseClickToFindMapHotspots.propTypes = {};
EditorExerciseClickToFindMapHotspots.defaultProps = {};
var EditorExerciseClickToFindMapHotspots$1 = observer(EditorExerciseClickToFindMapHotspots);

function getWidthPercent(imageWidth, widthBackground) {
  var widthToRet = imageWidth * 100 / widthBackground;
  if (widthToRet > 100) widthToRet = 100;
  if (widthToRet < 0) widthToRet = 0;
  return widthToRet;
}
function getHeightPercent(imageHeight, heightBackground) {
  var heightToRet = imageHeight * 100 / heightBackground;
  if (heightToRet > 100) heightToRet = 100;
  if (heightToRet < 0) heightToRet = 0;
  return heightToRet;
}

var EditorExerciseClickToFindContent = function EditorExerciseClickToFindContent(_ref) {
  var background = _ref.background,
    onChangeBackground = _ref.onChangeBackground,
    _onChangeSliderSize = _ref.onChangeSliderSize,
    hotspots = _ref.hotspots,
    onAddHotspot = _ref.onAddHotspot,
    onEditHotspot = _ref.onEditHotspot,
    onDeleteHotspot = _ref.onDeleteHotspot,
    assetsApi = _ref.assetsApi,
    noBoxPadding = _ref.noBoxPadding;
  var inputFileRef = useRef(null);
  var backgroundRef = useRef(background);
  backgroundRef.current = background;
  var _useState = useState(null),
    statusChangePreview = _useState[0],
    setStatusChangePreview = _useState[1];
  var _useState2 = useState(null),
    uploadPosition = _useState2[0],
    setUploadPosition = _useState2[1];
  var uploadPositionRef = useRef(uploadPosition);
  uploadPositionRef.current = uploadPosition;
  var _useState3 = useState(0),
    counterNewHotspost = _useState3[0],
    setCounterNewHotspost = _useState3[1];
  var loadImageError = useCallback(function () {
    window.alert(translate('load_image_error_message'));
  }, []);
  var loadImageAbort = useCallback(function () {
    console.log('El usuario ha cancelado la descarga');
  }, []);
  var inputFileHandler = useCallback(function (e) {
    sendFile({
      file: e.target.files[0]
    }, function (fileInfo, status) {
      setStatusChangePreview(status);
    }, function (fileInfo, functionAbort) {}, function (value) {
      var original_height_px = value.hasOwnProperty('original_height') ? value.original_height : 0;
      var original_width_px = value.hasOwnProperty('original_width') ? value.original_width : 0;
      var heightBackground = backgroundRef && backgroundRef.current ? backgroundRef.current.height : 800;
      var widthBackground = backgroundRef && backgroundRef.current ? backgroundRef.current.width : 1280;
      onAddHotspot({
        src: value.source,
        x: uploadPositionRef.current.x,
        y: uploadPositionRef.current.y,
        width: getWidthPercent(original_width_px, widthBackground),
        height: getHeightPercent(original_height_px, heightBackground),
        original_height_px: original_height_px,
        original_width_px: original_width_px
      });
      setStatusChangePreview(null);
    }, function (error) {
      loadImageError(error);
    }, function () {
      loadImageAbort();
    }, assetsApi);
  }, [sendFile, assetsApi]);
  function onAddHotspotMap(position) {
    setUploadPosition(position);
    inputFileRef.current.click();
  }
  function onClickNewHotspot() {
    var coords = 0 + counterNewHotspost;
    if (coords > 100) coords = 100;
    onAddHotspotMap({
      x: coords,
      y: coords
    });
    setCounterNewHotspost(function (_counter) {
      return _counter + 1;
    });
  }
  function onInputClick(event) {
    event.target.value = '';
  }
  return /*#__PURE__*/React__default.createElement(ImageUploadOrPreview$1, {
    background: background,
    onChangeBackground: onChangeBackground,
    onChangeSliderSize: function onChangeSliderSize(val) {
      return _onChangeSliderSize(val / 100);
    },
    showSliderSizeThumb: true,
    sliderSizeThumbTitle: translate('click_to_find_size_background_title'),
    sliderSizeThumbSubtitle: translate('click_to_find_size_background_subtitle'),
    showDeletePreview: false,
    showAltText: true,
    showChangePreview: true,
    componentPreview: /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-editor-exercise-click-to-find-map"
    }, /*#__PURE__*/React__default.createElement(EditorExerciseClickToFindMapHotspots$1, {
      background: background,
      hotspots: hotspots,
      onAddHotspot: onAddHotspotMap,
      onEditHotspot: onEditHotspot,
      onDeleteHotspot: onDeleteHotspot,
      noBoxPadding: noBoxPadding
    }), /*#__PURE__*/React__default.createElement("input", {
      ref: inputFileRef,
      className: "lemo-editor-exercise-click-to-find-map__input lemo-editor-exercise-click-to-find-map__input--hide",
      type: "file",
      name: "file",
      accept: "image/jpeg, image/png, image/gif",
      onChange: inputFileHandler,
      onClick: onInputClick
    }), statusChangePreview && statusChangePreview === fileStatuses.UPLOADING && uploadPosition && /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-editor-exercise-click-to-find-map__uploading",
      style: {
        top: uploadPosition.y + '%',
        left: uploadPosition.x + '%'
      }
    }, /*#__PURE__*/React__default.createElement(UploadIcon, {
      status: statusChangePreview
    }))),
    componentLeftAltText: /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-editor-exercise-click-to-find-map__button-add"
    }, /*#__PURE__*/React__default.createElement(ButtonInline, {
      icon: /*#__PURE__*/React__default.createElement(SvgPlusCircle, {
        className: "lemo-icon lemo-editor-exercise-click-to-find-map__icon-plus"
      }),
      onClick: function onClick() {
        return onClickNewHotspot();
      },
      text: translate('add_new_question')
    })),
    assetsApi: assetsApi
  });
};
EditorExerciseClickToFindContent.propTypes = {};
EditorExerciseClickToFindContent.defaultProps = {};
var EditorExerciseClickToFindContent$1 = observer(EditorExerciseClickToFindContent);

var EditorExerciseClickToFind = function EditorExerciseClickToFind(_ref) {
  var background = _ref.background,
    onChangeBackground = _ref.onChangeBackground,
    onChangeSliderSize = _ref.onChangeSliderSize,
    hotspots = _ref.hotspots,
    onAddHotspot = _ref.onAddHotspot,
    onEditHotspot = _ref.onEditHotspot,
    onDeleteHotspot = _ref.onDeleteHotspot,
    assetsApi = _ref.assetsApi,
    noBoxPadding = _ref.noBoxPadding;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "lemoid-upload-image",
    icon: /*#__PURE__*/React__default.createElement(SvgPhotograph, {
      width: 20,
      height: 20
    }),
    titleBox: translate('Exercise'),
    helpText: translate('click_to_find_exercise_help'),
    classNameAdd: "lemo-editor-exercise-click-to-find"
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement(EditorExerciseClickToFindContent$1, {
    background: background,
    onChangeBackground: onChangeBackground,
    onChangeSliderSize: onChangeSliderSize,
    hotspots: hotspots,
    onAddHotspot: onAddHotspot,
    onEditHotspot: onEditHotspot,
    onDeleteHotspot: onDeleteHotspot,
    assetsApi: assetsApi,
    noBoxPadding: noBoxPadding
  })));
};
EditorExerciseClickToFind.propTypes = {};
EditorExerciseClickToFind.defaultProps = {};
var EditorExerciseClickToFind$1 = observer(EditorExerciseClickToFind);

var EditorExerciseLabelStore$2 = function EditorExerciseLabelStore(_ref) {
  var store = _ref.store,
    withSizeDrops = _ref.withSizeDrops;
  var percentImage = store.image && store.image.hasOwnProperty('percent') ? store.image.percent : 1;
  return /*#__PURE__*/React__default.createElement(EditorExerciseClickToFind$1, {
    background: store.image ? {
      source: store.image.src,
      original_width: store.image.width,
      original_height: store.image.height,
      scale: percentImage * 100,
      width: percentImage * store.image.width,
      height: percentImage * store.image.height,
      alt: store.image.alt
    } : null,
    onChangeBackground: function onChangeBackground(value) {
      value ? store.setImage({
        src: value.source,
        width: value.original_width,
        height: value.original_height,
        percent: value.hasOwnProperty('scale') ? value.scale / 100 : 1,
        alt: value.alt
      }) : store.clearImage();
    },
    onChangeSliderSize: store.image.setPercent,
    store: store,
    withSizeDrops: withSizeDrops,
    hotspots: store.hotspots,
    onAddHotspot: store.addHotspot,
    onEditHotspot: store.editHotspot,
    onDeleteHotspot: store.deleteHotspot,
    assetsApi: getAssetsEditorApi(store.assetsEditorApi),
    noBoxPadding: store.ui_style.no_box_padding
  });
};
var EditorExerciseClickToFindStore = observer(EditorExerciseLabelStore$2);

var _excluded$z = ["store", "changed", "type", "immediateFeedback"];
var ClickToFindEditor = function ClickToFindEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$z);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setLabel|sortAnswersOptions|addAnswerOption|setErrorString|setShuffleOptions|sortQuestionsOptions|addQuestionOption|removeQuestionOption|removeAnswerOption|setLineColor|setLineThickness|updateSolution|setImage|addHotspot|editHotspot|deleteHotspot|setIsEvaluable|setShowSelection|setPercent",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.STIMULUS] = {
      order: 0
    }, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 2
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 3,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref[EDITOR_COMPONENT_COMMON.BACKGROUND] = {
      hide: true
    }, _ref[EDITOR_COMPONENT_COMMON.CLEAR_ALL] = {
      order: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.CLEAR_ALL].order,
      hide: false
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorExerciseClickToFindStore, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    withPenaltyByResponse: true,
    helpText: translate('exact_math_or_partial_match_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: [TYPES_CONFIG.CONFIG_FEEDBACK_MODE_CLICK_TO_FIND, TYPES_CONFIG.CONFIG_SHOW_SELECTION]
  }));
};
var ClickToFindEditor$1 = observer(ClickToFindEditor);

var ClickToFindUIStyles = types$1.compose(BaseModel$1, withShowSelection, types$1.model({
  feedback_mode: types$1.optional(types$1.string, feedbackModeTypes.FEEDBACK_WITH_BORDER),
  no_box_padding: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    setFeedbackMode: function setFeedbackMode(feedbackMode) {
      state.feedback_mode = feedbackMode;
      getParent(state).updateNotifier();
    }
  };
}));
var defaultClickToFindUIStyle = _extends({}, defaultUIStyle, {
  feedback_mode: feedbackModeTypes.FEEDBACK_WITH_BORDER
});

var HotspotModel = types$1.model({
  id: types$1.optional(types$1.string, function () {
    return uuid();
  }),
  src: types$1.string,
  x: types$1.optional(types$1.number, 0),
  y: types$1.optional(types$1.number, 0),
  z: types$1.optional(types$1.number, 1),
  height: types$1.optional(types$1.number, 0),
  width: types$1.optional(types$1.number, 0),
  original_height_px: types$1.optional(types$1.number, 0),
  original_width_px: types$1.optional(types$1.number, 0)
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      state.z = state.z === 0 ? state.maxDepth + 1 : state.z;
    },
    getNextDepth: function getNextDepth() {
      if (state.maxDepth !== state.z) {
        state.z = state.maxDepth + 1;
      }
    },
    setZ: function setZ(z) {
      state.z = z;
    },
    editHotspot: function editHotspot(hotspotUpdate) {
      if (hotspotUpdate) {
        state.src = hotspotUpdate.src;
        state.x = hotspotUpdate.x;
        state.y = hotspotUpdate.y;
        state.z = hotspotUpdate.z;
        state.height = hotspotUpdate.height;
        state.width = hotspotUpdate.width;
        state.original_height_px = hotspotUpdate.original_height_px;
        state.original_width_px = hotspotUpdate.original_width_px;
      }
    }
  };
}).views(function (state) {
  return {
    get maxDepth() {
      return getParent(state).reduce(function (acc, next) {
        return next.z > acc ? next.z : acc;
      }, 0);
    }
  };
});

var ClickToFindStore = types$1.compose(EditorBaseModel, types$1.model({
  isEvaluable: true,
  image: ImageModel,
  hotspots: types$1.optional(types$1.array(HotspotModel), []),
  ui_style: types$1.optional(ClickToFindUIStyles, defaultClickToFindUIStyle)
}).actions(function (state) {
  return {
    setImage: function setImage(_ref) {
      var src = _ref.src,
        width = _ref.width,
        height = _ref.height,
        percent = _ref.percent,
        alt = _ref.alt;
      state.image = {
        src: src,
        width: width,
        height: height,
        percent: percent,
        alt: alt,
        title: ''
      };
      state.updateNotifier();
    },
    addHotspot: function addHotspot(hotspot) {
      state.hotspots.push(hotspot);
      state.updateNotifier();
    },
    editHotspot: function editHotspot(hotspotUpdate) {
      var hotspotFind = hotspotUpdate ? state.hotspots.find(function (h) {
        return h.id === hotspotUpdate.id;
      }) : null;
      if (hotspotFind) {
        hotspotFind.editHotspot(hotspotUpdate);
      }
      state.updateNotifier();
    },
    deleteHotspot: function deleteHotspot(hotspot) {
      var hotspotFind = hotspot ? state.hotspots.find(function (h) {
        return h.id === hotspot.id;
      }) : null;
      if (hotspotFind) {
        destroy(hotspotFind);
      }
      state.updateNotifier();
    },
    clearAll: function clearAll() {
      state.clearAllBase();
      state.hotspots.clear();
      state.updateNotifier();
    }
  };
}).views(function (state) {
  return {
    getUserResponse: function getUserResponse() {
      return '';
    },
    getResults: function getResults() {
      return {};
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$S(rawData);
    },
    get output() {
      return exportCommonValues(state, {
        hotspots: state.hotspots.map(function (hotspot) {
          return {
            src: hotspot.src,
            x: hotspot.x,
            y: hotspot.y,
            z: hotspot.z,
            width: hotspot.width,
            height: hotspot.height,
            original_height_px: hotspot.original_height_px,
            original_width_px: hotspot.original_width_px
          };
        }),
        image: getSnapshot(state.image)
      });
    }
  };
}));
function _createSnapshot$S(data) {
  var hotspots = data.data.hotspots;
  var percentImage = getPercentImageFromData(data);
  return _extends({}, data.data, importCommonValues$1(data), {
    hotspots: hotspots.map(function (hotspot) {
      return {
        src: hotspot.src,
        x: hotspot.x,
        y: hotspot.y,
        z: hotspot.z,
        width: hotspot.width,
        height: hotspot.height,
        original_height_px: hotspot.original_height_px,
        original_width_px: hotspot.original_width_px
      };
    }),
    image: _extends({}, data.data.image, percentImage ? {
      percent: percentImage
    } : {})
  });
}
function createStore$16(data) {
  var store = ClickToFindStore.create(_createSnapshot$S(data));
  return store;
}

var iconTitle$6 = /*#__PURE__*/React__default.createElement(SvgAdjustments, {
  width: "24"
});
var titleBox$7 = 'Configuration';
var helpText$7 = 'config_help';
function BarChartEditorConfig(_ref) {
  var _store$ui_style;
  var store = _ref.store;
  var stepsList = useMemo(function () {
    return [translate('config_clock_steps_one'), translate('config_clock_steps_five')];
  }, [config.lang]);
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "configuration",
    icon: iconTitle$6,
    titleBox: translate(titleBox$7),
    helpText: translate(helpText$7),
    classNameAdd: "lemo-editor-config"
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement(ConfigShowCheckIcon, {
    title: translate('config_clock_digital_title'),
    subtitle: translate('config_clock_digital_subtitle'),
    isChecked: store.ui_style.type === CLOCK_TYPES.DIGITAL,
    onChange: function onChange(bool) {
      return store.ui_style.setType(bool ? CLOCK_TYPES.DIGITAL : CLOCK_TYPES.ANALOG);
    }
  }), /*#__PURE__*/React__default.createElement(Line1, null), store.ui_style.type !== CLOCK_TYPES.DIGITAL && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ConfigShowCheckIcon, {
    title: translate('config_clock_dark_mode_title'),
    subtitle: translate('config_clock_dark_mode_subtitle'),
    isChecked: store.ui_style.theme === CLOCK_THEMES.DARK,
    onChange: function onChange(bool) {
      return store.ui_style.setTheme(bool ? CLOCK_THEMES.DARK : CLOCK_THEMES.LIGHT);
    }
  }), config.showAuthorVariantsEditor && /*#__PURE__*/React__default.createElement(Line1, null)), /*#__PURE__*/React__default.createElement(ConfigVariantStyle$1, {
    onChange: function onChange(value) {
      store.ui_style.customClass.setVariant(value.variant);
      store.ui_style.customClass.setClassList(value.classList);
    },
    variantList: store.variants,
    customClass: {
      variant: (_store$ui_style = store.ui_style) === null || _store$ui_style === void 0 ? void 0 : _store$ui_style.customClass.variant,
      classList: store.ui_style.customClass.classList
    }
  })));
}
var ClockEditorConfig = observer(BarChartEditorConfig);

var _excluded$A = ["store", "changed", "type"];
var ClockEditor = function ClockEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$A);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setTitle|setStimulus|afterCreate|setFeedback|onUpdateHint|setTimeSystem|setTheme|setStep|setType",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 0
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 1
    }, _ref[EDITOR_COMPONENT_COMMON.BACKGROUND] = {
      hide: true,
      order: 3
    }, _ref)
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    hasMultipleResponses: false,
    evaluationTypes: [getEvaluationTypeOption(keysTranslateEvaluationTypes.EXACT_MATCH, keysTranslateSubtitleEvaluationTypes.EXACT_MATCH, validationModes.EXACT_MATCH)],
    helpText: translate('exact_math_or_match_response_or_match_group_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(ClockEditorConfig, {
    store: store
  }));
};
var ClockEditor$1 = observer(ClockEditor);

var MIN_LENGTH_WORD$1 = 2;
var MIN_NUMBER_WORDS = 2;
var EMPTY_CELL = '';
var CROSSWORD_COLUMNS_DEFAULT = 20;
var CROSSWORD_ROWS_DEFAULT = 20;
var CROSSWORD_MAX_WORD_LENGTH = 10;
var CROSSWORD_MAX_NUMBER_WORDS = 10;
var CROSSWORD_MAX_GRID_GRIZE = 20;
function isValidStringByLength$1(stringInput) {
  if (hasData(stringInput) && stringInput.length >= MIN_LENGTH_WORD$1) {
    return true;
  } else return false;
}
function trimTable(data, emptyCell) {
  var table = data.grid;
  var rows = table.length;
  var cols = table.length > 0 ? table[0].length : 0;
  var leftMost = cols;
  var topMost = rows;
  var rightMost = -1;
  var bottomMost = -1;
  for (var i = 0; i < rows; i++) {
    for (var j = 0; j < cols; j++) {
      if (table[i][j] !== emptyCell) {
        var x = j;
        var y = i;
        if (x < leftMost) {
          leftMost = x;
        }
        if (x > rightMost) {
          rightMost = x;
        }
        if (y < topMost) {
          topMost = y;
        }
        if (y > bottomMost) {
          bottomMost = y;
        }
      }
    }
  }
  var trimmedTable = initTable(bottomMost - topMost + 1, rightMost - leftMost + 1, emptyCell);
  for (var _i = topMost; _i < bottomMost + 1; _i++) {
    for (var _j = leftMost; _j < rightMost + 1; _j++) {
      trimmedTable[_i - topMost][_j - leftMost] = table[_i][_j];
    }
  }
  var solutions = data.solutions ? [].concat(data.solutions) : [];
  for (var index = 0; index < solutions.length; index++) {
    var solution = solutions[index];
    if (Object.prototype.hasOwnProperty.call(solution, 'startX') && Object.prototype.hasOwnProperty.call(solution, 'startY')) {
      solution.startX -= leftMost;
      solution.startY -= topMost;
    }
  }
  return {
    grid: trimmedTable,
    solutions: solutions,
    rows: Math.max(bottomMost - topMost + 1, 0),
    cols: Math.max(rightMost - leftMost + 1, 0)
  };
}
function initTable(rows, cols, emptyCell) {
  var table = [];
  for (var i = 0; i < rows; i++) {
    for (var j = 0; j < cols; j++) {
      if (j === 0) {
        table[i] = [emptyCell];
      } else {
        table[i][j] = emptyCell;
      }
    }
  }
  return table;
}

function CrosswordPuzzle(gridSize) {
  var usedWords = [];
  var emptyCell = EMPTY_CELL;
  var grid = Array.from(Array(gridSize), function () {
    return new Array(gridSize);
  });
  for (var row = 0; row < gridSize; row++) {
    for (var column = 0; column < gridSize; column++) {
      grid[row][column] = emptyCell;
    }
  }
  var update = function update(word) {
    var updated = false;
    if (canBePlaced(word)) {
      addWord(word);
      updated = true;
    }
    return updated;
  };
  var canBePlaced = function canBePlaced(word) {
    var canBePlaced = true;
    if (isValidPosition(word.row, word.column) && fitsOnGrid(word)) {
      var index = 0;
      var numberCharsMathching = 0;
      while (index < word.text.length) {
        var currentRow = word.vertical ? word.row + index : word.row;
        var currentColumn = !word.vertical ? word.column + index : word.column;
        if (word.text.charAt(index) === grid[currentRow][currentColumn]) numberCharsMathching++;
        if ((word.text.charAt(index) === grid[currentRow][currentColumn] || emptyCell === grid[currentRow][currentColumn]) && placementLegal(word, currentRow, currentColumn)) ; else {
          canBePlaced = false;
        }
        index++;
      }
      if (canBePlaced && usedWords.length > 0 && numberCharsMathching === 0) {
        canBePlaced = false;
      }
      if (canBePlaced) {
        if (word.vertical) {
          if (!(isEmptyCell(word.row - 1, word.column) && isEmptyCell(word.row + word.text.length, word.column))) {
            canBePlaced = false;
          }
        } else {
          if (!(isEmptyCell(word.row, word.column - 1) && isEmptyCell(word.row, word.column + word.text.length))) {
            canBePlaced = false;
          }
        }
      }
    } else {
      canBePlaced = false;
    }
    return canBePlaced;
  };
  var getIntersections = function getIntersections() {
    var intersections = 0;
    for (var _row = 0; _row < gridSize; _row++) {
      for (var _column = 0; _column < gridSize; _column++) {
        if (isLetter(_row, _column)) {
          if (isValidPosition(_row - 1, _column) && isValidPosition(_row + 1, _column) && isValidPosition(_row, _column - 1) && isValidPosition(_row, _column + 1) && isLetter(_row - 1, _column) && isLetter(_row + 1, _column) && isLetter(_row, _column - 1) && isLetter(_row, _column + 1)) {
            ++intersections;
          }
        }
      }
    }
    return intersections;
  };
  var placementLegal = function placementLegal(word, row, column) {
    var illegal = false;
    if (word.vertical) {
      illegal = isInterference(row, column + 1, row + 1, column) || isInterference(row, column - 1, row + 1, column) || overwritingVerticalWord(row, column) || invadingTerritory(word, row, column);
    } else {
      illegal = isInterference(row + 1, column, row, column + 1) || isInterference(row - 1, column, row, column + 1) || overwritingHorizontalWord(row, column) || invadingTerritory(word, row, column);
    }
    return !illegal;
  };
  var invadingTerritory = function invadingTerritory(word, row, column) {
    var invading = false;
    var empty = isEmptyCell(row, column);
    if (word.vertical) {
      var weHaveNeighbors = doesCharacterExist(row, column - 1) || doesCharacterExist(row, column + 1) || endOfWord(word, row, column) && doesCharacterExist(row + 1, column);
      invading = empty && weHaveNeighbors;
    } else {
      var _weHaveNeighbors = doesCharacterExist(row - 1, column) || doesCharacterExist(row + 1, column) || endOfWord(word, row, column) && doesCharacterExist(row, column + 1);
      invading = empty && _weHaveNeighbors;
    }
    return invading;
  };
  var endOfWord = function endOfWord(word, row, column) {
    if (word.vertical) {
      return word.row + word.text.length - 1 === row;
    } else {
      return word.column + word.text.length - 1 === column;
    }
  };
  var doesCharacterExist = function doesCharacterExist(row, column) {
    return isValidPosition(row, column) && isLetter(row, column);
  };
  var overwritingHorizontalWord = function overwritingHorizontalWord(row, column) {
    var leftColumn = column - 1;
    return isValidPosition(row, leftColumn) && isLetter(row, column) && isLetter(row, leftColumn);
  };
  var overwritingVerticalWord = function overwritingVerticalWord(row, column) {
    var rowAbove = row - 1;
    return isValidPosition(rowAbove, column) && isLetter(row, column) && isLetter(rowAbove, column);
  };
  var isInterference = function isInterference(row, column, nextRow, nextColumn) {
    return isValidPosition(row, column) && isValidPosition(nextRow, nextColumn) && isLetter(row, column) && isLetter(nextRow, nextColumn);
  };
  var isLetter = function isLetter(row, column) {
    return isValidPosition(row, column) && grid[row][column] !== emptyCell;
  };
  var isEmptyCell = function isEmptyCell(row, column) {
    return !isLetter(row, column);
  };
  var addWord = function addWord(word) {
    for (var letterIndex = 0; letterIndex < word.text.length; ++letterIndex) {
      var _row2 = word.row;
      var _column2 = word.column;
      if (word.vertical) {
        _row2 += letterIndex;
      } else {
        _column2 += letterIndex;
      }
      grid[_row2][_column2] = word.text.substring(letterIndex, letterIndex + 1);
      usedWords.push(word);
    }
  };
  var fitsOnGrid = function fitsOnGrid(word) {
    if (word.vertical) {
      return word.row + word.text.length <= gridSize;
    } else {
      return word.column + word.text.length <= gridSize;
    }
  };
  var isValidPosition = function isValidPosition(row, column) {
    return row >= 0 && row < gridSize && column >= 0 && column < gridSize;
  };
  return {
    grid: grid,
    update: update,
    isLetter: isLetter,
    getIntersections: getIntersections
  };
}

function Word(text, row, column, vertical) {
  this.text = text;
  this.row = row;
  this.column = column;
  this.vertical = vertical;
}

var createCrossWordV1 = function createCrossWordV1(words, gridSize) {
  var attemptsToFitWords = 5000;
  var maxContinuousFails = 100;
  var gridsToMake = 3;
  var usedWords = [];
  var generatedGrids = [];
  var goodStartingLetters = new Set();
  var tryWords = [];
  var attemptToPlaceWordOnGrid = function attemptToPlaceWordOnGrid(grid) {
    var text = getAWordToTry();
    if (text) {
      for (var row = 0; row < gridSize; ++row) {
        for (var column = 0; column < gridSize; ++column) {
          var word = new Word(text, row, column, mathRandom() >= 0.5);
          if (grid.update(word)) {
            pushUsedWords(word);
            return true;
          }
        }
      }
    }
    return false;
  };
  var getAWordToTry = function getAWordToTry() {
    tryWords = [];
    var word = getRandomWord();
    if (word) {
      var goodWord = isGoodWord(word);
      if (word && !goodWord) tryWords.push(word);
      while ((getUsedWordsText().includes(word) || !goodWord) && word !== null) {
        word = getRandomWord();
        if (word) {
          goodWord = isGoodWord(word);
          if (!goodWord) tryWords.push(word);
        }
      }
    }
    return word;
  };
  var getBestGrid = function getBestGrid(grids) {
    var bestGrid = null;
    if (grids.length > 0) {
      bestGrid = grids[0];
    }
    for (var _iterator = _createForOfIteratorHelperLoose(grids), _step; !(_step = _iterator()).done;) {
      var grid = _step.value;
      if (grid.solutions.length > bestGrid.solutions.length) {
        bestGrid = grid;
      } else {
        if (grid.solutions.length === bestGrid.solutions.length) {
          if (grid.grid && grid.grid.getIntersections() >= bestGrid.grid.getIntersections()) {
            bestGrid = grid;
          }
        }
      }
    }
    return bestGrid;
  };
  var isGoodWord = function isGoodWord(word) {
    var goodWord = false;
    for (var _iterator2 = _createForOfIteratorHelperLoose(goodStartingLetters), _step2; !(_step2 = _iterator2()).done;) {
      var letter = _step2.value;
      if (word.includes(letter)) {
        goodWord = true;
        break;
      }
    }
    return goodWord;
  };
  var generateGrids = function generateGrids() {
    generatedGrids = [];
    for (var gridsMade = 0; gridsMade < gridsToMake; gridsMade++) {
      var grid = new CrosswordPuzzle(gridSize);
      var firstWord = getRandomWord();
      if (firstWord) {
        var verticalFirstWord = mathRandom() >= 0.5;
        var rowFistWord = 0;
        var columnFirst = 0;
        if (verticalFirstWord) {
          rowFistWord = getRandomInt(gridSize - firstWord.length);
          columnFirst = getRandomInt(gridSize);
        } else {
          rowFistWord = getRandomInt(gridSize);
          columnFirst = getRandomInt(gridSize - firstWord.length);
        }
        var word = new Word(firstWord, rowFistWord, columnFirst, verticalFirstWord);
        grid.update(word);
        pushUsedWords(word);
        var continuousFails = 0;
        for (var attempts = 0; attempts < attemptsToFitWords; ++attempts) {
          var placed = attemptToPlaceWordOnGrid(grid);
          if (placed) {
            continuousFails = 0;
          } else {
            continuousFails++;
          }
          if (continuousFails > maxContinuousFails) {
            break;
          }
          if (usedWords.length >= words.length) {
            break;
          }
        }
        generatedGrids.push({
          grid: grid,
          solutions: [].concat(usedWords)
        });
        if (usedWords.length >= words.length) {
          break;
        }
      }
      usedWords = [];
      tryWords = [];
    }
  };
  var pushUsedWords = function pushUsedWords(wordInfo) {
    usedWords.push(wordInfo);
    wordInfo.text.split('').filter(function (_char) {
      return goodStartingLetters.add(_char);
    });
  };
  function getUsedWordsText() {
    return usedWords.map(function (usedWord) {
      return usedWord.text;
    });
  }
  function getUnusedWordsAndNotTry() {
    return words.filter(function (val) {
      return !getUsedWordsText().includes(val) && !tryWords.includes(val);
    });
  }
  function getRandomWord() {
    var words = getUnusedWordsAndNotTry();
    return words.length > 0 ? words[getRandomInt(words.length)] : null;
  }
  function getRandomInt(max) {
    return secureRandomInt(0, max - 1);
  }
  generateGrids();
  var bestGrid = getBestGrid(generatedGrids);
  return bestGrid;
};

function generateCrossword(words, gridSize, minNumberWords) {
  var _resultCreate$grid;
  if (words === void 0) {
    words = [];
  }
  if (gridSize === void 0) {
    gridSize = Math.max(CROSSWORD_COLUMNS_DEFAULT, CROSSWORD_ROWS_DEFAULT);
  }
  if (minNumberWords === void 0) {
    minNumberWords = MIN_NUMBER_WORDS;
  }
  function isValidMinWords() {
    return words.length >= minNumberWords;
  }
  var resultCreate = createCrossWordV1(words, gridSize);
  var gridToRet = resultCreate !== null && resultCreate !== void 0 && (_resultCreate$grid = resultCreate.grid) !== null && _resultCreate$grid !== void 0 && _resultCreate$grid.grid && isValidMinWords() ? resultCreate.grid.grid : [];
  var solutionsToRet = resultCreate !== null && resultCreate !== void 0 && resultCreate.solutions && isValidMinWords() ? resultCreate.solutions.map(function (solution) {
    return {
      value: solution.text,
      startX: solution.column,
      startY: solution.row,
      vertical: solution.vertical,
      visibleLetters: []
    };
  }) : [];
  if (gridToRet && solutionsToRet) {
    var trimTableResult = trimTable({
      grid: gridToRet,
      solutions: solutionsToRet
    }, EMPTY_CELL);
    if (trimTableResult) {
      if (trimTableResult.grid && trimTableResult.solutions) {
        gridToRet = trimTableResult.grid;
        solutionsToRet = trimTableResult.solutions;
      }
    }
  }
  var columns = gridToRet.length > 0 ? gridToRet[0].length : 0;
  var rows = gridToRet.length;
  var getWordsOut = function getWordsOut() {
    var wordsFind = words.filter(function (word) {
      return !solutionsToRet.find(function (solution) {
        return solution.value === word;
      });
    });
    return wordsFind || [];
  };
  var isInvalid = function isInvalid() {
    var wordsOut = getWordsOut();
    return wordsOut && wordsOut.length > 0;
  };
  var isValid = function isValid() {
    return !isInvalid();
  };
  return {
    grid: gridToRet,
    solutions: solutionsToRet,
    columns: columns,
    rows: rows,
    getWordsOut: getWordsOut,
    isValid: isValid
  };
}
function getMinGridSizeDefault(words) {
  var wordLength = words.length;
  if (wordLength <= 5) {
    return 14;
  } else if (wordLength === 6) {
    return 15;
  } else if (wordLength === 7) {
    return 16;
  } else if (wordLength === 8) {
    return 18;
  } else if (wordLength === 9) {
    return 19;
  } else if (wordLength >= 10) {
    return CROSSWORD_MAX_GRID_GRIZE;
  }
}
var createCrossWordV1Plus = function createCrossWordV1Plus(words) {
  var maxGridSize = Math.max(words.length, CROSSWORD_MAX_GRID_GRIZE);
  var minGridSize = getMinGridSizeDefault(words);
  var crosswordsValid = [];
  var crosswordsInvalid = [];
  for (var indexGridSize = minGridSize; indexGridSize <= maxGridSize; indexGridSize++) {
    var resultCreate = generateCrossword(words, indexGridSize);
    if (resultCreate.isValid()) {
      crosswordsValid.push(resultCreate);
      break;
    } else {
      crosswordsInvalid.push(resultCreate);
    }
  }
  if (crosswordsValid.length > 0) {
    return crosswordsValid[0];
  } else {
    return crosswordsInvalid[crosswordsInvalid.length - 1];
  }
};

var isOnlyLetters = function isOnlyLetters(str) {
  return /^[a-zA-ZáéíóúÁÉÍÓÚñÑçÇâêîôûäëïöüàèìòùÂÊÎÔÛÄËÏÖÜÀÈÌÒÙãÃõÕ]+$/.test(str);
};
var isAccent = function isAccent(text) {
  return text.match(/[`´¨^~]/);
};

var WordPositionModel = types$1.compose(ValueModel, types$1.model({
  startX: types$1.optional(types$1.number, -1),
  startY: types$1.optional(types$1.number, -1),
  visibleLetters: types$1.optional(types$1.array(types$1.number), []),
  vertical: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    setStartX: function setStartX(_startX) {
      state.startX = _startX;
    },
    setStartY: function setStartY(_startY) {
      state.startY = _startY;
    },
    setVisibleLetters: function setVisibleLetters(_visibleLetters) {
      state.visibleLetters = _visibleLetters;
    },
    setVertical: function setVertical(_vertical) {
      state._vertical = _vertical;
    }
  };
}).views(function (state) {
  return {
    get parent() {
      return getRoot(state);
    }
  };
}));
var WordPositionModel$1 = types$1.snapshotProcessor(WordPositionModel, {
  preProcessor: function preProcessor(sn) {
    return _extends({}, sn);
  },
  postProcessor: function postProcessor(sn) {
    return {
      word: sn.value,
      startX: sn.startX,
      startY: sn.startY,
      visibleLetters: sn.visibleLetters,
      vertical: sn.vertical
    };
  }
});

var CrosswordBoard = types$1.compose(types$1.model({
  columns: types$1.optional(types$1.number, CROSSWORD_COLUMNS_DEFAULT),
  rows: types$1.optional(types$1.number, CROSSWORD_ROWS_DEFAULT),
  letters: types$1.optional(types$1.array(types$1.array(types$1.string)), []),
  wordsPosition: types$1.optional(types$1.array(WordPositionModel$1), [])
}).actions(function (state) {
  return {
    setColumns: function setColumns(columns) {
      state.columns = columns;
      getParent(state).updateNotifier();
    },
    setRows: function setRows(rows) {
      state.rows = rows;
      getParent(state).updateNotifier();
    },
    setColumnsRows: function setColumnsRows(columns, rows) {
      state.columns = columns;
      state.rows = rows;
      getParent(state).updateNotifier();
    },
    setLetters: function setLetters(letters) {
      state.letters = letters;
      getParent(state).updateNotifier();
    },
    setBackward: function setBackward(backward) {
      state.backward = backward;
      getParent(state).updateNotifier();
      getParent(state).updateCrosswordBoard();
    },
    setDiagonal: function setDiagonal(diagonal) {
      state.diagonal = diagonal;
      getParent(state).updateNotifier();
      getParent(state).updateCrosswordBoard();
    },
    setWordsPosition: function setWordsPosition(wordsPosition) {
      state.wordsPosition = wordsPosition;
      getParent(state).updateNotifier();
    }
  };
}));
var CrosswordBoard$1 = types$1.snapshotProcessor(CrosswordBoard, {
  preProcessor: function preProcessor(sn) {
    return _extends({}, sn);
  },
  postProcessor: function postProcessor(sn) {
    return {
      columns: sn.columns,
      rows: sn.rows,
      random: sn.random,
      letters: sn.letters,
      words_position: sn.wordsPosition
    };
  }
});
var defaultBoard$1 = {
  columns: CROSSWORD_COLUMNS_DEFAULT,
  rows: CROSSWORD_ROWS_DEFAULT,
  letters: [],
  wordsPosition: []
};

var CrosswordUIStyles = types$1.compose(BaseModel$1, types$1.model({}).actions(function (state) {
  return {};
}));
var defaultWordSearchUIStyle = _extends({}, defaultUIStyle);

var WordsModel = types$1.compose(ValueModel, types$1.model({
  description: types$1.optional(types$1.string, ''),
  error: types$1.optional(types$1.string, '')
}).actions(function (state) {
  return {
    setError: function setError(_error) {
      state.error = _error;
    },
    setDescription: function setDescription(_description) {
      state.description = _description;
    },
    reset: function reset() {
      state.value = '';
    }
  };
}).views(function (state) {
  return {
    get parent() {
      return getRoot(state);
    }
  };
}));
var WordsModel$1 = types$1.snapshotProcessor(WordsModel, {
  preProcessor: function preProcessor(sn) {
    return _extends({}, sn);
  },
  postProcessor: function postProcessor(sn) {
    return {
      word: sn.value,
      description: sn.description
    };
  }
});

var CrosswordEditorStore = types$1.compose(EditorBaseModel, types$1.model({
  isEvaluable: true,
  board: types$1.optional(CrosswordBoard$1, defaultBoard$1),
  ui_style: types$1.optional(CrosswordUIStyles, defaultWordSearchUIStyle),
  words: types$1.optional(types$1.array(WordsModel$1), []),
  normalization: types$1.optional(InputNormalizationModel, {
    accents: false,
    lower: false,
    spaces: false
  }),
  shuffle_options: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      onAction(state, function (_ref) {
        var name = _ref.name;
        if (name.match(/removeValue|setValue|destroy/)) {
          state.updateValidation();
          state.updateCrosswordBoard();
        }
        if (name.match(/setColumnsRows/)) {
          state.deleteInvalidWordsByLength();
          state.updateValidation();
          state.updateCrosswordBoard();
        }
        if (name.match(/toggleLower/)) {
          state.convertWordToUppercaseOrLowercase();
          state.updateValidation();
          state.updateCrosswordBoard();
        }
      }, true);
    },
    clearAllErrorWords: function clearAllErrorWords() {
      for (var index = 0; index < state.words.length; index++) {
        var word = state.words[index];
        word.setError('');
      }
    },
    updateCrosswordBoard: function updateCrosswordBoard() {
      var generate = createCrossWordV1Plus(state.wordsValidValue);
      var wordsOut = generate.getWordsOut();
      if (wordsOut && wordsOut.length > 0) console.log(wordsOut);
      state.clearAllErrorWords();
      var _loop = function _loop() {
        var wordOut = wordsOut[index];
        var wordFind = state.words.find(function (word) {
          return word.value === wordOut;
        });
        if (wordFind) {
          if (state.wordsValidValue.length >= MIN_NUMBER_WORDS) {
            wordFind.setError(translate('crossword_word_out'));
          }
        }
      };
      for (var index = 0; index < wordsOut.length; index++) {
        _loop();
      }
      if (generate.isValid()) {
        state.board.setColumns(generate.columns);
        state.board.setRows(generate.rows);
        state.board.setLetters(generate.grid);
        state.board.setWordsPosition(generate.solutions);
      } else {
        state.board.setColumns(0);
        state.board.setRows(0);
        state.board.setLetters([]);
        state.board.setWordsPosition([]);
      }
      state.updateNotifier();
    },
    updateValidation: function updateValidation() {
      state.validation.setValue(state.wordsValidValue);
      state.updateNotifier();
    },
    removeValue: function removeValue(item) {
      destroy(item);
      state.updateNotifier();
    },
    addEmptyWord: function addEmptyWord() {
      state.words.push({
        value: ''
      });
      state.updateNotifier();
    },
    deleteInvalidWordsByLength: function deleteInvalidWordsByLength() {
      var invalidWords = state.getInvalidWordsByLength(state.board.columns, state.board.rows);
      if (invalidWords) {
        state.deleteWords(invalidWords);
      }
    },
    deleteWords: function deleteWords(wordsDelete) {
      for (var index = 0; index < wordsDelete.length; index++) {
        var wordDelete = wordsDelete[index];
        state.removeValue(wordDelete);
      }
    },
    convertWordToUppercaseOrLowercase: function convertWordToUppercaseOrLowercase() {
      for (var index = 0; index < state.words.length; index++) {
        var word = state.words[index];
        word.value = state.normalization.lower ? word.value.toLowerCase() : word.value.toUpperCase();
      }
    },
    setShuffleOptions: function setShuffleOptions(bool) {
      state.shuffle_options = bool;
      state.updateNotifier();
    }
  };
}).views(function (state) {
  return {
    getUserResponse: function getUserResponse() {
      return '';
    },
    getResults: function getResults() {
      return {};
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$T(rawData);
    },
    getWordPositionOrder: function getWordPositionOrder(wordsPositionOutput) {
      var wordsValid = state.wordsValid;
      if (wordsPositionOutput.length === wordsValid.length) {
        var wordsPositionOutputOrder = [];
        var _loop2 = function _loop2() {
          var word = wordsValid[index];
          var findWordPosition = wordsPositionOutput.find(function (wordPositionOutput) {
            return wordPositionOutput.word === word.value;
          });
          if (findWordPosition) {
            wordsPositionOutputOrder.push(findWordPosition);
          }
        };
        for (var index = 0; index < wordsValid.length; index++) {
          _loop2();
        }
        if (wordsPositionOutputOrder.length === wordsValid.length) {
          return wordsPositionOutputOrder;
        } else {
          return wordsPositionOutput;
        }
      } else {
        return wordsPositionOutput;
      }
    },
    get output() {
      var board = getSnapshot(state.board);
      var boardFinal = board.words_position ? _extends({}, board, {
        words_position: state.getWordPositionOrder(board.words_position)
      }) : board;
      var snapshotWords = getSnapshot(state.words);
      var snapshotWordsValid = getWordsValidFn(snapshotWords, 'word');
      return exportCommonValues(state, {
        words: snapshotWordsValid,
        board: boardFinal,
        normalization: getSnapshot(state.normalization),
        shuffle_options: state.shuffle_options
      });
    },
    get wordsValid() {
      return getWordsValidFn(state.words, 'value');
    },
    get wordsValidValue() {
      return state.wordsValid.map(function (res) {
        return res.value;
      });
    },
    getInvalidWordsByLength: function getInvalidWordsByLength(columns, rows) {
      var max = Math.max(columns, rows);
      var invalidWordsByLength = state.words.filter(function (word) {
        return word.value.length > max;
      });
      var wordsWhihoutInvalid = state.words.filter(function (word) {
        return !invalidWordsByLength.find(function (invalidWord) {
          return invalidWord.id === word.id;
        });
      });
      if (wordsWhihoutInvalid.length > state.getMaxNumberWords(columns, rows)) {
        var wordsOut = wordsWhihoutInvalid.slice(-1 * (wordsWhihoutInvalid.length - state.getMaxNumberWords(columns, rows)));
        if (wordsOut && wordsOut.length > 0) {
          invalidWordsByLength = invalidWordsByLength.concat(wordsOut);
        }
      }
      return invalidWordsByLength;
    },
    getMaxNumberWords: function getMaxNumberWords(columns, rows) {
      return CROSSWORD_MAX_NUMBER_WORDS;
    },
    get disabledAddNew() {
      return state.words.length + 1 > state.getMaxNumberWords(state.board.columns, state.board.rows);
    },
    isValidWord: function isValidWord(word) {
      var toRet = {
        isValid: true,
        wordFinal: word
      };
      return toRet;
    },
    isValidWordBlur: function isValidWordBlur(word) {
      var toRet = {
        isValid: true,
        wordFinal: word
      };
      if (word.length > 0) {
        if (!isOnlyLetters(word)) {
          toRet.isValid = false;
        }
        if (toRet.isValid) {
          var isLower = state.normalization && state.normalization.hasOwnProperty('lower') ? state.normalization.lower : false;
          if (!isLower) {
            var wordUpperCase = typeof word === 'string' ? word.toUpperCase() : word;
            toRet.wordFinal = wordUpperCase;
          } else {
            var wordLowerCase = typeof word === 'string' ? word.toLowerCase() : word;
            toRet.wordFinal = wordLowerCase;
          }
        }
      }
      return toRet;
    },
    isCanDelete: function isCanDelete(item, index) {
      return state.words.length > MIN_NUMBER_WORDS;
    },
    isVisibleMessageMinWords: function isVisibleMessageMinWords() {
      return state.words.length <= MIN_NUMBER_WORDS;
    }
  };
}));
function getWordsValidFn(words, propertyValue) {
  var wordsAdd = [];
  return words.filter(function (word) {
    var isValid = isValidStringByLength$1(word[propertyValue]) && wordsAdd.indexOf(word[propertyValue]) <= 0;
    if (isValid) wordsAdd.push(word[propertyValue]);
    return isValid;
  });
}
function createWords(words) {
  return words.map(function (word, idx) {
    return {
      value: word.word
    };
  });
}
function createBoard(board) {
  var wordsPosition = board.words_position.map(function (word, idx) {
    return {
      value: word.word,
      startX: word.startX,
      startY: word.startY,
      visibleLetters: word.visibleLetters,
      vertical: word.vertical
    };
  });
  return {
    columns: board.columns,
    rows: board.rows,
    random: board.random,
    letters: board.letters,
    wordsPosition: wordsPosition
  };
}
function _createSnapshot$T(data) {
  var _data$data = data.data,
    words = _data$data.words,
    board = _data$data.board;
  return _extends({}, data.data, importCommonValues$1(data), {
    words: createWords(words),
    board: createBoard(board)
  });
}
function createStore$17(data) {
  var store = CrosswordEditorStore.create(_createSnapshot$T(data));
  return store;
}

var CellModel = types$1.model('CellModel', {
  id: types$1.string,
  solution: types$1.string,
  value: types$1.string,
  isLocked: types$1.optional(types$1["boolean"], false),
  x: types$1.number,
  y: types$1.number
}).actions(function (state) {
  return {
    setValue: function setValue(value) {
      if (state.isLocked) return false;
      state.value = value === '_' ? '' : value;
    },
    setCurrentWord: function setCurrentWord() {
      var linkedWords = state.linkedWords;
      var parent = getParent(state, 2);
      parent.setCurrentWord(linkedWords.length === 1 ? linkedWords[0].id : '');
      parent.setWordSelected(state.linkedWords.map(function (_ref) {
        var id = _ref.id;
        return id;
      }));
    },
    finishEditing: function finishEditing() {
      var parent = getParent(state, 2);
      parent.setWordSelected();
    },
    reset: function reset() {
      if (!state.isLocked) state.value = '';
    }
  };
}).views(function (state) {
  return {
    get currentWord() {
      var _getParent = getParent(state, 2),
        currentWord = _getParent.currentWord,
        words = _getParent.words;
      return currentWord && words.find(function (_ref2) {
        var id = _ref2.id;
        return id === currentWord;
      });
    },
    get linkedWords() {
      var _getParent2 = getParent(state, 2),
        words = _getParent2.words;
      return words.filter(function (_ref3) {
        var cellRefs = _ref3.cellRefs;
        return cellRefs.includes(state.id);
      });
    },
    get parentWord() {
      return state.linkedWords.length === 1 ? state.linkedWords[0] : state.currentWord;
    },
    get parentWordIsSuccess() {
      return state.linkedWords.reduce(function (acc, next) {
        return next.isSuccess || acc;
      }, false);
    },
    get index() {
      return state.parentWord && getCellIndex(state.parentWord.cellRefs, state.id);
    },
    getNextSelection: function getNextSelection(findFunction) {
      if (!state.currentWord) return undefined;
      var cellRefs = state.currentWord.cellRefs;
      var index = state.index;
      var cellList = getParent(state);
      return findFunction(index, cellRefs, cellList);
    },
    get nextCell() {
      return state.getNextSelection(findNextCell);
    },
    get prevCell() {
      return state.getNextSelection(findPrevCell);
    },
    get wordIndexes() {
      return state.linkedWords.filter(function (_ref4) {
        var cellRefs = _ref4.cellRefs;
        return getCellIndex(cellRefs, state.id) === 0;
      });
    },
    get firstWordIndex() {
      return state.wordIndexes.length > 0 ? state.wordIndexes[0].index + 1 : '';
    },
    get secondWordIndex() {
      return state.wordIndexes.length > 1 ? state.wordIndexes[1].index + 1 : '';
    },
    get feedbackResult() {
      try {
        var parent = getParent(state, 2);
        var evaluationReady = parent.isEvaluated;
        var isSuccess = state.parentWordIsSuccess;
        return when()["case"](!evaluationReady, function () {
          return feedback$1.NOT_EVALUATED;
        })["case"](!isSuccess, function () {
          return feedback$1.WRONG;
        })["case"](isSuccess, function () {
          return feedback$1.RIGHT;
        }).resolve();
      } catch (e) {
        return feedback$1.NOT_EVALUATED;
      }
    },
    get isSuccess() {
      var _getParent3 = getParent(state, 2),
        normalization = _getParent3.normalization;
      var solution = state.solution,
        value = state.value;
      var normalize = function normalize(t) {
        return normalizeString(t, {
          accents: normalization.accents,
          lower: false
        });
      };
      return normalize(solution) === normalize(value);
    },
    get isEmpty() {
      return state.value.length === 0;
    },
    get isWordSelected() {
      var parent = getParent(state, 2);
      return state.linkedWords.reduce(function (acc, next) {
        return parent.wordSelected.includes(next.id) ? true : acc;
      }, false);
    }
  };
});
function findNextCell(index, cellRefs, cellList) {
  if (cellRefs.length - 1 === index) return undefined;
  var nextId = cellRefs[index + 1];
  return cellList.get(nextId).isLocked ? findNextCell(index + 1, cellRefs, cellList) : cellList.get(nextId);
}
function findPrevCell(index, cellRefs, cellList) {
  if (index === 0) return undefined;
  var nextId = cellRefs[index - 1];
  return cellList.get(nextId).isLocked ? findNextCell(index - 1, cellRefs, cellList) : cellList.get(nextId);
}
function getCellIndex(cellRefs, id) {
  return cellRefs.findIndex(function (i) {
    return i === id;
  });
}

var CellRefModel = types$1.string;
var CellRefModel$1 = types$1.snapshotProcessor(CellRefModel, {
  preProcessor: function preProcessor(sn) {
    return sn.id;
  }
});

var WordModel = types$1.model('WordModel', {
  id: types$1.optional(types$1.identifier, function () {
    return uuid();
  }),
  word: types$1.string,
  cellRefs: types$1.array(CellRefModel$1),
  visibleLetters: types$1.array(types$1.number),
  isVertical: true
}).views(function (state) {
  return {
    reset: function reset() {
      state.cells.forEach(function (cell) {
        return cell.reset();
      });
    },
    setResponse: function setResponse(response) {
      if (!isAlive(state) || !response) return false;
      var letters = response.split('');
      state.cellList.forEach(function (cell, idx) {
        return cell.setValue((letters === null || letters === void 0 ? void 0 : letters[idx]) || '');
      });
    }
  };
}).views(function (state) {
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get isEmpty() {
      return !state.cellList.find(function (_ref) {
        var isEmpty = _ref.isEmpty;
        return !isEmpty;
      });
    },
    get isSuccess() {
      return !state.cellList.find(function (_ref2) {
        var isSuccess = _ref2.isSuccess;
        return !isSuccess;
      });
    },
    get cellList() {
      var _getParent = getParent(state, 2),
        cells = _getParent.cells;
      return state.cellRefs.map(function (ref) {
        return cells.get(ref);
      });
    },
    get value() {
      return state.cellList.reduce(function (acc, next) {
        var newLetter = next.value.length === 0 ? '_' : next.value;
        return acc + newLetter;
      }, '');
    },
    get solution() {
      return getParent(state, 2).validation.value[state.index];
    },
    get isValid() {
      var _getParent2 = getParent(state, 2),
        normalization = _getParent2.normalization;
      var normalize = function normalize(str) {
        return normalizeString(str, normalization);
      };
      return normalize(state.value) === normalize(state.solution);
    }
  };
});

function createCells(responses) {
  return responses.reduce(function (acc, next) {
    return _extends({}, acc, getCells(next.cellRefs));
  }, {});
}
function getCells(cells) {
  return cells.reduce(function (acc, next) {
    var _extends2;
    return _extends({}, acc, (_extends2 = {}, _extends2[next.id] = next, _extends2));
  }, {});
}

function createWords$1(words) {
  return words.map(createWord);
}
function createWord(_ref) {
  var word = _ref.word,
    startX = _ref.startX,
    startY = _ref.startY,
    visibleLetters = _ref.visibleLetters,
    vertical = _ref.vertical;
  return {
    word: word,
    isVertical: vertical,
    cellRefs: getCells$1({
      word: word,
      startX: startX,
      startY: startY,
      visibleLetters: visibleLetters,
      vertical: vertical
    })
  };
}
function getCells$1(_ref2) {
  var word = _ref2.word,
    startX = _ref2.startX,
    startY = _ref2.startY,
    visibleLetters = _ref2.visibleLetters,
    vertical = _ref2.vertical;
  return Array.from(word).map(function (letter, idx) {
    var isLocked = visibleLetters === null || visibleLetters === void 0 ? void 0 : visibleLetters.includes(idx);
    var x = getXPosition({
      idx: idx,
      startX: startX,
      vertical: vertical
    });
    var y = getYPosition({
      idx: idx,
      startY: startY,
      vertical: vertical
    });
    var id = x + "_" + y;
    return {
      id: id,
      isLocked: isLocked,
      x: x,
      y: y,
      solution: letter,
      value: isLocked ? letter : ''
    };
  });
}
function getXPosition(_ref3) {
  var idx = _ref3.idx,
    startX = _ref3.startX,
    vertical = _ref3.vertical;
  if (idx === 0) return startX;
  return vertical ? startX : startX + idx;
}
function getYPosition(_ref4) {
  var idx = _ref4.idx,
    startY = _ref4.startY,
    vertical = _ref4.vertical;
  if (idx === 0) return startY;
  return vertical ? startY + idx : startY;
}

var withConfigureScorm$i = types$1.model({
  scormData: types$1.optional(ScormModel, {})
}).actions(function (state) {
  var getItem = function getItem(item) {
    return {
      id: item.word,
      userResponse: item.value,
      rightAnswer: item.word,
      result: item.isValid
    };
  };
  return {
    afterCreate: function afterCreate() {
      state.exerciseType = scormTypes.MATCHING;
      state.initScorm();
      onAction(state, function (_ref) {
        var name = _ref.name,
          path = _ref.path;
        if (name === 'reset' && path === '') state.initScorm();
        if (name === 'setValue') state.updateInteractives();
      }, true);
    },
    initScorm: function initScorm() {
      state.scormData.init(state, state.words.map(getItem));
    },
    updateInteractives: function updateInteractives() {
      state.words.forEach(function (item) {
        state.scormData.updateInteractive(getItem(item));
      });
    }
  };
});

var CrosswordQuestionStore = types$1.compose(QuestionBaseModel, withValidationModes, withShowSolutions, withConfigureScorm$i, withXAPITypeOther$1({
  xAPISolution: function xAPISolution(state) {
    return formatResponses(state.validation.value);
  }
}), types$1.model('CrosswordQuestion', {
  currentWord: types$1.maybe(types$1.string),
  cells: types$1.map(CellModel),
  words: types$1.optional(types$1.array(WordModel), []),
  wordSelected: types$1.optional(types$1.array(types$1.string), [])
}).actions(function (state) {
  return {
    setCurrentWord: function setCurrentWord(currentWord) {
      state.currentWord = currentWord;
    },
    setUserResponse: function setUserResponse(response) {
      if (!response) return false;
      state.words.push(response);
      state.removeDuplicates(response);
    },
    setWordSelected: function setWordSelected(indexList) {
      state.wordSelected = indexList;
    },
    clearWordSelected: function clearWordSelected() {
      state.wordSelected = [];
    },
    reset: function reset() {
      state.baseReset();
      state.cells.forEach(function (cell) {
        return cell.reset();
      });
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot$U(rawData);
      applySnapshot(state, data);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.string), response)) return false;
      state.words.forEach(function (word, idx) {
        return word.setResponse(response === null || response === void 0 ? void 0 : response[idx]);
      });
    }
  };
}).views(function (state) {
  return {
    get board() {
      return state.raw.data.board;
    },
    get foundWords() {
      return state.words.map(function (_ref) {
        var word = _ref.word;
        return word;
      });
    },
    get letters() {
      var letters = [];
      state.cells.forEach(function (cell) {
        return letters.push(cell);
      });
      return letters;
    },
    get boardSize() {
      var lastLetters = state.words.map(function (_ref2) {
        var cellList = _ref2.cellList;
        return last(cellList);
      });
      return lastLetters.reduce(function (acc, next) {
        return {
          w: Math.max(acc.w, next.x),
          h: Math.max(acc.h, next.y)
        };
      }, {
        w: 0,
        h: 0
      });
    },
    get normalization() {
      return state.raw.data.normalization;
    },
    getUserResponse: function getUserResponse() {
      var userResponse = state.words.map(function (_ref3) {
        var value = _ref3.value;
        return value;
      });
      return state.getRealUserResponse(userResponse);
    },
    get solution() {
      return state.validation;
    },
    get generationError() {
      return state.letters.length === 0;
    },
    get closestSolutionStats() {
      var initialValue = {
        hits: 0,
        failures: 0,
        notAnswered: 0
      };
      return state.words.reduce(function (acc, next) {
        var isEmpty = next.isEmpty,
          isSuccess = next.isSuccess;
        var result = when()["case"](isEmpty, function () {
          return {
            notAnswered: acc.notAnswered + 1
          };
        })["case"](isSuccess, function () {
          return {
            hits: acc.hits + 1
          };
        }).resolve(function () {
          return {
            failures: acc.failures + 1
          };
        });
        return _extends({}, acc, result);
      }, initialValue);
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$U(rawData);
    }
  };
}));
function _createSnapshot$U(data) {
  var _data$data = data.data,
    board = _data$data.board,
    validation = _data$data.validation;
  var words = createWords$1(board.words_position);
  var cells = createCells(words);
  var responsesLength = validation.valid_response.value.length;
  return _extends({}, data.data, importCommonValues(_extends({}, data)), {
    validation: withPenaltyPoints(responsesLength, validation),
    words: words,
    cells: cells
  });
}
function createStore$18(data) {
  return CrosswordQuestionStore.create(_createSnapshot$U(data));
}

var EditorButtonValidation = function EditorButtonValidation(_ref) {
  var text = _ref.text,
    onChangeText = _ref.onChangeText,
    titleBox = _ref.titleBox;
  var _useState = useState(hasData(text)),
    isChecked = _useState[0],
    setIsChecked = _useState[1];
  function onChangeToggle(isCheckedToogle) {
    setIsChecked(isCheckedToogle);
    onChangeText(isCheckedToogle ? translate('button_validation_default') : '');
  }
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "lemoid-button-validation",
    icon: /*#__PURE__*/React__default.createElement(SvgMenuAlt, {
      width: "24"
    }),
    titleBox: titleBox || translate('button_validation_title_box'),
    helpText: translate('button_validation_help'),
    classNameAdd: "lemo-editor-button-validation"
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement(EditorToggleTitleSubtitle$1, {
    title: translate('button_validation_title'),
    subtitle: translate('button_validation_subtitle'),
    isChecked: isChecked,
    onChange: onChangeToggle
  }), isChecked && /*#__PURE__*/React__default.createElement(EditorInputText$1, {
    value: text,
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      return onChangeText(value);
    },
    placeholder: translate('button_validation_alt')
  })));
};
EditorButtonValidation.propTypes = {
  text: propTypes.string,
  onChangeText: propTypes.func,
  titleBox: propTypes.string
};
EditorButtonValidation.defaultProps = {
  text: '',
  onChangeText: function onChangeText(text) {
    return console.log(text);
  }
};

var EditorTitleStore$2 = function EditorTitleStore(_ref) {
  var store = _ref.store,
    titleBox = _ref.titleBox;
  return /*#__PURE__*/React__default.createElement(EditorButtonValidation, {
    text: store.button,
    onChangeText: store.setButton,
    titleBox: titleBox
  });
};
EditorTitleStore$2.propTypes = {
  titleBox: EditorButtonValidation.propTypes.titleBox
};
var EditorButtonValidationStore = observer(EditorTitleStore$2);

var _excluded$B = ["store", "changed", "type"];
var StatementEditor = function StatementEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$B);
  var statementTexts = {
    title: translate('add_an_image_to_exercise'),
    subtitle: ''
  };
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setButton|setImage|clearImage|setSampleAnswer",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 1,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      hide: true
    }, _ref[EDITOR_COMPONENT_COMMON.BACKGROUND] = {
      hide: true
    }, _ref)
  }), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    titleBox: translate('image'),
    helpText: translate('config_background_help'),
    iconTitle: /*#__PURE__*/React__default.createElement(SvgPhotograph, {
      width: 20,
      height: 20
    }),
    configsAditional: [TYPES_CONFIG.CONFIG_BACKGROUND_IMAGE],
    listConfigsHide: [TYPES_CONFIG.CONFIG_VARIANT_STYLE],
    showSliderSizeThumbBackgrounImage: false,
    overwriteBackgroundTexts: statementTexts
  }), /*#__PURE__*/React__default.createElement(EditorSampleAnswerStore$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorButtonValidationStore, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: []
  }));
};
var StatementEditor$1 = observer(StatementEditor);

var _excluded$C = ["store", "changed", "type"];
var UploadFileEditor = function UploadFileEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$C);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setStimulus|setMaxFiles|setMinFiles|setSampleAnswer",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      hide: true
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 1,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref[EDITOR_COMPONENT_COMMON.BACKGROUND] = {
      hide: true
    }, _ref)
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorSampleAnswerStore$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: [TYPES_CONFIG.CONFIG_DIFFERENT_MAX_MIN_FILE_UPLOAD, TYPES_CONFIG.CONFIG_FILES_LIMIT, TYPES_CONFIG.CONFIG_FILE_SIZE_LIMIT, TYPES_CONFIG.CONFIG_TYPES_ALLOWED_ATTACHMENTS]
  }));
};
var UploadFileEditor$1 = observer(UploadFileEditor);

var EditorWordSearchSt = function EditorWordSearchSt(_ref) {
  var _store$board, _store$board2;
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(EditorWordSearch, {
    columns: (_store$board = store.board) === null || _store$board === void 0 ? void 0 : _store$board.columns,
    rows: (_store$board2 = store.board) === null || _store$board2 === void 0 ? void 0 : _store$board2.rows,
    onChange: function onChange(columns, rows) {
      return store.intentSetColumnsRows(columns, rows);
    },
    getInvalidWordsByLength: store.getInvalidWordsByLength
  });
};
EditorWordSearchSt.propTypes = {};
var EditorWordSearchSt$1 = observer(EditorWordSearchSt);

var EditorWordSearchPreviewSt = function EditorWordSearchPreviewSt(_ref) {
  var store = _ref.store,
    _ref$showSolutionPrev = _ref.showSolutionPreview,
    showSolutionPreview = _ref$showSolutionPrev === void 0 ? true : _ref$showSolutionPrev;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "word-search-preview",
    icon: /*#__PURE__*/React__default.createElement(SvgMenuAlt, {
      width: "24"
    }),
    titleBox: translate('word_search_preview_title_box'),
    helpText: translate('word_search_preview_help'),
    classNameAdd: 'lemo-editor-word-search-preview'
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-stack-layout-150"
  }, showSolutionPreview && /*#__PURE__*/React__default.createElement(SolutionPreview$1, {
    store: store,
    lang: config.lang,
    idx: 0,
    onSolutionChanged: function onSolutionChanged(idx, userResponse) {}
  }), /*#__PURE__*/React__default.createElement("div", {
    className: 'lemo-editor-word-search-preview__button'
  }, /*#__PURE__*/React__default.createElement(SimpleButton, {
    onClick: store.updateWordSearch,
    variant: variantsSimpleButton.primary,
    disabled: store.isLoadingWordSearch
  }, store.isLoadingWordSearch ? /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-word-search-preview__button-progress-icon"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-word-search-preview__button-progress-icon-spinner"
  })) : /*#__PURE__*/React__default.createElement(SvgRefresh, {
    className: "lemo-icon"
  }), translate(store.isLoadingWordSearch ? 'word_search_button_generate_is_loading' : 'word_search_button_generate'))))));
};
EditorWordSearchPreviewSt.propTypes = {};
var EditorWordSearchPreviewSt$1 = observer(EditorWordSearchPreviewSt);

var EditorSimpleListItem = function EditorSimpleListItem(_ref) {
  var item = _ref.item,
    _ref$wordsLimit = _ref.wordsLimit,
    wordsLimit = _ref$wordsLimit === void 0 ? undefined : _ref$wordsLimit,
    _ref$predicateTextCou = _ref.predicateTextCounter,
    predicateTextCounter = _ref$predicateTextCou === void 0 ? 'words_limit' : _ref$predicateTextCou,
    _ref$allowedLetters = _ref.allowedLetters,
    allowedLetters = _ref$allowedLetters === void 0 ? null : _ref$allowedLetters,
    _ref$isValidStringFn = _ref.isValidStringFn,
    isValidStringFn = _ref$isValidStringFn === void 0 ? null : _ref$isValidStringFn,
    _ref$isValidStringBlu = _ref.isValidStringBlurFn,
    isValidStringBlurFn = _ref$isValidStringBlu === void 0 ? null : _ref$isValidStringBlu,
    _ref$notifyChangeWhen = _ref.notifyChangeWhenBlur,
    notifyChangeWhenBlur = _ref$notifyChangeWhen === void 0 ? false : _ref$notifyChangeWhen,
    _ref$numberOption = _ref.numberOption,
    numberOption = _ref$numberOption === void 0 ? null : _ref$numberOption,
    _ref$textIsNotValidSt = _ref.textIsNotValidString,
    textIsNotValidString = _ref$textIsNotValidSt === void 0 ? null : _ref$textIsNotValidSt,
    _ref$textError = _ref.textError,
    textError = _ref$textError === void 0 ? null : _ref$textError,
    _ref$canDelete = _ref.canDelete,
    canDelete = _ref$canDelete === void 0 ? true : _ref$canDelete;
  var _useState = useState(item.value),
    localValue = _useState[0],
    setLocalValue = _useState[1];
  var _useState2 = useState(false),
    isError = _useState2[0],
    setIsError = _useState2[1];
  var _useState3 = useState(false),
    hasChange = _useState3[0],
    setHasChange = _useState3[1];
  useEffect(function () {
    if (item.value !== localValue) {
      if (item.value === '' && localValue !== '') {
        setHasChange(true);
      } else {
        setLocalValue(item.value);
      }
    }
  }, [item.value]);
  function _onBlur(value) {
    if (notifyChangeWhenBlur && ((item === null || item === void 0 ? void 0 : item.value) !== localValue || hasChange || localValue === '')) {
      if (isValidStringBlurFn) {
        var validResult = isValidStringBlurFn(value);
        var canContinue = validResult.isValid;
        if (canContinue) {
          setLocalValue(validResult.wordFinal);
          item.setValue(validResult.wordFinal);
        } else {
          item.setValue('');
          setIsError(true);
        }
      } else {
        if (isValidStringByLength(localValue)) {
          item.setValue(localValue);
        } else {
          item.setValue('');
          setIsError(true);
        }
      }
    }
    setHasChange(false);
  }
  function _onChange(value) {
    function notifyChangeOk(_value) {
      setIsError(false);
      setLocalValue(_value);
      if (!notifyChangeWhenBlur) {
        item.setValue(_value);
      }
    }
    if (isValidStringFn) {
      var validResult = isValidStringFn(value);
      var canContinue = validResult.isValid;
      if (canContinue) {
        notifyChangeOk(validResult.wordFinal);
      }
    } else {
      if (isValidString(value, allowedLetters)) {
        notifyChangeOk(value);
      } else {
        if (isValidString(value.toUpperCase(), allowedLetters)) {
          notifyChangeOk(value.toUpperCase());
        }
      }
    }
  }
  var isErrorFinal = isError || hasData(textError);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-simple-list-item"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-simple-list-item__input_remove"
  }, numberOption && /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-editor-simple-list-item__number"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-editor-simple-list-item__number-number"
  }, numberOption)), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-simple-list-item__input"
  }, /*#__PURE__*/React__default.createElement("input", {
    className: 'lemo-base-input' + (isErrorFinal ? ' lemo-error' : ''),
    placeholder: translate('Type something'),
    value: localValue,
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      _onChange(value);
    },
    onBlur: function onBlur(_ref3) {
      var value = _ref3.target.value;
      _onBlur(value);
    },
    type: "text",
    maxLength: wordsLimit
  }), wordsLimit !== undefined && wordsLimit > 0 && /*#__PURE__*/React__default.createElement("div", {
    className: 'lemo-editor-simple-list-item__text-counter' + (isError ? ' lemo-editor-simple-list-item__text-counter-error' : '')
  }, /*#__PURE__*/React__default.createElement(TextCounter, {
    limit: wordsLimit,
    count: localValue === null || localValue === void 0 ? void 0 : localValue.length,
    predicate: predicateTextCounter
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: classNames('lemo-editor-simple-list-item__remove', {
      'lemo-editor-simple-list-item__remove--disabled': !canDelete
    })
  }, /*#__PURE__*/React__default.createElement(SvgTrash$1, {
    className: 'lemo-icon',
    onClick: function onClick() {
      canDelete && item.destroy();
    }
  }))), isErrorFinal && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-simple-list-item__error"
  }, textError || textIsNotValidString)));
};
var EditorSimpleListItem$1 = observer(EditorSimpleListItem);

var EditorSimpleList = function EditorSimpleList(_ref) {
  var list = _ref.list,
    addNew = _ref.addNew,
    wordsLimit = _ref.wordsLimit,
    predicateTextCounter = _ref.predicateTextCounter,
    _ref$allowedLetters = _ref.allowedLetters,
    allowedLetters = _ref$allowedLetters === void 0 ? null : _ref$allowedLetters,
    _ref$isValidStringFn = _ref.isValidStringFn,
    isValidStringFn = _ref$isValidStringFn === void 0 ? null : _ref$isValidStringFn,
    _ref$isValidStringBlu = _ref.isValidStringBlurFn,
    isValidStringBlurFn = _ref$isValidStringBlu === void 0 ? null : _ref$isValidStringBlu,
    _ref$notifyChangeWhen = _ref.notifyChangeWhenBlur,
    notifyChangeWhenBlur = _ref$notifyChangeWhen === void 0 ? false : _ref$notifyChangeWhen,
    _ref$disabledAddNew = _ref.disabledAddNew,
    disabledAddNew = _ref$disabledAddNew === void 0 ? false : _ref$disabledAddNew,
    _ref$textIsNotValidSt = _ref.textIsNotValidString,
    textIsNotValidString = _ref$textIsNotValidSt === void 0 ? null : _ref$textIsNotValidSt,
    _ref$isCanDelete = _ref.isCanDelete,
    isCanDelete = _ref$isCanDelete === void 0 ? function (item, index) {
      return true;
    } : _ref$isCanDelete,
    _ref$componentRightAd = _ref.componentRightAdd,
    componentRightAdd = _ref$componentRightAd === void 0 ? null : _ref$componentRightAd;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-simple-list"
  }, list.map(function (item, idx) {
    return /*#__PURE__*/React__default.createElement(EditorSimpleListItem$1, {
      key: item.id,
      item: item,
      wordsLimit: wordsLimit,
      predicateTextCounter: predicateTextCounter,
      allowedLetters: allowedLetters,
      notifyChangeWhenBlur: notifyChangeWhenBlur,
      isValidStringFn: isValidStringFn,
      isValidStringBlurFn: isValidStringBlurFn,
      numberOption: idx + 1,
      textIsNotValidString: textIsNotValidString,
      textError: hasData(item.error) ? item.error : null,
      canDelete: isCanDelete(item, idx)
    });
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-horizontal-content lemo-editor-simple-list__footer",
    style: {
      marginLeft: 10
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-simple-list__footer-add"
  }, /*#__PURE__*/React__default.createElement(ButtonInline, {
    onClick: addNew,
    text: translate('add_new_response'),
    icon: /*#__PURE__*/React__default.createElement(SvgPlusCircle, {
      className: "lemo-icon lemo-editor-simple-list__icon-plus"
    }),
    disabled: disabledAddNew
  })), componentRightAdd && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-simple-list__footer-right",
    style: {
      marginLeft: 10
    }
  }, componentRightAdd)));
};
EditorSimpleList.propTypes = {};
EditorSimpleList.defaultProps = {};
var EditorSimpleList$1 = observer(EditorSimpleList);

var WordSearchSolutionLettersSt = function WordSearchSolutionLettersSt(_ref) {
  var _store$board;
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-word-serach-solution-letters"
  }, /*#__PURE__*/React__default.createElement(EditorSimpleList$1, {
    list: store.words,
    addNew: store.addEmptyWord,
    wordsLimit: (_store$board = store.board) === null || _store$board === void 0 ? void 0 : _store$board.columns,
    predicateTextCounter: 'word_search_counter_letter',
    allowedLetters: store.allowedLetters,
    notifyChangeWhenBlur: true,
    disabledAddNew: store.disabledAddNew,
    textIsNotValidString: translate('word_search_solutions_help'),
    isValidStringFn: store.isValidWord,
    isValidStringBlurFn: store.isValidWordBlur
  }));
};
WordSearchSolutionLettersSt.propTypes = {};
WordSearchSolutionLettersSt.defaultProps = {};
var WordSearchSolutionLettersSt$1 = observer(WordSearchSolutionLettersSt);

var _excluded$D = ["store", "changed", "type", "immediateFeedback"];
var WordSearchEditor = function WordSearchEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$D);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setLabel|sortAnswersOptions|addAnswerOption|setErrorString|setShuffleOptions|sortQuestionsOptions|addQuestionOption|removeQuestionOption|removeAnswerOption|setLineColor|setLineThickness|updateSolution|setImage|addHotspot|editHotspot|deleteHotspot|setIsEvaluable|setColumns|setRows|setColumnsRows|intentSetColumnsRows|setLetters|setBackward|setDiagonal|setAllowedLetters|addEmptyWord|removeValue|setValue|destroy",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.STIMULUS] = {
      order: 0
    }, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 4
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 5,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref[EDITOR_COMPONENT_COMMON.BACKGROUND] = {
      hide: true
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorWordSearchSt$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    showSolutions: false,
    helpText: translate('word_search_solutions_help'),
    evaluationTypes: [getEvaluationTypeOption(keysTranslateEvaluationTypes.EXACT_MATCH, keysTranslateSubtitleEvaluationTypes.EXACT_MATCH, validationModes.EXACT_MATCH), getEvaluationTypeOption(keysTranslateEvaluationTypes.PARTIAL_MATCH, keysTranslateSubtitleEvaluationTypes.PARTIAL_MATCH, validationModes.PARTIAL_MATCH_V2)],
    componentButton: /*#__PURE__*/React__default.createElement(WordSearchSolutionLettersSt$1, {
      store: store
    }),
    showPenalty: false
  }), /*#__PURE__*/React__default.createElement(EditorWordSearchPreviewSt$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: [TYPES_CONFIG.CONFIG_WORD_SEARCH_BACKWARD, TYPES_CONFIG.CONFIG_WORD_SEARCH_DIAGONAL, TYPES_CONFIG.CONFIG_WORD_SEARCH_ALLOWED_LETTERS]
  }));
};
var WordSearchEditor$1 = observer(WordSearchEditor);

var WordSearchUIStyles = types$1.compose(BaseModel$1, types$1.model({}).actions(function (state) {
  return {};
}));
var defaultWordSearchUIStyle$1 = _extends({}, defaultUIStyle);

var WordsModel$2 = types$1.compose(ValueModel, types$1.model({}).actions(function (state) {
  return {
    reset: function reset() {
      state.value = '';
    }
  };
}).views(function (state) {
  return {
    get parent() {
      return getRoot(state);
    }
  };
}));

var WORD_SEARCH_SHUFFLE_OPTIONS_DEFAULT = false;
var WordSearchEditorStore = types$1.compose(EditorBaseModel, types$1.model({
  isEvaluable: true,
  board: types$1.optional(WordSearchBoard$1, defaultBoard),
  shuffle_options: types$1.optional(types$1["boolean"], WORD_SEARCH_SHUFFLE_OPTIONS_DEFAULT),
  ui_style: types$1.optional(WordSearchUIStyles, defaultWordSearchUIStyle$1),
  words: types$1.optional(types$1.array(WordsModel$2), []),
  isLoadingWordSearch: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      onAction(state, function (_ref) {
        var name = _ref.name;
        if (name.match(/removeValue|setValue|destroy/)) {
          state.updateValidation();
          state.updateWordSearch();
        }
        if (name.match(/setAllowedLetters/)) {
          state.deleteInvalidWordsByAllowedLetters();
          state.updateValidation();
        }
      }, true);
    },
    intentSetColumnsRows: function intentSetColumnsRows(columns, rows) {
      var wordsValidValue = state.getWordsValidValueColunsRows(columns, rows);
      var generate = generateWordSearch(wordsValidValue, state.allowedLetters, columns, rows, state.board.diagonal, state.board.backward);
      if (generate) {
        state.board.setColumnsRows(columns, rows);
        state.deleteInvalidWordsByLength();
        state.updateValidation();
        state.updateWordSearchGenerate(generate);
      }
    },
    updateWordSearch: function updateWordSearch() {
      state.setIsLoadingWordSearch(true);
      setTimeout(function () {
        var generate = generateWordSearch(state.wordsValidValue, state.allowedLetters, state.board.columns, state.board.rows, state.board.diagonal, state.board.backward);
        state.updateWordSearchGenerate(generate);
        state.setIsLoadingWordSearch(false);
      }, 0);
    },
    updateWordSearchGenerate: function updateWordSearchGenerate(generate) {
      if (generate !== null && generate !== void 0 && generate.grid) {
        state.board.setLetters(generate.grid);
      }
      state.updateNotifier();
    },
    updateValidation: function updateValidation() {
      state.validation.setValue(state.wordsValidValue);
      state.updateNotifier();
    },
    setShuffleOptions: function setShuffleOptions(bool) {
      state.shuffle_options = bool;
      state.updateNotifier();
    },
    removeValue: function removeValue(item) {
      destroy(item);
      state.updateNotifier();
    },
    addEmptyWord: function addEmptyWord() {
      state.words.push({
        value: ''
      });
      state.updateNotifier();
    },
    deleteInvalidWordsByLength: function deleteInvalidWordsByLength() {
      var invalidWords = state.getInvalidWordsByLength(state.board.columns, state.board.rows);
      if (invalidWords) {
        state.deleteWords(invalidWords);
      }
    },
    deleteInvalidWordsByAllowedLetters: function deleteInvalidWordsByAllowedLetters() {
      var invalidWords = state.getInvalidWordsByAllowedLetters(state.board.allowed_letters);
      if (invalidWords && invalidWords.length > 0) {
        state.deleteWords(invalidWords);
        state.updateWordSearch();
      }
    },
    deleteWords: function deleteWords(wordsDelete) {
      for (var index = 0; index < wordsDelete.length; index++) {
        var wordDelete = wordsDelete[index];
        state.removeValue(wordDelete);
      }
    },
    isValidWord: function isValidWord(word) {
      var toRet = {
        isValid: true,
        wordFinal: word
      };
      return toRet;
    },
    isValidWordBlur: function isValidWordBlur(word) {
      var toRet = {
        isValid: true,
        wordFinal: word
      };
      if (state.wordsValidValue.indexOf(word) >= 0) {
        toRet = {
          isValid: false,
          wordFinal: ''
        };
        return toRet;
      }
      var allowedLetters = state.allowedLetters;
      if (isValidString(word, allowedLetters)) {
        toRet = {
          isValid: true,
          wordFinal: word
        };
      } else {
        if (isValidString(word.toUpperCase(), allowedLetters)) {
          toRet = {
            isValid: true,
            wordFinal: word.toUpperCase()
          };
        } else {
          var wordFiltered = clearString(word, allowedLetters);
          var wordFilteredUpperCase = clearString(word.toUpperCase(), allowedLetters);
          if (wordFilteredUpperCase.length > wordFiltered.length) {
            toRet = {
              isValid: true,
              wordFinal: wordFilteredUpperCase
            };
          } else {
            toRet = {
              isValid: true,
              wordFinal: wordFiltered
            };
          }
        }
      }
      return toRet;
    },
    setIsLoadingWordSearch: function setIsLoadingWordSearch(isLoading) {
      state.isLoadingWordSearch = isLoading;
    }
  };
}).views(function (state) {
  return {
    getUserResponse: function getUserResponse() {
      return '';
    },
    getResults: function getResults() {
      return {};
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$V(rawData);
    },
    get output() {
      return exportCommonValues(state, {
        board: getSnapshot(state.board),
        shuffle_options: state.shuffle_options
      });
    },
    get allowedLetters() {
      var _state$board;
      if (hasData((_state$board = state.board) === null || _state$board === void 0 ? void 0 : _state$board.allowed_letters)) {
        var _state$board2;
        return (_state$board2 = state.board) === null || _state$board2 === void 0 ? void 0 : _state$board2.allowed_letters;
      } else return getAllowedLettersGeneral();
    },
    get wordsValid() {
      var wordsAdd = [];
      return state.words.filter(function (word) {
        var isValid = isValidStringByLength(word.value) && wordsAdd.indexOf(word.value) <= 0;
        if (isValid) wordsAdd.push(word.value);
        return isValid;
      });
    },
    get wordsValidValue() {
      return state.wordsValid.map(function (res) {
        return res.value;
      });
    },
    getWordsValidValueColunsRows: function getWordsValidValueColunsRows(columns, rows) {
      var invalidWords = state.getInvalidWordsByLength(columns, rows);
      var wordsValidValue = state.wordsValidValue;
      var wordsValidValueFinal = [];
      if (wordsValidValue) {
        wordsValidValueFinal = wordsValidValue.filter(function (wordValidValue) {
          return !invalidWords.find(function (invalidWord) {
            return invalidWord.value === wordValidValue;
          });
        });
      }
      return wordsValidValueFinal;
    },
    getInvalidWordsByLength: function getInvalidWordsByLength(columns, rows) {
      var max = Math.max(columns, rows);
      var invalidWordsByLength = state.words.filter(function (word) {
        return word.value.length > max;
      });
      var wordsWhihoutInvalid = state.words.filter(function (word) {
        return !invalidWordsByLength.find(function (invalidWord) {
          return invalidWord.id === word.id;
        });
      });
      if (wordsWhihoutInvalid.length > state.getMaxNumberWords(columns, rows)) {
        var wordsOut = wordsWhihoutInvalid.slice(-1 * (wordsWhihoutInvalid.length - state.getMaxNumberWords(columns, rows)));
        if (wordsOut && wordsOut.length > 0) {
          invalidWordsByLength = invalidWordsByLength.concat(wordsOut);
        }
      }
      return invalidWordsByLength;
    },
    getInvalidWordsByAllowedLetters: function getInvalidWordsByAllowedLetters(allowedLetters) {
      return state.words.filter(function (word) {
        return !isValidString(word.value, allowedLetters);
      });
    },
    getMaxNumberWords: function getMaxNumberWords(columns, rows) {
      return Math.min(rows, columns) - 1;
    },
    get disabledAddNew() {
      return state.words.length + 1 > state.getMaxNumberWords(state.board.columns, state.board.rows);
    }
  };
}));
function createWords$2(validResponses) {
  return validResponses.map(function (validResponse, idx) {
    return {
      value: validResponse
    };
  });
}
function _createSnapshot$V(data) {
  var validation = data.data.validation;
  var validResponses = validation.valid_response.value;
  return _extends({}, data.data, importCommonValues$1(data), {
    words: createWords$2(validResponses)
  });
}
function createStore$19(data) {
  var store = WordSearchEditorStore.create(_createSnapshot$V(data));
  return store;
}

function Instructions(_ref) {
  var instructionList = _ref.instructionList;
  return /*#__PURE__*/React__default.createElement("ul", {
    className: "lemo-pathway-instructions"
  }, instructionList.map(function (_ref2, idx) {
    var id = _ref2.id,
      direction = _ref2.direction,
      steps = _ref2.steps;
    var itemId = id || "item" + idx;
    return /*#__PURE__*/React__default.createElement("li", {
      className: "lemo-instruction",
      key: itemId
    }, steps, " ", translate("direction_" + direction));
  }));
}
var Instructions$1 = observer(Instructions);

function Player(_ref) {
  var icon = _ref.icon,
    cellSize = _ref.cellSize,
    showAnimatedPlayer = _ref.showAnimatedPlayer,
    playerCoord = _ref.playerCoord,
    boardRef = _ref.boardRef;
  var _useState = useState(''),
    transformPosition = _useState[0],
    setTransformPosition = _useState[1];
  var counter = useRef();
  var paddings = useBoardPaddings(boardRef);
  function getPositionTransform(x, y) {
    return "translate(" + (x * cellSize + paddings[0]) + "px, " + (y * cellSize + paddings[1]) + "px)";
  }
  function resetPlayerPosition() {
    clearTimeout(counter.current);
    setTransformPosition(getPositionTransform(playerCoord[0], playerCoord[1]));
  }
  function startAnimation(idx) {
    if (idx === void 0) {
      idx = 1;
    }
    if (!showAnimatedPlayer) return resetPlayerPosition();
    if (idx === showAnimatedPlayer.length) return false;
    var _showAnimatedPlayer$i = showAnimatedPlayer[idx],
      x = _showAnimatedPlayer$i[0],
      y = _showAnimatedPlayer$i[1];
    setTransformPosition(getPositionTransform(x, y));
    if (!showAnimatedPlayer) startAnimation(idx + 1);
    counter.current = setTimeout(function () {
      startAnimation(idx + 1);
    }, 600);
  }
  useEffect(function () {
    showAnimatedPlayer === undefined ? resetPlayerPosition() : startAnimation();
  }, [showAnimatedPlayer, playerCoord]);
  useEffect(function () {
    resetPlayerPosition();
  }, [cellSize]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-pathway-player",
    style: {
      width: cellSize,
      height: cellSize,
      transform: transformPosition
    },
    "data-testid": "player"
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "lemo-pathway-player__img",
    src: icon,
    alt: ""
  }));
}
function useBoardPaddings(boardRef) {
  var boardStyles = boardRef.current ? window.getComputedStyle(boardRef.current) : {
    paddingLeft: 5,
    paddingTop: 5
  };
  return [parseInt(boardStyles.paddingLeft), parseInt(boardStyles.paddingTop)];
}
var Player$1 = observer(Player);

var WRAPPER_CLASS_NAME$8 = 'first-cell-direction';
function FirstCellDirection(_ref) {
  var direction = _ref.direction;
  var directionClassName = WRAPPER_CLASS_NAME$8 + "-" + direction.toLowerCase();
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1(WRAPPER_CLASS_NAME$8, directionClassName)
  }, /*#__PURE__*/React__default.createElement(SvgArrowSmRight, {
    className: "lemo-icon"
  }));
}

var showCellNumbers = false;
function Cell$4(_ref) {
  var cell = _ref.cell,
    cellSize = _ref.cellSize,
    userPathFeedback = _ref.userPathFeedback,
    disabled = _ref.disabled;
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "cell",
    "data-idx": cell.index,
    className: cn$1('lemo-pathway-cell', {
      'lemo-hide-buttons': cell.hideButtons,
      'lemo-is-action-button': cell.isActionButton,
      'lemo-cell-visited': cell.wasVisited,
      'lemo-is-back-button': cell.isBackButton,
      'lemo-player-position': cell.isPlayerPosition,
      'lemo-user-path-feedback': userPathFeedback,
      'lemo-preview-first-cell': cell.isPreviewFirstCell,
      'lemo-preview-last-cell': cell.isPreviewLastCell
    }),
    style: {
      width: cellSize,
      height: cellSize
    },
    onClick: function onClick() {
      return !disabled && cell.select();
    }
  }, showCellNumbers , cell.firstCellDirection && /*#__PURE__*/React__default.createElement(FirstCellDirection, {
    direction: cell.firstCellDirection
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-pathway-cell__bg"
  }));
}
var Cell$5 = observer(Cell$4);

var directionList = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  TOP: 'TOP',
  BOTTOM: 'BOTTOM'
};

function PreviewLastCell(_ref) {
  var cellSize = _ref.cellSize;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: cellSize,
    height: cellSize,
    viewBox: '0 0 90 90',
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "previewLastCell"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M5 9a4 4 0 0 1 4-4h12v16H5V9z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M5 21h16v16H5V21z",
    fill: "#000"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M5 37h16v16H5V37z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M5 53h16v16H5V53z",
    fill: "#000"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M5 69h16v16H9a4 4 0 0 1-4-4V69z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M21 5h16v16H21V5z",
    fill: "#000"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M21 21h16v16H21V21z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M21 37h16v16H21V37z",
    fill: "#000"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M21 53h16v16H21V53z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M21 69h16v16H21V69z",
    fill: "#000"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M37 5h16v16H37V5z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M37 21h16v16H37V21z",
    fill: "#000"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M37 37h16v16H37V37z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M37 53h16v16H37V53z",
    fill: "#000"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M37 69h16v16H37V69z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M53 5h16v16H53V5z",
    fill: "#000"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M53 21h16v16H53V21z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M53 37h16v16H53V37z",
    fill: "#000"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M53 53h16v16H53V53z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M53 69h16v16H53V69z",
    fill: "#000"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M69 5h12a4 4 0 0 1 4 4v12H69V5z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M69 21h16v16H69V21z",
    fill: "#000"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M69 37h16v16H69V37z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M69 53h16v16H69V53z",
    fill: "#000"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M69 69h16v12a4 4 0 0 1-4 4H69V69z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: "#fff",
    d: "M.5.5h89v89H.5z"
  }));
}

function Board$2(_ref) {
  var board = _ref.board,
    cellSize = _ref.cellSize,
    disabled = _ref.disabled;
  var previewModeClass = board.previewMode ? ' lemo-preview-mode' : '';
  function handleKey(e) {
    if (board.previewMode) return false;
    var direction = {
      ArrowLeft: directionList.LEFT,
      ArrowRight: directionList.RIGHT,
      ArrowUp: directionList.TOP,
      ArrowDown: directionList.BOTTOM
    }[e.key] || undefined;
    if (direction) {
      e.preventDefault();
      board.clickCell(direction);
    }
  }
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: 'lemo-pathway-board' + previewModeClass,
    style: board.styles
  }, !board.previewMode ? {
    tabIndex: 0
  } : {}, {
    onKeyDown: handleKey,
    "data-testid": "board"
  }), board.cellList.map(function (cell, idx) {
    var userPathFeedback = (board === null || board === void 0 ? void 0 : board.userPathFeedback) || [];
    var hasUserPathFeedback = userPathFeedback.includes(cell.index);
    return cell.isPreviewLastCell ? /*#__PURE__*/React__default.createElement(PreviewLastCell, {
      key: "cell_" + cell.index,
      cellSize: cellSize
    }) : /*#__PURE__*/React__default.createElement(Cell$5, {
      key: "cell_" + cell.index,
      cell: cell,
      cellSize: cellSize,
      disabled: disabled || board.previewMode,
      userPathFeedback: hasUserPathFeedback
    });
  }));
}
var Board$3 = observer(Board$2);

function PathwayBoard(_ref) {
  var store = _ref.store,
    solutionsMode = _ref.solutionsMode,
    cellSize = _ref.cellSize;
  var boardRef = useRef();
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-pathway-board-wrapper",
    ref: boardRef
  }, /*#__PURE__*/React__default.createElement(Player$1, {
    icon: store.icon,
    playerCoord: store.board.playerCoord,
    showAnimatedPlayer: store.board.showAnimatedPlayer,
    cellSize: cellSize,
    boardRef: boardRef
  }), /*#__PURE__*/React__default.createElement(Board$3, {
    board: store.board,
    cellSize: cellSize,
    disabled: !solutionsMode && store.disabled
  }));
}
var PathwayBoard$1 = observer(PathwayBoard);

var SMALL_VIEW$1 = 560;
var NORMAL_CELL_SIZE = 90;
function useCellSize(_ref) {
  var numColumns = _ref.numColumns,
    _ref$initialCellSize = _ref.initialCellSize,
    initialCellSize = _ref$initialCellSize === void 0 ? NORMAL_CELL_SIZE : _ref$initialCellSize,
    _ref$pathwayAutoSizeM = _ref.pathwayAutoSizeMediaQuery,
    pathwayAutoSizeMediaQuery = _ref$pathwayAutoSizeM === void 0 ? SMALL_VIEW$1 : _ref$pathwayAutoSizeM;
  var sizeRef = useRef(null);
  var _useState = useState(initialCellSize),
    cellSize = _useState[0],
    setCellSize = _useState[1];
  useResizeHandler2(sizeRef, function (_ref2) {
    var w = _ref2.w;
    setCellSize(w > pathwayAutoSizeMediaQuery ? initialCellSize : Math.floor(w / numColumns));
  });
  return {
    cellSize: cellSize,
    sizeRef: sizeRef
  };
}

function FloatingCell(_ref) {
  var children = _ref.children,
    cellSize = _ref.cellSize,
    playerCoord = _ref.playerCoord,
    boardRef = _ref.boardRef;
  var _useState = useState(''),
    transformPosition = _useState[0],
    setTransformPosition = _useState[1];
  var paddings = useBoardPaddings$1(boardRef);
  function getPositionTransform(x, y) {
    return "translate(" + (x * cellSize + paddings[0]) + "px, " + (y * cellSize + paddings[1]) + "px)";
  }
  function resetPlayerPosition() {
    setTransformPosition(getPositionTransform(playerCoord[0], playerCoord[1]));
  }
  useEffect(function () {
    resetPlayerPosition();
  }, [cellSize, playerCoord[0], playerCoord[1]]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-pathway-player",
    style: {
      width: cellSize,
      height: cellSize,
      transform: transformPosition
    },
    "data-testid": "floatingCell"
  }, children);
}
function useBoardPaddings$1(boardRef) {
  var boardStyles = boardRef.current ? window.getComputedStyle(boardRef.current) : {
    paddingLeft: 5,
    paddingTop: 5
  };
  return [parseInt(boardStyles.paddingLeft), parseInt(boardStyles.paddingTop)];
}
var FloatingCell$1 = observer(FloatingCell);

function SolutionsPathwayBoard(_ref) {
  var store = _ref.store,
    solutionsMode = _ref.solutionsMode,
    cellSize = _ref.cellSize;
  var boardRef = useRef();
  var showGoal = store.board.cellsVisited.length > 1;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-pathway-board-wrapper",
    ref: boardRef
  }, /*#__PURE__*/React__default.createElement(Player$1, {
    icon: store.icon,
    playerCoord: store.firstCellCoord,
    showAnimatedPlayer: store.board.showAnimatedPlayer,
    cellSize: cellSize,
    boardRef: boardRef
  }), showGoal && /*#__PURE__*/React__default.createElement(FloatingCell$1, {
    playerCoord: store.board.playerCoord,
    cellSize: cellSize,
    boardRef: boardRef
  }, /*#__PURE__*/React__default.createElement(PreviewLastCell, {
    cellSize: cellSize
  })), /*#__PURE__*/React__default.createElement(Board$3, {
    board: store.board,
    cellSize: cellSize,
    disabled: !solutionsMode && store.disabled
  }));
}
var SolutionsPathwayBoard$1 = observer(SolutionsPathwayBoard);

function RefreshButton(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React__default.createElement(SimpleButton, {
    className: "lemo-refresh-button",
    onClick: onClick,
    variant: "primary"
  }, /*#__PURE__*/React__default.createElement(SvgRefresh, null), " ", /*#__PURE__*/React__default.createElement("span", null, translate('generate_new')));
}

function PathwayQuestion(props) {
  var store = props.store,
    initialCellSize = props.initialCellSize,
    pathwayAutoSizeMediaQuery = props.pathwayAutoSizeMediaQuery,
    _props$solutionsMode = props.solutionsMode,
    solutionsMode = _props$solutionsMode === void 0 ? false : _props$solutionsMode;
  var _useCellSize = useCellSize({
      numColumns: store.columns,
      isReversePathway: true,
      initialCellSize: initialCellSize,
      pathwayAutoSizeMediaQuery: pathwayAutoSizeMediaQuery
    }),
    sizeRef = _useCellSize.sizeRef,
    cellSize = _useCellSize.cellSize;
  var changedHandlers = /reset|select|click|clickCell|randomizeSolution/;
  var layoutOrientation = getLayoutOrder(config.configExercise[types.other.PathWay].instructions_position, solutionsMode);
  var BoardComponent = solutionsMode ? SolutionsPathwayBoard$1 : PathwayBoard$1;
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: sizeRef
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', layoutOrientation, {
      'lemo-solutions-mode': solutionsMode,
      'lemo-disabled': !solutionsMode && store.disabled,
      'lemo-success': store.isSuccess,
      'lemo-error': store.isError
    })
  }, /*#__PURE__*/React__default.createElement(Instructions$1, {
    instructionList: solutionsMode ? store.solutionInstructions : store.instructions
  }), /*#__PURE__*/React__default.createElement(BoardComponent, {
    store: store,
    solutionsMode: solutionsMode,
    cellSize: cellSize
  })), solutionsMode && /*#__PURE__*/React__default.createElement(RefreshButton, {
    onClick: store.randomizeSolution
  }));
}
function getLayoutOrder(configPosition, solutionsMode) {
  var position = solutionsMode ? 'top' : configPosition.toLowerCase();
  return "lemo-layout-orientation-" + position;
}
var PathwayQuestion$1 = observer(PathwayQuestion);

function getCoordFromPosition(boardWidth, position) {
  var x = position % boardWidth;
  var y = Math.floor(position / boardWidth);
  return [x, y];
}

var CellModel$1 = types$1.model({
  index: types$1.number
}).actions(function (state) {
  return {
    select: function select(force) {
      if (force === void 0) {
        force = false;
      }
      if (!state.isActionButton && !force) return false;
      return state.isBackButton ? getParent(state, 2).goPreviousPosition() : getParent(state, 2).setNextPosition(state.index);
    }
  };
}).views(function (state) {
  var previewMode = function previewMode() {
    return getParent(state, 2).previewMode;
  };
  return {
    get coord() {
      var columns = getParent(state, 2).boardData.columns;
      return getCoordFromPosition(columns, state.index);
    },
    get isPreviewFirstCell() {
      if (!previewMode()) return false;
      return getParent(state, 2).firstSelectedCell === state.index;
    },
    get isPreviewLastCell() {
      if (!previewMode()) return false;
      return last(getParent(state, 2).cellsVisited) === this.index;
    },
    get wasVisited() {
      var cellsVisited = getParent(state, 2).cellsVisited.slice(0, -1);
      return cellsVisited.includes(this.index);
    },
    get isBackButton() {
      var parent = getParent(state, 2);
      if (previewMode()) return false;
      return parent.previousCell === this.index;
    },
    get isActionButton() {
      var _getParent = getParent(state, 3),
        isSolutionMode = _getParent.isSolutionMode;
      if (previewMode() && isSolutionMode) return false;
      if (state.wasVisited && !state.isBackButton) return false;
      return getParent(state, 2).actionButtons.includes(this.index);
    },
    get isPlayerPosition() {
      return last(getParent(state, 2).cellsVisited) === this.index;
    },
    get firstCellDirection() {
      return state.isPreviewFirstCell && getParent(state, 2).firstCellDirection;
    },
    get direction() {
      var board = getParent(state, 2);
      var visitedIndex = board.cellsVisited.findIndex(function (item) {
        return item === state.index;
      });
      if (visitedIndex < 1) return false;
      return getDirectionFromPreviousCell({
        columns: board.boardData.columns,
        currentCell: state.index,
        previousCell: board.cellsVisited[visitedIndex - 1]
      });
    },
    get hideButtons() {
      return !getParent(state, 2).cellButtonsVisible;
    }
  };
});
function getDirectionFromPreviousCell(_ref) {
  var columns = _ref.columns,
    currentCell = _ref.currentCell,
    previousCell = _ref.previousCell;
  var _getCoordFromPosition = getCoordFromPosition(columns, currentCell),
    x = _getCoordFromPosition[0],
    y = _getCoordFromPosition[1];
  var _getCoordFromPosition2 = getCoordFromPosition(columns, previousCell),
    xPrev = _getCoordFromPosition2[0],
    yPrev = _getCoordFromPosition2[1];
  if (xPrev === x) {
    return yPrev > y ? 'TOP' : 'BOTTOM';
  } else if (yPrev === y) {
    return xPrev > x ? 'LEFT' : 'RIGHT';
  }
  return false;
}

function getPositionFromCoord(boardWidth, _ref) {
  var x = _ref[0],
    y = _ref[1];
  return boardWidth * y + x;
}

var Board$4 = types$1.model({
  cellList: types$1.array(CellModel$1),
  cellsVisited: types$1.optional(types$1.array(types$1.number), []),
  previewMode: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    clickCell: function clickCell(cellDirection, force) {
      if (getParent(state).disabled) return false;
      var cellIndex = state.actionButtonReferences[cellDirection];
      var cellItem = state.cellList.find(function (_ref) {
        var index = _ref.index;
        return index === cellIndex;
      });
      cellItem === null || cellItem === void 0 ? void 0 : cellItem.select(force);
    },
    pushCell: function pushCell(cellId) {
      state.cellsVisited.push(cellId);
    },
    popCell: function popCell() {
      state.cellsVisited = state.cellsVisited.slice(0, -1);
    },
    setResponse: function setResponse(response) {
      var columns = state.boardData.columns;
      state.cellsVisited = response.map(function (coord) {
        return getPositionFromCoord(columns, coord);
      });
    },
    setNextPosition: function setNextPosition(playerPosition) {
      state.pushCell(playerPosition);
    },
    goPreviousPosition: function goPreviousPosition() {
      state.popCell();
    },
    setPreviewMode: function setPreviewMode(bool) {
      state.previewMode = bool;
    },
    reset: function reset(position) {
      var initialPosition = position === undefined ? state.cellsVisited[0] : position;
      state.cellsVisited = [initialPosition];
    }
  };
}).views(function (state) {
  return {
    get boardData() {
      return getParent(state, 1).raw.data.board;
    },
    get playerPosition() {
      return last(state.cellsVisited);
    },
    get playerCoord() {
      return state.previewMode ? state.boardData.pathway[0] : getCoordFromPosition(state.boardData.columns, state.playerPosition);
    },
    get isSolutionMode() {
      return getParent(state).isSolutionMode;
    },
    get actionButtonReferences() {
      var _state$boardData = state.boardData,
        columns = _state$boardData.columns,
        rows = _state$boardData.rows;
      var getPos = function getPos(x, y) {
        return getPositionFromCoord(columns, [x, y]);
      };
      var _state$playerCoord = state.playerCoord,
        x = _state$playerCoord[0],
        y = _state$playerCoord[1];
      return {
        TOP: y > 0 ? getPos(x, y - 1) : -1,
        BOTTOM: y < rows - 1 ? getPos(x, y + 1) : -1,
        LEFT: x > 0 ? getPos(x - 1, y) : -1,
        RIGHT: x < columns - 1 ? getPos(x + 1, y) : -1
      };
    },
    get actionButtons() {
      return Object.values(state.actionButtonReferences);
    },
    get background() {
      var _bgData$src;
      var _getParent = getParent(state),
        withBasePath = _getParent.withBasePath;
      var bgData = state.boardData.background;
      var hasBg = (bgData === null || bgData === void 0 ? void 0 : (_bgData$src = bgData.src) === null || _bgData$src === void 0 ? void 0 : _bgData$src.length) > 0;
      var withBackgroundSize = function withBackgroundSize() {
        return bgData.width && bgData.height ? {
          backgroundSize: bgData.width + "px " + bgData.height + "px"
        } : {};
      };
      var withBackgroundRepeat = function withBackgroundRepeat() {
        return _extends({
          backgroundRepeat: 'repeat'
        }, withBackgroundSize());
      };
      var getImageSrc = function getImageSrc() {
        return withBasePath(bgData.src);
      };
      var displayMode = bgData.mode === 'repeat' ? withBackgroundRepeat() : {
        backgroundSize: bgData.mode
      };
      return hasBg && _extends({}, displayMode, {
        backgroundImage: "url(" + getImageSrc() + ")"
      });
    },
    get styles() {
      return _extends({
        gridTemplateColumns: "repeat(" + state.boardData.columns + ", min-content)"
      }, state.background);
    },
    get previousCell() {
      return state.cellsVisited.length > 1 ? state.cellsVisited[state.cellsVisited.length - 2] : undefined;
    },
    get firstSelectedCell() {
      return state.cellsVisited[0];
    },
    get firstCellDirection() {
      var _getParent$validation;
      return ((_getParent$validation = getParent(state).validation.value[0]) === null || _getParent$validation === void 0 ? void 0 : _getParent$validation.direction) || undefined;
    },
    get cellButtonsVisible() {
      return true;
    }
  };
});

function createCellList(board) {
  var columns = board.columns,
    rows = board.rows;
  var length = columns * rows;
  return new Array(length).fill('').map(function (_, index) {
    return {
      index: index
    };
  });
}
function createBoard$1(board) {
  return createCellList(board);
}

function createInstructions(coords) {
  var instructions = [];
  for (var i = 0; i < coords.length - 1; i++) {
    var currentPos = coords[i];
    var nextPos = coords[i + 1];
    var direction = null;
    if (currentPos[0] < nextPos[0]) direction = directionList.RIGHT;else if (currentPos[0] > nextPos[0]) direction = directionList.LEFT;else if (currentPos[1] < nextPos[1]) direction = directionList.BOTTOM;else if (currentPos[1] > nextPos[1]) direction = directionList.TOP;
    var lastInstruction = instructions.length > 0 ? instructions[instructions.length - 1] : null;
    if ((lastInstruction === null || lastInstruction === void 0 ? void 0 : lastInstruction.direction) === direction) lastInstruction.steps++;else instructions.push({
      direction: direction,
      steps: 1
    });
  }
  return instructions;
}

function getRandomDirection(directions) {
  return directions[secureRandomInt(0, directions.length - 1)];
}
function getRandomSteps(maxSteps) {
  return secureRandomInt(1, maxSteps);
}
function isValidPosition(position, width, height, pathSet) {
  var x = position[0],
    y = position[1];
  var isWithinBounds = x >= 0 && x < width && y >= 0 && y < height;
  var doesNotCrossPath = !pathSet.has(x + "," + y);
  return isWithinBounds && doesNotCrossPath;
}
function getRandomPath(_ref) {
  var initPosition = _ref.initPosition,
    width = _ref.width,
    height = _ref.height,
    _ref$directionChanges = _ref.directionChanges,
    directionChanges = _ref$directionChanges === void 0 ? 3 : _ref$directionChanges;
  var path = [initPosition];
  var currentPosition = [].concat(initPosition);
  var directions = [[0, 1], [0, -1], [1, 0], [-1, 0]];
  var pathSet = new Set();
  pathSet.add(initPosition[0] + "," + initPosition[1]);
  for (var i = 0; i < directionChanges; i++) {
    var randomDirection = getRandomDirection(directions);
    var nextPosition = [].concat(currentPosition);
    var maxSteps = getRandomSteps(Math.min(width, height));
    var steps = 0;
    do {
      nextPosition = [nextPosition[0] + randomDirection[0], nextPosition[1] + randomDirection[1]];
      if (!isValidPosition(nextPosition, width, height, pathSet)) {
        if (steps === 0) {
          randomDirection = getRandomDirection(directions);
          nextPosition = [].concat(currentPosition);
          continue;
        }
        break;
      }
      steps++;
      currentPosition = [].concat(nextPosition);
      path.push([].concat(currentPosition));
      pathSet.add(currentPosition[0] + "," + currentPosition[1]);
    } while (steps < maxSteps);
  }
  return path;
}

var Instruction = types$1.model({
  id: types$1.optional(types$1.identifier, function () {
    return uuid();
  }),
  direction: types$1.enumeration('errorMessage', Object.values(directionList)),
  steps: types$1.number
});

var PathwayQuestionStore = types$1.compose(QuestionBaseModel, withValidationModes, withShowSolutions, withBasePathModel, withXAPITypeOther$1({
  interactionType: scormTypes.SEQUENCING
}), types$1.model({
  board: Board$4,
  instructions: types$1.array(Instruction)
}).actions(function (state) {
  return {
    setInstructions: function setInstructions(instructions) {
      state.instructions = instructions;
    },
    reset: function reset() {
      state.baseReset();
      state.board.reset();
    },
    randomizeSolution: function randomizeSolution() {
      state.setResponse(getRandomPath({
        initPosition: state.firstCellCoord,
        width: state.columns,
        height: state.rows,
        directionChanges: 3
      }));
    },
    clearPathwayWhenSizeChanges: function clearPathwayWhenSizeChanges(data) {
      if (state.columns !== data.board.columns || state.rows !== data.board.rows) {
        setTimeout(function () {
          state.board.reset();
        }, 100);
      }
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var startPoint = rawData.data.board.start_point;
      var data = _createSnapshot$W(rawData);
      state.clearPathwayWhenSizeChanges(data);
      state.raw = rawData;
      applySnapshot(state, data);
      if (startPoint !== undefined) {
        setTimeout(function () {
          var currentStartPoint = state.board.cellsVisited[0];
          var newStartPoint = getPositionFromCoord(state.columns, startPoint);
          currentStartPoint !== newStartPoint && state.board.reset(newStartPoint);
        }, 11);
      }
      return new Promise(function (resolve) {
        return setTimeout(resolve, 10);
      });
    },
    hydrateQuestionPreview: function hydrateQuestionPreview(rawData) {
      if (state.isSolutionsMode) return false;
      try {
        var data = _createSnapshot$W(rawData);
        var api = state.assetsQuestionApi;
        var apiDrive = state.assetsQuestionApiDrive;
        var validation = rawData.data.validation.valid_response.value;
        state.instructions = createInstructions(validation);
        applySnapshot(state, data);
        updateAssetsApi({
          api: api,
          apiDrive: apiDrive,
          state: state
        });
      } catch (e) {
        console.error(e);
      }
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.array(types$1.number)), response)) return false;
      state.board.setResponse(response);
    }
  };
}).views(function (state) {
  return {
    get icon() {
      return state.raw.data.board.icon;
    },
    get columns() {
      return state.raw.data.board.columns;
    },
    get rows() {
      return state.raw.data.board.rows;
    },
    getUserResponse: function getUserResponse() {
      var userResponse = state.board.cellsVisited.map(function (cellPosition) {
        return getCoordFromPosition(state.columns, cellPosition);
      });
      return state.getRealUserResponse(userResponse);
    },
    get solutionPositions() {
      return state.validation.value.map(function (cell) {
        return getPositionFromCoord(state.columns, cell);
      });
    },
    getResults: function getResults() {
      return state.board.cellsVisited.toString() === state.solutionPositions.toString() ? 1 : 0;
    },
    get isSuccess() {
      return when()["case"](state.isSolutionMode, function () {
        return false;
      })["case"](!state.isEvaluated, function () {
        return false;
      }).resolve(state.getResults() === 1);
    },
    get isError() {
      return when()["case"](state.isSolutionMode, function () {
        return false;
      })["case"](!state.isEvaluated, function () {
        return false;
      }).resolve(state.getResults() === 0);
    },
    get firstCellCoord() {
      return state.board.cellsVisited.length === 0 ? [0, 0] : getCoordFromPosition(state.columns, state.board.cellsVisited[0]);
    },
    get solutionInstructions() {
      return createInstructions(state.getUserResponse());
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$W(rawData);
    }
  };
}));
function updateAssetsApi(_ref) {
  var api = _ref.api,
    apiDrive = _ref.apiDrive,
    state = _ref.state;
  state.setAssetsQuestionApi(api);
  apiDrive && state.setAssetsQuestionApiDrive(apiDrive);
}
function _createSnapshot$W(data) {
  var _data$data = data.data,
    validation = _data$data.validation,
    board = _data$data.board;
  var validResponse = validation.valid_response.value;
  var initialPosition = validResponse[0];
  var cellsVisited = [getPositionFromCoord(board.columns, initialPosition)];
  var cellList = createBoard$1(board);
  return _extends({}, data.data, importCommonValues(data), {
    board: {
      cellList: cellList,
      cellsVisited: cellsVisited
    },
    instructions: createInstructions(validResponse)
  });
}
function createStore$1a(data) {
  return PathwayQuestionStore.create(_createSnapshot$W(data));
}

var s3Path = 'https://lemonade-assets.oneclick.es/pathway/';

var defaultBackgroundName = ['sand', 'grass', 'stone'];
var defaultBackgroundPath = [s3Path + 'bck1.png', s3Path + 'bck2.png', s3Path + 'bck3.png'];

var defaultCharacterName = ['farmer', 'pirate', 'worker'];
var defaultCharacterPath = [s3Path + 'farmer.png', s3Path + 'pirate.png', s3Path + 'worker.png'];

var SingleImageUploaderModel = types$1.compose(FileUploaderModel, types$1.model({
  uploadUpdate: types$1.optional(types$1.number, 0)
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      reaction(function () {
        return state.files.map(function (_ref) {
          var path = _ref.path;
          return path;
        }).join('');
      }, function () {
        if (state.files.length > 0) {
          state.send(false, true);
        }
      });
      reaction(function () {
        return state.files.reduce(function (acc, next) {
          return next.status === fileStatuses.COMPLETE ? acc + 1 : acc;
        }, 0);
      }, function () {
        state.notify();
      });
    },
    notify: function notify() {
      if (state.files.length > 0) {
        state.uploadUpdate += 1;
      }
    },
    clearAllFiles: function clearAllFiles() {
      state.files = [];
    },
    onAddFiles: function onAddFiles(acceptedFiles, isDrive) {
      if (isDrive === void 0) {
        isDrive = false;
      }
      if (state.files.length === state.maxFiles) {
        state.clearAllFiles();
      }
      return state.addFiles(acceptedFiles, isDrive);
    },
    onDropRejected: function onDropRejected(files) {
      var errorCode = files[0].errors[0].code;
      if (files.length === 0) return;
      state.setError(when()["case"](errorCode === 'file-invalid-type', errorList.INVALID_TYPE)["case"](errorCode === 'file-too-large', errorList.MAX_SIZE_EXCEEDED).resolve(errorList.UNKNOWN_ERROR));
    }
  };
}).views(function (state) {
  return {
    get assetsEditorApi() {
      return getParent(state, 2).assetsEditorApi;
    },
    get status() {
      var UPLOADING = fileStatuses.UPLOADING,
        ADDED = fileStatuses.ADDED,
        ERROR = fileStatuses.ERROR,
        START = fileStatuses.START;
      if (state.files.length === 0) return START;
      var currentStatus = state.files.map(function (f) {
        return f.status;
      });
      if (currentStatus.includes(ADDED)) return ADDED;
      if (currentStatus.includes(ERROR)) return ERROR;
      if (currentStatus.includes(UPLOADING)) return UPLOADING;
      return START;
    }
  };
}));

var BoardModel = types$1.model({
  size: types$1.number,
  customSize: XYModel,
  backgroundIndex: types$1.number,
  backgroundImg: types$1.maybe(types$1.string),
  backgroundUpload: SingleImageUploaderModel,
  characterIndex: types$1.number,
  characterImg: types$1.maybe(types$1.string),
  characterUpload: SingleImageUploaderModel,
  startPoint: XYModel
}).actions(function (state) {
  return {
    setSize: function setSize(size) {
      state.size = size;
      when()["case"](size === 0, function () {
        return state.setDefaultSize(4);
      })["case"](size === 1, function () {
        return state.setDefaultSize(5);
      })["case"](size === 2, function () {
        return state.setDefaultSize(6);
      }).resolve();
    },
    setDefaultSize: function setDefaultSize(value) {
      state.setXSize(value);
      state.setYSize(value);
      getParent(state).updateNotifier(true);
    },
    setXSize: function setXSize(size) {
      var newValue = parseFloat(size);
      if (typeof newValue === 'number') {
        state.customSize.setX(newValue);
        state.startPoint.setX(Math.min(newValue, state.startPoint.x));
        getParent(state).updateNotifier(true);
      }
    },
    setYSize: function setYSize(size) {
      var newValue = parseFloat(size);
      if (typeof newValue === 'number') {
        state.customSize.setY(newValue);
        state.startPoint.setY(Math.min(newValue, state.startPoint.y));
        getParent(state).updateNotifier(true);
      }
    },
    setBackgroundIndex: function setBackgroundIndex(value) {
      state.backgroundIndex = value;
      if (value < 3) {
        state.setBackgroundImg(defaultBackgroundPath[value]);
        state.backgroundUpload.clearAllFiles();
      }
    },
    setBackgroundImg: function setBackgroundImg(backgroundImg) {
      state.backgroundImg = backgroundImg;
      getParent(state).updateNotifier(true);
    },
    setCharacterIndex: function setCharacterIndex(value) {
      state.characterIndex = value;
      if (value < 3) state.setCharacterImg(defaultCharacterPath[value]);
    },
    setCharacterImg: function setCharacterImg(characterImg) {
      state.characterImg = characterImg;
      getParent(state).updateNotifier(true);
    },
    setStartX: function setStartX(coord) {
      var newValue = parseFloat(coord);
      if (typeof newValue === 'number') {
        state.startPoint.setX(newValue);
        getParent(state).updateNotifier(true);
      }
    },
    setStartY: function setStartY(coord) {
      var newValue = parseFloat(coord);
      if (typeof newValue === 'number') {
        state.startPoint.setY(newValue);
        getParent(state).updateNotifier(true);
      }
    }
  };
});
var BoardModel$1 = types$1.snapshotProcessor(BoardModel, {
  preProcessor: function preProcessor(snapshot) {
    var board = snapshot.board,
      validation = snapshot.validation;
    var solution = validation.valid_response.value;
    var rows = board.rows,
      columns = board.columns;
    var isFourGrid = rows === 4 && columns === 4;
    var isFiveGrid = rows === 5 && columns === 5;
    var isSixGrid = rows === 6 && columns === 6;
    var background = board.background.src;
    var character = board.icon;
    return {
      size: when()["case"](isFourGrid, function () {
        return 0;
      })["case"](isFiveGrid, function () {
        return 1;
      })["case"](isSixGrid, function () {
        return 2;
      }).resolve(function () {
        return 3;
      }),
      customSize: {
        x: board.rows,
        y: board.columns
      },
      backgroundImg: board.background.src,
      backgroundIndex: when()["case"](background === defaultBackgroundPath[0], function () {
        return 0;
      })["case"](background === defaultBackgroundPath[1], function () {
        return 1;
      })["case"](background === defaultBackgroundPath[2], function () {
        return 2;
      }).resolve(function () {
        return 3;
      }),
      backgroundUpload: {
        maxFiles: 1
      },
      characterImg: board.icon,
      characterIndex: when()["case"](character === defaultCharacterPath[0], function () {
        return 0;
      })["case"](character === defaultCharacterPath[1], function () {
        return 1;
      })["case"](character === defaultCharacterPath[2], function () {
        return 2;
      }).resolve(function () {
        return 3;
      }),
      characterUpload: {
        maxFiles: 1
      },
      startPoint: {
        x: solution[0][0] + 1,
        y: solution[0][1] + 1
      }
    };
  }
});

var PathwayEditorStore = types$1.compose(EditorBaseModel, types$1.model({
  board: BoardModel$1,
  ui_style: BaseModel$1
}).actions(function (state) {
  return {
    fn: function fn() {}
  };
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$X(rawData);
    },
    get output() {
      var startPoint = state.board.startPoint;
      return exportCommonValues(state, {
        board: _extends({}, state.raw.data.board, {
          columns: state.board.customSize.x,
          rows: state.board.customSize.y,
          icon: state.board.characterImg,
          start_point: [startPoint.x - 1, startPoint.y - 1],
          background: {
            mode: 'auto',
            width: undefined,
            height: undefined,
            alt: '',
            src: state.board.backgroundImg
          }
        })
      });
    }
  };
}));
function _createSnapshot$X(data) {
  return _extends({}, data.data, importCommonValues$1(data), {
    board: data.data
  });
}
function createStore$1b(data) {
  var store = PathwayEditorStore.create(_createSnapshot$X(data));
  return store;
}

var gridSizes = ['4x4', '5x5', '6x6'];

function GridSize(_ref) {
  var board = _ref.board;
  var customValue = translate('style_variant_custom');
  var defaultGridSize = [].concat(gridSizes, [customValue]);
  var minGrid = 3;
  var maxGrid = 8;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('editor_pathway_grid_size_title'),
    subtitle: translate('editor_pathway_grid_size_subtitle'),
    selectedIndex: board.size,
    onChange: board.setSize,
    itemList: defaultGridSize
  }), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: board.size === 3
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-columns lemo-columns-darker"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-column"
  }, /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: "lemo-extra-small-input",
    title: translate('editor_pathway_grid_width_title'),
    subtitle: translate('editor_pathway_grid_width_subtitle'),
    inputType: "number",
    value: board.customSize.x,
    min: minGrid,
    max: maxGrid,
    autoSize: true,
    onChange: board.setXSize
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-column"
  }, /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: "lemo-extra-small-input",
    title: translate('editor_pathway_grid_height_title'),
    subtitle: translate('editor_pathway_grid_height_subtitle'),
    inputType: "number",
    value: board.customSize.y,
    min: minGrid,
    max: maxGrid,
    autoSize: true,
    onChange: board.setYSize
  })))));
}
var GridSize$1 = observer(GridSize);

function SingleImageUploader(_ref) {
  var store = _ref.store,
    showDriveButton = _ref.showDriveButton,
    allowedFiles = _ref.allowedFiles,
    allowedFilesText = _ref.allowedFilesText,
    maxSize = _ref.maxSize,
    onUploadComplete = _ref.onUploadComplete;
  useEffect(function () {
    when()["case"](store.uploadUpdate === 0, function () {
      return false;
    })["case"](store.files.length === 0, function () {
      return onUploadComplete({
        path: ''
      });
    }).resolve(function () {
      return onUploadComplete(store.files[0]);
    });
  }, [store.uploadUpdate]);
  function removeFile() {
    store.clearAllFiles();
    onUploadComplete({
      path: ''
    });
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-single-image-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$1, {
    store: store,
    showDriveButton: showDriveButton,
    allowedFiles: allowedFiles,
    allowedFilesText: allowedFilesText,
    maxSize: maxSize
  }, function (file) {
    return /*#__PURE__*/React__default.createElement(CustomFileItem$1, {
      key: file.id,
      file: file,
      removeFile: removeFile
    });
  }));
}
var CustomFileItem$1 = observer(function (_ref2) {
  var file = _ref2.file,
    removeFile = _ref2.removeFile;
  return /*#__PURE__*/React__default.createElement(FileItem$1, {
    file: file
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-close-button",
    onClick: removeFile
  }, /*#__PURE__*/React__default.createElement(SvgXCircle, {
    className: "lemo-icon",
    width: 24
  })));
});
var SingleImageUploader$1 = observer(SingleImageUploader);

function BackgroundSelector(_ref) {
  var board = _ref.board;
  var customValue = translate('style_variant_custom');
  var defaultBackgroundData = [].concat(defaultBackgroundName.map(translate), [customValue]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('editor_pathway_change_image_title'),
    subtitle: translate('editor_pathway_change_image_subtitle'),
    selectedIndex: translate(board.backgroundIndex),
    onChange: board.setBackgroundIndex,
    itemList: defaultBackgroundData
  }), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: board.backgroundIndex === 3
  }, /*#__PURE__*/React__default.createElement(SingleImageUploader$1, {
    store: board.backgroundUpload,
    showDriveButton: config.isGooglePickerEnabled,
    allowedFiles: "image/jpeg,image/png,image/gif",
    allowedFilesText: translate('Allowed files: images (jpg, png, gif)'),
    maxSize: config.maxUploadFileSize,
    onUploadComplete: function onUploadComplete(file) {
      return board.setBackgroundImg(file.path);
    }
  })));
}
var BackgroundSelector$1 = observer(BackgroundSelector);

function CharacterSelector(_ref) {
  var board = _ref.board;
  var customValue = translate('style_variant_custom');
  var defaultCharacterData = [].concat(defaultCharacterName.map(translate), [customValue]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('editor_pathway_change_character_title'),
    subtitle: translate('editor_pathway_change_character_subtitle'),
    selectedIndex: translate(board.characterIndex),
    onChange: board.setCharacterIndex,
    itemList: defaultCharacterData
  }), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: board.characterIndex === 3
  }, /*#__PURE__*/React__default.createElement(SingleImageUploader$1, {
    store: board.characterUpload,
    showDriveButton: config.isGooglePickerEnabled,
    allowedFiles: "image/jpeg,image/png,image/gif",
    allowedFilesText: translate('Allowed files: images (jpg, png, gif)'),
    maxSize: config.maxUploadFileSize,
    onUploadComplete: function onUploadComplete(file) {
      return board.setCharacterImg(file.path);
    }
  })));
}
var CharacterSelector$1 = observer(CharacterSelector);

function CharacterSelector$2(_ref) {
  var board = _ref.board;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-columns"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-column"
  }, /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    title: translate('editor_pathway_coordinate_x_title'),
    subtitle: translate('editor_type_or_select_number'),
    inputType: "number",
    value: board.startPoint.x,
    min: 1,
    max: board.customSize.x,
    autoSize: true,
    onChange: board.setStartX
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-column"
  }, /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    title: translate('editor_pathway_coordinate_y_title'),
    subtitle: translate('editor_type_or_select_number'),
    inputType: "number",
    value: board.startPoint.y,
    min: 1,
    max: board.customSize.y,
    autoSize: true,
    onChange: board.setStartY
  })));
}
var StartingPoint = observer(CharacterSelector$2);

var idBox$7 = 'EditorGrid';
var titleBoxRef$6 = 'editor_pathway_grid_title';
var titleBoxHelpRef$6 = 'editor_pathway_grid_editor_help';
function EditorGrid(_ref) {
  var board = _ref.board;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: idBox$7,
    icon: /*#__PURE__*/React__default.createElement(SvgMenuAlt, {
      width: "24"
    }),
    titleBox: translate(titleBoxRef$6),
    helpText: translate(titleBoxHelpRef$6),
    classNameAdd: "lemo-editor-line-chart-table"
  }, /*#__PURE__*/React__default.createElement(GridSize$1, {
    board: board
  }), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(BackgroundSelector$1, {
    board: board
  }), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(CharacterSelector$1, {
    board: board
  }), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(StartingPoint, {
    board: board
  }));
}
var EditorGrid$1 = observer(EditorGrid);

var _excluded$E = ["store", "changed", "type", "immediateFeedback"];
function PathwayEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$E);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "adItem|addItemToResponse|sortItems|removeItem|removeItemToResponse|setSrc|setLabel|setTheme|setXAxisLabel|setXAxisName|setYAxisName|setYMax|setYMin|setYMultiplier|",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 1
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 2,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(EditorGrid$1, {
    board: store.board
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    showToggleIsEvaluable: false,
    hasMultipleResponses: false,
    helpText: translate('exact_math_or_match_response_or_match_group_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null));
}
var PathwayEditor$1 = observer(PathwayEditor);

function Cell$6(_ref) {
  var cell = _ref.cell,
    cellSize = _ref.cellSize,
    isLower = _ref.isLower,
    boardElement = _ref.boardElement,
    disabled = _ref.disabled;
  var element = useRef();
  var cellStyle = useMemo(function () {
    var _cell$x = cell.x,
      x = _cell$x === void 0 ? 0 : _cell$x,
      _cell$y = cell.y,
      y = _cell$y === void 0 ? 0 : _cell$y;
    return {
      left: x * cellSize,
      top: y * cellSize,
      width: cellSize,
      height: cellSize
    };
  }, [cell]);
  var isLowercase = useMemo(function () {
    return {
      textTransform: isLower ? 'lowercase' : 'uppercase'
    };
  }, [isLower]);
  function clearSelection() {
    var _element$current;
    (_element$current = element.current) === null || _element$current === void 0 ? void 0 : _element$current.blur();
    cell.finishEditing();
  }
  function nextSelection(nextLetterId) {
    if (!nextLetterId) return clearSelection();
    var nextElement = boardElement.current.querySelector("#cell_" + nextLetterId);
    if (nextElement === null) return false;
    nextElement.focus();
    setTimeout(function () {
      return nextElement.select();
    });
  }
  function selectNextLetter() {
    var _cell$nextCell;
    var nextLetterId = (_cell$nextCell = cell.nextCell) === null || _cell$nextCell === void 0 ? void 0 : _cell$nextCell.id;
    nextSelection(nextLetterId);
  }
  function selectPrevLetter() {
    var _cell$prevCell;
    var prevLetterId = (_cell$prevCell = cell.prevCell) === null || _cell$prevCell === void 0 ? void 0 : _cell$prevCell.id;
    nextSelection(prevLetterId);
  }
  function setValue(_ref2) {
    var target = _ref2.target;
    var isSign = isAccent(target.value);
    if (isOnlyLetters(target.value) || isSign) {
      cell.setValue(target.value);
      !isSign && selectNextLetter();
    }
  }
  function handleClick(e) {
    e.target.select();
    cell.setCurrentWord();
  }
  function handleDelete() {
    cell.setValue('');
    selectPrevLetter();
  }
  function handleKeyDown(e) {
    if (e.key === 'Escape') return e.target.blur();
    if (e.key === 'Delete' || e.key === 'Backspace') return handleDelete();
    if (e.shiftKey && e.key === 'Tab') {
      e.preventDefault();
      return selectPrevLetter();
    }
    if (e.key === 'Tab') {
      e.preventDefault();
      return selectNextLetter();
    }
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-cross-word-cell', {
      'lemo-is-word-selected': cell.isWordSelected,
      'lemo-success': cell.feedbackResult === feedback.RIGHT,
      'lemo-error': cell.feedbackResult === feedback.WRONG
    }),
    style: cellStyle
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-cross-word-cell__first-word-index"
  }, cell.firstWordIndex), /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-cross-word-cell__second-word-index"
  }, cell.secondWordIndex), /*#__PURE__*/React__default.createElement("input", {
    ref: element,
    id: "cell_" + cell.id,
    className: "lemo-cross-word-cell__text",
    value: cell.value,
    onInput: setValue,
    disabled: cell.isLocked || disabled,
    style: isLowercase,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    autoComplete: "off",
    maxLength: 1,
    tabIndex: -1
  }));
}
var Cell$7 = observer(Cell$6);

var cellSize$1 = 60;
function Board$5(_ref) {
  var size = _ref.size,
    letters = _ref.letters,
    isLower = _ref.isLower,
    clearWordSelected = _ref.clearWordSelected,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var boardElement = useRef();
  function isCellSelected() {
    return document.activeElement.classList.contains('lemo-cross-word-cell__text');
  }
  function handleCellSelection() {
    if (!isCellSelected()) clearWordSelected();
  }
  useEffect(function () {
    document.addEventListener('click', handleCellSelection, false);
    return function () {
      return document.removeEventListener('click', handleCellSelection);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    ref: boardElement,
    className: 'lemo-cross-word-board',
    style: {
      width: (size.w + 1) * cellSize$1,
      height: (size.h + 1) * cellSize$1
    }
  }, letters.map(function (letter) {
    return letter ? /*#__PURE__*/React__default.createElement(Cell$7, {
      key: letter.id,
      cell: letter,
      cellSize: cellSize$1,
      isLower: isLower,
      boardElement: boardElement,
      disabled: disabled
    }) : null;
  }));
}
var Board$6 = observer(Board$5);

function GenerationError() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-generation-error"
  }, /*#__PURE__*/React__default.createElement(SvgExclamationCircle, {
    className: "lemo-generation-error__icon",
    width: 51,
    height: 51
  }), /*#__PURE__*/React__default.createElement("p", {
    className: "lemo-generation-error__text"
  }, translate('generation_error')));
}

function CrosswordQuestion(props) {
  var store = props.store,
    _props$solutionsMode = props.solutionsMode,
    solutionsMode = _props$solutionsMode === void 0 ? false : _props$solutionsMode;
  var changedHandlers = /setTitle|select|clearWordSelected|finishEditing/;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', {
      'lemo-solutions-mode': solutionsMode
    })
  }, store.generationError ? /*#__PURE__*/React__default.createElement(GenerationError, null) : /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-cross-word-board-wrapper', {
      'lemo-disabled': solutionsMode || store.disabled
    })
  }, /*#__PURE__*/React__default.createElement(Board$6, {
    size: store.boardSize,
    letters: store.letters,
    disabled: solutionsMode || store.disabled,
    isLower: store.normalization.lower,
    clearWordSelected: store.clearWordSelected
  })))));
}
var CrosswordQuestion$1 = observer(CrosswordQuestion);

var _excluded$F = ["store"];
function PathwayControls(_ref) {
  var store = _ref.store,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$F);
  var showCancel = store.previousCell;
  return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
    showCancel: showCancel,
    onCancel: store.reset,
    store: store
  }, props));
}
var PathwayControls$1 = observer(PathwayControls);

var EditorCrosswordPreviewSt = function EditorCrosswordPreviewSt(_ref) {
  var store = _ref.store,
    _ref$showSolutionPrev = _ref.showSolutionPreview,
    showSolutionPreview = _ref$showSolutionPrev === void 0 ? true : _ref$showSolutionPrev;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "crossword-preview",
    icon: /*#__PURE__*/React__default.createElement(SvgMenuAlt, {
      width: "24"
    }),
    titleBox: translate('crossword_preview_title_box'),
    helpText: translate('crossword_preview_help'),
    classNameAdd: 'lemo-editor-crossword-preview'
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-stack-layout-150"
  }, showSolutionPreview && /*#__PURE__*/React__default.createElement(SolutionPreview$1, {
    store: store,
    lang: config.lang,
    idx: 0,
    onSolutionChanged: function onSolutionChanged(idx, userResponse) {}
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-crossword-preview__button"
  }, /*#__PURE__*/React__default.createElement(SimpleButton, {
    onClick: store.updateCrosswordBoard,
    variant: variantsSimpleButton.primary
  }, /*#__PURE__*/React__default.createElement(SvgRefresh, {
    className: "lemo-icon"
  }), translate('crossword_button_generate'))))));
};
EditorCrosswordPreviewSt.propTypes = {};
var EditorCrosswordPreviewSt$1 = observer(EditorCrosswordPreviewSt);

var CrosswordSolutionLettersSt = function CrosswordSolutionLettersSt(_ref) {
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-word-serach-solution-letters"
  }, /*#__PURE__*/React__default.createElement(EditorSimpleList$1, {
    list: store.words,
    addNew: store.addEmptyWord,
    wordsLimit: CROSSWORD_MAX_WORD_LENGTH,
    predicateTextCounter: 'crossword_counter_letter',
    notifyChangeWhenBlur: true,
    disabledAddNew: store.disabledAddNew,
    isValidStringFn: store.isValidWord,
    isValidStringBlurFn: store.isValidWordBlur,
    textIsNotValidString: translate('crossword_solutions_text_not_valid'),
    isCanDelete: store.isCanDelete,
    componentRightAdd: store.isVisibleMessageMinWords() && /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-word-serach-solution-letters__error_footer"
    }, translate('crossword_message_min_words').replaceAll('{{num_words}}', MIN_NUMBER_WORDS))
  }));
};
CrosswordSolutionLettersSt.propTypes = {};
CrosswordSolutionLettersSt.defaultProps = {};
var CrosswordSolutionLettersSt$1 = observer(CrosswordSolutionLettersSt);

var _excluded$G = ["store", "changed", "type", "immediateFeedback"];
var CrosswordEditor = function CrosswordEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$G);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setLabel|sortAnswersOptions|addAnswerOption|setErrorString|setShuffleOptions|sortQuestionsOptions|addQuestionOption|removeQuestionOption|removeAnswerOption|setLineColor|setLineThickness|updateSolution|setImage|addHotspot|editHotspot|deleteHotspot|setIsEvaluable|setColumns|setRows|setColumnsRows|setRandom|setLetters|setBackward|setDiagonal|addEmptyWord|removeValue|setValue|destroy|toggleLower|toggleAccents|updateCrosswordBoard",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.STIMULUS] = {
      order: 0
    }, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 4
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 5,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref[EDITOR_COMPONENT_COMMON.BACKGROUND] = {
      order: 7
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    showSolutions: false,
    helpText: translate('crossword_solutions_help'),
    evaluationTypes: [getEvaluationTypeOption(keysTranslateEvaluationTypes.EXACT_MATCH, keysTranslateSubtitleEvaluationTypes.EXACT_MATCH, validationModes.EXACT_MATCH), getEvaluationTypeOption(keysTranslateEvaluationTypes.PARTIAL_MATCH, keysTranslateSubtitleEvaluationTypes.PARTIAL_MATCH, validationModes.PARTIAL_MATCH_V2)],
    componentButton: /*#__PURE__*/React__default.createElement(CrosswordSolutionLettersSt$1, {
      store: store
    }),
    showPenalty: false
  }), /*#__PURE__*/React__default.createElement(EditorCrosswordPreviewSt$1, {
    store: store,
    showSolutionPreview: true
  }), ' ', /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(EditorConfigStoreDefault$1, {
    store: store,
    configsAditional: [TYPES_CONFIG.CONFIG_UPPERCASE_LOWERCASE, TYPES_CONFIG.CONFIG_ACCENT_SENSITIVE]
  })));
};
var CrosswordEditor$1 = observer(CrosswordEditor);

function DirectionButton(_ref) {
  var onClick = _ref.onClick,
    isDisabled = _ref.isDisabled,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React__default.createElement(KeyButton$1, {
    className: className,
    onClick: onClick,
    isDisabled: isDisabled
  }, /*#__PURE__*/React__default.createElement(SvgArrowSmRight, {
    className: "lemo-icon"
  }));
}
var DirectionButton$1 = observer(DirectionButton);

function DirectionControls(_ref) {
  var setDirection = _ref.setDirection,
    isDisabled = _ref.isDisabled;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-direction-controls"
  }, /*#__PURE__*/React__default.createElement(DirectionButton$1, {
    className: "lemo-direction-button-top",
    onClick: function onClick() {
      return setDirection(TOP);
    },
    isDisabled: isDisabled
  }), /*#__PURE__*/React__default.createElement(DirectionButton$1, {
    className: "lemo-direction-button-left",
    onClick: function onClick() {
      return setDirection(LEFT);
    },
    isDisabled: isDisabled
  }), /*#__PURE__*/React__default.createElement(DirectionButton$1, {
    className: "lemo-direction-button-bottom",
    onClick: function onClick() {
      return setDirection(BOTTOM);
    },
    isDisabled: isDisabled
  }), /*#__PURE__*/React__default.createElement(DirectionButton$1, {
    className: "lemo-direction-button-right",
    onClick: function onClick() {
      return setDirection(RIGHT$2);
    },
    isDisabled: isDisabled
  }));
}
var DirectionControls$1 = observer(DirectionControls);

function getTranslationTemplate(values, literal) {
  var tpl = literal;
  for (var key in values) tpl = tpl.replace(new RegExp('\\$' + key, 'gi'), values[key]);
  return tpl;
}

function ResponseCounter(_ref) {
  var remainingSteps = _ref.remainingSteps;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-response-counter lemo-text-body-s-regular lemo-color-text-04",
    "data-testid": "responseCounter"
  }, getTranslationTemplate({
    numSteps: remainingSteps
  }, translate('pathway_steps_counter')));
}
var ResponseCounter$1 = observer(ResponseCounter);

var WRAPPER_CLASS_NAME$9 = 'lemo-response';
function Response$1(_ref) {
  var onClose = _ref.onClose,
    response = _ref.response;
  var directionClassName = WRAPPER_CLASS_NAME$9 + "-" + response.direction.toLowerCase();
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1(WRAPPER_CLASS_NAME$9, directionClassName, {
      'lemo-selected': response.isSelected,
      'lemo-success': response.isSuccess,
      'lemo-error': response.isWrong
    })
  }, response.isSelected && /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-close-button",
    onClick: onClose
  }, /*#__PURE__*/React__default.createElement(SvgXCircle, {
    className: "lemo-icon"
  })), /*#__PURE__*/React__default.createElement(SvgArrowSmRight, {
    className: "lemo-icon"
  }));
}
var Response$2 = observer(Response$1);

function ResponseBox(_ref) {
  var store = _ref.store,
    solutionsMode = _ref.solutionsMode;
  var directions = solutionsMode ? store.solutionDirectionList : store.directionList;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-reverse-pathway-response",
    "data-testid": "responseBox"
  }, !solutionsMode && /*#__PURE__*/React__default.createElement(ResponseCounter$1, {
    remainingSteps: store.remainingSteps
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-response-list', {
      'lemo-error': store.isError,
      'lemo-success': store.isSuccess
    }),
    "data-testid": "responseList"
  }, directions.map(function (response, idx) {
    return /*#__PURE__*/React__default.createElement(Response$2, {
      key: response.id,
      onClose: store.removeLastResponse,
      response: response
    });
  })));
}
var ResponseBox$1 = observer(ResponseBox);

function SolutionsReversePathwayBoard(_ref) {
  var store = _ref.store,
    solutionsMode = _ref.solutionsMode,
    cellSize = _ref.cellSize;
  var boardRef = useRef();
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-pathway-board-wrapper",
    ref: boardRef
  }, /*#__PURE__*/React__default.createElement(FloatingCell$1, {
    playerCoord: store.board.playerCoord,
    cellSize: cellSize,
    boardRef: boardRef
  }, /*#__PURE__*/React__default.createElement(PreviewLastCell, {
    cellSize: cellSize
  })), /*#__PURE__*/React__default.createElement(FloatingCell$1, {
    playerCoord: store.board.playerCoord,
    cellSize: cellSize,
    boardRef: boardRef
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "lemo-pathway-player__img",
    src: store.icon,
    alt: ""
  })), /*#__PURE__*/React__default.createElement(Board$3, {
    board: store.board,
    cellSize: cellSize,
    disabled: !solutionsMode && store.disabled
  }));
}
var SolutionsReversePathwayBoard$1 = observer(SolutionsReversePathwayBoard);

function ReversePathwayQuestion(props) {
  var store = props.store,
    initialCellSize = props.initialCellSize,
    pathwayAutoSizeMediaQuery = props.pathwayAutoSizeMediaQuery,
    _props$solutionsMode = props.solutionsMode,
    solutionsMode = _props$solutionsMode === void 0 ? false : _props$solutionsMode;
  var _useCellSize = useCellSize({
      numColumns: store.columns,
      isReversePathway: true,
      initialCellSize: initialCellSize,
      pathwayAutoSizeMediaQuery: pathwayAutoSizeMediaQuery
    }),
    sizeRef = _useCellSize.sizeRef,
    cellSize = _useCellSize.cellSize;
  var changedHandlers = /reset|updateSteps|updateDirection|setDirection|removeLastResponse|clickCell|randomizeSolution|select/;
  var layoutOrientation = getLayoutOrder$1(store.ui_style.steps_position);
  var BoardComponent = solutionsMode ? SolutionsReversePathwayBoard$1 : PathwayBoard$1;
  useDefaultProp({
    setter: store.board.setPreviewMode,
    value: !solutionsMode
  });
  function setDirection(position) {
    store.setDirection(position);
    solutionsMode && store.board.clickCell(position);
  }
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: sizeRef
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', layoutOrientation, {
      'lemo-solutions-mode': solutionsMode,
      'lemo-disabled': !solutionsMode && store.disabled,
      'lemo-success': store.isSuccess,
      'lemo-error': store.isError
    })
  }, /*#__PURE__*/React__default.createElement(BoardComponent, {
    store: store,
    solutionsMode: solutionsMode,
    cellSize: cellSize
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-user-controls"
  }, /*#__PURE__*/React__default.createElement(DirectionControls$1, {
    setDirection: setDirection,
    isDisabled: store.areControlsDisabled && !solutionsMode
  }), /*#__PURE__*/React__default.createElement(ResponseBox$1, {
    store: store,
    solutionsMode: solutionsMode
  })), solutionsMode && /*#__PURE__*/React__default.createElement(RefreshButton, {
    onClick: store.randomizeSolution
  })));
}
function getLayoutOrder$1(configPosition) {
  if (configPosition === void 0) {
    configPosition = '';
  }
  return "lemo-layout-orientation-" + configPosition.toLowerCase();
}
var ReversePathwayQuestion$1 = observer(ReversePathwayQuestion);

var ResponseModel$9 = types$1.compose(getWithFeedbackResult(normalize$a), types$1.model({
  id: types$1.optional(types$1.identifier, function () {
    return uuid();
  }),
  direction: types$1.maybe(types$1.enumeration([TOP, LEFT, BOTTOM, RIGHT$2]))
}).actions(function (state) {
  return {
    setDirection: function setDirection(direction) {
      state.direction = direction;
    }
  };
}).views(function (state) {
  var parent = getParent(state, 2);
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get isSelected() {
      return getParent(state).length - 1 === state.index && !parent.isEvaluated;
    },
    get isValid() {
      var currentSolution = parent.linearDirections[state.index];
      return state.direction === currentSolution;
    }
  };
}));
function normalize$a(val) {
  return val;
}

var ReverseBoardModel = types$1.compose(Board$4, types$1.model({}).views(function (state) {
  var parent = getParent(state);
  return {
    get showAnimatedPlayer() {
      return state.previewMode && getParent(state).isEvaluated && !getParent(state).showSolution ? getParent(state).userResponseAsPathway : undefined;
    },
    get userPathFeedback() {
      var parent = getParent(state);
      return parent.isEvaluated ? parent.userPath.slice(1) : [];
    },
    get goalPosition() {
      return getCoordFromPosition(state.boardData.columns, last(state.cellsVisited));
    },
    get directionsFromCellsVisited() {
      return state.cellsVisited;
    },
    get playerCoord() {
      return parent.showSolution || parent.isSolutionMode ? state.goalPosition : state.boardData.pathway[0];
    },
    get cellButtonsVisible() {
      return false;
    }
  };
}));

function getGroupdDirections(directionList) {
  return directionList.reduce(function (acc, next, idx) {
    var previousValue = idx > 0 ? directionList[idx - 1] : undefined;
    return previousValue === next ? incLastDirection(acc) : createNewDirection(acc, next);
  }, []);
}
function createNewDirection(acc, direction) {
  return [].concat(acc, [{
    steps: 1,
    direction: direction
  }]);
}
function incLastDirection(acc) {
  var lastIndex = acc.length - 1;
  var head = acc.slice(0, lastIndex);
  var last = acc.slice(lastIndex)[0];
  last.steps = last.steps + 1;
  return [].concat(head, [last]);
}

function getLinearDirections(directionList) {
  return directionList.reduce(function (acc, next) {
    var nextValue = when()["case"](next.steps === 1, function () {
      return [next.direction];
    })["case"](next.steps > 1, function () {
      return populate(next.steps, function () {
        return next.direction;
      });
    }).resolve([]);
    return [].concat(acc, nextValue);
  }, []);
}

var ReversePathwayQuestionStore = types$1.compose(QuestionBaseModel, withValidationModes, withShowSolutions, withBasePathModel, withXAPITypeOther$1({
  interactionType: scormTypes.SEQUENCING
}), types$1.model({
  board: ReverseBoardModel,
  directionList: types$1.optional(types$1.array(ResponseModel$9), [])
}).actions(function (state) {
  return {
    setInstructions: function setInstructions(instructions) {
      state.instructions = instructions;
    },
    setDirection: function setDirection(direction) {
      if (state.remainingSteps > 0 || state.isSolutionMode) {
        state.directionList.push({
          direction: direction
        });
      }
    },
    removeLastResponse: function removeLastResponse() {
      state.directionList.pop();
    },
    reset: function reset() {
      state.baseReset();
      state.directionList = [];
    },
    randomizeSolution: function randomizeSolution() {
      state.board.setResponse(getRandomPath({
        initPosition: state.initPosition,
        width: state.columns,
        height: state.rows,
        directionChanges: 3
      }));
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot$Y(rawData);
      applySnapshot(state, data);
      state.raw = rawData;
      state.isSolutionMode = true;
      state.board.setPreviewMode(false);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    setResponse: function setResponse(response) {
      var responseModel = types$1.model({
        steps: types$1.number,
        direction: types$1.string
      });
      if (!typeChecker(types$1.array(responseModel), response)) return false;
      state.directionList = getLinearDirections(response).map(function (direction) {
        return {
          direction: direction
        };
      });
    }
  };
}).views(function (state) {
  return {
    get avoidAutoFeedback() {
      return true;
    },
    get icon() {
      return state.raw.data.board.icon;
    },
    get columns() {
      return state.raw.data.board.columns;
    },
    get rows() {
      return state.raw.data.board.rows;
    },
    get initPosition() {
      return state.raw.data.board.pathway[0];
    },
    get maxResponses() {
      return getLinearDirections(state.validation.value).length;
    },
    get remainingSteps() {
      return state.maxResponses - state.directionList.length;
    },
    getUserResponse: function getUserResponse() {
      var directionList = state.isSolutionMode ? state.solutionDirectionList : state.directionList;
      var directions = directionList.map(function (_ref) {
        var direction = _ref.direction;
        return direction;
      });
      var userResponse = getGroupdDirections(directions);
      return state.getRealUserResponse(userResponse);
    },
    get solutionDirectionList() {
      return state.board.cellsVisited.reduce(function (acc, next) {
        var cell = state.board.cellList[next];
        return cell.direction ? [].concat(acc, [{
          id: "cellId_" + next,
          direction: cell.direction
        }]) : acc;
      }, []);
    },
    getResults: function getResults() {
      var userResponse = state.getUserResponse();
      if (userResponse.length < state.validation.value.length) return 0;
      return state.validation.value.reduce(function (acc, next, idx) {
        var currentResponse = userResponse[idx];
        return next.steps === currentResponse.steps && next.direction === currentResponse.direction ? acc : 0;
      }, 1);
    },
    get linearDirections() {
      return getLinearDirections(state.validation.value);
    },
    get userResponseAsPathway() {
      var boardData = state.raw.data.board;
      var directions = state.directionList.map(function (_ref2) {
        var direction = _ref2.direction;
        return direction;
      });
      var firstCell = boardData.pathway[0];
      var maxY = boardData.rows - 1;
      var maxX = boardData.columns - 1;
      return directions.reduce(function (acc, next) {
        var newMovement = [];
        var _last = last(acc),
          currentX = _last[0],
          currentY = _last[1];
        if (next === TOP) {
          newMovement = [currentX, Math.max(0, currentY - 1)];
        }
        if (next === LEFT) {
          newMovement = [Math.max(0, currentX - 1), currentY];
        }
        if (next === BOTTOM) {
          newMovement = [currentX, Math.min(maxY, currentY + 1)];
        }
        if (next === RIGHT$2) {
          newMovement = [Math.min(maxX, currentX + 1), currentY];
        }
        return [].concat(acc, [newMovement]);
      }, [firstCell]);
    },
    get userPath() {
      return state.userResponseAsPathway.map(function (pos) {
        return getPositionFromCoord(state.board.boardData.columns, pos);
      });
    },
    get isSuccess() {
      return when()["case"](state.isSolutionMode, function () {
        return false;
      })["case"](!state.isEvaluated, function () {
        return false;
      }).resolve(state.getResults() === 1);
    },
    get isError() {
      return when()["case"](state.isSolutionMode, function () {
        return false;
      })["case"](!state.isEvaluated, function () {
        return false;
      }).resolve(state.getResults() === 0);
    },
    get areControlsDisabled() {
      return state.disabled || state.remainingSteps <= 0;
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$Y(rawData);
    }
  };
}));
function _createSnapshot$Y(data) {
  var board = data.data.board;
  var cellsVisited = board.pathway.map(function (coord) {
    return getPositionFromCoord(board.columns, coord);
  });
  var cellList = createBoard$1(board);
  return _extends({}, data.data, importCommonValues(data), {
    board: {
      cellList: cellList,
      cellsVisited: cellsVisited,
      previewMode: true
    },
    directionList: []
  });
}
function createStore$1c(data) {
  return ReversePathwayQuestionStore.create(_createSnapshot$Y(data));
}

var _excluded$H = ["store", "changed", "type", "immediateFeedback"];
function ReversePathwayEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$H);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "adItem|addItemToResponse|sortItems|removeItem|removeItemToResponse|setSrc|setLabel|setTheme|setXAxisLabel|setXAxisName|setYAxisName|setYMax|setYMin|setYMultiplier|",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 1
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 2,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(EditorGrid$1, {
    board: store.board
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    showToggleIsEvaluable: false,
    hasMultipleResponses: false,
    helpText: translate('exact_math_or_match_response_or_match_group_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null));
}
var ReversePathwayEditor$1 = observer(ReversePathwayEditor);

var s3Path$1 = 'https://lemonade-assets.oneclick.es/pathway/';

var defaultBackgroundPath$1 = [s3Path$1 + 'bck1.png', s3Path$1 + 'bck2.png', s3Path$1 + 'bck3.png'];

var defaultCharacterPath$1 = [s3Path$1 + 'farmer.png', s3Path$1 + 'pirate.png', s3Path$1 + 'worker.png'];

var BoardModel$2 = types$1.model({
  size: types$1.number,
  customSize: XYModel,
  backgroundIndex: types$1.number,
  backgroundImg: types$1.maybe(types$1.string),
  backgroundUpload: SingleImageUploaderModel,
  characterIndex: types$1.number,
  characterImg: types$1.maybe(types$1.string),
  characterUpload: SingleImageUploaderModel,
  startPoint: XYModel,
  pathway: types$1.optional(types$1.array(types$1.array(types$1.number)), [])
}).actions(function (state) {
  return {
    setSize: function setSize(size) {
      state.size = size;
      when()["case"](size === 0, function () {
        return state.setDefaultSize(4);
      })["case"](size === 1, function () {
        return state.setDefaultSize(5);
      })["case"](size === 2, function () {
        return state.setDefaultSize(6);
      }).resolve();
    },
    setDefaultSize: function setDefaultSize(value) {
      state.setXSize(value);
      state.setYSize(value);
      getParent(state).updateNotifier(true);
    },
    setXSize: function setXSize(size) {
      var newValue = parseFloat(size);
      if (typeof newValue === 'number') {
        state.customSize.setX(newValue);
        state.startPoint.setX(Math.min(newValue, state.startPoint.x));
        state.resetValidation();
      }
    },
    setYSize: function setYSize(size) {
      var newValue = parseFloat(size);
      if (typeof newValue === 'number') {
        state.customSize.setY(newValue);
        state.startPoint.setY(Math.min(newValue, state.startPoint.y));
        state.resetValidation();
      }
    },
    setBackgroundIndex: function setBackgroundIndex(value) {
      state.backgroundIndex = value;
      if (value < 3) {
        state.setBackgroundImg(defaultBackgroundPath$1[value]);
        state.backgroundUpload.clearAllFiles();
      }
    },
    setBackgroundImg: function setBackgroundImg(backgroundImg) {
      state.backgroundImg = backgroundImg;
      getParent(state).updateNotifier(true);
    },
    setCharacterIndex: function setCharacterIndex(value) {
      state.characterIndex = value;
      if (value < 3) state.setCharacterImg(defaultCharacterPath$1[value]);
    },
    setCharacterImg: function setCharacterImg(characterImg) {
      state.characterImg = characterImg;
      getParent(state).updateNotifier(true);
    },
    setStartX: function setStartX(coord) {
      var newValue = parseFloat(coord);
      if (typeof newValue === 'number') {
        state.startPoint.setX(newValue);
        state.resetValidation();
      }
    },
    setStartY: function setStartY(coord) {
      var newValue = parseFloat(coord);
      if (typeof newValue === 'number') {
        state.startPoint.setY(newValue);
        state.resetValidation();
      }
    },
    resetValidation: function resetValidation() {
      state.pathway = [[state.startPoint.x - 1, state.startPoint.y - 1]];
      getParent(state).validation.setValue([]);
      getParent(state).updateNotifier(true);
    },
    setPathway: function setPathway(pathway) {
      state.pathway = pathway;
    }
  };
});
var BoardModel$3 = types$1.snapshotProcessor(BoardModel$2, {
  preProcessor: function preProcessor(snapshot) {
    var board = snapshot.board;
    var rows = board.rows,
      columns = board.columns;
    var isFourGrid = rows === 4 && columns === 4;
    var isFiveGrid = rows === 5 && columns === 5;
    var isSixGrid = rows === 6 && columns === 6;
    var background = board.background.src;
    var character = board.icon;
    return {
      size: when()["case"](isFourGrid, function () {
        return 0;
      })["case"](isFiveGrid, function () {
        return 1;
      })["case"](isSixGrid, function () {
        return 2;
      }).resolve(function () {
        return 3;
      }),
      customSize: {
        x: board.rows,
        y: board.columns
      },
      backgroundImg: board.background.src,
      backgroundIndex: when()["case"](background === defaultBackgroundPath$1[0], function () {
        return 0;
      })["case"](background === defaultBackgroundPath$1[1], function () {
        return 1;
      })["case"](background === defaultBackgroundPath$1[2], function () {
        return 2;
      }).resolve(function () {
        return 3;
      }),
      backgroundUpload: {
        maxFiles: 1
      },
      characterImg: board.icon,
      characterIndex: when()["case"](character === defaultCharacterPath$1[0], function () {
        return 0;
      })["case"](character === defaultCharacterPath$1[1], function () {
        return 1;
      })["case"](character === defaultCharacterPath$1[2], function () {
        return 2;
      }).resolve(function () {
        return 3;
      }),
      characterUpload: {
        maxFiles: 1
      },
      startPoint: {
        x: board.pathway[0][0] + 1,
        y: board.pathway[0][1] + 1
      },
      pathway: board.pathway
    };
  }
});

function getPathway(_ref) {
  var solution = _ref.solution,
    startPoint = _ref.startPoint;
  var directions = getLinearDirections(solution);
  var pathway = [startPoint];
  directions.forEach(function (direction) {
    var currentPos = last(pathway);
    pathway.push(getNewPosition({
      currentPos: currentPos,
      direction: direction
    }));
  });
  return pathway;
}
function getNewPosition(_ref2) {
  var currentPos = _ref2.currentPos,
    direction = _ref2.direction;
  if (direction === BOTTOM) {
    return [currentPos[0], currentPos[1] + 1];
  }
  if (direction === TOP) {
    return [currentPos[0], currentPos[1] - 1];
  }
  if (direction === LEFT) {
    return [currentPos[0] - 1, currentPos[1]];
  }
  if (direction === RIGHT$2) {
    return [currentPos[0] + 1, currentPos[1]];
  }
}

var ReversePathwayEditorStore = types$1.compose(EditorBaseModel, types$1.model({
  board: BoardModel$3,
  ui_style: BaseModel$1
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      onAction(state, function (_ref) {
        var name = _ref.name,
          args = _ref.args;
        if (name === 'updateSolution') {
          var solution = args[1];
          var startPoint = [state.board.startPoint.x - 1, state.board.startPoint.y - 1];
          state.board.setPathway(getPathway({
            solution: solution,
            startPoint: startPoint
          }));
        }
      });
    }
  };
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$Z(rawData);
    },
    get output() {
      var board = state.board;
      var startPoint = [board.startPoint.x - 1, board.startPoint.y - 1];
      return exportCommonValues(state, {
        board: _extends({}, state.raw.data.board, {
          columns: board.customSize.x,
          rows: board.customSize.y,
          icon: board.characterImg,
          start_point: startPoint,
          background: {
            mode: 'auto',
            width: undefined,
            height: undefined,
            alt: '',
            src: board.backgroundImg
          },
          pathway: getSnapshot(board.pathway)
        })
      });
    }
  };
}));
function _createSnapshot$Z(data) {
  return _extends({}, data.data, importCommonValues$1(data), {
    board: data.data
  });
}
function createStore$1d(data) {
  var store = ReversePathwayEditorStore.create(_createSnapshot$Z(data));
  return store;
}

var RatingUIStyles = types$1.compose(BaseModel$1, types$1.model({}).actions(function (state) {
  return {};
}));

var RatingEditorStore = types$1.compose(EditorBaseModel, types$1.model({
  isEvaluable: false,
  ui_style: types$1.optional(RatingUIStyles, defaultUIStyle)
}).actions(function (state) {
  return {};
}).views(function (state) {
  return {
    getUserResponse: function getUserResponse() {
      return '';
    },
    getResults: function getResults() {
      return {};
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$_(rawData);
    },
    get output() {
      return exportCommonValues(state, {});
    }
  };
}));
function _createSnapshot$_(data) {
  return _extends({}, data.data, importCommonValues$1(data));
}
function createStore$1e(data) {
  var store = RatingEditorStore.create(_createSnapshot$_(data));
  return store;
}

var _excluded$I = ["store", "changed", "type"];
var RatingEditor = function RatingEditor(props) {
  var store = props.store,
    changed = props.changed,
    type = props.type,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$I);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setTitle|setStimulus|afterCreate",
    onlyComponentsView: ['TITLE', 'STIMULUS']
  }));
};
var RatingEditor$1 = observer(RatingEditor);

var RatingOptionModel = types$1.compose(ValueModel, types$1.model({
  label: types$1.string,
  label_tooltip: types$1.optional(types$1.string, ''),
  description: types$1.optional(types$1.string, ''),
  selected: false
}).actions(function (state) {
  return {
    setLabel: function setLabel(val) {
      state.label = val;
    },
    setLabelTooltip: function setLabelTooltip(val) {
      state.label_tooltip = val;
    },
    setDescription: function setDescription(val) {
      state.description = val;
    },
    reset: function reset() {
      state.selected = false;
    },
    setSelected: function setSelected(selected) {
      state.selected = selected;
    }
  };
}).views(function (state) {
  return {
    get isSelected() {
      var userResponse = getParent(state, 2).getUserResponse();
      return state.selected || userResponse.includes(state.value);
    },
    get index() {
      return getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get parent() {
      try {
        return getParent(state, 2);
      } catch (e) {
        return undefined;
      }
    }
  };
}));

var withConfigureScorm$j = types$1.compose(withScorm, types$1.model({}).views(function (state) {
  var getItem = function getItem() {
    return {
      userResponse: state.getUserResponse(),
      id: state.raw.reference,
      rightAnswer: '*',
      result: 1
    };
  };
  return {
    get scormType() {
      return scormTypes.LIKERT;
    },
    getInteractiveListInitScorm: function getInteractiveListInitScorm() {
      return [getItem()];
    },
    updateScormItem: function updateScormItem(name, path) {
      if (path.match(/\/options/) && name === 'setSelected') {
        return getItem();
      } else return null;
    }
  };
}));

var RatingQuestionStore = types$1.compose(QuestionBaseModel, withSampleAnswer, withEditableExercise, withConfigureScorm$j, withXAPINoEvaluable$1({
  interactionType: scormTypes.LIKERT
}), types$1.model({
  options: types$1.array(RatingOptionModel),
  cumulative_mode: types$1.optional(types$1["boolean"], true)
}).actions(function (state) {
  return {
    setResponse: function setResponse(value) {
      if (state.cumulative_mode) {
        var selectedIndex = state.options.findIndex(function (option) {
          return option.value === value;
        });
        if (selectedIndex !== -1) {
          state.options.forEach(function (option, index) {
            option.setSelected(index <= selectedIndex);
          });
        }
      } else {
        state.options.forEach(function (option) {
          option.setSelected(option.value === value);
        });
      }
      state.updateNotifier();
    },
    reset: function reset() {
      state.baseReset();
      state.options.forEach(function (option) {
        return option.reset();
      });
      state.updateNotifier();
    },
    send: function send() {
      state.setDisabled(true);
      state.setCacheOriginalResponse(state.getUserResponse());
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview() {
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$$(rawData);
    },
    getUserResponse: function getUserResponse() {
      var selectedOptions = state.options.filter(function (option) {
        return option.selected;
      });
      if (selectedOptions.length === 0) return '';
      if (state.cumulative_mode) {
        var maxIndex = Math.max.apply(Math, selectedOptions.map(function (option) {
          return state.options.indexOf(option);
        }));
        return state.options[maxIndex].value;
      } else {
        return selectedOptions[0].value;
      }
    },
    getSelectedOption: function getSelectedOption() {
      if (state.cumulative_mode) {
        var selectedOptions = state.options.filter(function (option) {
          return option.selected;
        });
        if (selectedOptions.length === 0) return null;
        var maxValue = Math.max.apply(Math, selectedOptions.map(function (option) {
          return parseInt(option.value);
        }));
        return state.options.find(function (option) {
          return parseInt(option.value) === maxValue;
        });
      } else {
        return state.options.find(function (option) {
          return option.selected;
        });
      }
    }
  };
}));
var createOptions$2 = function createOptions(arr) {
  return arr.map(function (item) {
    return _extends({}, item, {
      value: item.value.toString(),
      label_tooltip: item.label_tooltip || '',
      description: item.description || '',
      selected: false
    });
  });
};
function _createSnapshot$$(data) {
  var _data$data = data.data,
    options = _data$data.options,
    _data$data$cumulative = _data$data.cumulative_mode,
    cumulative_mode = _data$data$cumulative === void 0 ? true : _data$data$cumulative;
  return _extends({}, data.data, importCommonValues$1(data), {
    options: createOptions$2(options),
    cumulative_mode: cumulative_mode
  });
}
function createStore$1f(data) {
  return RatingQuestionStore.create(_createSnapshot$$(data));
}

function RatingQuestion(props) {
  var store = props.store;
  var changedHandlers = /setTitle|setStimulus|setResponse|setValue/;
  var isDisabled = store.disabled;
  var handleOptionClick = useCallback(function (value) {
    if (!isDisabled) store.setResponse(value);
  }, [store]);
  var renderContent = function renderContent(option) {
    if (option.label === 'icon_star' || option.label === '⭐') {
      return /*#__PURE__*/React__default.createElement("span", {
        className: "lemo-rating-option-button__content lemo-rating-option-button__content-icon"
      }, /*#__PURE__*/React__default.createElement(Star, {
        width: 64,
        height: 64
      }));
    } else {
      return /*#__PURE__*/React__default.createElement("span", {
        className: "lemo-rating-option-button__content lemo-rating-option-button__content-text"
      }, option.label);
    }
  };
  var selectedOption = store.getSelectedOption();
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classNames('lemo-question-body', {
      'lemo-disabled': isDisabled
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-rating-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-rating-options-container"
  }, store.options.map(function (option, index) {
    var isTextButton = option.label !== 'icon_star' && option.label !== '⭐';
    return /*#__PURE__*/React__default.createElement("button", {
      key: option.value,
      className: classNames('lemo-rating-option-button', {
        'lemo-rating-option-button--selected': option.selected,
        'lemo-rating-option-button--unselected': !option.selected,
        'lemo-text-button': isTextButton
      }),
      onClick: function onClick() {
        return handleOptionClick(option.value);
      },
      title: option.label_tooltip || option.value,
      type: "button"
    }, renderContent(option));
  })), selectedOption && selectedOption.description && selectedOption.description.trim() !== '' && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-rating-description-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-rating-description"
  }, selectedOption.description)))));
}
var RatingQuestion$1 = observer(RatingQuestion);

var _excluded$J = ["store"];
var RatingControls = function RatingControls(_ref) {
  var store = _ref.store,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$J);
  return /*#__PURE__*/React__default.createElement(SendControls$1, _extends({
    store: store
  }, props, {
    showCancel: false,
    renderScore: null
  }));
};
var RatingControls$1 = observer(RatingControls);

function AdaptativeChoiceQuestion(props) {
  var store = props.store;
  var handleOptionClick = function handleOptionClick(option) {
    store.setSingleResponse(option.value);
  };
  var handleBackClick = function handleBackClick() {
    if (store.currentLevel > 0) {
      store.goToLevel(store.currentLevel - 1);
    }
  };
  var handleNextClick = function handleNextClick() {
    if (store.currentLevel < store.levels.length - 1) {
      store.goToLevel(store.currentLevel + 1);
    }
  };
  var currentLevelData = store.getCurrentLevelData();
  var currentOptions = store.getCurrentLevelOptions();
  var selectedValues = store.getSelectedValuesArray();
  var isDisabled = store.disabled;
  var canGoBack = store.currentLevel > 0;
  var canGoNext = store.currentLevel < store.levels.length - 1;
  var hasSelections = store.getSelectedValuesArray().length > 0;
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: /setTitle|setStimulus|setResponse|setValue|setLevelTitle/
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', {
      'lemo-disabled': isDisabled
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-adaptative-choice__container"
  }, currentLevelData && currentLevelData.title && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-header"
  }, /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    content: currentLevelData.title,
    className: "lemo-stimulus lemo-text-body-l-regular lemo-color-text-01"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-adaptative-choice__options-container"
  }, currentOptions && currentOptions.length > 0 ? /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-adaptative-choice__grid"
  }, currentOptions.map(function (option) {
    return /*#__PURE__*/React__default.createElement("button", {
      key: option.value,
      className: "lemo-adaptative-choice__option " + (option.selected ? 'lemo-adaptative-choice__option--selected' : ''),
      onClick: function onClick() {
        return handleOptionClick(option);
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-adaptative-choice__option-content"
    }, option.src && option.src.trim() !== '' && /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-adaptative-choice-option-icon"
    }, !/\.(jpg|jpeg|png|gif|svg|webp|bmp)$/i.test(option.src) && !option.src.startsWith('http') ? /*#__PURE__*/React__default.createElement("span", {
      className: "lemo-adaptative-choice-option-emoji"
    }, option.src) :
    /*#__PURE__*/
    React__default.createElement("img", {
      src: store.withBasePath(option.src),
      alt: option.label || 'Option icon',
      width: 48,
      height: 48
    })), option.label && option.label.trim() !== '' && /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-adaptative-choice-option-text"
    }, option.label)));
  })) : /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-adaptative-choice__no-options"
  }, /*#__PURE__*/React__default.createElement("p", null, "No hay opciones disponibles para este nivel."))), (canGoBack || canGoNext && isDisabled) && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-adaptative-choice__navigation"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-adaptative-choice__navigation-left"
  }, canGoBack && /*#__PURE__*/React__default.createElement(InlineButton, {
    onClick: handleBackClick
  }, translate('other_adaptative_choice_back'))), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-adaptative-choice__navigation-right"
  }, canGoNext && isDisabled && /*#__PURE__*/React__default.createElement(InlineButton, {
    onClick: handleNextClick
  }, translate('other_adaptative_choice_next')))))));
}
var AdaptativeChoiceQuestion$1 = observer(AdaptativeChoiceQuestion);

var _excluded$K = ["store"];
var AdaptativeChoiceControls = function AdaptativeChoiceControls(_ref) {
  var store = _ref.store,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$K);
  return /*#__PURE__*/React__default.createElement(SendControls$1, _extends({
    store: store
  }, props, {
    showCancel: false,
    renderScore: null
  }));
};
var AdaptativeChoiceControls$1 = observer(AdaptativeChoiceControls);

var withConfigureScorm$k = types$1.compose(withScorm, types$1.model({}).views(function (state) {
  var getItem = function getItem() {
    return {
      userResponse: state.getUserResponse(),
      id: state.raw.reference,
      rightAnswer: '*',
      result: 1
    };
  };
  return {
    get scormType() {
      return scormTypes.LIKERT;
    },
    getInteractiveListInitScorm: function getInteractiveListInitScorm() {
      return [getItem()];
    },
    updateScormItem: function updateScormItem(name, path) {
      if (path.match(/\/levels/) && (name === 'setSelected' || name === 'setResponse')) {
        return getItem();
      } else return null;
    }
  };
}));

var LevelOptionModel = types$1.model('LevelOptionModel', {
  label: types$1.optional(types$1.string, ''),
  value: types$1.string,
  src: types$1.optional(types$1.string, ''),
  selected: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    setSelected: function setSelected(value) {
      state.selected = value;
    },
    reset: function reset() {
      state.selected = false;
    }
  };
});

var LevelModel = types$1.model('LevelModel', {
  id: types$1.string,
  title: types$1.string,
  options: types$1.optional(types$1.array(LevelOptionModel), []),
  dependencies: types$1.optional(types$1.map(types$1.array(LevelOptionModel)), {})
}).views(function (state) {
  return {
    getAvailableOptions: function getAvailableOptions(parentSelection) {
      if (state.options.length > 0) {
        return state.options;
      }
      if (state.dependencies && parentSelection) {
        return state.dependencies.get(parentSelection) || [];
      }
      return [];
    }
  };
});

var AdaptativeChoiceQuestionStore = types$1.compose(QuestionBaseModel, withBasePathModel, withSampleAnswer, withConfigureScorm$k, withXAPINoEvaluable$1({
  interactionType: scormTypes.LIKERT
}), types$1.model({
  levels: types$1.optional(types$1.array(LevelModel), []),
  currentLevel: types$1.optional(types$1.number, 0),
  selectedValues: types$1.optional(types$1.array(types$1.string), [])
}).actions(function (state) {
  return {
    setResponse: function setResponse(value) {
      if (!Array.isArray(value)) {
        console.warn('setResponse: value debe ser un array, recibido:', typeof value, value);
        return;
      }
      this.setPreviousResponse(value);
    },
    setSingleResponse: function setSingleResponse(value) {
      var currentLevelData = state.levels[state.currentLevel];
      if (!currentLevelData) return;
      var availableOptions = currentLevelData.getAvailableOptions(state.selectedValues[state.currentLevel - 1]);
      availableOptions.forEach(function (option) {
        option.setSelected(false);
      });
      var selectedOption = availableOptions.find(function (option) {
        return option.value === value;
      });
      if (selectedOption) {
        selectedOption.setSelected(true);
      }
      if (state.selectedValues.length <= state.currentLevel) {
        state.selectedValues.push(value);
      } else {
        var currentSelection = state.selectedValues[state.currentLevel];
        if (currentSelection !== value) {
          state.selectedValues.splice(state.currentLevel + 1);
        }
        state.selectedValues[state.currentLevel] = value;
      }
      for (var i = state.currentLevel + 1; i < state.levels.length; i++) {
        var levelData = state.levels[i];
        if (levelData.options.length > 0) {
          levelData.options.forEach(function (option) {
            return option.setSelected(false);
          });
        } else if (levelData.dependencies) {
          levelData.dependencies.forEach(function (options) {
            if (Array.isArray(options)) {
              options.forEach(function (option) {
                return option.setSelected(false);
              });
            }
          });
        }
      }
      if (state.currentLevel < state.levels.length - 1) {
        var nextLevelIndex = state.currentLevel + 1;
        var nextLevelData = state.levels[nextLevelIndex];
        if (nextLevelData) {
          var nextLevelOptions = nextLevelData.getAvailableOptions(value);
          if (nextLevelOptions && nextLevelOptions.length > 0) {
            state.currentLevel++;
          }
        }
      }
      state.updateNotifier();
    },
    setPreviousResponse: function setPreviousResponse(responses) {
      if (!Array.isArray(responses)) {
        console.warn('setPreviousResponse: responses debe ser un array');
        return;
      }
      state.levels.forEach(function (level) {
        if (level.options.length > 0) {
          level.options.forEach(function (option) {
            return option.setSelected(false);
          });
        }
        if (level.dependencies) {
          level.dependencies.forEach(function (options) {
            if (Array.isArray(options)) {
              options.forEach(function (option) {
                return option.setSelected(false);
              });
            }
          });
        }
      });
      state.selectedValues.clear();
      var maxLevelIndex = 0;
      responses.forEach(function (response, index) {
        var _loop = function _loop(levelIndex) {
          var levelData = state.levels[levelIndex];
          if (levelIndex === 0) {
            var availableOptions = levelData.options;
            var foundOption = availableOptions.find(function (option) {
              return option.value === response;
            });
            if (foundOption) {
              maxLevelIndex = Math.max(maxLevelIndex, levelIndex);
              return 1;
            }
          } else {
            if (levelData.dependencies) {
              levelData.dependencies.forEach(function (options, parentValue) {
                var foundOption = options.find(function (option) {
                  return option.value === response;
                });
                if (foundOption) {
                  maxLevelIndex = Math.max(maxLevelIndex, levelIndex);
                }
              });
            }
          }
        };
        for (var levelIndex = 0; levelIndex < state.levels.length; levelIndex++) {
          if (_loop(levelIndex)) break;
        }
      });
      responses.forEach(function (response, index) {
        if (index < state.levels.length) {
          var levelData = state.levels[index];
          if (!levelData) return;
          var parentSelection = index > 0 ? responses[index - 1] : null;
          var availableOptions = levelData.getAvailableOptions(parentSelection);
          var selectedOption = availableOptions.find(function (option) {
            return option.value === response;
          });
          if (selectedOption) {
            selectedOption.setSelected(true);
          }
          state.selectedValues.push(response);
        }
      });
      state.currentLevel = maxLevelIndex;
      state.updateNotifier();
    },
    goToLevel: function goToLevel(levelIndex) {
      if (levelIndex >= 0 && levelIndex < state.levels.length) {
        state.currentLevel = levelIndex;
        state.updateNotifier();
      }
    },
    reset: function reset() {
      state.baseReset();
      state.currentLevel = 0;
      state.selectedValues.clear();
      state.levels.forEach(function (level) {
        if (level.options.length > 0) {
          level.options.forEach(function (option) {
            return option.reset();
          });
        }
        if (level.dependencies) {
          level.dependencies.forEach(function (options) {
            if (Array.isArray(options)) {
              options.forEach(function (option) {
                return option.reset();
              });
            }
          });
        }
      });
      state.updateNotifier();
    },
    send: function send() {
      state.setDisabled(true);
    },
    edit: function edit() {
      var _state$onEdit;
      state.setDisabled(false);
      state === null || state === void 0 ? void 0 : (_state$onEdit = state.onEdit) === null || _state$onEdit === void 0 ? void 0 : _state$onEdit.call(state);
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview() {
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    setCommonParams: function setCommonParams(params) {
      state.setCommonParamsFn(params);
    }
  };
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$10(rawData);
    },
    getUserResponse: function getUserResponse() {
      var userResponse = state.selectedValues ? state.selectedValues.slice() : [];
      var result = state.getRealUserResponse(userResponse);
      return result;
    },
    getSelectedValuesArray: function getSelectedValuesArray() {
      return state.selectedValues ? state.selectedValues.slice() : [];
    },
    getUserResponseArray: function getUserResponseArray() {
      return state.selectedValues ? state.selectedValues.slice() : [];
    },
    getCurrentLevelData: function getCurrentLevelData() {
      return state.levels[state.currentLevel];
    },
    getCurrentLevelOptions: function getCurrentLevelOptions() {
      var currentLevelData = state.getCurrentLevelData();
      if (!currentLevelData) return [];
      var availableOptions = currentLevelData.getAvailableOptions(state.selectedValues[state.currentLevel - 1]);
      var currentSelection = state.selectedValues[state.currentLevel];
      if (currentSelection !== undefined) {
        availableOptions.forEach(function (option) {
          option.setSelected(option.value === currentSelection);
        });
      } else {
        availableOptions.forEach(function (option) {
          option.setSelected(false);
        });
      }
      return availableOptions;
    },
    getSelectedOptionForLevel: function getSelectedOptionForLevel(levelIndex) {
      if (levelIndex < 0 || levelIndex >= state.levels.length) return null;
      var levelData = state.levels[levelIndex];
      var parentSelection = levelIndex > 0 ? state.selectedValues[levelIndex - 1] : null;
      var availableOptions = levelData.getAvailableOptions(parentSelection);
      return availableOptions.find(function (option) {
        return option.selected;
      });
    },
    canGoToLevel: function canGoToLevel(levelIndex) {
      if (levelIndex === 0) return true;
      if (levelIndex > state.currentLevel) return false;
      for (var i = 0; i < levelIndex; i++) {
        if (!state.selectedValues[i]) return false;
      }
      return true;
    },
    isLevelComplete: function isLevelComplete(levelIndex) {
      return state.selectedValues[levelIndex] !== undefined;
    },
    get isEmpty() {
      return state.selectedValues.length === 0;
    },
    isPathComplete: function isPathComplete() {
      if (state.selectedValues.length === 0) return false;
      var nextLevelIndex = state.selectedValues.length;
      if (nextLevelIndex >= state.levels.length) return true;
      var nextLevelData = state.levels[nextLevelIndex];
      if (!nextLevelData) return true;
      var availableOptions = nextLevelData.getAvailableOptions(state.selectedValues[nextLevelIndex - 1]);
      return availableOptions.length === 0;
    },
    get editableControlsStatus() {
      var LOCKED = editableExerciseStatus.LOCKED,
        MODIFIED = editableExerciseStatus.MODIFIED,
        NOT_MODIFIED = editableExerciseStatus.NOT_MODIFIED,
        EMPTY = editableExerciseStatus.EMPTY;
      return when()["case"](state.disabled, function () {
        return LOCKED;
      })["case"](state.isEmpty, function () {
        return EMPTY;
      })["case"](state.isPathComplete(), function () {
        return MODIFIED;
      }).resolve(function () {
        return NOT_MODIFIED;
      });
    }
  };
}));
var createLevelOptions = function createLevelOptions(options) {
  if (!Array.isArray(options)) {
    console.warn('createLevelOptions received non-array:', options);
    return [];
  }
  return options.map(function (item) {
    return LevelOptionModel.create({
      label: item.label || '',
      value: item.value.toString(),
      src: item.src || '',
      selected: false
    });
  });
};
var createLevelDependencies = function createLevelDependencies(dependencies) {
  console.log('createLevelDependencies input:', dependencies);
  if (dependencies && typeof dependencies.get === 'function') {
    console.log('Dependencies already is a MobX-State-Tree map, returning as is');
    return dependencies;
  }
  if (!dependencies) {
    console.log('Dependencies is null/undefined, returning empty object');
    return {};
  }
  var dependenciesData = {};
  Object.entries(dependencies).forEach(function (_ref) {
    var key = _ref[0],
      options = _ref[1];
    console.log("Processing dependency key \"" + key + "\":", options);
    if (Array.isArray(options)) {
      var levelOptions = options.map(function (item) {
        return LevelOptionModel.create({
          label: item.label || '',
          value: item.value.toString(),
          src: item.src || '',
          selected: false
        });
      });
      dependenciesData[key] = levelOptions;
    } else {
      console.warn("Dependencies for key \"" + key + "\" is not an array:", options);
      dependenciesData[key] = [];
    }
  });
  console.log('createLevelDependencies output:', dependenciesData);
  return dependenciesData;
};
function _createSnapshot$10(data) {
  var _ref2 = data.data || {},
    _ref2$levels = _ref2.levels,
    levels = _ref2$levels === void 0 ? [] : _ref2$levels;
  var processedLevels = levels.map(function (level) {
    var levelData = {
      id: level.id || "level_" + Math.random(),
      title: level.title || '',
      options: level.options ? createLevelOptions(level.options) : []
    };
    if (level.dependencies) {
      levelData.dependencies = createLevelDependencies(level.dependencies);
    }
    return levelData;
  });
  var baseData = importCommonValues$1(data);
  return _extends({}, baseData, {
    levels: processedLevels,
    currentLevel: 0,
    selectedValues: [],
    isEvaluable: false,
    validation: {
      scoring_type: 'manual',
      valid_response: {
        score: 1,
        value: ''
      }
    },
    type: 'adaptativechoice',
    stimulus: data.data && data.data.stimulus || '',
    ui_style: data.data && data.data.ui_style || {}
  });
}
function createStore$1g(data) {
  return AdaptativeChoiceQuestionStore.create(_createSnapshot$10(data));
}

var iconTitle$7 = /*#__PURE__*/React__default.createElement(SvgAdjustments, {
  width: "24"
});
function LevelsConfig(_ref) {
  var store = _ref.store;
  var handleLevelTitleChange = function handleLevelTitleChange(levelIndex, content) {
    store.setLevelTitle(levelIndex, content);
  };
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "levels",
    icon: iconTitle$7,
    titleBox: translate('adaptative_choice_levels_config'),
    helpText: translate('adaptative_choice_levels_config_help'),
    classNameAdd: "lemo-editor-config"
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-levels-config__container"
  }, store.levels.map(function (level, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: level.id,
      className: "lemo-levels-config__level-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-levels-config__field-container"
    }, /*#__PURE__*/React__default.createElement("h5", {
      className: "lemo-levels-config__level-title"
    }, translate('adaptative_choice_level_title').replaceAll('{{level_number}}', index + 1))), /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-levels-config__field-container"
    }, /*#__PURE__*/React__default.createElement("label", {
      className: "lemo-levels-config__field-label"
    }, translate('adaptative_choice_level_title_label')), /*#__PURE__*/React__default.createElement(FroalaField$1, {
      editMode: true,
      content: level.title,
      setContent: function setContent(content) {
        return handleLevelTitleChange(index, content);
      },
      toolbarInline: false,
      canInsertVideo: false,
      placeholder: translate('adaptative_choice_level_title_placeholder'),
      className: "lemo-levels-config__field-input"
    })));
  }))));
}
var LevelsConfig$1 = observer(LevelsConfig);

var _excluded$L = ["store", "changed", "type"];
var AdaptativeChoiceEditor = function AdaptativeChoiceEditor(props) {
  var store = props.store,
    changed = props.changed,
    type = props.type,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$L);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setTitle|setStimulus|afterCreate|setLevelTitle",
    onlyComponentsView: ['TITLE']
  }), /*#__PURE__*/React__default.createElement(LevelsConfig$1, {
    store: store
  }));
};
var AdaptativeChoiceEditor$1 = observer(AdaptativeChoiceEditor);

var AdaptativeChoiceUIStyles = types$1.compose(BaseModel$1, types$1.model({}).actions(function (state) {
  return {};
}));

var AdaptativeChoiceEditorStore = types$1.compose(EditorBaseModel, types$1.model({
  isEvaluable: false,
  ui_style: types$1.optional(AdaptativeChoiceUIStyles, defaultUIStyle),
  levels: types$1.optional(types$1.array(types$1.model({
    id: types$1.string,
    title: types$1.string,
    options: types$1.optional(types$1.array(types$1.model({
      label: types$1.string,
      value: types$1.string,
      src: types$1.optional(types$1.string, '')
    })), []),
    dependencies: types$1.optional(types$1.map(types$1.array(types$1.model({
      label: types$1.string,
      value: types$1.string,
      src: types$1.optional(types$1.string, '')
    }))), {})
  })), [])
}).actions(function (state) {
  return {
    setLevelTitle: function setLevelTitle(levelIndex, title) {
      if (state.levels[levelIndex]) {
        state.levels[levelIndex].title = title;
      }
      state.updateNotifier();
    }
  };
}).views(function (state) {
  return {
    getUserResponse: function getUserResponse() {
      return '';
    },
    getResults: function getResults() {
      return {};
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$11(rawData);
    },
    get output() {
      return exportCommonValues(state, {
        levels: state.levels.map(function (level) {
          return {
            id: level.id,
            title: level.title,
            options: level.options ? getSnapshot(level.options) : [],
            dependencies: level.dependencies ? getSnapshot(level.dependencies) : {}
          };
        })
      });
    }
  };
}));
function _createSnapshot$11(data) {
  return _extends({}, data.data, importCommonValues$1(data), {
    levels: data.data.levels || []
  });
}
function createStore$1h(data) {
  var store = AdaptativeChoiceEditorStore.create(_createSnapshot$11(data));
  return store;
}

function getOther(props) {
  var _getCreator = getCreator(props, getDefaultData$7, types.other.UploadFile),
    type = _getCreator.type,
    exerciseData = _getCreator.exerciseData,
    setCommonParamsStore = _getCreator.setCommonParamsStore;
  return when()["case"](type === types.other.UploadFile, function () {
    var questionStore = createStore$13(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$14(exerciseData);
    setCommonParamsStore(editorStore);
    return createUploadFile(editorStore, questionStore);
  })["case"](type === types.other.Pencil, function () {
    var questionStore = createStore$$(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$10(exerciseData);
    setCommonParamsStore(editorStore);
    return createPencil(editorStore, questionStore);
  })["case"](type === types.other.Statement, function () {
    var questionStore = createStore$11(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$12(exerciseData);
    setCommonParamsStore(editorStore);
    return createStatement(editorStore, questionStore);
  })["case"](type === types.other.ClickToFind, function () {
    var questionStore = createStore$_(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$16(exerciseData);
    setCommonParamsStore(editorStore);
    return createClickToFind(editorStore, questionStore);
  })["case"](type === types.other.AudioRecorder, function () {
    var questionStore = createStore$Z(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$X(exerciseData);
    setCommonParamsStore(editorStore);
    return createAudioRecorder(editorStore, questionStore);
  })["case"](type === types.other.Clock, function () {
    var questionStore = createStore$1(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$Y(exerciseData);
    setCommonParamsStore(editorStore);
    return createClock(editorStore, questionStore);
  })["case"](type === types.other.WordSearch, function () {
    var questionStore = createStore$15(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$19(exerciseData);
    setCommonParamsStore(editorStore);
    return createWordSearch(editorStore, questionStore);
  })["case"](type === types.other.Crossword, function () {
    var questionStore = createStore$18(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$17(exerciseData);
    setCommonParamsStore(editorStore);
    return createCrossword(editorStore, questionStore);
  })["case"](type === types.other.PathWay, function () {
    var questionStore = createStore$1a(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$1b(exerciseData);
    setCommonParamsStore(editorStore);
    return createPathWay(editorStore, questionStore);
  })["case"](type === types.other.ReversePathWay, function () {
    var questionStore = createStore$1c(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$1d(exerciseData);
    setCommonParamsStore(editorStore);
    return createReversePathWay(editorStore, questionStore);
  })["case"](type === types.other.Rating, function () {
    var questionStore = createStore$1f(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$1e(exerciseData);
    setCommonParamsStore(editorStore);
    return createRating(editorStore, questionStore);
  })["case"](type === types.other.AdaptativeChoice, function () {
    var questionStore = createStore$1g(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$1h(exerciseData);
    setCommonParamsStore(editorStore);
    return createAdaptativeChoice(editorStore, questionStore);
  }).resolve(null);
}
function createUploadFile(editorStore, questionStore) {
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(UploadFileQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(UploadFileEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(UploadFileControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createPencil(editorStore, questionStore) {
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(PencilQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(PencilEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(SendControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createClickToFind(editorStore, questionStore) {
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(ClickToFindQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(ClickToFindEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createAudioRecorder(editorStore, questionStore) {
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(AudioRecorderQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(AudioRecorderEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(RecordAudioControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createClock(editorStore, questionStore) {
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(ClockQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(ClockEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createWordSearch(editorStore, questionStore) {
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(WordSearchQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(WordSearchEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createCrossword(editorStore, questionStore) {
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(CrosswordQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(CrosswordEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createPathWay(editorStore, questionStore) {
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(PathwayQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(PathwayEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(PathwayControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createReversePathWay(editorStore, questionStore) {
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(ReversePathwayQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(ReversePathwayEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(PathwayControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createStatement(editorStore, questionStore) {
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(StatementQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(StatementEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(StatementControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createRating(editorStore, questionStore) {
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(RatingQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(RatingEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(RatingControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createAdaptativeChoice(editorStore, questionStore) {
  return commonCreatorProps(questionStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(AdaptativeChoiceQuestion$1, _extends({
        store: questionStore
      }, extraParams));
    },
    QuestionPreview: function QuestionPreview(extraParams) {
      return /*#__PURE__*/React__default.createElement(_QuestionPreview, _extends({
        store: editorStore
      }, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(AdaptativeChoiceEditor$1, _extends({
        store: editorStore
      }, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(AdaptativeChoiceControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}

var ChartXDataModel = types$1.model('ChartCategory', {
  id: types$1.optional(types$1.identifier, function () {
    return uuid();
  }),
  x: types$1.optional(types$1.string, ''),
  y: types$1.number,
  src: types$1.optional(types$1.string, '')
}).views(function (state) {
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    }
  };
});

var CategoryModel = types$1.compose(ChartXDataModel, getWithFeedbackResult()).actions(function (state) {
  return {
    setValue: function setValue(value) {
      state.y = value;
    },
    reset: function reset() {
      state.y = 0;
    }
  };
}).views(function (state) {
  return {
    get label() {
      return state.x;
    },
    get value() {
      return state.y;
    },
    get imageList() {
      return getParent(state, 2).isEvaluated ? state.solutionImageList : state.fullImageList;
    },
    get fullImageList() {
      var _getParent = getParent(state, 2),
        maxValue = _getParent.maxValue;
      return populate(maxValue, function (i) {
        return {
          id: state.label + "_" + i,
          src: state.src
        };
      });
    },
    get solutionImageList() {
      return state.fullImageList.slice(0, state.value);
    },
    get isValid() {
      var validResponse = getParent(state, 2).validation.value;
      var currentSolution = validResponse.find(function (_ref) {
        var x = _ref.x;
        return x === state.label;
      });
      return currentSolution.y === state.value;
    }
  };
});

var PictographQuestionStore = types$1.compose(QuestionBaseModel, getClosestSolutionModel(checkResponse$i), withValidationModes, withXAPITypeOther$1({
  xAPISolution: function xAPISolution(state) {
    return formatResponses(state.validation.value.map(function (_ref) {
      var x = _ref.x,
        y = _ref.y;
      return x + "[.]" + y;
    }));
  }
}), types$1.model({
  categories: types$1.array(CategoryModel)
}).actions(function (state) {
  return {
    setResponse: function setResponse(response) {
      var responseModel = types$1.model({
        x: types$1.string,
        y: types$1.number
      });
      if (!typeChecker(types$1.array(responseModel), response)) return false;
      response.forEach(function (response) {
        var getCategoryByLabel = function getCategoryByLabel(label) {
          return state.categories.find(function (c) {
            return c.label === label;
          });
        };
        var currentCategory = getCategoryByLabel(response.x);
        currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.setValue(response.y);
      });
    },
    reset: function reset() {
      state.baseReset();
      state.categories.forEach(function (category) {
        category.reset();
      });
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      applySnapshot(state, _createSnapshot$12(rawData));
      state.setIsSolutionMode(true);
      state.setResponse(rawData.data.validation.valid_response.value);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  return {
    get chartData() {
      return state.raw.data.chart_data;
    },
    get yLabel() {
      return state.chartData.y_axis_label;
    },
    get yAxisLabel() {
      return state.chartData.y_axis_label;
    },
    get xAxisLabel() {
      return state.chartData.x_axis_label;
    },
    get yAxisName() {
      return state.chartData.y_axis_name;
    },
    get xAxisName() {
      return state.chartData.x_axis_name;
    },
    get xLabels() {
      return state.chartData.data.map(function (_ref2) {
        var x = _ref2.x;
        return {
          text: x
        };
      });
    },
    get multiplier() {
      var _state$chartData;
      return ((_state$chartData = state.chartData) === null || _state$chartData === void 0 ? void 0 : _state$chartData.multiplier_y_value) || 1;
    },
    get showLegend() {
      return state.ui_style.legend_show;
    },
    get maxValue() {
      return state.chartData.max_y_value;
    },
    get showTable() {
      return state.ui_style.chart_data_show && !state.isSolutionMode;
    },
    get tableBodyValues() {
      var multiplier = state.multiplier;
      var validResponse = state.validation.value;
      var updateValue = function updateValue(val) {
        return val * multiplier;
      };
      return validResponse.map(function (_ref3) {
        var x = _ref3.x,
          y = _ref3.y;
        return [x, updateValue(y)];
      });
    },
    get tableData() {
      return {
        headerData: [state.xAxisLabel, state.yAxisLabel],
        bodyData: state.tableBodyValues
      };
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$12(rawData);
    },
    getUserResponse: function getUserResponse() {
      return state.categories.map(function (_ref4) {
        var x = _ref4.x,
          y = _ref4.y;
        return {
          x: x,
          y: y
        };
      });
    }
  };
}));
function checkResponse$i(solution, userResponse, state) {
  var validResponse = state.validation.value;
  var currentSolution = validResponse.find(function (s) {
    return s.x === userResponse.x;
  });
  return currentSolution.y === userResponse.y;
}
function upgradeQuestionData(data) {
  var chartData = data.data.chart_data;
  if ('y_axis_name' in chartData) return data;
  return produce(data, function (draft) {
    draft.data.chart_data.y_axis_name = chartData.x_axis_label;
    draft.data.chart_data.y_axis_label = chartData.x_axis_label;
    draft.data.chart_data.x_axis_name = chartData.y_axis_label;
    draft.data.chart_data.x_axis_label = chartData.y_axis_label;
  });
}
function _createSnapshot$12(_data) {
  var data = upgradeQuestionData(_data);
  var chart_data = data.data.chart_data;
  return _extends({}, data.data, importCommonValues(data), {
    categories: chart_data.data
  });
}
function createStore$1i(data) {
  return PictographQuestionStore.create(_createSnapshot$12(data));
}

var BarModel = types$1.compose(getWithFeedbackResult(), types$1.model('BarModel', {
  id: types$1.optional(types$1.identifier, function () {
    return uuid();
  }),
  value: types$1.number,
  theme: types$1.maybe(types$1.string)
}).actions(function (state) {
  return {
    setValue: function setValue(value) {
      state.value = value;
    },
    selectBar: function selectBar() {
      state.rootModel.setSelectedBar(state.id);
    },
    unselectBar: function unselectBar() {
      state.rootModel.setSelectedBar(undefined);
    },
    reset: function reset() {
      state.value = 0;
    }
  };
}).views(function (state) {
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get rootModel() {
      return getParent(state, 4);
    },
    get maxValue() {
      return getParent(state, 4).maxValue;
    },
    get barHeight() {
      var unitValue = 100 / state.maxValue;
      var lowerHeight = unitValue / 2;
      return state.value === 0 ? lowerHeight : unitValue * state.value;
    },
    get zIndex() {
      var groupLength = getParent(state).length;
      return groupLength - state.index;
    },
    get isValid() {
      var _getParent = getParent(state, 2),
        groupSolution = _getParent.groupSolution;
      var currentSolution = groupSolution.y[state.index];
      return currentSolution === state.value;
    }
  };
}));

var BarGroupModel = types$1.compose(ChartXDataModel, types$1.model({
  y: types$1.array(BarModel)
}).actions(function (state) {
  return {
    applyValue: function applyValue(value) {
      var elements = value.map(function (v, idx) {
        var currentValue = state.y.length > idx ? getSnapshot(state.y[idx]) : {};
        return _extends({}, currentValue, {
          value: v
        });
      });
      state.y = elements;
    },
    reset: function reset() {
      state.y.forEach(function (bar) {
        return bar.reset();
      });
    }
  };
}).views(function (state) {
  var parent = getParent(state, 2);
  return {
    get label() {
      return state.x;
    },
    get values() {
      return state.y;
    },
    get groupSolution() {
      var validResponse = parent.validation.value;
      return validResponse.find(function (_ref) {
        var x = _ref.x;
        return x === state.label;
      });
    },
    get isEvaluated() {
      return parent.isEvaluated;
    },
    get validation() {
      return parent.validation;
    },
    get isEvaluable() {
      return parent.isEvaluable;
    },
    get showSolution() {
      return parent.showSolution;
    },
    get disabled() {
      return parent.disabled;
    },
    getCurrentSolution: function getCurrentSolution(idx) {
      return parent.getCurrentSolution(idx);
    }
  };
}));

var BarChartQuestionStore = types$1.compose(QuestionBaseModel, getClosestSolutionModel(checkResponse$j), withValidationModes, withXAPITypeOther$1({
  xAPISolution: function xAPISolution(state) {
    return formatResponses(state.validation.value.map(function (_ref) {
      var x = _ref.x,
        y = _ref.y;
      return x + "[.]" + y;
    }));
  }
}), types$1.model({
  chart: types$1.array(BarGroupModel),
  selectedBar: types$1.maybe(types$1.string)
}).actions(function (state) {
  return {
    setResponse: function setResponse(response) {
      var responseModel = types$1.model({
        x: types$1.string,
        y: types$1.array(types$1.number)
      });
      if (!typeChecker(types$1.array(responseModel), response)) return false;
      response.forEach(function (response) {
        var getItemByLabel = function getItemByLabel(label) {
          return state.chart.find(function (c) {
            return c.label === label;
          });
        };
        var currentItem = getItemByLabel(response.x);
        if (currentItem) currentItem === null || currentItem === void 0 ? void 0 : currentItem.applyValue(response.y);
      });
    },
    setSelectedBar: function setSelectedBar(selectedBar) {
      state.selectedBar = selectedBar;
    },
    reset: function reset() {
      state.baseReset();
      state.chart.forEach(function (item) {
        item.reset();
      });
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      applySnapshot(state, _createSnapshot$13(rawData));
      state.setIsSolutionMode(true);
      state.setResponse(rawData.data.validation.valid_response.value);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  return {
    get selectedValue() {
      var _findBarById;
      if (!state.selectedBar) return undefined;
      return ((_findBarById = findBarById(state.selectedBar, state.chart)) === null || _findBarById === void 0 ? void 0 : _findBarById.value) || 0;
    },
    get chartData() {
      return state.raw.data.chart_data;
    },
    get xAxisLabel() {
      return state.chartData.x_axis_label;
    },
    get yAxisName() {
      return state.chartData.y_axis_name;
    },
    get xAxisName() {
      return state.chartData.x_axis_name;
    },
    get yAxisLabels() {
      return state.chartData.y_axis_labels.map(function (data) {
        return _extends({}, data, {
          label: data.label
        });
      });
    },
    get initialYValue() {
      return state.chartData.min_y_value;
    },
    get yValues() {
      var maxValue = state.maxValue,
        multiplier = state.multiplier;
      return populate(maxValue, function (i) {
        return state.initialYValue + (i + 1) * multiplier;
      });
    },
    get xValues() {
      return state.chart.map(function (_ref2) {
        var label = _ref2.label;
        return label;
      });
    },
    get xLabels() {
      return state.chartData.data.map(function (label) {
        return {
          text: label.x,
          image: label.src
        };
      });
    },
    get multiplier() {
      var _state$chartData;
      return ((_state$chartData = state.chartData) === null || _state$chartData === void 0 ? void 0 : _state$chartData.multiplier_y_value) || 1;
    },
    get maxValue() {
      return state.chartData.max_y_value;
    },
    get hasLabelImages() {
      return state.chartData.data.find(function (d) {
        var _d$src;
        return ((_d$src = d.src) === null || _d$src === void 0 ? void 0 : _d$src.length) > 0;
      });
    },
    get showLegend() {
      return state.chartData.y_axis_labels.length > 1;
    },
    get showTable() {
      return state.ui_style.chart_data_show;
    },
    get tableBodyValues() {
      var multiplier = state.chartData.multiplier_y_value;
      var updateValue = function updateValue(val) {
        return state.initialYValue + val * multiplier;
      };
      var getRow = function getRow(val) {
        return [val.x].concat(val.y.map(updateValue));
      };
      return state.validation.value.reduce(function (acc, next) {
        return [].concat(acc, [getRow(next)]);
      }, []);
    },
    get tableData() {
      return {
        headerData: [state.xAxisLabel].concat(state.yAxisLabels.map(function (_ref3) {
          var label = _ref3.label;
          return label;
        })),
        bodyData: state.tableBodyValues
      };
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$13(rawData);
    },
    getUserResponse: function getUserResponse() {
      return state.chart.map(function (_ref4) {
        var id = _ref4.id,
          x = _ref4.x,
          y = _ref4.y;
        return {
          id: id,
          x: x,
          y: y.map(function (_ref5) {
            var value = _ref5.value;
            return value;
          })
        };
      });
    }
  };
}));
function checkResponse$j(solution, userResponse, state) {
  var validResponse = state.validation.value;
  var currentSolution = validResponse.find(function (s) {
    return s.x === userResponse.x;
  });
  return compareArray(currentSolution.y, userResponse.y);
}
function findBarById(id, chart, idx) {
  if (idx === void 0) {
    idx = 0;
  }
  if (idx >= chart.length) return undefined;
  var bar = chart[idx].y.find(function (element) {
    return element.id === id;
  });
  return bar ? getSnapshot(bar) : findBarById(id, chart, idx + 1);
}
function getColorTheme$1(element, yLabels, itemIndex) {
  var _yLabels$itemIndex;
  return element.theme || (yLabels === null || yLabels === void 0 ? void 0 : (_yLabels$itemIndex = yLabels[itemIndex]) === null || _yLabels$itemIndex === void 0 ? void 0 : _yLabels$itemIndex.theme) || '';
}
function getChartData(data, yLabels) {
  return data.map(function (element) {
    return produce(element, function (draft) {
      draft.y = element.y.map(function (item, idx) {
        return {
          value: item,
          theme: getColorTheme$1(element, yLabels, idx)
        };
      });
    });
  });
}
function upgradeQuestionData$1(data) {
  var chartData = data.data.chart_data;
  if ('y_axis_name' in chartData) return data;
  return produce(data, function (draft) {
    var _chartData$x_axis_lab, _chartData$x_axis_lab2;
    draft.data.chart_data.y_axis_name = ((_chartData$x_axis_lab = chartData.x_axis_labels) === null || _chartData$x_axis_lab === void 0 ? void 0 : (_chartData$x_axis_lab2 = _chartData$x_axis_lab[0]) === null || _chartData$x_axis_lab2 === void 0 ? void 0 : _chartData$x_axis_lab2.label) || '';
    draft.data.chart_data.y_axis_labels = chartData.x_axis_labels;
    draft.data.chart_data.x_axis_name = chartData.y_axis_label;
    draft.data.chart_data.x_axis_label = chartData.y_axis_label;
    delete draft.data.chart_data.x_axis_labels;
    delete draft.data.chart_data.y_axis_label;
  });
}
function _createSnapshot$13(_data) {
  var data = upgradeQuestionData$1(_data);
  var chart_data = data.data.chart_data;
  return _extends({}, data.data, importCommonValues(data), {
    chart: getChartData(chart_data.data, chart_data.y_axis_labels)
  });
}
function createStore$1j(data) {
  return BarChartQuestionStore.create(_createSnapshot$13(data));
}

function fixBelowPosition(newPosition) {
  return newPosition === BELOW ? ABOVE : newPosition;
}

var chartPositions = [ABOVE$2, LEFT$3, RIGHT$9];
var ChartUIStyles = types$1.compose(BaseModel$1, types$1.model({
  legend_show: false,
  chart_data_show: true,
  chart_data_position: types$1.optional(types$1.enumeration(chartPositions), ABOVE$2)
}).actions(function (state) {
  return {
    showLegend: function showLegend(bool) {
      state.legend_show = bool;
      getParent(state).updateNotifier();
    },
    showTable: function showTable(bool) {
      state.chart_data_show = bool;
      getParent(state).updateNotifier();
    },
    setTablePosition: function setTablePosition(position) {
      var newPosition = chartPositions[position];
      var normalizePosition = fixBelowPosition(newPosition);
      state.chart_data_position = normalizePosition;
      getParent(state).updateNotifier();
    }
  };
}).views(function (state) {
  return {
    get tablePositionIndex() {
      return chartPositions.findIndex(function (position) {
        return position === state.chart_data_position;
      });
    },
    get hideTable() {
      return !state.chart_data_show;
    }
  };
}));
var ChartUIStyles$1 = types$1.snapshotProcessor(ChartUIStyles, {
  preProcessor: function preProcessor(snapshot) {
    return _extends({}, snapshot, {
      chart_data_position: fixBelowPosition(snapshot.chart_data_position)
    });
  }
});

var themeNames$1 = ['theme-light-orange', 'theme-dark-orange', 'theme-light-blue', 'theme-dark-blue', 'theme-turquoise', 'theme-violet', 'theme-bordeaux', 'theme-green'];

var DataItemModel = types$1.model('DataItemList', {
  id: types$1.optional(types$1.identifier, function () {
    return uuid();
  }),
  src: types$1.maybe(types$1.string),
  x: types$1.string,
  theme: types$1.maybe(types$1.string)
}).actions(function (state) {
  return {
    updateNotifier: function updateNotifier() {
      getParent(state, 2).updateNotifier();
    },
    setSrc: function setSrc(src) {
      state.src = src;
      state.updateNotifier();
    },
    setLabel: function setLabel(label) {
      state.x = label;
      getParent(state, 2).updateValidation();
    },
    setTheme: function setTheme(themeIndex) {
      state.theme = themeNames$1[themeIndex];
      state.updateNotifier();
    }
  };
}).views(function (state) {
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get label() {
      return state.x;
    },
    get y() {
      var _getParent = getParent(state, 3),
        numSeries = _getParent.numSeries;
      return populate(numSeries, function () {
        return 0;
      });
    }
  };
});

function getNextTheme(themeList) {
  var themesLength = themeNames$1.length;
  var theme = '';
  var idx = 0;
  while (!theme) {
    var currentTheme = themeNames$1[idx];
    if (idx === themesLength) {
      theme = themeNames$1[0];
      break;
    }
    if (!themeList.includes(currentTheme)) {
      theme = currentTheme;
      break;
    }
    idx++;
  }
  return theme;
}

var DataItemListModel = types$1.compose(createItemListModel(DataItemModel), types$1.model('DataItemModel', {}).actions(function (state) {
  function getYValue(idx) {
    var validation = getParent(state, 2).validation;
    if (validation.value.length < idx) {
      return validation.value[idx].y;
    }
    var seriesLength = getParent(state).yAxisLabel.list.length;
    return populate(seriesLength, function () {
      return 0;
    });
  }
  return {
    updateValidation: function updateValidation() {
      var validation = getParent(state, 2).validation;
      validation.setValue(state.list.map(function (item, idx) {
        return _extends({}, getSnapshot(item), {
          y: getYValue(idx)
        });
      }));
      state.updateNotifier();
    },
    updateNotifier: function updateNotifier() {
      getParent(state, 2).updateNotifier();
    },
    addItem: function addItem() {
      var optionIndex = state.list.length + 1;
      var numSeries = getParent(state).numSeries;
      var newItem = {
        src: '',
        x: translate('option') + " " + optionIndex,
        y: populate(numSeries, function () {
          return 0;
        }),
        theme: getNextTheme(state.list.map(function (_ref) {
          var theme = _ref.theme;
          return theme;
        }))
      };
      state.list.push(newItem);
      state.updateValidation();
      state.updateNotifier();
    },
    addItemToResponse: function addItemToResponse(newItem) {
      var x = newItem.x,
        y = newItem.y,
        src = newItem.src;
      var validation = getParent(state, 2).validation;
      validation.setValue([].concat(validation.value, [{
        x: x,
        y: y,
        src: src
      }]));
    },
    sortItems: function sortItems(source, destination) {
      state.list = sortArrayItem(source, destination, state.list);
      state.updateValidation();
      state.updateNotifier();
    },
    removeItem: function removeItem(idx) {
      destroy(state.list[idx]);
      state.removeItemToResponse(idx);
      state.updateNotifier();
    },
    removeItemToResponse: function removeItemToResponse(itemIndex) {
      var validation = getParent(state, 2).validation;
      var updatedResponse = rmItem(itemIndex, validation.value);
      validation.setValue(updatedResponse);
    },
    reduceNumBars: function reduceNumBars() {
      while (state.list.length > 3) {
        this.removeItem(state.list.length - 1);
      }
    }
  };
}));

var BaseLabelThemeListModel = types$1.model('BaseLabelThemeListModel').actions(function (state) {
  return {
    updateNotifier: function updateNotifier() {
      getParent(state, 2).updateNotifier();
    },
    addItem: function addItem() {
      var newItem = {
        label: translate('Option') + " " + (state.list.length + 1),
        theme: getNextTheme(state.list.map(function (_ref) {
          var theme = _ref.theme;
          return theme;
        }))
      };
      state.list.push(newItem);
      state.addItemToResponse();
      state.updateNotifier();
    },
    removeItem: function removeItem(idx) {
      destroy(state.list[idx]);
      state.removeItemToResponse(idx);
      state.updateNotifier();
    }
  };
});

var LabelThemeItemModel = types$1.model({
  id: types$1.optional(types$1.identifier, function () {
    return uuid();
  }),
  theme: types$1.optional(types$1.string, function () {
    return themeNames$1[0];
  }),
  label: types$1.string
}).actions(function (state) {
  return {
    setLabel: function setLabel(label) {
      state.label = label;
      getParent(state, 2).updateNotifier();
    },
    setTheme: function setTheme(themeIndex) {
      state.theme = themeNames$1[themeIndex];
      getParent(state, 2).updateNotifier();
    }
  };
}).views(function (state) {
  return {
    get errorMessage() {
      return state.label.length === 0 ? translate('input_needs_value') : '';
    },
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get themeIndex() {
      return themeNames$1.findIndex(function (t) {
        return t === state.theme;
      });
    }
  };
});

var LabelThemeListModel = types$1.compose(createItemListModel(LabelThemeItemModel), BaseLabelThemeListModel, types$1.model('LabelThemeListModel', {}).actions(function (state) {
  return {
    addItemToResponse: function addItemToResponse() {
      var validation = getParent(state, 2).validation;
      validation.setValue(validation.value.map(function (val) {
        return _extends({}, val, {
          y: [].concat(val.y, [0])
        });
      }));
    },
    removeItemToResponse: function removeItemToResponse(itemIndex) {
      var validation = getParent(state, 2).validation;
      var updatedResponse = validation.value.map(function (val) {
        return _extends({}, val, {
          y: rmItem(itemIndex, val.y)
        });
      });
      validation.setValue(updatedResponse);
    }
  };
}));

var ChartDataModel = types$1.model({
  data: DataItemListModel,
  xAxisName: types$1.maybe(types$1.string),
  yAxisName: types$1.maybe(types$1.string),
  xAxisLabel: types$1.maybe(types$1.string),
  yAxisLabel: LabelThemeListModel,
  yMin: types$1.optional(types$1.number, 2),
  yMax: types$1.optional(types$1.number, 10),
  yMultiplier: types$1.optional(types$1.number, 1)
}).actions(function (state) {
  return {
    setXAxisLabel: function setXAxisLabel(value) {
      state.xAxisLabel = value;
      getParent(state).updateNotifier();
    },
    setXAxisName: function setXAxisName(xAxisName) {
      state.xAxisName = xAxisName;
      getParent(state).updateNotifier();
    },
    setYAxisName: function setYAxisName(yAxisName) {
      state.yAxisName = yAxisName;
      getParent(state).updateNotifier();
    },
    setYMax: function setYMax(yMax) {
      if (isNaN(yMax) || yMax === '') return;
      var safeValue = Math.min(Math.max(3, parseInt(yMax)), 10);
      state.yMax = safeValue;
      getParent(state).updateNotifier();
    },
    setYMin: function setYMin(yMin) {
      if (isNaN(yMin) || yMin === '') return;
      var safeValue = Math.max(0, parseInt(yMin));
      state.yMin = safeValue;
      getParent(state).updateNotifier();
    },
    setYMultiplier: function setYMultiplier(yMultiplier) {
      if (isNaN(yMultiplier) || yMultiplier === '') return;
      var safeValue = Math.max(1, parseInt(yMultiplier));
      state.yMultiplier = safeValue;
      getParent(state).updateNotifier();
    }
  };
}).views(function (state) {
  return {
    get numSeries() {
      return state.yAxisLabel.list.length;
    },
    get numBars() {
      return state.data.list.length;
    }
  };
});
function exportLabels(_ref) {
  var seriesLength = _ref.seriesLength,
    data = _ref.data;
  var yValue = populate(seriesLength, function () {
    return 0;
  });
  return data.map(function (itemValue) {
    return _extends({}, itemValue, {
      theme: seriesLength > 1 ? '' : itemValue.theme,
      y: yValue
    });
  });
}
var ChartDataModel$1 = types$1.snapshotProcessor(ChartDataModel, {
  preProcessor: function preProcessor(sn) {
    return {
      data: {
        list: sn.data
      },
      xAxisName: sn.x_axis_name,
      yAxisName: sn.y_axis_name,
      xAxisLabel: sn.x_axis_label,
      yAxisLabel: {
        list: sn.y_axis_labels
      },
      yMin: sn.min_y_value,
      yMax: sn.max_y_value,
      yMultiplier: sn.multiplier_y_value
    };
  },
  postProcessor: function postProcessor(sn) {
    var seriesLength = sn.yAxisLabel.list.length;
    return {
      data: exportLabels({
        seriesLength: seriesLength,
        data: sn.data.list
      }),
      y_axis_name: sn.yAxisName,
      x_axis_name: sn.xAxisName,
      y_axis_labels: sn.yAxisLabel.list,
      x_axis_label: sn.xAxisLabel,
      min_y_value: sn.yMin,
      max_y_value: sn.yMax,
      multiplier_y_value: sn.yMultiplier
    };
  }
});

var BarChartEditorStore = types$1.compose(EditorBaseModel, types$1.model({
  chartData: ChartDataModel$1,
  validation: ValidationModel,
  ui_style: ChartUIStyles$1
}).actions(function (state) {
  return {
    reset: function reset() {
      state.isEvaluated = false;
      state.showSolution = false;
      state.tempResponse = [];
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot$14(rawData);
      applySnapshot(state, data);
      state.setIsSolutionMode(true);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$14(rawData);
    },
    get output() {
      var x = exportCommonValues(state, {
        chart_data: getSnapshot(state.chartData)
      });
      return x;
    }
  };
}));
function _createSnapshot$14(data) {
  return _extends({}, data.data, importCommonValues$1(data), {
    chartData: data.data.chart_data
  });
}
function createStore$1k(data) {
  var store = BarChartEditorStore.create(_createSnapshot$14(data));
  return store;
}

var DataItemModel$1 = types$1.model('DataItemList', {
  id: types$1.optional(types$1.identifier, function () {
    return uuid();
  }),
  src: types$1.maybe(types$1.string),
  x: types$1.string,
  y: types$1.optional(types$1.number, 0)
}).actions(function (state) {
  return {
    updateNotifier: function updateNotifier() {
      getParent(state, 2).updateNotifier();
    },
    setSrc: function setSrc(src) {
      state.src = src;
      state.updateNotifier();
    },
    setLabel: function setLabel(label) {
      state.x = label;
      getParent(state, 2).updateValidation();
    },
    setX: function setX(x) {
      state.x = x;
      getParent(state, 2).updateValidation();
    },
    setY: function setY(y) {
      state.y = y;
      getParent(state, 2).updateValidation();
    }
  };
}).views(function (state) {
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get label() {
      return state.x;
    }
  };
});

var DataItemListModel$1 = types$1.compose(createItemListModel(DataItemModel$1), types$1.model('DataItemModel', {}).actions(function (state) {
  function getYValue(idx) {
    var validation = getParent(state, 2).validation;
    if (validation.value.length > idx) {
      return validation.value[idx].y;
    }
    return 0;
  }
  return {
    updateValidation: function updateValidation() {
      var validation = getParent(state, 2).validation;
      validation.setValue(state.list.map(function (item, idx) {
        return _extends({}, getSnapshot(item), {
          y: getYValue(idx)
        });
      }));
      state.updateNotifier();
    },
    updateNotifier: function updateNotifier() {
      getParent(state, 2).updateNotifier();
    },
    addItem: function addItem() {
      var optionIndex = state.list.length + 1;
      var newItem = {
        src: 'https://lemonade-assets.oneclick.es/fruits/aguacate.png',
        x: translate('option') + " " + optionIndex,
        y: 0
      };
      state.list.push(newItem);
      state.updateValidation();
      state.updateNotifier();
    },
    addItemToResponse: function addItemToResponse(newItem) {
      var x = newItem.x,
        y = newItem.y,
        src = newItem.src;
      var validation = getParent(state, 2).validation;
      validation.setValue([].concat(validation.value, [{
        x: x,
        y: y,
        src: src
      }]));
    },
    sortItems: function sortItems(source, destination) {
      state.list = sortArrayItem(source, destination, state.list);
      state.updateValidation();
      state.updateNotifier();
    },
    removeItem: function removeItem(idx) {
      destroy(state.list[idx]);
      state.removeItemToResponse(idx);
      state.updateNotifier();
    },
    removeItemToResponse: function removeItemToResponse(itemIndex) {
      var validation = getParent(state, 2).validation;
      var updatedResponse = rmItem(itemIndex, validation.value);
      validation.setValue(updatedResponse);
    }
  };
}));

var ChartDataModel$2 = types$1.model({
  data: DataItemListModel$1,
  xAxisLabel: types$1.maybe(types$1.string),
  yAxisLabel: types$1.maybe(types$1.string),
  xAxisName: types$1.maybe(types$1.string),
  yAxisName: types$1.maybe(types$1.string),
  yMin: types$1.optional(types$1.number, 0),
  yMax: types$1.optional(types$1.number, 10),
  name: types$1.maybe(types$1.string),
  yMultiplier: types$1.optional(types$1.number, 1)
}).actions(function (state) {
  return {
    setXAxisLabel: function setXAxisLabel(value) {
      state.xAxisLabel = value;
      getParent(state).updateNotifier();
    },
    setYAxisLabel: function setYAxisLabel(value) {
      state.yAxisLabel = value;
      getParent(state).updateNotifier();
    },
    setXAxisName: function setXAxisName(xAxisName) {
      state.xAxisName = xAxisName;
      getParent(state).updateNotifier();
    },
    setYAxisName: function setYAxisName(yAxisName) {
      state.yAxisName = yAxisName;
      getParent(state).updateNotifier();
    },
    setName: function setName(name) {
      state.name = name;
      getParent(state).updateNotifier();
    },
    setYMin: function setYMin(value) {
      state.yMin = value;
      getParent(state).updateNotifier();
    },
    setYMax: function setYMax(value) {
      state.yMax = parseInt(value + '');
      getParent(state).updateNotifier();
    },
    setYMultiplier: function setYMultiplier(yMultiplier) {
      if (isNaN(yMultiplier) || yMultiplier === '') return;
      var safeValue = Math.max(1, parseInt(yMultiplier));
      state.yMultiplier = safeValue;
      getParent(state).updateNotifier();
    }
  };
}).views(function (state) {
  return {};
});
function exportLabels$1(_ref) {
  var data = _ref.data;
  return data.map(function (itemValue) {
    return _extends({}, itemValue);
  });
}
var ChartDataModel$3 = types$1.snapshotProcessor(ChartDataModel$2, {
  preProcessor: function preProcessor(sn) {
    return {
      data: {
        list: sn.data
      },
      xAxisName: sn.x_axis_name,
      yAxisName: sn.y_axis_name,
      xAxisLabel: sn.x_axis_label,
      yAxisLabel: sn.y_axis_label,
      yMin: sn.min_y_value,
      yMax: sn.max_y_value,
      name: sn.name,
      yMultiplier: sn.multiplier_y_value
    };
  },
  postProcessor: function postProcessor(sn) {
    return {
      data: exportLabels$1({
        data: sn.data.list
      }),
      y_axis_name: sn.yAxisName,
      x_axis_name: sn.xAxisName,
      y_axis_label: sn.yAxisLabel,
      x_axis_label: sn.xAxisLabel,
      min_y_value: sn.yMin,
      max_y_value: sn.yMax,
      name: sn.name,
      multiplier_y_value: sn.yMultiplier
    };
  }
});

var PictographEditorStore = types$1.compose(EditorBaseModel, types$1.model({
  chartData: ChartDataModel$3,
  validation: ValidationModel,
  ui_style: ChartUIStyles$1
}).actions(function (state) {
  return {
    reset: function reset() {
      state.isEvaluated = false;
      state.showSolution = false;
      state.tempResponse = [];
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot$15(rawData);
      applySnapshot(state, data);
      state.setIsSolutionMode(true);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$15(rawData);
    },
    get output() {
      var x = exportCommonValues(state, {
        chart_data: getSnapshot(state.chartData)
      });
      return x;
    }
  };
}));
function _createSnapshot$15(data) {
  return _extends({}, data.data, importCommonValues$1(data), {
    chartData: data.data.chart_data
  });
}
function createStore$1l(data) {
  var store = PictographEditorStore.create(_createSnapshot$15(data));
  return store;
}

var DotModel$2 = types$1.model('DotModel', {
  id: types$1.optional(types$1.identifier, function () {
    return uuid();
  }),
  x: types$1.frozen(types$1.string),
  y: types$1.number,
  selected: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  var parent = getParent(state, 2);
  var rootModel = getParent(state, 4);
  return {
    setValue: function setValue(value) {
      state.y = value;
    },
    setSelected: function setSelected(selected) {
      state.selected = selected;
      selected && state.selectLine();
    },
    selectLine: function selectLine() {
      rootModel.setSelectedLine(parent.index);
    }
  };
}).views(function (state) {
  var rootModel = getParent(state, 4);
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get xPosition() {
      return rootModel.distanceBetweenPoints[state.index];
    },
    get maxValue() {
      return rootModel.maxValue;
    },
    get isEvaluated() {
      return rootModel.isEvaluated;
    }
  };
});

var LineModel$2 = types$1.compose(getWithFeedbackResult(normalize$b), types$1.model({
  id: types$1.string,
  theme: types$1.string,
  dots: types$1.array(DotModel$2)
}).actions(function (state) {
  return {
    applyValue: function applyValue(value) {
      if (!isAlive(state)) return;
      value.forEach(function (_ref, idx) {
        var y = _ref.y;
        if (state.dots.length <= idx) return;
        state.dots[idx].setValue(y);
      });
    },
    selectLine: function selectLine() {
      getParent(state, 2).setSelectedLine(state.index);
    },
    reset: function reset() {
      var lineValues = getParent(state, 2).chartData.data[state.index];
      state.applyValue(lineValues);
    }
  };
}).views(function (state) {
  var parent = getParent(state, 2);
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get selectedValue() {
      var currentDot = state.dots.find(function (dot) {
        return dot.selected;
      });
      return currentDot ? currentDot.y : -1;
    },
    get isSelected() {
      return parent.selectedLine === state.index && parent.selectedValue > -1;
    },
    get lineConnection() {
      return isAlive(state) ? state.dots.map(function (dot) {
        return {
          x: dot.xPosition,
          y: dot.y
        };
      }) : [];
    },
    get value() {
      return state.dots.map(function (_ref2) {
        var x = _ref2.x,
          y = _ref2.y;
        return {
          x: x,
          y: y
        };
      });
    }
  };
}));
function normalize$b(collection) {
  return collection.map(function (_ref3) {
    var y = _ref3.y;
    return y;
  }).toString();
}

var LineChartQuestionStore = types$1.compose(QuestionBaseModel, getClosestSolutionModel(checkResponse$k), withValidationModes, withXAPITypeOther$1({
  xAPISolution: function xAPISolution(state) {
    return formatResponses(getXAPIResponses(state));
  }
}), types$1.model({
  chart: types$1.array(LineModel$2),
  selectedLine: types$1.optional(types$1.number, -1)
}).actions(function (state) {
  return {
    setResponse: function setResponse(response) {
      var responseModel = types$1.model({
        x: types$1.string,
        y: types$1.number
      });
      if (!typeChecker(types$1.array(types$1.array(responseModel)), response)) return false;
      response.forEach(function (value, idx) {
        var currentChart = state.chart[idx];
        if (currentChart) currentChart.applyValue(value);
      });
      state.updateNotifier();
    },
    setSelectedLine: function setSelectedLine(selectedLine) {
      if (selectedLine === void 0) {
        selectedLine = -1;
      }
      state.selectedLine = selectedLine;
    },
    reset: function reset() {
      state.baseReset();
      state.chart.forEach(function (line) {
        line.reset();
      });
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var solution = rawData.data.validation.valid_response.value;
      var maxYValue = rawData.data.chart_data.max_y_value;
      var normalizeSerie = function normalizeSerie(serie) {
        return serie.map(function (_ref) {
          var x = _ref.x,
            y = _ref.y;
          return {
            x: x,
            y: Math.min(y, maxYValue)
          };
        });
      };
      var normalizedSolution = solution.map(normalizeSerie);
      applySnapshot(state, _createSnapshot$16(rawData));
      state.setIsSolutionMode(true);
      setTimeout(function () {
        state.setResponse(normalizedSolution);
      }, 101);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    },
    hydrateQuestionPreview: function hydrateQuestionPreview(rawData) {
      try {
        var data = _createSnapshot$16(rawData);
        var prevAssetsQuestionApi = state.assetsQuestionApi;
        applySnapshot(state, data);
        state.setIsSolutionMode(false);
        state.setAssetsQuestionApi(prevAssetsQuestionApi);
      } catch (e) {}
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  return {
    get selectedValue() {
      return state.chart.reduce(function (acc, next) {
        return next.selectedValue > -1 ? next.selectedValue : acc;
      }, -1);
    },
    get chartData() {
      return state.raw.data.chart_data;
    },
    get xAxisLabel() {
      return state.chartData.x_axis_label;
    },
    get yAxisName() {
      return state.chartData.y_axis_name;
    },
    get xAxisName() {
      return state.chartData.x_axis_name;
    },
    get yAxisLabels() {
      return state.chartData.y_axis_labels.map(function (data) {
        return _extends({}, data, {
          label: data.label
        });
      });
    },
    get initialYValue() {
      return state.chartData.min_y_value;
    },
    get measure() {
      return state.chartData.measure || '';
    },
    get yValues() {
      var maxY = state.chartData.max_y_value;
      var multiplier = state.chartData.multiplier_y_value;
      return populate(maxY, function (i) {
        return state.initialYValue + (i + 1) * multiplier;
      });
    },
    get xValues() {
      return state.chartData.data[0].map(function (_ref2) {
        var x = _ref2.x;
        return x;
      });
    },
    get xLabels() {
      return state.xValues.map(function (text) {
        return {
          text: text
        };
      });
    },
    get multiplier() {
      var _state$chartData;
      return ((_state$chartData = state.chartData) === null || _state$chartData === void 0 ? void 0 : _state$chartData.multiplier_y_value) || 1;
    },
    get distanceBetweenPoints() {
      var totalPoints = state.xValues.length;
      var distance = 100 / totalPoints;
      return populate(totalPoints, function (i) {
        return (i + 1) * distance - distance / 2;
      });
    },
    get showLegend() {
      return state.chart.length > 1;
    },
    get maxValue() {
      return state.chartData.max_y_value;
    },
    get initialLineOrder() {
      return state.chart.map(function (_, idx) {
        return state.chart[state.chart.length - (idx + 1)];
      });
    },
    get lines() {
      var orderLines = function orderLines() {
        return [].concat(state.initialLineOrder.filter(function (line) {
          return line.index !== state.selectedLine;
        }), [state.chart[state.selectedLine]]);
      };
      return state.selectedLine > -1 && state.chart.length > 1 ? orderLines() : state.initialLineOrder;
    },
    get showTable() {
      return state.ui_style.chart_data_show;
    },
    get tableBodyValues() {
      var multiplier = state.chartData.multiplier_y_value;
      var data = state.validation.value;
      var updateValue = function updateValue(val) {
        var value = state.initialYValue + val * multiplier;
        return (isNaN(value) ? state.initialYValue : value).toString() + state.measure;
      };
      var getRow = function getRow(dotIdx) {
        return data.map(function (line) {
          return updateValue(line[dotIdx].y);
        });
      };
      return state.xValues.map(function (xValue, idx) {
        return [xValue].concat(getRow(idx));
      });
    },
    get tableData() {
      return {
        headerData: [state.xAxisLabel].concat(state.yAxisLabels.map(function (_ref3) {
          var label = _ref3.label;
          return label;
        })),
        bodyData: state.tableBodyValues
      };
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$16(rawData);
    },
    getUserResponse: function getUserResponse() {
      return state.chart.map(function (line) {
        return line.dots.map(function (_ref4) {
          var x = _ref4.x,
            y = _ref4.y;
          return {
            x: x,
            y: y
          };
        });
      });
    }
  };
}));
function getXAPIResponses(state) {
  var labels = state.yAxisLabels.map(function (_ref5) {
    var label = _ref5.label;
    return label;
  });
  return state.validation.value.reduce(function (acc, next, idx) {
    var label = labels[idx];
    var values = next.map(function (_ref6) {
      var x = _ref6.x,
        y = _ref6.y;
      return label + "_" + x + "[.]" + y;
    });
    return acc.concat(values);
  }, []);
}
function checkResponse$k(solution, userResponse, state, idx) {
  var validResponse = state.validation.value;
  var currentSolution = validResponse[idx];
  var getYValues = function getYValues(collection) {
    return collection.map(function (_ref7) {
      var y = _ref7.y;
      return y;
    });
  };
  return compareArray(getYValues(currentSolution), getYValues(userResponse));
}
function getChartData$1(data, yLabels) {
  return data.map(function (line, lineIdx) {
    var emptyValue = {
      label: undefined,
      theme: undefined
    };
    var _ref8 = (yLabels === null || yLabels === void 0 ? void 0 : yLabels[lineIdx]) || emptyValue,
      label = _ref8.label,
      theme = _ref8.theme;
    return {
      id: label,
      theme: theme,
      dots: line.map(function (dot) {
        return {
          y: dot.y,
          x: dot.x
        };
      })
    };
  });
}
function upgradeQuestionData$2(data) {
  var chartData = data.data.chart_data;
  if ('y_axis_name' in chartData) return data;
  return produce(data, function (draft) {
    draft.data.chart_data.y_axis_name = chartData.y_axis_label;
    draft.data.chart_data.y_axis_labels = chartData.x_axis_labels;
    draft.data.chart_data.x_axis_name = '';
    draft.data.chart_data.x_axis_label = '';
    delete draft.data.chart_data.y_axis_label;
    delete draft.data.chart_data.x_axis_labels;
  });
}
function _createSnapshot$16(_data) {
  var data = upgradeQuestionData$2(_data);
  var chart_data = data.data.chart_data;
  return _extends({}, data.data, importCommonValues(data), {
    chart: getChartData$1(chart_data.data, chart_data.y_axis_labels)
  });
}
function createStore$1m(data) {
  return LineChartQuestionStore.create(_createSnapshot$16(data));
}

var DataItemListModel$2 = types$1.compose(createItemListModel(ValueModel), types$1.model('SeriesModel', {}).actions(function (state) {
  return {
    updateNotifier: function updateNotifier() {
      getParent(state, 2).updateNotifier();
    },
    setValue: function setValue(idx, value) {
      state.list[idx].setValue(value);
      state.updateNotifier();
    },
    addItem: function addItem() {
      var newItem = {
        value: translate('Option') + " " + (state.list.length + 1)
      };
      state.list.push(newItem);
      state.addItemToResponse(newItem);
      state.updateNotifier();
    },
    addItemToResponse: function addItemToResponse(newItem) {
      var validation = getParent(state, 2).validation;
      var updatedResponse = validation.value.map(function (serie) {
        return [].concat(serie, [{
          x: newItem.value,
          y: 0
        }]);
      });
      validation.setValue(updatedResponse);
    },
    removeItem: function removeItem(idx) {
      destroy(state.list[idx]);
      state.removeItemToResponse(idx);
      state.updateNotifier();
    },
    removeItemToResponse: function removeItemToResponse(itemIndex) {
      var validation = getParent(state, 2).validation;
      var updatedResponse = validation.value.map(function (serie) {
        return rmItem(itemIndex, serie);
      });
      validation.setValue(updatedResponse);
    }
  };
}));

var SeriesItemListModel = types$1.compose(createItemListModel(LabelThemeItemModel), BaseLabelThemeListModel, types$1.model('SeriesModel', {}).actions(function (state) {
  return {
    addItemToResponse: function addItemToResponse() {
      var validation = getParent(state, 2).validation;
      var labelsList = getParent(state).data.list;
      var valueItemList = labelsList.map(function (_ref) {
        var x = _ref.x;
        return {
          x: x,
          y: 0
        };
      });
      var updatedResponse = [].concat(validation.value, [valueItemList]);
      validation.setValue(updatedResponse);
    },
    removeItemToResponse: function removeItemToResponse(itemIndex) {
      var validation = getParent(state, 2).validation;
      var updatedResponse = rmItem(itemIndex, validation.value);
      validation.setValue(updatedResponse);
    }
  };
}));

var ChartDataModel$4 = types$1.model({
  data: DataItemListModel$2,
  yAxisName: types$1.maybe(types$1.string),
  xAxisName: types$1.maybe(types$1.string),
  yAxisLabel: SeriesItemListModel,
  xAxisLabel: types$1.maybe(types$1.string),
  yMin: types$1.optional(types$1.number, 2),
  yMax: types$1.optional(types$1.number, 10),
  yMultiplier: types$1.optional(types$1.number, 1),
  measure: types$1.optional(types$1.string, '')
}).actions(function (state) {
  return {
    setXAxisLabel: function setXAxisLabel(value) {
      state.xAxisLabel = value;
      getParent(state).updateNotifier();
    },
    setXAxisName: function setXAxisName(xAxisName) {
      state.xAxisName = xAxisName;
      getParent(state).updateNotifier();
    },
    setYAxisName: function setYAxisName(yAxisName) {
      state.yAxisName = yAxisName;
      getParent(state).updateNotifier();
    },
    setMeasure: function setMeasure(measure) {
      state.measure = measure;
      getParent(state).updateNotifier();
    },
    setYMax: function setYMax(yMax) {
      if (isNaN(yMax) || yMax === '') return;
      var safeValue = Math.min(Math.max(3, parseInt(yMax)), 10);
      state.yMax = safeValue;
      getParent(state).updateNotifier();
    },
    setYMin: function setYMin(yMin) {
      if (isNaN(yMin) || yMin === '') return;
      var safeValue = Math.max(0, parseInt(yMin));
      state.yMin = safeValue;
      getParent(state).updateNotifier();
    },
    setYMultiplier: function setYMultiplier(yMultiplier) {
      if (isNaN(yMultiplier) || yMultiplier === '') return;
      var safeValue = Math.max(1, parseInt(yMultiplier));
      state.yMultiplier = safeValue;
      getParent(state).updateNotifier();
    }
  };
}).views(function (state) {
  return {
    get viewFn() {
      return false;
    }
  };
});
function importLabels(data) {
  if (data.length === 0) return [];
  return {
    list: data[0].map(function (_ref) {
      var x = _ref.x;
      return {
        value: x
      };
    })
  };
}
function exportLabels$2(_ref2) {
  var series = _ref2.series,
    data = _ref2.data;
  if (series.length === 0) return [];
  var labels = data.map(function (_ref3) {
    var value = _ref3.value;
    return {
      x: value,
      y: 0
    };
  });
  return series.map(function (_) {
    return [].concat(labels);
  });
}
var ChartDataModel$5 = types$1.snapshotProcessor(ChartDataModel$4, {
  preProcessor: function preProcessor(sn) {
    return {
      data: importLabels(sn.data),
      yAxisName: sn.y_axis_name,
      xAxisName: sn.x_axis_name,
      yAxisLabel: {
        list: sn.y_axis_labels
      },
      xAxisLabel: sn.x_axis_label,
      yMin: sn.min_y_value,
      yMax: sn.max_y_value,
      yMultiplier: sn.multiplier_y_value,
      measure: sn.measure
    };
  },
  postProcessor: function postProcessor(sn) {
    return {
      data: exportLabels$2({
        series: sn.yAxisLabel.list,
        data: sn.data.list
      }),
      y_axis_name: sn.yAxisName,
      x_axis_name: sn.xAxisName,
      y_axis_labels: sn.yAxisLabel.list,
      x_axis_label: sn.xAxisLabel,
      min_y_value: sn.yMin,
      max_y_value: sn.yMax,
      multiplier_y_value: sn.yMultiplier,
      measure: sn.measure
    };
  }
});

var LineChartEditorStore = types$1.compose(EditorBaseModel, types$1.model({
  chartData: ChartDataModel$5,
  validation: ValidationModel,
  ui_style: ChartUIStyles$1
}).actions(function (state) {
  return {
    removeOption: function removeOption(option) {
      destroy(option);
      state.updateNotifier();
    },
    removeValue: function removeValue(item) {
      destroy(item);
      state.updateNotifier();
    },
    removeResponseByIdx: function removeResponseByIdx(idx) {
      state.removOption(state.options[idx]);
    },
    sortResponses: function sortResponses(source, destination) {
      state.options = sortArrayItem(source, destination, state.options);
    },
    reset: function reset() {
      state.isEvaluated = false;
      state.showSolution = false;
      state.tempResponse = [];
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      var data = _createSnapshot$17(rawData);
      applySnapshot(state, data);
      state.setIsSolutionMode(true);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$17(rawData);
    },
    get output() {
      return exportCommonValues(state, {
        chart_data: getSnapshot(state.chartData)
      });
    }
  };
}));
function _createSnapshot$17(data) {
  return _extends({}, data.data, importCommonValues$1(data), {
    chartData: data.data.chart_data
  });
}
function createStore$1n(data) {
  var store = LineChartEditorStore.create(_createSnapshot$17(data));
  return store;
}

function VerticalLabel(_ref) {
  var label = _ref.label;
  if (!label) return null;
  return /*#__PURE__*/React__default.createElement("p", {
    "data-testid": "verticalLabel",
    className: "lemo-vertical-label lemo-text-body-m-medium lemo-color-text-03",
    dangerouslySetInnerHTML: {
      __html: label
    }
  });
}

function YAxis(_ref) {
  var yAxisName = _ref.yAxisName,
    yValues = _ref.yValues,
    initialYValue = _ref.initialYValue,
    selectedValue = _ref.selectedValue,
    _ref$measure = _ref.measure,
    measure = _ref$measure === void 0 ? '' : _ref$measure;
  var isSelected = function isSelected(idx) {
    return !!config.graphsHelpMarks && idx === selectedValue - 1 ? 'lemo-selected' : '';
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(VerticalLabel, {
    label: yAxisName
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart-y-values",
    "data-testid": "yAxisValues"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-text-body-s-bold lemo-color-text-01"
  }, initialYValue, measure), yValues.map(function (val, idx) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: cn$1('lemo-chart-y-label-container', isSelected(idx)),
      key: "yValue_" + val
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "lemo-default-label lemo-text-body-s-bold lemo-color-text-01"
    }, val, measure), /*#__PURE__*/React__default.createElement("span", {
      className: "lemo-highligted-label lemo-text-body-s-bold lemo-color-text-white"
    }, val, measure));
  })));
}
var YAxis$1 = observer(YAxis);

function ChartContent(_ref) {
  var yValues = _ref.yValues,
    store = _ref.store;
  var isSelected = function isSelected(idx) {
    return idx === store.selectedValue - 1 ? 'lemo-selected' : '';
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart-content"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart-line lemo-first-line"
  }), yValues.map(function (val, idx) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-chart-line " + isSelected(idx),
      key: "chartLines_" + val
    });
  }));
}
var ChartContent$1 = observer(ChartContent);

function VerticalSlider(_ref) {
  var value = _ref.value,
    maxValue = _ref.maxValue,
    onChange = _ref.onChange,
    _ref$onMouseDown = _ref.onMouseDown,
    onMouseDown = _ref$onMouseDown === void 0 ? noop : _ref$onMouseDown,
    _ref$onMouseUp = _ref.onMouseUp,
    onMouseUp = _ref$onMouseUp === void 0 ? noop : _ref$onMouseUp,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  function handleChange(e) {
    onChange(parseInt(e.target.value));
  }
  return /*#__PURE__*/React__default.createElement("input", {
    className: 'lemo-vertical-slider ' + className,
    type: "range",
    value: value,
    min: 0,
    max: maxValue,
    step: 1,
    orient: "vertical",
    onChange: handleChange,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    onTouchStart: onMouseDown,
    onTouchEnd: onMouseUp
  });
}
var VerticalSlider$1 = observer(VerticalSlider);

function BarValue(_ref) {
  var bar = _ref.bar,
    maxValue = _ref.maxValue;
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "barValue",
    className: cn$1('lemo-chart-x-bar-value', bar.theme, {
      'lemo-success': bar.isSuccess,
      'lemo-error': bar.isWrong
    }),
    style: {
      zIndex: bar.zIndex
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'lemo-bar-shape',
    style: {
      top: 100 - bar.barHeight + "%"
    }
  }, /*#__PURE__*/React__default.createElement(FeedbackIcon, {
    isSuccess: bar.isSuccess,
    isError: bar.isWrong
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-bar-handler",
    style: {
      bottom: bar.barHeight + "%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-bar-handler-dot"
  })), /*#__PURE__*/React__default.createElement(VerticalSlider$1, {
    className: "lemo-bar-slider",
    value: bar.value,
    maxValue: maxValue,
    onChange: function onChange(val) {
      return bar.setValue(val);
    },
    onMouseUp: bar.unselectBar,
    onMouseDown: bar.selectBar
  }));
}
var BarValue$1 = observer(BarValue);

function ChartBar(_ref) {
  var bar = _ref.bar,
    maxValue = _ref.maxValue,
    style = _ref.style;
  var isMultipleBar = bar.y.length > 1 ? 'lemo-is-multiple-bar' : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-chart-x-bar', isMultipleBar),
    "data-testid": "chartBar",
    style: style
  }, bar.y.map(function (item) {
    return /*#__PURE__*/React__default.createElement(BarValue$1, {
      key: item.id,
      bar: item,
      maxValue: maxValue
    });
  }));
}
var ChartBar$1 = observer(ChartBar);

function ChartXValues(_ref) {
  var store = _ref.store;
  var barsLength = useMemo(function () {
    return store.chart.length;
  }, [store.chart.length]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart-x-values"
  }, store.chart.map(function (bar, idx) {
    return /*#__PURE__*/React__default.createElement(ChartBar$1, {
      key: "chartBar_" + bar.id,
      bar: bar,
      maxValue: store.maxValue,
      style: {
        zIndex: barsLength - idx
      }
    });
  }));
}
var ChartXValues$1 = observer(ChartXValues);

function ChartLabel(_ref) {
  var label = _ref.label,
    labelWidth = _ref.labelWidth,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? undefined : _ref$image;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart-label",
    "data-testid": "chartLabel",
    style: {
      width: labelWidth + "%"
    }
  }, image ? /*#__PURE__*/React__default.createElement("img", {
    className: "lemo-chart-label-image",
    src: image,
    alt: label
  }) : /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-chart-label-text lemo-text-body-m-regular lemo-color-text-01",
    dangerouslySetInnerHTML: {
      __html: label
    }
  }));
}
var ChartLabel$1 = observer(ChartLabel);

function ChartXLabels(_ref) {
  var labelWidth = _ref.labelWidth,
    labels = _ref.labels;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart-x-labels",
    "data-testid": "xLabelsContainer"
  }, labels.map(function (label, idx) {
    return /*#__PURE__*/React__default.createElement(ChartLabel$1, {
      key: "label_" + idx,
      label: label.text,
      image: label.image,
      labelWidth: labelWidth
    });
  }));
}
var ChartXLabels$1 = observer(ChartXLabels);

function HorizontalLabel(_ref) {
  var label = _ref.label;
  return /*#__PURE__*/React__default.createElement("p", {
    "data-testid": "horizontalLabel",
    className: "lemo-horizontal-label lemo-text-body-m-medium lemo-color-text-03",
    dangerouslySetInnerHTML: {
      __html: label
    }
  });
}

function ChartVerticalLine() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart-vertical-line"
  });
}

var LABEL_CLASS = 'lemo-chart-label';
var TEXT_MARGIN_BOTTOM = 32;
var IMAGE_MARGIN_BOTTOM = 69;
function Chart(_ref) {
  var store = _ref.store;
  var _useState = useState(store.hasLabelImages ? IMAGE_MARGIN_BOTTOM : TEXT_MARGIN_BOTTOM),
    margin = _useState[0],
    setMargin = _useState[1];
  var baseElement = useRef();
  useDispatchOnResize(function () {
    if (baseElement.current) {
      var elements = baseElement.current.querySelectorAll("." + LABEL_CLASS);
      var maxSize = Array.from(elements).reduce(function (acc, next) {
        return Math.max(next.offsetHeight, acc);
      }, 0);
      setMargin(maxSize);
    }
  }, baseElement);
  useEffect(function () {
    window.dispatchEvent(new Event('resize'));
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart",
    ref: baseElement,
    style: {
      marginBottom: margin
    },
    "data-testid": "chart"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart-left-side"
  }, /*#__PURE__*/React__default.createElement(YAxis$1, {
    initialYValue: store.initialYValue,
    yValues: store.yValues,
    yAxisName: store.yAxisName,
    selectedValue: store.selectedValue
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart-right-side"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart-area"
  }, /*#__PURE__*/React__default.createElement(ChartVerticalLine, null), /*#__PURE__*/React__default.createElement(ChartContent$1, {
    yValues: store.yValues,
    store: store
  }), /*#__PURE__*/React__default.createElement(ChartXValues$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(ChartXLabels$1, {
    labelWidth: 100 / store.xLabels.length,
    labels: store.xLabels
  }), /*#__PURE__*/React__default.createElement(HorizontalLabel, {
    label: store.xAxisName
  }))));
}
var Chart$1 = observer(Chart);

function ChartTable(_ref) {
  var tableData = _ref.tableData;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart-table",
    "data-testid": "table"
  }, /*#__PURE__*/React__default.createElement("table", null, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, tableData.headerData.map(function (value, idx) {
    return /*#__PURE__*/React__default.createElement("th", {
      key: value + "__" + idx
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-item-header lemo-text-body-s-bold lemo-color-text-02",
      dangerouslySetInnerHTML: {
        __html: value + '&nbsp;'
      }
    }));
  }))), /*#__PURE__*/React__default.createElement("tbody", null, tableData.bodyData.map(function (row, rowIdx) {
    return /*#__PURE__*/React__default.createElement("tr", {
      key: "row_" + rowIdx
    }, row.map(function (cell, cellIdx) {
      return /*#__PURE__*/React__default.createElement("td", {
        key: "cell_" + cell + "_" + cellIdx
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "lemo-item-body lemo-text-body-s-medium lemo-color-text-03",
        dangerouslySetInnerHTML: {
          __html: cell + '&nbsp;'
        }
      }));
    }));
  }))));
}

function LegendItem$1(_ref) {
  var label = _ref.label,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? '' : _ref$theme;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-legend-item"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-color-swatch " + theme
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-text",
    dangerouslySetInnerHTML: {
      __html: label
    }
  }));
}

function Legend$1(_ref) {
  var labels = _ref.labels;
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "legend",
    className: "lemo-legend"
  }, labels.map(function (_ref2, idx) {
    var id = _ref2.id,
      label = _ref2.label,
      theme = _ref2.theme;
    return /*#__PURE__*/React__default.createElement(LegendItem$1, {
      key: id + "_" + idx,
      label: label,
      theme: theme
    });
  }));
}

var getCheckTablePosition = function getCheckTablePosition(store) {
  return function (position) {
    var _store$ui_style;
    var newPosition = fixBelowPosition((_store$ui_style = store.ui_style) === null || _store$ui_style === void 0 ? void 0 : _store$ui_style.chart_data_position);
    return newPosition === position;
  };
};

function BarchartQuestion(props) {
  var _cn;
  var store = props.store,
    _props$solutionsMode = props.solutionsMode,
    solutionsMode = _props$solutionsMode === void 0 ? false : _props$solutionsMode;
  var changedHandlers = /reset|setValue/;
  var checkTablePosition = getCheckTablePosition(store);
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-body",
    style: {
      overflowX: 'auto'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-chart-question', (_cn = {
      'lemo-disabled': !solutionsMode && store.disabled,
      'lemo-solutions-mode': solutionsMode
    }, _cn[TABLE_POSITION_ABOVE$1] = checkTablePosition(ABOVE$1), _cn[TABLE_POSITION_BELOW$1] = checkTablePosition(BELOW$1), _cn[TABLE_POSITION_LEFT$1] = checkTablePosition(LEFT$1), _cn[TABLE_POSITION_RIGHT$1] = checkTablePosition(RIGHT$3), _cn))
  }, !solutionsMode && store.showTable && /*#__PURE__*/React__default.createElement(ChartTable, {
    tableData: store.tableData
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '100%'
    }
  }, store.showLegend && /*#__PURE__*/React__default.createElement(Legend$1, {
    labels: store.yAxisLabels
  }), /*#__PURE__*/React__default.createElement(Chart$1, {
    store: store
  })))));
}
var BarchartQuestion$1 = observer(BarchartQuestion);

function Graphic(_ref) {
  var selected = _ref.selected,
    src = _ref.src,
    label = _ref.label;
  return /*#__PURE__*/React__default.createElement("img", {
    className: cn$1('lemo-category-img', {
      'lemo-selected': selected
    }),
    draggable: "false",
    src: src,
    alt: label
  });
}

function ImageList(_ref) {
  var imageList = _ref.imageList,
    value = _ref.value,
    label = _ref.label,
    feedbackResult = _ref.feedbackResult;
  var isEvaluated = feedbackResult !== feedback.NOT_EVALUATED;
  var isSuccess = feedbackResult === feedback.RIGHT;
  var isError = feedbackResult === feedback.WRONG;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-category-image-list', {
      'lemo-is-touch': isTouchDevice(),
      'lemo-success': isSuccess,
      'lemo-error': isError
    })
  }, /*#__PURE__*/React__default.createElement(FeedbackIcon, {
    isSuccess: isSuccess,
    isError: isError
  }), imageList.map(function (_ref2, idx) {
    var id = _ref2.id,
      src = _ref2.src;
    var selected = idx < value;
    return /*#__PURE__*/React__default.createElement(Graphic, {
      key: id,
      label: label,
      src: src,
      isEvaluated: isEvaluated,
      selected: selected
    });
  }));
}
var ImageList$1 = observer(ImageList);

var itemSize = 36;
var getMinHeight = function getMinHeight(itemsLength) {
  return {
    minHeight: itemsLength * itemSize + 30
  };
};
function Category(_ref) {
  var category = _ref.category;
  var imageList = category.imageList,
    label = category.label,
    setValue = category.setValue,
    value = category.value,
    feedbackResult = category.feedbackResult,
    fullImageList = category.fullImageList;
  var itemsLength = fullImageList.length + 1;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-category",
    "data-testid": "category",
    style: getMinHeight(itemsLength)
  }, /*#__PURE__*/React__default.createElement(VerticalSlider$1, {
    className: "lemo-category-slider",
    value: value,
    maxValue: imageList.length,
    onChange: setValue
  }), /*#__PURE__*/React__default.createElement(ImageList$1, {
    imageList: imageList,
    label: label,
    value: value,
    feedbackResult: feedbackResult
  }));
}
var Category$1 = observer(Category);

function RenderCategories(_ref) {
  var categories = _ref.categories;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-pictograph-categories"
  }, categories.map(function (category) {
    return /*#__PURE__*/React__default.createElement(Category$1, {
      key: category.id,
      category: category
    });
  }));
}

function Chart$2(_ref) {
  var yAxisName = _ref.yAxisName,
    xAxisName = _ref.xAxisName,
    categories = _ref.categories,
    xLabels = _ref.xLabels;
  var labelWidth = 100 / xLabels.length;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-pictograph"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-pictograph-container"
  }, /*#__PURE__*/React__default.createElement(VerticalLabel, {
    label: yAxisName
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      flexGrow: 1
    }
  }, /*#__PURE__*/React__default.createElement(RenderCategories, {
    categories: categories
  }), /*#__PURE__*/React__default.createElement(ChartXLabels$1, {
    labelWidth: labelWidth,
    labels: xLabels
  }), /*#__PURE__*/React__default.createElement(HorizontalLabel, {
    label: xAxisName
  }))));
}

var TABLE_POSITION_ABOVE$3 = 'lemo-table_position_above';
var TABLE_POSITION_BELOW$3 = 'lemo-table_position_below';
var TABLE_POSITION_LEFT$3 = 'lemo-table_position_left';
var TABLE_POSITION_RIGHT$3 = 'lemo-table_position_right';
var ABOVE$3 = 'ABOVE';
var BELOW$3 = 'BELOW';
var LEFT$5 = 'LEFT';
var RIGHT$b = 'RIGHT';

function PictographQuestion(props) {
  var _cn;
  var store = props.store,
    _props$solutionsMode = props.solutionsMode,
    solutionsMode = _props$solutionsMode === void 0 ? false : _props$solutionsMode;
  var changedHandlers = /reset|setValue/;
  var checkTablePosition = function checkTablePosition(position) {
    var _store$ui_style;
    return ((_store$ui_style = store.ui_style) === null || _store$ui_style === void 0 ? void 0 : _store$ui_style.chart_data_position) === position;
  };
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-body",
    style: {
      overflowX: 'auto'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-chart-question', (_cn = {
      'lemo-disabled': !solutionsMode && store.disabled,
      'lemo-solutions-mode': solutionsMode
    }, _cn[TABLE_POSITION_ABOVE$3] = checkTablePosition(ABOVE$3), _cn[TABLE_POSITION_BELOW$3] = checkTablePosition(BELOW$3), _cn[TABLE_POSITION_LEFT$3] = checkTablePosition(LEFT$5), _cn[TABLE_POSITION_RIGHT$3] = checkTablePosition(RIGHT$b), _cn))
  }, store.showTable && /*#__PURE__*/React__default.createElement(ChartTable, {
    tableData: store.tableData
  }), /*#__PURE__*/React__default.createElement(Chart$2, {
    yAxisName: store.yAxisName,
    xAxisName: store.xAxisName,
    categories: store.categories,
    xLabels: store.xLabels
  }))));
}
var PictographQuestion$1 = observer(PictographQuestion);

function ChartContent$2(_ref) {
  var yValues = _ref.yValues,
    store = _ref.store;
  var isSelected = function isSelected(idx) {
    return idx === store.selectedValue - 1 ? 'lemo-selected' : '';
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart-content"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart-line lemo-first-line"
  }), yValues.map(function (val, idx) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-chart-line " + isSelected(idx),
      key: "chartLines_" + val
    });
  }));
}
var ChartContent$3 = observer(ChartContent$2);

var isTouch$a = isTouchDevice();
var eventMove$2 = isTouch$a ? 'touchmove' : 'mousemove';
var eventUp$2 = isTouch$a ? 'touchend' : 'mouseup';
function Dot$4(_ref) {
  var dot = _ref.dot,
    canvas = _ref.canvas,
    stepValue = _ref.stepValue,
    xPosition = _ref.xPosition,
    yPosition = _ref.yPosition,
    dotRadius = _ref.dotRadius,
    steps = _ref.steps;
  function getCursorPoint(evt) {
    var pt = canvas.current.createSVGPoint();
    var currentEvt = isTouch$a ? evt.touches[0] : evt;
    pt.x = currentEvt.clientX;
    pt.y = currentEvt.clientY;
    return pt.matrixTransform(canvas.current.getScreenCTM().inverse());
  }
  function getPositionValue(evt) {
    var _getCursorPoint = getCursorPoint(evt),
      y = _getCursorPoint.y;
    var position = Math.max(Math.min(Math.round(y / stepValue), steps), 0);
    return steps - position;
  }
  function moveDot(evt) {
    dot.setValue(getPositionValue(evt));
    evt.preventDefault();
  }
  function mouseDown() {
    canvas.current.addEventListener(eventMove$2, moveDot, false);
    window.addEventListener(eventUp$2, mouseUp, false);
    dot.setSelected(true);
  }
  function mouseUp() {
    canvas.current.removeEventListener(eventMove$2, moveDot);
    window.removeEventListener(eventUp$2, mouseUp);
    dot.setSelected(false);
  }
  var isEvaluated = dot.isEvaluated;
  return /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("circle", {
    className: "lemo-dot",
    r: isEvaluated ? 10 : dotRadius / 2,
    cx: xPosition + "%",
    transform: "translate(0, " + yPosition + ")",
    style: {
      strokeWidth: dot.selected ? 8 : 3
    }
  }), /*#__PURE__*/React__default.createElement("circle", {
    className: "lemo-dot-handler",
    r: isEvaluated ? 6 : dotRadius * 2,
    cx: xPosition + "%",
    transform: "translate(0, " + yPosition + ")",
    onMouseDown: !isTouch$a ? mouseDown : null,
    onTouchStart: mouseDown
  }));
}
var Dot$5 = observer(Dot$4);

function DotConnection(_ref) {
  var lineConnection = _ref.lineConnection,
    getYPositionInPixels = _ref.getYPositionInPixels,
    getXPositionInPixels = _ref.getXPositionInPixels,
    _ref$onLineOver = _ref.onLineOver,
    onLineOver = _ref$onLineOver === void 0 ? noop : _ref$onLineOver,
    _ref$onLineClick = _ref.onLineClick,
    onLineClick = _ref$onLineClick === void 0 ? noop : _ref$onLineClick,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'lemo-dot-connection' : _ref$className;
  var lineConfig = lineConnection.reduce(function (acc, next, idx) {
    return idx === 0 ? "M" + getXPositionInPixels(next.x) + " " + getYPositionInPixels(next.y) + " " : acc.concat("L" + getXPositionInPixels(next.x) + " " + getYPositionInPixels(next.y) + " ");
  }, '');
  return /*#__PURE__*/React__default.createElement("path", {
    className: className,
    d: lineConfig,
    onMouseOver: function onMouseOver() {
      return onLineOver(true);
    },
    onMouseOut: function onMouseOut() {
      return onLineOver(false);
    },
    onMouseDown: onLineClick
  });
}
var DotConnection$1 = observer(DotConnection);

function Line$c(_ref) {
  var line = _ref.line,
    canvas = _ref.canvas,
    canvasHeight = _ref.canvasHeight,
    canvasWidth = _ref.canvasWidth,
    dotRadius = _ref.dotRadius,
    steps = _ref.steps;
  var stepValue = canvasHeight / steps;
  var _useState = useState(false),
    hoverLine = _useState[0],
    setHoverLine = _useState[1];
  function getYPositionInPixels(value) {
    return (steps - value) * stepValue + dotRadius;
  }
  function getXPositionInPixels(value) {
    return value * (canvasWidth / 100);
  }
  return /*#__PURE__*/React__default.createElement("g", {
    id: line.id,
    "data-testid": "line",
    className: cn$1('lemo-line', line.theme, {
      'lemo-selected': line.isSelected,
      'lemo-mouse-over': hoverLine,
      'lemo-success': line.isSuccess,
      'lemo-error': line.isWrong
    })
  }, /*#__PURE__*/React__default.createElement(DotConnection$1, {
    className: "lemo-dot-connection-feedback",
    lineConnection: line.lineConnection,
    getYPositionInPixels: getYPositionInPixels,
    getXPositionInPixels: getXPositionInPixels,
    onLineOver: setHoverLine,
    onLineClick: function onLineClick() {
      return line.selectLine();
    }
  }), /*#__PURE__*/React__default.createElement(DotConnection$1, {
    className: "lemo-dot-connection",
    lineConnection: line.lineConnection,
    getYPositionInPixels: getYPositionInPixels,
    getXPositionInPixels: getXPositionInPixels
  }), line.dots.map(function (dot) {
    return /*#__PURE__*/React__default.createElement(Dot$5, {
      key: dot.id,
      dot: dot,
      xPosition: dot.xPosition,
      yPosition: getYPositionInPixels(dot.y),
      stepValue: stepValue,
      canvas: canvas,
      dotRadius: dotRadius,
      theme: line.theme,
      steps: steps
    });
  }));
}
var Line$d = observer(Line$c);

function VerticalLine(_ref) {
  var xPosition = _ref.xPosition,
    canvasHeight = _ref.canvasHeight,
    dotRadius = _ref.dotRadius;
  return /*#__PURE__*/React__default.createElement("line", {
    className: "lemo-vertical-line",
    y1: dotRadius,
    y2: canvasHeight - dotRadius,
    x1: xPosition + "%",
    x2: xPosition + "%"
  });
}
var VerticalLine$1 = observer(VerticalLine);

var dotRadius = 16;
var canvasHeight = 380;
function ChartCanvas(_ref) {
  var store = _ref.store;
  var canvas = useRef();
  var _useState = useState(1),
    canvasWidth = _useState[0],
    setCanvasWidth = _useState[1];
  function updateCanvasWidth() {
    setCanvasWidth(canvas.current.clientWidth);
  }
  useLayoutEffect(function () {
    updateCanvasWidth();
    window.addEventListener('resize', updateCanvasWidth, false);
    return function () {
      return window.removeEventListener('resize', updateCanvasWidth);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart-canvas",
    style: {
      top: -dotRadius
    }
  }, /*#__PURE__*/React__default.createElement("svg", {
    ref: canvas,
    width: "100%",
    height: canvasHeight
  }, /*#__PURE__*/React__default.createElement("rect", {
    className: "lemo-canvas-base",
    width: "100%",
    height: "100%",
    fill: "none"
  }), store.chart[0].dots.map(function (dot) {
    return /*#__PURE__*/React__default.createElement(VerticalLine$1, {
      key: "verticalLine_" + dot.id,
      dotRadius: dotRadius,
      xPosition: dot.xPosition,
      canvasHeight: canvasHeight
    });
  }), store.lines.map(function (line) {
    var _canvas$current;
    return /*#__PURE__*/React__default.createElement(Line$d, {
      key: line.id,
      line: line,
      canvas: canvas,
      canvasHeight: canvasHeight - dotRadius * 2,
      canvasWidth: ((_canvas$current = canvas.current) === null || _canvas$current === void 0 ? void 0 : _canvas$current.clientWidth) || canvasWidth,
      dotRadius: dotRadius,
      steps: store.maxValue
    });
  })));
}
var ChartCanvas$1 = observer(ChartCanvas);

var LABEL_CLASS$1 = 'lemo-chart-label';
var TEXT_MARGIN_BOTTOM$1 = 32;
function Chart$3(_ref) {
  var store = _ref.store;
  var _useState = useState(TEXT_MARGIN_BOTTOM$1),
    margin = _useState[0],
    setMargin = _useState[1];
  var baseElement = useRef();
  useDispatchOnResize(function () {
    if (baseElement.current) {
      var elements = baseElement.current.querySelectorAll("." + LABEL_CLASS$1);
      var maxSize = Array.from(elements).reduce(function (acc, next) {
        return Math.max(next.offsetHeight, acc);
      }, 0);
      setMargin(maxSize + 32);
    }
  }, baseElement);
  function resize() {
    window.dispatchEvent(new Event('resize'));
  }
  useEffect(function () {
    resize();
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart-wrapper"
  }, store.showLegend && /*#__PURE__*/React__default.createElement(Legend$1, {
    labels: store.yAxisLabels
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart",
    ref: baseElement,
    "data-testid": "chart",
    style: {
      marginBottom: margin
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart-left-side"
  }, /*#__PURE__*/React__default.createElement(YAxis$1, {
    initialYValue: store.initialYValue,
    yValues: store.yValues,
    yAxisName: store.yAxisName,
    selectedValue: store.selectedValue
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart-right-side"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart-area"
  }, /*#__PURE__*/React__default.createElement(ChartContent$3, {
    yValues: store.yValues,
    store: store
  }), /*#__PURE__*/React__default.createElement(ChartCanvas$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(ChartXLabels$1, {
    labelWidth: 100 / store.xLabels.length,
    labels: store.xLabels
  }), /*#__PURE__*/React__default.createElement(HorizontalLabel, {
    label: store.xAxisName
  })))));
}
var Chart$4 = observer(Chart$3);

function LineChartQuestion(props) {
  var _cn;
  var store = props.store,
    _props$solutionsMode = props.solutionsMode,
    solutionsMode = _props$solutionsMode === void 0 ? false : _props$solutionsMode;
  var changedHandlers = /setSelected|reset|setValue|selectLine|setResponse/;
  var checkTablePosition = getCheckTablePosition(store);
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-body",
    style: {
      overflowX: 'auto'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-chart-question', (_cn = {
      'lemo-disabled': !solutionsMode && store.disabled,
      'lemo-solutions-mode': solutionsMode
    }, _cn[TABLE_POSITION_ABOVE$2] = checkTablePosition(ABOVE$2), _cn[TABLE_POSITION_BELOW$2] = checkTablePosition(BELOW$2), _cn[TABLE_POSITION_LEFT$2] = checkTablePosition(LEFT$3), _cn[TABLE_POSITION_RIGHT$2] = checkTablePosition(RIGHT$9), _cn))
  }, store.showTable && !solutionsMode && /*#__PURE__*/React__default.createElement(ChartTable, {
    tableData: store.tableData
  }), /*#__PURE__*/React__default.createElement(Chart$4, {
    store: store
  }))));
}
var LineChartQuestion$1 = observer(LineChartQuestion);

var SLICE_CLASS_NAME$1 = 'fractional-shape-slice';
function useFigure$1(store) {
  var base = useRef();
  useEffect(function () {
    renderShape();
  }, []);
  useEffect(function () {
    renderShape();
    addInteraction();
  }, [store.updateFigure, store.showSolution]);
  function updateFigureFromStore() {
    getSlices().forEach(function (slice, idx) {
      if (idx >= store.slices.length) return false;
      slice.setAttribute('class', SLICE_CLASS_NAME$1 + " " + store.slices[idx].theme);
    });
  }
  function updateSliceFromStore(idx) {
    var theme = store.slices[idx].theme;
    getSliceIdx(idx).setAttribute('class', SLICE_CLASS_NAME$1 + " " + theme);
  }
  function renderShape() {
    renderFractionalShape(base.current, {
      type: CIRCLE,
      divisions: store.divisions,
      fill: 0
    });
    updateFigureFromStore();
  }
  function addInteraction() {
    var slices = getSlices();
    slices.forEach(function (slice, idx) {
      slice.addEventListener('mousedown', function () {
        if (store.isEvaluated) return false;
        store.paintSlice(idx);
        updateSliceFromStore(idx);
      });
    });
  }
  function getSlices() {
    return base.current.querySelectorAll("." + SLICE_CLASS_NAME$1);
  }
  function getSliceIdx(idx) {
    return base.current.querySelectorAll("." + SLICE_CLASS_NAME$1)[idx];
  }
  return {
    base: base
  };
}

function Figure$4(_ref) {
  var store = _ref.store;
  var isEvaluated = store.isEvaluated,
    points = store.points,
    showSolution = store.showSolution;
  var _useFigure = useFigure$1(store),
    base = _useFigure.base;
  var drawingTheme = store.currentTheme ? "lemo-drawing-theme " + store.currentTheme : '';
  var isSuccess = isEvaluated && points === 1 || showSolution;
  var isError = isEvaluated && points < 1 && !showSolution;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-pie-figure', drawingTheme, {
      'lemo-success': isSuccess,
      'lemo-error': isError
    }),
    ref: base
  });
}
var Figure$5 = observer(Figure$4);

function CategoryButton(_ref) {
  var label = _ref.label,
    theme = _ref.theme,
    pieIsReady = _ref.pieIsReady,
    onClick = _ref.onClick,
    isSelected = _ref.isSelected;
  return /*#__PURE__*/React__default.createElement("button", {
    key: label,
    className: cn$1('lemo-category', theme, {
      'lemo-selected': isSelected
    }),
    disabled: !pieIsReady,
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-category-content"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-category-icon"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-category-text"
  }, label)));
}

function Categories(_ref) {
  var store = _ref.store,
    isSmallScreen = _ref.isSmallScreen;
  var selectedCategory = isSmallScreen ? store.selectedCategoryIdx || 0 : store.selectedCategoryIdx;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-categories",
    "data-testid": "categories"
  }, store.categories.map(function (category, idx) {
    return /*#__PURE__*/React__default.createElement(CategoryButton, {
      key: category.label,
      label: category.label,
      theme: category.theme,
      pieIsReady: store.pieIsReady,
      isSelected: selectedCategory === idx,
      onClick: function onClick() {
        return store.setSelectedCategoryIdx(idx);
      }
    });
  }));
}
var Categories$1 = observer(Categories);

function TotalItemsInput(_ref) {
  var store = _ref.store;
  var isEvaluated = store.isEvaluated,
    points = store.points,
    showSolution = store.showSolution;
  var isSuccess = isEvaluated && points >= 0.5 || showSolution;
  var isError = isEvaluated && points < 0.5 && !showSolution;
  var isInitialState = store.divisions === 1 && !showSolution;
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "totalItemsInput",
    className: cn$1('lemo-total-items-input', {
      'lemo-initial-state': isInitialState,
      'lemo-success': isSuccess,
      'lemo-error': isError
    })
  }, /*#__PURE__*/React__default.createElement("span", null, translate('pie_chart_total_items_input')), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-total-items-input-value-box"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-total-items-input-value",
    "data-testid": "divisions"
  }, store.divisions)), /*#__PURE__*/React__default.createElement("span", null, "."));
}
var TotalItemsInput$1 = observer(TotalItemsInput);

function HorizontalChartTable(_ref) {
  var tableData = _ref.tableData;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-horizontal-chart-table",
    "data-testid": "table"
  }, /*#__PURE__*/React__default.createElement("table", null, /*#__PURE__*/React__default.createElement("tbody", null, tableData.bodyData.map(function (row, rowIdx) {
    return /*#__PURE__*/React__default.createElement("tr", {
      key: "row_" + rowIdx
    }, /*#__PURE__*/React__default.createElement("th", null, /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-item-header lemo-text-body-s-bold lemo-color-text-02",
      dangerouslySetInnerHTML: {
        __html: tableData.headerData[rowIdx] + '&nbsp;'
      }
    })), row.map(function (cell, cellIdx) {
      return /*#__PURE__*/React__default.createElement("td", {
        key: "cell_" + cell + "_" + cellIdx
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "lemo-item-body lemo-text-body-s-regular lemo-color-text-03",
        dangerouslySetInnerHTML: {
          __html: cell + '&nbsp;'
        }
      }));
    }));
  }))));
}

function CountButton(_ref) {
  var onClick = _ref.onClick,
    title = _ref.title,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-count-button",
    disabled: disabled,
    title: title,
    onClick: onClick
  }, children);
}
var CountButton$1 = observer(CountButton);

var responsiveIconNames = {
  DESKTOP: 'desktop',
  HORIZONTAL_TABLET: 'horizontal-tablet',
  VERTICAL_TABLET: 'vertical-tablet',
  VERTICAL_MOBILE: 'vertical-mobile'
};

var HORIZONTAL_TABLET_SIZE = 1024;
var VERTICAL_TABLET_SIZE = 768;
var VERTICAL_MOBILE_SIZE = 360;
var responsiveSizes = [{
  icon: responsiveIconNames.DESKTOP,
  name: 'Desktop',
  className: 'lemo-display-Desktop',
  width: '100%'
}, {
  icon: responsiveIconNames.HORIZONTAL_TABLET,
  name: '1024',
  className: 'lemo-display-1024',
  width: HORIZONTAL_TABLET_SIZE
}, {
  icon: responsiveIconNames.VERTICAL_TABLET,
  name: '768',
  className: 'lemo-display-768',
  width: VERTICAL_TABLET_SIZE
}, {
  icon: responsiveIconNames.VERTICAL_MOBILE,
  name: '360',
  className: 'lemo-display-360',
  width: VERTICAL_MOBILE_SIZE
}];

var INC_DIVISIONS = 'incDivisions';
var DEC_DIVISIONS = 'decDivisions';
function PieChartQuestion(props) {
  var _cn;
  var store = props.store,
    _props$solutionsMode = props.solutionsMode,
    solutionsMode = _props$solutionsMode === void 0 ? false : _props$solutionsMode;
  var changedHandlers = /incDivisions|decDivisions|reset|setSelectedCategoryIdx|paintSlice/;
  var templateWrapper = useRef();
  var _useState = useState(false),
    isSmallScreen = _useState[0],
    setIsSmallScreen = _useState[1];
  useResizeHandler2(templateWrapper, checkScreenSize);
  function checkScreenSize(_ref) {
    var w = _ref.w;
    setIsSmallScreen(w < VERTICAL_TABLET_SIZE);
  }
  var checkTablePosition = function checkTablePosition(position) {
    var _store$ui_style;
    return ((_store$ui_style = store.ui_style) === null || _store$ui_style === void 0 ? void 0 : _store$ui_style.chart_data_position) === position;
  };
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-body",
    ref: templateWrapper,
    style: {
      overflowX: 'auto'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-chart-question', (_cn = {
      'lemo-disabled': !solutionsMode && store.disabled,
      'lemo-solutions-mode': solutionsMode,
      'lemo-small-screen': isSmallScreen,
      'lemo-is-touch': isTouchDevice()
    }, _cn[TABLE_POSITION_ABOVE] = checkTablePosition(ABOVE), _cn[TABLE_POSITION_BELOW] = checkTablePosition(BELOW), _cn[TABLE_POSITION_LEFT] = checkTablePosition(LEFT$4), _cn[TABLE_POSITION_RIGHT] = checkTablePosition(RIGHT$a), _cn))
  }, /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: !solutionsMode
  }, store.isHorizontalTable ? /*#__PURE__*/React__default.createElement(HorizontalChartTable, {
    tableData: store.horizontalTableData
  }) : /*#__PURE__*/React__default.createElement(ChartTable, {
    tableData: store.tableData
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(TotalItemsInput$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-pie-chart-controls"
  }, /*#__PURE__*/React__default.createElement(CountButton$1, {
    disabled: store.disabled,
    title: INC_DIVISIONS,
    onClick: function onClick() {
      return store.incDivisions();
    }
  }, /*#__PURE__*/React__default.createElement(SvgPlusCircle, null)), /*#__PURE__*/React__default.createElement(Figure$5, {
    store: store
  }), /*#__PURE__*/React__default.createElement(CountButton$1, {
    disabled: store.disabled,
    title: DEC_DIVISIONS,
    onClick: function onClick() {
      return store.decDivisions();
    }
  }, /*#__PURE__*/React__default.createElement(SvgMinusCircle, null))), /*#__PURE__*/React__default.createElement(Categories$1, {
    store: store,
    isSmallScreen: isSmallScreen
  })))));
}
var PieChartQuestion$1 = observer(PieChartQuestion);

var SliceModel = types$1.compose(ValueModel, types$1.model({}).actions(function (state) {
  return {
    setValue: function setValue(value) {
      state.value = value;
      getParent(state, 2).setNewUpdate();
    },
    reset: function reset() {
      state.setValue('');
      getParent(state, 2).setNewUpdate();
    }
  };
}).views(function (state) {
  return {
    get category() {
      if (state.value === undefined) return false;
      return getParent(state, 2).categories[state.value];
    },
    get theme() {
      var _state$category;
      return ((_state$category = state.category) === null || _state$category === void 0 ? void 0 : _state$category.theme) || undefined;
    },
    get label() {
      var _state$category2;
      return ((_state$category2 = state.category) === null || _state$category2 === void 0 ? void 0 : _state$category2.label) || undefined;
    }
  };
}));

function checkPlainResponseFormat(response) {
  return typeChecker(types$1.array(types$1.maybeNull(types$1.string)), response);
}
function applyPlainResponse(state, responseList) {
  state.slices.forEach(function (slice, idx) {
    var categoryIndex = state.categories.findIndex(function (_ref) {
      var label = _ref.label;
      return label === responseList[idx];
    });
    slice.setValue(categoryIndex);
  });
}
function checkObjectResponseFormat(response) {
  var itemModel = types$1.model({
    label: types$1.string,
    value: types$1.number
  });
  return typeChecker(types$1.array(itemModel), response);
}
function applyObjectResponse(state, responseList) {
  var normalizedResponse = responseList.reduce(function (acc, next) {
    if (!next.value || !next.label) return acc;
    var itemList = populate(next.value, function () {
      return next.label;
    });
    return [].concat(acc, itemList);
  }, []);
  state.setDivisions(normalizedResponse.length);
  applyPlainResponse(state, normalizedResponse);
}
function setResponse$2(state, response) {
  if (checkPlainResponseFormat(response)) {
    state.setDivisions(response.length);
    return applyPlainResponse(state, response);
  }
  if (checkObjectResponseFormat(response)) {
    state.setDivisions(response.length);
    return applyObjectResponse(state, response);
  }
}

function groupValues(list) {
  if (!typeChecker(types$1.array(types$1.maybeNull(types$1.string)), list)) return list;
  return list.reduce(function (acc, next) {
    var foundItemIndex = acc.findIndex(function (_ref) {
      var label = _ref.label;
      return label === next;
    });
    if (foundItemIndex === -1) {
      return [].concat(acc, [{
        label: next,
        value: 1
      }]);
    }
    acc[foundItemIndex].value += 1;
    return acc;
  }, []);
}

function isValidResponse(state) {
  var value = groupValues(state.validation.value);
  var userResponse = groupValues(getNormalizedResponse(state.getUserResponse()));
  if (value.length !== userResponse.length) return false;
  return value.reduce(function (acc, next) {
    var currentCategory = userResponse.find(function (_ref) {
      var label = _ref.label;
      return label === next.label;
    });
    return (currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.value) === next.value ? acc : false;
  }, true);
}
function getNormalizedResponse(response) {
  return response.length === 1 && response[0] === null ? [] : response;
}
function validateSlicesLength(state) {
  var value = groupValues(state.validation.value);
  var validSlicesLength = value.reduce(function (acc, next) {
    return next === null ? acc : acc + next.value;
  }, 0);
  var userSlicesLength = state.slices.length;
  return validSlicesLength === userSlicesLength ? 0.5 : 0;
}
function getResults$1(state) {
  return isValidResponse(state) ? 1 : validateSlicesLength(state);
}

function spreadValues(list) {
  if (checkPlainResponseFormat(list)) return list;
  return list.reduce(function (acc, next) {
    return [].concat(acc, spread(next));
  }, []);
}
function spread(item) {
  return populate(item.value, function () {
    return item.label;
  });
}

var maxDivisions$2 = 16;
var PieChartQuestionStore = types$1.compose(QuestionBaseModel, withXAPITypeOther$1({
  xAPISolution: function xAPISolution(state) {
    return formatResponses(state.validation.value.map(function (_ref) {
      var label = _ref.label,
        value = _ref.value;
      return label + "[.]" + value;
    }));
  }
}), types$1.model({
  divisions: types$1.optional(types$1.number, 1),
  slices: types$1.optional(types$1.array(SliceModel), [{}]),
  keyboard: types$1.optional(KeyboardStore, {}),
  selectedCategoryIdx: types$1.maybe(types$1.number),
  updateFigure: types$1.optional(types$1.number, 0)
}).actions(function (state) {
  return {
    addSlices: function addSlices(difference) {
      var newLength = state.slices.length + Math.abs(difference);
      while (state.slices.length < newLength) {
        state.slices.splice(state.slices.length, 0, {});
      }
      this.setNewUpdate();
    },
    setNewUpdate: function setNewUpdate() {
      state.updateFigure = state.updateFigure + 1;
    },
    removeSlices: function removeSlices(difference) {
      state.slices.splice(state.slices.length - difference, difference);
      state.slices.length === 1 && state.slices[0].reset();
    },
    initChart: function initChart(divisions) {
      state.setSelectedCategoryIdx(when()["case"](divisions < 2, function () {
        return undefined;
      })["case"](state.selectedCategoryIdx === undefined, function () {
        return 0;
      }).resolve(state.selectedCategoryIdx));
    },
    updateSlices: function updateSlices(normalizedValue) {
      var difference = state.slices.length - normalizedValue;
      difference > 0 ? state.removeSlices(difference) : state.addSlices(difference);
    },
    incDivisions: function incDivisions() {
      if (state.divisions < maxDivisions$2) {
        state.setDivisions(state.divisions + 1);
      }
    },
    decDivisions: function decDivisions() {
      if (state.divisions > 1) {
        state.setDivisions(state.divisions - 1);
      }
    },
    setDivisions: function setDivisions(divisions) {
      state.divisions = divisions;
      state.initChart(divisions);
      state.updateSlices(divisions);
    },
    setSelectedCategoryIdx: function setSelectedCategoryIdx(idx) {
      state.selectedCategoryIdx = idx;
    },
    paintSlice: function paintSlice(idx) {
      if (!state.selectedCategoryIdx === undefined) return false;
      var selectedSlice = state.slices[idx];
      selectedSlice.setValue(selectedSlice.value !== state.selectedCategoryIdx ? state.selectedCategoryIdx : undefined);
    },
    setResponse: function setResponse(response) {
      setResponse$2(state, response);
    },
    reset: function reset() {
      state.baseReset();
      state.setDivisions(1);
      state.slices.map(function (slice) {
        return slice.reset();
      });
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {
      applySnapshot(state, _createSnapshot$18(rawData));
      state.setIsSolutionMode(true);
      return new Promise(function (resolve) {
        return setTimeout(resolve, 100);
      });
    }
  };
}).views(function (state) {
  return {
    get chartData() {
      return state.raw.data.chart_data;
    },
    get categories() {
      var categories = state.chartData.data;
      return categories.reduce(function (acc, next, idx) {
        if (idx === 0) return [next];
        var labels = acc.map(function (item) {
          return item.label;
        });
        return labels.includes(next.label) ? acc : [].concat(acc, [next]);
      }, []);
    },
    get normalizedTableValues() {
      var value = groupValues(state.validation.value);
      return state.categories.map(function (category) {
        var foundItem = value.find(function (item) {
          return item !== null && item.label === category.label;
        });
        return foundItem || {
          label: category.label,
          value: 0
        };
      });
    },
    get isHorizontalTable() {
      var maxTextCharactersLength = 90;
      var textHeadersLength = state.chartData.data.reduce(function (acc, next) {
        return acc + next.label.length;
      }, 0);
      var hasAppropriateTextLength = textHeadersLength < maxTextCharactersLength;
      var has3Categories = state.categories.length < 4;
      var isInVerticalPosition = [ABOVE, BELOW].includes(state.ui_style.chart_data_position);
      return hasAppropriateTextLength && has3Categories && isInVerticalPosition;
    },
    get tableData() {
      return {
        headerData: state.chartData.labels,
        bodyData: state.normalizedTableValues.map(function (_ref2) {
          var label = _ref2.label,
            value = _ref2.value;
          return [label, parseInt(value)];
        })
      };
    },
    get horizontalTableData() {
      return {
        headerData: state.chartData.labels,
        bodyData: [state.normalizedTableValues.map(function (_ref3) {
          var label = _ref3.label;
          return label;
        }), state.normalizedTableValues.map(function (_ref4) {
          var value = _ref4.value;
          return value;
        })]
      };
    },
    get currentTheme() {
      var _state$categories, _state$categories$sta;
      return ((_state$categories = state.categories) === null || _state$categories === void 0 ? void 0 : (_state$categories$sta = _state$categories[state.selectedCategoryIdx]) === null || _state$categories$sta === void 0 ? void 0 : _state$categories$sta.theme) || '';
    },
    get pieIsReady() {
      return state.slices.length > 1;
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$18(rawData);
    },
    getUserResponse: function getUserResponse() {
      return state.slices.map(function (slice) {
        return slice.label || null;
      });
    },
    getValidResponses: function getValidResponses() {
      return state.points === 1 ? state.getUserResponse() : spreadValues(state.validation.value);
    },
    getResults: function getResults() {
      return state.isSolutionMode ? 0 : getResults$1(state);
    }
  };
}));
function _createSnapshot$18(data) {
  return _extends({}, data.data, importCommonValues(data));
}
function createStore$1o(data) {
  return PieChartQuestionStore.create(_createSnapshot$18(data));
}

function InlineTitles(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'lemo-editor-inline-titles'
  }, children);
}
var InlineTitles$1 = observer(InlineTitles);

function TextLabelContainer(_ref) {
  var text = _ref.text,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-text-label-container " + className
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-text"
  }, text), children);
}
var TextLabelContainer$1 = observer(TextLabelContainer);

function EditorInputWithLabel(_ref) {
  var label = _ref.label,
    value = _ref.value,
    setValue = _ref.setValue,
    placeholder = _ref.placeholder,
    errorText = _ref.errorText;
  return /*#__PURE__*/React__default.createElement(TextLabelContainer$1, {
    className: "lemo-editor-table-title",
    text: label
  }, /*#__PURE__*/React__default.createElement(EditorInputText$1, {
    defaultValue: value,
    isError: errorText,
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      return setValue(value);
    },
    placeholder: placeholder
  }), errorText && /*#__PURE__*/React__default.createElement(ErrorMessage$2, {
    className: "lemo-table-title-error-message",
    message: errorText
  }));
}
var EditorInputWithLabel$1 = observer(EditorInputWithLabel);

function ColorSwatch(_ref) {
  var theme = _ref.theme,
    onClick = _ref.onClick;
  return /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-swatch-selector " + theme,
    onClick: onClick
  });
}

function ThemeDraggableItem(_ref) {
  var item = _ref.item,
    openSwatchList = _ref.openSwatchList,
    placeholder = _ref.placeholder,
    _ref$hideSwatch = _ref.hideSwatch,
    hideSwatch = _ref$hideSwatch === void 0 ? false : _ref$hideSwatch;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-theme-draggable-item"
  }, /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: !hideSwatch
  }, /*#__PURE__*/React__default.createElement(ColorSwatch, {
    theme: item.theme,
    onClick: function onClick() {
      return openSwatchList(item);
    }
  })), /*#__PURE__*/React__default.createElement(EditorInputText$1, {
    defaultValue: item.label,
    isError: item.label.length === 0,
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      return item.setLabel(value);
    },
    placeholder: translate(placeholder)
  }));
}
var ThemeDraggableItem$1 = observer(ThemeDraggableItem);

function ColorSwatchItemList(_ref) {
  var theme = _ref.theme,
    isSelected = _ref.isSelected,
    onClick = _ref.onClick;
  var selectedClass = isSelected ? 'lemo-selected' : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-color-swatch-item-list " + selectedClass,
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(ColorSwatch, {
    theme: theme,
    onClick: noop
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-text"
  }, translate(theme)));
}

function ColorSwatchList(_ref) {
  var getColor = _ref.getColor,
    setColor = _ref.setColor;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-color-swatch-list"
  }, themeNames$1.map(function (theme, idx) {
    return /*#__PURE__*/React__default.createElement(ColorSwatchItemList, {
      key: theme,
      theme: theme,
      isSelected: getColor === theme,
      onClick: function onClick() {
        return setColor(idx);
      }
    });
  }));
}

function ColorWatchPopover(_ref) {
  var setPopoverTarget = _ref.setPopoverTarget,
    getTargetElement = _ref.getTargetElement,
    getColor = _ref.getColor,
    setColor = _ref.setColor;
  return /*#__PURE__*/React__default.createElement(PopoverWrapper$1, {
    targetElement: getTargetElement(),
    onClickOutside: function onClickOutside() {
      return setPopoverTarget(-1);
    }
  }, /*#__PURE__*/React__default.createElement(ColorSwatchList, {
    getColor: getColor,
    setColor: setColor
  }));
}

function SerieListEditor(_ref) {
  var dataModel = _ref.dataModel,
    customAddItem = _ref.customAddItem,
    addButtonTooltipDescription = _ref.addButtonTooltipDescription,
    _ref$addButtonText = _ref.addButtonText,
    addButtonText = _ref$addButtonText === void 0 ? 'add_serie' : _ref$addButtonText,
    _ref$listHeader = _ref.listHeader,
    listHeader = _ref$listHeader === void 0 ? 'series' : _ref$listHeader,
    _ref$hideSwatchIfSing = _ref.hideSwatchIfSingleItem,
    hideSwatchIfSingleItem = _ref$hideSwatchIfSing === void 0 ? false : _ref$hideSwatchIfSing,
    _ref$itemListPlacehol = _ref.itemListPlaceholder,
    itemListPlaceholder = _ref$itemListPlacehol === void 0 ? 'serie_placeholder' : _ref$itemListPlacehol,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 1 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 3 : _ref$max;
  var _useState = useState(-1),
    popoverTarget = _useState[0],
    setPopoverTarget = _useState[1];
  var root = useRef();
  var hideSwatch = dataModel.list.length < 2 && hideSwatchIfSingleItem;
  var addButtonDisabled = dataModel.list.length >= max;
  function openSwatchList(item) {
    setPopoverTarget(item.index);
  }
  function getPopoverTarget() {
    return root.current.querySelectorAll('.lemo-swatch-selector')[popoverTarget];
  }
  function updateColor(color) {
    var item = dataModel.list[popoverTarget];
    item.setTheme(color);
    setPopoverTarget(-1);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    ref: root,
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React__default.createElement(TextLabelContainer$1, {
    className: "lemo-serie-list-editor",
    text: translate(listHeader)
  }, /*#__PURE__*/React__default.createElement(EditorItemList$1, {
    itemList: dataModel.list,
    addButtonText: translate(addButtonText),
    addButtonDisabled: addButtonDisabled,
    onAddItem: customAddItem || dataModel.addItem,
    onDragItem: dataModel.sortItems,
    onRemoveItem: dataModel.removeItem,
    addButtonTooltipDescription: translate(addButtonTooltipDescription),
    min: min
  }, function (item) {
    return /*#__PURE__*/React__default.createElement(ThemeDraggableItem$1, {
      placeholder: itemListPlaceholder,
      item: item,
      openSwatchList: openSwatchList,
      hideSwatch: hideSwatch
    });
  })), popoverTarget > -1 && /*#__PURE__*/React__default.createElement(ColorWatchPopover, {
    setPopoverTarget: setPopoverTarget,
    getTargetElement: getPopoverTarget,
    getColor: dataModel.list[popoverTarget].theme,
    setColor: updateColor
  }));
}
var SerieListEditor$1 = observer(SerieListEditor);

var idBox$8 = 'Table';
var titleBoxRef$7 = 'table_editor';
var titleBoxHelpRef$7 = 'piechart_table_editor_help';
var labelEmptyError = 'piechart_table_title_error_empty';
var labelText = 'charts_pie_chart_table_title';
var placeholder = 'charts_pie_chart_table_title_placeholder';
var MIN_SERIES = 3;
var MAX_SERIES = 5;
function EditorPieChartTable(_ref) {
  var chartData = _ref.chartData;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: idBox$8,
    icon: /*#__PURE__*/React__default.createElement(SvgMenuAlt, {
      width: "24"
    }),
    titleBox: translate(titleBoxRef$7),
    helpText: translate(titleBoxHelpRef$7),
    classNameAdd: "lemo-editor-line-chart-table"
  }, /*#__PURE__*/React__default.createElement(InlineTitles$1, null, chartData.labels.map(function (label, idx) {
    var errorText = label.length === 0 && translate(labelEmptyError);
    return /*#__PURE__*/React__default.createElement(EditorInputWithLabel$1, {
      key: "label-" + idx,
      value: label,
      placeholder: translate(placeholder),
      label: translate(labelText) + " " + (idx + 1),
      setValue: function setValue(label) {
        return chartData.setLabel({
          idx: idx,
          label: label
        });
      },
      errorText: errorText
    });
  })), /*#__PURE__*/React__default.createElement(SerieListEditor$1, {
    addButtonText: "charts_pie_chart_add_element",
    addButtonTooltipDescription: "charts_pie_chart_add_element_tooltip",
    listHeader: "charts_pie_chart_elements",
    itemListPlaceholder: "charts_pie_chart_elements_placeholder",
    itemListEmptyError: "charts_pie_chart_elements_error_empty",
    min: MIN_SERIES,
    max: MAX_SERIES,
    dataModel: chartData.data
  }));
}
var EditorPieChartTable$1 = observer(EditorPieChartTable);

var iconTitle$8 = /*#__PURE__*/React__default.createElement(SvgAdjustments, {
  width: 24,
  className: "lemo-icon-format-shape",
  style: {
    transform: 'rotate(90deg)'
  }
});
var titleBox$8 = 'Configuration';
var helpText$8 = 'config_help';
function LineChartEditorConfig(_ref) {
  var _store$ui_style;
  var store = _ref.store;
  var tablePositionsList = useMemo(function () {
    return [ABOVE$2, LEFT$3, RIGHT$9].map(translate);
  }, [config.lang]);
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "configuration",
    icon: iconTitle$8,
    titleBox: translate(titleBox$8),
    helpText: translate(helpText$8),
    classNameAdd: "lemo-editor-config"
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('table_position'),
    subtitle: translate('table_position_description'),
    selectedIndex: store.ui_style.tablePositionIndex,
    itemList: tablePositionsList,
    onChange: store.ui_style.setTablePosition
  }), config.showAuthorVariantsEditor && /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(ConfigVariantStyle$1, {
    onChange: function onChange(value) {
      store.ui_style.customClass.setVariant(value.variant);
      store.ui_style.customClass.setClassList(value.classList);
    },
    variantList: store.variants,
    customClass: {
      variant: (_store$ui_style = store.ui_style) === null || _store$ui_style === void 0 ? void 0 : _store$ui_style.customClass.variant,
      classList: store.ui_style.customClass.classList
    }
  })));
}
var PieChartEditorConfig = observer(LineChartEditorConfig);

var _excluded$M = ["store", "changed", "type", "immediateFeedback"];
function PieChartEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$M);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "adItem|addItemToResponse|sortItems|removeItem|removeItemToResponse|setSrc|setLabel|setTheme|setXAxisLabel|setXAxisName|setYAxisName|setYMax|setYMin|setYMultiplier|",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 1
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 2,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(EditorPieChartTable$1, {
    chartData: store.chartData
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    hasMultipleResponses: false,
    showToggleIsEvaluable: false,
    helpText: translate('exact_math_or_match_response_or_match_group_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(PieChartEditorConfig, {
    store: store
  }));
}
var PieChartEditor$1 = observer(PieChartEditor);

var ItemModel$3 = types$1.compose(LabelThemeItemModel, types$1.model({})).views(function (state) {
  return {
    get errorMessage() {
      return state.label.length === 0 ? 'charts_pie_chart_elements_error_empty' : '';
    }
  };
});
var LabelThemeListModel$1 = types$1.compose(createItemListModel(ItemModel$3), BaseLabelThemeListModel, types$1.model('LabelThemeListModel', {}).actions(function (state) {
  return {
    addItemToResponse: function addItemToResponse(label) {
      var _getParent = getParent(state, 2),
        validation = _getParent.validation;
      validation.setValue([].concat(validation.value, [{
        label: label,
        value: 0
      }]));
    },
    removeItemToResponse: function removeItemToResponse(itemIndex) {
      var _getParent2 = getParent(state, 2),
        validation = _getParent2.validation;
      var updatedResponse = rmItem(itemIndex, validation.value);
      validation.setValue(updatedResponse);
    },
    sortItems: function sortItems(source, destination) {
      var _getParent3 = getParent(state, 2),
        validation = _getParent3.validation;
      state.list = sortArrayItem(source, destination, state.list);
      validation.setValue(sortArrayItem(source, destination, validation.value));
      state.updateNotifier();
    }
  };
}));

var ChartDataModel$6 = types$1.model({
  data: LabelThemeListModel$1,
  labels: types$1.array(types$1.string)
}).actions(function (state) {
  return {
    setLabel: function setLabel(_ref) {
      var idx = _ref.idx,
        label = _ref.label;
      state.labels[idx] = label;
      getParent(state).updateNotifier();
    }
  };
}).views(function (state) {
  return {};
});
var ChartDataModel$7 = types$1.snapshotProcessor(ChartDataModel$6, {
  preProcessor: function preProcessor(sn) {
    return {
      data: {
        list: sn.data
      },
      labels: sn.labels
    };
  },
  postProcessor: function postProcessor(sn) {
    return {
      data: sn.data.list,
      labels: sn.labels
    };
  }
});

var PieChartEditorStore = types$1.compose(EditorBaseModel, types$1.model({
  chartData: ChartDataModel$7,
  ui_style: ChartUIStyles$1
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      onAction(state, function (_ref) {
        var name = _ref.name,
          path = _ref.path,
          args = _ref.args;
        if (name === 'setLabel') {
          var item = resolvePath(state, path);
          state.validation.setValue(state.validation.value.map(function (value, idx) {
            return idx === item.index ? _extends({}, value, {
              label: args[0]
            }) : value;
          }));
        }
      });
    }
  };
}).views(function (state) {
  return {
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$19(rawData);
    },
    get output() {
      return exportCommonValues(state, {
        chart_data: getSnapshot(state.chartData)
      });
    }
  };
}));
function _createSnapshot$19(data) {
  return _extends({}, data.data, importCommonValues$1(data), {
    chartData: data.data.chart_data,
    ui_style: data.data.ui_style
  });
}
function createStore$1p(data) {
  var store = PieChartEditorStore.create(_createSnapshot$19(data));
  return store;
}

function TableTitle(_ref) {
  var label = _ref.label,
    value = _ref.value,
    setValue = _ref.setValue,
    errorInputEmpty = _ref.errorInputEmpty,
    _ref$isRequired = _ref.isRequired,
    isRequired = _ref$isRequired === void 0 ? true : _ref$isRequired;
  var errorMessage = isRequired && value.length === 0 && (errorInputEmpty || translate('input_needs_value'));
  return /*#__PURE__*/React__default.createElement(TextLabelContainer$1, {
    className: "lemo-editor-table-title",
    text: label
  }, /*#__PURE__*/React__default.createElement(EditorInputText$1, {
    defaultValue: value,
    isError: isRequired && value.length === 0,
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      return setValue(value);
    },
    placeholder: translate('title_placeholder')
  }), /*#__PURE__*/React__default.createElement(ErrorMessage$2, {
    className: "lemo-table-title-error-message",
    message: errorMessage
  }));
}
var TableTitle$1 = observer(TableTitle);

function AxisTitles(_ref) {
  var x = _ref.x,
    y = _ref.y,
    setX = _ref.setX,
    setY = _ref.setY;
  return /*#__PURE__*/React__default.createElement(InlineTitles$1, null, /*#__PURE__*/React__default.createElement(TableTitle$1, {
    value: x,
    setValue: setX,
    isRequired: false,
    label: translate('x_axis_title'),
    placeholder: translate('x_axis_title')
  }), /*#__PURE__*/React__default.createElement(TableTitle$1, {
    value: y,
    setValue: setY,
    isRequired: false,
    label: translate('y_axis_title'),
    placeholder: translate('y_axis_title')
  }));
}

function DataListEditor(_ref) {
  var dataModel = _ref.dataModel;
  function handleChange(value, item) {
    dataModel.setValue(item.index, value);
  }
  return /*#__PURE__*/React__default.createElement(EditorItemList$1, {
    itemList: dataModel.list,
    addButtonText: translate('add_row'),
    addButtonTooltipDescription: translate('linechart_add_row_description'),
    addButtonDisabled: dataModel.list.length >= 10,
    onAddItem: dataModel.addItem,
    onDragItem: dataModel.sortItems,
    onRemoveItem: dataModel.removeItem
  }, function (item) {
    return /*#__PURE__*/React__default.createElement(EditorInputText$1, {
      defaultValue: item.value,
      onChange: function onChange(_ref2) {
        var value = _ref2.target.value;
        return handleChange(value, item);
      },
      placeholder: translate('title_placeholder')
    });
  });
}
var DataListEditor$1 = observer(DataListEditor);

var idBox$9 = 'Table';
var titleBoxRef$8 = 'linechart_table_editor_title';
var titleBoxHelpRef$8 = 'linechart_table_editor_help';
function EditorLineChartTable(_ref) {
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: idBox$9,
    icon: /*#__PURE__*/React__default.createElement(SvgMenuAlt, {
      width: "24"
    }),
    titleBox: translate(titleBoxRef$8),
    helpText: translate(titleBoxHelpRef$8),
    classNameAdd: "lemo-editor-line-chart-table"
  }, /*#__PURE__*/React__default.createElement(TableTitle$1, {
    value: store.chartData.xAxisLabel,
    setValue: store.chartData.setXAxisLabel
  }), /*#__PURE__*/React__default.createElement(DataListEditor$1, {
    dataModel: store.chartData.data
  }), /*#__PURE__*/React__default.createElement(SerieListEditor$1, {
    dataModel: store.chartData.yAxisLabel,
    addButtonTooltipDescription: "linechart_add_serie_description"
  }), /*#__PURE__*/React__default.createElement(AxisTitles, {
    setX: store.chartData.setXAxisName,
    setY: store.chartData.setYAxisName,
    x: store.chartData.xAxisName,
    y: store.chartData.yAxisName
  }), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: "lemo-small-input",
    title: translate('measure'),
    subtitle: translate('measure_description'),
    value: store.chartData.measure,
    onChange: store.chartData.setMeasure,
    placeholder: translate('measure_placeholder')
  }));
}
var EditorLineChartTable$1 = observer(EditorLineChartTable);

var iconTitle$9 = /*#__PURE__*/React__default.createElement(SvgSettingsTipography, {
  width: "24",
  className: "lemo-icon-format-shape"
});
var titleBox$9 = 'Configuration';
var helpText$9 = 'config_help';
function LineChartEditorConfig$1(_ref) {
  var _store$ui_style;
  var store = _ref.store;
  var tablePositionsList = useMemo(function () {
    return [ABOVE$2, LEFT$3, RIGHT$9].map(translate);
  }, [config.lang]);
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "configuration",
    icon: iconTitle$9,
    titleBox: translate(titleBox$9),
    helpText: translate(helpText$9),
    classNameAdd: "lemo-editor-config"
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement(ConfigShowCheckIcon, {
    title: translate('hide_table'),
    subtitle: translate('hide_table_description'),
    isChecked: store.ui_style.hideTable,
    onChange: function onChange(bool) {
      return store.ui_style.showTable(!bool);
    }
  }), /*#__PURE__*/React__default.createElement(Line1, null), !store.ui_style.hideTable && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('table_position'),
    subtitle: translate('table_position_description'),
    selectedIndex: store.ui_style.tablePositionIndex,
    itemList: tablePositionsList,
    onChange: store.ui_style.setTablePosition
  }), /*#__PURE__*/React__default.createElement(Line1, null)), /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: 'lemo-small-input',
    title: translate('max_y_value'),
    subtitle: translate('linechart_max_y_value_description'),
    inputType: 'number',
    min: 3,
    max: 10,
    value: store.chartData.yMax,
    onChange: store.chartData.setYMax,
    placeholder: translate('title_placeholder')
  }), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: 'lemo-small-input',
    title: translate('min_y_value'),
    subtitle: translate('min_y_value_description'),
    inputType: 'number',
    min: 0,
    value: store.chartData.yMin,
    onChange: store.chartData.setYMin,
    placeholder: translate('title_placeholder')
  }), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: 'lemo-small-input',
    title: translate('multiplier'),
    subtitle: translate('multiplier_description'),
    inputType: 'number',
    min: 1,
    value: store.chartData.yMultiplier,
    onChange: store.chartData.setYMultiplier,
    placeholder: translate('title_placeholder')
  }), config.showAuthorVariantsEditor && /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(ConfigVariantStyle$1, {
    onChange: function onChange(value) {
      store.ui_style.customClass.setVariant(value.variant);
      store.ui_style.customClass.setClassList(value.classList);
    },
    variantList: store.variants,
    customClass: {
      variant: (_store$ui_style = store.ui_style) === null || _store$ui_style === void 0 ? void 0 : _store$ui_style.customClass.variant,
      classList: store.ui_style.customClass.classList
    }
  })));
}
var LineChartEditorConfig$2 = observer(LineChartEditorConfig$1);

var _excluded$N = ["store", "changed", "type", "immediateFeedback"];
var LineChartEditor = function LineChartEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$N);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "setTitle|setStimulus|setValue|setScore|removeResponseByIdx|setTemplate|sortResponses|destroy|setValidResponse|setColumnCount|setRowCount|addItem|sortDrags|addDrag|setShuffleOptions|setDuplicateResponses|setIsEvaluable|updateSolution|createAlternativeSolution|removeSolution|setBackground|toggleWithBox|toggleStack|setStack|setWithBox|sortColumns",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 1
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 2,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(EditorLineChartTable$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    hasMultipleResponses: false,
    evaluationTypes: [getEvaluationTypeOption(keysTranslateEvaluationTypes.EXACT_MATCH, keysTranslateSubtitleEvaluationTypes.EXACT_MATCH, validationModes.EXACT_MATCH)],
    helpText: translate('exact_math_or_match_response_or_match_group_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(LineChartEditorConfig$2, {
    store: store
  }));
};
var LineChartEditor$1 = observer(LineChartEditor);

function DataListItem(_ref) {
  var item = _ref.item,
    imageApiKey = _ref.imageApiKey,
    showSwatches = _ref.showSwatches,
    handleChange = _ref.handleChange,
    openSwatchList = _ref.openSwatchList,
    _ref$altTextKey = _ref.altTextKey,
    altTextKey = _ref$altTextKey === void 0 ? 'change_image' : _ref$altTextKey,
    _ref$removableImage = _ref.removableImage,
    removableImage = _ref$removableImage === void 0 ? false : _ref$removableImage;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-data-list-item"
  }, /*#__PURE__*/React__default.createElement(OptionalImagePicker$1, {
    id: item.id,
    imageApiKey: imageApiKey,
    value: item.src,
    addImage: item.setSrc,
    altDescription: translate(altTextKey),
    removeImage: removableImage ? function () {
      return item.setSrc('');
    } : undefined
  }), /*#__PURE__*/React__default.createElement(EditorInputText$1, {
    defaultValue: item.x,
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      return handleChange(value, item);
    },
    placeholder: translate('title_placeholder')
  }), /*#__PURE__*/React__default.createElement(RenderWhen, {
    condition: showSwatches
  }, /*#__PURE__*/React__default.createElement(ColorSwatch, {
    theme: item.theme,
    onClick: function onClick() {
      return openSwatchList(item);
    }
  })));
}
var DataListItem$1 = observer(DataListItem);

function DataListEditor$2(_ref) {
  var dataModel = _ref.dataModel,
    imageApiKey = _ref.imageApiKey,
    showSwatches = _ref.showSwatches,
    numSeries = _ref.numSeries;
  var _useState = useState(-1),
    popoverTarget = _useState[0],
    setPopoverTarget = _useState[1];
  var root = useRef();
  var maxBars = numSeries > 1 ? 3 : 5;
  function openSwatchList(item) {
    setPopoverTarget(item.index);
  }
  function getPopoverTarget() {
    return root.current.querySelectorAll('.lemo-swatch-selector')[popoverTarget];
  }
  function updateColor(color) {
    var item = dataModel.list[popoverTarget];
    item.setTheme(color);
    setPopoverTarget(-1);
  }
  function handleChange(value, item) {
    item.setLabel(value);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    ref: root,
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React__default.createElement(EditorItemList$1, {
    itemList: dataModel.list,
    addButtonText: translate('add_row'),
    addButtonDisabled: dataModel.list.length >= maxBars,
    onAddItem: dataModel.addItem,
    onDragItem: dataModel.sortItems,
    onRemoveItem: dataModel.removeItem,
    addButtonTooltipDescription: translate('barchart_table_editor_add_row_tooltip')
  }, function (item) {
    return /*#__PURE__*/React__default.createElement(DataListItem$1, {
      item: item,
      imageApiKey: imageApiKey,
      showSwatches: showSwatches,
      handleChange: handleChange,
      openSwatchList: openSwatchList,
      altTextKey: "text_turned_into_alt_text",
      removableImage: true
    });
  }), popoverTarget > -1 && /*#__PURE__*/React__default.createElement(ColorWatchPopover, {
    setPopoverTarget: setPopoverTarget,
    getTargetElement: getPopoverTarget,
    getColor: dataModel.list[popoverTarget].theme,
    setColor: updateColor
  }));
}
var DataListEditor$3 = observer(DataListEditor$2);

var idBox$a = 'Table';
var titleBoxRef$9 = 'table_editor';
var titleBoxHelpRef$9 = 'barchart_table_editor_help';
function EditorBarChartTable(_ref) {
  var store = _ref.store;
  var _useState = useState(false),
    confirmMessageIsVisible = _useState[0],
    setConfirmMessageIsVisible = _useState[1];
  function addSeries() {
    if (store.chartData.numSeries === 1 && store.chartData.numBars > 3) {
      return setConfirmMessageIsVisible(true);
    }
    store.chartData.yAxisLabel.addItem();
  }
  function reduceNumBars() {
    store.chartData.data.reduceNumBars();
    store.chartData.yAxisLabel.addItem();
    setConfirmMessageIsVisible(false);
  }
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: idBox$a,
    icon: /*#__PURE__*/React__default.createElement(SvgMenuAlt, {
      width: "24"
    }),
    titleBox: translate(titleBoxRef$9),
    helpText: translate(titleBoxHelpRef$9),
    classNameAdd: "lemo-editor-line-chart-table"
  }, /*#__PURE__*/React__default.createElement(TableTitle$1, {
    value: store.chartData.xAxisLabel,
    setValue: store.chartData.setXAxisLabel
  }), /*#__PURE__*/React__default.createElement(DataListEditor$3, {
    dataModel: store.chartData.data,
    showSwatches: store.chartData.yAxisLabel.list.length < 2,
    imageApiKey: store.assetsEditorApi,
    numSeries: store.chartData.numSeries
  }), /*#__PURE__*/React__default.createElement(SerieListEditor$1, {
    dataModel: store.chartData.yAxisLabel,
    hideSwatchIfSingleItem: true,
    addButtonTooltipDescription: "barchart_table_editor_add_series_tooltip",
    customAddItem: addSeries
  }), /*#__PURE__*/React__default.createElement(AxisTitles, {
    setX: store.chartData.setXAxisName,
    setY: store.chartData.setYAxisName,
    x: store.chartData.xAxisName,
    y: store.chartData.yAxisName
  }), confirmMessageIsVisible && /*#__PURE__*/React__default.createElement(ModalConfirmMessage$1, {
    title: translate('modal_barchart_editor_reduce_bars_title'),
    message: translate('modal_barchart_editor_reduce_bars_title_subtitle'),
    onConfirm: reduceNumBars,
    onCancel: function onCancel() {
      return setConfirmMessageIsVisible(false);
    }
  }));
}
var EditorBarChartTable$1 = observer(EditorBarChartTable);

var iconTitle$a = /*#__PURE__*/React__default.createElement(SvgSettingsTipography, {
  width: "24",
  className: "lemo-icon-format-shape"
});
var titleBox$a = 'Configuration';
var helpText$a = 'config_help';
function BarChartEditorConfig$1(_ref) {
  var _store$ui_style;
  var store = _ref.store;
  var tablePositionsList = useMemo(function () {
    return [ABOVE$2, LEFT$3, RIGHT$9].map(translate);
  }, [config.lang]);
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "configuration",
    icon: iconTitle$a,
    titleBox: translate(titleBox$a),
    helpText: translate(helpText$a),
    classNameAdd: "lemo-editor-config"
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement(ConfigShowCheckIcon, {
    title: translate('hide_table'),
    subtitle: translate('hide_table_description'),
    isChecked: store.ui_style.hideTable,
    onChange: function onChange(bool) {
      return store.ui_style.showTable(!bool);
    }
  }), /*#__PURE__*/React__default.createElement(Line1, null), !store.ui_style.hideTable && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('table_position'),
    subtitle: translate('table_position_description'),
    selectedIndex: store.ui_style.tablePositionIndex,
    itemList: tablePositionsList,
    onChange: store.ui_style.setTablePosition
  }), /*#__PURE__*/React__default.createElement(Line1, null)), /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: 'lemo-small-input',
    title: translate('max_y_value'),
    subtitle: translate('max_y_value_description'),
    inputType: 'number',
    min: 3,
    max: 10,
    value: store.chartData.yMax,
    onChange: store.chartData.setYMax,
    placeholder: translate('title_placeholder')
  }), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: 'lemo-small-input',
    title: translate('multiplier'),
    subtitle: translate('multiplier_description'),
    inputType: 'number',
    min: 1,
    value: store.chartData.yMultiplier,
    onChange: store.chartData.setYMultiplier,
    placeholder: translate('title_placeholder')
  }), config.showAuthorVariantsEditor && /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(ConfigVariantStyle$1, {
    onChange: function onChange(value) {
      store.ui_style.customClass.setVariant(value.variant);
      store.ui_style.customClass.setClassList(value.classList);
    },
    variantList: store.variants,
    customClass: {
      variant: (_store$ui_style = store.ui_style) === null || _store$ui_style === void 0 ? void 0 : _store$ui_style.customClass.variant,
      classList: store.ui_style.customClass.classList
    }
  })));
}
var BarChartEditorConfig$2 = observer(BarChartEditorConfig$1);

var _excluded$O = ["store", "changed", "type", "immediateFeedback"];
var BarChartEditor = function BarChartEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$O);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "adItem|addItemToResponse|sortItems|removeItem|removeItemToResponse|setSrc|setLabel|setTheme|setXAxisLabel|setXAxisName|setYAxisName|setYMax|setYMin|setYMultiplier|",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 1
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 2,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(EditorBarChartTable$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    hasMultipleResponses: false,
    evaluationTypes: [getEvaluationTypeOption(keysTranslateEvaluationTypes.EXACT_MATCH, keysTranslateSubtitleEvaluationTypes.EXACT_MATCH, validationModes.EXACT_MATCH)],
    helpText: translate('exact_math_or_match_response_or_match_group_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(BarChartEditorConfig$2, {
    store: store
  }));
};
var BarChartEditor$1 = observer(BarChartEditor);

function DataListEditor$4(_ref) {
  var dataModel = _ref.dataModel,
    imageApiKey = _ref.imageApiKey,
    showSwatches = _ref.showSwatches,
    numSeries = _ref.numSeries;
  var _useState = useState(-1),
    popoverTarget = _useState[0],
    setPopoverTarget = _useState[1];
  var root = useRef();
  var maxBars = numSeries > 1 ? 3 : 5;
  function openSwatchList(item) {
    setPopoverTarget(item.index);
  }
  function getPopoverTarget() {
    return root.current.querySelectorAll('.lemo-swatch-selector')[popoverTarget];
  }
  function updateColor(color) {
    var item = dataModel.list[popoverTarget];
    item.setTheme(color);
    setPopoverTarget(-1);
  }
  function handleChange(value, item) {
    item.setLabel(value);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    ref: root,
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React__default.createElement(EditorItemList$1, {
    itemList: dataModel.list,
    addButtonText: translate('add_row'),
    addButtonDisabled: dataModel.list.length >= maxBars,
    onAddItem: dataModel.addItem,
    onDragItem: dataModel.sortItems,
    onRemoveItem: dataModel.removeItem
  }, function (item) {
    return /*#__PURE__*/React__default.createElement(DataListItem$1, {
      item: item,
      imageApiKey: imageApiKey,
      showSwatches: showSwatches,
      handleChange: handleChange,
      openSwatchList: openSwatchList,
      altTextKey: "change_image",
      removableImage: false
    });
  }), popoverTarget > -1 && /*#__PURE__*/React__default.createElement(ColorWatchPopover, {
    setPopoverTarget: setPopoverTarget,
    getTargetElement: getPopoverTarget,
    getColor: dataModel.list[popoverTarget].theme,
    setColor: updateColor
  }));
}
var DataListEditor$5 = observer(DataListEditor$4);

function ColumnsTitles(_ref) {
  var column1 = _ref.column1,
    column2 = _ref.column2,
    setColumn1 = _ref.setColumn1,
    setColumn2 = _ref.setColumn2;
  return /*#__PURE__*/React__default.createElement(InlineTitles$1, null, /*#__PURE__*/React__default.createElement(TableTitle$1, {
    value: column1,
    setValue: setColumn1,
    errorInputEmpty: translate('pictograph_table_title_empty')
  }), /*#__PURE__*/React__default.createElement(TableTitle$1, {
    value: column2,
    setValue: setColumn2,
    errorInputEmpty: translate('pictograph_table_title_empty')
  }));
}

var idBox$b = 'Table';
var titleBoxRef$a = 'table_editor';
var titleBoxHelpRef$a = 'pictograph_table_editor_help';
function EditorPictographTable(_ref) {
  var store = _ref.store;
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: idBox$b,
    icon: /*#__PURE__*/React__default.createElement(SvgMenuAlt, {
      width: "24"
    }),
    titleBox: translate(titleBoxRef$a),
    helpText: translate(titleBoxHelpRef$a),
    classNameAdd: "lemo-editor-line-chart-table"
  }, /*#__PURE__*/React__default.createElement(ColumnsTitles, {
    column1: store.chartData.xAxisLabel,
    setColumn1: store.chartData.setXAxisLabel,
    column2: store.chartData.yAxisLabel,
    setColumn2: store.chartData.setYAxisLabel
  }), /*#__PURE__*/React__default.createElement(DataListEditor$5, {
    dataModel: store.chartData.data,
    showSwatches: false,
    imageApiKey: store.assetsEditorApi,
    numSeries: 1
  }), /*#__PURE__*/React__default.createElement(AxisTitles, {
    setX: store.chartData.setXAxisName,
    setY: store.chartData.setYAxisName,
    x: store.chartData.xAxisName,
    y: store.chartData.yAxisName
  }));
}
var EditorBarChartTable$2 = observer(EditorPictographTable);

var iconTitle$b = /*#__PURE__*/React__default.createElement(SvgSettingsTipography, {
  width: "24",
  className: "lemo-icon-format-shape"
});
var titleBox$b = 'Configuration';
var helpText$b = 'config_help';
function PictographEditorConfig(_ref) {
  var _store$ui_style;
  var store = _ref.store;
  var tablePositionsList = useMemo(function () {
    return [ABOVE$2, LEFT$3, RIGHT$9].map(translate);
  }, [config.lang]);
  return /*#__PURE__*/React__default.createElement(EditorBox, {
    id: "configuration",
    icon: iconTitle$b,
    titleBox: translate(titleBox$b),
    helpText: translate(helpText$b),
    classNameAdd: "lemo-editor-config"
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement(ConfigShowCheckIcon, {
    title: translate('hide_table'),
    subtitle: translate('hide_table_description'),
    isChecked: store.ui_style.hideTable,
    onChange: function onChange(bool) {
      return store.ui_style.showTable(!bool);
    }
  }), /*#__PURE__*/React__default.createElement(Line1, null), !store.ui_style.hideTable && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(EditorDropdownTitleSubtitle$1, {
    title: translate('chart_position'),
    subtitle: translate('chart_position_description'),
    selectedIndex: store.ui_style.tablePositionIndex,
    itemList: tablePositionsList,
    onChange: store.ui_style.setTablePosition
  }), /*#__PURE__*/React__default.createElement(Line1, null)), /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: 'lemo-small-input',
    title: translate('max_y_value'),
    subtitle: translate('max_y_value_description'),
    inputType: 'number',
    min: 3,
    max: 10,
    value: store.chartData.yMax,
    onChange: store.chartData.setYMax,
    placeholder: translate('title_placeholder')
  }), /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(EditorInputTextTitleSubtitle$1, {
    className: 'lemo-small-input',
    title: translate('multiplier'),
    subtitle: translate('multiplier_description'),
    inputType: 'number',
    min: 1,
    value: store.chartData.yMultiplier,
    onChange: store.chartData.setYMultiplier,
    placeholder: translate('title_placeholder')
  }), config.showAuthorVariantsEditor && /*#__PURE__*/React__default.createElement(Line1, null), /*#__PURE__*/React__default.createElement(ConfigVariantStyle$1, {
    onChange: function onChange(value) {
      store.ui_style.customClass.setVariant(value.variant);
      store.ui_style.customClass.setClassList(value.classList);
    },
    variantList: store.variants,
    customClass: {
      variant: (_store$ui_style = store.ui_style) === null || _store$ui_style === void 0 ? void 0 : _store$ui_style.customClass.variant,
      classList: store.ui_style.customClass.classList
    }
  })));
}
var PictographEditorConfig$1 = observer(PictographEditorConfig);

var _excluded$P = ["store", "changed", "type", "immediateFeedback"];
var PictographEditor = function PictographEditor(props) {
  var _ref;
  var store = props.store,
    changed = props.changed,
    type = props.type,
    immediateFeedback = props.immediateFeedback,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded$P);
  return /*#__PURE__*/React__default.createElement(BaseEditor$1, _extends({}, otherProps, {
    store: store,
    changed: changed,
    type: type,
    patternParticular: "adItem|addItemToResponse|sortItems|removeItem|removeItemToResponse|setSrc|setLabel|setTheme|setXAxisLabel|setXAxisName|setYAxisName|setYMax|setYMin|setYMultiplier|",
    infoComponentsCommon: (_ref = {}, _ref[EDITOR_COMPONENT_COMMON.FEEDBACK] = {
      order: 1
    }, _ref[EDITOR_COMPONENT_COMMON.HINTS] = {
      order: 2,
      hide: INFO_COMPONENTS_COMMON_DEFAULT[EDITOR_COMPONENT_COMMON.HINTS].hide
    }, _ref),
    immediateFeedback: immediateFeedback
  }), /*#__PURE__*/React__default.createElement(EditorBarChartTable$2, {
    store: store
  }), /*#__PURE__*/React__default.createElement(EditorSolutionsStore$1, {
    store: store,
    hasMultipleResponses: false,
    evaluationTypes: [getEvaluationTypeOption(keysTranslateEvaluationTypes.EXACT_MATCH, keysTranslateSubtitleEvaluationTypes.EXACT_MATCH, validationModes.EXACT_MATCH)],
    helpText: translate('exact_math_or_match_response_or_match_group_or_manual_solutions_help')
  }), /*#__PURE__*/React__default.createElement(EditorHollowComponent, null), /*#__PURE__*/React__default.createElement(PictographEditorConfig$1, {
    store: store
  }));
};
var PictographEditor$1 = observer(PictographEditor);

var _excluded$Q = ["onClick", "hasContent", "disabled"];
function FlowchartButton(_ref) {
  var _onClick = _ref.onClick,
    hasContent = _ref.hasContent,
    disabled = _ref.disabled,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$Q);
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    className: "lemo-flowchart-button",
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    onClick: function onClick() {
      return !disabled && _onClick();
    }
  }, props), /*#__PURE__*/React__default.createElement("rect", {
    x: "1",
    y: "1",
    width: "50",
    height: "50",
    rx: "9",
    fill: "#4F4FFF"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "1",
    y: "1",
    width: "50",
    height: "50",
    rx: "9",
    stroke: "#4F4FFF",
    strokeWidth: "2"
  }), /*#__PURE__*/React__default.createElement("svg", {
    width: 50,
    height: 50,
    viewBox: "0 0 24 25",
    x: 1,
    y: 2
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35147 9.2515C6.8201 8.78287 7.5799 8.78287 8.04853 9.2515L12 13.203L15.9515 9.2515C16.4201 8.78287 17.1799 8.78287 17.6485 9.2515C18.1172 9.72013 18.1172 10.4799 17.6485 10.9486L12.8485 15.7486C12.3799 16.2172 11.6201 16.2172 11.1515 15.7486L6.35147 10.9486C5.88284 10.4799 5.88284 9.72013 6.35147 9.2515Z",
    fill: "white",
    style: {
      transformOrigin: 'center',
      transform: "scaleY(" + (hasContent ? -1 : 1) + ")"
    }
  })));
}
var FlowchartButton$1 = observer(FlowchartButton);

var EMPTY_NODE = '_empty_ _empty_ _empty_';

function Flowchart(_ref) {
  var renderMermaid = function renderMermaid() {
    try {
      return Promise.resolve(window.mermaid.render(chartId, flowchart.data)).then(function (_ref3) {
        var svg = _ref3.svg;
        return svg;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var flowchart = _ref.flowchart,
    updateFlowchart = _ref.updateFlowchart,
    openPanel = _ref.openPanel,
    chartId = _ref.chartId,
    selectedNodeIndex = _ref.selectedNodeIndex,
    isEvaluated = _ref.isEvaluated,
    showSolution = _ref.showSolution;
  var container = useRef();
  var _useState = useState(),
    content = _useState[0],
    setContent = _useState[1];
  var _useState2 = useState([]),
    controls = _useState2[0],
    setControls = _useState2[1];
  useResizeHandler2(container, function () {
    return setControls(updateControls({
      nodes: flowchart.nodes,
      chartId: chartId
    }));
  });
  function getContainerWidth() {
    var chart = document.getElementById(chartId);
    return chart ? chart.getBoundingClientRect().width : '100%';
  }
  function createEvents() {
    var chart = document.getElementById(chartId);
    if (chart) {
      var allNodes = chart.querySelectorAll('.node > .label-container');
      var interactiveNodes = flowchart.nodes.reduce(function (acc, next, idx) {
        if (next["static"]) return acc;
        return [].concat(acc, [{
          id: next.id,
          element: allNodes[idx],
          label: next.label
        }]);
      }, []);
      interactiveNodes.forEach(function (node) {
        if (!node.element) return;
        if (node.label !== EMPTY_NODE) {
          node.element.setAttribute('data-tooltip-id', 'lemo-flowchart-tooltip');
          node.element.setAttribute('data-tooltip-html', node.label);
        }
        node.element.addEventListener('click', function () {
          !isEvaluated && openPanel(node.id);
        });
      });
    }
  }
  function selectNode(selectedNodeIndex) {
    var chart = document.getElementById(chartId);
    if (!chart) return;
    if (selectedNodeIndex === null) {
      chart.querySelectorAll('.node > .label-container.lemo-selected').forEach(function (node) {
        node.classList.remove('lemo-selected');
      });
    }
    if (selectedNodeIndex !== undefined) {
      chart.querySelectorAll('.node > .label-container').forEach(function (node, index) {
        index === selectedNodeIndex ? node.classList.add('lemo-selected') : node.classList.remove('lemo-selected');
      });
    }
  }
  function updateFeedback() {
    var chart = document.getElementById(chartId);
    if (!chart) return;
    var nodeList = chart.querySelectorAll('.node .label-container');
    flowchart.nodes.forEach(function (node, idx) {
      var element = idx < nodeList.length ? nodeList[idx] : null;
      if (node["static"] || element === null) return;
      if (node.isSuccess) {
        element.classList.remove('lemo-error');
        element.classList.add('lemo-success');
      }
      if (node.isError) {
        element.classList.remove('lemo-success');
        element.classList.add('lemo-error');
      }
    });
  }
  function updateContainerHeight() {
    var chart = document.getElementById(chartId);
    if (chart) {
      var chartHeight = chart.getBoundingClientRect().height;
      if (container.current) {
        container.current.style.height = Math.round(chartHeight) + 20 + "px";
      }
    }
  }
  useLayoutEffect(function () {
    renderMermaid().then(function (svg) {
      setContent(svg);
      setTimeout(function () {
        setControls(updateControls({
          nodes: flowchart.nodes,
          chartId: chartId
        }));
        updateContainerHeight();
      }, 100);
    });
  }, [updateFlowchart]);
  useEffect(function () {
    createEvents();
  }, [content]);
  useEffect(function () {
    selectNode(selectedNodeIndex);
  }, [selectedNodeIndex]);
  useEffect(function () {
    if (isEvaluated && content) {
      updateFeedback();
    }
  }, [isEvaluated, showSolution, content]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-flowchart",
    ref: container
  }, /*#__PURE__*/React__default.createElement(Tooltip$1, {
    id: "lemo-flowchart-tooltip"
  }), /*#__PURE__*/React__default.createElement("svg", {
    className: "lemo-flowchart-controls",
    width: getContainerWidth(),
    height: "100%"
  }, controls.map(function (control) {
    return control !== null ? /*#__PURE__*/React__default.createElement(FlowchartButton$1, {
      key: control.id,
      className: "lemo-flowchart-button",
      width: 20,
      height: 20,
      x: control.x,
      y: control.y,
      hasContent: control.hasContent,
      disabled: isEvaluated,
      style: {
        pointerEvents: isEvaluated ? 'none' : 'auto'
      },
      onClick: function onClick() {
        return openPanel(control.id);
      }
    }) : null;
  })), /*#__PURE__*/React__default.createElement("div", {
    id: chartId,
    className: "mermaid"
  }), /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: content
    }
  }));
}
function updateControls(_ref2) {
  var chartId = _ref2.chartId,
    nodes = _ref2.nodes;
  var chart = document.getElementById(chartId);
  var chartBounds = chart.getBoundingClientRect();
  var nodeList = chart.querySelectorAll('.nodes .node');
  return nodes.map(function (node, index) {
    if (node["static"]) return null;
    var shape = nodeList[index].firstChild;
    var shapeBounds = shape.getBBox();
    var matrix = shape.getScreenCTM();
    var point = shape.ownerSVGElement.createSVGPoint();
    point.x = shapeBounds.x + 10 + shapeBounds.width;
    point.y = shapeBounds.y - 10 + shapeBounds.height / 2;
    var _point$matrixTransfor = point.matrixTransform(matrix),
      x = _point$matrixTransfor.x,
      y = _point$matrixTransfor.y;
    return {
      x: x - chartBounds.left,
      y: y - chartBounds.top,
      hasContent: node.value.length > 0,
      id: node.id
    };
  });
}
var Flowchart$1 = observer(Flowchart);

function OptionsPanel(_ref) {
  var _currentNode$value;
  var options = _ref.options,
    selectOption = _ref.selectOption,
    currentNode = _ref.currentNode,
    show = _ref.show;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-flowchart-options-panel', {
      'lemo-show': show
    })
  }, /*#__PURE__*/React__default.createElement("ul", {
    className: "lemo-flowchart-options-panel-container"
  }, options.map(function (option) {
    if (option.node) return null;
    return /*#__PURE__*/React__default.createElement("li", {
      className: "lemo-flowchart-options-panel-option",
      key: option.id
    }, /*#__PURE__*/React__default.createElement("button", {
      className: "lemo-option-button lemo-text-body-m-regular lemo-text-color-01",
      onClick: function onClick() {
        return selectOption(option.id);
      },
      dangerouslySetInnerHTML: {
        __html: option.label
      }
    }));
  }), (currentNode === null || currentNode === void 0 ? void 0 : (_currentNode$value = currentNode.value) === null || _currentNode$value === void 0 ? void 0 : _currentNode$value.length) > 0 && /*#__PURE__*/React__default.createElement("li", {
    className: "lemo-flowchart-options-panel-option"
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-empty-figure-button lemo-text-body-l-medium lemo-color-text-corporate",
    onClick: function onClick() {
      return selectOption('');
    }
  }, /*#__PURE__*/React__default.createElement("span", null, translate('empty-figure'), " ", /*#__PURE__*/React__default.createElement(SvgTrash$1, {
    className: "lemo-icon"
  }))))));
}
var OptionsPanel$1 = observer(OptionsPanel);

var LemonadeContext = createContext();
function Lemonade(_ref) {
  var className = _ref.className,
    children = _ref.children,
    parentContainer = _ref.parentContainer;
  var contextValue = {
    parentContainer: parentContainer
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1.apply(void 0, ['lemonade-exercises', 'lemo-token-container', className].concat(defaultThemeTokens))
  }, /*#__PURE__*/React__default.createElement(LemonadeContext.Provider, {
    value: contextValue
  }, children));
}

function PortalContainer(_ref) {
  var element = _ref.element,
    children = _ref.children;
  var _useState = useState(null),
    container = _useState[0],
    setContainer = _useState[1];
  useEffect(function () {
    if (element) {
      var targetElement = document.querySelector(element);
      if (targetElement) {
        setContainer(targetElement);
      } else {
        console.warn("No se encontr\xF3 ning\xFAn elemento con el selector: " + element);
      }
    }
  }, [element]);
  return container ? createPortal(children, container) : children;
}

function FlowchartQuestion(props) {
  var _store$currentNode;
  var store = props.store,
    _props$onShowMenu = props.onShowMenu,
    onShowMenu = _props$onShowMenu === void 0 ? noop : _props$onShowMenu;
  var changedHandlers = /reset|setValue|selectOption/;
  var ctx = useContext(LemonadeContext);
  var parentContainer = (ctx === null || ctx === void 0 ? void 0 : ctx.parentContainer) || null;
  var mermaidCondition = function mermaidCondition() {
    return typeof window.mermaid !== 'undefined';
  };
  var isMermaidReady = useLoadScript([{
    type: 'script',
    id: 'mermaidScriptId',
    url: 'https://cdn.jsdelivr.net/npm/mermaid@11/dist/mermaid.min.js',
    readyCondition: mermaidCondition
  }]) || mermaidCondition();
  useEffect(function () {
    if (isMermaidReady) {
      window.mermaid.initialize({
        maxTextSize: 900,
        startOnLoad: true
      });
    }
  }, [isMermaidReady]);
  useEffect(function () {
    if (store.optionsPanel.isOpened) {
      onShowMenu();
    }
  }, [store.optionsPanel.isOpened]);
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-question-body', {
      'lemo-disabled': store.disabled
    })
  }, isMermaidReady && /*#__PURE__*/React__default.createElement(Flowchart$1, {
    flowchart: store.flowchart,
    updateFlowchart: store.updateFlowchart,
    openPanel: store.openPanel,
    selectedNodeIndex: ((_store$currentNode = store.currentNode) === null || _store$currentNode === void 0 ? void 0 : _store$currentNode.index) || null,
    chartId: "lemo-flowchart-instance-" + store.reference,
    isEvaluated: store.isEvaluated,
    showSolution: store.showSolution || store.internalAutoFeedback
  }), store.optionsPanel.isOpened && /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-panel-bg",
    onClick: store.closePanel
  }), store.optionsPanel.isOpened && /*#__PURE__*/React__default.createElement(PortalContainer, {
    element: parentContainer
  }, /*#__PURE__*/React__default.createElement(OptionsPanel$1, {
    options: store.optionsPanel.optionList,
    selectOption: store.selectOption,
    currentNode: store.currentNode,
    show: store.optionsPanel.isOpened
  }))));
}
var FlowchartQuestion$1 = observer(FlowchartQuestion);

function createFlowChart(model) {
  return createConfig(model.config) + createNodes(model.nodes) + createEdges(model.edges);
}
function createNodes(nodes) {
  return nodes.reduce(function (acc, next) {
    return "" + acc + next.id + drawShape(next.type, next.label) + "\n";
  }, '');
}
var EMPTY_NODE$1 = '_empty_';
var EMPTY_NODE_CLASS = 'fc-empty-node';
var MAX_CHARS_PER_LINE = 16;
function drawShape(type, content) {
  if (content === void 0) {
    content = EMPTY_NODE$1;
  }
  var className = content === EMPTY_NODE$1 ? "class=\"" + EMPTY_NODE_CLASS + "\"" : '';
  var normalizedContent = normalizeContent(content);
  switch (type) {
    case 'start':
      return "((<p " + className + ">" + normalizedContent + "</p>))";
    case 'decision':
      return "{<p " + className + ">" + normalizedContent + "</p>}";
    case 'process':
      return "[<p " + className + ">" + normalizedContent + "</p>]";
    case 'end':
      return "((<p " + className + ">" + normalizedContent + "</p>))";
    default:
      return '';
  }
}
function normalizeContent(content) {
  if (content === EMPTY_NODE$1) return EMPTY_NODE$1;
  if (content.length <= MAX_CHARS_PER_LINE) return content;
  return content.replace(/\s{2,}/g, ' ').split(' ').reduce(function (acc, next) {
    if (acc[acc.length - 1].length + next.length <= MAX_CHARS_PER_LINE) {
      acc[acc.length - 1] += " " + next;
    } else {
      acc.push(next);
    }
    return acc;
  }, ['']).slice(0, 3).join(' ') + '...';
}
function createEdges(edges) {
  return edges.reduce(function (acc, next) {
    var connection = next.label ? " -->|" + next.label + "| " : ' --> ';
    return "" + acc + next.source + connection + next.target + "\n";
  }, '');
}
function createConfig(config) {
  return config.chart + " " + config.direction + "\n";
}

var NodeModel = types$1.model('NodeModel', {
  id: types$1.string,
  type: types$1.string,
  value: types$1.string,
  "static": types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    setValue: function setValue(labelId) {
      if (state["static"]) return;
      state.value = labelId;
    },
    clear: function clear() {
      if (state["static"]) return;
      state.value = '';
    }
  };
}).views(function (state) {
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get label() {
      var _getParent = getParent(state, 2),
        optionLabels = _getParent.optionLabels;
      if (state["static"]) return optionLabels[state.id];
      return state.value ? optionLabels[state.value] : EMPTY_NODE;
    },
    get validResponse() {
      var root = getParent(state, 3);
      return root.validResponses[state.index];
    },
    get isSuccess() {
      var root = getParent(state, 3);
      if (!root.isEvaluated) return false;
      return state.label === state.validResponse;
    },
    get isError() {
      var root = getParent(state, 3);
      if (!root.isEvaluated) return false;
      return state.label !== state.validResponse;
    }
  };
});
var NodeModel$1 = types$1.snapshotProcessor(NodeModel, {
  preProcessor: function preProcessor(snapshot) {
    return _extends({}, snapshot, {
      value: snapshot["static"] ? snapshot.id : ''
    });
  }
});

var FlowchartModel = types$1.model({
  nodes: types$1.array(NodeModel$1),
  config: types$1.frozen(),
  edges: types$1.frozen()
}).actions(function (state) {
  return {
    reset: function reset() {
      state.nodes.forEach(function (node) {
        return node.clear();
      });
    }
  };
}).views(function (state) {
  return {
    get optionLabels() {
      return getParent(state).optionLabels;
    },
    get normalizedNodeList() {
      return state.nodes.map(function (node) {
        return {
          id: node.id,
          type: node.type,
          label: state.optionLabels[node.value],
          "static": node["static"]
        };
      });
    },
    get data() {
      return createFlowChart({
        nodes: state.normalizedNodeList,
        config: state.config,
        edges: state.edges
      });
    }
  };
});

var OptionModel$4 = types$1.model({
  id: types$1.string,
  label: types$1.string
}).views(function (state) {
  return {
    get nodeList() {
      return getParent(state, 3).flowchart.nodes;
    },
    get node() {
      return state.nodeList.find(function (node) {
        return node.value === state.id;
      });
    }
  };
});

var OptionsPanelModel = types$1.model({
  isOpened: types$1["boolean"],
  optionList: types$1.array(OptionModel$4)
}).actions(function (state) {
  return {
    open: function open() {
      state.isOpened = true;
    },
    close: function close() {
      state.isOpened = false;
    },
    selectOption: function selectOption(optionId) {
      getParent(state).selectOption(optionId);
      state.close();
    }
  };
}).views(function (state) {
  return {
    get availableOptions() {
      return state.optionList.filter(function (option) {
        return !option.node;
      });
    }
  };
});

var FlowchartQuestionStore = types$1.compose(QuestionBaseModel, withXAPITypeOther$1({
  xAPISolution: function xAPISolution(state) {
    return formatResponses(state.validResponses);
  }
}), types$1.model({
  flowchart: FlowchartModel,
  optionsPanel: OptionsPanelModel,
  selectedNodeId: types$1.maybeNull(types$1.string),
  updateFlowchart: types$1.optional(types$1.number, 0)
}).actions(function (state) {
  return {
    selectNode: function selectNode(nodeId) {
      state.selectedNodeId = nodeId;
      state.optionsPanel.open();
    },
    update: function update() {
      state.updateFlowchart += 1;
    },
    openPanel: function openPanel(optionId) {
      if (optionId === state.selectedNodeId) return state.closePanel();
      state.selectedNodeId = optionId;
      state.optionsPanel.open();
    },
    closePanel: function closePanel() {
      state.selectedNodeId = undefined;
      state.optionsPanel.close();
    },
    selectOption: function selectOption(optionId) {
      if (!state.selectedNodeId) return;
      state.currentNode.setValue(optionId);
      state.selectedNodeId = undefined;
      state.optionsPanel.close();
      state.update();
    },
    clearResponses: function clearResponses() {
      state.selectedNodeId = null;
      state.flowchart.reset();
      state.update();
    },
    reset: function reset() {
      state.baseReset();
      state.clearResponses();
    },
    commitResponseFeedback: function commitResponseFeedback() {},
    setResponse: function setResponse(response) {
      if (!typeChecker(types$1.array(types$1.string), response)) return false;
      state.clearResponses();
      var findResponseId = function findResponseId(label) {
        return state.chartData.nodes.find(function (node) {
          return node.label === label;
        });
      };
      response.forEach(function (label, idx) {
        if (label === '') return;
        var node = state.flowchart.nodes[idx];
        !node["static"] && node.setValue(findResponseId(label).id);
      });
    },
    hydrateSolutionsPreview: function hydrateSolutionsPreview(rawData) {}
  };
}).views(function (state) {
  return {
    get currentNode() {
      var nodeList = state.flowchart.nodes;
      return nodeList.find(function (node) {
        return node.id === state.selectedNodeId;
      });
    },
    get chartData() {
      return state.raw.data.chart;
    },
    get optionLabels() {
      return state.chartData.nodes.reduce(function (acc, next) {
        var _extends2;
        return _extends({}, acc, (_extends2 = {}, _extends2[next.id] = next.label, _extends2));
      }, {});
    },
    get validResponses() {
      return state.chartData.nodes.map(function (node) {
        return node.label;
      });
    },
    get isSuccess() {
      return state.isEvaluated && state.getResults() === 1;
    },
    get isError() {
      return state.isEvaluated && state.getResults() === 0;
    },
    getSolutions: function getSolutions() {
      return state.validResponses;
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$1a(rawData);
    },
    getResults: function getResults() {
      return compareArray(state.validResponses, state.getUserResponse()) ? 1 : 0;
    },
    getUserResponse: function getUserResponse() {
      return state.flowchart.nodes.map(function (_ref) {
        var label = _ref.label;
        return label === EMPTY_NODE ? '' : label;
      });
    }
  };
}));
function _createSnapshot$1a(data) {
  var chart = data.data.chart;
  var optionList = chart.nodes.map(function (node) {
    return {
      id: node.id,
      label: node.label
    };
  });
  return _extends({}, data.data, importCommonValues(data), {
    flowchart: data.data.chart,
    optionsPanel: {
      isOpened: false,
      optionList: shuffle(optionList)
    }
  });
}
function createStore$1q(data) {
  return FlowchartQuestionStore.create(_createSnapshot$1a(data));
}

var barWidth = 62;
function ChartXLabels$2(_ref) {
  var store = _ref.store;
  var barsLength = store.chart.length;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "chart-x-labels",
    style: {
      width: barWidth * barsLength
    }
  }, store.xValues.map(function (val, idx) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "chart-x-label-container",
      key: "label-" + idx
    }, /*#__PURE__*/React__default.createElement("div", {
      className: 'lemo-chart-x-label-line'
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "lemo-chart-label-text no-break lemo-text-body-s-bold lemo-color-text-01"
    }, val)));
  }));
}

function Chart$5(_ref) {
  var store = _ref.store;
  var baseElement = useRef();
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart",
    ref: baseElement,
    "data-testid": "chart"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart-left-side"
  }, /*#__PURE__*/React__default.createElement(YAxis$1, {
    initialYValue: store.initialYValue,
    yValues: store.yValues,
    yAxisName: store.yAxisName,
    selectedValue: store.selectedValue
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart-right-side"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-chart-area"
  }, /*#__PURE__*/React__default.createElement(ChartVerticalLine, null), /*#__PURE__*/React__default.createElement(ChartContent$1, {
    yValues: store.yValues,
    store: store
  }), /*#__PURE__*/React__default.createElement(ChartXValues$1, {
    store: store
  }), /*#__PURE__*/React__default.createElement(ChartXLabels$2, {
    store: store
  }), /*#__PURE__*/React__default.createElement(HorizontalLabel, {
    label: store.xAxisName
  }))));
}
var Chart$6 = observer(Chart$5);

function SymmetryQuestion$1(props) {
  var _cn;
  var store = props.store,
    _props$solutionsMode = props.solutionsMode,
    solutionsMode = _props$solutionsMode === void 0 ? false : _props$solutionsMode;
  var changedHandlers = /reset|setValue/;
  var checkTablePosition = getCheckTablePosition(store);
  return /*#__PURE__*/React__default.createElement(QuestionBase$1, _extends({}, props, {
    changedHandlers: changedHandlers,
    changedHandlerDebugger: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-body"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-chart-question', (_cn = {
      'lemo-disabled': !solutionsMode && store.disabled,
      'lemo-solutions-mode': solutionsMode
    }, _cn[TABLE_POSITION_ABOVE$1] = checkTablePosition(ABOVE$1), _cn[TABLE_POSITION_BELOW$1] = checkTablePosition(BELOW$1), _cn[TABLE_POSITION_LEFT$1] = checkTablePosition(LEFT$1), _cn[TABLE_POSITION_RIGHT$1] = checkTablePosition(RIGHT$3), _cn))
  }, !solutionsMode && store.showTable && /*#__PURE__*/React__default.createElement(ChartTable, {
    tableData: store.tableData
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React__default.createElement(Chart$6, {
    store: store
  })))));
}
var HistogramsQuestion = observer(SymmetryQuestion$1);

var HistogramsQuestionStore = types$1.compose(BarChartQuestionStore, withXAPITypeOther$1({
  xAPISolution: function xAPISolution(state) {
    return formatResponses(state.validation.value.map(function (_ref) {
      var x = _ref.x,
        y = _ref.y;
      return x + "[.]" + y[0];
    }));
  }
}), types$1.model({}).views(function (state) {
  return {
    get xValues() {
      var x_values = state.chartData.x_values;
      return x_values;
    },
    get tableBodyValues() {
      return state.validation.value.map(function (_, idx) {
        var label = state.chartData.data[idx].x;
        var response = state.validation.value[idx].y[0];
        var responseValue = (response + state.initialYValue) * state.multiplier;
        return [label, responseValue];
      });
    },
    get tableData() {
      return {
        headerData: [state.chartData.x_axis_label, state.chartData.y_axis_label],
        bodyData: state.tableBodyValues
      };
    },
    createSnapshot: function createSnapshot(rawData) {
      return _createSnapshot$1b(rawData);
    }
  };
}));
function _createSnapshot$1b(data) {
  var _data$data = data.data,
    chart_data = _data$data.chart_data,
    ui_style = _data$data.ui_style;
  var _ui_style$theme = ui_style.theme,
    theme = _ui_style$theme === void 0 ? getRandomColorTheme() : _ui_style$theme;
  var chart = chart_data.data.map(function (item) {
    return {
      x: item.x,
      y: [{
        id: item.id,
        value: item.y[0],
        theme: theme
      }]
    };
  });
  return _extends({}, data.data, importCommonValues(data), {
    chart: chart
  });
}
function createStore$1r(data) {
  return HistogramsQuestionStore.create(_createSnapshot$1b(data));
}

function getCharts(props) {
  var _getCreator = getCreator(props, getDefaultData$8, types.cloze.Text),
    type = _getCreator.type,
    lang = _getCreator.lang,
    initialProps = _getCreator.initialProps,
    exerciseData = _getCreator.exerciseData,
    setCommonParamsStore = _getCreator.setCommonParamsStore;
  return when()["case"](type === types.charts.Pictograph, function () {
    var questionStore = createStore$1i(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$1l(exerciseData);
    setCommonParamsStore(editorStore);
    return createPictograph(editorStore, questionStore, initialProps, lang);
  })["case"](type === types.charts.Barchart, function () {
    var questionStore = createStore$1j(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$1k(exerciseData);
    setCommonParamsStore(editorStore);
    return createBarchart(editorStore, questionStore, initialProps, lang);
  })["case"](type === types.charts.LineChart, function () {
    var questionStore = createStore$1m(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$1n(exerciseData);
    setCommonParamsStore(editorStore);
    return createLineChart$1(editorStore, questionStore, initialProps, lang);
  })["case"](type === types.charts.PieChart, function () {
    var questionStore = createStore$1o(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$1p(exerciseData);
    setCommonParamsStore(editorStore);
    return createPieChart$1(editorStore, questionStore, initialProps, lang);
  })["case"](type === types.charts.Flowchart, function () {
    var questionStore = createStore$1q(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$N(exerciseData);
    setCommonParamsStore(editorStore);
    return createFlowchart(editorStore, questionStore, initialProps);
  })["case"](type === types.charts.Histograms, function () {
    var questionStore = createStore$1r(exerciseData);
    setCommonParamsStore(questionStore);
    var editorStore = createStore$N(exerciseData);
    setCommonParamsStore(editorStore);
    return createHistograms(editorStore, questionStore, initialProps);
  }).resolve(null);
}
function createPictograph(editorStore, questionStore, initialProps, lang) {
  return commonCreatorProps(editorStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(PictographQuestion$1, _extends({
        store: questionStore
      }, initialProps, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(PictographEditor$1, _extends({
        store: editorStore,
        lang: lang
      }, initialProps, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Feedback: function Feedback(extraParams) {
      return /*#__PURE__*/React__default.createElement(FeedbackManager$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createBarchart(editorStore, questionStore, initialProps, lang) {
  return commonCreatorProps(editorStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(BarchartQuestion$1, _extends({
        store: questionStore
      }, initialProps, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(BarChartEditor$1, _extends({
        store: editorStore,
        lang: lang
      }, initialProps, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Feedback: function Feedback(extraParams) {
      return /*#__PURE__*/React__default.createElement(FeedbackManager$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createLineChart$1(editorStore, questionStore, initialProps, lang) {
  return commonCreatorProps(editorStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(LineChartQuestion$1, _extends({
        store: questionStore
      }, initialProps, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(LineChartEditor$1, _extends({
        store: editorStore,
        lang: lang
      }, initialProps, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Feedback: function Feedback(extraParams) {
      return /*#__PURE__*/React__default.createElement(FeedbackManager$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createPieChart$1(editorStore, questionStore, initialProps, lang) {
  return commonCreatorProps(editorStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(PieChartQuestion$1, _extends({
        store: questionStore
      }, initialProps, extraParams));
    },
    Editor: function Editor(extraParams) {
      return /*#__PURE__*/React__default.createElement(PieChartEditor$1, _extends({
        store: editorStore,
        lang: lang
      }, initialProps, extraParams));
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Feedback: function Feedback(extraParams) {
      return /*#__PURE__*/React__default.createElement(FeedbackManager$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createFlowchart(editorStore, questionStore, initialProps, lang) {
  return commonCreatorProps(editorStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(FlowchartQuestion$1, _extends({
        store: questionStore
      }, initialProps, extraParams));
    },
    Editor: function Editor() {
      return /*#__PURE__*/React__default.createElement("p", null, "Editor in progress");
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Feedback: function Feedback(extraParams) {
      return /*#__PURE__*/React__default.createElement(FeedbackManager$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}
function createHistograms(editorStore, questionStore, initialProps, lang) {
  return commonCreatorProps(editorStore, {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(HistogramsQuestion, _extends({
        store: questionStore
      }, initialProps, extraParams));
    },
    Editor: function Editor() {
      return /*#__PURE__*/React__default.createElement("p", null, "Editor in progress");
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
        store: questionStore
      }, extraParams));
    },
    Feedback: function Feedback(extraParams) {
      return /*#__PURE__*/React__default.createElement(FeedbackManager$1, _extends({
        store: questionStore
      }, extraParams));
    },
    editorStore: editorStore,
    questionStore: questionStore
  });
}

var resumeString = function resumeString(text, len) {
  return text.length < len ? text : text.slice(0, len).concat('...');
};
var replaceImages = function replaceImages(dom) {
  return dom.querySelectorAll('img').forEach(function (element) {
    return element.after(' {img} ') && element.remove();
  });
};
var replaceFormulas = function replaceFormulas(dom) {
  return dom.querySelectorAll('.fr-math-v2 .fr-math').forEach(function (element) {
    element.after(' {for} ');
    element.remove();
  });
};
var imageIcon = function imageIcon() {
  return "\n  <svg width=\"18\" viewBox=\"0 0 26 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" style=\"position: relative; top: 3px;\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.39995 0.800049C1.63264 0.800049 0.199951 2.23274 0.199951 4.00005V20.0001C0.199951 21.7674 1.63264 23.2001 3.39995 23.2001H22.5999C24.3673 23.2001 25.7999 21.7674 25.7999 20.0001V4.00005C25.7999 2.23274 24.3673 0.800049 22.5999 0.800049H3.39995ZM22.5999 20.0001H3.39995L9.79995 7.20005L14.6 16.8001L17.8 10.4L22.5999 20.0001Z\" fill=\"#808080\"/>\n  </svg>\n";
};
var imageFormula = function imageFormula() {
  return "\n  <svg width=\"16\" height=\"14\" viewBox=\"0 0 16 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" style=\"position: relative; top: 2px;\">\n    <path d=\"M2.6485 0.0839001C3.15459 0.305019 3.3856 0.894537 3.16448 1.40062C2.41582 3.11413 2 5.00732 2 7.00025C2 8.99319 2.41582 10.8864 3.16448 12.5999C3.3856 13.106 3.15459 13.6955 2.6485 13.9166C2.14242 14.1377 1.5529 13.9067 1.33178 13.4006C0.474864 11.4394 0 9.27394 0 7.00025C0 4.72656 0.474864 2.56115 1.33178 0.599881C1.5529 0.0937936 2.14242 -0.137219 2.6485 0.0839001Z\" fill=\"#808080\"/>\n    <path d=\"M10.9613 4.00024C10.0499 4.00024 9.18796 4.41451 8.61864 5.12616L8.29115 5.53553L8.17992 5.25746C7.87619 4.49815 7.14078 4.00024 6.32297 4.00024H6C5.44772 4.00024 5 4.44796 5 5.00024C5 5.55253 5.44772 6.00024 6 6.00024H6.32297L6.8551 7.33058L5.81962 8.62494C5.62985 8.86215 5.34253 9.00024 5.03875 9.00024H5C4.44772 9.00024 4 9.44796 4 10.0002C4 10.5525 4.44772 11.0002 5 11.0002H5.03875C5.9501 11.0002 6.81204 10.586 7.38136 9.87433L7.70885 9.46496L7.82008 9.74302C8.12381 10.5023 8.85922 11.0002 9.67703 11.0002H10C10.5523 11.0002 11 10.5525 11 10.0002C11 9.44796 10.5523 9.00024 10 9.00024H9.67703L9.1449 7.6699L10.1804 6.37555C10.3702 6.13833 10.6575 6.00024 10.9613 6.00024H11C11.5523 6.00024 12 5.55253 12 5.00024C12 4.44796 11.5523 4.00024 11 4.00024H10.9613Z\" fill=\"#808080\"/>\n    <path d=\"M12.8355 1.40062C12.6144 0.894537 12.8454 0.305019 13.3515 0.0839001C13.8576 -0.137219 14.4471 0.0937936 14.6682 0.599881C15.5251 2.56115 16 4.72656 16 7.00025C16 9.27394 15.5251 11.4394 14.6682 13.4006C14.4471 13.9067 13.8576 14.1377 13.3515 13.9166C12.8454 13.6955 12.6144 13.106 12.8355 12.5999C13.5842 10.8864 14 8.99319 14 7.00025C14 5.00732 13.5842 3.11413 12.8355 1.40062Z\" fill=\"#808080\"/>\n  </svg>\n";
};
var getImageIcon = function getImageIcon(dom) {
  return dom.replace(/\{img}/g, imageIcon());
};
var getImageFormula = function getImageFormula(dom) {
  return dom.replace(/\{for}/g, imageFormula());
};
var getCleanQuestionDescription = function getCleanQuestionDescription(stimulus) {
  var dom = document.createElement('div');
  dom.innerHTML = stimulus;
  if (dom.innerText.length === 0) return '';
  replaceImages(dom);
  replaceFormulas(dom);
  var plainText = dom.innerText.replace(/\r?\n|\r/g, ' ');
  var shortDescription = resumeString(plainText, 35);
  return "\n      " + getImageFormula(getImageIcon(shortDescription)) + "\n  ";
};

var QuestionGroupModel = types$1.model({
  id: types$1.optional(types$1.string, function () {
    return uuid();
  }),
  data: types$1.frozen(),
  points: types$1.optional(types$1.number, 0),
  responseWithKey: types$1.frozen(),
  isNew: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  var parent = getParent(state, 2);
  return {
    setData: function setData(data) {
      state.data = data;
      state.isNew = false;
    },
    setPoints: function setPoints(points) {
      state.points = points;
    },
    setResponseWithKey: function setResponseWithKey(responseWithKey) {
      state.responseWithKey = responseWithKey;
    },
    openMenu: function openMenu() {
      parent.setSelectedQuestion(state.index);
    },
    closeMenu: function closeMenu() {
      parent.setSelectedQuestion(-1);
    },
    destroy: function destroy() {
      parent.removeQuestion(state);
    }
  };
}).views(function (state) {
  var parent = getParent(state, 2);
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get isMenuOpen() {
      return parent.selectedQuestion === state.index;
    },
    get reference() {
      var _state$data;
      return (_state$data = state.data) === null || _state$data === void 0 ? void 0 : _state$data.reference;
    },
    get type() {
      return state.data.type;
    },
    get template() {
      return state.data.metadata.name;
    },
    get stimulus() {
      var _state$data$data;
      return (_state$data$data = state.data.data) === null || _state$data$data === void 0 ? void 0 : _state$data$data.stimulus;
    },
    get templateDescription() {
      var stimulus = getCleanQuestionDescription(state.stimulus);
      return stimulus.length > 0 ? stimulus : state.template;
    },
    get action() {
      return getParent(state, 2).action;
    },
    get isSuccess() {
      var _getParent = getParent(state, 2),
        isEvaluated = _getParent.isEvaluated,
        showSolution = _getParent.showSolution;
      var isSuccess = isEvaluated && state.points > 0;
      return showSolution || isSuccess;
    },
    get isError() {
      var _getParent2 = getParent(state, 2),
        isEvaluated = _getParent2.isEvaluated,
        showSolution = _getParent2.showSolution;
      var isError = isEvaluated && state.points === 0;
      return !showSolution && isError;
    }
  };
});

var withUpdateNotifier = types$1.model({
  onUpdateNotifier: types$1.optional(types$1.number, function () {
    return Date.now();
  })
}).actions(function (state) {
  return {
    updateNotifier: function updateNotifier() {
      state.onUpdateNotifier = Date.now();
    }
  };
});

var CHECK_ANSWERS = 'CHECK_ANSWERS';
var RESET$1 = 'RESET';
var SHOW_SOLUTION = 'SHOW_SOLUTION';
var HIDE_SOLUTION = 'HIDE_SOLUTION';
var SHOW_HINTS = 'SHOW_HINTS';
var HIDE_HINTS = 'HIDE_HINTS';

var GROUP_EDITION = 'GROUP_EDITION';
var QUESTION_EDITION = 'QUESTION_EDITION';

var TYPE_DEFINITION = 'activitygroup';
var QuestionGroupStore = types$1.compose(withUpdateNotifier, types$1.model({
  id: types$1.optional(types$1.string, function () {
    return uuid();
  }),
  config: types$1.optional(types$1.frozen(), {}),
  layoutMode: types$1.optional(types$1.string, GROUP_EDITION),
  title: types$1.optional(types$1.string, ''),
  type: types$1.optional(types$1.string, TYPE_DEFINITION),
  stimulus: types$1.optional(types$1.string, ''),
  showSolution: types$1.optional(types$1["boolean"], false),
  feedback: types$1.optional(FeedbackModel, initialValue$1),
  hints: types$1.maybe(HintsModel$1),
  questionList: types$1.array(QuestionGroupModel),
  action: types$1.optional(types$1.string, ''),
  selectedQuestion: types$1.optional(types$1.number, -1),
  removeQuestionModal: types$1.optional(types$1.number, -1),
  addQuestionModal: types$1.optional(types$1["boolean"], false),
  isEvaluated: types$1.optional(types$1["boolean"], false)
}).actions(function (state) {
  return {
    afterCreate: function afterCreate() {
      onAction(state, function (_ref) {
        var name = _ref.name;
        if (name === 'showHint') return state.showHints();
        if (name === 'hideHint') return state.hideHints();
      });
    },
    setTitle: function setTitle(title) {
      state.title = title;
    },
    setStimulus: function setStimulus(stimulus) {
      state.stimulus = stimulus;
    },
    addQuestion: function addQuestion(questionType) {
      var id = uuid();
      var defaultData = getDefaultData$9(questionType);
      var data = _extends({}, defaultData, {
        metadata: _extends({}, defaultData.metadata, {
          layout: GROUPED_LAYOUT
        }),
        reference: id
      });
      state.questionList.push({
        data: data,
        isNew: true
      });
    },
    sortQuestions: function sortQuestions(source, destination) {
      state.questionList = sortArrayItem(source, destination, state.questionList);
    },
    moveQuestionUp: function moveQuestionUp() {
      var nextPosition = state.selectedQuestion - 1;
      state.sortQuestions(state.selectedQuestion, nextPosition);
      state.closeGroupedMenu();
    },
    moveQuestionDown: function moveQuestionDown() {
      var nextPosition = state.selectedQuestion + 1;
      state.sortQuestions(state.selectedQuestion, nextPosition);
      state.closeGroupedMenu();
    },
    duplicateQuestion: function duplicateQuestion() {
      var idx = state.selectedQuestion;
      var id = uuid();
      var data = _extends({}, state.questionList[idx].data, {
        reference: id
      });
      state.questionList.splice(idx + 1, 0, {
        id: id,
        data: data
      });
      state.closeGroupedMenu();
    },
    openRemoveQuestionModal: function openRemoveQuestionModal() {
      state.removeQuestionModal = state.selectedQuestion;
      state.closeGroupedMenu();
    },
    closeRemoveQuestionModal: function closeRemoveQuestionModal() {
      state.removeQuestionModal = -1;
    },
    confirmRemoveQuestion: function confirmRemoveQuestion(questionIndex) {
      destroy(state.questionList[state.removeQuestionModal]);
      state.closeRemoveQuestionModal();
    },
    openAddQuestionModal: function openAddQuestionModal() {
      state.addQuestionModal = true;
    },
    closeAddQuestionModal: function closeAddQuestionModal() {
      state.addQuestionModal = false;
    },
    checkAnswers: function checkAnswers() {
      state.setAction(CHECK_ANSWERS);
      state.isEvaluated = true;
    },
    showHints: function showHints() {
      state.setAction(SHOW_HINTS);
    },
    hideHints: function hideHints() {
      state.setAction(HIDE_HINTS);
    },
    reset: function reset() {
      state.setAction(RESET$1);
      state.showSolution = false;
      state.isEvaluated = false;
    },
    showSolutions: function showSolutions(bool) {
      state.setAction(bool ? SHOW_SOLUTION : HIDE_SOLUTION);
      state.showSolution = bool;
    },
    setAction: function setAction(action) {
      state.action = action;
    },
    setSelectedQuestion: function setSelectedQuestion(index) {
      state.selectedQuestion = index;
    },
    closeGroupedMenu: function closeGroupedMenu() {
      state.selectedQuestion = -1;
    },
    editGroup: function editGroup() {
      state.layoutMode = GROUP_EDITION;
    },
    editQuestion: function editQuestion() {
      state.layoutMode = QUESTION_EDITION;
    },
    showRemoveQuestionModal: function showRemoveQuestionModal() {
      state.removeQuestionModal = true;
    },
    hideRemoveQuestionModal: function hideRemoveQuestionModal() {
      state.removeQuestionModal = false;
    },
    saveQuestion: function saveQuestion(data) {
      var currentQuestion = state.questionList[state.selectedQuestion];
      currentQuestion.setData(data);
      state.editGroup();
      state.setSelectedQuestion(-1);
    },
    cancelCreate: function cancelCreate() {
      destroy(state.currentQuestion);
    },
    cancelQuestion: function cancelQuestion() {
      state.editGroup();
      state.currentQuestion.isNew && state.cancelCreate();
      state.setSelectedQuestion(-1);
    }
  };
}).views(function (state) {
  return {
    get totalScore() {
      return state.questionList.reduce(function (acc, next) {
        return acc + next.points;
      }, 0);
    },
    get score() {
      return state.totalScore / state.questionList.length;
    },
    get points() {
      return state.score;
    },
    get disabled() {
      return state.isEvaluated;
    },
    get isEvaluable() {
      return true;
    },
    get showAscendIcon() {
      return state.selectedQuestion > 0;
    },
    get questionResponses() {
      return state.questionList.reduce(function (acc, next) {
        var _next$data;
        acc[(_next$data = next.data) === null || _next$data === void 0 ? void 0 : _next$data.reference] = next.responseWithKey;
        return acc;
      }, {});
    },
    get correctQuestions() {
      return state.questionList.reduce(function (acc, next) {
        return next.points > 0 ? acc + 1 : acc;
      }, 0);
    },
    get questionsAnswered() {
      return state.questionList.reduce(function (acc, next) {
        return next.responseWithKey !== undefined ? acc + 1 : acc;
      }, 0);
    },
    getUserResponse: function getUserResponse() {
      return {
        reference: state.id,
        apiVersion: currentVersion,
        type: 'Activity group',
        revision: 1,
        value: {
          grade: {
            score: state.score,
            questionsAnswered: state.questionsAnswered,
            questionsGraded: state.questionList.length,
            questionsCorrect: state.correctQuestions
          },
          references: state.questionList.map(function (_ref2) {
            var data = _ref2.data;
            return data === null || data === void 0 ? void 0 : data.reference;
          }),
          responses: state.questionResponses
        }
      };
    },
    get output() {
      return getSnapshot(state);
    },
    getResponseWithKey: function getResponseWithKey() {
      return {
        reference: state.id,
        score: state.score,
        apiVersion: currentVersion,
        questionList: state.questionList.map(function (_ref3) {
          var responseWithKey = _ref3.responseWithKey;
          return responseWithKey;
        })
      };
    },
    get showDescendIcon() {
      return state.selectedQuestion < state.questionList.length - 1;
    },
    get currentQuestion() {
      return state.selectedQuestion >= 0 ? state.questionList[state.selectedQuestion] : undefined;
    },
    get basePath() {
      return state.config.basePath;
    },
    get assetsQuestionApi() {
      return state.config.assetsQuestionApi;
    },
    get assetsEditorApi() {
      return state.config.assetsEditorApi;
    },
    get assetsQuestionApiDrive() {
      return state.config.assetsQuestionApiDrive;
    }
  };
}));
var store = types$1.snapshotProcessor(QuestionGroupStore, {
  preProcessor: function preProcessor(sn) {
    var createQuestion = function createQuestion(reference, questions) {
      return {
        id: reference,
        data: questions[reference]
      };
    };
    var config = pick(['basePath', 'assetsQuestionApi', 'assetsQuestionApiDrive', 'assetsEditorApi'], sn);
    return _extends({}, sn, {
      config: config,
      questionList: sn.references.map(function (_ref4) {
        var reference = _ref4.reference;
        return createQuestion(reference, sn.questions);
      })
    });
  },
  postProcessor: function postProcessor(sn) {
    var getReferences = function getReferences(sn) {
      return sn.questionList.map(function (question) {
        var _question$data;
        return {
          reference: (_question$data = question.data) === null || _question$data === void 0 ? void 0 : _question$data.reference,
          type: question.data.type,
          template: question.data.metadata.name
        };
      });
    };
    var getQuestions = function getQuestions(sn) {
      return sn.questionList.reduce(function (acc, next) {
        var _next$data2, _extends2;
        return _extends({}, acc, (_extends2 = {}, _extends2[(_next$data2 = next.data) === null || _next$data2 === void 0 ? void 0 : _next$data2.reference] = next.data, _extends2));
      }, {});
    };
    return {
      id: sn.id,
      title: sn.title,
      type: sn.type,
      stimulus: sn.stimulus,
      feedback: sn.feedback,
      hints: sn.hints,
      references: getReferences(sn),
      questions: getQuestions(sn)
    };
  }
});
var createQuestionGroupStore = function createQuestionGroupStore(data) {
  return store.create(data);
};

function GroupPoints(_ref) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-group-points"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-progress",
    style: {
      visibility: 'hidden'
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-progress-text"
  }, "2 / 3"), /*#__PURE__*/React__default.createElement("span", {
    className: "lemo-completed-text"
  }, "Completed")), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-score"
  }, "Score"));
}

var _excluded$R = ["question", "isEditMode", "config"];
function GroupedQuestion(_ref) {
  var question = _ref.question,
    isEditMode = _ref.isEditMode,
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config,
    questionProps = _objectWithoutPropertiesLoose(_ref, _excluded$R);
  var _useLemonadeQuestion = useLemonadeQuestion(_extends({
      data: question.data
    }, config)),
    _useLemonadeQuestion$ = _useLemonadeQuestion.exercise,
    Question = _useLemonadeQuestion$.Question,
    Feedback = _useLemonadeQuestion$.Feedback,
    questionApi = _useLemonadeQuestion$.questionApi;
  useEffect(function () {
    if (question.action === CHECK_ANSWERS) {
      questionApi.checkAnswers();
      question.setPoints(questionApi.points);
    }
    if (question.action === RESET$1) {
      questionApi.reset();
      question.setPoints(0);
    }
    if (question.action === SHOW_SOLUTION) {
      questionApi.showSolutions(true);
    }
    if (question.action === HIDE_SOLUTION) {
      questionApi.showSolutions(false);
    }
    if (question.action === SHOW_HINTS) {
      questionApi.hints.showHint();
    }
    if (question.action === HIDE_HINTS) {
      questionApi.hints.hideHint();
    }
  }, [question.action]);
  function handleChanged(data) {
    var _questionProps$change;
    question.setResponseWithKey(questionApi.getResponse());
    questionProps === null || questionProps === void 0 ? void 0 : (_questionProps$change = questionProps.changed) === null || _questionProps$change === void 0 ? void 0 : _questionProps$change.call(questionProps, data);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-grouped-question', {
      'lemo-grouped-question-success': question.isSuccess,
      'lemo-grouped-question-error': question.isError
    })
  }, isEditMode && /*#__PURE__*/React__default.createElement(SvgDotsVertical, {
    className: "lemo-group-question-menu-icon",
    onClick: question.openMenu
  }), /*#__PURE__*/React__default.createElement(Question, _extends({}, questionProps, {
    changed: handleChanged,
    autoFocus: 'enabled'
  })), /*#__PURE__*/React__default.createElement(Feedback, null));
}
var GroupedQuestion$1 = observer(GroupedQuestion);

var _excluded$S = ["questionGroupStore", "isEditMode"];
function GroupQuestionList(_ref) {
  var questionGroupStore = _ref.questionGroupStore,
    isEditMode = _ref.isEditMode,
    questionProps = _objectWithoutPropertiesLoose(_ref, _excluded$S);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-group-question-list"
  }, questionGroupStore.questionList.map(function (question) {
    return /*#__PURE__*/React__default.createElement(GroupedQuestion$1, _extends({
      key: question.id,
      question: question,
      config: questionGroupStore.config,
      isEditMode: isEditMode
    }, questionProps));
  }));
}
var GroupQuestionList$1 = observer(GroupQuestionList);

var _excluded$T = ["questionGroupStore"];
function GroupValidationControls(_ref) {
  var questionGroupStore = _ref.questionGroupStore,
    extraParams = _objectWithoutPropertiesLoose(_ref, _excluded$T);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-group-validation-controls"
  }, /*#__PURE__*/React__default.createElement(QuestionControls$1, _extends({
    store: questionGroupStore,
    showPoints: false,
    showReset: true,
    showSolution: true
  }, extraParams)));
}
var GroupValidationControls$1 = observer(GroupValidationControls);

function EmptyQuestionGroupMessage() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-empty-questions-group-message"
  }, /*#__PURE__*/React__default.createElement("p", null, translate('no_questions_in_group')));
}

var _excluded$U = ["questionGroupStore", "isEditMode"];
function QuestionsGroup(_ref) {
  var questionGroupStore = _ref.questionGroupStore,
    isEditMode = _ref.isEditMode,
    questionProps = _objectWithoutPropertiesLoose(_ref, _excluded$U);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-questions-group"
  }, questionGroupStore.questionList.length === 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(EmptyQuestionGroupMessage, null), /*#__PURE__*/React__default.createElement(SimpleButton, {
    className: "lemo-add-new-exercise-button",
    variant: variantsSimpleButton.primary,
    onClick: questionGroupStore.openAddQuestionModal,
    style: {
      width: '100%'
    },
    title: "add new exercise"
  }, translate('add_new_exercise'))), questionGroupStore.questionList.length > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(GroupPoints, {
    questionGroupStore: questionGroupStore
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-group-stimulus"
  }, /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    content: questionGroupStore.stimulus,
    className: "lemo-stimulus"
  })), /*#__PURE__*/React__default.createElement(GroupQuestionList$1, _extends({
    questionGroupStore: questionGroupStore,
    isEditMode: isEditMode
  }, questionProps)), isEditMode && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Hints$1, {
    hints: questionGroupStore.hints
  }), /*#__PURE__*/React__default.createElement(FeedbackManager$1, {
    store: questionGroupStore
  }), /*#__PURE__*/React__default.createElement(GroupValidationControls$1, {
    questionGroupStore: questionGroupStore
  }))));
}
var QuestionsGroup$1 = observer(QuestionsGroup);

function getQuestionGroup(data) {
  var questionGroupStore = createQuestionGroupStore(data);
  return {
    Question: function Question(extraParams) {
      return /*#__PURE__*/React__default.createElement(QuestionsGroup$1, _extends({
        questionGroupStore: questionGroupStore,
        isEditMode: false
      }, extraParams));
    },
    Editor: function Editor() {
      return /*#__PURE__*/React__default.createElement("div", null, "Las actividades agrupadas no pueden hacer uso del hook useLemonadeEditor");
    },
    Controls: function Controls(extraParams) {
      return /*#__PURE__*/React__default.createElement(GroupValidationControls$1, _extends({
        questionGroupStore: questionGroupStore
      }, extraParams));
    },
    SampleAnswer: function SampleAnswer() {
      return /*#__PURE__*/React__default.createElement("div", null);
    },
    Feedback: function Feedback(extraParams) {
      return /*#__PURE__*/React__default.createElement(FeedbackManager$1, _extends({
        store: questionGroupStore
      }, extraParams));
    },
    store: questionGroupStore
  };
}

var creator = {
  getMultipleChoice: getMultipleChoice,
  getChoiceMatrix: getChoiceMatrix,
  getEssay: getEssay,
  getCloze: getCloze,
  getClassify: getClassify,
  getLabelImage: getLabelImage,
  getMath: getMath,
  getOther: getOther,
  getCharts: getCharts,
  getQuestionGroup: getQuestionGroup
};

function emptyComponents() {
  var Empty = function Empty() {
    return /*#__PURE__*/React__default.createElement("div", null);
  };
  return {
    Editor: function Editor() {
      return /*#__PURE__*/React__default.createElement(Empty, null);
    },
    Question: function Question() {
      return /*#__PURE__*/React__default.createElement(Empty, null);
    },
    Controls: function Controls() {
      return /*#__PURE__*/React__default.createElement(Empty, null);
    },
    WithTheme: function WithTheme() {
      return /*#__PURE__*/React__default.createElement(Empty, null);
    },
    Feedback: function Feedback() {
      return /*#__PURE__*/React__default.createElement(Empty, null);
    },
    store: LemonadeBaseModel.create({})
  };
}
function getActivity(_ref) {
  var data = _ref.data,
    defaultData = _ref.defaultData,
    lang = _ref.lang,
    basePath = _ref.basePath,
    assetsQuestionApi = _ref.assetsQuestionApi,
    assetsEditorApi = _ref.assetsEditorApi,
    assetsQuestionApiDrive = _ref.assetsQuestionApiDrive,
    initialProps = _ref.initialProps;
  if (!data && !defaultData) return emptyComponents();
  if ((data === null || data === void 0 ? void 0 : data.type) === 'activitygroup') return creator.getQuestionGroup(data);
  try {
    if (lang) config.setLang(lang);
    var activityData = defaultData ? getDefaultData$9(defaultData) : data;
    var activityKeys = findSubKey(activityData.metadata.name, types);
    return function (ref) {
      return {
        multipleChoice: creator.getMultipleChoice,
        choiceMatrix: creator.getChoiceMatrix,
        essay: creator.getEssay,
        cloze: creator.getCloze,
        classify: creator.getClassify,
        labelImage: creator.getLabelImage,
        math: creator.getMath,
        other: creator.getOther,
        charts: creator.getCharts
      }[ref];
    }([activityKeys[0]])({
      lang: config.lang,
      data: activityData,
      type: activityKeys[1],
      basePath: basePath,
      assetsQuestionApi: assetsQuestionApi,
      assetsEditorApi: assetsEditorApi,
      assetsQuestionApiDrive: assetsQuestionApiDrive,
      initialProps: initialProps
    });
  } catch (e) {
    console.warn("Lemonade can't render the exercise", e);
    return emptyComponents();
  }
}

function useLemonade(_ref) {
  var data = _ref.data,
    defaultData = _ref.defaultData,
    lang = _ref.lang,
    basePath = _ref.basePath,
    assetsQuestionApi = _ref.assetsQuestionApi,
    assetsEditorApi = _ref.assetsEditorApi;
  var createExercise = function createExercise() {
    return getActivity({
      data: data,
      defaultData: defaultData,
      lang: lang,
      basePath: basePath,
      assetsQuestionApi: assetsQuestionApi,
      assetsEditorApi: assetsEditorApi
    });
  };
  var immediateExercise = createExercise();
  var _useState = useState(immediateExercise),
    exercise = _useState[0],
    setExercise = _useState[1];
  var updateExercise = useCallback(function (props) {
    setExercise(function () {
      return getActivity(props);
    });
  }, [setExercise]);
  return {
    exercise: exercise || immediateExercise,
    updateExercise: updateExercise
  };
}

var _excluded$V = ["data", "defaultData", "lang", "basePath", "assetsEditorApi"];
function useLemonadeEditor(_ref) {
  var data = _ref.data,
    defaultData = _ref.defaultData,
    lang = _ref.lang,
    basePath = _ref.basePath,
    assetsEditorApi = _ref.assetsEditorApi,
    initialProps = _objectWithoutPropertiesLoose(_ref, _excluded$V);
  var createExercise = function createExercise() {
    return getActivity({
      data: data,
      defaultData: defaultData,
      lang: lang,
      basePath: basePath,
      assetsEditorApi: assetsEditorApi,
      initialProps: initialProps
    });
  };
  var localState = useLocalObservable(function () {
    return {
      instance: createExercise(),
      updateExercise: function updateExercise(props) {
        this.instance = getActivity(_extends({}, props, {
          assetsEditorApi: assetsEditorApi,
          basePath: basePath
        }));
      }
    };
  });
  return {
    exercise: {
      Editor: localState.instance.Editor,
      Question: localState.instance.QuestionPreview,
      editorApi: localState.instance.editorStore
    },
    updateExercise: localState.updateExercise
  };
}

function BoxComponent(_ref) {
  var children = _ref.children,
    title = _ref.title,
    subtitle = _ref.subtitle;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-box-component"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'style-guide-box-component__title'
  }, title), /*#__PURE__*/React__default.createElement("div", {
    className: 'style-guide-box-component__subtitle'
  }, subtitle), children);
}
BoxComponent.propTypes = {};
BoxComponent.defaultProps = {};

function StyleGuideFeedbacks() {
  function getFeedbackItem(mode, idx, value) {
    if (mode === void 0) {
      mode = 'error';
    }
    if (idx === void 0) {
      idx = 1;
    }
    if (value === void 0) {
      value = 'Mi feedback individual';
    }
    var feedback = {
      mode: mode,
      idx: idx,
      value: value
    };
    return /*#__PURE__*/React__default.createElement(Dialog, {
      className: "lemo-feedback-dialog"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "lemo-feedback-list"
    }, /*#__PURE__*/React__default.createElement(FeedbackItem$1, {
      key: 'feedback-response-1',
      feedback: feedback
    })));
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-feedbacks"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-feedbacks__group"
  }, /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'FeedbackItem',
    subtitle: '-'
  }, getFeedbackItem('error', 1))));
}
StyleGuideFeedbacks.propTypes = {};
StyleGuideFeedbacks.defaultProps = {};

function StyleGuideBlocksEditor() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-blocks-editor"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-blocks-editor__group"
  }, /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'EditorConfig',
    subtitle: ''
  }, /*#__PURE__*/React__default.createElement(EditorConfig, {
    listConfig: [TYPES_CONFIG.CONFIG_SUFFLE_ANSWERS, TYPES_CONFIG.CONFIG_COLUMNS],
    suffleAnswer: true,
    onChangeShuffleAnswer: function onChangeShuffleAnswer() {},
    columns: 2,
    onChangeColumns: function onChangeColumns() {}
  })), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'EditorAnswerOptions',
    subtitle: ''
  }, /*#__PURE__*/React__default.createElement(EditorAnswerOptions$1, {
    options: [{
      value: 'Valor 1'
    }, {
      value: 'Valor 2'
    }],
    showToggleShuffleOptions: false
  })), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'EditorAnswerOptions',
    subtitle: 'No feedback'
  }, /*#__PURE__*/React__default.createElement(EditorAnswerOptions$1, {
    options: [{
      value: 'Valor 1'
    }, {
      value: 'Valor 2'
    }],
    showToggleShuffleOptions: false,
    showFeedbackAnswer: false
  })), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'EditorTitle',
    subtitle: ''
  }, /*#__PURE__*/React__default.createElement(EditorTitle, {
    onTitleChange: function onTitleChange() {}
  }))));
}
StyleGuideBlocksEditor.propTypes = {};
StyleGuideBlocksEditor.defaultProps = {};

function StyleGuideButtons() {
  var textButton = 'Button';
  var icon = /*#__PURE__*/React__default.createElement(SvgLightBulb, {
    className: "lemo-icon"
  });
  function getButtons(disabled) {
    var propsCommon = {};
    if (disabled) propsCommon.disabled = disabled;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BoxComponent, {
      title: 'SimpleButton',
      subtitle: 'Variant secondary'
    }, /*#__PURE__*/React__default.createElement(SimpleButton, _extends({}, propsCommon, {
      onClick: function onClick() {},
      title: 'Boton'
    }), icon, textButton)), /*#__PURE__*/React__default.createElement(BoxComponent, {
      title: 'SimpleButton',
      subtitle: 'Variant primary'
    }, /*#__PURE__*/React__default.createElement(SimpleButton, _extends({}, propsCommon, {
      onClick: function onClick() {},
      variant: variantsSimpleButton.primary
    }), icon, textButton)), /*#__PURE__*/React__default.createElement(BoxComponent, {
      title: 'ButtonIcon',
      subtitle: '-'
    }, /*#__PURE__*/React__default.createElement(ButtonIcon, _extends({}, propsCommon, {
      icon: icon,
      onClick: function onClick() {}
    }))), /*#__PURE__*/React__default.createElement(BoxComponent, _extends({}, propsCommon, {
      title: 'ButtonInline',
      subtitle: 'With icon'
    }), /*#__PURE__*/React__default.createElement(ButtonInline, _extends({}, propsCommon, {
      onClick: function onClick() {},
      text: textButton,
      icon: icon
    }))), /*#__PURE__*/React__default.createElement(BoxComponent, {
      title: 'ButtonInline',
      subtitle: 'Color red'
    }, /*#__PURE__*/React__default.createElement(ButtonInline, _extends({}, propsCommon, {
      onClick: function onClick() {},
      text: textButton,
      icon: icon,
      color: colorsButton.red
    }))), /*#__PURE__*/React__default.createElement(BoxComponent, {
      title: 'InlineButton',
      subtitle: '-'
    }, /*#__PURE__*/React__default.createElement(InlineButton, _extends({}, propsCommon, {
      onClick: function onClick() {}
    }), icon, textButton)), /*#__PURE__*/React__default.createElement(BoxComponent, {
      title: 'DriveButton',
      subtitle: '-'
    }, /*#__PURE__*/React__default.createElement(DriveButton, _extends({}, propsCommon, {
      onClick: function onClick() {}
    }))));
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-buttons"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-buttons__group"
  }, getButtons()), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-buttons__group-name"
  }, "Disabled"), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-buttons__group"
  }, getButtons(true)));
}
StyleGuideButtons.propTypes = {};
StyleGuideButtons.defaultProps = {};

function Option$4(_ref) {
  var option = _ref.option,
    labelType = _ref.labelType,
    idx = _ref.idx,
    showCheckIcon = _ref.showCheckIcon,
    className = _ref.className,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showCheckIcon && children, /*#__PURE__*/React__default.createElement(OptionWrapper$1, {
    labelType: labelType,
    idx: idx,
    option: option,
    className: className
  }));
}
var Option$5 = observer(Option$4);

function StyleGuideCheckboxs() {
  function getOption(selected, feedbackResult, showCheckIcon, withPin, isWrongCache) {
    if (selected === void 0) {
      selected = true;
    }
    if (feedbackResult === void 0) {
      feedbackResult = feedback.RIGHT;
    }
    if (showCheckIcon === void 0) {
      showCheckIcon = true;
    }
    if (withPin === void 0) {
      withPin = false;
    }
    if (isWrongCache === void 0) {
      isWrongCache = false;
    }
    return /*#__PURE__*/React__default.createElement("div", {
      className: 'lemo-multiple-choice-question'
    }, /*#__PURE__*/React__default.createElement(Option$5, {
      option: {
        parent: {
          selected: selected,
          setSelected: function setSelected() {},
          label: 'Opcion 1',
          feedbackResult: feedbackResult,
          withPin: withPin,
          isWrongCache: isWrongCache,
          showCheckIcon: showCheckIcon,
          ui_style: {
            hasLabels: true,
            columnCount: 1,
            labelType: labelTypes.NONE
          }
        }
      },
      idx: 0
    }));
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-checkboxs"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-checkboxs__group"
  }, /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'Option',
    subtitle: 'Default - CheckIcon'
  }, getOption(false, null, true)), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'Option',
    subtitle: 'Selected - CheckIcon'
  }, getOption(true, null, true)), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'Option',
    subtitle: 'feedback RIGHT - CheckIcon'
  }, getOption(true, feedback.RIGHT, true)), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'Option',
    subtitle: 'feedback WRONG - CheckIcon'
  }, getOption(true, feedback.WRONG, true)), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'Option',
    subtitle: 'feedback WRONG Pin - CheckIcon'
  }, getOption(true, feedback.WRONG, true, true, true)), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'Option',
    subtitle: 'Default - WihoutCheckIcon'
  }, getOption(false, null, false)), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'Option',
    subtitle: 'Selected - WihoutCheckIcon'
  }, getOption(true, null, false)), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'Option',
    subtitle: 'feedback RIGHT - WihoutCheckIcon'
  }, getOption(true, feedback.RIGHT, false)), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'Option',
    subtitle: 'feedback WRONG - WihoutCheckIcon'
  }, getOption(true, feedback.WRONG, false)), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'Option',
    subtitle: 'feedback WRONG Pin - WihoutCheckIcon'
  }, getOption(true, feedback.WRONG, false, true, true))));
}
StyleGuideCheckboxs.propTypes = {};
StyleGuideCheckboxs.defaultProps = {};

function StyleGuideDropdowns() {
  var iconItem = /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '24px',
      height: '24px',
      backgroundColor: '#234233'
    }
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-dropdowns"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-dropdowns__group"
  }, /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'DropDown',
    subtitle: '-'
  }, /*#__PURE__*/React__default.createElement(DropDown$1, {
    onSelect: function onSelect() {},
    selectedIndex: 1,
    itemList: ['Item1', 'Item2', 'Item3 large option'],
    disabled: false
  })), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'DropDownWithIcon',
    subtitle: '-'
  }, /*#__PURE__*/React__default.createElement(DropDownWithIcon, {
    onSelect: function onSelect() {},
    selectedIndex: 2,
    itemList: [{
      text: 'Item1',
      icon: iconItem
    }, {
      text: 'Item2',
      icon: iconItem
    }, {
      text: 'Item3 large option',
      icon: iconItem
    }],
    disabled: false
  })), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'EditorColor',
    subtitle: '-'
  }, /*#__PURE__*/React__default.createElement(EditorColor, {
    color: '#846489',
    onChange: function onChange() {},
    popoverRight: "0px"
  })), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'DropDown',
    subtitle: 'Success'
  }, /*#__PURE__*/React__default.createElement(DropDown$1, {
    onSelect: function onSelect() {},
    selectedIndex: 1,
    itemList: ['Item1', 'Item2', 'Item3 large option'],
    disabled: false,
    isStyleFeedbackSuccess: true
  })), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'DropDown',
    subtitle: 'Error'
  }, /*#__PURE__*/React__default.createElement(DropDown$1, {
    onSelect: function onSelect() {},
    selectedIndex: 1,
    itemList: ['Item1', 'Item2', 'Item3 large option'],
    disabled: false,
    isStyleFeedbackError: true
  })), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'Pointer Dropdown',
    subtitle: '-'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-pointer-editor"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-dropdown-wrapper"
  }, /*#__PURE__*/React__default.createElement(DropDown$1, {
    onSelect: function onSelect() {},
    selectedIndex: 1,
    itemList: ['Item1', 'Item2', 'Item3 large option'],
    disabled: false,
    isStyleFeedbackError: true
  }))))));
}
StyleGuideDropdowns.propTypes = {};
StyleGuideDropdowns.defaultProps = {};

function StyleGuideEssay() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-essay"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-essay__group"
  }, /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'RichText',
    subtitle: 'Sin wordsLimit'
  }, /*#__PURE__*/React__default.createElement(RichText$1, {
    readOnly: true
  }), ' '), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'RichText',
    subtitle: 'Con wordsLimit'
  }, /*#__PURE__*/React__default.createElement(RichText$1, {
    readOnly: true,
    wordsLimit: 200
  }), ' ')));
}
StyleGuideEssay.propTypes = {};
StyleGuideEssay.defaultProps = {};

function StyleGuideRadios() {
  var Single = types.multipleChoice.Single;
  function getOption(selected, feedbackResult, showCheckIcon, withPin, isWrongCache) {
    if (selected === void 0) {
      selected = true;
    }
    if (feedbackResult === void 0) {
      feedbackResult = feedback.RIGHT;
    }
    if (showCheckIcon === void 0) {
      showCheckIcon = true;
    }
    if (withPin === void 0) {
      withPin = false;
    }
    if (isWrongCache === void 0) {
      isWrongCache = false;
    }
    return /*#__PURE__*/React__default.createElement("div", {
      className: 'lemo-multiple-choice-question'
    }, /*#__PURE__*/React__default.createElement(Option$5, {
      option: {
        parent: {
          selected: selected,
          setSelected: function setSelected() {},
          label: 'Opcion 1',
          feedbackResult: feedbackResult,
          withPin: withPin,
          isWrongCache: isWrongCache,
          showCheckIcon: showCheckIcon,
          ui_style: {
            hasLabels: true,
            columnCount: 1,
            labelType: labelTypes.NONE
          }
        }
      },
      idx: 0,
      type: Single
    }));
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-radios"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-radios__group"
  }, /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'Option',
    subtitle: 'Default - CheckIcon'
  }, getOption(false, null, true)), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'Option',
    subtitle: 'Selected - CheckIcon'
  }, getOption(true, null, true)), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'Option',
    subtitle: 'feedback RIGHT - CheckIcon'
  }, getOption(true, feedback.RIGHT, true)), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'Option',
    subtitle: 'feedback WRONG - CheckIcon'
  }, getOption(true, feedback.WRONG, true)), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'Option',
    subtitle: 'feedback WRONG Pin - CheckIcon'
  }, getOption(true, feedback.WRONG, true, true, true)), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'Option',
    subtitle: 'Default - WihoutCheckIcon'
  }, getOption(false, null, false)), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'Option',
    subtitle: 'Selected - WihoutCheckIcon'
  }, getOption(true, null, false)), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'Option',
    subtitle: 'feedback RIGHT - WihoutCheckIcon'
  }, getOption(true, feedback.RIGHT, false)), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'Option',
    subtitle: 'feedback WRONG - WihoutCheckIcon'
  }, getOption(true, feedback.WRONG, false)), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'Option',
    subtitle: 'feedback WRONG Pin - WihoutCheckIcon'
  }, getOption(true, feedback.WRONG, false, true, true))));
}
StyleGuideRadios.propTypes = {};
StyleGuideRadios.defaultProps = {};

function StyleGuideSlider() {
  var _useState = useState(1),
    min = _useState[0],
    setMin = _useState[1];
  var _useState2 = useState(10),
    max = _useState2[0],
    setMax = _useState2[1];
  var propsCommon = {
    showFilesLimitMin: true,
    min: min,
    max: max,
    onChangeMax: setMax,
    onChangeMin: setMin
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-slider"
  }, /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'EditorSlider',
    subtitle: ''
  }, /*#__PURE__*/React__default.createElement(EditorSlider, null)), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'EditorSlider',
    subtitle: ''
  }, /*#__PURE__*/React__default.createElement(EditorSlider, _extends({}, propsCommon, {
    showLimitMin: true
  }))), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'EditorSliderTitleSubtitle',
    subtitle: ''
  }, /*#__PURE__*/React__default.createElement(EditorSliderTitleSubtitle, _extends({}, propsCommon, {
    title: 'Título',
    subtitle: 'Subtítulo'
  }))), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'EditorSliderTitleSubtitle',
    subtitle: ''
  }, /*#__PURE__*/React__default.createElement(EditorSliderTitleSubtitle, _extends({}, propsCommon, {
    title: 'Título',
    subtitle: 'Subtítulo',
    showLimitMin: true,
    limitMin: 1
  }))), /*#__PURE__*/React__default.createElement(BoxComponent, {
    title: 'ConfigFilesLimit',
    subtitle: ''
  }, /*#__PURE__*/React__default.createElement(ConfigFilesLimit, propsCommon)));
}
StyleGuideSlider.propTypes = {};
StyleGuideSlider.defaultProps = {};

function StyleGuideIcons() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgAdjustments, {
    title: 'Icon_Adjustments'
  }), "Icon_ArrowCircleLeft", /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Adjustments")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgArrowSmRight, {
    title: 'Icon_ArrowSmRight'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "ArrowSmRight")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgAscending, {
    title: 'Icon_Ascending'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Ascending")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgBackspace, {
    title: 'Icon_Backspace'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Backspace")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgBolt, {
    title: 'Icon_Bolt'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Bolt")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgCheck, {
    title: 'Icon_Check'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Check")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgCheckBold, {
    title: 'Icon_CheckBold'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "CheckBold")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgCheckCircle, {
    title: 'Icon_CheckCircle'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "CheckCircle")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgChevronDoubleDown, {
    title: 'Icon_ChevronDoubleDown'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "ChevronDoubleDown")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgChevronDown, {
    title: 'Icon_ChevronDown'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "ChevronDown")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgChevronLeft, {
    title: 'Icon_ChevronLeft'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "ChevronLeft")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgChevronRight, {
    title: 'Icon_ChevronRight'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "ChevronRight")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgChevronUp, {
    title: 'Icon_ChevronUp'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "ChevronUp")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgClipboard, {
    title: 'Icon_Clipboard'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Clipboard")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(ClipboardCheck, {
    title: 'Icon_ClipboardCheck'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "ClipboardCheck")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgClipboardList, {
    title: 'Icon_ClipboardList'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "ClipboardList")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgCloud, {
    title: 'Icon_Cloud'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Cloud")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgCloudUpload, {
    title: 'Icon_CloudUpload'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "CloudUpload")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgCursorClick, {
    title: 'Icon_Cursor_Click'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "CursorClick")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgDesktopComputer, {
    title: 'Icon_DesktopComputer'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "DesktopComputer")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgDeviceMobile, {
    title: 'Icon_DeviceMobile'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "DeviceMobile")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgDeviceTablet, {
    title: 'Icon_DeviceTablet'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "DeviceTablet")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgDobleArrow, {
    title: 'Icon_DobleArrow'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "DobleArrow")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgDobleArrowVertical, {
    title: 'Icon_DobleArrowVertical'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "DobleArrowVertical")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgDocument, {
    title: 'Icon_Document'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Document")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgDocumentDuplicate, {
    title: 'Icon_DocumentDuplicate'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "DocumentDuplicate")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgDotsVertical, {
    title: 'Icon_DotsVertical'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "DotsVertical")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgDownload, {
    title: 'Icon_Download'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Download")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgDrag, {
    title: 'Icon_Drag'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Drag")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgDrive, {
    title: 'Icon_Drive'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Drive")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgEraser, {
    title: 'Icon_Eraser'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Eraser")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgExclamation, {
    title: 'Icon_Exclamation'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Exclamation")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgExclamationCircle, {
    title: 'Icon_ExclamationCircle'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "ExclamationCircle")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgExternalLink, {
    title: 'Icon_ExternalLink'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "ExternalLink")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgFormatListBulleted, {
    title: 'Icon_FormatListBulleted'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "FormatListBulleted")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgKeyboard, {
    title: 'Icon_Keyboard'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Keyboard")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgLightBulb, {
    title: 'Icon_LightBulb'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "LightBulb")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgMenuAlt, {
    title: 'Icon_MenuAlt'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "MenuAlt")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgMicrophone, {
    title: 'Icon_Microphone'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Microphone")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgMicrophoneOff, {
    title: 'Icon_MicrophoneOff'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "MicrophoneOff")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgMinusCircle, {
    title: 'Icon_MinusCircle'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "MinusCircle")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgMusicNote, {
    title: 'Icon_MusicNote'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "MusicNote")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgPause, {
    title: 'Icon_Pause'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Pause")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgPencil, {
    title: 'Icon_Pencil'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Pencil")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgPhotograph, {
    title: 'Icon_Photograph'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Photograph")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgPlay, {
    title: 'Icon_Play'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Play")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgPlus, {
    title: 'Icon_Plus'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Plus")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgPlusCircle, {
    title: 'Icon_PlusCircle'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "PlusCircle")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgQuestionMarkCircle, {
    title: 'Icon_QuestionMarkCircle'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "QuestionMarkCircle")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgRangeHandlerMobile, {
    title: 'Icon_RangeHandlerMobile'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "RangeHandlerMobile")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgRefresh, {
    title: 'Icon_Refresh'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Refresh")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgReplay, {
    title: 'Icon_Replay'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Replay")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgReply, {
    title: 'Icon_Reply'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Reply")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgRichtextBold, {
    title: 'Icon_RichtextBold'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "RichtextBold")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgRichtextItalic, {
    title: 'Icon_RichtextItalic'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "RichtextItalic")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgRichtextList, {
    title: 'Icon_RichtextList'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "RichtextList")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgRichtextNumberedlist, {
    title: 'Icon_RichtextNumberedlist'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "RichtextNumberedlist")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgRichtextQuote, {
    title: 'Icon_RichtextQuote'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "RichtextQuote")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgRichtextSubindex, {
    title: 'Icon_RichtextSubindex'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "RichtextSubindex")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgRichtextSuperindex, {
    title: 'Icon_RichtextSuperindex'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "RichtextSuperindex")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgRichtextTitle, {
    title: 'Icon_RichtextTitle'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "RichtextTitle")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgRichtextUnderline, {
    title: 'Icon_RichtextUnderline'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "RichtextUnderline")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgRule, {
    title: 'Icon_Rule'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Rule")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgSettingsTipography, {
    title: 'Icon_SettingsTipography'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "SettingsTipography")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgShieldExclamation, {
    title: 'Icon_ShieldExclamation'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "ShieldExclamation")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgSortDescending, {
    title: 'Icon_SortDescending'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "SortDescending")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgSortText, {
    title: 'Icon_SortText'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "SortText")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgSparkles, {
    title: 'Icon_Sparkles'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Sparkles")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgSpeakerNotes, {
    title: 'Icon_SpeakerNotes'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "SpeakerNotes")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(Star, {
    title: 'Icon_Star'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Star")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgStop, {
    title: 'Icon_Stop'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Stop")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgTable, {
    title: 'Icon_Table'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Table")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgTrash$1, {
    title: 'Icon_Trash'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Trash")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgUpload, {
    title: 'Icon_Upload'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "Upload")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgViewList, {
    title: 'Icon_ViewList'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "ViewList")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgX, {
    title: 'Icon_X'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "X")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgXBold, {
    title: 'Icon_XBold'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "XBold")), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon"
  }, /*#__PURE__*/React__default.createElement(SvgXCircle, {
    title: 'Icon_XCircle'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-icons__icon-text"
  }, "XCircle")));
}

function StyleGuideAll() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-all"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-all__title"
  }, "Buttons"), /*#__PURE__*/React__default.createElement(StyleGuideButtons, null), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-all__title"
  }, "Dropdowns"), /*#__PURE__*/React__default.createElement(StyleGuideDropdowns, null), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-all__title"
  }, "Blocks Editor"), /*#__PURE__*/React__default.createElement(StyleGuideBlocksEditor, null), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-all__title"
  }, "Checkboxs"), /*#__PURE__*/React__default.createElement(StyleGuideCheckboxs, null), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-all__title"
  }, "Radios"), /*#__PURE__*/React__default.createElement(StyleGuideRadios, null), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-all__title"
  }, "Essay"), /*#__PURE__*/React__default.createElement(StyleGuideEssay, null), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-all__title"
  }, "Feedbacks"), /*#__PURE__*/React__default.createElement(StyleGuideFeedbacks, null), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-all__title"
  }, "Icons"), /*#__PURE__*/React__default.createElement(StyleGuideIcons, null), /*#__PURE__*/React__default.createElement("div", {
    className: "style-guide-all__title"
  }, "Slider"), /*#__PURE__*/React__default.createElement(StyleGuideSlider, null));
}
StyleGuideAll.propTypes = {};
StyleGuideAll.defaultProps = {};

function ScaffoldSeparator(_ref) {
  var questionIdx = _ref.questionIdx,
    totalQuestions = _ref.totalQuestions;
  var step = translate('scaffold_separator_step');
  var of = translate('scaffold_separator_of');
  return questionIdx === 0 ? null : /*#__PURE__*/React__default.createElement("div", {
    className: "scaffold-separator"
  }, step + " " + questionIdx + " " + of + " " + totalQuestions);
}

function useScaffoldApi() {
  var _useState = useState(),
    api = _useState[0],
    scaffoldApi = _useState[1];
  return _extends({
    scaffoldApi: scaffoldApi
  }, api);
}

var QuestionModel$2 = types$1.model('scaffoldQuestionModel', {
  id: types$1.string,
  isMain: types$1.optional(types$1["boolean"], false),
  data: types$1.frozen(),
  isDisabled: false,
  wasSolutionVisible: false,
  nextQuestionId: types$1.maybe(types$1.string)
}).actions(function (state) {
  return {
    setDisabled: function setDisabled() {
      state.isDisabled = true;
    },
    setEnabled: function setEnabled() {
      state.isDisabled = false;
    },
    next: function next() {
      getParent(state, 2).next();
    },
    setWasSolutionVisible: function setWasSolutionVisible() {
      state.wasSolutionVisible = true;
    },
    saveResponse: function saveResponse(userResponse) {
      getParent(state, 2).addUserResponse(state.index, userResponse);
    },
    reset: function reset() {
      state.isDisabled = false;
      state.wasSolutionVisible = false;
    },
    restartScaffold: function restartScaffold() {
      getParent(state, 2).restart();
    },
    trackAction: function trackAction(reference) {}
  };
}).views(function (state) {
  return {
    get index() {
      return isAlive(state) && getParent(state).findIndex(function (item) {
        return item === state;
      });
    },
    get totalQuestions() {
      return getParent(state).length;
    },
    get isActive() {
      return getParent(state, 2).currentQuestionId === state.id;
    },
    get isInBetween() {
      return !state.isMain && !state.isLast;
    },
    get isInBetweenSolution() {
      return state.isInBetween && state.wasSolutionVisible;
    },
    get isLast() {
      return !state.nextQuestionId;
    }
  };
});

var ScaffoldStore = types$1.model('scaffoldStore', {
  questionList: types$1.optional(types$1.array(QuestionModel$2), []),
  activeQuestionList: types$1.optional(types$1.array(types$1.string), []),
  userResponse: types$1.optional(types$1.frozen(), []),
  isFinished: false
}).actions(function (state) {
  function addNextQuestion() {
    !state.isComplete && state.activeQuestionList.push(state.nextQuestionId);
  }
  return {
    next: function next() {
      addNextQuestion();
    },
    finish: function finish() {
      state.isFinished = true;
    },
    restart: function restart() {
      state.activeQuestionList = [state.questionList[0].id];
      state.isFinished = false;
      state.userResponse = [];
      state.questionList.forEach(function (question) {
        return question.reset();
      });
    },
    addUserResponse: function addUserResponse(idx, userResponse) {
      var cloneList = [].concat(state.userResponse);
      cloneList[idx] = userResponse;
      state.userResponse = cloneList;
    }
  };
}).views(function (state) {
  return {
    getQuestionById: function getQuestionById(questionId) {
      return state.questionList.find(function (question) {
        return question.id === questionId;
      });
    },
    get currentQuestionId() {
      return last(state.activeQuestionList);
    },
    get currentQuestion() {
      return state.getQuestionById(state.currentQuestionId);
    },
    get nextQuestionId() {
      return state.currentQuestion.nextQuestionId;
    },
    get nextQuestion() {
      return state.nextQuestionId && state.getQuestionById(state.nextQuestionId);
    },
    get isComplete() {
      return !state.nextQuestionId;
    },
    getUserResponses: function getUserResponses() {
      var _state$getResponses = state.getResponses(),
        references = _state$getResponses.references,
        responses = _state$getResponses.responses;
      return references.map(function (ref) {
        return responses[ref].value;
      });
    },
    getResponses: function getResponses() {
      return {
        references: state.userResponse.map(function (response) {
          return Object.keys(response)[0];
        }),
        responses: state.userResponse.reduce(function (acc, next) {
          var _extends2;
          var _Object$entries$ = Object.entries(next)[0],
            key = _Object$entries$[0],
            val = _Object$entries$[1];
          return _extends({}, acc, (_extends2 = {}, _extends2[key] = val, _extends2));
        }, {})
      };
    }
  };
});
function createQuestions$3(questionList) {
  return questionList.map(function (question, idx) {
    var nextIndex = idx < questionList.length && idx + 1;
    var nextQuestionData = nextIndex && questionList[nextIndex];
    return {
      id: question.reference,
      isMain: idx === 0,
      data: question,
      nextQuestionId: nextQuestionData === null || nextQuestionData === void 0 ? void 0 : nextQuestionData.reference
    };
  });
}
function createScaffold(_ref) {
  var data = _ref.data,
    _ref$initialStep = _ref.initialStep,
    initialStep = _ref$initialStep === void 0 ? 0 : _ref$initialStep;
  var firstQuestion = data.questions[initialStep].reference;
  return ScaffoldStore.create({
    questionList: createQuestions$3(data.questions),
    activeQuestionList: [firstQuestion]
  });
}

function ScaffoldRender(_ref) {
  var scaffoldStore = _ref.scaffoldStore,
    questionId = _ref.questionId,
    getApi = _ref.getApi,
    children = _ref.children,
    onComplete = _ref.onComplete,
    onNext = _ref.onNext,
    onSuccess = _ref.onSuccess,
    onError = _ref.onError;
  var currentQuestion = scaffoldStore.getQuestionById(questionId);
  var scaffoldListLength = scaffoldStore.activeQuestionList.length;
  var totalQuestions = scaffoldStore.questionList.length - 1;
  var _useLemonadeQuestion = useLemonadeQuestion({
      data: currentQuestion.data
    }),
    exercise = _useLemonadeQuestion.exercise;
  var questionApi = exercise.questionApi;
  var status = useQuestionStatus({
    store: questionApi,
    currentQuestion: currentQuestion
  });
  var disableQuestion = useCallback(function () {
    questionApi.setDisabled(true);
    currentQuestion.setDisabled();
  }, [questionApi, currentQuestion]);
  var checkOnComplete = useCallback(function () {
    var success = questionApi.points > 0;
    var mainQuestionSuccess = currentQuestion.isMain && success;
    if (mainQuestionSuccess || currentQuestion.isLast) {
      onComplete === null || onComplete === void 0 ? void 0 : onComplete({
        store: questionApi,
        currentQuestion: currentQuestion
      });
      return true;
    }
    onNext === null || onNext === void 0 ? void 0 : onNext({
      store: questionApi,
      currentQuestion: currentQuestion
    });
    return false;
  }, [questionApi, currentQuestion, onComplete, onNext]);
  var hideSolutions = useCallback(function () {
    questionApi.showSolution && questionApi.showSolutions(false);
  }, [questionApi]);
  var next = useCallback(function () {
    disableQuestion();
    hideSolutions();
    currentQuestion.saveResponse(questionApi.getResponseWithKey());
    if (!checkOnComplete()) currentQuestion.next();
  }, [questionApi, currentQuestion, disableQuestion, hideSolutions]);
  var initScaffold = useCallback(function () {
    return currentQuestion.isMain ? next() : undefined;
  }, [currentQuestion, next]);
  var showSolutions = useCallback(function (bool) {
    disableQuestion();
    questionApi.showSolutions(bool);
  }, [questionApi, disableQuestion]);
  var checkAnswers = useCallback(function () {
    var success = questionApi.points > 0;
    disableQuestion();
    questionApi.checkAnswers();
    success ? onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess({
      store: questionApi,
      currentQuestion: currentQuestion
    }) : onError === null || onError === void 0 ? void 0 : onError({
      store: questionApi,
      currentQuestion: currentQuestion
    });
  }, [questionApi, disableQuestion]);
  useEffect(function () {
    if (scaffoldListLength === 1 && currentQuestion.index === 0 && questionApi.isEvaluated) {
      questionApi.reset();
    }
  }, [scaffoldListLength]);
  useEffect(function () {
    getApi === null || getApi === void 0 ? void 0 : getApi({
      showAnswers: function showAnswers() {
        return showSolutions(true);
      },
      hideAnswers: function hideAnswers() {
        return showSolutions(false);
      },
      showSolution: questionApi.showSolution,
      isEvaluated: questionApi.isEvaluated,
      store: questionApi,
      scaffoldStore: scaffoldStore,
      currentQuestion: currentQuestion,
      status: status,
      checkAnswers: checkAnswers,
      next: next,
      initScaffold: initScaffold
    });
  }, []);
  useEffect(function () {
    var actionName = 'trackAction';
    var actionTracker = onAction(scaffoldStore, function (_ref2) {
      var name = _ref2.name,
        args = _ref2.args;
      var eq = function eq(currentAction) {
        return args[0] === currentAction;
      };
      if (name === actionName) {
        when()["case"](eq(actionList.NEXT), onNext)["case"](eq(actionList.SUCCESS), onSuccess)["case"](eq(actionList.ERROR), onError)["case"](eq(actionList.COMPLETE), onComplete).resolve();
      }
    });
    return function () {
      return actionTracker();
    };
  }, []);
  return React__default.cloneElement(children, _extends({}, exercise, {
    scaffoldStore: scaffoldStore,
    currentQuestion: currentQuestion,
    totalQuestions: totalQuestions
  }), children.props);
}
var ScaffoldRenderer = observer(ScaffoldRender);

function Scaffold(_ref) {
  var data = _ref.data,
    children = _ref.children,
    api = _ref.api,
    _ref$initialStep = _ref.initialStep,
    initialStep = _ref$initialStep === void 0 ? 0 : _ref$initialStep,
    onComplete = _ref.onComplete,
    onNext = _ref.onNext,
    onSuccess = _ref.onSuccess,
    onError = _ref.onError;
  var _useState = useState(null),
    scaffoldStore = _useState[0],
    setScaffoldStore = _useState[1];
  var _useState2 = useState(null),
    scaffoldId = _useState2[0],
    setScaffoldId = _useState2[1];
  var dataId = data === null || data === void 0 ? void 0 : data.id;
  var updateScaffold = useCallback(function () {
    if (data) {
      setScaffoldStore(createScaffold({
        data: data,
        initialStep: initialStep
      }));
      setScaffoldId(data.id);
    }
  }, [setScaffoldStore, setScaffoldId, data]);
  window.scaffoldStore = scaffoldStore;
  useEffect(function () {
    if (dataId) updateScaffold();
  }, [dataId]);
  return !scaffoldStore ? null : /*#__PURE__*/React__default.createElement("div", {
    key: scaffoldId
  }, scaffoldStore.activeQuestionList.map(function (questionId, idx, arr) {
    var withApiRef = !!api && idx === arr.length - 1;
    return /*#__PURE__*/React__default.createElement(ScaffoldRenderer, {
      key: questionId,
      getApi: withApiRef && api,
      scaffoldStore: scaffoldStore,
      questionId: questionId,
      onComplete: onComplete,
      onNext: onNext,
      onSuccess: onSuccess,
      onError: onError
    }, children);
  }));
}
var Scaffold$1 = observer(Scaffold);

function downloadDocument(element) {
  var preHtml = "\n    <html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'>\n    <head>\n        <meta charset='utf-8'>\n        <title>Export HTML To Doc</title>\n        <style>*{margin: 0; padding:0}</style>\n        <style>\n            body {\n                font-family: sans-serif;\n                font-size: 18px;\n            }\n        </style>\n    </head>\n    <body>\n";
  var postHtml = '</body></html>';
  var html = preHtml + element.innerHTML + postHtml;
  var blob = new Blob(["\uFEFF", html], {
    type: 'application/msword'
  });
  var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
  var filename = 'document.doc';
  var downloadLink = document.createElement('a');
  document.body.appendChild(downloadLink);
  if (navigator.msSaveOrOpenBlob) {
    navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    downloadLink.href = url;
    downloadLink.download = filename;
    downloadLink.click();
  }
  document.body.removeChild(downloadLink);
}

var QuestionListItem = function QuestionListItem(_ref) {
  var item = _ref.item,
    dragProvider = _ref.dragProvider;
  var draggableProps = dragProvider.draggableProps,
    dragHandleProps = dragProvider.dragHandleProps,
    innerRef = dragProvider.innerRef;
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: "lemo-question-list-item"
  }, draggableProps, {
    ref: innerRef
  }), /*#__PURE__*/React__default.createElement("div", dragHandleProps, /*#__PURE__*/React__default.createElement(SvgDrag, {
    className: "lemo-editor-box-list-item-icon-drag lemo-icon",
    width: 24
  })), /*#__PURE__*/React__default.createElement(HTMLContent$1, {
    className: "lemo-text",
    content: item.templateDescription
  }));
};
var QuestionListItem$1 = observer(QuestionListItem);

function addItemButton(_ref) {
  var onClick = _ref.onClick,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React__default.createElement("button", {
    className: 'lemo-add-item-button ' + className,
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-icon-wrapper"
  }, /*#__PURE__*/React__default.createElement(SvgPlusCircle, {
    className: "lemo-icon"
  })), /*#__PURE__*/React__default.createElement("hr", {
    className: "lemo-add-item-button-line"
  }));
}

function GroupEditor(_ref) {
  var _questionGroupStore$f;
  var questionGroupStore = _ref.questionGroupStore;
  var feedbackConfig = questionGroupStore.feedback.config;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-group-editor lemo-editor",
    style: {
      paddingTop: 0
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-fr-scrollable-container",
    id: FROALA_ID_SCROLLABLE_CONTAINER
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-editor-horizontal-content-box full-width"
  }, /*#__PURE__*/React__default.createElement("div", {
    id: "lemo-group-name"
  }, /*#__PURE__*/React__default.createElement(EditorBox, {
    icon: /*#__PURE__*/React__default.createElement(SvgClipboard, {
      width: 24,
      className: "lemo-icon"
    }),
    id: "groupName",
    titleBox: translate('group_name'),
    helpText: translate('group_name_help_text')
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement(EditorInputText$1, {
    value: questionGroupStore.title,
    placeholder: translate('group_name_placeholder'),
    onChange: function onChange(e) {
      return questionGroupStore.setTitle(e.target.value);
    }
  })))), /*#__PURE__*/React__default.createElement("div", {
    id: "lemo-group-stimulus"
  }, /*#__PURE__*/React__default.createElement(EditorStimulus$1, {
    assetsFroalaApi: getAssetsEditorApi(questionGroupStore.assetsEditorApi),
    stimulus: questionGroupStore.stimulus,
    onStimulusChange: questionGroupStore.setStimulus,
    titleBox: translate('group_stimulus_box_title'),
    placeholder: translate('group_stimulus_placeholder')
  })), /*#__PURE__*/React__default.createElement("div", {
    id: "lemo-corrective-feedback"
  }, /*#__PURE__*/React__default.createElement(EditorFeedbackExercise$1, {
    feedback: (_questionGroupStore$f = questionGroupStore.feedback.errorMessage) === null || _questionGroupStore$f === void 0 ? void 0 : _questionGroupStore$f.value,
    onChangeFeedback: questionGroupStore.feedback.setErrorString,
    showConfigFeedbacksIndividual: false,
    icon: /*#__PURE__*/React__default.createElement(SvgShieldExclamation, {
      width: 24,
      className: "lemo-icon"
    }),
    assetsFroalaApi: getAssetsEditorApi(questionGroupStore.assetsEditorApi),
    helpText: translate('feedback_exercise_help'),
    hasGlobalFeedback: feedbackConfig.hasGlobalFeedback,
    setGlobalFeedback: function setGlobalFeedback(bool) {
      return feedbackConfig.setGlobalFeedback(bool);
    },
    hasSpecificFeedback: feedbackConfig.hasSpecificFeedback,
    setSpecificFeedback: function setSpecificFeedback(bool) {
      return feedbackConfig.setSpecificFeedback(bool);
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    id: "lemo-hint"
  }, /*#__PURE__*/React__default.createElement(EditorHints$1, {
    icon: /*#__PURE__*/React__default.createElement(SvgLightBulb, {
      width: 24,
      className: "lemo-icon"
    }),
    hints: questionGroupStore.hints.hintList.toJSON(),
    resetHints: function resetHints() {
      return questionGroupStore.hints.resetHints();
    },
    addHint: function addHint(value) {
      return questionGroupStore.hints.addHint(value);
    },
    onChangeHint: function onChangeHint(index, value) {
      return questionGroupStore.hints.onUpdateHint(index, value);
    },
    assetsFroalaApi: getAssetsEditorApi(questionGroupStore.assetsEditorApi)
  })), /*#__PURE__*/React__default.createElement("div", {
    id: "lemo-question-list"
  }, /*#__PURE__*/React__default.createElement(EditorBox, {
    icon: /*#__PURE__*/React__default.createElement(SvgViewList, {
      width: 24,
      className: "lemo-icon"
    }),
    id: "groupName",
    titleBox: translate('group_editor_exercise_list'),
    helpText: translate('group_editor_exercise_list_help_text')
  }, /*#__PURE__*/React__default.createElement(EditorContent, null, /*#__PURE__*/React__default.createElement(EditorSortingList$1, {
    list: questionGroupStore.questionList,
    keyId: "id",
    onDragEnd: questionGroupStore.sortQuestions
  }, function (itemList, provider) {
    return /*#__PURE__*/React__default.createElement(QuestionListItem$1, {
      item: itemList,
      dragProvider: provider
    });
  })), /*#__PURE__*/React__default.createElement(addItemButton, {
    onClick: questionGroupStore.openAddQuestionModal
  }))), /*#__PURE__*/React__default.createElement("div", {
    id: "lemo-popups"
  })));
}
var GroupEditor$1 = observer(GroupEditor);

function GroupedQuestionMenu(_ref) {
  var questionGroupStore = _ref.questionGroupStore;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-grouped-question-menu"
  }, /*#__PURE__*/React__default.createElement(SvgPencil, {
    className: "lemo-icon",
    width: 20,
    onClick: questionGroupStore.editQuestion
  }), questionGroupStore.showAscendIcon && /*#__PURE__*/React__default.createElement(SvgAscending, {
    className: "lemo-icon",
    width: 20,
    onClick: questionGroupStore.moveQuestionUp
  }), questionGroupStore.showDescendIcon && /*#__PURE__*/React__default.createElement(SvgSortDescending, {
    className: "lemo-icon",
    width: 20,
    onClick: questionGroupStore.moveQuestionDown
  }), /*#__PURE__*/React__default.createElement(SvgDocumentDuplicate, {
    className: "lemo-icon",
    width: 20,
    onClick: questionGroupStore.duplicateQuestion
  }), /*#__PURE__*/React__default.createElement(SvgTrash$1, {
    className: "lemo-icon",
    width: 20,
    onClick: questionGroupStore.openRemoveQuestionModal
  }));
}
var GroupedQuestionMenu$1 = observer(GroupedQuestionMenu);

function AddQuestionModal(_ref) {
  var questionGroupStore = _ref.questionGroupStore;
  var categories = config.groupedQuestionModal.categories;
  var _useState = useState(0),
    selected = _useState[0],
    setSelected = _useState[1];
  function createQuestion(questionId) {
    questionGroupStore.addQuestion(questionId);
    questionGroupStore.closeAddQuestionModal();
    questionGroupStore.editQuestion();
    questionGroupStore.setSelectedQuestion(questionGroupStore.questionList.length - 1);
  }
  return /*#__PURE__*/React__default.createElement(Modal$1, null, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-add-question-modal"
  }, /*#__PURE__*/React__default.createElement("section", {
    className: "lemo-modal-header"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "lemo-title"
  }, translate('add_new_activity')), /*#__PURE__*/React__default.createElement(WrapButton, {
    className: "lemo-close-button",
    onClick: questionGroupStore.closeAddQuestionModal
  }, /*#__PURE__*/React__default.createElement(SvgX, null))), /*#__PURE__*/React__default.createElement("section", {
    className: "lemo-modal-tab-list"
  }, categories.map(function (category, idx) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: cn$1('lemo-tab', {
        'lemo-selected': selected === idx
      }),
      key: category.name,
      onClick: function onClick() {
        return setSelected(idx);
      }
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "lemo-tab-text"
    }, category.name));
  })), /*#__PURE__*/React__default.createElement("section", {
    className: "lemo-modal-tab-content"
  }, categories[selected].questions.map(function (question, idx) {
    return /*#__PURE__*/React__default.createElement("li", {
      className: "lemo-tab-content",
      key: question.id
    }, /*#__PURE__*/React__default.createElement("button", {
      className: "lemo-template-button",
      onClick: function onClick() {
        return createQuestion(question.id);
      }
    }, question.name));
  }))));
}

var changedHandlers = 'setTitle|setStimulus|setGlobalFeedback|setErrorString|addHint|onUpdateHint|resetHints';
var changedHandlerDebugger = false;
function GroupEditorLayout(_ref) {
  var questionGroupStore = _ref.questionGroupStore,
    changed = _ref.changed;
  useChangedCallback(changed, changedHandlers, questionGroupStore, changedHandlerDebugger);
  useEffect(function () {
    onSnapshot(questionGroupStore.questionList, function () {
      var _questionGroupStore$g;
      changed({
        output: questionGroupStore.output,
        points: questionGroupStore === null || questionGroupStore === void 0 ? void 0 : questionGroupStore.points,
        response: questionGroupStore === null || questionGroupStore === void 0 ? void 0 : (_questionGroupStore$g = questionGroupStore.getResponseWithKey) === null || _questionGroupStore$g === void 0 ? void 0 : _questionGroupStore$g.call(questionGroupStore),
        store: questionGroupStore
      });
    });
  }, []);
  var getPopoverTarget = function getPopoverTarget() {
    return document.querySelectorAll('.lemo-group-question-menu-icon')[questionGroupStore.selectedQuestion];
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-group-editor-layout"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-columns-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-group-editor-wrapper"
  }, /*#__PURE__*/React__default.createElement(GroupEditor$1, {
    questionGroupStore: questionGroupStore
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-group-wrapper"
  }, /*#__PURE__*/React__default.createElement(QuestionsGroup$1, {
    questionGroupStore: questionGroupStore,
    isEditMode: true
  }))), questionGroupStore.selectedQuestion > -1 && /*#__PURE__*/React__default.createElement(PopoverWrapper$1, {
    targetElement: getPopoverTarget(),
    position: 'bottom-start',
    onClickOutside: questionGroupStore.closeGroupedMenu
  }, /*#__PURE__*/React__default.createElement(GroupedQuestionMenu$1, {
    questionGroupStore: questionGroupStore
  })), questionGroupStore.removeQuestionModal > -1 && /*#__PURE__*/React__default.createElement(ModalConfirmMessage$1, {
    title: translate('remove_grouped_question_modal_title'),
    message: translate('remove_grouped_question_modal_description'),
    onConfirm: questionGroupStore.confirmRemoveQuestion,
    onCancel: questionGroupStore.closeRemoveQuestionModal
  }), questionGroupStore.addQuestionModal && /*#__PURE__*/React__default.createElement(AddQuestionModal, {
    questionGroupStore: questionGroupStore
  }));
}
var GroupEditorLayout$1 = observer(GroupEditorLayout);

function QuestionEditorLayout(_ref) {
  var questionGroupStore = _ref.questionGroupStore;
  var questionData = questionGroupStore.questionList[questionGroupStore.selectedQuestion].data;
  var _useLemonadeEditor = useLemonadeEditor(_extends({
      data: questionData
    }, questionGroupStore.config)),
    _useLemonadeEditor$ex = _useLemonadeEditor.exercise,
    Question = _useLemonadeEditor$ex.Question,
    editorApi = _useLemonadeEditor$ex.editorApi,
    Editor = _useLemonadeEditor$ex.Editor;
  var handleChange = useCallback(function (output) {
    return console.log('changed: ', output.store);
  }, []);
  function save() {
    questionGroupStore.saveQuestion(editorApi.output);
  }
  function cancel() {
    questionGroupStore.cancelQuestion();
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemonade-exercises"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-editor-layout"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-column-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-column sticky"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-wrapper"
  }, /*#__PURE__*/React__default.createElement(Question, {
    changed: handleChange
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-editor-controls"
  }, /*#__PURE__*/React__default.createElement(SimpleButton, {
    className: "lemo-cancel-question-button",
    variant: variantsSimpleButton.secondary,
    onClick: cancel,
    title: "cancel"
  }, translate('cancel')), /*#__PURE__*/React__default.createElement(SimpleButton, {
    className: "lemo-save-question-button",
    variant: variantsSimpleButton.primary,
    onClick: save,
    title: "save"
  }, translate('save')))), /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-column"
  }, /*#__PURE__*/React__default.createElement(Editor, null)))));
}
var QuestionEditorLayout$1 = observer(QuestionEditorLayout);

function getDefaultQuestionGroup () {
  return {
    id: '7e53ecaa-cd23-4dbe-b3e4-f01cebaaa09a',
    title: '',
    type: 'activitygroup',
    stimulus: '',
    feedback: {
      successMessage: '',
      errorMessages: [],
      responseMessages: [],
      config: {
        visibility: true,
        hasGlobalFeedback: false,
        hasSpecificFeedback: false,
        sequence: 'stack'
      }
    },
    hints: ['<p>global</p>'],
    references: [{
      reference: '867e53ec-aacd-43bd-be33-e4f01cebaaa0',
      type: 'mcq',
      template: 'Multiple choice – standard'
    }],
    questions: {
      '867e53ec-aacd-43bd-be33-e4f01cebaaa0': {
        title: '',
        type: 'mcq',
        data: {
          type: 'mcq',
          multiple_responses: true,
          options: [{
            label: '<p>Cow</p>',
            value: '0',
            feedback: ''
          }, {
            label: '<p>Dog</p>',
            value: '1',
            feedback: ''
          }, {
            label: '<p>Cat</p>',
            value: '2',
            feedback: ''
          }, {
            label: '<p>Shark</p>',
            value: '3',
            feedback: ''
          }],
          stimulus: '<p>What is the animal in the picture?&nbsp;<img src="https://images.pexels.com/photos/45201/kitty-cat-kitten-pet-45201.jpeg" class="fr-fic fr-dib"></p>',
          shuffle_options: true,
          validation: {
            scoring_type: 'exactMatch',
            immediateFeedback: false,
            alt_responses: [],
            valid_response: {
              score: 1,
              value: ['2']
            },
            penalty_mode: 'NONE',
            penalty: 0
          },
          ui_style: {
            type: 'Multiple choice – standard',
            columns: 1,
            labelType: '',
            customClass: '',
            inlineFeedback: false
          },
          isEvaluable: true,
          attempts: {
            attempts: 0
          },
          hints: ['<p>local</p>'],
          feedback: {
            successMessage: '',
            errorMessages: [],
            responseMessages: [],
            config: {
              visibility: true,
              hasGlobalFeedback: false,
              hasSpecificFeedback: false,
              sequence: 'stack'
            }
          },
          showCheckIcon: true
        },
        metadata: {
          name: 'Multiple choice – standard',
          layout: 'grouped_layout'
        },
        reference: '867e53ec-aacd-43bd-be33-e4f01cebaaa0',
        extraValues: {}
      }
    }
  };
}

function QuestionGroupLayout(_ref) {
  var data = _ref.data,
    basePath = _ref.basePath,
    assetsQuestionApi = _ref.assetsQuestionApi,
    assetsEditorApi = _ref.assetsEditorApi,
    assetsQuestionApiDrive = _ref.assetsQuestionApiDrive,
    _ref$changed = _ref.changed,
    changed = _ref$changed === void 0 ? noop : _ref$changed;
  var _useState = useState(function () {
      return createQuestionGroupStore(_extends({}, data || getDefaultQuestionGroup(), {
        basePath: basePath,
        assetsQuestionApi: assetsQuestionApi,
        assetsQuestionApiDrive: assetsQuestionApiDrive,
        assetsEditorApi: assetsEditorApi
      }));
    }),
    questionGroupStore = _useState[0];
  window.questionGroupStore = questionGroupStore;
  useEffect(function () {
    window.scrollTo(0, 0);
  }, [questionGroupStore.layoutMode]);
  var eq = function eq(query) {
    return questionGroupStore.layoutMode === query;
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-question-group-layout"
  }, when()["case"](eq(GROUP_EDITION), function () {
    return /*#__PURE__*/React__default.createElement(GroupEditorLayout$1, {
      questionGroupStore: questionGroupStore,
      changed: changed
    });
  })["case"](eq(QUESTION_EDITION), function () {
    return /*#__PURE__*/React__default.createElement(QuestionEditorLayout$1, {
      questionGroupStore: questionGroupStore
    });
  }).resolve(function () {
    return null;
  }));
}
var QuestionGroupLayout$1 = observer(QuestionGroupLayout);

function PreviewBody(_ref) {
  var size = _ref.size,
    questionData = _ref.questionData;
  var _useLemonadeQuestion = useLemonadeQuestion({
      data: questionData
    }),
    exercise = _useLemonadeQuestion.exercise;
  var _useState = useState(0),
    viewportHeight = _useState[0],
    setViewportHeight = _useState[1];
  useEffect(function () {
    setViewportHeight(window.innerHeight - 80);
  }, []);
  function getInnerHeight() {
    return size.className === 'lemo-display-Desktop' ? {
      minHeight: viewportHeight
    } : {};
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-preview-body"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cn$1('lemo-screen-container', size.className),
    style: getInnerHeight()
  }, /*#__PURE__*/React__default.createElement(exercise.Question, null), /*#__PURE__*/React__default.createElement(exercise.Feedback, null), /*#__PURE__*/React__default.createElement(exercise.Controls, {
    showPoints: true,
    showCheckAnswer: true,
    showReset: true,
    showSolution: true,
    visible: true
  })));
}

function SizeSelectorButton(_ref) {
  var selected = _ref.selected,
    onClick = _ref.onClick,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement("button", {
    className: cn$1('lemo-size-selector-button', {
      'lemo-selected': selected
    }),
    onClick: onClick
  }, children);
}

function SizeIcon(_ref) {
  var value = _ref.value;
  var eq = function eq(val) {
    return val === value;
  };
  return when()["case"](eq(responsiveIconNames.DESKTOP), function () {
    return /*#__PURE__*/React__default.createElement(SvgDesktopComputer, {
      className: "lemo-icon"
    });
  })["case"](eq(responsiveIconNames.HORIZONTAL_TABLET), function () {
    return /*#__PURE__*/React__default.createElement(SvgDeviceTablet, {
      className: "lemo-icon lemo-horizontal"
    });
  })["case"](eq(responsiveIconNames.VERTICAL_TABLET), function () {
    return /*#__PURE__*/React__default.createElement(SvgDeviceTablet, {
      className: "lemo-icon"
    });
  })["case"](eq(responsiveIconNames.VERTICAL_MOBILE), function () {
    return /*#__PURE__*/React__default.createElement(SvgDeviceMobile, {
      className: "lemo-icon"
    });
  }).resolve(function () {
    return null;
  });
}

function SizeSelector(_ref) {
  var size = _ref.size,
    setSize = _ref.setSize;
  return /*#__PURE__*/React__default.createElement("ul", {
    className: "lemo-size-selector"
  }, responsiveSizes.map(function (item) {
    return /*#__PURE__*/React__default.createElement(SizeSelectorButton, {
      key: item.name,
      onClick: function onClick() {
        return setSize(item);
      },
      selected: size === item
    }, /*#__PURE__*/React__default.createElement(SizeIcon, {
      value: item.icon
    }), /*#__PURE__*/React__default.createElement("span", {
      className: "lemo-text"
    }, item.name));
  }));
}

function BackButton(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React__default.createElement("button", {
    className: "lemo-back-button",
    onClick: onClick,
    role: "button"
  }, /*#__PURE__*/React__default.createElement(SvgArrowCircleLeft, {
    className: "lemo-icon"
  }));
}

function PreviewHeader(_ref) {
  var onGoBack = _ref.onGoBack,
    size = _ref.size,
    setSize = _ref.setSize;
  return /*#__PURE__*/React__default.createElement("nav", {
    className: "lemo-preview-header"
  }, /*#__PURE__*/React__default.createElement(BackButton, {
    onClick: onGoBack
  }), /*#__PURE__*/React__default.createElement(SizeSelector, {
    size: size,
    setSize: setSize
  }));
}

function ResponsivePreview(_ref) {
  var questionData = _ref.questionData,
    onGoBack = _ref.onGoBack;
  var _useState = useState(responsiveSizes[0]),
    size = _useState[0],
    setSize = _useState[1];
  return /*#__PURE__*/React__default.createElement("div", {
    className: "lemo-responsive-preview"
  }, /*#__PURE__*/React__default.createElement(PreviewHeader, {
    size: size,
    onGoBack: onGoBack,
    setSize: setSize
  }), /*#__PURE__*/React__default.createElement(PreviewBody, {
    size: size,
    questionData: questionData
  }));
}

var FEEDBACK_QUESTION_TYPES = [types.multipleChoice.EmotionsSingle, types.other.Rating, types.other.AdaptativeChoice];
function isFeedbackQuestionType(questionType) {
  return FEEDBACK_QUESTION_TYPES.includes(questionType);
}

configure({
  isolateGlobalState: true
});
printLemonadeVersion();

export { AllEditors, AllQuestions, CROSS_SYMBOL, DOT_SYMBOL, FEEDBACK_QUESTION_TYPES, FeedbackManager$1 as FeedbackManager, FroalaField$1 as FroalaField, HTMLContent$1 as HTMLContent, Lemonade, LemonadeRenderContext, QuestionGroupLayout$1 as QuestionGroupLayout, ResponsivePreview, Scaffold$1 as Scaffold, ScaffoldControls$1 as ScaffoldControls, ScaffoldSeparator, ScaffoldingMobile$1 as ScaffoldingMobile, StyleGuideAll, actionPerformedTypes, amplitudeEnvironments, autoFocusTypes, checkAmplitudeEnvironment, decimalSeparatorTypes, downloadDocument, getActivity, getConfig, getDefaultData$9 as getDefaultData, initConfig, isEnvironmentInitialized, isFeedbackQuestionType, isManualEvaluation, normalizedTypes, questionContext, setConfig, thousandsSeparatorTypes, types, useLemonade, useLemonadeEditor, useLemonadeQuestion, useScaffoldApi };
//# sourceMappingURL=index.modern.js.map
